(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888,1203],{

/***/ 88000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./DealDetail": 20814,
	"./DealDetail.json": 20814,
	"./StoreListData": 92197,
	"./StoreListData.js": 92197,
	"./TnC-detail": 30431,
	"./TnC-detail.json": 30431,
	"./cart-case-1": 91209,
	"./cart-case-1.json": 91209,
	"./cart-case-3": 81839,
	"./cart-case-3.json": 81839,
	"./cart-case-3a": 21225,
	"./cart-case-3a.json": 21225,
	"./cart-case-5": 78394,
	"./cart-case-5.json": 78394,
	"./cart-case-6": 96057,
	"./cart-case-6.json": 96057,
	"./cart-case-7": 24804,
	"./cart-case-7.json": 24804,
	"./cart-case-8": 78149,
	"./cart-case-8.json": 78149,
	"./cart-deal": 59637,
	"./cart-deal-onceOff": 58844,
	"./cart-deal-onceOff.json": 58844,
	"./cart-deal.json": 59637,
	"./cart-dual": 5402,
	"./cart-dual.json": 5402,
	"./cart-null": 42816,
	"./cart-null.json": 42816,
	"./cart-out-of-stock": 8143,
	"./cart-out-of-stock.json": 8143,
	"./cart-preorder": 58968,
	"./cart-preorder.json": 58968,
	"./cart-sample": 68181,
	"./cart-sample.json": 68181,
	"./cart-upgrade": 36189,
	"./cart-upgrade.json": 36189,
	"./cart-vas": 44376,
	"./cart-vas.json": 44376,
	"./dealsSelectionMockData": 83870,
	"./dealsSelectionMockData.js": 83870,
	"./getAllDeals": 11008,
	"./getAllDeals.json": 11008,
	"./getAllProducts": 66473,
	"./getAllProducts.json": 66473,
	"./mockRenderComponent": 29151,
	"./mockRenderComponent.js": 29151,
	"./order-confirmation": 50393,
	"./order-confirmation-2": 21781,
	"./order-confirmation-2.json": 21781,
	"./order-confirmation.json": 50393,
	"./order-detail-cancelled": 92701,
	"./order-detail-cancelled.json": 92701,
	"./order-detail-error": 62825,
	"./order-detail-error.json": 62825,
	"./order-detail-error_1": 65907,
	"./order-detail-error_1.json": 65907,
	"./order-detail-failed": 11237,
	"./order-detail-failed.json": 11237,
	"./order-detail-mess": 47811,
	"./order-detail-mess.json": 47811,
	"./order-detail-paid": 74667,
	"./order-detail-paid.json": 74667,
	"./order-detail-processing": 28029,
	"./order-detail-processing.json": 28029,
	"./order-history-1": 18498,
	"./order-history-1.json": 18498,
	"./order-history-2": 95675,
	"./order-history-2.json": 95675,
	"./order-history-3": 13637,
	"./order-history-3.json": 13637,
	"./order-history-4": 95093,
	"./order-history-4.json": 95093,
	"./order-history-products": 3628,
	"./order-history-products.json": 3628,
	"./order-status-map": 43444,
	"./order-status-map.js": 43444,
	"./order-tracking-statuses": 64140,
	"./order-tracking-statuses-approved": 92365,
	"./order-tracking-statuses-approved.json": 92365,
	"./order-tracking-statuses-cond-approved": 41763,
	"./order-tracking-statuses-cond-approved.json": 41763,
	"./order-tracking-statuses-condition": 64214,
	"./order-tracking-statuses-condition.json": 64214,
	"./order-tracking-statuses-declined": 1584,
	"./order-tracking-statuses-declined.json": 1584,
	"./order-tracking-statuses-delivered": 28131,
	"./order-tracking-statuses-delivered.json": 28131,
	"./order-tracking-statuses-error": 77567,
	"./order-tracking-statuses-error.json": 77567,
	"./order-tracking-statuses-failed": 41572,
	"./order-tracking-statuses-failed.json": 41572,
	"./order-tracking-statuses-pending": 75768,
	"./order-tracking-statuses-pending.json": 75768,
	"./order-tracking-statuses-processing": 54647,
	"./order-tracking-statuses-processing.json": 54647,
	"./order-tracking-statuses.json": 64140,
	"./order-tracking-vetting-status": 72930,
	"./order-tracking-vetting-status.json": 72930,
	"./orders-customer-response": 56743,
	"./orders-customer-response.json": 56743,
	"./payment-intent": 79687,
	"./payment-intent.json": 79687,
	"./preOrderFormDetails": 97710,
	"./preOrderFormDetails.json": 97710,
	"./products-cart": 88306,
	"./products-cart.json": 88306,
	"./searchProductTabsMock": 12729,
	"./searchProductTabsMock.js": 12729,
	"./storeList": 91764,
	"./storeList.json": 91764,
	"./vasDetails": 14604,
	"./vasDetails.json": 14604
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88000;

/***/ }),

/***/ 87701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BL": function() { return /* binding */ start; },
/* harmony export */   "Ct": function() { return /* binding */ placements; },
/* harmony export */   "F2": function() { return /* binding */ right; },
/* harmony export */   "I": function() { return /* binding */ bottom; },
/* harmony export */   "Pj": function() { return /* binding */ viewport; },
/* harmony export */   "YP": function() { return /* binding */ reference; },
/* harmony export */   "bw": function() { return /* binding */ variationPlacements; },
/* harmony export */   "d7": function() { return /* binding */ auto; },
/* harmony export */   "k5": function() { return /* binding */ popper; },
/* harmony export */   "mv": function() { return /* binding */ basePlacements; },
/* harmony export */   "t$": function() { return /* binding */ left; },
/* harmony export */   "ut": function() { return /* binding */ end; },
/* harmony export */   "we": function() { return /* binding */ top; },
/* harmony export */   "xs": function() { return /* binding */ modifierPhases; },
/* harmony export */   "zV": function() { return /* binding */ clippingParents; }
/* harmony export */ });
/* unused harmony exports beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite */
var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

/***/ }),

/***/ 32092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCallbackRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * A convenience hook around `useState` designed to be paired with
 * the component [callback ref](https://reactjs.org/docs/refs-and-the-dom.html#callback-refs) api.
 * Callback refs are useful over `useRef()` when you need to respond to the ref being set
 * instead of lazily accessing it in an effect.
 *
 * ```ts
 * const [element, attachRef] = useCallbackRef<HTMLDivElement>()
 *
 * useEffect(() => {
 *   if (!element) return
 *
 *   const calendar = new FullCalendar.Calendar(element)
 *
 *   return () => {
 *     calendar.destroy()
 *   }
 * }, [element])
 *
 * return <div ref={attachRef} />
 * ```
 *
 * @category refs
 */

function useCallbackRef() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
}

/***/ }),

/***/ 51176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useEventCallback; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useCommittedRef.js

/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */

function useCommittedRef(value) {
  var ref = (0,react.useRef)(value);
  (0,react.useEffect)(function () {
    ref.current = value;
  }, [value]);
  return ref;
}

/* harmony default export */ var esm_useCommittedRef = (useCommittedRef);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useEventCallback.js


function useEventCallback(fn) {
  var ref = esm_useCommittedRef(fn);
  return (0,react.useCallback)(function () {
    return ref.current && ref.current.apply(ref, arguments);
  }, [ref]);
}

/***/ }),

/***/ 35654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mergeRefs */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var toFnRef = function toFnRef(ref) {
  return !ref || typeof ref === 'function' ? ref : function (value) {
    ref.current = value;
  };
};

function mergeRefs(refA, refB) {
  var a = toFnRef(refA);
  var b = toFnRef(refB);
  return function (value) {
    if (a) a(value);
    if (b) b(value);
  };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */

function useMergedRefs(refA, refB) {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return mergeRefs(refA, refB);
  }, [refA, refB]);
}

/* harmony default export */ __webpack_exports__["Z"] = (useMergedRefs);

/***/ }),

/***/ 6454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMounted; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Track whether a component is current mounted. Generally less preferable than
 * properlly canceling effects so they don't run after a component is unmounted,
 * but helpful in cases where that isn't feasible, such as a `Promise` resolution.
 *
 * @returns a function that returns the current isMounted state of the component
 *
 * ```ts
 * const [data, setData] = useState(null)
 * const isMounted = useMounted()
 *
 * useEffect(() => {
 *   fetchdata().then((newData) => {
 *      if (isMounted()) {
 *        setData(newData);
 *      }
 *   })
 * })
 * ```
 */

function useMounted() {
  var mounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
  var isMounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(function () {
    return mounted.current;
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    mounted.current = true;
    return function () {
      mounted.current = false;
    };
  }, []);
  return isMounted.current;
}

/***/ }),

/***/ 76852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useWillUnmount; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useUpdatedRef.js

/**
 * Returns a ref that is immediately updated with the new value
 *
 * @param value The Ref value
 * @category refs
 */

function useUpdatedRef(value) {
  var valueRef = (0,react.useRef)(value);
  valueRef.current = value;
  return valueRef;
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useWillUnmount.js


/**
 * Attach a callback that fires when a component unmounts
 *
 * @param fn Handler to run when the component unmounts
 * @category effects
 */

function useWillUnmount(fn) {
  var onUnmount = useUpdatedRef(fn);
  (0,react.useEffect)(function () {
    return function () {
      return onUnmount.current();
    };
  }, []);
}

/***/ }),

/***/ 63367:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (factory) {
   true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) :
  0;
})((function () { 'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
      object = _getPrototypeOf(object);
      if (object === null) break;
    }

    return object;
  }

  function _get() {
    if (typeof Reflect !== "undefined" && Reflect.get) {
      _get = Reflect.get.bind();
    } else {
      _get = function _get(target, property, receiver) {
        var base = _superPropBase(target, property);

        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);

        if (desc.get) {
          return desc.get.call(arguments.length < 3 ? target : receiver);
        }

        return desc.value;
      };
    }

    return _get.apply(this, arguments);
  }

  var Emitter = /*#__PURE__*/function () {
    function Emitter() {
      _classCallCheck(this, Emitter);

      Object.defineProperty(this, 'listeners', {
        value: {},
        writable: true,
        configurable: true
      });
    }

    _createClass(Emitter, [{
      key: "addEventListener",
      value: function addEventListener(type, callback, options) {
        if (!(type in this.listeners)) {
          this.listeners[type] = [];
        }

        this.listeners[type].push({
          callback: callback,
          options: options
        });
      }
    }, {
      key: "removeEventListener",
      value: function removeEventListener(type, callback) {
        if (!(type in this.listeners)) {
          return;
        }

        var stack = this.listeners[type];

        for (var i = 0, l = stack.length; i < l; i++) {
          if (stack[i].callback === callback) {
            stack.splice(i, 1);
            return;
          }
        }
      }
    }, {
      key: "dispatchEvent",
      value: function dispatchEvent(event) {
        if (!(event.type in this.listeners)) {
          return;
        }

        var stack = this.listeners[event.type];
        var stackToCall = stack.slice();

        for (var i = 0, l = stackToCall.length; i < l; i++) {
          var listener = stackToCall[i];

          try {
            listener.callback.call(this, event);
          } catch (e) {
            Promise.resolve().then(function () {
              throw e;
            });
          }

          if (listener.options && listener.options.once) {
            this.removeEventListener(event.type, listener.callback);
          }
        }

        return !event.defaultPrevented;
      }
    }]);

    return Emitter;
  }();

  var AbortSignal = /*#__PURE__*/function (_Emitter) {
    _inherits(AbortSignal, _Emitter);

    var _super = _createSuper(AbortSignal);

    function AbortSignal() {
      var _this;

      _classCallCheck(this, AbortSignal);

      _this = _super.call(this); // Some versions of babel does not transpile super() correctly for IE <= 10, if the parent
      // constructor has failed to run, then "this.listeners" will still be undefined and then we call
      // the parent constructor directly instead as a workaround. For general details, see babel bug:
      // https://github.com/babel/babel/issues/3041
      // This hack was added as a fix for the issue described here:
      // https://github.com/Financial-Times/polyfill-library/pull/59#issuecomment-477558042

      if (!_this.listeners) {
        Emitter.call(_assertThisInitialized(_this));
      } // Compared to assignment, Object.defineProperty makes properties non-enumerable by default and
      // we want Object.keys(new AbortController().signal) to be [] for compat with the native impl


      Object.defineProperty(_assertThisInitialized(_this), 'aborted', {
        value: false,
        writable: true,
        configurable: true
      });
      Object.defineProperty(_assertThisInitialized(_this), 'onabort', {
        value: null,
        writable: true,
        configurable: true
      });
      Object.defineProperty(_assertThisInitialized(_this), 'reason', {
        value: undefined,
        writable: true,
        configurable: true
      });
      return _this;
    }

    _createClass(AbortSignal, [{
      key: "toString",
      value: function toString() {
        return '[object AbortSignal]';
      }
    }, {
      key: "dispatchEvent",
      value: function dispatchEvent(event) {
        if (event.type === 'abort') {
          this.aborted = true;

          if (typeof this.onabort === 'function') {
            this.onabort.call(this, event);
          }
        }

        _get(_getPrototypeOf(AbortSignal.prototype), "dispatchEvent", this).call(this, event);
      }
    }]);

    return AbortSignal;
  }(Emitter);
  var AbortController = /*#__PURE__*/function () {
    function AbortController() {
      _classCallCheck(this, AbortController);

      // Compared to assignment, Object.defineProperty makes properties non-enumerable by default and
      // we want Object.keys(new AbortController()) to be [] for compat with the native impl
      Object.defineProperty(this, 'signal', {
        value: new AbortSignal(),
        writable: true,
        configurable: true
      });
    }

    _createClass(AbortController, [{
      key: "abort",
      value: function abort(reason) {
        var event;

        try {
          event = new Event('abort');
        } catch (e) {
          if (typeof document !== 'undefined') {
            if (!document.createEvent) {
              // For Internet Explorer 8:
              event = document.createEventObject();
              event.type = 'abort';
            } else {
              // For Internet Explorer 11:
              event = document.createEvent('Event');
              event.initEvent('abort', false, false);
            }
          } else {
            // Fallback where document isn't available:
            event = {
              type: 'abort',
              bubbles: false,
              cancelable: false
            };
          }
        }

        var signalReason = reason;

        if (signalReason === undefined) {
          if (typeof document === 'undefined') {
            signalReason = new Error('This operation was aborted');
            signalReason.name = 'AbortError';
          } else {
            try {
              signalReason = new DOMException('signal is aborted without reason');
            } catch (err) {
              // IE 11 does not support calling the DOMException constructor, use a
              // regular error object on it instead.
              signalReason = new Error('This operation was aborted');
              signalReason.name = 'AbortError';
            }
          }
        }

        this.signal.reason = signalReason;
        this.signal.dispatchEvent(event);
      }
    }, {
      key: "toString",
      value: function toString() {
        return '[object AbortController]';
      }
    }]);

    return AbortController;
  }();

  if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
    // These are necessary to make sure that we get correct output for:
    // Object.prototype.toString.call(new AbortController())
    AbortController.prototype[Symbol.toStringTag] = 'AbortController';
    AbortSignal.prototype[Symbol.toStringTag] = 'AbortSignal';
  }

  function polyfillNeeded(self) {
    if (self.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL) {
      console.log('__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL=true is set, will force install polyfill');
      return true;
    } // Note that the "unfetch" minimal fetch polyfill defines fetch() without
    // defining window.Request, and this polyfill need to work on top of unfetch
    // so the below feature detection needs the !self.AbortController part.
    // The Request.prototype check is also needed because Safari versions 11.1.2
    // up to and including 12.1.x has a window.AbortController present but still
    // does NOT correctly implement abortable fetch:
    // https://bugs.webkit.org/show_bug.cgi?id=174980#c2


    return typeof self.Request === 'function' && !self.Request.prototype.hasOwnProperty('signal') || !self.AbortController;
  }

  /**
   * Note: the "fetch.Request" default value is available for fetch imported from
   * the "node-fetch" package and not in browsers. This is OK since browsers
   * will be importing umd-polyfill.js from that path "self" is passed the
   * decorator so the default value will not be used (because browsers that define
   * fetch also has Request). One quirky setup where self.fetch exists but
   * self.Request does not is when the "unfetch" minimal fetch polyfill is used
   * on top of IE11; for this case the browser will try to use the fetch.Request
   * default value which in turn will be undefined but then then "if (Request)"
   * will ensure that you get a patched fetch but still no Request (as expected).
   * @param {fetch, Request = fetch.Request}
   * @returns {fetch: abortableFetch, Request: AbortableRequest}
   */

  function abortableFetchDecorator(patchTargets) {
    if ('function' === typeof patchTargets) {
      patchTargets = {
        fetch: patchTargets
      };
    }

    var _patchTargets = patchTargets,
        fetch = _patchTargets.fetch,
        _patchTargets$Request = _patchTargets.Request,
        NativeRequest = _patchTargets$Request === void 0 ? fetch.Request : _patchTargets$Request,
        NativeAbortController = _patchTargets.AbortController,
        _patchTargets$__FORCE = _patchTargets.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL,
        __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL = _patchTargets$__FORCE === void 0 ? false : _patchTargets$__FORCE;

    if (!polyfillNeeded({
      fetch: fetch,
      Request: NativeRequest,
      AbortController: NativeAbortController,
      __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL: __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL
    })) {
      return {
        fetch: fetch,
        Request: Request
      };
    }

    var Request = NativeRequest; // Note that the "unfetch" minimal fetch polyfill defines fetch() without
    // defining window.Request, and this polyfill need to work on top of unfetch
    // hence we only patch it if it's available. Also we don't patch it if signal
    // is already available on the Request prototype because in this case support
    // is present and the patching below can cause a crash since it assigns to
    // request.signal which is technically a read-only property. This latter error
    // happens when you run the main5.js node-fetch example in the repo
    // "abortcontroller-polyfill-examples". The exact error is:
    //   request.signal = init.signal;
    //   ^
    // TypeError: Cannot set property signal of #<Request> which has only a getter

    if (Request && !Request.prototype.hasOwnProperty('signal') || __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL) {
      Request = function Request(input, init) {
        var signal;

        if (init && init.signal) {
          signal = init.signal; // Never pass init.signal to the native Request implementation when the polyfill has
          // been installed because if we're running on top of a browser with a
          // working native AbortController (i.e. the polyfill was installed due to
          // __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL being set), then passing our
          // fake AbortSignal to the native fetch will trigger:
          // TypeError: Failed to construct 'Request': member signal is not of type AbortSignal.

          delete init.signal;
        }

        var request = new NativeRequest(input, init);

        if (signal) {
          Object.defineProperty(request, 'signal', {
            writable: false,
            enumerable: false,
            configurable: true,
            value: signal
          });
        }

        return request;
      };

      Request.prototype = NativeRequest.prototype;
    }

    var realFetch = fetch;

    var abortableFetch = function abortableFetch(input, init) {
      var signal = Request && Request.prototype.isPrototypeOf(input) ? input.signal : init ? init.signal : undefined;

      if (signal) {
        var abortError;

        try {
          abortError = new DOMException('Aborted', 'AbortError');
        } catch (err) {
          // IE 11 does not support calling the DOMException constructor, use a
          // regular error object on it instead.
          abortError = new Error('Aborted');
          abortError.name = 'AbortError';
        } // Return early if already aborted, thus avoiding making an HTTP request


        if (signal.aborted) {
          return Promise.reject(abortError);
        } // Turn an event into a promise, reject it once `abort` is dispatched


        var cancellation = new Promise(function (_, reject) {
          signal.addEventListener('abort', function () {
            return reject(abortError);
          }, {
            once: true
          });
        });

        if (init && init.signal) {
          // Never pass .signal to the native implementation when the polyfill has
          // been installed because if we're running on top of a browser with a
          // working native AbortController (i.e. the polyfill was installed due to
          // __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL being set), then passing our
          // fake AbortSignal to the native fetch will trigger:
          // TypeError: Failed to execute 'fetch' on 'Window': member signal is not of type AbortSignal.
          delete init.signal;
        } // Return the fastest promise (don't need to wait for request to finish)


        return Promise.race([cancellation, realFetch(input, init)]);
      }

      return realFetch(input, init);
    };

    return {
      fetch: abortableFetch,
      Request: Request
    };
  }

  (function (self) {

    if (!polyfillNeeded(self)) {
      return;
    }

    if (!self.fetch) {
      console.warn('fetch() is not available, cannot install abortcontroller-polyfill');
      return;
    }

    var _abortableFetch = abortableFetchDecorator(self),
        fetch = _abortableFetch.fetch,
        Request = _abortableFetch.Request;

    self.fetch = fetch;
    self.Request = Request;
    Object.defineProperty(self, 'AbortController', {
      writable: true,
      enumerable: false,
      configurable: true,
      value: AbortController
    });
    Object.defineProperty(self, 'AbortSignal', {
      writable: true,
      enumerable: false,
      configurable: true,
      value: AbortSignal
    });
  })(typeof self !== 'undefined' ? self : __webpack_require__.g);

}));


/***/ }),

/***/ 9669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(51609);

/***/ }),

/***/ 55448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var settle = __webpack_require__(36026);
var buildURL = __webpack_require__(15327);
var buildFullPath = __webpack_require__(94097);
var parseHeaders = __webpack_require__(84109);
var isURLSameOrigin = __webpack_require__(67985);
var createError = __webpack_require__(85061);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(4372);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 51609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var bind = __webpack_require__(91849);
var Axios = __webpack_require__(30321);
var mergeConfig = __webpack_require__(47185);
var defaults = __webpack_require__(45655);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(65263);
axios.CancelToken = __webpack_require__(14972);
axios.isCancel = __webpack_require__(26502);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(8713);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 65263:
/***/ (function(module) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ 14972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(65263);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 26502:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 30321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var buildURL = __webpack_require__(15327);
var InterceptorManager = __webpack_require__(80782);
var dispatchRequest = __webpack_require__(13572);
var mergeConfig = __webpack_require__(47185);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ 80782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 94097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(91793);
var combineURLs = __webpack_require__(7303);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 85061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(80481);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ 13572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var transformData = __webpack_require__(18527);
var isCancel = __webpack_require__(26502);
var defaults = __webpack_require__(45655);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 80481:
/***/ (function(module) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),

/***/ 47185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),

/***/ 36026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(85061);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 18527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ 45655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(34155);


var utils = __webpack_require__(64867);
var normalizeHeaderName = __webpack_require__(16016);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(55448);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(55448);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 91849:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 15327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 7303:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 4372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 91793:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 67985:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 16016:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 84109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 8713:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 64867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(91849);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),

/***/ 94184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 2350:
/***/ (function() {



/***/ }),

/***/ 9351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports optionsSupported, onceSupported */
/* harmony import */ var _canUseDOM__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23004);
/* eslint-disable no-return-assign */

var optionsSupported = false;
var onceSupported = false;

try {
  var options = {
    get passive() {
      return optionsSupported = true;
    },

    get once() {
      // eslint-disable-next-line no-multi-assign
      return onceSupported = optionsSupported = true;
    }

  };

  if (_canUseDOM__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z) {
    window.addEventListener('test', options, options);
    window.removeEventListener('test', options, true);
  }
} catch (e) {
  /* */
}

/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */
function addEventListener(node, eventName, handler, options) {
  if (options && typeof options !== 'boolean' && !onceSupported) {
    var once = options.once,
        capture = options.capture;
    var wrappedHandler = handler;

    if (!onceSupported && once) {
      wrappedHandler = handler.__once || function onceHandler(event) {
        this.removeEventListener(eventName, onceHandler, capture);
        handler.call(this, event);
      };

      handler.__once = wrappedHandler;
    }

    node.addEventListener(eventName, wrappedHandler, optionsSupported ? options : capture);
  }

  node.addEventListener(eventName, handler, options);
}

/* harmony default export */ __webpack_exports__["ZP"] = (addEventListener);

/***/ }),

/***/ 23004:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = (!!(typeof window !== 'undefined' && window.document && window.document.createElement));

/***/ }),

/***/ 90424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ contains; }
/* harmony export */ });
/* eslint-disable no-bitwise, no-cond-assign */

/**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */
function contains(context, node) {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  if (context.contains) return context.contains(node);
  if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}

/***/ }),

/***/ 91505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ css; }
});

// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/ownerDocument.js
var ownerDocument = __webpack_require__(67216);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/ownerWindow.js

/**
 * Returns the owner window of a given element.
 * 
 * @param node the element
 */

function ownerWindow(node) {
  var doc = (0,ownerDocument/* default */.Z)(node);
  return doc && doc.defaultView || window;
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/getComputedStyle.js

/**
 * Returns one or all computed style properties of an element.
 * 
 * @param node the element
 * @param psuedoElement the style property
 */

function getComputedStyle(node, psuedoElement) {
  return ownerWindow(node).getComputedStyle(node, psuedoElement);
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/hyphenate.js
var rUpper = /([A-Z])/g;
function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/hyphenateStyle.js
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */

var msPattern = /^ms-/;
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/isTransform.js
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function isTransform(value) {
  return !!(value && supportedTransforms.test(value));
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/css.js




function style(node, property) {
  var css = '';
  var transforms = '';

  if (typeof property === 'string') {
    return node.style.getPropertyValue(hyphenateStyleName(property)) || getComputedStyle(node).getPropertyValue(hyphenateStyleName(property));
  }

  Object.keys(property).forEach(function (key) {
    var value = property[key];

    if (!value && value !== 0) {
      node.style.removeProperty(hyphenateStyleName(key));
    } else if (isTransform(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += hyphenateStyleName(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += "transform: " + transforms + ";";
  }

  node.style.cssText += ";" + css;
}

/* harmony default export */ var css = (style);

/***/ }),

/***/ 11132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ hasClass; }
/* harmony export */ });
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

/***/ }),

/***/ 72950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _addEventListener__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9351);
/* harmony import */ var _removeEventListener__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30099);



function listen(node, eventName, handler, options) {
  (0,_addEventListener__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(node, eventName, handler, options);
  return function () {
    (0,_removeEventListener__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(node, eventName, handler, options);
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (listen);

/***/ }),

/***/ 67216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ownerDocument; }
/* harmony export */ });
/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

/***/ }),

/***/ 30099:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */
function removeEventListener(node, eventName, handler, options) {
  var capture = options && typeof options !== 'boolean' ? options.capture : options;
  node.removeEventListener(eventName, handler, capture);

  if (handler.__once) {
    node.removeEventListener(eventName, handler.__once, capture);
  }
}

/* harmony default export */ __webpack_exports__["Z"] = (removeEventListener);

/***/ }),

/***/ 94305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ transitionEnd; }
});

// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/css.js + 5 modules
var css = __webpack_require__(91505);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/listen.js
var listen = __webpack_require__(72950);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/triggerEvent.js
/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */
function triggerEvent(node, eventName, bubbles, cancelable) {
  if (bubbles === void 0) {
    bubbles = false;
  }

  if (cancelable === void 0) {
    cancelable = true;
  }

  if (node) {
    var event = document.createEvent('HTMLEvents');
    event.initEvent(eventName, bubbles, cancelable);
    node.dispatchEvent(event);
  }
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/transitionEnd.js




function parseDuration(node) {
  var str = (0,css/* default */.Z)(node, 'transitionDuration') || '';
  var mult = str.indexOf('ms') === -1 ? 1000 : 1;
  return parseFloat(str) * mult;
}

function emulateTransitionEnd(element, duration, padding) {
  if (padding === void 0) {
    padding = 5;
  }

  var called = false;
  var handle = setTimeout(function () {
    if (!called) triggerEvent(element, 'transitionend', true);
  }, duration + padding);
  var remove = (0,listen/* default */.Z)(element, 'transitionend', function () {
    called = true;
  }, {
    once: true
  });
  return function () {
    clearTimeout(handle);
    remove();
  };
}

function transitionEnd(element, handler, duration, padding) {
  if (duration == null) duration = parseDuration(element) || 0;
  var removeEmulate = emulateTransitionEnd(element, duration, padding);
  var remove = (0,listen/* default */.Z)(element, 'transitionend', handler);
  return function () {
    removeEmulate();
    remove();
  };
}

/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(21296);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 96103:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 21296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(96103);
} else {}


/***/ }),

/***/ 41143:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {}

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),

/***/ 36808:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ 72023:
/***/ (function(module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(34155);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 0.9.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2017
 * @license MIT
 */
/*jslint bitwise: true */
(function () {
  'use strict';

  var ERROR = 'input is invalid type';
  var WINDOW = typeof window === 'object';
  var root = WINDOW ? window : {};
  if (root.JS_SHA256_NO_WINDOW) {
    WINDOW = false;
  }
  var WEB_WORKER = !WINDOW && typeof self === 'object';
  var NODE_JS = !root.JS_SHA256_NO_NODE_JS && typeof process === 'object' && process.versions && process.versions.node;
  if (NODE_JS) {
    root = __webpack_require__.g;
  } else if (WEB_WORKER) {
    root = self;
  }
  var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && "object" === 'object' && module.exports;
  var AMD =  true && __webpack_require__.amdO;
  var ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
  var HEX_CHARS = '0123456789abcdef'.split('');
  var EXTRA = [-2147483648, 8388608, 32768, 128];
  var SHIFT = [24, 16, 8, 0];
  var K = [
    0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
    0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
    0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
    0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
    0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
    0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
    0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
    0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
  ];
  var OUTPUT_TYPES = ['hex', 'array', 'digest', 'arrayBuffer'];

  var blocks = [];

  if (root.JS_SHA256_NO_NODE_JS || !Array.isArray) {
    Array.isArray = function (obj) {
      return Object.prototype.toString.call(obj) === '[object Array]';
    };
  }

  if (ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) {
    ArrayBuffer.isView = function (obj) {
      return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
  }

  var createOutputMethod = function (outputType, is224) {
    return function (message) {
      return new Sha256(is224, true).update(message)[outputType]();
    };
  };

  var createMethod = function (is224) {
    var method = createOutputMethod('hex', is224);
    if (NODE_JS) {
      method = nodeWrap(method, is224);
    }
    method.create = function () {
      return new Sha256(is224);
    };
    method.update = function (message) {
      return method.create().update(message);
    };
    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
      var type = OUTPUT_TYPES[i];
      method[type] = createOutputMethod(type, is224);
    }
    return method;
  };

  var nodeWrap = function (method, is224) {
    var crypto = eval("require('crypto')");
    var Buffer = eval("require('buffer').Buffer");
    var algorithm = is224 ? 'sha224' : 'sha256';
    var nodeMethod = function (message) {
      if (typeof message === 'string') {
        return crypto.createHash(algorithm).update(message, 'utf8').digest('hex');
      } else {
        if (message === null || message === undefined) {
          throw new Error(ERROR);
        } else if (message.constructor === ArrayBuffer) {
          message = new Uint8Array(message);
        }
      }
      if (Array.isArray(message) || ArrayBuffer.isView(message) ||
        message.constructor === Buffer) {
        return crypto.createHash(algorithm).update(new Buffer(message)).digest('hex');
      } else {
        return method(message);
      }
    };
    return nodeMethod;
  };

  var createHmacOutputMethod = function (outputType, is224) {
    return function (key, message) {
      return new HmacSha256(key, is224, true).update(message)[outputType]();
    };
  };

  var createHmacMethod = function (is224) {
    var method = createHmacOutputMethod('hex', is224);
    method.create = function (key) {
      return new HmacSha256(key, is224);
    };
    method.update = function (key, message) {
      return method.create(key).update(message);
    };
    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
      var type = OUTPUT_TYPES[i];
      method[type] = createHmacOutputMethod(type, is224);
    }
    return method;
  };

  function Sha256(is224, sharedMemory) {
    if (sharedMemory) {
      blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] =
        blocks[4] = blocks[5] = blocks[6] = blocks[7] =
        blocks[8] = blocks[9] = blocks[10] = blocks[11] =
        blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
      this.blocks = blocks;
    } else {
      this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    }

    if (is224) {
      this.h0 = 0xc1059ed8;
      this.h1 = 0x367cd507;
      this.h2 = 0x3070dd17;
      this.h3 = 0xf70e5939;
      this.h4 = 0xffc00b31;
      this.h5 = 0x68581511;
      this.h6 = 0x64f98fa7;
      this.h7 = 0xbefa4fa4;
    } else { // 256
      this.h0 = 0x6a09e667;
      this.h1 = 0xbb67ae85;
      this.h2 = 0x3c6ef372;
      this.h3 = 0xa54ff53a;
      this.h4 = 0x510e527f;
      this.h5 = 0x9b05688c;
      this.h6 = 0x1f83d9ab;
      this.h7 = 0x5be0cd19;
    }

    this.block = this.start = this.bytes = this.hBytes = 0;
    this.finalized = this.hashed = false;
    this.first = true;
    this.is224 = is224;
  }

  Sha256.prototype.update = function (message) {
    if (this.finalized) {
      return;
    }
    var notString, type = typeof message;
    if (type !== 'string') {
      if (type === 'object') {
        if (message === null) {
          throw new Error(ERROR);
        } else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) {
          message = new Uint8Array(message);
        } else if (!Array.isArray(message)) {
          if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) {
            throw new Error(ERROR);
          }
        }
      } else {
        throw new Error(ERROR);
      }
      notString = true;
    }
    var code, index = 0, i, length = message.length, blocks = this.blocks;

    while (index < length) {
      if (this.hashed) {
        this.hashed = false;
        blocks[0] = this.block;
        blocks[16] = blocks[1] = blocks[2] = blocks[3] =
          blocks[4] = blocks[5] = blocks[6] = blocks[7] =
          blocks[8] = blocks[9] = blocks[10] = blocks[11] =
          blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
      }

      if (notString) {
        for (i = this.start; index < length && i < 64; ++index) {
          blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
        }
      } else {
        for (i = this.start; index < length && i < 64; ++index) {
          code = message.charCodeAt(index);
          if (code < 0x80) {
            blocks[i >> 2] |= code << SHIFT[i++ & 3];
          } else if (code < 0x800) {
            blocks[i >> 2] |= (0xc0 | (code >> 6)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          } else if (code < 0xd800 || code >= 0xe000) {
            blocks[i >> 2] |= (0xe0 | (code >> 12)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          } else {
            code = 0x10000 + (((code & 0x3ff) << 10) | (message.charCodeAt(++index) & 0x3ff));
            blocks[i >> 2] |= (0xf0 | (code >> 18)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 12) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          }
        }
      }

      this.lastByteIndex = i;
      this.bytes += i - this.start;
      if (i >= 64) {
        this.block = blocks[16];
        this.start = i - 64;
        this.hash();
        this.hashed = true;
      } else {
        this.start = i;
      }
    }
    if (this.bytes > 4294967295) {
      this.hBytes += this.bytes / 4294967296 << 0;
      this.bytes = this.bytes % 4294967296;
    }
    return this;
  };

  Sha256.prototype.finalize = function () {
    if (this.finalized) {
      return;
    }
    this.finalized = true;
    var blocks = this.blocks, i = this.lastByteIndex;
    blocks[16] = this.block;
    blocks[i >> 2] |= EXTRA[i & 3];
    this.block = blocks[16];
    if (i >= 56) {
      if (!this.hashed) {
        this.hash();
      }
      blocks[0] = this.block;
      blocks[16] = blocks[1] = blocks[2] = blocks[3] =
        blocks[4] = blocks[5] = blocks[6] = blocks[7] =
        blocks[8] = blocks[9] = blocks[10] = blocks[11] =
        blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
    }
    blocks[14] = this.hBytes << 3 | this.bytes >>> 29;
    blocks[15] = this.bytes << 3;
    this.hash();
  };

  Sha256.prototype.hash = function () {
    var a = this.h0, b = this.h1, c = this.h2, d = this.h3, e = this.h4, f = this.h5, g = this.h6,
      h = this.h7, blocks = this.blocks, j, s0, s1, maj, t1, t2, ch, ab, da, cd, bc;

    for (j = 16; j < 64; ++j) {
      // rightrotate
      t1 = blocks[j - 15];
      s0 = ((t1 >>> 7) | (t1 << 25)) ^ ((t1 >>> 18) | (t1 << 14)) ^ (t1 >>> 3);
      t1 = blocks[j - 2];
      s1 = ((t1 >>> 17) | (t1 << 15)) ^ ((t1 >>> 19) | (t1 << 13)) ^ (t1 >>> 10);
      blocks[j] = blocks[j - 16] + s0 + blocks[j - 7] + s1 << 0;
    }

    bc = b & c;
    for (j = 0; j < 64; j += 4) {
      if (this.first) {
        if (this.is224) {
          ab = 300032;
          t1 = blocks[0] - 1413257819;
          h = t1 - 150054599 << 0;
          d = t1 + 24177077 << 0;
        } else {
          ab = 704751109;
          t1 = blocks[0] - 210244248;
          h = t1 - 1521486534 << 0;
          d = t1 + 143694565 << 0;
        }
        this.first = false;
      } else {
        s0 = ((a >>> 2) | (a << 30)) ^ ((a >>> 13) | (a << 19)) ^ ((a >>> 22) | (a << 10));
        s1 = ((e >>> 6) | (e << 26)) ^ ((e >>> 11) | (e << 21)) ^ ((e >>> 25) | (e << 7));
        ab = a & b;
        maj = ab ^ (a & c) ^ bc;
        ch = (e & f) ^ (~e & g);
        t1 = h + s1 + ch + K[j] + blocks[j];
        t2 = s0 + maj;
        h = d + t1 << 0;
        d = t1 + t2 << 0;
      }
      s0 = ((d >>> 2) | (d << 30)) ^ ((d >>> 13) | (d << 19)) ^ ((d >>> 22) | (d << 10));
      s1 = ((h >>> 6) | (h << 26)) ^ ((h >>> 11) | (h << 21)) ^ ((h >>> 25) | (h << 7));
      da = d & a;
      maj = da ^ (d & b) ^ ab;
      ch = (h & e) ^ (~h & f);
      t1 = g + s1 + ch + K[j + 1] + blocks[j + 1];
      t2 = s0 + maj;
      g = c + t1 << 0;
      c = t1 + t2 << 0;
      s0 = ((c >>> 2) | (c << 30)) ^ ((c >>> 13) | (c << 19)) ^ ((c >>> 22) | (c << 10));
      s1 = ((g >>> 6) | (g << 26)) ^ ((g >>> 11) | (g << 21)) ^ ((g >>> 25) | (g << 7));
      cd = c & d;
      maj = cd ^ (c & a) ^ da;
      ch = (g & h) ^ (~g & e);
      t1 = f + s1 + ch + K[j + 2] + blocks[j + 2];
      t2 = s0 + maj;
      f = b + t1 << 0;
      b = t1 + t2 << 0;
      s0 = ((b >>> 2) | (b << 30)) ^ ((b >>> 13) | (b << 19)) ^ ((b >>> 22) | (b << 10));
      s1 = ((f >>> 6) | (f << 26)) ^ ((f >>> 11) | (f << 21)) ^ ((f >>> 25) | (f << 7));
      bc = b & c;
      maj = bc ^ (b & d) ^ cd;
      ch = (f & g) ^ (~f & h);
      t1 = e + s1 + ch + K[j + 3] + blocks[j + 3];
      t2 = s0 + maj;
      e = a + t1 << 0;
      a = t1 + t2 << 0;
    }

    this.h0 = this.h0 + a << 0;
    this.h1 = this.h1 + b << 0;
    this.h2 = this.h2 + c << 0;
    this.h3 = this.h3 + d << 0;
    this.h4 = this.h4 + e << 0;
    this.h5 = this.h5 + f << 0;
    this.h6 = this.h6 + g << 0;
    this.h7 = this.h7 + h << 0;
  };

  Sha256.prototype.hex = function () {
    this.finalize();

    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5,
      h6 = this.h6, h7 = this.h7;

    var hex = HEX_CHARS[(h0 >> 28) & 0x0F] + HEX_CHARS[(h0 >> 24) & 0x0F] +
      HEX_CHARS[(h0 >> 20) & 0x0F] + HEX_CHARS[(h0 >> 16) & 0x0F] +
      HEX_CHARS[(h0 >> 12) & 0x0F] + HEX_CHARS[(h0 >> 8) & 0x0F] +
      HEX_CHARS[(h0 >> 4) & 0x0F] + HEX_CHARS[h0 & 0x0F] +
      HEX_CHARS[(h1 >> 28) & 0x0F] + HEX_CHARS[(h1 >> 24) & 0x0F] +
      HEX_CHARS[(h1 >> 20) & 0x0F] + HEX_CHARS[(h1 >> 16) & 0x0F] +
      HEX_CHARS[(h1 >> 12) & 0x0F] + HEX_CHARS[(h1 >> 8) & 0x0F] +
      HEX_CHARS[(h1 >> 4) & 0x0F] + HEX_CHARS[h1 & 0x0F] +
      HEX_CHARS[(h2 >> 28) & 0x0F] + HEX_CHARS[(h2 >> 24) & 0x0F] +
      HEX_CHARS[(h2 >> 20) & 0x0F] + HEX_CHARS[(h2 >> 16) & 0x0F] +
      HEX_CHARS[(h2 >> 12) & 0x0F] + HEX_CHARS[(h2 >> 8) & 0x0F] +
      HEX_CHARS[(h2 >> 4) & 0x0F] + HEX_CHARS[h2 & 0x0F] +
      HEX_CHARS[(h3 >> 28) & 0x0F] + HEX_CHARS[(h3 >> 24) & 0x0F] +
      HEX_CHARS[(h3 >> 20) & 0x0F] + HEX_CHARS[(h3 >> 16) & 0x0F] +
      HEX_CHARS[(h3 >> 12) & 0x0F] + HEX_CHARS[(h3 >> 8) & 0x0F] +
      HEX_CHARS[(h3 >> 4) & 0x0F] + HEX_CHARS[h3 & 0x0F] +
      HEX_CHARS[(h4 >> 28) & 0x0F] + HEX_CHARS[(h4 >> 24) & 0x0F] +
      HEX_CHARS[(h4 >> 20) & 0x0F] + HEX_CHARS[(h4 >> 16) & 0x0F] +
      HEX_CHARS[(h4 >> 12) & 0x0F] + HEX_CHARS[(h4 >> 8) & 0x0F] +
      HEX_CHARS[(h4 >> 4) & 0x0F] + HEX_CHARS[h4 & 0x0F] +
      HEX_CHARS[(h5 >> 28) & 0x0F] + HEX_CHARS[(h5 >> 24) & 0x0F] +
      HEX_CHARS[(h5 >> 20) & 0x0F] + HEX_CHARS[(h5 >> 16) & 0x0F] +
      HEX_CHARS[(h5 >> 12) & 0x0F] + HEX_CHARS[(h5 >> 8) & 0x0F] +
      HEX_CHARS[(h5 >> 4) & 0x0F] + HEX_CHARS[h5 & 0x0F] +
      HEX_CHARS[(h6 >> 28) & 0x0F] + HEX_CHARS[(h6 >> 24) & 0x0F] +
      HEX_CHARS[(h6 >> 20) & 0x0F] + HEX_CHARS[(h6 >> 16) & 0x0F] +
      HEX_CHARS[(h6 >> 12) & 0x0F] + HEX_CHARS[(h6 >> 8) & 0x0F] +
      HEX_CHARS[(h6 >> 4) & 0x0F] + HEX_CHARS[h6 & 0x0F];
    if (!this.is224) {
      hex += HEX_CHARS[(h7 >> 28) & 0x0F] + HEX_CHARS[(h7 >> 24) & 0x0F] +
        HEX_CHARS[(h7 >> 20) & 0x0F] + HEX_CHARS[(h7 >> 16) & 0x0F] +
        HEX_CHARS[(h7 >> 12) & 0x0F] + HEX_CHARS[(h7 >> 8) & 0x0F] +
        HEX_CHARS[(h7 >> 4) & 0x0F] + HEX_CHARS[h7 & 0x0F];
    }
    return hex;
  };

  Sha256.prototype.toString = Sha256.prototype.hex;

  Sha256.prototype.digest = function () {
    this.finalize();

    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5,
      h6 = this.h6, h7 = this.h7;

    var arr = [
      (h0 >> 24) & 0xFF, (h0 >> 16) & 0xFF, (h0 >> 8) & 0xFF, h0 & 0xFF,
      (h1 >> 24) & 0xFF, (h1 >> 16) & 0xFF, (h1 >> 8) & 0xFF, h1 & 0xFF,
      (h2 >> 24) & 0xFF, (h2 >> 16) & 0xFF, (h2 >> 8) & 0xFF, h2 & 0xFF,
      (h3 >> 24) & 0xFF, (h3 >> 16) & 0xFF, (h3 >> 8) & 0xFF, h3 & 0xFF,
      (h4 >> 24) & 0xFF, (h4 >> 16) & 0xFF, (h4 >> 8) & 0xFF, h4 & 0xFF,
      (h5 >> 24) & 0xFF, (h5 >> 16) & 0xFF, (h5 >> 8) & 0xFF, h5 & 0xFF,
      (h6 >> 24) & 0xFF, (h6 >> 16) & 0xFF, (h6 >> 8) & 0xFF, h6 & 0xFF
    ];
    if (!this.is224) {
      arr.push((h7 >> 24) & 0xFF, (h7 >> 16) & 0xFF, (h7 >> 8) & 0xFF, h7 & 0xFF);
    }
    return arr;
  };

  Sha256.prototype.array = Sha256.prototype.digest;

  Sha256.prototype.arrayBuffer = function () {
    this.finalize();

    var buffer = new ArrayBuffer(this.is224 ? 28 : 32);
    var dataView = new DataView(buffer);
    dataView.setUint32(0, this.h0);
    dataView.setUint32(4, this.h1);
    dataView.setUint32(8, this.h2);
    dataView.setUint32(12, this.h3);
    dataView.setUint32(16, this.h4);
    dataView.setUint32(20, this.h5);
    dataView.setUint32(24, this.h6);
    if (!this.is224) {
      dataView.setUint32(28, this.h7);
    }
    return buffer;
  };

  function HmacSha256(key, is224, sharedMemory) {
    var i, type = typeof key;
    if (type === 'string') {
      var bytes = [], length = key.length, index = 0, code;
      for (i = 0; i < length; ++i) {
        code = key.charCodeAt(i);
        if (code < 0x80) {
          bytes[index++] = code;
        } else if (code < 0x800) {
          bytes[index++] = (0xc0 | (code >> 6));
          bytes[index++] = (0x80 | (code & 0x3f));
        } else if (code < 0xd800 || code >= 0xe000) {
          bytes[index++] = (0xe0 | (code >> 12));
          bytes[index++] = (0x80 | ((code >> 6) & 0x3f));
          bytes[index++] = (0x80 | (code & 0x3f));
        } else {
          code = 0x10000 + (((code & 0x3ff) << 10) | (key.charCodeAt(++i) & 0x3ff));
          bytes[index++] = (0xf0 | (code >> 18));
          bytes[index++] = (0x80 | ((code >> 12) & 0x3f));
          bytes[index++] = (0x80 | ((code >> 6) & 0x3f));
          bytes[index++] = (0x80 | (code & 0x3f));
        }
      }
      key = bytes;
    } else {
      if (type === 'object') {
        if (key === null) {
          throw new Error(ERROR);
        } else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) {
          key = new Uint8Array(key);
        } else if (!Array.isArray(key)) {
          if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) {
            throw new Error(ERROR);
          }
        }
      } else {
        throw new Error(ERROR);
      }
    }

    if (key.length > 64) {
      key = (new Sha256(is224, true)).update(key).array();
    }

    var oKeyPad = [], iKeyPad = [];
    for (i = 0; i < 64; ++i) {
      var b = key[i] || 0;
      oKeyPad[i] = 0x5c ^ b;
      iKeyPad[i] = 0x36 ^ b;
    }

    Sha256.call(this, is224, sharedMemory);

    this.update(iKeyPad);
    this.oKeyPad = oKeyPad;
    this.inner = true;
    this.sharedMemory = sharedMemory;
  }
  HmacSha256.prototype = new Sha256();

  HmacSha256.prototype.finalize = function () {
    Sha256.prototype.finalize.call(this);
    if (this.inner) {
      this.inner = false;
      var innerHash = this.array();
      Sha256.call(this, this.is224, this.sharedMemory);
      this.update(this.oKeyPad);
      this.update(innerHash);
      Sha256.prototype.finalize.call(this);
    }
  };

  var exports = createMethod();
  exports.sha256 = exports;
  exports.sha224 = createMethod(true);
  exports.sha256.hmac = createHmacMethod();
  exports.sha224.hmac = createHmacMethod(true);

  if (COMMON_JS) {
    module.exports = exports;
  } else {
    root.sha256 = exports.sha256;
    root.sha224 = exports.sha224;
    if (AMD) {
      !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
        return exports;
      }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
  }
})();


/***/ }),

/***/ 7544:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(91203)


/***/ }),

/***/ 71404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$R": function() { return /* binding */ SET_RELATED_DEALS; },
/* harmony export */   "Gg": function() { return /* binding */ SET_WHITELISTED_ROUTERS; },
/* harmony export */   "HP": function() { return /* binding */ SET_DEAL_DETAILS; },
/* harmony export */   "NR": function() { return /* binding */ SET_ALL_DEAL_DATA; },
/* harmony export */   "QH": function() { return /* binding */ SET_APPLICATION_TYPE; },
/* harmony export */   "VF": function() { return /* binding */ SET_ATTRIBUTE_CODES; },
/* harmony export */   "WU": function() { return /* binding */ SET_INCLUSION_COLOR; },
/* harmony export */   "_I": function() { return /* binding */ SET_CONTRACT_DURATIONS; },
/* harmony export */   "e7": function() { return /* binding */ SET_DEVICE_COLOR_OPTIONS; },
/* harmony export */   "h0": function() { return /* binding */ SET_DEAL_LIST; },
/* harmony export */   "qC": function() { return /* binding */ SET_DEVICE_DURATION_PRICE; },
/* harmony export */   "tc": function() { return /* binding */ SET_CONTRACT_TYPES; },
/* harmony export */   "tj": function() { return /* binding */ SET_DEVICE_COLOR; }
/* harmony export */ });
/* unused harmony export SET_SIMILAR_DEALS */
var SET_ALL_DEAL_DATA = "SET_ALL_DEAL_DATA";
var SET_APPLICATION_TYPE = "SET_APPLICATION_TYPE";
var SET_ATTRIBUTE_CODES = "SET_ATTRIBUTE_CODES";
var SET_CONTRACT_DURATIONS = "SET_CONTRACT_DURATIONS";
var SET_CONTRACT_TYPES = "SET_CONTRACT_TYPES";
var SET_DEAL_DETAILS = "SET_DEAL_DETAILS";
var SET_DEAL_LIST = "SET_DEAL_LIST";
var SET_DEVICE_COLOR = "SET_DEVICE_COLOR";
var SET_DEVICE_COLOR_OPTIONS = "SET_DEVICE_COLOR_OPTIONS";
var SET_DEVICE_DURATION_PRICE = "SET_DEVICE_DURATION_PRICE";
var SET_INCLUSION_COLOR = "SET_INCLUSION_COLOR";
var SET_RELATED_DEALS = "SET_RELATED_DEALS";
var SET_SIMILAR_DEALS = "SET_SIMILAR_DEALS";
var SET_WHITELISTED_ROUTERS = "SET_WHITELISTED_ROUTERS";

/***/ }),

/***/ 1369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ TOGGLE_FILTERS; },
/* harmony export */   "$u": function() { return /* binding */ SET_POST_CHECKOUT_CURRENT_STEP; },
/* harmony export */   "AH": function() { return /* binding */ SET_XDS_RESULT; },
/* harmony export */   "BD": function() { return /* binding */ ADD_ALTERNATE_NUMBERS; },
/* harmony export */   "BP": function() { return /* binding */ SET_BILLING; },
/* harmony export */   "Bd": function() { return /* binding */ TOGGLE_SNACK_BAR; },
/* harmony export */   "C7": function() { return /* binding */ UPDATE_CAN_RECEIVE_OTP; },
/* harmony export */   "CI": function() { return /* binding */ SET_SKIP_CREDIT_VETTING; },
/* harmony export */   "DI": function() { return /* binding */ SET_CREDIT_VETTING_OUTCOME; },
/* harmony export */   "DJ": function() { return /* binding */ ADD_CREDIT_PROFILE; },
/* harmony export */   "Di": function() { return /* binding */ REPLACE_COMPARE_PRODUCT; },
/* harmony export */   "EC": function() { return /* binding */ GUEST_VIEW_CART; },
/* harmony export */   "EI": function() { return /* binding */ GEOLOCATION_POSITION; },
/* harmony export */   "Ek": function() { return /* binding */ ADD_COUPON_CODE; },
/* harmony export */   "Ev": function() { return /* binding */ GET_DEALS_PRODUCTS_BY_SKUS; },
/* harmony export */   "Fh": function() { return /* binding */ PAST_TOKEN; },
/* harmony export */   "Fu": function() { return /* binding */ REMOVE_COMPARE_PRODUCT; },
/* harmony export */   "GA": function() { return /* binding */ SET_IS_LOADING; },
/* harmony export */   "GE": function() { return /* binding */ SET_CREDIT_VETTING_RESULT; },
/* harmony export */   "GT": function() { return /* binding */ SET_NORMAL_CHECKOUT_CURRENT_STEP; },
/* harmony export */   "Gm": function() { return /* binding */ SET_NUMBER_TO_TRANSFER; },
/* harmony export */   "HM": function() { return /* binding */ SET_CREDIT_CHECK_CONTACT_DATA; },
/* harmony export */   "Hi": function() { return /* binding */ GEOLOCATION_STATUS; },
/* harmony export */   "I6": function() { return /* binding */ GET_RECOMMENDED_DEALS; },
/* harmony export */   "Jl": function() { return /* binding */ GET_UPGRADE_CONSUMPTION; },
/* harmony export */   "Js": function() { return /* binding */ ADD_CONFIGURABLE_PRODUCT_TO_CART; },
/* harmony export */   "Kc": function() { return /* binding */ SET_NUMBER_TRANSFER_DETAILS; },
/* harmony export */   "Ld": function() { return /* binding */ SET_RELOGIN; },
/* harmony export */   "Np": function() { return /* binding */ TOP_BANNER_TOGGLE; },
/* harmony export */   "O$": function() { return /* binding */ GUEST_CART_ITEMS; },
/* harmony export */   "OZ": function() { return /* binding */ REMOVE_FROM_CART; },
/* harmony export */   "Of": function() { return /* binding */ UPDATE_NEXT_MSISDN_SELECTED; },
/* harmony export */   "Ov": function() { return /* binding */ ADD_COMPARE_PRODUCT; },
/* harmony export */   "PH": function() { return /* binding */ CHANGE_OTHER_STORE; },
/* harmony export */   "Q0": function() { return /* binding */ CLEAR_ENTIRE_JOURNEY; },
/* harmony export */   "QE": function() { return /* binding */ SELECTED_STORAGE; },
/* harmony export */   "QV": function() { return /* binding */ SET_CHECKOUT_LOGIN; },
/* harmony export */   "Qz": function() { return /* binding */ ADD_BUNDLE_PRODUCT_TO_CART; },
/* harmony export */   "SQ": function() { return /* binding */ SET_SHIPPING_METHOD; },
/* harmony export */   "Sr": function() { return /* binding */ GUEST_RESET_CART; },
/* harmony export */   "Ss": function() { return /* binding */ UPDATE_MSISDN_STATUS; },
/* harmony export */   "T1": function() { return /* binding */ BREADCRUMB_SELECT; },
/* harmony export */   "TY": function() { return /* binding */ SET_AUTHENTICATION_DETAILS; },
/* harmony export */   "Tw": function() { return /* binding */ TOGGLE_SEARCH; },
/* harmony export */   "U5": function() { return /* binding */ TOP_BANNER_MODAL_TOGGLE; },
/* harmony export */   "Um": function() { return /* binding */ SET_MINIAPP; },
/* harmony export */   "VM": function() { return /* binding */ SET_PAYMENT_METHOD_URL; },
/* harmony export */   "VV": function() { return /* binding */ CHECKOUT_PAGE_ERROR_SELECTED_PREFERENCE; },
/* harmony export */   "Vl": function() { return /* binding */ TERMS_AND_CONDITIONS_TOPIC; },
/* harmony export */   "Vo": function() { return /* binding */ REMOVE_ALL; },
/* harmony export */   "Vs": function() { return /* binding */ GET_CATEGORY_CMS_CONTENT; },
/* harmony export */   "WC": function() { return /* binding */ MEGA_MENU; },
/* harmony export */   "WD": function() { return /* binding */ SET_BACKENABLED; },
/* harmony export */   "WO": function() { return /* binding */ UPDATE_DEAL_GRID_RESET; },
/* harmony export */   "WP": function() { return /* binding */ DISPLAY_HIDE_FOOTER; },
/* harmony export */   "W_": function() { return /* binding */ GET_SHIPPING_BILLING; },
/* harmony export */   "XI": function() { return /* binding */ ALERT_SELECT; },
/* harmony export */   "ZM": function() { return /* binding */ UPDATE_UPGRADE_REDIRECT; },
/* harmony export */   "ZP": function() { return /* binding */ GET_UPGRADE_BRANDS; },
/* harmony export */   "ZU": function() { return /* binding */ CLEAR_UPGRADE_JOURNEY_STATUS; },
/* harmony export */   "ZY": function() { return /* binding */ GET_FOOTER_LINKS_SUCCESS; },
/* harmony export */   "Zd": function() { return /* binding */ SYNC_USER_PROFILE_SUCCESS; },
/* harmony export */   "_G": function() { return /* binding */ INVALID_OTP; },
/* harmony export */   "_c": function() { return /* binding */ SET_CREDIT_SELECTED_AFFORD_DEAL; },
/* harmony export */   "_f": function() { return /* binding */ UPDATE_DEAL_SELECTION_RESET; },
/* harmony export */   "ah": function() { return /* binding */ UPDATE_ELIGIBILITY_CHECK_STATUS; },
/* harmony export */   "bA": function() { return /* binding */ UPDATE_UPGRADE_JOURNEY_STATUS; },
/* harmony export */   "bL": function() { return /* binding */ SET_LOOKUP_DETAILS; },
/* harmony export */   "bP": function() { return /* binding */ SET_CREDIT_CHECK_PERSONAL_DATA; },
/* harmony export */   "bb": function() { return /* binding */ SET_NUMBER_TRANSFER_TYPE; },
/* harmony export */   "bh": function() { return /* binding */ TERMS_AND_CONDITIONS; },
/* harmony export */   "bn": function() { return /* binding */ PRODUCT_COMPARE_LIST; },
/* harmony export */   "c4": function() { return /* binding */ SET_HELP_LEAD_BUCKET; },
/* harmony export */   "c9": function() { return /* binding */ SYNC_USER_PROFILE_FAILURE; },
/* harmony export */   "ch": function() { return /* binding */ ADD_SIMPLE_PRODUCT_TO_CART; },
/* harmony export */   "cq": function() { return /* binding */ SET_CREDIT_CHECK_DEBIT_DATA; },
/* harmony export */   "ct": function() { return /* binding */ RESET_INVALID_OTPS; },
/* harmony export */   "eK": function() { return /* binding */ DISPLAY_HIDE_MODAL; },
/* harmony export */   "eT": function() { return /* binding */ SET_PROFILE_DATA; },
/* harmony export */   "ey": function() { return /* binding */ CHANGE_OTHER_METHODS; },
/* harmony export */   "f$": function() { return /* binding */ CANDC_STORE_DETAILS; },
/* harmony export */   "fR": function() { return /* binding */ SYNC_USER_PROFILE; },
/* harmony export */   "gA": function() { return /* binding */ MSISDN_BLOCKED; },
/* harmony export */   "gC": function() { return /* binding */ SYNC_USER_PROFILE_RESET; },
/* harmony export */   "gL": function() { return /* binding */ SET_HOME_COMPONENTS; },
/* harmony export */   "gQ": function() { return /* binding */ UPDATE_CART; },
/* harmony export */   "hL": function() { return /* binding */ GET_UPGRADE_MODELS; },
/* harmony export */   "i4": function() { return /* binding */ GLOBAL_NAV; },
/* harmony export */   "iQ": function() { return /* binding */ SET_FEATURES; },
/* harmony export */   "ic": function() { return /* binding */ UPDATE_ELIGIBILITY_DATA; },
/* harmony export */   "j$": function() { return /* binding */ UPDATE_LINKED_NUMBER; },
/* harmony export */   "j1": function() { return /* binding */ UPDATE_DISPLAY_DATA; },
/* harmony export */   "jA": function() { return /* binding */ UPDATE_UNMASKED_MSISDN; },
/* harmony export */   "jN": function() { return /* binding */ UPDATE_LOGGED_IN_USER_ELIGIBILITY_DATA; },
/* harmony export */   "j_": function() { return /* binding */ SHOW_COMPARE_ERROR; },
/* harmony export */   "jw": function() { return /* binding */ SET_POST_ORDER_RESPONSE; },
/* harmony export */   "jy": function() { return /* binding */ GET_PAST_USAGE; },
/* harmony export */   "k_": function() { return /* binding */ SET_PROFILE_LOADING; },
/* harmony export */   "l6": function() { return /* binding */ GET_PRODUCTS_BY_SKUS; },
/* harmony export */   "lG": function() { return /* binding */ UPDATE_SELECTED_DISPLAY_DATA; },
/* harmony export */   "lb": function() { return /* binding */ SELECTED_COLOR; },
/* harmony export */   "m7": function() { return /* binding */ IS_MULTICART; },
/* harmony export */   "n1": function() { return /* binding */ SET_CREDIT_CHECK_AFFORD_DEAL; },
/* harmony export */   "nU": function() { return /* binding */ SET_MAX_RECURRING; },
/* harmony export */   "nd": function() { return /* binding */ SET_CREDIT_CHECK_HOME_DATA; },
/* harmony export */   "nn": function() { return /* binding */ PRODUCT_SEARCH_LIST; },
/* harmony export */   "o2": function() { return /* binding */ REMOVE_COUPON_CODE; },
/* harmony export */   "og": function() { return /* binding */ UPDATE_PRODUCT_GRID_RESET; },
/* harmony export */   "pI": function() { return /* binding */ UPDATE_SELECTED_UPGRADE_DATA; },
/* harmony export */   "pM": function() { return /* binding */ SET_CREDIT_CHECK_DELIVERY_DATA; },
/* harmony export */   "rY": function() { return /* binding */ UPDATE_CHECK_DEAL_QUALIFIES; },
/* harmony export */   "sM": function() { return /* binding */ GET_CURRENCY_SYMBOL; },
/* harmony export */   "sm": function() { return /* binding */ SET_SHIPPING; },
/* harmony export */   "tG": function() { return /* binding */ STOP_UPGRADE_MODAL_TOGGLE; },
/* harmony export */   "ug": function() { return /* binding */ ADD_DEAL_TO_CART; },
/* harmony export */   "v6": function() { return /* binding */ GET_SKU; },
/* harmony export */   "vy": function() { return /* binding */ SET_CONTRACT_MODE; },
/* harmony export */   "wQ": function() { return /* binding */ SET_PAYMENT_METHOD; },
/* harmony export */   "wR": function() { return /* binding */ DISPLAY_INVALID_OTP_ERROR; },
/* harmony export */   "y9": function() { return /* binding */ DEAL_PRICE; },
/* harmony export */   "yP": function() { return /* binding */ SET_CREDIT_CHECK_EMPLOYMENT_DATA; },
/* harmony export */   "yn": function() { return /* binding */ UPDATE_UPGRADE_DATA; }
/* harmony export */ });
/* unused harmony exports PRODUCT_LIST, PRODUCT_LIST_PAGE, PRODUCT_LIST_METADATA, CATEGORIES_LIST, PRODUCT_DETAILS, PRODUCT_DETAILS_ERROR, SELECTED_VARIANT, SELECT_CATEGORY, SELECT_SUB_CATEGORY, SELECT_BRANDS, SELECT_PRICE, SELECT_PROMOTIONS, RESET_FILTERS, SELECT_PRODUCT_RANGE, PAGE_HISTORY, GET_FOOTER_LINKS_FAILURE, UPDATE_PRODUCT_BRANDS, STOP_UPGRADE */
// REDUX ACTION TYPES
var PRODUCT_LIST = "PRODUCT_LIST";
var PRODUCT_LIST_PAGE = "PRODUCT_LIST_PAGE";
var SET_IS_LOADING = "SET_IS_LOADING";
var PRODUCT_LIST_METADATA = "PRODUCT_LIST_METADATA";
var CATEGORIES_LIST = "CATEGORIES_LIST";
var PRODUCT_DETAILS = "PRODUCT_DETAILS";
var PRODUCT_DETAILS_ERROR = "PRODUCT_DETAILS_ERROR";
var SELECTED_COLOR = "SELECTED_COLOR";
var SELECTED_STORAGE = "SELECTED_STORAGE";
var SELECTED_VARIANT = "SELECTED_VARIANT";
var ADD_COMPARE_PRODUCT = "ADD_COMPARE_PRODUCT";
var REMOVE_COMPARE_PRODUCT = "REMOVE_COMPARE_PRODUCT";
var SHOW_COMPARE_ERROR = "SHOW_COMPARE_ERROR";
var REMOVE_ALL = "REMOVE_ALL";
var PRODUCT_COMPARE_LIST = "PRODUCT_COMPARE_LIST";
var REPLACE_COMPARE_PRODUCT = "REPLACE_COMPARE_PRODUCT";
var PRODUCT_SEARCH_LIST = "PRODUCT_SEARCH_LIST";
var GET_SKU = "GET_SKU";
var MEGA_MENU = "MEGA_MENU";
var GLOBAL_NAV = "GLOBAL_NAV";
var SET_HOME_COMPONENTS = "SET_HOME_COMPONENTS";
var SELECT_CATEGORY = "SELECT_CATEGORY";
var SELECT_SUB_CATEGORY = "SELECT_SUB_CATEGORY";
var SELECT_BRANDS = "SELECT_BRANDS";
var SELECT_PRICE = "SELECT_PRICE";
var SELECT_PROMOTIONS = "SELECT_PROMOTIONS";
var RESET_FILTERS = "RESET_FILTERS";
var TOGGLE_FILTERS = "TOGGLE_FILTERS";
var SELECT_PRODUCT_RANGE = "SELECT_PRODUCT_RANGE";
var PAGE_HISTORY = "PAGE_HISTORY";
var GEOLOCATION_STATUS = "GEOLOCATION_STATUS";
var GEOLOCATION_POSITION = "GEOLOCATION_POSITION";
var CANDC_STORE_DETAILS = "CANDC_STORE_DETAILS";
var GET_FOOTER_LINKS_SUCCESS = "GET_FOOTER_LINKS_SUCCESS";
var GET_FOOTER_LINKS_FAILURE = "GET_FOOTER_LINKS_FAILURE";
var DISPLAY_HIDE_FOOTER = "DISPLAY_HIDE_FOOTER";
var TERMS_AND_CONDITIONS = "TERMS_AND_CONDITIONS";
var CHANGE_OTHER_METHODS = "CHANGE_OTHER_METHODS";
var CHANGE_OTHER_STORE = "CHANGE_OTHER_STORE";
var TERMS_AND_CONDITIONS_TOPIC = "TERMS_AND_CONDITIONS_TOPIC";
var UPDATE_PRODUCT_BRANDS = "UPDATE_PRODUCT_BRANDS";
var ADD_SIMPLE_PRODUCT_TO_CART = "ADD_SIMPLE_PRODUCT_TO_CART";
var ADD_BUNDLE_PRODUCT_TO_CART = "ADD_BUNDLE_PRODUCT_TO_CART";
var ADD_CONFIGURABLE_PRODUCT_TO_CART = "ADD_CONFIGURABLE_PRODUCT_TO_CART";
var UPDATE_CART = "UPDATE_CART";
var REMOVE_FROM_CART = "REMOVE_FROM_CART";
var GUEST_VIEW_CART = "GUEST_VIEW_CART";
var GUEST_RESET_CART = "GUEST_RESET_CART";
var SET_SHIPPING_METHOD = "SET_SHIPPING_METHOD";
var SET_SHIPPING = "SET_SHIPPING";
var SET_BILLING = "SET_BILLING";
var ADD_COUPON_CODE = "ADD_COUPON_CODE";
var REMOVE_COUPON_CODE = "REMOVE_COUPON_CODE";
var SET_PROFILE_DATA = "SET_PROFILE_DATA";
var SET_PROFILE_LOADING = "SET_PROFILE_LOADING";
var SET_RELOGIN = "SET_RELOGIN";
var SET_MINIAPP = "SET_MINIAPP";
var SET_BACKENABLED = "SET_BACKENABLED";
var SET_CHECKOUT_LOGIN = "SET_CHECKOUT_LOGIN";
var TOGGLE_SEARCH = "TOGGLE_SEARCH";
var BREADCRUMB_SELECT = "BREADCRUMB_SELECT";
var ALERT_SELECT = "ALERT_SELECT";
var GET_SHIPPING_BILLING = "GET_SHIPPING_BILLING";
var IS_MULTICART = "IS_MULTICART";
var SET_NORMAL_CHECKOUT_CURRENT_STEP = "SET_NORMAL_CHECKOUT_CURRENT_STEP";
var SET_POST_CHECKOUT_CURRENT_STEP = "SET_POST_CHECKOUT_CURRENT_STEP";
var SET_LOOKUP_DETAILS = "SET_LOOKUP_DETAILS";
var SET_AUTHENTICATION_DETAILS = "SET_AUTHENTICATION_DETAILS";
var SET_SKIP_CREDIT_VETTING = "SET_SKIP_CREDIT_VETTING";
var SET_XDS_RESULT = "SET_XDS_RESULT";
var SET_CREDIT_VETTING_RESULT = "SET_CREDIT_VETTING_RESULT";
var SET_NUMBER_TRANSFER_TYPE = "SET_NUMBER_TRANSFER_TYPE";
var SET_NUMBER_TO_TRANSFER = "SET_NUMBER_TO_TRANSFER";
var SET_NUMBER_TRANSFER_DETAILS = "SET_NUMBER_TRANSFER_DETAILS";
var SET_PAYMENT_METHOD = "SET_PAYMENT_METHOD";
var SET_PAYMENT_METHOD_URL = "SET_PAYMENT_METHOD_URL";
var SET_POST_ORDER_RESPONSE = "SET_POST_ORDER_RESPONSE"; // upgrade

var DISPLAY_HIDE_MODAL = "DISPLAY_HIDE_MODAL";
var TOP_BANNER_TOGGLE = "TOP_BANNER_TOGGLE";
var TOP_BANNER_MODAL_TOGGLE = "TOP_BANNER_MODAL_TOGGLE";
var STOP_UPGRADE_MODAL_TOGGLE = "STOP_UPGRADE_MODAL_TOGGLE";
var UPDATE_UPGRADE_JOURNEY_STATUS = "UPDATE_UPGRADE_JOURNEY_STATUS";
var CLEAR_UPGRADE_JOURNEY_STATUS = "CLEAR_UPGRADE_JOURNEY_STATUS";
var UPDATE_CAN_RECEIVE_OTP = "UPDATE_CAN_RECEIVE_OTP";
var UPDATE_MSISDN_STATUS = "UPDATE_MSISDN_STATUS";
var UPDATE_ELIGIBILITY_CHECK_STATUS = "UPDATE_ELIGIBILITY_CHECK_STATUS";
var UPDATE_DISPLAY_DATA = "UPDATE_DISPLAY_DATA";
var UPDATE_SELECTED_DISPLAY_DATA = "UPDATE_SELECTED_DISPLAY_DATA";
var UPDATE_UPGRADE_DATA = "UPDATE_UPGRADE_DATA";
var INVALID_OTP = "INVALID_OTP";
var UPDATE_ELIGIBILITY_DATA = "UPDATE_ELIGIBILITY_DATA";
var ADD_ALTERNATE_NUMBERS = "ADD_ALTERNATE_NUMBERS";
var SET_CREDIT_CHECK_PERSONAL_DATA = "SET_CREDIT_CHECK_PERSONAL_DATA";
var SET_CREDIT_CHECK_EMPLOYMENT_DATA = "SET_CREDIT_CHECK_EMPLOYMENT_DATA";
var SET_CREDIT_CHECK_HOME_DATA = "SET_CREDIT_CHECK_HOME_DATA";
var SET_CREDIT_CHECK_DEBIT_DATA = "SET_CREDIT_CHECK_DEBIT_DATA";
var SET_CREDIT_CHECK_DELIVERY_DATA = "SET_CREDIT_CHECK_DELIVERY_DATA";
var SET_CREDIT_CHECK_CONTACT_DATA = "SET_CREDIT_CHECK_CONTACT_DATA";
var SET_CREDIT_CHECK_AFFORD_DEAL = "SET_CREDIT_CHECK_AFFORD_DEAL";
var SET_CREDIT_SELECTED_AFFORD_DEAL = "SET_CREDIT_SELECTED_AFFORD_DEAL";
var UPDATE_LOGGED_IN_USER_ELIGIBILITY_DATA = "UPDATE_LOGGED_IN_USER_ELIGIBILITY_DATA";
var UPDATE_UNMASKED_MSISDN = "UPDATE_UN_MASKED_MSISDN";
var GET_PAST_USAGE = "GET_PAST_USAGE";
var GET_UPGRADE_BRANDS = "GET_UPGRADE_BRANDS";
var GET_UPGRADE_MODELS = "GET_UPGRADE_MODELS";
var GET_RECOMMENDED_DEALS = "GET_RECOMMENDED_DEALS";
var UPDATE_SELECTED_UPGRADE_DATA = "UPDATE_SELECTED_UPGRADE_DATA";
var UPDATE_UPGRADE_REDIRECT = "UPDATE_UPGRADE_REDIRECT";
var GET_UPGRADE_CONSUMPTION = "GET_UPGRADE_CONSUMPTION";
var ADD_CREDIT_PROFILE = "ADD_CREDIT_PROFILE";
var UPDATE_CHECK_DEAL_QUALIFIES = "UPDATE_CHECK_DEAL_QUALIFIES";
var STOP_UPGRADE = "STOP_UPGRADE";
var RESET_INVALID_OTPS = "RESET_INVALID_OTPS";
var TOGGLE_SNACK_BAR = "TOGGLE_SNACK_BAR";
var DEAL_PRICE = "DEAL_PRIC";
var PAST_TOKEN = "PAST_TOKEN";
var UPDATE_DEAL_GRID_RESET = "UPDATE_DEAL_GRID_RESET";
var UPDATE_DEAL_SELECTION_RESET = "UPDATE_DEAL_SELECTION_RESET";
var UPDATE_PRODUCT_GRID_RESET = "UPDATE_PRODUCT_GRID_RESET";
var UPDATE_LINKED_NUMBER = "UPDATE_LINKED_NUMBER";
var MSISDN_BLOCKED = "MSISDN_BLOCKED";
var DISPLAY_INVALID_OTP_ERROR = "DISPLAY_INVALID_OTP_ERROR";
var UPDATE_NEXT_MSISDN_SELECTED = "UPDATE_NEXT_MSISDN_SELECTED";
var CLEAR_ENTIRE_JOURNEY = "CLEAR_ENTIRE_JOURNEY";
var ADD_DEAL_TO_CART = "ADD_DEAL_TO_CART";
var SET_CREDIT_VETTING_OUTCOME = "SET_CREDIT_VETTING_OUTCOME";
var SYNC_USER_PROFILE = "SYNC_USER_PROFILE";
var SYNC_USER_PROFILE_SUCCESS = "SYNC_USER_PROFILE_SUCCESS";
var SYNC_USER_PROFILE_FAILURE = "SYNC_USER_PROFILE_FAILURE";
var SYNC_USER_PROFILE_RESET = "SYNC_USER_PROFILE_RESET"; //post-checkout

var GUEST_CART_ITEMS = "GUEST_CART_ITEMS"; //checkout-page-error

var CHECKOUT_PAGE_ERROR_SELECTED_PREFERENCE = "CHECKOUT_PAGE_ERROR_SELECTED_PREFERENCE"; //help button

var SET_HELP_LEAD_BUCKET = "SET_HELP_LEAD_BUCKET"; // Deal Details


 // Features

var SET_FEATURES = "SET_FEATURES"; // Page Builder

var GET_CATEGORY_CMS_CONTENT = "GET_CATEGORY_CMS_CONTENT";
var GET_DEALS_PRODUCTS_BY_SKUS = "GET_DEALS_PRODUCTS_BY_SKUS";
var GET_PRODUCTS_BY_SKUS = "GET_PRODUCTS_BY_SKUS";
var GET_CURRENCY_SYMBOL = "GET_CURRENCY_SYMBOL"; // Deal Builder

var SET_CONTRACT_MODE = "SET_CONTRACT_MODE";
var SET_MAX_RECURRING = "SET_MAX_RECURRING";

/***/ }),

/***/ 35311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$D": function() { return /* binding */ deleteItemsFromCheckout; },
/* harmony export */   "HJ": function() { return /* binding */ addBundleProductToGuestCart; },
/* harmony export */   "Jj": function() { return /* binding */ resetGuestCart; },
/* harmony export */   "Pj": function() { return /* binding */ addGuestCartProducts; },
/* harmony export */   "TX": function() { return /* binding */ setCartMulti; },
/* harmony export */   "a1": function() { return /* binding */ addSimpleProductToGuestCart; },
/* harmony export */   "bc": function() { return /* binding */ addConfigurableToGuestCart; },
/* harmony export */   "cD": function() { return /* binding */ showGuestCart; },
/* harmony export */   "dY": function() { return /* binding */ deleteItemsFromCart; },
/* harmony export */   "iq": function() { return /* binding */ updateItemsofCart; },
/* harmony export */   "r$": function() { return /* binding */ removeCouponFromCart; },
/* harmony export */   "vD": function() { return /* binding */ addCouponToCart; },
/* harmony export */   "wJ": function() { return /* binding */ getShippingAndBilling; }
/* harmony export */ });
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50029);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var Redux_actionTypes_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1369);
/* harmony import */ var utils_helperServices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64036);
/* harmony import */ var utils_ajaxServices__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18517);
/* harmony import */ var _config_queries__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91250);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var deleteItemsFromCheckout = function deleteItemsFromCheckout(cartId, cartItemId) {
  return /*#__PURE__*/function () {
    var _ref = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(dispatch) {
      var deletedItems, cartResult;
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return utils_ajaxServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fetchGraphQLPOSTRequest */ .Z.fetchGraphQLPOSTRequest(_config_queries__WEBPACK_IMPORTED_MODULE_5__/* .removeCartItems */ .t9, {
                cart_id: cartId,
                cart_item_id: cartItemId
              });

            case 2:
              deletedItems = _context.sent;
              _context.next = 5;
              return utils_ajaxServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fetchGraphQLPOSTRequest */ .Z.fetchGraphQLPOSTRequest(_config_queries__WEBPACK_IMPORTED_MODULE_5__/* .guestViewCart */ .xw, {
                cart_id: cartId
              });

            case 5:
              cartResult = _context.sent;

              if (cartResult && cartResult.errors && cartResult.data && cartResult.data.cart) {
                deletedItems.removeItemFromCart = cartResult.data;
                cartResult = cartResult.data;
              } else {
                deletedItems.removeItemFromCart = cartResult;
              }

              (0,utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .updateCartExpiry */ .YF)();
              dispatch({
                type: Redux_actionTypes_index__WEBPACK_IMPORTED_MODULE_6__/* .GUEST_VIEW_CART */ .EC,
                payload: cartResult
              });

              if (deletedItems) {
                (0,utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .cartUpdateEvent */ .Px)();
              }

              return _context.abrupt("return", deletedItems);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var showGuestCart = function showGuestCart(cartId) {
  return /*#__PURE__*/function () {
    var _ref2 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2(dispatch) {
      var _cartResult, _cartResult2, _cartResult2$data;

      var cartResult;
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return utils_ajaxServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fetchGraphQLPOSTRequest */ .Z.fetchGraphQLPOSTRequest(_config_queries__WEBPACK_IMPORTED_MODULE_5__/* .guestViewCart */ .xw, {
                cart_id: cartId
              });

            case 2:
              cartResult = _context2.sent;

              if (cartResult && (_cartResult = cartResult) !== null && _cartResult !== void 0 && _cartResult.errors && (_cartResult2 = cartResult) !== null && _cartResult2 !== void 0 && (_cartResult2$data = _cartResult2.data) !== null && _cartResult2$data !== void 0 && _cartResult2$data.cart) {
                cartResult = cartResult.data;
              }

              dispatch({
                type: Redux_actionTypes_index__WEBPACK_IMPORTED_MODULE_6__/* .GUEST_VIEW_CART */ .EC,
                payload: cartResult
              });
              (0,utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .cartUpdateEvent */ .Px)();
              return _context2.abrupt("return", cartResult);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var resetGuestCart = function resetGuestCart() {
  return function (dispatch) {
    dispatch({
      type: Redux_actionTypes_index__WEBPACK_IMPORTED_MODULE_6__/* .GUEST_RESET_CART */ .Sr
    });
  };
};
var getShippingAndBilling = function getShippingAndBilling(cartId) {
  return /*#__PURE__*/function () {
    var _ref3 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee3(dispatch) {
      var cartResult;
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return utils_ajaxServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fetchGraphQLPOSTRequest */ .Z.fetchGraphQLPOSTRequest(_config_queries__WEBPACK_IMPORTED_MODULE_5__/* .shippingAndBillingAddress */ .NF, {
                cart_id: cartId
              });

            case 2:
              cartResult = _context3.sent;

              if (cartResult && cartResult.errors && cartResult.data && cartResult.data.cart) {
                cartResult = cartResult.data;
              }

              dispatch({
                type: Redux_actionTypes_index__WEBPACK_IMPORTED_MODULE_6__/* .GET_SHIPPING_BILLING */ .W_,
                payload: cartResult
              });
              return _context3.abrupt("return", cartResult);

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var addSimpleProductToGuestCart = function addSimpleProductToGuestCart(cartId, cartItems) {
  return /*#__PURE__*/function () {
    var _ref4 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee4(dispatch) {
      var addSimpleProductData, cartResult;
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return utils_ajaxServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fetchGraphQLPOSTRequest */ .Z.fetchGraphQLPOSTRequest(_config_queries__WEBPACK_IMPORTED_MODULE_5__/* .guestAddSimpleProductToCart */ .nF, {
                cart_id: cartId,
                cart_items: cartItems
              });

            case 2:
              addSimpleProductData = _context4.sent;

              if (!((addSimpleProductData === null || addSimpleProductData === void 0 ? void 0 : addSimpleProductData.status) === 200)) {
                _context4.next = 14;
                break;
              }

              _context4.next = 6;
              return utils_ajaxServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fetchGraphQLPOSTRequest */ .Z.fetchGraphQLPOSTRequest(_config_queries__WEBPACK_IMPORTED_MODULE_5__/* .guestViewCart */ .xw, {
                cart_id: cartId
              });

            case 6:
              cartResult = _context4.sent;

              if (cartResult && cartResult.errors && cartResult.data && cartResult.data.cart) {
                addSimpleProductData.addSimpleProductsToCart = cartResult.data;
              } else {
                addSimpleProductData.addSimpleProductsToCart = cartResult;
              }

              (0,utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .updateCartExpiry */ .YF)();
              dispatch({
                type: Redux_actionTypes_index__WEBPACK_IMPORTED_MODULE_6__/* .ADD_SIMPLE_PRODUCT_TO_CART */ .ch,
                payload: addSimpleProductData
              });

              if (addSimpleProductData) {
                (0,utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .cartUpdateEvent */ .Px)();
              }

              return _context4.abrupt("return", addSimpleProductData);

            case 14:
              return _context4.abrupt("return", addSimpleProductData);

            case 15:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var addBundleProductToGuestCart = function addBundleProductToGuestCart(cartId, cartItems) {
  return /*#__PURE__*/function () {
    var _ref5 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee5(dispatch) {
      var addBundleProductData, cartResult;
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return utils_ajaxServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fetchGraphQLPOSTRequest */ .Z.fetchGraphQLPOSTRequest(_config_queries__WEBPACK_IMPORTED_MODULE_5__/* .guestAddBundleProduct */ .WR, {
                cart_id: cartId,
                cart_items: cartItems
              });

            case 2:
              addBundleProductData = _context5.sent;

              if (!((addBundleProductData === null || addBundleProductData === void 0 ? void 0 : addBundleProductData.status) === 200)) {
                _context5.next = 14;
                break;
              }

              _context5.next = 6;
              return utils_ajaxServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fetchGraphQLPOSTRequest */ .Z.fetchGraphQLPOSTRequest(_config_queries__WEBPACK_IMPORTED_MODULE_5__/* .guestViewCart */ .xw, {
                cart_id: cartId
              });

            case 6:
              cartResult = _context5.sent;

              if (cartResult && cartResult.errors && cartResult.data && cartResult.data.cart) {
                addBundleProductData.addBundleProductsToCart = cartResult.data;
              } else {
                addBundleProductData.addBundleProductsToCart = cartResult;
              }

              (0,utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .updateCartExpiry */ .YF)();
              dispatch({
                type: Redux_actionTypes_index__WEBPACK_IMPORTED_MODULE_6__/* .ADD_BUNDLE_PRODUCT_TO_CART */ .Qz,
                payload: addBundleProductData
              });

              if (addBundleProductData) {
                (0,utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .cartUpdateEvent */ .Px)();
              }

              return _context5.abrupt("return", addBundleProductData);

            case 14:
              return _context5.abrupt("return", addBundleProductData);

            case 15:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var addConfigurableToGuestCart = function addConfigurableToGuestCart(cartId, cartItems) {
  return /*#__PURE__*/function () {
    var _ref6 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee6(dispatch) {
      var addConfigurableProductData, cartResult;
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return utils_ajaxServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fetchGraphQLPOSTRequest */ .Z.fetchGraphQLPOSTRequest(_config_queries__WEBPACK_IMPORTED_MODULE_5__/* .guestAddConfigurableProductToCart */ .p5, {
                cart_id: cartId,
                cart_items: cartItems
              });

            case 2:
              addConfigurableProductData = _context6.sent;

              if (!((addConfigurableProductData === null || addConfigurableProductData === void 0 ? void 0 : addConfigurableProductData.status) === 200)) {
                _context6.next = 14;
                break;
              }

              _context6.next = 6;
              return utils_ajaxServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fetchGraphQLPOSTRequest */ .Z.fetchGraphQLPOSTRequest(_config_queries__WEBPACK_IMPORTED_MODULE_5__/* .guestViewCart */ .xw, {
                cart_id: cartId
              });

            case 6:
              cartResult = _context6.sent;

              if (cartResult && cartResult.errors && cartResult.data && cartResult.data.cart) {
                addConfigurableProductData.addConfigurableProductsToCart = cartResult.data;
              } else {
                addConfigurableProductData.addConfigurableProductsToCart = cartResult;
              }

              (0,utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .updateCartExpiry */ .YF)();
              dispatch({
                type: Redux_actionTypes_index__WEBPACK_IMPORTED_MODULE_6__/* .ADD_CONFIGURABLE_PRODUCT_TO_CART */ .Js,
                payload: addConfigurableProductData
              });

              if (addConfigurableProductData) {
                (0,utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .cartUpdateEvent */ .Px)();
              }

              return _context6.abrupt("return", addConfigurableProductData);

            case 14:
              return _context6.abrupt("return", addConfigurableProductData);

            case 15:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x6) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var deleteItemsFromCart = function deleteItemsFromCart(cartId, cartItemId) {
  return /*#__PURE__*/function () {
    var _ref7 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee7(dispatch) {
      var deletedItems, cartResult;
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return utils_ajaxServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fetchGraphQLPOSTRequest */ .Z.fetchGraphQLPOSTRequest(_config_queries__WEBPACK_IMPORTED_MODULE_5__/* .removeCartItems */ .t9, {
                cart_id: cartId,
                cart_item_id: cartItemId
              });

            case 2:
              deletedItems = _context7.sent;

              if (!deletedItems.removeItemFromCart) {
                _context7.next = 11;
                break;
              }

              _context7.next = 6;
              return utils_ajaxServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fetchGraphQLPOSTRequest */ .Z.fetchGraphQLPOSTRequest(_config_queries__WEBPACK_IMPORTED_MODULE_5__/* .guestViewCart */ .xw, {
                cart_id: cartId
              });

            case 6:
              cartResult = _context7.sent;

              if (cartResult && cartResult.errors && cartResult.data && cartResult.data.cart) {
                deletedItems.removeItemFromCart = cartResult.data;
              } else {
                deletedItems.removeItemFromCart = cartResult;
              }

              (0,utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .updateCartExpiry */ .YF)();
              dispatch({
                type: Redux_actionTypes_index__WEBPACK_IMPORTED_MODULE_6__/* .REMOVE_FROM_CART */ .OZ,
                payload: deletedItems
              });
              (0,utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .cartUpdateEvent */ .Px)();

            case 11:
              return _context7.abrupt("return", deletedItems);

            case 12:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x7) {
      return _ref7.apply(this, arguments);
    };
  }();
};
var updateItemsofCart = function updateItemsofCart(cartId, cartItemId, quantity, configureAttributes, customizable_options) {
  return /*#__PURE__*/function () {
    var _ref8 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee8(dispatch) {
      var attributes, updatedItems, cartResult;
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              attributes = configureAttributes ? configureAttributes : [];
              _context8.next = 3;
              return utils_ajaxServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fetchGraphQLPOSTRequest */ .Z.fetchGraphQLPOSTRequest(_config_queries__WEBPACK_IMPORTED_MODULE_5__/* .updateCartItems */ ._W, {
                cart_id: cartId,
                cart_item_id: cartItemId,
                quantity: quantity,
                attributes: attributes,
                customizable_options: customizable_options
              });

            case 3:
              updatedItems = _context8.sent;
              _context8.next = 6;
              return utils_ajaxServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fetchGraphQLPOSTRequest */ .Z.fetchGraphQLPOSTRequest(_config_queries__WEBPACK_IMPORTED_MODULE_5__/* .guestViewCart */ .xw, {
                cart_id: cartId
              });

            case 6:
              cartResult = _context8.sent;

              if (cartResult && cartResult.errors && cartResult.data && cartResult.data.cart) {
                updatedItems.updateCartItems = cartResult.data;
              } else {
                updatedItems.updateCartItems = cartResult;
              }

              (0,utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .updateCartExpiry */ .YF)();
              dispatch({
                type: Redux_actionTypes_index__WEBPACK_IMPORTED_MODULE_6__/* .UPDATE_CART */ .gQ,
                payload: updatedItems
              });

              if (updatedItems) {
                (0,utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .cartUpdateEvent */ .Px)();
              }

              dispatch({
                type: Redux_actionTypes_index__WEBPACK_IMPORTED_MODULE_6__/* .GUEST_VIEW_CART */ .EC,
                payload: cartResult
              });
              return _context8.abrupt("return", updatedItems);

            case 13:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function (_x8) {
      return _ref8.apply(this, arguments);
    };
  }();
};
var addCouponToCart = function addCouponToCart(cartId, couponCode) {
  return /*#__PURE__*/function () {
    var _ref9 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee9(dispatch) {
      var appliedCoupon, cartResult, combined;
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return utils_ajaxServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fetchGraphQLPOSTRequest */ .Z.fetchGraphQLPOSTRequest(_config_queries__WEBPACK_IMPORTED_MODULE_5__/* .AddCouponCode */ .Pe, {
                cart_id: cartId,
                coupon_code: couponCode
              });

            case 2:
              appliedCoupon = _context9.sent;
              _context9.next = 5;
              return utils_ajaxServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fetchGraphQLPOSTRequest */ .Z.fetchGraphQLPOSTRequest(_config_queries__WEBPACK_IMPORTED_MODULE_5__/* .guestViewCart */ .xw, {
                cart_id: cartId
              });

            case 5:
              cartResult = _context9.sent;
              combined = _objectSpread(_objectSpread({}, appliedCoupon), {}, {
                applyCouponToCart: cartResult
              });
              (0,utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .updateCartExpiry */ .YF)();
              dispatch({
                type: Redux_actionTypes_index__WEBPACK_IMPORTED_MODULE_6__/* .ADD_COUPON_CODE */ .Ek,
                payload: combined
              });
              return _context9.abrupt("return", appliedCoupon);

            case 10:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function (_x9) {
      return _ref9.apply(this, arguments);
    };
  }();
};
var removeCouponFromCart = function removeCouponFromCart(cartId) {
  return /*#__PURE__*/function () {
    var _ref10 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee10(dispatch) {
      var removedCoupon, cartResult;
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return utils_ajaxServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fetchGraphQLPOSTRequest */ .Z.fetchGraphQLPOSTRequest(_config_queries__WEBPACK_IMPORTED_MODULE_5__/* .removeCouponCode */ .cK, {
                cart_id: cartId
              });

            case 2:
              removedCoupon = _context10.sent;
              _context10.next = 5;
              return utils_ajaxServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fetchGraphQLPOSTRequest */ .Z.fetchGraphQLPOSTRequest(_config_queries__WEBPACK_IMPORTED_MODULE_5__/* .guestViewCart */ .xw, {
                cart_id: cartId
              });

            case 5:
              cartResult = _context10.sent;
              removedCoupon.removeCouponFromCart = cartResult;
              (0,utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .updateCartExpiry */ .YF)();
              dispatch({
                type: Redux_actionTypes_index__WEBPACK_IMPORTED_MODULE_6__/* .REMOVE_COUPON_CODE */ .o2,
                payload: removedCoupon
              });
              return _context10.abrupt("return", removedCoupon);

            case 10:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function (_x10) {
      return _ref10.apply(this, arguments);
    };
  }();
};
var addGuestCartProducts = function addGuestCartProducts(products, totalItems, coupon) {
  return function (dispatch) {
    dispatch({
      type: Redux_actionTypes_index__WEBPACK_IMPORTED_MODULE_6__/* .GUEST_CART_ITEMS */ .O$,
      payload: {
        products: products,
        totalItems: totalItems,
        coupon: coupon
      }
    });
  };
};
var setCartMulti = function setCartMulti(isMulti) {
  return function (dispatch) {
    dispatch({
      type: Redux_actionTypes_index__WEBPACK_IMPORTED_MODULE_6__/* .IS_MULTICART */ .m7,
      payload: isMulti
    });
  };
};

/***/ }),

/***/ 88093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ setLoadingStatus; },
/* harmony export */   "k": function() { return /* binding */ checkFeatures; }
/* harmony export */ });
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50029);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var Redux_actionTypes_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1369);
/* harmony import */ var utils_ajaxServices__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18517);




var setLoadingStatus = function setLoadingStatus(status, dispatch) {
  if (dispatch) {
    dispatch({
      type: Redux_actionTypes_index__WEBPACK_IMPORTED_MODULE_2__/* .SET_IS_LOADING */ .GA,
      payload: status
    });
  }

  if (status) {
    document.body.classList.add('spinnerOverlay');
  } else {
    document.body.classList.remove('spinnerOverlay');
  }
};
var checkFeatures = function checkFeatures() {
  return /*#__PURE__*/function () {
    var _ref = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
      var featuresResult;
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return utils_ajaxServices__WEBPACK_IMPORTED_MODULE_1__/* ["default"].httpGet */ .Z.httpGet("featureBaseUrl", "", "api", "features");

            case 2:
              featuresResult = _context.sent;

              if (featuresResult) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return", {
                ok: false,
                isError: true,
                res: featuresResult
              });

            case 5:
              dispatch({
                type: Redux_actionTypes_index__WEBPACK_IMPORTED_MODULE_2__/* .SET_FEATURES */ .iQ,
                payload: featuresResult
              });
              return _context.abrupt("return", {
                ok: true
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

/***/ }),

/***/ 9449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ setContractMode; },
/* harmony export */   "V": function() { return /* binding */ setMaxRecurring; }
/* harmony export */ });
/* harmony import */ var _actionTypes_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1369);

var setContractMode = function setContractMode(value) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_0__/* .SET_CONTRACT_MODE */ .vy,
      payload: value
    });
  };
};
var setMaxRecurring = function setMaxRecurring(value) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_0__/* .SET_MAX_RECURRING */ .nU,
      payload: value
    });
  };
};

/***/ }),

/***/ 42220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HS": function() { return /* binding */ setBackEnabled; },
/* harmony export */   "Kg": function() { return /* binding */ setProfileLoading; },
/* harmony export */   "Lf": function() { return /* binding */ setReLogin; },
/* harmony export */   "Oh": function() { return /* binding */ setCheckoutLogin; },
/* harmony export */   "_J": function() { return /* binding */ setProfileData; },
/* harmony export */   "aD": function() { return /* binding */ toggleFilters; },
/* harmony export */   "j2": function() { return /* binding */ toggleSearch; },
/* harmony export */   "no": function() { return /* binding */ setMiniApp; }
/* harmony export */ });
/* unused harmony exports megaMenu, globalNav */
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50029);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _actionTypes_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1369);
/* harmony import */ var _utils_ajaxServices__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18517);
/* harmony import */ var _commonAction__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88093);





var megaMenu = function megaMenu() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setLoadingStatus(true, dispatch);
              _context.next = 4;
              return ajaxService.httpGet("drupalBaseUrl", "", "api", "getMainMenuMetaData");

            case 4:
              result = _context.sent;
              dispatch({
                type: MEGA_MENU,
                payload: result.children
              });
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              setLoadingStatus(false, dispatch);

            case 11:
              _context.prev = 11;
              setLoadingStatus(false, dispatch);
              return _context.finish(11);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8, 11, 14]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var globalNav = function globalNav() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var result;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              setLoadingStatus(true, dispatch);
              _context2.next = 4;
              return ajaxService.httpGet("drupalBaseUrl", "", "api", "getGlobalNavMetaData");

            case 4:
              result = _context2.sent;
              dispatch({
                type: GLOBAL_NAV,
                payload: result
              });
              _context2.next = 11;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              setLoadingStatus(false, dispatch);

            case 11:
              _context2.prev = 11;
              setLoadingStatus(false, dispatch);
              return _context2.finish(11);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 8, 11, 14]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var toggleSearch = function toggleSearch(value) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_3__/* .TOGGLE_SEARCH */ .Tw,
      payload: value
    });
  };
};
var setProfileData = function setProfileData(profileInfo) {
  return /*#__PURE__*/function () {
    var _ref3 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(dispatch) {
      var _profileInfo$result, _profileInfo$result$p, _profileInfo$result$p2, customerInfo;

      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (profileInfo && profileInfo.result && profileInfo.result.magentoProfileResponse[0] && profileInfo.result.magentoProfileResponse[0].oauthTokenDetails[0]) {
                customerInfo = {
                  id: profileInfo.result.magentoProfileResponse[0].oauthTokenDetails[0].customer_id,
                  groupName: profileInfo.result.magentoProfileResponse[0].customerGroupName
                };
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_3__/* .SET_PROFILE_DATA */ .eT,
                  payload: {
                    profile: profileInfo.result.magentoProfileResponse[0].ProfileDetails[0],
                    user: true,
                    customer: customerInfo,
                    oauthTokenDetails: profileInfo.result.magentoProfileResponse[0].oauthTokenDetails[0],
                    subscriptions: (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$result = profileInfo.result) === null || _profileInfo$result === void 0 ? void 0 : (_profileInfo$result$p = _profileInfo$result.profileSubscriptionResponse) === null || _profileInfo$result$p === void 0 ? void 0 : (_profileInfo$result$p2 = _profileInfo$result$p.subscriptions) === null || _profileInfo$result$p2 === void 0 ? void 0 : _profileInfo$result$p2.subscriptions) || []
                  }
                });
              } else {
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_3__/* .SET_PROFILE_DATA */ .eT,
                  payload: {
                    profile: null,
                    user: false,
                    customer: null,
                    oauthTokenDetails: null,
                    subscriptions: []
                  }
                });
              }

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var setProfileLoading = function setProfileLoading(status) {
  return /*#__PURE__*/function () {
    var _ref4 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(dispatch) {
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              dispatch({
                type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_3__/* .SET_PROFILE_LOADING */ .k_,
                payload: status
              });

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var setReLogin = function setReLogin(status) {
  return /*#__PURE__*/function () {
    var _ref5 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(dispatch) {
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              dispatch({
                type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_3__/* .SET_RELOGIN */ .Ld,
                payload: status
              });

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var setMiniApp = function setMiniApp(status) {
  return /*#__PURE__*/function () {
    var _ref6 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6(dispatch) {
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              dispatch({
                type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_3__/* .SET_MINIAPP */ .Um,
                payload: status
              });

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x6) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var setBackEnabled = function setBackEnabled(status) {
  return /*#__PURE__*/function () {
    var _ref7 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee7(dispatch) {
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              dispatch({
                type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_3__/* .SET_BACKENABLED */ .WD,
                payload: status
              });

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x7) {
      return _ref7.apply(this, arguments);
    };
  }();
};
var toggleFilters = function toggleFilters(value) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_3__/* .TOGGLE_FILTERS */ .$G,
      payload: value
    });
  };
};
var setCheckoutLogin = function setCheckoutLogin(status) {
  return /*#__PURE__*/function () {
    var _ref8 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee8(dispatch) {
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              dispatch({
                type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_3__/* .SET_CHECKOUT_LOGIN */ .QV,
                payload: status
              });

            case 1:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function (_x8) {
      return _ref8.apply(this, arguments);
    };
  }();
};

/***/ }),

/***/ 58486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ resetInvalidOtps; },
/* harmony export */   "CC": function() { return /* binding */ fetchAlternateNumbers; },
/* harmony export */   "GZ": function() { return /* binding */ getAllEligibility; },
/* harmony export */   "HZ": function() { return /* binding */ setSelectedDisplayData; },
/* harmony export */   "Mn": function() { return /* binding */ getDeviceModels; },
/* harmony export */   "NO": function() { return /* binding */ fetchDisplayDetails; },
/* harmony export */   "Np": function() { return /* binding */ toggleSnackBar; },
/* harmony export */   "Od": function() { return /* binding */ displayHideUpgradeTopbanner; },
/* harmony export */   "Op": function() { return /* binding */ updatedNextMsisdnSelected; },
/* harmony export */   "P": function() { return /* binding */ generateOTP; },
/* harmony export */   "Pl": function() { return /* binding */ updateMsisdnStatus; },
/* harmony export */   "QB": function() { return /* binding */ updateLinkedNumber; },
/* harmony export */   "QH": function() { return /* binding */ updateDealSelectionReset; },
/* harmony export */   "QV": function() { return /* binding */ fetchCreditFilters; },
/* harmony export */   "RZ": function() { return /* binding */ checkIfdealQualifies; },
/* harmony export */   "Ri": function() { return /* binding */ displayHideUpgradeTopbannerModal; },
/* harmony export */   "UY": function() { return /* binding */ updateEligibiltyCheckStatus; },
/* harmony export */   "VA": function() { return /* binding */ updateData; },
/* harmony export */   "VZ": function() { return /* binding */ getRecommendedDeals; },
/* harmony export */   "We": function() { return /* binding */ eligibilityForLinkedNumbersList; },
/* harmony export */   "Wm": function() { return /* binding */ getEligibilityForAlternativeNumbers; },
/* harmony export */   "YA": function() { return /* binding */ getLookupData; },
/* harmony export */   "Zi": function() { return /* binding */ displayInvalidOTPError; },
/* harmony export */   "aI": function() { return /* binding */ updateJourneyStatus; },
/* harmony export */   "c7": function() { return /* binding */ updateUnmaskedMsisdn; },
/* harmony export */   "ex": function() { return /* binding */ displayHideUpgradeModal; },
/* harmony export */   "ff": function() { return /* binding */ addDealToCart; },
/* harmony export */   "kb": function() { return /* binding */ setDevicePrice; },
/* harmony export */   "m5": function() { return /* binding */ getPastUsage; },
/* harmony export */   "ow": function() { return /* binding */ generateOneTimePin; },
/* harmony export */   "rX": function() { return /* binding */ clearUpgradeJourney; },
/* harmony export */   "rn": function() { return /* binding */ updateCanReciveOTP; },
/* harmony export */   "vo": function() { return /* binding */ updateProductGridReset; },
/* harmony export */   "wi": function() { return /* binding */ updateDealsReset; },
/* harmony export */   "x$": function() { return /* binding */ updateSelectedData; },
/* harmony export */   "z9": function() { return /* binding */ updateUpgradeRedirect; }
/* harmony export */ });
/* unused harmony export stopUpgradeTopbannerModal */
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50029);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64036);
/* harmony import */ var _utils_microServices__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49366);
/* harmony import */ var _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1369);
/* harmony import */ var _utils_ajaxServices__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18517);
/* harmony import */ var _utils_featuresService__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90760);
/* harmony import */ var _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70098);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28658);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var env = (_config_index__WEBPACK_IMPORTED_MODULE_6___default().env);
var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_6___default().envConfigs)[env].imagePrefix;
var displayHideUpgradeModal = function displayHideUpgradeModal(value) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .DISPLAY_HIDE_MODAL */ .eK,
      payload: value
    });
  };
};
var clearUpgradeJourney = function clearUpgradeJourney() {
  var clearAll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return function (dispatch) {
    (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .deleteSessionStorage */ .pC)("isNotshowQualifyingDeals");
    _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .legacySessionData.forEach */ .wc.forEach(function (item) {
      return (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .deleteSessionStorage */ .pC)(item);
    });

    if (clearAll) {
      dispatch({
        type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .CLEAR_ENTIRE_JOURNEY */ .Q0
      });
    } else {
      dispatch({
        type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .CLEAR_UPGRADE_JOURNEY_STATUS */ .ZU
      });
      dispatch({
        type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .SET_CONTRACT_MODE */ .vy,
        payload: 'new-contract'
      });
    }
  };
};
var updateCanReciveOTP = function updateCanReciveOTP(value) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_CAN_RECEIVE_OTP */ .C7,
      payload: value
    });
  };
};
var updateMsisdnStatus = function updateMsisdnStatus(number, status) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_MSISDN_STATUS */ .Ss,
      payload: {
        status: status,
        number: number
      }
    });
  };
};
var updateEligibiltyCheckStatus = function updateEligibiltyCheckStatus(value) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_ELIGIBILITY_CHECK_STATUS */ .ah,
      payload: value
    });
  };
};
var updateJourneyStatus = function updateJourneyStatus(value) {
  var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .upgradeStages.TECHNICAL_ERROR */ .wv.TECHNICAL_ERROR;
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_UPGRADE_JOURNEY_STATUS */ .bA,
      payload: {
        status: status,
        code: value
      }
    });
  };
};
var generateOneTimePin = function generateOneTimePin(msisdn) {
  return /*#__PURE__*/function () {
    var _ref = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(dispatch) {
      var params, responseData;
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .showSpinner */ .yh)();
              params = [{
                address: msisdn,
                message: "otp-warning-sms-message",
                otpMessageProperties: {
                  additionalProp1: "string",
                  additionalProp2: "string",
                  additionalProp3: "string"
                },
                type: "SMS"
              }];
              _context.next = 5;
              return _utils_microServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("api", "oneTimePin", params, null, false, [msisdn]);

            case 5:
              responseData = _context.sent;

              if (responseData.fail) {
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_UPGRADE_JOURNEY_STATUS */ .bA,
                  payload: {
                    status: _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .upgradeStages.TECHNICAL_ERROR */ .wv.TECHNICAL_ERROR,
                    code: _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .errorCodes.otp_service_down */ .Zk.otp_service_down
                  }
                });
              } else {
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_UPGRADE_JOURNEY_STATUS */ .bA,
                  payload: {
                    status: _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .upgradeStages.OTP_ENRTY */ .wv.OTP_ENRTY,
                    code: null
                  }
                });
              }

              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();

            case 12:
              _context.prev = 12;
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();
              return _context.finish(12);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9, 12, 15]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var setToken = function setToken(token) {
  var _token$response;

  if (token && token !== null && token !== void 0 && (_token$response = token.response) !== null && _token$response !== void 0 && _token$response.headers) {
    var _token$response2;

    _components_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_7__.Cookie.set("eligibility-token", token === null || token === void 0 ? void 0 : (_token$response2 = token.response) === null || _token$response2 === void 0 ? void 0 : _token$response2.headers["x-auth-jwt"]);
  }
};

var getAllEligibility = function getAllEligibility(msisdn, otp) {
  return /*#__PURE__*/function () {
    var _ref2 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2(dispatch) {
      var responseData, params, _responseData, _responseData$respons, _responseData2, _responseData2$respon;

      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .showSpinner */ .yh)();
              params = {
                id: msisdn,
                key: "UPGRADE_ELIGIBILITY",
                otp: otp,
                msisdn: msisdn
              };
              _context2.next = 5;
              return _utils_microServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("api", "getAllEligibility", params, null, false);

            case 5:
              responseData = _context2.sent;

              if (responseData.fail) {
                if (responseData.error.status === 422) {
                  dispatch({
                    type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .INVALID_OTP */ ._G
                  });
                } else if (responseData.error.status === 400) {
                  dispatch({
                    type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .MSISDN_BLOCKED */ .gA
                  });
                } else if (responseData.error.status === 401) {
                  dispatch({
                    type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_UPGRADE_JOURNEY_STATUS */ .bA,
                    payload: {
                      status: _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .upgradeStages.TECHNICAL_ERROR */ .wv.TECHNICAL_ERROR,
                      code: _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .errorCodes.user_acc_error */ .Zk.user_acc_error
                    }
                  });
                } else {
                  dispatch({
                    type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_UPGRADE_JOURNEY_STATUS */ .bA,
                    payload: {
                      status: _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .upgradeStages.TECHNICAL_ERROR */ .wv.TECHNICAL_ERROR,
                      code: _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .errorCodes.service_down */ .Zk.service_down
                    }
                  });
                }
              } else {
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .RESET_INVALID_OTPS */ .ct
                });
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_UPGRADE_JOURNEY_STATUS */ .bA,
                  payload: {
                    status: _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .upgradeStages.UPGRADE_RESULT */ .wv.UPGRADE_RESULT,
                    code: null
                  }
                });
                setToken(responseData);
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_ELIGIBILITY_DATA */ .ic,
                  payload: {
                    data: ((_responseData = responseData) === null || _responseData === void 0 ? void 0 : (_responseData$respons = _responseData.response) === null || _responseData$respons === void 0 ? void 0 : _responseData$respons.data) || {}
                  }
                });
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .PAST_TOKEN */ .Fh,
                  payload: {
                    token: (_responseData2 = responseData) === null || _responseData2 === void 0 ? void 0 : (_responseData2$respon = _responseData2.response) === null || _responseData2$respon === void 0 ? void 0 : _responseData2$respon.headers
                  }
                });
              }

              _context2.next = 12;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();

            case 12:
              _context2.prev = 12;
              setToken(responseData);
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();
              return _context2.finish(12);

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 9, 12, 16]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var fetchAlternateNumbers = function fetchAlternateNumbers(msisdn) {
  return /*#__PURE__*/function () {
    var _ref3 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee3(dispatch) {
      var params, reqParams, responseData, dispatchData, _responseData$respons2, _responseData$respons3, _responseData$respons4, _responseData$respons5, _responseData$respons6, _responseData$respons7;

      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .showSpinner */ .yh)();
              params = {
                docType: "MSISDN"
              };
              reqParams = [msisdn];
              _context3.next = 6;
              return _utils_microServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("api", "getMSIDNForAuthentication", params, false, reqParams);

            case 6:
              responseData = _context3.sent;

              dispatchData = function dispatchData() {
                return dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_UPGRADE_JOURNEY_STATUS */ .bA,
                  payload: {
                    status: _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .upgradeStages.TECHNICAL_ERROR */ .wv.TECHNICAL_ERROR,
                    code: _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .errorCodes.code_otp_no_alternative */ .Zk.code_otp_no_alternative
                  }
                });
              };

              if (responseData.fail) {
                if (responseData.error.status === 404) {
                  dispatchData();
                } else {
                  dispatch({
                    type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_UPGRADE_JOURNEY_STATUS */ .bA,
                    payload: {
                      status: _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .upgradeStages.TECHNICAL_ERROR */ .wv.TECHNICAL_ERROR,
                      code: _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .errorCodes.service_down */ .Zk.service_down
                    }
                  });
                }
              } else {
                if ((_responseData$respons2 = responseData.response) !== null && _responseData$respons2 !== void 0 && (_responseData$respons3 = _responseData$respons2.data) !== null && _responseData$respons3 !== void 0 && _responseData$respons3.result && ((_responseData$respons4 = responseData.response) === null || _responseData$respons4 === void 0 ? void 0 : (_responseData$respons5 = _responseData$respons4.data) === null || _responseData$respons5 === void 0 ? void 0 : _responseData$respons5.result.length) > 0) {
                  dispatch({
                    type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .ADD_ALTERNATE_NUMBERS */ .BD,
                    payload: {
                      data: (_responseData$respons6 = responseData.response) === null || _responseData$respons6 === void 0 ? void 0 : (_responseData$respons7 = _responseData$respons6.data) === null || _responseData$respons7 === void 0 ? void 0 : _responseData$respons7.result
                    }
                  });
                  dispatch({
                    type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_UPGRADE_JOURNEY_STATUS */ .bA,
                    payload: {
                      status: _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .upgradeStages.NUMBER_SELECT */ .wv.NUMBER_SELECT,
                      code: null
                    }
                  });
                } else {
                  dispatchData();
                }
              }

              _context3.next = 14;
              break;

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](0);
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();

            case 14:
              _context3.prev = 14;
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();
              return _context3.finish(14);

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 11, 14, 17]]);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var getEligibilityForAlternativeNumbers = function getEligibilityForAlternativeNumbers(msisdn, maskedMsisdn, otp) {
  return /*#__PURE__*/function () {
    var _ref4 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee4(dispatch) {
      var responseData, params, _responseData3, _responseData3$respon;

      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .showSpinner */ .yh)();
              params = {
                idNumber: msisdn,
                docType: "MSISDN",
                maskedMsisdn: maskedMsisdn,
                otp: otp,
                msisdn: msisdn
              };
              _context4.next = 5;
              return _utils_microServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("api", "getEligibilityForAlternativeNumbers", params, null, false);

            case 5:
              responseData = _context4.sent;

              if (responseData.fail) {
                if (responseData.error.status === 401) {
                  dispatch({
                    type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .INVALID_OTP */ ._G
                  });
                } else {
                  dispatch({
                    type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_UPGRADE_JOURNEY_STATUS */ .bA,
                    payload: {
                      status: _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .upgradeStages.TECHNICAL_ERROR */ .wv.TECHNICAL_ERROR,
                      code: _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .errorCodes.service_down */ .Zk.service_down
                    }
                  });
                }
              } else {
                setToken(responseData);
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_UPGRADE_JOURNEY_STATUS */ .bA,
                  payload: {
                    status: _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .upgradeStages.UPGRADE_RESULT */ .wv.UPGRADE_RESULT,
                    code: null
                  }
                });
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_ELIGIBILITY_DATA */ .ic,
                  payload: {
                    data: ((_responseData3 = responseData) === null || _responseData3 === void 0 ? void 0 : (_responseData3$respon = _responseData3.response) === null || _responseData3$respon === void 0 ? void 0 : _responseData3$respon.data) || {}
                  }
                });
              }

              _context4.next = 12;
              break;

            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](0);
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();

            case 12:
              _context4.prev = 12;
              setToken(responseData);
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();
              return _context4.finish(12);

            case 16:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 9, 12, 16]]);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var generateOTP = function generateOTP(msisdn, maskedMsisdn) {
  return /*#__PURE__*/function () {
    var _ref5 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee5(dispatch) {
      var urlParams, responseData;
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .showSpinner */ .yh)();
              urlParams = "?idNumber=".concat(msisdn, "&docType=MSISDN&maskedMsisdn=").concat(maskedMsisdn);
              _context5.next = 5;
              return _utils_microServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("api", "generateOtp", {}, null, false, null, urlParams);

            case 5:
              responseData = _context5.sent;

              if (responseData.fail) {
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_UPGRADE_JOURNEY_STATUS */ .bA,
                  payload: {
                    status: _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .upgradeStages.TECHNICAL_ERROR */ .wv.TECHNICAL_ERROR,
                    code: _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .errorCodes.otp_service_down */ .Zk.otp_service_down
                  }
                });
              } else {
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_UPGRADE_JOURNEY_STATUS */ .bA,
                  payload: {
                    status: _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .upgradeStages.OTP_ENRTY */ .wv.OTP_ENRTY,
                    code: null
                  }
                });
              }

              _context5.next = 12;
              break;

            case 9:
              _context5.prev = 9;
              _context5.t0 = _context5["catch"](0);
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();

            case 12:
              _context5.prev = 12;
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();
              return _context5.finish(12);

            case 15:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 9, 12, 15]]);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var eligibilityForLinkedNumbersList = function eligibilityForLinkedNumbersList(msisdns) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "test";
  return /*#__PURE__*/function () {
    var _ref6 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee6(dispatch) {
      var params, responseData, _responseData$respons8, _responseData$respons9;

      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .showSpinner */ .yh)();
              params = {
                msisdn: msisdns.join(","),
                sendSms: false,
                name: name
              };
              _context6.next = 5;
              return _utils_microServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("api", "eligibilityForLinkedNumbersList", params, false, null, null, true);

            case 5:
              responseData = _context6.sent;

              if (!responseData.fail) {
                _context6.next = 10;
                break;
              }

              if (responseData.error.status === 401) {
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_UPGRADE_JOURNEY_STATUS */ .bA,
                  payload: {
                    status: _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .upgradeStages.TECHNICAL_ERROR */ .wv.TECHNICAL_ERROR,
                    code: _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .errorCodes.user_acc_error */ .Zk.user_acc_error
                  }
                });
              } else {
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_UPGRADE_JOURNEY_STATUS */ .bA,
                  payload: {
                    status: _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .upgradeStages.TECHNICAL_ERROR */ .wv.TECHNICAL_ERROR,
                    code: _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .errorCodes.logged_user_service_down */ .Zk.logged_user_service_down
                  }
                });
              }

              _context6.next = 13;
              break;

            case 10:
              dispatch({
                type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_UPGRADE_JOURNEY_STATUS */ .bA,
                payload: {
                  status: _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .upgradeStages.UPGRADE_RESULT */ .wv.UPGRADE_RESULT,
                  code: null
                }
              });
              dispatch({
                type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_LOGGED_IN_USER_ELIGIBILITY_DATA */ .jN,
                payload: {
                  data: responseData === null || responseData === void 0 ? void 0 : (_responseData$respons8 = responseData.response) === null || _responseData$respons8 === void 0 ? void 0 : _responseData$respons8.data
                }
              });
              return _context6.abrupt("return", responseData === null || responseData === void 0 ? void 0 : (_responseData$respons9 = responseData.response) === null || _responseData$respons9 === void 0 ? void 0 : _responseData$respons9.data);

            case 13:
              _context6.next = 18;
              break;

            case 15:
              _context6.prev = 15;
              _context6.t0 = _context6["catch"](0);
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();

            case 18:
              _context6.prev = 18;
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();
              return _context6.finish(18);

            case 21:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[0, 15, 18, 21]]);
    }));

    return function (_x6) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var setSelectedDisplayData = function setSelectedDisplayData(payload) {
  return /*#__PURE__*/function () {
    var _ref7 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee7(dispatch) {
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              dispatch({
                type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_SELECTED_DISPLAY_DATA */ .lG,
                payload: payload
              });

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x7) {
      return _ref7.apply(this, arguments);
    };
  }();
};
var fetchDisplayDetails = function fetchDisplayDetails(resultCode) {
  return /*#__PURE__*/function () {
    var _ref8 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee8(dispatch) {
      var result;
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .showSpinner */ .yh)();
              dispatch({
                type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_DISPLAY_DATA */ .j1,
                payload: {}
              });
              _context8.next = 5;
              return _utils_ajaxServices__WEBPACK_IMPORTED_MODULE_4__/* ["default"].httpGet */ .Z.httpGet("drupalBaseUrl", "", "api", "upgradeResult", [resultCode]);

            case 5:
              result = _context8.sent;
              dispatch({
                type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_DISPLAY_DATA */ .j1,
                payload: result && result.length && result[0]
              });
              _context8.next = 13;
              break;

            case 9:
              _context8.prev = 9;
              _context8.t0 = _context8["catch"](0);
              dispatch({
                type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_DISPLAY_DATA */ .j1,
                payload: {
                  analyticTitle: "upgradeeligibility_logged_500",
                  category: "Upgrade",
                  icon: "".concat(imagePrefix, "/assets/images/icon-cross.svg"),
                  primaryCTAText: "Call me back",
                  primaryCTAURL: "/shopping/forms/ecommerce",
                  primaryEnabled: "Yes",
                  resultCode: "upgradeeligibility_logged_500",
                  resultHTML: false,
                  resultText: "We’re not able to check your upgrade status right now. Please try again later, or have one of our consultants contact you.",
                  resultTitle: "Something went wrong",
                  secondaryCTAText: "Go to home page",
                  secondaryCTAURL: "/",
                  secondaryEnabled: "Yes"
                }
              });
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();

            case 13:
              _context8.prev = 13;
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();
              return _context8.finish(13);

            case 16:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[0, 9, 13, 16]]);
    }));

    return function (_x8) {
      return _ref8.apply(this, arguments);
    };
  }();
};
var displayHideUpgradeTopbanner = function displayHideUpgradeTopbanner(value) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .TOP_BANNER_TOGGLE */ .Np,
      payload: value
    });
  };
};
var displayHideUpgradeTopbannerModal = function displayHideUpgradeTopbannerModal(value) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .TOP_BANNER_MODAL_TOGGLE */ .U5,
      payload: value
    });
  };
};
var stopUpgradeTopbannerModal = function stopUpgradeTopbannerModal(value) {
  return function (dispatch) {
    dispatch({
      type: types.STOP_UPGRADE_MODAL_TOGGLE,
      payload: value
    });
  };
};
var fetchCreditFilters = function fetchCreditFilters(msisdn) {
  return /*#__PURE__*/function () {
    var _ref9 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee9(dispatch) {
      var _responseData$respons10, _responseData$respons11, _responseData$respons12, _responseData$respons13, _responseData$respons14, _responseData$respons15, reqParams, responseData;

      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .showSpinner */ .yh)();
              reqParams = [msisdn];
              _context9.next = 5;
              return _utils_microServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("api", "creditFilters", {}, false, reqParams);

            case 5:
              responseData = _context9.sent;
              dispatch({
                type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .ADD_CREDIT_PROFILE */ .DJ,
                payload: (responseData === null || responseData === void 0 ? void 0 : (_responseData$respons10 = responseData.response) === null || _responseData$respons10 === void 0 ? void 0 : (_responseData$respons11 = _responseData$respons10.data) === null || _responseData$respons11 === void 0 ? void 0 : (_responseData$respons12 = _responseData$respons11.result) === null || _responseData$respons12 === void 0 ? void 0 : _responseData$respons12.creditFilter) || {}
              });
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();
              return _context9.abrupt("return", _objectSpread({
                fail: responseData === null || responseData === void 0 ? void 0 : responseData.fail
              }, responseData === null || responseData === void 0 ? void 0 : (_responseData$respons13 = responseData.response) === null || _responseData$respons13 === void 0 ? void 0 : (_responseData$respons14 = _responseData$respons13.data) === null || _responseData$respons14 === void 0 ? void 0 : (_responseData$respons15 = _responseData$respons14.result) === null || _responseData$respons15 === void 0 ? void 0 : _responseData$respons15.creditFilter));

            case 11:
              _context9.prev = 11;
              _context9.t0 = _context9["catch"](0);
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();

            case 14:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[0, 11]]);
    }));

    return function (_x9) {
      return _ref9.apply(this, arguments);
    };
  }();
};
var updateSelectedData = function updateSelectedData(data) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_SELECTED_UPGRADE_DATA */ .pI,
      payload: {
        resultCode: data === null || data === void 0 ? void 0 : data.resultCode,
        data: data,
        msisdn: (0,_services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .maskMsisdn */ .Ly)(data === null || data === void 0 ? void 0 : data.msisdn)
      }
    });
  };
};
var updateData = function updateData(data) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_UPGRADE_DATA */ .yn,
      payload: {
        resultCode: data === null || data === void 0 ? void 0 : data.resultCode,
        data: data,
        msisdn: (0,_services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .maskMsisdn */ .Ly)(data === null || data === void 0 ? void 0 : data.msisdn)
      }
    });
  };
};
var updateUpgradeRedirect = function updateUpgradeRedirect(link, text) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_UPGRADE_REDIRECT */ .ZM,
      payload: {
        link: link,
        text: text
      }
    });
  };
};
var updateUnmaskedMsisdn = function updateUnmaskedMsisdn(value) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_UNMASKED_MSISDN */ .jA,
      payload: value
    });
  };
};
var getPastUsage = function getPastUsage(msisdn) {
  return /*#__PURE__*/function () {
    var _ref10 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee10(dispatch) {
      var queryParams, responseData;
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .showSpinner */ .yh)();
              queryParams = "?msisdn=".concat(msisdn);
              _context10.next = 5;
              return _utils_microServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("api", "pastUsage", null, false, null, queryParams);

            case 5:
              responseData = _context10.sent;

              if (responseData.fail) {
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_UPGRADE_JOURNEY_STATUS */ .bA,
                  payload: {
                    status: _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .upgradeStages.TECHNICAL_ERROR */ .wv.TECHNICAL_ERROR,
                    code: _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .errorCodes.otp_service_down */ .Zk.otp_service_down
                  }
                });
              } else {
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .GET_PAST_USAGE */ .jy,
                  payload: {
                    data: responseData === null || responseData === void 0 ? void 0 : responseData.response.data.result
                  }
                });
              }

              _context10.next = 12;
              break;

            case 9:
              _context10.prev = 9;
              _context10.t0 = _context10["catch"](0);
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();

            case 12:
              _context10.prev = 12;
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();
              return _context10.finish(12);

            case 15:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, null, [[0, 9, 12, 15]]);
    }));

    return function (_x10) {
      return _ref10.apply(this, arguments);
    };
  }();
};
var getLookupData = function getLookupData() {
  return /*#__PURE__*/function () {
    var _ref11 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee11(dispatch) {
      var responseData, _responseData$respons16, _responseData$respons17;

      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .showSpinner */ .yh)();
              _context11.next = 4;
              return _utils_microServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("api", "lookupData", null, false);

            case 4:
              responseData = _context11.sent;

              if (responseData) {
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .GET_UPGRADE_BRANDS */ .ZP,
                  payload: {
                    data: responseData === null || responseData === void 0 ? void 0 : (_responseData$respons16 = responseData.response) === null || _responseData$respons16 === void 0 ? void 0 : (_responseData$respons17 = _responseData$respons16.data) === null || _responseData$respons17 === void 0 ? void 0 : _responseData$respons17.result
                  }
                });
              }

              _context11.next = 11;
              break;

            case 8:
              _context11.prev = 8;
              _context11.t0 = _context11["catch"](0);
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();

            case 11:
              _context11.prev = 11;
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();
              return _context11.finish(11);

            case 14:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[0, 8, 11, 14]]);
    }));

    return function (_x11) {
      return _ref11.apply(this, arguments);
    };
  }();
};
var getDeviceModels = function getDeviceModels(brand) {
  return /*#__PURE__*/function () {
    var _ref12 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee12(dispatch) {
      var queryParams, responseData, _responseData$respons18, _responseData$respons19;

      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .showSpinner */ .yh)();
              queryParams = "?manufacturer=".concat(brand);
              _context12.next = 5;
              return _utils_microServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("api", "upgradeDeviceModels", null, false, null, queryParams);

            case 5:
              responseData = _context12.sent;

              if (responseData) {
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .GET_UPGRADE_MODELS */ .hL,
                  payload: {
                    data: responseData === null || responseData === void 0 ? void 0 : (_responseData$respons18 = responseData.response) === null || _responseData$respons18 === void 0 ? void 0 : (_responseData$respons19 = _responseData$respons18.data) === null || _responseData$respons19 === void 0 ? void 0 : _responseData$respons19.result
                  }
                });
              }

              _context12.next = 12;
              break;

            case 9:
              _context12.prev = 9;
              _context12.t0 = _context12["catch"](0);
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();

            case 12:
              _context12.prev = 12;
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();
              return _context12.finish(12);

            case 15:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, null, [[0, 9, 12, 15]]);
    }));

    return function (_x12) {
      return _ref12.apply(this, arguments);
    };
  }();
};
var getRecommendedDeals = function getRecommendedDeals(num) {
  var contract = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var brand = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var model = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
  var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";
  var deviceInstallment = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";
  var financeIndicator = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : "";
  var dealSku = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : "";
  var simOnlyUpgradeFlg = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : "";
  return /*#__PURE__*/function () {
    var _ref13 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee13(dispatch) {
      var contractUrl, brandsUrl, modelUrl, limitUrl, financedThresholdAmount, accountDealFlag, dealSheetNumber, simOnlyUpgrade, queryParams, responseData, _responseData$respons20, _responseData$respons21, _responseData$respons22, _responseData$respons23;

      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.prev = 0;
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .showSpinner */ .yh)();
              contractUrl = contract ? "&simOnly=".concat(contract) : "";
              brandsUrl = brand ? "&deviceManufacturer=".concat(brand) : "";
              modelUrl = model ? "&device=".concat(model) : "";
              limitUrl = limit ? "&tariffLimit=".concat(limit) : "";
              financedThresholdAmount = deviceInstallment ? "&financedThresholdAmount=".concat(Number(deviceInstallment)) : "";
              accountDealFlag = financeIndicator ? "&accountDealFlag=".concat(financeIndicator) : "";
              dealSheetNumber = dealSku ? "&dealsheetNumber=".concat(dealSku) : "";
              simOnlyUpgrade = _utils_featuresService__WEBPACK_IMPORTED_MODULE_10__/* .Features.get */ .A.get("simOnlyEarlyUpgradeEnabled") && simOnlyUpgradeFlg === "Y" ? "&simOnlyAnytimeUpgrade=".concat(simOnlyUpgradeFlg) : "";
              queryParams = "?msisdn=".concat(num).concat(contractUrl).concat(brandsUrl).concat(modelUrl).concat(limitUrl).concat(financedThresholdAmount).concat(accountDealFlag).concat(dealSheetNumber).concat(simOnlyUpgrade);
              _context13.next = 13;
              return _utils_microServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("api", "getRecommendedDeals", null, false, null, queryParams);

            case 13:
              responseData = _context13.sent;

              if (responseData.fail) {
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .GET_RECOMMENDED_DEALS */ .I6,
                  payload: {
                    data: responseData === null || responseData === void 0 ? void 0 : (_responseData$respons20 = responseData.response) === null || _responseData$respons20 === void 0 ? void 0 : (_responseData$respons21 = _responseData$respons20.data) === null || _responseData$respons21 === void 0 ? void 0 : _responseData$respons21.result,
                    error: true
                  }
                });
              } else {
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .GET_RECOMMENDED_DEALS */ .I6,
                  payload: {
                    data: responseData === null || responseData === void 0 ? void 0 : (_responseData$respons22 = responseData.response) === null || _responseData$respons22 === void 0 ? void 0 : (_responseData$respons23 = _responseData$respons22.data) === null || _responseData$respons23 === void 0 ? void 0 : _responseData$respons23.result,
                    error: false
                  }
                });
              }

              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();
              return _context13.abrupt("return", responseData);

            case 19:
              _context13.prev = 19;
              _context13.t0 = _context13["catch"](0);
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();
              return _context13.abrupt("return", _context13.t0);

            case 23:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, null, [[0, 19]]);
    }));

    return function (_x13) {
      return _ref13.apply(this, arguments);
    };
  }();
};
var checkIfdealQualifies = function checkIfdealQualifies(value) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_CHECK_DEAL_QUALIFIES */ .rY,
      payload: value
    });
  };
};
var resetInvalidOtps = function resetInvalidOtps() {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .RESET_INVALID_OTPS */ .ct
    });
  };
};
var toggleSnackBar = function toggleSnackBar(value) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .TOGGLE_SNACK_BAR */ .Bd,
      payload: value
    });
  };
};
var setDevicePrice = function setDevicePrice(value) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .DEAL_PRICE */ .y9,
      payload: value
    });
  };
};
var updateDealsReset = function updateDealsReset() {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_DEAL_GRID_RESET */ .WO
    });
  };
};
var updateDealSelectionReset = function updateDealSelectionReset() {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_DEAL_SELECTION_RESET */ ._f
    });
  };
};
var updateProductGridReset = function updateProductGridReset() {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_PRODUCT_GRID_RESET */ .og
    });
  };
};
var updateLinkedNumber = function updateLinkedNumber(msisdn) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_LINKED_NUMBER */ .j$,
      payload: msisdn
    });
  };
};
var displayInvalidOTPError = function displayInvalidOTPError(value) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .DISPLAY_INVALID_OTP_ERROR */ .wR,
      payload: value
    });
  };
};
var updatedNextMsisdnSelected = function updatedNextMsisdnSelected(value) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .UPDATE_NEXT_MSISDN_SELECTED */ .Of,
      payload: value
    });
  };
};
var addDealToCart = function addDealToCart(value) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_8__/* .ADD_DEAL_TO_CART */ .ug,
      payload: value
    });
  };
};

/***/ }),

/***/ 79549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _CTAButton_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21938);
/* harmony import */ var _CTAButton_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_CTAButton_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28658);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64036);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);




/**
 * CTAButton component: Displays button based on props passed from parent component.
 * e.g <CTAButton variant="primary" id="" className=""/>
 */
// * For proper styling, use one of the among variants.




var VARIANTS = ["primary", "solid white", "solid grey", "solid blackish", "solid black", "solid red", "solid green", "outline black", "outline white", "outline grey", "flat black", "flat white", "flat red", "flat teal51", "link teal", "link black", "link white", "link teal51", "solid light gray"];

var CTAButton = function CTAButton(props) {
  var variant = props.variant.toLowerCase();
  var env = (_config_index__WEBPACK_IMPORTED_MODULE_2___default().env);
  var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_2___default().envConfigs)[env].imagePrefix; // checks if props button variant type exists in our VARIANTS stylings

  var setButtonStyle = VARIANTS.includes(variant) ? variant.replace(/ /g, "-") : VARIANTS[0];
  var ctaLink = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_1__/* .internalUrl */ .az)(props.url);

  var generateImageUrl = function generateImageUrl() {
    switch (props.variant) {
      case "link teal51":
        return "".concat(imagePrefix, "/assets/images/custom-arrow-teal.svg");

      case "link white":
        return "".concat(imagePrefix, "/assets/images/custom-arrow-white.svg");

      default:
        return "".concat(imagePrefix, "/assets/images/custom-arrow.svg");
        break;
    }
  };

  var renderButtonContents = function renderButtonContents() {
    if (props.url) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Link, {
          legacyBehavior: true,
          href: ctaLink.url,
          prefetch: props.isOpenNewTab && props.isOpenNewTab === "1" ? false : ctaLink.internal,
          passHref: true,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("a", {
            id: props.id,
            onClick: props.handleClick,
            className: "".concat((_CTAButton_module_scss__WEBPACK_IMPORTED_MODULE_4___default().button), " ").concat((_CTAButton_module_scss__WEBPACK_IMPORTED_MODULE_4___default())["button__".concat(setButtonStyle)], " ").concat(props.className, " ").concat((_CTAButton_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[props === null || props === void 0 ? void 0 : props.btnSizing]),
            target: props.isOpenNewTab === "1" ? "_blank" : "_self",
            children: [props.children, props.variant.includes("link") ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
              className: (_CTAButton_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["right-arrow"]),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
                src: "".concat(imagePrefix, "/assets/images/custom-arrow.svg"),
                style: {
                  marginBottom: ".125rem"
                }
              })
            }) : ""]
          })
        })
      });
    } else if (props.navigation) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", {
          id: props.id,
          href: props.navigation,
          onClick: props.handleClick,
          className: "".concat((_CTAButton_module_scss__WEBPACK_IMPORTED_MODULE_4___default().button), " ").concat((_CTAButton_module_scss__WEBPACK_IMPORTED_MODULE_4___default())["button__".concat(setButtonStyle)], " ").concat(props.className),
          children: props.children
        })
      });
    } else {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("button", {
        type: props.type,
        id: props.id,
        value: props.value,
        className: "".concat((_CTAButton_module_scss__WEBPACK_IMPORTED_MODULE_4___default().button), " ").concat((_CTAButton_module_scss__WEBPACK_IMPORTED_MODULE_4___default())["button__".concat(setButtonStyle)], " ").concat(props.className, "  ").concat((_CTAButton_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[props === null || props === void 0 ? void 0 : props.btnSizing]),
        disabled: props.disabled,
        onClick: props.handleClick,
        children: [" ", props.children, props.variant.includes("link") ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
          className: (_CTAButton_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["right-arrow"]),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
            src: generateImageUrl(),
            style: {
              marginBottom: ".125rem"
            }
          })
        }) : ""]
      });
    }
  };

  return renderButtonContents();
};

CTAButton.defaultProps = {
  type: "button",
  id: "",
  className: "",
  variant: "",
  children: "",
  disabled: false,
  url: "",
  handleClick: function handleClick() {}
};
/* harmony default export */ __webpack_exports__["default"] = (CTAButton);

/***/ }),

/***/ 28658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Accordion": function() { return /* binding */ DependencyHelper_Accordion; },
  "Breadcrumb": function() { return /* binding */ DependencyHelper_Breadcrumb; },
  "Button": function() { return /* binding */ DependencyHelper_Button; },
  "ButtonGroup": function() { return /* binding */ DependencyHelper_ButtonGroup; },
  "Card": function() { return /* binding */ DependencyHelper_Card; },
  "CardColumns": function() { return /* binding */ DependencyHelper_CardColumns; },
  "CardDeck": function() { return /* binding */ DependencyHelper_CardDeck; },
  "Col": function() { return /* binding */ DependencyHelper_Col; },
  "Container": function() { return /* binding */ DependencyHelper_Container; },
  "Cookie": function() { return /* binding */ Cookie; },
  "Countdown": function() { return /* binding */ Countdown; },
  "CustomContainer": function() { return /* binding */ CustomContainer; },
  "Dropdown": function() { return /* binding */ DependencyHelper_Dropdown; },
  "DropdownButton": function() { return /* binding */ DependencyHelper_DropdownButton; },
  "FooterContainer": function() { return /* binding */ FooterContainer; },
  "Form": function() { return /* binding */ DependencyHelper_Form; },
  "Head": function() { return /* binding */ Head; },
  "Image": function() { return /* binding */ DependencyHelper_Image; },
  "Link": function() { return /* binding */ Link; },
  "Modal": function() { return /* binding */ DependencyHelper_Modal; },
  "Nav": function() { return /* binding */ DependencyHelper_Nav; },
  "OverlayTrigger": function() { return /* binding */ DependencyHelper_OverlayTrigger; },
  "OwlCarousel": function() { return /* binding */ DependencyHelper_OwlCarousel; },
  "Pannellum": function() { return /* binding */ Pannellum; },
  "PannellumGetConfig": function() { return /* binding */ PannellumGetConfig; },
  "PannellumSetYaw": function() { return /* binding */ PannellumSetYaw; },
  "Progress": function() { return /* binding */ Progress; },
  "ProgressBar": function() { return /* binding */ DependencyHelper_ProgressBar; },
  "Router": function() { return /* binding */ Router; },
  "Row": function() { return /* binding */ DependencyHelper_Row; },
  "Spinner": function() { return /* binding */ DependencyHelper_Spinner; },
  "Tab": function() { return /* binding */ DependencyHelper_Tab; },
  "Text": function() { return /* binding */ Text; },
  "TextTruncate": function() { return /* binding */ TextTruncate; },
  "Tooltip": function() { return /* binding */ DependencyHelper_Tooltip; },
  "connect": function() { return /* binding */ connect; },
  "sha256": function() { return /* binding */ DependencyHelper_sha256; },
  "useAccordionToggle": function() { return /* binding */ DependencyHelper_useAccordionToggle; },
  "useDispatch": function() { return /* binding */ useDispatch; },
  "useRouter": function() { return /* binding */ useRouter; },
  "withRouter": function() { return /* binding */ withRouter; }
});

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(21608);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/addEventListener.js
var addEventListener = __webpack_require__(9351);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/canUseDOM.js
var canUseDOM = __webpack_require__(23004);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/ownerDocument.js
var ownerDocument = __webpack_require__(67216);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/removeEventListener.js
var removeEventListener = __webpack_require__(30099);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/scrollbarSize.js

var size;
function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (canUseDOM/* default */.Z) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useCallbackRef.js
var useCallbackRef = __webpack_require__(32092);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useEventCallback.js + 1 modules
var useEventCallback = __webpack_require__(51176);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useWillUnmount.js + 1 modules
var useWillUnmount = __webpack_require__(76852);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/transitionEnd.js + 1 modules
var transitionEnd = __webpack_require__(94305);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/activeElement.js

/**
 * Returns the actively focused element safely.
 *
 * @param doc the document to check
 */

function activeElement(doc) {
  if (doc === void 0) {
    doc = (0,ownerDocument/* default */.Z)();
  }

  // Support: IE 9 only
  // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
  try {
    var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
    // document.activeElement from an <iframe>

    if (!active || !active.nodeName) return null;
    return active;
  } catch (e) {
    /* ie throws if no active element */
    return doc.body;
  }
}
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/contains.js
var contains = __webpack_require__(90424);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/listen.js
var listen = __webpack_require__(72950);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useMounted.js
var useMounted = __webpack_require__(6454);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/usePrevious.js

/**
 * Store the last of some value. Tracked via a `Ref` only updating it
 * after the component renders.
 *
 * Helpful if you need to compare a prop value to it's previous value during render.
 *
 * ```ts
 * function Component(props) {
 *   const lastProps = usePrevious(props)
 *
 *   if (lastProps.foo !== props.foo)
 *     resetValueFromProps(props.foo)
 * }
 * ```
 *
 * @param value the value to track
 */

function usePrevious(value) {
  var ref = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    ref.current = value;
  });
  return ref.current;
}
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/hasClass.js
var hasClass = __webpack_require__(11132);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/addClass.js

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0,hasClass/* default */.Z)(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/removeClass.js
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/css.js + 5 modules
var css = __webpack_require__(91505);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/isDocument.js
function isDocument(element) {
  return 'nodeType' in element && element.nodeType === document.DOCUMENT_NODE;
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/isWindow.js

function isWindow(node) {
  if ('window' in node && node.window === node) return node;
  if (isDocument(node)) return node.defaultView || false;
  return false;
}
;// CONCATENATED MODULE: ./node_modules/react-overlays/esm/isOverflowing.js



function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
}

function bodyIsOverflowing(node) {
  var doc = isWindow(node) ? (0,ownerDocument/* default */.Z)() : (0,ownerDocument/* default */.Z)(node);
  var win = isWindow(node) || doc.defaultView;
  return doc.body.clientWidth < win.innerWidth;
}

function isOverflowing(container) {
  var win = isWindow(container);
  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
}
;// CONCATENATED MODULE: ./node_modules/react-overlays/esm/manageAriaHidden.js
var BLACKLIST = ['template', 'script', 'style'];

var isHidable = function isHidable(_ref) {
  var nodeType = _ref.nodeType,
      tagName = _ref.tagName;
  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
};

var siblings = function siblings(container, exclude, cb) {
  [].forEach.call(container.children, function (node) {
    if (exclude.indexOf(node) === -1 && isHidable(node)) {
      cb(node);
    }
  });
};

function ariaHidden(hide, node) {
  if (!node) return;

  if (hide) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}
function hideSiblings(container, _ref2) {
  var dialog = _ref2.dialog,
      backdrop = _ref2.backdrop;
  siblings(container, [dialog, backdrop], function (node) {
    return ariaHidden(true, node);
  });
}
function showSiblings(container, _ref3) {
  var dialog = _ref3.dialog,
      backdrop = _ref3.backdrop;
  siblings(container, [dialog, backdrop], function (node) {
    return ariaHidden(false, node);
  });
}
;// CONCATENATED MODULE: ./node_modules/react-overlays/esm/ModalManager.js







function findIndexOf(arr, cb) {
  var idx = -1;
  arr.some(function (d, i) {
    if (cb(d, i)) {
      idx = i;
      return true;
    }

    return false;
  });
  return idx;
}

/**
 * Proper state management for containers and the modals in those containers.
 *
 * @internal Used by the Modal to ensure proper styling of containers.
 */
var ModalManager = /*#__PURE__*/function () {
  function ModalManager(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        _ref$hideSiblingNodes = _ref.hideSiblingNodes,
        hideSiblingNodes = _ref$hideSiblingNodes === void 0 ? true : _ref$hideSiblingNodes,
        _ref$handleContainerO = _ref.handleContainerOverflow,
        handleContainerOverflow = _ref$handleContainerO === void 0 ? true : _ref$handleContainerO;

    this.hideSiblingNodes = void 0;
    this.handleContainerOverflow = void 0;
    this.modals = void 0;
    this.containers = void 0;
    this.data = void 0;
    this.scrollbarSize = void 0;
    this.hideSiblingNodes = hideSiblingNodes;
    this.handleContainerOverflow = handleContainerOverflow;
    this.modals = [];
    this.containers = [];
    this.data = [];
    this.scrollbarSize = scrollbarSize();
  }

  var _proto = ModalManager.prototype;

  _proto.isContainerOverflowing = function isContainerOverflowing(modal) {
    var data = this.data[this.containerIndexFromModal(modal)];
    return data && data.overflowing;
  };

  _proto.containerIndexFromModal = function containerIndexFromModal(modal) {
    return findIndexOf(this.data, function (d) {
      return d.modals.indexOf(modal) !== -1;
    });
  };

  _proto.setContainerStyle = function setContainerStyle(containerState, container) {
    var style = {
      overflow: 'hidden'
    }; // we are only interested in the actual `style` here
    // because we will override it

    containerState.style = {
      overflow: container.style.overflow,
      paddingRight: container.style.paddingRight
    };

    if (containerState.overflowing) {
      // use computed style, here to get the real padding
      // to add our scrollbar width
      style.paddingRight = parseInt((0,css/* default */.Z)(container, 'paddingRight') || '0', 10) + this.scrollbarSize + "px";
    }

    (0,css/* default */.Z)(container, style);
  };

  _proto.removeContainerStyle = function removeContainerStyle(containerState, container) {
    Object.assign(container.style, containerState.style);
  };

  _proto.add = function add(modal, container, className) {
    var modalIdx = this.modals.indexOf(modal);
    var containerIdx = this.containers.indexOf(container);

    if (modalIdx !== -1) {
      return modalIdx;
    }

    modalIdx = this.modals.length;
    this.modals.push(modal);

    if (this.hideSiblingNodes) {
      hideSiblings(container, modal);
    }

    if (containerIdx !== -1) {
      this.data[containerIdx].modals.push(modal);
      return modalIdx;
    }

    var data = {
      modals: [modal],
      // right now only the first modal of a container will have its classes applied
      classes: className ? className.split(/\s+/) : [],
      overflowing: isOverflowing(container)
    };

    if (this.handleContainerOverflow) {
      this.setContainerStyle(data, container);
    }

    data.classes.forEach(addClass.bind(null, container));
    this.containers.push(container);
    this.data.push(data);
    return modalIdx;
  };

  _proto.remove = function remove(modal) {
    var modalIdx = this.modals.indexOf(modal);

    if (modalIdx === -1) {
      return;
    }

    var containerIdx = this.containerIndexFromModal(modal);
    var data = this.data[containerIdx];
    var container = this.containers[containerIdx];
    data.modals.splice(data.modals.indexOf(modal), 1);
    this.modals.splice(modalIdx, 1); // if that was the last modal in a container,
    // clean up the container

    if (data.modals.length === 0) {
      data.classes.forEach(removeClass.bind(null, container));

      if (this.handleContainerOverflow) {
        this.removeContainerStyle(data, container);
      }

      if (this.hideSiblingNodes) {
        showSiblings(container, modal);
      }

      this.containers.splice(containerIdx, 1);
      this.data.splice(containerIdx, 1);
    } else if (this.hideSiblingNodes) {
      // otherwise make sure the next top modal is visible to a SR
      var _data$modals = data.modals[data.modals.length - 1],
          backdrop = _data$modals.backdrop,
          dialog = _data$modals.dialog;
      ariaHidden(false, dialog);
      ariaHidden(false, backdrop);
    }
  };

  _proto.isTopModal = function isTopModal(modal) {
    return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
  };

  return ModalManager;
}();

/* harmony default export */ var esm_ModalManager = (ModalManager);
// EXTERNAL MODULE: ./node_modules/react-overlays/esm/useWaitForDOMRef.js
var useWaitForDOMRef = __webpack_require__(23446);
;// CONCATENATED MODULE: ./node_modules/react-overlays/esm/Modal.js



/* eslint-disable @typescript-eslint/no-use-before-define, react/prop-types */













var manager;

function getManager() {
  if (!manager) manager = new esm_ModalManager();
  return manager;
}

function useModalManager(provided) {
  var modalManager = provided || getManager();
  var modal = (0,react.useRef)({
    dialog: null,
    backdrop: null
  });
  return Object.assign(modal.current, {
    add: function add(container, className) {
      return modalManager.add(modal.current, container, className);
    },
    remove: function remove() {
      return modalManager.remove(modal.current);
    },
    isTopModal: function isTopModal() {
      return modalManager.isTopModal(modal.current);
    },
    setDialogRef: (0,react.useCallback)(function (ref) {
      modal.current.dialog = ref;
    }, []),
    setBackdropRef: (0,react.useCallback)(function (ref) {
      modal.current.backdrop = ref;
    }, [])
  });
}

var Modal = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var _ref$show = _ref.show,
      show = _ref$show === void 0 ? false : _ref$show,
      _ref$role = _ref.role,
      role = _ref$role === void 0 ? 'dialog' : _ref$role,
      className = _ref.className,
      style = _ref.style,
      children = _ref.children,
      _ref$backdrop = _ref.backdrop,
      backdrop = _ref$backdrop === void 0 ? true : _ref$backdrop,
      _ref$keyboard = _ref.keyboard,
      keyboard = _ref$keyboard === void 0 ? true : _ref$keyboard,
      onBackdropClick = _ref.onBackdropClick,
      onEscapeKeyDown = _ref.onEscapeKeyDown,
      transition = _ref.transition,
      backdropTransition = _ref.backdropTransition,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus,
      _ref$enforceFocus = _ref.enforceFocus,
      enforceFocus = _ref$enforceFocus === void 0 ? true : _ref$enforceFocus,
      _ref$restoreFocus = _ref.restoreFocus,
      restoreFocus = _ref$restoreFocus === void 0 ? true : _ref$restoreFocus,
      restoreFocusOptions = _ref.restoreFocusOptions,
      renderDialog = _ref.renderDialog,
      _ref$renderBackdrop = _ref.renderBackdrop,
      renderBackdrop = _ref$renderBackdrop === void 0 ? function (props) {
    return /*#__PURE__*/react.createElement("div", props);
  } : _ref$renderBackdrop,
      providedManager = _ref.manager,
      containerRef = _ref.container,
      containerClassName = _ref.containerClassName,
      onShow = _ref.onShow,
      _ref$onHide = _ref.onHide,
      onHide = _ref$onHide === void 0 ? function () {} : _ref$onHide,
      onExit = _ref.onExit,
      onExited = _ref.onExited,
      onExiting = _ref.onExiting,
      onEnter = _ref.onEnter,
      onEntering = _ref.onEntering,
      onEntered = _ref.onEntered,
      rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["show", "role", "className", "style", "children", "backdrop", "keyboard", "onBackdropClick", "onEscapeKeyDown", "transition", "backdropTransition", "autoFocus", "enforceFocus", "restoreFocus", "restoreFocusOptions", "renderDialog", "renderBackdrop", "manager", "container", "containerClassName", "onShow", "onHide", "onExit", "onExited", "onExiting", "onEnter", "onEntering", "onEntered"]);

  var container = (0,useWaitForDOMRef/* default */.Z)(containerRef);
  var modal = useModalManager(providedManager);
  var isMounted = (0,useMounted/* default */.Z)();
  var prevShow = usePrevious(show);

  var _useState = (0,react.useState)(!show),
      exited = _useState[0],
      setExited = _useState[1];

  var lastFocusRef = (0,react.useRef)(null);
  (0,react.useImperativeHandle)(ref, function () {
    return modal;
  }, [modal]);

  if (canUseDOM/* default */.Z && !prevShow && show) {
    lastFocusRef.current = activeElement();
  }

  if (!transition && !show && !exited) {
    setExited(true);
  } else if (show && exited) {
    setExited(false);
  }

  var handleShow = (0,useEventCallback/* default */.Z)(function () {
    modal.add(container, containerClassName);
    removeKeydownListenerRef.current = (0,listen/* default */.Z)(document, 'keydown', handleDocumentKeyDown);
    removeFocusListenerRef.current = (0,listen/* default */.Z)(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
    // and so steals focus from it
    function () {
      return setTimeout(handleEnforceFocus);
    }, true);

    if (onShow) {
      onShow();
    } // autofocus after onShow to not trigger a focus event for previous
    // modals before this one is shown.


    if (autoFocus) {
      var currentActiveElement = activeElement(document);

      if (modal.dialog && currentActiveElement && !(0,contains/* default */.Z)(modal.dialog, currentActiveElement)) {
        lastFocusRef.current = currentActiveElement;
        modal.dialog.focus();
      }
    }
  });
  var handleHide = (0,useEventCallback/* default */.Z)(function () {
    modal.remove();
    removeKeydownListenerRef.current == null ? void 0 : removeKeydownListenerRef.current();
    removeFocusListenerRef.current == null ? void 0 : removeFocusListenerRef.current();

    if (restoreFocus) {
      var _lastFocusRef$current;

      // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
      (_lastFocusRef$current = lastFocusRef.current) == null ? void 0 : _lastFocusRef$current.focus == null ? void 0 : _lastFocusRef$current.focus(restoreFocusOptions);
      lastFocusRef.current = null;
    }
  }); // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
  // Show logic when:
  //  - show is `true` _and_ `container` has resolved

  (0,react.useEffect)(function () {
    if (!show || !container) return;
    handleShow();
  }, [show, container,
  /* should never change: */
  handleShow]); // Hide cleanup logic when:
  //  - `exited` switches to true
  //  - component unmounts;

  (0,react.useEffect)(function () {
    if (!exited) return;
    handleHide();
  }, [exited, handleHide]);
  (0,useWillUnmount/* default */.Z)(function () {
    handleHide();
  }); // --------------------------------

  var handleEnforceFocus = (0,useEventCallback/* default */.Z)(function () {
    if (!enforceFocus || !isMounted() || !modal.isTopModal()) {
      return;
    }

    var currentActiveElement = activeElement();

    if (modal.dialog && currentActiveElement && !(0,contains/* default */.Z)(modal.dialog, currentActiveElement)) {
      modal.dialog.focus();
    }
  });
  var handleBackdropClick = (0,useEventCallback/* default */.Z)(function (e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    onBackdropClick == null ? void 0 : onBackdropClick(e);

    if (backdrop === true) {
      onHide();
    }
  });
  var handleDocumentKeyDown = (0,useEventCallback/* default */.Z)(function (e) {
    if (keyboard && e.keyCode === 27 && modal.isTopModal()) {
      onEscapeKeyDown == null ? void 0 : onEscapeKeyDown(e);

      if (!e.defaultPrevented) {
        onHide();
      }
    }
  });
  var removeFocusListenerRef = (0,react.useRef)();
  var removeKeydownListenerRef = (0,react.useRef)();

  var handleHidden = function handleHidden() {
    setExited(true);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    onExited == null ? void 0 : onExited.apply(void 0, args);
  };

  var Transition = transition;

  if (!container || !(show || Transition && !exited)) {
    return null;
  }

  var dialogProps = (0,esm_extends/* default */.Z)({
    role: role,
    ref: modal.setDialogRef,
    // apparently only works on the dialog role element
    'aria-modal': role === 'dialog' ? true : undefined
  }, rest, {
    style: style,
    className: className,
    tabIndex: -1
  });

  var dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/react.createElement("div", dialogProps, /*#__PURE__*/react.cloneElement(children, {
    role: 'document'
  }));

  if (Transition) {
    dialog = /*#__PURE__*/react.createElement(Transition, {
      appear: true,
      unmountOnExit: true,
      "in": !!show,
      onExit: onExit,
      onExiting: onExiting,
      onExited: handleHidden,
      onEnter: onEnter,
      onEntering: onEntering,
      onEntered: onEntered
    }, dialog);
  }

  var backdropElement = null;

  if (backdrop) {
    var BackdropTransition = backdropTransition;
    backdropElement = renderBackdrop({
      ref: modal.setBackdropRef,
      onClick: handleBackdropClick
    });

    if (BackdropTransition) {
      backdropElement = /*#__PURE__*/react.createElement(BackdropTransition, {
        appear: true,
        "in": !!show
      }, backdropElement);
    }
  }

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react_dom.createPortal( /*#__PURE__*/react.createElement(react.Fragment, null, backdropElement, dialog), container));
});
var propTypes = {
  /**
   * Set the visibility of the Modal
   */
  show: (prop_types_default()).bool,

  /**
   * A DOM element, a `ref` to an element, or function that returns either. The Modal is appended to it's `container` element.
   *
   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
   * page content can be placed behind a virtual backdrop as well as a visual one.
   */
  container: (prop_types_default()).any,

  /**
   * A callback fired when the Modal is opening.
   */
  onShow: (prop_types_default()).func,

  /**
   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
   *
   * The `onHide` callback only signals intent from the Modal,
   * you must actually set the `show` prop to `false` for the Modal to close.
   */
  onHide: (prop_types_default()).func,

  /**
   * Include a backdrop component.
   */
  backdrop: prop_types_default().oneOfType([(prop_types_default()).bool, prop_types_default().oneOf(['static'])]),

  /**
   * A function that returns the dialog component. Useful for custom
   * rendering. **Note:** the component should make sure to apply the provided ref.
   *
   * ```js static
   * renderDialog={props => <MyDialog {...props} />}
   * ```
   */
  renderDialog: (prop_types_default()).func,

  /**
   * A function that returns a backdrop component. Useful for custom
   * backdrop rendering.
   *
   * ```js
   *  renderBackdrop={props => <MyBackdrop {...props} />}
   * ```
   */
  renderBackdrop: (prop_types_default()).func,

  /**
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   *
   * If preventDefault() is called on the keyboard event, closing the modal will be cancelled.
   */
  onEscapeKeyDown: (prop_types_default()).func,

  /**
   * A callback fired when the backdrop, if specified, is clicked.
   */
  onBackdropClick: (prop_types_default()).func,

  /**
   * A css class or set of classes applied to the modal container when the modal is open,
   * and removed when it is closed.
   */
  containerClassName: (prop_types_default()).string,

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: (prop_types_default()).bool,

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the dialog component.
   */
  transition: (prop_types_default()).elementType,

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the backdrop components.
   */
  backdropTransition: (prop_types_default()).elementType,

  /**
   * When `true` The modal will automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes. This also
   * works correctly with any Modal children that have the `autoFocus` prop.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  autoFocus: (prop_types_default()).bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while open.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  enforceFocus: (prop_types_default()).bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: (prop_types_default()).bool,

  /**
   * Options passed to focus function when `restoreFocus` is set to `true`
   *
   * @link  https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#Parameters
   */
  restoreFocusOptions: prop_types_default().shape({
    preventScroll: (prop_types_default()).bool
  }),

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: (prop_types_default()).func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: (prop_types_default()).func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: (prop_types_default()).func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: (prop_types_default()).func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: (prop_types_default()).func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: (prop_types_default()).func,

  /**
   * A ModalManager instance used to track and manage the state of open
   * Modals. Useful when customizing how modals interact within a container
   */
  manager: prop_types_default().instanceOf(esm_ModalManager)
};
Modal.displayName = 'Modal';
Modal.propTypes = propTypes;
/* harmony default export */ var esm_Modal = (Object.assign(Modal, {
  Manager: esm_ModalManager
}));
// EXTERNAL MODULE: ./node_modules/warning/warning.js
var warning = __webpack_require__(42473);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/querySelectorAll.js
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
/**
 * Runs `querySelectorAll` on a given element.
 * 
 * @param element the element
 * @param selector the selector
 */

function qsa(element, selector) {
  return toArray(element.querySelectorAll(selector));
}
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/BootstrapModalManager.js





var Selector = {
  FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
  STICKY_CONTENT: '.sticky-top',
  NAVBAR_TOGGLER: '.navbar-toggler'
};

var BootstrapModalManager = /*#__PURE__*/function (_ModalManager) {
  (0,inheritsLoose/* default */.Z)(BootstrapModalManager, _ModalManager);

  function BootstrapModalManager() {
    return _ModalManager.apply(this, arguments) || this;
  }

  var _proto = BootstrapModalManager.prototype;

  _proto.adjustAndStore = function adjustAndStore(prop, element, adjust) {
    var _css;

    var actual = element.style[prop]; // TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
    // @ts-ignore

    element.dataset[prop] = actual;
    (0,css/* default */.Z)(element, (_css = {}, _css[prop] = parseFloat((0,css/* default */.Z)(element, prop)) + adjust + "px", _css));
  };

  _proto.restore = function restore(prop, element) {
    var value = element.dataset[prop];

    if (value !== undefined) {
      var _css2;

      delete element.dataset[prop];
      (0,css/* default */.Z)(element, (_css2 = {}, _css2[prop] = value, _css2));
    }
  };

  _proto.setContainerStyle = function setContainerStyle(containerState, container) {
    var _this = this;

    _ModalManager.prototype.setContainerStyle.call(this, containerState, container);

    if (!containerState.overflowing) return;
    var size = scrollbarSize();
    qsa(container, Selector.FIXED_CONTENT).forEach(function (el) {
      return _this.adjustAndStore('paddingRight', el, size);
    });
    qsa(container, Selector.STICKY_CONTENT).forEach(function (el) {
      return _this.adjustAndStore('marginRight', el, -size);
    });
    qsa(container, Selector.NAVBAR_TOGGLER).forEach(function (el) {
      return _this.adjustAndStore('marginRight', el, size);
    });
  };

  _proto.removeContainerStyle = function removeContainerStyle(containerState, container) {
    var _this2 = this;

    _ModalManager.prototype.removeContainerStyle.call(this, containerState, container);

    qsa(container, Selector.FIXED_CONTENT).forEach(function (el) {
      return _this2.restore('paddingRight', el);
    });
    qsa(container, Selector.STICKY_CONTENT).forEach(function (el) {
      return _this2.restore('marginRight', el);
    });
    qsa(container, Selector.NAVBAR_TOGGLER).forEach(function (el) {
      return _this2.restore('marginRight', el);
    });
  };

  return BootstrapModalManager;
}(esm_ModalManager);


// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Fade.js
var Fade = __webpack_require__(41068);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/camelize.js
var rHyphen = /-(.)/g;
function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/createWithBsPrefix.js


var _excluded = ["className", "bsPrefix", "as"];





var pascalCase = function pascalCase(str) {
  return str[0].toUpperCase() + camelize(str).slice(1);
};

// TODO: emstricten & fix the typing here! `createWithBsPrefix<TElementType>...`
function createWithBsPrefix(prefix, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$displayName = _ref.displayName,
      displayName = _ref$displayName === void 0 ? pascalCase(prefix) : _ref$displayName,
      Component = _ref.Component,
      defaultProps = _ref.defaultProps;

  var BsComponent = /*#__PURE__*/react.forwardRef(function (_ref2, ref) {
    var className = _ref2.className,
        bsPrefix = _ref2.bsPrefix,
        _ref2$as = _ref2.as,
        Tag = _ref2$as === void 0 ? Component || 'div' : _ref2$as,
        props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, _excluded);

    var resolvedPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, prefix);
    return /*#__PURE__*/react.createElement(Tag, (0,esm_extends/* default */.Z)({
      ref: ref,
      className: classnames_default()(className, resolvedPrefix)
    }, props));
  });
  BsComponent.defaultProps = defaultProps;
  BsComponent.displayName = displayName;
  return BsComponent;
}
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalBody.js

/* harmony default export */ var ModalBody = (createWithBsPrefix('modal-body'));
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalContext.js

var ModalContext = /*#__PURE__*/react.createContext({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onHide: function onHide() {}
});
/* harmony default export */ var esm_ModalContext = (ModalContext);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalDialog.js


var ModalDialog_excluded = ["bsPrefix", "className", "contentClassName", "centered", "size", "children", "scrollable"];



var ModalDialog = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      contentClassName = _ref.contentClassName,
      centered = _ref.centered,
      size = _ref.size,
      children = _ref.children,
      scrollable = _ref.scrollable,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ModalDialog_excluded);

  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'modal');
  var dialogClass = bsPrefix + "-dialog";
  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    className: classnames_default()(dialogClass, className, size && bsPrefix + "-" + size, centered && dialogClass + "-centered", scrollable && dialogClass + "-scrollable")
  }), /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(bsPrefix + "-content", contentClassName)
  }, children));
});
ModalDialog.displayName = 'ModalDialog';
/* harmony default export */ var esm_ModalDialog = (ModalDialog);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalFooter.js

/* harmony default export */ var ModalFooter = (createWithBsPrefix('modal-footer'));
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CloseButton.js


var CloseButton_excluded = ["label", "onClick", "className"];



var CloseButton_propTypes = {
  label: (prop_types_default()).string.isRequired,
  onClick: (prop_types_default()).func
};
var defaultProps = {
  label: 'Close'
};
var CloseButton = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var label = _ref.label,
      onClick = _ref.onClick,
      className = _ref.className,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, CloseButton_excluded);

  return /*#__PURE__*/react.createElement("button", (0,esm_extends/* default */.Z)({
    ref: ref,
    type: "button",
    className: classnames_default()('close', className),
    onClick: onClick
  }, props), /*#__PURE__*/react.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7"), /*#__PURE__*/react.createElement("span", {
    className: "sr-only"
  }, label));
});
CloseButton.displayName = 'CloseButton';
CloseButton.propTypes = CloseButton_propTypes;
CloseButton.defaultProps = defaultProps;
/* harmony default export */ var esm_CloseButton = (CloseButton);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalHeader.js


var ModalHeader_excluded = ["bsPrefix", "closeLabel", "closeButton", "onHide", "className", "children"];






var ModalHeader_defaultProps = {
  closeLabel: 'Close',
  closeButton: false
};
var ModalHeader = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      closeLabel = _ref.closeLabel,
      closeButton = _ref.closeButton,
      onHide = _ref.onHide,
      className = _ref.className,
      children = _ref.children,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ModalHeader_excluded);

  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'modal-header');
  var context = (0,react.useContext)(esm_ModalContext);
  var handleClick = (0,useEventCallback/* default */.Z)(function () {
    if (context) context.onHide();
    if (onHide) onHide();
  });
  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    ref: ref
  }, props, {
    className: classnames_default()(className, bsPrefix)
  }), children, closeButton && /*#__PURE__*/react.createElement(esm_CloseButton, {
    label: closeLabel,
    onClick: handleClick
  }));
});
ModalHeader.displayName = 'ModalHeader';
ModalHeader.defaultProps = ModalHeader_defaultProps;
/* harmony default export */ var esm_ModalHeader = (ModalHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/divWithClassName.js



/* harmony default export */ var divWithClassName = (function (className) {
  return /*#__PURE__*/react.forwardRef(function (p, ref) {
    return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({}, p, {
      ref: ref,
      className: classnames_default()(p.className, className)
    }));
  });
});
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalTitle.js


var DivStyledAsH4 = divWithClassName('h4');
/* harmony default export */ var ModalTitle = (createWithBsPrefix('modal-title', {
  Component: DivStyledAsH4
}));
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Modal.js


var Modal_excluded = ["bsPrefix", "className", "style", "dialogClassName", "contentClassName", "children", "dialogAs", "aria-labelledby", "aria-describedby", "aria-label", "show", "animation", "backdrop", "keyboard", "onEscapeKeyDown", "onShow", "onHide", "container", "autoFocus", "enforceFocus", "restoreFocus", "restoreFocusOptions", "onEntered", "onExit", "onExiting", "onEnter", "onEntering", "onExited", "backdropClassName", "manager"];






















var Modal_manager;
var Modal_defaultProps = {
  show: false,
  backdrop: true,
  keyboard: true,
  autoFocus: true,
  enforceFocus: true,
  restoreFocus: true,
  animation: true,
  dialogAs: esm_ModalDialog
};
/* eslint-disable no-use-before-define, react/no-multi-comp */

function DialogTransition(props) {
  return /*#__PURE__*/react.createElement(Fade/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    timeout: null
  }));
}

function BackdropTransition(props) {
  return /*#__PURE__*/react.createElement(Fade/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    timeout: null
  }));
}
/* eslint-enable no-use-before-define */


var Modal_Modal = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      style = _ref.style,
      dialogClassName = _ref.dialogClassName,
      contentClassName = _ref.contentClassName,
      children = _ref.children,
      Dialog = _ref.dialogAs,
      ariaLabelledby = _ref['aria-labelledby'],
      ariaDescribedby = _ref['aria-describedby'],
      ariaLabel = _ref['aria-label'],
      show = _ref.show,
      animation = _ref.animation,
      backdrop = _ref.backdrop,
      keyboard = _ref.keyboard,
      onEscapeKeyDown = _ref.onEscapeKeyDown,
      onShow = _ref.onShow,
      onHide = _ref.onHide,
      container = _ref.container,
      autoFocus = _ref.autoFocus,
      enforceFocus = _ref.enforceFocus,
      restoreFocus = _ref.restoreFocus,
      restoreFocusOptions = _ref.restoreFocusOptions,
      onEntered = _ref.onEntered,
      onExit = _ref.onExit,
      onExiting = _ref.onExiting,
      onEnter = _ref.onEnter,
      onEntering = _ref.onEntering,
      onExited = _ref.onExited,
      backdropClassName = _ref.backdropClassName,
      propsManager = _ref.manager,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, Modal_excluded);

  var _useState = (0,react.useState)({}),
      modalStyle = _useState[0],
      setStyle = _useState[1];

  var _useState2 = (0,react.useState)(false),
      animateStaticModal = _useState2[0],
      setAnimateStaticModal = _useState2[1];

  var waitingForMouseUpRef = (0,react.useRef)(false);
  var ignoreBackdropClickRef = (0,react.useRef)(false);
  var removeStaticModalAnimationRef = (0,react.useRef)(null); // TODO: what's this type

  var _useCallbackRef = (0,useCallbackRef/* default */.Z)(),
      modal = _useCallbackRef[0],
      setModalRef = _useCallbackRef[1];

  var handleHide = (0,useEventCallback/* default */.Z)(onHide);
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'modal');
  (0,react.useImperativeHandle)(ref, function () {
    return {
      get _modal() {
         false ? 0 : void 0;
        return modal;
      }

    };
  }, [modal]);
  var modalContext = (0,react.useMemo)(function () {
    return {
      onHide: handleHide
    };
  }, [handleHide]);

  function getModalManager() {
    if (propsManager) return propsManager;
    if (!Modal_manager) Modal_manager = new BootstrapModalManager();
    return Modal_manager;
  }

  function updateDialogStyle(node) {
    if (!canUseDOM/* default */.Z) return;
    var containerIsOverflowing = getModalManager().isContainerOverflowing(modal);
    var modalIsOverflowing = node.scrollHeight > (0,ownerDocument/* default */.Z)(node).documentElement.clientHeight;
    setStyle({
      paddingRight: containerIsOverflowing && !modalIsOverflowing ? scrollbarSize() : undefined,
      paddingLeft: !containerIsOverflowing && modalIsOverflowing ? scrollbarSize() : undefined
    });
  }

  var handleWindowResize = (0,useEventCallback/* default */.Z)(function () {
    if (modal) {
      updateDialogStyle(modal.dialog);
    }
  });
  (0,useWillUnmount/* default */.Z)(function () {
    (0,removeEventListener/* default */.Z)(window, 'resize', handleWindowResize);

    if (removeStaticModalAnimationRef.current) {
      removeStaticModalAnimationRef.current();
    }
  }); // We prevent the modal from closing during a drag by detecting where the
  // the click originates from. If it starts in the modal and then ends outside
  // don't close.

  var handleDialogMouseDown = function handleDialogMouseDown() {
    waitingForMouseUpRef.current = true;
  };

  var handleMouseUp = function handleMouseUp(e) {
    if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) {
      ignoreBackdropClickRef.current = true;
    }

    waitingForMouseUpRef.current = false;
  };

  var handleStaticModalAnimation = function handleStaticModalAnimation() {
    setAnimateStaticModal(true);
    removeStaticModalAnimationRef.current = (0,transitionEnd/* default */.Z)(modal.dialog, function () {
      setAnimateStaticModal(false);
    });
  };

  var handleStaticBackdropClick = function handleStaticBackdropClick(e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    handleStaticModalAnimation();
  };

  var handleClick = function handleClick(e) {
    if (backdrop === 'static') {
      handleStaticBackdropClick(e);
      return;
    }

    if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
      ignoreBackdropClickRef.current = false;
      return;
    }

    onHide == null ? void 0 : onHide();
  };

  var handleEscapeKeyDown = function handleEscapeKeyDown(e) {
    if (!keyboard && backdrop === 'static') {
      // Call preventDefault to stop modal from closing in react-overlays,
      // then play our animation.
      e.preventDefault();
      handleStaticModalAnimation();
    } else if (keyboard && onEscapeKeyDown) {
      onEscapeKeyDown(e);
    }
  };

  var handleEnter = function handleEnter(node, isAppearing) {
    if (node) {
      node.style.display = 'block';
      updateDialogStyle(node);
    }

    onEnter == null ? void 0 : onEnter(node, isAppearing);
  };

  var handleExit = function handleExit(node) {
    removeStaticModalAnimationRef.current == null ? void 0 : removeStaticModalAnimationRef.current();
    onExit == null ? void 0 : onExit(node);
  };

  var handleEntering = function handleEntering(node, isAppearing) {
    onEntering == null ? void 0 : onEntering(node, isAppearing); // FIXME: This should work even when animation is disabled.

    (0,addEventListener/* default */.ZP)(window, 'resize', handleWindowResize);
  };

  var handleExited = function handleExited(node) {
    if (node) node.style.display = ''; // RHL removes it sometimes

    onExited == null ? void 0 : onExited(node); // FIXME: This should work even when animation is disabled.

    (0,removeEventListener/* default */.Z)(window, 'resize', handleWindowResize);
  };

  var renderBackdrop = (0,react.useCallback)(function (backdropProps) {
    return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({}, backdropProps, {
      className: classnames_default()(bsPrefix + "-backdrop", backdropClassName, !animation && 'show')
    }));
  }, [animation, backdropClassName, bsPrefix]);

  var baseModalStyle = (0,esm_extends/* default */.Z)({}, style, modalStyle); // Sets `display` always block when `animation` is false


  if (!animation) {
    baseModalStyle.display = 'block';
  }

  var renderDialog = function renderDialog(dialogProps) {
    return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
      role: "dialog"
    }, dialogProps, {
      style: baseModalStyle,
      className: classnames_default()(className, bsPrefix, animateStaticModal && bsPrefix + "-static"),
      onClick: backdrop ? handleClick : undefined,
      onMouseUp: handleMouseUp,
      "aria-label": ariaLabel,
      "aria-labelledby": ariaLabelledby,
      "aria-describedby": ariaDescribedby
    }), /*#__PURE__*/react.createElement(Dialog, (0,esm_extends/* default */.Z)({}, props, {
      onMouseDown: handleDialogMouseDown,
      className: dialogClassName,
      contentClassName: contentClassName
    }), children));
  };

  return /*#__PURE__*/react.createElement(esm_ModalContext.Provider, {
    value: modalContext
  }, /*#__PURE__*/react.createElement(esm_Modal, {
    show: show,
    ref: setModalRef,
    backdrop: backdrop,
    container: container,
    keyboard: true // Always set true - see handleEscapeKeyDown
    ,
    autoFocus: autoFocus,
    enforceFocus: enforceFocus,
    restoreFocus: restoreFocus,
    restoreFocusOptions: restoreFocusOptions,
    onEscapeKeyDown: handleEscapeKeyDown,
    onShow: onShow,
    onHide: onHide,
    onEnter: handleEnter,
    onEntering: handleEntering,
    onEntered: onEntered,
    onExit: handleExit,
    onExiting: onExiting,
    onExited: handleExited,
    manager: getModalManager(),
    containerClassName: bsPrefix + "-open",
    transition: animation ? DialogTransition : undefined,
    backdropTransition: animation ? BackdropTransition : undefined,
    renderBackdrop: renderBackdrop,
    renderDialog: renderDialog
  }));
});
Modal_Modal.displayName = 'Modal';
Modal_Modal.defaultProps = Modal_defaultProps;
Modal_Modal.Body = ModalBody;
Modal_Modal.Header = esm_ModalHeader;
Modal_Modal.Title = ModalTitle;
Modal_Modal.Footer = ModalFooter;
Modal_Modal.Dialog = esm_ModalDialog;
Modal_Modal.TRANSITION_DURATION = 300;
Modal_Modal.BACKDROP_TRANSITION_DURATION = 150;
/* harmony default export */ var react_bootstrap_esm_Modal = (Modal_Modal);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardContext.js

var context = /*#__PURE__*/react.createContext(null);
context.displayName = 'CardContext';
/* harmony default export */ var CardContext = (context);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardImg.js


var CardImg_excluded = ["bsPrefix", "className", "variant", "as"];



var CardImg_defaultProps = {
  variant: null
};
var CardImg = /*#__PURE__*/react.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      variant = _ref.variant,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'img' : _ref$as,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, CardImg_excluded);

  var prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-img');
  return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
    ref: ref,
    className: classnames_default()(variant ? prefix + "-" + variant : prefix, className)
  }, props));
});
CardImg.displayName = 'CardImg';
CardImg.defaultProps = CardImg_defaultProps;
/* harmony default export */ var esm_CardImg = (CardImg);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Card.js


var Card_excluded = ["bsPrefix", "className", "bg", "text", "border", "body", "children", "as"];







var DivStyledAsH5 = divWithClassName('h5');
var DivStyledAsH6 = divWithClassName('h6');
var CardBody = createWithBsPrefix('card-body');
var CardTitle = createWithBsPrefix('card-title', {
  Component: DivStyledAsH5
});
var CardSubtitle = createWithBsPrefix('card-subtitle', {
  Component: DivStyledAsH6
});
var CardLink = createWithBsPrefix('card-link', {
  Component: 'a'
});
var CardText = createWithBsPrefix('card-text', {
  Component: 'p'
});
var CardHeader = createWithBsPrefix('card-header');
var CardFooter = createWithBsPrefix('card-footer');
var CardImgOverlay = createWithBsPrefix('card-img-overlay');
var Card_defaultProps = {
  body: false
};
var Card = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      bg = _ref.bg,
      text = _ref.text,
      border = _ref.border,
      body = _ref.body,
      children = _ref.children,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, Card_excluded);

  var prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card');
  var cardContext = (0,react.useMemo)(function () {
    return {
      cardHeaderBsPrefix: prefix + "-header"
    };
  }, [prefix]);
  return /*#__PURE__*/react.createElement(CardContext.Provider, {
    value: cardContext
  }, /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
    ref: ref
  }, props, {
    className: classnames_default()(className, prefix, bg && "bg-" + bg, text && "text-" + text, border && "border-" + border)
  }), body ?
  /*#__PURE__*/
  // @ts-ignore
  react.createElement(CardBody, null, children) : children));
});
Card.displayName = 'Card';
Card.defaultProps = Card_defaultProps;
Card.Img = esm_CardImg;
Card.Title = CardTitle;
Card.Subtitle = CardSubtitle;
Card.Body = CardBody;
Card.Link = CardLink;
Card.Text = CardText;
Card.Header = CardHeader;
Card.Footer = CardFooter;
Card.ImgOverlay = CardImgOverlay;
/* harmony default export */ var esm_Card = (Card);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardDeck.js

/* harmony default export */ var CardDeck = (createWithBsPrefix('card-deck'));
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardColumns.js

/* harmony default export */ var CardColumns = (createWithBsPrefix('card-columns'));
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ButtonGroup.js


var ButtonGroup_excluded = ["bsPrefix", "size", "toggle", "vertical", "className", "as"];



var ButtonGroup_defaultProps = {
  vertical: false,
  toggle: false,
  role: 'group'
};
var ButtonGroup = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      size = _ref.size,
      toggle = _ref.toggle,
      vertical = _ref.vertical,
      className = _ref.className,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ButtonGroup_excluded);

  var prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'btn-group');
  var baseClass = prefix;
  if (vertical) baseClass = prefix + "-vertical";
  return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({}, rest, {
    ref: ref,
    className: classnames_default()(className, baseClass, size && prefix + "-" + size, toggle && prefix + "-toggle")
  }));
});
ButtonGroup.displayName = 'ButtonGroup';
ButtonGroup.defaultProps = ButtonGroup_defaultProps;
/* harmony default export */ var esm_ButtonGroup = (ButtonGroup);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/matches.js
var matchesImpl;
/**
 * Checks if a given element matches a selector.
 * 
 * @param node the element
 * @param selector the selector
 */

function matches(node, selector) {
  if (!matchesImpl) {
    var body = document.body;
    var nativeMatch = body.matches || body.matchesSelector || body.webkitMatchesSelector || body.mozMatchesSelector || body.msMatchesSelector;

    matchesImpl = function matchesImpl(n, s) {
      return nativeMatch.call(n, s);
    };
  }

  return matchesImpl(node, selector);
}
// EXTERNAL MODULE: ./node_modules/uncontrollable/lib/esm/index.js + 4 modules
var esm = __webpack_require__(47150);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useForceUpdate.js

/**
 * Returns a function that triggers a component update. the hook equivalent to
 * `this.forceUpdate()` in a class component. In most cases using a state value directly
 * is preferable but may be required in some advanced usages of refs for interop or
 * when direct DOM manipulation is required.
 *
 * ```ts
 * const forceUpdate = useForceUpdate();
 *
 * const updateOnClick = useCallback(() => {
 *  forceUpdate()
 * }, [forceUpdate])
 *
 * return <button type="button" onClick={updateOnClick}>Hi there</button>
 * ```
 */

function useForceUpdate() {
  // The toggling state value is designed to defeat React optimizations for skipping
  // updates when they are stricting equal to the last state value
  var _useReducer = (0,react.useReducer)(function (state) {
    return !state;
  }, false),
      dispatch = _useReducer[1];

  return dispatch;
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useEventListener.js



/**
 * Attaches an event handler outside directly to specified DOM element
 * bypassing the react synthetic event system.
 *
 * @param element The target to listen for events on
 * @param event The DOM event name
 * @param handler An event handler
 * @param capture Whether or not to listen during the capture event phase
 */
function useEventListener(eventTarget, event, listener, capture) {
  if (capture === void 0) {
    capture = false;
  }

  var handler = (0,useEventCallback/* default */.Z)(listener);
  (0,react.useEffect)(function () {
    var target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
    target.addEventListener(event, handler, capture);
    return function () {
      return target.removeEventListener(event, handler, capture);
    };
  }, [eventTarget]);
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useGlobalListener.js



/**
 * Attaches an event handler outside directly to the `document`,
 * bypassing the react synthetic event system.
 *
 * ```ts
 * useGlobalListener('keydown', (event) => {
 *  console.log(event.key)
 * })
 * ```
 *
 * @param event The DOM event name
 * @param handler An event handler
 * @param capture Whether or not to listen during the capture event phase
 */
function useGlobalListener(event, handler, capture) {
  if (capture === void 0) {
    capture = false;
  }

  var documentTarget = (0,react.useCallback)(function () {
    return document;
  }, []);
  return useEventListener(documentTarget, event, handler, capture);
}
;// CONCATENATED MODULE: ./node_modules/react-overlays/esm/DropdownContext.js

var DropdownContext = /*#__PURE__*/react.createContext(null);
/* harmony default export */ var esm_DropdownContext = (DropdownContext);
// EXTERNAL MODULE: ./node_modules/react-overlays/esm/usePopper.js + 53 modules
var usePopper = __webpack_require__(8534);
// EXTERNAL MODULE: ./node_modules/react-overlays/esm/useRootClose.js + 1 modules
var useRootClose = __webpack_require__(86453);
// EXTERNAL MODULE: ./node_modules/react-overlays/esm/mergeOptionsWithPopperConfig.js
var mergeOptionsWithPopperConfig = __webpack_require__(82343);
;// CONCATENATED MODULE: ./node_modules/react-overlays/esm/DropdownMenu.js










var noop = function noop() {};
/**
 * @memberOf Dropdown
 * @param {object}  options
 * @param {boolean} options.flip Automatically adjust the menu `drop` position based on viewport edge detection
 * @param {[number, number]} options.offset Define an offset distance between the Menu and the Toggle
 * @param {boolean} options.show Display the menu manually, ignored in the context of a `Dropdown`
 * @param {boolean} options.usePopper opt in/out of using PopperJS to position menus. When disabled you must position it yourself.
 * @param {string}  options.rootCloseEvent The pointer event to listen for when determining "clicks outside" the menu for triggering a close.
 * @param {object}  options.popperConfig Options passed to the [`usePopper`](/api/usePopper) hook.
 */


function useDropdownMenu(options) {
  if (options === void 0) {
    options = {};
  }

  var context = (0,react.useContext)(esm_DropdownContext);

  var _useCallbackRef = (0,useCallbackRef/* default */.Z)(),
      arrowElement = _useCallbackRef[0],
      attachArrowRef = _useCallbackRef[1];

  var hasShownRef = (0,react.useRef)(false);
  var _options = options,
      flip = _options.flip,
      offset = _options.offset,
      rootCloseEvent = _options.rootCloseEvent,
      _options$fixed = _options.fixed,
      fixed = _options$fixed === void 0 ? false : _options$fixed,
      _options$popperConfig = _options.popperConfig,
      popperConfig = _options$popperConfig === void 0 ? {} : _options$popperConfig,
      _options$usePopper = _options.usePopper,
      shouldUsePopper = _options$usePopper === void 0 ? !!context : _options$usePopper;
  var show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;
  var alignEnd = (context == null ? void 0 : context.alignEnd) == null ? options.alignEnd : context.alignEnd;

  if (show && !hasShownRef.current) {
    hasShownRef.current = true;
  }

  var handleClose = function handleClose(e) {
    context == null ? void 0 : context.toggle(false, e);
  };

  var _ref = context || {},
      drop = _ref.drop,
      setMenu = _ref.setMenu,
      menuElement = _ref.menuElement,
      toggleElement = _ref.toggleElement;

  var placement = alignEnd ? 'bottom-end' : 'bottom-start';
  if (drop === 'up') placement = alignEnd ? 'top-end' : 'top-start';else if (drop === 'right') placement = alignEnd ? 'right-end' : 'right-start';else if (drop === 'left') placement = alignEnd ? 'left-end' : 'left-start';
  var popper = (0,usePopper/* default */.Z)(toggleElement, menuElement, (0,mergeOptionsWithPopperConfig/* default */.ZP)({
    placement: placement,
    enabled: !!(shouldUsePopper && show),
    enableEvents: show,
    offset: offset,
    flip: flip,
    fixed: fixed,
    arrowElement: arrowElement,
    popperConfig: popperConfig
  }));

  var menuProps = (0,esm_extends/* default */.Z)({
    ref: setMenu || noop,
    'aria-labelledby': toggleElement == null ? void 0 : toggleElement.id
  }, popper.attributes.popper, {
    style: popper.styles.popper
  });

  var metadata = {
    show: show,
    alignEnd: alignEnd,
    hasShown: hasShownRef.current,
    toggle: context == null ? void 0 : context.toggle,
    popper: shouldUsePopper ? popper : null,
    arrowProps: shouldUsePopper ? (0,esm_extends/* default */.Z)({
      ref: attachArrowRef
    }, popper.attributes.arrow, {
      style: popper.styles.arrow
    }) : {}
  };
  (0,useRootClose/* default */.Z)(menuElement, handleClose, {
    clickTrigger: rootCloseEvent,
    disabled: !show
  });
  return [menuProps, metadata];
}
var DropdownMenu_propTypes = {
  /**
   * A render prop that returns a Menu element. The `props`
   * argument should spread through to **a component that can accept a ref**.
   *
   * @type {Function ({
   *   show: boolean,
   *   alignEnd: boolean,
   *   close: (?SyntheticEvent) => void,
   *   placement: Placement,
   *   update: () => void,
   *   forceUpdate: () => void,
   *   props: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     aria-labelledby: ?string
   *   },
   *   arrowProps: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *   },
   * }) => React.Element}
   */
  children: (prop_types_default()).func.isRequired,

  /**
   * Controls the visible state of the menu, generally this is
   * provided by the parent `Dropdown` component,
   * but may also be specified as a prop directly.
   */
  show: (prop_types_default()).bool,

  /**
   * Aligns the dropdown menu to the 'end' of it's placement position.
   * Generally this is provided by the parent `Dropdown` component,
   * but may also be specified as a prop directly.
   */
  alignEnd: (prop_types_default()).bool,

  /**
   * Enables the Popper.js `flip` modifier, allowing the Dropdown to
   * automatically adjust it's placement in case of overlap with the viewport or toggle.
   * Refer to the [flip docs](https://popper.js.org/popper-documentation.html#modifiers..flip.enabled) for more info
   */
  flip: (prop_types_default()).bool,
  usePopper: prop_types_default().oneOf([true, false]),

  /**
   * A set of popper options and props passed directly to react-popper's Popper component.
   */
  popperConfig: (prop_types_default()).object,

  /**
   * Override the default event used by RootCloseWrapper.
   */
  rootCloseEvent: (prop_types_default()).string
};
var DropdownMenu_defaultProps = {
  usePopper: true
};

/**
 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
 *
 * @displayName DropdownMenu
 * @memberOf Dropdown
 */
function DropdownMenu(_ref2) {
  var children = _ref2.children,
      options = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, ["children"]);

  var _useDropdownMenu = useDropdownMenu(options),
      props = _useDropdownMenu[0],
      meta = _useDropdownMenu[1];

  return /*#__PURE__*/react.createElement(react.Fragment, null, meta.hasShown ? children(props, meta) : null);
}

DropdownMenu.displayName = 'ReactOverlaysDropdownMenu';
DropdownMenu.propTypes = DropdownMenu_propTypes;
DropdownMenu.defaultProps = DropdownMenu_defaultProps;
/** @component */

/* harmony default export */ var esm_DropdownMenu = (DropdownMenu);
;// CONCATENATED MODULE: ./node_modules/react-overlays/esm/DropdownToggle.js




var DropdownToggle_noop = function noop() {};
/**
 * Wires up Dropdown toggle functionality, returning a set a props to attach
 * to the element that functions as the dropdown toggle (generally a button).
 *
 * @memberOf Dropdown
 */


function useDropdownToggle() {
  var _ref = (0,react.useContext)(esm_DropdownContext) || {},
      _ref$show = _ref.show,
      show = _ref$show === void 0 ? false : _ref$show,
      _ref$toggle = _ref.toggle,
      toggle = _ref$toggle === void 0 ? DropdownToggle_noop : _ref$toggle,
      setToggle = _ref.setToggle;

  var handleClick = (0,react.useCallback)(function (e) {
    toggle(!show, e);
  }, [show, toggle]);
  return [{
    ref: setToggle || DropdownToggle_noop,
    onClick: handleClick,
    'aria-haspopup': true,
    'aria-expanded': !!show
  }, {
    show: show,
    toggle: toggle
  }];
}
var DropdownToggle_propTypes = {
  /**
   * A render prop that returns a Toggle element. The `props`
   * argument should spread through to **a component that can accept a ref**. Use
   * the `onToggle` argument to toggle the menu open or closed
   *
   * @type {Function ({
   *   show: boolean,
   *   toggle: (show: boolean) => void,
   *   props: {
   *     ref: (?HTMLElement) => void,
   *     aria-haspopup: true
   *     aria-expanded: boolean
   *   },
   * }) => React.Element}
   */
  children: (prop_types_default()).func.isRequired
};

/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */
function DropdownToggle(_ref2) {
  var children = _ref2.children;

  var _useDropdownToggle = useDropdownToggle(),
      props = _useDropdownToggle[0],
      meta = _useDropdownToggle[1];

  return /*#__PURE__*/react.createElement(react.Fragment, null, children(props, meta));
}

DropdownToggle.displayName = 'ReactOverlaysDropdownToggle';
DropdownToggle.propTypes = DropdownToggle_propTypes;
/** @component */

/* harmony default export */ var esm_DropdownToggle = (DropdownToggle);
;// CONCATENATED MODULE: ./node_modules/react-overlays/esm/Dropdown.js













var Dropdown_propTypes = {
  /**
   * A render prop that returns the root dropdown element. The `props`
   * argument should spread through to an element containing _both_ the
   * menu and toggle in order to handle keyboard events for focus management.
   *
   * @type {Function ({
   *   props: {
   *     onKeyDown: (SyntheticEvent) => void,
   *   },
   * }) => React.Element}
   */
  children: (prop_types_default()).node,

  /**
   * Determines the direction and location of the Menu in relation to it's Toggle.
   */
  drop: prop_types_default().oneOf(['up', 'left', 'right', 'down']),

  /**
   * Controls the focus behavior for when the Dropdown is opened. Set to
   * `true` to always focus the first menu item, `keyboard` to focus only when
   * navigating via the keyboard, or `false` to disable completely
   *
   * The Default behavior is `false` **unless** the Menu has a `role="menu"`
   * where it will default to `keyboard` to match the recommended [ARIA Authoring practices](https://www.w3.org/TR/wai-aria-practices-1.1/#menubutton).
   */
  focusFirstItemOnShow: prop_types_default().oneOf([false, true, 'keyboard']),

  /**
   * A css slector string that will return __focusable__ menu items.
   * Selectors should be relative to the menu component:
   * e.g. ` > li:not('.disabled')`
   */
  itemSelector: (prop_types_default()).string,

  /**
   * Align the menu to the 'end' side of the placement side of the Dropdown toggle. The default placement is `top-start` or `bottom-start`.
   */
  alignEnd: (prop_types_default()).bool,

  /**
   * Whether or not the Dropdown is visible.
   *
   * @controllable onToggle
   */
  show: (prop_types_default()).bool,

  /**
   * Sets the initial show position of the Dropdown.
   */
  defaultShow: (prop_types_default()).bool,

  /**
   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
   * `show` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
   *
   * ```ts static
   * function(
   *   isOpen: boolean,
   *   event: SyntheticEvent,
   * ): void
   * ```
   *
   * @controllable show
   */
  onToggle: (prop_types_default()).func
};

function useRefWithUpdate() {
  var forceUpdate = useForceUpdate();
  var ref = (0,react.useRef)(null);
  var attachRef = (0,react.useCallback)(function (element) {
    ref.current = element; // ensure that a menu set triggers an update for consumers

    forceUpdate();
  }, [forceUpdate]);
  return [ref, attachRef];
}
/**
 * @displayName Dropdown
 * @public
 */


function Dropdown(_ref) {
  var drop = _ref.drop,
      alignEnd = _ref.alignEnd,
      defaultShow = _ref.defaultShow,
      rawShow = _ref.show,
      rawOnToggle = _ref.onToggle,
      _ref$itemSelector = _ref.itemSelector,
      itemSelector = _ref$itemSelector === void 0 ? '* > *' : _ref$itemSelector,
      focusFirstItemOnShow = _ref.focusFirstItemOnShow,
      children = _ref.children;

  var _useUncontrolledProp = (0,esm/* useUncontrolledProp */.$c)(rawShow, defaultShow, rawOnToggle),
      show = _useUncontrolledProp[0],
      onToggle = _useUncontrolledProp[1]; // We use normal refs instead of useCallbackRef in order to populate the
  // the value as quickly as possible, otherwise the effect to focus the element
  // may run before the state value is set


  var _useRefWithUpdate = useRefWithUpdate(),
      menuRef = _useRefWithUpdate[0],
      setMenu = _useRefWithUpdate[1];

  var menuElement = menuRef.current;

  var _useRefWithUpdate2 = useRefWithUpdate(),
      toggleRef = _useRefWithUpdate2[0],
      setToggle = _useRefWithUpdate2[1];

  var toggleElement = toggleRef.current;
  var lastShow = usePrevious(show);
  var lastSourceEvent = (0,react.useRef)(null);
  var focusInDropdown = (0,react.useRef)(false);
  var toggle = (0,react.useCallback)(function (nextShow, event) {
    onToggle(nextShow, event);
  }, [onToggle]);
  var context = (0,react.useMemo)(function () {
    return {
      toggle: toggle,
      drop: drop,
      show: show,
      alignEnd: alignEnd,
      menuElement: menuElement,
      toggleElement: toggleElement,
      setMenu: setMenu,
      setToggle: setToggle
    };
  }, [toggle, drop, show, alignEnd, menuElement, toggleElement, setMenu, setToggle]);

  if (menuElement && lastShow && !show) {
    focusInDropdown.current = menuElement.contains(document.activeElement);
  }

  var focusToggle = (0,useEventCallback/* default */.Z)(function () {
    if (toggleElement && toggleElement.focus) {
      toggleElement.focus();
    }
  });
  var maybeFocusFirst = (0,useEventCallback/* default */.Z)(function () {
    var type = lastSourceEvent.current;
    var focusType = focusFirstItemOnShow;

    if (focusType == null) {
      focusType = menuRef.current && matches(menuRef.current, '[role=menu]') ? 'keyboard' : false;
    }

    if (focusType === false || focusType === 'keyboard' && !/^key.+$/.test(type)) {
      return;
    }

    var first = qsa(menuRef.current, itemSelector)[0];
    if (first && first.focus) first.focus();
  });
  (0,react.useEffect)(function () {
    if (show) maybeFocusFirst();else if (focusInDropdown.current) {
      focusInDropdown.current = false;
      focusToggle();
    } // only `show` should be changing
  }, [show, focusInDropdown, focusToggle, maybeFocusFirst]);
  (0,react.useEffect)(function () {
    lastSourceEvent.current = null;
  });

  var getNextFocusedChild = function getNextFocusedChild(current, offset) {
    if (!menuRef.current) return null;
    var items = qsa(menuRef.current, itemSelector);
    var index = items.indexOf(current) + offset;
    index = Math.max(0, Math.min(index, items.length));
    return items[index];
  };

  useGlobalListener('keydown', function (event) {
    var _menuRef$current, _toggleRef$current;

    var key = event.key;
    var target = event.target;
    var fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
    var fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target); // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
    // in inscrutability

    var isInput = /input|textarea/i.test(target.tagName);

    if (isInput && (key === ' ' || key !== 'Escape' && fromMenu)) {
      return;
    }

    if (!fromMenu && !fromToggle) {
      return;
    }

    if (!menuRef.current && key === 'Tab') {
      return;
    }

    lastSourceEvent.current = event.type;

    switch (key) {
      case 'ArrowUp':
        {
          var next = getNextFocusedChild(target, -1);
          if (next && next.focus) next.focus();
          event.preventDefault();
          return;
        }

      case 'ArrowDown':
        event.preventDefault();

        if (!show) {
          onToggle(true, event);
        } else {
          var _next = getNextFocusedChild(target, 1);

          if (_next && _next.focus) _next.focus();
        }

        return;

      case 'Tab':
        // on keydown the target is the element being tabbed FROM, we need that
        // to know if this event is relevant to this dropdown (e.g. in this menu).
        // On `keyup` the target is the element being tagged TO which we use to check
        // if focus has left the menu
        (0,addEventListener/* default */.ZP)(document, 'keyup', function (e) {
          var _menuRef$current2;

          if (e.key === 'Tab' && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) {
            onToggle(false, event);
          }
        }, {
          once: true
        });
        break;

      case 'Escape':
        event.preventDefault();
        event.stopPropagation();
        onToggle(false, event);
        break;

      default:
    }
  });
  return /*#__PURE__*/react.createElement(esm_DropdownContext.Provider, {
    value: context
  }, children);
}

Dropdown.displayName = 'ReactOverlaysDropdown';
Dropdown.propTypes = Dropdown_propTypes;
Dropdown.Menu = esm_DropdownMenu;
Dropdown.Toggle = esm_DropdownToggle;
/* harmony default export */ var esm_Dropdown = (Dropdown);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/SelectableContext.js
 // TODO (apparently this is a bare "onSelect"?)

var SelectableContext = /*#__PURE__*/react.createContext(null);
var makeEventKey = function makeEventKey(eventKey, href) {
  if (href === void 0) {
    href = null;
  }

  if (eventKey != null) return String(eventKey);
  return href || null;
};
/* harmony default export */ var esm_SelectableContext = (SelectableContext);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/NavContext.js
 // TODO: check this

var NavContext = /*#__PURE__*/react.createContext(null);
NavContext.displayName = 'NavContext';
/* harmony default export */ var esm_NavContext = (NavContext);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/SafeAnchor.js
var SafeAnchor = __webpack_require__(48358);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/DropdownItem.js


var DropdownItem_excluded = ["bsPrefix", "className", "children", "eventKey", "disabled", "href", "onClick", "onSelect", "active", "as"];







var DropdownItem_defaultProps = {
  as: SafeAnchor/* default */.Z,
  disabled: false
};
var DropdownItem = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      children = _ref.children,
      eventKey = _ref.eventKey,
      disabled = _ref.disabled,
      href = _ref.href,
      onClick = _ref.onClick,
      onSelect = _ref.onSelect,
      propActive = _ref.active,
      Component = _ref.as,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, DropdownItem_excluded);

  var prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'dropdown-item');
  var onSelectCtx = (0,react.useContext)(esm_SelectableContext);
  var navContext = (0,react.useContext)(esm_NavContext);

  var _ref2 = navContext || {},
      activeKey = _ref2.activeKey;

  var key = makeEventKey(eventKey, href);
  var active = propActive == null && key != null ? makeEventKey(activeKey) === key : propActive;
  var handleClick = (0,useEventCallback/* default */.Z)(function (event) {
    // SafeAnchor handles the disabled case, but we handle it here
    // for other components
    if (disabled) return;
    if (onClick) onClick(event);
    if (onSelectCtx) onSelectCtx(key, event);
    if (onSelect) onSelect(key, event);
  });
  return (
    /*#__PURE__*/
    // "TS2604: JSX element type 'Component' does not have any construct or call signatures."
    // @ts-ignore
    react.createElement(Component, (0,esm_extends/* default */.Z)({}, props, {
      ref: ref,
      href: href,
      disabled: disabled,
      className: classnames_default()(className, prefix, active && 'active', disabled && 'disabled'),
      onClick: handleClick
    }), children)
  );
});
DropdownItem.displayName = 'DropdownItem';
DropdownItem.defaultProps = DropdownItem_defaultProps;
/* harmony default export */ var esm_DropdownItem = (DropdownItem);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useMergedRefs.js
var useMergedRefs = __webpack_require__(35654);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/NavbarContext.js
 // TODO: check

var NavbarContext_context = /*#__PURE__*/react.createContext(null);
NavbarContext_context.displayName = 'NavbarContext';
/* harmony default export */ var NavbarContext = (NavbarContext_context);
// EXTERNAL MODULE: ./node_modules/invariant/browser.js
var browser = __webpack_require__(41143);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/useWrappedRefWithWarning.js



function useWrappedRefWithWarning(ref, componentName) {
  // @ts-ignore
  if (true) return ref; // eslint-disable-next-line react-hooks/rules-of-hooks

  var warningRef = (0,react.useCallback)(function (refValue) {
    !(refValue == null || !refValue.isReactComponent) ?  false ? 0 : browser_default()(false) : void 0;
  }, [componentName]); // eslint-disable-next-line react-hooks/rules-of-hooks

  return (0,useMergedRefs/* default */.Z)(warningRef, ref);
}
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/usePopperMarginModifiers.js
var usePopperMarginModifiers = __webpack_require__(73509);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/DropdownMenu.js


var DropdownMenu_excluded = ["bsPrefix", "className", "align", "alignRight", "rootCloseEvent", "flip", "show", "renderOnMount", "as", "popperConfig"];










var alignDirection = prop_types_default().oneOf(['left', 'right']);
var alignPropType = prop_types_default().oneOfType([alignDirection, prop_types_default().shape({
  sm: alignDirection
}), prop_types_default().shape({
  md: alignDirection
}), prop_types_default().shape({
  lg: alignDirection
}), prop_types_default().shape({
  xl: alignDirection
})]);
var esm_DropdownMenu_defaultProps = {
  align: 'left',
  alignRight: false,
  flip: true
};
var DropdownMenu_DropdownMenu = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      align = _ref.align,
      alignRight = _ref.alignRight,
      rootCloseEvent = _ref.rootCloseEvent,
      flip = _ref.flip,
      showProps = _ref.show,
      renderOnMount = _ref.renderOnMount,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      popperConfig = _ref.popperConfig,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, DropdownMenu_excluded);

  var isNavbar = (0,react.useContext)(NavbarContext);
  var prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'dropdown-menu');

  var _usePopperMarginModif = (0,usePopperMarginModifiers/* default */.Z)(),
      popperRef = _usePopperMarginModif[0],
      marginModifiers = _usePopperMarginModif[1];

  var alignClasses = [];

  if (align) {
    if (typeof align === 'object') {
      var keys = Object.keys(align);
       false ? 0 : void 0;

      if (keys.length) {
        var brkPoint = keys[0];
        var direction = align[brkPoint]; // .dropdown-menu-right is required for responsively aligning
        // left in addition to align left classes.
        // Reuse alignRight to toggle the class below.

        alignRight = direction === 'left';
        alignClasses.push(prefix + "-" + brkPoint + "-" + direction);
      }
    } else if (align === 'right') {
      alignRight = true;
    }
  }

  var _useDropdownMenu = useDropdownMenu({
    flip: flip,
    rootCloseEvent: rootCloseEvent,
    show: showProps,
    alignEnd: alignRight,
    usePopper: !isNavbar && alignClasses.length === 0,
    popperConfig: (0,esm_extends/* default */.Z)({}, popperConfig, {
      modifiers: marginModifiers.concat((popperConfig == null ? void 0 : popperConfig.modifiers) || [])
    })
  }),
      menuProps = _useDropdownMenu[0],
      _useDropdownMenu$ = _useDropdownMenu[1],
      hasShown = _useDropdownMenu$.hasShown,
      popper = _useDropdownMenu$.popper,
      show = _useDropdownMenu$.show,
      alignEnd = _useDropdownMenu$.alignEnd,
      toggle = _useDropdownMenu$.toggle;

  menuProps.ref = (0,useMergedRefs/* default */.Z)(popperRef, (0,useMergedRefs/* default */.Z)(useWrappedRefWithWarning(ref, 'DropdownMenu'), menuProps.ref));
  if (!hasShown && !renderOnMount) return null; // For custom components provide additional, non-DOM, props;

  if (typeof Component !== 'string') {
    menuProps.show = show;

    menuProps.close = function () {
      return toggle == null ? void 0 : toggle(false);
    };

    menuProps.alignRight = alignEnd;
  }

  var style = props.style;

  if (popper != null && popper.placement) {
    // we don't need the default popper style,
    // menus are display: none when not shown.
    style = (0,esm_extends/* default */.Z)({}, props.style, menuProps.style);
    props['x-placement'] = popper.placement;
  }

  return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({}, props, menuProps, {
    style: style,
    className: classnames_default().apply(void 0, [className, prefix, show && 'show', alignEnd && prefix + "-right"].concat(alignClasses))
  }));
});
DropdownMenu_DropdownMenu.displayName = 'DropdownMenu';
DropdownMenu_DropdownMenu.defaultProps = esm_DropdownMenu_defaultProps;
/* harmony default export */ var react_bootstrap_esm_DropdownMenu = (DropdownMenu_DropdownMenu);
// EXTERNAL MODULE: ./node_modules/prop-types-extra/lib/isRequiredForA11y.js
var isRequiredForA11y = __webpack_require__(55638);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/DropdownToggle.js


var DropdownToggle_excluded = ["bsPrefix", "split", "className", "childBsPrefix", "as"];








var DropdownToggle_DropdownToggle = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      split = _ref.split,
      className = _ref.className,
      childBsPrefix = _ref.childBsPrefix,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? Button/* default */.Z : _ref$as,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, DropdownToggle_excluded);

  var prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'dropdown-toggle');

  if (childBsPrefix !== undefined) {
    props.bsPrefix = childBsPrefix;
  }

  var _useDropdownToggle = useDropdownToggle(),
      toggleProps = _useDropdownToggle[0];

  toggleProps.ref = (0,useMergedRefs/* default */.Z)(toggleProps.ref, useWrappedRefWithWarning(ref, 'DropdownToggle')); // This intentionally forwards size and variant (if set) to the
  // underlying component, to allow it to render size and style variants.

  return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
    className: classnames_default()(className, prefix, split && prefix + "-split")
  }, toggleProps, props));
});
DropdownToggle_DropdownToggle.displayName = 'DropdownToggle';
/* harmony default export */ var react_bootstrap_esm_DropdownToggle = (DropdownToggle_DropdownToggle);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Dropdown.js


var Dropdown_excluded = ["bsPrefix", "drop", "show", "className", "alignRight", "onSelect", "onToggle", "focusFirstItemOnShow", "as", "navbar"];











var DropdownHeader = createWithBsPrefix('dropdown-header', {
  defaultProps: {
    role: 'heading'
  }
});
var DropdownDivider = createWithBsPrefix('dropdown-divider', {
  defaultProps: {
    role: 'separator'
  }
});
var DropdownItemText = createWithBsPrefix('dropdown-item-text', {
  Component: 'span'
});
var Dropdown_defaultProps = {
  navbar: false
};
var Dropdown_Dropdown = /*#__PURE__*/react.forwardRef(function (pProps, ref) {
  var _useUncontrolled = (0,esm/* useUncontrolled */.Ch)(pProps, {
    show: 'onToggle'
  }),
      bsPrefix = _useUncontrolled.bsPrefix,
      drop = _useUncontrolled.drop,
      show = _useUncontrolled.show,
      className = _useUncontrolled.className,
      alignRight = _useUncontrolled.alignRight,
      onSelect = _useUncontrolled.onSelect,
      onToggle = _useUncontrolled.onToggle,
      focusFirstItemOnShow = _useUncontrolled.focusFirstItemOnShow,
      _useUncontrolled$as = _useUncontrolled.as,
      Component = _useUncontrolled$as === void 0 ? 'div' : _useUncontrolled$as,
      _4 = _useUncontrolled.navbar,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_useUncontrolled, Dropdown_excluded);

  var onSelectCtx = (0,react.useContext)(esm_SelectableContext);
  var prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'dropdown');
  var handleToggle = (0,useEventCallback/* default */.Z)(function (nextShow, event, source) {
    if (source === void 0) {
      source = event.type;
    }

    if (event.currentTarget === document && (source !== 'keydown' || event.key === 'Escape')) source = 'rootClose';

    if (onToggle) {
      onToggle(nextShow, event, {
        source: source
      });
    }
  });
  var handleSelect = (0,useEventCallback/* default */.Z)(function (key, event) {
    if (onSelectCtx) onSelectCtx(key, event);
    if (onSelect) onSelect(key, event);
    handleToggle(false, event, 'select');
  });
  return /*#__PURE__*/react.createElement(esm_SelectableContext.Provider, {
    value: handleSelect
  }, /*#__PURE__*/react.createElement(esm_Dropdown, {
    drop: drop,
    show: show,
    alignEnd: alignRight,
    onToggle: handleToggle,
    focusFirstItemOnShow: focusFirstItemOnShow,
    itemSelector: "." + prefix + "-item:not(.disabled):not(:disabled)"
  }, /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    className: classnames_default()(className, show && 'show', (!drop || drop === 'down') && prefix, drop === 'up' && 'dropup', drop === 'right' && 'dropright', drop === 'left' && 'dropleft')
  }))));
});
Dropdown_Dropdown.displayName = 'Dropdown';
Dropdown_Dropdown.defaultProps = Dropdown_defaultProps;
Dropdown_Dropdown.Divider = DropdownDivider;
Dropdown_Dropdown.Header = DropdownHeader;
Dropdown_Dropdown.Item = esm_DropdownItem;
Dropdown_Dropdown.ItemText = DropdownItemText;
Dropdown_Dropdown.Menu = react_bootstrap_esm_DropdownMenu;
Dropdown_Dropdown.Toggle = react_bootstrap_esm_DropdownToggle;
/* harmony default export */ var react_bootstrap_esm_Dropdown = (Dropdown_Dropdown);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/DropdownButton.js


var DropdownButton_excluded = ["title", "children", "bsPrefix", "rootCloseEvent", "variant", "size", "menuAlign", "menuRole", "renderMenuOnMount", "disabled", "href", "id"];





var DropdownButton_propTypes = {
  /**
   * An html id attribute for the Toggle button, necessary for assistive technologies, such as screen readers.
   * @type {string|number}
   * @required
   */
  id: (prop_types_default()).any,

  /** An `href` passed to the Toggle component */
  href: (prop_types_default()).string,

  /** An `onClick` handler passed to the Toggle component */
  onClick: (prop_types_default()).func,

  /** The content of the non-toggle Button.  */
  title: (prop_types_default()).node.isRequired,

  /** Disables both Buttons  */
  disabled: (prop_types_default()).bool,

  /**
   * Aligns the dropdown menu responsively.
   *
   * _see [DropdownMenu](#dropdown-menu-props) for more details_
   *
   * @type {"left"|"right"|{ sm: "left"|"right" }|{ md: "left"|"right" }|{ lg: "left"|"right" }|{ xl: "left"|"right"} }
   */
  menuAlign: alignPropType,

  /** An ARIA accessible role applied to the Menu component. When set to 'menu', The dropdown */
  menuRole: (prop_types_default()).string,

  /** Whether to render the dropdown menu in the DOM before the first time it is shown */
  renderMenuOnMount: (prop_types_default()).bool,

  /**
   *  Which event when fired outside the component will cause it to be closed.
   *
   * _see [DropdownMenu](#dropdown-menu-props) for more details_
   */
  rootCloseEvent: (prop_types_default()).string,

  /** @ignore */
  bsPrefix: (prop_types_default()).string,

  /** @ignore */
  variant: (prop_types_default()).string,

  /** @ignore */
  size: (prop_types_default()).string
};
/**
 * A convenience component for simple or general use dropdowns. Renders a `Button` toggle and all `children`
 * are passed directly to the default `Dropdown.Menu`. This component accepts all of
 * [`Dropdown`'s props](#dropdown-props).
 *
 * _All unknown props are passed through to the `Dropdown` component._ Only
 * the Button `variant`, `size` and `bsPrefix` props are passed to the toggle,
 * along with menu-related props are passed to the `Dropdown.Menu`
 */

var DropdownButton = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var title = _ref.title,
      children = _ref.children,
      bsPrefix = _ref.bsPrefix,
      rootCloseEvent = _ref.rootCloseEvent,
      variant = _ref.variant,
      size = _ref.size,
      menuAlign = _ref.menuAlign,
      menuRole = _ref.menuRole,
      renderMenuOnMount = _ref.renderMenuOnMount,
      disabled = _ref.disabled,
      href = _ref.href,
      id = _ref.id,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, DropdownButton_excluded);

  return /*#__PURE__*/react.createElement(react_bootstrap_esm_Dropdown, (0,esm_extends/* default */.Z)({
    ref: ref
  }, props), /*#__PURE__*/react.createElement(react_bootstrap_esm_DropdownToggle, {
    id: id,
    href: href,
    size: size,
    variant: variant,
    disabled: disabled,
    childBsPrefix: bsPrefix
  }, title), /*#__PURE__*/react.createElement(react_bootstrap_esm_DropdownMenu, {
    align: menuAlign,
    role: menuRole,
    renderOnMount: renderMenuOnMount,
    rootCloseEvent: rootCloseEvent
  }, children));
});
DropdownButton.displayName = 'DropdownButton';
DropdownButton.propTypes = DropdownButton_propTypes;
/* harmony default export */ var esm_DropdownButton = (DropdownButton);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ElementChildren.js

/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */

function map(children, func) {
  var index = 0;
  return react.Children.map(children, function (child) {
    return /*#__PURE__*/react.isValidElement(child) ? func(child, index++) : child;
  });
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */


function forEach(children, func) {
  var index = 0;
  React.Children.forEach(children, function (child) {
    if ( /*#__PURE__*/React.isValidElement(child)) func(child, index++);
  });
}


;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ProgressBar.js


var ProgressBar_excluded = ["min", "now", "max", "label", "srOnly", "striped", "animated", "className", "style", "variant", "bsPrefix"],
    _excluded2 = ["isChild"],
    _excluded3 = ["min", "now", "max", "label", "srOnly", "striped", "animated", "bsPrefix", "variant", "className", "children"];




var ROUND_PRECISION = 1000;
/**
 * Validate that children, if any, are instances of `<ProgressBar>`.
 */

function onlyProgressBar(props, propName, componentName) {
  var children = props[propName];

  if (!children) {
    return null;
  }

  var error = null;
  React.Children.forEach(children, function (child) {
    if (error) {
      return;
    }
    /**
     * Compare types in a way that works with libraries that patch and proxy
     * components like react-hot-loader.
     *
     * see https://github.com/gaearon/react-hot-loader#checking-element-types
     */
    // eslint-disable-next-line @typescript-eslint/no-use-before-define


    var element = /*#__PURE__*/React.createElement(ProgressBar, null);
    if (child.type === element.type) return;
    var childType = child.type;
    var childIdentifier = /*#__PURE__*/React.isValidElement(child) ? childType.displayName || childType.name || childType : child;
    error = new Error("Children of " + componentName + " can contain only ProgressBar " + ("components. Found " + childIdentifier + "."));
  });
  return error;
}

var ProgressBar_defaultProps = {
  min: 0,
  max: 100,
  animated: false,
  isChild: false,
  srOnly: false,
  striped: false
};

function getPercentage(now, min, max) {
  var percentage = (now - min) / (max - min) * 100;
  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
}

function renderProgressBar(_ref, ref) {
  var _classNames;

  var min = _ref.min,
      now = _ref.now,
      max = _ref.max,
      label = _ref.label,
      srOnly = _ref.srOnly,
      striped = _ref.striped,
      animated = _ref.animated,
      className = _ref.className,
      style = _ref.style,
      variant = _ref.variant,
      bsPrefix = _ref.bsPrefix,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ProgressBar_excluded);

  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    ref: ref
  }, props, {
    role: "progressbar",
    className: classnames_default()(className, bsPrefix + "-bar", (_classNames = {}, _classNames["bg-" + variant] = variant, _classNames[bsPrefix + "-bar-animated"] = animated, _classNames[bsPrefix + "-bar-striped"] = animated || striped, _classNames)),
    style: (0,esm_extends/* default */.Z)({
      width: getPercentage(now, min, max) + "%"
    }, style),
    "aria-valuenow": now,
    "aria-valuemin": min,
    "aria-valuemax": max
  }), srOnly ? /*#__PURE__*/react.createElement("span", {
    className: "sr-only"
  }, label) : label);
}

var ProgressBar = /*#__PURE__*/react.forwardRef(function (_ref2, ref) {
  var isChild = _ref2.isChild,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, _excluded2);

  props.bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(props.bsPrefix, 'progress');

  if (isChild) {
    return renderProgressBar(props, ref);
  }

  var min = props.min,
      now = props.now,
      max = props.max,
      label = props.label,
      srOnly = props.srOnly,
      striped = props.striped,
      animated = props.animated,
      bsPrefix = props.bsPrefix,
      variant = props.variant,
      className = props.className,
      children = props.children,
      wrapperProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded3);

  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    ref: ref
  }, wrapperProps, {
    className: classnames_default()(className, bsPrefix)
  }), children ? map(children, function (child) {
    return /*#__PURE__*/(0,react.cloneElement)(child, {
      isChild: true
    });
  }) : renderProgressBar({
    min: min,
    now: now,
    max: max,
    label: label,
    srOnly: srOnly,
    striped: striped,
    animated: animated,
    bsPrefix: bsPrefix,
    variant: variant
  }, ref));
});
ProgressBar.displayName = 'ProgressBar';
ProgressBar.defaultProps = ProgressBar_defaultProps;
/* harmony default export */ var esm_ProgressBar = (ProgressBar);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Tooltip.js
var Tooltip = __webpack_require__(43489);
// EXTERNAL MODULE: ./node_modules/prop-types-extra/lib/all.js
var lib_all = __webpack_require__(4391);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Feedback.js


var Feedback_excluded = ["as", "className", "type", "tooltip"];



var Feedback_propTypes = {
  /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */
  type: (prop_types_default()).string,

  /** Display feedback as a tooltip. */
  tooltip: (prop_types_default()).bool,
  as: (prop_types_default()).elementType
};
var Feedback = /*#__PURE__*/react.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref, ref) {
  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      className = _ref.className,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'valid' : _ref$type,
      _ref$tooltip = _ref.tooltip,
      tooltip = _ref$tooltip === void 0 ? false : _ref$tooltip,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, Feedback_excluded);

  return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    className: classnames_default()(className, type + "-" + (tooltip ? 'tooltip' : 'feedback'))
  }));
});
Feedback.displayName = 'Feedback';
Feedback.propTypes = Feedback_propTypes;
/* harmony default export */ var esm_Feedback = (Feedback);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormContext.js
 // TODO

var FormContext = /*#__PURE__*/react.createContext({
  controlId: undefined
});
/* harmony default export */ var esm_FormContext = (FormContext);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormCheckInput.js


var FormCheckInput_excluded = ["id", "bsPrefix", "bsCustomPrefix", "className", "type", "isValid", "isInvalid", "isStatic", "as"];




var FormCheckInput = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      bsPrefix = _ref.bsPrefix,
      bsCustomPrefix = _ref.bsCustomPrefix,
      className = _ref.className,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'checkbox' : _ref$type,
      _ref$isValid = _ref.isValid,
      isValid = _ref$isValid === void 0 ? false : _ref$isValid,
      _ref$isInvalid = _ref.isInvalid,
      isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid,
      isStatic = _ref.isStatic,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'input' : _ref$as,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, FormCheckInput_excluded);

  var _useContext = (0,react.useContext)(esm_FormContext),
      controlId = _useContext.controlId,
      custom = _useContext.custom;

  var _ref2 = custom ? [bsCustomPrefix, 'custom-control-input'] : [bsPrefix, 'form-check-input'],
      prefix = _ref2[0],
      defaultPrefix = _ref2[1];

  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(prefix, defaultPrefix);
  return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    type: type,
    id: id || controlId,
    className: classnames_default()(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid', isStatic && 'position-static')
  }));
});
FormCheckInput.displayName = 'FormCheckInput';
/* harmony default export */ var esm_FormCheckInput = (FormCheckInput);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormCheckLabel.js


var FormCheckLabel_excluded = ["bsPrefix", "bsCustomPrefix", "className", "htmlFor"];




var FormCheckLabel = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      bsCustomPrefix = _ref.bsCustomPrefix,
      className = _ref.className,
      htmlFor = _ref.htmlFor,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, FormCheckLabel_excluded);

  var _useContext = (0,react.useContext)(esm_FormContext),
      controlId = _useContext.controlId,
      custom = _useContext.custom;

  var _ref2 = custom ? [bsCustomPrefix, 'custom-control-label'] : [bsPrefix, 'form-check-label'],
      prefix = _ref2[0],
      defaultPrefix = _ref2[1];

  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(prefix, defaultPrefix);
  return /*#__PURE__*/react.createElement("label", (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    htmlFor: htmlFor || controlId,
    className: classnames_default()(className, bsPrefix)
  }));
});
FormCheckLabel.displayName = 'FormCheckLabel';
/* harmony default export */ var esm_FormCheckLabel = (FormCheckLabel);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormCheck.js


var FormCheck_excluded = ["id", "bsPrefix", "bsCustomPrefix", "inline", "disabled", "isValid", "isInvalid", "feedbackTooltip", "feedback", "className", "style", "title", "type", "label", "children", "custom", "as"];








var FormCheck = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      bsPrefix = _ref.bsPrefix,
      bsCustomPrefix = _ref.bsCustomPrefix,
      _ref$inline = _ref.inline,
      inline = _ref$inline === void 0 ? false : _ref$inline,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$isValid = _ref.isValid,
      isValid = _ref$isValid === void 0 ? false : _ref$isValid,
      _ref$isInvalid = _ref.isInvalid,
      isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid,
      _ref$feedbackTooltip = _ref.feedbackTooltip,
      feedbackTooltip = _ref$feedbackTooltip === void 0 ? false : _ref$feedbackTooltip,
      feedback = _ref.feedback,
      className = _ref.className,
      style = _ref.style,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'checkbox' : _ref$type,
      label = _ref.label,
      children = _ref.children,
      propCustom = _ref.custom,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'input' : _ref$as,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, FormCheck_excluded);

  var custom = type === 'switch' ? true : propCustom;

  var _ref2 = custom ? [bsCustomPrefix, 'custom-control'] : [bsPrefix, 'form-check'],
      prefix = _ref2[0],
      defaultPrefix = _ref2[1];

  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(prefix, defaultPrefix);

  var _useContext = (0,react.useContext)(esm_FormContext),
      controlId = _useContext.controlId;

  var innerFormContext = (0,react.useMemo)(function () {
    return {
      controlId: id || controlId,
      custom: custom
    };
  }, [controlId, custom, id]);
  var hasLabel = custom || label != null && label !== false && !children;
  var input = /*#__PURE__*/react.createElement(esm_FormCheckInput, (0,esm_extends/* default */.Z)({}, props, {
    type: type === 'switch' ? 'checkbox' : type,
    ref: ref,
    isValid: isValid,
    isInvalid: isInvalid,
    isStatic: !hasLabel,
    disabled: disabled,
    as: as
  }));
  return /*#__PURE__*/react.createElement(esm_FormContext.Provider, {
    value: innerFormContext
  }, /*#__PURE__*/react.createElement("div", {
    style: style,
    className: classnames_default()(className, bsPrefix, custom && "custom-" + type, inline && bsPrefix + "-inline")
  }, children || /*#__PURE__*/react.createElement(react.Fragment, null, input, hasLabel && /*#__PURE__*/react.createElement(esm_FormCheckLabel, {
    title: title
  }, label), (isValid || isInvalid) && /*#__PURE__*/react.createElement(esm_Feedback, {
    type: isValid ? 'valid' : 'invalid',
    tooltip: feedbackTooltip
  }, feedback))));
});
FormCheck.displayName = 'FormCheck';
FormCheck.Input = esm_FormCheckInput;
FormCheck.Label = esm_FormCheckLabel;
/* harmony default export */ var esm_FormCheck = (FormCheck);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormFileInput.js


var FormFileInput_excluded = ["id", "bsPrefix", "bsCustomPrefix", "className", "isValid", "isInvalid", "lang", "as"];




var FormFileInput = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      bsPrefix = _ref.bsPrefix,
      bsCustomPrefix = _ref.bsCustomPrefix,
      className = _ref.className,
      isValid = _ref.isValid,
      isInvalid = _ref.isInvalid,
      lang = _ref.lang,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'input' : _ref$as,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, FormFileInput_excluded);

  var _useContext = (0,react.useContext)(esm_FormContext),
      controlId = _useContext.controlId,
      custom = _useContext.custom;

  var type = 'file';

  var _ref2 = custom ? [bsCustomPrefix, 'custom-file-input'] : [bsPrefix, 'form-control-file'],
      prefix = _ref2[0],
      defaultPrefix = _ref2[1];

  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(prefix, defaultPrefix);
  return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    id: id || controlId,
    type: type,
    lang: lang,
    className: classnames_default()(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
  }));
});
FormFileInput.displayName = 'FormFileInput';
/* harmony default export */ var esm_FormFileInput = (FormFileInput);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormFileLabel.js


var FormFileLabel_excluded = ["bsPrefix", "bsCustomPrefix", "className", "htmlFor"];




var FormFileLabel = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      bsCustomPrefix = _ref.bsCustomPrefix,
      className = _ref.className,
      htmlFor = _ref.htmlFor,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, FormFileLabel_excluded);

  var _useContext = (0,react.useContext)(esm_FormContext),
      controlId = _useContext.controlId,
      custom = _useContext.custom;

  var _ref2 = custom ? [bsCustomPrefix, 'custom-file-label'] : [bsPrefix, 'form-file-label'],
      prefix = _ref2[0],
      defaultPrefix = _ref2[1];

  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(prefix, defaultPrefix);
  return /*#__PURE__*/react.createElement("label", (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    htmlFor: htmlFor || controlId,
    className: classnames_default()(className, bsPrefix),
    "data-browse": props['data-browse']
  }));
});
FormFileLabel.displayName = 'FormFileLabel';
/* harmony default export */ var esm_FormFileLabel = (FormFileLabel);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormFile.js


var FormFile_excluded = ["id", "bsPrefix", "bsCustomPrefix", "disabled", "isValid", "isInvalid", "feedbackTooltip", "feedback", "className", "style", "label", "children", "custom", "lang", "data-browse", "as", "inputAs"];








var FormFile = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      bsPrefix = _ref.bsPrefix,
      bsCustomPrefix = _ref.bsCustomPrefix,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$isValid = _ref.isValid,
      isValid = _ref$isValid === void 0 ? false : _ref$isValid,
      _ref$isInvalid = _ref.isInvalid,
      isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid,
      _ref$feedbackTooltip = _ref.feedbackTooltip,
      feedbackTooltip = _ref$feedbackTooltip === void 0 ? false : _ref$feedbackTooltip,
      feedback = _ref.feedback,
      className = _ref.className,
      style = _ref.style,
      label = _ref.label,
      children = _ref.children,
      custom = _ref.custom,
      lang = _ref.lang,
      dataBrowse = _ref['data-browse'],
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      _ref$inputAs = _ref.inputAs,
      inputAs = _ref$inputAs === void 0 ? 'input' : _ref$inputAs,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, FormFile_excluded);

  var _ref2 = custom ? [bsCustomPrefix, 'custom'] : [bsPrefix, 'form-file'],
      prefix = _ref2[0],
      defaultPrefix = _ref2[1];

  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(prefix, defaultPrefix);
  var type = 'file';

  var _useContext = (0,react.useContext)(esm_FormContext),
      controlId = _useContext.controlId;

  var innerFormContext = (0,react.useMemo)(function () {
    return {
      controlId: id || controlId,
      custom: custom
    };
  }, [controlId, custom, id]);
  var hasLabel = label != null && label !== false && !children;
  var input = /*#__PURE__*/react.createElement(esm_FormFileInput, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    isValid: isValid,
    isInvalid: isInvalid,
    disabled: disabled,
    as: inputAs,
    lang: lang
  }));
  return /*#__PURE__*/react.createElement(esm_FormContext.Provider, {
    value: innerFormContext
  }, /*#__PURE__*/react.createElement(Component, {
    style: style,
    className: classnames_default()(className, bsPrefix, custom && "custom-" + type)
  }, children || /*#__PURE__*/react.createElement(react.Fragment, null, custom ? /*#__PURE__*/react.createElement(react.Fragment, null, input, hasLabel && /*#__PURE__*/react.createElement(esm_FormFileLabel, {
    "data-browse": dataBrowse
  }, label)) : /*#__PURE__*/react.createElement(react.Fragment, null, hasLabel && /*#__PURE__*/react.createElement(esm_FormFileLabel, null, label), input), (isValid || isInvalid) && /*#__PURE__*/react.createElement(esm_Feedback, {
    type: isValid ? 'valid' : 'invalid',
    tooltip: feedbackTooltip
  }, feedback))));
});
FormFile.displayName = 'FormFile';
FormFile.Input = esm_FormFileInput;
FormFile.Label = esm_FormFileLabel;
/* harmony default export */ var esm_FormFile = (FormFile);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormControl.js


var FormControl_excluded = ["bsPrefix", "bsCustomPrefix", "type", "size", "htmlSize", "id", "className", "isValid", "isInvalid", "plaintext", "readOnly", "custom", "as"];







var FormControl = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      bsCustomPrefix = _ref.bsCustomPrefix,
      type = _ref.type,
      size = _ref.size,
      htmlSize = _ref.htmlSize,
      id = _ref.id,
      className = _ref.className,
      _ref$isValid = _ref.isValid,
      isValid = _ref$isValid === void 0 ? false : _ref$isValid,
      _ref$isInvalid = _ref.isInvalid,
      isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid,
      plaintext = _ref.plaintext,
      readOnly = _ref.readOnly,
      custom = _ref.custom,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'input' : _ref$as,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, FormControl_excluded);

  var _useContext = (0,react.useContext)(esm_FormContext),
      controlId = _useContext.controlId;

  var _ref2 = custom ? [bsCustomPrefix, 'custom'] : [bsPrefix, 'form-control'],
      prefix = _ref2[0],
      defaultPrefix = _ref2[1];

  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(prefix, defaultPrefix);
  var classes;

  if (plaintext) {
    var _classes;

    classes = (_classes = {}, _classes[bsPrefix + "-plaintext"] = true, _classes);
  } else if (type === 'file') {
    var _classes2;

    classes = (_classes2 = {}, _classes2[bsPrefix + "-file"] = true, _classes2);
  } else if (type === 'range') {
    var _classes3;

    classes = (_classes3 = {}, _classes3[bsPrefix + "-range"] = true, _classes3);
  } else if (Component === 'select' && custom) {
    var _classes4;

    classes = (_classes4 = {}, _classes4[bsPrefix + "-select"] = true, _classes4[bsPrefix + "-select-" + size] = size, _classes4);
  } else {
    var _classes5;

    classes = (_classes5 = {}, _classes5[bsPrefix] = true, _classes5[bsPrefix + "-" + size] = size, _classes5);
  }

   false ? 0 : void 0;
  return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({}, props, {
    type: type,
    size: htmlSize,
    ref: ref,
    readOnly: readOnly,
    id: id || controlId,
    className: classnames_default()(className, classes, isValid && "is-valid", isInvalid && "is-invalid")
  }));
});
FormControl.displayName = 'FormControl';
/* harmony default export */ var esm_FormControl = (Object.assign(FormControl, {
  Feedback: esm_Feedback
}));
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormGroup.js


var FormGroup_excluded = ["bsPrefix", "className", "children", "controlId", "as"];




var FormGroup = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      children = _ref.children,
      controlId = _ref.controlId,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, FormGroup_excluded);

  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'form-group');
  var context = (0,react.useMemo)(function () {
    return {
      controlId: controlId
    };
  }, [controlId]);
  return /*#__PURE__*/react.createElement(esm_FormContext.Provider, {
    value: context
  }, /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    className: classnames_default()(className, bsPrefix)
  }), children));
});
FormGroup.displayName = 'FormGroup';
/* harmony default export */ var esm_FormGroup = (FormGroup);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormLabel.js


var FormLabel_excluded = ["as", "bsPrefix", "column", "srOnly", "className", "htmlFor"];






var FormLabel_defaultProps = {
  column: false,
  srOnly: false
};
var FormLabel = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'label' : _ref$as,
      bsPrefix = _ref.bsPrefix,
      column = _ref.column,
      srOnly = _ref.srOnly,
      className = _ref.className,
      htmlFor = _ref.htmlFor,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, FormLabel_excluded);

  var _useContext = (0,react.useContext)(esm_FormContext),
      controlId = _useContext.controlId;

  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'form-label');
  var columnClass = 'col-form-label';
  if (typeof column === 'string') columnClass = columnClass + " " + columnClass + "-" + column;
  var classes = classnames_default()(className, bsPrefix, srOnly && 'sr-only', column && columnClass);
   false ? 0 : void 0;
  htmlFor = htmlFor || controlId;
  if (column) return /*#__PURE__*/react.createElement(Col/* default */.Z, (0,esm_extends/* default */.Z)({
    ref: ref,
    as: "label",
    className: classes,
    htmlFor: htmlFor
  }, props));
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
    react.createElement(Component, (0,esm_extends/* default */.Z)({
      ref: ref,
      className: classes,
      htmlFor: htmlFor
    }, props))
  );
});
FormLabel.displayName = 'FormLabel';
FormLabel.defaultProps = FormLabel_defaultProps;
/* harmony default export */ var esm_FormLabel = (FormLabel);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormText.js


var FormText_excluded = ["bsPrefix", "className", "as", "muted"];



var FormText = /*#__PURE__*/react.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'small' : _ref$as,
      muted = _ref.muted,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, FormText_excluded);

  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'form-text');
  return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    className: classnames_default()(className, bsPrefix, muted && 'text-muted')
  }));
});
FormText.displayName = 'FormText';
/* harmony default export */ var esm_FormText = (FormText);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Switch.js



var Switch = /*#__PURE__*/react.forwardRef(function (props, ref) {
  return /*#__PURE__*/react.createElement(esm_FormCheck, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    type: "switch"
  }));
});
Switch.displayName = 'Switch';
Switch.Input = esm_FormCheck.Input;
Switch.Label = esm_FormCheck.Label;
/* harmony default export */ var esm_Switch = (Switch);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Form.js


var Form_excluded = ["bsPrefix", "inline", "className", "validated", "as"];











var FormRow = createWithBsPrefix('form-row');
var Form_defaultProps = {
  inline: false
};
var FormImpl = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      inline = _ref.inline,
      className = _ref.className,
      validated = _ref.validated,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'form' : _ref$as,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, Form_excluded);

  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'form');
  return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    className: classnames_default()(className, validated && 'was-validated', inline && bsPrefix + "-inline")
  }));
});
FormImpl.displayName = 'Form';
FormImpl.defaultProps = Form_defaultProps;
FormImpl.Row = FormRow;
FormImpl.Group = esm_FormGroup;
FormImpl.Control = esm_FormControl;
FormImpl.Check = esm_FormCheck;
FormImpl.File = esm_FormFile;
FormImpl.Switch = esm_Switch;
FormImpl.Label = esm_FormLabel;
FormImpl.Text = esm_FormText;
/* harmony default export */ var Form = (FormImpl);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/OverlayTrigger.js + 3 modules
var OverlayTrigger = __webpack_require__(95944);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Image.js


var Image_excluded = ["bsPrefix", "className", "fluid", "rounded", "roundedCircle", "thumbnail"];




var Image_propTypes = {
  /**
   * @default 'img'
   */
  bsPrefix: (prop_types_default()).string,

  /**
   * Sets image as fluid image.
   */
  fluid: (prop_types_default()).bool,

  /**
   * Sets image shape as rounded.
   */
  rounded: (prop_types_default()).bool,

  /**
   * Sets image shape as circle.
   */
  roundedCircle: (prop_types_default()).bool,

  /**
   * Sets image shape as thumbnail.
   */
  thumbnail: (prop_types_default()).bool
};
var Image_defaultProps = {
  fluid: false,
  rounded: false,
  roundedCircle: false,
  thumbnail: false
};
var Image = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      fluid = _ref.fluid,
      rounded = _ref.rounded,
      roundedCircle = _ref.roundedCircle,
      thumbnail = _ref.thumbnail,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, Image_excluded);

  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'img');
  var classes = classnames_default()(fluid && bsPrefix + "-fluid", rounded && "rounded", roundedCircle && "rounded-circle", thumbnail && bsPrefix + "-thumbnail");
  return /*#__PURE__*/react.createElement("img", (0,esm_extends/* default */.Z)({
    // eslint-disable-line jsx-a11y/alt-text
    ref: ref
  }, props, {
    className: classnames_default()(className, classes)
  }));
});
Image.displayName = 'Image';
Image.defaultProps = Image_defaultProps;
/* harmony default export */ var esm_Image = (Image);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/TabContext.js

var TabContext = /*#__PURE__*/react.createContext(null);
/* harmony default export */ var esm_TabContext = (TabContext);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/TabContainer.js





var TabContainer = function TabContainer(props) {
  var _useUncontrolled = (0,esm/* useUncontrolled */.Ch)(props, {
    activeKey: 'onSelect'
  }),
      id = _useUncontrolled.id,
      generateCustomChildId = _useUncontrolled.generateChildId,
      onSelect = _useUncontrolled.onSelect,
      activeKey = _useUncontrolled.activeKey,
      transition = _useUncontrolled.transition,
      mountOnEnter = _useUncontrolled.mountOnEnter,
      unmountOnExit = _useUncontrolled.unmountOnExit,
      children = _useUncontrolled.children;

  var generateChildId = (0,react.useMemo)(function () {
    return generateCustomChildId || function (key, type) {
      return id ? id + "-" + type + "-" + key : null;
    };
  }, [id, generateCustomChildId]);
  var tabContext = (0,react.useMemo)(function () {
    return {
      onSelect: onSelect,
      activeKey: activeKey,
      transition: transition,
      mountOnEnter: mountOnEnter || false,
      unmountOnExit: unmountOnExit || false,
      getControlledId: function getControlledId(key) {
        return generateChildId(key, 'tabpane');
      },
      getControllerId: function getControllerId(key) {
        return generateChildId(key, 'tab');
      }
    };
  }, [onSelect, activeKey, transition, mountOnEnter, unmountOnExit, generateChildId]);
  return /*#__PURE__*/react.createElement(esm_TabContext.Provider, {
    value: tabContext
  }, /*#__PURE__*/react.createElement(esm_SelectableContext.Provider, {
    value: onSelect || null
  }, children));
};

/* harmony default export */ var esm_TabContainer = (TabContainer);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/TabContent.js


var TabContent_excluded = ["bsPrefix", "as", "className"];



var TabContent = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      className = _ref.className,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, TabContent_excluded);

  var decoratedBsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'tab-content');
  return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
    ref: ref
  }, props, {
    className: classnames_default()(className, decoratedBsPrefix)
  }));
});
/* harmony default export */ var esm_TabContent = (TabContent);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/TabPane.js


var TabPane_excluded = ["activeKey", "getControlledId", "getControllerId"],
    TabPane_excluded2 = ["bsPrefix", "className", "active", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "mountOnEnter", "unmountOnExit", "transition", "as", "eventKey"];







function useTabContext(props) {
  var context = (0,react.useContext)(esm_TabContext);
  if (!context) return props;

  var activeKey = context.activeKey,
      getControlledId = context.getControlledId,
      getControllerId = context.getControllerId,
      rest = (0,objectWithoutPropertiesLoose/* default */.Z)(context, TabPane_excluded);

  var shouldTransition = props.transition !== false && rest.transition !== false;
  var key = makeEventKey(props.eventKey);
  return (0,esm_extends/* default */.Z)({}, props, {
    active: props.active == null && key != null ? makeEventKey(activeKey) === key : props.active,
    id: getControlledId(props.eventKey),
    'aria-labelledby': getControllerId(props.eventKey),
    transition: shouldTransition && (props.transition || rest.transition || Fade/* default */.Z),
    mountOnEnter: props.mountOnEnter != null ? props.mountOnEnter : rest.mountOnEnter,
    unmountOnExit: props.unmountOnExit != null ? props.unmountOnExit : rest.unmountOnExit
  });
}

var TabPane = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _useTabContext = useTabContext(props),
      bsPrefix = _useTabContext.bsPrefix,
      className = _useTabContext.className,
      active = _useTabContext.active,
      onEnter = _useTabContext.onEnter,
      onEntering = _useTabContext.onEntering,
      onEntered = _useTabContext.onEntered,
      onExit = _useTabContext.onExit,
      onExiting = _useTabContext.onExiting,
      onExited = _useTabContext.onExited,
      mountOnEnter = _useTabContext.mountOnEnter,
      unmountOnExit = _useTabContext.unmountOnExit,
      Transition = _useTabContext.transition,
      _useTabContext$as = _useTabContext.as,
      Component = _useTabContext$as === void 0 ? 'div' : _useTabContext$as,
      _ = _useTabContext.eventKey,
      rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_useTabContext, TabPane_excluded2);

  var prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'tab-pane');
  if (!active && !Transition && unmountOnExit) return null;
  var pane = /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({}, rest, {
    ref: ref,
    role: "tabpanel",
    "aria-hidden": !active,
    className: classnames_default()(className, prefix, {
      active: active
    })
  }));
  if (Transition) pane = /*#__PURE__*/react.createElement(Transition, {
    in: active,
    onEnter: onEnter,
    onEntering: onEntering,
    onEntered: onEntered,
    onExit: onExit,
    onExiting: onExiting,
    onExited: onExited,
    mountOnEnter: mountOnEnter,
    unmountOnExit: unmountOnExit
  }, pane); // We provide an empty the TabContext so `<Nav>`s in `<TabPane>`s don't
  // conflict with the top level one.

  return /*#__PURE__*/react.createElement(esm_TabContext.Provider, {
    value: null
  }, /*#__PURE__*/react.createElement(esm_SelectableContext.Provider, {
    value: null
  }, pane));
});
TabPane.displayName = 'TabPane';
/* harmony default export */ var esm_TabPane = (TabPane);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Tab.js






/* eslint-disable react/require-render-return, react/no-unused-prop-types */
var Tab = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(Tab, _React$Component);

  function Tab() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Tab.prototype;

  _proto.render = function render() {
    throw new Error('ReactBootstrap: The `Tab` component is not meant to be rendered! ' + "It's an abstract component that is only valid as a direct Child of the `Tabs` Component. " + 'For custom tabs components use TabPane and TabsContainer directly');
    return null;
  };

  return Tab;
}(react.Component);

Tab.Container = esm_TabContainer;
Tab.Content = esm_TabContent;
Tab.Pane = esm_TabPane;
/* harmony default export */ var esm_Tab = (Tab);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AbstractNav.js


var AbstractNav_excluded = ["as", "onSelect", "activeKey", "role", "onKeyDown"];








// eslint-disable-next-line @typescript-eslint/no-empty-function
var AbstractNav_noop = function noop() {};

var AbstractNav = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'ul' : _ref$as,
      onSelect = _ref.onSelect,
      activeKey = _ref.activeKey,
      role = _ref.role,
      onKeyDown = _ref.onKeyDown,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, AbstractNav_excluded);

  // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
  // and don't want to reset the set in the effect
  var forceUpdate = useForceUpdate();
  var needsRefocusRef = (0,react.useRef)(false);
  var parentOnSelect = (0,react.useContext)(esm_SelectableContext);
  var tabContext = (0,react.useContext)(esm_TabContext);
  var getControlledId, getControllerId;

  if (tabContext) {
    role = role || 'tablist';
    activeKey = tabContext.activeKey;
    getControlledId = tabContext.getControlledId;
    getControllerId = tabContext.getControllerId;
  }

  var listNode = (0,react.useRef)(null);

  var getNextActiveChild = function getNextActiveChild(offset) {
    var currentListNode = listNode.current;
    if (!currentListNode) return null;
    var items = qsa(currentListNode, '[data-rb-event-key]:not(.disabled)');
    var activeChild = currentListNode.querySelector('.active');
    if (!activeChild) return null;
    var index = items.indexOf(activeChild);
    if (index === -1) return null;
    var nextIndex = index + offset;
    if (nextIndex >= items.length) nextIndex = 0;
    if (nextIndex < 0) nextIndex = items.length - 1;
    return items[nextIndex];
  };

  var handleSelect = function handleSelect(key, event) {
    if (key == null) return;
    if (onSelect) onSelect(key, event);
    if (parentOnSelect) parentOnSelect(key, event);
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (onKeyDown) onKeyDown(event);
    var nextActiveChild;

    switch (event.key) {
      case 'ArrowLeft':
      case 'ArrowUp':
        nextActiveChild = getNextActiveChild(-1);
        break;

      case 'ArrowRight':
      case 'ArrowDown':
        nextActiveChild = getNextActiveChild(1);
        break;

      default:
        return;
    }

    if (!nextActiveChild) return;
    event.preventDefault();
    handleSelect(nextActiveChild.dataset.rbEventKey, event);
    needsRefocusRef.current = true;
    forceUpdate();
  };

  (0,react.useEffect)(function () {
    if (listNode.current && needsRefocusRef.current) {
      var activeChild = listNode.current.querySelector('[data-rb-event-key].active');
      if (activeChild) activeChild.focus();
    }

    needsRefocusRef.current = false;
  });
  var mergedRef = (0,useMergedRefs/* default */.Z)(ref, listNode);
  return /*#__PURE__*/react.createElement(esm_SelectableContext.Provider, {
    value: handleSelect
  }, /*#__PURE__*/react.createElement(esm_NavContext.Provider, {
    value: {
      role: role,
      // used by NavLink to determine it's role
      activeKey: makeEventKey(activeKey),
      getControlledId: getControlledId || AbstractNav_noop,
      getControllerId: getControllerId || AbstractNav_noop
    }
  }, /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({}, props, {
    onKeyDown: handleKeyDown,
    ref: mergedRef,
    role: role
  }))));
});
/* harmony default export */ var esm_AbstractNav = (AbstractNav);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/NavItem.js


var NavItem_excluded = ["bsPrefix", "className", "children", "as"];



var NavItem = /*#__PURE__*/react.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      children = _ref.children,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, NavItem_excluded);

  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'nav-item');
  return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    className: classnames_default()(className, bsPrefix)
  }), children);
});
NavItem.displayName = 'NavItem';
/* harmony default export */ var esm_NavItem = (NavItem);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AbstractNavItem.js


var AbstractNavItem_excluded = ["active", "className", "eventKey", "onSelect", "onClick", "as"];






var AbstractNavItem_defaultProps = {
  disabled: false
};
var AbstractNavItem = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var active = _ref.active,
      className = _ref.className,
      eventKey = _ref.eventKey,
      onSelect = _ref.onSelect,
      onClick = _ref.onClick,
      Component = _ref.as,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, AbstractNavItem_excluded);

  var navKey = makeEventKey(eventKey, props.href);
  var parentOnSelect = (0,react.useContext)(esm_SelectableContext);
  var navContext = (0,react.useContext)(esm_NavContext);
  var isActive = active;

  if (navContext) {
    if (!props.role && navContext.role === 'tablist') props.role = 'tab';
    var contextControllerId = navContext.getControllerId(navKey);
    var contextControlledId = navContext.getControlledId(navKey);
     false ? 0 : void 0;
     false ? 0 : void 0;
    props['data-rb-event-key'] = navKey;
    props.id = contextControllerId || props.id;
    props['aria-controls'] = contextControlledId || props['aria-controls'];
    isActive = active == null && navKey != null ? navContext.activeKey === navKey : active;
  }

  if (props.role === 'tab') {
    if (props.disabled) {
      props.tabIndex = -1;
      props['aria-disabled'] = true;
    }

    props['aria-selected'] = isActive;
  }

  var handleOnclick = (0,useEventCallback/* default */.Z)(function (e) {
    if (onClick) onClick(e);
    if (navKey == null) return;
    if (onSelect) onSelect(navKey, e);
    if (parentOnSelect) parentOnSelect(navKey, e);
  });
  return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    onClick: handleOnclick,
    className: classnames_default()(className, isActive && 'active')
  }));
});
AbstractNavItem.defaultProps = AbstractNavItem_defaultProps;
/* harmony default export */ var esm_AbstractNavItem = (AbstractNavItem);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/NavLink.js


var NavLink_excluded = ["bsPrefix", "disabled", "className", "href", "eventKey", "onSelect", "as"];





var NavLink_defaultProps = {
  disabled: false,
  as: SafeAnchor/* default */.Z
};
var NavLink = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      disabled = _ref.disabled,
      className = _ref.className,
      href = _ref.href,
      eventKey = _ref.eventKey,
      onSelect = _ref.onSelect,
      as = _ref.as,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, NavLink_excluded);

  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'nav-link');
  return /*#__PURE__*/react.createElement(esm_AbstractNavItem, (0,esm_extends/* default */.Z)({}, props, {
    href: href,
    ref: ref,
    eventKey: eventKey,
    as: as,
    disabled: disabled,
    onSelect: onSelect,
    className: classnames_default()(className, bsPrefix, disabled && 'disabled')
  }));
});
NavLink.displayName = 'NavLink';
NavLink.defaultProps = NavLink_defaultProps;
/* harmony default export */ var esm_NavLink = (NavLink);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Nav.js


var Nav_excluded = ["as", "bsPrefix", "variant", "fill", "justify", "navbar", "navbarScroll", "className", "children", "activeKey"];










var Nav_defaultProps = {
  justify: false,
  fill: false
};
var Nav = /*#__PURE__*/react.forwardRef(function (uncontrolledProps, ref) {
  var _classNames;

  var _useUncontrolled = (0,esm/* useUncontrolled */.Ch)(uncontrolledProps, {
    activeKey: 'onSelect'
  }),
      _useUncontrolled$as = _useUncontrolled.as,
      as = _useUncontrolled$as === void 0 ? 'div' : _useUncontrolled$as,
      initialBsPrefix = _useUncontrolled.bsPrefix,
      variant = _useUncontrolled.variant,
      fill = _useUncontrolled.fill,
      justify = _useUncontrolled.justify,
      navbar = _useUncontrolled.navbar,
      navbarScroll = _useUncontrolled.navbarScroll,
      className = _useUncontrolled.className,
      children = _useUncontrolled.children,
      activeKey = _useUncontrolled.activeKey,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_useUncontrolled, Nav_excluded);

  var bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(initialBsPrefix, 'nav');
  var navbarBsPrefix;
  var cardHeaderBsPrefix;
  var isNavbar = false;
  var navbarContext = (0,react.useContext)(NavbarContext);
  var cardContext = (0,react.useContext)(CardContext);

  if (navbarContext) {
    navbarBsPrefix = navbarContext.bsPrefix;
    isNavbar = navbar == null ? true : navbar;
  } else if (cardContext) {
    cardHeaderBsPrefix = cardContext.cardHeaderBsPrefix;
  }

  return /*#__PURE__*/react.createElement(esm_AbstractNav, (0,esm_extends/* default */.Z)({
    as: as,
    ref: ref,
    activeKey: activeKey,
    className: classnames_default()(className, (_classNames = {}, _classNames[bsPrefix] = !isNavbar, _classNames[navbarBsPrefix + "-nav"] = isNavbar, _classNames[navbarBsPrefix + "-nav-scroll"] = isNavbar && navbarScroll, _classNames[cardHeaderBsPrefix + "-" + variant] = !!cardHeaderBsPrefix, _classNames[bsPrefix + "-" + variant] = !!variant, _classNames[bsPrefix + "-fill"] = fill, _classNames[bsPrefix + "-justified"] = justify, _classNames))
  }, props), children);
});
Nav.displayName = 'Nav';
Nav.defaultProps = Nav_defaultProps;
Nav.Item = esm_NavItem;
Nav.Link = esm_NavLink;
/* harmony default export */ var esm_Nav = (Nav);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionContext.js

var AccordionContext_context = /*#__PURE__*/react.createContext(null);
AccordionContext_context.displayName = 'AccordionContext';
/* harmony default export */ var AccordionContext = (AccordionContext_context);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionToggle.js


var AccordionToggle_excluded = ["as", "children", "eventKey", "onClick"];



function useAccordionToggle(eventKey, onClick) {
  var contextEventKey = (0,react.useContext)(AccordionContext);
  var onSelect = (0,react.useContext)(esm_SelectableContext);
  return function (e) {
    /*
      Compare the event key in context with the given event key.
      If they are the same, then collapse the component.
    */
    var eventKeyPassed = eventKey === contextEventKey ? null : eventKey;
    if (onSelect) onSelect(eventKeyPassed, e);
    if (onClick) onClick(e);
  };
}
var AccordionToggle = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'button' : _ref$as,
      children = _ref.children,
      eventKey = _ref.eventKey,
      onClick = _ref.onClick,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, AccordionToggle_excluded);

  var accordionOnClick = useAccordionToggle(eventKey, onClick);

  if (Component === 'button') {
    props.type = 'button';
  }

  return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
    ref: ref,
    onClick: accordionOnClick
  }, props), children);
});
/* harmony default export */ var esm_AccordionToggle = (AccordionToggle);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Collapse.js
var Collapse = __webpack_require__(9966);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionCollapse.js


var AccordionCollapse_excluded = ["children", "eventKey"];




var AccordionCollapse = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      eventKey = _ref.eventKey,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, AccordionCollapse_excluded);

  var contextEventKey = (0,react.useContext)(AccordionContext); // Empty SelectableContext is to prevent elements in the collapse
  // from collapsing the accordion when clicked.

  return /*#__PURE__*/react.createElement(esm_SelectableContext.Provider, {
    value: null
  }, /*#__PURE__*/react.createElement(Collapse/* default */.Z, (0,esm_extends/* default */.Z)({
    ref: ref,
    in: contextEventKey === eventKey
  }, props), /*#__PURE__*/react.createElement("div", null, react.Children.only(children))));
});
AccordionCollapse.displayName = 'AccordionCollapse';
/* harmony default export */ var esm_AccordionCollapse = (AccordionCollapse);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Accordion.js


var Accordion_excluded = ["as", "activeKey", "bsPrefix", "children", "className", "onSelect"];








var Accordion = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _useUncontrolled = (0,esm/* useUncontrolled */.Ch)(props, {
    activeKey: 'onSelect'
  }),
      _useUncontrolled$as = _useUncontrolled.as,
      Component = _useUncontrolled$as === void 0 ? 'div' : _useUncontrolled$as,
      activeKey = _useUncontrolled.activeKey,
      bsPrefix = _useUncontrolled.bsPrefix,
      children = _useUncontrolled.children,
      className = _useUncontrolled.className,
      onSelect = _useUncontrolled.onSelect,
      controlledProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_useUncontrolled, Accordion_excluded);

  var finalClassName = classnames_default()(className, (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion'));
  return /*#__PURE__*/react.createElement(AccordionContext.Provider, {
    value: activeKey || null
  }, /*#__PURE__*/react.createElement(esm_SelectableContext.Provider, {
    value: onSelect || null
  }, /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
    ref: ref
  }, controlledProps, {
    className: finalClassName
  }), children)));
});
Accordion.displayName = 'Accordion';
Accordion.Toggle = esm_AccordionToggle;
Accordion.Collapse = esm_AccordionCollapse;
/* harmony default export */ var esm_Accordion = (Accordion);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Spinner.js


var Spinner_excluded = ["bsPrefix", "variant", "animation", "size", "children", "as", "className"];



var Spinner = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      variant = _ref.variant,
      animation = _ref.animation,
      size = _ref.size,
      children = _ref.children,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      className = _ref.className,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, Spinner_excluded);

  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'spinner');
  var bsSpinnerPrefix = bsPrefix + "-" + animation;
  return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
    ref: ref
  }, props, {
    className: classnames_default()(className, bsSpinnerPrefix, size && bsSpinnerPrefix + "-" + size, variant && "text-" + variant)
  }), children);
});
Spinner.displayName = 'Spinner';
/* harmony default export */ var esm_Spinner = (Spinner);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/BreadcrumbItem.js


var BreadcrumbItem_excluded = ["bsPrefix", "active", "children", "className", "as", "linkAs", "linkProps", "href", "title", "target"];




var BreadcrumbItem_defaultProps = {
  active: false,
  linkProps: {}
};
var BreadcrumbItem = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      active = _ref.active,
      children = _ref.children,
      className = _ref.className,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'li' : _ref$as,
      _ref$linkAs = _ref.linkAs,
      LinkComponent = _ref$linkAs === void 0 ? SafeAnchor/* default */.Z : _ref$linkAs,
      linkProps = _ref.linkProps,
      href = _ref.href,
      title = _ref.title,
      target = _ref.target,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, BreadcrumbItem_excluded);

  var prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'breadcrumb-item');
  return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
    ref: ref
  }, props, {
    className: classnames_default()(prefix, className, {
      active: active
    }),
    "aria-current": active ? 'page' : undefined
  }), active ? children : /*#__PURE__*/react.createElement(LinkComponent, (0,esm_extends/* default */.Z)({}, linkProps, {
    href: href,
    title: title,
    target: target
  }), children));
});
BreadcrumbItem.displayName = 'BreadcrumbItem';
BreadcrumbItem.defaultProps = BreadcrumbItem_defaultProps;
/* harmony default export */ var esm_BreadcrumbItem = (BreadcrumbItem);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js


var Breadcrumb_excluded = ["bsPrefix", "className", "listProps", "children", "label", "as"];




var Breadcrumb_defaultProps = {
  label: 'breadcrumb',
  listProps: {}
};
var Breadcrumb = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      listProps = _ref.listProps,
      children = _ref.children,
      label = _ref.label,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'nav' : _ref$as,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, Breadcrumb_excluded);

  var prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'breadcrumb');
  return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
    "aria-label": label,
    className: className,
    ref: ref
  }, props), /*#__PURE__*/react.createElement("ol", (0,esm_extends/* default */.Z)({}, listProps, {
    className: classnames_default()(prefix, listProps == null ? void 0 : listProps.className)
  }), children));
});
Breadcrumb.displayName = 'Breadcrumb';
Breadcrumb.defaultProps = Breadcrumb_defaultProps;
Breadcrumb.Item = esm_BreadcrumbItem;
/* harmony default export */ var esm_Breadcrumb = (Breadcrumb);
// EXTERNAL MODULE: ./node_modules/react-owl-carousel2/lib/OwlCarousel.js
var OwlCarousel = __webpack_require__(68820);
var OwlCarousel_default = /*#__PURE__*/__webpack_require__.n(OwlCarousel);
// EXTERNAL MODULE: ./node_modules/react-text-truncate/lib/index.js
var lib = __webpack_require__(37856);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/react-countdown/dist/index.es.js
var index_es = __webpack_require__(98130);
// EXTERNAL MODULE: ./node_modules/js-sha256/src/sha256.js
var sha256 = __webpack_require__(72023);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./library/react-pannellum/index.js
var react_pannellum = __webpack_require__(91553);
;// CONCATENATED MODULE: ./components/atoms/DependencyHelper.js












 //Next Dependencies




 //Redux Dependencies

 //ReactPannellum Dependencies

 // React Bootstrap dependencies

var DependencyHelper_Container = Container/* default */.Z;
var DependencyHelper_Row = Row/* default */.Z;
var DependencyHelper_Col = Col/* default */.Z;
var DependencyHelper_Modal = react_bootstrap_esm_Modal;
var DependencyHelper_Image = esm_Image;
var DependencyHelper_Card = esm_Card;
var DependencyHelper_CardDeck = CardDeck;
var DependencyHelper_CardColumns = CardColumns;
var DependencyHelper_Button = Button/* default */.Z;
var DependencyHelper_ButtonGroup = esm_ButtonGroup;
var DependencyHelper_Dropdown = react_bootstrap_esm_Dropdown;
var DependencyHelper_DropdownButton = esm_DropdownButton;
var DependencyHelper_Tab = esm_Tab;
var DependencyHelper_Nav = esm_Nav;
var DependencyHelper_Accordion = esm_Accordion;
var DependencyHelper_useAccordionToggle = useAccordionToggle;
var DependencyHelper_Spinner = esm_Spinner;
var DependencyHelper_Breadcrumb = esm_Breadcrumb;
var DependencyHelper_OwlCarousel = (OwlCarousel_default());
var Countdown = index_es/* default */.ZP;
var DependencyHelper_ProgressBar = esm_ProgressBar;
var DependencyHelper_Tooltip = Tooltip/* default */.Z;
var DependencyHelper_Form = Form;
var DependencyHelper_OverlayTrigger = OverlayTrigger/* default */.Z;
var TextTruncate = (lib_default()); //Next Dependencies

var Head = (head_default());
var Router = (router_default());
var Link = (link_default());
var useRouter = router.useRouter;
var withRouter = router.withRouter; //Div Container

var CustomContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DependencyHelper__CustomContainer",
  componentId: "sc-ws8fko-0"
})([""]);
var FooterContainer = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
  displayName: "DependencyHelper__FooterContainer",
  componentId: "sc-ws8fko-1"
})([""]);
var Text = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
  displayName: "DependencyHelper__Text",
  componentId: "sc-ws8fko-2"
})([""]);
var Progress = styled_components_browser_esm/* default.progress.withConfig */.ZP.progress.withConfig({
  displayName: "DependencyHelper__Progress",
  componentId: "sc-ws8fko-3"
})([""]); //Redux Connect

var connect = es/* connect */.$j;
var useDispatch = es/* useDispatch */.I0; //ReactPannellum Dependencies

var Pannellum = react_pannellum/* default */.ZP;
var PannellumGetConfig = react_pannellum/* getConfig */.iE;
var PannellumSetYaw = react_pannellum/* setYaw */.X3; //JS-Cookie

var Cookie = (js_cookie_default());
var DependencyHelper_sha256 = sha256.sha256;

/***/ }),

/***/ 30390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _ButtonWithIcon_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48258);
/* harmony import */ var _ButtonWithIcon_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ButtonWithIcon_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var ButtonWithIcon = function ButtonWithIcon(_ref) {
  var className = _ref.className,
      labelText = _ref.labelText,
      img_url_inactive = _ref.img_url_inactive,
      img_url_active = _ref.img_url_active,
      img_url_disable = _ref.img_url_disable,
      img_width = _ref.img_width,
      img_height = _ref.img_height,
      clickHandler = _ref.clickHandler,
      buttonLabelStyle = _ref.buttonLabelStyle,
      id = _ref.id,
      disableBackButton = _ref.disableBackButton;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(img_url_active),
      src = _useState[0],
      setSrc = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setSrc(disableBackButton ? img_url_disable : img_url_inactive);
  }, [disableBackButton]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
    className: "".concat(className, " ").concat((_ButtonWithIcon_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["button-container"])),
    onClick: clickHandler,
    onMouseOver: !disableBackButton ? function () {
      return setSrc(img_url_active);
    } : undefined,
    onMouseOut: !disableBackButton ? function () {
      return setSrc(img_url_inactive);
    } : undefined,
    id: id,
    disabled: disableBackButton,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      children: src && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
        className: disableBackButton ? "".concat((_ButtonWithIcon_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["disable-img"])) : "image",
        src: src,
        alt: "",
        width: img_width,
        height: img_height
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
      className: disableBackButton ? "".concat((_ButtonWithIcon_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["disable-button-label"]), " ").concat(buttonLabelStyle) : "".concat((_ButtonWithIcon_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["button-label"]), " ").concat(buttonLabelStyle),
      id: "button-label-".concat(labelText),
      children: labelText
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ButtonWithIcon);

/***/ }),

/***/ 51707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97565);
/* harmony import */ var _Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);






var Checkbox = function Checkbox(_ref) {
  var click = _ref.click,
      isBrand = _ref.isBrand,
      handleCheck = _ref.handleCheck,
      isChecked = _ref.isChecked,
      isHidden = _ref.isHidden,
      id = _ref.id,
      customSelectStyle = _ref.customSelectStyle,
      largerCheckSize = _ref.largerCheckSize,
      checkBoxLabelStyling = _ref.checkBoxLabelStyling,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      uniqueCheckId = _ref.uniqueCheckId,
      check = _ref.check;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isCheckedState = _useState[0],
      setCheckedState = _useState[1];

  var toggleChange = function toggleChange(event) {
    if (click) {
      click(event, !isCheckedState);
    } else {
      setCheckedState(isCheckedState = !isCheckedState);
    }

    if (isBrand) {
      handleCheck(isCheckedState);
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setCheckedState(isChecked);
  }, [isChecked]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: "".concat(isHidden ? (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["checkbox-hide"]) : (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["checkbox-container"])),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
        className: " ".concat((_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["checkbox-label"]), " ").concat(customSelectStyle ? "" : (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["checkbox-label--bold"]), " ").concat(largerCheckSize ? (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["checkbox-label--large"]) : "e", "\n\t\t\t\t\t").concat((_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[checkBoxLabelStyling], "\n\t\t\t\t\t").concat(disabled ? (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disabled) : ""),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
          type: "checkbox",
          name: "check-one",
          id: id,
          checked: isCheckedState,
          value: "check-one",
          onChange: function onChange(event) {
            return toggleChange(event);
          },
          className: (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["checkbox-input"]),
          uniqueid: uniqueCheckId,
          disabled: disabled
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          className: (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["checkbox-span"]),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
            className: (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["span-text"]),
            children: check
          })
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Checkbox);

/***/ }),

/***/ 74183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28658);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64036);
/* harmony import */ var _image_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39489);
/* harmony import */ var _ConfirmModal_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69346);
/* harmony import */ var _ConfirmModal_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ConfirmModal_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);








var ConfirmModal = function ConfirmModal(_ref) {
  var show = _ref.show,
      title = _ref.title,
      text = _ref.text,
      subtext = _ref.subtext,
      cancelLabel = _ref.cancelLabel,
      confirmLabel = _ref.confirmLabel,
      handleCancel = _ref.handleCancel,
      handleConfirm = _ref.handleConfirm,
      imageUrl = _ref.imageUrl;
  var imagePath = imageUrl ? imageUrl : "".concat(_utils_helperServices__WEBPACK_IMPORTED_MODULE_1__/* .imagePrefix */ .Sj, "/assets/images/icon-trash-active.svg");
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Modal, {
      show: show,
      dialogClassName: "".concat((_ConfirmModal_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["confirm-modal"])),
      onHide: handleCancel,
      centered: true,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Modal.Header, {
        className: (_ConfirmModal_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["modal-header"]),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_image_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
          className: (_ConfirmModal_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["close-button"]),
          img_path: "".concat(_utils_helperServices__WEBPACK_IMPORTED_MODULE_1__/* .imagePrefix */ .Sj, "/assets/images/modal-close.svg"),
          onClick: handleCancel
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Modal.Body, {
        className: (_ConfirmModal_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["modal-body"]),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.CustomContainer, {
          className: (_ConfirmModal_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["trash-icon"]),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_image_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
            img_path: imagePath
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.CustomContainer, {
          className: (_ConfirmModal_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
          id: "".concat(title, "-heading"),
          children: title
        }), subtext && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.CustomContainer, {
          className: (_ConfirmModal_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["sub-content"]),
          dangerouslySetInnerHTML: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_1__/* .createMarkup */ .KU)(subtext)
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.CustomContainer, {
          className: (_ConfirmModal_module_scss__WEBPACK_IMPORTED_MODULE_4___default().content),
          dangerouslySetInnerHTML: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_1__/* .createMarkup */ .KU)(text),
          id: "".concat(title, "-desc")
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Modal.Footer, {
        className: (_ConfirmModal_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["modal-footer"]),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Button, {
          onClick: handleConfirm,
          className: "".concat((_ConfirmModal_module_scss__WEBPACK_IMPORTED_MODULE_4___default().sure)),
          id: "".concat(confirmLabel, "-btn"),
          children: confirmLabel
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Button, {
          onClick: handleCancel,
          className: "".concat((_ConfirmModal_module_scss__WEBPACK_IMPORTED_MODULE_4___default().cancel)),
          id: "".concat(cancelLabel, "-btn"),
          children: cancelLabel
        })]
      })]
    })
  });
};

ConfirmModal.defaultProps = {
  title: "Are you sure?",
  cancelLabel: "No, cancel",
  confirmLabel: "Yes, I'm sure"
};
/* harmony default export */ __webpack_exports__["Z"] = (ConfirmModal);

/***/ }),

/***/ 40521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);

var MainContainer = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "MainContainer",
  componentId: "sc-k0nny7-0"
})(["margin-top:", ";padding-top:", ";@media screen and (min-width:36rem){margin-top:", ";padding-top:", ";}@media screen and (min-width:48rem){margin-top:", ";padding-top:", ";}@media screen and (min-width:62rem){margin-top:", ";padding-top:", ";}@media screen and (min-width:75rem){margin-top:", ";margin-top:", ";}"], function (props) {
  return props.marginTop;
}, function (props) {
  return props.paddingTop;
}, function (props) {
  return props.smMarginTop;
}, function (props) {
  return props.smPaddingTop;
}, function (props) {
  return props.mdMarginTop;
}, function (props) {
  return props.mdPaddingTop;
}, function (props) {
  return props.lgMarginTop;
}, function (props) {
  return props.lgPaddingTop;
}, function (props) {
  return props.xlMarginTop;
}, function (props) {
  return props.xlPaddingTop;
});
/* harmony default export */ __webpack_exports__["Z"] = (MainContainer);

/***/ }),

/***/ 85436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var IconsComponent = function IconsComponent(_ref) {
  var type = _ref.type,
      width = _ref.width,
      height = _ref.height;
  var imageArray = {
    data: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
      width: width,
      height: height,
      viewBox: "0 0 100 100",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
        children: "Drupal/Deal details/data"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
          d: "M37.843397,8.97389202 L63.3036435,33.4156667 L77.0833333,33.4166667 C78.1879028,33.4166667 79.0833333,34.3120972 79.0833333,35.4166667 L79.0833333,62.5833333 L89.5833333,62.5833333 C91.3848875,62.5833333 92.2680154,64.7784743 90.968397,66.026108 L64.9267303,91.026108 C64.1528062,91.7690751 62.9305271,91.7690751 62.156603,91.026108 L36.6946435,66.5826667 L22.9166667,66.5833333 C21.8120972,66.5833333 20.9166667,65.6879028 20.9166667,64.5833333 L20.9166667,37.4166667 L10.4166667,37.4166667 C8.61511246,37.4166667 7.73198465,35.2215257 9.03160301,33.973892 L35.0732697,8.97389202 C35.8471938,8.23092488 37.0694729,8.23092488 37.843397,8.97389202 Z M52,37.4166667 L52,64.5833333 C52,65.6376951 51.1841222,66.5014985 50.1492623,66.5778476 L50,66.5833333 L50,66.5833333 L42.4712872,66.5833333 L63.5416667,86.8108976 L84.6120461,66.5833333 L77.0833333,66.5833333 C75.9787638,66.5833333 75.0833333,65.6879028 75.0833333,64.5833333 L75.0833333,37.4166667 L52,37.4166667 Z M36.4583333,13.1891024 L15.3879539,33.4166667 L22.9166667,33.4166667 C24.0212362,33.4166667 24.9166667,34.3120972 24.9166667,35.4166667 L24.9166667,62.5833333 L48,62.5833333 L48,35.4166667 C48,34.3120972 48.8954305,33.4166667 50,33.4166667 L57.5287128,33.4166667 L36.4583333,13.1891024 Z",
          id: "path-".concat(type)
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
        id: "Drupal/Deal-details/data",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        transform: "translate(0.000000, 0.000000)",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
          id: "Rectangle-".concat(type),
          x: "0",
          y: "0",
          width: "100",
          height: "100"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
          id: "Group",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
            id: "Rectangle-".concat(type),
            x: "0",
            y: "0",
            width: "100",
            height: "100"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
            id: "mask-".concat(type),
            fill: "white",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("use", {
              xlinkHref: "#path-".concat(type)
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("use", {
            id: "Mask-".concat(type),
            fill: "#ffffff",
            fillRule: "nonzero",
            xlinkHref: "#path-".concat(type)
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            mask: "url(#mask-".concat(type, ")"),
            fill: "#ffffff",
            id: "COLOUR-MASK-".concat(type),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                id: "Rectangle-".concat(type),
                x: "0",
                y: "0",
                width: "100",
                height: "100"
              })
            })
          })]
        })]
      })]
    }),
    phone: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
      width: width,
      height: height,
      viewBox: "0 0 100 101",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
        children: "Drupal/Deal details/phone"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
          d: "M65.8054535,60.6276927 C65.8972404,60.5584062 65.9948322,60.4971655 66.0971441,60.4446514 C68.4569063,59.233446 70.9519422,58.9757522 72.7603009,60.0763305 C74.3805296,61.0921479 88.3879671,70.4280671 89.6454694,71.3246718 C91.9703804,72.9823438 92.2642527,76.6792088 90.1740275,79.5764197 C86.1982491,85.0871505 79.6494468,91.7163167 76.0962712,91.5819038 C74.441193,91.519294 73.2681734,91.4027098 71.4797405,91.0210647 C68.901182,90.4708096 66.0533649,89.4988334 62.8792951,87.9948765 C54.5452308,84.04598 44.9004118,76.8969142 33.8112242,65.7490165 C22.7217121,54.6007924 15.6575106,44.942621 11.8104865,36.62826 C10.3451091,33.4612207 9.41258679,30.6248401 8.90202754,28.060353 C8.54841003,26.2841683 8.45285309,25.1373321 8.41676083,23.4805865 C8.34051858,19.9423782 15.2100203,13.5160179 20.8040805,9.72004845 C23.7335068,7.73222344 27.399577,8.09373532 29.0683945,10.3714929 C29.9158763,11.554137 38.9222467,25.3075811 40.1477536,27.2607332 C41.2690157,29.0496168 40.9621984,31.5425066 39.6927228,33.8970648 C39.3229118,34.5829713 38.5138986,35.9862855 37.3796426,37.9209519 L37.3261775,38.0121279 C36.7716522,38.9575966 36.1778292,39.9645316 35.584049,40.9677037 C35.530627,41.0579584 35.4781853,41.1465264 35.4268077,41.2332688 C35.867545,41.8726647 36.4235356,42.6287888 37.1056174,43.5012995 C39.3001697,46.3085441 42.2956811,49.685093 46.2226147,53.6391797 C47.3608249,54.8048166 49.1173409,56.3281777 51.3468202,58.1073257 C51.8581368,58.5153617 52.3910955,58.9342547 52.9434625,59.3625935 C54.8051965,60.8062948 56.8036017,62.2935406 58.8024782,63.7395016 C59.3248944,64.1174106 59.8193604,64.472201 60.278858,64.7995197 L65.8054535,60.6276927 Z M61.5226715,68.8723073 C60.8317656,69.3938471 59.8837563,69.4117009 59.1737031,68.9165452 C59.0353683,68.8200775 58.7793625,68.6402187 58.422434,68.3873318 C57.8293842,67.9671508 57.1690135,67.4947378 56.458036,66.980426 C54.4257357,65.5102866 52.3929641,63.9974648 50.4922665,62.5235488 C49.9256472,62.0841579 49.3781428,61.6538323 48.8518346,61.2338328 C46.5040127,59.3602462 44.6388061,57.7426218 43.3726072,56.4458093 C39.3488502,52.3943341 36.2486584,48.8997892 33.9542784,45.9648463 C32.5499771,44.1684811 31.7167851,42.937653 31.3373945,42.2752131 C30.9789504,41.6493472 30.9852484,40.878967 31.3538771,40.2590451 C31.3929737,40.1932965 31.3929737,40.1932965 31.5702478,39.8947161 C31.7426876,39.6041503 31.9348671,39.2799289 32.1418418,38.930252 C32.7331045,37.9313331 33.3243246,36.9288117 33.8758395,35.9884758 L33.9289606,35.8978865 C35.0358788,34.0098493 35.8338876,32.6256233 36.1718605,31.9987685 C36.8296817,30.7786757 36.9613638,29.7087588 36.7589972,29.3858988 C35.5741689,27.4975786 26.6056613,13.8019541 25.8294258,12.718541 C25.527546,12.3065416 24.2952427,12.1850239 23.0500862,13.0299515 C21.5933285,14.0184657 18.7917503,16.2736211 16.6377583,18.2886623 C14.0397658,20.7190621 12.4036928,22.8310393 12.415689,23.3939402 C12.4903439,26.814707 13.1044519,29.8993088 15.4407231,34.9485629 C19.0767277,42.806859 25.8680201,52.0919093 36.6471091,62.9280668 C47.4289266,73.7669672 56.7062095,80.6436027 64.5920591,84.3801235 C69.6677533,86.7851195 72.8046636,87.4545248 76.2474788,87.5852351 C76.843991,87.6073283 79.0019903,86.0278799 81.5094802,83.4896192 C83.5741256,81.3996375 85.8914537,78.6757773 86.9301392,77.2360803 C87.8021093,76.0274635 87.7090366,74.8566239 87.3232806,74.5815782 C86.1323518,73.7324406 72.1905823,64.440289 70.6582785,63.4793861 C70.2939192,63.2576769 69.2561807,63.3547401 68.0689747,63.9307398 L61.5226715,68.8723073 Z",
          id: "path-".concat(type)
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
        id: "Drupal/Deal-details/phone",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        transform: "translate(0.000000, 1.000000)",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
          id: "Rectangle-".concat(type),
          x: "0",
          y: "0",
          width: "100",
          height: "100"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
          id: "Group",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
            id: "Rectangle-".concat(type),
            x: "0",
            y: "0",
            width: "100",
            height: "100"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
            id: "mask-".concat(type),
            fill: "white",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("use", {
              xlinkHref: "#path-".concat(type)
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("use", {
            id: "Mask-".concat(type),
            fill: "#ffffff",
            fillRule: "nonzero",
            xlinkHref: "#path-".concat(type)
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            mask: "url(#mask-".concat(type, ")"),
            fill: "#ffffff",
            id: "COLOUR-MASK-".concat(type),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                id: "Rectangle-".concat(type),
                x: "0",
                y: "0",
                width: "100",
                height: "100"
              })
            })
          })]
        })]
      })]
    }),
    sms: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
      width: width,
      height: height,
      viewBox: "0 0 100 100",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
        children: "Drupal/Deal details/sms"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
          d: "M41.019494,12.6654527 C45.4576167,12.3845369 49.9121135,12.8148428 54.2044255,13.9375035 C58.1434621,14.9460861 61.8788523,16.6270117 65.2446749,18.9052951 C68.3723023,21.018447 71.0270421,23.7577546 73.041037,26.9496928 C73.4338335,27.5136598 73.9714528,28.4286352 74.5034861,29.6157478 C75.6153025,32.0965155 76.1886279,34.6748723 75.918708,37.2370189 C79.1981752,38.4868993 82.2674446,40.23429 85.019165,42.4176446 L85.019165,42.4176446 L85.1107286,42.4948748 C86.595506,43.8253299 87.8817779,45.3618719 88.9263518,47.0512811 C91.5498291,51.259345 92.279224,56.3779056 90.9337227,61.1579129 C90.414249,62.9793129 89.6322549,64.7153398 88.6139343,66.3088673 C87.5710873,67.9460383 86.3253633,69.4447401 84.9093259,70.7665752 C83.7966402,71.8093985 82.5986006,72.7558632 81.3282189,73.5962597 C81.7520831,74.5087398 82.63377,75.5729568 83.8783153,76.6632217 C84.5807265,77.2785584 85.3413422,77.8549233 86.1022321,78.3715005 C86.5553584,78.6791332 86.9007363,78.8941624 87.0820146,78.9993674 C88.6703099,79.9211351 88.2807937,82.3168026 86.4822884,82.687904 C84.1784927,83.1632663 81.8246839,83.3514205 79.4873019,83.2485858 C77.4459847,83.17178 75.4197066,82.8664246 73.43658,82.3355793 C71.7376159,81.8715377 70.0853968,81.2507834 68.5022151,80.4818045 C67.4013768,79.947885 66.3349876,79.3461392 65.3091769,78.6801167 C61.9277354,78.859241 58.5382938,78.515114 55.2658481,77.6605076 C52.1307942,76.8514253 49.1601736,75.5037317 46.4917586,73.6811141 C44.4749908,72.31291 42.7055412,70.6185192 41.2500809,68.6648633 C38.6690786,70.0766536 36.5839006,71.1445419 34.9457103,71.9165802 C33.8439648,72.4358054 33.1486793,72.7272734 32.8017586,72.8507696 C30.8278024,73.5605878 28.7939461,74.0912394 26.7193335,74.4372052 C23.804262,74.9150101 20.8415957,75.0335168 17.8976742,74.7900715 C15.9553467,74.6294523 15.3665297,72.0687413 17.0436189,71.0758633 C17.1020435,71.0412745 17.2353905,70.9580816 17.4327954,70.8277365 C17.7755807,70.6013978 18.1611686,70.3305978 18.5786805,70.016914 C19.7785586,69.1154248 20.9802865,68.0594047 22.0974497,66.8641487 C23.2555526,65.6250913 24.2483976,64.3144062 25.0355804,62.9419101 C24.3986205,62.6582009 23.8759267,62.4184374 23.2769681,62.135656 C22.4175245,61.7298939 21.6438639,61.3438416 20.953081,60.9719675 C20.0146544,60.4667775 19.2404076,59.9941267 18.6412581,59.5472661 C16.7001904,58.1161333 14.9523705,56.4399609 13.4402438,54.5591545 C11.9715874,52.7292847 10.7829578,50.6913601 9.9111791,48.5068266 C9.04107058,46.3082999 8.53705304,43.982065 8.41874715,41.6120343 C8.24822076,37.8763505 9.01715536,34.157539 10.6570959,30.7919434 C12.3386113,27.3598012 14.7027423,24.3068476 17.600136,21.8239241 C20.708862,19.1431482 24.2508123,17.0105212 28.0697022,15.5191286 C32.2114567,13.8892454 36.5853004,12.9258924 41.019494,12.6654527 Z M72.9013722,40.4300173 C69.9116973,39.6500461 66.8163849,39.3540013 63.7223629,39.553796 C60.6259201,39.7371104 57.578345,40.4117895 54.6911601,41.5536126 C52.0786199,42.5824348 49.6605084,44.0489445 47.5343254,45.8956491 C45.6326244,47.5334706 44.0847984,49.5418069 42.9901229,51.7882183 C41.9787441,53.8926201 41.508699,56.2162096 41.6226207,58.5483068 C41.7358396,60.8673516 42.4335728,63.1201226 43.643373,65.0849715 C44.9554588,67.1819308 46.690396,68.9822471 48.742622,70.3745185 C51.0335922,71.9393182 53.5790475,73.0941254 56.2709763,73.7888563 C59.2602053,74.5694925 62.3553136,74.8655177 65.438321,74.665648 L65.438321,74.665648 L65.5677083,74.6614583 L65.8854167,74.6614583 C66.2872449,74.6614583 66.6797557,74.7824981 67.0117973,75.0088039 C68.043183,75.7117536 69.1247481,76.3380928 70.2488121,76.8832774 C71.6103504,77.5445999 73.0303395,78.0781032 74.4806719,78.4742623 C76.1652472,78.9251683 77.8950532,79.1858461 79.650372,79.2519313 C80.0339092,79.2687987 80.4175627,79.2766332 80.8010162,79.2756692 C78.558719,77.2091694 77.1578521,75.0689585 77.0490817,72.7553825 C77.0141325,72.0120051 77.3948227,71.3106975 78.0372328,70.9350103 C79.5271089,70.0637175 80.9146868,69.0282596 82.1769167,67.845287 C83.3493134,66.7508799 84.3785858,65.512586 85.2418017,64.1574229 C86.0525393,62.8887302 86.6741672,61.5087164 87.0852315,60.0674689 C88.1239182,56.3774126 87.5600597,52.4205112 85.5280802,49.1611852 C84.6911394,47.8076058 83.6667035,46.5795119 82.4853727,45.5134578 C79.9007172,43.4710653 77.0006179,41.8630934 73.8988754,40.7527862 C73.8196779,40.7244365 73.7433725,40.6916062 73.6701426,40.6546829 L73.6701426,40.6546829 L73.1724743,40.5096362 C73.1311662,40.4990271 73.0904623,40.4871778 73.0503952,40.4741363 Z M53.2022658,17.8099149 C49.3123793,16.792534 45.2848738,16.4034756 41.2631093,16.658017 C37.2416597,16.8942331 33.2830338,17.766133 29.5296346,19.2431816 C26.128328,20.5715017 22.9776633,22.4685334 20.2076683,24.8571958 C17.7187795,26.9900615 15.6912545,29.6083343 14.2510445,32.5479375 C12.9059666,35.3084049 12.2745592,38.3620914 12.4141788,41.4211073 C12.5102905,43.346223 12.9211691,45.2425858 13.6283801,47.0295373 C14.351194,48.8407713 15.3391052,50.5345608 16.5587081,52.0541241 C17.8536772,53.6648254 19.3515295,55.1012771 21.0237728,56.334245 C21.4496899,56.6518782 22.0686672,57.0297423 22.8491409,57.4499004 C23.4717461,57.7850719 24.1844602,58.1407122 24.9846963,58.5185212 C26.0305144,59.0122746 26.8452434,59.3741919 28.5580249,60.1190527 C29.5655631,60.5572147 30.0310049,61.7260825 29.6004459,62.7368932 C28.5399889,65.2264964 26.9661069,67.5130656 25.0197298,69.5954998 C24.6384316,70.0034519 24.2494848,70.3965376 23.8551068,70.774645 C24.5952198,70.7057185 25.332957,70.6110738 26.0668459,70.4907854 C27.8991473,70.1852209 29.7002164,69.7153056 31.4542221,69.0845905 C31.4903755,69.0717196 31.6075911,69.026098 31.8131243,68.9399373 C32.1828615,68.7849412 32.6561829,68.5736318 33.2404877,68.2982635 C34.7743309,67.5754014 36.7433208,66.5681378 39.1974391,65.2279331 C38.2724542,63.1909167 37.7371256,60.9912774 37.627382,58.7434159 C37.4809752,55.7463143 38.0850695,52.7600747 39.3895951,50.0457827 C40.7271645,47.3008405 42.6103165,44.8574119 44.9176695,42.8702496 C47.3806207,40.7310167 50.1901146,39.0271458 53.2228038,37.8328706 C56.5017449,36.5361133 59.9660824,35.7691703 63.4752677,35.5614497 C66.3150608,35.3780453 69.1637917,35.5636675 71.9795545,36.1195472 C72.0061108,34.5542468 71.5891868,32.8936051 70.8533105,31.2516627 C70.6007525,30.6881366 70.3302343,30.1728398 70.0617993,29.7199271 C69.9069455,29.4586525 69.793405,29.2847318 69.7416221,29.2114479 L69.7416221,29.2114479 L69.6815411,29.1213391 C67.9601373,26.3816806 65.6863324,24.0311022 63.0039078,22.2187465 C60.0178649,20.197532 56.7053491,18.7068999 53.2022658,17.8099149 Z",
          id: "path-".concat(type)
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
        id: "Drupal/Deal-details/sms",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
          id: "Rectangle-".concat(type),
          x: "0",
          y: "0",
          width: "100",
          height: "100"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
          id: "Group",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
            id: "mask-".concat(type),
            fill: "white",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("use", {
              xlinkHref: "#path-".concat(type)
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("use", {
            id: "Mask-".concat(type),
            fill: "#ffffff",
            fillRule: "nonzero",
            xlinkHref: "#path-".concat(type)
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            mask: "url(#mask-".concat(type, ")"),
            fill: "#ffffff",
            id: "COLOUR-MASK-".concat(type),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                id: "Rectangle-".concat(type),
                x: "0",
                y: "0",
                width: "100",
                height: "100"
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
            id: "Rectangle-".concat(type),
            mask: "url(#mask-".concat(type, ")"),
            x: "0",
            y: "0",
            width: "100",
            height: "100"
          })]
        })]
      })]
    }),
    combo: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
      width: width,
      height: height,
      viewBox: "0 0 100 100",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
        children: "Drupal/Deal details/combo"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
          d: "M24.9173529,10.3714929 C25.3278519,10.9443362 27.6525823,14.4665297 30.0800926,18.1684538 L30.5507303,18.8864557 C32.9839627,22.6000428 35.4031071,26.3146751 35.996712,27.2607332 C37.117974,29.0496168 36.8111568,31.5425066 35.5416812,33.8970648 C35.1718701,34.5829713 34.3628569,35.9862855 33.2286009,37.9209519 L33.1751358,38.0121279 C32.6206105,38.9575966 32.0267876,39.9645316 31.4330073,40.9677037 C31.3795853,41.0579584 31.3271436,41.1465264 31.275766,41.2332688 C31.7165033,41.8726647 32.2724939,42.6287888 32.9545757,43.5012995 C35.149128,46.3085441 38.1446394,49.685093 42.071573,53.6391797 C43.2097832,54.8048166 44.9662993,56.3281777 47.1957786,58.1073257 C47.7070952,58.5153617 48.2400538,58.9342547 48.7924208,59.3625935 C50.6541549,60.8062948 52.6525601,62.2935406 54.6514366,63.7395016 C55.1738528,64.1174106 55.6683187,64.472201 56.1278163,64.7995197 L61.6544119,60.6276927 C61.7461987,60.5584062 61.8437905,60.4971655 61.9461024,60.4446514 C64.3058646,59.233446 66.8009006,58.9757522 68.6092592,60.0763305 C70.2294879,61.0921479 84.2369255,70.4280671 85.4944278,71.3246718 C87.8193387,72.9823438 88.1132111,76.6792088 86.0229858,79.5764197 C82.0472074,85.0871505 75.4984051,91.7163167 71.9452295,91.5819038 C70.2901514,91.519294 69.1171317,91.4027098 67.3286989,91.0210647 C64.7501404,90.4708096 61.9023232,89.4988334 58.7282534,87.9948765 C50.3941891,84.04598 40.7493701,76.8969142 29.6601826,65.7490165 C18.5706704,54.6007924 11.5064689,44.942621 7.65944483,36.62826 C6.19406742,33.4612207 5.26154512,30.6248401 4.75098587,28.060353 C4.39736836,26.2841683 4.30181142,25.1373321 4.26571917,23.4805865 C4.18947691,19.9423782 11.0589786,13.5160179 16.6530388,9.72004845 C19.5824652,7.73222344 23.2485353,8.09373532 24.9173529,10.3714929 Z M18.8990445,13.0299515 C17.4422869,14.0184657 14.6407086,16.2736211 12.4867166,18.2886623 C9.88872413,20.7190621 8.2526511,22.8310393 8.26464735,23.3939402 C8.33930221,26.814707 8.95341019,29.8993088 11.2896814,34.9485629 C14.925686,42.806859 21.7169784,52.0919093 32.4960674,62.9280668 C43.2778849,73.7669672 52.5551678,80.6436027 60.4410174,84.3801235 C65.5167116,86.7851195 68.6536219,87.4545248 72.0964372,87.5852351 C72.6929494,87.6073283 74.8509487,86.0278799 77.3584385,83.4896192 C79.4230839,81.3996375 81.740412,78.6757773 82.7790975,77.2360803 C83.6510676,76.0274635 83.5579949,74.8566239 83.1722389,74.5815782 C82.60513,74.177227 79.1466739,71.8583601 75.5136731,69.4362574 L74.7855507,68.9509971 L74.7855507,68.9509971 L74.0576036,68.4662038 C70.5473978,66.1293532 67.212583,63.9217065 66.5072368,63.4793861 C66.1428775,63.2576769 65.105139,63.3547401 63.917933,63.9307398 L57.3716298,68.8723073 C56.6807239,69.3938471 55.7327147,69.4117009 55.0226614,68.9165452 C54.8843267,68.8200775 54.6283209,68.6402187 54.2713923,68.3873318 C53.6783426,67.9671508 53.0179719,67.4947378 52.3069944,66.980426 C50.2746941,65.5102866 48.2419225,63.9974648 46.3412248,62.5235488 C45.7746055,62.0841579 45.2271011,61.6538323 44.7007929,61.2338328 C42.352971,59.3602462 40.4877644,57.7426218 39.2215655,56.4458093 C35.1978085,52.3943341 32.0976167,48.8997892 29.8032368,45.9648463 C28.3989354,44.1684811 27.5657434,42.937653 27.1863528,42.2752131 C26.8279087,41.6493472 26.8342068,40.878967 27.2028354,40.2590451 L27.2147164,40.2390643 L27.2147164,40.2390643 L27.2369136,40.2017191 C27.2616292,40.1601209 27.3010234,40.0937697 27.4192061,39.8947161 C27.5916459,39.6041503 27.7838254,39.2799289 27.9908001,38.930252 C28.5820629,37.9313331 29.173283,36.9288117 29.7247978,35.9884758 L29.7779189,35.8978865 C30.8848372,34.0098493 31.682846,32.6256233 32.0208188,31.9987685 C32.67864,30.7786757 32.8103221,29.7087588 32.6079555,29.3858988 C31.4231272,27.4975786 22.4546196,13.8019541 21.6783841,12.718541 C21.3765044,12.3065416 20.144201,12.1850239 18.8990445,13.0299515 Z M87.515625,4.25 C92.0719742,4.25 95.765625,7.94365081 95.765625,12.5 L95.765625,12.5 L95.765625,33.3333333 C95.765625,37.8896825 92.0719742,41.5833333 87.515625,41.5833333 L87.515625,41.5833333 L87.4322917,41.5833333 L87.4322917,50.9947917 C87.4322917,52.7485472 85.33583,53.6530531 84.0600196,52.4497382 L84.0600196,52.4497382 L72.5389523,41.5833333 L50.015625,41.5833333 C45.4592758,41.5833333 41.765625,37.8896825 41.765625,33.3333333 L41.765625,33.3333333 L41.765625,12.5 C41.765625,7.94365081 45.4592758,4.25 50.015625,4.25 L50.015625,4.25 Z M87.515625,8.25 L50.015625,8.25 C47.6684148,8.25 45.765625,10.1527898 45.765625,12.5 L45.765625,12.5 L45.765625,33.3333333 C45.765625,35.6805435 47.6684148,37.5833333 50.015625,37.5833333 L50.015625,37.5833333 L73.3333333,37.5833333 C73.8435349,37.5833333 74.3344474,37.7783191 74.7056054,38.1283868 L74.7056054,38.1283868 L83.4322917,46.3591959 L83.4322917,39.5833333 C83.4322917,38.4787638 84.3277222,37.5833333 85.4322917,37.5833333 L85.4322917,37.5833333 L87.515625,37.5833333 C89.8628352,37.5833333 91.765625,35.6805435 91.765625,33.3333333 L91.765625,33.3333333 L91.765625,12.5 C91.765625,10.1527898 89.8628352,8.25 87.515625,8.25 L87.515625,8.25 Z M81.265625,25.0833333 C82.3701945,25.0833333 83.265625,25.9787638 83.265625,27.0833333 C83.265625,28.1879028 82.3701945,29.0833333 81.265625,29.0833333 L81.265625,29.0833333 L56.265625,29.0833333 C55.1610555,29.0833333 54.265625,28.1879028 54.265625,27.0833333 C54.265625,25.9787638 55.1610555,25.0833333 56.265625,25.0833333 L56.265625,25.0833333 Z M81.265625,16.75 C82.3701945,16.75 83.265625,17.6454305 83.265625,18.75 C83.265625,19.8545695 82.3701945,20.75 81.265625,20.75 L81.265625,20.75 L56.265625,20.75 C55.1610555,20.75 54.265625,19.8545695 54.265625,18.75 C54.265625,17.6454305 55.1610555,16.75 56.265625,16.75 L56.265625,16.75 Z",
          id: "path-".concat(type)
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
        id: "Drupal/Deal-details/combo",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
          id: "Rectangle-".concat(type),
          x: "0",
          y: "0",
          width: "100",
          height: "100"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
          id: "Group",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
            id: "mask-".concat(type),
            fill: "white",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("use", {
              xlinkHref: "#path-".concat(type)
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("use", {
            id: "Mask-".concat(type),
            fill: "#ffffff",
            fillRule: "nonzero",
            xlinkHref: "#path-".concat(type)
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            mask: "url(#mask-".concat(type, ")"),
            fill: "#ffffff",
            id: "COLOUR-MASK-".concat(type),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                id: "Rectangle-".concat(type),
                x: "0",
                y: "0",
                width: "100",
                height: "100"
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
            id: "Rectangle-".concat(type),
            mask: "url(#mask-".concat(type, ")"),
            x: "0",
            y: "0",
            width: "100",
            height: "100"
          })]
        })]
      })]
    }),
    leftDisabled: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
      width: "7",
      height: "12",
      viewBox: "0 0 7 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.464145 5.44688C0.118722 5.73474 0.118723 6.26527 0.464146 6.55312L5.81947 11.0159C6.28843 11.4067 7.0004 11.0732 7.0004 10.4628L7.0004 1.53723C7.0004 0.92679 6.28842 0.593318 5.81947 0.984114L0.464145 5.44688Z",
        fill: "#A8ACB8"
      })
    }),
    left: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
      width: "7",
      height: "12",
      viewBox: "0 0 7 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.464145 5.44688C0.118722 5.73474 0.118723 6.26527 0.464146 6.55312L5.81947 11.0159C6.28843 11.4067 7.0004 11.0732 7.0004 10.4628L7.0004 1.53723C7.0004 0.92679 6.28842 0.593318 5.81947 0.984114L0.464145 5.44688Z",
        fill: "#08081B"
      })
    }),
    right: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
      width: "7",
      height: "12",
      viewBox: "0 0 7 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.53586 5.44688C6.88128 5.73474 6.88128 6.26527 6.53585 6.55312L1.18053 11.0159C0.711574 11.4067 -0.000402927 11.0732 -0.000402927 10.4628L-0.000402927 1.53723C-0.000402927 0.92679 0.711575 0.593318 1.18053 0.984114L6.53586 5.44688Z",
        fill: "#08081B"
      })
    }),
    rightDisabled: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
      width: "7",
      height: "12",
      viewBox: "0 0 7 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.53586 5.44688C6.88128 5.73474 6.88128 6.26527 6.53585 6.55312L1.18053 11.0159C0.711574 11.4067 -0.000402927 11.0732 -0.000402927 10.4628L-0.000402927 1.53723C-0.000402927 0.92679 0.711575 0.593318 1.18053 0.984114L6.53586 5.44688Z",
        fill: "#A8ACB8"
      })
    }),
    closeBlack: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "30",
      height: "30",
      viewBox: "0 0 30 30",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
        fill: "none",
        fillRule: "evenodd",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
          d: "M0 0H30V30H0z"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
          fill: "#000",
          fillRule: "nonzero",
          d: "M7.946 6.897l.084.073L15 13.939l6.97-6.97c.293-.292.767-.292 1.06 0 .267.267.29.684.073.977l-.073.084L16.061 15l6.97 6.97c.292.293.292.767 0 1.06-.267.267-.684.29-.977.073l-.084-.073L15 16.061l-6.97 6.97c-.293.292-.767.292-1.06 0-.267-.267-.29-.684-.073-.977l.073-.084L13.939 15l-6.97-6.97c-.292-.293-.292-.767 0-1.06.267-.267.684-.29.977-.073z"
        })]
      })
    }),
    mobileLeftDisable: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      transform: "translate(0, 4)",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
        width: "32",
        height: "32",
        rx: "16",
        fill: "#EBEDEF"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.2849 15.2626C9.82431 15.6464 9.82431 16.3538 10.2849 16.7376L17.4253 22.6879C18.0506 23.209 18.9999 22.7644 18.9999 21.9504V10.0497C18.9999 9.2358 18.0506 8.79117 17.4253 9.31223L10.2849 15.2626Z",
        fill: "#A8ACB8"
      })]
    }),
    mobileLeft: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
      width: "67",
      height: "75",
      viewBox: "0 0 68 72",
      fill: "null",
      xmlns: "http://www.w3.org/2000/svg",
      transform: "translate(0, 7)",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
        filter: "url(#filter0_d_5269_40539)",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
          x: "17",
          y: "15",
          width: "32",
          height: "32",
          rx: "18",
          fill: "white"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M26.2849 30.2626C25.8243 30.6464 25.8243 31.3538 26.2849 31.7376L33.4253 37.6879C34.0506 38.209 35 37.7644 35 36.9504V25.0497C35 24.2358 34.0506 23.7912 33.4253 24.3122L26.2849 30.2626Z",
          fill: "#08081B"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
          id: "filter0_d_5269_40539",
          x: "0",
          y: "0",
          width: "72",
          height: "72",
          filterUnits: "userSpaceOnUse",
          colorInterpolationFilters: "sRGB",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
            floodOpacity: "0",
            result: "BackgroundImageFix"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
            "in": "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
            dy: "5"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
            stdDeviation: "10"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
            type: "matrix",
            values: "0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 0 0.101961 0 0 0 0.15 0"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
            mode: "normal",
            in2: "BackgroundImageFix",
            result: "effect1_dropShadow_5269_40539"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
            mode: "normal",
            "in": "SourceGraphic",
            in2: "effect1_dropShadow_5269_40539",
            result: "shape"
          })]
        })
      })]
    }),
    mobileNext: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
      width: "67",
      height: "75",
      viewBox: "0 0 67 78",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      transform: "translate(0, 7)",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
        filter: "url(#filter0_d_5269_40539)",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
          x: "20",
          y: "15",
          width: "32",
          height: "32",
          rx: "16",
          fill: "white"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M41.7151 30.2626C42.1757 30.6464 42.1757 31.3538 41.7151 31.7376L34.5747 37.6879C33.9494 38.209 33.0001 37.7644 33.0001 36.9504V25.0497C33.0001 24.2358 33.9494 23.7912 34.5747 24.3122L41.7151 30.2626Z",
          fill: "#08081B"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
          id: "filter0_d_5269_40539",
          x: "0",
          y: "0",
          width: "72",
          height: "72",
          filterUnits: "userSpaceOnUse",
          colorInterpolationFilters: "sRGB",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
            floodOpacity: "0",
            result: "BackgroundImageFix"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
            "in": "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
            dy: "5"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
            stdDeviation: "10"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
            type: "matrix",
            values: "0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 0 0.101961 0 0 0 0.15 0"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
            mode: "normal",
            in2: "BackgroundImageFix",
            result: "effect1_dropShadow_5269_40539"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
            mode: "normal",
            "in": "SourceGraphic",
            in2: "effect1_dropShadow_5269_40539",
            result: "shape"
          })]
        })
      })]
    }),
    mobileDisableNext: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
      width: "68",
      height: "72",
      viewBox: "0 0 68 72",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      transform: "translate(0, 4)",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
        x: "20",
        y: "15",
        width: "32",
        height: "32",
        rx: "16",
        fill: "#EBEDEF"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M41.7151 30.2626C42.1757 30.6464 42.1757 31.3538 41.7151 31.7376L34.5747 37.6879C33.9494 38.209 33.0001 37.7644 33.0001 36.9504V25.0497C33.0001 24.2358 33.9494 23.7912 34.5747 24.3122L41.7151 30.2626Z",
        fill: "#A8ACB8"
      })]
    })
  };
  return imageArray[type];
};

/* harmony default export */ __webpack_exports__["Z"] = (IconsComponent);

/***/ }),

/***/ 39489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ image_image; }
});

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(77521);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/atoms/image/imageStyle.jsx
var imageStyle = [".jsx-4156302797{object-fit:contain;}"];
imageStyle.__hash = "4156302797";
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atoms/image/image.jsx







var Image = function Image(props) {
  var onClick = function onClick() {
    props.onClick && props.onClick();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      id: props.id,
      src: props.img_path,
      alt: props.img_alt,
      style: {
        width: props.img_width,
        height: props.img_height
      },
      onClick: onClick,
      className: "jsx-".concat(imageStyle.__hash) + " " + (props.className || "")
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((style_default()), {
      id: imageStyle.__hash,
      children: imageStyle
    })]
  });
};

/* harmony default export */ var image_image = (Image);
Image.defaultProps = {
  img_alt: "",
  className: "image"
};

/***/ }),

/***/ 52932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _SnackBar_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59544);
/* harmony import */ var _SnackBar_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_SnackBar_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var SnackBar = function SnackBar(props) {
  var env = (_config_index__WEBPACK_IMPORTED_MODULE_0___default().env);
  var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_0___default().envConfigs)[env].imagePrefix;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: props.isVisible ? "".concat((_SnackBar_module_scss__WEBPACK_IMPORTED_MODULE_2___default().snackBar), " ").concat(props.className) : "",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      className: (_SnackBar_module_scss__WEBPACK_IMPORTED_MODULE_2___default().snackBar__msgContainer),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
        className: "".concat((_SnackBar_module_scss__WEBPACK_IMPORTED_MODULE_2___default().snackBar__label), " ").concat(props.labelStyling),
        children: props.message
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
        className: (_SnackBar_module_scss__WEBPACK_IMPORTED_MODULE_2___default().snackBar__closeImage),
        onClick: props.closeSnackBar,
        src: "".concat(imagePrefix, "/assets/images/error-copy.svg"),
        alt: "placeholder"
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (SnackBar);

/***/ }),

/***/ 7971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58151);
/* harmony import */ var _Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28658);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64036);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var env = (_config_index__WEBPACK_IMPORTED_MODULE_2___default().env);
var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_2___default().envConfigs)[env].imagePrefix;

var TooltipContainer = function TooltipContainer(_ref) {
  var children = _ref.children,
      text = _ref.text;
  var isMobile = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_1__/* .componentCheckSize */ .Qj)() < 576;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.OverlayTrigger, {
    trigger: ["hover", "click"],
    placement: isMobile ? "top" : "right",
    overlay: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Tooltip, {
      id: "tooltip-right",
      className: (_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_4___default().tooltipContainer),
      children: children
    }),
    children: text ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
      className: (_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_4___default().textStyle),
      children: text
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
      className: (_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_4___default().toolTipIcon),
      src: "".concat(imagePrefix, "/assets/images/toolTip-icon.svg")
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (TooltipContainer);

/***/ }),

/***/ 51969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ upgradeDropdown_UpgradeDropdown; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/helperServices.js + 3 modules
var helperServices = __webpack_require__(64036);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atoms/textHighlighter/TextHighlighter.jsx




var HighLighter = function HighLighter(_ref) {
  var str = _ref.str,
      findValue = _ref.findValue,
      customClass = _ref.customClass;
  var splitValues = str.split(" ");
  return /*#__PURE__*/_jsx("div", {
    className: customClass,
    id: str,
    children: splitValues.map(function (item, index) {
      return /*#__PURE__*/_jsxs("span", {
        className: " ".concat(styles["normalText"], " ").concat(styles[item.match(findValue) && "textHighlight"]),
        children: [item, " "]
      }, index);
    })
  });
};

/* harmony default export */ var TextHighlighter = ((/* unused pure expression or super */ null && (HighLighter)));
// EXTERNAL MODULE: ./components/atoms/upgradeDropdown/UpgradeDropdown.module.scss
var UpgradeDropdown_module = __webpack_require__(76618);
var UpgradeDropdown_module_default = /*#__PURE__*/__webpack_require__.n(UpgradeDropdown_module);
;// CONCATENATED MODULE: ./components/atoms/upgradeDropdown/UpgradeDropdown.jsx






var mWidth = 320; // 576

var UpgradeDropdown = function UpgradeDropdown(_ref) {
  var selectedValue = _ref.selectedValue,
      optionsList = _ref.optionsList,
      handleSelect = _ref.handleSelect,
      className = _ref.className,
      selectClass = _ref.selectClass,
      dropdownClass = _ref.dropdownClass,
      containerclass = _ref.containerclass,
      showIcon = _ref.showIcon;

  var _useState = (0,react.useState)(false),
      showOptionList = _useState[0],
      setShowOptionList = _useState[1];

  var isMobile = (0,helperServices/* componentCheckSize */.Qj)() < mWidth;

  var handleClickOutside = function handleClickOutside(e) {
    if (!e.target.classList.contains((UpgradeDropdown_module_default()).select__option) && !e.target.classList.contains((UpgradeDropdown_module_default()).select__text)) {
      setShowOptionList(false);
    }
  };

  var handleListDisplay = function handleListDisplay() {
    if (!isMobile) {
      setShowOptionList(function (prevState) {
        return !prevState;
      });
    }
  };

  var optionClick = function optionClick(e) {
    setShowOptionList(false);
    handleSelect(e.target.getAttribute("data-value"));
  };

  (0,react.useEffect)(function () {
    document.addEventListener("click", handleClickOutside);
    return function () {
      document.removeEventListener("click", handleClickOutside);
    };
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "".concat((UpgradeDropdown_module_default())["new-select"], " ").concat(containerclass),
    children: !isMobile ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat((UpgradeDropdown_module_default()).select, " ").concat((UpgradeDropdown_module_default()).select__class, "  ").concat(className),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "".concat((UpgradeDropdown_module_default()).select__text, "  ").concat(showOptionList ? (UpgradeDropdown_module_default())["select__text--active"] : "", " ").concat(selectClass),
        onClick: handleListDisplay,
        children: selectedValue ? selectedValue : "-Select-"
      }), showOptionList && /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: "".concat((UpgradeDropdown_module_default()).select__options, " ").concat(dropdownClass),
        children: optionsList.map(function (option, index) {
          console.log(option.label, selectedValue, option.label == selectedValue);
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: "".concat((UpgradeDropdown_module_default()).select__option, " ").concat(option.label === selectedValue ? showIcon ? (UpgradeDropdown_module_default())["select__option--active-flag"] : (UpgradeDropdown_module_default())["select__option--active"] : ""),
            "data-value": option.label,
            onClick: optionClick,
            id: option.id && option.id,
            children: option.label
          }, index);
        })
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("select", {
      className: "".concat((UpgradeDropdown_module_default())["native-select"]),
      onChange: function onChange(event) {
        return handleSelect(event.target.value);
      },
      children: optionsList && optionsList.map(function (item) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
          selected: selectedValue === item.label ? "selected" : "",
          children: item.label
        });
      })
    })
  });
};

/* harmony default export */ var upgradeDropdown_UpgradeDropdown = (UpgradeDropdown);

/***/ }),

/***/ 7918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _SearchBoxContainer_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98918);
/* harmony import */ var _SearchBoxContainer_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_SearchBoxContainer_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _atoms_image_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39489);
/* harmony import */ var _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28658);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);









var SearchBoxContainer = function SearchBoxContainer(_ref) {
  var _ref$closeRequired = _ref.closeRequired,
      closeRequired = _ref$closeRequired === void 0 ? true : _ref$closeRequired,
      className = _ref.className,
      text = _ref.text,
      handleChange = _ref.handleChange,
      handleCancel = _ref.handleCancel,
      hideNavItems = _ref.hideNavItems,
      inputStyle = _ref.inputStyle,
      handleKeyPress = _ref.handleKeyPress,
      handleSearchClick = _ref.handleSearchClick,
      handleFocus = _ref.handleFocus,
      isSearchTxt = _ref.isSearchTxt,
      isSearchComb = _ref.isSearchComb,
      focus = _ref.focus,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "" : _ref$placeholder,
      _ref$HintBlock = _ref.HintBlock,
      HintBlock = _ref$HintBlock === void 0 ? null : _ref$HintBlock,
      iconStyle = _ref.iconStyle;
  var env = (_config_index__WEBPACK_IMPORTED_MODULE_2___default().env);
  var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_2___default().envConfigs)[env].imagePrefix;
  var inputAutoFocus = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createRef();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(''),
      searchText = _useState[0],
      setSearchText = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      blur = _useState2[0],
      markAsBlurred = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    if (focus) {
      inputAutoFocus.current.focus();
    }
  }, [focus]);
  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    setSearchText(text);
  }, [text]);

  var handleOnChange = function handleOnChange(e) {
    if (isSearchTxt) {
      setSearchText(e.target.value);
    } else if (isSearchComb) {
      setSearchText(e.target.value);
      handleChange(e);
    } else {
      handleChange(e);
    }
  };

  var handleInputFocus = function handleInputFocus() {
    handleFocus && handleFocus();
    markAsBlurred(false);
  };

  var setImgPath = function setImgPath() {
    var iconPath = "".concat(imagePrefix, "/assets/images/search");

    if (iconStyle) {
      iconPath += "-".concat(iconStyle);
    } else {
      if (HintBlock) {
        iconPath += '-blue';
      } else if (hideNavItems) {
        iconPath += '-red';
      }
    }

    return iconPath += '.svg';
  };

  var resetValue = function resetValue() {
    setSearchText("");
    handleCancel();
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.CustomContainer, {
      className: "".concat((_SearchBoxContainer_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["search-box"]), " ").concat(HintBlock && searchText && !blur && (_SearchBoxContainer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().focus), " ").concat(className),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_atoms_image_image__WEBPACK_IMPORTED_MODULE_0__["default"], {
        className: (_SearchBoxContainer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().img),
        img_path: setImgPath(),
        img_alt: "icon",
        img_width: "1.125rem",
        img_height: "1.125rem",
        onClick: handleSearchClick,
        id: "search-box-img"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("input", {
        ref: inputAutoFocus,
        type: "text",
        name: searchText,
        onBlur: function onBlur() {
          return markAsBlurred(true);
        },
        className: "".concat((_SearchBoxContainer_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["search-input"]), " ").concat(inputStyle),
        onChange: handleOnChange,
        value: searchText //onChange= isSearch ?     {e => setSearchText(e.target.value)}
        ,
        onKeyPress: handleKeyPress,
        onFocus: handleInputFocus,
        id: "search-box-input",
        placeholder: placeholder
      }), searchText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_atoms_image_image__WEBPACK_IMPORTED_MODULE_0__["default"], {
        className: (_SearchBoxContainer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().img),
        img_path: "".concat(imagePrefix, "/assets/images/close-copy.svg"),
        img_alt: "icon",
        img_width: "1.125rem",
        img_height: "1.125rem",
        onClick: resetValue
      })]
    }), HintBlock && searchText && !blur && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(HintBlock, {
      addClass: (_SearchBoxContainer_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["hintBlock-box"])
    })]
  });
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    hideNavItems: state.navDetails.hideNavItems
  };
};

/* harmony default export */ __webpack_exports__["Z"] = ((0,_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.connect)(mapStateToProps)(SearchBoxContainer));

/***/ }),

/***/ 94029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58223);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64036);
/* harmony import */ var _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69152);
/* harmony import */ var _ErrorTooltip_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69418);
/* harmony import */ var _ErrorTooltip_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_ErrorTooltip_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var ErrorTooltip = function ErrorTooltip(_ref) {
  var errorMsg = _ref.errorMsg,
      buttonHandler = _ref.buttonHandler,
      buttonLabel = _ref.buttonLabel,
      type = _ref.type,
      hideDismissButton = _ref.hideDismissButton,
      className = _ref.className,
      textClass = _ref.textClass,
      dismissClass = _ref.dismissClass,
      showAnalytics = _ref.showAnalytics,
      _ref$customStyle = _ref.customStyle,
      customStyle = _ref$customStyle === void 0 ? {} : _ref$customStyle,
      _ref$setFixedTop = _ref.setFixedTop,
      setFixedTop = _ref$setFixedTop === void 0 ? false : _ref$setFixedTop;
  var env = (_config_index__WEBPACK_IMPORTED_MODULE_2___default().env);
  var winWidth = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_4__/* .componentCheckSize */ .Qj)();
  var isMobile = winWidth <= _config_constants__WEBPACK_IMPORTED_MODULE_3__/* .MOBILE_WIDTH */ .P_;
  var isTablet = winWidth <= _config_constants__WEBPACK_IMPORTED_MODULE_3__/* .TABLET_WIDE_WIDTH */ .PH;
  var specialClass = ["not_allow_place_order", "orders_service"].indexOf(type) !== -1;
  var isHideIcon = isMobile && !specialClass;
  var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_2___default().envConfigs)[env].imagePrefix;
  var imgUrl = type === "upgrade" ? "".concat(imagePrefix, "/assets/images/upgrade-info.svg") : type === "alert" ? "".concat(imagePrefix, "/assets/images/bell-icon.svg") : "".concat(imagePrefix, "/assets/images/warning-black.svg");
  var imgSize = 25;

  switch (type) {
    case "upgrade":
    case "alert":
    case "warning":
      imgSize = 30;
      break;

    case "not_allow_place_order":
      imgSize = 17.6;
      break;
  }

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (errorMsg && showAnalytics) {
      (0,_services_analyticsUtag__WEBPACK_IMPORTED_MODULE_5__/* .error */ .vU)(errorMsg);
    }
  }, []);
  customStyle = setFixedTop ? _objectSpread(_objectSpread({}, customStyle), {}, {
    position: 'fixed',
    top: '0'
  }) : customStyle;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
    className: "".concat((_ErrorTooltip_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["error-card-block"]), " ").concat((_ErrorTooltip_module_scss__WEBPACK_IMPORTED_MODULE_7___default())[type], " ").concat(className),
    style: customStyle,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
      className: "".concat((_ErrorTooltip_module_scss__WEBPACK_IMPORTED_MODULE_7___default().textContainer), " ").concat(textClass),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        className: "d-flex ".concat(specialClass && isTablet ? "align-items-flex-start" : "align-items-center"),
        children: [!isHideIcon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("img", {
          className: (_ErrorTooltip_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["error-icon"]),
          src: imgUrl,
          width: imgSize,
          height: imgSize
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
          className: (_ErrorTooltip_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["error-card-message"]),
          children: errorMsg ? errorMsg : ""
        })]
      }), !hideDismissButton && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: "".concat((_ErrorTooltip_module_scss__WEBPACK_IMPORTED_MODULE_7___default().dismiss_button), " ").concat(dismissClass),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("button", {
          onClick: buttonHandler,
          children: buttonLabel ? buttonLabel : "Dismiss"
        })
      })]
    })
  });
};

ErrorTooltip.defaultProps = {
  type: "default",
  hideDismissButton: false,
  showAnalytics: true
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorTooltip);

/***/ }),

/***/ 19899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ OtpInput; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atoms/singleOTPInput/SingleOTPInput.jsx


var _excluded = ["focus", "autoFocus"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SingleOTPInputComponent = function SingleOTPInputComponent(props) {
  function usePrevious(value) {
    var ref = (0,react.useRef)(); // Store current value in ref

    (0,react.useEffect)(function () {
      ref.current = value;
    }, [value]); // Only re-run if value changes
    // Return previous value (happens before update in useEffect above)

    return ref.current;
  }

  var focus = props.focus,
      autoFocus = props.autoFocus,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  var inputRef = (0,react.useRef)(null);
  var prevFocus = usePrevious(!!focus);
  (0,react.useLayoutEffect)(function () {
    if (inputRef.current) {
      if (focus && autoFocus) {
        inputRef.current.focus();
      }

      if (focus && autoFocus && focus !== prevFocus) {
        inputRef.current.focus();
        inputRef.current.select();
      }
    }
  }, [autoFocus, focus, prevFocus]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread({
    ref: inputRef
  }, rest));
};

/* harmony default export */ var SingleOTPInput = (SingleOTPInputComponent);
// EXTERNAL MODULE: ./components/molecules/otpInput/OtpInput.module.scss
var OtpInput_module = __webpack_require__(73722);
var OtpInput_module_default = /*#__PURE__*/__webpack_require__.n(OtpInput_module);
;// CONCATENATED MODULE: ./components/molecules/otpInput/OtpInput.jsx



var OtpInput_excluded = ["length", "isNumberInput", "autoFocus", "disabled", "onChangeOTP", "inputClassName", "inputStyle", "resendOTP", "validateOTP", "otpValues", "setOTPValues", "className"];

function OtpInput_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function OtpInput_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? OtpInput_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : OtpInput_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var OTPInput = function OTPInput(props) {
  var length = props.length,
      isNumberInput = props.isNumberInput,
      autoFocus = props.autoFocus,
      disabled = props.disabled,
      onChangeOTP = props.onChangeOTP,
      inputClassName = props.inputClassName,
      inputStyle = props.inputStyle,
      resendOTP = props.resendOTP,
      validateOTP = props.validateOTP,
      otpValues = props.otpValues,
      setOTPValues = props.setOTPValues,
      className = props.className,
      rest = (0,objectWithoutProperties/* default */.Z)(props, OtpInput_excluded);

  var _useState = (0,react.useState)(0),
      activeInput = _useState[0],
      setActiveInput = _useState[1]; // Focus `inputIndex` input


  var focusInput = (0,react.useCallback)(function (inputIndex) {
    var selectedIndex = Math.max(Math.min(length - 1, inputIndex), 0);
    setActiveInput(selectedIndex);
  }, [length]);
  var getRightValue = (0,react.useCallback)(function (str) {
    var changedValue = str;

    if (!isNumberInput) {
      return changedValue;
    }

    return !changedValue || /\d/.test(changedValue) ? changedValue : "";
  }, [isNumberInput]); // Change OTP value at focussing input

  var changeCodeAtFocus = (0,react.useCallback)(function (str) {
    var updatedOTPValues = (0,toConsumableArray/* default */.Z)(otpValues);

    updatedOTPValues[activeInput] = str[0] || "";
    setOTPValues(updatedOTPValues);
  }, [activeInput, otpValues]);
  var focusNextInput = (0,react.useCallback)(function () {
    focusInput(activeInput + 1);
  }, [activeInput, focusInput]);
  var handleOnFocus = (0,react.useCallback)(function (index) {
    return function () {
      focusInput(index);
    };
  }, [focusInput]);
  var focusPrevInput = (0,react.useCallback)(function () {
    focusInput(activeInput - 1);
  }, [activeInput, focusInput]);
  var handleOnChange = (0,react.useCallback)(function (e) {
    var val = getRightValue(e.currentTarget.value);

    if (!val) {
      e.preventDefault();
      return;
    }

    changeCodeAtFocus(val);
    focusNextInput();
  }, [changeCodeAtFocus, focusNextInput, getRightValue]); // Hanlde onBlur input

  var handleOnBlur = (0,react.useCallback)(function () {
    setActiveInput(-1);
  }, []); // Handle onKeyDown input

  var handleOnKeyDown = (0,react.useCallback)(function (e) {
    switch (e.key) {
      case "Backspace":
      case "Delete":
        {
          e.preventDefault();

          if (otpValues[activeInput]) {
            changeCodeAtFocus("");
          } else {
            focusPrevInput();
          }

          break;
        }

      case "ArrowLeft":
        {
          e.preventDefault();
          focusPrevInput();
          break;
        }

      case "ArrowRight":
        {
          e.preventDefault();
          focusNextInput();
          break;
        }

      case " ":
        {
          e.preventDefault();
          break;
        }

      default:
        break;
    }
  }, [activeInput, changeCodeAtFocus, focusNextInput, focusPrevInput, otpValues]); // Handle onPaste input

  var handleOnPaste = (0,react.useCallback)(function (e) {
    e.preventDefault();
    var pastedData = e.clipboardData.getData("text/plain").trim().slice(0, length - activeInput).split("");

    if (pastedData) {
      var nextFocusIndex = 0;

      var updatedOTPValues = (0,toConsumableArray/* default */.Z)(otpValues);

      updatedOTPValues.forEach(function (val, index) {
        if (index >= activeInput) {
          var changedValue = getRightValue(pastedData.shift() || val);

          if (changedValue) {
            updatedOTPValues[index] = changedValue;
            nextFocusIndex = index;
          }
        }
      });
      setOTPValues(updatedOTPValues);
      setActiveInput(Math.min(nextFocusIndex + 1, length - 1));
    }
  }, [activeInput, getRightValue, length, otpValues]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", OtpInput_objectSpread(OtpInput_objectSpread({}, rest), {}, {
    className: "".concat((OtpInput_module_default()).container, " ").concat(className),
    children: Array(length).fill("").map(function (_, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(SingleOTPInput, {
        focus: activeInput === index,
        value: otpValues && otpValues[index],
        autoFocus: autoFocus,
        onFocus: handleOnFocus(index),
        onChange: handleOnChange,
        onKeyDown: handleOnKeyDown,
        onBlur: handleOnBlur,
        onPaste: handleOnPaste,
        style: inputStyle,
        className: inputClassName,
        disabled: disabled
      }, "SingleInput-".concat(index));
    })
  }));
};

/* harmony default export */ var OtpInput = (OTPInput);

/***/ }),

/***/ 27575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(57023);
/* harmony import */ var _UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _atoms_checkBox_Checkbox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51707);
/* harmony import */ var _atoms_CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79549);
/* harmony import */ var _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28658);
/* harmony import */ var _otpInput_OtpInput__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19899);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64036);
/* harmony import */ var _atoms_upgradeDropdown_UpgradeDropdown__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51969);
/* harmony import */ var _Redux_actions_upgradeAction__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(58486);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99599);
/* harmony import */ var _atoms_iconsComponent_IconsComponent__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85436);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85893);

 // import Image from "../../atoms/image/image";
















var UpgradeComponent = function UpgradeComponent(_ref) {
  var displayData = _ref.displayData,
      showModal = _ref.showModal,
      toggleModal = _ref.toggleModal,
      updatedNextMsisdnSelected = _ref.updatedNextMsisdnSelected;
  var iconUrl = displayData.iconUrl,
      title = displayData.title,
      description = displayData.description,
      infoText = displayData.infoText,
      mobileNumbers = displayData.mobileNumbers,
      numbers = displayData.numbers,
      selectedNumber = displayData.selectedNumber,
      handleOptionClick = displayData.handleOptionClick,
      input = displayData.input,
      inputTitle = displayData.inputTitle,
      onChangeHandler = displayData.onChangeHandler,
      onBlurHandler = displayData.onBlurHandler,
      errorMessage = displayData.errorMessage,
      maxLength = displayData.maxLength,
      checkbox = displayData.checkbox,
      checkValue = displayData.checkValue,
      checkBoxHandler = displayData.checkBoxHandler,
      checkBoxText = displayData.checkBoxText,
      checkDatabox = displayData.checkDatabox,
      checkDataValue = displayData.checkDataValue,
      checkBoxDataHandler = displayData.checkBoxDataHandler,
      checkBoxData = displayData.checkBoxData,
      otpInput = displayData.otpInput,
      otpValue = displayData.otpValue,
      otpHandler = displayData.otpHandler,
      primaryButtonText = displayData.primaryButtonText,
      primaryButtonStyle = displayData.primaryButtonStyle,
      primaryButtonDisabled = displayData.primaryButtonDisabled,
      onClickHandlerPrimary = displayData.onClickHandlerPrimary,
      secondaryButtonText = displayData.secondaryButtonText,
      secondaryButtonStyle = displayData.secondaryButtonStyle,
      secondaryButtonDisabled = displayData.secondaryButtonDisabled,
      onClickHandlerSecondary = displayData.onClickHandlerSecondary,
      textButton = displayData.textButton,
      textButtonHandler = displayData.textButtonHandler,
      dropdown = displayData.dropdown,
      dropdownData = displayData.dropdownData,
      selectedDropdownValue = displayData.selectedDropdownValue,
      handleVal = displayData.handleVal,
      showAddnlInfo = displayData.showAddnlInfo,
      invalidOTPTries = displayData.invalidOTPTries;
  var env = (_config_index__WEBPACK_IMPORTED_MODULE_2___default().env);
  var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_2___default().envConfigs)[env].imagePrefix;
  var isMobile = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_7__/* .componentCheckSize */ .Qj)() <= 768;
  var callbackRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (inputFocus) {
    setTimeout(function () {
      if (inputFocus) {
        inputFocus.focus();
      }
    }, [300]);
  }, []);
  var primaryButtonClass = primaryButtonText && primaryButtonText.toLowerCase() == "continue" ? "upgrade-btn-continue" : primaryButtonText && primaryButtonText.toLowerCase() == "submit otp" ? "upgrade-btn-submit-otp" : "upgrade-continue";
  var modalContentClass = !isMobile && primaryButtonText && primaryButtonText.toLowerCase() == "continue" ? "upgrade-modal-continue" : !isMobile && primaryButtonText && primaryButtonText.toLowerCase() == "submit otp" ? "upgrade-modal-submit-otp" : "upgrade-modal";
  var isSubmitOTP = primaryButtonText && primaryButtonText.toLowerCase() == "submit otp" ? true : false;
  var descriptionMarginClassName = "";

  if (input || primaryButtonText && secondaryButtonText) {
    descriptionMarginClassName = (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["medium-margin-bottom"]);
  }

  if (dropdown && !infoText) {
    descriptionMarginClassName = (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["big-margin-bottom"]);
  }

  var scrollToTop = function scrollToTop() {
    // scrolling the window up when closing the modal
    if (showModal) window.scrollTo(0, 0);
  };

  var primaryButtonClick = function primaryButtonClick() {
    //updatedNextMsisdnSelected(true); keep this code, will remove or used in next pr
    scrollToTop();
    onClickHandlerPrimary();
  };

  var textButtonClick = function textButtonClick() {
    scrollToTop();
    textButtonHandler();
  };

  var toggleUpgradeModal = function toggleUpgradeModal() {
    scrollToTop();
    toggleModal();
  };

  return showModal && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_5__.Modal, {
    show: showModal,
    dialogClassName: "".concat((_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default())[modalContentClass]),
    onHide: toggleUpgradeModal,
    centered: true,
    backdrop: "static",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_5__.Modal.Header, {
      className: (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["upgrademodal-header"]),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_5__.CustomContainer, {
        onClick: toggleUpgradeModal,
        className: (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["close-button"]),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_atoms_iconsComponent_IconsComponent__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
          type: "closeBlack"
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_5__.Modal.Body, {
      className: (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["modal-body"]),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
        className: (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default().upgradeComponent),
        children: [dropdown && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
          className: (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default().dropdownContainer),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_atoms_upgradeDropdown_UpgradeDropdown__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            selectedValue: selectedDropdownValue,
            optionsList: dropdownData,
            handleSelect: handleVal
          })
        }), showAddnlInfo && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
          className: (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default().addnlInfo),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("img", {
            src: "".concat(imagePrefix, "/assets/images/warning-white.svg"),
            width: 20,
            height: 20
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
            children: _config_labels__WEBPACK_IMPORTED_MODULE_10__/* ["default"].upgrade.lbl_addnl_info */ .Z.upgrade.lbl_addnl_info
          })]
        }), iconUrl && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("img", {
          src: "".concat(iconUrl),
          className: (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default().icon),
          alt: '',
          width: 80,
          height: 80
        }), title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
          className: (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default().title),
          children: title
        }), description && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
          className: "".concat((_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default().description), " ").concat(descriptionMarginClassName),
          dangerouslySetInnerHTML: {
            __html: description
          }
        }), infoText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
          className: (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default().infoText),
          children: infoText
        }), input && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
          className: (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default().inputContainer),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
            className: (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default().inputTitle),
            children: inputTitle
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("input", {
            type: "text",
            ref: callbackRef,
            placeholder: "Enter your cellphone number",
            className: "".concat((_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["input-box"]), " ").concat(errorMessage ? (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default().invalid) : ""),
            onChange: onChangeHandler,
            onBlur: onBlurHandler,
            maxLength: maxLength
          }), errorMessage && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
            className: (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["invalid-feedback"]),
            children: errorMessage
          }), checkbox && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
            className: (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default().checkboxContainer),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_atoms_checkBox_Checkbox__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              isChecked: !!checkValue,
              id: "checkbox1",
              click: checkBoxHandler
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
              className: (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default().checkboxText),
              children: [" ", checkBoxText]
            })]
          })]
        }), checkDatabox && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
          className: (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default().checkboxContainer),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_atoms_checkBox_Checkbox__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            isChecked: !!checkDataValue,
            id: "checkbox2",
            click: checkBoxDataHandler
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
            className: (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default().checkboxText),
            children: [" ", checkBoxData]
          })]
        }), otpInput && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_otpInput_OtpInput__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          autoFocus: true,
          isNumberInput: true,
          length: 4,
          className: (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default().otpContainer),
          inputClassName: (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default().otpInput) // onChangeOTP={otpHandler}
          ,
          otpValues: otpValue,
          setOTPValues: otpHandler
        }), mobileNumbers && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_5__.Form, {
          className: "".concat((_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["select-number-form"])),
          children: function () {
            switch (true) {
              case numbers.length > 4:
                var multipleNum = [];
                {
                  numbers.map(function (item, index) {
                    return multipleNum.push({
                      id: index,
                      label: item
                    });
                  });
                }
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_5__.Form.Group, {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_atoms_upgradeDropdown_UpgradeDropdown__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    selectedValue: selectedNumber,
                    optionsList: multipleNum,
                    handleSelect: handleOptionClick
                  })
                });

              case numbers.length === 2 || numbers.length === 3:
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_5__.Row, {
                  className: "justify-content-center mt-3",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("ul", {
                    children: numbers.map(function (item, index) {
                      var _jsx2;

                      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("li", (_jsx2 = {
                        className: "num-3"
                      }, (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_jsx2, "className", "".concat((_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default().singleNumber), " ").concat(selectedNumber === item && (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default().selctedNumber))), (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_jsx2, "onClick", function onClick() {
                        return handleOptionClick(item);
                      }), (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_jsx2, "children", item), _jsx2), index);
                    })
                  })
                });

              case numbers.length === 4:
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_5__.Row, {
                  className: "mt-3 justify-content-center",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("ul", {
                    className: (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["wrap-numbers"]),
                    children: numbers.map(function (item, index) {
                      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("li", {
                        className: "".concat((_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["num-4"]), " ").concat((_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default().singleNumber), " ").concat(selectedNumber === item && (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default().selctedNumber)),
                        onClick: function onClick() {
                          return handleOptionClick(item);
                        },
                        children: item
                      }, index);
                    })
                  })
                });

              default:
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_5__.Row, {
                  className: "justify-content-center mt-3",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("ul", {
                    children: numbers.map(function (item, index) {
                      var _jsx3;

                      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("li", (_jsx3 = {
                        className: "num-3"
                      }, (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_jsx3, "className", "".concat((_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default().singleNumber), " ").concat(selectedNumber === item && (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default().selctedNumber))), (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_jsx3, "onClick", function onClick() {
                        return handleOptionClick(item);
                      }), (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_jsx3, "children", item), _jsx3), index);
                    })
                  })
                });
            }
          }()
        }), textButton && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_atoms_CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_4__["default"], {
          handleClick: textButtonClick,
          variant: "flat teal51",
          className: (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["re-send-otp-btn"]),
          children: textButton
        }), primaryButtonText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
          className: isSubmitOTP ? (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default().buttonContainerOTP) : (_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default().buttonContainer),
          children: [primaryButtonText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_atoms_CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_4__["default"], {
            variant: primaryButtonStyle,
            className: "".concat((_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default())[primaryButtonClass], " button-red button-large"),
            handleClick: primaryButtonClick,
            disabled: !!primaryButtonDisabled,
            children: primaryButtonText
          }), secondaryButtonText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_atoms_CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_4__["default"], {
            variant: secondaryButtonStyle,
            className: "".concat((_UpgradeModal_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["upgrade-continue"]), " button-outline button-large"),
            handleClick: onClickHandlerSecondary,
            disabled: secondaryButtonDisabled,
            children: secondaryButtonText
          })]
        })]
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = ((0,_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_5__.connect)(null, {
  updatedNextMsisdnSelected: _Redux_actions_upgradeAction__WEBPACK_IMPORTED_MODULE_9__/* .updatedNextMsisdnSelected */ .Op
})(UpgradeComponent));

/***/ }),

/***/ 93957:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var colors = {
  Black100: '#000000',
  Black40: '#282828',

  /*not available in style guide*/
  White0: '#ffffff',
  Grey02: '#f9f9f9',
  Grey04: '#f4f4f4',
  Grey08: '#ebebeb',
  Grey14: '#dbdbdb',
  Grey20: '#cccccc',
  Grey40: '#999999',
  Grey60: '#666666',
  Grey70: '#4a4d4e',
  Grey80: '#333333',
  Grey84: '#2a2a2a',
  Red70: '#e60000',
  Red75: '#bd0000',
  Red80: '#990000',
  Red67: '#ff0000',
  Teal51: '#00b0ca',
  Teal65: '#007c92',
  Teal75: '#005765',
  Purple72: '#5e2750',
  Purple53: '#9c2aa0',
  Yellow50: '#eb9700',
  Yellow40: '#fecb00',
  Limegreen55: '#a8b400',
  Green74: '#428600',
  Black23: '#282828',
  Purple100: '#9C2AA0'
};
/* harmony default export */ __webpack_exports__["Z"] = (colors);

/***/ }),

/***/ 58223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BQ": function() { return /* binding */ StockStatus; },
/* harmony export */   "CB": function() { return /* binding */ VODAPAY_RESULT_CODES; },
/* harmony export */   "CS": function() { return /* binding */ MAX_DATA; },
/* harmony export */   "Dz": function() { return /* binding */ STREET_ADDR; },
/* harmony export */   "EL": function() { return /* binding */ CREDIT_VETTING_STATUS; },
/* harmony export */   "ER": function() { return /* binding */ OCCUPATION_TYPE_FKEY; },
/* harmony export */   "FW": function() { return /* binding */ MIN_MINUTES; },
/* harmony export */   "GS": function() { return /* binding */ StockNotifications; },
/* harmony export */   "Kt": function() { return /* binding */ MIN_DATA; },
/* harmony export */   "Kz": function() { return /* binding */ ACCOUNT_TYPE_LKEY; },
/* harmony export */   "MR": function() { return /* binding */ MR; },
/* harmony export */   "NO": function() { return /* binding */ BANK_NAME; },
/* harmony export */   "Or": function() { return /* binding */ CITY; },
/* harmony export */   "PH": function() { return /* binding */ TABLET_WIDE_WIDTH; },
/* harmony export */   "P_": function() { return /* binding */ MOBILE_WIDTH; },
/* harmony export */   "Q0": function() { return /* binding */ EMP_CATEGORY_LKEY; },
/* harmony export */   "Q5": function() { return /* binding */ ACCOUNT_TYPE; },
/* harmony export */   "QO": function() { return /* binding */ MISS; },
/* harmony export */   "QP": function() { return /* binding */ SUBURB; },
/* harmony export */   "RR": function() { return /* binding */ OCCUPATIONS_FKEY; },
/* harmony export */   "RU": function() { return /* binding */ FILTER_HEADERS; },
/* harmony export */   "Sw": function() { return /* binding */ DEBIT_DATE_FKEY; },
/* harmony export */   "Tu": function() { return /* binding */ EMP_CATEGORY_FKEY; },
/* harmony export */   "UT": function() { return /* binding */ MAX_MINUTES; },
/* harmony export */   "UV": function() { return /* binding */ MALE; },
/* harmony export */   "V8": function() { return /* binding */ TOWN; },
/* harmony export */   "Vr": function() { return /* binding */ MAX_AIRTIME; },
/* harmony export */   "W1": function() { return /* binding */ FEMALE; },
/* harmony export */   "Wh": function() { return /* binding */ NumberTransferTypes; },
/* harmony export */   "X_": function() { return /* binding */ MAX_ONCE_OF; },
/* harmony export */   "YD": function() { return /* binding */ DoubleDealItems; },
/* harmony export */   "YY": function() { return /* binding */ BUILDING_ADDR; },
/* harmony export */   "Yw": function() { return /* binding */ OCCUPATIONS_LKEY; },
/* harmony export */   "Zy": function() { return /* binding */ SPP; },
/* harmony export */   "_V": function() { return /* binding */ MAX_MONTHLY_RECURRING; },
/* harmony export */   "_d": function() { return /* binding */ FPP; },
/* harmony export */   "aB": function() { return /* binding */ OCCUPATION_TYPE_LKEY; },
/* harmony export */   "aL": function() { return /* binding */ BUSINESS; },
/* harmony export */   "as": function() { return /* binding */ P50_CUST; },
/* harmony export */   "cl": function() { return /* binding */ SA_COUNTRY; },
/* harmony export */   "d4": function() { return /* binding */ COLOR_LABEL; },
/* harmony export */   "e9": function() { return /* binding */ CHECKOUT_CONFIG; },
/* harmony export */   "el": function() { return /* binding */ SmartphonesLabel; },
/* harmony export */   "ew": function() { return /* binding */ PROVINCE; },
/* harmony export */   "h7": function() { return /* binding */ DeviceTypes; },
/* harmony export */   "hJ": function() { return /* binding */ MIN_AIRTIME; },
/* harmony export */   "iI": function() { return /* binding */ UNIT; },
/* harmony export */   "j_": function() { return /* binding */ NotificationTypes; },
/* harmony export */   "ln": function() { return /* binding */ ROUTE; },
/* harmony export */   "mh": function() { return /* binding */ SALARY_DAY_FKEY; },
/* harmony export */   "nB": function() { return /* binding */ POST_BOX; },
/* harmony export */   "oP": function() { return /* binding */ SALARY_DAY_LKEY; },
/* harmony export */   "rm": function() { return /* binding */ ACCOUNT_TYPE_FKEY; },
/* harmony export */   "sr": function() { return /* binding */ STREET_NO; },
/* harmony export */   "tV": function() { return /* binding */ MRS; },
/* harmony export */   "tb": function() { return /* binding */ POST_STREET; },
/* harmony export */   "u3": function() { return /* binding */ MINOR_SUBURB; },
/* harmony export */   "uQ": function() { return /* binding */ StockMode; },
/* harmony export */   "uU": function() { return /* binding */ TABLET_WIDTH; },
/* harmony export */   "ur": function() { return /* binding */ BACK_ORDER_DEAL_AVAILABILITY_STATUS; },
/* harmony export */   "wR": function() { return /* binding */ CONSENT_CHECK; },
/* harmony export */   "x5": function() { return /* binding */ SID; },
/* harmony export */   "xO": function() { return /* binding */ LEAD_BUCKETS; },
/* harmony export */   "y7": function() { return /* binding */ AGREE_CHECK; },
/* harmony export */   "yV": function() { return /* binding */ USE_DRUPAL_DATA; },
/* harmony export */   "yZ": function() { return /* binding */ ScreenSizeTypes; }
/* harmony export */ });
/* unused harmony exports MIN_PRICE, MAX_PRICE, DEBIT_DATE_LKEY, UNLIMITED */
var MIN_PRICE = 0;
var MAX_PRICE = 4000;
var MIN_DATA = 0;
var MAX_DATA = 400;
var MIN_MINUTES = 0;
var MAX_MINUTES = 1500; //Unlimited

var MIN_AIRTIME = 0;
var MAX_AIRTIME = 810; //Unlimited

var MAX_MONTHLY_RECURRING = 4000; //CheckoutCreditCheck

var EMP_CATEGORY_FKEY = "employmentType";
var EMP_CATEGORY_LKEY = "employmentCode";
var OCCUPATION_TYPE_FKEY = "occupationType";
var OCCUPATION_TYPE_LKEY = "occupationCode";
var OCCUPATIONS_FKEY = "description";
var OCCUPATIONS_LKEY = "id";
var SALARY_DAY_FKEY = "name";
var SALARY_DAY_LKEY = "value";
var ACCOUNT_TYPE_FKEY = "name";
var ACCOUNT_TYPE_LKEY = "value";
var ACCOUNT_TYPE = "accountType";
var DEBIT_DATE_FKEY = "name";
var DEBIT_DATE_LKEY = "value";
var BANK_NAME = "bankName";
var MALE = "Male";
var FEMALE = "Female";
var MR = "Mr";
var MRS = "Mrs";
var MISS = "Miss";
var UNIT = "unit";
var BUSINESS = "building";
var STREET_NO = "street_number";
var ROUTE = "route";
var SUBURB = "suburb";
var MINOR_SUBURB = "minor_region";
var PROVINCE = "province";
var POST_STREET = "post_street";
var POST_BOX = "post_box";
var TOWN = "town";
var CITY = "city";
var SID = "SID";
var SPP = "SPP";
var FPP = "FPP";
var SA_COUNTRY = "SOUTH AFRICA-ZA";
var STREET_ADDR = "Street Address";
var BUILDING_ADDR = "Building Address";
var CONSENT_CHECK = "consentCheck0";
var AGREE_CHECK = "consentCheck1";
var P50_CUST = "P0050";
var MAX_ONCE_OF = 50000;
var UNLIMITED = 100000;
var MOBILE_WIDTH = 576;
var TABLET_WIDTH = 992;
var TABLET_WIDE_WIDTH = 1024;
var USE_DRUPAL_DATA = true;
var FILTER_HEADERS = {
  FILTER_DEALS: "Filter deals",
  FILTERS: "Filters",
  PLAN_TYPE: "I’m looking for...",
  BUDGET: "Budget",
  CONTRACT_TYPE: "Contract options",
  DATA_VOICE: "Data & voice minutes",
  MORE_FILTERS: "More filters",
  SORT_BY: "Sort by",
  RESET_ALL: "Reset all",
  PROMOTIONS: "Promotions",
  ACCESSORIES_AND_VOUCHERS: "Accessories & vouchers",
  RESET: "Reset"
};
var BACK_ORDER_DEAL_AVAILABILITY_STATUS = 411;
var CHECKOUT_CONFIG = {
  normalStepsTracker: [{
    stepNo: 1,
    title: "Delivery",
    heading: "Delivery details",
    id: "delivery"
  }, {
    stepNo: 2,
    title: "Review order",
    heading: "Review order",
    id: "review"
  }, {
    stepNo: 3,
    title: "Payment",
    heading: "Payment",
    id: "payment"
  }, {
    stepNo: 4,
    title: "Order confirmation",
    heading: "Confirmation",
    id: "orderConfirmation"
  }],
  newLineStepsTracker: [{
    stepNo: 1,
    title: "Authentication",
    heading: "Authentication",
    id: "authentication"
  }, {
    stepNo: 2,
    title: "Credit check",
    heading: "Credit check",
    id: "creditCheck"
  }, {
    stepNo: 3,
    title: "Delivery",
    heading: "Delivery details",
    id: "delivery"
  }, {
    stepNo: 4,
    title: "Review & submit",
    heading: "Review & submit",
    id: "review"
  }, {
    stepNo: 5,
    title: "Confirmation",
    heading: "Confirmation",
    id: "orderConfirmation"
  }],
  newLineStepsTrackerWithPayment: [{
    stepNo: 1,
    title: "Authentication",
    heading: "Authentication",
    id: "authentication"
  }, {
    stepNo: 2,
    title: "Credit check",
    heading: "Credit check",
    id: "creditCheck"
  }, {
    stepNo: 3,
    title: "Delivery",
    heading: "Delivery details",
    id: "delivery"
  }, {
    stepNo: 4,
    title: "Review order",
    heading: "Review order",
    id: "review"
  }, {
    stepNo: 5,
    title: "Submit & pay",
    heading: "Submit & pay",
    id: "payment"
  }, {
    stepNo: 6,
    title: "Confirmation",
    heading: "Confirmation",
    id: "orderConfirmation"
  }],
  newLineStepsTrackerWithNumberTransfer: [{
    stepNo: 1,
    title: "Authentication",
    heading: "Authentication",
    id: "authentication"
  }, {
    stepNo: 2,
    title: "Credit check",
    heading: "Credit check",
    id: "creditCheck"
  }, {
    stepNo: 3,
    title: "Number transfer",
    heading: "Number transfer",
    id: "numberTransfer"
  }, {
    stepNo: 4,
    title: "Delivery",
    heading: "Delivery details",
    id: "delivery"
  }, {
    stepNo: 5,
    title: "Review & submit",
    heading: "Review & submit",
    id: "review"
  }, {
    stepNo: 6,
    title: "Confirmation",
    heading: "Confirmation",
    id: "orderConfirmation"
  }],
  newLineStepsTrackerWithNumberTransferPayment: [{
    stepNo: 1,
    title: "Authentication",
    heading: "Authentication",
    id: "authentication"
  }, {
    stepNo: 2,
    title: "Credit check",
    heading: "Credit check",
    id: "creditCheck"
  }, {
    stepNo: 3,
    title: "Number transfer",
    heading: "Number transfer",
    id: "numberTransfer"
  }, {
    stepNo: 4,
    title: "Delivery",
    heading: "Delivery details",
    id: "delivery"
  }, {
    stepNo: 5,
    title: "Review order",
    heading: "Review order",
    id: "review"
  }, {
    stepNo: 6,
    title: "Submit & pay",
    heading: "Submit & pay",
    id: "payment"
  }, {
    stepNo: 7,
    title: "Confirmation",
    heading: "Confirmation",
    id: "orderConfirmation"
  }],
  upgradeStepsTracker: [{
    stepNo: 1,
    title: "Authorisation",
    heading: "Authorisation",
    id: "authentication"
  }, {
    stepNo: 2,
    title: "Delivery",
    heading: "Delivery details",
    id: "delivery"
  }, {
    stepNo: 3,
    title: "Review & submit",
    heading: "Review & submit",
    id: "review"
  }, {
    stepNo: 4,
    title: "Confirmation",
    heading: "Confirmation",
    id: "orderConfirmation"
  }],
  upgradeStepsTrackerWithPayment: [{
    stepNo: 1,
    title: "Authorisation",
    heading: "Authorisation",
    id: "authentication"
  }, {
    stepNo: 2,
    title: "Delivery",
    heading: "Delivery details",
    id: "delivery"
  }, {
    stepNo: 3,
    title: "Review order",
    heading: "Review order",
    id: "review"
  }, {
    stepNo: 4,
    title: "Submit & pay",
    heading: "Submit & pay",
    id: "payment"
  }, {
    stepNo: 5,
    title: "Confirmation",
    heading: "Confirmation",
    id: "orderConfirmation"
  }],
  upgradeStepsTrackerWithNumberTransfer: [{
    stepNo: 1,
    title: "Authorisation",
    heading: "Authorisation",
    id: "authentication"
  }, {
    stepNo: 2,
    title: "Number transfer",
    heading: "Number transfer",
    id: "numberTransfer"
  }, {
    stepNo: 3,
    title: "Delivery",
    heading: "Delivery details",
    id: "delivery"
  }, {
    stepNo: 4,
    title: "Review & submit",
    heading: "Review & submit",
    id: "review"
  }, {
    stepNo: 5,
    title: "Confirmation",
    heading: "Confirmation",
    id: "orderConfirmation"
  }],
  upgradeStepsTrackerWithNumberTransferPayment: [{
    stepNo: 1,
    title: "Authorisation",
    heading: "Authorisation",
    id: "authentication"
  }, {
    stepNo: 2,
    title: "Number transfer",
    heading: "Number transfer",
    id: "numberTransfer"
  }, {
    stepNo: 3,
    title: "Delivery",
    heading: "Delivery details",
    id: "delivery"
  }, {
    stepNo: 4,
    title: "Review order",
    heading: "Review order",
    id: "review"
  }, {
    stepNo: 5,
    title: "Submit & pay",
    heading: "Submit & pay",
    id: "payment"
  }, {
    stepNo: 6,
    title: "Confirmation",
    heading: "Confirmation",
    id: "orderConfirmation"
  }],
  normalJourney: {
    delivery: {
      prevStep: "login",
      activeStepNo: 1
    },
    review: {
      prevStep: "delivery",
      activeStepNo: 2
    },
    payment: {
      prevStep: "review",
      activeStepNo: 3
    },
    orderConfirmation: {
      prevStep: "delivery",
      activeStepNo: 4
    }
  },
  newLineJourney: {
    authentication: {
      prevStep: "login",
      activeStepNo: 1
    },
    otp: {
      prevStep: "authentication",
      activeStepNo: 1
    },
    xds: {
      prevStep: "authentication",
      activeStepNo: 1
    },
    creditCheck: {
      prevStep: "authentication",
      activeStepNo: 2
    },
    delivery: {
      prevStep: "creditCheck",
      activeStepNo: 3
    },
    review: {
      prevStep: "delivery",
      activeStepNo: 4
    },
    orderConfirmation: {
      prevStep: "authentication",
      activeStepNo: 5
    }
  },
  newLineJourneyWithPayment: {
    authentication: {
      prevStep: "login",
      activeStepNo: 1
    },
    otp: {
      prevStep: "authentication",
      activeStepNo: 1
    },
    xds: {
      prevStep: "authentication",
      activeStepNo: 1
    },
    creditCheck: {
      prevStep: "authentication",
      activeStepNo: 2
    },
    delivery: {
      prevStep: "creditCheck",
      activeStepNo: 3
    },
    review: {
      prevStep: "delivery",
      activeStepNo: 4
    },
    payment: {
      prevStep: "review",
      activeStepNo: 5
    },
    orderConfirmation: {
      prevStep: "authentication",
      activeStepNo: 6
    }
  },
  newLineJourneyWithNumberTransfer: {
    authentication: {
      prevStep: "login",
      activeStepNo: 1
    },
    otp: {
      prevStep: "authentication",
      activeStepNo: 1
    },
    xds: {
      prevStep: "authentication",
      activeStepNo: 1
    },
    creditCheck: {
      prevStep: "authentication",
      activeStepNo: 2
    },
    numberTransfer: {
      prevStep: "creditCheck",
      activeStepNo: 3
    },
    delivery: {
      prevStep: "numberTransfer",
      activeStepNo: 4
    },
    review: {
      prevStep: "delivery",
      activeStepNo: 5
    },
    orderConfirmation: {
      prevStep: "authentication",
      activeStepNo: 6
    }
  },
  newLineJourneyWithNumberTransferPayment: {
    authentication: {
      prevStep: "login",
      activeStepNo: 1
    },
    otp: {
      prevStep: "authentication",
      activeStepNo: 1
    },
    xds: {
      prevStep: "authentication",
      activeStepNo: 1
    },
    creditCheck: {
      prevStep: "authentication",
      activeStepNo: 2
    },
    numberTransfer: {
      prevStep: "creditCheck",
      activeStepNo: 3
    },
    delivery: {
      prevStep: "numberTransfer",
      activeStepNo: 4
    },
    review: {
      prevStep: "delivery",
      activeStepNo: 5
    },
    payment: {
      prevStep: "review",
      activeStepNo: 6
    },
    orderConfirmation: {
      prevStep: "authentication",
      activeStepNo: 7
    }
  },
  upgradeJourney: {
    authentication: {
      prevStep: "login",
      activeStepNo: 1
    },
    otp: {
      prevStep: "authentication",
      activeStepNo: 1
    },
    delivery: {
      prevStep: "authentication",
      activeStepNo: 2
    },
    review: {
      prevStep: "delivery",
      activeStepNo: 3
    },
    orderConfirmation: {
      prevStep: "authentication",
      activeStepNo: 4
    }
  },
  upgradeJourneyWithPayment: {
    authentication: {
      prevStep: "login",
      activeStepNo: 1
    },
    otp: {
      prevStep: "authentication",
      activeStepNo: 1
    },
    delivery: {
      prevStep: "authentication",
      activeStepNo: 2
    },
    review: {
      prevStep: "delivery",
      activeStepNo: 3
    },
    payment: {
      prevStep: "review",
      activeStepNo: 4
    },
    orderConfirmation: {
      prevStep: "authentication",
      activeStepNo: 5
    }
  },
  upgradeJourneyWithNumberTransfer: {
    authentication: {
      prevStep: "login",
      activeStepNo: 1
    },
    otp: {
      prevStep: "authentication",
      activeStepNo: 1
    },
    numberTransfer: {
      prevStep: "authentication",
      activeStepNo: 2
    },
    delivery: {
      prevStep: "numberTransfer",
      activeStepNo: 3
    },
    review: {
      prevStep: "delivery",
      activeStepNo: 4
    },
    orderConfirmation: {
      prevStep: "authentication",
      activeStepNo: 5
    }
  },
  upgradeJourneyWithNumberTransferPayment: {
    authentication: {
      prevStep: "login",
      activeStepNo: 1
    },
    otp: {
      prevStep: "authentication",
      activeStepNo: 1
    },
    numberTransfer: {
      prevStep: "authentication",
      activeStepNo: 2
    },
    delivery: {
      prevStep: "numberTransfer",
      activeStepNo: 3
    },
    review: {
      prevStep: "delivery",
      activeStepNo: 4
    },
    payment: {
      prevStep: "review",
      activeStepNo: 5
    },
    orderConfirmation: {
      prevStep: "authentication",
      activeStepNo: 6
    }
  }
};
var NumberTransferTypes = Object.freeze({
  NEW_NUMBER: "new number",
  VOD_NUMBER: "vodacom number",
  EXTERNAL: "another network"
});
var CREDIT_VETTING_STATUS = {
  approved: "APPROVED",
  pending: "PENDING",
  referred: "REFERRED",
  offline: "OFFLINE",
  approvedWithConditions: "APPROVED WITH CONDITIONS"
};
var LEAD_BUCKETS = {
  general: "General_help",
  "default": "leads_new",
  startCheckout: "Start_checkout",
  delivery: "Delivery_details",
  orderReview: "Order_review",
  orderConfirmation: "Order_confirmation",
  payment: "Payment_details",
  addLine: {
    xds: "XDS_authentication",
    otpAuth: "verification_of_existing_customer_addon_line_otp",
    creditVetting: "credit_vetting",
    numberTransfer: "number_transfer"
  },
  upgrade: {
    otpAuth: "upgrade_authorisation"
  }
};
var VODAPAY_RESULT_CODES = {
  success: "9000",
  processing: "8000",
  failed: "4000",
  cancelled: "6001"
};
var ScreenSizeTypes = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  Desktop: 'desktop'
}; // Deal Details

var COLOR_LABEL = "Colour";
var SmartphonesLabel = 'Smartphones';
var DoubleDealItems = ['CioT Devices', 'Feature Phones', 'Fibre', 'Gaming', 'Laptop', 'Modems', 'Portable Audio', 'Printers', 'Scanners', 'Smartphones', 'Tablet', 'Wearable Tech'];
var DeviceTypes = {
  PrimaryDevice: "primary",
  SecondaryDevice: 'secondary',
  Inclusion: 'inclusion'
};
var NotificationTypes = {
  Warning: "warning",
  Error: "error",
  Success: "success"
};
var StockStatus = {
  IN_STOCK: 'IN_STOCK',
  OUT_OF_STOCK: "OUT_OF_STOCK"
};
var StockMode = {
  IN_STOCK: 'IN_STOCK',
  OUT_OF_STOCK: "OUT_OF_STOCK",
  BACK_ORDER: "BACK_ORDER"
};
var StockNotifications = {
  BackOrder: {
    text: "Delayed delivery",
    description: "The colour you have chosen is currently unavailable. Please be advised that if you select this colour, your delivery may be delayed by 2-3 weeks.",
    type: NotificationTypes.Warning
  },
  OutOfStock: {
    text: "Colour out of stock",
    description: "",
    type: NotificationTypes.Error
  }
};

/***/ }),

/***/ 78198:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var font = {
  regular: "'Roboto Regular', Arial, Helvetica, sans-serif",
  bold: "'Roboto Bold', Arial, Helvetica, sans-serif",
  medium: "'Roboto Medium', Arial, Helvetica, sans-serif",
  light: "'Roboto Light', Arial, Helvetica, sans-serif",
  black: "'Roboto Black', Arial, Helvetica, sans-serif",
  VodafoneRg: "'VodafoneRg', Arial, Helvetica, sans-serif",
  VodafoneBd: "'VodafoneBd', Arial, Helvetica, sans-serif",
  VodafoneExB: "'VodafoneExB', Arial, Helvetica, sans-serif"
};
/* harmony default export */ __webpack_exports__["Z"] = (font);

/***/ }),

/***/ 26125:
/***/ (function(module) {

// const env = "onPremDev"; // This const MUST ALWAYS be on line 1. Overwritten by k8 on startup. Refer to package.json start script
var k8sConfig =  false ? 0 : "";
var env = ""; // This const MUST ALWAYS be on line 1. Overwritten by k8 on startup. Refer to package.json start script

if (false) {} else {
  var host = window && window.location.hostname.toLowerCase();

  if (host.includes("local")) {
    env = "onPremQA";
  } else if (host.includes("webdev-stream-two")) {
    env = "onPremDev";
  } else if (host.includes("webdev-stream-four")) {
    env = "onPremDev";
  } else if (host.includes("dev")) {
    env = "onPremDev";
  } else if (host.includes("qa")) {
    env = "onPremQA";
  } else if (host.includes("stg")) {
    env = "onPremStage";
  } else {
    env = "Prod";
  }
}

var tempPort = 7700;
var proxy = "http://username:password@vfproxy.vodacom.corp:80/";
var config = {
  // TODO: Need to split config between client and server. Browser should not get config of upstream API's that are being proxied by the Node server.
  env: "".concat(env),
  envConfigs: {
    dev: {
      port: tempPort,
      server: "http://localhost:".concat(tempPort),
      serverDomain: "http://localhost:".concat(tempPort),
      cookieDomain: "localhost",
      headerfooterUrlRoot: "https://wwwdev.vodacom.co.za",
      paymentCallback: "http://localhost:".concat(tempPort, "/shopping/checkout"),
      postPaymentCallback: "http://localhost:".concat(tempPort, "/shopping/post-checkout"),
      paymentProvision: "https://wwwdev.vodacom.co.za/cloud/rest/v1/product-ordering-management/provision",
      graphql: {
        url: "https://shopqa.vodacom.co.za/graphql",
        proxy: proxy
      },
      restApi: {
        url: "https://shopqa.vodacom.co.za/rest",
        proxy: proxy,
        cloudApi: "https://wwwqa.vodacom.co.za/cloud/api"
      },
      drupalApi: {
        url: "https://wwwqa.vodacom.co.za",
        proxy: proxy,
        auth: "dnNzLmhlYWRsZXNzLmZvcm0udXNlcjpYNkxpSjJuTDUwZDlQNHlLTTVuSw=="
      },
      dxl: {
        url: "/dxl",
        proxyUrl: "https://apiqa.vodacom.co.za",
        proxy: null
      },
      DIDLoginUrl: "https://wwwdev.vodacom.co.za/cloud/digital/login",
      DIDRegisterUrl: "https://wwwdev.vodacom.co.za/cloud/digital/registration",
      imagePrefix: "/public",
      shoppingUrlPrefix: "/shopping",
      vodaComTermUrlPrefix: "/vodacom/terms",
      legacyEnv: "dev",
      helpText: "helpText",
      featureBaseUrl: "/shopping/api/features",
      vodapay: {
        clientId: '2020122325111778413994',
        userId: '216610000000549759346',
        useApplyAuthCode: true
      },
      miniAppUrl: 'https://vodminiapps.nonprod.vodacom.co.za/sales/index.html'
    },
    onPremDev: {
      port: 8080,
      server: "https://wwwdev.vodacom.co.za",
      // `http://localhost:${tempPort}`
      serverDomain: "https://vodacomcozadev.prod.acquia-sites.com",
      // Setting QA to fetch drupal QA config
      cookieDomain: ".vodacom.co.za",
      // sslKey: "ec2dev.key",
      // sslCert: "ec2dev.cert",
      headerfooterUrlRoot: "https://wwwdev.vodacom.co.za",
      paymentCallback: "https://wwwdev.vodacom.co.za/shopping/checkout",
      postPaymentCallback: "https://wwwdev.vodacom.co.za/shopping/post-checkout",
      paymentProvision: "https://apidev.vodacom.co.za/web/payment/v1/handlePayment",
      graphql: {
        url: "https://shopdev.vodacom.co.za/graphql",

        /*changing to shopdev temporarily for testing*/
        proxy: "http://vod-ms-egress-proxy:3128"
      },
      restApi: {
        url: "https://shopdev.vodacom.co.za/rest",
        proxy: "http://vod-ms-egress-proxy:3128",
        cloudApi: "https://wwwdev.vodacom.co.za/cloud/api"
      },
      drupalApi: {
        url: "https://vodacomcozaqa.prod.acquia-sites.com",
        proxy: "http://vod-ms-egress-proxy:3128",
        auth: "dnNzLmhlYWRsZXNzLmZvcm0udXNlcjpYNkxpSjJuTDUwZDlQNHlLTTVuSw=="
      },
      dxl: {
        url: "https://apidev.vodacom.co.za",
        proxy: null
      },
      DIDLoginUrl: "https://wwwdev.vodacom.co.za/cloud/digital/login",
      DIDRegisterUrl: "https://wwwdev.vodacom.co.za/cloud/digital/registration",
      imagePrefix: "/public",
      shoppingUrlPrefix: "/shopping",
      vodaComTermUrlPrefix: "/vodacom/terms",
      legacyEnv: "dev",
      helpText: "helpText",
      featureBaseUrl: "/shopping/api/features",
      vodapay: {
        clientId: '',
        userId: '',
        useApplyAuthCode: false
      },
      miniAppUrl: 'https://vodminiapps.nonprod.vodacom.co.za/sales/index.html',
      redux: {
        enableLogger: true
      }
    },
    onPremQA: {
      port: 8080,
      server: "https://wwwqa.vodacom.co.za",
      serverDomain: "https://wwwqa.vodacom.co.za",
      cookieDomain: ".vodacom.co.za",
      headerfooterUrlRoot: "https://wwwqa.vodacom.co.za",
      // sslKey: "ec2dev.key",
      // sslCert: "ec2dev.cert",
      paymentCallback: "https://wwwqa.vodacom.co.za/shopping/checkout",
      postPaymentCallback: "https://wwwqa.vodacom.co.za/shopping/post-checkout",
      paymentProvision: "https://apiqa.vodacom.co.za/web/payment/v1/handlePayment",
      graphql: {
        url: "https://shopqa.vodacom.co.za/graphql",
        proxy: "http://vod-ms-egress-proxy:3128"
      },
      restApi: {
        url: "https://shopqa.vodacom.co.za/rest",
        proxy: "http://vod-ms-egress-proxy:3128",
        cloudApi: "https://wwwqa.vodacom.co.za/cloud/api"
      },
      drupalApi: {
        url: "https://wwwqa.vodacom.co.za",
        proxy: "http://vod-ms-egress-proxy:3128",
        auth: "dnNzLmhlYWRsZXNzLmZvcm0udXNlcjpYNkxpSjJuTDUwZDlQNHlLTTVuSw=="
      },
      dxl: {
        url: "https://apiqa.vodacom.co.za",
        proxy: null
      },
      DIDLoginUrl: "https://wwwqa.vodacom.co.za/cloud/digital/login",
      DIDRegisterUrl: "https://wwwqa.vodacom.co.za/cloud/digital/registration",
      imagePrefix: "/public",
      shoppingUrlPrefix: "/shopping",
      vodaComTermUrlPrefix: "/vodacom/terms",
      legacyEnv: "qa",
      helpText: "helpText",
      featureBaseUrl: "/shopping/api/features",
      vodapay: {
        clientId: '',
        userId: '',
        useApplyAuthCode: false
      },
      miniAppUrl: 'https://vodminiapps.nonprod.vodacom.co.za/sales/index.html',
      redux: {
        enableLogger: true
      }
    },
    onPremStage: {
      port: 8080,
      server: "https://wwwstg.vodacom.co.za",
      serverDomain: "https://wwwstg.vodacom.co.za",
      cookieDomain: ".vodacom.co.za",
      headerfooterUrlRoot: "https://wwwstg.vodacom.co.za",
      // sslKey: "ec2dev.key",
      // sslCert: "ec2dev.cert",
      paymentCallback: "https://wwwstg.vodacom.co.za/shopping/checkout",
      postPaymentCallback: "https://wwwstg.vodacom.co.za/shopping/post-checkout",
      // https://apistg.vodacom.co.za/web/payment/v1/provision
      paymentProvision: "https://apistg.vodacom.co.za/web/payment/v1/handlePayment",
      graphql: {
        url: "https://shopstg.vodacom.co.za/graphql",
        proxy: "http://vod-ms-egress-proxy:3128"
      },
      restApi: {
        url: "https://shopstg.vodacom.co.za/index.php/rest",
        proxy: "http://vod-ms-egress-proxy:3128",
        cloudApi: "https://wwwstg.vodacom.co.za/cloud/api"
      },
      drupalApi: {
        url: "https://wwwstg.vodacom.co.za",
        proxy: "http://vod-ms-egress-proxy:3128",
        auth: "dnNzLmhlYWRsZXNzLmZvcm0udXNlcjpYNkxpSjJuTDUwZDlQNHlLTTVuSw=="
      },
      dxl: {
        url: "https://apistg.vodacom.co.za",
        proxy: null
      },
      DIDLoginUrl: "https://wwwstg.vodacom.co.za/cloud/digital/login",
      DIDRegisterUrl: "https://wwwstg.vodacom.co.za/cloud/digital/registration",
      imagePrefix: "/public",
      shoppingUrlPrefix: "/shopping",
      vodaComTermUrlPrefix: "/vodacom/terms",
      legacyEnv: "stg",
      helpText: "helpTextStg",
      featureBaseUrl: "/shopping/api/features",
      vodapay: {
        clientId: '',
        userId: '',
        useApplyAuthCode: false
      },
      miniAppUrl: 'https://vodminiapps.nonprod.vodacom.co.za/sales/index.html'
    },
    Prod: {
      port: 8080,
      server: "https://www.vodacom.co.za",
      serverDomain: "https://www.vodacom.co.za",
      cookieDomain: ".vodacom.co.za",
      headerfooterUrlRoot: "https://www.vodacom.co.za",
      // sslKey: "ec2dev.key",
      // sslCert: "ec2dev.cert",
      paymentCallback: "https://www.vodacom.co.za/shopping/checkout",
      postPaymentCallback: "https://www.vodacom.co.za/shopping/post-checkout",
      paymentProvision: "https://api.vodacom.co.za/web/payment/v1/handlePayment",
      graphql: {
        url: "https://shop.vodacom.co.za/graphql",
        proxy: "http://vod-ms-egress-proxy:3128"
      },
      restApi: {
        url: "https://shop.vodacom.co.za/index.php/rest",
        proxy: "http://vod-ms-egress-proxy:3128",
        cloudApi: "https://www.vodacom.co.za/cloud/api"
      },
      drupalApi: {
        url: "https://www.vodacom.co.za",
        proxy: "http://vod-ms-egress-proxy:3128",
        auth: "dnNzLmhlYWRsZXNzLmZvcm0udXNlcjpYNkxpSjJuTDUwZDlQNHlLTTVuSw=="
      },
      dxl: {
        url: "https://api.vodacom.co.za",
        proxy: null
      },
      DIDLoginUrl: "https://www.vodacom.co.za/cloud/digital/login",
      DIDRegisterUrl: "https://www.vodacom.co.za/cloud/digital/registration",
      imagePrefix: "/public",
      shoppingUrlPrefix: "/shopping",
      vodaComTermUrlPrefix: "/vodacom/terms",
      legacyEnv: "",
      helpText: "helpTextProd",
      featureBaseUrl: "/shopping/api/features",
      vodapay: {
        clientId: '',
        userId: '',
        useApplyAuthCode: false
      },
      miniAppUrl: 'https://vodminiapps.prod.vodacom.co.za/sales/index.html'
    }
  },
  dev: false,
  drupalBaseUrl: "/drupalApi",
  apiBaseUrl: "http://dummy.restapiexample.com/api/v1",
  graphqlUrl: "/graphql",
  restUrl: "/dxl",
  addressSearchBaseUrl: "/addressApi",
  featureBaseUrl: "/shopping/api/features",
  stub: {
    getProdListMetaData: "productMetaData.json",
    getMainMenuMetaData: "mainMenuMetaData.json",
    getGlobalNavMetaData: "globalNavMetaData.json"
  },
  api: {
    getProdListMetaData: "/products/2c6db31d-6773-428e-b937-9d4ccf7ac75c",
    footerUrl: "/fragment-footer",
    getHomePage: "/home-page/0d9304ac-af10-46a5-8a08-4d62340b8072",
    getMainMenuMetaData: "/cms-api/main-menu",
    getGlobalNavMetaData: "/cms-api/global-navigation",
    getPage: "/cms-api/page",
    searchQuickLinks: "/cms-api/search-quick-links-api?_format=json",
    getBundles: "/cms-api/get-bundles",
    bundleDeals: "/cms-api/deal/bundles",
    helpText: "/cms-api/help-text/926",
    helpTextStg: "/cms-api/help-text/516",
    helpTextProd: "/cms-api/help-text/516",
    internationalCalling: "/cms-api/international-calling-page",
    addressSearch: "/sedirectory_2/services/geocode/v2/address?ils_location=446 RigelAvenue,Erasmusrand&indent=true&ils_groups=address_component&ils_groups=metadata",
    preOrderFormDetails: "/cms-api/webform_rest/pre_launch_form/fields?_format=json",
    preOrderSubmit: "/cms-api/webform_rest/submit",
    preOrderCsrfToken: "/cms-api/rest/session/token",
    addressSearchDev: "/vod-ms-location-management/restricted-cluster-only-services/v2/geocode/address",
    profileSync: "/web/auth/rest/services/v4/login/ecom",
    profileUpdate: "/web/ecom/rest/cbu/V1/vodacom/login",
    dealSelectionData: "/cms-api/commerce-data-api",
    dealSelectionMinutes: "/cms-api/commerce-minutes-api",
    contactUsPage: "/cms-api/contact-us-page/contact-us/CBU",
    contactUsPagePreview: "/cms-api/contact-us-page/contact-us/CBU/0",
    contactUsSubcategories: "/cms-api/contactUs/subCategories",
    contactUsCards: "/cms-api/contactUs/cards",
    addressDev: "/web/location/v2/location/geocode/address",
    postpaidProductOrder: "/web/ecom/product-ordering/v1/productOrder",
    verifyPayment: "/web/payment/v1/verify",
    search: "/web/search/v1/search?searchText=",
    searchNoResult: "/cms-api/page/search-no-results/CBU",
    searchNoResultPreview: "/cms-api/page/search-no-results/CBU/0",
    getMethodGraphQL: "/web/ecom/v1/graphql",
    postMethodGraphQL: "/web/ecom/v1/graphql/product",
    getCovidBannerConfig: "/sites/default/files/2021-01/menuconfig.json",
    cartValidationAddOnceOffError: "/cms-api/commerce-result-code/CartValidation_AddOnceOff_Error",
    cartValidationAddDealError: "/cms-api/commerce-result-code/CartValidation_AddDeal_Error",
    formCsrfToken: "/cms-api/rest/session/token",
    userTesterFormDetails: "/cms-api/webform_rest/sign_up_form_user_tester/fields?_format=json",
    betaTesterFormDetails: "/cms-api/webform_rest/sign_up_form_beta_tester/fields?_format=json",
    dynamicFormSubmit: "/cms-api/webform_rest/submit",
    staticFormSubmit: "/web/vetting-manage/customers/leads",
    checkoutFaq: "/cms-api/page/checkout-journey/CBU",
    checkoutPath: "/cms-api/page/delivery-details/CBU",
    paidDeliveryCheckoutPath: '/cms-api/page/delivery-details-paid/CBU',
    numberTransferPage: "/cms-api/page/transfer-number-info/CBU",
    loadLookup: "/web/vetting-manage/public-services/vetting/manage/loadlookups",
    customerInformation: "/web/product-offering-qualification/vetting/customers/{reqParams}/msisdns",
    preValidation: "/web/vetting/vetting/customers/{reqParams}/validate",
    geoGraphicSiteStock: "/web/location/v1/location/findwithstock",
    getCords: "/web/location/v1/Spatial-Exchange/geocode/address",
    questionsAndAnswers: "/web/subscriber/authentication/retrieveQuestionsAndAnswers/{reqParams}",
    submitXdsAnswers: "/web/subscriber/authentication/submitXDSAnswers",
    mergeCartError: "/cms-api/commerce-result-code/merge_cart_error",
    errorResultDetails: "/cms-api/commerce-result-code",
    upgradeEligibleCheck: "/cms-api/page/upgrade-eligible-check-page/CBU",
    //upgrade
    oneTimePin: "/web/otp/vetting/{reqParams}",
    oneTimePinv2: "/web/otp/generate/onetimepins/PORT_IN/{reqParams}",
    oneTimePinEligible: "/web/otp/rest/v1/onetimepins/PORT_IN/{reqParams}",
    validatePhoneForPrepaidNumber: "/web/ecom/customer/rest/services/web/customer/msisdn/{reqParams}/details",
    portInValidation: "/web/ecom/customer/customers/customerinteraction/{reqParams}",
    getAllEligibility: "/web/product-offering-qualification/v1/all/eligible",
    getMSIDNForAuthentication: "/web/ecom/customer/{reqParams}/upgradeMsisdns",
    generateOtp: "/web/otp/vetting/generateOtp",
    getEligibilityForAlternativeNumbers: "/web/product-offering-qualification/v1/eligible/numbers/alternate",
    eligibilityForLinkedNumbersList: "/web/product-offering-qualification/v1/eligible/numbers/linked",
    upgradeResult: "/cms-api/commerce-result-code",
    UnprocessedVettingResult: "/cms-api/commerce-result-code/Unprocessed_Vetting_Result",
    DeclinedNonNXTLVL: "/cms-api/commerce-result-code/Declined_Non-NXT_LVL",
    creditCheckConsent: "/cms-api/page/credit-check-consent/CBU",
    createCustomer: "/web/ecom/customer/customers/{reqParams}/information",
    customerDetails: "/web/ecom/customer/v1/customerDetails",
    pastUsage: "/web/ecom/customer/rest/services/past-usage",
    lookupData: "/web/devices/rest/service/lookup-device-data",
    upgradeDeviceModels: "/web/devices/v1/devices/models",
    getRecommendedDeals: "/web/product-offering/deals/getAllRecommendedDeals",
    consumption: "/cloud/rest/services/web/customer/consumption",
    validateBankDetails: "/web/vetting-manage/customers/{reqParams}/accounts/validate",
    creditFilters: "/web/ecom/customer/{reqParams}/creditFilters?field=creditProfile&idType=MSISDN",
    creditVettingOutcome: "/web/sales-order-fulfillment/v1/credit/vetting",
    authenticateAlternativeNumber: "/web/otp/vetting/authenticateAlternativeNumber",
    dealDetailsUnaffordabilityError: "/cms-api/commerce-result-code/Deal_Details_Unaffordability_Error",
    upgradeLegacySwitch: "/cms-api/legacy-switch",
    headerFragment: "/fragment-header",
    footerFragment: "/fragment-footer",
    getOrderShippingStatus: "/web/ecom/ecom/order/shipping/status/{reqParams}",
    getOrderVettingStatus: "/cms-api/commerce-result-code/{reqParams}",
    getOrderStatusStatic: "/cms-api/page/order-tracking-vetting-status/CBU",
    features: "/features-check",
    getVASDeatilsForDeals: "/web/ecom/v1/getVAS",
    pendedReferredSplitMessage: "/cms-api/page/pended-referred-order-split-message/CBU",
    offlineSplitMessage: "/cms-api/page/multi-cart-unprocessed-vetting-split-text/CBU",
    storeStockCheckStatus: "/cms-api/page/store-stock-check-online-postpaid/CBU",
    contractCover: "/cms-api/page/deal-cart-page-vas-text/CBU",
    shoppingCartEmpty: "/cms-api/page/shopping-cart-empty-text/CBU",
    preOrderProductInfo: "/cms-api/page/pre-order-product-info/CBU",
    preOrderProductDetail: "/cms-api/page/pre-order-product-details-info/CBU",
    preOrderDealDetail: "/cms-api/page/pre-order-deal-details-info/CBU",
    paymentOptionsData: "/cms-api/page/payment-option-description-page/CBU",
    paymentStoredCardsData: "/web/ecom/product-ordering/v1/paymentMethods/paymentMethod",
    deleteStoredCard: "/web/ecom/product-ordering/v1/paymentMethods/paymentMethod/{reqParams}",
    getMiniAppPaymentUrl: "/web/ecom/product-ordering/v1/customerPayment/vodaPay"
  },
  pageServiceQueryData: {
    site: "CBU",
    status: "",
    preview: "/0"
  },
  paymentConfig: {
    paymentGatewayBaseUrl: "",
    paymentGatewayUrl: "",
    payServerUser: "",
    transactionStatusCallbackFormat: "",
    transactionStatusCallbackMethod: "",
    merchantReference: "",
    currency: "",
    transactionType: "",
    merchantIdentifier: "",
    customerIdentifier: "",
    encType: ""
  },
  buyOptions: [{
    label: "Buy this product once-off",
    name: "once-off"
  }, {
    label: "Get this product on a new contract",
    name: "on-contract"
  }, {
    label: "Upgrade",
    name: "upgrade"
  }],
  dealBuyOptions: [{
    label: "Get this deal on a new contract",
    name: "new-contract"
  }, {
    label: "Upgrade",
    name: "upgrade"
  }],
  order_id: "order_id",
  pay_fail_count: "pay_fail_count",
  cookie_category: {
    strictly_necessary: "C0001",
    performance: "C0002",
    functional: "C0003",
    targeted: "C0004",
    social_media: "C0005"
  },
  maxRetriesCount: 3,
  legacyAllowed: false,
  collectAtStore: true,
  miniApp: {
    paymentCallback: '/shopping/checkout',
    postPaymentCallback: '/shopping/post-checkout'
  }
};
config.EnvConfig = config.envConfigs[env];
module.exports = config;

/***/ }),

/***/ 99599:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var labels = {
  lbl_once_off_only: "Once-off only",
  lbl_add_to_compare: "Add to compare",
  lbl_added_to_compare: "Added to compare",
  lbl_preorder_now: "Pre-order now!",
  lbl_buy_now: "Buy now",
  lbl_see_details: "See details",
  lbl_your_cart: "Your cart",
  lbl_add_to_cart: "Add to cart",
  lbl_add_to_bundle: "Add this to bundle",
  lbl_about_to_purchase: "You’re about to purchase:",
  lbl_quantity: "Qty:",
  lbl_promotion: "Promotion:",
  lbl_move_to_wishlist: "Move to my wishlist",
  lbl_remove: "Remove",
  lbl_sub_total: "Sub-total:",
  lbl_total_once_off_due: "Total due now:",
  lbl_total_saving: "Total saving:",
  lbl_order_summary: "Order summary",
  lbl_delivery: "Delivery:",
  lbl_vat: "VAT (incl.):",
  lbl_reset: "Reset",
  lbl_total: "Total:",
  lbl_total_due: "Total due now:",
  lbl_total_paid: "Total paid:",
  lbl_checkout_now: "Checkout now",
  lbl_promocode_query: "Got a promo code or voucher?",
  lbl_enter_promo: "Enter promo / voucher code",
  lbl_apply_code: "Apply code",
  lbl_change_storage: "Change storage size",
  lbl_change_storage_or_color: "Change storage or color",
  lbl_change_color: "Change colour",
  lbl_view_product_details: "View product details",
  lbl_move_product_to_wishlist: "Move product to my wishlist",
  lbl_remove_from_cart: "Remove product from my cart",
  lbl_remove_deal_from_cart: "Remove deal from my cart",
  lbl_deal_remove_from_cart: "has been removed from your cart",
  lbl_why_shop_online: "WHY SHOP ONLINE?",
  lbl_free_delivery: "FREE delivery",
  lbl_paid_delivery: "Get FREE delivery ",
  lbl_free_delivery_text: "when you spend R600 or more.",
  lbl_click_collect: "This order can be collected from a Vodacom Shop ",
  lbl_click_collect_normal: "You can choose between delivery or collection options during checkout.",
  lbl_on_orders: "on orders over R600",
  lbl_orders_service_down: "We seem to be having some issues fetching your past orders. Please try again later.",
  lbl_easy_returns: "Easy returns",
  lbl_delivery_within: "within 14 days of delivery",
  lbl_all_secure: "100% secure",
  lbl_online_checkout: "online checkout & payment",
  lbl_price_type: "Price type:",
  lbl_sort_by: "Sort by",
  lbl_filter_products: "Filter products",
  lbl_filter_device: "Filter by product",
  lbl_filter_device_mobile: "Filter by product",
  lbl_more_filters: "More filters",
  lbl_recommend_for_you: "Recommended for you",
  lbl_cart_items: "itemno products have been added to your cart",
  lbl_cart_item: "1 product has been added to your cart",
  lbl_removed_from_cart: "has been removed from  your cart",
  lbl_updated_cart: "The product quantity has been updated",
  lbl_free: "Free",
  lbl_view_cart: "View my cart",
  lbl_continue_shopping: "Continue shopping",
  lbl_item_add_success: "This item has been added to your cart",
  lbl_empty_cart_msg: "You don’t have anything in your cart yet",
  lbl_in_stock: "IN_STOCK",
  lbl_out_of_stock: "OUT_OF_STOCK",
  lbl_once_off_purchase: "ONCE-OFF PURCHASE",
  lbl_monthly_purchase: "NEW CONTRACT",
  lbl_upgrade_purchase: "UPGRADE",
  lbl_app_type: "Application type:",
  lbl_contract_duration: "Contract duration:",
  lbl_add_Ons: "Add-ons:",
  lbl_deal: "Deal",
  lbl_monthly_subtotal: "Monthly sub-total:",
  lbl_onceoff_subtotal: "Once-off sub-total:",
  lbl_once_off_item_count: "Number of once-off items:",
  lbl_monthly_total: "Monthly total:",
  lbl_onceoff_total: "Total due now:",
  lbl_cart_max_item: 6,
  lbl_cart_min_product_add_qty: 1,
  lbl_international_calling_costs: "International Calling costs",
  lbl_cart_items_max_msg: "The total number of items in your cart exceeds the maximum allowed. Please reduce your cart to less than <XY> items.",
  lbl_cart_order_max_msg: "Your cart total exceeds the maximum amount allowed. Please remove items to reduce your total to <RXX> or less.",
  lbl_out_of_stock_msg: "An item in your cart is currently out of stock. Please remove it before checking out.",
  lbl_only_one_type_product: "Unfortunately, you can only check out one type of product at a time - either a monthly contract or one or more once-off purchase items. Please remove either the contract or once-off items from your cart in order to continue to checkout.",
  lbl_only_one_deal_allowed: "You can only apply for one contract at a time. Please remove 1 deal from your cart before checking out.",
  lbl_only_uniq_vas_allowed: "You have two of the same add-ons in your cart. Please remove one of them before continuing to checkout.",
  lbl_add_up_to_four: "You can only add up to 4 add-ons to your contract. Please remove any excess add-ons before continuing to checkout.",
  lbl_no_items: "Number of items:",
  lbl_another_deal: "Choose another deal",
  lbl_invalid_coupon: "The voucher code you've entered is invalid. Please try again.",
  lbl_promo_text: "PROMO CODE / VOUCHER",
  lbl_coupon_applied_successfully: "Your voucher discount has been applied to your cart.",
  lbl_magento_invalid_coupon_error: "The coupon code isn't valid. Verify the code and try again.",
  lbl_coupon_code_removed_successfully: "Your voucher discount has been removed from your cart",
  lbl_out_of_stock_description: "We expect to have this product back in stock in 2 - 3 weeks",
  lbl_out_of_stock_title: "Currently out of online stock",
  // lbl_nearest_store_stock_description: "This store near you has stock:",
  lbl_click_and_collect_msg: "Click and Collect may or may not be available, depending on what's included in your order at checkout",
  lbl_multi_onceoff_msg: "Your monthly contract payment will only be deducted via debit order once your application has been processed",
  lbl_current_user_cannot_perform_operation_on_cart: "The current user cannot perform operations on cart",
  lbl_could_not_find_cart_id: "Could not find a cart with ID",
  lbl_available_pre_order_only: "Available for pre-order only",
  lbl_available_pre_order_only_desc: "We expect this product to sell fast.  Pre-order today to make sure you don't miss out!",
  lbl_pre_order_browse_all: "Browse all",
  lbl_pre_order_online_exclusive_tag: "Online Exclusive",
  lbl_pre_order_deal_message: "Apply for this deal today and be one of the first customers to get your order delivered when this product becomes available",
  lbl_no_store_list_found: "Oops! We seem to have an issue showing store information right now. Please select the delivery option, or try again later.",
  lbl_store_reservation_business_error: "store_reservation_business_error",
  lbl_store_reservation_technical_error: "store_reservation_technical_error",
  lbl_affordability_product_filter: "We'll show you search results based on your affordability",
  BreadCrumbLabels: {
    lbl_home: "Home",
    lbl_browse_products: "Browse products",
    lbl_all_products: "All products",
    lbl_compare_products: "Compare products",
    lbl_product_details: "Product details",
    lbl_cart: "Cart",
    lbl_hidden_breadCrumb_for_mobile: "...",
    items_display_before_collapser_mbl: 1,
    items_display_after_collapser_mbl: 2,
    max_display_items_mbl: 3,
    lbl_shop: "Shop",
    lbl_browse_all_deals: "Browse all deals",
    lbl_order_details: "Order details",
    lbl_order_history: "Order History",
    lbl_deal_details: "Deal details",
    lbl_upgrade_page: "Upgrade",
    lbl_track_order: "Track my order"
  },
  productBottomFooterTabs: {
    lbl_similar_products: "Similar products",
    lbl_related_products: "Related products",
    lbl_brand_new: "More from",
    lbl_brand: "Brand",
    max_products: 6
  },
  productBottomFooterTabArr: [{
    key: "SMP",
    title: "Similar products"
  }, {
    key: "RLP",
    title: "Related products"
  }, {
    key: "BRAND",
    title: "More from"
  }],
  lbl_product_typeName_configurable: "ConfigurableProduct",
  lbl_product_typeName_simple: "SimpleProduct",
  lbl_product_type_bundle: "BundleProduct",
  lbl_discount_end_text: "Discount ends in",
  lbl_promotion_tag_link: "See our great deals",
  lbl_promotion_tag_text: "for this product",
  Session_Keys: {
    lbl_breadCrumb: "BreadCrumb",
    lbl_list_page_router_with_filters: "ListPageRouterWithFilters",
    lbl_page_visit_history: "PageVisitHistory",
    lbl_cart_summary: "dealGroupIds"
  },
  lbl_continue_with_checkout: "Continue with checkout",
  lbl_exit_checkout: {
    desktop: "Exit checkout",
    mobile: "Exit"
  },
  lbl_checkout_header: {
    title: "Secure checkout"
  },
  sortKeys: {
    lbl_most_popular: "Most popular",
    lbl_low_to_high: "Price - Low to high",
    lbl_new_to_old: "Latest to oldest",
    lbl_old_to_new: "Oldest to newest",
    lbl_high_to_low: "Price - High to low",
    lbl_recommended: "Recommended"
  },
  priceFilter: {
    monthly_lbl_low_to_high: "monthly Price - Low to high",
    monthly_lbl_high_to_low: "monthly Price - High to low"
  },
  lbl_pm: "PM",
  lbl_browse_all_prods: "Browse all products",
  lbl_all_categories: "All categories",
  lbl_deal_range: "Explore our deal range",
  lbl_filter_text: "Use the filters below to find exactly what you’re looking for",
  lbl_categories: "Categories",
  lbl_price: "Price",
  lbl_pagination_show_previous: "Show previous",
  lbl_pagination_show_more: "Show more",
  pagination_max_items_per_page: 12,
  deal_selection_pagination_max_per_page: 4,
  deal_selection_pagination_tablet_max_per_page: 3,
  order_history_max_items_per_page: 6,
  lbl_start_text: "Starting from",
  lbl_product_detail_indicator_note_postpaid: "* Please note Click & Collect may or may not be available, depending on what’s included in your order at checkout.",
  lbl_product_detail_indicator_note_prepaid: "* You’ll be able to select delivery or collection options at checkout.",
  lbl_do_an_upgrade_check: "Do an upgrade check",
  lbl_choose_upgrade_deal: "Choose upgrade deal",
  lbl_custom_dropdown_typeName: "CustomizableDropDownOption",
  lbl_custom_dropdown_prepaid_option: "once-off",
  lbl_custom_dropdown_prepaid_optionData: "Buy this product once off",
  lbl_custom_dropdown_deal_option: "contract",
  lbl_custom_dropdown_upgrade_option: "upgrade",
  lbl_custom_dropdown_upgrade_option_new_contract: "new-contract",
  lbl_payment_redirect: "Redirecting you to Vodacom Payment Services...",
  lbl_payment_failure_heading: "Something went wrong",
  lbl_payment_failure_description: "Your payment was not successful. Would you like to try again ?",
  lbl_payment_failure_note: "(Please check your card details on the next page to make sure there are no errors)",
  lbl_payment_failure_heading_error: "Payment unsuccessful",
  lbl_payment_failure_description_error_guest: "We were unable to process this transaction. Please check whether your card is valid and your account contains sufficient funds before trying again.",
  lbl_payment_failure_description_error: "We were unable to process this transaction. Please check whether your card is valid and your account contains sufficient funds. This order will be saved to your order history for 24 hours, in case you’d like to try again.",
  lbl_payment_failure_note_error: "Your item will be kept in your cart if you'd like to come back later and try again",
  lbl_payment_failure_heading_tech_error: "We've encountered a technical issue",
  lbl_payment_failure_description_tech_error: "Unfortunately we can't process your payment right now. Please try again later",
  lbl_checkout_unavailable: "Checkout is currently unavailable. Our team is aware of this issue and are working on it. Please try again later.",
  lbl_deal_selection_page_card_btn: "View deal details",
  lbl_go_to_order_page_btn: "Go to order history",
  lbl_back_to_top_btn: "Back to top",
  lbl_closed_order_type: "closed",
  lbl_order_details_header: "Order details",
  lbl_order_number: "Order number",
  lbl_order_date: "Order date",
  lbl_order_total: "Order total",
  lbl_order_status: "Order Status",
  lbl_order_placed_on: "Order placed on",
  lbl_order_type: "Order type",
  lbl_order_block_title: "Your order:",
  lbl_order_see_more_details: "See order details",
  lbl_estimated_delivery_date: "Estimated delivery date",
  lbl_estimated_delivery_date_mobile: "Est. delivery date",
  lbl_total_amount_paid: "Total amount paid",
  lbl_total_monthly_amount_paid: "Total due every month",
  lbl_amount_not_paid: "Not paid",
  lbl_delivery_address: "Delivery address",
  lbl_contact_person: "Contact person",
  lbl_courier: "Courier",
  lbl_way_bill_number: "Waybill number",
  lbl_your_purchased_items: "Your purchased items",
  lbl_log_a_return: "Log a return",
  lbl_track_this_order: "Track this order",
  lbl_complete_this_order: "Complete this order",
  lbl_retry_payment_order: "Retry payment",
  lbl_deal_selection_page: {
    lbl_heading: "Now, let’s find the perfect plan to go with your device…",
    lbl_heading_mobile: "Use the filters below to see the kind of deals you’re looking for:",
    lbl_filter_plan_type: "Plan type",
    lbl_filter_your_budget: "Your budget",
    lbl_filter_contract: "Contract type & duration",
    lbl_filter_monthly: "Data & voice minutes",
    lbl_filter_more: "+ More filters",
    lbl_more_filters: "More filters",
    lbl_plan_question: "What should your plan give you each month?",
    lbl_budget_question: "How much can you spend per month?",
    lbl_contract_question1: "Which type of contract do you prefer?",
    lbl_contract_question2: "How long should your contract be?",
    lbl_monthly_question1: "How much data do you need?",
    lbl_monthly_question2: "How many minutes do you need?",
    lbl_more_question: "More Filters",
    lbl_promotion_and_specials: "Promotions & specials",
    lbl_accessories_and_vouchers: "Accessories & vouchers",
    lbl_sort_heading: "Now, choose the deal you like the most:"
  },
  lbl_clear_button_text: "Clear",
  lbl_reset_button_text: "Reset",
  lbl_apply_button_text: "Apply",
  lbl_reset_all_filters: "Reset all filters",
  lbl_plan: "Plan",
  lbl_budget: "Budget",
  lbl_contract: "Contract",
  lbl_monthly: "Monthly",
  lbl_once_off: "Once-off",
  lbl_monthlyData: "Data",
  lbl_monthlyMinutes: "Minutes",
  lbl_more: "More",
  lbl_select: "- Select -",
  lbl_contractType: "ContractType",
  lbl_contractDuration: "ContractDuration",
  lbl_defaultPlanType: "Data & Voice",
  lbl_99999_min: "99999 min",
  lbl_unlimited: "Unlimited",
  lbl_order_history_header: "Your order history",
  lbl_track_my_order_header: "Track my order",
  lbl_all_years: "All years",
  lbl_reference_year: 2020,
  lbl_years: "Years",
  order_history_default_items_count: 6,
  lbl_view_order_details: "View order details",
  lbl_end_order_list: "That’s it! You’ve reached the end of this list.",
  lbl_show_more_orders: "Show more orders",
  lbl_show_more_deals: "+ Show more deals",
  lbl_show_more_products: "+ Show more products",
  lbl_load_more_orders: "+ Show more orders",
  lbl_order_total_colon: "Order total:",
  lbl_order_once_off_total: "Once-off total:",
  lbl_order_monthly_total: "Monthly total:",
  lbl_order_number_hash: "Order #",
  lbl_order_status_latest: "Latest order status:",
  lbl_order_reference_number: "Reference number:",
  lbl_orders_require_documents: "Documents we require:",
  lbl_past_orders: "past orders",
  lbl_zero_past_orders: "0 - 0 past orders",
  lbl_zero_items_default_text: "0 - 0 of 0 results",
  lbl_results: "Results",
  lbl_no_results_found: "No results found",
  lbl_order_history_info: "This is a list of all your previous online purchases, upgrades and contract applications",
  lbl_track_my_order_info: "Find out what your order’s current status is. You can track orders placed online or through our call centre.",
  lbl_promotions: "promotions",
  lbl_vouchers: "vouchers",
  lbl_mobile_filter_headers: {
    lbl_data_and_voice: "Data & voice",
    lbl_budget: "Set your budget",
    lbl_contract: "Select contract type & duration",
    lbl_monthly: "Select data & voice minutes"
  },
  lbl_storage: "storage",
  lbl_months: "months",
  lbl_color: "Color",
  lbl_Internal_Storage: "Internal Storage",
  lbl_internal_storage: "internal_storage",
  lbl_screen_size_pixels: "screen_size_pixels",
  lbl_apply_filter: "Apply filter",
  lbl_save_selection: "Save selection",
  lbl_top_up: "top up",
  lbl_standard_contract: "standard contract",
  errors: {
    lbl_something_went_wrong: "Something went wrong",
    lbl_technical_issue: "We’ve encountered a technical issue",
    lbl_contact_soon: "We’ll be in contact soon!",
    lbl_form_not_submitted: "Your form could not be submitted",
    lbl_try_again: "Please try again later.",
    lbl_form_not_submitted_check_error: "Your form could not be submitted. Please check for errors and try again.",
    lbl_form_not_submitted_fill_required: "Your form could not be submitted. Please fill all the required fields and try again.",
    lbl_something_went_wrong_try_again: "Something went wrong, please try again later.",
    lbl_deals_filter_error: "We seem to be having some issues fetching your search results. Please try again later."
  },
  deal_details: {
    lbl_what_deal_gives: "So, what does this deal give me?",
    lbl_get_device: "You get this device...",
    lbl_you_get: "You get a…",
    lbl_review_deal: "Review your selected deal:",
    lbl_on_a: "on a",
    lbl_with: "with:",
    lbl_deal_includes: "This deal also includes…",
    lbl_contract_duration: "Contract duration:",
    lbl_deal_duration_price: "Deal duration & price:",
    lbl_deal_details: "Deal details",
    lbl_plan_details: "Plan details",
    lbl_device_plan_details: "Device & plan details",
    lbl_acc_voucher_details: "Accessory & voucher details",
    lbl_delivery_returns: "Delivery & returns",
    lbl_get_this_deal: "Get this deal",
    lbl_deal_to_cart: "Add deal to cart",
    lbl_deal_added: "This deal has been added to your cart",
    lbl_add_deal_cart: "Add deal to cart",
    lbl_upgrade_this_deal: "Upgrade to this deal",
    lbl_sim_size: "SIM card size:",
    lbl_total_monthly_due: "Total due every month:",
    lbl_vas_added: "has been added",
    lbl_vas_removed: "has been removed",
    device_data: {
      lbl_deal_price: "Deal price",
      lbl_contract_duration: "Contract duration",
      lbl_available_online: "Available online",
      lbl_available_store: "Available in-store" // lbl_available_stores: "Available in stores",

    },
    lbl_session_storage: "deal-buyOption",
    lbl_new_contract_deal_option: "Get this deal on a new contract",
    lbl_upgrade_deal_option: "Upgrade",
    lbl_upgrade_deal_option_lower_case: "upgrade",
    lbl_new_contract_deal: "New contract",
    lbl_new_contract_deal_vas: "+ Add contract / device insurance"
  },
  lbl_order_processing_state: "processing",
  lbl_order_pending_state: "pending",
  lbl_order_processing_l500_success_state: "processing_update_500_success",
  lbl_order_new_state: "new",
  lbl_data_only: "data only",
  order_status_labels: {
    lbl_processing: "Processing...",
    lbl_processed: "Order processed",
    lbl_paid: "Paid",
    lbl_order_error: "Order error",
    lbl_payment_failed: "Payment failed",
    lbl_cancelled: "Order cancelled",
    lbl_in_progress: "In Progress",
    lbl_payment_pending: "Payment Pending",
    lbl_pending: "Pending",
    lbl_order_failed: "Order Failed",
    lbl_payment_unsuccessful: "Payment Unsuccessful",
    lbl_new: "New",
    lbl_order_created: "Order Created"
  },
  order_blurb_labels: {
    lbl_will_be_cancelled: "This order will be cancelled in 23h 24m. Please retry payment to avoid cancellation.",
    lbl_retry_order: "This order will be cancelled in 23h 24m. Please retry payment to avoid cancellation.",
    lbl_consultant_touch: "A consultant will get in touch with you",
    lbl_settlement_failed: "Payment settlement failed",
    lbl_payment_received: "Payment was received and settled"
  },
  order_messages_labels: {
    lbl_will_be_cancelled: "Something went wrong while processing your order. Please press the 'Retry payment' button above to submit your order for processing again. If you don't resubmit, this order will be cancelled after 24 hours.",
    lbl_is_cancelled: "We couldn't finish processing this order due to a technical error",
    lbl_consultant_touch: "Something went wrong while processing your order. One of our consultants will contact you in order to resolve this issue.",
    lbl_consultant_phone: "One of our consultants will contact you on",
    lbl_settlement_failed: "Your payment could not be settled successfully. The payment authorisation on your account will be reversed within 5 - 10 days, depending on your bank. In the meantime, we'll continue processing your contract application separately. Please contact your bank for more information. Alternatively, you can contact Customer Care at 08217844."
  },
  lbl_airtime: "airtime",
  lbl_buy_bundle: "Buy Bundle",
  lbl_Months: "months",
  lbl_select_deal: "Choose a deal",
  lbl_build_contract: "Build your contract",
  lbl_internal_search: {
    lbl_search_see_all: "See all product results",
    lbl_search_see_all_deals: "See all deals results",
    lbl_all_result: "All results",
    lbl_promotions: "Promotions",
    lbl_products: "Products",
    lbl_deals: "Deals",
    lbl_services: "Services",
    lbl_content_video: " Content & Videos",
    lbl_help_support: "Help & Support",
    lbl_latest_products: "Latest products",
    lbl_bestselling_products: "Bestselling products",
    lbl_latest: "latest",
    lbl_bestSelling: "Bestselling",
    lbl_tab_names: {
      lbl_allresults: "all-results",
      lbl_products: "products",
      lbl_deals: "deals",
      lbl_promotions: "promotions",
      lbl_content_videos: "content-videos",
      lbl_content_and_videos: "content & videos",
      lbl_help_support: "help-support",
      lbl_services: "services"
    },
    lbl_showing3_result: "Showing 3 of "
  },
  lbl_results_found: "results found",
  lbl_past_orders_found: "past orders",
  lbl_result_found: "result found",
  lbl_see_all: "See all results",
  lbl_cart_recently_viewed: "You recently viewed:",
  lbl_there_is_no_match: "There's no match for",
  lbl_could_not_render_page: "could not render page template",
  lbl_you_will_save: "You'll save",
  lbl_order_waiting: "You still have an order waiting to be completed",
  lbl_order_not_final: "Your previous order was not finalised successfully. Would you like to complete it now?",
  lbl_hurry_text: "Hurry! This order will be automatically cancelled 24 hours after it was created.",
  lbl_view_order: "View order",
  lbl_complete_order: "Complete order now",
  lbl_search_no_result: "search_no_result",
  errorMessages: {
    lbl_filters_did_not_load_error: "Oops! These filters did not load correctly this time. Please try loading the page again.",
    lbl_page_error: "Oops! This page could not be loaded correctly.",
    lbl_page_error_subheading1: "We're currently experiencing technical issues, or this page might be down for maintenance.",
    lbl_page_error_subheading2: "Either way, our team is on it and will have it up and running again soon!",
    lbl_user_profile_sync: "Something went wrong. It seems the product could not be added to your cart. Please try again later.",
    lbl_back_order_deal_unavailable: "Unfortunately, this product is currently unavailable. You can continue to browse more deals."
  },
  lbl_menu_top: {
    lbl_switch_business: "Switch to business",
    lbl_find_store: "Find a store",
    lbl_page_error_subheading1: "We're currently experiencing technical issues, or this page might be down for maintenance.",
    lbl_page_error_subheading2: "Either way, our team is on it and will have it up and running again soon!",
    lbl_product_404_heading: "This product is no longer available",
    lbl_product_404_label: "Currently out of stock",
    lbl_product_404_description: "Try browsing all our products to find something similar",
    lbl_deal_404_heading: "Deal expired",
    lbl_deal_404_description: "Try browsing all our deals to find something similar",
    lbl_user_profile_sync: "Something went wrong. it seems the product could not be added to your cart. Please try again later."
  },
  lbl_upgrade_page_heading: "Let’s see if you can upgrade today",
  lbl_upgrade_page_heading_mobile: "Upgrade check",
  lbl_upgrade_page_description: "Enter your details below to see if you’re able to upgrade your contract today:",
  lbl_which_number: "Which number do you want to upgrade?",
  lbl_which_number_mobile: "Which number are you upgrading?",
  lbl_i_can_receive_sms: "I can receive an SMS on this number",
  lbl_what_to_expect: "Wondering what to expect?",
  lbl_what_to_expect_data: [{
    id: "1",
    text: "If you are eligible for an upgrade, we\u2019ll show you a set of <span class=\"expect-text\">Just4You deals</span> that have been specially recommended for you <span class=\"expect-text\">based on your previous usage</span>"
  }, {
    id: "2",
    text: "If you don\u2019t like any of the recommended deals, you can still browse <span class=\"expect-text\">other deals </span>on our website that you qualify for"
  }, {
    id: "3",
    text: "We <span class=\"expect-text\">don\u2019t require any documents</span> during the online upgrade process"
  }],
  checkout: {
    lbl_merge_cart_error_title: "We see you’ve got more items in your cart",
    lbl_merge_cart_error_desc: "You previously added one or more items to your cart when you were logged in. Would you like to view those items now, or would you like to clear your cart and continue with your current checkout?",
    lbl_session_invalid: "Your session seems to be expired. Please refresh to re-login, and try again.",
    lbl_cart_invalid: "Your cart seems to be expired. Please refresh and try again.",
    lbl_technical_error_title: "We’ve encountered a technical issue",
    lbl_technical_error_desc: "Unfortunately, we can’t proceed with your application right now. Please try again later, or let us give you a call to help complete your application telephonically.",
    lbl_something_went_wrong_try_again: "Something went wrong. Please try again.",
    lbl_invalid_attempt_title: "Something went wrong",
    lbl_invalid_attempt_desc: "Unfortunately, we can’t proceed with your application right now. Please try again later, or let us give you a call to help complete your application telephonically.",
    lbl_no_deal_product: "It seems their is no deal product in your cart. Please add a deal product to proceed further.",
    lbl_select_preference: "Please select your preference below:",
    lbl_preference_values: [{
      id: "call-me-back",
      label: "I want a consultant to call me back",
      analyticsLabel: "call me back"
    }, {
      id: "once-off",
      label: "I still want to check out my once-off purchase items",
      analyticsLabel: "once-off"
    }, {
      id: "all-above",
      label: "All of the above",
      analyticsLabel: "all of the above"
    }],
    lbl_preference_approved_conditions_values: [{
      id: "select-another-deal-need-once-off",
      label: "Let me select another deal to apply for. I’ll check out my once-off purchase items afterwards.",
      analyticsLabel: "check once-off after"
    }, {
      id: "select-another-deal-dont-need-once-off",
      label: "Let me select another deal to apply for. I don’t need the once-off purchase items anymore.",
      analyticsLabel: "remove once-off"
    }, {
      id: "check-once-off-only",
      label: "I only want to check out my once-off purchase items now",
      analyticsLabel: "once-off only"
    }],
    lbl_will_be_in_touch: "We'll be in touch soon!",
    lbl_continue_once_off: "Would you like to continue with the purchase of the once-off items in your order?"
  },
  delivery: {
    contractTypeContactFormInfo: "Please enter your own contact details. For security reasons, the courier needs to deliver this order to the person applying for the contract."
  },
  payment: {
    removeCreditCard: "Your credit / debit card has been removed from your profile",
    removeCreditCardFail: "Something went wrong. Please try again.",
    noCreditCardWarning: "We’re not able to show your previously saved cards right now. You can still continue to the next page and enter/select your card details there."
  },
  orderConfirmation: {
    lbl_contract_default_desc: "Your application has been submitted. Someone will be in touch soon to confirm your application result.",
    lbl_contract_upgrade_desc: "Your upgrade has been submitted",
    lbl_normal_sub_desc: "As soon as your payment has been approved and confirmed, we’ll send you a confirmation email with all your order and delivery details.",
    lbl_your_order_should_delivered: "Your order should be delivered in the next:",
    lbl_your_reference_number: "Your reference number:",
    lbl_cqfd_order_fail_heading: "Something went wrong",
    lbl_cqfd_order_fail_description: "Unfortunately, there was a technical issue with your previous online application. A consultant will contact you soon to help you complete your application.",
    lbl_order_fail_heading: "We’ve encountered a technical issue",
    lbl_order_fail_description: "Unfortunately, we can’t proceed with your application right now. Please try again later, or let us give you a call to help complete your application telephonically.",
    lbl_order_fullfilment_stock_dependant: "Fulfilment of orders is stock-dependant at the time of application approval.",
    lbl_we_need_documents: "We need a few documents",
    errorCodes: {
      newLineApproved: "order-confirmation-newline-approved",
      newLineOffline: "order-confirmation-newline-offline",
      newLinePendedId: "order-confirmation-newline-pended-id",
      newLinePendedPassport: "order-confirmation-newline-pended-passport",
      newLineApprovedWithConditions: "order-confirmation-newline-approved-with-conditions",
      addLineApproved: "order-confirmation-addline-approved",
      addLineOffline: "order-confirmation-addline-offline",
      addLinePendedId: "order-confirmation-addline-pended-id",
      addLinePendedPassport: "order-confirmation-addline-pended-passport",
      addLineApprovedWithConditions: "order-confirmation-addline-approved-with-conditions",
      upgradeApproved: "order-confirmation-upgrade-approved"
    }
  },
  auth: {
    lbl_technical_error_title: "We’ve encountered a technical issue",
    lbl_technical_error_desc: "Unfortunately, we can’t proceed with your application right now. Please try again later.",
    lbl_tooltip_message: "The main account holder is the person responsible for paying the account, and their associated number is typically their very first Vodacom contract number",
    errorCodes: {
      api_time_out: "letsGetStarted_504"
    },
    lbl_email_readOnly: "We’ll use this email address from your Vodacom profile to communicate with you regarding your order"
  },
  xds: {
    lbl_info: ["We use a third party service and your ID number to source these questions and answers from the Department of Home Affairs and the credit bureau"],
    lbl_success_title: "Your application has been successfully authenticated",
    lbl_failed_title: "We will authenticate you once your application has been submitted",
    lbl_error_title: "We seem to be having some technical issues right now. We'll authenticate your application once its been submitted.",
    lbl_success_desc: null,
    lbl_failed_desc: "Not all your answers to the security questions were correct. You can still continue completing your application - we'll simply authenticate your application after you've submitted it",
    lbl_error_desc: null,
    lbl_question_fetching_title: "Fetching your questions...",
    lbl_checking_answer_title: "Checking your answers..."
  },
  lbl_error_block_API_fail: "Oops! This page didn’t load correctly. Please try reloading the page to see everything as it should be.",
  lbl_top_banner: {
    lbl_busy_upgrade: "You are busy with upgrading your contract",
    lbl_Process_upgrade: "<span class='upgrade-cancel-nr'>No worries if you don't want to upgrade {{cellphone}} right now.</span> " + "You can explore new contracts or even upgrade a different number!",
    lbl_process_upgrade_title: "Change your mind?",
    lbl_no_longer_upgrade_title: "You're no longer upgrading your contract",
    lbl_no_longer_upgrade_msg: "Want to continue upgrading again? You can navigate to the Upgrade page from the main menu, or you can select the upgrade option when choosing your device or deal.",
    lbl_btn: {
      lbl_see_detail: "See More Details",
      lbl_stop_upgrade: "I don’t want to upgrade right now",
      lbl_start_upgrade: "I want to upgrade another number",
      lbl_recommended_deals: "I want to get a new contract",
      lbl_okay_got_it: "Okay, got it"
    }
  },
  lbl_transfer_number: {
    lbl_phone_number: "Which number would you like to use?",
    lbl_new_number: "I’d like a new number",
    lbl_vodacom_number: "I have a Vodacom prepaid number",
    lbl_external_number: "I have a prepaid number from another network",
    lbl_retry_button: "Try another prepaid number",
    lbl_retry_button2: "Use another number instead",
    lbl_agree_1: "I agree that the number above is a prepaid number and it belongs to me",
    lbl_agree_2: "I agree to receive a new number if this number cannot be transferred successfully",
    lbl_agree_3: "I agree to forfeit any airtime or bundles on this number when it is transferred",
    lbl_important_things: "Important things to know"
  },
  lbl_upgrade_info_banner: "These deals were recommended for you based on your past usage and affordability",
  //upgrade
  upgrade: {
    lbl_invalid_otp_try_1: "Looks like you entered an invalid OTP. Please try again.",
    lbl_invalid_otp_try_2: "Looks like you entered an invalid OTP again. You have one attempt remaining. Please try again.",
    lbl_invalid_otp_try_3: "For your security, you've been temporarily blocked from requesting new OTPs. Please try again in 24 hours.",
    lbl_invalid_otp_try_3_desc: "For your security, you've been temporarily blocked from requesting new OTPs. Please try again in 24 hours.",
    lbl_invalid_otp_try_3_title: "You’ve entered 3 invalid OTPs",
    lbl_invalid_otp_try_3_btn_title: "You’ve entered 3 invalid OTPs",
    lbl_enter_msisdn_title: "Let’s see if you can upgrade today",
    lbl_enter_msisdn_desc: "Please enter the cellphone number that you’d like to upgrade below:",
    lbl_enter_msisdn_input_title: "Your cellphone number",
    lbl_enter_msisdn_checkbox_text: "I can receive an SMS on this number",
    lbl_enter_otp_title: "Please enter your 4-digit OTP",
    lbl_enter_otp_desc_prefix: "We’ve sent a One-Time PIN (OTP) to",
    lbl_enter_otp_desc_suffix: ". Please enter it below to continue:",
    lbl_enter_otp_desc_suffix_v2: "Please enter it below to continue:",
    lbl_btn_resend_otp: "Resend OTP",
    lbl_btn_continue: "Continue",
    lbl_select_number_title: "Where can we send your OTP?",
    lbl_select_number_desc: "We need to send you a One-Time PIN (OTP) to authenticate this application. On which number you would like to recive your OTP?",
    lbl_btn_none_otp: "None of these numbers can receive SMS OTPs",
    lbl_otp_resent_info: "Your One-Time PIN has been resent. Please check your inbox.",
    lbl_tooltip_message: "The main account holder is the person responsible for paying the account, and their associated number is typically their very first Vodacom contract number",
    lbl_tooltip_prefix_text: "Yes, the",
    lbl_tooltip_text: "main account holder",
    lbl_tooltip_suffix_text: " will be able to provide an OTP",
    lbl_error_zero: "Number must start with 0 or 27",
    lbl_error_numbers: "This field can only contain numbers",
    lbl_error_enter_number: "Please enter your cellphone number",
    lbl_snackbar_title: "Hey, you can upgrade!",
    lbl_snackbar_desc: "That’s right! The wait is finally over. Click through to upgrade your contract right here, right now.",
    lbl_snackbar_btn_text: "See upgrade deals",
    lbl_still_upgrading: "Are you still upgrading?",
    lbl_processing_desc: "You’re currently in the process of selecting an upgrade deal. Would you like to stop your upgrade and apply for a new contract instead?",
    lbl_continue_upgrade: "Continue upgrading",
    lbl_apply_new_contract: "Apply for a new contract",
    lbl_do_upgrade: "Do an upgrade check",
    lbl_here_to_do_upgrade: "Here to do an upgrade?",
    lbl_products_qualify: "Browse products you qualify for",
    lbl_deals_qualify: "Only show deals I qualify for",
    lbl_deals_for_upgrade: "Based on your profile, these are the deals you can upgrade to",
    lbl_deals_no_products: "Unfortunately, there are no deals that you qualify for right now",
    lbl_upgrade_due_info: "Once we’ve checked if you’re due for an upgrade, and if this is a qualifying upgrade deal for you, you’ll be able to add it to your cart and continue to checkout",
    lbl_upgrade_qualify_info: "Once we’ve checked if this is a qualifying upgrade deal for you, you’ll be able to continue to checkout",
    lbl_prod_upgrade_qualify_info: "Next, you’ll be presented with all our contract deals for this month, which you can filter and browse until you find the one that suits you best.",
    lbl_prod_upgrade_due_info: "Once we’ve checked if you’re due for an upgrade, you’ll be able to select from a range of deals for this product that you already qualify for.",
    lbl_upgrade_add_to_cart_info: "Once we’ve checked if this is a qualifying upgrade deal for you, you’ll be able to add it to your cart and continue to checkout",
    lbl_home_btn: "Go to home page",
    lbl_addnl_info: "You can upgrade another number! Check the dropdown above to see which of your numbers are upgradable right now.",
    lbl_see_deals_btn: "See all deals I qualify for",
    lbl_btn_submit_otp: "Submit OTP",
    lbl_see_products_btn: "See all devices I qualify for",
    lbl_cant_upgrade: "You can't upgrade now.",
    lbl_find_out_why: "Find out why",
    lbl_afford_title: "You can upgrade, but there are no qualifying deals for this device",
    lbl_afford_desc: "Unfortunately, based on your customer profile, we couldn’t find any upgrade deals for this device that you currently qualify for. Would you like to see your available upgrade deals?",
    lbl_afford_btn: "Show me deals I qualify for",
    lbl_reset_desc: "We couldn't find any results for your selected filters. Try widen your search by changing some of your selections, or reset all filters below.",
    lbl_no_products: "Unfortunately, there are no deals that you qualify for right now",
    lbl_scroll_desc: "The wait is finally over! Scroll down to choose the perfect upgrade deal for you.",
    lbl_upgrade_number: "Upgrade this number",
    planData: {
      lbl_looking_for: "I’m looking for...",
      lbl_contract_with_device: "A contract with a device",
      lbl_contract_sim_only: "A SIM only contract"
    },
    stages: {
      lbl_number_entry: "number entry",
      lbl_otp_entery: "otp entry",
      lbl_number_select: "number select",
      lbl_upgrade_result: "upgrade result",
      lbl_technical_error: "technical error",
      lbl_eligible_number_select: "eligible number select"
    },
    errorCodes: {
      code_user_not_found: "upgradeeligibility_other_na_011",
      code_invalid_otp_error: "upgradeeligibility_otp_invalid",
      code_otp_service_down: "upgradeeligibility_otp_500",
      code_otp_no_alternative: "upgradeeligibility_otp_no_alternative",
      code_service_down: "upgradeeligibility_other_na_500",
      code_logged_user_service_down: "upgradeeligibility_logged_500",
      code_mah_user_upgradable: "upgradeeligibility_c3d_mah_000",
      code_child_user_upgradable: "upgradeeligibility_c3d_child_000",
      code_user_duefor_upgrade: "012",
      code_user_duefor_upgrade_with_null: "upgradeeligibility_c3d_na_null",
      code_deal_not_affordable: "upgradeaffordability_dealdetails_fail",
      code_product_not_affordable: "upgradeaffordability_productdetails_fail",
      code_user_acc_error: "upgradeeligibility_other_na_001",
      code_credit_filter_error: "upgradeeligibility_affordability_technical",
      code_cbu_staff_not_eligible: "upgradeeligibility_other_na"
    }
  },
  creditCheckout: {
    lbl_invalid_attempt_1: "Your bank account details seem to be invalid. Please check for errors and try again.",
    lbl_invalid_attempt_1_multicart: "Your bank details seem to be invalid. Please check for errors and try again.",
    lbl_invalid_attempt_2: "Your bank account details seem to be invalid. You have one attempt remaining. Please check for errors and try again.",
    lbl_invalid_attempt_3: "You’ve entered invalid account details for a third time. Let us give you a call and help you complete your application telephonically.",
    lbl_invalid_attempt_3_title: "Invalid bank account details",
    lbl_invalid_attempt_4: "Looks like this account cannot be debited. Please check for errors or try another account number.",
    lbl_bank_page_warning: "Please use your own bank account details for this application. We can only verify your bank account if it was opened using your ID/passport number.",
    lbl_warning_contents: ["The account number matches the selected account type", "The account can be debited", "The account is currently active"],
    lbl_debicheck_mandate: "To protect your account from fraudsters, DebiCheck lets you authorise debit orders electronically before transactions are processed. It's an extra layer of security for your peace of mind.",
    lbl_debicheck_mandate_multicart: "To protect your account from fraudsters, DebiCheck lets you authorise debit orders electronically before transactions are processed. It's an extra layer of security for your peace of mind.",
    deliveryDetails: {
      lbl_receive_type_title: "How would you like to receive your order?",
      lbl_delivery_type_title: "Where should we have it delivered?",
      lbl_another_address_title: "Please enter your delivery address below:",
      lbl_courier_title: "The courier will contact you on:",
      lbl_store_title: "Collecting from a store",
      lbl_store_contents: ["<p>We’ve made sure <strong>we only show you stores that have your items in stock.</strong> If you can’t find your favourite store below, it may be that they don’t have stock right now.</p>", "<p>The store you choose will let you know <strong>when your order is ready for collection.</strong> It normally takes 1 - 3 days to prepare your order.</p>", "<p>Collections can be made <strong>during normal store operating hours.</strong></p>"],
      lbl_collect_type_title: "Where would you like to collect your order?",
      lbl_store_search_title: "Try searching for your town, suburb or favourite shopping centre",
      lbl_invalid_attempt_title: "Something went wrong",
      lbl_invalid_attempt_desc: "Unfortunately, we can’t proceed with your application right now. Please try again later, or let us give you a call to help complete your application telephonically."
    }
  },
  creditVetting: {
    lbl_code_approved: "Approved_Vetting_Outcome",
    code_approved_with_condition: "Approved_Conditions_Vetting_Outcome",
    code_p50_affordability: "P50_Approved_Conditions_Outcome",
    code_unaffordability: "Deal_Details_Unaffordability_Error",
    lbl_p50_error_code: "P50_Approved_With_Conditions",
    lbl_available_deals: "Based on your last credit check, these are the deals you can apply for",
    lbl_qualify: "Only show deals I qualify for",
    lbl_loading_screen_msg: "Checking your credit status with registered credit bureaus…",
    lbl_loading_screen_msg_multicart: "Checking your credit status with registered credit bureaus…",
    lbl_approved_with_condition: "Approved_With_Conditions",
    lbl_form_content_not_found: "consentFormContentNotFound",
    lbl_chk_consent: "give consent",
    lbl_chk_agree: "above is correct",
    lbl_processed: "PROCESSED",
    lbl_unprocessed: "UNPROCESSED",
    lbl_approved: "APPROVED",
    lbl_declined: "DECLINED",
    lbl_referred: "REFERRED",
    lbl_pended: "PENDED",
    lbl_pending: "PENDING",
    lbl_screentype_loading: "loadingScreen",
    lbl_approved_with_condition_status: "APPROVED WITH CONDITIONS",
    lbl_resultcode_approved_with_condition: "CreditVetting_APPROVED WITH CONDITIONS",
    lbl_resultcode_approved: "CreditVetting_APPROVED",
    lbl_resultcode_offline: "CreditVetting_OFFLINE",
    lbl_resultcode_offline_unprocessed: "Unprocessed_Vetting_Result",
    lbl_resultcode_declined_nxtlvl: "CreditVetting_DECLINED_NXTLVL",
    lbl_resultcode_declined: "CreditVetting_DECLINED",
    lbl_resultcode_referred: "CreditVetting_REFERRED",
    lbl_resultcode_pended: "CreditVetting_PENDED",
    lbl_resultcode_pending: "CreditVetting_PENDING",
    lbl_declined_passport: "Declined_Non-NXT_LVL",
    lbl_declined_non_nxtlvl: "Declined_LeadNXT_LVL",
    lbl_pending_non_nxtlvl: "Declined_Non-NXT_LVL_Pended",
    lbl_referred_non_nxtlvl: "Declined_Non-NXT_LVL_Referred",
    lbl_lead_submitted: "Lead_Submitted",
    approvedWithCodition: {
      lbl_technical_error_title: "Your credit check has been approved, but not for this deal...",
      lbl_technical_error_desc: "You have the option to choose a different deal from a range of deals that have been selected based on your credit check result. Would you like to continue to choose another deal?",
      lbl_primary_button: "Yes, show me other deals",
      lbl_secondary_button: "Exit checkout"
    },
    approved: {
      lbl_title: "Your credit status has been approved!",
      lbl_desc: "You can now continue with your application.",
      lbl_screentype: "Approved_Vetting_Outcome"
    },
    lbl_submit_docs_info: "Once you’ve submitted your application we’ll tell you which documents we require and where you can send them. The outcome of your application will be communicated with you after we’ve received and processed your documents.",
    lbl_split_cart_notification_message: "<strong>We need to check out your order in two parts</strong><br/>Your once-off purchase items will be moved back to your cart for now, and you can check them out after submitting your application."
  },
  product_affordability: {
    lbl_upgrade_banner: "You’re upgrading ",
    lbl_upgrade_banner_mobile: "You're upgrading {contract_label}",
    lbl_available_deals: "Based on your credit profile, these are the available deals you can apply for",
    lbl_available_products: "Based on your credit profile, these are the products on the available deals you can apply for",
    lbl_available_products_tablet: "Based on your profile, these are the products with deals you can upgrade to",
    lbl_available_deals_tablet: "Based on your profile, these are the products with deals you can upgrade to",
    lbl_qualify: "Only show devices I qualify for",
    lbl_qualify_device_plan: "Based on your credit profile, we can offer you deals with a device and a plan",
    lbl_qualify_sim_only: "Based on your credit profile, we can offer you SIM-only deals and possibly deals that include a device and plan",
    lbl_qualify_limited_deals: "Based on your credit profile, we can offer you deals with a limited range of devices and plans",
    lbl_no_deals_available: "Unfortunately, there are no deals that you qualify right now.",
    lbl_do_upgrade: "See Details",
    lbl_qualify_deals_plan: "Based on your credit profile, we can offer you deals with a device and a plan",
    lbl_busy_mobile: "You’re upgrading"
  },
  mah_authentication: {
    lbl_success_title: "Your upgrade has been successfully authorised!",
    lbl_mah_info: "The main account holder is the person responsible for paying the account, and their associated number is typically their very first Vodacom contract number",
    lbl_enter_otp_title: "Please enter your OTP below:",
    lbl_enter_mah_otp_title: "Please enter the main account holder’s OTP below:",
    lbl_where_to_sent_otp: "Where should we send the OTP?",
    lbl_select_number: "Please select the number to which we can send the One-Time PIN (OTP) below:",
    lbl_one_time_pin: "One-time PIN:",
    lbl_validate_otp: "Validate OTP",
    lbl_resend_otp: "Resend OTP",
    lbl_havent_received_otp: "Haven’t received your OTP SMS yet?",
    lbl_otp_sent_desc_1: "Your OTP was sent to",
    lbl_otp_sent_desc_2: ". If this is a data SIM, or you can’t receive an SMS on this number, one of our consultants will need to call you.",
    lbl_cant_receive_otp: "I can’t receive an SMS on this number",
    lbl_send_otp: "Send OTP",
    lbl_call_me_back: "Call me back",
    lbl_will_send_otp: "We’ll be sending you a One-Time PIN (OTP) in order for you to authorise this upgrade",
    lbl_mah_auth: "Main account holder authorisation",
    lbl_mah_auth_desc: "We’ll be sending a One-Time PIN (OTP) to the main account holder in order for them to authorise this upgrade. Once they’ve received it, please enter it below to continue.",
    lbl_send_otp_other: "Send OTP to another number",
    lbl_pay_my_bill: "Pay my bill"
  },
  post_checkout: {
    otp_authentication: {
      lbl_main_heading: "Authorise adding a contract",
      lbl_sub_heading: "We've sent a One-Time PIN (OTP) to ",
      lbl_sub_heading_2: " in order for you to authorise the addition of this contract",
      lbl_input_title: "Please enter your OTP below:",
      lbl_resend_otp: "Resend OTP",
      lbl_validate_otp: "Validate OTP",
      lbl_call_me_back: "Call Me Back",
      lbl_otp_message_title: "Haven't received your OTP SMS yet?",
      lbl_otp_message_desc: "Your OTP was sent to {masked_msisdn}. If this is a data SIM, or you can't receive an SMS on this number, one of our consultants will need to call you.",
      lbl_otp_message_link: "I can't receive an SMS on this number",
      lbl_otp_multiple_mah_title: "Where should we send the OTP?",
      lbl_otp_multiple_mah_subheading: "Please select the number to which we can send the One-Time PIN (OTP) below:",
      lbl_otp_sms_receive_checkbox: "I can receive an SMS on this number",
      lbl_otp_send_btn: "Send OTP",
      lbl_otp_sent_to_another: "Send OTP to another number",
      lbl_otp_success: "Your application has been successfully authorised!",
      lbl_otp_3_try_title: "You've entered 3 invalid OTPs",
      lbl_otp_3_try_desc: "For your security, you've been temporarily blocked from requesting new OTPs.  Please try again in 24 hours, or have one of our consultants call you to assist you telephonically.",
      lbl_otp_resent_info: "Your One-Time PIN has been resent. Please check your inbox.",
      lbl_otp_cannot_send: "We can't send you a One-Time PIN",
      lbl_otp_cannot_send_desc: "Unfortunately, you don't have a Vodacom number that can receive an OTP linked to your profile. One of our consultants can contact you to help you apply for this contract telephonically."
    }
  },
  lbl_success_auth: "You’ve been authenticated for this upgrade",
  lbl_success_approved: "You’ve been approved for this contract"
};
/* harmony default export */ __webpack_exports__["Z"] = (labels);

/***/ }),

/***/ 91250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$H": function() { return /* binding */ getAttributeOptions; },
/* harmony export */   "$J": function() { return /* binding */ setNewShippingAddress; },
/* harmony export */   "$L": function() { return /* binding */ dealGrid; },
/* harmony export */   "$j": function() { return /* binding */ setExistingShippingAddress; },
/* harmony export */   "Ag": function() { return /* binding */ setGuestEmailOnCart; },
/* harmony export */   "BI": function() { return /* binding */ getProductsBySkus; },
/* harmony export */   "Bi": function() { return /* binding */ setExistingBillAddress; },
/* harmony export */   "Dq": function() { return /* binding */ vasProductAddOrRemoveInCart; },
/* harmony export */   "J0": function() { return /* binding */ getSAStates; },
/* harmony export */   "Je": function() { return /* binding */ ProductSearchList; },
/* harmony export */   "KV": function() { return /* binding */ customerPlacedOrder; },
/* harmony export */   "Ky": function() { return /* binding */ ProductCarouselData; },
/* harmony export */   "Lo": function() { return /* binding */ updateCustomerAddress; },
/* harmony export */   "MI": function() { return /* binding */ getAllCustomerAddressLists; },
/* harmony export */   "My": function() { return /* binding */ vasProductQuery; },
/* harmony export */   "N2": function() { return /* binding */ getAddressTypes; },
/* harmony export */   "NF": function() { return /* binding */ shippingAndBillingAddress; },
/* harmony export */   "Nh": function() { return /* binding */ DealSelectionDetail; },
/* harmony export */   "PF": function() { return /* binding */ FilterProducts; },
/* harmony export */   "Pe": function() { return /* binding */ AddCouponCode; },
/* harmony export */   "QC": function() { return /* binding */ customerPreviousOrders; },
/* harmony export */   "QI": function() { return /* binding */ Products; },
/* harmony export */   "R6": function() { return /* binding */ CartRecentProducts; },
/* harmony export */   "RA": function() { return /* binding */ DealSelection; },
/* harmony export */   "Rj": function() { return /* binding */ Categories; },
/* harmony export */   "Rr": function() { return /* binding */ getDealSkus; },
/* harmony export */   "T$": function() { return /* binding */ getCustomerActiveCart; },
/* harmony export */   "T0": function() { return /* binding */ createCustomerAddress; },
/* harmony export */   "U2": function() { return /* binding */ ProductSearchtWithoutCategoryList; },
/* harmony export */   "UN": function() { return /* binding */ recommmendedDeals; },
/* harmony export */   "WR": function() { return /* binding */ guestAddBundleProduct; },
/* harmony export */   "Xn": function() { return /* binding */ getGraphQlOperationFromRequestQuery; },
/* harmony export */   "Xv": function() { return /* binding */ DealDetail; },
/* harmony export */   "_W": function() { return /* binding */ updateCartItems; },
/* harmony export */   "cK": function() { return /* binding */ removeCouponCode; },
/* harmony export */   "f4": function() { return /* binding */ ProductDetails; },
/* harmony export */   "g6": function() { return /* binding */ persistCart; },
/* harmony export */   "j8": function() { return /* binding */ setNewBillingAddress; },
/* harmony export */   "jK": function() { return /* binding */ getCurrencySymbol; },
/* harmony export */   "jr": function() { return /* binding */ getDealsProductsBySkus; },
/* harmony export */   "kd": function() { return /* binding */ setPaymentMethodOnCart; },
/* harmony export */   "kr": function() { return /* binding */ AlertDetails; },
/* harmony export */   "lO": function() { return /* binding */ salesOrderDetail; },
/* harmony export */   "lR": function() { return /* binding */ dealGridAggregations; },
/* harmony export */   "mf": function() { return /* binding */ productAggregations; },
/* harmony export */   "nF": function() { return /* binding */ guestAddSimpleProductToCart; },
/* harmony export */   "p5": function() { return /* binding */ guestAddConfigurableProductToCart; },
/* harmony export */   "qP": function() { return /* binding */ getCategoryCMS; },
/* harmony export */   "qZ": function() { return /* binding */ guestCreateEmptyCart; },
/* harmony export */   "t9": function() { return /* binding */ removeCartItems; },
/* harmony export */   "u9": function() { return /* binding */ getAttributes; },
/* harmony export */   "vn": function() { return /* binding */ CompareProducts; },
/* harmony export */   "vu": function() { return /* binding */ setShippingMethodsOnCart; },
/* harmony export */   "xw": function() { return /* binding */ guestViewCart; },
/* harmony export */   "zH": function() { return /* binding */ BannerDetails; }
/* harmony export */ });
/* unused harmony exports ProductsByBrand, urlResolver, productDetailsUrl, DealSelectionProductGQL, generateCustomerToken, placeOrder, RelatedDeals, getAll5GRouters */
var Products = "query products($id: String, $manufacturer: String, $ids: [String], $sort:ProductAttributeSortInput, $pageSize: Int, $currentPage: Int) {products(filter: {category_id: { eq: $id }manufacturer: { eq: $manufacturer }sku: { in: $ids }price: {from: \"0.001\", to: \"9999999999\"},is_deal_product: {eq: \"0\"},is_hidden_product:{eq : \"0\"},is_esd_product: { eq: \"0\"}} sort: $sort, pageSize: $pageSize, currentPage: $currentPage) { total_count page_info { page_size current_page total_pages } items { name quantity bundle_product_price promotion_tag_swatch badges_swatch sku badges badges_label stock_status low_stock_threshold display_low_stock_badge deal_go_live_date deal_end_date deal_label is_deal_locked categories {id name url_key image} ... on ConfigurableProduct { variants { product {id name quantity sku stock_status price_range {minimum_price {regular_price {value currency } final_price{value currency } discount {amount_off percent_off } } maximum_price {regular_price {value currency } final_price{value currency } discount {amount_off percent_off } } }  } attributes { label code value_index } } }  __typename price_range { minimum_price { regular_price { value currency } final_price{ value currency } discount { amount_off percent_off } } maximum_price { regular_price { value currency } final_price{ value currency } discount { amount_off percent_off } } } image { url } small_image{ url } } aggregations{ count label attribute_code options{ count label value }  } } }";
var Categories = "query category($id: Int){category(id: $id) { product_total_count children { position id name image product_total_count children { position id name image product_total_count }}}}";
var CartRecentProducts = "query products($id: String, $manufacturer: String, $ids: [String], $sort:ProductAttributeSortInput, $pageSize: Int, $currentPage: Int) {products(filter: {category_id: { eq: $id }manufacturer: { eq: $manufacturer }sku: { in: $ids }price: {from: \"0.001\", to: \"9999999999\"},is_deal_product: {eq: \"0\"},is_hidden_product:{eq : \"0\"},is_esd_product: { eq: \"0\"}} sort: $sort, pageSize: $pageSize, currentPage: $currentPage) { total_count page_info { page_size current_page total_pages } items { name quantity bundle_product_price promotion_tag_swatch badges_swatch sku badges badges_label stock_status low_stock_threshold display_low_stock_badge deal_go_live_date deal_end_date deal_label is_deal_locked categories {id name url_key image} ... on ConfigurableProduct { variants { product {id name quantity sku stock_status price_range {minimum_price {regular_price {value currency } final_price{value currency } discount {amount_off percent_off } } maximum_price {regular_price {value currency } final_price{value currency } discount {amount_off percent_off } } }  } attributes { label code value_index } } }  __typename ... on BundleProduct { items{ option_id options{ id } } } ... on CustomizableProductInterface { options { title required sort_order option_id __typename ... on CustomizableDropDownOption { title value { price_type option_type_id title price sku } } } } price_range { minimum_price { regular_price { value currency } final_price{ value currency } discount { amount_off percent_off } } maximum_price { regular_price { value currency } final_price{ value currency } discount { amount_off percent_off } } } image { url } small_image{ url } } aggregations{ count label attribute_code options{ count label value } } sort_fields{ default options{ label value } } } }";
var ProductsByBrand = "query products( $manufacturer: String ) { products( filter: { manufacturer: { eq: $manufacturer } price: { from: \"0.001\", to: \"9999999999\" } is_deal_product: { eq: \"0\" } is_hidden_product: { eq: \"0\" } is_esd_product: { eq: \"0\"} }  pageSize: 6, currentPage: 1  ) { items { name quantity promotion_tag_swatch badges_swatch sku badges badges_label stock_status low_stock_threshold display_low_stock_badge __typename price_range { minimum_price { regular_price { value currency } final_price { value currency } discount { amount_off percent_off } } maximum_price { regular_price { value currency } final_price { value currency } discount { amount_off percent_off } } } image { url } small_image { url } } } }";
var getCategoryCMS = "\n\tquery getCategoryCMS($id: String!) {\n\t\tcategories(filters: { ids: { in: [$id] }}) {\n\t\t\titems {\n\t\t\t\tcms_block {\n\t\t\t\t\tcontent\n\t\t\t\t}\n\t\t\t\tdisplay_mode\n\t\t\t\tname\n\t\t\t}\n\t\t}\n\t}\n";
var getProductsBySkus = "\n\tquery getProductsBySkus($skus: [String], $pageSize: Int!) {\n\t\tproducts(filter: { sku: { in: $skus } }, pageSize: $pageSize) {\n\t\t\titems {\n\t\t\t\tid\n\t\t\t\tuid\n\t\t\t\tname\n\t\t\t\tbundle_product_price\n\t\t\t\tprimary_product_image\n\t\t\t\tprimary_product_sku\n\t\t\t\tmanufacturer\n\t\t\t\tmanufacturer_label\n\t\t\t\tprice_range {\n\t\t\t\t\tminimum_price {\n\t\t\t\t\t\tfinal_price {\n\t\t\t\t\t\t\t\tcurrency\n\t\t\t\t\t\t\t\tvalue\n\t\t\t\t\t\t}\n\t\t\t\t\t\tregular_price {\n\t\t\t\t\t\t\t\tcurrency\n\t\t\t\t\t\t\t\tvalue\n\t\t\t\t\t\t}\n\t\t\t\t\t\tdiscount {\n\t\t\t\t\t\t\t\tamount_off\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\tmaximum_price {\n\t\t\t\t\t\tfinal_price {\n\t\t\t\t\t\t\tcurrency\n\t\t\t\t\t\t\tvalue\n\t\t\t\t\t\t}\n\t\t\t\t\t\tregular_price {\n\t\t\t\t\t\t\tcurrency\n\t\t\t\t\t\t\tvalue\n\t\t\t\t\t\t}\n\t\t\t\t\t\tdiscount {\n\t\t\t\t\t\t\tamount_off\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tsku\n\t\t\t\tsmall_image {\n\t\t\t\t\turl\n\t\t\t\t}\n\t\t\t\t... on ConfigurableProduct {\n\t\t\t\t\tconfigurable_options {\n\t\t\t\t\t\tvalues {\n\t\t\t\t\t\t\tvalue_index\n\t\t\t\t\t\t\tswatch_data {\n\t\t\t\t\t\t\t\tvalue\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tstock_status\n\t\t\t\turl_key\n\t\t\t\t__typename\n\t\t\t}\n\t\t}\n\t}\n";
var getDealsProductsBySkus = "\n\tquery getDealsProductsBySkus($skus: [String], $pageSize: Int!) {\n\t\tproducts(filter: { sku: { in: $skus } }, pageSize: $pageSize) {\n\t\t\titems {\n\t\t\t\tid\n\t\t\t\tname\n\t\t\t\tmonthly_recurring\n\t\t\t\tsave_monthly_recurring\n\t\t\t\told_monthly_recurring\n\t\t\t\tpayment_terms\n\t\t\t\tpayment_terms_label\n\t\t\t\tprimary_product_image\n\t\t\t\tprimary_product_sku\n\t\t\t\tmanufacturer\n\t\t\t\tmanufacturer_label\n\t\t\t\tanytime_product_sku\n\t\t\t\tsku\n\t\t\t\tsmall_image {\n\t\t\t\t\turl\n\t\t\t\t}\n\t\t\t\tstock_status\n\t\t\t\turl_key\n      \t\t\t... on BundleProduct {\n\t\t\t\t\titems {\n\t\t\t\t\t\toptions {\n\t\t\t\t\t\t\tproduct {\n\t\t\t\t\t\t\t\tname\n\t\t\t\t\t\t\t\tpromo_data\n\t\t\t\t\t\t\t\tnightowl_units\n\t\t\t\t\t\t\t\tnightowl_uom\n\t\t\t\t\t\t\t\tminutes\n\t\t\t\t\t\t\t\tminutes_label\n\t\t\t\t\t\t\t\tattribute_set_id\n\t\t\t\t\t\t\t\tsku\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t__typename\n\t\t\t}\n\t\t}\n\t}\n";
var getCurrencySymbol = "\n\tquery getCurrencySymbol {\n\t\tcurrency {\n\t\t\tbase_currency_symbol\n\t\t}\n\t}\n";
var CompareProducts = "\n  query productCompare($skus: String) {\n    productCompare(skus: $skus) {\n      allProducts {\n        name\n        image\n\t\t\t\tdata\n\t\t\t\tsku\n      }\n    }\n  }\n";
var urlResolver = "\n  query urlResolver($url: String!) {\n\troute(url: $url) {\n\t\t__typename\n\t\trelative_url\n\t\tredirect_code\n\t\ttype\n\t\t... on SimpleProduct {\n\t\t  sku\n\t\t  url_key\n\t\t  uid\n\t\t  url_rewrites {\n\t\t\turl\n\t\t\tparameters {\n\t\t\t  name\n\t\t\t  value\n\t\t\t}\n\t\t  }\n\t\t  relative_url\n\t\t  redirect_code\n\t\t  type\n\t\t}\n  }\n}\n";
var productDetailsUrl = "query products($url_key: String!) { products(filter: { url_key: { eq: $url_key } }) { items { id meta_title meta_description attribute_set_id name badges badges_swatch badges_label manufacturer stock_status stock_message { out_of_stock_title out_of_stock_description low_stock_title low_stock_description } deal_data { product_id min_price deal_installment } quantity low_stock_threshold display_low_stock_badge manufacturer_label promotion_link promotion_tag_label sku delivery_and_return specification_data delivery_message video_preview_url video_title video_url short_description { html } description { html } battery_capacity bundle_product_price __typename general_description promotions { start_date end_date } price_range { minimum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } maximum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } } image { url label } small_image { url label } media_gallery { url label position } categories { id name level } ... on CustomizableProductInterface { options { title required sort_order option_id __typename ... on CustomizableDropDownOption { title value { price_type option_type_id title price sku } } } } ... on ConfigurableProduct { deal_data { product_id min_price deal_installment } configurable_options { id attribute_id label position use_default attribute_code values { value_index label swatch_data { value } } product_id } variants { product { id name badges badges_label badges_swatch promotion_tag promotion_tag_swatch sku delivery_and_return front_camera secondary_camera network_4g battery_capacity stock_status quantity low_stock_threshold specification_data video_preview_url video_title video_url short_description { html } description { html } promotions { start_date end_date } promotion_link promotion_tag_label display_low_stock_badge __typename general_description image { url label } small_image { url label } thumbnail { url label } media_gallery { url label position } attribute_set_id ... on PhysicalProductInterface { weight } price_range { minimum_price { regular_price { value currency } final_price { value currency } discount { amount_off percent_off } } maximum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } } } attributes { label code value_index } } } ... on BundleProduct { dynamic_sku dynamic_price dynamic_weight price_view ship_bundle_items items { option_id title required type position sku options { id quantity position is_default price price_type can_change_quantity label product { id name quantity low_stock_threshold display_low_stock_badge sku __typename price_range { minimum_price { regular_price { value } } } } } } } related_products { name sku badges badges_swatch badges_label quantity low_stock_threshold display_low_stock_badge price_range { minimum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } maximum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } } image { url label } } upsell_products { name sku badges badges_swatch badges_label quantity stock_status __typename low_stock_threshold display_low_stock_badge price_range { minimum_price { regular_price { value } final_price { value } discount { amount_off } } maximum_price { regular_price { value } final_price { value } discount { amount_off } } } image { url label } } crosssell_products { name sku badges badges_swatch badges_label quantity low_stock_threshold display_low_stock_badge price_range { minimum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } maximum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } } image { url label } } } } }";
var ProductSearchList = " query products($key: String, $id: String){ products(filter: {category_id:{eq: $id}, name: {match: $key}, is_hidden_product: {eq: \"0\"}}, pageSize: 200, currentPage: 1sort: {product_ranking: DESC}) { total_count page_info { page_size current_page total_pages } items { name promotion_tag_swatch badges_swatch sku badges badges_label manufacturer manufacturer_label promotion_tag_label payment_terms_label stock_status low_stock_threshold display_low_stock_badge categories{ id name url_key image } __typename description{ html } meta_title meta_description price_range { minimum_price { regular_price { value currency } final_price{ value currency } discount { amount_off percent_off } } maximum_price { regular_price { value currency } final_price{ value currency } discount { amount_off percent_off } } } price_tiers{ discount{ amount_off percent_off } final_price{ value currency } quantity } image { url label } small_image{ url label } media_gallery { url label ... on ProductVideo { video_content { media_type video_provider video_url video_title video_description video_metadata } } } } aggregations{ count label attribute_code options{ count label value } } sort_fields{ default options{ label value } } } } ";
var ProductSearchtWithoutCategoryList = " query products($key: String){ products(filter: {is_hidden_product: {eq: \"0\"}, is_deal_product: {eq: \"0\"}, is_esd_product: { eq: \"0\"}}, search: $key, pageSize: 200, currentPage: 1sort: {product_ranking: DESC}) { items { name sku categories{ id name } manufacturer manufacturer_label meta_title meta_description image { url label } small_image{ url label } } } }";
var FilterProducts = "query products( $filter: ProductAttributeFilterInput $sort: ProductAttributeSortInput $pageSize: Int $currentPage: Int ) { products( filter: $filter pageSize: $pageSize sort: $sort currentPage: $currentPage ) { total_count page_info { page_size current_page total_pages } items { name quantity bundle_product_price promotion_tag_swatch badges_swatch sku badges badges_label stock_status low_stock_threshold display_low_stock_badge deal_go_live_date deal_end_date deal_label is_deal_locked categories { id name url_key image } ... on ConfigurableProduct { configurable_options { id attribute_id label position use_default attribute_code values { value_index label swatch_data { value } } } variants { product { stock_status } } } __typename price_range { minimum_price { regular_price { value currency } final_price { value currency } discount { amount_off percent_off } } maximum_price { regular_price { value currency } final_price { value currency } discount { amount_off percent_off } } } image { url } small_image { url } } aggregations { count label attribute_code options { count label value } } sort_fields { default options { label value } } } }";
var ProductDetails = " query products($id: String!) { products(filter: { sku: { eq: $id } }) { items { pdp_best_features video_url id attribute_set_id deal_builder_deals name badges badges_swatch badges_label manufacturer stock_status stock_message { out_of_stock_title out_of_stock_description low_stock_title low_stock_description } deal_data { product_id min_price deal_installment } quantity low_stock_threshold display_low_stock_badge manufacturer_label promotion_link promotion_tag_label sku delivery_and_return specification_data delivery_message video_preview_url video_title video_url short_description { html } description { html } battery_capacity bundle_product_price __typename general_description promotions { start_date end_date } price_range { minimum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } maximum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } } image { url label } small_image { url label } media_gallery { url label position } categories { id name level } ... on CustomizableProductInterface { options { title required sort_order option_id __typename ... on CustomizableDropDownOption { title value { price_type option_type_id title price sku } } } } ... on ConfigurableProduct { deal_data { product_id min_price deal_installment } configurable_options { id attribute_id label position use_default attribute_code values { value_index label swatch_data { value } } product_id } variants { product { id name deal_builder_deals badges badges_label badges_swatch promotion_tag promotion_tag_swatch sku delivery_and_return front_camera secondary_camera network_4g battery_capacity stock_status quantity low_stock_threshold specification_data video_preview_url video_title video_url short_description { html } description { html } promotions { start_date end_date } promotion_link promotion_tag_label display_low_stock_badge __typename general_description image { url label } small_image { url label } thumbnail { url label } media_gallery { url label position } attribute_set_id ... on PhysicalProductInterface { weight } price_range { minimum_price { regular_price { value currency } final_price { value currency } discount { amount_off percent_off } } maximum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } } } attributes { label code value_index } } } ... on BundleProduct { dynamic_sku dynamic_price dynamic_weight price_view ship_bundle_items items { option_id title required type position sku options { id quantity position is_default price price_type can_change_quantity label product { id name quantity low_stock_threshold display_low_stock_badge sku __typename price_range { minimum_price { regular_price { value } } } } } } } related_products { name sku badges badges_swatch badges_label quantity low_stock_threshold display_low_stock_badge price_range { minimum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } maximum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } } image { url label } } upsell_products { name sku badges badges_swatch badges_label quantity stock_status __typename low_stock_threshold display_low_stock_badge price_range { minimum_price { regular_price { value } final_price { value } discount { amount_off } } maximum_price { regular_price { value } final_price { value } discount { amount_off } } } image { url label } } crosssell_products { name sku badges badges_swatch badges_label quantity low_stock_threshold display_low_stock_badge price_range { minimum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } maximum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } } image { url label } } } } }";
var DealSelectionProductGQL = "\nquery products($id: String!) {\n\tproducts(filter: { sku: { eq: $id } }) {\n\t\titems {\n\t\t\tattribute_set_id\n\t\t\tname\n\t\t\tsku\n\t\t\tbundle_product_price\n\t\t\t__typename\n\t\t\tsmall_image {\n\t\t\t\turl\n\t\t\t\tlabel\n\t\t\t}\n\t\t\tcategories {\n\t\t\t\tname\n\t\t\t}\n\t\t\t... on ConfigurableProduct {\n\t\t\t\tconfigurable_options {\n\t\t\t\t\tid\n\t\t\t\t\tattribute_id\n\t\t\t\t\tlabel\n\t\t\t\t\tattribute_code\n\t\t\t\t\tvalues {\n\t\t\t\t\t\tvalue_index\n\t\t\t\t\t\tlabel\n\t\t\t\t\t\tswatch_data {\n\t\t\t\t\t\t\tvalue\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\tproduct_id\n\t\t\t\t}\n\t\t\t\tvariants {\n\t\t\t\t\tproduct {\n\t\t\t\t\t\tid\n\t\t\t\t\t\tname\n\t\t\t\t\t\tsku\n\t\t\t\t\t\t__typename\n\t\t\t\t\t\tsmall_image {\n\t\t\t\t\t\t\turl\n\t\t\t\t\t\t\tlabel\n\t\t\t\t\t\t}\n\t\t\t\t\t\tattribute_set_id\n\t\t\t\t\t}\n\t\t\t\t\tattributes {\n\t\t\t\t\t\tlabel\n\t\t\t\t\t\tcode\n\t\t\t\t\t\tvalue_index\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}";
var ProductCarouselData = "query products($id: String!) {\n\tproducts(filter: { sku: { eq: $id } }) {\n\t\titems {\n\t\t\tname\n\t\t\tsku\n\t\t\tpromotion_tag_swatch\n\t\t\tbadges_swatch\n\t\t\tbadges\n\t\t\tbadges_label\n\t\t\tmanufacturer\n\t\t\tquantity\n\t\t\tmanufacturer_label\n\t\t\tpromotion_tag_label\n\t\t\tstock_status\n\t\t\tlow_stock_threshold\n\t\t\tdisplay_low_stock_badge\n\t\t\tcategories {\n\t\t\t\tid\n\t\t\t\tname\n\t\t\t\turl_key\n\t\t\t\timage\n\t\t\t}\n\t\t\t__typename\n\t\t\tdescription {\n\t\t\t\thtml\n\t\t\t}\n\t\t\tmeta_title\n\t\t\tmeta_description\n\t\t\tprice_range {\n\t\t\t\tminimum_price {\n\t\t\t\t\tregular_price {\n\t\t\t\t\t\tvalue\n\t\t\t\t\t\tcurrency\n\t\t\t\t\t}\n\t\t\t\t\tfinal_price {\n\t\t\t\t\t\tvalue\n\t\t\t\t\t\tcurrency\n\t\t\t\t\t}\n\t\t\t\t\tdiscount {\n\t\t\t\t\t\tamount_off\n\t\t\t\t\t\tpercent_off\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tmaximum_price {\n\t\t\t\t\tregular_price {\n\t\t\t\t\t\tvalue\n\t\t\t\t\t\tcurrency\n\t\t\t\t\t}\n\t\t\t\t\tfinal_price {\n\t\t\t\t\t\tvalue\n\t\t\t\t\t\tcurrency\n\t\t\t\t\t}\n\t\t\t\t\tdiscount {\n\t\t\t\t\t\tamount_off\n\t\t\t\t\t\tpercent_off\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\tprice_tiers {\n\t\t\t\tdiscount {\n\t\t\t\t\tamount_off\n\t\t\t\t\tpercent_off\n\t\t\t\t}\n\t\t\t\tfinal_price {\n\t\t\t\t\tvalue\n\t\t\t\t\tcurrency\n\t\t\t\t}\n\t\t\t\tquantity\n\t\t\t}\n\t\t\timage {\n\t\t\t\turl\n\t\t\t\tlabel\n\t\t\t}\n\t\t\tsmall_image {\n\t\t\t\turl\n\t\t\t\tlabel\n\t\t\t}\n\t\t\tmedia_gallery {\n\t\t\t\turl\n\t\t\t\tlabel\n\t\t\t\t... on ProductVideo {\n\t\t\t\t\tvideo_content {\n\t\t\t\t\t\tmedia_type\n\t\t\t\t\t\tvideo_provider\n\t\t\t\t\t\tvideo_url\n\t\t\t\t\t\tvideo_title\n\t\t\t\t\t\tvideo_description\n\t\t\t\t\t\tvideo_metadata\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}";
var guestCreateEmptyCart = "mutation {\n\tcreateEmptyCart\n}";
var guestAddSimpleProductToCart = "mutation addSimpleProductsToCart(\n\t$cart_id: String!\n\t$cart_items: [SimpleProductCartItemInput]!\n) {\n\taddSimpleProductsToCart(\n\t\tinput: { cart_id: $cart_id, cart_items: $cart_items }\n\t) {\n\t\tcart {\n\t\t\titems {\n\t\t\t\tid\n\t\t\t\tproduct {\n\t\t\t\t\tsku\n\t\t\t\t\tstock_status\n\t\t\t\t\tstock_item {\n\t\t\t\t\t\tmin_qty\n\t\t\t\t\t\tmin_sale_qty\n\t\t\t\t\t\tmax_sale_qty\n\t\t\t\t\t}\n\t\t\t\t\tname\n\t\t\t\t}\n\t\t\t\tquantity\n\t\t\t}\n\t\t\ttotal_quantity\n\t\t}\n\t}\n}";
var guestAddConfigurableProductToCart = "mutation addConfigurableProductsToCart(\n\t$cart_id: String!\n\t$cart_items: [ConfigurableProductCartItemInput]!\n) {\n\taddConfigurableProductsToCart(\n\t\tinput: {\n\t\t\tcart_id: $cart_id\n\t\t\tcart_items: $cart_items\n\t\t}\n\t) {\n\t\tcart {\n\t\t\titems {\n\t\t\t\tid\n\t\t\t\tquantity\n\t\t\t\tproduct {\n\t\t\t\t\tname\n\t\t\t\t\tsku\n\t\t\t\t}\n\t\t\t\t... on ConfigurableCartItem {\n\t\t\t\t\tconfigurable_options {\n\t\t\t\t\t\tid\n\t\t\t\t\t\toption_label\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\ttotal_quantity\n\t\t}\n\t}\n}";
var guestAddBundleProduct = "mutation addBundleProductsToCart(\n\t$cart_id: String!\n\t$cart_items: [BundleProductCartItemInput]!\n) {\n\taddBundleProductsToCart(\n\t\tinput: {\n\t\t\tcart_id: $cart_id\n\t\t\tcart_items: $cart_items\n\t\t}\n\t) {\n\t\tcart {\n\t\t\titems {\n\t\t\t\tid\n\t\t\t\tquantity\n\t\t\t\tproduct {\n\t\t\t\t\tsku\n\t\t\t\t}\n\t\t\t\t... on BundleCartItem {\n\t\t\t\t\tbundle_options {\n\t\t\t\t\t\tid\n\t\t\t\t\t\tlabel\n\t\t\t\t\t\ttype\n\t\t\t\t\t\tvalues {\n\t\t\t\t\t\t\tid\n\t\t\t\t\t\t\tlabel\n\t\t\t\t\t\t\tprice\n\t\t\t\t\t\t\tquantity\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}";
var shippingAndBillingAddress = "query($cart_id: String!) {cart(cart_id: $cart_id) {email billing_address {customer_address_id firstname lastname address_type_name address_name region {region_id code label } country {code label } unit_number complex_name street_number street company city suburb postcode telephone instructions } shipping_addresses {customer_address_id firstname lastname address_type_name address_name region {region_id code label } country {code label } unit_number complex_name street_number street company city suburb postcode telephone instructions selected_shipping_method {amount {value currency } carrier_code carrier_title method_code method_title } } } }";
var guestViewCart = "query ($cart_id: String!) {\n  cart(cart_id: $cart_id) {\n    shippingMessageText {\n      delivery_message\n      free_shipping_message\n      free_shipping_method_message\n      standard_shipping_message\n      standard_shipping_method_message\n    }\n    shipping_fee_calculate {\n      method_code\n      carrier_code\n      shipping_label\n      shipping_fee\n    }\n    cart_order_limits {\n      cart_qty_limit\n      order_value_limit\n    }\n    items {\n      id\n      parent_product_sku\n      prices {\n        row_total_original {\n          value\n        }\n        row_total_including_tax {\n          value\n        }\n        total_item_discount {\n          value\n        }\n        price {\n          value\n        }\n        discounts {\n          label\n          amount {\n            value\n          }\n        }\n      }\n      product {\n\t\t... on ConfigurableProduct {\n\t\t\tconfigurable_options {\n\t\t\t  id\n\t\t\t  attribute_id\n\t\t\t  label\n\t\t\t  position\n\t\t\t  use_default\n\t\t\t  attribute_code\n\t\t\t  values {\n\t\t\t\tvalue_index\n\t\t\t\tlabel\n\t\t\t\tswatch_data {\n\t\t\t\t  value\n\t\t\t\t}\n\t\t\t  }\n\t\t\t  product_id\n\t\t\t}\n\t\t\tvariants {\n\t\t\t  product {\n\t\t\t\tid\n\t\t\t\tname\n\t\t\t\tsku\n\t\t\t\tpromotion_tag_label\n\t\t\t\tstock_status\n\t\t\t\tstock_item {\n\t\t\t\t  min_qty\n\t\t\t\t  min_sale_qty\n\t\t\t\t  max_sale_qty\n\t\t\t\t}\n\t\t\t\tattribute_set_id\n\t\t\t\t... on PhysicalProductInterface {\n\t\t\t\t  weight\n\t\t\t\t}\n\t\t\t\tsmall_image {\n\t\t\t\t  url\n\t\t\t\t  label\n\t\t\t\t}\n\t\t\t\tprice_range {\n\t\t\t\t  minimum_price {\n\t\t\t\t\tregular_price {\n\t\t\t\t\t  value\n\t\t\t\t\t  currency\n\t\t\t\t\t}\n\t\t\t\t\tfinal_price {\n\t\t\t\t\t  value\n\t\t\t\t\t  currency\n\t\t\t\t\t}\n\t\t\t\t\tdiscount {\n\t\t\t\t\t  amount_off\n\t\t\t\t\t  percent_off\n\t\t\t\t\t}\n\t\t\t\t  }\n\t\t\t\t  maximum_price {\n\t\t\t\t\tregular_price {\n\t\t\t\t\t  value\n\t\t\t\t\t  currency\n\t\t\t\t\t}\n\t\t\t\t\tfinal_price {\n\t\t\t\t\t  value\n\t\t\t\t\t  currency\n\t\t\t\t\t}\n\t\t\t\t\tdiscount {\n\t\t\t\t\t  amount_off\n\t\t\t\t\t  percent_off\n\t\t\t\t\t}\n\t\t\t\t  }\n\t\t\t\t}\n\t\t\t\tquantity\n\t\t\t\tbadges_label\n\t\t\t\tlow_stock_threshold\n\t\t\t\tattribute_set_id\n\t\t\t  }\n\t\t\t  attributes {\n\t\t\t\tlabel\n\t\t\t\tcode\n\t\t\t\tvalue_index\n\t\t\t  }\n\t\t\t}\n\t\t  }\n        ... on BundleProduct {\n          enable_click_and_collect\n          items {\n            option_id\n            title\n            options {\n              id\n              is_hidden_product\n              is_default\n              label\n              quantity\n              product {\n                id\n                name\n                sku\n                quantity\n                primary_product_sku\n                promo_data\n                ... on ConfigurableProduct {\n                  configurable_options {\n                    id\n                    attribute_id\n                    attribute_code\n                    label\n                    values {\n                      value_index\n                      label\n                      swatch_data {\n                        value\n                      }\n                    }\n                  }\n                  variants {\n                    product {\n                      id\n                      name\n                      sku\n                      stock_status\n                      quantity\n                      low_stock_threshold\n                      image {\n                        url\n                        label\n                      }\n                      __typename\n                    }\n                    attributes {\n                      label\n                      code\n                      value_index\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n        ... on CustomizableProductInterface {\n          options {\n            option_id\n          }\n        }\n        anytime_product_sku\n        name\n        id\n        sku\n        deal_delivery\n        sim_only_flg\n        promotion_tag_label\n        low_stock_threshold\n        quantity\n        stock_status\n        is_deal_product\n        description {\n          html\n        }\n        badges\n        promo_data\n        minutes\n        minutes_label\n        airtime\n        old_monthly_recurring\n        sms\n        plan_name\n        plan_name_label\n        plan_type\n        componentid\n        contract_sku\n        plan_type_label\n        nightowl_units\n        nightowl_uom\n        contract_type\n        contract_type_label\n        payment_terms\n        payment_terms_label\n        badges_label\n        promotion_tag\n        promotion_tag_label\n        promotion_link\n        accessories\n        accessories_label\n        monthly_recurring\n        primary_product_sku\n        categories {\n          id\n          name\n          level\n          category_url\n          description\n        }\n        primary_product_image\n        primary_product_name\n        categories {\n          id\n          name\n        }\n        eppixproductcode\n        __typename\n        image {\n          url\n          label\n        }\n        small_image {\n          url\n          label\n        }\n        ... on SimpleProduct {\n          __typename\n        }\n      }\n      ... on ConfigurableCartItem {\n        configurable_options {\n          id\n          option_label\n          value_id\n          value_label\n        }\n        config_custom_options: customizable_options {\n          id\n          values {\n            id\n            label\n            value\n          }\n        }\n      }\n      ... on BundleCartItem {\n        bundle_custom_options: customizable_options {\n          values {\n            value\n          }\n        }\n        customizable_options {\n          label\n          values {\n            value\n            label\n          }\n        }\n        bundle_customisable_option {\n          attribute_option_id\n          selected_attribute\n        }\n      }\n      quantity\n    }\n    available_payment_methods {\n      code\n      title\n    }\n    selected_payment_method {\n      code\n      title\n    }\n    applied_coupons {\n      code\n    }\n    prices {\n      discounts {\n        amount {\n          value\n        }\n        label\n      }\n      grand_total {\n        value\n        currency\n      }\n      subtotal_including_tax {\n        value\n        currency\n      }\n      subtotal_excluding_tax {\n        value\n        currency\n      }\n      subtotal_with_discount_excluding_tax {\n        value\n        currency\n      }\n      applied_taxes {\n        amount {\n          value\n          currency\n        }\n        label\n      }\n      discounts {\n        amount {\n          value\n        }\n        label\n      }\n    }\n    total_quantity\n  }\n}\n";
var getAttributes = "query products($sku: String!){ products(filter: { sku: { eq: $sku } }) { items {attribute_set_id  internal_storage  internal_storage_label    battery_capacity battery_capacity_label color color_label screen_size_pixels_label screen_size_pixels} attribute_set_config{ attribute_set_id configurable_product_attribute_set_attributes configurable_product_attribute_set_label } }}";
var updateCartItems = "mutation updateCartItems(\n\t$cart_id: String!\n\t$cart_item_id: Int!\n\t$quantity: Float!\n\t$attributes: [SuperAttributeInput]\n\t$customizable_options: [CustomizableOptionInput]!\n) {\n\tupdateCartItems(\n\t\tinput: {\n\t\t\tcart_id: $cart_id\n\t\t\tcart_items: [\n\t\t\t\t{\n\t\t\t\t\tcart_item_id: $cart_item_id\n\t\t\t\t\tquantity: $quantity\n\t\t\t\t\tsuper_attribute: $attributes\n\t\t\t\t\tcustomizable_options: $customizable_options\n\t\t\t\t}\n\t\t\t]\n\t\t}\n\t) {\n\t\tcart {\n\t\t\titems {\n\t\t\t\tid\n\t\t\t\tproduct {\n\t\t\t\t\tsku\n\t\t\t\t\tstock_status\n\t\t\t\t\tstock_item {\n\t\t\t\t\t\tmin_qty\n\t\t\t\t\t\tmin_sale_qty\n\t\t\t\t\t\tmax_sale_qty\n\t\t\t\t\t}\n\t\t\t\t\tname\n\t\t\t\t}\n\t\t\t\tquantity\n\t\t\t}\n\t\t\ttotal_quantity\n\t\t}\n\t}\n}";
var removeCartItems = "mutation removeItemFromCart($cart_id: String!, $cart_item_id: Int!) {\n\tremoveItemFromCart(input: { cart_id: $cart_id, cart_item_id: $cart_item_id }) {\n\t\tcart {\n\t\t\titems {\n\t\t\t\tid\n\t\t\t\tproduct {\n\t\t\t\t\tsku\n\t\t\t\t\tname\n\t\t\t\t}\n\t\t\t\tquantity\n\t\t\t}\n\t\t\ttotal_quantity\n\t\t}\n\t}\n}";
var generateCustomerToken = "mutation generateCustomerToken(\n\t$email: String!\n\t$password: String!\n\t) {\n\t  generateCustomerToken(\n\t\temail: $email\n\t password: $password\n\t  ) {\n\t\ttoken\n\t  }\n\t}";
var setGuestEmailOnCart = "mutation setGuestEmailOnCart(\n\t$cart_id: String!\n\t$email: String!\n\t) {\n\t\tsetGuestEmailOnCart(\n\t\t\tinput: {\n\t\t\t  cart_id: $cart_id\n\t\t\t  email: $email\n\t\t\t}\n\t\t  ) {\n\t\t\tcart {\n\t\t\t  email\n\t\t\t}\n\t\t  }\n\t}";
var getAllCustomerAddressLists = "{\n\tcustomer {\n\t\tfirstname\n\t\tlastname\n\t\ttelephone\n\t\tsuffix\n\t\temail\n\t\taddresses {\n\t\t\tid\n\t\t\tfirstname\n            lastname\n            address_type_name\n            address_name\n            region {\n                region_id\n                region\n                region_code\n            }\n            country_code\n            unit_number\n            complex_name\n            street_number\n            street\n            company\n            city\n            suburb\n            postcode\n            telephone\n            instructions\n            default_shipping\n\t\t\tdefault_billing\n\t\t\tis_shipping_address\n\t\t\tis_billing_address\n\t\t}\n\t}\n}";
var setNewBillingAddress = "mutation setBillingAddressOnCart(\n\t$cart_id: String!\n\t$firstname: String!\n\t$lastname: String!\n\t$company: String\n\t$instructions: String\n\t$street: [String]!\n\t$city: String!\n\t$region: String!\n\t$address_type_name: String!\n\t$address_name: String!\n\t$unit_number: String\n\t$complex_name: String\n\t$street_number: String\n\t$suburb: String!\n\t$postcode: String!\n\t$country_code: String!\n\t$telephone: String!\n\t$save_in_address_book: Boolean\n\t$is_shipping_address: Int!\n\t$is_billing_address: Int!\n\t$same_as_shipping: Boolean\n) {\n\tsetBillingAddressOnCart(\n\t\tinput: {\n\t\t\tcart_id: $cart_id\n\t\t\tbilling_address: {\n\t\t\t\taddress: {\n\t\t\t\t\tfirstname: $firstname\n\t\t\t\t\tlastname: $lastname\n\t\t\t\t\tcompany: $company\n\t\t\t\t\tinstructions: $instructions\n\t\t\t\t\tstreet: $street\n\t\t\t\t\tcity: $city\n\t\t\t\t\tregion: $region\n\t\t\t\t\taddress_type_name: $address_type_name\n\t\t\t\t\taddress_name: $address_name\n\t\t\t\t\tunit_number: $unit_number\n\t\t\t\t\tcomplex_name: $complex_name\n\t\t\t\t\tstreet_number: $street_number\n\t\t\t\t\tsuburb: $suburb\n\t\t\t\t\tpostcode: $postcode\n\t\t\t\t\tcountry_code: $country_code\n\t\t\t\t\ttelephone: $telephone\n\t\t\t\t\tsave_in_address_book: $save_in_address_book\n\t\t\t\t\tis_shipping_address: $is_shipping_address\n\t\t\t\t\tis_billing_address: $is_billing_address\n\t\t\t\t}\n\t\t\t\tsame_as_shipping: $same_as_shipping\n\t\t\t}\n\t\t}\n\t) {\n\t\tcart {\n\t\t\tbilling_address {\n\t\t\t\tcustomer_address_id\n\t\t\t\tfirstname\n\t\t\t\tlastname\n                address_type_name\n\t\t\t\taddress_name\n                region {\n\t\t\t\t\tregion_id\n\t\t\t\t\tcode\n\t\t\t\t\tlabel\n\t\t\t\t}\n                country {\n\t\t\t\t\tcode\n\t\t\t\t\tlabel\n\t\t\t\t}\n                unit_number\n\t\t\t\tcomplex_name\n\t\t\t\tstreet_number\n                street\n\t\t\t\tcompany\n\t\t\t\tcity\n\t\t\t\tsuburb\n\t\t\t\tpostcode\n\t\t\t\ttelephone\n\t\t\t\tinstructions\n\t\t\t\tis_shipping_address\n\t\t\t\tis_billing_address\n\t\t\t}\n\t\t}\n\t}\n}";
var setExistingBillAddress = "mutation setBillingAddressOnCart(\n\t$cart_id: String!\n\t$customer_address_id: Int!\n\t$same_as_shipping: Boolean\n) {\n\tsetBillingAddressOnCart(\n\t\tinput: {\n\t\t\tcart_id: $cart_id\n\t\t\tbilling_address: { customer_address_id: $customer_address_id, same_as_shipping: $same_as_shipping}\n\t\t}\n\t) {\n\t\tcart {\n\t\t\tbilling_address {\n\t\t\t\tcustomer_address_id\n\t\t\t\tfirstname\n\t\t\t\tlastname\n                address_type_name\n\t\t\t\taddress_name\n                region {\n\t\t\t\t\tregion_id\n\t\t\t\t\tcode\n\t\t\t\t\tlabel\n\t\t\t\t}\n                country {\n\t\t\t\t\tcode\n\t\t\t\t\tlabel\n\t\t\t\t}\n                unit_number\n\t\t\t\tcomplex_name\n\t\t\t\tstreet_number\n                street\n\t\t\t\tcompany\n\t\t\t\tcity\n\t\t\t\tsuburb\n\t\t\t\tpostcode\n\t\t\t\ttelephone\n\t\t\t\tinstructions\n\t\t\t\tis_shipping_address\n\t\t\t\tis_billing_address\n\t\t\t}\n\t\t}\n\t}\n}";
var setNewShippingAddress = "mutation setShippingAddressesOnCart(\n\t$cart_id: String!\n\t$firstname: String!\n\t$lastname: String!\n\t$company: String\n\t$instructions: String\n\t$street: [String]!\n\t$city: String!\n\t$region: String!\n\t$address_type_name: String!\n\t$address_name: String!\n\t$unit_number: String\n\t$complex_name: String\n\t$street_number: String\n\t$suburb: String!\n\t$postcode: String!\n\t$country_code: String!\n\t$telephone: String!\n\t$save_in_address_book: Boolean\n\t$is_shipping_address: Int!\n) {\n\tsetShippingAddressesOnCart(\n\t\tinput: {\n\t\t\tcart_id: $cart_id\n\t\t\tshipping_addresses: [\n\t\t\t\t{\n\t\t\t\t\taddress: {\n\t\t\t\t\t\tfirstname: $firstname\n\t\t\t\t\t\tlastname: $lastname\n\t\t\t\t\t\tcompany: $company\n\t\t\t\t\t\tinstructions: $instructions\n\t\t\t\t\t\tstreet: $street\n\t\t\t\t\t\tcity: $city\n\t\t\t\t\t\tregion: $region\n\t\t\t\t\t\taddress_type_name: $address_type_name\n\t\t\t\t\t\taddress_name: $address_name\n\t\t\t\t\t\tunit_number: $unit_number\n\t\t\t\t\t\tcomplex_name: $complex_name\n\t\t\t\t\t\tstreet_number: $street_number\n\t\t\t\t\t\tsuburb: $suburb\n\t\t\t\t\t\tpostcode: $postcode\n\t\t\t\t\t\tcountry_code: $country_code\n\t\t\t\t\t\ttelephone: $telephone\n\t\t\t\t\t\tsave_in_address_book: $save_in_address_book\n\t\t\t\t\t\tis_shipping_address: $is_shipping_address\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t]\n\t\t}\n\t) {\n\t\tcart {\n\t\t\tshipping_addresses {\n\t\t\t\tcustomer_address_id\n\t\t\t\tfirstname\n\t\t\t\tlastname\n                address_type_name\n\t\t\t\taddress_name\n                region {\n\t\t\t\t\tregion_id\n\t\t\t\t\tcode\n\t\t\t\t\tlabel\n\t\t\t\t}\n                country {\n\t\t\t\t\tcode\n\t\t\t\t\tlabel\n\t\t\t\t}\n                unit_number\n\t\t\t\tcomplex_name\n\t\t\t\tstreet_number\n                street\n\t\t\t\tcompany\n\t\t\t\tcity\n\t\t\t\tsuburb\n\t\t\t\tpostcode\n\t\t\t\ttelephone\n\t\t\t\tinstructions\n\t\t\t\tis_shipping_address\n\t\t\t\tis_billing_address\n                selected_shipping_method {\n                    amount {\n                        value\n                        currency\n                    }\n                    carrier_code\n                    carrier_title\n                    method_code\n                    method_title\n                }\n\t\t\t}\n\t\t}\n\t}\n}";
var setExistingShippingAddress = "mutation setShippingAddressesOnCart(\n\t$cart_id: String!\n\t$customer_address_id: Int!\n) {\n\tsetShippingAddressesOnCart(\n\t\tinput: {\n\t\t\tcart_id: $cart_id\n\t\t\tshipping_addresses: [{ customer_address_id: $customer_address_id }]\n\t\t}\n\t) {\n\t\tcart {\n\t\t\tshipping_addresses {\n\t\t\t\tcustomer_address_id\n\t\t\t\tfirstname\n\t\t\t\tlastname\n                address_type_name\n\t\t\t\taddress_name\n                region {\n\t\t\t\t\tregion_id\n\t\t\t\t\tcode\n\t\t\t\t\tlabel\n\t\t\t\t}\n                country {\n\t\t\t\t\tcode\n\t\t\t\t\tlabel\n\t\t\t\t}\n                unit_number\n\t\t\t\tcomplex_name\n\t\t\t\tstreet_number\n                street\n\t\t\t\tcompany\n\t\t\t\tcity\n\t\t\t\tsuburb\n\t\t\t\tpostcode\n\t\t\t\ttelephone\n\t\t\t\tinstructions\n\t\t\t\tis_shipping_address\n\t\t\t\tis_billing_address\n                selected_shipping_method {\n                    amount {\n                        value\n                        currency\n                    }\n                    carrier_code\n                    carrier_title\n                    method_code\n                    method_title\n                }\n\t\t\t}\n\t\t}\n\t}\n}";
var updateCustomerAddress = "mutation updateCustomerAddress(\n\t$id: Int!\n\t$region_id: Int!\n\t$region: String!\n\t$region_code: String!\n\t$company: String\n\t$instructions: String\n\t$street: [String]!\n\t$telephone: String!\n\t$postcode: String!\n\t$city: String!\n\t$address_type_name: String!\n\t$address_name: String!\n\t$unit_number: String\n\t$complex_name: String\n\t$street_number: String\n\t$suburb: String!\n\t$firstname: String!\n\t$lastname: String!\n\t$default_shipping: Boolean!\n\t$default_billing: Boolean!\n\t$is_shipping_address: Int!\n\t$is_billing_address: Int!\n) {\n\tupdateCustomerAddress(\n\t\tid: $id\n\t\tinput: {\n\t\t\tregion: { region_id: $region_id, region: $region, region_code: $region_code }\n\t\t\tcountry_code: ZA\n\t\t\tinstructions: $instructions\n\t\t\tcompany: $company\n\t\t\tstreet: $street\n\t\t\ttelephone: $telephone\n\t\t\tpostcode: $postcode\n\t\t\tcity: $city\n\t\t\taddress_type_name: $address_type_name\n\t\t\taddress_name: $address_name\n\t\t\tunit_number: $unit_number\n\t\t\tcomplex_name: $complex_name\n\t\t\tstreet_number: $street_number\n\t\t\tsuburb: $suburb\n\t\t\tfirstname: $firstname\n\t\t\tlastname: $lastname\n\t\t\tdefault_shipping: $default_shipping\n\t\t\tdefault_billing: $default_billing\n\t\t\tis_shipping_address: $is_shipping_address\n\t\t\tis_billing_address: $is_billing_address\n\t\t}\n\t) {\n\t\tid\n\t\tfirstname\n\t\tlastname\n        address_type_name\n\t\taddress_name\n\t\tregion {\n\t\t\tregion_id\n\t\t\tregion\n\t\t\tregion_code\n\t\t}\n        country_code\n        unit_number\n\t\tcomplex_name\n\t\tstreet_number\n\t\tstreet\n        company\n\t\tcity\n\t\tsuburb\n        postcode\n        telephone\n        instructions\n\t\tdefault_shipping\n\t\tdefault_billing\n\t\tis_shipping_address\n\t\tis_billing_address\n\t}\n}";
var createCustomerAddress = "mutation createCustomerAddress(\n\t$region_id: Int!\n\t$region: String!\n\t$region_code: String!\n\t$company: String\n\t$instructions: String\n\t$street: [String]!\n\t$telephone: String!\n\t$postcode: String!\n\t$city: String!\n\t$address_type_name: String!\n\t$address_name: String!\n\t$unit_number: String\n\t$complex_name: String\n\t$street_number: String\n\t$suburb: String!\n\t$firstname: String!\n\t$lastname: String!\n\t$default_shipping: Boolean!\n\t$default_billing: Boolean!\n\t$is_shipping_address: Int!\n\t$is_billing_address: Int!\n) {\n\tcreateCustomerAddress(\n\t\tinput: {\n\t\t\tregion: { region_id: $region_id, region: $region, region_code: $region_code }\n\t\t\tcountry_code: ZA\n\t\t\tinstructions: $instructions\n\t\t\tcompany: $company\n\t\t\tstreet: $street\n\t\t\ttelephone: $telephone\n\t\t\tpostcode: $postcode\n\t\t\tcity: $city\n\t\t\taddress_type_name: $address_type_name\n\t\t\taddress_name: $address_name\n\t\t\tunit_number: $unit_number\n\t\t\tcomplex_name: $complex_name\n\t\t\tstreet_number: $street_number\n\t\t\tsuburb: $suburb\n\t\t\tfirstname: $firstname\n\t\t\tlastname: $lastname\n\t\t\tdefault_shipping: $default_shipping\n\t\t\tdefault_billing: $default_billing\n\t\t\tis_shipping_address: $is_shipping_address\n\t\t\tis_billing_address: $is_billing_address\n\t\t}\n\t) {\n\t\tid\n\t\tfirstname\n\t\tlastname\n        address_type_name\n\t\taddress_name\n\t\tregion {\n\t\t\tregion_id\n\t\t\tregion\n\t\t\tregion_code\n\t\t}\n        country_code\n        unit_number\n\t\tcomplex_name\n\t\tstreet_number\n\t\tstreet\n        company\n\t\tcity\n\t\tsuburb\n        postcode\n        telephone\n        instructions\n\t\tdefault_shipping\n\t\tdefault_billing\n\t\tis_shipping_address\n\t\tis_billing_address\n\t}\n}";
var getSAStates = "query {\n    country(id: \"ZA\") {\n        id\n        full_name_english\n        available_regions {\n            id\n            code\n            name\n        }\n    }\n}";
var getAddressTypes = "{\n\taddressType {\n\t\tallOptions{\n\t\t  id\n\t\t  label\n\t\t}\n\t}\n  }";
var getCustomerActiveCart = "{\n\tcustomerCart {\n\t  id\n\t  items {\n\t\tid\n\t\tproduct {\n\t\t  name\n\t\t  sku\n\t\t}\n\t\tquantity\n\t  }\n\t}\n  }";
var getDealSkus = "\n   query products($name: String)\n\t{\n\t\tDealSelection (sku: $name)\n\t\t{\n\t\tdeal_skus\n\t\t}\n}";
var DealSelection = "\n   query products($filter: ProductAttributeFilterInput,$sort:ProductAttributeSortInput, $pageSize: Int, $currentPage: Int) {\n\t products(\n\t\t filter: $filter,\n\t\t pageSize: $pageSize,\n\t\t currentPage: $currentPage sort: $sort\n\t ) {\n\t\t total_count\n\t\t page_info {\n\t\t\t page_size\n\t\t\t current_page\n\t\t\t total_pages\n\t\t }\n\t\t items {\n\t\t\tname\n\t\t\turl_key\n\t\t\tsku\n\t\t\tpromo_data\n\t\t\tminutes\n\t\t\tpromotion_tag_swatch\n\t\t\tminutes_label\n\t\t\tairtime\n\t\t\tsms\n\t\t\tprimary_product_image\n\t\t\tprimary_product_sku\n\t\t\tcontract_sku\n\t\t\tpayment_terms\n\t\t\tpayment_terms_label\n\t\t\tpackage_description\n\t\t\tpromotion_tag\n\t\t\tpromotion_tag_label\n\t\t\tmonthly_recurring\n\t\t\told_tariff\n\t\t\told_installment\n\t\t\told_monthly_recurring\n\t\t\tsave_monthly_recurring\n\t\t\tstock_status\n\t\t\tdeal_go_live_date\n\t\t\tdeal_end_date\n\t\t\tdeal_label\n\t\t\tis_deal_locked\n\t\t\t__typename\n\t\t\timage {\n\t\t\t  url\n\t\t\t}\n\t\t\tsmall_image {\n\t\t\t  url\n\t\t\t}\n\t\t  }\n\t\t aggregations {\n\t\t\tattribute_code\n\t\t\toptions {\n\t\t\t  label\n\t\t\t  value\n\t\t\t}\n\t\t }\n\t\t price_range {\n\t\t\tattribute_code\n\t\t\tmin_value\n\t\t\tmax_value\n\t\t  }\n\t }\n }";
var getAttributeOptions = "query {\n\t customAttributeMetadata(\n\t   attributes: [\n\t\t {\n\t\t   attribute_code: \"plan_type\"\n\t\t   entity_type: \"4\"\n\t\t }\n\t\t {\n\t\t   attribute_code: \"accessories\"\n\t\t   entity_type: \"4\"\n\t\t }\n\t\t {\n\t\t   attribute_code: \"plan_name\"\n\t\t   entity_type: \"4\"\n\t\t }\n\t\t {\n\t\t   attribute_code: \"contract_type\"\n\t\t   entity_type: \"4\"\n\t\t }\n\t\t {\n\t\t   attribute_code: \"promotion_tag\"\n\t\t   entity_type: \"4\"\n\t\t }\n\t\t {\n\t\t   attribute_code: \"payment_terms\"\n\t\t   entity_type: \"4\"\n\t\t }\n\t   ]\n\t ) {\n\t   items {\n\t\t attribute_code\n\t\t attribute_type\n\t\t attribute_options {\n\t\t  value\n\t\t  label\n\t\t  default\n\t\t}\n\t   }\n\t }\n\t contract_type_desc {\n\t\tcontract_type_option_label\n        contract_type_desc\n\t  }\n   }";
var dealGrid = "query products( $search: String $filter: ProductAttributeFilterInput $sort: ProductAttributeSortInput $pageSize: Int $currentPage: Int ) { contract_type_desc { contract_type_option_label contract_type_desc } products( search: $search filter: $filter pageSize: $pageSize currentPage: $currentPage sort: $sort ) { total_count page_info { page_size current_page total_pages } items { name url_key sku promo_data minutes categories { id name level } promotion_tag_swatch minutes_label airtime sms primary_product_image primary_product_sku contract_sku payment_terms payment_terms_label package_description promotion_tag promotion_tag_label monthly_recurring old_tariff old_installment old_monthly_recurring save_monthly_recurring stock_status deal_go_live_date deal_end_date deal_label is_deal_locked __typename image { url } small_image { url } } aggregations { label attribute_code options { label value } } price_range { attribute_code min_value max_value } } }";
var setShippingMethodsOnCart = "mutation setShippingMethodsOnCart(\n\t$cart_id: String!,\n\t$carrier_code: String!,\n\t$method_code: String!\n\t){\n\tsetShippingMethodsOnCart(\n\t\tinput: {\n\t\tcart_id: $cart_id,\n\t\tshipping_methods: [\n\t\t\t{\n\t\t\tcarrier_code: $carrier_code,\n\t\t\tmethod_code: $method_code\n\t\t\t}\n\t\t]\n\t\t}\n\t) {\n\t\tcart {\n\t\tshipping_addresses {\n\t\t\tselected_shipping_method {\n\t\t\tcarrier_code\n\t\t\tcarrier_title\n\t\t\tmethod_code\n\t\t\tmethod_title\n\t\t\tamount {\n\t\t\t\tvalue\n\t\t\t\tcurrency\n\t\t\t}\n\t\t\t}\n\t\t}\n\t\t}\n\t}\n}";
var setPaymentMethodOnCart = "mutation setPaymentMethodOnCart(\n\t$cart_id: String!\n\t$payment_code: String!\n){\n\tsetPaymentMethodOnCart(input: {\n\t\tcart_id: $cart_id\n\t\tpayment_method: {\n\t\t\tcode: $payment_code\n\t\t}\n\t}) {\n\t\tcart {\n\t\tselected_payment_method {\n\t\t\tcode\n\t\t\ttitle\n\t\t}\n\t\t}\n\t}\n}";
var placeOrder = "mutation placeOrder(\n\t\t$cart_id: String!\n\t){placeOrder(\n\t\t  input: {\n\t\t\tcart_id: $cart_id\n\t\t  }\n\t\t) {\n\t\t\torder {\n\t\t\t\torder_number\n\t\t\t\ttracking_number\n\t\t\t\tcourier_partner\n\t\t\t\tdelivery_address\n\t\t\t\tcontact_person\n\t\t\t\tpayment_status\n\t\t\t\tgrand_total\n\t\t\t\tcustomer_name\n\t\t\t\tcustomer_email\n\t\t\t\titems {\n\t\t\t\t\timage\n\t\t\t\t\ttitle\n\t\t\t\t\tprice\n\t\t\t\t\t  qty\n\t\t\t\t  regular_price\n\t\t\t\t  configurable_options{\n\t\t\t\t\tid\n\t\t\t\t\toption_label\n\t\t\t\t\tvalue_id\n\t\t\t\t\toption_value\n\t\t\t\t  }\n\t\t\t\t  bundle_options {\n\t\t\t\t\t\t\tid\n\t\t\t\t\t\t\tlabel\n\t\t\t\t\t\t\tvalues {\n\t\t\t\t\t\t\t\tlabel\n\t\t\t\t\t\t\t\tprice\n\t\t\t\t\t\t\t\tquantity\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t invoice_url\n\t\t\t\tdelivery_time_message\n\t\t\t}\n\t\t}\n\t}";
var BannerDetails = " query banners($grid:String,$brand:String,$promotion:String){ banners(grid:$grid,brand:$brand,promotion:$promotion){ banner_image banner_icon_image banner_heading banner_heading_descriptions banner_url banner_mobile_image } }";
var AlertDetails = "\n\tquery productAlert($productId:String){\n\t\tproductAlert(productId:$productId){\n\t\tmessage\n\t\t}\n\t}";
var salesOrderDetail = "query salesOrder($id: String){\n\tsalesOrder(id: $id) {\n    increment_id\n    customer_name\n    grand_total\n    order_type\n    is_guest_customer\n    created_at\n    shipping_method\n    customer_email\n    tracking_number\n    courier_partner\n    delivery_address\n    delivery_fee\n    sim_only_flg\n    contact_person\n    payment_status\n    order_status\n    invoice_url\n    delivery_time_message\n    estimated_delivery_date\n    waybill_number\n    discount_amount\n    cancel_order_duration_in_minutes\n    ordered_product_details {\n      product_details\n    }\n    journey_type\n    vetting_result\n    items {\n      image\n      title\n      price\n      qty\n      primary_product_image\n      vas_category_image\n      description\n      regular_price\n      is_deal_product\n      monthly_recurring\n      parent_product_sku\n\t\t\tpromo_data\n      configurable_options{\n        id\n        option_label\n        value_id\n        option_value\n        attribute_code\n      }\n      bundle_options {\n        id\n        label\n        values {\n          label\n          price\n          quantity\n        }\n      }\n    }\n\t}\n}";
var customerPreviousOrders = "query customerPlacedOrder($year: String, $sort: SortEnum, $pageSize: Int, $currentPage: Int ) {\n\tcustomerPlacedOrder (year: $year, order_id:\"\", sort:{ created_at:$sort }, pageSize: $pageSize, currentPage: $currentPage) {\n\t\ttotal_count\n\t}\n}";
var customerPlacedOrder = "query customerPlacedOrder($order_id: String, $year: String, $sort: SortEnum, $pageSize: Int, $currentPage: Int ) {\n\tcustomerPlacedOrder ( year: $year, order_id:$order_id, sort:{ created_at:$sort }, pageSize: $pageSize, currentPage: $currentPage) {\n\t\ttotal_count\n\t\tpage_info {\n\t\t\tpage_size\n\t\t\t\tcurrent_page\n\t\t\t\ttotal_pages\n\t\t}\n\t\tallOrderRecords{\n\t\t\torder_id\n\t\t\tincrement_id\n\t\t\tcustomer_name\n\t\t\tgrand_total\n\t\t\tmonthly_recurring\n\t\t\tpayment_terms\n\t\t\tpayment_terms_label\n\t\t\tcreated_at\n\t\t\tshipping_method\n\t\t\tstatus\n\t\t\testimated_delivery_date\n\t\t\torder_type\n\t\t\timage\n\t\t\tprimary_product_image\n\t\t\tview_order_history\n\t\t\tcancel_order_duration_in_minutes\n\t\t\twaybill_number\n\t\t}\n\t}\n}";
var AddCouponCode = "mutation applyCouponToCart($cart_id: String!, $coupon_code: String!) {\n\tapplyCouponToCart(input: { cart_id: $cart_id, coupon_code: $coupon_code }) {\n\t\tcart {\n\t\t\titems {\n\t\t\t\tproduct {\n\t\t\t\t\tname\n\t\t\t\t}\n\t\t\t\tprices {\n\t\t\t\t\ttotal_item_discount {\n\t\t\t\t\t\tvalue\n\t\t\t\t\t}\n\t\t\t\t\tprice {\n\t\t\t\t\t\tvalue\n\t\t\t\t\t}\n\t\t\t\t\tdiscounts {\n\t\t\t\t\t\tlabel\n\t\t\t\t\t\tamount {\n\t\t\t\t\t\t\tvalue\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tproduct {\n\t\t\t\t\tname\n\t\t\t\t\tsku\n\t\t\t\t}\n\t\t\t\tquantity\n\t\t\t}\n\t\t\tapplied_coupons {\n\t\t\t\tcode\n\t\t\t}\n\t\t\tprices {\n\t\t\tgrand_total {\n\t\t\t\t\tvalue\n\t\t\t\t\tcurrency\n\t\t\t\t}\n\t\t\t\tsubtotal_including_tax {\n\t\t\t\t\tvalue\n\t\t\t\t\tcurrency\n\t\t\t\t}\n\t\t\t\tsubtotal_excluding_tax {\n\t\t\t\t\tvalue\n\t\t\t\t\tcurrency\n\t\t\t\t}\n\n\t\t\t\tsubtotal_with_discount_excluding_tax {\n\t\t\t\t\tvalue\n\t\t\t\t\tcurrency\n\t\t\t\t}\n\t\t\t\tapplied_taxes {\n\t\t\t\t\tamount {\n\t\t\t\t\t\tvalue\n\t\t\t\t\t\tcurrency\n\t\t\t\t\t}\n\t\t\t\t\tlabel\n\t\t\t\t}\n\t\t\t\tdiscounts {\n\t\t\t\t\tamount {\n\t\t\t\t\t\tvalue\n\t\t\t\t\t}\n\t\t\t\t\tlabel\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}";
var DealDetail = "query products($url_key: [String]) {\n\tcontract_type_desc {\n\t  contract_type_option_label\n\t  contract_type_desc\n\t}\n\tproducts(filter: { url_key: { in: $url_key } }) {\n    items {\n      id\n\t  url_key\n\t  deal_delivery\n      name\n      meta_title\n      meta_description\n      sku\n\t  contract_sku\n      sim_only_flg\n      categories {\n      id\n      name\n      }\n      promotion_tag\n      promotion_tag_swatch\n      badges_swatch\n      badges\n      promotion_link\n      badges_label\n      __typename\n      delivery_message\n      tariff\n      installment\n      old_installment\n      old_tariff\n      monthly_recurring\n      old_monthly_recurring\n      save_monthly_recurring\n      stock_status\n      payment_terms\n      payment_terms_label\n      primary_product_sku\n      primary_product_image\n      anytime_product_sku\n      promotion_tag\n      promotion_tag_description\n      promotion_tag_label\n      delivery_and_return\n      promo_data\n      nightowl_units\n      nightowl_uom\n      minutes\n      minutes_label\n      airtime\n      sms\n      plan_type_label\n      plan_name_label\n      contract_type_label\n      contract_type\n      voucher_url\n      promotion_link\n      internal_storage\n      internal_storage_label\n      battery_capacity_label\n      color\n      color_label\n      stock_message {\n      out_of_stock_title\n      out_of_stock_description\n      low_stock_title\n      low_stock_description\n      }\n      image {\n      url\n      label\n      }\n      small_image {\n      url\n      label\n      }\n      media_gallery {\n      url\n      label\n      }\n      ... on CustomizableProductInterface {\n      options {\n      title\n      required\n      sort_order\n      option_id\n      __typename\n      ... on CustomizableDropDownOption {\n      title\n      value {\n      price_type\n      option_type_id\n      title\n      sku\n      }\n      }\n      }\n      }\n      ... on BundleProduct {\n        enable_click_and_collect\n        items {\n          option_id\n          title\n          required\n          type\n          position\n          sku\n          options {\n            id\n            quantity\n            position\n            is_default\n            price\n            price_type\n            is_hidden_product\n            can_change_quantity\n            label\n            product {\n              id\n              name\n              sku\n              quantity\n              stock_status\n              primary_product_image\n              promotion_link\n              primary_product_sku\n              promo_data\n              nightowl_units\n              nightowl_uom\n              minutes\n              minutes_label\n              airtime\n              sms\n              badges\n              visibility\n              attribute_set_id\n              badges_label\n              promotion_tag_swatch\n              badges_swatch\n              color\n              color_label\n              size\n              size_label\n              screen_size_pixels_label\n              internal_storage\n              internal_storage_label\n              battery_capacity_label\n              manufacturer\n              manufacturer_label\n              __typename\n              image {\n                url\n                label\n              }\n              ... on ConfigurableProduct {\n                configurable_options {\n                  id\n                  attribute_id\n                  label\n                  position\n                  use_default\n                  attribute_code\n                  values {\n                    value_index\n                    label\n                    swatch_data {\n                      value\n                    }\n                  }\n                  product_id\n                }\n                variants {\n                  product {\n                    id\n                    name\n                    sku\n                    stock_status\n                    quantity\n                    low_stock_threshold\n                    image {  url label }\n                    __typename\n                    price_range {\n                      minimum_price {\n                        regular_price {\n                          value\n                          currency\n                        }\n                        final_price {\n                          value\n                          currency\n                        }\n                        discount {\n                          amount_off\n                          percent_off\n                        }\n                      }\n                      maximum_price {\n                        regular_price {\n                          value\n                        }\n                        final_price {\n                          value\n                        }\n                        discount {\n                          amount_off\n                          percent_off\n                        }\n                      }\n                    }\n                  }\n                  attributes {\n                    label\n                    code\n                    value_index\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      related_products {\n        name\n        sku\n        primary_product_image\n        primary_product_sku\n        promotion_tag_swatch\n        badges_swatch\n        badges\n        badges_label\n        quantity\n        componentid\n        url_key\n        low_stock_threshold\n        display_low_stock_badge\n        plan_type_label\n        plan_name_label\n        promo_data\n        nightowl_units\n        nightowl_uom\n        minutes\n        minutes_label\n        airtime\n        sms\n        payment_terms\n        payment_terms_label\n        tariff\n        installment\n        old_installment\n        old_tariff\n        monthly_recurring\n        old_monthly_recurring\n        save_monthly_recurring\n      }\n      upsell_products {\n        name\n        sku\n        primary_product_image\n        primary_product_sku\n        promotion_tag_swatch\n        badges_swatch\n        badges\n        badges_label\n        quantity\n        componentid\n        contract_sku\n        low_stock_threshold\n        display_low_stock_badge\n        plan_type_label\n        plan_name_label\n        promo_data\n        nightowl_units\n        nightowl_uom\n        minutes\n        minutes_label\n        airtime\n        sms\n        payment_terms\n        payment_terms_label\n        tariff\n        install\n        old_installment\n        old_tariff\n        monthly_recurring\n        old_monthly_recurring\n        save_monthly_recurring\n      }\n      crosssell_products {\n        name\n        sku\n        primary_product_image\n        primary_product_sku\n        promotion_tag_swatch\n        badges_swatch\n        badges\n        badges_label\n        quantity\n        low_stock_threshold\n        display_low_stock_badge\n        plan_type_label\n        plan_name_label\n        promo_data\n        nightowl_units\n        nightowl_uom\n        minutes\n        minutes_label\n        airtime\n        sms\n        componentid\n        contract_sku\n        payment_terms\n        payment_terms_label\n        tariff\n        installment\n        old_installment\n        old_tariff\n        monthly_recurring\n        old_monthly_recurring\n        save_monthly_recurring\n      }\n    }\n\t  attribute_set_config {\n      attribute_set_id\n      configurable_product_attribute_set_attributes\n      configurable_product_attribute_set_label\n\t  }\n\t}\n}";
var RelatedDeals = "query products($manufacturer: String) {\n\tproducts(\n\t\tfilter: {\n\t\t\tmanufacturer: { eq: $manufacturer }\n\t\t\tprice: { from: \"0.001\", to: \"9999999999\" }\n\t\t\tis_deal_product: { eq: \"0\" }\n\t\t\tis_hidden_product: { eq: \"0\" }\n\t\t\tis_esd_product: { eq: \"0\"}\n\t\t}\n\t\tpageSize: 4\n\t\tcurrentPage: 1\n\t) {\n\t\titems {\n\t\t\tairtime\n\t\t\turl_key\n\t\t\tbadges_label\n\t\t\tcontract_sku\n\t\t\tdeal_end_date\n\t\t\tdeal_go_live_date\n\t\t\tdeal_label\n\t\t\tid\n\t\t\timage {\n        url\n      }\n\t\t\tinstallment\n\t\t\tis_deal_locked\n\t\t\tmeta_title\n\t\t\tmeta_description\n\t\t\tminutes_label\n\t\t\tmonthly_recurring\n\t\t\tname\n\t\t\told_installment\n\t\t\told_monthly_recurring\n\t\t\told_tariff\n\t\t\tpackage_description\n\t\t\tpayment_terms\n\t\t\tpayment_terms_label\n\t\t\tprimary_product_image\n      primary_product_sku\n\t\t\tpromo_data\n\t\t\tpromotion_tag_label\n\t\t\tpromotion_tag_swatch\n\t\t\tquantity\n\t\t\tsave_monthly_recurring\n\t\t\tsmall_image {\n\t\t\t\turl\n\t\t\t\tlabel\n\t\t\t}\n\t\t\tsms\n\t\t\tsku\n\t\t\ttariff\n\t\t}\n\t}\n}";
var DealSelectionDetail = "query products($contract_skus: [String]) { contract_type_desc { contract_type_option_label contract_type_desc } products(filter: { url_key: { in: $contract_skus} }) { items { id name categories{ id name } promotion_tag promotion_tag_swatch badges_swatch badges promotion_link badges_label __typename eppixproductcode delivery_message tariff installment old_installment old_tariff monthly_recurring old_monthly_recurring save_monthly_recurring stock_status payment_terms payment_terms_label primary_product_sku primary_product_image anytime_product_sku promotion_tag promotion_tag_description promotion_tag_label delivery_and_return promo_data nightowl_units nightowl_uom minutes minutes_label airtime sms plan_type_label plan_name_label contract_type_label contract_type voucher_url promotion_link internal_storage internal_storage_label battery_capacity_label color color_label stock_message { out_of_stock_title out_of_stock_description low_stock_title low_stock_description } image { url label } small_image{ url label } media_gallery { url label } ... on CustomizableProductInterface { options { title required sort_order option_id __typename ... on CustomizableDropDownOption { title value { price_type option_type_id title sku } } } } ... on BundleProduct { enable_click_and_collect items { option_id title required type position sku options { id quantity position is_default price price_type is_hidden_product can_change_quantity label product { id name sku quantity stock_status primary_product_image promotion_link primary_product_sku promo_data nightowl_units nightowl_uom minutes minutes_label airtime sms badges visibility attribute_set_id badges_label promotion_tag_swatch badges_swatch color color_label size size_label screen_size_pixels_label internal_storage internal_storage_label battery_capacity_label __typename image { url label } } } } } related_products { name sku primary_product_image primary_product_sku promotion_tag_swatch badges_swatch badges badges_label quantity componentid contract_sku low_stock_threshold display_low_stock_badge plan_type_label plan_name_label promo_data nightowl_units nightowl_uom minutes minutes_label airtime sms payment_terms payment_terms_label tariff installment old_installment old_tariff monthly_recurring old_monthly_recurring save_monthly_recurring image { url label } categories { id name url_key image } ... on BundleProduct { items { option_id title sku options { id label product { id name sku quantity __typename } } } } } upsell_products { name sku primary_product_image primary_product_sku promotion_tag_swatch badges_swatch badges badges_label quantity componentid contract_sku low_stock_threshold display_low_stock_badge plan_type_label plan_name_label promo_data nightowl_units nightowl_uom minutes minutes_label airtime sms payment_terms payment_terms_label tariff install old_installment old_tariff monthly_recurring old_monthly_recurring save_monthly_recurring image { url label } categories { id name url_key image } ... on BundleProduct { items { option_id title sku options { id label product { id name sku quantity __typename } } } } } crosssell_products { name sku primary_product_image primary_product_sku promotion_tag_swatch badges_swatch badges badges_label quantity low_stock_threshold display_low_stock_badge plan_type_label plan_name_label promo_data  nightowl_units nightowl_uom minutes minutes_label airtime sms componentid contract_sku payment_terms payment_terms_label tariff installment old_installment old_tariff monthly_recurring old_monthly_recurring save_monthly_recurring image { url label } categories { id name url_key image } ... on BundleProduct { items { option_id title sku options { id label product { id name sku quantity __typename } } } } } } attribute_set_config{ attribute_set_id configurable_product_attribute_set_attributes configurable_product_attribute_set_label } } }";
var persistCart = "query {\n\tpersist_cart{\n\t\tpersistent_enable\n\t\tpersistent_lifetime\n\t\tpersistent_logout_clear\n\t}\n}";
var removeCouponCode = "mutation removeCouponFromCart($cart_id: String!) {\n\tremoveCouponFromCart(input: { cart_id: $cart_id }) {\n\t\tcart {\n\t\t\titems {\n\t\t\t\tproduct {\n\t\t\t\t\tname\n\t\t\t\t}\n\t\t\t\tquantity\n\t\t\t}\n\t\t\tapplied_coupons {\n\t\t\t\tcode\n\t\t\t}\n\t\t\tprices {\n\t\t\t\tgrand_total {\n\t\t\t\t\tvalue\n\t\t\t\t\tcurrency\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}";
var getGraphQlOperationFromRequestQuery = function getGraphQlOperationFromRequestQuery(requestQuery) {
  var _requestQuery, _requestQuery6, _requestQuery16;

  var mySubString = "operation_name"; //if starts with query

  if ((_requestQuery = requestQuery) !== null && _requestQuery !== void 0 && _requestQuery.trim().startsWith("query")) {
    var _requestQuery2, _requestQuery3, _requestQuery4, _requestQuery5;

    requestQuery = (_requestQuery2 = requestQuery) === null || _requestQuery2 === void 0 ? void 0 : _requestQuery2.substr(((_requestQuery3 = requestQuery) === null || _requestQuery3 === void 0 ? void 0 : _requestQuery3.indexOf("{")) + 1).trim();
    mySubString = (_requestQuery4 = requestQuery) === null || _requestQuery4 === void 0 ? void 0 : _requestQuery4.substr(0, (_requestQuery5 = requestQuery) === null || _requestQuery5 === void 0 ? void 0 : _requestQuery5.indexOf("("));
  } //start with mutation
  else if ((_requestQuery6 = requestQuery) !== null && _requestQuery6 !== void 0 && _requestQuery6.trim().startsWith("mutation")) {
    var _requestQuery7, _requestQuery8, _requestQuery9;

    requestQuery = (_requestQuery7 = requestQuery) === null || _requestQuery7 === void 0 ? void 0 : _requestQuery7.substr(((_requestQuery8 = requestQuery) === null || _requestQuery8 === void 0 ? void 0 : _requestQuery8.indexOf("{")) + 1).trim();

    if (((_requestQuery9 = requestQuery) === null || _requestQuery9 === void 0 ? void 0 : _requestQuery9.indexOf("(")) == -1) {
      var _requestQuery10, _requestQuery11, _requestQuery12, _requestQuery13;

      var endIndex = ((_requestQuery10 = requestQuery) === null || _requestQuery10 === void 0 ? void 0 : _requestQuery10.indexOf(" ")) == -1 ? (_requestQuery11 = requestQuery) === null || _requestQuery11 === void 0 ? void 0 : _requestQuery11.indexOf("}") : (_requestQuery12 = requestQuery) === null || _requestQuery12 === void 0 ? void 0 : _requestQuery12.indexOf(" ");
      mySubString = (_requestQuery13 = requestQuery) === null || _requestQuery13 === void 0 ? void 0 : _requestQuery13.substr(0, endIndex);
    } else {
      var _requestQuery14, _requestQuery15;

      mySubString = (_requestQuery14 = requestQuery) === null || _requestQuery14 === void 0 ? void 0 : _requestQuery14.substr(0, (_requestQuery15 = requestQuery) === null || _requestQuery15 === void 0 ? void 0 : _requestQuery15.indexOf("("));
    }
  } //starts with a {
  else if ((_requestQuery16 = requestQuery) !== null && _requestQuery16 !== void 0 && _requestQuery16.trim().startsWith("{")) {
    var _requestQuery17, _requestQuery18, _requestQuery19, _requestQuery20;

    requestQuery = (_requestQuery17 = requestQuery) === null || _requestQuery17 === void 0 ? void 0 : _requestQuery17.substr(((_requestQuery18 = requestQuery) === null || _requestQuery18 === void 0 ? void 0 : _requestQuery18.indexOf("{")) + 1).trim();
    mySubString = (_requestQuery19 = requestQuery) === null || _requestQuery19 === void 0 ? void 0 : _requestQuery19.substr(0, (_requestQuery20 = requestQuery) === null || _requestQuery20 === void 0 ? void 0 : _requestQuery20.indexOf("{"));
    mySubString = mySubString.replace(/[():$_{}]/g, " ");
    mySubString = mySubString.trim();
  }

  return mySubString;
};
var recommmendedDeals = "\n   query products($filter: ProductAttributeFilterInput,$sort:ProductAttributeSortInput, $pageSize: Int, $currentPage: Int) {\n\t products(\n\t\t filter: $filter,\n\t\t pageSize: $pageSize,\n\t\t currentPage: $currentPage sort: $sort\n\t ) {\n\t\t total_count\n\t\t page_info {\n\t\t\t page_size\n\t\t\t current_page\n\t\t\t total_pages\n\t\t }\n\t\t items {\n\t\t\t name\n\t\t\t url_key\n\t\t\t sku\n\t\t\t primary_product_image\n            primary_product_sku\n\t\t\t badges\n\t\t\t promo_data\n\t\t\t minutes\n\t\t\t minutes_label\n\t\t\t airtime\n\t\t\t sms\n\t\t\t componentid\n      \t\t contract_sku\n\t\t\t plan_name\n\t\t\t plan_name_label\n\t\t\t package_description\n\t\t\t plan_type\n\t\t\t plan_type_label\n\t\t\t contract_type\n\t\t\t contract_type_label\n\t\t\t payment_terms\n\t\t\t payment_terms_label\n\t\t\t badges_label\n\t\t\t manufacturer\n\t\t\t manufacturer_label\n\t\t\t promotion_tag\n\t\t\t promotion_tag_label\n\t\t\t accessories\n\t\t\t accessories_label\n\t\t\t monthly_recurring\n\t\t\t old_tariff\n\t\t\t old_installment\n\t\t\t old_monthly_recurring\n\t\t\t save_monthly_recurring\n\t\t\t stock_status\n\t\t\t low_stock_threshold\n\t\t\t display_low_stock_badge\n\t\t\t deal_go_live_date\n\t\t\t deal_end_date\n\t\t\t deal_label\n\t\t\t is_deal_locked\n\t\t\t server_time\n\t\t\t categories {\n\t\t\t\tid\n\t\t\t\tname\n\t\t\t}\n\t\t\t __typename\n\t\t\t image {\n\t\t\t\t url\n\t\t\t\t label\n\t\t\t }\n\t\t\t small_image {\n\t\t\t\t url\n\t\t\t\t label\n\t\t\t }\n\t\t\t ... on BundleProduct {\n\t\t\t\titems {\n\t\t\t\t  option_id\n\t\t\t\t  title\n\t\t\t\t  sku\n\t\t\t\t  options {\n\t\t\t\t\tid\n\t\t\t\t\tlabel\n\t\t\t\t\tproduct {\n\t\t\t\t\t  id\n\t\t\t\t\t  name\n\t\t\t\t\t  sku\n\t\t\t\t\t  quantity\n\t\t\t\t\t  __typename\n\t\t\t\t\t}\n\t\t\t\t  }\n\t\t\t\t}\n\t\t\t  }\n\t\t }\n\t\t sort_fields {\n\t\t\t default\n\t\t\t options {\n\t\t\t\t label\n\t\t\t\t value\n\t\t\t }\n\t\t }\n\t\t price_range {\n\t\t\tattribute_code\n\t\t\tmin_value\n\t\t\tmax_value\n\t\t  }\n\t }\n }";
var dealGridAggregations = "query products($filter: ProductAttributeFilterInput,$sort: ProductAttributeSortInput,$pageSize: Int,$currentPage: Int) {\n\tproducts(filter: $filter,pageSize: $pageSize,currentPage: $currentPage,sort: $sort) { aggregations {label attribute_code options {label value}}}}";
var productAggregations = "query products($filter: ProductAttributeFilterInput,$sort: ProductAttributeSortInput,$pageSize: Int,$currentPage: Int)\n{\n\tproducts(filter:$filter, currentPage: $currentPage, pageSize: $pageSize, sort: $sort)\n\t{ aggregations{ label attribute_code options{ label value }  } }\n}"; //  is_pre_selected

var vasProductQuery = "name is_pre_selected sku promotion_link description { html } stock_status image { url label } categories { id name image level category_url } ... on CustomizableProductInterface { options { title required sort_order option_id ... on CustomizableDropDownOption { title value { price_type option_type_id title price sku } } } }";
var vasProductAddOrRemoveInCart = "mutation addRemoveCartItems($cart_id: String!, $remove_simple_products: [String], $cart_items: [BundleProductCartItemInput]!)\n{\n\taddRemoveCartItems(input: { cart_id: $cart_id, remove_simple_products: $remove_simple_products, cart_items: $cart_items})\n\t{\n\t  cart {\n\t\titems {\n\t\t  id\n\t\t  quantity\n\t\t  product {\n\t\t\tsku\n\t\t  }\n\t\t  ... on BundleCartItem {\n\t\t\tbundle_options {\n\t\t\t  id\n\t\t\t  label\n\t\t\t  type\n\t\t\t  values {\n\t\t\t\tid\n\t\t\t\tlabel\n\t\t\t\tprice\n\t\t\t\tquantity\n\t\t\t  }\n\t\t\t}\n\t\t\tcustomizable_options {\n\t\t\t  id\n\t\t\t  label\n\t\t\t  values {\n\t\t\t\tid\n\t\t\t\tvalue\n\t\t\t  }\n\t\t\t}\n\t\t  }\n\t\t}\n\t  }\n\t}\n  }";
var getAll5GRouters = "{\n  products(\n    filter: { whitelisted_flag: { eq: \"1\" },\n      is_deal_product : {eq : \"0\"},\n    }\n    currentPage: 1\n    sort: { name: ASC }\n  ) {\n    total_count\n    items {\n      id\n\t  url_key\n      sku\n      whitelisted_flag\n      attribute_set_id\n      name\n      image {\n        url\n        label\n      }\n      price_range {\n        minimum_price {\n          regular_price {\n            value\n            currency\n          }\n          final_price {\n            value\n            currency\n          }\n        }\n      }\n    }\n  }\n}";

/***/ }),

/***/ 69842:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var types = {
  TYPE_PREPAID: "Prepaid",
  TYPE_POSTPAID: "Postpaid",
  TYPE_PREORDER: "Pre Order",
  TYPE_MONTHLY: "Monthly",
  TYPE_ONCE_OFF: "Once-off",
  TRACKING: "tracking",
  DETAILS: "details",
  PRICE_MIN_VALUE: 0,
  PRICE_MAX_VALUE: 100000,
  PRICE_MAX_VALUE_MONTHLY: 4000,
  PRICE_MAX_VALUE_ONCE_OF: 50000,
  DEAL_GRID_PAGE: "deals",
  TRACK_MY_ORDER_PAGE: "track-my-order",
  ORDER_DETAILS_PAGE: "view-order-details"
};
/* harmony default export */ __webpack_exports__["Z"] = (types);

/***/ }),

/***/ 92197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "deliveryDetailsCBU": function() { return /* binding */ deliveryDetailsCBU; },
/* harmony export */   "storeListData": function() { return /* binding */ storeListData; }
/* harmony export */ });
var storeListData = {
  "result": {
    "messages": [],
    "result": {
      "storeList": [{
        "storeID": 1199,
        "shopCode": "352794061115343",
        "name": "VODACOM SHOP BOULDERS MIDRAND",
        "addressLineOne": "Old Pretoria Road",
        "addressLineTwo": "Shop 26, Boulders Shopping Centre",
        "city": "Midrand",
        "district": "Johannesburg",
        "state": "Southern Gauteng",
        "country": "ZA",
        "postalCode": "1685",
        "mainPhone": "+27114658104",
        "email": "OmniBBDDevTeam@vodacom.co.za",
        "alternativePhone": null,
        "mobilePhone": null,
        "fax": null,
        "paymentTypes": [{
          "paymentTypeDescription": null,
          "paymentTypeId": 0
        }],
        "additionalPhone": null,
        "tradingHours": [{
          "dayOfWeek": 0,
          "startTime": 0,
          "endTime": 0
        }],
        "bir": false,
        "storeCategory": {
          "categoryID": 4,
          "description": "Emerging Market"
        },
        "open": true,
        "coordinate": {
          "latitude": -25.99977,
          "longitude": 28.12571
        },
        "distance": 3.448784277021117,
        "type": {
          "typeId": 4,
          "description": "Vodacom Shop"
        },
        "stockReservationEnable": true,
        "upgradeToCollectEnable": true,
        "stockCode": null,
        "quantity": 0,
        "inStock": false,
        "lastUpdate": null
      }, {
        "storeID": 1327,
        "shopCode": "23209",
        "name": "VODACOM SHOP REPAIRS FOURWAYS",
        "addressLineOne": "Corner William Nicol and Witkoppen Street",
        "addressLineTwo": "Shop M7C, Fourways Mall",
        "city": "Fourways",
        "district": "Johannesburg",
        "state": "Southern Gauteng",
        "country": "ZA",
        "postalCode": "2191",
        "mainPhone": "27114656716",
        "email": "OmniBBDDevTeam@vodacom.co.za",
        "alternativePhone": null,
        "mobilePhone": null,
        "fax": null,
        "paymentTypes": [{
          "paymentTypeDescription": null,
          "paymentTypeId": 0
        }],
        "additionalPhone": null,
        "tradingHours": [{
          "dayOfWeek": 0,
          "startTime": 0,
          "endTime": 0
        }],
        "bir": false,
        "storeCategory": {
          "categoryID": 3,
          "description": "Super Premium"
        },
        "open": true,
        "coordinate": {
          "latitude": -26.022339,
          "longitude": 28.008699
        },
        "distance": 13.37037840001163,
        "type": {
          "typeId": 4,
          "description": "Vodacom Shop"
        },
        "stockReservationEnable": false,
        "upgradeToCollectEnable": false,
        "stockCode": "0000000103004940",
        "quantity": 625,
        "inStock": true,
        "lastUpdate": "2020-08-09T01:18:29.0"
      }, {
        "storeID": 1345,
        "shopCode": "27881",
        "name": "VODACOM SHOP RIVONIA ",
        "addressLineOne": "Corner Rivonia Boulevard and Mutual Road",
        "addressLineTwo": "Shop 70, Rivonia Village Shopping Centre",
        "city": "Rivonia",
        "district": "Johannesburg",
        "state": "Southern Gauteng",
        "country": "ZA",
        "postalCode": "2499",
        "mainPhone": "27118074391",
        "email": "OmniBBDDevTeam@vodacom.co.za",
        "alternativePhone": null,
        "mobilePhone": null,
        "fax": null,
        "paymentTypes": [{
          "paymentTypeDescription": null,
          "paymentTypeId": 0
        }],
        "additionalPhone": null,
        "tradingHours": [{
          "dayOfWeek": 0,
          "startTime": 0,
          "endTime": 0
        }],
        "bir": false,
        "storeCategory": {
          "categoryID": 1,
          "description": "Standard"
        },
        "open": true,
        "coordinate": {
          "latitude": -26.060142,
          "longitude": 28.060374
        },
        "distance": 12.222816237212735,
        "type": {
          "typeId": 4,
          "description": "Vodacom Shop"
        },
        "stockReservationEnable": true,
        "upgradeToCollectEnable": true,
        "stockCode": null,
        "quantity": 0,
        "inStock": false,
        "lastUpdate": null
      }, {
        "storeID": 1510,
        "shopCode": "POSTEST1997",
        "name": "TEST VODACOM SHOP VODACOM WORLD",
        "addressLineOne": "082 Vodacom Boulevard",
        "addressLineTwo": "Shop 7, Vodacom World ",
        "city": "Midrand",
        "district": "Johannesburg",
        "state": "Southern Gauteng",
        "country": "ZA",
        "postalCode": "1682",
        "mainPhone": "27116536750",
        "email": "hitesh.buwade@vcontractor.co.za",
        "alternativePhone": null,
        "mobilePhone": null,
        "fax": null,
        "paymentTypes": [{
          "paymentTypeDescription": null,
          "paymentTypeId": 0
        }],
        "additionalPhone": null,
        "tradingHours": [{
          "dayOfWeek": 0,
          "startTime": 0,
          "endTime": 0
        }],
        "bir": true,
        "storeCategory": {
          "categoryID": 3,
          "description": "Super Premium"
        },
        "open": true,
        "coordinate": {
          "latitude": -25.970113,
          "longitude": 28.128212
        },
        "distance": 0.142907789240403,
        "type": {
          "typeId": 4,
          "description": "Vodacom Shop"
        },
        "stockReservationEnable": true,
        "upgradeToCollectEnable": true,
        "stockCode": null,
        "quantity": 0,
        "inStock": false,
        "lastUpdate": null
      }, {
        "storeID": 1384,
        "shopCode": "27277",
        "name": "VODACOM SHOP WOODMEAD RETAIL PARK",
        "addressLineOne": "1 Waterval Street",
        "addressLineTwo": "Shop 3A and 4, Woodmead Retail Park",
        "city": "Woodmead Ext 40",
        "district": "Johannesburg",
        "state": "Southern Gauteng",
        "country": "ZA",
        "postalCode": "2191",
        "mainPhone": "27116569598",
        "email": "OmniBBDDevTeam@vodacom.co.za",
        "alternativePhone": null,
        "mobilePhone": null,
        "fax": null,
        "paymentTypes": [{
          "paymentTypeDescription": null,
          "paymentTypeId": 0
        }],
        "additionalPhone": null,
        "tradingHours": [{
          "dayOfWeek": 0,
          "startTime": 0,
          "endTime": 0
        }],
        "bir": false,
        "storeCategory": {
          "categoryID": 1,
          "description": "Standard"
        },
        "open": true,
        "coordinate": {
          "latitude": -26.047415,
          "longitude": 28.080078
        },
        "distance": 9.986754721365912,
        "type": {
          "typeId": 4,
          "description": "Vodacom Shop"
        },
        "stockReservationEnable": true,
        "upgradeToCollectEnable": true,
        "stockCode": null,
        "quantity": 0,
        "inStock": false,
        "lastUpdate": null
      }, {
        "storeID": 1373,
        "shopCode": "VWOR1",
        "name": "VODACOM SHOP VODACOM WORLD",
        "addressLineOne": "082 Vodacom Boulevard",
        "addressLineTwo": "Shop 7, Vodacom World ",
        "city": "Midrand",
        "district": "Johannesburg",
        "state": "Southern Gauteng",
        "country": "ZA",
        "postalCode": "1682",
        "mainPhone": "27116536750",
        "email": "OmniBBDDevTeam@vodacom.co.za",
        "alternativePhone": null,
        "mobilePhone": null,
        "fax": null,
        "paymentTypes": [{
          "paymentTypeDescription": null,
          "paymentTypeId": 0
        }],
        "additionalPhone": null,
        "tradingHours": [{
          "dayOfWeek": 0,
          "startTime": 0,
          "endTime": 0
        }],
        "bir": true,
        "storeCategory": {
          "categoryID": 3,
          "description": "Super Premium"
        },
        "open": true,
        "coordinate": {
          "latitude": -25.970113,
          "longitude": 28.128212
        },
        "distance": 0.142907789240403,
        "type": {
          "typeId": 4,
          "description": "Vodacom Shop"
        },
        "stockReservationEnable": false,
        "upgradeToCollectEnable": false,
        "stockCode": "0000000103004940",
        "quantity": 98,
        "inStock": true,
        "lastUpdate": "2020-09-14T13:03:55.0"
      }, {
        "storeID": 1366,
        "shopCode": "36401",
        "name": "VODACOM SHOP THEMBISA BIRCH ACRES ",
        "addressLineOne": "Corner Isimuku Street and Andrew Mapheto Drive",
        "addressLineTwo": "Shop 51C, Birch Acres Mall",
        "city": "Birch Acres",
        "district": "Johannesburg",
        "state": "Southern Gauteng",
        "country": "ZA",
        "postalCode": "1618",
        "mainPhone": "27721440826",
        "email": "OmniBBDDevTeam@vodacom.co.za",
        "alternativePhone": null,
        "mobilePhone": null,
        "fax": null,
        "paymentTypes": [{
          "paymentTypeDescription": null,
          "paymentTypeId": 0
        }],
        "additionalPhone": null,
        "tradingHours": [{
          "dayOfWeek": 0,
          "startTime": 0,
          "endTime": 0
        }],
        "bir": false,
        "storeCategory": {
          "categoryID": 4,
          "description": "Emerging Market"
        },
        "open": true,
        "coordinate": {
          "latitude": -26.034944,
          "longitude": 28.19142
        },
        "distance": 9.670766171614137,
        "type": {
          "typeId": 4,
          "description": "Vodacom Shop"
        },
        "stockReservationEnable": true,
        "upgradeToCollectEnable": true,
        "stockCode": null,
        "quantity": 0,
        "inStock": false,
        "lastUpdate": null
      }, {
        "storeID": 1206,
        "shopCode": "13212",
        "name": "VODACOM SHOP CENTURION MALL",
        "addressLineOne": "Heuwel Avenue, Entrance 5",
        "addressLineTwo": "Shop 268B, Centurion Shopping Centre",
        "city": "Centurion",
        "district": "Pretoria",
        "state": "Northern Gauteng",
        "country": "ZA",
        "postalCode": "1049",
        "mainPhone": "+27183923495",
        "email": "OmniBBDDevTeam@vodacom.co.za",
        "alternativePhone": null,
        "mobilePhone": null,
        "fax": null,
        "paymentTypes": [{
          "paymentTypeDescription": null,
          "paymentTypeId": 0
        }],
        "additionalPhone": null,
        "tradingHours": [{
          "dayOfWeek": 0,
          "startTime": 0,
          "endTime": 0
        }],
        "bir": false,
        "storeCategory": {
          "categoryID": 2,
          "description": "Premium"
        },
        "open": true,
        "coordinate": {
          "latitude": -25.856605,
          "longitude": 28.184833
        },
        "distance": 13.69392629113139,
        "type": {
          "typeId": 4,
          "description": "Vodacom Shop"
        },
        "stockReservationEnable": true,
        "upgradeToCollectEnable": true,
        "stockCode": null,
        "quantity": 0,
        "inStock": false,
        "lastUpdate": null
      }, {
        "storeID": 1365,
        "shopCode": "37723",
        "name": "VODACOM SHOP THE REDS",
        "addressLineOne": "Corner Hendrik Verwoerd and Rooihuiskraal Drives",
        "addressLineTwo": "Shop 15 and 16, Mall @ Reds",
        "city": "Rooihuiskraal",
        "district": "Pretoria",
        "state": "Northern Gauteng",
        "country": "ZA",
        "postalCode": "0157",
        "mainPhone": "27126569567",
        "email": "OmniBBDDevTeam@vodacom.co.za",
        "alternativePhone": null,
        "mobilePhone": null,
        "fax": null,
        "paymentTypes": [{
          "paymentTypeDescription": null,
          "paymentTypeId": 0
        }],
        "additionalPhone": null,
        "tradingHours": [{
          "dayOfWeek": 0,
          "startTime": 0,
          "endTime": 0
        }],
        "bir": true,
        "storeCategory": {
          "categoryID": 2,
          "description": "Premium"
        },
        "open": true,
        "coordinate": {
          "latitude": -25.895967,
          "longitude": 28.156153
        },
        "distance": 8.563258521616842,
        "type": {
          "typeId": 4,
          "description": "Vodacom Shop"
        },
        "stockReservationEnable": false,
        "upgradeToCollectEnable": false,
        "stockCode": "0000000103004940",
        "quantity": 297,
        "inStock": true,
        "lastUpdate": "2020-08-17T01:23:37.0"
      }, {
        "storeID": 1228,
        "shopCode": "VDSFR",
        "name": "VODACOM SHOP FOURWAYS",
        "addressLineOne": "Corner William Nicol and Witkoppen Street",
        "addressLineTwo": "Shop G100A, Fourways Mall",
        "city": "Fourways",
        "district": "Johannesburg",
        "state": "Southern Gauteng",
        "country": "ZA",
        "postalCode": "2191",
        "mainPhone": "27114658104",
        "email": "OmniBBDDevTeam@vodacom.co.za",
        "alternativePhone": null,
        "mobilePhone": null,
        "fax": null,
        "paymentTypes": [{
          "paymentTypeDescription": null,
          "paymentTypeId": 0
        }],
        "additionalPhone": null,
        "tradingHours": [{
          "dayOfWeek": 0,
          "startTime": 0,
          "endTime": 0
        }],
        "bir": true,
        "storeCategory": {
          "categoryID": 3,
          "description": "Super Premium"
        },
        "open": true,
        "coordinate": {
          "latitude": -26.022339,
          "longitude": 28.008699
        },
        "distance": 13.37037840001163,
        "type": {
          "typeId": 4,
          "description": "Vodacom Shop"
        },
        "stockReservationEnable": false,
        "upgradeToCollectEnable": false,
        "stockCode": "0000000103004940",
        "quantity": 2640,
        "inStock": true,
        "lastUpdate": "2020-08-17T01:42:04.0"
      }]
    },
    "successful": false,
    "code": 0
  }
};
var deliveryDetailsCBU = {
  "id": "ddbef899-9c1c-4fcc-8a68-ba86b236a69c",
  "analyticTitle": "Delivery details landing page",
  "sections": [{
    "type": "paragraph_list",
    "id": "f84fe31a-f972-4e91-9160-9c0057406496",
    "analyticTitle": "Delivery details",
    "title": "How would you like to receive your order?",
    "items": [{
      "id": "552e8d89-0eb3-4258-8cec-97d3e69c34de",
      "title": "Deliver via courier",
      "description": "<p><strong>Standard delivery</strong></p><ul>\t<li>Since your order is over {order_amount}, your delivery is FREE</li>\t<li>Deliveries normally take 3 - 4 business days</li>\t<li>Deliveries are made on weekdays between 08:00 and 17:00</li></ul>"
    }, {
      "id": "52847d96-fc89-41c1-9f71-6362c5ff503c",
      "title": "Collect in store",
      "description": "<p><strong>Collecting from a store</strong></p><ul>\t<li>We've made sure we only show you stores that have your items in stock. If you can't find your favourite store below, it may be that they don't have stock right now.</li>\t<li>The store you choose will let you know when your order is ready for collection. It normally takes 1 - 3 days to prepare your order.</li>\t<li>Collections can be made during normal store operating hours.</li></ul>"
    }],
    "icon": "https://wwwdev.vodacom.co.za/sites/vodacomcoza/files/2021-09/Path.svg"
  }],
  "status": "success"
};

/***/ }),

/***/ 83870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dealsTopData": function() { return /* binding */ dealsTopData; },
/* harmony export */   "mockPlanType": function() { return /* binding */ mockPlanType; },
/* harmony export */   "mockSkuList": function() { return /* binding */ mockSkuList; }
/* harmony export */ });
var dealsTopData = {
  componentHeading: "Build your contract",
  componentDescription: "Follow these few easy steps to make sure your contract gives you what you need",
  selectedMessage: "Okay! You’ve selected a great device…",
  selectedDeviceDetails: {
    title: "Apple Iphone 11 pro",
    imageUrl: "assets/images/front5.png",
    storageSize: [{
      id: "1",
      label: "64GB"
    }, {
      id: "2",
      label: "128GB"
    }, {
      id: "3",
      label: "256GB"
    }],
    colorVariants: [{
      id: "1",
      code: "color",
      hex: "#778077",
      label: "Midnight Green"
    }, {
      id: "2",
      code: "color",
      hex: "#424648",
      label: "Space Grey"
    }]
  },
  dealLink: "Choose another device"
};
var mockSkuList = {
  "items": [{
    "name": "BundleProd",
    "sku": "1280464749",
    "badges": null,
    "data": 60,
    "minutes": 200,
    "airtime": 100,
    "sms": null,
    "plan_type": 5539,
    "plan_type_label": "Data only",
    "contract_type": 5540,
    "contract_type_label": "Standard contract",
    "monthly_recurring": 400,
    "payment_terms": 5477,
    "payment_terms_label": "36",
    "badges_label": null,
    "manufacturer": null,
    "manufacturer_label": null,
    "promotion_tag": 5512,
    "promotion_tag_label": "Black Friday",
    "accessories": 5547,
    "accessories_label": "Apple Airpods",
    "plan_name": 5542,
    "plan_name_label": "myRed",
    "stock_status": "OUT_OF_STOCK",
    "low_stock_threshold": 5,
    "display_low_stock_badge": 0,
    "categories": [{
      "id": 59,
      "name": "Tablets & Laptops",
      "url_key": "tablets-laptops",
      "image": "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Tablets_laptop.png"
    }, {
      "id": 69,
      "name": "Gaming",
      "url_key": "gaming",
      "image": "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Gaming_1.png"
    }],
    "__typename": "BundleProduct",
    "price_range": {
      "minimum_price": {
        "regular_price": {
          "value": 0,
          "currency": "ZAR"
        },
        "final_price": {
          "value": 0,
          "currency": "ZAR"
        },
        "discount": {
          "amount_off": 0,
          "percent_off": 0
        }
      },
      "maximum_price": {
        "regular_price": {
          "value": 0,
          "currency": "ZAR"
        },
        "final_price": {
          "value": 0,
          "currency": "ZAR"
        },
        "discount": {
          "amount_off": 0,
          "percent_off": 0
        }
      }
    },
    "price_tiers": [],
    "image": {
      "url": "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/c/acer-chromebook-11-c732.png",
      "label": "BundleProd"
    },
    "small_image": {
      "url": "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/c/acer-chromebook-11-c732.png",
      "label": "BundleProd"
    },
    "dynamic_sku": true,
    "dynamic_price": false,
    "dynamic_weight": true,
    "price_view": "PRICE_RANGE",
    "ship_bundle_items": "TOGETHER",
    "items": [{
      "option_id": 95,
      "title": "laptop1",
      "required": true,
      "type": "radio",
      "position": 1,
      "sku": "1280464749",
      "options": [{
        "id": 103,
        "quantity": 10,
        "position": 1,
        "is_default": true,
        "price": 0,
        "price_type": "FIXED",
        "can_change_quantity": false,
        "label": "Acer ChromeBook R11, Black",
        "product": {
          "id": 825,
          "name": "Acer ChromeBook R11, Black",
          "sku": "102065700",
          "quantity": null,
          "__typename": "SimpleProduct",
          "price_range": {
            "minimum_price": {
              "regular_price": {
                "value": 1000,
                "currency": "ZAR"
              },
              "final_price": {
                "value": 1000,
                "currency": "ZAR"
              },
              "discount": {
                "amount_off": 0,
                "percent_off": 0
              }
            }
          }
        }
      }]
    }, {
      "option_id": 96,
      "title": "Kit",
      "required": true,
      "type": "radio",
      "position": 2,
      "sku": "1280464749",
      "options": [{
        "id": 104,
        "quantity": 10,
        "position": 1,
        "is_default": true,
        "price": 0,
        "price_type": "FIXED",
        "can_change_quantity": false,
        "label": "V-Home ",
        "product": {
          "id": 824,
          "name": "V-Home ",
          "sku": "108017087",
          "quantity": 5959,
          "__typename": "SimpleProduct",
          "price_range": {
            "minimum_price": {
              "regular_price": {
                "value": 5479,
                "currency": "ZAR"
              },
              "final_price": {
                "value": 799,
                "currency": "ZAR"
              },
              "discount": {
                "amount_off": 4680,
                "percent_off": 85.42
              }
            }
          }
        }
      }]
    }]
  }, {
    "name": "NO PHONE + VHOME - STARTER KIT @ R150 PM (R150 Finance + R0 Sub) on Ciot - TOTAL R179 (Incl R29 Vsim subs)",
    "sku": "1280464750",
    "badges": null,
    "data": 60,
    "minutes": 200,
    "airtime": 40,
    "sms": null,
    "plan_type": 5537,
    "plan_type_label": "Data & Voice",
    "contract_type": 5540,
    "contract_type_label": "Standard contract",
    "monthly_recurring": 500,
    "payment_terms": 5477,
    "payment_terms_label": "36",
    "badges_label": null,
    "manufacturer": null,
    "manufacturer_label": null,
    "promotion_tag": 5497,
    "promotion_tag_label": "For Today Only",
    "accessories": 5547,
    "accessories_label": "Apple Airpods",
    "plan_name": 5542,
    "plan_name_label": "myRed",
    "stock_status": "IN_STOCK",
    "low_stock_threshold": 5,
    "display_low_stock_badge": 0,
    "categories": [{
      "id": 69,
      "name": "Gaming",
      "url_key": "gaming",
      "image": "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Gaming_1.png"
    }],
    "__typename": "BundleProduct",
    "price_range": {
      "minimum_price": {
        "regular_price": {
          "value": 12000,
          "currency": "ZAR"
        },
        "final_price": {
          "value": 12000,
          "currency": "ZAR"
        },
        "discount": {
          "amount_off": 0,
          "percent_off": 0
        }
      },
      "maximum_price": {
        "regular_price": {
          "value": 12000,
          "currency": "ZAR"
        },
        "final_price": {
          "value": 12000,
          "currency": "ZAR"
        },
        "discount": {
          "amount_off": 0,
          "percent_off": 0
        }
      }
    },
    "price_tiers": [],
    "image": {
      "url": "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/static/version1600419101/graphql/_view/en_GB/Magento_Catalog/images/product/placeholder/image.jpg",
      "label": "NO PHONE + VHOME - STARTER KIT @ R150 PM (R150 Finance + R0 Sub) on Ciot - TOTAL R179 (Incl R29 Vsim subs)"
    },
    "small_image": {
      "url": "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/static/version1600419101/graphql/_view/en_GB/Magento_Catalog/images/product/placeholder/small_image.jpg",
      "label": "NO PHONE + VHOME - STARTER KIT @ R150 PM (R150 Finance + R0 Sub) on Ciot - TOTAL R179 (Incl R29 Vsim subs)"
    },
    "dynamic_sku": true,
    "dynamic_price": false,
    "dynamic_weight": true,
    "price_view": "PRICE_RANGE",
    "ship_bundle_items": "TOGETHER",
    "items": [{
      "option_id": 97,
      "title": "Phone1",
      "required": true,
      "type": "radio",
      "position": 1,
      "sku": "1280464750",
      "options": [{
        "id": 105,
        "quantity": 1,
        "position": 1,
        "is_default": true,
        "price": 0,
        "price_type": "FIXED",
        "can_change_quantity": false,
        "label": "Apple iPhone 11 Pro Max",
        "product": {
          "id": 818,
          "name": "Apple iPhone 11 Pro Max",
          "sku": "104046524-1",
          "quantity": null,
          "__typename": "SimpleProduct",
          "price_range": {
            "minimum_price": {
              "regular_price": {
                "value": 24859,
                "currency": "ZAR"
              },
              "final_price": {
                "value": 22999,
                "currency": "ZAR"
              },
              "discount": {
                "amount_off": 1860,
                "percent_off": 7.48
              }
            }
          }
        }
      }]
    }, {
      "option_id": 98,
      "title": "Kit",
      "required": false,
      "type": "radio",
      "position": 2,
      "sku": "1280464750",
      "options": [{
        "id": 106,
        "quantity": 1,
        "position": 1,
        "is_default": true,
        "price": 0,
        "price_type": "FIXED",
        "can_change_quantity": false,
        "label": "V-Home ",
        "product": {
          "id": 824,
          "name": "V-Home ",
          "sku": "108017087",
          "quantity": 5959,
          "__typename": "SimpleProduct",
          "price_range": {
            "minimum_price": {
              "regular_price": {
                "value": 5479,
                "currency": "ZAR"
              },
              "final_price": {
                "value": 799,
                "currency": "ZAR"
              },
              "discount": {
                "amount_off": 4680,
                "percent_off": 85.42
              }
            }
          }
        }
      }]
    }]
  }, {
    "name": "Apple iPhone 8 Pro + @ R200 With 20GB Data Free",
    "sku": "1280464751",
    "badges": null,
    "data": 40,
    "minutes": 300,
    "airtime": 20,
    "sms": null,
    "plan_type": 5537,
    "plan_type_label": "Data & Voice",
    "contract_type": 5540,
    "contract_type_label": "Standard contract",
    "monthly_recurring": 300,
    "payment_terms": 5478,
    "payment_terms_label": "12",
    "badges_label": null,
    "manufacturer": null,
    "manufacturer_label": null,
    "promotion_tag": 5512,
    "promotion_tag_label": "Black Friday",
    "accessories": 5548,
    "accessories_label": "Apple TV 4K 64GB",
    "plan_name": 5542,
    "plan_name_label": "myRed",
    "stock_status": "OUT_OF_STOCK",
    "low_stock_threshold": 5,
    "display_low_stock_badge": 0,
    "categories": [{
      "id": 49,
      "name": "Phones & Sim",
      "url_key": "phones",
      "image": "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Phone_SIM.png"
    }, {
      "id": 50,
      "name": "Smartphones",
      "url_key": "smartphones",
      "image": null
    }],
    "__typename": "BundleProduct",
    "price_range": {
      "minimum_price": {
        "regular_price": {
          "value": 20000,
          "currency": "ZAR"
        },
        "final_price": {
          "value": 4000,
          "currency": "ZAR"
        },
        "discount": {
          "amount_off": 16000,
          "percent_off": 80
        }
      },
      "maximum_price": {
        "regular_price": {
          "value": 20000,
          "currency": "ZAR"
        },
        "final_price": {
          "value": 4000,
          "currency": "ZAR"
        },
        "discount": {
          "amount_off": 16000,
          "percent_off": 80
        }
      }
    },
    "price_tiers": [],
    "image": {
      "url": "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/5/1/516gyfgghql._sy879_.jpg",
      "label": "Apple iPhone 8 Pro + @ R200 With 20GB Data Free"
    },
    "small_image": {
      "url": "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/5/1/516gyfgghql._sy879_.jpg",
      "label": "Apple iPhone 8 Pro + @ R200 With 20GB Data Free"
    },
    "dynamic_sku": true,
    "dynamic_price": false,
    "dynamic_weight": true,
    "price_view": "PRICE_RANGE",
    "ship_bundle_items": "TOGETHER",
    "items": [{
      "option_id": 99,
      "title": "Phone1",
      "required": true,
      "type": "radio",
      "position": 1,
      "sku": "1280464751",
      "options": [{
        "id": 107,
        "quantity": 10,
        "position": 1,
        "is_default": true,
        "price": 0,
        "price_type": "FIXED",
        "can_change_quantity": false,
        "label": "Apple iPhone 11 Pro Max",
        "product": {
          "id": 818,
          "name": "Apple iPhone 11 Pro Max",
          "sku": "104046524-1",
          "quantity": null,
          "__typename": "SimpleProduct",
          "price_range": {
            "minimum_price": {
              "regular_price": {
                "value": 24859,
                "currency": "ZAR"
              },
              "final_price": {
                "value": 22999,
                "currency": "ZAR"
              },
              "discount": {
                "amount_off": 1860,
                "percent_off": 7.48
              }
            }
          }
        }
      }]
    }, {
      "option_id": 100,
      "title": "Kit",
      "required": true,
      "type": "radio",
      "position": 2,
      "sku": "1280464751",
      "options": [{
        "id": 108,
        "quantity": 10,
        "position": 1,
        "is_default": true,
        "price": 0,
        "price_type": "FIXED",
        "can_change_quantity": false,
        "label": "V-Home ",
        "product": {
          "id": 824,
          "name": "V-Home ",
          "sku": "108017087",
          "quantity": 5959,
          "__typename": "SimpleProduct",
          "price_range": {
            "minimum_price": {
              "regular_price": {
                "value": 5479,
                "currency": "ZAR"
              },
              "final_price": {
                "value": 799,
                "currency": "ZAR"
              },
              "discount": {
                "amount_off": 4680,
                "percent_off": 85.42
              }
            }
          }
        }
      }]
    }]
  }]
};
var mockPlanType = [{
  "label": "Data & Voice Minutes"
}, {
  "label": "Airtime"
}, {
  "label": "Data only"
}];

/***/ }),

/***/ 29151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "accordion": function() { return /* binding */ accordion; },
/* harmony export */   "appstore_banner": function() { return /* binding */ appstore_banner; },
/* harmony export */   "banner": function() { return /* binding */ banner; },
/* harmony export */   "bread_crumb": function() { return /* binding */ bread_crumb; },
/* harmony export */   "calling_costs": function() { return /* binding */ calling_costs; },
/* harmony export */   "carousel": function() { return /* binding */ carousel; },
/* harmony export */   "countdown_banner": function() { return /* binding */ countdown_banner; },
/* harmony export */   "deal_catalog": function() { return /* binding */ deal_catalog; },
/* harmony export */   "defaultCase": function() { return /* binding */ defaultCase; },
/* harmony export */   "defaultPayInt": function() { return /* binding */ defaultPayInt; },
/* harmony export */   "four_column_usp": function() { return /* binding */ four_column_usp; },
/* harmony export */   "horizontal_video": function() { return /* binding */ horizontal_video; },
/* harmony export */   "image_card": function() { return /* binding */ image_card; },
/* harmony export */   "landingPageComponent": function() { return /* binding */ landingPageComponent; },
/* harmony export */   "multi_column_card": function() { return /* binding */ multi_column_card; },
/* harmony export */   "multi_column_proposition": function() { return /* binding */ multi_column_proposition; },
/* harmony export */   "multi_column_usp": function() { return /* binding */ multi_column_usp; },
/* harmony export */   "multi_quadrant_phone_visual": function() { return /* binding */ multi_quadrant_phone_visual; },
/* harmony export */   "multi_quadrant_proposition": function() { return /* binding */ multi_quadrant_proposition; },
/* harmony export */   "numerical_counter": function() { return /* binding */ numerical_counter; },
/* harmony export */   "panoramic_image": function() { return /* binding */ panoramic_image; },
/* harmony export */   "paragraph": function() { return /* binding */ paragraph; },
/* harmony export */   "portlet": function() { return /* binding */ portlet; },
/* harmony export */   "process_image_123": function() { return /* binding */ process_image_123; },
/* harmony export */   "productOrderReq": function() { return /* binding */ productOrderReq; },
/* harmony export */   "product_card": function() { return /* binding */ product_card; },
/* harmony export */   "product_carousel": function() { return /* binding */ product_carousel; },
/* harmony export */   "product_catalog": function() { return /* binding */ product_catalog; },
/* harmony export */   "shop_brand_card_carousel": function() { return /* binding */ shop_brand_card_carousel; },
/* harmony export */   "shop_category_card_carousel": function() { return /* binding */ shop_category_card_carousel; },
/* harmony export */   "small_card_image_carousel": function() { return /* binding */ small_card_image_carousel; },
/* harmony export */   "testimonial_carousel": function() { return /* binding */ testimonial_carousel; },
/* harmony export */   "three_column_plain_cards": function() { return /* binding */ three_column_plain_cards; },
/* harmony export */   "two_column_proposition": function() { return /* binding */ two_column_proposition; }
/* harmony export */ });
var carousel = {
  type: "carousel",
  id: "90176625-39f3-4fd2-8219-b2a4cc6ee04e",
  analyticTitle: "Home Page Carousel",
  buttonStyle: "Primary",
  items: [{
    id: "61bed040-496f-4651-90be-9569d5b4ee45",
    title: "Apple iPhone x",
    heading: "Just the right amount of everything",
    description: "",
    image: "http://3.250.153.131/sites/default/files/2020-06/carousel2.png",
    callToActionUri: "http://example.com",
    callToActionLabel: "Shop now"
  }, {
    id: "a46b7546-97c3-4801-8cd5-bb49ea7b1270",
    title: "Samsung",
    heading: "Built for sound inside  and out",
    description: "",
    image: "http://3.250.153.131/sites/default/files/2020-08/background.png",
    callToActionUri: "http://example.com",
    callToActionLabel: "Shop now"
  }]
};
var image_card = {
  type: "image_card",
  id: "a4b5eeb3-87d9-41b8-97fa-5b3872d8eba8",
  analyticTitle: "Get covered",
  title: "Get covered",
  description: "",
  buttonStyle: "Outline White",
  imageCardType: "3*3",
  tabStyle: "large-black",
  tabType: "tab",
  items: {
    Insurance: [{
      id: "ea8cb45f-d771-4471-982a-8eeb78534948",
      title: "DEVICE COVER",
      description: "<p>Protect your gadgets from damage, loss and theft</p>",
      category: "Insurance",
      image: "http://3.250.153.131/sites/default/files/2020-07/image_13.png",
      icon: "http://3.250.153.131/sites/default/files/2020-07/cellphone-o-copy_0.png",
      callToActionUri: "http://google.com",
      callToActionLabel: "Learn more"
    }, {
      id: "0c55dfda-dc99-474e-92e6-169613e7dc8e",
      title: "DEVICE COVER",
      description: "<p>Protect your gadgets from damage, loss and theft</p>",
      category: "Insurance",
      image: "http://3.250.153.131/sites/default/files/2020-06/insurance3.png",
      icon: "http://3.250.153.131/sites/default/files/2020-07/cellphone-o-copy_0.png",
      callToActionUri: "http://google.com",
      callToActionLabel: "Learn more"
    }, {
      id: "4cec40af-c7c9-41f9-b817-19fb9126af94",
      title: "DEVICE COVER",
      description: "<p>Protect your gadgets from damage, loss and theft</p>",
      category: "Insurance",
      image: "http://3.250.153.131/sites/default/files/2020-06/insurance3.png",
      icon: "http://3.250.153.131/sites/default/files/2020-07/cellphone-o-copy_0.png",
      callToActionUri: "http://google.com",
      callToActionLabel: "Learn more"
    }, {
      id: "a9d383f1-b6f9-4766-800f-02b3eeb2621a",
      title: "DEVICE COVER First element",
      description: "<p>Protect your gadgets from damage, loss and theft</p>",
      category: "Insurance",
      image: "http://3.250.153.131/sites/default/files/2020-06/insurance3.png",
      icon: "http://3.250.153.131/sites/default/files/2020-07/cellphone-o-copy_0.png",
      callToActionUri: "http://test.com",
      callToActionLabel: "Learn more"
    }, {
      id: "20d229aa-4f02-4d4f-b9b3-2b636672a882",
      title: "DEVICE COVER",
      description: "<p>Protect your gadgets from damage, loss and theft</p>",
      category: "Insurance",
      image: "http://3.250.153.131/sites/default/files/2020-06/insurance2.png",
      icon: "http://3.250.153.131/sites/default/files/2020-07/cellphone-o-copy_0.png",
      callToActionUri: "http://example.com",
      callToActionLabel: "Learn more"
    }, {
      id: "6b15fdd7-8877-4988-80a0-c76fe21b9108",
      title: "DEVICE COVER",
      description: "<p>Protect your gadgets from damage, loss and theft</p>",
      category: "Insurance",
      image: "http://3.250.153.131/sites/default/files/2020-06/insurance2.png",
      icon: "http://3.250.153.131/sites/default/files/2020-07/cellphone-o-copy_0.png",
      callToActionUri: "http://example.com",
      callToActionLabel: "Learn more"
    }]
  }
};
var product_card = {
  type: "product_card",
  id: "a4b5eeb3-87d9-41b8-97fa-5b3872d8eba8",
  analyticTitle: "Get covered",
  title: "Get covered",
  description: "",
  buttonStyle: "Outline White",
  imageCardType: "3*3",
  tabStyle: "large-black",
  tabType: "tab",
  items: {
    Insurance: [{
      id: "ea8cb45f-d771-4471-982a-8eeb78534948",
      title: "DEVICE COVER",
      description: "<p>Protect your gadgets from damage, loss and theft</p>",
      category: "Insurance",
      image: "http://3.250.153.131/sites/default/files/2020-07/image_13.png",
      icon: "http://3.250.153.131/sites/default/files/2020-07/cellphone-o-copy_0.png",
      callToActionUri: "http://google.com",
      callToActionLabel: "Learn more"
    }, {
      id: "0c55dfda-dc99-474e-92e6-169613e7dc8e",
      title: "DEVICE COVER",
      description: "<p>Protect your gadgets from damage, loss and theft</p>",
      category: "Insurance",
      image: "http://3.250.153.131/sites/default/files/2020-06/insurance3.png",
      icon: "http://3.250.153.131/sites/default/files/2020-07/cellphone-o-copy_0.png",
      callToActionUri: "http://google.com",
      callToActionLabel: "Learn more"
    }, {
      id: "4cec40af-c7c9-41f9-b817-19fb9126af94",
      title: "DEVICE COVER",
      description: "<p>Protect your gadgets from damage, loss and theft</p>",
      category: "Insurance",
      image: "http://3.250.153.131/sites/default/files/2020-06/insurance3.png",
      icon: "http://3.250.153.131/sites/default/files/2020-07/cellphone-o-copy_0.png",
      callToActionUri: "http://google.com",
      callToActionLabel: "Learn more"
    }, {
      id: "a9d383f1-b6f9-4766-800f-02b3eeb2621a",
      title: "DEVICE COVER First element",
      description: "<p>Protect your gadgets from damage, loss and theft</p>",
      category: "Insurance",
      image: "http://3.250.153.131/sites/default/files/2020-06/insurance3.png",
      icon: "http://3.250.153.131/sites/default/files/2020-07/cellphone-o-copy_0.png",
      callToActionUri: "http://test.com",
      callToActionLabel: "Learn more"
    }, {
      id: "20d229aa-4f02-4d4f-b9b3-2b636672a882",
      title: "DEVICE COVER",
      description: "<p>Protect your gadgets from damage, loss and theft</p>",
      category: "Insurance",
      image: "http://3.250.153.131/sites/default/files/2020-06/insurance2.png",
      icon: "http://3.250.153.131/sites/default/files/2020-07/cellphone-o-copy_0.png",
      callToActionUri: "http://example.com",
      callToActionLabel: "Learn more"
    }, {
      id: "6b15fdd7-8877-4988-80a0-c76fe21b9108",
      title: "DEVICE COVER",
      description: "<p>Protect your gadgets from damage, loss and theft</p>",
      category: "Insurance",
      image: "http://3.250.153.131/sites/default/files/2020-06/insurance2.png",
      icon: "http://3.250.153.131/sites/default/files/2020-07/cellphone-o-copy_0.png",
      callToActionUri: "http://example.com",
      callToActionLabel: "Learn more"
    }]
  }
};
var portlet = {
  type: "portlet",
  id: "ba640131-8199-4576-beb4-d7f8f147ae01",
  analyticTitle: "Explore Our Portlet",
  title: "Explore our range",
  description: "",
  buttonStyle: "Primary",
  tabStyle: "red-without-line",
  tabType: "pill",
  items: {
    Bestseller: [{
      id: "01f7a87d-b06b-4a2c-b1da-49c9b0750633",
      title: "Apple Airpods with case",
      description: "<p>A massive leap forward in resolution and zoom for mobile photography</p>",
      category: "Bestseller",
      badgeStyle: "Badge Style 1",
      fromLabel: null,
      badgeLabel: "Brand New",
      left: "30",
      top: "50",
      image: "http://3.250.153.131/sites/default/files/2020-06/image.png",
      imageHeading: "Airpods",
      placement: "bottom",
      addOn: "+ Free charger",
      imageDescription: "Amazing Sound",
      callToActionUri: "http://example.com",
      callToActionLabel: "Shop now"
    }, {
      id: "c8ac7c0f-7494-4a81-8617-ceea9fb77fcf",
      title: "Apple Airpods with case",
      description: "<p>A massive leap forward in resolution and zoom for mobile photography</p>",
      category: "Bestseller",
      badgeStyle: "Badge Style 1",
      fromLabel: null,
      badgeLabel: "Brand New",
      left: null,
      top: null,
      image: "http://3.250.153.131/sites/default/files/2020-06/image.png",
      imageHeading: null,
      placement: null,
      addOn: "+ Free charger",
      imageDescription: null,
      callToActionUri: "http://example.com",
      callToActionLabel: "Shop now"
    }, {
      id: "43493998-ea9e-4957-9665-a6b33b753b41",
      title: "Apple Airpods with case",
      description: "<p>A massive leap forward in resolution and zoom for mobile photography</p>",
      category: "Bestseller",
      fromLabel: null,
      badgeLabel: null,
      left: null,
      top: null,
      image: "http://3.250.153.131/sites/default/files/2020-06/image_1.png",
      imageHeading: null,
      placement: null,
      addOn: "+ Free charger",
      imageDescription: null,
      callToActionUri: "http://example.com",
      callToActionLabel: "Shop now"
    }, {
      id: "78595c66-3469-4b8a-aa86-b3cbf91d7fea",
      title: "Apple Airpods with case",
      description: "<p>A massive leap forward in resolution and zoom for mobile photography</p>",
      category: "Bestseller",
      badgeStyle: "Badge Style 1",
      fromLabel: null,
      badgeLabel: "Double Deals",
      left: null,
      top: null,
      image: "http://3.250.153.131/sites/default/files/2020-06/image_0.png",
      imageHeading: null,
      placement: null,
      addOn: "+ Free charger",
      imageDescription: null,
      callToActionUri: "http://example.com",
      callToActionLabel: "Shop now"
    }, {
      id: "e38746be-a56b-4d6a-be73-26777cfdf832",
      title: "Apple Airpods with case",
      description: "<p>A massive leap forward in resolution and zoom for mobile photography</p>",
      category: "Bestseller",
      badgeStyle: "Badge Style 1",
      fromLabel: null,
      badgeLabel: "Double Deals",
      left: null,
      top: null,
      image: "http://3.250.153.131/sites/default/files/2020-06/image_0.png",
      imageHeading: null,
      placement: null,
      addOn: "+ Free charger",
      imageDescription: null,
      callToActionUri: "http://example.com",
      callToActionLabel: "Shop now"
    }, {
      id: "760b1947-fcf0-4edd-86e8-e4ba19375b0b",
      title: "Apple Airpods with case",
      description: "<p>A massive leap forward in resolution and zoom for mobile photography</p>",
      category: "Bestseller",
      badgeStyle: "Badge Style 1",
      fromLabel: null,
      badgeLabel: "Double Deals",
      left: null,
      top: null,
      image: "http://3.250.153.131/sites/default/files/2020-06/image_0.png",
      imageHeading: null,
      placement: null,
      addOn: "+ Free charger",
      imageDescription: null,
      callToActionUri: "http://example.com",
      callToActionLabel: "Shop now"
    }],
    "Latest Special": [{
      id: "e7632532-6770-4b61-9599-7965769da27f",
      title: "Apple Airpods with case",
      description: "<p>A massive leap forward in resolution and zoom for mobile photography</p>",
      category: "Latest Special",
      fromLabel: null,
      badgeLabel: null,
      left: null,
      top: null,
      image: "http://3.250.153.131/sites/default/files/2020-06/image_1.png",
      imageHeading: null,
      placement: null,
      addOn: "+ Free charger",
      imageDescription: null,
      callToActionUri: "http://example.com",
      callToActionLabel: "Shop now"
    }, {
      id: "73a4af96-96c4-4ea1-af30-ebd1d1149f8e",
      title: "Apple Airpods with case",
      description: "<p>A massive leap forward in resolution and zoom for mobile photography</p>",
      category: "Latest Special",
      fromLabel: null,
      badgeLabel: null,
      left: null,
      top: null,
      image: "http://3.250.153.131/sites/default/files/2020-06/image_1.png",
      imageHeading: null,
      placement: null,
      addOn: "+ Free charger",
      imageDescription: null,
      callToActionUri: "http://example.com",
      callToActionLabel: "Shop now"
    }, {
      id: "1182a84f-b131-43e0-a04e-cbb2106873e5",
      title: "Apple Airpods with case",
      description: "<p>A massive leap forward in resolution and zoom for mobile photography</p>",
      category: "Latest Special",
      fromLabel: null,
      badgeLabel: null,
      left: null,
      top: null,
      image: "http://3.250.153.131/sites/default/files/2020-06/image_1.png",
      imageHeading: null,
      placement: null,
      addOn: "+ Free charger",
      imageDescription: null,
      callToActionUri: "http://example.com",
      callToActionLabel: "Shop now"
    }]
  }
};
var product_catalog = {
  type: "product_catalog",
  id: "5af3586b-1926-4e5c-bec3-03597432328c",
  analyticTitle: "CBU: Product Catalog",
  title: "Shop By",
  description: "<p>Category</p>",
  buttonLabel: "Shop all",
  buttonStyle: "Outline White",
  tabStyle: "black-with-line",
  tabType: "tab",
  displayStyle: "Grid",
  productCategory: {
    1035: {
      id: "66",
      name: "Routers"
    },
    1040: {
      id: "55",
      name: "Smart watches"
    },
    1041: {
      id: "56",
      name: "Portable Audio"
    },
    1050: {
      id: "49",
      name: "Phones"
    },
    1067: {
      id: "82",
      name: "Printers & Scanners"
    }
  },
  API: {
    type: "product_catalog",
    id: "52ca84bf-c913-4174-be05-c126f270b29e",
    analyticTitle: "Product by Category",
    apiName: "Product by Category",
    apiEndpoint: 'https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/index.php/graphql?query={ products(filter: {category_id:{eq: <productCategoryID>},price: {from: "0", to: "999999"}}, pageSize: 5, currentPage: 1 sort: {position: DESC}) { total_count page_info { page_size current_page total_pages } items { name sku badges badges_label manufacturer manufacturer_label promotion_tag_label payment_terms_label stock_status low_stock_threshold display_low_stock_badge categories{ id name url_key image } __typename description{ html } meta_title meta_description price_range { minimum_price { regular_price { value currency } final_price{ value currency } discount { amount_off percent_off } } maximum_price { regular_price { value currency } final_price{ value currency } discount { amount_off percent_off } } } price_tiers{ discount{ amount_off percent_off } final_price{ value currency } quantity } image { url label } small_image{ url label } media_gallery { url label ... on ProductVideo { video_content { media_type video_provider video_url video_title video_description video_metadata } } } } aggregations{ count label attribute_code options{ count label value } } sort_fields{ default options{ label value } } } }',
    method: "GET",
    headers: {
      Store: "cbu",
      "Content-Type": "application/json"
    }
  },
  numOfProducts: "5"
};
var four_column_usp = {
  type: "four_column_usp",
  id: "70e43a5a-0989-497e-96b3-ff35fc31ca13",
  analyticTitle: "USP - Why shop online",
  title: "Why shop online?",
  description: null,
  items: [{
    id: "7bebcd8f-266d-45dd-a218-3b5ab57b33ca",
    description: "<p>Shop online, safe and secure with multiple payment options changed.</p>\r\n",
    icon: "http://3.250.153.131/sites/default/files/2020-07/illustration.png"
  }, {
    id: "4fbb34a8-f5ce-43fd-8271-6d780a6d2f7b",
    description: "<p>Free standard delivery on all contracts and orders over R600 changed.</p>\r\n",
    icon: "http://3.250.153.131/sites/default/files/2020-07/illustration4.png"
  }, {
    id: "96e7da09-e19b-4062-b98c-856855893340",
    description: "<p>Free SIM and connection&nbsp; cahnged.</p>\r\n",
    icon: "http://3.250.153.131/sites/default/files/2020-07/illustration2.png"
  }, {
    id: "292ac9f2-7e1d-4d11-a511-02ea72600848",
    description: "<p>24/7 Convinience at your fingertips cahnged</p>\r\n",
    icon: "http://3.250.153.131/sites/default/files/2020-07/illustration3.png"
  }]
};
var banner = {
  type: "banner",
  analyticTitle: "CBU: Entertainment Banner",
  id: "4d0fd645-4561-4840-ad11-b2c973773aab",
  bannerTitle: "EXPLORE",
  bannerSubTitle: "<p>Entertainment</p>",
  bannerImage: "http://3.250.153.131/sites/default/files/2020-06/homebanner.png",
  callToActionUrl: "http://example.com",
  callToActionLabel: "Show More",
  buttonStyle: "Primary"
};
var appstore_banner = {
  type: "appstore_banner",
  id: "c50ba287-3018-42e7-abcb-dd35177bcda7",
  analyticTitle: "Stay In Control Banner",
  icon: "http://3.250.153.131/sites/default/files/2020-06/cellphone-o-copy%403x.png",
  title: "Stay in",
  heading: "<p>Control</p>",
  description: "<p>MY VODACOM APP</p><h1>Designed to make your life easier</h1><p>Make life easier by downloading the My Vodacom App,&nbsp; view balances, data usage, buy bundles, airtime, and so much more!</p>",
  backgroundImage: "http://3.250.153.131/sites/default/files/2020-06/play-store-banner-desktop-bg.png",
  image: "http://3.250.153.131/sites/default/files/2020-06/bitmap-hand.png",
  buttonItems: [{
    id: "6fa5b6c0-2f8d-49ba-8502-e2fabf9ef7fd",
    buttonImage: "http://3.250.153.131/sites/default/files/2020-06/google-play%403x.png",
    buttonUrl: "http://example.com."
  }, {
    id: "a27df718-1d6a-4ba0-9d74-be2720899149",
    buttonImage: "http://3.250.153.131/sites/default/files/2020-06/app-store.png",
    buttonUrl: "http://google.com"
  }]
};
var process_image_123 = {
  type: "123_process_image",
  id: "1240ad57-2156-43f1-a781-04afccfe51d5",
  analyticTitle: "Demo 1-2-3 Step Process Image - Square Image",
  title: "My New component",
  description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum non lacus ut turpis hendrerit tristique vel id metus. Cras pretium quam dui, in mollis erat sodales at. Interdum et malesuada fames ac ante ipsum primis in faucibus. Cras ut ex aliquet, condimentum elit ac, ultrices lectus. Cras sagittis, velit nec congue lobortis, arcu velit dapibus velit, eu pretium leo nunc vitae ligula. Etiam vel rutrum odio. Donec lacinia arcu a dolor lacinia, sed tincidunt risus facilisis.</p>",
  items: [{
    id: "3907de22-cdbb-4d72-9ede-10867a8d85cc",
    imageStyle: "Square Image",
    title: "Lorem ipsum dolor sit amet",
    description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>",
    image: "http://3.250.153.131/sites/default/files/2020-07/Group%203.jpg"
  }, {
    id: "eb9bb7b8-fe02-445a-a0f3-9146ef3330d5",
    imageStyle: "Square Image",
    title: "Lorem ipsum",
    description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>",
    image: "http://3.250.153.131/sites/default/files/2020-07/Group%205.jpg"
  }, {
    id: "38a2ac8e-05ba-4f01-a824-d9af11768cae",
    imageStyle: "Square Image",
    title: "Vestibulum eget sempee",
    description: "<p>Vestibulum non lacus ut turpis hendrerit tristique vel id metus. Cras pretium quam dui, in mollis erat sodales at. Interdum et malesuada fames ac ante ipsum primis in faucibus. Cras ut ex aliquet, condimentum elit ac, ultrices lectus. Cras sagittis, velit nec congue lobortis, arcu velit dapibus velit, eu pretium leo nunc vitae ligula. Etiam vel rutrum odio. Donec lacinia arcu a dolor lacinia, sed tincidunt risus facilisis.</p>",
    image: "http://3.250.153.131/sites/default/files/2020-07/Group%206.jpg"
  }]
};
var horizontal_video = {
  type: "horizontal_video",
  id: "bc48ae64-e6eb-495f-afcb-d7ce60813958",
  analyticTitle: "CBU: Horizontal video",
  title: "Explore",
  description: "<p>Vodaworld</p>",
  thumbnail: "http://3.250.153.131/sites/default/files/2020-06/group-67.png",
  thumbnailHeading: "Video",
  thumbnailDesc: "<p>Explore our newly launched Apple boutique now</p>",
  video: "http://3.250.153.131/sites/default/files/2020-07/AdobeStock_295620918_Video_HD_Preview.mp4"
};
var landingPageComponent = {
  type: "promotion_container",
  id: "fcdc6da1-f54e-49e8-8816-3bec5ed5f74e",
  analyticTitle: "Promotional container without button",
  title: "Lorem ipsum dolor sit amet",
  heading: "<p>Heading</p>",
  description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam congue sed ligula id pulvinar. Aenean blandit libero non metus laoreet vestibulum. Aenean eleifend tristique mauris. Suspendisse consequat risus a scelerisque interdum. Sed posuere mattis posuere. Phasellus purus mi, posuere non tincidunt ultrices, sagittis a dui. Etiam imperdiet quam quis feugiat porta. Fusce imperdiet condimentum nisl, ut egestas sapien viverra eget. In odio ex, posuere nec pretium vel, tempor id sapien. Sed imperdiet quam id lorem euismod faucibus.</p>",
  image: "http://3.250.153.131/sites/default/files/2020-07/Image.png"
}; ///____

var bread_crumb = {
  type: "bread_crumb",
  id: "fcdc6da1-f54e-49e8-8816-3bec5ed5f74e",
  analyticTitle: "Promotional container without button",
  title: "Lorem ipsum dolor sit amet",
  heading: "<p>Heading</p>",
  description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam congue sed ligula id pulvinar. Aenean blandit libero non metus laoreet vestibulum. Aenean eleifend tristique mauris. Suspendisse consequat risus a scelerisque interdum. Sed posuere mattis posuere. Phasellus purus mi, posuere non tincidunt ultrices, sagittis a dui. Etiam imperdiet quam quis feugiat porta. Fusce imperdiet condimentum nisl, ut egestas sapien viverra eget. In odio ex, posuere nec pretium vel, tempor id sapien. Sed imperdiet quam id lorem euismod faucibus.</p>",
  image: "http://3.250.153.131/sites/default/files/2020-07/Image.png"
};
var multi_column_card = {
  type: "multi_column_card",
  analyticTitle: "analyticTitle",
  items: "items"
};
var three_column_plain_cards = {
  type: "3_column_plain_cards",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle"
};
var paragraph = {
  type: "paragraph",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle"
};
var two_column_proposition = {
  type: "two_column_proposition",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle"
};
var calling_costs = {
  type: "calling_costs",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle"
};
var numerical_counter = {
  type: "numerical_counter",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle"
};
var countdown_banner = {
  type: "countdown_banner",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle"
};
var multi_column_proposition = {
  type: "multi_column_proposition",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle"
};
var testimonial_carousel = {
  type: "testimonial_carousel",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle"
};
var multi_quadrant_proposition = {
  type: "multi_quadrant_proposition",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle"
};
var product_carousel = {
  type: "product_carousel",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle"
};
var accordion = {
  type: "accordion",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle"
};
var multi_quadrant_phone_visual = {
  type: "multi_quadrant_phone_visual",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle"
};
var panoramic_image = {
  type: "panoramic_image",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle"
};
var small_card_image_carousel = {
  type: "small_card_image_carousel",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle"
};
var shop_category_card_carousel = {
  type: "shop_category_card_carousel",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle"
};
var shop_brand_card_carousel = {
  type: "shop_brand_card_carousel",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle"
};
var multi_column_usp = {
  type: "multi_column_usp",
  id: "fcdc6da1-f54e-49e8-8816-3bec5ed5f74e",
  analyticTitle: "Promotional container without button",
  title: "Lorem ipsum dolor sit amet",
  heading: "<p>Heading</p>",
  description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam congue sed ligula id pulvinar. Aenean blandit libero non metus laoreet vestibulum. Aenean eleifend tristique mauris. Suspendisse consequat risus a scelerisque interdum. Sed posuere mattis posuere. Phasellus purus mi, posuere non tincidunt ultrices, sagittis a dui. Etiam imperdiet quam quis feugiat porta. Fusce imperdiet condimentum nisl, ut egestas sapien viverra eget. In odio ex, posuere nec pretium vel, tempor id sapien. Sed imperdiet quam id lorem euismod faucibus.</p>",
  image: "http://3.250.153.131/sites/default/files/2020-07/Image.png"
};
var deal_catalog = {
  type: "deal_catalog",
  id: "fcdc6da1-f54e-49e8-8816-3bec5ed5f74e",
  analyticTitle: "Promotional container without button",
  title: "Lorem ipsum dolor sit amet",
  heading: "<p>Heading</p>",
  description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam congue sed ligula id pulvinar. Aenean blandit libero non metus laoreet vestibulum. Aenean eleifend tristique mauris. Suspendisse consequat risus a scelerisque interdum. Sed posuere mattis posuere. Phasellus purus mi, posuere non tincidunt ultrices, sagittis a dui. Etiam imperdiet quam quis feugiat porta. Fusce imperdiet condimentum nisl, ut egestas sapien viverra eget. In odio ex, posuere nec pretium vel, tempor id sapien. Sed imperdiet quam id lorem euismod faucibus.</p>",
  image: "http://3.250.153.131/sites/default/files/2020-07/Image.png"
};
var defaultCase = {
  type: "default_any"
};
var defaultPayInt = {
  Transaction: {
    Username: "Pinkflam2",
    Password: "Pinkflam2",
    Destination: "UCF",
    TransactionType: "01",
    SupplierID: "Pink flamingo 2",
    Submission: {
      Number: "3",
      Stamp: Date.now().toString()
    },
    Identifier: "D7616EEA-6C3D-49E6-AE72-000B451D20D4",
    Currency: "ZAR",
    Order: {
      Products: [{
        id: 1,
        ProductCode: "Product1",
        Description: "ProductDescription",
        Quantity: "1",
        Price: "2",
        VatRate: "0",
        Subtotal: "2"
      }],
      Delivery: {
        Auto: "false"
      },
      ProductTotal: "2"
    }
  }
};
var productOrderReq = {
  productOrder: [{
    contact: {
      firstName: "",
      middleName: "",
      lastName1: "",
      lastName2: "",
      identificationID: "",
      identificationType: "",
      expirationDate: "",
      identificationCharacteristics: "",
      gender: "",
      dateOfBirth: "",
      contact: "",
      emailAddress: ""
    },
    externalId: "",
    storeCode: "",
    orderReference: "",
    journeyType: "",
    productOrderItems: {
      productOrderItem: [{
        productID: "",
        action: "",
        productName: "",
        lineNumber: "",
        eventTime: "",
        quantity: "",
        unitOfMeasure: "",
        customerItemID: "",
        customerItemIDType: "",
        rechargeType: "",
        validationSysTraceAuditNumber: "",
        validationTransDateTime: "",
        deliveryAddress: {
          country: "",
          stateOrProvince: "",
          supplementaryLocation: {
            addressLine1: "",
            addressLine2: "",
            addressLine3: "",
            addressLine4: "",
            addressLine5: "NA"
          },
          urbanAddress: {
            streetNr: "",
            streetName: "",
            streetType: "",
            locality: "",
            postCode: "",
            deliveryInstructions: ""
          }
        },
        productOrderItemTotal: {
          subTotal: "",
          amount: "",
          dutyFreeAmount: "",
          priceType: "",
          shippingAmount: "",
          taxIncludedAmount: "",
          totalAmount: "",
          unit: "",
          loyaltyPointsTotal: "",
          amountBreakDown: ""
        },
        note: {
          discountedFlag: "",
          portingAuthorisationCode: "",
          priorNumber: "",
          handSetReplacementOffset: "",
          manualFlags: "",
          csrComments: "",
          fixedLineNumber: "",
          newMSISDN: ""
        }
      }]
    },
    productOrderTotal: {
      subTotal: "",
      priceType: "",
      shippingAmount: "",
      taxIncludedAmount: "",
      totalAmount: "",
      unit: "",
      loyaltyPointsTotal: "",
      amountBreakDown: ""
    },
    relatedParties: {
      customerId: "",
      ssoid: "",
      rechargeMSISDN: "",
      customerReference: ""
    },
    payment: {
      paymentReference: {
        country: "string",
        stateOrProvince: "string",
        supplementaryLocation: {
          addressLine1: "string",
          addressLine2: "string",
          addressLine3: "string",
          addressLine4: "string",
          addressLine5: ""
        },
        urbanAddress: {
          streetNr: "string",
          streetName: "string",
          streetType: "string",
          locality: "string",
          postCode: "string",
          deliveryInstructions: "string"
        }
      },
      VoucherNumber: "string",
      type: "CRED_CARD",
      AccountHoldersName: "string",
      voucherNumber: "string",
      AccountHoldersPhone: "string",
      accountHoldersName: "string",
      EncryptedPaymentDetails: "string",
      accountHoldersPhone: "string",
      AuthorisedAmount: "string",
      encryptedPaymentDetails: "string",
      Currency: "string",
      authorisedAmount: "",
      AuthorisationCode: "string",
      unit: "string",
      LoyaltyPoints: "string",
      authorisationCode: "string",
      RecurringPayment: "string",
      loyaltyPoints: "string",
      recurringPayment: "string"
    },
    identifier: {
      applicationID: "string",
      serviceID: "string",
      serviceInterfaceVersion: "string",
      eventTime: "string",
      referenceID: "string",
      identityID: "string",
      correlationID: "string"
    },
    orderTypeFlag: "string",
    productOrderItemCount: "string",
    shipTo: "string",
    shippingMethod: "string",
    Characteristic: {
      name: "string"
    },
    eventTime: "string",
    ricaAddress: {
      address1: "string",
      address2: "string",
      address3: "string",
      city: "string",
      countryID: "string",
      postalCode: "string",
      suburb: "string",
      province: "string"
    }
  }]
};

/***/ }),

/***/ 43444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99599);

var mappedStatus = {
  CREATE_MAGENTO_SUCCESS: _config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_processing */ .Z.order_status_labels.lbl_processing,
  CREATE_EPPIX_FAILED: _config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_order_error */ .Z.order_status_labels.lbl_order_error,
  EPPIX_CREATE_TEMP_FAIL: _config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_processing */ .Z.order_status_labels.lbl_processing,
  CREATE_EPPIX_SUCCESS: _config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_processing */ .Z.order_status_labels.lbl_processing,
  CREATE_SUBMITTED_FAIL: _config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_processing */ .Z.order_status_labels.lbl_processing,
  CREATE_SUBMIT_SUCCESS: _config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_processing */ .Z.order_status_labels.lbl_processing,
  ZERO_VALUE_ORDER: _config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_processing */ .Z.order_status_labels.lbl_processing,
  FORM_ENCRYPTION_FAILED: _config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_order_error */ .Z.order_status_labels.lbl_order_error,
  PAYMENT_INIT_FAILED: _config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_order_error */ .Z.order_status_labels.lbl_order_error,
  PAYMENT_INIT_SUCCESS: _config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_processing */ .Z.order_status_labels.lbl_processing,
  PAYMENT_COMPLETE_FAILED: _config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_payment_failed */ .Z.order_status_labels.lbl_payment_failed,
  "Pending order countdown elapsed": _config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_cancelled */ .Z.order_status_labels.lbl_cancelled,
  PAYMENT_COMPLETE_SUCCESS: _config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_processing */ .Z.order_status_labels.lbl_processing,
  CQFD_SUBMIT_FAIL: _config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_order_error */ .Z.order_status_labels.lbl_order_error,
  CQFD_SUBMIT_TEMP_FAIL: _config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_processing */ .Z.order_status_labels.lbl_processing,
  CQFD_SUBMIT_SUCCESS: _config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_processing */ .Z.order_status_labels.lbl_processing,
  CREATE_L500_FAILED: _config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_processing */ .Z.order_status_labels.lbl_processing,
  CREATE_L500_SUCCESS: _config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_processing */ .Z.order_status_labels.lbl_processing,
  MULTI_PAYMENT_SETTLE_FAILED: _config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_order_error */ .Z.order_status_labels.lbl_order_error,
  PAYMENT_SETTLED_FAILED: _config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_order_error */ .Z.order_status_labels.lbl_order_error,
  PAYMENT_SETTLED_SUCCESS: _config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_paid */ .Z.order_status_labels.lbl_paid,
  UPDATE_L500_FAILED: _config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_processing */ .Z.order_status_labels.lbl_processing,
  UPDATE_L500_SUCCESS: _config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_processing */ .Z.order_status_labels.lbl_processing,
  UPDATE_EPPIX_FAILED: _config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_processing */ .Z.order_status_labels.lbl_processing,
  UPDATE_EPPIX_SUCCESS: _config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_processing */ .Z.order_status_labels.lbl_processing,
  ORDER_COMPLETE_SUCCESS: _config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_processed */ .Z.order_status_labels.lbl_processed
};
var mappedStyles = {
  x: 'a'
};
mappedStyles[_config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_processing */ .Z.order_status_labels.lbl_processing] = "order-status--processing";
mappedStyles[_config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_paid */ .Z.order_status_labels.lbl_paid] = "order-status--processing";
mappedStyles[_config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_processed */ .Z.order_status_labels.lbl_processed] = "order-status--processed";
mappedStyles[_config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_order_error */ .Z.order_status_labels.lbl_order_error] = "order-status--error";
mappedStyles[_config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_payment_failed */ .Z.order_status_labels.lbl_payment_failed] = "order-status--error";
mappedStyles[_config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_cancelled */ .Z.order_status_labels.lbl_cancelled] = "order-status--cancelled";
var mappedIcons = {
  x: 'a'
};
mappedIcons[_config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_processing */ .Z.order_status_labels.lbl_processing] = "sync.svg";
mappedIcons[_config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_paid */ .Z.order_status_labels.lbl_paid] = "sync.svg";
mappedIcons[_config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_processed */ .Z.order_status_labels.lbl_processed] = "success-circle.svg";
mappedIcons[_config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_order_error */ .Z.order_status_labels.lbl_order_error] = "warning.svg";
mappedIcons[_config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_payment_failed */ .Z.order_status_labels.lbl_payment_failed] = "warning.svg";
mappedIcons[_config_labels__WEBPACK_IMPORTED_MODULE_0__/* ["default"].order_status_labels.lbl_cancelled */ .Z.order_status_labels.lbl_cancelled] = "icon-cross.svg";
/* harmony default export */ __webpack_exports__["default"] = ({
  mappedStatus: mappedStatus,
  mappedStyles: mappedStyles,
  mappedIcons: mappedIcons
});

/***/ }),

/***/ 12729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "productSearchMock": function() { return /* binding */ productSearchMock; },
/* harmony export */   "productsMockData": function() { return /* binding */ productsMockData; },
/* harmony export */   "searchTabsMockData": function() { return /* binding */ searchTabsMockData; }
/* harmony export */ });
var productsMockData = [{
  name: "Apple Promo Bundle",
  sku: "Test_Promo_Bundle",
  badges: null,
  badges_label: null,
  manufacturer: null,
  stock_status: "OUT_OF_STOCK",
  categories: [{
    id: 53,
    name: "Wearable Tech",
    url_key: "wearable-tech",
    image: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Wearable_tech.png"
  }],
  __typename: "BundleProduct",
  description: {
    html: ""
  },
  meta_title: "Test_Promo_Bundle",
  meta_description: "Test_Promo_Bundle ",
  price_range: {
    minimum_price: {
      regular_price: {
        value: 9998,
        currency: "ZAR"
      },
      final_price: {
        value: 7998,
        currency: "ZAR"
      },
      discount: {
        amount_off: 2000,
        percent_off: 20
      }
    },
    maximum_price: {
      regular_price: {
        value: 9998,
        currency: "ZAR"
      },
      final_price: {
        value: 7998,
        currency: "ZAR"
      },
      discount: {
        amount_off: 2000,
        percent_off: 20
      }
    }
  },
  price_tiers: [],
  image: {
    url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_smartwatch_bundle.png",
    label: "Apple Promo Bundle"
  },
  small_image: {
    url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_smartwatch_bundle.png",
    label: "Apple Promo Bundle"
  },
  media_gallery: [{
    url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_smartwatch_bundle.png",
    label: "Apple Promo Bundle"
  }]
}, {
  name: "Apple iPhone 8 Pro + @ R200 With 20GB Data Free",
  sku: "1280464751",
  badges: null,
  badges_label: null,
  manufacturer: null,
  stock_status: "OUT_OF_STOCK",
  categories: [{
    id: 49,
    name: "Phones & SIM",
    url_key: "phones",
    image: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Phone_SIM.png"
  }, {
    id: 50,
    name: "Smartphones",
    url_key: "smartphones",
    image: null
  }],
  __typename: "BundleProduct",
  description: {
    html: ""
  },
  meta_title: "BundleTest4",
  meta_description: "BundleTest4 ",
  price_range: {
    minimum_price: {
      regular_price: {
        value: 20000,
        currency: "ZAR"
      },
      final_price: {
        value: 4000,
        currency: "ZAR"
      },
      discount: {
        amount_off: 16000,
        percent_off: 80
      }
    },
    maximum_price: {
      regular_price: {
        value: 20000,
        currency: "ZAR"
      },
      final_price: {
        value: 4000,
        currency: "ZAR"
      },
      discount: {
        amount_off: 16000,
        percent_off: 80
      }
    }
  },
  price_tiers: [],
  image: {
    url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/5/1/516gyfgghql._sy879_.jpg",
    label: "Apple iPhone 8 Pro + @ R200 With 20GB Data Free"
  },
  small_image: {
    url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/5/1/516gyfgghql._sy879_.jpg",
    label: "Apple iPhone 8 Pro + @ R200 With 20GB Data Free"
  },
  media_gallery: [{
    url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/5/1/516gyfgghql._sy879_.jpg",
    label: "Apple iPhone 8 Pro + @ R200 With 20GB Data Free"
  }]
}, {
  name: "Promo Bundle",
  sku: "Promo_Bundle",
  badges: null,
  badges_label: null,
  manufacturer: null,
  stock_status: "IN_STOCK",
  categories: [{
    id: 49,
    name: "Phones & SIM",
    url_key: "phones",
    image: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Phone_SIM.png"
  }],
  __typename: "BundleProduct",
  description: {
    html: ""
  },
  meta_title: "Promo_Bundle",
  meta_description: "Promo_Bundle ",
  price_range: {
    minimum_price: {
      regular_price: {
        value: 5967,
        currency: "ZAR"
      },
      final_price: {
        value: 5967,
        currency: "ZAR"
      },
      discount: {
        amount_off: 0,
        percent_off: 0
      }
    },
    maximum_price: {
      regular_price: {
        value: 5967,
        currency: "ZAR"
      },
      final_price: {
        value: 5967,
        currency: "ZAR"
      },
      discount: {
        amount_off: 0,
        percent_off: 0
      }
    }
  },
  price_tiers: [],
  image: {
    url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_bundle.jpg",
    label: "Promo Bundle"
  },
  small_image: {
    url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_bundle.jpg",
    label: "Promo Bundle"
  },
  media_gallery: [{
    url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_bundle.jpg",
    label: "Promo Bundle"
  }]
}, {
  name: "WearableTech Bundle",
  sku: "105577WBT_BN",
  badges: null,
  badges_label: null,
  manufacturer: null,
  stock_status: "OUT_OF_STOCK",
  categories: [{
    id: 52,
    name: "Accessories",
    url_key: "accessories",
    image: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Accessories_1.png"
  }, {
    id: 53,
    name: "Wearable Tech",
    url_key: "wearable-tech",
    image: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Wearable_tech.png"
  }],
  __typename: "BundleProduct",
  description: {
    html: ""
  },
  meta_title: "Wearable_Tech_Bundle",
  meta_description: "Wearable_Tech_Bundle ",
  price_range: {
    minimum_price: {
      regular_price: {
        value: 24995,
        currency: "ZAR"
      },
      final_price: {
        value: 19995,
        currency: "ZAR"
      },
      discount: {
        amount_off: 5000,
        percent_off: 20
      }
    },
    maximum_price: {
      regular_price: {
        value: 24995,
        currency: "ZAR"
      },
      final_price: {
        value: 19995,
        currency: "ZAR"
      },
      discount: {
        amount_off: 5000,
        percent_off: 20
      }
    }
  },
  price_tiers: [],
  image: {
    url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_huawei.png",
    label: "WearableTech Bundle"
  },
  small_image: {
    url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_huawei.png",
    label: "WearableTech Bundle"
  },
  media_gallery: [{
    url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_huawei.png",
    label: "WearableTech Bundle"
  }]
}];
var searchTabsMockData = {
  Promotions: [{
    title: "Promotions 1 -Pre-Order the new Samsung Galaxy Note 20 and get a R4 000 Samsung accessory voucher.",
    description: "This is the power phone that forever changes how you work and play.",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Promotions 2- Pre-Order the new Samsung Galaxy Note 20 and get a R4 000 Samsung accessory voucher.",
    description: "This is the power phone that forever changes how you work and play.",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Promotions -3 Pre-Order the new Samsung Galaxy Note 20 and get a R4 000 Samsung accessory voucher.",
    description: "This is the power phone that forever changes how you work and play.",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Pre-Order the new Samsung Galaxy Note 20 and get a R4 000 Samsung accessory voucher.",
    description: "This is the power phone that forever changes how you work and play.",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Pre-Order the new Samsung Galaxy Note 20 and get a R4 000 Samsung accessory voucher.",
    description: "This is the power phone that forever changes how you work and play.",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Pre-Order the new Samsung Galaxy Note 20 and get a R4 000 Samsung accessory voucher.",
    description: "This is the power phone that forever changes how you work and play.",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Pre-Order the new Samsung Galaxy Note 20 and get a R4 000 Samsung accessory voucher.",
    description: "This is the power phone that forever changes how you work and play.",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Pre-Order the new Samsung Galaxy Note 20 and get a R4 000 Samsung accessory voucher.",
    description: "This is the power phone that forever changes how you work and play.",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Pre-Order the new Samsung Galaxy Note 20 and get a R4 000 Samsung accessory voucher.",
    description: "This is the power phone that forever changes how you work and play.",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Promotions - last - Pre-Order the new Samsung Galaxy Note 20 and get a R4 000 Samsung accessory voucher.",
    description: "This is the power phone that forever changes how you work and play.",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }],
  Specials: [{
    title: "Specials = Vodacom Double Deals | 2 For 1",
    description: "Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Specials 1= Red Hot Dealz",
    description: "Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Red Hot Dealz",
    description: "Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Red Hot Dealz",
    description: "Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Red Hot Dealz",
    description: "Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Red Hot Dealz",
    description: "Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }],
  Content: [{
    title: "Content - Vodacom Double Deals | 2 For 1",
    description: "Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Content - Red Hot Dealz",
    description: "Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Content Red Hot Dealz",
    description: "Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Content Red Hot Dealz",
    description: "Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Content Hot Dealz",
    description: "Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Red Hot Dealz",
    description: "Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Red Hot Dealz",
    description: "Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }],
  Services: [{
    title: "Services - Vodacom Double Deals | 2 For 1",
    description: "Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Services-  Red Hot Dealz",
    description: "Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Services Red Hot Dealz",
    description: "Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Services Red Hot Dealz",
    description: "Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Red Hot Dealz",
    description: "Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Red Hot Dealz",
    description: "Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Red Hot Dealz",
    description: "Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }],
  Help: [{
    title: "Help -Vodacom Double Deals | 2 For 1",
    description: "Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Red Hot Dealz",
    description: "Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Red Hot Dealz",
    description: "Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Red Hot Dealz",
    description: "Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Red Hot Dealz",
    description: "Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Red Hot Dealz",
    description: "Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }, {
    title: "Red Hot Dealz",
    description: "Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
    button_txt: "Learn More",
    CTAButton_txt: "https://www.google.com/"
  }]
};
var productSearchMock = {
  products: {
    total_count: 21,
    page_info: {
      page_size: 12,
      current_page: 1,
      total_pages: 2
    },
    items: [{
      name: "Apple Promo Bundle",
      sku: "Test_Promo_Bundle",
      badges: null,
      badges_label: null,
      manufacturer: null,
      stock_status: "OUT_OF_STOCK",
      categories: [{
        id: 53,
        name: "Wearable Tech",
        url_key: "wearable-tech",
        image: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Wearable_tech.png"
      }],
      __typename: "BundleProduct",
      description: {
        html: ""
      },
      meta_title: "Test_Promo_Bundle",
      meta_description: "Test_Promo_Bundle ",
      price_range: {
        minimum_price: {
          regular_price: {
            value: 9998,
            currency: "ZAR"
          },
          final_price: {
            value: 7998,
            currency: "ZAR"
          },
          discount: {
            amount_off: 2000,
            percent_off: 20
          }
        },
        maximum_price: {
          regular_price: {
            value: 9998,
            currency: "ZAR"
          },
          final_price: {
            value: 7998,
            currency: "ZAR"
          },
          discount: {
            amount_off: 2000,
            percent_off: 20
          }
        }
      },
      price_tiers: [],
      image: {
        url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_smartwatch_bundle.png",
        label: "Apple Promo Bundle"
      },
      small_image: {
        url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_smartwatch_bundle.png",
        label: "Apple Promo Bundle"
      },
      media_gallery: [{
        url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_smartwatch_bundle.png",
        label: "Apple Promo Bundle"
      }]
    }, {
      name: "Apple iPhone 8 Pro + @ R200 With 20GB Data Free",
      sku: "1280464751",
      badges: null,
      badges_label: null,
      manufacturer: null,
      stock_status: "OUT_OF_STOCK",
      categories: [{
        id: 49,
        name: "Phones & SIM",
        url_key: "phones",
        image: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Phone_SIM.png"
      }, {
        id: 50,
        name: "Smartphones",
        url_key: "smartphones",
        image: null
      }],
      __typename: "BundleProduct",
      description: {
        html: ""
      },
      meta_title: "BundleTest4",
      meta_description: "BundleTest4 ",
      price_range: {
        minimum_price: {
          regular_price: {
            value: 20000,
            currency: "ZAR"
          },
          final_price: {
            value: 4000,
            currency: "ZAR"
          },
          discount: {
            amount_off: 16000,
            percent_off: 80
          }
        },
        maximum_price: {
          regular_price: {
            value: 20000,
            currency: "ZAR"
          },
          final_price: {
            value: 4000,
            currency: "ZAR"
          },
          discount: {
            amount_off: 16000,
            percent_off: 80
          }
        }
      },
      price_tiers: [],
      image: {
        url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/5/1/516gyfgghql._sy879_.jpg",
        label: "Apple iPhone 8 Pro + @ R200 With 20GB Data Free"
      },
      small_image: {
        url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/5/1/516gyfgghql._sy879_.jpg",
        label: "Apple iPhone 8 Pro + @ R200 With 20GB Data Free"
      },
      media_gallery: [{
        url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/5/1/516gyfgghql._sy879_.jpg",
        label: "Apple iPhone 8 Pro + @ R200 With 20GB Data Free"
      }]
    }, {
      name: "20GB Data once off",
      sku: "DV2MY5697",
      badges: null,
      badges_label: null,
      manufacturer: null,
      stock_status: "OUT_OF_STOCK",
      categories: [{
        id: 49,
        name: "Phones & SIM",
        url_key: "phones",
        image: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Phone_SIM.png"
      }, {
        id: 50,
        name: "Smartphones",
        url_key: "smartphones",
        image: null
      }],
      __typename: "BundleProduct",
      description: {
        html: "20GB Data once off"
      },
      meta_title: "40GB Data Sim",
      meta_description: "42GB Data Sim",
      price_range: {
        minimum_price: {
          regular_price: {
            value: 199,
            currency: "ZAR"
          },
          final_price: {
            value: 199,
            currency: "ZAR"
          },
          discount: {
            amount_off: 0,
            percent_off: 0
          }
        },
        maximum_price: {
          regular_price: {
            value: 199,
            currency: "ZAR"
          },
          final_price: {
            value: 199,
            currency: "ZAR"
          },
          discount: {
            amount_off: 0,
            percent_off: 0
          }
        }
      },
      price_tiers: [],
      image: {
        url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/api-web-largeid462978_2.jpg",
        label: "20GB Data once off"
      },
      small_image: {
        url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/api-web-mediumid462978_2.jpg",
        label: "20GB Data once off"
      },
      media_gallery: [{
        url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/api-web-largeid462978_2.jpg",
        label: "20GB Data once off"
      }, {
        url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/api-web-mediumid462978_2.jpg",
        label: "20GB Data once off"
      }, {
        url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/api-mobi-mediumid462978_2.jpg",
        label: "20GB Data once off"
      }]
    }, {
      name: "Promo Bundle",
      sku: "Promo_Bundle",
      badges: null,
      badges_label: null,
      manufacturer: null,
      stock_status: "IN_STOCK",
      categories: [{
        id: 49,
        name: "Phones & SIM",
        url_key: "phones",
        image: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Phone_SIM.png"
      }],
      __typename: "BundleProduct",
      description: {
        html: ""
      },
      meta_title: "Promo_Bundle",
      meta_description: "Promo_Bundle ",
      price_range: {
        minimum_price: {
          regular_price: {
            value: 5967,
            currency: "ZAR"
          },
          final_price: {
            value: 5967,
            currency: "ZAR"
          },
          discount: {
            amount_off: 0,
            percent_off: 0
          }
        },
        maximum_price: {
          regular_price: {
            value: 5967,
            currency: "ZAR"
          },
          final_price: {
            value: 5967,
            currency: "ZAR"
          },
          discount: {
            amount_off: 0,
            percent_off: 0
          }
        }
      },
      price_tiers: [],
      image: {
        url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_bundle.jpg",
        label: "Promo Bundle"
      },
      small_image: {
        url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_bundle.jpg",
        label: "Promo Bundle"
      },
      media_gallery: [{
        url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_bundle.jpg",
        label: "Promo Bundle"
      }]
    }, {
      name: "WearableTech Bundle",
      sku: "105577WBT_BN",
      badges: null,
      badges_label: null,
      manufacturer: null,
      stock_status: "OUT_OF_STOCK",
      categories: [{
        id: 52,
        name: "Accessories",
        url_key: "accessories",
        image: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Accessories_1.png"
      }, {
        id: 53,
        name: "Wearable Tech",
        url_key: "wearable-tech",
        image: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Wearable_tech.png"
      }],
      __typename: "BundleProduct",
      description: {
        html: ""
      },
      meta_title: "Wearable_Tech_Bundle",
      meta_description: "Wearable_Tech_Bundle ",
      price_range: {
        minimum_price: {
          regular_price: {
            value: 24995,
            currency: "ZAR"
          },
          final_price: {
            value: 19995,
            currency: "ZAR"
          },
          discount: {
            amount_off: 5000,
            percent_off: 20
          }
        },
        maximum_price: {
          regular_price: {
            value: 24995,
            currency: "ZAR"
          },
          final_price: {
            value: 19995,
            currency: "ZAR"
          },
          discount: {
            amount_off: 5000,
            percent_off: 20
          }
        }
      },
      price_tiers: [],
      image: {
        url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_huawei.png",
        label: "WearableTech Bundle"
      },
      small_image: {
        url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_huawei.png",
        label: "WearableTech Bundle"
      },
      media_gallery: [{
        url: "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_huawei.png",
        label: "WearableTech Bundle"
      }]
    }],
    aggregations: [{
      count: 2,
      label: "Price",
      attribute_code: "price",
      options: [{
        count: 20,
        label: "*-100000",
        value: "*_100000"
      }, {
        count: 1,
        label: "100000-*",
        value: "100000_*"
      }]
    }, {
      count: 8,
      label: "Category",
      attribute_code: "category_id",
      options: [{
        count: 7,
        label: "Phones & SIM",
        value: "49"
      }, {
        count: 5,
        label: "Smartphones",
        value: "50"
      }, {
        count: 4,
        label: "Gaming",
        value: "69"
      }, {
        count: 3,
        label: "Wearable Tech",
        value: "53"
      }, {
        count: 3,
        label: "Tablets & Laptops",
        value: "59"
      }, {
        count: 2,
        label: "Accessories",
        value: "52"
      }, {
        count: 2,
        label: "Smart Home",
        value: "74"
      }, {
        count: 1,
        label: "Gaming Laptops",
        value: "63"
      }]
    }, {
      count: 2,
      label: "Manufacturer",
      attribute_code: "manufacturer",
      options: [{
        count: 14,
        label: "Apple",
        value: "5487"
      }, {
        count: 1,
        label: "Samsung",
        value: "5488"
      }]
    }, {
      count: 3,
      label: "Color",
      attribute_code: "color",
      options: [{
        count: 4,
        label: "Space Grey",
        value: "5486"
      }, {
        count: 3,
        label: "Midnight Green",
        value: "5485"
      }, {
        count: 2,
        label: "Black",
        value: "5442"
      }]
    }, {
      count: 1,
      label: "Dynamic SKU",
      attribute_code: "sku_type",
      options: [{
        count: 21,
        label: "1",
        value: "1"
      }]
    }, {
      count: 3,
      label: "bundle_product_price_bucket",
      attribute_code: "bundle_product_price_bucket",
      options: [{
        count: 2,
        label: "400_450",
        value: "400_450"
      }, {
        count: 4,
        label: "2100_2150",
        value: "2100_2150"
      }, {
        count: 4,
        label: "2300_*",
        value: "2300_*"
      }]
    }, {
      count: 7,
      label: "Promotion Tag",
      attribute_code: "promotion_tag",
      options: [{
        count: 11,
        label: "Black Friday",
        value: "5512"
      }, {
        count: 9,
        label: "Exclusive to Online",
        value: "5496"
      }, {
        count: 4,
        label: "For Today Only",
        value: "5497"
      }, {
        count: 3,
        label: "Red hot deal",
        value: "5509"
      }, {
        count: 2,
        label: "Buy One Get One Free",
        value: "5533"
      }, {
        count: 1,
        label: "2 is better than 1",
        value: "5508"
      }, {
        count: 1,
        label: "Sim only deals",
        value: "5510"
      }]
    }, {
      count: 4,
      label: "Payment Terms",
      attribute_code: "payment_terms",
      options: [{
        count: 7,
        label: "24 months",
        value: "5554"
      }, {
        count: 7,
        label: "32 months",
        value: "5555"
      }, {
        count: 6,
        label: "12 months",
        value: "5553"
      }, {
        count: 1,
        label: "36 months",
        value: "5556"
      }]
    }, {
      count: 3,
      label: "Package Type or Plan Name",
      attribute_code: "plan_name",
      options: [{
        count: 7,
        label: "myRed",
        value: "5542"
      }, {
        count: 5,
        label: "myRed Data",
        value: "5543"
      }, {
        count: 3,
        label: "Smart",
        value: "5545"
      }]
    }, {
      count: 1,
      label: "Is Deal Locked",
      attribute_code: "is_deal_locked",
      options: [{
        count: 6,
        label: "1",
        value: "1"
      }]
    }, {
      count: 1,
      label: "Is Deal Product",
      attribute_code: "is_deal_product",
      options: [{
        count: 21,
        label: "1",
        value: "1"
      }]
    }, {
      count: 1,
      label: "Hide Product From Search And Listing Page",
      attribute_code: "is_hidden_product",
      options: [{
        count: 1,
        label: "1",
        value: "1"
      }]
    }, {
      count: 5,
      label: "minutes_bucket",
      attribute_code: "minutes_bucket",
      options: [{
        count: 1,
        label: "100_150",
        value: "100_150"
      }, {
        count: 1,
        label: "150_200",
        value: "150_200"
      }, {
        count: 6,
        label: "200_250",
        value: "200_250"
      }, {
        count: 6,
        label: "300_350",
        value: "300_350"
      }, {
        count: 3,
        label: "350_*",
        value: "350_*"
      }]
    }, {
      count: 4,
      label: "data_bucket",
      attribute_code: "data_bucket",
      options: [{
        count: 6,
        label: "*_50",
        value: "*_50"
      }, {
        count: 6,
        label: "50_100",
        value: "50_100"
      }, {
        count: 5,
        label: "100_150",
        value: "100_150"
      }, {
        count: 1,
        label: "200_*",
        value: "200_*"
      }]
    }, {
      count: 4,
      label: "airtime_bucket",
      attribute_code: "airtime_bucket",
      options: [{
        count: 9,
        label: "*_50",
        value: "*_50"
      }, {
        count: 3,
        label: "50_100",
        value: "50_100"
      }, {
        count: 3,
        label: "100_150",
        value: "100_150"
      }, {
        count: 3,
        label: "200_*",
        value: "200_*"
      }]
    }, {
      count: 10,
      label: "monthly_recurring_bucket",
      attribute_code: "monthly_recurring_bucket",
      options: [{
        count: 1,
        label: "100_150",
        value: "100_150"
      }, {
        count: 2,
        label: "300_350",
        value: "300_350"
      }, {
        count: 2,
        label: "350_400",
        value: "350_400"
      }, {
        count: 3,
        label: "400_450",
        value: "400_450"
      }, {
        count: 1,
        label: "500_550",
        value: "500_550"
      }, {
        count: 2,
        label: "600_650",
        value: "600_650"
      }, {
        count: 2,
        label: "700_750",
        value: "700_750"
      }, {
        count: 1,
        label: "900_950",
        value: "900_950"
      }, {
        count: 1,
        label: "1200_1250",
        value: "1200_1250"
      }, {
        count: 2,
        label: "1300_*",
        value: "1300_*"
      }]
    }, {
      count: 3,
      label: "Accessories",
      attribute_code: "accessories",
      options: [{
        count: 6,
        label: "Apple Airpods",
        value: "5547"
      }, {
        count: 4,
        label: "Apple TV 4K 64GB",
        value: "5548"
      }, {
        count: 3,
        label: "Samsung Galaxy Buds",
        value: "5550"
      }]
    }, {
      count: 3,
      label: "Plan Type",
      attribute_code: "plan_type",
      options: [{
        count: 15,
        label: "Data & Voice",
        value: "5537"
      }, {
        count: 5,
        label: "Data only",
        value: "5539"
      }, {
        count: 3,
        label: "Airtime",
        value: "5538"
      }]
    }, {
      count: 2,
      label: "Contract Type",
      attribute_code: "contract_type",
      options: [{
        count: 7,
        label: "Standard contract",
        value: "5540"
      }, {
        count: 5,
        label: "Top up",
        value: "5541"
      }]
    }],
    sort_fields: {
      "default": "product_ranking",
      options: [{
        label: "Position",
        value: "position"
      }, {
        label: "Price",
        value: "price"
      }, {
        label: "Deal Product Price",
        value: "bundle_product_price"
      }, {
        label: "Is Deal Product",
        value: "is_deal_product"
      }, {
        label: "Product Position",
        value: "product_ranking"
      }]
    }
  }
};

/***/ }),

/***/ 91553:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var React = _interopDefault(__webpack_require__(67294));

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  var _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };

  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  var _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}
/*eslint-disable*/


var libpannellum = function (window, document, undefined$1) {
  if (!window || !document) return;

  function Renderer(container) {
    var canvas = document.createElement("canvas");
    canvas.style.width = canvas.style.height = "100%";
    container.appendChild(canvas);
    var program, gl, vs, fs;
    var fallbackImgSize;
    var world;
    var vtmps;
    var pose;
    var image, imageType, dynamic;
    var texCoordBuffer, cubeVertBuf, cubeVertTexCoordBuf, cubeVertIndBuf;
    var globalParams;
    /**
     * Initialize renderer.
     * @memberof Renderer
     * @instance
     * @param {Image|Array|Object} image - Input image; format varies based on
     *      `imageType`. For `equirectangular`, this is an image; for
     *      `cubemap`, this is an array of images for the cube faces in the
     *      order [+z, +x, -z, -x, +y, -y]; for `multires`, this is a
     *      configuration object.
     * @param {string} imageType - The type of the image: `equirectangular`,
     *      `cubemap`, or `multires`.
     * @param {boolean} dynamic - Whether or not the image is dynamic (e.g. video).
     * @param {number} haov - Initial horizontal angle of view.
     * @param {number} vaov - Initial vertical angle of view.
     * @param {number} voffset - Initial vertical offset angle.
     * @param {function} callback - Load callback function.
     * @param {Object} [params] - Other configuration parameters (`horizonPitch`, `horizonRoll`, `backgroundColor`).
     */

    this.init = function (_image, _imageType, _dynamic, haov, vaov, voffset, callback, params) {
      // Default argument for image type
      if (_imageType === undefined$1) _imageType = "equirectangular";

      if (_imageType != "equirectangular" && _imageType != "cubemap" && _imageType != "multires") {
        console.log("Error: invalid image type specified!");
        throw {
          type: "config error"
        };
      }

      imageType = _imageType;
      image = _image;
      dynamic = _dynamic;
      globalParams = params || {}; // Clear old data

      if (program) {
        if (vs) {
          gl.detachShader(program, vs);
          gl.deleteShader(vs);
        }

        if (fs) {
          gl.detachShader(program, fs);
          gl.deleteShader(fs);
        }

        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
        if (program.texture) gl.deleteTexture(program.texture);
        if (program.nodeCache) for (var i = 0; i < program.nodeCache.length; i++) {
          gl.deleteTexture(program.nodeCache[i].texture);
        }
        gl.deleteProgram(program);
        program = undefined$1;
      }

      pose = undefined$1;
      var s;
      var faceMissing = false;
      var cubeImgWidth;

      if (imageType == "cubemap") {
        for (s = 0; s < 6; s++) {
          if (image[s].width > 0) {
            if (cubeImgWidth === undefined$1) cubeImgWidth = image[s].width;
            if (cubeImgWidth != image[s].width) console.log("Cube faces have inconsistent widths: " + cubeImgWidth + " vs. " + image[s].width);
          } else faceMissing = true;
        }
      }

      function fillMissingFaces(imgSize) {
        if (faceMissing) {
          // Fill any missing fallback/cubemap faces with background
          var nbytes = imgSize * imgSize * 4; // RGB, plus non-functional alpha

          var imageArray = new Uint8ClampedArray(nbytes);
          var rgb = params.backgroundColor ? params.backgroundColor : [0, 0, 0];
          rgb[0] *= 255;
          rgb[1] *= 255;
          rgb[2] *= 255; // Maybe filling could be done faster, see e.g. https://stackoverflow.com/questions/1295584/most-efficient-way-to-create-a-zero-filled-javascript-array

          for (var i = 0; i < nbytes; i++) {
            imageArray[i++] = rgb[0];
            imageArray[i++] = rgb[1];
            imageArray[i++] = rgb[2];
          }

          var backgroundSquare = new ImageData(imageArray, imgSize, imgSize);

          for (s = 0; s < 6; s++) {
            if (image[s].width == 0) image[s] = backgroundSquare;
          }
        }
      } // This awful browser specific test exists because iOS 8/9 and IE 11
      // don't display non-power-of-two cubemap textures but also don't
      // throw an error (tested on an iPhone 5c / iOS 8.1.3 / iOS 9.2 /
      // iOS 10.3.1).
      // Therefore, the WebGL context is never created for these browsers for
      // NPOT cubemaps, and the CSS 3D transform fallback renderer is used
      // instead.


      if (!(imageType == "cubemap" && (cubeImgWidth & cubeImgWidth - 1) !== 0 && (navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad).* os 8_/) || navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad).* os 9_/) || navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad).* os 10_/) || navigator.userAgent.match(/Trident.*rv[ :]*11\./)))) {
        // Enable WebGL on canvas
        if (!gl) gl = canvas.getContext("experimental-webgl", {
          alpha: false,
          depth: false
        });
        if (gl && gl.getError() == 1286) handleWebGLError1286();
      } // If there is no WebGL, fall back to CSS 3D transform renderer.
      // This will discard the image loaded so far and load the fallback image.
      // While browser specific tests are usually frowned upon, the
      // fallback viewer only really works with WebKit/Blink and IE 10/11
      // (it doesn't work properly in Firefox).


      if (!gl && (imageType == "multires" && image.hasOwnProperty("fallbackPath") || imageType == "cubemap") && ("WebkitAppearance" in document.documentElement.style || navigator.userAgent.match(/Trident.*rv[ :]*11\./) || navigator.appVersion.indexOf("MSIE 10") !== -1)) {
        // Remove old world if it exists
        if (world) {
          container.removeChild(world);
        } // Initialize renderer


        world = document.createElement("div");
        world.className = "pnlm-world"; // Add images

        var path;

        if (image.basePath) {
          path = image.basePath + image.fallbackPath;
        } else {
          path = image.fallbackPath;
        }

        var sides = ["f", "r", "b", "l", "u", "d"];
        var loaded = 0;

        var onLoad = function onLoad() {
          // Draw image on canvas
          var faceCanvas = document.createElement("canvas");
          faceCanvas.className = "pnlm-face pnlm-" + sides[this.side] + "face";
          world.appendChild(faceCanvas);
          var faceContext = faceCanvas.getContext("2d");
          faceCanvas.style.width = this.width + 4 + "px";
          faceCanvas.style.height = this.height + 4 + "px";
          faceCanvas.width = this.width + 4;
          faceCanvas.height = this.height + 4;
          faceContext.drawImage(this, 2, 2);
          var imgData = faceContext.getImageData(0, 0, faceCanvas.width, faceCanvas.height);
          var data = imgData.data; // Duplicate edge pixels

          var i;
          var j;

          for (i = 2; i < faceCanvas.width - 2; i++) {
            for (j = 0; j < 4; j++) {
              data[(i + faceCanvas.width) * 4 + j] = data[(i + faceCanvas.width * 2) * 4 + j];
              data[(i + faceCanvas.width * (faceCanvas.height - 2)) * 4 + j] = data[(i + faceCanvas.width * (faceCanvas.height - 3)) * 4 + j];
            }
          }

          for (i = 2; i < faceCanvas.height - 2; i++) {
            for (j = 0; j < 4; j++) {
              data[(i * faceCanvas.width + 1) * 4 + j] = data[(i * faceCanvas.width + 2) * 4 + j];
              data[((i + 1) * faceCanvas.width - 2) * 4 + j] = data[((i + 1) * faceCanvas.width - 3) * 4 + j];
            }
          }

          for (j = 0; j < 4; j++) {
            data[(faceCanvas.width + 1) * 4 + j] = data[(faceCanvas.width * 2 + 2) * 4 + j];
            data[(faceCanvas.width * 2 - 2) * 4 + j] = data[(faceCanvas.width * 3 - 3) * 4 + j];
            data[(faceCanvas.width * (faceCanvas.height - 2) + 1) * 4 + j] = data[(faceCanvas.width * (faceCanvas.height - 3) + 2) * 4 + j];
            data[(faceCanvas.width * (faceCanvas.height - 1) - 2) * 4 + j] = data[(faceCanvas.width * (faceCanvas.height - 2) - 3) * 4 + j];
          }

          for (i = 1; i < faceCanvas.width - 1; i++) {
            for (j = 0; j < 4; j++) {
              data[i * 4 + j] = data[(i + faceCanvas.width) * 4 + j];
              data[(i + faceCanvas.width * (faceCanvas.height - 1)) * 4 + j] = data[(i + faceCanvas.width * (faceCanvas.height - 2)) * 4 + j];
            }
          }

          for (i = 1; i < faceCanvas.height - 1; i++) {
            for (j = 0; j < 4; j++) {
              data[i * faceCanvas.width * 4 + j] = data[(i * faceCanvas.width + 1) * 4 + j];
              data[((i + 1) * faceCanvas.width - 1) * 4 + j] = data[((i + 1) * faceCanvas.width - 2) * 4 + j];
            }
          }

          for (j = 0; j < 4; j++) {
            data[j] = data[(faceCanvas.width + 1) * 4 + j];
            data[(faceCanvas.width - 1) * 4 + j] = data[(faceCanvas.width * 2 - 2) * 4 + j];
            data[faceCanvas.width * (faceCanvas.height - 1) * 4 + j] = data[(faceCanvas.width * (faceCanvas.height - 2) + 1) * 4 + j];
            data[(faceCanvas.width * faceCanvas.height - 1) * 4 + j] = data[(faceCanvas.width * (faceCanvas.height - 1) - 2) * 4 + j];
          } // Draw image width duplicated edge pixels on canvas


          faceContext.putImageData(imgData, 0, 0);
          incLoaded.call(this);
        };

        var incLoaded = function incLoaded() {
          if (this.width > 0) {
            if (fallbackImgSize === undefined$1) fallbackImgSize = this.width;
            if (fallbackImgSize != this.width) console.log("Fallback faces have inconsistent widths: " + fallbackImgSize + " vs. " + this.width);
          } else faceMissing = true;

          loaded++;

          if (loaded == 6) {
            fallbackImgSize = this.width;
            container.appendChild(world);
            callback();
          }
        };

        faceMissing = false;

        for (s = 0; s < 6; s++) {
          var faceImg = new Image();
          faceImg.crossOrigin = globalParams.crossOrigin ? globalParams.crossOrigin : "anonymous";
          faceImg.side = s;
          faceImg.onload = onLoad;
          faceImg.onerror = incLoaded; // ignore missing face to support partial fallback image

          if (imageType == "multires") {
            faceImg.src = path.replace("%s", sides[s]) + "." + image.extension;
          } else {
            faceImg.src = image[s].src;
          }
        }

        fillMissingFaces(fallbackImgSize);
        return;
      } else if (!gl) {
        console.log("Error: no WebGL support detected!");
        throw {
          type: "no webgl"
        };
      }

      if (imageType == "cubemap") fillMissingFaces(cubeImgWidth);

      if (image.basePath) {
        image.fullpath = image.basePath + image.path;
      } else {
        image.fullpath = image.path;
      }

      image.invTileResolution = 1 / image.tileResolution;
      var vertices = createCube();
      vtmps = [];

      for (s = 0; s < 6; s++) {
        vtmps[s] = vertices.slice(s * 12, s * 12 + 12);
        vertices = createCube();
      } // Make sure image isn't too big


      var maxWidth = 0;

      if (imageType == "equirectangular") {
        maxWidth = gl.getParameter(gl.MAX_TEXTURE_SIZE);

        if (Math.max(image.width / 2, image.height) > maxWidth) {
          console.log("Error: The image is too big; it's " + image.width + "px wide, " + "but this device's maximum supported size is " + maxWidth * 2 + "px.");
          throw {
            type: "webgl size error",
            width: image.width,
            maxWidth: maxWidth * 2
          };
        }
      } else if (imageType == "cubemap") {
        if (cubeImgWidth > gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE)) {
          console.log("Error: The image is too big; it's " + cubeImgWidth + "px wide, " + "but this device's maximum supported size is " + maxWidth + "px.");
          throw {
            type: "webgl size error",
            width: cubeImgWidth,
            maxWidth: maxWidth
          };
        }
      } // Store horizon pitch and roll if applicable


      if (params !== undefined$1 && (params.horizonPitch !== undefined$1 || params.horizonRoll !== undefined$1)) pose = [params.horizonPitch == undefined$1 ? 0 : params.horizonPitch, params.horizonRoll == undefined$1 ? 0 : params.horizonRoll]; // Set 2d texture binding

      var glBindType = gl.TEXTURE_2D; // Create viewport for entire canvas

      gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight); // Check precision support

      if (gl.getShaderPrecisionFormat) {
        var precision = gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT);

        if (precision && precision.precision < 1) {
          // `highp` precision not supported; https://stackoverflow.com/a/33308927
          fragEquiCubeBase = fragEquiCubeBase.replace("highp", "mediump");
        }
      } // Create vertex shader


      vs = gl.createShader(gl.VERTEX_SHADER);
      var vertexSrc = v;

      if (imageType == "multires") {
        vertexSrc = vMulti;
      }

      gl.shaderSource(vs, vertexSrc);
      gl.compileShader(vs); // Create fragment shader

      fs = gl.createShader(gl.FRAGMENT_SHADER);
      var fragmentSrc = fragEquirectangular;

      if (imageType == "cubemap") {
        glBindType = gl.TEXTURE_CUBE_MAP;
        fragmentSrc = fragCube;
      } else if (imageType == "multires") {
        fragmentSrc = fragMulti;
      }

      gl.shaderSource(fs, fragmentSrc);
      gl.compileShader(fs); // Link WebGL program

      program = gl.createProgram();
      gl.attachShader(program, vs);
      gl.attachShader(program, fs);
      gl.linkProgram(program); // Log errors

      if (!gl.getShaderParameter(vs, gl.COMPILE_STATUS)) console.log(gl.getShaderInfoLog(vs));
      if (!gl.getShaderParameter(fs, gl.COMPILE_STATUS)) console.log(gl.getShaderInfoLog(fs));
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) console.log(gl.getProgramInfoLog(program)); // Use WebGL program

      gl.useProgram(program);
      program.drawInProgress = false; // Set background clear color (does not apply to cubemap/fallback image)

      var color = params.backgroundColor ? params.backgroundColor : [0, 0, 0];
      gl.clearColor(color[0], color[1], color[2], 1.0);
      gl.clear(gl.COLOR_BUFFER_BIT); // Look up texture coordinates location

      program.texCoordLocation = gl.getAttribLocation(program, "a_texCoord");
      gl.enableVertexAttribArray(program.texCoordLocation);

      if (imageType != "multires") {
        // Provide texture coordinates for rectangle
        if (!texCoordBuffer) texCoordBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, texCoordBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, 1, 1, 1, 1, -1, -1, 1, 1, -1, -1, -1]), gl.STATIC_DRAW);
        gl.vertexAttribPointer(program.texCoordLocation, 2, gl.FLOAT, false, 0, 0); // Pass aspect ratio

        program.aspectRatio = gl.getUniformLocation(program, "u_aspectRatio");
        gl.uniform1f(program.aspectRatio, gl.drawingBufferWidth / gl.drawingBufferHeight); // Locate psi, theta, focal length, horizontal extent, vertical extent, and vertical offset

        program.psi = gl.getUniformLocation(program, "u_psi");
        program.theta = gl.getUniformLocation(program, "u_theta");
        program.f = gl.getUniformLocation(program, "u_f");
        program.h = gl.getUniformLocation(program, "u_h");
        program.v = gl.getUniformLocation(program, "u_v");
        program.vo = gl.getUniformLocation(program, "u_vo");
        program.rot = gl.getUniformLocation(program, "u_rot"); // Pass horizontal extent, vertical extent, and vertical offset

        gl.uniform1f(program.h, haov / (Math.PI * 2.0));
        gl.uniform1f(program.v, vaov / Math.PI);
        gl.uniform1f(program.vo, voffset / Math.PI * 2); // Set background color

        if (imageType == "equirectangular") {
          program.backgroundColor = gl.getUniformLocation(program, "u_backgroundColor");
          gl.uniform4fv(program.backgroundColor, color.concat([1]));
        } // Create texture


        program.texture = gl.createTexture();
        gl.bindTexture(glBindType, program.texture); // Upload images to texture depending on type

        if (imageType == "cubemap") {
          // Load all six sides of the cube map
          gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, image[1]);
          gl.texImage2D(gl.TEXTURE_CUBE_MAP_NEGATIVE_X, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, image[3]);
          gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_Y, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, image[4]);
          gl.texImage2D(gl.TEXTURE_CUBE_MAP_NEGATIVE_Y, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, image[5]);
          gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_Z, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, image[0]);
          gl.texImage2D(gl.TEXTURE_CUBE_MAP_NEGATIVE_Z, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, image[2]);
        } else {
          if (image.width <= maxWidth) {
            gl.uniform1i(gl.getUniformLocation(program, "u_splitImage"), 0); // Upload image to the texture

            gl.texImage2D(glBindType, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, image);
          } else {
            // Image needs to be split into two parts due to texture size limits
            gl.uniform1i(gl.getUniformLocation(program, "u_splitImage"), 1); // Draw image on canvas

            var cropCanvas = document.createElement("canvas");
            cropCanvas.width = image.width / 2;
            cropCanvas.height = image.height;
            var cropContext = cropCanvas.getContext("2d");
            cropContext.drawImage(image, 0, 0); // Upload first half of image to the texture

            var cropImage = cropContext.getImageData(0, 0, image.width / 2, image.height);
            gl.texImage2D(glBindType, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, cropImage); // Create and bind texture for second half of image

            program.texture2 = gl.createTexture();
            gl.activeTexture(gl.TEXTURE1);
            gl.bindTexture(glBindType, program.texture2);
            gl.uniform1i(gl.getUniformLocation(program, "u_image1"), 1); // Upload second half of image to the texture

            cropContext.drawImage(image, -image.width / 2, 0);
            cropImage = cropContext.getImageData(0, 0, image.width / 2, image.height);
            gl.texImage2D(glBindType, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, cropImage); // Set parameters for rendering any size

            gl.texParameteri(glBindType, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(glBindType, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            gl.texParameteri(glBindType, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
            gl.texParameteri(glBindType, gl.TEXTURE_MAG_FILTER, gl.LINEAR); // Reactivate first texture unit

            gl.activeTexture(gl.TEXTURE0);
          }
        } // Set parameters for rendering any size


        gl.texParameteri(glBindType, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(glBindType, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(glBindType, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(glBindType, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      } else {
        // Look up vertex coordinates location
        program.vertPosLocation = gl.getAttribLocation(program, "a_vertCoord");
        gl.enableVertexAttribArray(program.vertPosLocation); // Create buffers

        if (!cubeVertBuf) cubeVertBuf = gl.createBuffer();
        if (!cubeVertTexCoordBuf) cubeVertTexCoordBuf = gl.createBuffer();
        if (!cubeVertIndBuf) cubeVertIndBuf = gl.createBuffer(); // Bind texture coordinate buffer and pass coordinates to WebGL

        gl.bindBuffer(gl.ARRAY_BUFFER, cubeVertTexCoordBuf);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]), gl.STATIC_DRAW); // Bind square index buffer and pass indicies to WebGL

        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, cubeVertIndBuf);
        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array([0, 1, 2, 0, 2, 3]), gl.STATIC_DRAW); // Find uniforms

        program.perspUniform = gl.getUniformLocation(program, "u_perspMatrix");
        program.cubeUniform = gl.getUniformLocation(program, "u_cubeMatrix"); //program.colorUniform = gl.getUniformLocation(program, 'u_color');

        program.level = -1;
        program.currentNodes = [];
        program.nodeCache = [];
        program.nodeCacheTimestamp = 0;
      } // Check if there was an error


      var err = gl.getError();

      if (err !== 0) {
        console.log("Error: Something went wrong with WebGL!", err);
        throw {
          type: "webgl error"
        };
      }

      callback();
    };
    /**
     * Destroy renderer.
     * @memberof Renderer
     * @instance
     */


    this.destroy = function () {
      if (container !== undefined$1) {
        if (canvas !== undefined$1 && container.contains(canvas)) {
          container.removeChild(canvas);
        }

        if (world !== undefined$1 && container.contains(world)) {
          container.removeChild(world);
        }
      }

      if (gl) {
        // The spec says this is only supposed to simulate losing the WebGL
        // context, but in practice it tends to actually free the memory.
        var extension = gl.getExtension("WEBGL_lose_context");
        if (extension) extension.loseContext();
      }
    };
    /**
     * Resize renderer (call after resizing container).
     * @memberof Renderer
     * @instance
     */


    this.resize = function () {
      var pixelRatio = window.devicePixelRatio || 1;
      canvas.width = canvas.clientWidth * pixelRatio;
      canvas.height = canvas.clientHeight * pixelRatio;

      if (gl) {
        if (gl.getError() == 1286) handleWebGLError1286();
        gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);

        if (imageType != "multires") {
          gl.uniform1f(program.aspectRatio, canvas.clientWidth / canvas.clientHeight);
        }
      }
    }; // Initialize canvas size


    this.resize();
    /**
     * Set renderer horizon pitch and roll.
     * @memberof Renderer
     * @instance
     */

    this.setPose = function (horizonPitch, horizonRoll) {
      pose = [horizonPitch, horizonRoll];
    };
    /**
     * Render new view of panorama.
     * @memberof Renderer
     * @instance
     * @param {number} pitch - Pitch to render at (in radians).
     * @param {number} yaw - Yaw to render at (in radians).
     * @param {number} hfov - Horizontal field of view to render with (in radians).
     * @param {Object} [params] - Extra configuration parameters.
     * @param {number} [params.roll] - Camera roll (in radians).
     * @param {boolean} [params.returnImage] - Return rendered image?
     */


    this.render = function (pitch, yaw, hfov, params) {
      var focal,
          i,
          s,
          roll = 0;
      if (params === undefined$1) params = {};
      if (params.roll) roll = params.roll; // Apply pitch and roll transformation if applicable

      if (pose !== undefined$1) {
        var horizonPitch = pose[0],
            horizonRoll = pose[1]; // Calculate new pitch and yaw

        var orig_pitch = pitch,
            orig_yaw = yaw,
            x = Math.cos(horizonRoll) * Math.sin(pitch) * Math.sin(horizonPitch) + Math.cos(pitch) * (Math.cos(horizonPitch) * Math.cos(yaw) + Math.sin(horizonRoll) * Math.sin(horizonPitch) * Math.sin(yaw)),
            y = -Math.sin(pitch) * Math.sin(horizonRoll) + Math.cos(pitch) * Math.cos(horizonRoll) * Math.sin(yaw),
            z = Math.cos(horizonRoll) * Math.cos(horizonPitch) * Math.sin(pitch) + Math.cos(pitch) * (-Math.cos(yaw) * Math.sin(horizonPitch) + Math.cos(horizonPitch) * Math.sin(horizonRoll) * Math.sin(yaw));
        pitch = Math.asin(Math.max(Math.min(z, 1), -1));
        yaw = Math.atan2(y, x); // Calculate roll

        var v = [Math.cos(orig_pitch) * (Math.sin(horizonRoll) * Math.sin(horizonPitch) * Math.cos(orig_yaw) - Math.cos(horizonPitch) * Math.sin(orig_yaw)), Math.cos(orig_pitch) * Math.cos(horizonRoll) * Math.cos(orig_yaw), Math.cos(orig_pitch) * (Math.cos(horizonPitch) * Math.sin(horizonRoll) * Math.cos(orig_yaw) + Math.sin(orig_yaw) * Math.sin(horizonPitch))],
            w = [-Math.cos(pitch) * Math.sin(yaw), Math.cos(pitch) * Math.cos(yaw)];
        var roll_adj = Math.acos(Math.max(Math.min((v[0] * w[0] + v[1] * w[1]) / (Math.sqrt(v[0] * v[0] + v[1] * v[1] + v[2] * v[2]) * Math.sqrt(w[0] * w[0] + w[1] * w[1])), 1), -1));
        if (v[2] < 0) roll_adj = 2 * Math.PI - roll_adj;
        roll += roll_adj;
      } // If no WebGL


      if (!gl && (imageType == "multires" || imageType == "cubemap")) {
        // Determine face transforms
        s = fallbackImgSize / 2;
        var transforms = {
          f: "translate3d(-" + (s + 2) + "px, -" + (s + 2) + "px, -" + s + "px)",
          b: "translate3d(" + (s + 2) + "px, -" + (s + 2) + "px, " + s + "px) rotateX(180deg) rotateZ(180deg)",
          u: "translate3d(-" + (s + 2) + "px, -" + s + "px, " + (s + 2) + "px) rotateX(270deg)",
          d: "translate3d(-" + (s + 2) + "px, " + s + "px, -" + (s + 2) + "px) rotateX(90deg)",
          l: "translate3d(-" + s + "px, -" + (s + 2) + "px, " + (s + 2) + "px) rotateX(180deg) rotateY(90deg) rotateZ(180deg)",
          r: "translate3d(" + s + "px, -" + (s + 2) + "px, -" + (s + 2) + "px) rotateY(270deg)"
        };
        focal = 1 / Math.tan(hfov / 2);
        var zoom = focal * canvas.clientWidth / 2 + "px";
        var transform = "perspective(" + zoom + ") translateZ(" + zoom + ") rotateX(" + pitch + "rad) rotateY(" + yaw + "rad) "; // Apply face transforms

        var faces = Object.keys(transforms);

        for (i = 0; i < 6; i++) {
          var face = world.querySelector(".pnlm-" + faces[i] + "face");
          if (!face) continue; // ignore missing face to support partial cubemap/fallback image

          face.style.webkitTransform = transform + transforms[faces[i]];
          face.style.transform = transform + transforms[faces[i]];
        }

        return;
      }

      if (imageType != "multires") {
        // Calculate focal length from vertical field of view
        var vfov = 2 * Math.atan(Math.tan(hfov * 0.5) / (gl.drawingBufferWidth / gl.drawingBufferHeight));
        focal = 1 / Math.tan(vfov * 0.5); // Pass psi, theta, roll, and focal length

        gl.uniform1f(program.psi, yaw);
        gl.uniform1f(program.theta, pitch);
        gl.uniform1f(program.rot, roll);
        gl.uniform1f(program.f, focal);

        if (dynamic === true) {
          // Update texture if dynamic
          if (imageType == "equirectangular") {
            gl.bindTexture(gl.TEXTURE_2D, program.texture);
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, image);
          }
        } // Draw using current buffer


        gl.drawArrays(gl.TRIANGLES, 0, 6);
      } else {
        // Create perspective matrix
        var perspMatrix = makePersp(hfov, gl.drawingBufferWidth / gl.drawingBufferHeight, 0.1, 100.0); // Find correct zoom level

        checkZoom(hfov); // Create rotation matrix

        var matrix = identityMatrix3();
        matrix = rotateMatrix(matrix, -roll, "z");
        matrix = rotateMatrix(matrix, -pitch, "x");
        matrix = rotateMatrix(matrix, yaw, "y");
        matrix = makeMatrix4(matrix); // Set matrix uniforms

        gl.uniformMatrix4fv(program.perspUniform, false, new Float32Array(transposeMatrix4(perspMatrix)));
        gl.uniformMatrix4fv(program.cubeUniform, false, new Float32Array(transposeMatrix4(matrix))); // Find current nodes

        var rotPersp = rotatePersp(perspMatrix, matrix);
        program.nodeCache.sort(multiresNodeSort);

        if (program.nodeCache.length > 200 && program.nodeCache.length > program.currentNodes.length + 50) {
          // Remove older nodes from cache
          var removed = program.nodeCache.splice(200, program.nodeCache.length - 200);

          for (var j = 0; j < removed.length; j++) {
            // Explicitly delete textures
            gl.deleteTexture(removed[j].texture);
          }
        }

        program.currentNodes = [];
        var sides = ["f", "b", "u", "d", "l", "r"];

        for (s = 0; s < 6; s++) {
          var ntmp = new MultiresNode(vtmps[s], sides[s], 1, 0, 0, image.fullpath);
          testMultiresNode(rotPersp, ntmp, pitch, yaw);
        }

        program.currentNodes.sort(multiresNodeRenderSort); // Unqueue any pending requests for nodes that are no longer visible

        for (i = pendingTextureRequests.length - 1; i >= 0; i--) {
          if (program.currentNodes.indexOf(pendingTextureRequests[i].node) === -1) {
            pendingTextureRequests[i].node.textureLoad = false;
            pendingTextureRequests.splice(i, 1);
          }
        } // Allow one request to be pending, so that we can create a texture buffer for that in advance of loading actually beginning


        if (pendingTextureRequests.length === 0) {
          for (i = 0; i < program.currentNodes.length; i++) {
            var node = program.currentNodes[i];

            if (!node.texture && !node.textureLoad) {
              node.textureLoad = true;
              setTimeout(processNextTile, 0, node); // Only process one tile per frame to improve responsiveness

              break;
            }
          }
        } // Draw tiles


        multiresDraw();
      }

      if (params.returnImage !== undefined$1) {
        return canvas.toDataURL("image/png");
      }
    };
    /**
     * Check if images are loading.
     * @memberof Renderer
     * @instance
     * @returns {boolean} Whether or not images are loading.
     */


    this.isLoading = function () {
      if (gl && imageType == "multires") {
        for (var i = 0; i < program.currentNodes.length; i++) {
          if (!program.currentNodes[i].textureLoaded) {
            return true;
          }
        }
      }

      return false;
    };
    /**
     * Retrieve renderer's canvas.
     * @memberof Renderer
     * @instance
     * @returns {HTMLElement} Renderer's canvas.
     */


    this.getCanvas = function () {
      return canvas;
    };
    /**
     * Sorting method for multires nodes.
     * @private
     * @param {MultiresNode} a - First node.
     * @param {MultiresNode} b - Second node.
     * @returns {number} Base tiles first, then higher timestamp first.
     */


    function multiresNodeSort(a, b) {
      // Base tiles are always first
      if (a.level == 1 && b.level != 1) {
        return -1;
      }

      if (b.level == 1 && a.level != 1) {
        return 1;
      } // Higher timestamp first


      return b.timestamp - a.timestamp;
    }
    /**
     * Sorting method for multires node rendering.
     * @private
     * @param {MultiresNode} a - First node.
     * @param {MultiresNode} b - Second node.
     * @returns {number} Lower zoom levels first, then closest to center first.
     */


    function multiresNodeRenderSort(a, b) {
      // Lower zoom levels first
      if (a.level != b.level) {
        return a.level - b.level;
      } // Lower distance from center first


      return a.diff - b.diff;
    }
    /**
     * Draws multires nodes.
     * @private
     */


    function multiresDraw() {
      if (!program.drawInProgress) {
        program.drawInProgress = true;
        gl.clear(gl.COLOR_BUFFER_BIT);

        for (var i = 0; i < program.currentNodes.length; i++) {
          if (program.currentNodes[i].textureLoaded > 1) {
            //var color = program.currentNodes[i].color;
            //gl.uniform4f(program.colorUniform, color[0], color[1], color[2], 1.0);
            // Bind vertex buffer and pass vertices to WebGL
            gl.bindBuffer(gl.ARRAY_BUFFER, cubeVertBuf);
            gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(program.currentNodes[i].vertices), gl.STATIC_DRAW);
            gl.vertexAttribPointer(program.vertPosLocation, 3, gl.FLOAT, false, 0, 0); // Prep for texture

            gl.bindBuffer(gl.ARRAY_BUFFER, cubeVertTexCoordBuf);
            gl.vertexAttribPointer(program.texCoordLocation, 2, gl.FLOAT, false, 0, 0); // Bind texture and draw tile

            gl.bindTexture(gl.TEXTURE_2D, program.currentNodes[i].texture); // Bind program.currentNodes[i].texture to TEXTURE0

            gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0);
          }
        }

        program.drawInProgress = false;
      }
    }
    /**
     * Creates new multires node.
     * @constructor
     * @private
     * @param {number[]} vertices - Node's verticies.
     * @param {string} side - Node's cube face.
     * @param {number} level - Node's zoom level.
     * @param {number} x - Node's x position.
     * @param {number} y - Node's y position.
     * @param {string} path - Node's path.
     */


    function MultiresNode(vertices, side, level, x, y, path) {
      this.vertices = vertices;
      this.side = side;
      this.level = level;
      this.x = x;
      this.y = y;
      this.path = path.replace("%s", side).replace("%l", level).replace("%x", x).replace("%y", y);
    }
    /**
     * Test if multires node is visible. If it is, add it to current nodes,
     * load its texture, and load appropriate child nodes.
     * @private
     * @param {number[]} rotPersp - Rotated perspective matrix.
     * @param {MultiresNode} node - Multires node to check.
     * @param {number} pitch - Pitch to check at.
     * @param {number} yaw - Yaw to check at.
     * @param {number} hfov - Horizontal field of view to check at.
     */


    function testMultiresNode(rotPersp, node, pitch, yaw, hfov) {
      if (checkSquareInView(rotPersp, node.vertices)) {
        // Calculate central angle between center of view and center of tile
        var v = node.vertices;
        var x = v[0] + v[3] + v[6] + v[9];
        var y = v[1] + v[4] + v[7] + v[10];
        var z = v[2] + v[5] + v[8] + v[11];
        var r = Math.sqrt(x * x + y * y + z * z);
        var theta = Math.asin(z / r);
        var phi = Math.atan2(y, x);
        var ydiff = phi - yaw;
        ydiff += ydiff > Math.PI ? -2 * Math.PI : ydiff < -Math.PI ? 2 * Math.PI : 0;
        ydiff = Math.abs(ydiff);
        node.diff = Math.acos(Math.sin(pitch) * Math.sin(theta) + Math.cos(pitch) * Math.cos(theta) * Math.cos(ydiff)); // Add node to current nodes and load texture if needed

        var inCurrent = false;

        for (var k = 0; k < program.nodeCache.length; k++) {
          if (program.nodeCache[k].path == node.path) {
            inCurrent = true;
            program.nodeCache[k].timestamp = program.nodeCacheTimestamp++;
            program.nodeCache[k].diff = node.diff;
            program.currentNodes.push(program.nodeCache[k]);
            break;
          }
        }

        if (!inCurrent) {
          //node.color = [Math.random(), Math.random(), Math.random()];
          node.timestamp = program.nodeCacheTimestamp++;
          program.currentNodes.push(node);
          program.nodeCache.push(node);
        } // TODO: Test error
        // Create child nodes


        if (node.level < program.level) {
          var cubeSize = image.cubeResolution * Math.pow(2, node.level - image.maxLevel);
          var numTiles = Math.ceil(cubeSize * image.invTileResolution) - 1;
          var doubleTileSize = cubeSize % image.tileResolution * 2;
          var lastTileSize = cubeSize * 2 % image.tileResolution;

          if (lastTileSize === 0) {
            lastTileSize = image.tileResolution;
          }

          if (doubleTileSize === 0) {
            doubleTileSize = image.tileResolution * 2;
          }

          var f = 0.5;

          if (node.x == numTiles || node.y == numTiles) {
            f = 1.0 - image.tileResolution / (image.tileResolution + lastTileSize);
          }

          var i = 1.0 - f;
          var children = [];
          var vtmp, ntmp;
          var f1 = f,
              f2 = f,
              f3 = f,
              i1 = i,
              i2 = i,
              i3 = i; // Handle non-symmetric tiles

          if (lastTileSize < image.tileResolution) {
            if (node.x == numTiles && node.y != numTiles) {
              f2 = 0.5;
              i2 = 0.5;

              if (node.side == "d" || node.side == "u") {
                f3 = 0.5;
                i3 = 0.5;
              }
            } else if (node.x != numTiles && node.y == numTiles) {
              f1 = 0.5;
              i1 = 0.5;

              if (node.side == "l" || node.side == "r") {
                f3 = 0.5;
                i3 = 0.5;
              }
            }
          } // Handle small tiles that have fewer than four children


          if (doubleTileSize <= image.tileResolution) {
            if (node.x == numTiles) {
              f1 = 0;
              i1 = 1;

              if (node.side == "l" || node.side == "r") {
                f3 = 0;
                i3 = 1;
              }
            }

            if (node.y == numTiles) {
              f2 = 0;
              i2 = 1;

              if (node.side == "d" || node.side == "u") {
                f3 = 0;
                i3 = 1;
              }
            }
          }

          vtmp = [v[0], v[1], v[2], v[0] * f1 + v[3] * i1, v[1] * f + v[4] * i, v[2] * f3 + v[5] * i3, v[0] * f1 + v[6] * i1, v[1] * f2 + v[7] * i2, v[2] * f3 + v[8] * i3, v[0] * f + v[9] * i, v[1] * f2 + v[10] * i2, v[2] * f3 + v[11] * i3];
          ntmp = new MultiresNode(vtmp, node.side, node.level + 1, node.x * 2, node.y * 2, image.fullpath);
          children.push(ntmp);

          if (!(node.x == numTiles && doubleTileSize <= image.tileResolution)) {
            vtmp = [v[0] * f1 + v[3] * i1, v[1] * f + v[4] * i, v[2] * f3 + v[5] * i3, v[3], v[4], v[5], v[3] * f + v[6] * i, v[4] * f2 + v[7] * i2, v[5] * f3 + v[8] * i3, v[0] * f1 + v[6] * i1, v[1] * f2 + v[7] * i2, v[2] * f3 + v[8] * i3];
            ntmp = new MultiresNode(vtmp, node.side, node.level + 1, node.x * 2 + 1, node.y * 2, image.fullpath);
            children.push(ntmp);
          }

          if (!(node.x == numTiles && doubleTileSize <= image.tileResolution) && !(node.y == numTiles && doubleTileSize <= image.tileResolution)) {
            vtmp = [v[0] * f1 + v[6] * i1, v[1] * f2 + v[7] * i2, v[2] * f3 + v[8] * i3, v[3] * f + v[6] * i, v[4] * f2 + v[7] * i2, v[5] * f3 + v[8] * i3, v[6], v[7], v[8], v[9] * f1 + v[6] * i1, v[10] * f + v[7] * i, v[11] * f3 + v[8] * i3];
            ntmp = new MultiresNode(vtmp, node.side, node.level + 1, node.x * 2 + 1, node.y * 2 + 1, image.fullpath);
            children.push(ntmp);
          }

          if (!(node.y == numTiles && doubleTileSize <= image.tileResolution)) {
            vtmp = [v[0] * f + v[9] * i, v[1] * f2 + v[10] * i2, v[2] * f3 + v[11] * i3, v[0] * f1 + v[6] * i1, v[1] * f2 + v[7] * i2, v[2] * f3 + v[8] * i3, v[9] * f1 + v[6] * i1, v[10] * f + v[7] * i, v[11] * f3 + v[8] * i3, v[9], v[10], v[11]];
            ntmp = new MultiresNode(vtmp, node.side, node.level + 1, node.x * 2, node.y * 2 + 1, image.fullpath);
            children.push(ntmp);
          }

          for (var j = 0; j < children.length; j++) {
            testMultiresNode(rotPersp, children[j], pitch, yaw);
          }
        }
      }
    }
    /**
     * Creates cube vertex array.
     * @private
     * @returns {number[]} Cube vertex array.
     */


    function createCube() {
      return [-1, 1, -1, 1, 1, -1, 1, -1, -1, -1, -1, -1, // Front face
      1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, // Back face
      -1, 1, 1, 1, 1, 1, 1, 1, -1, -1, 1, -1, // Up face
      -1, -1, -1, 1, -1, -1, 1, -1, 1, -1, -1, 1, // Down face
      -1, 1, 1, -1, 1, -1, -1, -1, -1, -1, -1, 1, // Left face
      1, 1, -1, 1, 1, 1, 1, -1, 1, 1, -1, -1 // Right face
      ];
    }
    /**
     * Creates 3x3 identity matrix.
     * @private
     * @returns {number[]} Identity matrix.
     */


    function identityMatrix3() {
      return [1, 0, 0, 0, 1, 0, 0, 0, 1];
    }
    /**
     * Rotates a 3x3 matrix.
     * @private
     * @param {number[]} m - Matrix to rotate.
     * @param {number[]} angle - Angle to rotate by in radians.
     * @param {string} axis - Axis to rotate about (`x`, `y`, or `z`).
     * @returns {number[]} Rotated matrix.
     */


    function rotateMatrix(m, angle, axis) {
      var s = Math.sin(angle);
      var c = Math.cos(angle);

      if (axis == "x") {
        return [m[0], c * m[1] + s * m[2], c * m[2] - s * m[1], m[3], c * m[4] + s * m[5], c * m[5] - s * m[4], m[6], c * m[7] + s * m[8], c * m[8] - s * m[7]];
      }

      if (axis == "y") {
        return [c * m[0] - s * m[2], m[1], c * m[2] + s * m[0], c * m[3] - s * m[5], m[4], c * m[5] + s * m[3], c * m[6] - s * m[8], m[7], c * m[8] + s * m[6]];
      }

      if (axis == "z") {
        return [c * m[0] + s * m[1], c * m[1] - s * m[0], m[2], c * m[3] + s * m[4], c * m[4] - s * m[3], m[5], c * m[6] + s * m[7], c * m[7] - s * m[6], m[8]];
      }
    }
    /**
     * Turns a 3x3 matrix into a 4x4 matrix.
     * @private
     * @param {number[]} m - Input matrix.
     * @returns {number[]} Expanded matrix.
     */


    function makeMatrix4(m) {
      return [m[0], m[1], m[2], 0, m[3], m[4], m[5], 0, m[6], m[7], m[8], 0, 0, 0, 0, 1];
    }
    /**
     * Transposes a 4x4 matrix.
     * @private
     * @param {number[]} m - Input matrix.
     * @returns {number[]} Transposed matrix.
     */


    function transposeMatrix4(m) {
      return [m[0], m[4], m[8], m[12], m[1], m[5], m[9], m[13], m[2], m[6], m[10], m[14], m[3], m[7], m[11], m[15]];
    }
    /**
     * Creates a perspective matrix.
     * @private
     * @param {number} hfov - Desired horizontal field of view.
     * @param {number} aspect - Desired aspect ratio.
     * @param {number} znear - Near distance.
     * @param {number} zfar - Far distance.
     * @returns {number[]} Generated perspective matrix.
     */


    function makePersp(hfov, aspect, znear, zfar) {
      var fovy = 2 * Math.atan(Math.tan(hfov / 2) * gl.drawingBufferHeight / gl.drawingBufferWidth);
      var f = 1 / Math.tan(fovy / 2);
      return [f / aspect, 0, 0, 0, 0, f, 0, 0, 0, 0, (zfar + znear) / (znear - zfar), 2 * zfar * znear / (znear - zfar), 0, 0, -1, 0];
    }
    /**
     * Processes a loaded texture image into a WebGL texture.
     * @private
     * @param {Image} img - Input image.
     * @param {WebGLTexture} tex - Texture to bind image to.
     */


    function processLoadedTexture(img, tex) {
      gl.bindTexture(gl.TEXTURE_2D, tex);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, img);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.bindTexture(gl.TEXTURE_2D, null);
    }

    var pendingTextureRequests = []; // Based on http://blog.tojicode.com/2012/03/javascript-memory-optimization-and.html

    var loadTexture = function () {
      var cacheTop = 4; // Maximum number of concurrents loads

      var textureImageCache = {};
      var crossOrigin;

      function TextureImageLoader() {
        var self = this;
        this.texture = this.callback = null;
        this.image = new Image();
        this.image.crossOrigin = crossOrigin ? crossOrigin : "anonymous";

        var loadFn = function loadFn() {
          if (self.image.width > 0 && self.image.height > 0) {
            // ignore missing tile to supporting partial image
            processLoadedTexture(self.image, self.texture);
            self.callback(self.texture, true);
          } else {
            self.callback(self.texture, false);
          }

          releaseTextureImageLoader(self);
        };

        this.image.addEventListener("load", loadFn);
        this.image.addEventListener("error", loadFn); // ignore missing tile file to support partial image, otherwise retry loop causes high CPU load
      }

      TextureImageLoader.prototype.loadTexture = function (src, texture, callback) {
        this.texture = texture;
        this.callback = callback;
        this.image.src = src;
      };

      function PendingTextureRequest(node, src, texture, callback) {
        this.node = node;
        this.src = src;
        this.texture = texture;
        this.callback = callback;
      }

      function releaseTextureImageLoader(til) {
        if (pendingTextureRequests.length) {
          var req = pendingTextureRequests.shift();
          til.loadTexture(req.src, req.texture, req.callback);
        } else textureImageCache[cacheTop++] = til;
      }

      for (var i = 0; i < cacheTop; i++) {
        textureImageCache[i] = new TextureImageLoader();
      }

      return function (node, src, callback, _crossOrigin) {
        crossOrigin = _crossOrigin;
        var texture = gl.createTexture();
        if (cacheTop) textureImageCache[--cacheTop].loadTexture(src, texture, callback);else pendingTextureRequests.push(new PendingTextureRequest(node, src, texture, callback));
        return texture;
      };
    }();
    /**
     * Loads image and creates texture for a multires node / tile.
     * @private
     * @param {MultiresNode} node - Input node.
     */


    function processNextTile(node) {
      loadTexture(node, node.path + "." + image.extension, function (texture, loaded) {
        node.texture = texture;
        node.textureLoaded = loaded ? 2 : 1;
      }, globalParams.crossOrigin);
    }
    /**
     * Finds and applies optimal multires zoom level.
     * @private
     * @param {number} hfov - Horizontal field of view to check at.
     */


    function checkZoom(hfov) {
      // Find optimal level
      var newLevel = 1;

      while (newLevel < image.maxLevel && gl.drawingBufferWidth > image.tileResolution * Math.pow(2, newLevel - 1) * Math.tan(hfov / 2) * 0.707) {
        newLevel++;
      } // Apply change


      program.level = newLevel;
    }
    /**
     * Rotates perspective matrix.
     * @private
     * @param {number[]} p - Perspective matrix.
     * @param {number[]} r - Rotation matrix.
     * @returns {number[]} Rotated matrix.
     */


    function rotatePersp(p, r) {
      return [p[0] * r[0], p[0] * r[1], p[0] * r[2], 0, p[5] * r[4], p[5] * r[5], p[5] * r[6], 0, p[10] * r[8], p[10] * r[9], p[10] * r[10], p[11], -r[8], -r[9], -r[10], 0];
    }
    /**
     * Applies rotated perspective matrix to a 3-vector
     * (last element is inverted).
     * @private
     * @param {number[]} m - Rotated perspective matrix.
     * @param {number[]} v - Input 3-vector.
     * @returns {number[]} Resulting 4-vector.
     */


    function applyRotPerspToVec(m, v) {
      return [m[0] * v[0] + m[1] * v[1] + m[2] * v[2], m[4] * v[0] + m[5] * v[1] + m[6] * v[2], m[11] + m[8] * v[0] + m[9] * v[1] + m[10] * v[2], 1 / (m[12] * v[0] + m[13] * v[1] + m[14] * v[2])];
    }
    /**
     * Checks if a vertex is visible.
     * @private
     * @param {number[]} m - Rotated perspective matrix.
     * @param {number[]} v - Input vertex.
     * @returns {number} 1 or -1 if the vertex is or is not visible,
     *      respectively.
     */


    function checkInView(m, v) {
      var vpp = applyRotPerspToVec(m, v);
      var winX = vpp[0] * vpp[3];
      var winY = vpp[1] * vpp[3];
      var winZ = vpp[2] * vpp[3];
      var ret = [0, 0, 0];
      if (winX < -1) ret[0] = -1;
      if (winX > 1) ret[0] = 1;
      if (winY < -1) ret[1] = -1;
      if (winY > 1) ret[1] = 1;
      if (winZ < -1 || winZ > 1) ret[2] = 1;
      return ret;
    }
    /**
     * Checks if a square (tile) is visible.
     * @private
     * @param {number[]} m - Rotated perspective matrix.
     * @param {number[]} v - Square's vertex array.
     * @returns {boolean} Whether or not the square is visible.
     */


    function checkSquareInView(m, v) {
      var check1 = checkInView(m, v.slice(0, 3));
      var check2 = checkInView(m, v.slice(3, 6));
      var check3 = checkInView(m, v.slice(6, 9));
      var check4 = checkInView(m, v.slice(9, 12));
      var testX = check1[0] + check2[0] + check3[0] + check4[0];
      if (testX == -4 || testX == 4) return false;
      var testY = check1[1] + check2[1] + check3[1] + check4[1];
      if (testY == -4 || testY == 4) return false;
      var testZ = check1[2] + check2[2] + check3[2] + check4[2];
      return testZ != 4;
    }
    /**
     * On iOS (iPhone 5c, iOS 10.3), this WebGL error occurs when the canvas is
     * too big. Unfortuately, there's no way to test for this beforehand, so we
     * reduce the canvas size if this error is thrown.
     * @private
     */


    function handleWebGLError1286() {
      console.log("Reducing canvas size due to error 1286!");
      canvas.width = Math.round(canvas.width / 2);
      canvas.height = Math.round(canvas.height / 2);
    }
  } // Vertex shader for equirectangular and cube


  var v = ["attribute vec2 a_texCoord;", "varying vec2 v_texCoord;", "void main() {", // Set position
  "gl_Position = vec4(a_texCoord, 0.0, 1.0);", // Pass the coordinates to the fragment shader
  "v_texCoord = a_texCoord;", "}"].join(""); // Vertex shader for multires

  var vMulti = ["attribute vec3 a_vertCoord;", "attribute vec2 a_texCoord;", "uniform mat4 u_cubeMatrix;", "uniform mat4 u_perspMatrix;", "varying mediump vec2 v_texCoord;", "void main(void) {", // Set position
  "gl_Position = u_perspMatrix * u_cubeMatrix * vec4(a_vertCoord, 1.0);", // Pass the coordinates to the fragment shader
  "v_texCoord = a_texCoord;", "}"].join(""); // Fragment shader

  var fragEquiCubeBase = ["precision highp float;", // mediump looks bad on some mobile devices
  "uniform float u_aspectRatio;", "uniform float u_psi;", "uniform float u_theta;", "uniform float u_f;", "uniform float u_h;", "uniform float u_v;", "uniform float u_vo;", "uniform float u_rot;", "const float PI = 3.14159265358979323846264;", // Texture
  "uniform sampler2D u_image0;", "uniform sampler2D u_image1;", "uniform bool u_splitImage;", "uniform samplerCube u_imageCube;", // Coordinates passed in from vertex shader
  "varying vec2 v_texCoord;", // Background color (display for partial panoramas)
  "uniform vec4 u_backgroundColor;", "void main() {", // Map canvas/camera to sphere
  "float x = v_texCoord.x * u_aspectRatio;", "float y = v_texCoord.y;", "float sinrot = sin(u_rot);", "float cosrot = cos(u_rot);", "float rot_x = x * cosrot - y * sinrot;", "float rot_y = x * sinrot + y * cosrot;", "float sintheta = sin(u_theta);", "float costheta = cos(u_theta);", "float a = u_f * costheta - rot_y * sintheta;", "float root = sqrt(rot_x * rot_x + a * a);", "float lambda = atan(rot_x / root, a / root) + u_psi;", "float phi = atan((rot_y * costheta + u_f * sintheta) / root);"].join("\n"); // Fragment shader

  var fragCube = fragEquiCubeBase + [// Look up color from texture
  "float cosphi = cos(phi);", "gl_FragColor = textureCube(u_imageCube, vec3(cosphi*sin(lambda), sin(phi), cosphi*cos(lambda)));", "}"].join("\n"); // Fragment shader

  var fragEquirectangular = fragEquiCubeBase + [// Wrap image
  "lambda = mod(lambda + PI, PI * 2.0) - PI;", // Map texture to sphere
  "vec2 coord = vec2(lambda / PI, phi / (PI / 2.0));", // Look up color from texture
  // Map from [-1,1] to [0,1] and flip y-axis
  "if(coord.x < -u_h || coord.x > u_h || coord.y < -u_v + u_vo || coord.y > u_v + u_vo)", "gl_FragColor = u_backgroundColor;", "else {", "if(u_splitImage) {", // Image was split into two textures to work around texture size limits
  "if(coord.x < 0.0)", "gl_FragColor = texture2D(u_image0, vec2((coord.x + u_h) / u_h, (-coord.y + u_v + u_vo) / (u_v * 2.0)));", "else", "gl_FragColor = texture2D(u_image1, vec2((coord.x + u_h) / u_h - 1.0, (-coord.y + u_v + u_vo) / (u_v * 2.0)));", "} else {", "gl_FragColor = texture2D(u_image0, vec2((coord.x + u_h) / (u_h * 2.0), (-coord.y + u_v + u_vo) / (u_v * 2.0)));", "}", "}", "}"].join("\n"); // Fragment shader

  var fragMulti = ["varying mediump vec2 v_texCoord;", "uniform sampler2D u_sampler;", //'uniform mediump vec4 u_color;',
  "void main(void) {", // Look up color from texture
  "gl_FragColor = texture2D(u_sampler, v_texCoord);", //    'gl_FragColor = u_color;',
  "}"].join("");
  return {
    renderer: function renderer(container, image, imagetype, dynamic) {
      return new Renderer(container, image, imagetype, dynamic);
    }
  };
}( false ? 0 : window, typeof document === "undefined" ? null : document);

var pannellum = function (window, document, undefined$1) {
  function Viewer(container, initialConfig, onRender) {
    var _this = this; // Declare variables


    var config,
        renderer,
        preview,
        isUserInteracting = false,
        latestInteraction = Date.now(),
        onPointerDownPointerX = 0,
        onPointerDownPointerY = 0,
        onPointerDownPointerDist = -1,
        onPointerDownYaw = 0,
        onPointerDownPitch = 0,
        keysDown = new Array(10),
        fullscreenActive = false,
        loaded,
        error = false,
        listenersAdded = false,
        panoImage,
        prevTime,
        speed = {
      yaw: 0,
      pitch: 0,
      hfov: 0
    },
        animating = false,
        orientation = false,
        orientationYawOffset = 0,
        autoRotateStart,
        autoRotateSpeed = 0,
        origHfov,
        origPitch,
        animatedMove = {},
        externalEventListeners = {},
        specifiedPhotoSphereExcludes = [],
        update = false,
        // Should we update when still to render dynamic content
    eps = 1e-6,
        hotspotsCreated = false,
        destroyed = false;
    var defaultConfig = {
      hfov: 100,
      minHfov: 50,
      multiResMinHfov: false,
      maxHfov: 120,
      pitch: 0,
      minPitch: -90,
      maxPitch: 90,
      yaw: 0,
      minYaw: -180,
      maxYaw: 180,
      roll: 0,
      haov: 360,
      vaov: 180,
      vOffset: 0,
      autoRotate: false,
      autoRotateInactivityDelay: -1,
      autoRotateStopDelay: 0,
      type: "equirectangular",
      northOffset: 0,
      showFullscreenCtrl: true,
      dynamic: false,
      dynamicUpdate: false,
      doubleClickZoom: true,
      keyboardZoom: true,
      mouseZoom: true,
      showZoomCtrl: true,
      autoLoad: false,
      showControls: true,
      orientationOnByDefault: false,
      hotSpotDebug: false,
      backgroundColor: [0, 0, 0],
      avoidShowingBackground: false,
      animationTimingFunction: timingFunction,
      draggable: true,
      disableKeyboardCtrl: false,
      crossOrigin: "anonymous",
      touchPanSpeedCoeffFactor: 1,
      capturedKeyNumbers: [16, 17, 27, 37, 38, 39, 40, 61, 65, 68, 83, 87, 107, 109, 173, 187, 189],
      friction: 0.15
    }; // Translatable / configurable strings
    // Some strings contain '%s', which is a placeholder for inserted values
    // When setting strings in external configuration, `\n` should be used instead of `<br>` to insert line breaks

    defaultConfig.strings = {
      // Labels
      loadButtonLabel: "Click to<br>Load<br>Panorama",
      // Errors
      noPanoramaError: "No panorama image was specified.",
      fileAccessError: "The file %s could not be accessed.",
      // One substitution: file URL
      malformedURLError: "There is something wrong with the panorama URL.",
      iOS8WebGLError: "Due to iOS 8's broken WebGL implementation, only " + "progressive encoded JPEGs work for your device (this " + "panorama uses standard encoding).",
      genericWebGLError: "Your browser does not have the necessary WebGL support to display this panorama.",
      textureSizeError: "This panorama is too big for your device! It's " + "%spx wide, but your device only supports images up to " + "%spx wide. Try another device." + " (If you're the author, try scaling down the image.)",
      // Two substitutions: image width, max image width
      unknownError: "Unknown error. Check developer console."
    };
    var mainContainer = document.getElementById("image-wrapper");
    container = typeof container === "string" ? document.getElementById(container) : container;
    container.classList.add("pnlm-container");
    container.tabIndex = 0; // Create container for ui

    var uiContainer = document.createElement("div");
    uiContainer.className = "pnlm-ui";
    container.appendChild(uiContainer); // Create container for renderer

    var renderContainer = document.createElement("div");
    renderContainer.className = "pnlm-render-container";
    container.appendChild(renderContainer);
    var dragFix = document.createElement("div");
    dragFix.className = "pnlm-dragfix";
    uiContainer.appendChild(dragFix); // Display about information on right click

    var aboutMsg = document.createElement("span");
    aboutMsg.className = "pnlm-about-msg";
    aboutMsg.innerHTML = '<a href="https://pannellum.org/" target="_blank">Pannellum</a>'; //uiContainer.appendChild(aboutMsg);

    dragFix.addEventListener("contextmenu", aboutMessage); // Create info display

    var infoDisplay = {}; // Hot spot debug indicator

    var hotSpotDebugIndicator = document.createElement("div");
    hotSpotDebugIndicator.className = "pnlm-sprite pnlm-hot-spot-debug-indicator";
    uiContainer.appendChild(hotSpotDebugIndicator); // Panorama info

    infoDisplay.container = document.createElement("div");
    infoDisplay.container.className = "pnlm-panorama-info";
    infoDisplay.title = document.createElement("div");
    infoDisplay.title.className = "pnlm-title-box";
    infoDisplay.container.appendChild(infoDisplay.title);
    infoDisplay.author = document.createElement("div");
    infoDisplay.author.className = "pnlm-author-box";
    infoDisplay.container.appendChild(infoDisplay.author);
    uiContainer.appendChild(infoDisplay.container); // Load box

    infoDisplay.load = {};
    infoDisplay.load.box = document.createElement("div");
    infoDisplay.load.boxp = document.createElement("p");
    infoDisplay.load.lbox = document.createElement("div");
    infoDisplay.load.lbox.className = "";
    infoDisplay.load.lbox.innerHTML = '<div></div>';
    infoDisplay.load.box.appendChild(infoDisplay.load.lbox);
    infoDisplay.load.lbar = document.createElement("div");
    infoDisplay.load.lbar.className = "";
    infoDisplay.load.lbarFill = document.createElement("div");
    infoDisplay.load.lbarFill.className = "";
    infoDisplay.load.lbar.appendChild(infoDisplay.load.lbarFill);
    infoDisplay.load.box.appendChild(infoDisplay.load.lbar);
    infoDisplay.load.msg = document.createElement("p");
    infoDisplay.load.msg.className = "";
    infoDisplay.load.box.appendChild(infoDisplay.load.msg);
    uiContainer.appendChild(infoDisplay.load.box); // Error message

    infoDisplay.errorMsg = document.createElement("div");
    infoDisplay.errorMsg.className = "pnlm-error-msg pnlm-info-box";
    uiContainer.appendChild(infoDisplay.errorMsg); // Create controls

    var controls = {};
    controls.container = document.createElement("div");
    controls.container.className = "pnlm-controls-container";
    uiContainer.appendChild(controls.container); // Load button

    controls.load = document.createElement("div");
    controls.load.className = "pnlm-load-button";
    controls.load.addEventListener("click", function () {
      processOptions();
      load();
    });
    uiContainer.appendChild(controls.load); // Zoom controls

    controls.zoom = document.createElement("div");
    controls.zoom.className = "pnlm-zoom-controls pnlm-controls";
    controls.zoomIn = document.createElement("div");
    controls.zoomIn.className = "pnlm-zoom-in pnlm-sprite pnlm-control";
    controls.zoomIn.addEventListener("click", zoomIn);
    controls.zoom.appendChild(controls.zoomIn);
    controls.zoomOut = document.createElement("div");
    controls.zoomOut.className = "pnlm-zoom-out pnlm-sprite pnlm-control";
    controls.zoomOut.addEventListener("click", zoomOut);
    controls.zoom.appendChild(controls.zoomOut);
    controls.container.appendChild(controls.zoom); // Fullscreen toggle

    controls.fullscreen = document.createElement("div");
    controls.fullscreen.addEventListener("click", toggleFullscreen);
    controls.fullscreen.className = "pnlm-fullscreen-toggle-button pnlm-sprite pnlm-fullscreen-toggle-button-inactive pnlm-controls pnlm-control";
    if (document.fullscreenEnabled || document.mozFullScreenEnabled || document.webkitFullscreenEnabled || document.msFullscreenEnabled) controls.container.appendChild(controls.fullscreen); // Device orientation toggle

    controls.orientation = document.createElement("div");
    controls.orientation.addEventListener("click", function (e) {
      if (orientation) stopOrientation();else startOrientation();
    });
    controls.orientation.addEventListener("mousedown", function (e) {
      e.stopPropagation();
    });
    controls.orientation.addEventListener("touchstart", function (e) {
      e.stopPropagation();
    });
    controls.orientation.addEventListener("pointerdown", function (e) {
      e.stopPropagation();
    });
    controls.orientation.className = "pnlm-orientation-button pnlm-orientation-button-inactive pnlm-sprite pnlm-controls pnlm-control";
    var orientationSupport = false;

    if (window.DeviceOrientationEvent && location.protocol == "https:" && navigator.userAgent.toLowerCase().indexOf("mobi") >= 0) {
      // This user agent check is here because there's no way to check if a
      // device has an inertia measurement unit. We used to be able to check if a
      // DeviceOrientationEvent had non-null values, but with iOS 13 requiring a
      // permission prompt to access such events, this is no longer possible.
      controls.container.appendChild(controls.orientation);
      orientationSupport = true;
    } // Compass


    var compass = document.createElement("div");
    compass.className = "pnlm-compass pnlm-controls pnlm-control";
    uiContainer.appendChild(compass); // Load and process configuration

    if (initialConfig.firstScene) {
      // Activate first scene if specified in URL
      mergeConfig(initialConfig.firstScene);
    } else if (initialConfig["default"] && initialConfig["default"].firstScene) {
      // Activate first scene if specified in file
      mergeConfig(initialConfig["default"].firstScene);
    } else {
      mergeConfig(null);
    }

    processOptions(true);
    /**
     * Initializes viewer.
     * @private
     */

    function init() {
      // Display an error for IE 9 as it doesn't work but also doesn't otherwise
      // show an error (older versions don't work at all)
      // Based on: http://stackoverflow.com/a/10965203
      var div = document.createElement("div");
      div.innerHTML = "<!--[if lte IE 9]><i></i><![endif]-->";

      if (div.getElementsByTagName("i").length == 1) {
        anError();
        return;
      }

      origHfov = config.hfov;
      origPitch = config.pitch;
      var i, p;

      if (config.type == "cubemap") {
        panoImage = [];

        for (i = 0; i < 6; i++) {
          panoImage.push(new Image());
          panoImage[i].crossOrigin = config.crossOrigin;
        }

        infoDisplay.load.lbox.style.display = "block";
        infoDisplay.load.lbar.style.display = "none";
      } else if (config.type == "multires") {
        var c = JSON.parse(JSON.stringify(config.multiRes)); // Deep copy
        // Avoid "undefined" in path, check (optional) multiRes.basePath, too
        // Use only multiRes.basePath if it's an absolute URL

        if (config.basePath && config.multiRes.basePath && !/^(?:[a-z]+:)?\/\//i.test(config.multiRes.basePath)) {
          c.basePath = config.basePath + config.multiRes.basePath;
        } else if (config.multiRes.basePath) {
          c.basePath = config.multiRes.basePath;
        } else if (config.basePath) {
          c.basePath = config.basePath;
        }

        panoImage = c;
      } else {
        if (config.dynamic === true) {
          panoImage = config.imageSource;
        } else {
          if (config.imageSource === undefined$1) {
            anError(config.uiText.noPanoramaError);
            return;
          }

          panoImage = new Image();
        }
      } // Configure image loading


      if (config.type == "cubemap") {
        // Quick loading counter for synchronous loading
        var itemsToLoad = 6;

        var onLoad = function onLoad() {
          itemsToLoad--;

          if (itemsToLoad === 0) {
            onImageLoad();
          }
        };

        var onError = function onError(e) {
          var a = document.createElement("a");
          a.href = e.target.src;
          a.innerHTML = a.href;
          anError(config.uiText.fileAccessError.replace("%s", a.outerHTML));
        };

        for (i = 0; i < panoImage.length; i++) {
          panoImage[i].onload = onLoad;
          panoImage[i].onerror = onError;
          p = config.cubeMap[i];

          if (p == "null") {
            // support partial cubemap image with explicitly empty faces
            console.log("Will use background instead of missing cubemap face " + i);
            onLoad();
          } else {
            if (config.basePath && !absoluteURL(p)) {
              p = config.basePath + p;
            }

            panoImage[i].onload = onLoad;
            panoImage[i].onerror = onError;
            panoImage[i].src = sanitizeURL(p); //panoImage[i].src = encodeURI(p);
          }
        }
      } else if (config.type == "multires") {
        onImageLoad();
      } else {
        p = "";

        if (config.basePath) {
          p = config.basePath;
        }

        if (config.dynamic !== true) {
          // Still image
          p = absoluteURL(config.imageSource) ? config.imageSource : p + config.imageSource;

          panoImage.onload = function () {
            window.URL.revokeObjectURL(this.src); // Clean up

            onImageLoad();
          };

          var xhr = new XMLHttpRequest();

          xhr.onloadend = function () {
            if (xhr.status != 200) {
              // Display error if image can't be loaded
              var a = document.createElement("a");
              a.href = p;
              a.textContent = a.href;
              anError(config.strings.fileAccessError.replace("%s", a.outerHTML));
            }

            var img = this.response;
            parseGPanoXMP(img);
            infoDisplay.load.msg.innerHTML = "";
          };

          xhr.onprogress = function (e) {
            if (e.lengthComputable) {
              // Display progress
              var percent = e.loaded / e.total * 100;
              infoDisplay.load.lbarFill.style.width = percent + "%";
              var unit, numerator, denominator;

              if (e.total > 1e6) {
                unit = "MB";
                numerator = (e.loaded / 1e6).toFixed(2);
                denominator = (e.total / 1e6).toFixed(2);
              } else if (e.total > 1e3) {
                unit = "kB";
                numerator = (e.loaded / 1e3).toFixed(1);
                denominator = (e.total / 1e3).toFixed(1);
              } else {
                unit = "B";
                numerator = e.loaded;
                denominator = e.total;
              }

              infoDisplay.load.msg.innerHTML = "";
            } else {
              // Display loading spinner
              infoDisplay.load.lbox.style.display = "block";
              infoDisplay.load.lbar.style.display = "none";
            }
          };

          try {
            xhr.open("GET", p, true);
          } catch (e) {
            // Malformed URL
            anError(config.strings.malformedURLError);
          }

          xhr.responseType = "blob";
          xhr.setRequestHeader("Accept", "image/*,*/*;q=0.9");
          xhr.withCredentials = config.crossOrigin === "use-credentials";
          xhr.send();
        }
      }

      if (config.draggable) uiContainer.classList.add("pnlm-grab");
      uiContainer.classList.remove("pnlm-grabbing"); // Properly handle switching to dynamic scenes

      update = config.dynamicUpdate === true;

      if (config.dynamic && update) {
        panoImage = config.panorama;
        onImageLoad();
      }
    }
    /**
     * Test if URL is absolute or relative.
     * @private
     * @param {string} url - URL to test
     * @returns {boolean} True if absolute, else false
     */


    function absoluteURL(url) {
      // From http://stackoverflow.com/a/19709846
      return new RegExp("^(?:[a-z]+:)?//", "i").test(url) || url[0] == "/" || url.slice(0, 5) == "blob:";
    }
    /**
     * Create renderer and initialize event listeners once image is loaded.
     * @private
     */


    function onImageLoad() {
      if (!renderer) renderer = new libpannellum.renderer(renderContainer); // Only add event listeners once

      if (!listenersAdded) {
        listenersAdded = true;
        dragFix.addEventListener("mousedown", onDocumentMouseDown, false);
        document.addEventListener("mousemove", onDocumentMouseMove, false);
        document.addEventListener("mouseup", onDocumentMouseUp, false);

        if (config.mouseZoom) {
          uiContainer.addEventListener("mousewheel", onDocumentMouseWheel, false);
          uiContainer.addEventListener("DOMMouseScroll", onDocumentMouseWheel, false);
        }

        if (config.doubleClickZoom) {
          dragFix.addEventListener("dblclick", onDocumentDoubleClick, false);
        }

        mainContainer.addEventListener("mozfullscreenchange", onFullScreenChange, false);
        mainContainer.addEventListener("webkitfullscreenchange", onFullScreenChange, false);
        mainContainer.addEventListener("msfullscreenchange", onFullScreenChange, false);
        mainContainer.addEventListener("fullscreenchange", onFullScreenChange, false);
        window.addEventListener("resize", onDocumentResize, false);
        window.addEventListener("orientationchange", onDocumentResize, false);

        if (!config.disableKeyboardCtrl) {
          container.addEventListener("keydown", onDocumentKeyPress, false);
          container.addEventListener("keyup", onDocumentKeyUp, false);
          container.addEventListener("blur", clearKeys, false);
        }

        document.addEventListener("mouseleave", onDocumentMouseUp, false);

        if (document.documentElement.style.pointerAction === "" && document.documentElement.style.touchAction === "") {
          dragFix.addEventListener("pointerdown", onDocumentPointerDown, false);
          dragFix.addEventListener("pointermove", onDocumentPointerMove, false);
          dragFix.addEventListener("pointerup", onDocumentPointerUp, false);
          dragFix.addEventListener("pointerleave", onDocumentPointerUp, false);
        } else {
          dragFix.addEventListener("touchstart", onDocumentTouchStart, false);
          dragFix.addEventListener("touchmove", onDocumentTouchMove, false);
          dragFix.addEventListener("touchend", onDocumentTouchEnd, false);
        } // Deal with MS pointer events


        if (window.navigator.pointerEnabled) container.style.touchAction = "none";
      }

      renderInit();
      setHfov(config.hfov); // possibly adapt hfov after configuration and canvas is complete; prevents empty space on top or bottom by zomming out too much

      setTimeout(function () {}, 500);
    }
    /**
     * Parses Google Photo Sphere XMP Metadata.
     * https://developers.google.com/photo-sphere/metadata/
     * @private
     * @param {Image} image - Image to read XMP metadata from.
     */


    function parseGPanoXMP(image) {
      var reader = new FileReader();
      reader.addEventListener("loadend", function () {
        var img = reader.result; // This awful browser specific test exists because iOS 8 does not work
        // with non-progressive encoded JPEGs.

        if (navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad).* os 8_/)) {
          var flagIndex = img.indexOf("\xff\xc2");
          if (flagIndex < 0 || flagIndex > 65536) anError(config.strings.iOS8WebGLError);
        }

        var start = img.indexOf("<x:xmpmeta");

        if (start > -1 && config.ignoreGPanoXMP !== true) {
          var xmpData = img.substring(start, img.indexOf("</x:xmpmeta>") + 12); // Extract the requested tag from the XMP data

          var getTag = function getTag(tag) {
            var result;

            if (xmpData.indexOf(tag + '="') >= 0) {
              result = xmpData.substring(xmpData.indexOf(tag + '="') + tag.length + 2);
              result = result.substring(0, result.indexOf('"'));
            } else if (xmpData.indexOf(tag + ">") >= 0) {
              result = xmpData.substring(xmpData.indexOf(tag + ">") + tag.length + 1);
              result = result.substring(0, result.indexOf("<"));
            }

            if (result !== undefined$1) {
              return Number(result);
            }

            return null;
          }; // Relevant XMP data


          var xmp = {
            fullWidth: getTag("GPano:FullPanoWidthPixels"),
            croppedWidth: getTag("GPano:CroppedAreaImageWidthPixels"),
            fullHeight: getTag("GPano:FullPanoHeightPixels"),
            croppedHeight: getTag("GPano:CroppedAreaImageHeightPixels"),
            topPixels: getTag("GPano:CroppedAreaTopPixels"),
            heading: getTag("GPano:PoseHeadingDegrees"),
            horizonPitch: getTag("GPano:PosePitchDegrees"),
            horizonRoll: getTag("GPano:PoseRollDegrees")
          };

          if (xmp.fullWidth !== null && xmp.croppedWidth !== null && xmp.fullHeight !== null && xmp.croppedHeight !== null && xmp.topPixels !== null) {
            // Set up viewer using GPano XMP data
            if (specifiedPhotoSphereExcludes.indexOf("haov") < 0) config.haov = xmp.croppedWidth / xmp.fullWidth * 360;
            if (specifiedPhotoSphereExcludes.indexOf("vaov") < 0) config.vaov = xmp.croppedHeight / xmp.fullHeight * 180;
            if (specifiedPhotoSphereExcludes.indexOf("vOffset") < 0) config.vOffset = ((xmp.topPixels + xmp.croppedHeight / 2) / xmp.fullHeight - 0.5) * -180;

            if (xmp.heading !== null && specifiedPhotoSphereExcludes.indexOf("northOffset") < 0) {
              // TODO: make sure this works correctly for partial panoramas
              config.northOffset = xmp.heading;

              if (config.compass !== false) {
                config.compass = true;
              }
            }

            if (xmp.horizonPitch !== null && xmp.horizonRoll !== null) {
              if (specifiedPhotoSphereExcludes.indexOf("horizonPitch") < 0) config.horizonPitch = xmp.horizonPitch;
              if (specifiedPhotoSphereExcludes.indexOf("horizonRoll") < 0) config.horizonRoll = xmp.horizonRoll;
            } // TODO: add support for initial view settings

          }
        } // Load panorama


        panoImage.src = window.URL.createObjectURL(image);
      });
      if (reader.readAsBinaryString !== undefined$1) reader.readAsBinaryString(image);else reader.readAsText(image);
    }
    /**
     * Displays an error message.
     * @private
     * @param {string} errorMsg - Error message to display. If not specified, a
     *      generic WebGL error is displayed.
     */


    function anError(errorMsg) {
      if (errorMsg === undefined$1) errorMsg = config.strings.genericWebGLError;
      infoDisplay.errorMsg.innerHTML = "<p>" + errorMsg + "</p>";
      controls.load.style.display = "none";
      infoDisplay.load.box.style.display = "none";
      infoDisplay.errorMsg.style.display = "table";
      error = true;
      loaded = undefined$1;
      renderContainer.style.display = "none";
      fireEvent("error", errorMsg);
    }
    /**
     * Hides error message display.
     * @private
     */


    function clearError() {
      if (error) {
        infoDisplay.load.box.style.display = "none";
        infoDisplay.errorMsg.style.display = "none";
        error = false;
        renderContainer.style.display = "block";
        fireEvent("errorcleared");
      }
    }
    /**
     * Displays about message.
     * @private
     * @param {MouseEvent} event - Right click location
     */


    function aboutMessage(event) {
      var pos = mousePosition(event);
      aboutMsg.style.left = pos.x + "px";
      aboutMsg.style.top = pos.y + "px";
      clearTimeout(aboutMessage.t1);
      clearTimeout(aboutMessage.t2);
      aboutMsg.style.display = "block";
      aboutMsg.style.opacity = 1;
      aboutMessage.t1 = setTimeout(function () {
        aboutMsg.style.opacity = 0;
      }, 2000);
      aboutMessage.t2 = setTimeout(function () {
        aboutMsg.style.display = "none";
      }, 2500);
      event.preventDefault();
    }
    /**
     * Calculate mouse position relative to top left of viewer container.
     * @private
     * @param {MouseEvent} event - Mouse event to use in calculation
     * @returns {Object} Calculated X and Y coordinates
     */


    function mousePosition(event) {
      var bounds = container.getBoundingClientRect();
      var pos = {}; // pageX / pageY needed for iOS

      pos.x = (event.clientX || event.pageX) - bounds.left;
      pos.y = (event.clientY || event.pageY) - bounds.top;
      return pos;
    }
    /**
     * Event handler for mouse clicks. Initializes panning. Prints center and click
     * location coordinates when hot spot debugging is enabled.
     * @private
     * @param {MouseEvent} event - Document mouse down event.
     */


    function onDocumentMouseDown(event) {
      // Override default action
      event.preventDefault(); // But not all of it

      container.focus(); // Only do something if the panorama is loaded

      if (!loaded || !config.draggable) {
        return;
      } // Calculate mouse position relative to top left of viewer container


      var pos = mousePosition(event); // Log pitch / yaw of mouse click when debugging / placing hot spots

      if (config.hotSpotDebug) {
        var coords = mouseEventToCoords(event);
        console.log("Pitch: " + coords[0] + ", Yaw: " + coords[1] + ", Center Pitch: " + config.pitch + ", Center Yaw: " + config.yaw + ", HFOV: " + config.hfov);
      } // Turn off auto-rotation if enabled


      stopAnimation();
      stopOrientation();
      config.roll = 0;
      speed.hfov = 0;
      isUserInteracting = true;
      latestInteraction = Date.now();
      onPointerDownPointerX = pos.x;
      onPointerDownPointerY = pos.y;
      onPointerDownYaw = config.yaw;
      onPointerDownPitch = config.pitch;
      uiContainer.classList.add("pnlm-grabbing");
      uiContainer.classList.remove("pnlm-grab");
      fireEvent("mousedown", event);
      animateInit();
    }
    /**
     * Event handler for double clicks. Zooms in at clicked location
     * @private
     * @param {MouseEvent} event - Document mouse down event.
     */


    function onDocumentDoubleClick(event) {
      if (config.minHfov === config.hfov) {
        _this.setHfov(origHfov, 1000);
      } else {
        var coords = mouseEventToCoords(event);

        _this.lookAt(coords[0], coords[1], config.minHfov, 1000);
      }
    }
    /**
     * Calculate panorama pitch and yaw from location of mouse event.
     * @private
     * @param {MouseEvent} event - Document mouse down event.
     * @returns {number[]} [pitch, yaw]
     */


    function mouseEventToCoords(event) {
      var pos = mousePosition(event);
      var canvas = renderer.getCanvas();
      var canvasWidth = canvas.clientWidth,
          canvasHeight = canvas.clientHeight;
      var x = pos.x / canvasWidth * 2 - 1;
      var y = (1 - pos.y / canvasHeight * 2) * canvasHeight / canvasWidth;
      var focal = 1 / Math.tan(config.hfov * Math.PI / 360);
      var s = Math.sin(config.pitch * Math.PI / 180);
      var c = Math.cos(config.pitch * Math.PI / 180);
      var a = focal * c - y * s;
      var root = Math.sqrt(x * x + a * a);
      var pitch = Math.atan((y * c + focal * s) / root) * 180 / Math.PI;
      var yaw = Math.atan2(x / root, a / root) * 180 / Math.PI + config.yaw;
      if (yaw < -180) yaw += 360;
      if (yaw > 180) yaw -= 360;
      return [pitch, yaw];
    }
    /**
     * Event handler for mouse moves. Pans center of view.
     * @private
     * @param {MouseEvent} event - Document mouse move event.
     */


    function onDocumentMouseMove(event) {
      if (isUserInteracting && loaded) {
        latestInteraction = Date.now();
        var canvas = renderer.getCanvas();
        var canvasWidth = canvas.clientWidth,
            canvasHeight = canvas.clientHeight;
        var pos = mousePosition(event); //TODO: This still isn't quite right

        var yaw = (Math.atan(onPointerDownPointerX / canvasWidth * 2 - 1) - Math.atan(pos.x / canvasWidth * 2 - 1)) * 180 / Math.PI * config.hfov / 90 + onPointerDownYaw;
        speed.yaw = (yaw - config.yaw) % 360 * 0.2;
        config.yaw = yaw;
        var vfov = 2 * Math.atan(Math.tan(config.hfov / 360 * Math.PI) * canvasHeight / canvasWidth) * 180 / Math.PI;
        var pitch = (Math.atan(pos.y / canvasHeight * 2 - 1) - Math.atan(onPointerDownPointerY / canvasHeight * 2 - 1)) * 180 / Math.PI * vfov / 90 + onPointerDownPitch;
        speed.pitch = (pitch - config.pitch) * 0.2;
        config.pitch = pitch;
      }
    }
    /**
     * Event handler for mouse up events. Stops panning.
     * @private
     */


    function onDocumentMouseUp(event) {
      if (!isUserInteracting) {
        return;
      }

      isUserInteracting = false;

      if (Date.now() - latestInteraction > 15) {
        // Prevents jump when user rapidly moves mouse, stops, and then
        // releases the mouse button
        speed.pitch = speed.yaw = 0;
      }

      uiContainer.classList.add("pnlm-grab");
      uiContainer.classList.remove("pnlm-grabbing");
      latestInteraction = Date.now();
      fireEvent("mouseup", event);
    }
    /**
     * Event handler for touches. Initializes panning if one touch or zooming if
     * two touches.
     * @private
     * @param {TouchEvent} event - Document touch start event.
     */


    function onDocumentTouchStart(event) {
      // Only do something if the panorama is loaded
      if (!loaded || !config.draggable) {
        return;
      } // Turn off auto-rotation if enabled


      stopAnimation();
      stopOrientation();
      config.roll = 0;
      speed.hfov = 0; // Calculate touch position relative to top left of viewer container

      var pos0 = mousePosition(event.targetTouches[0]);
      onPointerDownPointerX = pos0.x;
      onPointerDownPointerY = pos0.y;

      if (event.targetTouches.length == 2) {
        // Down pointer is the center of the two fingers
        var pos1 = mousePosition(event.targetTouches[1]);
        onPointerDownPointerX += (pos1.x - pos0.x) * 0.5;
        onPointerDownPointerY += (pos1.y - pos0.y) * 0.5;
        onPointerDownPointerDist = Math.sqrt((pos0.x - pos1.x) * (pos0.x - pos1.x) + (pos0.y - pos1.y) * (pos0.y - pos1.y));
      }

      isUserInteracting = true;
      latestInteraction = Date.now();
      onPointerDownYaw = config.yaw;
      onPointerDownPitch = config.pitch;
      fireEvent("touchstart", event);
      animateInit();
    }
    /**
     * Event handler for touch movements. Pans center of view if one touch or
     * adjusts zoom if two touches.
     * @private
     * @param {TouchEvent} event - Document touch move event.
     */


    function onDocumentTouchMove(event) {
      if (!config.draggable) {
        return;
      } // Override default action


      event.preventDefault();

      if (loaded) {
        latestInteraction = Date.now();
      }

      if (isUserInteracting && loaded) {
        var pos0 = mousePosition(event.targetTouches[0]);
        var clientX = pos0.x;
        var clientY = pos0.y;

        if (event.targetTouches.length == 2 && onPointerDownPointerDist != -1) {
          var pos1 = mousePosition(event.targetTouches[1]);
          clientX += (pos1.x - pos0.x) * 0.5;
          clientY += (pos1.y - pos0.y) * 0.5;
          var clientDist = Math.sqrt((pos0.x - pos1.x) * (pos0.x - pos1.x) + (pos0.y - pos1.y) * (pos0.y - pos1.y));
          setHfov(config.hfov + (onPointerDownPointerDist - clientDist) * 0.1);
          onPointerDownPointerDist = clientDist;
        } // The smaller the config.hfov value (the more zoomed-in the user is), the faster
        // yaw/pitch are perceived to change on one-finger touchmove (panning) events and vice versa.
        // To improve usability at both small and large zoom levels (config.hfov values)
        // we introduce a dynamic pan speed coefficient.
        //
        // Currently this seems to *roughly* keep initial drag/pan start position close to
        // the user's finger while panning regardless of zoom level / config.hfov value.


        var touchmovePanSpeedCoeff = config.hfov / 360 * config.touchPanSpeedCoeffFactor;
        var yaw = (onPointerDownPointerX - clientX) * touchmovePanSpeedCoeff + onPointerDownYaw;
        speed.yaw = (yaw - config.yaw) % 360 * 0.2;
        config.yaw = yaw;
        var pitch = (clientY - onPointerDownPointerY) * touchmovePanSpeedCoeff + onPointerDownPitch;
        speed.pitch = (pitch - config.pitch) * 0.2;
        config.pitch = pitch;
      }
    }
    /**
     * Event handler for end of touches. Stops panning and/or zooming.
     * @private
     */


    function onDocumentTouchEnd() {
      isUserInteracting = false;

      if (Date.now() - latestInteraction > 150) {
        speed.pitch = speed.yaw = 0;
      }

      onPointerDownPointerDist = -1;
      latestInteraction = Date.now();
      fireEvent("touchend", event);
    }

    var pointerIDs = [],
        pointerCoordinates = [];
    /**
     * Event handler for touch starts in IE / Edge.
     * @private
     * @param {PointerEvent} event - Document pointer down event.
     */

    function onDocumentPointerDown(event) {
      if (event.pointerType == "touch") {
        // Only do something if the panorama is loaded
        if (!loaded || !config.draggable) return;
        pointerIDs.push(event.pointerId);
        pointerCoordinates.push({
          clientX: event.clientX,
          clientY: event.clientY
        });
        event.targetTouches = pointerCoordinates;
        onDocumentTouchStart(event);
        event.preventDefault();
      }
    }
    /**
     * Event handler for touch moves in IE / Edge.
     * @private
     * @param {PointerEvent} event - Document pointer move event.
     */


    function onDocumentPointerMove(event) {
      if (event.pointerType == "touch") {
        if (!config.draggable) return;

        for (var i = 0; i < pointerIDs.length; i++) {
          if (event.pointerId == pointerIDs[i]) {
            pointerCoordinates[i].clientX = event.clientX;
            pointerCoordinates[i].clientY = event.clientY;
            event.targetTouches = pointerCoordinates;
            onDocumentTouchMove(event);
            event.preventDefault();
            return;
          }
        }
      }
    }
    /**
     * Event handler for touch ends in IE / Edge.
     * @private
     * @param {PointerEvent} event - Document pointer up event.
     */


    function onDocumentPointerUp(event) {
      if (event.pointerType == "touch") {
        var defined = false;

        for (var i = 0; i < pointerIDs.length; i++) {
          if (event.pointerId == pointerIDs[i]) pointerIDs[i] = undefined$1;
          if (pointerIDs[i]) defined = true;
        }

        if (!defined) {
          pointerIDs = [];
          pointerCoordinates = [];
          onDocumentTouchEnd();
        }

        event.preventDefault();
      }
    }
    /**
     * Event handler for mouse wheel. Changes zoom.
     * @private
     * @param {WheelEvent} event - Document mouse wheel event.
     */


    function onDocumentMouseWheel(event) {
      // Only do something if the panorama is loaded and mouse wheel zoom is enabled
      if (!loaded || config.mouseZoom == "fullscreenonly" && !fullscreenActive) {
        return;
      }

      event.preventDefault(); // Turn off auto-rotation if enabled

      stopAnimation();
      latestInteraction = Date.now();

      if (event.wheelDeltaY) {
        // WebKit
        setHfov(config.hfov - event.wheelDeltaY * 0.05);
        speed.hfov = event.wheelDelta < 0 ? 1 : -1;
      } else if (event.wheelDelta) {
        // Opera / Explorer 9
        setHfov(config.hfov - event.wheelDelta * 0.05);
        speed.hfov = event.wheelDelta < 0 ? 1 : -1;
      } else if (event.detail) {
        // Firefox
        setHfov(config.hfov + event.detail * 1.5);
        speed.hfov = event.detail > 0 ? 1 : -1;
      }

      animateInit();
    }
    /**
     * Event handler for key presses. Updates list of currently pressed keys.
     * @private
     * @param {KeyboardEvent} event - Document key press event.
     */


    function onDocumentKeyPress(event) {
      // Turn off auto-rotation if enabled
      stopAnimation();
      latestInteraction = Date.now();
      stopOrientation();
      config.roll = 0; // Record key pressed

      var keynumber = event.which || event.keycode; // Override default action for keys that are used

      if (config.capturedKeyNumbers.indexOf(keynumber) < 0) return;
      event.preventDefault(); // If escape key is pressed

      if (keynumber == 27) {
        // If in fullscreen mode
        if (fullscreenActive) {
          toggleFullscreen();
        }
      } else {
        // Change key
        changeKey(keynumber, true);
      }
    }
    /**
     * Clears list of currently pressed keys.
     * @private
     */


    function clearKeys() {
      for (var i = 0; i < 10; i++) {
        keysDown[i] = false;
      }
    }
    /**
     * Event handler for key releases. Updates list of currently pressed keys.
     * @private
     * @param {KeyboardEvent} event - Document key up event.
     */


    function onDocumentKeyUp(event) {
      // Record key pressed
      var keynumber = event.which || event.keycode; // Override default action for keys that are used

      if (config.capturedKeyNumbers.indexOf(keynumber) < 0) return;
      event.preventDefault(); // Change key

      changeKey(keynumber, false);
    }
    /**
     * Updates list of currently pressed keys.
     * @private
     * @param {number} keynumber - Key number.
     * @param {boolean} value - Whether or not key is pressed.
     */


    function changeKey(keynumber, value) {
      var keyChanged = false;

      switch (keynumber) {
        // If minus key is released
        case 109:
        case 189:
        case 17:
        case 173:
          if (keysDown[0] != value) {
            keyChanged = true;
          }

          keysDown[0] = value;
          break;
        // If plus key is released

        case 107:
        case 187:
        case 16:
        case 61:
          if (keysDown[1] != value) {
            keyChanged = true;
          }

          keysDown[1] = value;
          break;
        // If up arrow is released

        case 38:
          if (keysDown[2] != value) {
            keyChanged = true;
          }

          keysDown[2] = value;
          break;
        // If "w" is released

        case 87:
          if (keysDown[6] != value) {
            keyChanged = true;
          }

          keysDown[6] = value;
          break;
        // If down arrow is released

        case 40:
          if (keysDown[3] != value) {
            keyChanged = true;
          }

          keysDown[3] = value;
          break;
        // If "s" is released

        case 83:
          if (keysDown[7] != value) {
            keyChanged = true;
          }

          keysDown[7] = value;
          break;
        // If left arrow is released

        case 37:
          if (keysDown[4] != value) {
            keyChanged = true;
          }

          keysDown[4] = value;
          break;
        // If "a" is released

        case 65:
          if (keysDown[8] != value) {
            keyChanged = true;
          }

          keysDown[8] = value;
          break;
        // If right arrow is released

        case 39:
          if (keysDown[5] != value) {
            keyChanged = true;
          }

          keysDown[5] = value;
          break;
        // If "d" is released

        case 68:
          if (keysDown[9] != value) {
            keyChanged = true;
          }

          keysDown[9] = value;
      }

      if (keyChanged && value) {
        if (typeof performance !== "undefined" && performance.now()) {
          prevTime = performance.now();
        } else {
          prevTime = Date.now();
        }

        animateInit();
      }
    }
    /**
     * Pans and/or zooms panorama based on currently pressed keys. Also handles
     * panorama "inertia" and auto rotation.
     * @private
     */


    function keyRepeat() {
      // Only do something if the panorama is loaded
      if (!loaded) {
        return;
      }

      var isKeyDown = false;
      var prevPitch = config.pitch;
      var prevYaw = config.yaw;
      var prevZoom = config.hfov;
      var newTime;

      if (typeof performance !== "undefined" && performance.now()) {
        newTime = performance.now();
      } else {
        newTime = Date.now();
      }

      if (prevTime === undefined$1) {
        prevTime = newTime;
      }

      var diff = (newTime - prevTime) * config.hfov / 1700;
      diff = Math.min(diff, 1.0); // If minus key is down

      if (keysDown[0] && config.keyboardZoom === true) {
        setHfov(config.hfov + (speed.hfov * 0.8 + 0.5) * diff);
        isKeyDown = true;
      } // If plus key is down


      if (keysDown[1] && config.keyboardZoom === true) {
        setHfov(config.hfov + (speed.hfov * 0.8 - 0.2) * diff);
        isKeyDown = true;
      } // If up arrow or "w" is down


      if (keysDown[2] || keysDown[6]) {
        // Pan up
        config.pitch += (speed.pitch * 0.8 + 0.2) * diff;
        isKeyDown = true;
      } // If down arrow or "s" is down


      if (keysDown[3] || keysDown[7]) {
        // Pan down
        config.pitch += (speed.pitch * 0.8 - 0.2) * diff;
        isKeyDown = true;
      } // If left arrow or "a" is down


      if (keysDown[4] || keysDown[8]) {
        // Pan left
        config.yaw += (speed.yaw * 0.8 - 0.2) * diff;
        isKeyDown = true;
      } // If right arrow or "d" is down


      if (keysDown[5] || keysDown[9]) {
        // Pan right
        config.yaw += (speed.yaw * 0.8 + 0.2) * diff;
        isKeyDown = true;
      }

      if (isKeyDown) latestInteraction = Date.now(); // If auto-rotate

      if (config.autoRotate) {
        // Pan
        if (newTime - prevTime > 0.001) {
          var timeDiff = (newTime - prevTime) / 1000;
          var yawDiff = (speed.yaw / timeDiff * diff - config.autoRotate * 0.2) * timeDiff;
          yawDiff = (-config.autoRotate > 0 ? 1 : -1) * Math.min(Math.abs(config.autoRotate * timeDiff), Math.abs(yawDiff));
          config.yaw += yawDiff;
        } // Deal with stopping auto rotation after a set delay


        if (config.autoRotateStopDelay) {
          config.autoRotateStopDelay -= newTime - prevTime;

          if (config.autoRotateStopDelay <= 0) {
            config.autoRotateStopDelay = false;
            autoRotateSpeed = config.autoRotate;
            config.autoRotate = 0;
          }
        }
      } // Animated moves


      if (animatedMove.pitch) {
        animateMove("pitch");
        prevPitch = config.pitch;
      }

      if (animatedMove.yaw) {
        animateMove("yaw");
        prevYaw = config.yaw;
      }

      if (animatedMove.hfov) {
        animateMove("hfov");
        prevZoom = config.hfov;
      } // "Inertia"


      if (diff > 0 && !config.autoRotate) {
        // "Friction"
        var slowDownFactor = 1 - config.friction; // Yaw

        if (!keysDown[4] && !keysDown[5] && !keysDown[8] && !keysDown[9] && !animatedMove.yaw) {
          config.yaw += speed.yaw * diff * slowDownFactor;
        } // Pitch


        if (!keysDown[2] && !keysDown[3] && !keysDown[6] && !keysDown[7] && !animatedMove.pitch) {
          config.pitch += speed.pitch * diff * slowDownFactor;
        } // Zoom


        if (!keysDown[0] && !keysDown[1] && !animatedMove.hfov) {
          setHfov(config.hfov + speed.hfov * diff * slowDownFactor);
        }
      }

      prevTime = newTime;

      if (diff > 0) {
        speed.yaw = speed.yaw * 0.8 + (config.yaw - prevYaw) / diff * 0.2;
        speed.pitch = speed.pitch * 0.8 + (config.pitch - prevPitch) / diff * 0.2;
        speed.hfov = speed.hfov * 0.8 + (config.hfov - prevZoom) / diff * 0.2; // Limit speed

        var maxSpeed = config.autoRotate ? Math.abs(config.autoRotate) : 5;
        speed.yaw = Math.min(maxSpeed, Math.max(speed.yaw, -maxSpeed));
        speed.pitch = Math.min(maxSpeed, Math.max(speed.pitch, -maxSpeed));
        speed.hfov = Math.min(maxSpeed, Math.max(speed.hfov, -maxSpeed));
      } // Stop movement if opposite controls are pressed


      if (keysDown[0] && keysDown[1]) {
        speed.hfov = 0;
      }

      if ((keysDown[2] || keysDown[6]) && (keysDown[3] || keysDown[7])) {
        speed.pitch = 0;
      }

      if ((keysDown[4] || keysDown[8]) && (keysDown[5] || keysDown[9])) {
        speed.yaw = 0;
      }
    }
    /**
     * Animates moves.
     * @param {string} axis - Axis to animate
     * @private
     */


    function animateMove(axis) {
      var t = animatedMove[axis];
      var normTime = Math.min(1, Math.max((Date.now() - t.startTime) / 1000 / (t.duration / 1000), 0));
      var result = t.startPosition + config.animationTimingFunction(normTime) * (t.endPosition - t.startPosition);

      if (t.endPosition > t.startPosition && result >= t.endPosition || t.endPosition < t.startPosition && result <= t.endPosition || t.endPosition === t.startPosition) {
        result = t.endPosition;
        speed[axis] = 0;
        delete animatedMove[axis];
      }

      config[axis] = result;
    }
    /**
     * @param {number} t - Normalized time in animation
     * @return {number} Position in animation
     * @private
     */


    function timingFunction(t) {
      // easeInOutQuad from https://gist.github.com/gre/1650294
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    }
    /**
     * Event handler for document resizes. Updates viewer size and rerenders view.
     * @private
     */


    function onDocumentResize() {
      // Resize panorama renderer (moved to onFullScreenChange)
      //renderer.resize();
      //animateInit();
      // Kludge to deal with WebKit regression: https://bugs.webkit.org/show_bug.cgi?id=93525
      onFullScreenChange("resize");
    }
    /**
     * Initializes animation.
     * @private
     */


    function animateInit() {
      if (animating) {
        return;
      }

      animating = true;
      animate();
    }
    /**
     * Animates view, using requestAnimationFrame to trigger rendering.
     * @private
     */


    function animate() {
      if (destroyed) {
        return;
      }

      render();
      if (autoRotateStart) clearTimeout(autoRotateStart);

      if (isUserInteracting || orientation === true) {
        console.log("ani", animate);
        requestAnimationFrame(animate);
      } else if (keysDown[0] || keysDown[1] || keysDown[2] || keysDown[3] || keysDown[4] || keysDown[5] || keysDown[6] || keysDown[7] || keysDown[8] || keysDown[9] || config.autoRotate || animatedMove.pitch || animatedMove.yaw || animatedMove.hfov || Math.abs(speed.yaw) > 0.01 || Math.abs(speed.pitch) > 0.01 || Math.abs(speed.hfov) > 0.01) {
        keyRepeat();

        if (config.autoRotateInactivityDelay >= 0 && autoRotateSpeed && Date.now() - latestInteraction > config.autoRotateInactivityDelay && !config.autoRotate) {
          config.autoRotate = autoRotateSpeed;

          _this.lookAt(origPitch, undefined$1, origHfov, 3000);
        }

        requestAnimationFrame(animate);
      } else if (renderer && (renderer.isLoading() || config.dynamic === true && update)) {
        requestAnimationFrame(animate);
      } else {
        fireEvent("animatefinished", {
          pitch: _this.getPitch(),
          yaw: _this.getYaw(),
          hfov: _this.getHfov()
        });
        animating = false;
        prevTime = undefined$1;
        var autoRotateStartTime = config.autoRotateInactivityDelay - (Date.now() - latestInteraction);

        if (autoRotateStartTime > 0) {
          autoRotateStart = setTimeout(function () {
            config.autoRotate = autoRotateSpeed;

            _this.lookAt(origPitch, undefined$1, origHfov, 3000);

            animateInit();
          }, autoRotateStartTime);
        } else if (config.autoRotateInactivityDelay >= 0 && autoRotateSpeed) {
          config.autoRotate = autoRotateSpeed;

          _this.lookAt(origPitch, undefined$1, origHfov, 3000);

          animateInit();
        }
      }
    }
    /**
     * Renders panorama view.
     * @private
     */


    function render() {
      var tmpyaw;

      if (loaded) {
        var canvas = renderer.getCanvas();

        if (config.autoRotate !== false) {
          // When auto-rotating this check needs to happen first (see issue #764)
          if (config.yaw > 180) {
            config.yaw -= 360;
          } else if (config.yaw < -180) {
            config.yaw += 360;
          }
        } // Keep a tmp value of yaw for autoRotate comparison later


        tmpyaw = config.yaw; // Optionally avoid showing background (empty space) on left or right by adapting min/max yaw

        var hoffcut = 0,
            voffcut = 0;

        if (config.avoidShowingBackground) {
          var hfov2 = config.hfov / 2,
              vfov2 = Math.atan2(Math.tan(hfov2 / 180 * Math.PI), canvas.width / canvas.height) * 180 / Math.PI,
              transposed = config.vaov > config.haov;

          if (transposed) {
            voffcut = vfov2 * (1 - Math.min(Math.cos((config.pitch - hfov2) / 180 * Math.PI), Math.cos((config.pitch + hfov2) / 180 * Math.PI)));
          } else {
            hoffcut = hfov2 * (1 - Math.min(Math.cos((config.pitch - vfov2) / 180 * Math.PI), Math.cos((config.pitch + vfov2) / 180 * Math.PI)));
          }
        } // Ensure the yaw is within min and max allowed


        var yawRange = config.maxYaw - config.minYaw,
            minYaw = -180,
            maxYaw = 180;

        if (yawRange < 360) {
          minYaw = config.minYaw + config.hfov / 2 + hoffcut;
          maxYaw = config.maxYaw - config.hfov / 2 - hoffcut;

          if (yawRange < config.hfov) {
            // Lock yaw to average of min and max yaw when both can be seen at once
            minYaw = maxYaw = (minYaw + maxYaw) / 2;
          }

          config.yaw = Math.max(minYaw, Math.min(maxYaw, config.yaw));
        }

        if (!(config.autoRotate !== false)) {
          // When not auto-rotating, this check needs to happen after the
          // previous check (see issue #698)
          if (config.yaw > 180) {
            config.yaw -= 360;
          } else if (config.yaw < -180) {
            config.yaw += 360;
          }
        } // Check if we autoRotate in a limited by min and max yaw
        // If so reverse direction


        if (config.autoRotate !== false && tmpyaw != config.yaw && prevTime !== undefined$1) {
          // this condition prevents changing the direction initially
          config.autoRotate *= -1;
        } // Ensure the calculated pitch is within min and max allowed


        var vfov = 2 * Math.atan(Math.tan(config.hfov / 180 * Math.PI * 0.5) / (canvas.width / canvas.height)) / Math.PI * 180;
        var minPitch = config.minPitch + vfov / 2,
            maxPitch = config.maxPitch - vfov / 2;
        var pitchRange = config.maxPitch - config.minPitch;

        if (pitchRange < vfov) {
          // Lock pitch to average of min and max pitch when both can be seen at once
          minPitch = maxPitch = (minPitch + maxPitch) / 2;
        }

        if (isNaN(minPitch)) minPitch = -90;
        if (isNaN(maxPitch)) maxPitch = 90;
        config.pitch = Math.max(minPitch, Math.min(maxPitch, config.pitch));
        renderer.render(config.pitch * Math.PI / 180, config.yaw * Math.PI / 180, config.hfov * Math.PI / 180, {
          roll: config.roll * Math.PI / 180
        });
        renderHotSpots(); // Update compass

        if (config.compass) {
          compass.style.transform = "rotate(" + (-config.yaw - config.northOffset) + "deg)";
          compass.style.webkitTransform = "rotate(" + (-config.yaw - config.northOffset) + "deg)";
        }

        if (onRender) {
          onRender(config.yaw - config.northOffset);
        }
      }
    }
    /**
     * Creates a new quaternion.
     * @private
     * @constructor
     * @param {Number} w - W value
     * @param {Number} x - X value
     * @param {Number} y - Y value
     * @param {Number} z - Z value
     */


    function Quaternion(w, x, y, z) {
      this.w = w;
      this.x = x;
      this.y = y;
      this.z = z;
    }
    /**
     * Multiplies quaternions.
     * @private
     * @param {Quaternion} q - Quaternion to multiply
     * @returns {Quaternion} Result of multiplication
     */


    Quaternion.prototype.multiply = function (q) {
      return new Quaternion(this.w * q.w - this.x * q.x - this.y * q.y - this.z * q.z, this.x * q.w + this.w * q.x + this.y * q.z - this.z * q.y, this.y * q.w + this.w * q.y + this.z * q.x - this.x * q.z, this.z * q.w + this.w * q.z + this.x * q.y - this.y * q.x);
    };
    /**
     * Converts quaternion to Euler angles.
     * @private
     * @returns {Number[]} [phi angle, theta angle, psi angle]
     */


    Quaternion.prototype.toEulerAngles = function () {
      var phi = Math.atan2(2 * (this.w * this.x + this.y * this.z), 1 - 2 * (this.x * this.x + this.y * this.y)),
          theta = Math.asin(2 * (this.w * this.y - this.z * this.x)),
          psi = Math.atan2(2 * (this.w * this.z + this.x * this.y), 1 - 2 * (this.y * this.y + this.z * this.z));
      return [phi, theta, psi];
    };
    /**
     * Converts device orientation API Tait-Bryan angles to a quaternion.
     * @private
     * @param {Number} alpha - Alpha angle (in degrees)
     * @param {Number} beta - Beta angle (in degrees)
     * @param {Number} gamma - Gamma angle (in degrees)
     * @returns {Quaternion} Orientation quaternion
     */


    function taitBryanToQuaternion(alpha, beta, gamma) {
      var r = [beta ? beta * Math.PI / 180 / 2 : 0, gamma ? gamma * Math.PI / 180 / 2 : 0, alpha ? alpha * Math.PI / 180 / 2 : 0];
      var c = [Math.cos(r[0]), Math.cos(r[1]), Math.cos(r[2])],
          s = [Math.sin(r[0]), Math.sin(r[1]), Math.sin(r[2])];
      return new Quaternion(c[0] * c[1] * c[2] - s[0] * s[1] * s[2], s[0] * c[1] * c[2] - c[0] * s[1] * s[2], c[0] * s[1] * c[2] + s[0] * c[1] * s[2], c[0] * c[1] * s[2] + s[0] * s[1] * c[2]);
    }
    /**
     * Computes current device orientation quaternion from device orientation API
     * Tait-Bryan angles.
     * @private
     * @param {Number} alpha - Alpha angle (in degrees)
     * @param {Number} beta - Beta angle (in degrees)
     * @param {Number} gamma - Gamma angle (in degrees)
     * @returns {Quaternion} Orientation quaternion
     */


    function computeQuaternion(alpha, beta, gamma) {
      // Convert Tait-Bryan angles to quaternion
      var quaternion = taitBryanToQuaternion(alpha, beta, gamma); // Apply world transform

      quaternion = quaternion.multiply(new Quaternion(Math.sqrt(0.5), -Math.sqrt(0.5), 0, 0)); // Apply screen transform

      var angle = window.orientation ? -window.orientation * Math.PI / 180 / 2 : 0;
      return quaternion.multiply(new Quaternion(Math.cos(angle), 0, -Math.sin(angle), 0));
    }
    /**
     * Event handler for device orientation API. Controls pointing.
     * @private
     * @param {DeviceOrientationEvent} event - Device orientation event.
     */


    function orientationListener(e) {
      if (e.hasOwnProperty("requestPermission")) e.requestPermission();
      var q = computeQuaternion(e.alpha, e.beta, e.gamma).toEulerAngles();

      if (typeof orientation == "number" && orientation < 10) {
        // This kludge is necessary because iOS sometimes provides a few stale
        // device orientation events when the listener is removed and then
        // readded. Thus, we skip the first 10 events to prevent this from
        // causing problems.
        orientation += 1;
      } else if (orientation === 10) {
        // Record starting yaw to prevent jumping
        orientationYawOffset = q[2] / Math.PI * 180 + config.yaw;
        orientation = true;
        requestAnimationFrame(animate);
      } else {
        config.pitch = q[0] / Math.PI * 180;
        config.roll = -q[1] / Math.PI * 180;
        config.yaw = -q[2] / Math.PI * 180 + orientationYawOffset;
      }
    }
    /**
     * Initializes renderer.
     * @private
     */


    function renderInit() {
      try {
        var params = {};
        if (config.horizonPitch !== undefined$1) params.horizonPitch = config.horizonPitch * Math.PI / 180;
        if (config.horizonRoll !== undefined$1) params.horizonRoll = config.horizonRoll * Math.PI / 180;
        if (config.backgroundColor !== undefined$1) params.backgroundColor = config.backgroundColor;
        renderer.init(panoImage, config.type, config.dynamic, config.haov * Math.PI / 180, config.vaov * Math.PI / 180, config.vOffset * Math.PI / 180, renderInitCallback, params);

        if (config.dynamic !== true) {
          // Allow image to be garbage collected
          panoImage = undefined$1;
        }
      } catch (event) {
        // Panorama not loaded
        // Display error if there is a bad texture
        if (event.type == "webgl error" || event.type == "no webgl") {
          anError();
        } else if (event.type == "webgl size error") {
          anError(config.strings.textureSizeError.replace("%s", event.width).replace("%s", event.maxWidth));
        } else {
          anError(config.strings.unknownError);
          throw event;
        }
      }
    }
    /**
     * Triggered when render initialization finishes. Handles fading between
     * scenes as well as showing the compass and hotspots and hiding the loading
     * display.
     * @private
     */


    function renderInitCallback() {
      // Fade if specified
      if (config.sceneFadeDuration && renderer.fadeImg !== undefined$1) {
        renderer.fadeImg.style.opacity = 0; // Remove image

        var fadeImg = renderer.fadeImg;
        delete renderer.fadeImg;
        setTimeout(function () {
          renderContainer.removeChild(fadeImg);
          fireEvent("scenechangefadedone");
        }, config.sceneFadeDuration);
      } // Show compass if applicable


      if (config.compass) {
        compass.style.display = "inline";
      } else {
        compass.style.display = "none";
      } // Show hotspots


      createHotSpots(); // Hide loading display

      infoDisplay.load.box.style.display = "none";

      if (preview !== undefined$1) {
        renderContainer.removeChild(preview);
        preview = undefined$1;
      }

      loaded = true;
      animateInit();
      fireEvent("load");
    }
    /**
     * Creates hot spot element for the current scene.
     * @private
     * @param {Object} hs - The configuration for the hotspot
     */


    function createHotSpot(hs) {
      // Make sure hot spot pitch and yaw are numbers
      hs.pitch = Number(hs.pitch) || 0;
      hs.yaw = Number(hs.yaw) || 0;
      var div = document.createElement("div");
      div.className = "pnlm-hotspot-base";
      div.id = hs.id;
      if (hs.cssClass) div.className += " " + hs.cssClass;else div.className += " pnlm-hotspot pnlm-sprite pnlm-" + escapeHTML(hs.type);
      var span = document.createElement("span");
      if (hs.text) span.innerHTML = escapeHTML(hs.text);
      var a;

      if (hs.video) {
        var video = document.createElement("video"),
            vidp = hs.video;
        if (config.basePath && !absoluteURL(vidp)) vidp = config.basePath + vidp;
        video.src = sanitizeURL(vidp);
        video.controls = true;
        video.style.width = hs.width + "px";
        renderContainer.appendChild(div);
        span.appendChild(video);
      } else if (hs.image) {
        var imgp = hs.image;
        if (config.basePath && !absoluteURL(imgp)) imgp = config.basePath + imgp;
        a = document.createElement("a");
        a.href = sanitizeURL(hs.URL ? hs.URL : imgp);
        a.target = "_blank";
        span.appendChild(a);
        var image = document.createElement("img");
        image.src = sanitizeURL(imgp);
        image.style.width = hs.width + "px";
        image.style.paddingTop = "5px";
        renderContainer.appendChild(div);
        a.appendChild(image);
        span.style.maxWidth = "initial";
      } else if (hs.URL) {
        a = document.createElement("a");
        a.href = sanitizeURL(hs.URL);

        if (hs.attributes) {
          for (var key in hs.attributes) {
            a.setAttribute(key, hs.attributes[key]);
          }
        } else {
          a.target = "_blank";
        }

        renderContainer.appendChild(a);
        div.className += " pnlm-pointer";
        span.className += " pnlm-pointer";
        a.appendChild(div);
      } else {
        if (hs.sceneId) {
          div.onclick = div.ontouchend = function () {
            if (!div.clicked) {
              div.clicked = true;
              loadScene(hs.sceneId, hs.targetPitch, hs.targetYaw, hs.targetHfov);
            }

            return false;
          };

          div.className += " pnlm-pointer";
          span.className += " pnlm-pointer";
        }

        renderContainer.appendChild(div);
      }

      if (hs.createTooltipFunc) {
        hs.createTooltipFunc(div, hs.createTooltipArgs);
      } else if (hs.text || hs.video || hs.image) {
        div.classList.add("pnlm-tooltip");
        div.appendChild(span);
        span.style.width = span.scrollWidth - 20 + "px";
        span.style.marginLeft = -(span.scrollWidth - div.offsetWidth) / 2 + "px";
        span.style.marginTop = -span.scrollHeight - 12 + "px";
      }

      if (hs.clickHandlerFunc) {
        div.addEventListener("click", function (e) {
          hs.clickHandlerFunc(e, hs.clickHandlerArgs);
        }, "false");
        div.className += " pnlm-pointer";
        span.className += " pnlm-pointer";
      }

      hs.div = div;
    }
    /**
     * Creates hot spot elements for the current scene.
     * @private
     */


    function createHotSpots() {
      if (hotspotsCreated) return;

      if (!config.hotSpots) {
        config.hotSpots = [];
      } else {
        // Sort by pitch so tooltip is never obscured by another hot spot
        config.hotSpots = config.hotSpots.sort(function (a, b) {
          return a.pitch < b.pitch;
        });
        config.hotSpots.forEach(createHotSpot);
      }

      hotspotsCreated = true;
      renderHotSpots();
    }
    /**
     * Destroys currently created hot spot elements.
     * @private
     */


    function destroyHotSpots() {
      var hs = config.hotSpots;
      hotspotsCreated = false;
      delete config.hotSpots;

      if (hs) {
        for (var i = 0; i < hs.length; i++) {
          var current = hs[i].div;

          if (current) {
            while (current.parentNode && current.parentNode != renderContainer) {
              current = current.parentNode;
            }

            renderContainer.removeChild(current);
          }

          delete hs[i].div;
        }
      }
    }
    /**
     * Renders hot spot, updating its position and visibility.
     * @private
     */


    function renderHotSpot(hs) {
      var hsPitchSin = Math.sin(hs.pitch * Math.PI / 180),
          hsPitchCos = Math.cos(hs.pitch * Math.PI / 180),
          configPitchSin = Math.sin(config.pitch * Math.PI / 180),
          configPitchCos = Math.cos(config.pitch * Math.PI / 180),
          yawCos = Math.cos((-hs.yaw + config.yaw) * Math.PI / 180);
      var z = hsPitchSin * configPitchSin + hsPitchCos * yawCos * configPitchCos;

      if (hs.yaw <= 90 && hs.yaw > -90 && z <= 0 || (hs.yaw > 90 || hs.yaw <= -90) && z <= 0) {
        hs.div.style.visibility = "hidden";
      } else {
        var yawSin = Math.sin((-hs.yaw + config.yaw) * Math.PI / 180),
            hfovTan = Math.tan(config.hfov * Math.PI / 360);
        hs.div.style.visibility = "visible"; // Subpixel rendering doesn't work in Firefox
        // https://bugzilla.mozilla.org/show_bug.cgi?id=739176

        var canvas = renderer.getCanvas(),
            canvasWidth = canvas.clientWidth,
            canvasHeight = canvas.clientHeight;
        var coord = [-canvasWidth / hfovTan * yawSin * hsPitchCos / z / 2, -canvasWidth / hfovTan * (hsPitchSin * configPitchCos - hsPitchCos * yawCos * configPitchSin) / z / 2]; // Apply roll

        var rollSin = Math.sin(config.roll * Math.PI / 180),
            rollCos = Math.cos(config.roll * Math.PI / 180);
        coord = [coord[0] * rollCos - coord[1] * rollSin, coord[0] * rollSin + coord[1] * rollCos]; // Apply transform

        coord[0] += (canvasWidth - hs.div.offsetWidth) / 2;
        coord[1] += (canvasHeight - hs.div.offsetHeight) / 2;
        var transform = "translate(" + coord[0] + "px, " + coord[1] + "px) translateZ(9999px) rotate(" + config.roll + "deg)";

        if (hs.scale) {
          transform += " scale(" + origHfov / config.hfov / z + ")";
        } // assign keyframes


        var markerkeyframes = [{
          transform: transform + " scale(0.9)"
        }, {
          transform: transform + " scale(1)"
        }, {
          transform: transform + " scale(0.9)"
        }]; // assign timings

        var markertiming = {
          duration: 1000,
          easing: "ease-in-out",
          iterations: Infinity,
          delay: 1000
        };
        hs.div.style.webkitTransform = transform;
        hs.div.style.MozTransform = transform;
        hs.div.style.transform = transform;
        var hotspotEle = document.getElementById(hs.id); //var pulseAnimate = hotspotEle.animate(markerkeyframes, markertiming);
        //pulseAnimate.play();

        hotspotEle.onmouseover = function () {//pulseAnimate.pause();
        };

        hotspotEle.onmouseout = function () {//pulseAnimate.play();
        };
      }
    }
    /**
     * Renders hot spots, updating their positions and visibility.
     * @private
     */


    function renderHotSpots() {
      config.hotSpots.forEach(renderHotSpot);
    }
    /**
     * Merges a scene configuration into the current configuration.
     * @private
     * @param {string} sceneId - Identifier of scene configuration to merge in.
     */


    function mergeConfig(sceneId) {
      config = {};
      var k, s;
      var photoSphereExcludes = ["haov", "vaov", "vOffset", "northOffset", "horizonPitch", "horizonRoll"];
      specifiedPhotoSphereExcludes = []; // Merge default config

      for (k in defaultConfig) {
        if (defaultConfig.hasOwnProperty(k)) {
          config[k] = defaultConfig[k];
        }
      } // Merge default scene config


      for (k in initialConfig["default"]) {
        if (initialConfig["default"].hasOwnProperty(k)) {
          if (k == "strings") {
            for (s in initialConfig["default"].strings) {
              if (initialConfig["default"].strings.hasOwnProperty(s)) {
                config.strings[s] = escapeHTML(initialConfig["default"].strings[s]);
              }
            }
          } else {
            config[k] = initialConfig["default"][k];

            if (photoSphereExcludes.indexOf(k) >= 0) {
              specifiedPhotoSphereExcludes.push(k);
            }
          }
        }
      } // Merge current scene config


      if (sceneId !== null && sceneId !== "" && initialConfig.scenes && initialConfig.scenes[sceneId]) {
        var scene = initialConfig.scenes[sceneId];

        for (k in scene) {
          if (scene.hasOwnProperty(k)) {
            if (k == "strings") {
              for (s in scene.strings) {
                if (scene.strings.hasOwnProperty(s)) {
                  config.strings[s] = escapeHTML(scene.strings[s]);
                }
              }
            } else {
              config[k] = scene[k];

              if (photoSphereExcludes.indexOf(k) >= 0) {
                specifiedPhotoSphereExcludes.push(k);
              }
            }
          }
        }

        config.scene = sceneId;
      } // Merge initial config


      for (k in initialConfig) {
        if (initialConfig.hasOwnProperty(k)) {
          if (k == "strings") {
            for (s in initialConfig.strings) {
              if (initialConfig.strings.hasOwnProperty(s)) {
                config.strings[s] = escapeHTML(initialConfig.strings[s]);
              }
            }
          } else {
            config[k] = initialConfig[k];

            if (photoSphereExcludes.indexOf(k) >= 0) {
              specifiedPhotoSphereExcludes.push(k);
            }
          }
        }
      }
    }
    /**
     * Processes configuration options.
     * @param {boolean} [isPreview] - Whether or not the preview is being displayed
     * @private
     */


    function processOptions(isPreview) {
      isPreview = isPreview ? isPreview : false; // Process preview first so it always loads before the browser hits its
      // maximum number of connections to a server as can happen with cubic
      // panoramas

      if (isPreview && "preview" in config) {
        var p = config.preview;
        if (config.basePath && !absoluteURL(p)) p = config.basePath + p;
        preview = document.createElement("div");
        preview.className = "pnlm-preview-img";
        preview.style.backgroundImage = "url('" + sanitizeURLForCss(p) + "')";
        renderContainer.appendChild(preview);
      } // Handle different preview values


      var title = config.title,
          author = config.author;

      if (isPreview) {
        if ("previewTitle" in config) config.title = config.previewTitle;
        if ("previewAuthor" in config) config.author = config.previewAuthor;
      } // Reset title / author display


      if (!config.hasOwnProperty("title")) infoDisplay.title.innerHTML = "";
      if (!config.hasOwnProperty("author")) infoDisplay.author.innerHTML = "";
      if (!config.hasOwnProperty("title") && !config.hasOwnProperty("author")) infoDisplay.container.style.display = "none"; // Fill in load button label and loading box text

      for (var key in config) {
        if (config.hasOwnProperty(key)) {
          switch (key) {
            case "title":
              infoDisplay.title.innerHTML = escapeHTML(config[key]);
              infoDisplay.container.style.display = "inline";
              break;

            case "author":
              var authorText = escapeHTML(config[key]);

              if (config.authorURL) {
                var authorLink = document.createElement("a");
                authorLink.href = sanitizeURL(config["authorURL"]);
                authorLink.target = "_blank";
                authorLink.innerHTML = escapeHTML(config[key]);
                authorText = authorLink.outerHTML;
              }

              infoDisplay.author.innerHTML = config.strings.bylineLabel.replace("%s", authorText);
              infoDisplay.container.style.display = "inline";
              break;

            case "fallback":
              var link = document.createElement("a");
              link.href = sanitizeURL(config[key]);
              link.target = "_blank";
              link.textContent = "Click here to view this panorama in an alternative viewer.";
              var message = document.createElement("p");
              message.textContent = "Your browser does not support WebGL.";
              message.appendChild(document.createElement("br"));
              message.appendChild(link);
              infoDisplay.errorMsg.innerHTML = ""; // Removes all children nodes

              infoDisplay.errorMsg.appendChild(message);
              break;

            case "hfov":
              setHfov(Number(config[key]));
              break;

            case "autoLoad":
              if (config[key] === true && renderer === undefined$1) {
                // Show loading box
                infoDisplay.load.box.style.display = "inline"; // Hide load button

                controls.load.style.display = "none"; // Initialize

                init();
              }

              break;

            case "showZoomCtrl":
              if (config[key] && config.showControls != false) {
                // Show zoom controls
                controls.zoom.style.display = "block";
              } else {
                // Hide zoom controls
                controls.zoom.style.display = "none";
              }

              break;

            case "showFullscreenCtrl":
              if (config[key] && config.showControls != false && ("fullscreen" in document || "mozFullScreen" in document || "webkitIsFullScreen" in document || "msFullscreenElement" in document)) {
                // Show fullscreen control
                controls.fullscreen.style.display = "block";
              } else {
                // Hide fullscreen control
                controls.fullscreen.style.display = "none";
              }

              break;

            case "hotSpotDebug":
              if (config[key]) hotSpotDebugIndicator.style.display = "block";else hotSpotDebugIndicator.style.display = "none";
              break;

            case "showControls":
              if (!config[key]) {
                controls.orientation.style.display = "none";
                controls.zoom.style.display = "none";
                controls.fullscreen.style.display = "none";
              }

              break;

            case "orientationOnByDefault":
              if (config[key]) {
                startOrientation();
                break;
              }

          }
        }
      }

      if (isPreview) {
        // Restore original values if changed for preview
        if (title) config.title = title;else delete config.title;
        if (author) config.author = author;else delete config.author;
      }
    }
    /**
     * Toggles fullscreen mode.
     * @private
     */


    function toggleFullscreen() {
      if (loaded && !error) {
        if (!fullscreenActive) {
          try {
            if (mainContainer.requestFullscreen) {
              //container.requestFullscreen();
              mainContainer.requestFullscreen();
            } else if (mainContainer.mozRequestFullScreen) {
              //container.mozRequestFullScreen();
              mainContainer.mozRequestFullScreen();
            } else if (mainContainer.msRequestFullscreen) {
              //container.msRequestFullscreen();
              mainContainer.msRequestFullscreen();
            } else {
              //container.webkitRequestFullScreen();
              mainContainer.webkitRequestFullScreen();
            }
          } catch (event) {// Fullscreen doesn't work
          }
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        }
      }
    }
    /**
     * Event handler for fullscreen changes.
     * @private
     */


    function onFullScreenChange(resize) {
      if (document.fullscreenElement || document.fullscreen || document.mozFullScreen || document.webkitIsFullScreen || document.msFullscreenElement) {
        controls.fullscreen.classList.add("pnlm-fullscreen-toggle-button-active");
        fullscreenActive = true;
      } else {
        controls.fullscreen.classList.remove("pnlm-fullscreen-toggle-button-active");
        fullscreenActive = false;
      }

      if (resize !== "resize") fireEvent("fullscreenchange", fullscreenActive); // Resize renderer (deal with browser quirks and fixes #155)

      renderer.resize();
      setHfov(config.hfov);
      animateInit();
    }
    /**
     * Increases panorama zoom. For use with zoom button.
     * @private
     */


    function zoomIn() {
      if (loaded) {
        setHfov(config.hfov - 5);
        animateInit();
      }
    }
    /**
     * Decreases panorama zoom. For use with zoom button.
     * @private
     */


    function zoomOut() {
      if (loaded) {
        setHfov(config.hfov + 5);
        animateInit();
      }
    }
    /**
     * Clamps horzontal field of view to viewer's limits.
     * @private
     * @param {number} hfov - Input horizontal field of view (in degrees)
     * @return {number} - Clamped horizontal field of view (in degrees)
     */


    function constrainHfov(hfov) {
      // Keep field of view within bounds
      var minHfov = config.minHfov;

      if (config.type == "multires" && renderer && !config.multiResMinHfov) {
        minHfov = Math.min(minHfov, renderer.getCanvas().width / (config.multiRes.cubeResolution / 90 * 0.9));
      }

      if (minHfov > config.maxHfov) {
        // Don't change view if bounds don't make sense
        console.log("HFOV bounds do not make sense (minHfov > maxHfov).");
        return config.hfov;
      }

      var newHfov = config.hfov;

      if (hfov < minHfov) {
        newHfov = minHfov;
      } else if (hfov > config.maxHfov) {
        newHfov = config.maxHfov;
      } else {
        newHfov = hfov;
      } // Optionally avoid showing background (empty space) on top or bottom by adapting newHfov


      if (config.avoidShowingBackground && renderer) {
        var canvas = renderer.getCanvas();
        newHfov = Math.min(newHfov, Math.atan(Math.tan((config.maxPitch - config.minPitch) / 360 * Math.PI) / canvas.height * canvas.width) * 360 / Math.PI);
      }

      return newHfov;
    }
    /**
     * Sets viewer's horizontal field of view.
     * @private
     * @param {number} hfov - Desired horizontal field of view in degrees.
     */


    function setHfov(hfov) {
      config.hfov = constrainHfov(hfov);
      fireEvent("zoomchange", config.hfov);
    }
    /**
     * Stops auto rotation and animated moves.
     * @private
     */


    function stopAnimation() {
      animatedMove = {};
      autoRotateSpeed = config.autoRotate ? config.autoRotate : autoRotateSpeed;
      config.autoRotate = false;
    }
    /**
     * Loads panorama.
     * @private
     */


    function load() {
      // Since WebGL error handling is very general, first we clear any error box
      // since it is a new scene and the error from previous maybe because of lacking
      // memory etc and not because of a lack of WebGL support etc
      clearError();
      loaded = false;
      controls.load.style.display = "none";
      infoDisplay.load.box.style.display = "inline";
      init();
    }
    /**
     * Loads scene.
     * @private
     * @param {string} sceneId - Identifier of scene configuration to merge in.
     * @param {number} targetPitch - Pitch viewer should be centered on once scene loads.
     * @param {number} targetYaw - Yaw viewer should be centered on once scene loads.
     * @param {number} targetHfov - HFOV viewer should use once scene loads.
     * @param {boolean} [fadeDone] - If `true`, fade setup is skipped.
     */


    function loadScene(sceneId, targetPitch, targetYaw, targetHfov, fadeDone) {
      if (!loaded) fadeDone = true; // Don't try to fade when there isn't a scene loaded

      loaded = false;
      animatedMove = {}; // Set up fade if specified

      var fadeImg, workingPitch, workingYaw, workingHfov;

      if (config.sceneFadeDuration && !fadeDone) {
        var data = renderer.render(config.pitch * Math.PI / 180, config.yaw * Math.PI / 180, config.hfov * Math.PI / 180, {
          returnImage: true
        });

        if (data !== undefined$1) {
          fadeImg = new Image();
          fadeImg.className = "pnlm-fade-img";
          fadeImg.style.transition = "opacity " + config.sceneFadeDuration / 1000 + "s";
          fadeImg.style.width = "100%";
          fadeImg.style.height = "100%";

          fadeImg.onload = function () {
            loadScene(sceneId, targetPitch, targetYaw, targetHfov, true);
          };

          fadeImg.src = data;
          renderContainer.appendChild(fadeImg);
          renderer.fadeImg = fadeImg;
          return;
        }
      } // Set new pointing


      if (targetPitch === "same") {
        workingPitch = config.pitch;
      } else {
        workingPitch = targetPitch;
      }

      if (targetYaw === "same") {
        workingYaw = config.yaw;
      } else if (targetYaw === "sameAzimuth") {
        workingYaw = config.yaw + (config.northOffset || 0) - (initialConfig.scenes[sceneId].northOffset || 0);
      } else {
        workingYaw = targetYaw;
      }

      if (targetHfov === "same") {
        workingHfov = config.hfov;
      } else {
        workingHfov = targetHfov;
      } // Destroy hot spots from previous scene


      destroyHotSpots(); // Create the new config for the scene

      mergeConfig(sceneId); // Stop motion

      speed.yaw = speed.pitch = speed.hfov = 0; // Reload scene

      processOptions();

      if (workingPitch !== undefined$1) {
        config.pitch = workingPitch;
      }

      if (workingYaw !== undefined$1) {
        config.yaw = workingYaw;
      }

      if (workingHfov !== undefined$1) {
        config.hfov = workingHfov;
      }

      fireEvent("scenechange", sceneId);
      load();
    }
    /**
     * Stop using device orientation.
     * @private
     */


    function stopOrientation() {
      window.removeEventListener("deviceorientation", orientationListener);
      controls.orientation.classList.remove("pnlm-orientation-button-active");
      orientation = false;
    }
    /**
     * Start using device orientation.
     * @private
     */


    function startOrientation() {
      orientation = 1; // Fix for IOS 13 where the user needs to perform an action i.e click. Then we need to ask permission

      if (DeviceOrientationEvent && typeof DeviceOrientationEvent.requestPermission === "function") {
        DeviceOrientationEvent.requestPermission().then(function (response) {
          if (response === "granted") {
            window.addEventListener("deviceorientation", orientationListener);
          }
        })["catch"](console.error);
      } else {
        window.addEventListener("deviceorientation", orientationListener);
      } // window.addEventListener('deviceorientation', orientationListener);


      controls.orientation.classList.add("pnlm-orientation-button-active");
    }
    /**
     * Escapes HTML string (to mitigate possible DOM XSS attacks).
     * @private
     * @param {string} s - String to escape
     * @returns {string} Escaped string
     */


    function escapeHTML(s) {
      if (!initialConfig.escapeHTML) return String(s).split("\n").join("<br>");
      return String(s).split(/&/g).join("&amp;").split('"').join("&quot;").split("'").join("&#39;").split("<").join("&lt;").split(">").join("&gt;").split("/").join("&#x2f;").split("\n").join("<br>"); // Allow line breaks
    }
    /**
     * Removes possibility of XSS attacks with URLs.
     * The URL cannot be of protocol 'javascript'.
     * @private
     * @param {string} url - URL to sanitize
     * @returns {string} Sanitized URL
     */


    function sanitizeURL(url) {
      if (url.trim().toLowerCase().indexOf("javascript:") === 0) {
        return "about:blank";
      }

      return url;
    }
    /**
     * Removes possibility of XSS atacks with URLs for CSS.
     * The URL will be sanitized with `sanitizeURL()` and single quotes
     * and double quotes escaped.
     * @private
     * @param {string} url - URL to sanitize
     * @returns {string} Sanitized URL
     */


    function sanitizeURLForCss(url) {
      return sanitizeURL(url).replace(/"/g, "%22").replace(/'/g, "%27");
    }
    /**
     * Checks whether or not a panorama is loaded.
     * @memberof Viewer
     * @instance
     * @returns {boolean} `true` if a panorama is loaded, else `false`
     */


    this.isLoaded = function () {
      return Boolean(loaded);
    };
    /**
     * Returns the pitch of the center of the view.
     * @memberof Viewer
     * @instance
     * @returns {number} Pitch in degrees
     */


    this.getPitch = function () {
      return config.pitch;
    };
    /**
     * Sets the pitch of the center of the view.
     * @memberof Viewer
     * @instance
     * @param {number} pitch - Pitch in degrees
     * @param {boolean|number} [animated=1000] - Animation duration in milliseconds or false for no animation
     * @param {function} [callback] - Function to call when animation finishes
     * @param {object} [callbackArgs] - Arguments to pass to callback function
     * @returns {Viewer} `this`
     */


    this.setPitch = function (pitch, animated, callback, callbackArgs) {
      latestInteraction = Date.now();

      if (Math.abs(pitch - config.pitch) <= eps) {
        if (typeof callback == "function") callback(callbackArgs);
        return this;
      }

      animated = animated == undefined$1 ? 1000 : Number(animated);

      if (animated) {
        animatedMove.pitch = {
          startTime: Date.now(),
          startPosition: config.pitch,
          endPosition: pitch,
          duration: animated
        };
        if (typeof callback == "function") setTimeout(function () {
          callback(callbackArgs);
        }, animated);
      } else {
        config.pitch = pitch;
      }

      animateInit();
      return this;
    };
    /**
     * Returns the minimum and maximum allowed pitches (in degrees).
     * @memberof Viewer
     * @instance
     * @returns {number[]} [minimum pitch, maximum pitch]
     */


    this.getPitchBounds = function () {
      return [config.minPitch, config.maxPitch];
    };
    /**
     * Set the minimum and maximum allowed pitches (in degrees).
     * @memberof Viewer
     * @instance
     * @param {number[]} bounds - [minimum pitch, maximum pitch]
     * @returns {Viewer} `this`
     */


    this.setPitchBounds = function (bounds) {
      config.minPitch = Math.max(-90, Math.min(bounds[0], 90));
      config.maxPitch = Math.max(-90, Math.min(bounds[1], 90));
      return this;
    };
    /**
     * Returns the yaw of the center of the view.
     * @memberof Viewer
     * @instance
     * @returns {number} Yaw in degrees
     */


    this.getYaw = function () {
      return config.yaw;
    };
    /**
     * Sets the yaw of the center of the view.
     * @memberof Viewer
     * @instance
     * @param {number} yaw - Yaw in degrees [-180, 180]
     * @param {boolean|number} [animated=1000] - Animation duration in milliseconds or false for no animation
     * @param {function} [callback] - Function to call when animation finishes
     * @param {object} [callbackArgs] - Arguments to pass to callback function
     * @returns {Viewer} `this`
     */


    this.setYaw = function (yaw, animated, callback, callbackArgs) {
      latestInteraction = Date.now();

      if (Math.abs(yaw - config.yaw) <= eps) {
        if (typeof callback == "function") callback(callbackArgs);
        return this;
      }

      animated = animated == undefined$1 ? 1000 : Number(animated);
      yaw = (yaw + 180) % 360 - 180; // Keep in bounds

      if (animated) {
        // Animate in shortest direction
        if (config.yaw - yaw > 180) yaw += 360;else if (yaw - config.yaw > 180) yaw -= 360;
        animatedMove.yaw = {
          startTime: Date.now(),
          startPosition: config.yaw,
          endPosition: yaw,
          duration: animated
        };
        if (typeof callback == "function") setTimeout(function () {
          callback(callbackArgs);
        }, animated);
      } else {
        config.yaw = yaw;
      }

      animateInit();
      return this;
    };
    /**
     * Returns the minimum and maximum allowed pitches (in degrees).
     * @memberof Viewer
     * @instance
     * @returns {number[]} [yaw pitch, maximum yaw]
     */


    this.getYawBounds = function () {
      return [config.minYaw, config.maxYaw];
    };
    /**
     * Set the minimum and maximum allowed yaws (in degrees [-180, 180]).
     * @memberof Viewer
     * @instance
     * @param {number[]} bounds - [minimum yaw, maximum yaw]
     * @returns {Viewer} `this`
     */


    this.setYawBounds = function (bounds) {
      config.minYaw = Math.max(-180, Math.min(bounds[0], 180));
      config.maxYaw = Math.max(-180, Math.min(bounds[1], 180));
      return this;
    };
    /**
     * Returns the horizontal field of view.
     * @memberof Viewer
     * @instance
     * @returns {number} Horizontal field of view in degrees
     */


    this.getHfov = function () {
      return config.hfov;
    };
    /**
     * Sets the horizontal field of view.
     * @memberof Viewer
     * @instance
     * @param {number} hfov - Horizontal field of view in degrees
     * @param {boolean|number} [animated=1000] - Animation duration in milliseconds or false for no animation
     * @param {function} [callback] - Function to call when animation finishes
     * @param {object} [callbackArgs] - Arguments to pass to callback function
     * @returns {Viewer} `this`
     */


    this.setHfov = function (hfov, animated, callback, callbackArgs) {
      latestInteraction = Date.now();

      if (Math.abs(hfov - config.hfov) <= eps) {
        if (typeof callback == "function") callback(callbackArgs);
        return this;
      }

      animated = animated == undefined$1 ? 1000 : Number(animated);

      if (animated) {
        animatedMove.hfov = {
          startTime: Date.now(),
          startPosition: config.hfov,
          endPosition: constrainHfov(hfov),
          duration: animated
        };
        if (typeof callback == "function") setTimeout(function () {
          callback(callbackArgs);
        }, animated);
      } else {
        setHfov(hfov);
      }

      animateInit();
      return this;
    };
    /**
     * Returns the minimum and maximum allowed horizontal fields of view
     * (in degrees).
     * @memberof Viewer
     * @instance
     * @returns {number[]} [minimum hfov, maximum hfov]
     */


    this.getHfovBounds = function () {
      return [config.minHfov, config.maxHfov];
    };
    /**
     * Set the minimum and maximum allowed horizontal fields of view (in degrees).
     * @memberof Viewer
     * @instance
     * @param {number[]} bounds - [minimum hfov, maximum hfov]
     * @returns {Viewer} `this`
     */


    this.setHfovBounds = function (bounds) {
      config.minHfov = Math.max(0, bounds[0]);
      config.maxHfov = Math.max(0, bounds[1]);
      return this;
    };
    /**
     * Set a new view. Any parameters not specified remain the same.
     * @memberof Viewer
     * @instance
     * @param {number} [pitch] - Target pitch
     * @param {number} [yaw] - Target yaw
     * @param {number} [hfov] - Target hfov
     * @param {boolean|number} [animated=1000] - Animation duration in milliseconds or false for no animation
     * @param {function} [callback] - Function to call when animation finishes
     * @param {object} [callbackArgs] - Arguments to pass to callback function
     * @returns {Viewer} `this`
     */


    this.lookAt = function (pitch, yaw, hfov, animated, callback, callbackArgs) {
      animated = animated == undefined$1 ? 1000 : Number(animated);

      if (pitch !== undefined$1 && Math.abs(pitch - config.pitch) > eps) {
        this.setPitch(pitch, animated, callback, callbackArgs);
        callback = undefined$1;
      }

      if (yaw !== undefined$1 && Math.abs(yaw - config.yaw) > eps) {
        this.setYaw(yaw, animated, callback, callbackArgs);
        callback = undefined$1;
      }

      if (hfov !== undefined$1 && Math.abs(hfov - config.hfov) > eps) {
        this.setHfov(hfov, animated, callback, callbackArgs);
        callback = undefined$1;
      }

      if (typeof callback == "function") callback(callbackArgs);
      return this;
    };
    /**
     * Returns the panorama's north offset.
     * @memberof Viewer
     * @instance
     * @returns {number} North offset in degrees
     */


    this.getNorthOffset = function () {
      return config.northOffset;
    };
    /**
     * Sets the panorama's north offset.
     * @memberof Viewer
     * @instance
     * @param {number} heading - North offset in degrees
     * @returns {Viewer} `this`
     */


    this.setNorthOffset = function (heading) {
      config.northOffset = Math.min(360, Math.max(0, heading));
      animateInit();
      return this;
    };
    /**
     * Returns the panorama's horizon roll.
     * @memberof Viewer
     * @instance
     * @returns {number} Horizon roll in degrees
     */


    this.getHorizonRoll = function () {
      return config.horizonRoll;
    };
    /**
     * Sets the panorama's horizon roll.
     * @memberof Viewer
     * @instance
     * @param {number} roll - Horizon roll in degrees [-90, 90]
     * @returns {Viewer} `this`
     */


    this.setHorizonRoll = function (roll) {
      config.horizonRoll = Math.min(90, Math.max(-90, roll));
      renderer.setPose(config.horizonPitch * Math.PI / 180, config.horizonRoll * Math.PI / 180);
      animateInit();
      return this;
    };
    /**
     * Returns the panorama's horizon pitch.
     * @memberof Viewer
     * @instance
     * @returns {number} Horizon pitch in degrees
     */


    this.getHorizonPitch = function () {
      return config.horizonPitch;
    };
    /**
     * Sets the panorama's horizon pitch.
     * @memberof Viewer
     * @instance
     * @param {number} pitch - Horizon pitch in degrees [-90, 90]
     * @returns {Viewer} `this`
     */


    this.setHorizonPitch = function (pitch) {
      config.horizonPitch = Math.min(90, Math.max(-90, pitch));
      renderer.setPose(config.horizonPitch * Math.PI / 180, config.horizonRoll * Math.PI / 180);
      animateInit();
      return this;
    };
    /**
     * Start auto rotation.
     *
     * Before starting rotation, the viewer is panned to `pitch`.
     * @memberof Viewer
     * @instance
     * @param {number} [speed] - Auto rotation speed / direction. If not specified, previous value is used.
     * @param {number} [pitch] - The pitch to rotate at. If not specified, inital pitch is used.
     * @returns {Viewer} `this`
     */


    this.startAutoRotate = function (speed, pitch) {
      speed = speed || autoRotateSpeed || 1;
      pitch = pitch === undefined$1 ? origPitch : pitch;
      config.autoRotate = speed;

      _this.lookAt(pitch, undefined$1, origHfov, 3000);

      animateInit();
      return this;
    };
    /**
     * Stop auto rotation.
     * @memberof Viewer
     * @instance
     * @returns {Viewer} `this`
     */


    this.stopAutoRotate = function () {
      autoRotateSpeed = config.autoRotate ? config.autoRotate : autoRotateSpeed;
      config.autoRotate = false;
      config.autoRotateInactivityDelay = -1;
      return this;
    };
    /**
     * Stops all movement.
     * @memberof Viewer
     * @instance
     */


    this.stopMovement = function () {
      stopAnimation();
      speed = {
        yaw: 0,
        pitch: 0,
        hfov: 0
      };
    };
    /**
     * Returns the panorama renderer.
     * @memberof Viewer
     * @instance
     * @returns {Renderer}
     */


    this.getRenderer = function () {
      return renderer;
    };
    /**
     * Sets update flag for dynamic content.
     * @memberof Viewer
     * @instance
     * @param {boolean} bool - Whether or not viewer should update even when still
     * @returns {Viewer} `this`
     */


    this.setUpdate = function (bool) {
      update = bool === true;
      if (renderer === undefined$1) onImageLoad();else animateInit();
      return this;
    };
    /**
     * Calculate panorama pitch and yaw from location of mouse event.
     * @memberof Viewer
     * @instance
     * @param {MouseEvent} event - Document mouse down event.
     * @returns {number[]} [pitch, yaw]
     */


    this.mouseEventToCoords = function (event) {
      return mouseEventToCoords(event);
    };
    /**
     * Change scene being viewed.
     * @memberof Viewer
     * @instance
     * @param {string} sceneId - Identifier of scene to switch to.
     * @param {number} [pitch] - Pitch to use with new scene
     * @param {number} [yaw] - Yaw to use with new scene
     * @param {number} [hfov] - HFOV to use with new scene
     * @returns {Viewer} `this`
     */


    this.loadScene = function (sceneId, pitch, yaw, hfov) {
      if (loaded !== false) loadScene(sceneId, pitch, yaw, hfov);
      return this;
    };
    /**
     * Get ID of current scene.
     * @memberof Viewer
     * @instance
     * @returns {string} ID of current scene
     */


    this.getScene = function () {
      return config.scene;
    };
    /**
     * Add a new scene.
     * @memberof Viewer
     * @instance
     * @param {string} sceneId - The ID of the new scene
     * @param {string} config - The configuration of the new scene
     * @returns {Viewer} `this`
     */


    this.addScene = function (sceneId, config) {
      initialConfig.scenes[sceneId] = config;
      return this;
    };
    /**
     * Remove a scene.
     * @memberof Viewer
     * @instance
     * @param {string} sceneId - The ID of the scene
     * @returns {boolean} False if the scene is the current scene or if the scene doesn't exists, else true
     */


    this.removeScene = function (sceneId) {
      if (config.scene === sceneId || !initialConfig.scenes.hasOwnProperty(sceneId)) return false;
      delete initialConfig.scenes[sceneId];
      return true;
    };
    /**
     * Toggle fullscreen.
     * @memberof Viewer
     * @instance
     * @returns {Viewer} `this`
     */


    this.toggleFullscreen = function () {
      toggleFullscreen();
      return this;
    };
    /**
     * Get configuration of current scene.
     * @memberof Viewer
     * @instance
     * @returns {Object} Configuration of current scene
     */


    this.getConfig = function () {
      return config;
    };
    /**
     * Get viewer's container element.
     * @memberof Viewer
     * @instance
     * @returns {HTMLElement} Container `div` element
     */


    this.getContainer = function () {
      return container;
    };
    /**
     * Add a new hot spot.
     * @memberof Viewer
     * @instance
     * @param {Object} hs - The configuration for the hot spot
     * @param {string} [sceneId] - Adds hot spot to specified scene if provided, else to current scene
     * @returns {Viewer} `this`
     * @throws Throws an error if the scene ID is provided but invalid
     */


    this.addHotSpot = function (hs, sceneId) {
      if (sceneId === undefined$1 && config.scene === undefined$1) {
        // Not a tour
        config.hotSpots.push(hs);
      } else {
        // Tour
        var id = sceneId !== undefined$1 ? sceneId : config.scene;

        if (initialConfig.scenes.hasOwnProperty(id)) {
          if (!initialConfig.scenes[id].hasOwnProperty("hotSpots")) {
            initialConfig.scenes[id].hotSpots = []; // Create hot spots array if needed

            if (id == config.scene) config.hotSpots = initialConfig.scenes[id].hotSpots; // Link to current config
          }

          initialConfig.scenes[id].hotSpots.push(hs); // Add hot spot to config
        } else {
          throw "Invalid scene ID!";
        }
      }

      if (sceneId === undefined$1 || config.scene == sceneId) {
        // Add to current scene
        createHotSpot(hs);
        if (loaded) renderHotSpot(hs);
      }

      return this;
    };
    /**
     * Remove a hot spot.
     * @memberof Viewer
     * @instance
     * @param {string} hotSpotId - The ID of the hot spot
     * @param {string} [sceneId] - Removes hot spot from specified scene if provided, else from current scene
     * @returns {boolean} True if deletion is successful, else false
     */


    this.removeHotSpot = function (hotSpotId, sceneId) {
      if (sceneId === undefined$1 || config.scene == sceneId) {
        if (!config.hotSpots) return false;

        for (var i = 0; i < config.hotSpots.length; i++) {
          if (config.hotSpots[i].hasOwnProperty("id") && config.hotSpots[i].id === hotSpotId) {
            // Delete hot spot DOM elements
            var current = config.hotSpots[i].div;

            while (current.parentNode != renderContainer) {
              current = current.parentNode;
            }

            renderContainer.removeChild(current);
            delete config.hotSpots[i].div; // Remove hot spot from configuration

            config.hotSpots.splice(i, 1);
            return true;
          }
        }
      } else {
        if (initialConfig.scenes.hasOwnProperty(sceneId)) {
          if (!initialConfig.scenes[sceneId].hasOwnProperty("hotSpots")) return false;

          for (var j = 0; j < initialConfig.scenes[sceneId].hotSpots.length; j++) {
            if (initialConfig.scenes[sceneId].hotSpots[j].hasOwnProperty("id") && initialConfig.scenes[sceneId].hotSpots[j].id === hotSpotId) {
              // Remove hot spot from configuration
              initialConfig.scenes[sceneId].hotSpots.splice(j, 1);
              return true;
            }
          }
        } else {
          return false;
        }
      }
    };
    /**
     * This method should be called if the viewer's container is resized.
     * @memberof Viewer
     * @instance
     */


    this.resize = function () {
      if (renderer) onDocumentResize();
    };
    /**
     * Check if a panorama is loaded.
     * @memberof Viewer
     * @instance
     * @returns {boolean} True if a panorama is loaded, else false
     */


    this.isLoaded = function () {
      return loaded;
    };
    /**
     * Check if device orientation control is supported.
     * @memberof Viewer
     * @instance
     * @returns {boolean} True if supported, else false
     */


    this.isOrientationSupported = function () {
      return orientationSupport || false;
    };
    /**
     * Stop using device orientation.
     * @memberof Viewer
     * @instance
     */


    this.stopOrientation = function () {
      stopOrientation();
    };
    /**
     * Start using device orientation (does nothing if not supported).
     * @memberof Viewer
     * @instance
     */


    this.startOrientation = function () {
      if (orientationSupport) startOrientation();
    };
    /**
     * Check if device orientation control is currently activated.
     * @memberof Viewer
     * @instance
     * @returns {boolean} True if active, else false
     */


    this.isOrientationActive = function () {
      return Boolean(orientation);
    };
    /**
     * Subscribe listener to specified event.
     * @memberof Viewer
     * @instance
     * @param {string} type - Type of event to subscribe to.
     * @param {Function} listener - Listener function to subscribe to event.
     * @returns {Viewer} `this`
     */


    this.on = function (type, listener) {
      externalEventListeners[type] = externalEventListeners[type] || [];
      externalEventListeners[type].push(listener);
      return this;
    };
    /**
     * Remove an event listener (or listeners).
     * @memberof Viewer
     * @param {string} [type] - Type of event to remove listeners from. If not specified, all listeners are removed.
     * @param {Function} [listener] - Listener function to remove. If not specified, all listeners of specified type are removed.
     * @returns {Viewer} `this`
     */


    this.off = function (type, listener) {
      if (!type) {
        // Remove all listeners if type isn't specified
        externalEventListeners = {};
        return this;
      }

      if (listener) {
        var i = externalEventListeners[type].indexOf(listener);

        if (i >= 0) {
          // Remove listener if found
          externalEventListeners[type].splice(i, 1);
        }

        if (externalEventListeners[type].length == 0) {
          // Remove category if empty
          delete externalEventListeners[type];
        }
      } else {
        // Remove category of listeners if listener isn't specified
        delete externalEventListeners[type];
      }

      return this;
    };
    /**
     * Fire listeners attached to specified event.
     * @private
     * @param {string} [type] - Type of event to fire listeners for.
     */


    function fireEvent(type) {
      if (type in externalEventListeners) {
        // Reverse iteration is useful, if event listener is removed inside its definition
        for (var i = externalEventListeners[type].length; i > 0; i--) {
          externalEventListeners[type][externalEventListeners[type].length - i].apply(null, [].slice.call(arguments, 1));
        }
      }
    }
    /**
     * Destructor.
     * @instance
     * @memberof Viewer
     */


    this.destroy = function () {
      destroyed = true;
      clearTimeout(autoRotateStart);
      if (renderer) renderer.destroy();

      if (listenersAdded) {
        document.removeEventListener("mousemove", onDocumentMouseMove, false);
        document.removeEventListener("mouseup", onDocumentMouseUp, false);
        mainContainer.removeEventListener("mozfullscreenchange", onFullScreenChange, false);
        mainContainer.removeEventListener("webkitfullscreenchange", onFullScreenChange, false);
        mainContainer.removeEventListener("msfullscreenchange", onFullScreenChange, false);
        mainContainer.removeEventListener("fullscreenchange", onFullScreenChange, false);
        window.removeEventListener("resize", onDocumentResize, false);
        window.removeEventListener("orientationchange", onDocumentResize, false);
        container.removeEventListener("keydown", onDocumentKeyPress, false);
        container.removeEventListener("keyup", onDocumentKeyUp, false);
        container.removeEventListener("blur", clearKeys, false);
        document.removeEventListener("mouseleave", onDocumentMouseUp, false);
      }

      container.innerHTML = "";
      container.classList.remove("pnlm-container");
    };
  }

  return {
    viewer: function viewer(container, config, onRender) {
      return new Viewer(container, config, onRender);
    }
  };
}( false ? 0 : window, typeof document === "undefined" ? null : document);

var uiText = {
  loadButtonLabel: "Click to<br>Load<br>Panorama",
  noPanoramaError: "No panorama image was specified.",
  fileAccessError: "The file %s could not be accessed.",
  malformedURLError: "There is something wrong with the panorama URL.",
  iOS8WebGLError: "Due to iOS 8's broken WebGL implementation, only progressive encoded JPEGs work for your device (this panorama uses standard encoding).",
  genericWebGLError: "Your browser does not have the necessary WebGL support to display this panorama.",
  textureSizeError: "This panorama is too big for your device! It's %spx wide, but your device only supports images up to %spx wide. Try another device. (If you're the author, try scaling down the image.)",
  unknownError: "Unknown error. Check developer console."
};
var style = {
  width: "600px",
  height: "400px",
  background: "#000000"
};

function myPromise(condition) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var promise = new Promise(function (resolve, reject) {
    if (condition) {
      if (args && Array.isArray(args) && args.length) {
        resolve.apply(void 0, args);
      } else {
        reject("Argruments cannot be empty");
      }
    } else {
      reject("Something when wrong!!!");
    }
  });
  return promise;
}

var constants = {
  uiText: uiText,
  style: style,
  myPromise: myPromise
};

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === "undefined") {
    return;
  }

  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.type = "text/css";

  if (insertAt === "top") {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "\r\n\r\n/* Pannellum 2.4.1, https://github.com/mpetroff/pannellum */\r\n\r\n.pnlm-container {\r\n  margin: 0;\r\n  padding: 0;\r\n  overflow: hidden;\r\n  position: relative;\r\n  cursor: default;\r\n  width: 100%;\r\n  height: 100%;\r\n  font-family: Helvetica, \"Nimbus Sans L\", \"Liberation Sans\", Arial, sans-serif;\r\n  background: #f4f4f4 url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2267%22%20height%3D%22100%22%20viewBox%3D%220%200%2067%20100%22%3E%0A%3Cpath%20stroke%3D%22%23ccc%22%20fill%3D%22none%22%20d%3D%22M33.5%2C50%2C0%2C63%2C33.5%2C75%2C67%2C63%2C33.5%2C50m-33.5-50%2C67%2C25m-0.5%2C0%2C0%2C75m-66.5-75%2C67-25m-33.5%2C75%2C0%2C25m0-100%2C0%2C50%22%2F%3E%0A%3C%2Fsvg%3E%0A') repeat;\r\n  -webkit-user-select: none;\r\n  -khtml-user-select: none;\r\n  -moz-user-select: none;\r\n  -o-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  outline: 0;\r\n  line-height: 1.4;\r\n  contain: content;\r\n}\r\n\r\n.pnlm-container * {\r\n  box-sizing: content-box;\r\n}\r\n\r\n.pnlm-ui {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 1;\r\n}\r\n\r\n.pnlm-grab {\r\n  cursor: grab;\r\n  cursor: url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20height%3D%2226%22%20width%3D%2226%22%3E%0A%3Cpath%20stroke%3D%22%23000%22%20stroke-width%3D%221px%22%20fill%3D%22%23fff%22%20d%3D%22m15.3%2020.5s6.38-6.73%204.64-8.24-3.47%201.01-3.47%201.01%203.61-5.72%201.41-6.49c-2.2-0.769-3.33%204.36-3.33%204.36s0.873-5.76-1.06-5.76-1.58%205.39-1.58%205.39-0.574-4.59-2.18-4.12c-1.61%200.468-0.572%205.51-0.572%205.51s-1.58-4.89-2.93-3.79c-1.35%201.11%200.258%205.25%200.572%206.62%200.836%202.43%202.03%202.94%202.17%205.55%22%2F%3E%0A%3C%2Fsvg%3E%0A') 12 8, default\r\n}\r\n\r\n.pnlm-grabbing {\r\n  cursor: grabbing;\r\n  cursor: url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20height%3D%2226%22%20width%3D%2226%22%3E%0A%3Cpath%20stroke%3D%22%23000%22%20stroke-width%3D%221px%22%20fill%3D%22%23fff%22%20d%3D%22m15.3%2020.5s5.07-5.29%203.77-6.74c-1.31-1.45-2.53%200.14-2.53%200.14s2.74-3.29%200.535-4.06c-2.2-0.769-2.52%201.3-2.52%201.3s0.81-2.13-1.12-2.13-1.52%201.77-1.52%201.77-0.261-1.59-1.87-1.12c-1.61%200.468-0.874%202.17-0.874%202.17s-0.651-1.55-2-0.445c-1.35%201.11-0.68%202.25-0.365%203.62%200.836%202.43%202.03%202.94%202.17%205.55%22%2F%3E%0A%3C%2Fsvg%3E%0A') 12 8, default\r\n}\r\n\r\n.pnlm-sprite {\r\n  background-image: url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2226%22%20height%3D%22208%22%3E%0A%3Ccircle%20fill-opacity%3D%22.78%22%20cy%3D%22117%22%20cx%3D%2213%22%20r%3D%2211%22%20fill%3D%22%23fff%22%2F%3E%0A%3Ccircle%20fill-opacity%3D%22.78%22%20cy%3D%22143%22%20cx%3D%2213%22%20r%3D%2211%22%20fill%3D%22%23fff%22%2F%3E%0A%3Ccircle%20cy%3D%22169%22%20cx%3D%2213%22%20r%3D%227%22%20fill%3D%22none%22%20stroke%3D%22%23000%22%20stroke-width%3D%222%22%2F%3E%0A%3Ccircle%20cy%3D%22195%22%20cx%3D%2213%22%20r%3D%227%22%20fill%3D%22none%22%20stroke%3D%22%23000%22%20stroke-width%3D%222%22%2F%3E%0A%3Ccircle%20cx%3D%2213%22%20cy%3D%22195%22%20r%3D%222.5%22%2F%3E%0A%3Cpath%20d%3D%22m5%2083v6h2v-4h4v-2zm10%200v2h4v4h2v-6zm-5%205v6h6v-6zm-5%205v6h6v-2h-4v-4zm14%200v4h-4v2h6v-6z%22%2F%3E%0A%3Cpath%20d%3D%22m13%20110a7%207%200%200%200%20-7%207%207%207%200%200%200%207%207%207%207%200%200%200%207%20-7%207%207%200%200%200%20-7%20-7zm-1%203h2v2h-2zm0%203h2v5h-2z%22%2F%3E%0A%3Cpath%20d%3D%22m5%2057v6h2v-4h4v-2zm10%200v2h4v4h2v-6zm-10%2010v6h6v-2h-4v-4zm14%200v4h-4v2h6v-6z%22%2F%3E%0A%3Cpath%20d%3D%22m17%2038v2h-8v-2z%22%2F%3E%0A%3Cpath%20d%3D%22m12%209v3h-3v2h3v3h2v-3h3v-2h-3v-3z%22%2F%3E%0A%3Cpath%20d%3D%22m13%20136-6.125%206.125h4.375v7.875h3.5v-7.875h4.375z%22%2F%3E%0A%3Cpath%20d%3D%22m10.428%20173.33v-5.77l5-2.89v5.77zm1-1.73%203-1.73-3.001-1.74z%22%2F%3E%0A%3C%2Fsvg%3E%0A')\r\n}\r\n\r\n.pnlm-container:-moz-full-screen {\r\n  height: 100% !important;\r\n  width: 100% !important;\r\n  position: static !important;\r\n}\r\n.pnlm-container:-webkit-full-screen {\r\n  height: 100% !important;\r\n  width: 100% !important;\r\n  position: static !important;\r\n}\r\n.pnlm-container:-ms-fullscreen {\r\n  height: 100% !important;\r\n  width: 100% !important;\r\n  position: static !important;\r\n}\r\n.pnlm-container:fullscreen {\r\n  height: 100% !important;\r\n  width: 100% !important;\r\n  position: static !important;\r\n}\r\n\r\n.pnlm-render-container {\r\n  cursor: inherit;\r\n\r\n  /* Fix display bug in Safari 7 */\r\n  position: absolute;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.pnlm-controls {\r\n  margin-top: 4px;\r\n  background-color: #fff;\r\n  border: 1px solid #999;\r\n  border-color: rgba(0,0,0,0.4);\r\n  border-radius: 3px;\r\n  cursor: pointer;\r\n  z-index: 2;\r\n  /* Fix Safari fullscreen bug */\r\n  -webkit-transform: translateZ(9999px);\r\n  transform: translateZ(9999px);\r\n}\r\n\r\n.pnlm-control:hover {\r\n  background-color: #f8f8f8;\r\n}\r\n\r\n.pnlm-controls-container {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 4px;\r\n  z-index: 1;\r\n}\r\n\r\n.pnlm-zoom-controls {\r\n  width: 26px;\r\n  height: 52px;\r\n}\r\n\r\n.pnlm-zoom-in {\r\n  width: 100%;\r\n  height: 50%;\r\n  position: absolute;\r\n  top: 0;\r\n  border-radius: 3px 3px 0 0;\r\n}\r\n\r\n.pnlm-zoom-out {\r\n  width: 100%;\r\n  height: 50%;\r\n  position: absolute;\r\n  bottom: 0;\r\n  background-position: 0 -26px;\r\n  border-top: 1px solid #ddd;\r\n  border-top-color: rgba(0,0,0,0.10);\r\n  border-radius: 0 0 3px 3px;\r\n}\r\n\r\n.pnlm-fullscreen-toggle-button, .pnlm-orientation-button, .pnlm-hot-spot-debug-indicator {\r\n  width: 26px;\r\n  height: 26px;\r\n}\r\n\r\n.pnlm-hot-spot-debug-indicator {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 26px;\r\n  height: 26px;\r\n  margin: -13px 0 0 -13px;\r\n  background-color: rgba(255, 255, 255, 0.5);\r\n  border-radius: 13px;\r\n  display: none;\r\n}\r\n\r\n.pnlm-orientation-button-inactive {\r\n  background-position: 0 -156px;\r\n}\r\n\r\n.pnlm-orientation-button-active {\r\n  background-position: 0 -182px;\r\n}\r\n\r\n.pnlm-fullscreen-toggle-button-inactive {\r\n  background-position: 0 -52px;\r\n}\r\n\r\n.pnlm-fullscreen-toggle-button-active {\r\n  background-position: 0 -78px;\r\n}\r\n\r\n.pnlm-panorama-info {\r\n  position: absolute;\r\n  bottom: 4px;\r\n  background-color: rgba(0,0,0,0.7);\r\n  border-radius: 0 3px 3px 0;\r\n  padding-right: 10px;\r\n  color: #fff;\r\n  text-align: left;\r\n  display: none;\r\n  z-index: 2;\r\n  /* Fix Safari fullscreen bug */\r\n  -webkit-transform: translateZ(9999px);\r\n  transform: translateZ(9999px);\r\n}\r\n\r\n.pnlm-title-box {\r\n  position: relative;\r\n  font-size: 20px;\r\n  display: table;\r\n  padding-left: 5px;\r\n  margin-bottom: 3px;\r\n}\r\n\r\n.pnlm-author-box {\r\n  position: relative;\r\n  font-size: 12px;\r\n  display: table;\r\n  padding-left: 5px;\r\n}\r\n\r\n.pnlm-load-box {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 200px;\r\n  height: 150px;\r\n  margin: -75px 0 0 -100px;\r\n  background-color: rgba(0,0,0,0.7);\r\n  border-radius: 3px;\r\n  text-align: center;\r\n  font-size: 20px;\r\n  display: none;\r\n  color: #fff;\r\n}\r\n\r\n.pnlm-load-box p {\r\n  margin: 20px 0;\r\n}\r\n\r\n.pnlm-lbox {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 20px;\r\n  height: 20px;\r\n  margin: -10px 0 0 -10px;\r\n  display: none;\r\n}\r\n\r\n.pnlm-loading {\r\n  animation-duration: 1.5s;\r\n  -webkit-animation-duration: 1.5s;\r\n  animation-name: pnlm-mv;\r\n  -webkit-animation-name: pnlm-mv;\r\n  animation-iteration-count: infinite;\r\n  -webkit-animation-iteration-count: infinite;\r\n  animation-timing-function: linear;\r\n  -webkit-animation-timing-function: linear;\r\n  height: 10px;\r\n  width: 10px;\r\n  background-color: #fff;\r\n  position: relative;\r\n}\r\n\r\n@keyframes pnlm-mv {\r\n  from {left:0;top:0;}\r\n  25% {left:10px;top:0;}\r\n  50% {left:10px;top:10px;}\r\n  75% {left:0;top:10px;}\r\n  to {left:0;top:0;}\r\n}\r\n\r\n@-webkit-keyframes pnlm-mv {\r\n  from {left:0;top:0;}\r\n  25% {left:10px;top:0;}\r\n  50% {left:10px;top:10px;}\r\n  75% {left:0;top:10px;}\r\n  to {left:0;top:0;}\r\n}\r\n\r\n.pnlm-load-button {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 200px;\r\n  height: 100px;\r\n  margin: -50px 0 0 -100px;\r\n  background-color: rgba(0,0,0,.7);\r\n  border-radius: 3px;\r\n  text-align: center;\r\n  font-size: 20px;\r\n  display: table;\r\n  color: #fff;\r\n  cursor: pointer;\r\n}\r\n\r\n.pnlm-load-button:hover {\r\n  background-color: rgba(0,0,0,.8);\r\n}\r\n\r\n.pnlm-load-button p {\r\n  display: table-cell;\r\n  vertical-align: middle;\r\n}\r\n\r\n.pnlm-info-box {\r\n  font-size: 15px;\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 200px;\r\n  height: 150px;\r\n  margin: -75px 0 0 -100px;\r\n  background-color: #000;\r\n  border-radius: 3px;\r\n  display: table;\r\n  text-align: center;\r\n  color: #fff;\r\n  table-layout: fixed;\r\n}\r\n\r\n.pnlm-info-box a, .pnlm-author-box a {\r\n  color: #fff;\r\n  word-wrap: break-word;\r\n  overflow-wrap: break-word;\r\n}\r\n\r\n.pnlm-info-box p {\r\n  display: table-cell;\r\n  vertical-align: middle;\r\n  padding: 0 5px 0 5px;\r\n}\r\n\r\n.pnlm-error-msg {\r\n  display: none;\r\n}\r\n\r\n.pnlm-about-msg {\r\n  font-size: 11px;\r\n  line-height: 11px;\r\n  color: #fff;\r\n  padding: 5px 8px 5px 8px;\r\n  background: rgba(0,0,0,0.7);\r\n  border-radius: 3px;\r\n  position: absolute;\r\n  top: 50px;\r\n  left: 50px;\r\n  display: none;\r\n  opacity: 0;\r\n  -moz-transition: opacity .3s ease-in-out;\r\n  -webkit-transition: opacity .3s ease-in-out;\r\n  -o-transition: opacity .3s ease-in-out;\r\n  -ms-transition: opacity .3s ease-in-out;\r\n  transition: opacity .3s ease-in-out;\r\n  z-index: 1;\r\n}\r\n\r\n.pnlm-about-msg a:link, .pnlm-about-msg a:visited {\r\n  color: #fff;\r\n}\r\n\r\n.pnlm-about-msg a:hover, .pnlm-about-msg a:active {\r\n  color: #eee;\r\n}\r\n\r\n.pnlm-hotspot-base {\r\n  position: absolute;\r\n  visibility: hidden;\r\n  cursor: default;\r\n  vertical-align: middle;\r\n  top: 0;\r\n  z-index: 1;\r\n}\r\n.pnlm-hotspot {\r\n  height: 26px;\r\n  width: 26px;\r\n  border-radius: 13px;\r\n}\r\n.pnlm-hotspot:hover {\r\n  background-color: rgba(255,255,255,0.2);\r\n}\r\n.pnlm-hotspot.pnlm-info {\r\n  background-position: 0 -104px;\r\n}\r\n.pnlm-hotspot.pnlm-scene {\r\n  background-position: 0 -130px;\r\n}\r\n\r\ndiv.pnlm-tooltip span {\r\n  visibility: hidden;\r\n  position: absolute;\r\n  border-radius: 3px;\r\n  background-color: rgba(0,0,0,0.7);\r\n  color: #fff;\r\n  text-align: center;\r\n  max-width: 200px;\r\n  padding: 5px 10px;\r\n  margin-left: -220px;\r\n  cursor: default;\r\n}\r\ndiv.pnlm-tooltip:hover span{\r\n  visibility: visible;\r\n}\r\ndiv.pnlm-tooltip:hover span:after {\r\n  content: '';\r\n  position: absolute;\r\n  width: 0;\r\n  height: 0;\r\n  border-width: 10px;\r\n  border-style: solid;\r\n  border-color: rgba(0,0,0,0.7) transparent transparent transparent;\r\n  bottom: -20px;\r\n  left: -10px;\r\n  margin: 0 50%;\r\n}\r\n\r\n.pnlm-compass {\r\n  position: absolute;\r\n  width: 50px;\r\n  height: 50px;\r\n  right: 4px;\r\n  bottom: 4px;\r\n  border-radius: 25px;\r\n  background-image: url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20height%3D%2250%22%20width%3D%2250%22%3E%0A%3Cpath%20d%3D%22m24.5078%206-3.2578%2018h7.5l-3.25781-18h-0.984376zm-3.2578%2020%203.2578%2018h0.9844l3.2578-18h-7.5zm1.19531%200.9941h5.10938l-2.5547%2014.1075-2.5547-14.1075z%22%2F%3E%0A%3C%2Fsvg%3E%0A');\r\n  cursor: default;\r\n  display: none;\r\n}\r\n\r\n.pnlm-world {\r\n  position: absolute;\r\n  left: 50%;\r\n  top: 50%;\r\n}\r\n.pnlm-face {\r\n  position: absolute;\r\n  -webkit-transform-origin: 0 0 0;\r\n  transform-origin: 0 0 0;\r\n}\r\n\r\n.pnlm-dragfix, .pnlm-preview-img {\r\n  position: absolute;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.pnlm-preview-img {\r\n  background-size: cover;\r\n  background-position: center;\r\n}\r\n\r\n.pnlm-lbar {\r\n  width: 150px;\r\n  margin: 0 auto;\r\n  border: #fff 1px solid;\r\n  height: 6px;\r\n}\r\n\r\n.pnlm-lbar-fill {\r\n  background: #fff;\r\n  height: 100%;\r\n  width: 0;\r\n}\r\n\r\n.pnlm-lmsg {\r\n  font-size: 12px;\r\n}\r\n\r\n.pnlm-fade-img {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n\r\n.pnlm-pointer {\r\n  cursor: pointer;\r\n}\r\n";
styleInject(css_248z);
var myPannellum = null;

var ReactPannellum = /*#__PURE__*/function (_React$Component) {
  _inherits(ReactPannellum, _React$Component);

  var _super = _createSuper(ReactPannellum);

  function ReactPannellum() {
    _classCallCheck(this, ReactPannellum);

    return _super.apply(this, arguments);
  }

  _createClass(ReactPannellum, [{
    key: "initPanalleum",
    value: function initPanalleum() {
      var _this$props = this.props,
          sceneId = _this$props.sceneId,
          config = _this$props.config,
          imageSource = _this$props.imageSource,
          autoRotate = _this$props.autoRotate,
          autoRotateSpeep = _this$props.autoRotateSpeep;
      myPannellum = pannellum.viewer(this.props.id, {
        "default": {
          firstScene: sceneId
        },
        scenes: _defineProperty({}, sceneId, _objectSpread2(_objectSpread2({}, config), {}, {
          imageSource: imageSource
        }))
      }, this.props.onRender);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;

      if (this.props.imageSource) {
        this.initPanalleum();
        this.props.onPanoramaLoaded && myPannellum.on("load", function () {
          return _this.props.onPanoramaLoaded();
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      myPannellum && this.props.onPanoramaLoaded && myPannellum.off("load", this.props.onPanoramaLoaded);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          style = _this$props2.style,
          className = _this$props2.className,
          id = _this$props2.id;
      return /*#__PURE__*/React.createElement("div", {
        id: id,
        style: style,
        className: className
      });
    }
  }], [{
    key: "isLoaded",
    value: function isLoaded() {
      return myPannellum && myPannellum.isLoaded();
    }
  }, {
    key: "getPitch",
    value: function getPitch() {
      return myPannellum && myPannellum.getPitch();
    }
  }, {
    key: "setPitch",
    value: function setPitch(pitch) {
      var animated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
      var callback = arguments.length > 2 ? arguments[2] : undefined;
      var callbackArgs = arguments.length > 3 ? arguments[3] : undefined;

      if (myPannellum) {
        myPannellum.setPitch(pitch, animated, callback, callbackArgs);
      }
    }
  }, {
    key: "getPitchBounds",
    value: function getPitchBounds() {
      return myPannellum && myPannellum.getPitchBounds();
    }
  }, {
    key: "setPitchBounds",
    value: function setPitchBounds(bounds) {
      if (myPannellum) {
        myPannellum.setPitchBounds(bounds);
      }
    }
  }, {
    key: "getYaw",
    value: function getYaw() {
      return myPannellum && myPannellum.getYaw();
    }
  }, {
    key: "setYaw",
    value: function setYaw(yaw) {
      var animated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
      var callback = arguments.length > 2 ? arguments[2] : undefined;
      var callbackArgs = arguments.length > 3 ? arguments[3] : undefined;

      if (myPannellum) {
        myPannellum.setYaw(yaw, animated, callback, callbackArgs);
      }
    }
  }, {
    key: "getYawBounds",
    value: function getYawBounds() {
      return myPannellum && myPannellum.getYawBounds();
    }
  }, {
    key: "setYawBounds",
    value: function setYawBounds(bounds) {
      constants.myPromise(myPannellum, {
        bounds: bounds
      }).then(function (_ref) {
        var bounds = _ref.bounds;
        myPannellum.setYawBounds(bounds);
      })["catch"](function (err) {
        console.log(err);
      });
    }
  }, {
    key: "getHfov",
    value: function getHfov() {
      return myPannellum && myPannellum.getHfov();
    }
  }, {
    key: "setHfov",
    value: function setHfov(hfov) {
      var animated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
      var callback = arguments.length > 2 ? arguments[2] : undefined;
      var callbackArgs = arguments.length > 3 ? arguments[3] : undefined;

      if (myPannellum) {
        myPannellum.setHfov(hfov, animated, callback, callbackArgs);
      }
    }
  }, {
    key: "getHfovBounds",
    value: function getHfovBounds() {
      return myPannellum && myPannellum.getHfovBounds();
    }
  }, {
    key: "setHfovBounds",
    value: function setHfovBounds(bounds) {
      constants.myPromise(myPannellum, {
        bounds: bounds
      }).then(function (_ref2) {
        var bounds = _ref2.bounds;
        myPannellum.setHfovBounds(bounds);
      })["catch"](function (err) {
        console.log(err);
      });
    }
  }, {
    key: "lookAt",
    value: function lookAt(pitch, yaw, hfov) {
      var animated = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000;
      var callback = arguments.length > 4 ? arguments[4] : undefined;
      var callbackArgs = arguments.length > 5 ? arguments[5] : undefined;

      if (myPannellum) {
        myPannellum.lookAt(pitch, yaw, hfov, animated, callback, callbackArgs);
      }
    }
  }, {
    key: "getNorthOffset",
    value: function getNorthOffset() {
      return myPannellum && myPannellum.getNorthOffset();
    }
  }, {
    key: "setNorthOffset",
    value: function setNorthOffset(heading) {
      constants.myPromise(myPannellum, {
        heading: heading
      }).then(function (_ref3) {
        var heading = _ref3.heading;
        myPannellum.setNorthOffset(heading);
      })["catch"](function (err) {
        console.log(err);
      });
    }
  }, {
    key: "getHorizonRoll",
    value: function getHorizonRoll() {
      return myPannellum && myPannellum.getHorizonRoll();
    }
  }, {
    key: "setHorizonRoll",
    value: function setHorizonRoll(roll) {
      constants.myPromise(myPannellum, {
        roll: roll
      }).then(function (_ref4) {
        var roll = _ref4.roll;
        myPannellum.setHorizonRoll(roll);
      })["catch"](function (err) {
        console.log(err);
      });
    }
  }, {
    key: "getHorizonPitch",
    value: function getHorizonPitch() {
      return myPannellum && myPannellum.getHorizonPitch();
    }
  }, {
    key: "setHorizonPitch",
    value: function setHorizonPitch(pitch) {
      constants.myPromise(myPannellum, {
        pitch: pitch
      }).then(function (_ref5) {
        var pitch = _ref5.pitch;
        myPannellum.setHorizonPitch(pitch);
      })["catch"](function (err) {
        console.log(err);
      });
    }
  }, {
    key: "startAutoRotate",
    value: function startAutoRotate(speed, pitch) {
      constants.myPromise(myPannellum, {
        pitch: pitch
      }).then(function (_ref6) {
        var pitch = _ref6.pitch;
        myPannellum.startAutoRotate(speed, pitch);
      })["catch"](function (err) {
        console.log(err);
      });
    }
  }, {
    key: "stopAutoRotate",
    value: function stopAutoRotate() {
      if (myPannellum) {
        myPannellum.stopAutoRotate();
      }
    }
  }, {
    key: "mouseEventToCoords",
    value: function mouseEventToCoords(event) {
      return myPannellum && myPannellum.mouseEventToCoords(event);
    }
  }, {
    key: "addScene",
    value: function addScene(sceneId, config, callback) {
      if (sceneId && config & typeof config === 'object' && Object.keys(config).length) {
        constants.myPromise(myPannellum, {
          sceneId: sceneId,
          config: config,
          callback: callback
        }).then(function (_ref7) {
          var sceneId = _ref7.sceneId,
              config = _ref7.config,
              callback = _ref7.callback;
          myPannellum.addScene(sceneId, config);
          callback && callback();
        })["catch"](function (err) {
          console.log(err);
        });
      } else {
        console.log("sceneId cannot be empty and config.imageSource cannot be empty!!");
      }
    }
  }, {
    key: "getCurrentScene",
    value: function getCurrentScene() {
      return myPannellum && myPannellum.getConfig().scene;
    }
  }, {
    key: "getAllScenes",
    value: function getAllScenes() {
      return myPannellum && myPannellum.getAllScenes();
    }
  }, {
    key: "removeScene",
    value: function removeScene(sceneId, callback) {
      if (sceneId && sceneId !== "") {
        constants.myPromise(myPannellum, {
          sceneId: sceneId
        }).then(function (_ref8) {
          var sceneId = _ref8.sceneId;
          myPannellum.removeScene(sceneId);
          callback && callback();
        })["catch"](function (err) {
          console.log(err);
        });
      } else {
        console.log("sceneId cannot be empty");
      }
    }
  }, {
    key: "loadScene",
    value: function loadScene(sceneId, targetPitch, targetYaw, targetHfov, fadeDone) {
      if (myPannellum && sceneId && sceneId !== "") {
        myPannellum.loadScene(sceneId, targetPitch, targetYaw, targetHfov, fadeDone);
      }
    }
  }, {
    key: "toggleFullscreen",
    value: function toggleFullscreen() {
      return myPannellum && myPannellum.toggleFullscreen();
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      return myPannellum && myPannellum.getConfig();
    }
  }, {
    key: "getContainer",
    value: function getContainer() {
      return myPannellum && myPannellum.getContainer();
    }
  }, {
    key: "addHotSpot",
    value: function addHotSpot(hotspot, sceneId) {
      if (hotspot && typeof hotspot === 'object' && Object.keys(hotspot).length) {
        constants.myPromise(myPannellum, {
          hotspot: hotspot,
          sceneId: sceneId
        }).then(function (_ref9) {
          var hotspot = _ref9.hotspot,
              sceneId = _ref9.sceneId;
          myPannellum.addHotSpot(hotspot, sceneId);
        })["catch"](function (err) {
          console.log(err);
        });
      } else {
        console.log("hotspot cannot be empty, please check hotspot elements needed in document: config props `hotSpots`.");
      }
    }
  }, {
    key: "removeHotSpot",
    value: function removeHotSpot(hotSpotId, sceneId) {
      if (hotSpotId !== "") {
        constants.myPromise(myPannellum, {
          hotSpotId: hotSpotId,
          sceneId: sceneId
        }).then(function (_ref10) {
          var hotSpotId = _ref10.hotSpotId,
              sceneId = _ref10.sceneId;
          myPannellum.removeHotSpot(hotSpotId, sceneId);
        })["catch"](function (err) {
          console.log(err);
        });
      } else {
        console.log("hotspotId cannot be empty!!");
      }
    }
  }]);

  return ReactPannellum;
}(React.Component);

ReactPannellum.defaultProps = {
  className: "",
  style: _objectSpread2({}, constants.style),
  config: {
    autoLoad: false,
    autoRotate: 0,
    autoRotateInactivityDelay: 0,
    autoRotateStopDelay: 0,
    preview: "",
    uiText: _objectSpread2({}, constants.uiText),
    showZoomCtrl: true,
    keyboardZoom: true,
    mouseZoom: true,
    doubleClickZoom: false,
    draggable: true,
    disableKeyboardCtrl: false,
    showFullscreenCtrl: true,
    showControls: true,
    yaw: 0,
    pitch: 0,
    maxPitch: 90,
    minPitch: -90,
    maxYaw: 180,
    minYaw: -180,
    hfov: 100,
    compass: false,
    northOffset: 0,
    hotSpots: [],
    hotSpotDebug: false
  }
};
var addScene = ReactPannellum.addScene;
var getCurrentScene = ReactPannellum.getCurrentScene;
var getAllScenes = ReactPannellum.getAllScenes;
var removeScene = ReactPannellum.removeScene;
var loadScene = ReactPannellum.loadScene;
var isLoaded = ReactPannellum.isLoaded;
var getPitch = ReactPannellum.getPitch;
var setPitch = ReactPannellum.setPitch;
var getPitchBounds = ReactPannellum.getPitchBounds;
var setPitchBounds = ReactPannellum.setPitchBounds;
var getYaw = ReactPannellum.getYaw;
var setYaw = ReactPannellum.setYaw;
var getYawBounds = ReactPannellum.getYawBounds;
var setYawBounds = ReactPannellum.setYawBounds;
var getHfov = ReactPannellum.getHfov;
var setHfov = ReactPannellum.setHfov;
var getHfovBounds = ReactPannellum.getHfovBounds;
var setHfovBounds = ReactPannellum.setHfovBounds;
var lookAt = ReactPannellum.lookAt;
var getNorthOffset = ReactPannellum.getNorthOffset;
var setNorthOffset = ReactPannellum.setNorthOffset;
var getHorizonRoll = ReactPannellum.getHorizonRoll;
var setHorizonRoll = ReactPannellum.setHorizonRoll;
var getHorizonPitch = ReactPannellum.getHorizonPitch;
var setHorizonPitch = ReactPannellum.setHorizonPitch;
var startAutoRotate = ReactPannellum.startAutoRotate;
var stopAutoRotate = ReactPannellum.stopAutoRotate;
var mouseEventToCoords = ReactPannellum.mouseEventToCoords;
var toggleFullscreen = ReactPannellum.toggleFullscreen;
var getConfig = ReactPannellum.getConfig;
var getContainer = ReactPannellum.getContainer;
var addHotSpot = ReactPannellum.addHotSpot;
var removeHotSpot = ReactPannellum.removeHotSpot;
__webpack_unused_export__ = addHotSpot;
__webpack_unused_export__ = addScene;
exports.ZP = ReactPannellum;
__webpack_unused_export__ = getAllScenes;
exports.iE = getConfig;
__webpack_unused_export__ = getContainer;
__webpack_unused_export__ = getCurrentScene;
__webpack_unused_export__ = getHfov;
__webpack_unused_export__ = getHfovBounds;
__webpack_unused_export__ = getHorizonPitch;
__webpack_unused_export__ = getHorizonRoll;
__webpack_unused_export__ = getNorthOffset;
__webpack_unused_export__ = getPitch;
__webpack_unused_export__ = getPitchBounds;
__webpack_unused_export__ = getYaw;
__webpack_unused_export__ = getYawBounds;
__webpack_unused_export__ = isLoaded;
__webpack_unused_export__ = loadScene;
__webpack_unused_export__ = lookAt;
__webpack_unused_export__ = mouseEventToCoords;
__webpack_unused_export__ = removeHotSpot;
__webpack_unused_export__ = removeScene;
__webpack_unused_export__ = setHfov;
__webpack_unused_export__ = setHfovBounds;
__webpack_unused_export__ = setHorizonPitch;
__webpack_unused_export__ = setHorizonRoll;
__webpack_unused_export__ = setNorthOffset;
__webpack_unused_export__ = setPitch;
__webpack_unused_export__ = setPitchBounds;
exports.X3 = setYaw;
__webpack_unused_export__ = setYawBounds;
__webpack_unused_export__ = startAutoRotate;
__webpack_unused_export__ = stopAutoRotate;
__webpack_unused_export__ = toggleFullscreen;

/***/ }),

/***/ 65235:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ''));

function getDomainLocale(path, locale, locales, domainLocales) {
  if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
    return false;
  }
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 29938:
/***/ (function(module, exports, __webpack_require__) {

"use client";
"use strict";

var _slicedToArray = __webpack_require__(85696);

var _toConsumableArray = __webpack_require__(7980);

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = Image;

var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);

var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(67294));

var _head = _interop_require_default(__webpack_require__(16505));

var _imageBlurSvg = __webpack_require__(27675);

var _imageConfig = __webpack_require__(35980);

var _imageConfigContext = __webpack_require__(11059);

var _warnOnce = __webpack_require__(92783);

var _imageLoader = _interop_require_default(__webpack_require__(81923));

function Image(_param) {
  var src = _param.src,
      sizes = _param.sizes,
      _param$unoptimized = _param.unoptimized,
      unoptimized = _param$unoptimized === void 0 ? false : _param$unoptimized,
      _param$priority = _param.priority,
      priority = _param$priority === void 0 ? false : _param$priority,
      loading = _param.loading,
      className = _param.className,
      quality = _param.quality,
      width = _param.width,
      height = _param.height,
      fill = _param.fill,
      style = _param.style,
      onLoad = _param.onLoad,
      onLoadingComplete = _param.onLoadingComplete,
      _param$placeholder = _param.placeholder,
      placeholder = _param$placeholder === void 0 ? 'empty' : _param$placeholder,
      blurDataURL = _param.blurDataURL,
      layout = _param.layout,
      objectFit = _param.objectFit,
      objectPosition = _param.objectPosition,
      lazyBoundary = _param.lazyBoundary,
      lazyRoot = _param.lazyRoot,
      all = _object_without_properties_loose(_param, ["src", "sizes", "unoptimized", "priority", "loading", "className", "quality", "width", "height", "fill", "style", "onLoad", "onLoadingComplete", "placeholder", "blurDataURL", "layout", "objectFit", "objectPosition", "lazyBoundary", "lazyRoot"]);

  var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
  var config = (0, _react).useMemo(function () {
    var c = configEnv || configContext || _imageConfig.imageConfigDefault;
    var allSizes = [].concat(_toConsumableArray(c.deviceSizes), _toConsumableArray(c.imageSizes)).sort(function (a, b) {
      return a - b;
    });
    var deviceSizes = c.deviceSizes.sort(function (a, b) {
      return a - b;
    });
    return _extends({}, c, {
      allSizes: allSizes,
      deviceSizes: deviceSizes
    });
  }, [configContext]);
  var rest = all;
  var loader = rest.loader || _imageLoader["default"]; // Remove property so it's not spread on <img> element

  delete rest.loader;

  if ('__next_img_default' in loader) {
    // This special value indicates that the user
    // didn't define a "loader" prop or config.
    if (config.loader === 'custom') {
      throw new Error("Image with src \"".concat(src, "\" is missing \"loader\" prop.") + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
    }
  } else {
    // The user defined a "loader" prop or config.
    // Since the config object is internal only, we
    // must not pass it to the user-defined "loader".
    var customImageLoader = loader;

    var _tmp;

    _tmp = function _tmp(obj) {
      var _ = obj.config,
          opts = _object_without_properties_loose(obj, ["config"]);

      return customImageLoader(opts);
    }, loader = _tmp, _tmp;
  }

  if (layout) {
    if (layout === 'fill') {
      fill = true;
    }

    var layoutToStyle = {
      intrinsic: {
        maxWidth: '100%',
        height: 'auto'
      },
      responsive: {
        width: '100%',
        height: 'auto'
      }
    };
    var layoutToSizes = {
      responsive: '100vw',
      fill: '100vw'
    };
    var layoutStyle = layoutToStyle[layout];

    if (layoutStyle) {
      style = _extends({}, style, layoutStyle);
    }

    var layoutSizes = layoutToSizes[layout];

    if (layoutSizes && !sizes) {
      sizes = layoutSizes;
    }
  }

  var staticSrc = '';
  var widthInt = getInt(width);
  var heightInt = getInt(height);
  var blurWidth;
  var blurHeight;

  if (isStaticImport(src)) {
    var staticImageData = isStaticRequire(src) ? src["default"] : src;

    if (!staticImageData.src) {
      throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
    }

    if (!staticImageData.height || !staticImageData.width) {
      throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
    }

    blurWidth = staticImageData.blurWidth;
    blurHeight = staticImageData.blurHeight;
    blurDataURL = blurDataURL || staticImageData.blurDataURL;
    staticSrc = staticImageData.src;

    if (!fill) {
      if (!widthInt && !heightInt) {
        widthInt = staticImageData.width;
        heightInt = staticImageData.height;
      } else if (widthInt && !heightInt) {
        var ratio = widthInt / staticImageData.width;
        heightInt = Math.round(staticImageData.height * ratio);
      } else if (!widthInt && heightInt) {
        var _ratio = heightInt / staticImageData.height;

        widthInt = Math.round(staticImageData.width * _ratio);
      }
    }
  }

  src = typeof src === 'string' ? src : staticSrc;
  var isLazy = !priority && (loading === 'lazy' || typeof loading === 'undefined');

  if (src.startsWith('data:') || src.startsWith('blob:')) {
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
    unoptimized = true;
    isLazy = false;
  }

  if (config.unoptimized) {
    unoptimized = true;
  }

  var _useState = (0, _react).useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      blurComplete = _useState2[0],
      setBlurComplete = _useState2[1];

  var _useState3 = (0, _react).useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showAltText = _useState4[0],
      setShowAltText = _useState4[1];

  var qualityInt = getInt(quality);

  if (false) { var _Object$entries$_i, legacyKey, legacyValue, _i, _Object$entries, url, urlStr, VALID_BLUR_EXT; }

  var imgStyle = Object.assign(fill ? {
    position: 'absolute',
    height: '100%',
    width: '100%',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    objectFit: objectFit,
    objectPosition: objectPosition
  } : {}, showAltText ? {} : {
    color: 'transparent'
  }, style);
  var blurStyle = placeholder === 'blur' && blurDataURL && !blurComplete ? {
    backgroundSize: imgStyle.objectFit || 'cover',
    backgroundPosition: imgStyle.objectPosition || '50% 50%',
    backgroundRepeat: 'no-repeat',
    backgroundImage: "url(\"data:image/svg+xml;charset=utf-8,".concat((0, _imageBlurSvg).getImageBlurSvg({
      widthInt: widthInt,
      heightInt: heightInt,
      blurWidth: blurWidth,
      blurHeight: blurHeight,
      blurDataURL: blurDataURL
    }), "\")")
  } : {};

  if (false) {}

  var imgAttributes = generateImgAttrs({
    config: config,
    src: src,
    unoptimized: unoptimized,
    width: widthInt,
    quality: qualityInt,
    sizes: sizes,
    loader: loader
  });
  var srcString = src;

  if (false) { var fullUrl; }

  var linkProps = {
    // @ts-expect-error upgrade react types to react 18
    imageSrcSet: imgAttributes.srcSet,
    imageSizes: imgAttributes.sizes,
    crossOrigin: rest.crossOrigin
  };
  var onLoadRef = (0, _react).useRef(onLoad);
  (0, _react).useEffect(function () {
    onLoadRef.current = onLoad;
  }, [onLoad]);
  var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
  (0, _react).useEffect(function () {
    onLoadingCompleteRef.current = onLoadingComplete;
  }, [onLoadingComplete]);

  var imgElementArgs = _extends({
    isLazy: isLazy,
    imgAttributes: imgAttributes,
    heightInt: heightInt,
    widthInt: widthInt,
    qualityInt: qualityInt,
    className: className,
    imgStyle: imgStyle,
    blurStyle: blurStyle,
    loading: loading,
    config: config,
    fill: fill,
    unoptimized: unoptimized,
    placeholder: placeholder,
    loader: loader,
    srcString: srcString,
    onLoadRef: onLoadRef,
    onLoadingCompleteRef: onLoadingCompleteRef,
    setBlurComplete: setBlurComplete,
    setShowAltText: setShowAltText
  }, rest);

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(ImageElement, Object.assign({}, imgElementArgs)), priority ? // Note how we omit the `href` attribute, as it would only be relevant
  // for browsers that do not support `imagesrcset`, and in those cases
  // it would likely cause the incorrect image to be preloaded.
  //
  // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset

  /*#__PURE__*/
  _react["default"].createElement(_head["default"], null, /*#__PURE__*/_react["default"].createElement("link", Object.assign({
    key: '__nimg-' + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
    rel: "preload",
    as: "image",
    href: imgAttributes.srcSet ? undefined : imgAttributes.src
  }, linkProps))) : null);
}

'use client';
var configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","dangerouslyAllowSVG":false,"unoptimized":false};
var allImgs = new Map();
var perfObserver;

if (false) {}

var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && (['lazy', 'eager', undefined]));

function isStaticRequire(src) {
  return src["default"] !== undefined;
}

function isStaticImageData(src) {
  return src.src !== undefined;
}

function isStaticImport(src) {
  return typeof src === 'object' && (isStaticRequire(src) || isStaticImageData(src));
}

function getWidths(_ref, width, sizes) {
  var deviceSizes = _ref.deviceSizes,
      allSizes = _ref.allSizes;

  if (sizes) {
    // Find all the "vw" percent sizes used in the sizes prop
    var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
    var percentSizes = [];

    for (var match; match = viewportWidthRe.exec(sizes); match) {
      percentSizes.push(parseInt(match[2]));
    }

    if (percentSizes.length) {
      var smallestRatio = Math.min.apply(Math, percentSizes) * 0.01;
      return {
        widths: allSizes.filter(function (s) {
          return s >= deviceSizes[0] * smallestRatio;
        }),
        kind: 'w'
      };
    }

    return {
      widths: allSizes,
      kind: 'w'
    };
  }

  if (typeof width !== 'number') {
    return {
      widths: deviceSizes,
      kind: 'w'
    };
  }

  var widths = _toConsumableArray(new Set( // > This means that most OLED screens that say they are 3x resolution,
  // > are actually 3x in the green color, but only 1.5x in the red and
  // > blue colors. Showing a 3x resolution image in the app vs a 2x
  // > resolution image will be visually the same, though the 3x image
  // > takes significantly more data. Even true 3x resolution screens are
  // > wasteful as the human eye cannot see that level of detail without
  // > something like a magnifying glass.
  // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
  [width, width * 2
  /*, width * 3*/
  ].map(function (w) {
    return allSizes.find(function (p) {
      return p >= w;
    }) || allSizes[allSizes.length - 1];
  })));

  return {
    widths: widths,
    kind: 'x'
  };
}

function generateImgAttrs(_ref2) {
  var config = _ref2.config,
      src = _ref2.src,
      unoptimized = _ref2.unoptimized,
      width = _ref2.width,
      quality = _ref2.quality,
      sizes = _ref2.sizes,
      loader = _ref2.loader;

  if (unoptimized) {
    return {
      src: src,
      srcSet: undefined,
      sizes: undefined
    };
  }

  var _getWidths = getWidths(config, width, sizes),
      widths = _getWidths.widths,
      kind = _getWidths.kind;

  var last = widths.length - 1;
  return {
    sizes: !sizes && kind === 'w' ? '100vw' : sizes,
    srcSet: widths.map(function (w, i) {
      return "".concat(loader({
        config: config,
        src: src,
        quality: quality,
        width: w
      }), " ").concat(kind === 'w' ? w : i + 1).concat(kind);
    }).join(', '),
    // It's intended to keep `src` the last attribute because React updates
    // attributes in order. If we keep `src` the first one, Safari will
    // immediately start to fetch `src`, before `sizes` and `srcSet` are even
    // updated by React. That causes multiple unnecessary requests if `srcSet`
    // and `sizes` are defined.
    // This bug cannot be reproduced in Chrome or Firefox.
    src: loader({
      config: config,
      src: src,
      quality: quality,
      width: widths[last]
    })
  };
}

function getInt(x) {
  if (typeof x === 'number' || typeof x === 'undefined') {
    return x;
  }

  if (typeof x === 'string' && /^[0-9]+$/.test(x)) {
    return parseInt(x, 10);
  }

  return NaN;
} // See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.


function handleLoading(img, src, placeholder, onLoadRef, onLoadingCompleteRef, setBlurComplete, unoptimized) {
  if (!img || img['data-loaded-src'] === src) {
    return;
  }

  img['data-loaded-src'] = src;
  var p = 'decode' in img ? img.decode() : Promise.resolve();
  p["catch"](function () {}).then(function () {
    if (!img.parentNode) {
      // Exit early in case of race condition:
      // - onload() is called
      // - decode() is called but incomplete
      // - unmount is called
      // - decode() completes
      return;
    }

    if (placeholder === 'blur') {
      setBlurComplete(true);
    }

    if (onLoadRef == null ? void 0 : onLoadRef.current) {
      // Since we don't have the SyntheticEvent here,
      // we must create one with the same shape.
      // See https://reactjs.org/docs/events.html
      var event = new Event('load');
      Object.defineProperty(event, 'target', {
        writable: false,
        value: img
      });
      var prevented = false;
      var stopped = false;
      onLoadRef.current(_extends({}, event, {
        nativeEvent: event,
        currentTarget: img,
        target: img,
        isDefaultPrevented: function isDefaultPrevented() {
          return prevented;
        },
        isPropagationStopped: function isPropagationStopped() {
          return stopped;
        },
        persist: function persist() {},
        preventDefault: function preventDefault() {
          prevented = true;
          event.preventDefault();
        },
        stopPropagation: function stopPropagation() {
          stopped = true;
          event.stopPropagation();
        }
      }));
    }

    if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
      onLoadingCompleteRef.current(img);
    }

    if (false) { var widthModified, heightModified, valid, _window$getComputedSt, position, widthViewportRatio; }
  });
}

var ImageElement = function ImageElement(_param) {
  var imgAttributes = _param.imgAttributes,
      heightInt = _param.heightInt,
      widthInt = _param.widthInt,
      qualityInt = _param.qualityInt,
      className = _param.className,
      imgStyle = _param.imgStyle,
      blurStyle = _param.blurStyle,
      isLazy = _param.isLazy,
      fill = _param.fill,
      placeholder = _param.placeholder,
      loading = _param.loading,
      srcString = _param.srcString,
      config = _param.config,
      unoptimized = _param.unoptimized,
      loader = _param.loader,
      onLoadRef = _param.onLoadRef,
      onLoadingCompleteRef = _param.onLoadingCompleteRef,
      setBlurComplete = _param.setBlurComplete,
      setShowAltText = _param.setShowAltText,
      onLoad = _param.onLoad,
      _onError = _param.onError,
      rest = _object_without_properties_loose(_param, ["imgAttributes", "heightInt", "widthInt", "qualityInt", "className", "imgStyle", "blurStyle", "isLazy", "fill", "placeholder", "loading", "srcString", "config", "unoptimized", "loader", "onLoadRef", "onLoadingCompleteRef", "setBlurComplete", "setShowAltText", "onLoad", "onError"]);

  loading = isLazy ? 'lazy' : loading;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("img", Object.assign({}, rest, imgAttributes, {
    width: widthInt,
    height: heightInt,
    decoding: "async",
    "data-nimg": fill ? 'fill' : '1',
    className: className,
    // @ts-ignore - TODO: upgrade to `@types/react@17`
    loading: loading,
    style: _extends({}, imgStyle, blurStyle),
    ref: (0, _react).useCallback(function (img) {
      if (!img) {
        return;
      }

      if (_onError) {
        // If the image has an error before react hydrates, then the error is lost.
        // The workaround is to wait until the image is mounted which is after hydration,
        // then we set the src again to trigger the error handler (if there was an error).
        // eslint-disable-next-line no-self-assign
        img.src = img.src;
      }

      if (false) {}

      if (img.complete) {
        handleLoading(img, srcString, placeholder, onLoadRef, onLoadingCompleteRef, setBlurComplete, unoptimized);
      }
    }, [srcString, placeholder, onLoadRef, onLoadingCompleteRef, setBlurComplete, _onError, unoptimized]),
    onLoad: function onLoad(event) {
      var img = event.currentTarget;
      handleLoading(img, srcString, placeholder, onLoadRef, onLoadingCompleteRef, setBlurComplete, unoptimized);
    },
    onError: function onError(event) {
      // if the real image fails to load, this will ensure "alt" is visible
      setShowAltText(true);

      if (placeholder === 'blur') {
        // If the real image fails to load, this will still remove the placeholder.
        setBlurComplete(true);
      }

      if (_onError) {
        _onError(event);
      }
    }
  })));
};

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 77913:
/***/ (function(module, exports, __webpack_require__) {

"use client";
"use strict";

var _slicedToArray = __webpack_require__(85696);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var _router = __webpack_require__(12199);

var _formatUrl = __webpack_require__(17389);

var _addLocale = __webpack_require__(51630);

var _routerContext = __webpack_require__(59541);

var _appRouterContext = __webpack_require__(6163);

var _useIntersection = __webpack_require__(27215);

var _getDomainLocale = __webpack_require__(65235);

var _addBasePath = __webpack_require__(70729);

'use client';
var prefetched = new Set();

function prefetch(router, href, as, options) {
  if (false) {}

  if (!(0, _router).isLocalURL(href)) {
    return;
  } // We should only dedupe requests when experimental.optimisticClientCache is
  // disabled.


  if (!options.bypassPrefetchedCheck) {
    var locale = // Let the link's locale prop override the default router locale.
    typeof options.locale !== 'undefined' ? options.locale : 'locale' in router ? router.locale : undefined;
    var prefetchedKey = href + '%' + as + '%' + locale; // If we've already fetched the key, then don't prefetch it again!

    if (prefetched.has(prefetchedKey)) {
      return;
    } // Mark this URL as prefetched.


    prefetched.add(prefetchedKey);
  } // Prefetch the JSON page if asked (only in the client)
  // We need to handle a prefetch error here since we may be
  // loading with priority which can reject but we don't
  // want to force navigation since this is only a prefetch


  Promise.resolve(router.prefetch(href, as, options))["catch"](function (err) {
    if (false) {}
  });
}

function isModifiedEvent(event) {
  var target = event.currentTarget.target;
  return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}

function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
  var nodeName = e.currentTarget.nodeName; // anchors inside an svg have a lowercase nodeName

  var isAnchorNodeName = nodeName.toUpperCase() === 'A';

  if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
    // ignore click for browser’s default behavior
    return;
  }

  e.preventDefault();

  var navigate = function navigate() {
    // If the router is an NextRouter instance it will have `beforePopState`
    if ('beforePopState' in router) {
      router[replace ? 'replace' : 'push'](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
      });
    } else {
      router[replace ? 'replace' : 'push'](as || href, {
        forceOptimisticNavigation: !prefetchEnabled
      });
    }
  };

  if (isAppRouter) {
    // @ts-expect-error startTransition exists.
    _react["default"].startTransition(navigate);
  } else {
    navigate();
  }
}

function formatStringOrUrl(urlObjOrString) {
  if (typeof urlObjOrString === 'string') {
    return urlObjOrString;
  }

  return (0, _formatUrl).formatUrl(urlObjOrString);
}
/**
 * React Component that enables client-side transitions between routes.
 */


var Link = /*#__PURE__*/_react["default"].forwardRef(function LinkComponent(props, forwardedRef) {
  if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }

  var children;

  var hrefProp = props.href,
      asProp = props.as,
      childrenProp = props.children,
      prefetchProp = props.prefetch,
      passHref = props.passHref,
      replace = props.replace,
      shallow = props.shallow,
      scroll = props.scroll,
      locale = props.locale,
      _onClick = props.onClick,
      onMouseEnterProp = props.onMouseEnter,
      onTouchStartProp = props.onTouchStart,
      _props$legacyBehavior = props.legacyBehavior,
      legacyBehavior = _props$legacyBehavior === void 0 ? Boolean(true) !== true : _props$legacyBehavior,
      restProps = _object_without_properties_loose(props, ["href", "as", "children", "prefetch", "passHref", "replace", "shallow", "scroll", "locale", "onClick", "onMouseEnter", "onTouchStart", "legacyBehavior"]);

  children = childrenProp;

  if (legacyBehavior && (typeof children === 'string' || typeof children === 'number')) {
    children = /*#__PURE__*/_react["default"].createElement("a", null, children);
  }

  var prefetchEnabled = prefetchProp !== false;

  var pagesRouter = _react["default"].useContext(_routerContext.RouterContext);

  var appRouter = _react["default"].useContext(_appRouterContext.AppRouterContext);

  var router = pagesRouter != null ? pagesRouter : appRouter; // We're in the app directory if there is no pages router.

  var isAppRouter = !pagesRouter;

  var _react$default$useMem = _react["default"].useMemo(function () {
    if (!pagesRouter) {
      var _resolvedHref = formatStringOrUrl(hrefProp);

      return {
        href: _resolvedHref,
        as: asProp ? formatStringOrUrl(asProp) : _resolvedHref
      };
    }

    var _resolveHref = (0, _router).resolveHref(pagesRouter, hrefProp, true),
        _resolveHref2 = _slicedToArray(_resolveHref, 2),
        resolvedHref = _resolveHref2[0],
        resolvedAs = _resolveHref2[1];

    return {
      href: resolvedHref,
      as: asProp ? (0, _router).resolveHref(pagesRouter, asProp) : resolvedAs || resolvedHref
    };
  }, [pagesRouter, hrefProp, asProp]),
      href = _react$default$useMem.href,
      as = _react$default$useMem.as;

  var previousHref = _react["default"].useRef(href);

  var previousAs = _react["default"].useRef(as); // This will return the first child, if multiple are provided it will throw an error


  var child;

  if (legacyBehavior) {
    if (false) {} else {
      child = _react["default"].Children.only(children);
    }
  } else {
    if (false) { var ref; }
  }

  var childRef = legacyBehavior ? child && typeof child === 'object' && child.ref : forwardedRef;

  var _useIntersection2 = (0, _useIntersection).useIntersection({
    rootMargin: '200px'
  }),
      _useIntersection3 = _slicedToArray(_useIntersection2, 3),
      setIntersectionRef = _useIntersection3[0],
      isVisible = _useIntersection3[1],
      resetVisible = _useIntersection3[2];

  var setRef = _react["default"].useCallback(function (el) {
    // Before the link getting observed, check if visible state need to be reset
    if (previousAs.current !== as || previousHref.current !== href) {
      resetVisible();
      previousAs.current = as;
      previousHref.current = href;
    }

    setIntersectionRef(el);

    if (childRef) {
      if (typeof childRef === 'function') childRef(el);else if (typeof childRef === 'object') {
        childRef.current = el;
      }
    }
  }, [as, childRef, href, resetVisible, setIntersectionRef]); // Prefetch the URL if we haven't already and it's visible.


  _react["default"].useEffect(function () {
    if (!router) {
      return;
    } // If we don't need to prefetch the URL, don't do prefetch.


    if (!isVisible || !prefetchEnabled) {
      return;
    } // Prefetch the URL.


    prefetch(router, href, as, {
      locale: locale
    });
  }, [as, href, isVisible, locale, prefetchEnabled, pagesRouter == null ? void 0 : pagesRouter.locale, router]);

  var childProps = {
    ref: setRef,
    onClick: function onClick(e) {
      if (false) {}

      if (!legacyBehavior && typeof _onClick === 'function') {
        _onClick(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onClick === 'function') {
        child.props.onClick(e);
      }

      if (!router) {
        return;
      }

      if (e.defaultPrevented) {
        return;
      }

      linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled);
    },
    onMouseEnter: function onMouseEnter(e) {
      if (!legacyBehavior && typeof onMouseEnterProp === 'function') {
        onMouseEnterProp(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onMouseEnter === 'function') {
        child.props.onMouseEnter(e);
      }

      if (!router) {
        return;
      }

      if (!prefetchEnabled && isAppRouter) {
        return;
      }

      prefetch(router, href, as, {
        locale: locale,
        priority: true,
        // @see {https://github.com/vercel/next.js/discussions/40268?sort=top#discussioncomment-3572642}
        bypassPrefetchedCheck: true
      });
    },
    onTouchStart: function onTouchStart(e) {
      if (!legacyBehavior && typeof onTouchStartProp === 'function') {
        onTouchStartProp(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onTouchStart === 'function') {
        child.props.onTouchStart(e);
      }

      if (!router) {
        return;
      }

      if (!prefetchEnabled && isAppRouter) {
        return;
      }

      prefetch(router, href, as, {
        locale: locale,
        priority: true,
        // @see {https://github.com/vercel/next.js/discussions/40268?sort=top#discussioncomment-3572642}
        bypassPrefetchedCheck: true
      });
    }
  }; // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
  // defined, we specify the current 'href', so that repetition is not needed by the user

  if (!legacyBehavior || passHref || child.type === 'a' && !('href' in child.props)) {
    var curLocale = typeof locale !== 'undefined' ? locale : pagesRouter == null ? void 0 : pagesRouter.locale; // we only render domain locales if we are currently on a domain locale
    // so that locale links are still visitable in development/preview envs

    var localeDomain = (pagesRouter == null ? void 0 : pagesRouter.isLocaleDomain) && (0, _getDomainLocale).getDomainLocale(as, curLocale, pagesRouter == null ? void 0 : pagesRouter.locales, pagesRouter == null ? void 0 : pagesRouter.domainLocales);
    childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, pagesRouter == null ? void 0 : pagesRouter.defaultLocale));
  }

  return legacyBehavior ? /*#__PURE__*/_react["default"].cloneElement(child, childProps) : /*#__PURE__*/_react["default"].createElement("a", Object.assign({}, restProps, childProps), children);
});

var _default = Link;
exports["default"] = _default;

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 27215:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__(85696);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useIntersection = useIntersection;

var _react = __webpack_require__(67294);

var _requestIdleCallback = __webpack_require__(98065);

var hasIntersectionObserver = typeof IntersectionObserver === 'function';
var observers = new Map();
var idList = [];

function createObserver(options) {
  var id = {
    root: options.root || null,
    margin: options.rootMargin || ''
  };
  var existing = idList.find(function (obj) {
    return obj.root === id.root && obj.margin === id.margin;
  });
  var instance;

  if (existing) {
    instance = observers.get(existing);

    if (instance) {
      return instance;
    }
  }

  var elements = new Map();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var callback = elements.get(entry.target);
      var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;

      if (callback && isVisible) {
        callback(isVisible);
      }
    });
  }, options);
  instance = {
    id: id,
    observer: observer,
    elements: elements
  };
  idList.push(id);
  observers.set(id, instance);
  return instance;
}

function observe(element, callback, options) {
  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements;

  elements.set(element, callback);
  observer.observe(element);
  return function unobserve() {
    elements["delete"](element);
    observer.unobserve(element); // Destroy observer when there's nothing left to watch:

    if (elements.size === 0) {
      observer.disconnect();
      observers["delete"](id);
      var index = idList.findIndex(function (obj) {
        return obj.root === id.root && obj.margin === id.margin;
      });

      if (index > -1) {
        idList.splice(index, 1);
      }
    }
  };
}

function useIntersection(_ref) {
  var rootRef = _ref.rootRef,
      rootMargin = _ref.rootMargin,
      disabled = _ref.disabled;
  var isDisabled = disabled || !hasIntersectionObserver;

  var _useState = (0, _react).useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0, _react).useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      element = _useState4[0],
      setElement = _useState4[1];

  (0, _react).useEffect(function () {
    if (hasIntersectionObserver) {
      if (isDisabled || visible) return;

      if (element && element.tagName) {
        var unobserve = observe(element, function (isVisible) {
          return isVisible && setVisible(isVisible);
        }, {
          root: rootRef == null ? void 0 : rootRef.current,
          rootMargin: rootMargin
        });
        return unobserve;
      }
    } else {
      if (!visible) {
        var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function () {
          return setVisible(true);
        });
        return function () {
          return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
        };
      }
    }
  }, [element, isDisabled, rootMargin, rootRef, visible]);
  var resetVisible = (0, _react).useCallback(function () {
    setVisible(false);
  }, []);
  return [setElement, visible, resetVisible];
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 91203:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__(33227);

var _createClass = __webpack_require__(88361);

var _inherits = __webpack_require__(85971);

var _possibleConstructorReturn = __webpack_require__(52715);

var _getPrototypeOf = __webpack_require__(91193);

var _regeneratorRuntime = __webpack_require__(87794);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _async_to_generator = (__webpack_require__(60932)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var _utils = __webpack_require__(67206);

function appGetInitialProps(_) {
  return _appGetInitialProps.apply(this, arguments);
}

function _appGetInitialProps() {
  _appGetInitialProps =
  /**
  * `App` component is used for initialize of pages. It allows for overwriting and full control of the `page` initialization.
  * This allows for keeping state between navigation, custom error handling, injecting additional data.
  */
  _async_to_generator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var Component, ctx, pageProps;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            Component = _ref.Component, ctx = _ref.ctx;
            _context.next = 3;
            return (0, _utils).loadGetInitialProps(Component, ctx);

          case 3:
            pageProps = _context.sent;
            return _context.abrupt("return", {
              pageProps: pageProps
            });

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _appGetInitialProps.apply(this, arguments);
}

var _Component;

var App = /*#__PURE__*/function (_Component2) {
  _inherits(App, _Component2);

  var _super = _createSuper(App);

  function App() {
    _classCallCheck(this, App);

    return _super.apply(this, arguments);
  }

  _createClass(App, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Component = _this$props.Component,
          pageProps = _this$props.pageProps;
      return /*#__PURE__*/_react["default"].createElement(Component, Object.assign({}, pageProps));
    }
  }]);

  return App;
}(_Component = _react["default"].Component);

App.origGetInitialProps = appGetInitialProps;
App.getInitialProps = appGetInitialProps;
exports["default"] = App;

/***/ }),

/***/ 17285:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AmpStateContext = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var AmpStateContext = _react["default"].createContext({});

exports.AmpStateContext = AmpStateContext;

if (false) {}

/***/ }),

/***/ 80354:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isInAmpMode = isInAmpMode;

function isInAmpMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ampFirst = _ref.ampFirst,
      ampFirst = _ref$ampFirst === void 0 ? false : _ref$ampFirst,
      _ref$hybrid = _ref.hybrid,
      hybrid = _ref$hybrid === void 0 ? false : _ref$hybrid,
      _ref$hasQuery = _ref.hasQuery,
      hasQuery = _ref$hasQuery === void 0 ? false : _ref$hasQuery;

  return ampFirst || hybrid && hasQuery;
}

/***/ }),

/***/ 16505:
/***/ (function(module, exports, __webpack_require__) {

"use client";
"use strict";

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.defaultHead = defaultHead;
exports["default"] = void 0;

var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(67294));

var _sideEffect = _interop_require_default(__webpack_require__(70148));

var _ampContext = __webpack_require__(17285);

var _headManagerContext = __webpack_require__(60523);

var _ampMode = __webpack_require__(80354);

var _warnOnce = __webpack_require__(92783);

'use client';

function defaultHead() {
  var inAmpMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var head = [/*#__PURE__*/_react["default"].createElement("meta", {
    charSet: "utf-8"
  })];

  if (!inAmpMode) {
    head.push( /*#__PURE__*/_react["default"].createElement("meta", {
      name: "viewport",
      content: "width=device-width"
    }));
  }

  return head;
}

function onlyReactElement(list, child) {
  // React children can be "string" or "number" in this case we ignore them for backwards compat
  if (typeof child === 'string' || typeof child === 'number') {
    return list;
  } // Adds support for React.Fragment


  if (child.type === _react["default"].Fragment) {
    return list.concat(_react["default"].Children.toArray(child.props.children).reduce(function (fragmentList, fragmentChild) {
      if (typeof fragmentChild === 'string' || typeof fragmentChild === 'number') {
        return fragmentList;
      }

      return fragmentList.concat(fragmentChild);
    }, []));
  }

  return list.concat(child);
}

var METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];
/*
 returns a function for filtering head child elements
 which shouldn't be duplicated, like <title/>
 Also adds support for deduplicated `key` properties
*/

function unique() {
  var keys = new Set();
  var tags = new Set();
  var metaTypes = new Set();
  var metaCategories = {};
  return function (h) {
    var isUnique = true;
    var hasKey = false;

    if (h.key && typeof h.key !== 'number' && h.key.indexOf('$') > 0) {
      hasKey = true;
      var key = h.key.slice(h.key.indexOf('$') + 1);

      if (keys.has(key)) {
        isUnique = false;
      } else {
        keys.add(key);
      }
    } // eslint-disable-next-line default-case


    switch (h.type) {
      case 'title':
      case 'base':
        if (tags.has(h.type)) {
          isUnique = false;
        } else {
          tags.add(h.type);
        }

        break;

      case 'meta':
        for (var i = 0, len = METATYPES.length; i < len; i++) {
          var metatype = METATYPES[i];
          if (!h.props.hasOwnProperty(metatype)) continue;

          if (metatype === 'charSet') {
            if (metaTypes.has(metatype)) {
              isUnique = false;
            } else {
              metaTypes.add(metatype);
            }
          } else {
            var category = h.props[metatype];
            var categories = metaCategories[metatype] || new Set();

            if ((metatype !== 'name' || !hasKey) && categories.has(category)) {
              isUnique = false;
            } else {
              categories.add(category);
              metaCategories[metatype] = categories;
            }
          }
        }

        break;
    }

    return isUnique;
  };
}
/**
 *
 * @param headChildrenElements List of children of <Head>
 */


function reduceComponents(headChildrenElements, props) {
  var inAmpMode = props.inAmpMode;
  return headChildrenElements.reduce(onlyReactElement, []).reverse().concat(defaultHead(inAmpMode).reverse()).filter(unique()).reverse().map(function (c, i) {
    var key = c.key || i;

    if ( true && !inAmpMode) {
      if (c.type === 'link' && c.props['href'] && // TODO(prateekbh@): Replace this with const from `constants` when the tree shaking works.
      ['https://fonts.googleapis.com/css', 'https://use.typekit.net/'].some(function (url) {
        return c.props['href'].startsWith(url);
      })) {
        var newProps = _extends({}, c.props || {});

        newProps['data-href'] = newProps['href'];
        newProps['href'] = undefined; // Add this attribute to make it easy to identify optimized tags

        newProps['data-optimized-fonts'] = true;
        return /*#__PURE__*/_react["default"].cloneElement(c, newProps);
      }
    }

    if (false) { var srcMessage; }

    return /*#__PURE__*/_react["default"].cloneElement(c, {
      key: key
    });
  });
}
/**
 * This component injects elements to `<head>` of your page.
 * To avoid duplicated `tags` in `<head>` you can use the `key` property, which will make sure every tag is only rendered once.
 */


function Head(_ref) {
  var children = _ref.children;
  var ampState = (0, _react).useContext(_ampContext.AmpStateContext);
  var headManager = (0, _react).useContext(_headManagerContext.HeadManagerContext);
  return /*#__PURE__*/_react["default"].createElement(_sideEffect["default"], {
    reduceComponentsToState: reduceComponents,
    headManager: headManager,
    inAmpMode: (0, _ampMode).isInAmpMode(ampState)
  }, children);
}

var _default = Head;
exports["default"] = _default;

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 27675:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getImageBlurSvg = getImageBlurSvg;

function getImageBlurSvg(_ref) {
  var widthInt = _ref.widthInt,
      heightInt = _ref.heightInt,
      blurWidth = _ref.blurWidth,
      blurHeight = _ref.blurHeight,
      blurDataURL = _ref.blurDataURL;
  var std = blurWidth && blurHeight ? '1' : '20';
  var svgWidth = blurWidth || widthInt;
  var svgHeight = blurHeight || heightInt;
  var feComponentTransfer = blurDataURL.startsWith('data:image/jpeg') ? "%3CfeComponentTransfer%3E%3CfeFuncA type='discrete' tableValues='1 1'/%3E%3C/feComponentTransfer%3E%" : '';

  if (svgWidth && svgHeight) {
    return "%3Csvg xmlns='http%3A//www.w3.org/2000/svg' viewBox='0 0 ".concat(svgWidth, " ").concat(svgHeight, "'%3E%3Cfilter id='b' color-interpolation-filters='sRGB'%3E%3CfeGaussianBlur stdDeviation='").concat(std, "'/%3E").concat(feComponentTransfer, "%3C/filter%3E%3Cimage preserveAspectRatio='none' filter='url(%23b)' x='0' y='0' height='100%25' width='100%25' href='").concat(blurDataURL, "'/%3E%3C/svg%3E");
  }

  return "%3Csvg xmlns='http%3A//www.w3.org/2000/svg'%3E%3Cimage style='filter:blur(20px)' x='0' y='0' height='100%25' width='100%25' href='".concat(blurDataURL, "'/%3E%3C/svg%3E");
}

/***/ }),

/***/ 81923:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

function defaultLoader(_ref) {
  var config = _ref.config,
      src = _ref.src,
      width = _ref.width,
      quality = _ref.quality;

  if (false) { var _require, hasMatch, parsedSrc, missingValues; }

  if (src.endsWith('.svg') && !config.dangerouslyAllowSVG) {
    // Special case to make svg serve as-is to avoid proxying
    // through the built-in Image Optimization API.
    return src;
  }

  return "".concat(config.path, "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
} // We use this to determine if the import is the default loader
// or a custom loader defined by the user in next.config.js


defaultLoader.__next_img_default = true;
var _default = defaultLoader;
exports["default"] = _default;

/***/ }),

/***/ 70148:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = SideEffect;

var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(67294));

function SideEffect(props) {
  var headManager = props.headManager,
      reduceComponentsToState = props.reduceComponentsToState;

  function emitChange() {
    if (headManager && headManager.mountedInstances) {
      var headElements = _react.Children.toArray(Array.from(headManager.mountedInstances).filter(Boolean));

      headManager.updateHead(reduceComponentsToState(headElements, props));
    }
  }

  if (isServer) {
    var ref;
    headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref.add(props.children);
    emitChange();
  }

  useClientOnlyLayoutEffect(function () {
    var ref1;
    headManager == null ? void 0 : (ref1 = headManager.mountedInstances) == null ? void 0 : ref1.add(props.children);
    return function () {
      var ref;
      headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref["delete"](props.children);
    };
  }); // We need to call `updateHead` method whenever the `SideEffect` is trigger in all
  // life-cycles: mount, update, unmount. However, if there are multiple `SideEffect`s
  // being rendered, we only trigger the method from the last one.
  // This is ensured by keeping the last unflushed `updateHead` in the `_pendingUpdate`
  // singleton in the layout effect pass, and actually trigger it in the effect pass.

  useClientOnlyLayoutEffect(function () {
    if (headManager) {
      headManager._pendingUpdate = emitChange;
    }

    return function () {
      if (headManager) {
        headManager._pendingUpdate = emitChange;
      }
    };
  });
  useClientOnlyEffect(function () {
    if (headManager && headManager._pendingUpdate) {
      headManager._pendingUpdate();

      headManager._pendingUpdate = null;
    }

    return function () {
      if (headManager && headManager._pendingUpdate) {
        headManager._pendingUpdate();

        headManager._pendingUpdate = null;
      }
    };
  });
  return null;
}

var isServer = false;
var useClientOnlyLayoutEffect = isServer ? function () {} : _react.useLayoutEffect;
var useClientOnlyEffect = isServer ? function () {} : _react.useEffect;

/***/ }),

/***/ 92783:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.warnOnce = void 0;

var warnOnce = function warnOnce(_) {};

if (false) { var warnings; }

exports.warnOnce = warnOnce;

/***/ }),

/***/ 33395:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
/* provided dependency */ var process = __webpack_require__(34155);
__webpack_require__(2350);

var React = __webpack_require__(67294);

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
/*
Based on Glamor's sheet
https://github.com/threepointone/glamor/blob/667b480d31b3721a905021b26e1290ce92ca2879/src/sheet.js
*/


function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var isProd = typeof process !== "undefined" && process.env && true;

var isString = function isString(o) {
  return Object.prototype.toString.call(o) === "[object String]";
};

var StyleSheet = /*#__PURE__*/function () {
  function StyleSheet(param) {
    var ref = param === void 0 ? {} : param,
        _name = ref.name,
        name = _name === void 0 ? "stylesheet" : _name,
        _optimizeForSpeed = ref.optimizeForSpeed,
        optimizeForSpeed = _optimizeForSpeed === void 0 ? isProd : _optimizeForSpeed;
    invariant$1(isString(name), "`name` must be a string");
    this._name = name;
    this._deletedRulePlaceholder = "#" + name + "-deleted-rule____{}";
    invariant$1(typeof optimizeForSpeed === "boolean", "`optimizeForSpeed` must be a boolean");
    this._optimizeForSpeed = optimizeForSpeed;
    this._serverSheet = undefined;
    this._tags = [];
    this._injected = false;
    this._rulesCount = 0;
    var node =  true && document.querySelector('meta[property="csp-nonce"]');
    this._nonce = node ? node.getAttribute("content") : null;
  }

  var _proto = StyleSheet.prototype;

  _proto.setOptimizeForSpeed = function setOptimizeForSpeed(bool) {
    invariant$1(typeof bool === "boolean", "`setOptimizeForSpeed` accepts a boolean");
    invariant$1(this._rulesCount === 0, "optimizeForSpeed cannot be when rules have already been inserted");
    this.flush();
    this._optimizeForSpeed = bool;
    this.inject();
  };

  _proto.isOptimizeForSpeed = function isOptimizeForSpeed() {
    return this._optimizeForSpeed;
  };

  _proto.inject = function inject() {
    var _this = this;

    invariant$1(!this._injected, "sheet already injected");
    this._injected = true;

    if ( true && this._optimizeForSpeed) {
      this._tags[0] = this.makeStyleTag(this._name);
      this._optimizeForSpeed = "insertRule" in this.getSheet();

      if (!this._optimizeForSpeed) {
        if (!isProd) {
          console.warn("StyleSheet: optimizeForSpeed mode not supported falling back to standard mode.");
        }

        this.flush();
        this._injected = true;
      }

      return;
    }

    this._serverSheet = {
      cssRules: [],
      insertRule: function insertRule(rule, index) {
        if (typeof index === "number") {
          _this._serverSheet.cssRules[index] = {
            cssText: rule
          };
        } else {
          _this._serverSheet.cssRules.push({
            cssText: rule
          });
        }

        return index;
      },
      deleteRule: function deleteRule(index) {
        _this._serverSheet.cssRules[index] = null;
      }
    };
  };

  _proto.getSheetForTag = function getSheetForTag(tag) {
    if (tag.sheet) {
      return tag.sheet;
    } // this weirdness brought to you by firefox


    for (var i = 0; i < document.styleSheets.length; i++) {
      if (document.styleSheets[i].ownerNode === tag) {
        return document.styleSheets[i];
      }
    }
  };

  _proto.getSheet = function getSheet() {
    return this.getSheetForTag(this._tags[this._tags.length - 1]);
  };

  _proto.insertRule = function insertRule(rule, index) {
    invariant$1(isString(rule), "`insertRule` accepts only strings");

    if (false) {}

    if (this._optimizeForSpeed) {
      var sheet = this.getSheet();

      if (typeof index !== "number") {
        index = sheet.cssRules.length;
      } // this weirdness for perf, and chrome's weird bug
      // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule


      try {
        sheet.insertRule(rule, index);
      } catch (error) {
        if (!isProd) {
          console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
        }

        return -1;
      }
    } else {
      var insertionPoint = this._tags[index];

      this._tags.push(this.makeStyleTag(this._name, rule, insertionPoint));
    }

    return this._rulesCount++;
  };

  _proto.replaceRule = function replaceRule(index, rule) {
    if (this._optimizeForSpeed || false) {
      var sheet =  true ? this.getSheet() : 0;

      if (!rule.trim()) {
        rule = this._deletedRulePlaceholder;
      }

      if (!sheet.cssRules[index]) {
        // @TBD Should we throw an error?
        return index;
      }

      sheet.deleteRule(index);

      try {
        sheet.insertRule(rule, index);
      } catch (error) {
        if (!isProd) {
          console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
        } // In order to preserve the indices we insert a deleteRulePlaceholder


        sheet.insertRule(this._deletedRulePlaceholder, index);
      }
    } else {
      var tag = this._tags[index];
      invariant$1(tag, "old rule at index `" + index + "` not found");
      tag.textContent = rule;
    }

    return index;
  };

  _proto.deleteRule = function deleteRule(index) {
    if (false) {}

    if (this._optimizeForSpeed) {
      this.replaceRule(index, "");
    } else {
      var tag = this._tags[index];
      invariant$1(tag, "rule at index `" + index + "` not found");
      tag.parentNode.removeChild(tag);
      this._tags[index] = null;
    }
  };

  _proto.flush = function flush() {
    this._injected = false;
    this._rulesCount = 0;

    if (true) {
      this._tags.forEach(function (tag) {
        return tag && tag.parentNode.removeChild(tag);
      });

      this._tags = [];
    } else {}
  };

  _proto.cssRules = function cssRules() {
    var _this = this;

    if (false) {}

    return this._tags.reduce(function (rules, tag) {
      if (tag) {
        rules = rules.concat(Array.prototype.map.call(_this.getSheetForTag(tag).cssRules, function (rule) {
          return rule.cssText === _this._deletedRulePlaceholder ? null : rule;
        }));
      } else {
        rules.push(null);
      }

      return rules;
    }, []);
  };

  _proto.makeStyleTag = function makeStyleTag(name, cssString, relativeToTag) {
    if (cssString) {
      invariant$1(isString(cssString), "makeStyleTag accepts only strings as second parameter");
    }

    var tag = document.createElement("style");
    if (this._nonce) tag.setAttribute("nonce", this._nonce);
    tag.type = "text/css";
    tag.setAttribute("data-" + name, "");

    if (cssString) {
      tag.appendChild(document.createTextNode(cssString));
    }

    var head = document.head || document.getElementsByTagName("head")[0];

    if (relativeToTag) {
      head.insertBefore(tag, relativeToTag);
    } else {
      head.appendChild(tag);
    }

    return tag;
  };

  _createClass(StyleSheet, [{
    key: "length",
    get: function get() {
      return this._rulesCount;
    }
  }]);

  return StyleSheet;
}();

function invariant$1(condition, message) {
  if (!condition) {
    throw new Error("StyleSheet: " + message + ".");
  }
}

function hash(str) {
  var _$hash = 5381,
      i = str.length;

  while (i) {
    _$hash = _$hash * 33 ^ str.charCodeAt(--i);
  }
  /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
  * integers. Since we want the results to be always positive, convert the
  * signed int to an unsigned by doing an unsigned bitshift. */


  return _$hash >>> 0;
}

var stringHash = hash;

var sanitize = function sanitize(rule) {
  return rule.replace(/\/style/gi, "\\/style");
};

var cache = {};
/**
 * computeId
 *
 * Compute and memoize a jsx id from a basedId and optionally props.
 */

function computeId(baseId, props) {
  if (!props) {
    return "jsx-" + baseId;
  }

  var propsToString = String(props);
  var key = baseId + propsToString;

  if (!cache[key]) {
    cache[key] = "jsx-" + stringHash(baseId + "-" + propsToString);
  }

  return cache[key];
}
/**
 * computeSelector
 *
 * Compute and memoize dynamic selectors.
 */


function computeSelector(id, css) {
  var selectoPlaceholderRegexp = /__jsx-style-dynamic-selector/g; // Sanitize SSR-ed CSS.
  // Client side code doesn't need to be sanitized since we use
  // document.createTextNode (dev) and the CSSOM api sheet.insertRule (prod).

  if (false) {}

  var idcss = id + css;

  if (!cache[idcss]) {
    cache[idcss] = css.replace(selectoPlaceholderRegexp, id);
  }

  return cache[idcss];
}

function mapRulesToStyle(cssRules, options) {
  if (options === void 0) options = {};
  return cssRules.map(function (args) {
    var id = args[0];
    var css = args[1];
    return /*#__PURE__*/React__default["default"].createElement("style", {
      id: "__" + id,
      // Avoid warnings upon render with a key
      key: "__" + id,
      nonce: options.nonce ? options.nonce : undefined,
      dangerouslySetInnerHTML: {
        __html: css
      }
    });
  });
}

var StyleSheetRegistry = /*#__PURE__*/function () {
  function StyleSheetRegistry(param) {
    var ref = param === void 0 ? {} : param,
        _styleSheet = ref.styleSheet,
        styleSheet = _styleSheet === void 0 ? null : _styleSheet,
        _optimizeForSpeed = ref.optimizeForSpeed,
        optimizeForSpeed = _optimizeForSpeed === void 0 ? false : _optimizeForSpeed;
    this._sheet = styleSheet || new StyleSheet({
      name: "styled-jsx",
      optimizeForSpeed: optimizeForSpeed
    });

    this._sheet.inject();

    if (styleSheet && typeof optimizeForSpeed === "boolean") {
      this._sheet.setOptimizeForSpeed(optimizeForSpeed);

      this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
    }

    this._fromServer = undefined;
    this._indices = {};
    this._instancesCounts = {};
  }

  var _proto = StyleSheetRegistry.prototype;

  _proto.add = function add(props) {
    var _this = this;

    if (undefined === this._optimizeForSpeed) {
      this._optimizeForSpeed = Array.isArray(props.children);

      this._sheet.setOptimizeForSpeed(this._optimizeForSpeed);

      this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
    }

    if ( true && !this._fromServer) {
      this._fromServer = this.selectFromServer();
      this._instancesCounts = Object.keys(this._fromServer).reduce(function (acc, tagName) {
        acc[tagName] = 0;
        return acc;
      }, {});
    }

    var ref = this.getIdAndRules(props),
        styleId = ref.styleId,
        rules = ref.rules; // Deduping: just increase the instances count.

    if (styleId in this._instancesCounts) {
      this._instancesCounts[styleId] += 1;
      return;
    }

    var indices = rules.map(function (rule) {
      return _this._sheet.insertRule(rule);
    }) // Filter out invalid rules
    .filter(function (index) {
      return index !== -1;
    });
    this._indices[styleId] = indices;
    this._instancesCounts[styleId] = 1;
  };

  _proto.remove = function remove(props) {
    var _this = this;

    var styleId = this.getIdAndRules(props).styleId;
    invariant(styleId in this._instancesCounts, "styleId: `" + styleId + "` not found");
    this._instancesCounts[styleId] -= 1;

    if (this._instancesCounts[styleId] < 1) {
      var tagFromServer = this._fromServer && this._fromServer[styleId];

      if (tagFromServer) {
        tagFromServer.parentNode.removeChild(tagFromServer);
        delete this._fromServer[styleId];
      } else {
        this._indices[styleId].forEach(function (index) {
          return _this._sheet.deleteRule(index);
        });

        delete this._indices[styleId];
      }

      delete this._instancesCounts[styleId];
    }
  };

  _proto.update = function update(props, nextProps) {
    this.add(nextProps);
    this.remove(props);
  };

  _proto.flush = function flush() {
    this._sheet.flush();

    this._sheet.inject();

    this._fromServer = undefined;
    this._indices = {};
    this._instancesCounts = {};
  };

  _proto.cssRules = function cssRules() {
    var _this = this;

    var fromServer = this._fromServer ? Object.keys(this._fromServer).map(function (styleId) {
      return [styleId, _this._fromServer[styleId]];
    }) : [];

    var cssRules = this._sheet.cssRules();

    return fromServer.concat(Object.keys(this._indices).map(function (styleId) {
      return [styleId, _this._indices[styleId].map(function (index) {
        return cssRules[index].cssText;
      }).join(_this._optimizeForSpeed ? "" : "\n")];
    }) // filter out empty rules
    .filter(function (rule) {
      return Boolean(rule[1]);
    }));
  };

  _proto.styles = function styles(options) {
    return mapRulesToStyle(this.cssRules(), options);
  };

  _proto.getIdAndRules = function getIdAndRules(props) {
    var css = props.children,
        dynamic = props.dynamic,
        id = props.id;

    if (dynamic) {
      var styleId = computeId(id, dynamic);
      return {
        styleId: styleId,
        rules: Array.isArray(css) ? css.map(function (rule) {
          return computeSelector(styleId, rule);
        }) : [computeSelector(styleId, css)]
      };
    }

    return {
      styleId: computeId(id),
      rules: Array.isArray(css) ? css : [css]
    };
  };
  /**
  * selectFromServer
  *
  * Collects style tags from the document with id __jsx-XXX
  */


  _proto.selectFromServer = function selectFromServer() {
    var elements = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
    return elements.reduce(function (acc, element) {
      var id = element.id.slice(2);
      acc[id] = element;
      return acc;
    }, {});
  };

  return StyleSheetRegistry;
}();

function invariant(condition, message) {
  if (!condition) {
    throw new Error("StyleSheetRegistry: " + message + ".");
  }
}

var StyleSheetContext = /*#__PURE__*/React.createContext(null);
StyleSheetContext.displayName = "StyleSheetContext";

function createStyleRegistry() {
  return new StyleSheetRegistry();
}

function StyleRegistry(param) {
  var configuredRegistry = param.registry,
      children = param.children;
  var rootRegistry = React.useContext(StyleSheetContext);
  var ref = React.useState(function () {
    return rootRegistry || configuredRegistry || createStyleRegistry();
  }),
      registry = ref[0];
  return /*#__PURE__*/React__default["default"].createElement(StyleSheetContext.Provider, {
    value: registry
  }, children);
}

function useStyleRegistry() {
  return React.useContext(StyleSheetContext);
} // Opt-into the new `useInsertionEffect` API in React 18, fallback to `useLayoutEffect`.
// https://github.com/reactwg/react-18/discussions/110


var useInsertionEffect = React__default["default"].useInsertionEffect || React__default["default"].useLayoutEffect;
var defaultRegistry =  true ? createStyleRegistry() : 0;

function JSXStyle(props) {
  var registry = defaultRegistry ? defaultRegistry : useStyleRegistry(); // If `registry` does not exist, we do nothing here.

  if (!registry) {
    return null;
  }

  if (false) {}

  useInsertionEffect(function () {
    registry.add(props);
    return function () {
      registry.remove(props);
    }; // props.children can be string[], will be striped since id is identical
  }, [props.id, String(props.dynamic)]);
  return null;
}

JSXStyle.dynamic = function (info) {
  return info.map(function (tagInfo) {
    var baseId = tagInfo[0];
    var props = tagInfo[1];
    return computeId(baseId, props);
  }).join(" ");
};

__webpack_unused_export__ = StyleRegistry;
__webpack_unused_export__ = createStyleRegistry;
exports.style = JSXStyle;
__webpack_unused_export__ = useStyleRegistry;

/***/ }),

/***/ 77521:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(33395).style;

/***/ }),

/***/ 32055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(10748);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(81531);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/next/app.js
var app = __webpack_require__(7544);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/abortcontroller-polyfill/dist/polyfill-patch-fetch.js
var polyfill_patch_fetch = __webpack_require__(63367);
// EXTERNAL MODULE: ./components/atoms/DependencyHelper.js + 81 modules
var DependencyHelper = __webpack_require__(28658);
// EXTERNAL MODULE: ./components/atoms/container/MainContainer.jsx
var MainContainer = __webpack_require__(40521);
// EXTERNAL MODULE: ./components/atoms/buttons/buttonWithIcon/ButtonWithIcon.jsx
var ButtonWithIcon = __webpack_require__(30390);
// EXTERNAL MODULE: ./components/atoms/loader/loader.module.scss
var loader_module = __webpack_require__(91490);
var loader_module_default = /*#__PURE__*/__webpack_require__.n(loader_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atoms/loader/loader.jsx




var LoaderComponent = function LoaderComponent() {
  var isLoading = (0,es/* useSelector */.v9)(function (state) {
    return state.common.isLoading;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    id: "loaderMain",
    className: "".concat((loader_module_default()).loader, " ").concat(isLoading ? (loader_module_default())["show-spinner"] : "")
  });
};

/* harmony default export */ var loader = (LoaderComponent);
// EXTERNAL MODULE: ./components/molecules/searchNav/SearchNav.module.scss
var SearchNav_module = __webpack_require__(27199);
var SearchNav_module_default = /*#__PURE__*/__webpack_require__.n(SearchNav_module);
// EXTERNAL MODULE: ./Redux/actions/navAction.js
var navAction = __webpack_require__(42220);
// EXTERNAL MODULE: ./utils/helperServices.js + 3 modules
var helperServices = __webpack_require__(64036);
// EXTERNAL MODULE: ./components/molecules/SearchBoxContainer/SearchBoxContainer.jsx
var SearchBoxContainer = __webpack_require__(7918);
;// CONCATENATED MODULE: ./components/molecules/searchNav/SearchNav.jsx









var SearchNav = function SearchNav(_ref) {
  var _ref$lableName = _ref.lableName,
      lableName = _ref$lableName === void 0 ? "Cancel" : _ref$lableName,
      handleCancel = _ref.handleCancel,
      handleChange = _ref.handleChange,
      text = _ref.text,
      handleKeyPress = _ref.handleKeyPress,
      handleSearchClick = _ref.handleSearchClick,
      handleFocus = _ref.handleFocus;
  var isTablet = (0,helperServices/* componentCheckSize */.Qj)() <= 768;

  var searchBox = /*#__PURE__*/(0,jsx_runtime.jsx)(SearchBoxContainer/* default */.Z, {
    focus: true,
    closeRequired: isTablet ? false : true,
    className: (SearchNav_module_default())["search-box"],
    handleChange: handleChange,
    text: text,
    handleCancel: handleCancel,
    handleKeyPress: handleKeyPress,
    handleSearchClick: handleSearchClick,
    handleFocus: handleFocus
  });

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: isTablet ? /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: (SearchNav_module_default())["search-container"],
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (SearchNav_module_default())["search-items"],
        children: [searchBox, /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: handleCancel,
          className: (SearchNav_module_default())["cancel-btn"],
          children: lableName
        })]
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: (SearchNav_module_default())["search-container"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (SearchNav_module_default())["search-items"],
        children: searchBox
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (SearchNav_module_default())["horizantal-line"]
      })]
    })
  });
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    hideNavItems: state.navDetails.hideNavItems
  };
};

/* harmony default export */ var searchNav_SearchNav = ((0,DependencyHelper.connect)(mapStateToProps, {
  toggleSearch: navAction/* toggleSearch */.j2
})(SearchNav));
// EXTERNAL MODULE: ./components/organisms/InternalSearch/InterNalSearch.module.scss
var InterNalSearch_module = __webpack_require__(96602);
var InterNalSearch_module_default = /*#__PURE__*/__webpack_require__.n(InterNalSearch_module);
// EXTERNAL MODULE: ./utils/ajaxServices.js + 6 modules
var ajaxServices = __webpack_require__(18517);
// EXTERNAL MODULE: ./services/analyticsUtag.js
var analyticsUtag = __webpack_require__(69152);
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(26125);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./components/organisms/InternalSearch/InterNalSearch.jsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var InterNalSearch = function InterNalSearch(_ref) {
  var hideNavItems = _ref.hideNavItems,
      toggleSearch = _ref.toggleSearch,
      globalNavigationLinks = _ref.globalNavigationLinks;

  var _useState = (0,react.useState)(""),
      text = _useState[0],
      setText = _useState[1];

  var _useState2 = (0,react.useState)([]),
      links = _useState2[0],
      setLinks = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      showLink = _useState3[0],
      setShowLink = _useState3[1];

  var isTablet = (0,helperServices/* componentCheckSize */.Qj)() <= 768;
  var router = (0,DependencyHelper.useRouter)();
  var env = (config_default()).env;
  var urlPrefix = (config_default()).envConfigs[env].shoppingUrlPrefix;
  var urlObj = globalNavigationLinks.children.find(function (link) {
    return link.title === "Search" && link.type === "icon";
  });
  var searchUrl = urlObj.url;
  (0,react.useEffect)(function () {
    function fetchQuickLinks() {
      return _fetchQuickLinks.apply(this, arguments);
    }

    function _fetchQuickLinks() {
      _fetchQuickLinks = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var linksArr;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "searchQuickLinks");

              case 2:
                linksArr = _context.sent;
                setLinks([{
                  id: 1,
                  searchedHeading: "quick links",
                  globalsuggestion: linksArr
                }]);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchQuickLinks.apply(this, arguments);
    }

    fetchQuickLinks();
  }, []);

  var handleChange = function handleChange(e) {
    setText(e.target.value);
  };

  var closeOptions = function closeOptions() {
    toggleSearch(false);
  };

  var handleKeyPress = function handleKeyPress(e) {
    var route;

    if (searchUrl.includes("internal:")) {
      route = searchUrl.split("internal:")[1];
    } else {
      route = searchUrl;
    }

    if (e.key === "Enter") {
      var tempText = text;
      tempText = tempText.replace(/\s/g, '');

      if (tempText && tempText.length) {
        closeOptions();
        (0,helperServices/* showSpinner */.yh)();
        router.push({
          pathname: "".concat(route, "/").concat(encodeURI(text))
        });
        (0,helperServices/* hideSpinner */.v3)();
      }
    }
  };

  var handleSearchClick = function handleSearchClick() {
    var route;

    if (searchUrl.includes("internal:")) {
      route = searchUrl.split("internal:")[1];
    } else {
      route = searchUrl;
    }

    var tempText = text;
    tempText = tempText.replace(/\s/g, '');

    if (tempText && tempText.length) {
      closeOptions();
      (0,helperServices/* showSpinner */.yh)();
      router.push({
        pathname: "".concat(route, "/").concat(encodeURI(text))
      });
      (0,helperServices/* hideSpinner */.v3)();
    }
  };

  var handleFocus = function handleFocus() {
    setShowLink(true);
    var analyticsData = analyticsUtag/* getUtagData */.GS(["visitor_login_status", "visitor_customer_id", "visitor_subscription_type", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "page_site_section_lvl_4"]);
    analyticsUtag/* link */.p4(_objectSpread({
      page_tool_event: "use",
      page_tool_name: "search bar",
      page_name: "internal search",
      page_channel: "search",
      page_master_tab: "personal"
    }, analyticsData));
  };

  var learnMoreClicked = function learnMoreClicked(linkdata, index) {
    var url = linkdata.url;
    toggleSearch(false);
    var analyticsData = analyticsUtag/* getUtagData */.GS(["visitor_login_status", "visitor_customer_id", "visitor_subscription_type", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "page_site_section_lvl_4"]);
    analyticsUtag/* link */.p4(_objectSpread({
      search_event: "quick_search",
      search_terms: linkdata.title,
      search_results: index + 1,
      search_category: "quick links",
      search_type: "quick links"
    }, analyticsData));

    if (url) {
      if (url.includes("internal:")) {
        var route = url.split("internal:")[1];

        if (route) {
          DependencyHelper.Router.push({
            pathname: route
          });
        }
      } else {
        window.open(url, "_blank");
      }
    }
  };

  var searchSection = /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    className: (InterNalSearch_module_default())["internal-search-container"],
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(searchNav_SearchNav, {
      handleCancel: closeOptions,
      handleChange: handleChange,
      text: text,
      handleKeyPress: handleKeyPress,
      handleSearchClick: handleSearchClick,
      handleFocus: handleFocus,
      isSearchTxt: false
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: (InterNalSearch_module_default())["box-conatiner"],
      children: showLink && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (InterNalSearch_module_default())["searched-items"],
          children: links.map(function (link) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                className: (InterNalSearch_module_default())["searched-heading"],
                children: link.searchedHeading
              }), link.globalsuggestion.map(function (linkdata, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                  className: (InterNalSearch_module_default())["product-labels"],
                  onClick: function onClick() {
                    return learnMoreClicked(linkdata, index);
                  },
                  children: linkdata.title
                }, linkdata.id);
              })]
            }, link.id);
          })
        })
      })
    })]
  });

  return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
    children: isTablet ? /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Modal, {
      backdrop: false,
      show: hideNavItems,
      onHide: closeOptions,
      dialogClassName: "select-modal",
      children: searchSection
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Modal, {
      backdrop: false,
      show: hideNavItems,
      onHide: closeOptions,
      dialogClassName: "search-modal",
      children: searchSection
    })
  });
};

var InterNalSearch_mapStateToProps = function mapStateToProps(state) {
  return {
    hideNavItems: state.navDetails.hideNavItems,
    globalNavigationLinks: state.navDetails.globalNav.navigationLinks
  };
};

/* harmony default export */ var InternalSearch_InterNalSearch = ((0,DependencyHelper.connect)(InterNalSearch_mapStateToProps, {
  toggleSearch: navAction/* toggleSearch */.j2
})(InterNalSearch));
// EXTERNAL MODULE: ./components/atoms/image/image.jsx + 1 modules
var image_image = __webpack_require__(39489);
// EXTERNAL MODULE: ./components/molecules/upgradeErrorModal/upgradeErrorModal.module.scss
var upgradeErrorModal_module = __webpack_require__(91635);
var upgradeErrorModal_module_default = /*#__PURE__*/__webpack_require__.n(upgradeErrorModal_module);
;// CONCATENATED MODULE: ./components/molecules/upgradeErrorModal/upgradeErrorModal.jsx









var upgradeErrorModal = function upgradeErrorModal(_ref) {
  var show = _ref.show,
      text = _ref.text,
      type = _ref.type,
      title = _ref.title,
      subText = _ref.subText,
      nextDate = _ref.nextDate,
      cellphone = _ref.cellphone,
      cancelLabel = _ref.cancelLabel,
      handleCancel = _ref.handleCancel,
      primaryLabel = _ref.primaryLabel,
      handleRestart = _ref.handleRestart,
      secondaryLabel = _ref.secondaryLabel,
      solidBlackBtnLabel = _ref.solidBlackBtnLabel,
      solidBlackBtnAction = _ref.solidBlackBtnAction,
      handlePrimaryAction = _ref.handlePrimaryAction,
      outlineWhiteBtnLabel = _ref.outlineWhiteBtnLabel,
      outlineWhiteBtnAction = _ref.outlineWhiteBtnAction,
      handleSecondaryAction = _ref.handleSecondaryAction,
      solidBlackBtnLabelSecond = _ref.solidBlackBtnLabelSecond;
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  var isMobile = (0,helperServices/* componentCheckSize */.Qj)() < 768;
  var imgUrl;

  switch (type) {
    case "sucess":
      imgUrl = "".concat(imagePrefix, "/assets/images/icon-sucess.svg");
      break;

    case "error":
      imgUrl = "".concat(imagePrefix, "/assets/images/icon-cross.svg");
      break;

    case "info":
      imgUrl = "".concat(imagePrefix, "/assets/images/icon-info.svg");
      break;

    case "telephonic":
      imgUrl = "".concat(imagePrefix, "/assets/images/deal-builder/call.svg");
      break;

    default:
      imgUrl = isMobile ? "".concat(imagePrefix, "/assets/images/deal-builder/product-search.svg") : "".concat(imagePrefix, "/assets/images/deal-builder/question.svg");
      break;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Modal, {
      show: show,
      dialogClassName: "".concat((upgradeErrorModal_module_default())["upgrade-error-modal"]),
      onHide: handleCancel,
      centered: true,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Modal.Header, {
        className: (upgradeErrorModal_module_default())["modal-header"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
          className: (upgradeErrorModal_module_default())["close-button"],
          img_path: "".concat(imagePrefix, "/assets/images/deal-builder/close-small.svg"),
          onClick: handleCancel
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Modal.Body, {
        className: (upgradeErrorModal_module_default())["modal-body"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (upgradeErrorModal_module_default()).icon,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
            className: (upgradeErrorModal_module_default())["icon-cross"],
            img_path: imgUrl
          })
        }), title && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (upgradeErrorModal_module_default()).title,
          id: "".concat(title, "-heading"),
          children: title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (upgradeErrorModal_module_default()).content,
          dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(text.replace("{{cellphone}}", cellphone)),
          id: "".concat(title, "-desc")
        }), nextDate && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (upgradeErrorModal_module_default()).nextDate,
          id: "".concat(nextDate, "-text"),
          children: nextDate
        }), (!primaryLabel && !secondaryLabel || !primaryLabel && !cancelLabel) && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (upgradeErrorModal_module_default()).subText,
          id: "".concat(subText, "-text"),
          children: subText
        })]
      }), (primaryLabel || secondaryLabel || cancelLabel || solidBlackBtnLabel) && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Modal.Footer, {
        className: (upgradeErrorModal_module_default())["modal-footer"],
        children: [primaryLabel && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Button, {
          onClick: handlePrimaryAction,
          className: "".concat((upgradeErrorModal_module_default()).primary),
          id: "".concat(primaryLabel, "-btn"),
          children: primaryLabel
        }), secondaryLabel && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Button, {
          onClick: handleSecondaryAction,
          className: "".concat((upgradeErrorModal_module_default()).secondary),
          id: "".concat(secondaryLabel, "-btn"),
          children: secondaryLabel
        }), cancelLabel && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Button, {
          onClick: handleCancel,
          className: "".concat((upgradeErrorModal_module_default()).cancel),
          id: "".concat(cancelLabel, "-btn"),
          children: cancelLabel
        }), solidBlackBtnLabel && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Button, {
          onClick: solidBlackBtnAction,
          className: "".concat((upgradeErrorModal_module_default()).cancelUpgradeBttn, " new-contract"),
          id: "".concat(solidBlackBtnLabel, "-btn"),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: solidBlackBtnLabel
          })
        }), solidBlackBtnLabelSecond && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Button, {
          onClick: handleRestart,
          className: "".concat((upgradeErrorModal_module_default()).cancelUpgradeBttn, " another-number"),
          id: "".concat(solidBlackBtnLabelSecond, "-btn"),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: solidBlackBtnLabelSecond
          })
        }), outlineWhiteBtnLabel && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Button, {
          onClick: outlineWhiteBtnAction,
          className: "".concat((upgradeErrorModal_module_default()).cancelUpgradeBttn, " cancel-upgrade"),
          id: "".concat(outlineWhiteBtnLabel, "-btn"),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: outlineWhiteBtnLabel
          })
        })]
      })]
    })
  });
};

upgradeErrorModal.defaultProps = {
  title: "Technical Error"
};
/* harmony default export */ var upgradeErrorModal_upgradeErrorModal = (upgradeErrorModal);
// EXTERNAL MODULE: ./components/molecules/upgradeBanner/UpgradeBanner.module.scss
var UpgradeBanner_module = __webpack_require__(43483);
var UpgradeBanner_module_default = /*#__PURE__*/__webpack_require__.n(UpgradeBanner_module);
// EXTERNAL MODULE: ./config/labels.js
var labels = __webpack_require__(99599);
// EXTERNAL MODULE: ./Redux/actions/upgradeAction.js
var upgradeAction = __webpack_require__(58486);
// EXTERNAL MODULE: ./services/upgradeService.js
var upgradeService = __webpack_require__(70098);
// EXTERNAL MODULE: ./Redux/actions/dealBuilderAction.js
var dealBuilderAction = __webpack_require__(9449);
;// CONCATENATED MODULE: ./components/molecules/upgradeBanner/UpgradeBanner.jsx




function UpgradeBanner_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function UpgradeBanner_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? UpgradeBanner_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : UpgradeBanner_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var UpgradeBanner = function UpgradeBanner(_ref) {
  var _upgrade$selectedUpgr8, _upgrade$selectedUpgr9;

  var upgrade = _ref.upgrade,
      displayHideUpgradeTopbannerModal = _ref.displayHideUpgradeTopbannerModal,
      displayHideUpgradeModal = _ref.displayHideUpgradeModal,
      updateJourneyStatus = _ref.updateJourneyStatus,
      generateOneTimePin = _ref.generateOneTimePin,
      setContractMode = _ref.setContractMode;
  var env = (config_default()).env;
  var isMobile = (0,helperServices/* componentResize */.Y4)();
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  var imgUrl = "".concat(imagePrefix, "/assets/images/upgrade-info.svg");
  var imgSize = 30;

  var _useState = (0,react.useState)(0),
      idleCounter = _useState[0],
      setIdleCounter = _useState[1];

  var pageName = "";

  var onSeeDetails = function onSeeDetails() {
    var _upgrade$selectedUpgr, _upgrade$selectedUpgr2, _upgrade$selectedUpgr3, _upgrade$selectedUpgr4, _upgrade$selectedUpgr5;

    displayHideUpgradeTopbannerModal(true);
    pageName = analyticsUtag/* getPageName */.j0();
    var cutomerType = upgrade !== null && upgrade !== void 0 && (_upgrade$selectedUpgr = upgrade.selectedUpgradeResponse) !== null && _upgrade$selectedUpgr !== void 0 && _upgrade$selectedUpgr.business ? "EBU" : upgrade !== null && upgrade !== void 0 && (_upgrade$selectedUpgr2 = upgrade.selectedUpgradeResponse) !== null && _upgrade$selectedUpgr2 !== void 0 && _upgrade$selectedUpgr2.c3dCustomer ? "C3D" : "Legacy";
    analyticsUtag/* link */.p4({
      link_type: "o",
      link_name: "".concat(pageName, ": ").concat(labels/* default.lbl_top_banner.lbl_btn.lbl_see_detail */.Z.lbl_top_banner.lbl_btn.lbl_see_detail)
    });
    analyticsUtag/* view */.ei(UpgradeBanner_objectSpread({
      page_event: "view",
      page_name: "".concat(pageName, ": see details"),
      page_master_tab: "personal",
      upgrade_eligibility_status: "".concat(upgrade !== null && upgrade !== void 0 && (_upgrade$selectedUpgr3 = upgrade.selectedUpgradeResponse) !== null && _upgrade$selectedUpgr3 !== void 0 && _upgrade$selectedUpgr3.upgradeEligible ? upgrade === null || upgrade === void 0 ? void 0 : (_upgrade$selectedUpgr4 = upgrade.selectedUpgradeResponse) === null || _upgrade$selectedUpgr4 === void 0 ? void 0 : _upgrade$selectedUpgr4.upgradeEligible : false),
      upgrade_eligible_date: upgrade === null || upgrade === void 0 ? void 0 : (_upgrade$selectedUpgr5 = upgrade.selectedUpgradeResponse) === null || _upgrade$selectedUpgr5 === void 0 ? void 0 : _upgrade$selectedUpgr5.upgradeDate,
      upgrade_customer_type: cutomerType
    }, analyticsUtag/* getUtagData */.GS(["visitor_login", "visitor_customer_id", "visitor_msisdn_hash", "visitor_subscription_type", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "page_site_section_lvl_4"])));
    analyticsUtag/* setPageName */.t0(pageName);
  };

  var isEligible = function isEligible() {
    var _upgrade$selectedUpgr6;

    return (upgrade === null || upgrade === void 0 ? void 0 : upgrade.upgradeCheckDone) && (upgrade === null || upgrade === void 0 ? void 0 : (_upgrade$selectedUpgr6 = upgrade.selectedUpgradeResponse) === null || _upgrade$selectedUpgr6 === void 0 ? void 0 : _upgrade$selectedUpgr6.upgradeEligible) && (upgrade === null || upgrade === void 0 ? void 0 : upgrade.topBannerVisible);
  };

  var fetchOTP = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _upgrade$selectedUpgr7;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              generateOneTimePin(upgrade === null || upgrade === void 0 ? void 0 : (_upgrade$selectedUpgr7 = upgrade.selectedUpgradeResponse) === null || _upgrade$selectedUpgr7 === void 0 ? void 0 : _upgrade$selectedUpgr7.msisdn);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchOTP() {
      return _ref2.apply(this, arguments);
    };
  }();

  var checkIdleTimeSpan = function checkIdleTimeSpan() {
    var IDLE_TIMEOUT = 1200;
    var secondCounter = idleCounter;

    if (secondCounter == IDLE_TIMEOUT) {
      displayHideUpgradeModal(true);
      updateJourneyStatus(null, upgradeService/* upgradeStages.OTP_ENRTY */.wv.OTP_ENRTY);
      fetchOTP();
    } else if (secondCounter > IDLE_TIMEOUT) {
      setIdleCounter(0);
    }
  };

  var checkIdleTime = function checkIdleTime(idleCounter) {
    document.addEventListener('click', function (e) {
      setIdleCounter(0);
    }, false);

    document.onkeypress = function () {
      setIdleCounter(0);
    };

    if (isEligible()) {
      checkIdleTimeSpan(idleCounter);
    }
  };

  (0,react.useEffect)(function () {
    if (isEligible()) {
      setContractMode('upgrade');
    }
  }, []);
  (0,react.useEffect)(function () {
    var interval = setInterval(function () {
      setIdleCounter(idleCounter + 1);
      checkIdleTime(idleCounter);
    }, 1000);
    return function () {
      return clearInterval(interval);
    };
  }, [idleCounter]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: isEligible() ? 'upgradeVisible' : '',
    children: isEligible() && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (UpgradeBanner_module_default()).banner,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container ".concat((UpgradeBanner_module_default()).banner),
        id: "seeUpgradeDetails",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (UpgradeBanner_module_default()).wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (UpgradeBanner_module_default()).message,
            children: [!isMobile && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              className: (UpgradeBanner_module_default()).text,
              children: [labels/* default.product_affordability.lbl_upgrade_banner */.Z.product_affordability.lbl_upgrade_banner, " ", upgrade === null || upgrade === void 0 ? void 0 : (_upgrade$selectedUpgr8 = upgrade.selectedUpgradeResponse) === null || _upgrade$selectedUpgr8 === void 0 ? void 0 : _upgrade$selectedUpgr8.msisdn]
            }), isMobile && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              className: (UpgradeBanner_module_default()).text,
              children: [labels/* default.product_affordability.lbl_busy_mobile */.Z.product_affordability.lbl_busy_mobile, " ", upgrade === null || upgrade === void 0 ? void 0 : (_upgrade$selectedUpgr9 = upgrade.selectedUpgradeResponse) === null || _upgrade$selectedUpgr9 === void 0 ? void 0 : _upgrade$selectedUpgr9.msisdn]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: (UpgradeBanner_module_default()).button,
            onClick: onSeeDetails,
            children: "Cancel"
          })]
        })
      })
    })
  });
};

var UpgradeBanner_mapStateToProps = function mapStateToProps(state) {
  return {
    upgrade: state.upgrade
  };
};

/* harmony default export */ var upgradeBanner_UpgradeBanner = ((0,es/* connect */.$j)(UpgradeBanner_mapStateToProps, {
  displayHideUpgradeTopbannerModal: upgradeAction/* displayHideUpgradeTopbannerModal */.Ri,
  displayHideUpgradeModal: upgradeAction/* displayHideUpgradeModal */.ex,
  updateJourneyStatus: upgradeAction/* updateJourneyStatus */.aI,
  generateOneTimePin: upgradeAction/* generateOneTimePin */.ow,
  setContractMode: dealBuilderAction/* setContractMode */.I
})(UpgradeBanner));
// EXTERNAL MODULE: ./components/organisms/upgradeContainer/UpgradeContainer.module.scss
var UpgradeContainer_module = __webpack_require__(61373);
var UpgradeContainer_module_default = /*#__PURE__*/__webpack_require__.n(UpgradeContainer_module);
// EXTERNAL MODULE: ./components/molecules/upgradeModal/UpgradeModal.jsx
var UpgradeModal = __webpack_require__(27575);
// EXTERNAL MODULE: ./components/atoms/snackBar/SnackBar.jsx
var SnackBar = __webpack_require__(52932);
// EXTERNAL MODULE: ./components/molecules/errorToolTip/ErrorTooltip.jsx
var ErrorTooltip = __webpack_require__(94029);
// EXTERNAL MODULE: ./components/atoms/toolTip/Tooltip.jsx
var Tooltip = __webpack_require__(7971);
// EXTERNAL MODULE: ./components/atoms/snackBar/SnackBar.module.scss
var SnackBar_module = __webpack_require__(59544);
var SnackBar_module_default = /*#__PURE__*/__webpack_require__.n(SnackBar_module);
// EXTERNAL MODULE: ./components/atoms/CTAButton/CTAButton.jsx
var CTAButton = __webpack_require__(79549);
;// CONCATENATED MODULE: ./components/atoms/snackBar/SnackBarWithButton.jsx






var SnackBarWithButton = function SnackBarWithButton(props) {
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: props.isVisible ? "".concat((SnackBar_module_default()).snackBar, " ").concat(props.className) : "",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (SnackBar_module_default()).snackBar__titleContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
        className: (SnackBar_module_default()).snackBar__title,
        children: props.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        className: (SnackBar_module_default()).snackBar__titleContainer__closeImage,
        onClick: props.closeSnackBar,
        src: "".concat(imagePrefix, "/assets/images/close-white.svg"),
        alt: "placeholder"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
      className: (SnackBar_module_default()).snackBar__description,
      children: props.description
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
      variant: "solid white",
      className: (SnackBar_module_default()).snackBar__button,
      handleClick: function handleClick() {
        return props.buttonHandler();
      },
      children: props.btnText
    })]
  });
};

/* harmony default export */ var snackBar_SnackBarWithButton = (SnackBarWithButton);
// EXTERNAL MODULE: ./components/atoms/snackBar/SnackBarWithDismiss.module.scss
var SnackBarWithDismiss_module = __webpack_require__(90326);
var SnackBarWithDismiss_module_default = /*#__PURE__*/__webpack_require__.n(SnackBarWithDismiss_module);
;// CONCATENATED MODULE: ./components/atoms/snackBar/SnackBarWithDismiss.jsx





var SnackBarWithDismiss = function SnackBarWithDismiss(props) {
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: props.isVisible ? "".concat((SnackBarWithDismiss_module_default()).snackBar, " ").concat(props.className) : "",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (SnackBarWithDismiss_module_default()).snackBar__msgContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
        className: (SnackBarWithDismiss_module_default()).snackBar__label,
        children: props.message
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (SnackBarWithDismiss_module_default()).snackBar__dismissContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        onClick: props.closeSnackBar,
        className: (SnackBarWithDismiss_module_default()).dismissLink,
        children: "Dismiss"
      })
    })]
  });
};

/* harmony default export */ var snackBar_SnackBarWithDismiss = (SnackBarWithDismiss);
;// CONCATENATED MODULE: ./components/organisms/upgradeContainer/UpgradeContainer.jsx




function UpgradeContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function UpgradeContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? UpgradeContainer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : UpgradeContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





















var UpgradeContainer = function UpgradeContainer(props) {
  var _props$upgradeDisplay14, _props$upgradeDisplay15, _props$upgradeDisplay16, _props$upgradeDisplay17, _props$upgradeDisplay18, _props$upgradeDisplay19, _props$upgradeDisplay20, _props$upgradeDisplay21, _props$upgradeDisplay22, _props$upgradeDisplay23, _props$upgradeDisplay24, _props$upgradeDisplay25, _props$upgradeDisplay26, _props$upgradeDisplay27, _props$upgradeRespons7, _props$upgradeRespons8;

  var numRegEx = RegExp(/^[0-9]*$/);
  var cellPhoneRegEx = RegExp(/^0[0-9]*$/);
  var msisdnRegEx = RegExp(/^27[0-9]*$/);
  var router = (0,DependencyHelper.useRouter)();

  var _useState = (0,react.useState)(props.unMaskedMsisdn || ""),
      msisdn = _useState[0],
      setMsisdn = _useState[1];

  var _useState2 = (0,react.useState)(true),
      otpCheckBox = _useState2[0],
      setOtpCheckBox = _useState2[1];

  var _useState3 = (0,react.useState)(Array(4).fill("")),
      otp = _useState3[0],
      setOtp = _useState3[1];

  var _useState4 = (0,react.useState)(),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      showSnackBar = _useState5[0],
      setShowSnackBar = _useState5[1];

  var _useState6 = (0,react.useState)({
    visible: false,
    message: ""
  }),
      showErrorToolTip = _useState6[0],
      setShowErrorToolTip = _useState6[1];

  var _useState7 = (0,react.useState)(""),
      selectedNumber = _useState7[0],
      setSelectedNumber = _useState7[1];

  var _useState8 = (0,react.useState)(),
      newOtp = _useState8[0],
      setNewOtp = _useState8[1];

  var _useState9 = (0,react.useState)(false),
      mahConsentCheck = _useState9[0],
      setMahConsentCheck = _useState9[1];

  var _useState10 = (0,react.useState)([]),
      resultNumbers = _useState10[0],
      setResultNumbers = _useState10[1];

  var _useState11 = (0,react.useState)(""),
      selectedResultNumber = _useState11[0],
      setSelectedResultNumber = _useState11[1];

  var _useState12 = (0,react.useState)(false),
      showAddnlInfo = _useState12[0],
      setShowAddnlInfo = _useState12[1];

  var _useState13 = (0,react.useState)(props.unMaskedMsisdn),
      selectedLinkedNumber = _useState13[0],
      setSelectedLinkedNumber = _useState13[1];

  var _useState14 = (0,react.useState)(""),
      numberWhereOTPSent = _useState14[0],
      setNumberWhereOTPSent = _useState14[1];

  var _useState15 = (0,react.useState)(""),
      currentPageName = _useState15[0],
      setCurrentPageName = _useState15[1];

  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  var maxRetriesCount = (config_default()).maxRetriesCount;
  var shoppingUrlPrefix = (config_default()).envConfigs[env].shoppingUrlPrefix;
  var isMobile = (0,helperServices/* componentResize */.Y4)();

  var toggleModal = function toggleModal(upgradeCheckDone) {
    var status = upgradeCheckDone ? upgradeCheckDone : props.upgradeCheckDone;

    if (DependencyHelper.Router.asPath != "/shopping/upgrade" || !status) {
      resetUpgradeJourney();
    }

    props.displayHideUpgradeModal(!props.showModal);
    analyticsUtag/* setPageName */.t0(currentPageName);
    setCurrentPageName("");
  };

  var dismissModal = function dismissModal() {
    var pageName = analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;
    analyticsUtag/* link */.p4(UpgradeContainer_objectSpread({
      page_tool_event: "use",
      page_tool_name: "".concat(pageName, ": dismiss")
    }, getUtagViewData()));
    closeModal();
  };

  (0,react.useEffect)(function () {
    var _window;

    if ((_window = window) !== null && _window !== void 0 && _window.location.reload) {
      if (props.journeyStatus == (upgradeService/* upgradeStages.NUMBER_ENRTY */.wv.NUMBER_ENRTY || upgradeService/* upgradeStages.NUMBER_SELECTupgradeStages.OTP_ENRTY */.wv.NUMBER_SELECTupgradeStages.OTP_ENRTY || upgradeService/* upgradeStages.UPGRADE_RESULT */.wv.UPGRADE_RESULT || upgradeService/* upgradeStages.TECHNICAL_ERROR */.wv.TECHNICAL_ERROR || upgradeService/* upgradeStages.ELIGIBLE_NUMBER_SELECT */.wv.ELIGIBLE_NUMBER_SELECT) || !props.upgradeCheckDone) {
        props.clearUpgradeJourney();
      }
    }
  }, []);

  var closeModal = function closeModal() {
    if (props.userLoggedIn) {
      props.displayHideUpgradeModal(!props.showModal);
      analyticsUtag/* setPageName */.t0(currentPageName);
      setCurrentPageName("");
    } else {
      toggleModal();

      if (!(DependencyHelper.Router.asPath == "/shopping/upgrade") || !props.upgradeCheckDone) {
        props.clearUpgradeJourney();
      }
    }

    if (props.invalidOTPTries > 0 && props.invalidOTPTries < maxRetriesCount) {
      props.displayInvalidOTPError(false);
      setShowErrorToolTip({
        visible: false,
        message: ""
      });
    }

    if (props.upgradeCheckDone == true && props.journeyStatus == upgradeService/* upgradeStages.OTP_ENRTY */.wv.OTP_ENRTY) {
      props.clearUpgradeJourney();
      (0,upgradeService/* resetFiltersOnStopUpgrade */.Jo)(DependencyHelper.Router === null || DependencyHelper.Router === void 0 ? void 0 : DependencyHelper.Router.pathname);
      (0,helperServices/* hideSpinner */.v3)();
    }
  };

  var resetUpgradeJourney = function resetUpgradeJourney() {
    setShowErrorToolTip({
      visible: false,
      message: ""
    });
    setOtp(Array(4).fill(""));
    setMsisdn("");
    setOtpCheckBox(true);
    setMahConsentCheck(false);
    setShowAddnlInfo(false);
    setResultNumbers([]);
    setSelectedResultNumber("");
    setErrorMessage();
  };

  (0,react.useEffect)(function () {
    if (!props.userLoggedIn && !props.allUpgradesData.length || props.userLoggedIn && props.allUpgradesData.length > 0) {
      var msisdnsFilter = props.subscriptions.filter(function (subs) {
        if (subs.type === 1) {
          return subs.subscriptionId;
        }
      });
      var msisdns = msisdnsFilter.map(function (item) {
        return item.subscriptionId;
      });

      if (msisdns.length > 0) {
        var _props$profileData;

        (0,helperServices/* showSpinner */.yh)();
        props.eligibilityForLinkedNumbersList(msisdns, props === null || props === void 0 ? void 0 : (_props$profileData = props.profileData) === null || _props$profileData === void 0 ? void 0 : _props$profileData.firstname);
      }
    }
  }, [props.userLoggedIn]);

  var recommendedNavigate = function recommendedNavigate() {
    props.toggleSnackBar(false);

    if ((0,upgradeService/* checkifUpgradableAndC3D */.Yo)(props.resultCode)) {
      (0,helperServices/* showSpinner */.yh)();
      router.push("".concat(shoppingUrlPrefix, "/upgrade")).then(function () {
        window.scrollTo(0, 0);
        props.updateEligibiltyCheckStatus(true);
        (0,helperServices/* hideSpinner */.v3)();
      });
    } else {
      props.displayHideUpgradeModal(true);
    }

    analyticsUtag/* link */.p4(UpgradeContainer_objectSpread({
      link_type: "o",
      link_name: "".concat(analyticsUtag/* getUtagData */.GS(["page_name"]).page_name, ": snackbar ").concat(labels/* default.upgrade.lbl_snackbar_btn_text */.Z.upgrade.lbl_snackbar_btn_text)
    }, getUtagViewData()));
  };

  var closeUpgradeSnackBar = function closeUpgradeSnackBar() {
    analyticsUtag/* link */.p4(UpgradeContainer_objectSpread({
      page_tool_event: "use",
      page_tool_name: "".concat(analyticsUtag/* getUtagData */.GS(["page_name"]).page_name, ": snackbar dismiss")
    }, getUtagViewData()));
    props.toggleSnackBar(false);
  };

  (0,react.useEffect)(function () {
    var message = "";
    var occurance = "";

    if (props.invalidOTPTries > 0 && props.invalidOTPTries < maxRetriesCount) {
      if (props.invalidOTPTries === maxRetriesCount - 1) {
        message = labels/* default.upgrade.lbl_invalid_otp_try_2 */.Z.upgrade.lbl_invalid_otp_try_2;
        occurance = "twice";
      } else {
        message = labels/* default.upgrade.lbl_invalid_otp_try_1 */.Z.upgrade.lbl_invalid_otp_try_1;
        occurance = "once";
      }

      setOtp(Array(4).fill(""));

      if (props.isDisplayInvalidOTPError) {
        setShowErrorToolTip({
          visible: true,
          message: message
        });
      }

      analyticsUtag/* view */.ei(UpgradeContainer_objectSpread(UpgradeContainer_objectSpread({}, getUtagViewData()), {}, {
        page_name: "shopping: upgrade: eligibility: otp failed ".concat(occurance)
      }));
    } else if (props.invalidOTPTries === maxRetriesCount) {
      (0,helperServices/* showSpinner */.yh)();
      resetUpgradeJourney();
      props.clearUpgradeJourney();
      router.push("/shopping/error").then(function () {
        window.scrollTo(0, 0);
        (0,helperServices/* hideSpinner */.v3)();
      });
    }
  }, [props.invalidOTPTries]);
  (0,react.useEffect)(function () {
    if (showSnackBar) {
      var timer = setTimeout(function () {
        return closeSnackBar();
      }, 3000);
      return function () {
        clearTimeout(timer);
      };
    }
  }, [showSnackBar]);
  (0,react.useEffect)(function () {
    function getCreditfilters() {
      return _getCreditfilters.apply(this, arguments);
    }

    function _getCreditfilters() {
      _getCreditfilters = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var isProductPage, isDealBuilderPage, affordCode, creditFilters, _ref, financeIndicator, total_monthly_payment, deviceInstallment, _props$devicePrice, _props$upgradeRespons, result, _result$response, _result$response$data;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                isProductPage = (0,upgradeService/* checkIfFromDetailPage */.Ip)(DependencyHelper.Router.asPath);
                isDealBuilderPage = DependencyHelper.Router.asPath.includes("/shopping/deal-builder");
                affordCode = (0,upgradeService/* fetchAffordCode */.x2)(DependencyHelper.Router.asPath);

                if (!((0,upgradeService/* checkifUpgradableAndC3D */.Yo)(props.resultCode) && (isProductPage || isDealBuilderPage))) {
                  _context.next = 25;
                  break;
                }

                _context.next = 7;
                return props.fetchCreditFilters(props.upgradeResponse.msisdn);

              case 7:
                creditFilters = _context.sent;

                if (creditFilters.fail) {
                  _context.next = 21;
                  break;
                }

                _ref = creditFilters || {}, financeIndicator = _ref.financeIndicator, total_monthly_payment = _ref.total_monthly_payment, deviceInstallment = _ref.deviceInstallment;
                props.setMaxRecurring(total_monthly_payment);

                if (!(0,upgradeService/* checkIfFromDealDetailPage */.U4)(DependencyHelper.Router.asPath)) {
                  _context.next = 18;
                  break;
                }

                _context.next = 14;
                return props.getRecommendedDeals(props.unMaskedMsisdn, "", "", "", total_monthly_payment, Number(deviceInstallment), financeIndicator, (_props$devicePrice = props.devicePrice) === null || _props$devicePrice === void 0 ? void 0 : _props$devicePrice.sku, (_props$upgradeRespons = props.upgradeResponse) === null || _props$upgradeRespons === void 0 ? void 0 : _props$upgradeRespons.simOnlyUpgradeFlg);

              case 14:
                result = _context.sent;

                if (result.fail) {
                  props.displayHideUpgradeModal(true);
                  props.updateJourneyStatus(upgradeService/* errorCodes.service_down */.Zk.service_down, upgradeService/* upgradeStages.TECHNICAL_ERROR */.wv.TECHNICAL_ERROR);
                } else {
                  if ((result === null || result === void 0 ? void 0 : (_result$response = result.response) === null || _result$response === void 0 ? void 0 : (_result$response$data = _result$response.data) === null || _result$response$data === void 0 ? void 0 : _result$response$data.isUpgradeAffordable) === "N") {
                    props.fetchDisplayDetails(affordCode);
                  } else {
                    props.fetchDisplayDetails(props.resultCode);
                  }
                }

                _context.next = 19;
                break;

              case 18:
                if (financeIndicator && financeIndicator === "Y" && Number(props.devicePrice.devicePrice) > Number(total_monthly_payment)) {
                  props.fetchDisplayDetails(affordCode);
                } else if (financeIndicator && financeIndicator === "N" && (Number(props.devicePrice.devicePrice) > Number(total_monthly_payment) || Number(props.devicePrice.installment) > Number(deviceInstallment))) {
                  props.fetchDisplayDetails(affordCode);
                } else {
                  props.fetchDisplayDetails(props.resultCode);
                }

              case 19:
                _context.next = 23;
                break;

              case 21:
                props.displayHideUpgradeModal(true);
                props.updateJourneyStatus(upgradeService/* errorCodes.service_down */.Zk.service_down, upgradeService/* upgradeStages.TECHNICAL_ERROR */.wv.TECHNICAL_ERROR);

              case 23:
                _context.next = 26;
                break;

              case 25:
                props.fetchDisplayDetails(props.resultCode);

              case 26:
                _context.next = 31;
                break;

              case 28:
                _context.prev = 28;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0);

              case 31:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 28]]);
      }));
      return _getCreditfilters.apply(this, arguments);
    }

    if (props.resultCode && (props.journeyStatus === upgradeService/* upgradeStages.UPGRADE_RESULT */.wv.UPGRADE_RESULT || props.journeyStatus === upgradeService/* upgradeStages.TECHNICAL_ERROR */.wv.TECHNICAL_ERROR)) {
      getCreditfilters();
    }
  }, [props === null || props === void 0 ? void 0 : props.journeyStatus, props.resultCode]); // Check for upgrade eligibility pre-checkout

  (0,react.useEffect)(function () {
    var _props$allUpgradesDat;

    var showMultipleNumbers = true;
    var upgradableNumbers = 0;
    var foundMsisdn = false;

    if ((props === null || props === void 0 ? void 0 : (_props$allUpgradesDat = props.allUpgradesData) === null || _props$allUpgradesDat === void 0 ? void 0 : _props$allUpgradesDat.length) > 0) {
      var msisdns = props.allUpgradesData.map(function (item, index) {
        if ((0,upgradeService/* maskMsisdn */.Ly)(item.msisdn) === (0,upgradeService/* maskMsisdn */.Ly)(props.unMaskedMsisdn)) {
          foundMsisdn = true;
          showMultipleNumbers = item === null || item === void 0 ? void 0 : item.mah;
          setSelectedResultNumber(item.upgradeEligible ? "".concat((0,upgradeService/* maskMsisdn */.Ly)(item.msisdn), " (Upgradeable)") : "".concat((0,upgradeService/* maskMsisdn */.Ly)(item.msisdn), " (Not upgradeable)"));
        }

        if (item.upgradeEligible) {
          upgradableNumbers = upgradableNumbers + 1;
        }

        return {
          num: item.msisdn,
          id: index + 1,
          label: item.upgradeEligible ? "".concat((0,upgradeService/* maskMsisdn */.Ly)(item.msisdn), " (Upgradeable)") : "".concat((0,upgradeService/* maskMsisdn */.Ly)(item.msisdn), " (Not upgradeable)"),
          upgradeEligible: item.upgradeEligible
        };
      });

      if (showMultipleNumbers) {
        setShowAddnlInfo(upgradableNumbers > 1);
        setResultNumbers(msisdns);
      } else {
        setResultNumbers(msisdns.filter(function (item) {
          return (0,upgradeService/* maskMsisdn */.Ly)(item.num) === (0,upgradeService/* maskMsisdn */.Ly)(props.unMaskedMsisdn);
        }));
      }

      if (!foundMsisdn) {
        setResultNumbers([]);
        setSelectedResultNumber(props.upgradeResponse.upgradeEligible ? "".concat((0,upgradeService/* maskMsisdn */.Ly)(props.upgradeResponse.msisdn), " (Upgradeable)") : "".concat((0,upgradeService/* maskMsisdn */.Ly)(props.upgradeResponse.msisdn), " (Not upgradeable)"));
      }
    }
  }, [props.allUpgradesData]);
  (0,react.useEffect)(function () {
    var _props$upgradeRespons2, _props$upgradeRespons3, _props$upgradeRespons4;

    setSelectedResultNumber(props !== null && props !== void 0 && (_props$upgradeRespons2 = props.upgradeResponse) !== null && _props$upgradeRespons2 !== void 0 && _props$upgradeRespons2.upgradeEligible ? "".concat((0,upgradeService/* maskMsisdn */.Ly)(props === null || props === void 0 ? void 0 : (_props$upgradeRespons3 = props.upgradeResponse) === null || _props$upgradeRespons3 === void 0 ? void 0 : _props$upgradeRespons3.msisdn), " (Upgradeable)") : "".concat((0,upgradeService/* maskMsisdn */.Ly)(props === null || props === void 0 ? void 0 : (_props$upgradeRespons4 = props.upgradeResponse) === null || _props$upgradeRespons4 === void 0 ? void 0 : _props$upgradeRespons4.msisdn), " (Not upgradeable)"));
  }, [props.upgradeResponse]);

  var handleNewSelect = function handleNewSelect(selectedValue) {
    setSelectedResultNumber(selectedValue);
    var upgradableNumbers = 0;
    resultNumbers.forEach(function (item) {
      if (item.label === selectedValue) {
        var newResult = props.allUpgradesData.find(function (value) {
          return value.msisdn === item.num;
        });
        props.updateData(newResult);
      } else {
        if (item.upgradeEligible) {
          upgradableNumbers = upgradableNumbers + 1;
        }
      }
    });
    setShowAddnlInfo(upgradableNumbers > 0);
  };

  var closeSnackBar = function closeSnackBar() {
    setShowSnackBar(false);
  };

  var getErrorMessage = function getErrorMessage(value) {
    if (value && value.length > 0) {
      if (numRegEx.test(value)) {
        if (!(cellPhoneRegEx.test(value) || msisdnRegEx.test(value))) {
          setErrorMessage(labels/* default.upgrade.lbl_error_zero */.Z.upgrade.lbl_error_zero);
        } else {
          setErrorMessage("");
        }
      } else {
        setErrorMessage(labels/* default.upgrade.lbl_error_numbers */.Z.upgrade.lbl_error_numbers);
      }
    } else {
      setErrorMessage(labels/* default.upgrade.lbl_error_enter_number */.Z.upgrade.lbl_error_enter_number);
    }
  };

  var getUtagViewData = function getUtagViewData() {
    return analyticsUtag/* getUtagData */.GS(["visitor_customer_id", "visitor_login_status", "visitor_subscription_type", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "page_site_section_lvl_4", "visitor_msisdn_hash", "page_name", "page_channel", "page_master_tab", "upgrade_eligibility_status", "upgrade_ineligible_reason", "upgrade_eligible_date", "upgrade_customer_type"]);
  };

  var checkAndUpdateMsisdn = function checkAndUpdateMsisdn(event) {
    getErrorMessage(event.target.value);
    setMsisdn(event.target.value);
  };

  var handleOnBlur = function handleOnBlur() {
    if (errorMessage) {
      analyticsUtag/* link */.p4({
        page_name: analyticsUtag/* getPageName */.j0(),
        page_form_name: labels/* default.upgrade.lbl_enter_msisdn_title */.Z.upgrade.lbl_enter_msisdn_title,
        page_form_event: "error",
        page_errors: errorMessage,
        page_error_type: "form"
      });
    }
  };

  var updateCheckBox = function updateCheckBox(e) {
    setOtpCheckBox(!otpCheckBox);
    props.updateCanReciveOTP(!otpCheckBox);
    var pageName = analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;
    analyticsUtag/* link */.p4(UpgradeContainer_objectSpread({
      page_tool_event: "use",
      page_tool_name: "".concat(pageName, ": ").concat(otpCheckBox ? "I can't use sms" : "I can use sms")
    }, getUtagViewData()));
  };

  var validateOTP = function validateOTP() {
    var otpValue = otp.join("");
    analyticsUtag/* link */.p4(UpgradeContainer_objectSpread({
      link_type: "o",
      link_name: "".concat(analyticsUtag/* getUtagData */.GS(["page_name"]).page_name, ": ").concat(labels/* default.upgrade.lbl_btn_submit_otp */.Z.upgrade.lbl_btn_submit_otp)
    }, getUtagViewData())); //call for validating OTP

    setShowErrorToolTip({
      visible: false,
      message: ""
    });

    if (otpCheckBox && props.canReciveOTP) {
      props.getAllEligibility(msisdn || props.unMaskedMsisdn, otpValue).then(function () {
        setOtp(Array(4).fill(""));
        setOtpCheckBox(true);
      });
    } else {
      props.getEligibilityForAlternativeNumbers(msisdn || props.unMaskedMsisdn, selectedNumber || props.msisdnEntered, otpValue).then(function () {
        setOtp(Array(4).fill(""));
        setOtpCheckBox(true);
      });
    }

    props.updateUnmaskedMsisdn(msisdn || props.unMaskedMsisdn);
  };

  var getLinkedNumbers = function getLinkedNumbers() {
    //call to fetch linked numbers to msisdn
    props.fetchAlternateNumbers(msisdn);
  };

  var fetchOTP = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              //call for sending OTP
              props.generateOneTimePin(msisdn);
              setNumberWhereOTPSent((0,upgradeService/* maskMsisdn */.Ly)(msisdn));

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetchOTP() {
      return _ref2.apply(this, arguments);
    };
  }();

  var generateOTPforLinkedNumber = function generateOTPforLinkedNumber(value) {
    //props.updateMsisdnStatus(value, true);
    props.generateOTP(msisdn, value);
    setSelectedNumber(value);
    setNumberWhereOTPSent((0,upgradeService/* maskMsisdn */.Ly)(value));
    props.updateLinkedNumber(value);
  };

  var onClickContinue = function onClickContinue() {
    analyticsUtag/* link */.p4(UpgradeContainer_objectSpread({
      link_type: "o",
      link_name: "".concat(analyticsUtag/* getUtagData */.GS(["page_name"]).page_name, ": ").concat(labels/* default.upgrade.lbl_btn_continue */.Z.upgrade.lbl_btn_continue)
    }, getUtagViewData()));

    if (otpCheckBox) {
      fetchOTP();
    } else {
      getLinkedNumbers();
    }

    props.updateUnmaskedMsisdn(msisdn);
    props.updateMsisdnStatus((0,upgradeService/* maskMsisdn */.Ly)(msisdn), true);
  };

  var resendOTP = function resendOTP() {
    var _Analytics$getUtagDat;

    //call for resend OTP
    var pageName = (_Analytics$getUtagDat = analyticsUtag/* getUtagData */.GS(["page_name"])) === null || _Analytics$getUtagDat === void 0 ? void 0 : _Analytics$getUtagDat.page_name;
    analyticsUtag/* link */.p4(UpgradeContainer_objectSpread({
      page_tool_event: "use",
      page_tool_name: "".concat(pageName, ": resend otp")
    }, getUtagViewData()));

    if (otpCheckBox) {
      fetchOTP();
    } else {
      props.generateOTP(msisdn, selectedNumber);
    }

    setShowSnackBar(true);
    closeErrorToolTip();
  };

  var navigateTo = function navigateTo(url) {
    var _props$resultCode;

    if (!(0,upgradeService/* checkifUpgradableAndC3D */.Yo)(props === null || props === void 0 ? void 0 : (_props$resultCode = props.resultCode) === null || _props$resultCode === void 0 ? void 0 : _props$resultCode.toLowerCase())) {
      closeModal();

      if (url) {
        navigateRedirection(url);
      }
    } else {
      props.updateSelectedData(props.upgradeResponse);
      setMahConsentCheck(false);
      props.displayHideUpgradeTopbanner(true);
      toggleModal(true);
      props.updateEligibiltyCheckStatus(true);
      props.resetInvalidOtps();

      if ((0,upgradeService/* checkIfFromDealDetailPage */.U4)(DependencyHelper.Router.asPath)) {
        var _props$creditFilters, _props$creditFilters2, _props$creditFilters3, _props$devicePrice2, _props$upgradeRespons5;

        props.getRecommendedDeals(props.unMaskedMsisdn, "", "", "", (_props$creditFilters = props.creditFilters) === null || _props$creditFilters === void 0 ? void 0 : _props$creditFilters.total_monthly_payment, Number((_props$creditFilters2 = props.creditFilters) === null || _props$creditFilters2 === void 0 ? void 0 : _props$creditFilters2.deviceInstallment), (_props$creditFilters3 = props.creditFilters) === null || _props$creditFilters3 === void 0 ? void 0 : _props$creditFilters3.financeIndicator, (_props$devicePrice2 = props.devicePrice) === null || _props$devicePrice2 === void 0 ? void 0 : _props$devicePrice2.sku, (_props$upgradeRespons5 = props.upgradeResponse) === null || _props$upgradeRespons5 === void 0 ? void 0 : _props$upgradeRespons5.simOnlyUpgradeFlg).then(function (result) {
          if (result.fail) {
            props.displayHideUpgradeModal(true);
            props.updateJourneyStatus(upgradeService/* errorCodes.service_down */.Zk.service_down, upgradeService/* upgradeStages.TECHNICAL_ERROR */.wv.TECHNICAL_ERROR);
          } else {
            var _result$response2, _result$response2$dat;

            if ((result === null || result === void 0 ? void 0 : (_result$response2 = result.response) === null || _result$response2 === void 0 ? void 0 : (_result$response2$dat = _result$response2.data) === null || _result$response2$dat === void 0 ? void 0 : _result$response2$dat.isUpgradeAffordable) === "N") {
              navigateRedirection(url);
            } else {
              (0,upgradeService/* handoverUpgradeeSession */.I0)(props.canReciveOTP, props.isChildAllowed, props.upgradeResponse); // navigateRedirection(props.upgradeLink.link);

              props.addDealToCart(true);
            }
          }
        });
      } else if ((0,upgradeService/* checkIfFromDetailPage */.Ip)(DependencyHelper.Router.asPath)) {
        if (props.creditFilters.financeIndicator === "Y" && Number(props.devicePrice.devicePrice) > Number(props.creditFilters.total_monthly_payment)) {
          navigateRedirection(url);
        } else if (props.creditFilters.financeIndicator === "N") {
          if (Number(props.devicePrice.devicePrice) > Number(props.creditFilters.total_monthly_payment)) {
            navigateRedirection(url);
          } else if (Number(props.devicePrice.installment) > Number(props.creditFilters.deviceInstallment)) {
            navigateRedirection(url);
          } else {
            navigateRedirection(props.upgradeLink.link);
          }
        } else {
          navigateRedirection(props.upgradeLink.link);
        }
      } else {
        var _props$upgradeRespons6;

        props.fetchCreditFilters(props === null || props === void 0 ? void 0 : (_props$upgradeRespons6 = props.upgradeResponse) === null || _props$upgradeRespons6 === void 0 ? void 0 : _props$upgradeRespons6.msisdn);
        (0,upgradeService/* handoverUpgradeeSession */.I0)(props.canReciveOTP, props.isChildAllowed, props.upgradeResponse);
      }
    }
  };

  var navigateRedirection = function navigateRedirection(url) {
    (0,helperServices/* showSpinner */.yh)();
    (0,upgradeService/* handoverUpgradeeSession */.I0)(props.canReciveOTP, props.isChildAllowed, props.upgradeResponse);
    router === null || router === void 0 ? void 0 : router.push(url).then(function () {
      (0,helperServices/* hideSpinner */.v3)();
    });
  };

  (0,react.useEffect)(function () {
    var numArray = [];

    for (var i = 0; i < otp.length; i++) {
      if (otp[i] != "") {
        numArray.push(otp[i]);
      }
    }

    setNewOtp(numArray);
  }, [otp]);

  var displayErrorPopup = function displayErrorPopup() {
    analyticsUtag/* link */.p4(UpgradeContainer_objectSpread({
      link_type: "o",
      link_name: "".concat(analyticsUtag/* getUtagData */.GS(["page_name"]).page_name, ": can't otp")
    }, getUtagViewData()));
    props.updateJourneyStatus(upgradeService/* errorCodes.otp_service_down */.Zk.otp_service_down);
  };

  var fetchMaxNumber = function fetchMaxNumber(value) {
    var maxNumber = 11;

    if (cellPhoneRegEx.test(value)) {
      maxNumber = 10;
    }

    return maxNumber;
  };

  var CellNumberInput = {
    iconUrl: "".concat(imagePrefix, "/assets/images/deal-builder/upgrade-black.svg"),
    title: labels/* default.upgrade.lbl_enter_msisdn_title */.Z.upgrade.lbl_enter_msisdn_title,
    analyticTitle: "shopping: upgrade: eligibility: pop up",
    description: labels/* default.upgrade.lbl_enter_msisdn_desc */.Z.upgrade.lbl_enter_msisdn_desc,
    input: true,
    inputTitle: labels/* default.upgrade.lbl_enter_msisdn_input_title */.Z.upgrade.lbl_enter_msisdn_input_title,
    onChangeHandler: checkAndUpdateMsisdn,
    onBlurHandler: handleOnBlur,
    errorMessage: errorMessage,
    maxLength: fetchMaxNumber(msisdn),
    checkbox: true,
    checkValue: otpCheckBox,
    checkBoxText: labels/* default.upgrade.lbl_enter_msisdn_checkbox_text */.Z.upgrade.lbl_enter_msisdn_checkbox_text,
    checkBoxHandler: updateCheckBox,
    primaryButtonText: labels/* default.upgrade.lbl_btn_continue */.Z.upgrade.lbl_btn_continue,
    primaryButtonDisabled: !((msisdn === null || msisdn === void 0 ? void 0 : msisdn.length) === fetchMaxNumber(msisdn)) || errorMessage,
    primaryButtonStyle: !((msisdn === null || msisdn === void 0 ? void 0 : msisdn.length) === fetchMaxNumber(msisdn)) || errorMessage ? "solid light gray" : "solid red",
    onClickHandlerPrimary: onClickContinue
  };
  var OTPInput = {
    title: labels/* default.upgrade.lbl_enter_otp_title */.Z.upgrade.lbl_enter_otp_title,
    analyticTitle: "shopping: upgrade: eligibility: enter otp",
    description: isMobile ? "".concat(labels/* default.upgrade.lbl_enter_otp_desc_prefix */.Z.upgrade.lbl_enter_otp_desc_prefix, " ").concat(numberWhereOTPSent ? numberWhereOTPSent : props.msisdnEntered, " ").concat(labels/* default.upgrade.lbl_enter_otp_desc_suffix */.Z.upgrade.lbl_enter_otp_desc_suffix) : "".concat(labels/* default.upgrade.lbl_enter_otp_desc_prefix */.Z.upgrade.lbl_enter_otp_desc_prefix, " ").concat(numberWhereOTPSent ? numberWhereOTPSent : props.msisdnEntered, ".<br/>").concat(labels/* default.upgrade.lbl_enter_otp_desc_suffix_v2 */.Z.upgrade.lbl_enter_otp_desc_suffix_v2),
    otpInput: true,
    invalidOTPTries: props === null || props === void 0 ? void 0 : props.invalidOTPTries,
    otpValue: otp,
    otpHandler: setOtp,
    textButton: labels/* default.upgrade.lbl_btn_resend_otp */.Z.upgrade.lbl_btn_resend_otp,
    textButtonHandler: resendOTP,
    primaryButtonText: labels/* default.upgrade.lbl_btn_submit_otp */.Z.upgrade.lbl_btn_submit_otp,
    primaryButtonStyle: newOtp && newOtp.length == 4 ? "solid red" : "solid light gray",
    primaryButtonDisabled: !(newOtp && newOtp.length == 4),
    onClickHandlerPrimary: validateOTP
  };
  var linkedNumbersData = {
    title: labels/* default.upgrade.lbl_select_number_title */.Z.upgrade.lbl_select_number_title,
    analyticTitle: "shopping: upgrade: eligibility: send otp",
    description: labels/* default.upgrade.lbl_select_number_desc */.Z.upgrade.lbl_select_number_desc,
    mobileNumbers: true,
    numbers: props.linkedNumbersList,
    selectedNumber: selectedNumber,
    handleOptionClick: generateOTPforLinkedNumber,
    textButton: labels/* default.upgrade.lbl_btn_none_otp */.Z.upgrade.lbl_btn_none_otp,
    textButtonHandler: displayErrorPopup
  };

  var updateMahConsentCheck = function updateMahConsentCheck(e) {
    setMahConsentCheck(!mahConsentCheck);
    analyticsUtag/* link */.p4(UpgradeContainer_objectSpread(UpgradeContainer_objectSpread({}, getUtagViewData()), {}, {
      page_tool_event: "use",
      page_tool_name: "".concat(analyticsUtag/* getUtagData */.GS(["page_name"]).page_name, ": ").concat(mahConsentCheck ? "mah can't provide otp" : "mah can provide otp")
    }));
  };

  var ToolTipComponent = /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
    className: (UpgradeContainer_module_default()).tooltipCheckbox,
    children: [labels/* default.upgrade.lbl_tooltip_prefix_text */.Z.upgrade.lbl_tooltip_prefix_text, /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
        text: labels/* default.upgrade.lbl_tooltip_text */.Z.upgrade.lbl_tooltip_text,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: labels/* default.upgrade.lbl_tooltip_message */.Z.upgrade.lbl_tooltip_message
        })
      }), " "]
    }), labels/* default.upgrade.lbl_tooltip_suffix_text */.Z.upgrade.lbl_tooltip_suffix_text]
  });

  var handleResultCodePrimaryCTA = function handleResultCodePrimaryCTA() {
    var _props$upgradeDisplay;

    if ((0,upgradeService/* checkIfFromDealDetailPage */.U4)(DependencyHelper.Router.asPath)) {
      var _props$devicePrice3;

      analyticsUtag/* link */.p4(UpgradeContainer_objectSpread(UpgradeContainer_objectSpread({}, getUtagViewData()), {}, {
        link_type: "o",
        link_name: "".concat(analyticsUtag/* getUtagData */.GS(["page_name"]).page_name, ": ").concat(ctaText())
      }, props === null || props === void 0 ? void 0 : (_props$devicePrice3 = props.devicePrice) === null || _props$devicePrice3 === void 0 ? void 0 : _props$devicePrice3.analyticsOptions));
    } else {
      analyticsUtag/* link */.p4(UpgradeContainer_objectSpread(UpgradeContainer_objectSpread({}, getUtagViewData()), {}, {
        link_type: "o",
        link_name: "".concat(analyticsUtag/* getUtagData */.GS(["page_name"]).page_name, ": ").concat(ctaText())
      }));
    }

    if (props !== null && props !== void 0 && (_props$upgradeDisplay = props.upgradeDisplayData) !== null && _props$upgradeDisplay !== void 0 && _props$upgradeDisplay.primaryCTAType) {
      var _props$upgradeDisplay2, _props$upgradeDisplay3;

      var url = "".concat(props === null || props === void 0 ? void 0 : (_props$upgradeDisplay2 = props.upgradeDisplayData) === null || _props$upgradeDisplay2 === void 0 ? void 0 : _props$upgradeDisplay2.primaryCTAURL, "?bucket=").concat(props === null || props === void 0 ? void 0 : (_props$upgradeDisplay3 = props.upgradeDisplayData) === null || _props$upgradeDisplay3 === void 0 ? void 0 : _props$upgradeDisplay3.leadType);
      navigateTo(url);
    } else {
      var _props$upgradeDisplay4;

      navigateTo(props === null || props === void 0 ? void 0 : (_props$upgradeDisplay4 = props.upgradeDisplayData) === null || _props$upgradeDisplay4 === void 0 ? void 0 : _props$upgradeDisplay4.primaryCTAURL);
    }
  };

  var handleResultCodeSecondaryCTA = function handleResultCodeSecondaryCTA() {
    var _props$upgradeDisplay5, _props$upgradeDisplay6;

    analyticsUtag/* link */.p4(UpgradeContainer_objectSpread(UpgradeContainer_objectSpread({}, getUtagViewData()), {}, {
      link_type: "o",
      link_name: "".concat(analyticsUtag/* getUtagData */.GS(["page_name"]).page_name, ": ").concat(props === null || props === void 0 ? void 0 : (_props$upgradeDisplay5 = props.upgradeDisplayData) === null || _props$upgradeDisplay5 === void 0 ? void 0 : _props$upgradeDisplay5.secondaryCTAText)
    }));

    if (props !== null && props !== void 0 && (_props$upgradeDisplay6 = props.upgradeDisplayData) !== null && _props$upgradeDisplay6 !== void 0 && _props$upgradeDisplay6.secondaryCTAType) {
      var _props$upgradeDisplay7, _props$upgradeDisplay8;

      var url = "".concat(props === null || props === void 0 ? void 0 : (_props$upgradeDisplay7 = props.upgradeDisplayData) === null || _props$upgradeDisplay7 === void 0 ? void 0 : _props$upgradeDisplay7.secondaryCTAURL, "?bucket=").concat(props === null || props === void 0 ? void 0 : (_props$upgradeDisplay8 = props.upgradeDisplayData) === null || _props$upgradeDisplay8 === void 0 ? void 0 : _props$upgradeDisplay8.leadType);
      navigateTo(url);
    } else {
      var _props$upgradeDisplay9;

      navigateTo(props === null || props === void 0 ? void 0 : (_props$upgradeDisplay9 = props.upgradeDisplayData) === null || _props$upgradeDisplay9 === void 0 ? void 0 : _props$upgradeDisplay9.secondaryCTAURL);
    }
  };

  var ctaText = function ctaText() {
    var _props$upgradeDisplay10, _props$upgradeDisplay11, _props$upgradeDisplay12;

    var CTAText = props === null || props === void 0 ? void 0 : (_props$upgradeDisplay10 = props.upgradeDisplayData) === null || _props$upgradeDisplay10 === void 0 ? void 0 : _props$upgradeDisplay10.primaryCTAText;

    if (router.pathname == "/shopping/upgrade" && ((props === null || props === void 0 ? void 0 : (_props$upgradeDisplay11 = props.upgradeDisplayData) === null || _props$upgradeDisplay11 === void 0 ? void 0 : _props$upgradeDisplay11.primaryCTAText) === "Choose an upgrade deal" || (props === null || props === void 0 ? void 0 : (_props$upgradeDisplay12 = props.upgradeDisplayData) === null || _props$upgradeDisplay12 === void 0 ? void 0 : _props$upgradeDisplay12.primaryCTAText) === "See all deals I qualify for")) {
      CTAText = "Upgrade this number";
    } else if ((0,upgradeService/* checkifUpgradableAndC3D */.Yo)(props === null || props === void 0 ? void 0 : props.resultCode) && props.upgradeLink.text) {
      var _props$upgradeDisplay13;

      if (unescape(props === null || props === void 0 ? void 0 : (_props$upgradeDisplay13 = props.upgradeDisplayData) === null || _props$upgradeDisplay13 === void 0 ? void 0 : _props$upgradeDisplay13.primaryCTAText) !== "Show me deals I qualify for") {
        CTAText = props.upgradeLink.text;
      }
    }

    return CTAText;
  };

  var updateSelectedLinkedData = function updateSelectedLinkedData() {
    var selectedData = props.allUpgradesData.filter(function (item) {
      if ((0,upgradeService/* maskMsisdn */.Ly)(item.msisdn) === selectedLinkedNumber) {
        return item;
      }
    });
    props.displayHideUpgradeModal(false);
    props.updateEligibiltyCheckStatus(true);
    props.fetchCreditFilters(selectedData[0].msisdn).then(function () {
      props.checkIfdealQualifies();
      props.updateData(selectedData[0]);
    });
    analyticsUtag/* setPageName */.t0(currentPageName);
    setCurrentPageName("");
  };

  var allLinkedNumbers = function allLinkedNumbers() {
    var numbers = [];
    props.allUpgradesData.forEach(function (item) {
      if (item.upgradeEligible) {
        numbers.push((0,upgradeService/* maskMsisdn */.Ly)(item.msisdn));
      }
    });
    return numbers;
  };

  var allSelctedNumber = function allSelctedNumber(value) {
    setSelectedLinkedNumber(value);
  };

  var eligibleNumbersData = {
    iconUrl: "".concat(imagePrefix, "/assets/images/success-circle.svg"),
    title: "Yes! You can upgrade right now!",
    description: "The wait is finally over!<br> Which of your upgradeable numbers would you like to upgrade now?",
    primaryButtonText: "Upgrade this number",
    onClickHandlerPrimary: updateSelectedLinkedData,
    mobileNumbers: true,
    numbers: allLinkedNumbers(),
    selectedNumber: selectedLinkedNumber,
    handleOptionClick: allSelctedNumber
  };
  var userMessage = {
    iconUrl: (props === null || props === void 0 ? void 0 : (_props$upgradeDisplay14 = props.upgradeDisplayData) === null || _props$upgradeDisplay14 === void 0 ? void 0 : _props$upgradeDisplay14.icon) || "",
    title: (props === null || props === void 0 ? void 0 : (_props$upgradeDisplay15 = props.upgradeDisplayData) === null || _props$upgradeDisplay15 === void 0 ? void 0 : _props$upgradeDisplay15.resultTitle) || "",
    analyticTitle: (props === null || props === void 0 ? void 0 : (_props$upgradeDisplay16 = props.upgradeDisplayData) === null || _props$upgradeDisplay16 === void 0 ? void 0 : _props$upgradeDisplay16.analyticTitle) || "",
    description: props !== null && props !== void 0 && (_props$upgradeDisplay17 = props.upgradeDisplayData) !== null && _props$upgradeDisplay17 !== void 0 && _props$upgradeDisplay17.resultHTML ? props === null || props === void 0 ? void 0 : (_props$upgradeDisplay18 = props.upgradeDisplayData) === null || _props$upgradeDisplay18 === void 0 ? void 0 : _props$upgradeDisplay18.resultHTML : (props === null || props === void 0 ? void 0 : (_props$upgradeDisplay19 = props.upgradeDisplayData) === null || _props$upgradeDisplay19 === void 0 ? void 0 : _props$upgradeDisplay19.resultText) || "",
    infoText: (0,upgradeService/* checkUserNextDueDateforUpgrade */.$R)(props.resultCode) ? (0,helperServices/* titleCase */.Qs)(props.upgradeResponse.upgradeDate.toLowerCase()) : "",
    checkDatabox: (0,upgradeService/* checkChildUpgradable */.IP)(props.resultCode),
    checkDataValue: mahConsentCheck,
    checkBoxDataHandler: updateMahConsentCheck,
    checkBoxData: ToolTipComponent,
    primaryButtonText: (props === null || props === void 0 ? void 0 : (_props$upgradeDisplay20 = props.upgradeDisplayData) === null || _props$upgradeDisplay20 === void 0 ? void 0 : _props$upgradeDisplay20.primaryEnabled) === "Yes" ? ctaText() : null,
    primaryButtonStyle: (props === null || props === void 0 ? void 0 : (_props$upgradeDisplay21 = props.upgradeDisplayData) === null || _props$upgradeDisplay21 === void 0 ? void 0 : _props$upgradeDisplay21.primaryEnabled) === "Yes" ? (0,upgradeService/* checkChildUpgradable */.IP)(props.resultCode) && !mahConsentCheck ? "solid light gray" : "" : null,
    primaryButtonDisabled: (props === null || props === void 0 ? void 0 : (_props$upgradeDisplay22 = props.upgradeDisplayData) === null || _props$upgradeDisplay22 === void 0 ? void 0 : _props$upgradeDisplay22.primaryEnabled) === "Yes" ? (0,upgradeService/* checkChildUpgradable */.IP)(props.resultCode) && !mahConsentCheck ? true : false : true,
    onClickHandlerPrimary: (props === null || props === void 0 ? void 0 : (_props$upgradeDisplay23 = props.upgradeDisplayData) === null || _props$upgradeDisplay23 === void 0 ? void 0 : _props$upgradeDisplay23.primaryEnabled) === "Yes" ? handleResultCodePrimaryCTA : null,
    secondaryButtonText: (props === null || props === void 0 ? void 0 : (_props$upgradeDisplay24 = props.upgradeDisplayData) === null || _props$upgradeDisplay24 === void 0 ? void 0 : _props$upgradeDisplay24.secondaryEnabled) === "Yes" ? props === null || props === void 0 ? void 0 : props.upgradeDisplayData.secondaryCTAText : null,
    secondaryButtonStyle: (props === null || props === void 0 ? void 0 : (_props$upgradeDisplay25 = props.upgradeDisplayData) === null || _props$upgradeDisplay25 === void 0 ? void 0 : _props$upgradeDisplay25.secondaryEnabled) === "Yes" ? "flat black" : null,
    secondaryButtonDisabled: (props === null || props === void 0 ? void 0 : (_props$upgradeDisplay26 = props.upgradeDisplayData) === null || _props$upgradeDisplay26 === void 0 ? void 0 : _props$upgradeDisplay26.secondaryEnabled) === "Yes" ? false : true,
    onClickHandlerSecondary: (props === null || props === void 0 ? void 0 : (_props$upgradeDisplay27 = props.upgradeDisplayData) === null || _props$upgradeDisplay27 === void 0 ? void 0 : _props$upgradeDisplay27.secondaryEnabled) === "Yes" ? handleResultCodeSecondaryCTA : null,
    dropdown: resultNumbers.length > 0 && !(0,upgradeService/* checkIfHiddenDropdown */.M$)(props === null || props === void 0 ? void 0 : (_props$upgradeRespons7 = props.upgradeResponse) === null || _props$upgradeRespons7 === void 0 ? void 0 : (_props$upgradeRespons8 = _props$upgradeRespons7.resultCode) === null || _props$upgradeRespons8 === void 0 ? void 0 : _props$upgradeRespons8.toLowerCase()),
    handleVal: handleNewSelect,
    selectedDropdownValue: selectedResultNumber,
    dropdownData: resultNumbers,
    showAddnlInfo: showAddnlInfo
  };
  (0,react.useEffect)(function () {
    if (!currentPageName) {
      setCurrentPageName(analyticsUtag/* getPageName */.j0());
    }

    var Data = displayData();
    var userMetaData = analyticsUtag/* getProfileData */.$y(props.userLoggedIn, props.profileData, props.authDetails);

    if (props.showModal) {
      debouncedAnalytics(props.resultCode, props.journeyStatus, Data.analyticTitle, Data.title, userMetaData, Data.showAddnlInfo, props.upgradeResponse);
    }
  }, [props.journeyStatus, props.showModal, props.resultCode, props.upgradeDisplayData, props.upgradeResponse]);

  var viewAnalytics = function viewAnalytics(resultCode, journeyStatus, analyticTitle, modalTitle, userMetaData, additionalInfo, upgradeResponse) {
    if (resultCode && (journeyStatus === upgradeService/* upgradeStages.UPGRADE_RESULT */.wv.UPGRADE_RESULT || journeyStatus === upgradeService/* upgradeStages.TECHNICAL_ERROR */.wv.TECHNICAL_ERROR)) {
      if (analyticTitle) {
        var upgradeStrategy = upgradeResponse;
        analyticsUtag/* view */.ei(UpgradeContainer_objectSpread(UpgradeContainer_objectSpread(UpgradeContainer_objectSpread({
          page_event: "view",
          page_name: analyticTitle.replace(/(&#039;)/g, "'"),
          page_channel: "shopping",
          page_master_tab: "personal"
        }, analyticsUtag/* getUtagData */.GS(["page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "page_site_section_lvl_4"])), {}, {
          upgrade_eligibility_status: "".concat(upgradeStrategy !== null && upgradeStrategy !== void 0 && upgradeStrategy.upgradeEligible ? upgradeStrategy === null || upgradeStrategy === void 0 ? void 0 : upgradeStrategy.upgradeEligible : false),
          upgrade_eligible_date: (upgradeStrategy === null || upgradeStrategy === void 0 ? void 0 : upgradeStrategy.upgradeDate) || "",
          upgrade_ineligible_reason: !(upgradeStrategy !== null && upgradeStrategy !== void 0 && upgradeStrategy.upgradeEligible) ? "".concat(modalTitle) : "",
          upgrade_customer_type: !upgradeStrategy ? null : upgradeStrategy !== null && upgradeStrategy !== void 0 && upgradeStrategy.c3dCustomer ? "C3D" : upgradeStrategy !== null && upgradeStrategy !== void 0 && upgradeStrategy.business ? "EBU" : "Legacy"
        }, userMetaData), {}, {
          upgrade_additional_message: additionalInfo ? labels/* default.upgrade.lbl_addnl_info */.Z.upgrade.lbl_addnl_info : null
        }));
      }
    } else {
      analyticsUtag/* view */.ei(UpgradeContainer_objectSpread(UpgradeContainer_objectSpread({
        page_event: "view",
        page_name: analyticTitle === null || analyticTitle === void 0 ? void 0 : analyticTitle.replace(/(&#039;)/g, "'"),
        page_channel: "shopping",
        page_master_tab: "personal"
      }, analyticsUtag/* getUtagData */.GS(["page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "page_site_section_lvl_4"])), userMetaData));
    }
  };

  var debouncedAnalytics = (0,react.useCallback)((0,helperServices/* debounce */.Ds)(function (resultCode, journeyStatus, analyticTitle, modalTitle, userMetaData, additionalInfo, upgradeResponse) {
    return viewAnalytics(resultCode, journeyStatus, analyticTitle, modalTitle, userMetaData, additionalInfo, upgradeResponse);
  }, 500), [] // will be created only once initially
  );

  var displayData = function displayData() {
    switch (props.journeyStatus) {
      case upgradeService/* upgradeStages.NUMBER_ENRTY */.wv.NUMBER_ENRTY:
        return CellNumberInput;

      case upgradeService/* upgradeStages.NUMBER_SELECT */.wv.NUMBER_SELECT:
        return linkedNumbersData;

      case upgradeService/* upgradeStages.OTP_ENRTY */.wv.OTP_ENRTY:
        return OTPInput;

      case upgradeService/* upgradeStages.UPGRADE_RESULT */.wv.UPGRADE_RESULT:
        return userMessage;

      case upgradeService/* upgradeStages.TECHNICAL_ERROR */.wv.TECHNICAL_ERROR:
        return userMessage;

      case upgradeService/* upgradeStages.ELIGIBLE_NUMBER_SELECT */.wv.ELIGIBLE_NUMBER_SELECT:
        return eligibleNumbersData;

      default:
        return userMessage;
    }
  };

  var closeErrorToolTip = function closeErrorToolTip() {
    setShowErrorToolTip({
      visible: false,
      message: ""
    });
    props.displayInvalidOTPError(false);
  }; // useEffect(() => {
  //   setMsisdn(props.unMaskedMsisdn);
  // }, [props.unMaskedMsisdn]);


  (0,react.useEffect)(function () {
    //do not display upgrade modal popup on first load, especially when changing pages
    props.displayHideUpgradeModal(false);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [showErrorToolTip.visible && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorTooltip/* default */.Z, {
      errorMsg: showErrorToolTip.message,
      buttonHandler: closeErrorToolTip,
      className: (UpgradeContainer_module_default()).toolTip
    }), showSnackBar && !isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(SnackBar["default"], {
      message: labels/* default.upgrade.lbl_otp_resent_info */.Z.upgrade.lbl_otp_resent_info,
      className: "defaultSnackBarStyling",
      closeSnackBar: closeSnackBar,
      isVisible: showSnackBar
    }), showSnackBar && isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(snackBar_SnackBarWithDismiss, {
      message: labels/* default.upgrade.lbl_otp_resent_info */.Z.upgrade.lbl_otp_resent_info,
      className: "defaultSnackBarStyling",
      closeSnackBar: closeSnackBar,
      isVisible: showSnackBar
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(UpgradeModal/* default */.Z, {
      showModal: props.showModal,
      displayData: displayData(),
      toggleModal: dismissModal
    }), props.showSnackBar && /*#__PURE__*/(0,jsx_runtime.jsx)(snackBar_SnackBarWithButton, {
      title: labels/* default.upgrade.lbl_snackbar_title */.Z.upgrade.lbl_snackbar_title,
      description: labels/* default.upgrade.lbl_snackbar_desc */.Z.upgrade.lbl_snackbar_desc,
      className: "defaultSnackBarStyling ".concat((UpgradeContainer_module_default()).snackBarStyle),
      btnText: labels/* default.upgrade.lbl_snackbar_btn_text */.Z.upgrade.lbl_snackbar_btn_text,
      closeSnackBar: closeUpgradeSnackBar,
      isVisible: props.showSnackBar,
      buttonHandler: recommendedNavigate
    })]
  });
};

var UpgradeContainer_mapStateToProps = function mapStateToProps(state) {
  return {
    showModal: state.upgrade.showModal,
    askForCellNumber: state.upgrade.askForCellNumber,
    canReciveOTP: state.upgrade.canReciveOTP,
    msisdnEntered: state.upgrade.msisdn,
    upgradeCheckDone: state.upgrade.upgradeCheckDone,
    journeyStatus: state.upgrade.upgradeStatus,
    profileData: state.navDetails.profileData,
    authDetails: state.checkoutDetails.authDetails,
    userLoggedIn: state.navDetails.isUserLoggedIn,
    subscriptions: state.navDetails.subscriptions,
    upgradeResponse: state.upgrade.upgradeResponse,
    invalidOTPTries: state.upgrade.invalidOTPTries,
    linkedNumbersList: state.upgrade.linkedNumbers,
    upgradeDisplayData: state.upgrade.upgradeDisplayData,
    resultCode: state.upgrade.resultCode,
    unMaskedMsisdn: state.upgrade.unMaskedMsisdn,
    allUpgradesData: state.upgrade.allUpgradesData,
    upgradeLink: state.upgrade.upgradeLink,
    checkedBefore: state.upgrade.msisdn,
    showSnackBar: state.upgrade.showSnackBar,
    devicePrice: state.upgrade.devicePrice,
    creditFilters: state.upgrade.creditFilters,
    eligibleUpgradeList: state.upgrade.eligibleUpgradeList,
    isChildAllowed: state.upgrade.isChildAllowed,
    isDisplayInvalidOTPError: state.upgrade.displayInvalidOTPError
  };
};

/* harmony default export */ var upgradeContainer_UpgradeContainer = ((0,DependencyHelper.connect)(UpgradeContainer_mapStateToProps, {
  displayHideUpgradeModal: upgradeAction/* displayHideUpgradeModal */.ex,
  clearUpgradeJourney: upgradeAction/* clearUpgradeJourney */.rX,
  updateCanReciveOTP: upgradeAction/* updateCanReciveOTP */.rn,
  updateMsisdnStatus: upgradeAction/* updateMsisdnStatus */.Pl,
  updateEligibiltyCheckStatus: upgradeAction/* updateEligibiltyCheckStatus */.UY,
  generateOneTimePin: upgradeAction/* generateOneTimePin */.ow,
  getAllEligibility: upgradeAction/* getAllEligibility */.GZ,
  fetchAlternateNumbers: upgradeAction/* fetchAlternateNumbers */.CC,
  generateOTP: upgradeAction/* generateOTP */.P,
  getEligibilityForAlternativeNumbers: upgradeAction/* getEligibilityForAlternativeNumbers */.Wm,
  eligibilityForLinkedNumbersList: upgradeAction/* eligibilityForLinkedNumbersList */.We,
  fetchDisplayDetails: upgradeAction/* fetchDisplayDetails */.NO,
  updateJourneyStatus: upgradeAction/* updateJourneyStatus */.aI,
  displayHideUpgradeTopbanner: upgradeAction/* displayHideUpgradeTopbanner */.Od,
  updateSelectedData: upgradeAction/* updateSelectedData */.x$,
  fetchCreditFilters: upgradeAction/* fetchCreditFilters */.QV,
  checkIfdealQualifies: upgradeAction/* checkIfdealQualifies */.RZ,
  resetInvalidOtps: upgradeAction/* resetInvalidOtps */.$G,
  toggleSnackBar: upgradeAction/* toggleSnackBar */.Np,
  updateUnmaskedMsisdn: upgradeAction/* updateUnmaskedMsisdn */.c7,
  updateLinkedNumber: upgradeAction/* updateLinkedNumber */.QB,
  getRecommendedDeals: upgradeAction/* getRecommendedDeals */.VZ,
  displayInvalidOTPError: upgradeAction/* displayInvalidOTPError */.Zi,
  updateData: upgradeAction/* updateData */.VA,
  addDealToCart: upgradeAction/* addDealToCart */.ff,
  setMaxRecurring: dealBuilderAction/* setMaxRecurring */.V
})(UpgradeContainer));
;// CONCATENATED MODULE: ./components/organisms/footer/Footer.jsx






var fetched = false;
function Footer(_ref) {
  var _ref$hidden = _ref.hidden,
      hidden = _ref$hidden === void 0 ? false : _ref$hidden;
  var env = (config_default()).env;
  var drupal = (config_default()).envConfigs[env].drupalApi.url;

  var _useState = (0,react.useState)(""),
      menuFragment = _useState[0],
      setMenuFragment = _useState[1];

  (0,react.useEffect)(function () {
    var getNavigation = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var fragment, abslutePath;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fetched = true;
                _context.next = 3;
                return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "footerFragment", "", "text");

              case 3:
                fragment = _context.sent;

                if (fragment) {
                  abslutePath = fragment.replace(/src="\//g, "src=\"".concat(drupal, "/"));
                  setMenuFragment(abslutePath);
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getNavigation() {
        return _ref2.apply(this, arguments);
      };
    }();

    if (!fetched) getNavigation();
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("footer", {
    id: "footerFragment",
    dangerouslySetInnerHTML: {
      __html: menuFragment
    },
    className: hidden ? "d-none" : ""
  });
}
;// CONCATENATED MODULE: ./node_modules/dangerously-set-html-content/dist/index.modern.js


function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var _excluded = ["html", "dangerouslySetInnerHTML"];
function DangerouslySetHtmlContent(_ref) {
  var html = _ref.html,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var divRef = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    if (!html || !divRef.current) throw new Error("html prop cant't be null");
    var slotHtml = document.createRange().createContextualFragment(html);
    divRef.current.innerHTML = '';
    divRef.current.appendChild(slotHtml);
  }, [html, divRef]);

  return /*#__PURE__*/react.createElement("div", _extends({}, rest, {
    ref: divRef
  }));
}

/* harmony default export */ var index_modern = (DangerouslySetHtmlContent);
//# sourceMappingURL=index.modern.js.map

;// CONCATENATED MODULE: ./components/molecules/headerFragment/headerFragment.jsx







var headerFragment_fetched = false;
function Headerfragment() {
  var env = (config_default()).env;
  var drupal = (config_default()).envConfigs[env].drupalApi.url;

  var _useState = (0,react.useState)("<div />"),
      menuFragment = _useState[0],
      setMenuFragment = _useState[1];

  (0,react.useEffect)(function () {
    var getNavigation = /*#__PURE__*/function () {
      var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var fragment, abslutePath;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                headerFragment_fetched = true;
                _context.next = 3;
                return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "headerFragment", "", "text");

              case 3:
                fragment = _context.sent;

                if (fragment) {
                  abslutePath = fragment.replace(/src="\/theme/g, "src=\"".concat(drupal, "/theme"));
                  setMenuFragment(abslutePath);
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getNavigation() {
        return _ref.apply(this, arguments);
      };
    }();

    if (!headerFragment_fetched) getNavigation();
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_modern, {
    id: "headerFragment",
    html: menuFragment
  });
}
// EXTERNAL MODULE: ./components/atoms/getHelp/getHelp.module.scss
var getHelp_module = __webpack_require__(61493);
var getHelp_module_default = /*#__PURE__*/__webpack_require__.n(getHelp_module);
// EXTERNAL MODULE: ./components/atoms/confirmModal/ConfirmModal.jsx
var ConfirmModal = __webpack_require__(74183);
;// CONCATENATED MODULE: ./components/atoms/getHelp/getHelp.jsx


function getHelp_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function getHelp_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? getHelp_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : getHelp_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var GetHelp = function GetHelp(props) {
  var env = (config_default()).env;
  var legacyEnv = (config_default()).envConfigs[env].legacyEnv;

  var _useState = (0,react.useState)(false),
      show = _useState[0],
      setShow = _useState[1];

  var _useState2 = (0,react.useState)(true),
      showBtn = _useState2[0],
      setShowBtn = _useState2[1];

  var confirmLabel = "Call me back";
  var cancelLabel = "No, thanks";

  var handleCancel = function handleCancel() {
    setShow(false);
    setShowBtn(true);
  };

  var showModal = function showModal() {
    setShow(true);
    setShowBtn(false);
    (0,analyticsUtag/* link */.p4)(getHelp_objectSpread({
      page_tool_event: "use",
      page_tool_name: "".concat((0,analyticsUtag/* getUtagData */.GS)(["page_name"]).page_name, ": need some help?")
    }, getUtagViewData()));
  };

  var handleDismiss = function handleDismiss() {
    handleCancel();
    (0,analyticsUtag/* link */.p4)(getHelp_objectSpread({
      page_tool_event: "use",
      page_tool_name: "".concat((0,analyticsUtag/* getUtagData */.GS)(["page_name"]).page_name, ": dismiss")
    }, getUtagViewData()));
  };

  var handleConfirm = function handleConfirm() {
    handleCancel();
    (0,analyticsUtag/* link */.p4)(getHelp_objectSpread({
      link_type: "o",
      link_name: "".concat((0,analyticsUtag/* getUtagData */.GS)(["page_name"]).page_name, ": ").concat(confirmLabel)
    }, getUtagViewData()));
    var isMiniApp = (0,helperServices/* getCookieValue */.Do)("miniApp") === "true";
    var targetToOpen = isMiniApp ? "_self" : "_blank";
    window.open("https://www".concat(legacyEnv, ".vodacom.co.za/shopping/forms/ecommerce?bucket=").concat(props === null || props === void 0 ? void 0 : props.leadBucket), targetToOpen);
  };

  var getUtagViewData = function getUtagViewData() {
    return (0,analyticsUtag/* getUtagData */.GS)(["visitor_customer_id", "visitor_login_status", "visitor_subscription_type", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "page_site_section_lvl_4", "visitor_msisdn_hash", "page_name", "page_channel", "page_master_tab", "upgrade_eligibility_status", "upgrade_ineligible_reason", "upgrade_eligible_date", "upgrade_customer_type"]);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat(props.stacked && (getHelp_module_default()).stick_to_bottom, " ").concat((getHelp_module_default()).btn, " ").concat(props.className, " ").concat(showBtn ? (getHelp_module_default())["btn-view"] : ""),
      onClick: showModal,
      id: "ecom-help-btn",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M20 35.8332C28.7445 35.8332 35.8334 28.7443 35.8334 19.9998C35.8334 11.2553 28.7445 4.1665 20 4.1665C11.2555 4.1665 4.16669 11.2553 4.16669 19.9998C4.16669 28.7443 11.2555 35.8332 20 35.8332Z",
          fill: "white"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20 4.9667C11.6974 4.9667 4.9667 11.6974 4.9667 20C4.9667 28.3027 11.6974 35.0334 20 35.0334C28.3027 35.0334 35.0334 28.3027 35.0334 20C35.0334 11.6974 28.3027 4.9667 20 4.9667ZM3.3667 20C3.3667 10.8137 10.8137 3.3667 20 3.3667C29.1864 3.3667 36.6334 10.8137 36.6334 20C36.6334 29.1864 29.1864 36.6334 20 36.6334C10.8137 36.6334 3.3667 29.1864 3.3667 20Z",
          fill: "white"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M15.8083 14.6439C15.8083 14.6439 16.377 11.6001 20 11.6168C23.6229 11.6334 24.8479 16.0793 22.9375 18.023C22.0833 18.8959 21.352 19.6147 20.8333 20.1189C20.5693 20.3799 20.3597 20.6907 20.2166 21.0333C20.0736 21.3759 19.9999 21.7434 20 22.1147V23.7251",
          stroke: "url(#paint0_linear_12149:283893)",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.0001 28.7167C20.2118 28.7167 20.3834 28.5451 20.3834 28.3334C20.3834 28.1217 20.2118 27.95 20.0001 27.95C19.7883 27.95 19.6167 28.1217 19.6167 28.3334C19.6167 28.5451 19.7883 28.7167 20.0001 28.7167ZM18.7834 28.3334C18.7834 27.6614 19.3281 27.1167 20.0001 27.1167C20.672 27.1167 21.2167 27.6614 21.2167 28.3334C21.2167 29.0053 20.672 29.55 20.0001 29.55C19.3281 29.55 18.7834 29.0053 18.7834 28.3334Z",
          fill: "url(#paint1_linear_12149:283893)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.9999 28.9252C20.3267 28.9252 20.5916 28.6603 20.5916 28.3335C20.5916 28.0068 20.3267 27.7419 19.9999 27.7419C19.6732 27.7419 19.4083 28.0068 19.4083 28.3335C19.4083 28.6603 19.6732 28.9252 19.9999 28.9252ZM18.9916 28.3335C18.9916 27.7766 19.4431 27.3252 19.9999 27.3252C20.5568 27.3252 21.0083 27.7766 21.0083 28.3335C21.0083 28.8904 20.5568 29.3419 19.9999 29.3419C19.4431 29.3419 18.9916 28.8904 18.9916 28.3335Z",
          fill: "url(#paint2_linear_12149:283893)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M20 29.583C20.6904 29.583 21.25 29.0234 21.25 28.333C21.25 27.6427 20.6904 27.083 20 27.083C19.3096 27.083 18.75 27.6427 18.75 28.333C18.75 29.0234 19.3096 29.583 20 29.583Z",
          fill: "url(#paint3_linear_12149:283893)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20 27.983C19.8067 27.983 19.65 28.1397 19.65 28.333C19.65 28.5263 19.8067 28.683 20 28.683C20.1933 28.683 20.35 28.5263 20.35 28.333C20.35 28.1397 20.1933 27.983 20 27.983ZM21.25 28.333C21.25 29.0234 20.6904 29.583 20 29.583C19.3096 29.583 18.75 29.0234 18.75 28.333C18.75 27.6427 19.3096 27.083 20 27.083C20.6904 27.083 21.25 27.6427 21.25 28.333Z",
          fill: "url(#paint4_linear_12149:283893)"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
            id: "paint0_linear_12149:283893",
            x1: "16.834",
            y1: "22.1773",
            x2: "26.8532",
            y2: "15.5376",
            gradientUnits: "userSpaceOnUse",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
              stopColor: "#8E0000"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
              offset: "1",
              stopColor: "#F30000"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
            id: "paint1_linear_12149:283893",
            x1: "19.0944",
            y1: "29.239",
            x2: "21.2808",
            y2: "27.0527",
            gradientUnits: "userSpaceOnUse",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
              stopColor: "#8E0000"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
              offset: "1",
              stopColor: "#F30000"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
            id: "paint2_linear_12149:283893",
            x1: "19.2494",
            y1: "29.0841",
            x2: "21.0613",
            y2: "27.2721",
            gradientUnits: "userSpaceOnUse",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
              stopColor: "#8E0000"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
              offset: "1",
              stopColor: "#F30000"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
            id: "paint3_linear_12149:283893",
            x1: "19.0696",
            y1: "29.2634",
            x2: "21.3158",
            y2: "27.0172",
            gradientUnits: "userSpaceOnUse",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
              stopColor: "#8E0000"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
              offset: "1",
              stopColor: "#F30000"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
            id: "paint4_linear_12149:283893",
            x1: "19.0696",
            y1: "29.2634",
            x2: "21.3158",
            y2: "27.0172",
            gradientUnits: "userSpaceOnUse",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
              stopColor: "#8E0000"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
              offset: "1",
              stopColor: "#F30000"
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (getHelp_module_default()).txt,
        children: ["Need\xA0", /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "d-none d-md-flex d-sm-flex",
          children: "some"
        }), "\xA0help?"]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ConfirmModal/* default */.Z, {
      show: show,
      title: "Let us give you a call",
      text: "If you're struggling to shop on our website, one of our friendly consultants can call you and assist over the phone.",
      cancelLabel: cancelLabel,
      confirmLabel: confirmLabel,
      imageUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/consultant.svg"),
      handleCancel: handleDismiss,
      handleConfirm: handleConfirm
    })]
  });
};

/* harmony default export */ var getHelp = (GetHelp);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./config/colors.js
var colors = __webpack_require__(93957);
// EXTERNAL MODULE: ./config/fonts.js
var fonts = __webpack_require__(78198);
;// CONCATENATED MODULE: ./components/miniApp/miniAppHeader/miniAppStyled.js




var HeaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "miniAppStyled__HeaderContainer",
  componentId: "sc-70eo3i-0"
})(["background-color:", ";box-shadow:0 0.125rem 0.25rem 0 rgb(136 136 136 / 10%);display:flex;align-items:center;justify-content:space-between;height:70px;padding:0 16px;position:fixed;top:0;left:0;right:0;z-index:6;"], colors/* default.White0 */.Z.White0);
var HeaderSpace = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "miniAppStyled__HeaderSpace",
  componentId: "sc-70eo3i-1"
})(["height:70px;"]);
var Logo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "miniAppStyled__Logo",
  componentId: "sc-70eo3i-2"
})(["background-image:url(", "/assets/images/logo.png);background-position:center;background-size:contain;background-repeat:no-repeat;height:40px;width:40px;"], config.EnvConfig.imagePrefix);
var HContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "miniAppStyled__HContainer",
  componentId: "sc-70eo3i-3"
})(["display:flex;align-items:center;"]);
var Cart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "miniAppStyled__Cart",
  componentId: "sc-70eo3i-4"
})(["background-image:url(", "/assets/images/cart.png);background-position:center;background-size:contain;background-repeat:no-repeat;position:relative;height:22px;width:22px;"], config.EnvConfig.imagePrefix);
var CartCounter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "miniAppStyled__CartCounter",
  componentId: "sc-70eo3i-5"
})(["border-radius:50%;width:18px;height:18px;font-size:12px;line-height:14px;background:", ";color:", ";display:flex;justify-content:center;align-items:center;position:absolute;top:-8px;right:-8px;"], colors/* default.Green74 */.Z.Green74, colors/* default.White0 */.Z.White0);
var Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "miniAppStyled__Divider",
  componentId: "sc-70eo3i-6"
})(["background-color:", ";margin:0 16px;width:0.5px;height:40px;"], colors/* default.Grey14 */.Z.Grey14);
var Menu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "miniAppStyled__Menu",
  componentId: "sc-70eo3i-7"
})(["background-image:url(", "/assets/images/", ");background-position:center;background-size:contain;background-repeat:no-repeat;height:20px;width:20px;margin:0 2px 0 0;"], config.EnvConfig.imagePrefix, function (props) {
  return props.image;
});
var MenuContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "miniAppStyled__MenuContent",
  componentId: "sc-70eo3i-8"
})(["background-color:", ";position:fixed;top:70px;left:0;right:0;overflow:hidden;z-index:5;", " ", ""], colors/* default.White0 */.Z.White0, function (props) {
  return !props.show && "\n    max-height: 0;\n    transition: max-height 0.2s linear;\n  ";
}, function (props) {
  return props.show && "\n    max-height: ".concat(props.numberOfItems * 52, "px;\n    transition: max-height 0.2s linear;\n  ");
});
var MenuContentItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "miniAppStyled__MenuContentItem",
  componentId: "sc-70eo3i-9"
})(["background-color:", ";display:flex;align-items:center;height:52px;padding:0 16px;border-bottom:0.5px solid ", ";font-family:", ";font-size:16px;"], colors/* default.White0 */.Z.White0, colors/* default.Grey14 */.Z.Grey14, fonts/* default.regular */.Z.regular);
var MenuOverlayContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "miniAppStyled__MenuOverlayContainer",
  componentId: "sc-70eo3i-10"
})(["position:fixed;top:0;bottom:0;left:0;right:0;z-index:4;"]);
;// CONCATENATED MODULE: ./components/miniApp/constants.js
var MiniAppMenuItems = [{
  display: "Order history",
  path: "/shopping/view-order-history"
}];
;// CONCATENATED MODULE: ./components/miniApp/miniAppHeader/MiniAppHeader.jsx


function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }










var MiniAppHeaderComponent = function MiniAppHeaderComponent(_ref) {
  var cartTotalQuantity = _ref.cartTotalQuantity,
      router = _ref.router;

  var _React$useState = react.useState([]),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      menuItems = _React$useState2[0],
      setMenuItems = _React$useState2[1];

  var _React$useState3 = react.useState(cartTotalQuantity),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      cartQuantity = _React$useState4[0],
      setCartQuantity = _React$useState4[1];

  var _React$useState5 = react.useState(false),
      _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
      showMenuContent = _React$useState6[0],
      setShowMenuContent = _React$useState6[1];

  var onLogoClick = function onLogoClick(e) {
    if (window.location.pathname === "/shopping/products") {
      return;
    }

    e.stopPropagation();
    (0,helperServices/* showSpinner */.yh)();
    setShowMenuContent(false);
    router.push("/shopping/products");
  };

  var onCartClick = function onCartClick(e) {
    if (window.location.pathname === "/shopping/cart") {
      return;
    }

    e.stopPropagation();
    (0,helperServices/* showSpinner */.yh)();
    setShowMenuContent(false);
    router.push("/shopping/cart");
  };

  var onMenuItemClick = function onMenuItemClick(e, path) {
    if (!path || window.location.pathname === path) {
      return;
    }

    e.stopPropagation();
    (0,helperServices/* showSpinner */.yh)();
    setShowMenuContent(false);
    router.push(path);
  };

  var onMenuClick = function onMenuClick(e) {
    e.stopPropagation();
    setShowMenuContent(!showMenuContent);
  };

  react.useEffect(function () {
    setCartQuantity(cartTotalQuantity);
  }, [cartTotalQuantity]);
  react.useEffect(function () {
    if (!MiniAppMenuItems || MiniAppMenuItems.length === 0) {
      return;
    }

    var mItems = [];

    var _iterator = _createForOfIteratorHelper(MiniAppMenuItems),
        _step;

    try {
      var _loop = function _loop() {
        var menuItem = _step.value;
        mItems.push( /*#__PURE__*/(0,jsx_runtime.jsx)(MenuContentItem, {
          onClick: function onClick(e) {
            return onMenuItemClick(e, menuItem.path);
          },
          children: menuItem.display
        }));
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    setMenuItems(mItems);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {}), /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderSpace, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(HeaderContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Logo, {
        onClick: onLogoClick
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(HContainer, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Cart, {
          onClick: onCartClick,
          children: !!cartQuantity && /*#__PURE__*/(0,jsx_runtime.jsx)(CartCounter, {
            children: cartQuantity
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Divider, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Menu, {
          image: showMenuContent ? "close-black.svg" : "hb-lines.png",
          onClick: onMenuClick
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(MenuContent, {
      show: showMenuContent,
      numberOfItems: menuItems.length,
      children: menuItems
    }), showMenuContent && /*#__PURE__*/(0,jsx_runtime.jsx)(MenuOverlayContainer, {
      onTouchEnd: function onTouchEnd() {
        return setShowMenuContent(false);
      }
    })]
  });
};

var MiniAppHeader_mapStateToProps = function mapStateToProps(state) {
  return {
    cartTotalQuantity: state.cartDetails.totalQuantity
  };
};

var MiniAppHeader = (0,DependencyHelper.connect)(MiniAppHeader_mapStateToProps)(MiniAppHeaderComponent);
;// CONCATENATED MODULE: ./components/miniApp/index.js

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js

function objectSpread2_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? objectSpread2_ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : objectSpread2_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
;// CONCATENATED MODULE: ./node_modules/redux/es/redux.js


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {}

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 0);
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : 0);
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : 0);
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 0);
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 0);
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 0);
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : 0);
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 0);
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : 0);
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : 0);
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

var legacy_createStore = (/* unused pure expression or super */ null && (createStore));

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : 0);
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : 0);
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {}

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {}

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) { var warningMessage; }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : 0);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : 0);
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 0);
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2(_objectSpread2({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {}



;// CONCATENATED MODULE: ./node_modules/redux-thunk/es/index.js
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ var redux_thunk_es = (thunk);
// EXTERNAL MODULE: ./node_modules/redux-logger/dist/redux-logger.js
var redux_logger = __webpack_require__(94500);
var redux_logger_default = /*#__PURE__*/__webpack_require__.n(redux_logger);
// EXTERNAL MODULE: ./Redux/actionTypes/index.js
var actionTypes = __webpack_require__(1369);
;// CONCATENATED MODULE: ./Redux/reducers/productReducer.js


var productSearchList = function productSearchList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case actionTypes/* PRODUCT_SEARCH_LIST */.nn:
      return payload;

    default:
      return state;
  }
};

/* harmony default export */ var productReducer = ({
  productSearchList: productSearchList
});
;// CONCATENATED MODULE: ./Redux/reducers/productCompareReducer.js



function productCompareReducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function productCompareReducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? productCompareReducer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : productCompareReducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var initialState = {
  productCompareList: [],
  showError: '',
  productCompareAttrList: []
};

var productCompareReducer = function productCompareReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actionTypes/* ADD_COMPARE_PRODUCT */.Ov:
      return productCompareReducer_objectSpread(productCompareReducer_objectSpread({}, state), {}, {
        productCompareList: [].concat((0,toConsumableArray/* default */.Z)(state.productCompareList), [action.payload]),
        showError: ''
      });

    case actionTypes/* REMOVE_COMPARE_PRODUCT */.Fu:
      {
        // eslint-disable-next-line no-case-declarations
        var sku = action.payload.sku;
        var updatedArray = state.productCompareList.filter(function (product) {
          return product.sku !== sku;
        });
        return productCompareReducer_objectSpread(productCompareReducer_objectSpread({}, state), {}, {
          productCompareList: updatedArray,
          showError: ''
        });
      }

    case actionTypes/* REMOVE_ALL */.Vo:
      return productCompareReducer_objectSpread(productCompareReducer_objectSpread({}, state), {}, {
        productCompareList: [],
        showError: ''
      });

    case actionTypes/* SHOW_COMPARE_ERROR */.j_:
      return productCompareReducer_objectSpread(productCompareReducer_objectSpread({}, state), {}, {
        showError: action.payload
      });

    case actionTypes/* PRODUCT_COMPARE_LIST */.bn:
      return productCompareReducer_objectSpread(productCompareReducer_objectSpread({}, state), {}, {
        productCompareAttrList: action.payload
      });

    case actionTypes/* REPLACE_COMPARE_PRODUCT */.Di:
      {
        var previousItemSku = action.payload.previousItem.sku;

        var _updatedArray = (0,toConsumableArray/* default */.Z)(state.productCompareList);

        _updatedArray.map(function (prod, index) {
          if (prod.sku === previousItemSku) {
            return _updatedArray.splice(index, 1, action.payload.currentItem);
          }
        });

        return productCompareReducer_objectSpread(productCompareReducer_objectSpread({}, state), {}, {
          productCompareList: _updatedArray
        });
      }

    default:
      return state;
  }
};

/* harmony default export */ var reducers_productCompareReducer = (productCompareReducer);
;// CONCATENATED MODULE: ./Redux/reducers/productDetailReducer.js


function productDetailReducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function productDetailReducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? productDetailReducer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : productDetailReducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var productDetailReducer_initialState = {
  color: {},
  storage: '',
  sku: '',
  bundleProducts: []
};
/* harmony default export */ var productDetailReducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : productDetailReducer_initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case actionTypes/* SELECTED_COLOR */.lb:
      return productDetailReducer_objectSpread(productDetailReducer_objectSpread({}, state), {}, {
        color: payload
      });

    case actionTypes/* SELECTED_STORAGE */.QE:
      return productDetailReducer_objectSpread(productDetailReducer_objectSpread({}, state), {}, {
        storage: payload
      });

    case actionTypes/* GET_SKU */.v6:
      return productDetailReducer_objectSpread(productDetailReducer_objectSpread({}, state), {}, {
        sku: payload
      });

    default:
      return state;
  }
});
;// CONCATENATED MODULE: ./Redux/reducers/cartReducer.js


function cartReducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function cartReducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? cartReducer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : cartReducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var cartReducer_initialState = {
  totalQuantity: 0,
  cartProductItems: [],
  prices: null,
  shipping_address: null,
  billing_address: null,
  available_payment_methods: [],
  selected_shipping_method: null,
  shippingMessageText: null,
  shippingFeeCalculate: null,
  cartLimits: null,
  errorMsg: null,
  applied_coupons: null,
  notificationData: null,
  allow_place_order: 1,
  guestCartItems: [],
  guestCartQty: 0,
  guestCoupons: null,
  isMulti: false,
  contract: false,
  contractMissed: false,
  onceOff: false,
  onceOffMissed: false,
  hasPreOrder: false,
  hasBackOrder: false
};

function getShippingMethodValue(addresses) {
  if (!addresses) {
    return null;
  }

  if (Array.isArray(addresses) && addresses.length > 0) {
    return addresses[0].selected_shipping_method;
  }

  return addresses.selected_shipping_method;
}

function getShipAndBillValue(payload) {
  if (payload && payload.setAddress) {
    return payload.setAddress;
  } else if (payload && payload.updatedAddress) {
    return payload.updatedAddress;
  } else {
    return null;
  }
}

var cartReducer = function cartReducer() {
  var _shoppingCart, _shoppingCart2, _shoppingCart3, _shoppingCart4, _shoppingCart5, _shoppingCart6, _shoppingCart7, _shoppingCart8, _shoppingCart9, _shoppingCart10, _shoppingCart11, _shoppingCart12, _shoppingCart13, _payload$addSimplePro, _shoppingCart14, _shoppingCart15, _shoppingCart16, _shoppingCart17, _shoppingCart18, _shoppingCart19, _shoppingCart20, _payload$addBundlePro, _shoppingCart21, _shoppingCart22, _shoppingCart23, _shoppingCart24, _shoppingCart25, _shoppingCart26, _shoppingCart27, _payload$errors, _payload$errors$, _payload$addConfigura, _shoppingCart28, _shoppingCart29, _shoppingCart30, _shoppingCart31, _shoppingCart32, _shoppingCart33, _shoppingCart34, _payload$updateCartIt, _shoppingCart35, _shoppingCart36, _shoppingCart37, _shoppingCart38, _payload$removeItemFr, _shoppingCart39, _shoppingCart40, _shoppingCart41, _shoppingCart42, _shoppingCart43, _payload$shippingMeth, _shoppingCart44, _payload$applyCouponT, _payload$applyCouponT2, _payload$applyCouponT3, _payload$removeCoupon, _payload$removeCoupon2;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : cartReducer_initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  var shoppingCart, cartItems;

  switch (type) {
    case actionTypes/* GUEST_VIEW_CART */.EC:
      shoppingCart = payload && (payload === null || payload === void 0 ? void 0 : payload.cart) || {};
      cartItems = (0,helperServices/* mapCartProductItems */.$T)(((_shoppingCart = shoppingCart) === null || _shoppingCart === void 0 ? void 0 : _shoppingCart.items) || []);
      return cartReducer_objectSpread(cartReducer_objectSpread(cartReducer_objectSpread({}, state), (0,helperServices/* validateOrderItems */.Nr)(cartItems)), {}, {
        applied_coupons: (0,helperServices/* valOrNull */.Xo)((_shoppingCart2 = shoppingCart) === null || _shoppingCart2 === void 0 ? void 0 : _shoppingCart2.applied_coupons),
        cartProductItems: cartItems,
        totalQuantity: ((_shoppingCart3 = shoppingCart) === null || _shoppingCart3 === void 0 ? void 0 : _shoppingCart3.total_quantity) || 0,
        prices: (0,helperServices/* valOrNull */.Xo)((_shoppingCart4 = shoppingCart) === null || _shoppingCart4 === void 0 ? void 0 : _shoppingCart4.prices),
        shippingMessageText: (0,helperServices/* valOrNull */.Xo)((_shoppingCart5 = shoppingCart) === null || _shoppingCart5 === void 0 ? void 0 : _shoppingCart5.shippingMessageText),
        shippingFeeCalculate: (0,helperServices/* valOrNull */.Xo)((_shoppingCart6 = shoppingCart) === null || _shoppingCart6 === void 0 ? void 0 : _shoppingCart6.shipping_fee_calculate),
        cartLimits: (0,helperServices/* valOrNull */.Xo)((_shoppingCart7 = shoppingCart) === null || _shoppingCart7 === void 0 ? void 0 : _shoppingCart7.cart_order_limits),
        notificationData: (0,helperServices/* valOrNull */.Xo)((_shoppingCart8 = shoppingCart) === null || _shoppingCart8 === void 0 ? void 0 : _shoppingCart8.notification_data),
        allow_place_order: (_shoppingCart9 = shoppingCart) === null || _shoppingCart9 === void 0 ? void 0 : _shoppingCart9.allow_place_order,
        available_payment_methods: (_shoppingCart10 = shoppingCart) === null || _shoppingCart10 === void 0 ? void 0 : _shoppingCart10.available_payment_methods
      });

    case actionTypes/* GUEST_CART_ITEMS */.O$:
      return cartReducer_objectSpread(cartReducer_objectSpread({}, state), {}, {
        guestCartItems: payload ? payload.products : [],
        guestCartQty: payload ? payload.totalItems : 0,
        guestCoupons: payload ? payload.coupon : null
      });

    case actionTypes/* GET_SHIPPING_BILLING */.W_:
      shoppingCart = payload && (payload === null || payload === void 0 ? void 0 : payload.cart) || {};
      return cartReducer_objectSpread(cartReducer_objectSpread({}, state), {}, {
        shipping_address: (0,helperServices/* valOrNull */.Xo)((_shoppingCart11 = shoppingCart) === null || _shoppingCart11 === void 0 ? void 0 : _shoppingCart11.shipping_addresses),
        billing_address: (0,helperServices/* valOrNull */.Xo)((_shoppingCart12 = shoppingCart) === null || _shoppingCart12 === void 0 ? void 0 : _shoppingCart12.billing_address),
        selected_shipping_method: getShippingMethodValue((_shoppingCart13 = shoppingCart) === null || _shoppingCart13 === void 0 ? void 0 : _shoppingCart13.shipping_addresses)
      });

    case actionTypes/* ADD_SIMPLE_PRODUCT_TO_CART */.ch:
      shoppingCart = payload && (payload === null || payload === void 0 ? void 0 : (_payload$addSimplePro = payload.addSimpleProductsToCart) === null || _payload$addSimplePro === void 0 ? void 0 : _payload$addSimplePro.cart) || {};
      cartItems = (0,helperServices/* mapCartProductItems */.$T)(((_shoppingCart14 = shoppingCart) === null || _shoppingCart14 === void 0 ? void 0 : _shoppingCart14.items) || []);
      return cartReducer_objectSpread(cartReducer_objectSpread(cartReducer_objectSpread({}, state), (0,helperServices/* validateOrderItems */.Nr)(cartItems)), {}, {
        totalQuantity: ((_shoppingCart15 = shoppingCart) === null || _shoppingCart15 === void 0 ? void 0 : _shoppingCart15.total_quantity) || 0,
        cartProductItems: cartItems,
        prices: (0,helperServices/* valOrNull */.Xo)((_shoppingCart16 = shoppingCart) === null || _shoppingCart16 === void 0 ? void 0 : _shoppingCart16.prices),
        shippingMessageText: (0,helperServices/* valOrNull */.Xo)((_shoppingCart17 = shoppingCart) === null || _shoppingCart17 === void 0 ? void 0 : _shoppingCart17.shippingMessageText),
        shippingFeeCalculate: (0,helperServices/* valOrNull */.Xo)((_shoppingCart18 = shoppingCart) === null || _shoppingCart18 === void 0 ? void 0 : _shoppingCart18.shipping_fee_calculate),
        selected_shipping_method: getShippingMethodValue((_shoppingCart19 = shoppingCart) === null || _shoppingCart19 === void 0 ? void 0 : _shoppingCart19.shipping_addresses),
        cartLimits: (0,helperServices/* valOrNull */.Xo)((_shoppingCart20 = shoppingCart) === null || _shoppingCart20 === void 0 ? void 0 : _shoppingCart20.cart_order_limits)
      });

    case actionTypes/* ADD_BUNDLE_PRODUCT_TO_CART */.Qz:
      shoppingCart = payload && (payload === null || payload === void 0 ? void 0 : (_payload$addBundlePro = payload.addBundleProductsToCart) === null || _payload$addBundlePro === void 0 ? void 0 : _payload$addBundlePro.cart) || {};
      cartItems = (0,helperServices/* mapCartProductItems */.$T)(((_shoppingCart21 = shoppingCart) === null || _shoppingCart21 === void 0 ? void 0 : _shoppingCart21.items) || []);
      return cartReducer_objectSpread(cartReducer_objectSpread(cartReducer_objectSpread({}, state), (0,helperServices/* validateOrderItems */.Nr)(cartItems)), {}, {
        totalQuantity: ((_shoppingCart22 = shoppingCart) === null || _shoppingCart22 === void 0 ? void 0 : _shoppingCart22.total_quantity) || 0,
        cartProductItems: cartItems,
        prices: (0,helperServices/* valOrNull */.Xo)((_shoppingCart23 = shoppingCart) === null || _shoppingCart23 === void 0 ? void 0 : _shoppingCart23.prices),
        shippingMessageText: (0,helperServices/* valOrNull */.Xo)((_shoppingCart24 = shoppingCart) === null || _shoppingCart24 === void 0 ? void 0 : _shoppingCart24.shippingMessageText),
        shippingFeeCalculate: (0,helperServices/* valOrNull */.Xo)((_shoppingCart25 = shoppingCart) === null || _shoppingCart25 === void 0 ? void 0 : _shoppingCart25.shipping_fee_calculate),
        selected_shipping_method: getShippingMethodValue((_shoppingCart26 = shoppingCart) === null || _shoppingCart26 === void 0 ? void 0 : _shoppingCart26.shipping_addresses),
        cartLimits: (0,helperServices/* valOrNull */.Xo)((_shoppingCart27 = shoppingCart) === null || _shoppingCart27 === void 0 ? void 0 : _shoppingCart27.cart_order_limits),
        errorMsg: payload && (payload === null || payload === void 0 ? void 0 : (_payload$errors = payload.errors) === null || _payload$errors === void 0 ? void 0 : _payload$errors.length) > 0 && (_payload$errors$ = payload.errors[0]) !== null && _payload$errors$ !== void 0 && _payload$errors$.message ? payload.errors[0].message : null
      });

    case actionTypes/* ADD_CONFIGURABLE_PRODUCT_TO_CART */.Js:
      shoppingCart = payload && (payload === null || payload === void 0 ? void 0 : (_payload$addConfigura = payload.addConfigurableProductsToCart) === null || _payload$addConfigura === void 0 ? void 0 : _payload$addConfigura.cart) || {};
      cartItems = (0,helperServices/* mapCartProductItems */.$T)(((_shoppingCart28 = shoppingCart) === null || _shoppingCart28 === void 0 ? void 0 : _shoppingCart28.items) || []);
      return cartReducer_objectSpread(cartReducer_objectSpread(cartReducer_objectSpread({}, state), (0,helperServices/* validateOrderItems */.Nr)(cartItems)), {}, {
        totalQuantity: ((_shoppingCart29 = shoppingCart) === null || _shoppingCart29 === void 0 ? void 0 : _shoppingCart29.total_quantity) || 0,
        cartProductItems: cartItems,
        prices: (0,helperServices/* valOrNull */.Xo)((_shoppingCart30 = shoppingCart) === null || _shoppingCart30 === void 0 ? void 0 : _shoppingCart30.prices),
        shippingMessageText: (0,helperServices/* valOrNull */.Xo)((_shoppingCart31 = shoppingCart) === null || _shoppingCart31 === void 0 ? void 0 : _shoppingCart31.shippingMessageText),
        shippingFeeCalculate: (0,helperServices/* valOrNull */.Xo)((_shoppingCart32 = shoppingCart) === null || _shoppingCart32 === void 0 ? void 0 : _shoppingCart32.shipping_fee_calculate),
        selected_shipping_method: getShippingMethodValue((_shoppingCart33 = shoppingCart) === null || _shoppingCart33 === void 0 ? void 0 : _shoppingCart33.shipping_addresses),
        cartLimits: (0,helperServices/* valOrNull */.Xo)((_shoppingCart34 = shoppingCart) === null || _shoppingCart34 === void 0 ? void 0 : _shoppingCart34.cart_order_limits)
      });

    case actionTypes/* UPDATE_CART */.gQ:
      shoppingCart = payload && (payload === null || payload === void 0 ? void 0 : (_payload$updateCartIt = payload.updateCartItems) === null || _payload$updateCartIt === void 0 ? void 0 : _payload$updateCartIt.cart) || {};
      cartItems = (0,helperServices/* mapCartProductItems */.$T)(((_shoppingCart35 = shoppingCart) === null || _shoppingCart35 === void 0 ? void 0 : _shoppingCart35.items) || []);
      return cartReducer_objectSpread(cartReducer_objectSpread(cartReducer_objectSpread({}, state), (0,helperServices/* validateOrderItems */.Nr)(cartItems)), {}, {
        totalQuantity: ((_shoppingCart36 = shoppingCart) === null || _shoppingCart36 === void 0 ? void 0 : _shoppingCart36.total_quantity) || 0,
        cartProductItems: cartItems,
        prices: (0,helperServices/* valOrNull */.Xo)((_shoppingCart37 = shoppingCart) === null || _shoppingCart37 === void 0 ? void 0 : _shoppingCart37.prices),
        cartLimits: (0,helperServices/* valOrNull */.Xo)((_shoppingCart38 = shoppingCart) === null || _shoppingCart38 === void 0 ? void 0 : _shoppingCart38.cart_order_limits),
        errorMsg: payload && payload.errors && payload.errors.length > 0 && payload.errors[0].message ? payload.errors[0].message : null
      });

    case actionTypes/* REMOVE_FROM_CART */.OZ:
      shoppingCart = payload && (payload === null || payload === void 0 ? void 0 : (_payload$removeItemFr = payload.removeItemFromCart) === null || _payload$removeItemFr === void 0 ? void 0 : _payload$removeItemFr.cart) || {};
      cartItems = (0,helperServices/* mapCartProductItems */.$T)(((_shoppingCart39 = shoppingCart) === null || _shoppingCart39 === void 0 ? void 0 : _shoppingCart39.items) || []);
      return cartReducer_objectSpread(cartReducer_objectSpread(cartReducer_objectSpread({}, state), (0,helperServices/* validateOrderItems */.Nr)(cartItems)), {}, {
        totalQuantity: ((_shoppingCart40 = shoppingCart) === null || _shoppingCart40 === void 0 ? void 0 : _shoppingCart40.total_quantity) || 0,
        cartProductItems: cartItems,
        prices: (0,helperServices/* valOrNull */.Xo)((_shoppingCart41 = shoppingCart) === null || _shoppingCart41 === void 0 ? void 0 : _shoppingCart41.prices),
        selected_shipping_method: getShippingMethodValue((_shoppingCart42 = shoppingCart) === null || _shoppingCart42 === void 0 ? void 0 : _shoppingCart42.shipping_addresses),
        cartLimits: (0,helperServices/* valOrNull */.Xo)((_shoppingCart43 = shoppingCart) === null || _shoppingCart43 === void 0 ? void 0 : _shoppingCart43.cart_order_limits)
      });

    case actionTypes/* SET_SHIPPING_METHOD */.SQ:
      shoppingCart = payload && (payload === null || payload === void 0 ? void 0 : (_payload$shippingMeth = payload.shippingMethod) === null || _payload$shippingMeth === void 0 ? void 0 : _payload$shippingMeth.cart) || {};
      return cartReducer_objectSpread(cartReducer_objectSpread({}, state), {}, {
        selected_shipping_method: getShippingMethodValue((_shoppingCart44 = shoppingCart) === null || _shoppingCart44 === void 0 ? void 0 : _shoppingCart44.shipping_addresses)
      });

    case actionTypes/* SET_SHIPPING */.sm:
      return cartReducer_objectSpread(cartReducer_objectSpread({}, state), {}, {
        shipping_address: payload ? getShipAndBillValue(payload) : null
      });

    case actionTypes/* SET_BILLING */.BP:
      return cartReducer_objectSpread(cartReducer_objectSpread({}, state), {}, {
        billing_address: payload ? getShipAndBillValue(payload) : null
      });

    case actionTypes/* ADD_COUPON_CODE */.Ek:
      return cartReducer_objectSpread(cartReducer_objectSpread({}, state), {}, {
        prices: payload && payload.errors ? state.prices : payload && payload !== null && payload !== void 0 && (_payload$applyCouponT = payload.applyCouponToCart) !== null && _payload$applyCouponT !== void 0 && _payload$applyCouponT.cart.prices ? payload.applyCouponToCart.cart.prices : null,
        applied_coupons: payload && (payload === null || payload === void 0 ? void 0 : (_payload$applyCouponT2 = payload.applyCouponToCart) === null || _payload$applyCouponT2 === void 0 ? void 0 : (_payload$applyCouponT3 = _payload$applyCouponT2.cart) === null || _payload$applyCouponT3 === void 0 ? void 0 : _payload$applyCouponT3.applied_coupons),
        errorMsg: payload && payload.errors && payload.errors.length > 0 && payload.errors[0].message ? payload.errors[0].message : null
      });

    case actionTypes/* REMOVE_COUPON_CODE */.o2:
      return cartReducer_objectSpread(cartReducer_objectSpread({}, state), {}, {
        applied_coupons: null,
        prices: payload && payload !== null && payload !== void 0 && (_payload$removeCoupon = payload.removeCouponFromCart) !== null && _payload$removeCoupon !== void 0 && (_payload$removeCoupon2 = _payload$removeCoupon.cart) !== null && _payload$removeCoupon2 !== void 0 && _payload$removeCoupon2.prices ? payload.removeCouponFromCart.cart.prices : null
      });

    case actionTypes/* GUEST_RESET_CART */.Sr:
      return cartReducer_objectSpread(cartReducer_objectSpread({}, state), cartReducer_initialState);

    case actionTypes/* IS_MULTICART */.m7:
      return cartReducer_objectSpread(cartReducer_objectSpread({}, state), {}, {
        isMulti: payload
      });

    default:
      return state;
  }
};

/* harmony default export */ var reducers_cartReducer = (cartReducer);
;// CONCATENATED MODULE: ./Redux/reducers/geoLocationReducer.js


function geoLocationReducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function geoLocationReducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? geoLocationReducer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : geoLocationReducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var geoLocationReducer_initialState = {
  allowed: undefined,
  latitude: null,
  longitude: null,
  storeDetails: undefined,
  changeStore: undefined,
  changeMethods: undefined
};

var geoLocationReducer = function geoLocationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : geoLocationReducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action && action.type) {
    case actionTypes/* GEOLOCATION_STATUS */.Hi:
      return geoLocationReducer_objectSpread(geoLocationReducer_objectSpread({}, state), {}, {
        allowed: action.payload
      });

    case actionTypes/* GEOLOCATION_POSITION */.EI:
      return geoLocationReducer_objectSpread(geoLocationReducer_objectSpread({}, state), {}, {
        latitude: action.payload.latitude,
        longitude: action.payload.longitude
      });

    case actionTypes/* CANDC_STORE_DETAILS */.f$:
      return geoLocationReducer_objectSpread(geoLocationReducer_objectSpread({}, state), {}, {
        storeDetails: action.payload
      });

    case actionTypes/* CHANGE_OTHER_STORE */.PH:
      return geoLocationReducer_objectSpread(geoLocationReducer_objectSpread({}, state), {}, {
        changeStore: action.payload
      });

    case actionTypes/* CHANGE_OTHER_METHODS */.ey:
      return geoLocationReducer_objectSpread(geoLocationReducer_objectSpread({}, state), {}, {
        changeMethods: action.payload
      });

    default:
      return state;
  }
};

/* harmony default export */ var reducers_geoLocationReducer = (geoLocationReducer);
;// CONCATENATED MODULE: ./Redux/reducers/homeReducer.js


function homeReducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function homeReducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? homeReducer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : homeReducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var homeReducer_initialState = {
  home: {}
};
function homeReducers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : homeReducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actionTypes/* SET_HOME_COMPONENTS */.gL:
      return homeReducer_objectSpread(homeReducer_objectSpread({}, state), {}, {
        home: action.data
      });

    default:
      return state;
  }
}
;// CONCATENATED MODULE: ./Redux/reducers/navigationReducer.js


function navigationReducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function navigationReducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? navigationReducer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : navigationReducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var navigationReducer_initialState = {
  footerLinks: {}
};

var navigationReducer = function navigationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : navigationReducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actionTypes/* GET_FOOTER_LINKS_SUCCESS */.ZY:
      return navigationReducer_objectSpread(navigationReducer_objectSpread({}, state), {}, {
        footerLinks: action.payload.footerData
      });

    default:
      return state;
  }
};

/* harmony default export */ var reducers_navigationReducer = (navigationReducer);
;// CONCATENATED MODULE: ./Redux/reducers/navReducer.js


function navReducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function navReducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? navReducer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : navReducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var navReducer_initialState = {
  megaMenu: [],
  globalNav: {},
  profileData: null,
  isUserLoggedIn: false,
  isProfileLoading: null,
  isReLogin: false,
  isMiniApp: false,
  isBackEnabled: false,
  isCheckoutLogin: false,
  customerData: null,
  oauthTokenDetails: null,
  subscriptions: [],
  hideNavItems: false,
  isMobileFilter: false
};

var navReducer = function navReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : navReducer_initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case actionTypes/* MEGA_MENU */.WC:
      return navReducer_objectSpread(navReducer_objectSpread({}, state), {}, {
        megaMenu: payload
      });

    case actionTypes/* GLOBAL_NAV */.i4:
      return navReducer_objectSpread(navReducer_objectSpread({}, state), {}, {
        globalNav: payload
      });

    case actionTypes/* SET_PROFILE_DATA */.eT:
      return navReducer_objectSpread(navReducer_objectSpread({}, state), {}, {
        profileData: payload.profile,
        isUserLoggedIn: payload.user,
        customerData: payload.customer,
        oauthTokenDetails: payload.oauthTokenDetails,
        subscriptions: payload.subscriptions,
        isProfileLoading: false
      });

    case actionTypes/* TOGGLE_SEARCH */.Tw:
      return navReducer_objectSpread(navReducer_objectSpread({}, state), {}, {
        hideNavItems: payload ? true : false
      });

    case actionTypes/* TOGGLE_FILTERS */.$G:
      return navReducer_objectSpread(navReducer_objectSpread({}, state), {}, {
        isMobileFilter: payload ? true : false
      });

    case actionTypes/* SET_PROFILE_LOADING */.k_:
      return navReducer_objectSpread(navReducer_objectSpread({}, state), {}, {
        isProfileLoading: !!payload
      });

    case actionTypes/* SET_RELOGIN */.Ld:
      return navReducer_objectSpread(navReducer_objectSpread({}, state), {}, {
        isReLogin: payload ? true : false
      });

    case actionTypes/* SET_CHECKOUT_LOGIN */.QV:
      return navReducer_objectSpread(navReducer_objectSpread({}, state), {}, {
        isCheckoutLogin: payload ? true : false
      });

    case actionTypes/* SET_MINIAPP */.Um:
      return navReducer_objectSpread(navReducer_objectSpread({}, state), {}, {
        isMiniApp: payload ? true : false
      });

    case actionTypes/* SET_BACKENABLED */.WD:
      return navReducer_objectSpread(navReducer_objectSpread({}, state), {}, {
        isBackEnabled: payload ? true : false
      });

    default:
      return state;
  }
};

/* harmony default export */ var reducers_navReducer = (navReducer);
;// CONCATENATED MODULE: ./Redux/reducers/footerReducer.js


function footerReducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function footerReducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? footerReducer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : footerReducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var footerReducer_initialState = {
  hideFooter: false
};

var displayHideFooterReducer = function displayHideFooterReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : footerReducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actionTypes/* DISPLAY_HIDE_FOOTER */.WP:
      if (action.payload === true || action.payload === false) {
        return footerReducer_objectSpread(footerReducer_objectSpread({}, state), {}, {
          hideFooter: action.payload
        });
      } else {
        return state;
      }

    default:
      return state;
  }
};

/* harmony default export */ var footerReducer = (displayHideFooterReducer);
;// CONCATENATED MODULE: ./Redux/reducers/termsAndConditionsReducer.js


function termsAndConditionsReducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function termsAndConditionsReducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? termsAndConditionsReducer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : termsAndConditionsReducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var termsAndConditionsReducer_initialState = {
  list: {},
  topic: {}
};
/* harmony default export */ var termsAndConditionsReducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : termsAndConditionsReducer_initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case actionTypes/* TERMS_AND_CONDITIONS */.bh:
      return termsAndConditionsReducer_objectSpread(termsAndConditionsReducer_objectSpread({}, state), {}, {
        list: payload
      });

    case actionTypes/* TERMS_AND_CONDITIONS_TOPIC */.Vl:
      return termsAndConditionsReducer_objectSpread(termsAndConditionsReducer_objectSpread({}, state), {}, {
        topic: payload
      });

    default:
      return state;
  }
});
;// CONCATENATED MODULE: ./Redux/reducers/breadcrumbReducer.js


function breadcrumbReducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function breadcrumbReducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? breadcrumbReducer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : breadcrumbReducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var breadcrumbReducer_initialState = {
  slice: false
};

var SliceBreadcrumb = function SliceBreadcrumb() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : breadcrumbReducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actionTypes/* BREADCRUMB_SELECT */.T1:
      return breadcrumbReducer_objectSpread(breadcrumbReducer_objectSpread({}, state), {}, {
        slice: action.payload
      });

    default:
      return state;
  }
};

/* harmony default export */ var breadcrumbReducer = (SliceBreadcrumb);
;// CONCATENATED MODULE: ./Redux/reducers/AlertReducer.js


function AlertReducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function AlertReducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? AlertReducer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : AlertReducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var AlertReducer_initialState = {
  alert: false
};

var alertSelect = function alertSelect() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : AlertReducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action && action.type) {
    case actionTypes/* ALERT_SELECT */.XI:
      return AlertReducer_objectSpread(AlertReducer_objectSpread({}, state), {}, {
        alert: action.payload
      });

    default:
      return state;
  }
};

/* harmony default export */ var AlertReducer = (alertSelect);
// EXTERNAL MODULE: ./config/constants.js
var constants = __webpack_require__(58223);
;// CONCATENATED MODULE: ./Redux/reducers/checkoutReducer.js


function checkoutReducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function checkoutReducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? checkoutReducer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : checkoutReducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var checkoutReducer_initialState = {
  normalCheckoutCurrentStep: null,
  postCheckoutCurrentStep: null,
  lookupDetails: null,
  authDetails: null,
  skipCreditVetting: false,
  xdsResult: null,
  creditVettingResult: null,
  numberTransferType: constants/* NumberTransferTypes.NEW_NUMBER */.Wh.NEW_NUMBER,
  numberToTransfer: "",
  numberTransferDetails: {},
  paymentMethodCode: "checkmo",
  paymentMethodUrl: null,
  postOrderResponse: {}
};

var checkoutReducer = function checkoutReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : checkoutReducer_initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case actionTypes/* SET_NORMAL_CHECKOUT_CURRENT_STEP */.GT:
      return checkoutReducer_objectSpread(checkoutReducer_objectSpread({}, state), {}, {
        normalCheckoutCurrentStep: payload
      });

    case actionTypes/* SET_POST_CHECKOUT_CURRENT_STEP */.$u:
      return checkoutReducer_objectSpread(checkoutReducer_objectSpread({}, state), {}, {
        postCheckoutCurrentStep: payload
      });

    case actionTypes/* SET_LOOKUP_DETAILS */.bL:
      return checkoutReducer_objectSpread(checkoutReducer_objectSpread({}, state), {}, {
        lookupDetails: payload
      });

    case actionTypes/* SET_AUTHENTICATION_DETAILS */.TY:
      return checkoutReducer_objectSpread(checkoutReducer_objectSpread({}, state), {}, {
        authDetails: payload
      });

    case actionTypes/* SET_SKIP_CREDIT_VETTING */.CI:
      return checkoutReducer_objectSpread(checkoutReducer_objectSpread({}, state), {}, {
        skipCreditVetting: payload
      });

    case actionTypes/* SET_XDS_RESULT */.AH:
      return checkoutReducer_objectSpread(checkoutReducer_objectSpread({}, state), {}, {
        xdsResult: payload
      });

    case actionTypes/* SET_CREDIT_VETTING_RESULT */.GE:
      return checkoutReducer_objectSpread(checkoutReducer_objectSpread({}, state), {}, {
        creditVettingResult: payload
      });

    case actionTypes/* SET_NUMBER_TRANSFER_TYPE */.bb:
      return checkoutReducer_objectSpread(checkoutReducer_objectSpread({}, state), {}, {
        numberTransferType: payload
      });

    case actionTypes/* SET_NUMBER_TRANSFER_DETAILS */.Kc:
      return checkoutReducer_objectSpread(checkoutReducer_objectSpread({}, state), {}, {
        numberTransferDetails: payload
      });

    case actionTypes/* SET_NUMBER_TO_TRANSFER */.Gm:
      return checkoutReducer_objectSpread(checkoutReducer_objectSpread({}, state), {}, {
        numberToTransfer: payload
      });

    case actionTypes/* SET_PAYMENT_METHOD */.wQ:
      return checkoutReducer_objectSpread(checkoutReducer_objectSpread({}, state), {}, {
        paymentMethodCode: payload
      });

    case actionTypes/* SET_PAYMENT_METHOD_URL */.VM:
      return checkoutReducer_objectSpread(checkoutReducer_objectSpread({}, state), {}, {
        paymentMethodUrl: payload
      });

    case actionTypes/* SET_POST_ORDER_RESPONSE */.jw:
      return checkoutReducer_objectSpread(checkoutReducer_objectSpread({}, state), {}, {
        postOrderResponse: payload
      });

    default:
      return state;
  }
};

/* harmony default export */ var reducers_checkoutReducer = (checkoutReducer);
;// CONCATENATED MODULE: ./Redux/reducers/creditCheckReducer.js


function creditCheckReducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function creditCheckReducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? creditCheckReducer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : creditCheckReducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var creditCheckReducer_initialState = {
  personalDetails: null,
  employmentDetails: null,
  homeDetails: null,
  debitDetails: null,
  deliveryDetails: null,
  contactDetails: null,
  isShowAffordDeal: false,
  isSelectedAffordDeal: true,
  creditVettingDetails: null
};

var creditCheckReducer = function creditCheckReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : creditCheckReducer_initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case actionTypes/* SET_CREDIT_CHECK_PERSONAL_DATA */.bP:
      return creditCheckReducer_objectSpread(creditCheckReducer_objectSpread({}, state), {}, {
        personalDetails: payload
      });

    case actionTypes/* SET_CREDIT_CHECK_EMPLOYMENT_DATA */.yP:
      return creditCheckReducer_objectSpread(creditCheckReducer_objectSpread({}, state), {}, {
        employmentDetails: payload
      });

    case actionTypes/* SET_CREDIT_CHECK_HOME_DATA */.nd:
      return creditCheckReducer_objectSpread(creditCheckReducer_objectSpread({}, state), {}, {
        homeDetails: payload
      });

    case actionTypes/* SET_CREDIT_CHECK_DEBIT_DATA */.cq:
      return creditCheckReducer_objectSpread(creditCheckReducer_objectSpread({}, state), {}, {
        debitDetails: payload
      });

    case actionTypes/* SET_CREDIT_CHECK_DELIVERY_DATA */.pM:
      return creditCheckReducer_objectSpread(creditCheckReducer_objectSpread({}, state), {}, {
        deliveryDetails: payload
      });

    case actionTypes/* SET_CREDIT_CHECK_CONTACT_DATA */.HM:
      return creditCheckReducer_objectSpread(creditCheckReducer_objectSpread({}, state), {}, {
        contactDetails: payload
      });

    case actionTypes/* SET_CREDIT_CHECK_AFFORD_DEAL */.n1:
      return creditCheckReducer_objectSpread(creditCheckReducer_objectSpread({}, state), {}, {
        isShowAffordDeal: payload
      });

    case actionTypes/* SET_CREDIT_SELECTED_AFFORD_DEAL */._c:
      return creditCheckReducer_objectSpread(creditCheckReducer_objectSpread({}, state), {}, {
        isSelectedAffordDeal: payload
      });

    case actionTypes/* SET_CREDIT_VETTING_OUTCOME */.DI:
      return creditCheckReducer_objectSpread(creditCheckReducer_objectSpread({}, state), {}, {
        creditVettingDetails: payload
      });

    default:
      return state;
  }
};

/* harmony default export */ var reducers_creditCheckReducer = (creditCheckReducer);
;// CONCATENATED MODULE: ./Redux/reducers/userProfileReducer.js


function userProfileReducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function userProfileReducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? userProfileReducer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : userProfileReducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var userProfileReducer_initialState = {
  userDetails: null
};

var userProfileSync = function userProfileSync() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userProfileReducer_initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case actionTypes/* SYNC_USER_PROFILE_SUCCESS */.Zd:
      return userProfileReducer_objectSpread(userProfileReducer_objectSpread({}, state), {}, {
        userDetails: userProfileReducer_objectSpread(userProfileReducer_objectSpread({}, payload), {}, {
          apiStatus: true
        })
      });

    case actionTypes/* SYNC_USER_PROFILE_FAILURE */.c9:
      return userProfileReducer_objectSpread(userProfileReducer_objectSpread({}, state), {}, {
        userDetails: userProfileReducer_objectSpread(userProfileReducer_objectSpread({}, payload), {}, {
          apiStatus: false
        })
      });

    case actionTypes/* SYNC_USER_PROFILE_RESET */.gC:
      return userProfileReducer_objectSpread(userProfileReducer_objectSpread({}, state), {}, {
        userDetails: null
      });

    default:
      return state;
  }
};

/* harmony default export */ var userProfileReducer = (userProfileSync);
;// CONCATENATED MODULE: ./Redux/reducers/upgradeReducer.js


function upgradeReducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function upgradeReducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? upgradeReducer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : upgradeReducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var upgradeReducer_initialState = {
  showModal: false,
  upgradeStatus: "number entry",
  msisdn: "",
  unMaskedMsisdn: "",
  canReciveOTP: true,
  linkedNumbers: [],
  selectedLinkedNumber: "",
  invalidOTPTries: 0,
  upgradeCheckDone: false,
  upgradeResponse: {},
  selectedUpgradeResponse: {},
  selectedUpgradeMsisdn: "",
  upgradeDisplayData: {},
  selectedUpgradeDisplayData: {},
  resultCode: "",
  topBannerVisible: true,
  topBannerModal: false,
  stopBannerModal: false,
  creditFilters: {},
  allUpgradesData: [],
  upgradeLink: {
    link: "",
    text: ""
  },
  pastUsageData: {},
  manufacturers: [],
  deviceModels: [],
  recommendedSkus: [],
  checkIsDealAffordable: false,
  showSnackBar: false,
  eligibleUpgradeList: [],
  devicePrice: {
    devicePrice: 0,
    installment: 0
  },
  resetDealGrid: false,
  resetDealSelection: false,
  resetProductGrid: false,
  isChildAllowed: false,
  responseToken: "",
  dealApiError: false,
  displayInvalidOTPError: false,
  isNextMsisdnSelected: false,
  addDeal: false
};

var upgradeReducer = function upgradeReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : upgradeReducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actionTypes/* DISPLAY_HIDE_MODAL */.eK:
      return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
        showModal: action.payload
      });

    case actionTypes/* TOP_BANNER_TOGGLE */.Np:
      return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
        topBannerVisible: action.payload
      });

    case actionTypes/* TOP_BANNER_MODAL_TOGGLE */.U5:
      return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
        topBannerModal: action.payload
      });

    case actionTypes/* STOP_UPGRADE_MODAL_TOGGLE */.tG:
      return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
        stopBannerModal: action.payload
      });

    case actionTypes/* UPDATE_UPGRADE_JOURNEY_STATUS */.bA:
      return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
        upgradeStatus: action.payload.status,
        resultCode: action.payload.code
      });

    case actionTypes/* CLEAR_UPGRADE_JOURNEY_STATUS */.ZU:
      return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
        showModal: false,
        upgradeStatus: upgradeService/* upgradeStages.NUMBER_ENRTY */.wv.NUMBER_ENRTY,
        invalidOTPTries: 0,
        canReciveOTP: true,
        linkedNumbers: [],
        upgradeResponse: {},
        selectedUpgradeResponse: {},
        upgradeDisplayData: {},
        selectedUpgradeDisplayData: {},
        resultCode: null,
        allUpgradesData: [],
        upgradeCheckDone: false,
        topBannerVisible: false,
        checkIsDealAffordable: false,
        showSnackBar: false,
        eligibleUpgradeList: [],
        creditFilters: {},
        resetDealGrid: true,
        resetDealSelection: true,
        resetProductGrid: true,
        selectedLinkedNumber: "",
        isChildAllowed: false,
        displayInvalidOTPError: false,
        manufacturers: [],
        upgradeLink: {
          link: "",
          text: ""
        },
        addDeal: false
      });

    case actionTypes/* CLEAR_ENTIRE_JOURNEY */.Q0:
      return upgradeReducer_initialState;

    case actionTypes/* UPDATE_DEAL_GRID_RESET */.WO:
      return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
        resetDealGrid: false
      });

    case actionTypes/* UPDATE_DEAL_SELECTION_RESET */._f:
      return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
        resetDealSelection: false
      });

    case actionTypes/* UPDATE_PRODUCT_GRID_RESET */.og:
      return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
        resetProductGrid: false
      });

    case actionTypes/* UPDATE_CAN_RECEIVE_OTP */.C7:
      return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
        canReciveOTP: action.payload
      });

    case actionTypes/* UPDATE_MSISDN_STATUS */.Ss:
      return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
        msisdn: action.payload.number
      });

    case actionTypes/* UPDATE_ELIGIBILITY_CHECK_STATUS */.ah:
      return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
        upgradeCheckDone: action.payload,
        topBannerVisible: action.payload
      });

    case actionTypes/* UPDATE_ELIGIBILITY_DATA */.ic:
      {
        var _action$payload$data, _action$payload$data$, _action$payload$data2, _action$payload$data3, _newUpgrade, _newUpgrade$resultCod, _action$payload$data13, _action$payload$data14;

        var currentUpgrade = [];
        var isCurrentUpgradeMah = false;
        var isChildAllowed = false;

        if ((_action$payload$data = action.payload.data) !== null && _action$payload$data !== void 0 && (_action$payload$data$ = _action$payload$data.result) !== null && _action$payload$data$ !== void 0 && _action$payload$data$.result && (_action$payload$data2 = action.payload.data) !== null && _action$payload$data2 !== void 0 && (_action$payload$data3 = _action$payload$data2.result) !== null && _action$payload$data3 !== void 0 && _action$payload$data3.result.length) {
          var _action$payload$data4, _action$payload$data5, _action$payload$data6, _action$payload$data7;

          (_action$payload$data4 = action.payload.data) === null || _action$payload$data4 === void 0 ? void 0 : (_action$payload$data5 = _action$payload$data4.result) === null || _action$payload$data5 === void 0 ? void 0 : _action$payload$data5.result.forEach(function (item) {
            if ((0,upgradeService/* maskMsisdn */.Ly)(item.msisdn) === (0,upgradeService/* maskMsisdn */.Ly)(state.selectedLinkedNumber)) {
              isChildAllowed = !(item !== null && item !== void 0 && item.mah);
            }
          });
          currentUpgrade = (_action$payload$data6 = action.payload.data) === null || _action$payload$data6 === void 0 ? void 0 : (_action$payload$data7 = _action$payload$data6.result) === null || _action$payload$data7 === void 0 ? void 0 : _action$payload$data7.result.filter(function (item) {
            if ((0,upgradeService/* maskMsisdn */.Ly)(item.msisdn) === (0,upgradeService/* maskMsisdn */.Ly)(state.unMaskedMsisdn)) {
              isCurrentUpgradeMah = item === null || item === void 0 ? void 0 : item.mah;
              return item;
            }
          });
        }

        var newUpgrade = {};

        if (currentUpgrade.length) {
          newUpgrade = currentUpgrade[0];
        } else {
          var _action$payload$data8, _action$payload$data9, _action$payload$data10;

          if ((_action$payload$data8 = action.payload.data) !== null && _action$payload$data8 !== void 0 && (_action$payload$data9 = _action$payload$data8.result) !== null && _action$payload$data9 !== void 0 && (_action$payload$data10 = _action$payload$data9.result[0]) !== null && _action$payload$data10 !== void 0 && _action$payload$data10.msisdn) {
            newUpgrade = {};
          } else {
            var _action$payload$data11, _action$payload$data12;

            newUpgrade = (_action$payload$data11 = action.payload.data) === null || _action$payload$data11 === void 0 ? void 0 : (_action$payload$data12 = _action$payload$data11.result) === null || _action$payload$data12 === void 0 ? void 0 : _action$payload$data12.result[0];
          }
        }

        return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
          resultCode: (_newUpgrade = newUpgrade) !== null && _newUpgrade !== void 0 && _newUpgrade.resultCode ? (_newUpgrade$resultCod = newUpgrade.resultCode) === null || _newUpgrade$resultCod === void 0 ? void 0 : _newUpgrade$resultCod.toLowerCase() : upgradeService/* errorCodes.user_acc_error */.Zk.user_acc_error,
          upgradeResponse: newUpgrade,
          allUpgradesData: !isCurrentUpgradeMah ? currentUpgrade : (_action$payload$data13 = action.payload.data) === null || _action$payload$data13 === void 0 ? void 0 : (_action$payload$data14 = _action$payload$data13.result) === null || _action$payload$data14 === void 0 ? void 0 : _action$payload$data14.result,
          isChildAllowed: isChildAllowed
        });
      }

    case actionTypes/* UPDATE_DISPLAY_DATA */.j1:
      return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
        upgradeDisplayData: action.payload
      });

    case actionTypes/* UPDATE_SELECTED_DISPLAY_DATA */.lG:
      return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
        selectedUpgradeDisplayData: action.payload
      });

    case actionTypes/* INVALID_OTP */._G:
      return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
        invalidOTPTries: state.invalidOTPTries + 1,
        displayInvalidOTPError: true
      });

    case actionTypes/* MSISDN_BLOCKED */.gA:
      return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
        invalidOTPTries: (config_default()).maxRetriesCount
      });

    case actionTypes/* ADD_ALTERNATE_NUMBERS */.BD:
      return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
        linkedNumbers: action.payload.data
      });

    case actionTypes/* UPDATE_LOGGED_IN_USER_ELIGIBILITY_DATA */.jN:
      {
        var _eligibleUpgrade$0$re, _action$payload$data$2, _action$payload$data$3;

        var eligibleUpgrade = [];

        if (action.payload.data && action.payload.data.length) {
          eligibleUpgrade = action.payload.data.filter(function (item) {
            if (item.upgradeEligible) {
              return item;
            }
          });
        }

        return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
          resultCode: eligibleUpgrade.length ? (_eligibleUpgrade$0$re = eligibleUpgrade[0].resultCode) === null || _eligibleUpgrade$0$re === void 0 ? void 0 : _eligibleUpgrade$0$re.toLowerCase() : (_action$payload$data$2 = action.payload.data[0]) === null || _action$payload$data$2 === void 0 ? void 0 : (_action$payload$data$3 = _action$payload$data$2.resultCode) === null || _action$payload$data$3 === void 0 ? void 0 : _action$payload$data$3.toLowerCase(),
          upgradeResponse: eligibleUpgrade.length ? eligibleUpgrade[0] : action.payload.data[0] || {},
          selectedUpgradeResponse: eligibleUpgrade.length ? eligibleUpgrade[0] : action.payload.data[0] || {},
          allUpgradesData: action.payload.data,
          showSnackBar: eligibleUpgrade.length > 0,
          eligibleUpgradeList: eligibleUpgrade,
          msisdn: sessionStorage.getItem('upgradeMsisdn'),
          unMaskedMsisdn: "",
          selectedUpgradeMsisdn: ""
        });
      }

    case actionTypes/* ADD_CREDIT_PROFILE */.DJ:
      return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
        creditFilters: action.payload
      });

    case actionTypes/* UPDATE_SELECTED_UPGRADE_DATA */.pI:
      {
        var _action$payload$resul, _action$payload$data15;

        return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
          resultCode: (_action$payload$resul = action.payload.resultCode) === null || _action$payload$resul === void 0 ? void 0 : _action$payload$resul.toLowerCase(),
          selectedUpgradeResponse: action.payload.data,
          msisdn: action.payload.msisdn,
          selectedUpgradeMsisdn: (_action$payload$data15 = action.payload.data) === null || _action$payload$data15 === void 0 ? void 0 : _action$payload$data15.msisdn
        });
      }

    case actionTypes/* UPDATE_UPGRADE_DATA */.yn:
      {
        var _action$payload$resul2;

        return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
          resultCode: (_action$payload$resul2 = action.payload.resultCode) === null || _action$payload$resul2 === void 0 ? void 0 : _action$payload$resul2.toLowerCase(),
          upgradeResponse: action.payload.data,
          msisdn: action.payload.msisdn
        });
      }

    case actionTypes/* UPDATE_UPGRADE_REDIRECT */.ZM:
      {
        return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
          upgradeLink: action.payload
        });
      }

    case actionTypes/* UPDATE_UNMASKED_MSISDN */.jA:
      {
        return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
          unMaskedMsisdn: action.payload
        });
      }

    case actionTypes/* GET_PAST_USAGE */.jy:
      {
        return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
          pastUsageData: action.payload.data
        });
      }

    case actionTypes/* GET_UPGRADE_BRANDS */.ZP:
      {
        return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
          manufacturers: action.payload.data
        });
      }

    case actionTypes/* GET_UPGRADE_MODELS */.hL:
      {
        return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
          deviceModels: action.payload.data
        });
      }

    case actionTypes/* GET_RECOMMENDED_DEALS */.I6:
      {
        return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
          recommendedSkus: action.payload.data,
          dealApiError: action.payload.error
        });
      }

    case actionTypes/* GET_UPGRADE_CONSUMPTION */.Jl:
      {
        return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
          pastConsumptionData: action.payload.data
        });
      }

    case actionTypes/* UPDATE_CHECK_DEAL_QUALIFIES */.rY:
      {
        return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
          checkIsDealAffordable: action.payload
        });
      }

    case actionTypes/* RESET_INVALID_OTPS */.ct:
      {
        return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
          invalidOTPTries: 0
        });
      }

    case actionTypes/* TOGGLE_SNACK_BAR */.Bd:
      {
        return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
          showSnackBar: action.payload
        });
      }

    case actionTypes/* DEAL_PRICE */.y9:
      {
        return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
          devicePrice: action.payload
        });
      }

    case actionTypes/* UPDATE_LINKED_NUMBER */.j$:
      {
        return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
          selectedLinkedNumber: action.payload
        });
      }

    case actionTypes/* PAST_TOKEN */.Fh:
      {
        var _action$payload;

        return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
          responseToken: (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.token
        });
      }

    case actionTypes/* DISPLAY_INVALID_OTP_ERROR */.wR:
      {
        return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
          displayInvalidOTPError: action.payload
        });
      }

    case actionTypes/* UPDATE_NEXT_MSISDN_SELECTED */.Of:
      {
        return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
          isNextMsisdnSelected: action.payload
        });
      }

    case actionTypes/* ADD_DEAL_TO_CART */.ug:
      {
        return upgradeReducer_objectSpread(upgradeReducer_objectSpread({}, state), {}, {
          addDeal: action.payload
        });
      }

    default:
      return state;
  }
};

/* harmony default export */ var reducers_upgradeReducer = (upgradeReducer);
;// CONCATENATED MODULE: ./Redux/reducers/checkoutErrorReducer.js


function checkoutErrorReducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function checkoutErrorReducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? checkoutErrorReducer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : checkoutErrorReducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var checkoutErrorReducer_initialState = {
  selected_preference: null
};

var selectedPreferenceReducer = function selectedPreferenceReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : checkoutErrorReducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action && action.type) {
    case actionTypes/* CHECKOUT_PAGE_ERROR_SELECTED_PREFERENCE */.VV:
      return checkoutErrorReducer_objectSpread(checkoutErrorReducer_objectSpread({}, state), {}, {
        selected_preference: action.payload
      });

    default:
      return state;
  }
};

/* harmony default export */ var checkoutErrorReducer = (selectedPreferenceReducer);
;// CONCATENATED MODULE: ./Redux/reducers/getHelpReducer.js


function getHelpReducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function getHelpReducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? getHelpReducer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : getHelpReducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var getHelpReducer_initialState = {
  getHelpLeadBucket: constants/* LEAD_BUCKETS.general */.xO.general
};

var getHelpReducer = function getHelpReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getHelpReducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actionTypes/* SET_HELP_LEAD_BUCKET */.c4:
      if (action.payload) {
        return getHelpReducer_objectSpread(getHelpReducer_objectSpread({}, state), {}, {
          getHelpLeadBucket: action.payload
        });
      } else {
        return state;
      }

    default:
      return state;
  }
};

/* harmony default export */ var reducers_getHelpReducer = (getHelpReducer);
// EXTERNAL MODULE: ./Redux/actionTypes/dealDetailsActionTypes.js
var dealDetailsActionTypes = __webpack_require__(71404);
;// CONCATENATED MODULE: ./Redux/reducers/dealDetailsReducer.js


function dealDetailsReducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function dealDetailsReducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? dealDetailsReducer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : dealDetailsReducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var dealDetailsReducer_initialState = {
  attributeCodes: [],
  contractsList: [],
  contractsDurations: [],
  dataPlanDetails: {},
  dealInclusions: [],
  dealInclusionColors: {},
  dealList: [],
  primaryProductColors: [],
  primaryProduct: {},
  relatedDeals: [],
  secondaryProduct: {},
  secondaryProductColors: [],
  selectedApplicationType: {},
  selectedDealDetails: {},
  // TODO: Dissolve into other props to remove duplication
  selectedPrimaryDeviceColor: {},
  selectedSecondaryDeviceColor: {},
  selectedDurationAndPrice: {},
  similarDeals: [],
  whiteListedRouters: []
};
/* harmony default export */ var dealDetailsReducer = (function () {
  var _payload$primaryDevic, _payload$secondaryDev;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : dealDetailsReducer_initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case dealDetailsActionTypes/* SET_ALL_DEAL_DATA */.NR:
      return dealDetailsReducer_objectSpread(dealDetailsReducer_objectSpread({}, state), {}, {
        attributeCodes: payload.attributeCodes,
        contractsDurations: payload.contractsDurations,
        contractsList: payload.contractsList,
        dataPlanDetails: payload.dataPlanDetails,
        dealList: payload.dealList,
        dealInclusions: payload.dealInclusions,
        dealInclusionColors: payload.dealInclusionColors,
        primaryProductColors: payload.primaryProductColors,
        primaryProduct: payload.primaryProduct,
        relatedDeals: payload.relatedDeals,
        secondaryProduct: payload.secondaryProduct || {},
        secondaryProductColors: payload.secondaryProductColors || [],
        selectedDealDetails: payload.selectedDealDetails,
        selectedPrimaryDeviceColor: payload.selectedPrimaryDeviceColor,
        selectedSecondaryDeviceColor: payload.selectedSecondaryDeviceColor,
        similarDeals: payload.similarDeals || []
      });

    case dealDetailsActionTypes/* SET_APPLICATION_TYPE */.QH:
      return dealDetailsReducer_objectSpread(dealDetailsReducer_objectSpread({}, state), {}, {
        selectedApplicationType: payload
      });

    case dealDetailsActionTypes/* SET_ATTRIBUTE_CODES */.VF:
      return dealDetailsReducer_objectSpread(dealDetailsReducer_objectSpread({}, state), {}, {
        attributeCodes: payload
      });

    case dealDetailsActionTypes/* SET_CONTRACT_DURATIONS */._I:
      return dealDetailsReducer_objectSpread(dealDetailsReducer_objectSpread({}, state), {}, {
        contractsDurations: payload
      });

    case dealDetailsActionTypes/* SET_CONTRACT_TYPES */.tc:
      return dealDetailsReducer_objectSpread(dealDetailsReducer_objectSpread({}, state), {}, {
        contractsList: payload
      });

    case dealDetailsActionTypes/* SET_DEAL_DETAILS */.HP:
      {
        var newDeal = Array.isArray(state.dealList) && state.dealList.find(function (deal) {
          return deal.sku === payload.dealSku;
        }) || {};
        return dealDetailsReducer_objectSpread(dealDetailsReducer_objectSpread({}, state), {}, {
          selectedDealDetails: newDeal
        });
      }

    case dealDetailsActionTypes/* SET_DEAL_LIST */.h0:
      return dealDetailsReducer_objectSpread(dealDetailsReducer_objectSpread({}, state), {}, {
        dealList: payload
      });

    case dealDetailsActionTypes/* SET_DEVICE_COLOR */.tj:
      return dealDetailsReducer_objectSpread(dealDetailsReducer_objectSpread({}, state), {}, {
        selectedPrimaryDeviceColor: (_payload$primaryDevic = payload.primaryDeviceColor) !== null && _payload$primaryDevic !== void 0 ? _payload$primaryDevic : state.selectedPrimaryDeviceColor,
        selectedSecondaryDeviceColor: (_payload$secondaryDev = payload.secondaryDeviceColor) !== null && _payload$secondaryDev !== void 0 ? _payload$secondaryDev : state.selectedSecondaryDeviceColor
      });

    case dealDetailsActionTypes/* SET_DEVICE_COLOR_OPTIONS */.e7:
      return dealDetailsReducer_objectSpread(dealDetailsReducer_objectSpread({}, state), {}, {
        primaryProductColors: payload
      });

    case dealDetailsActionTypes/* SET_DEVICE_DURATION_PRICE */.qC:
      return dealDetailsReducer_objectSpread(dealDetailsReducer_objectSpread({}, state), {}, {
        selectedDurationAndPrice: payload
      });

    case dealDetailsActionTypes/* SET_INCLUSION_COLOR */.WU:
      return dealDetailsReducer_objectSpread(dealDetailsReducer_objectSpread({}, state), {}, {
        dealInclusionColors: dealDetailsReducer_objectSpread(dealDetailsReducer_objectSpread({}, state.dealInclusionColors), {}, (0,defineProperty/* default */.Z)({}, payload.inclusionSku, dealDetailsReducer_objectSpread(dealDetailsReducer_objectSpread({}, state.dealInclusionColors[payload.inclusionSku]), {}, {
          selectedColor: payload.inclusionColor
        })))
      });

    case dealDetailsActionTypes/* SET_RELATED_DEALS */.$R:
      return dealDetailsReducer_objectSpread(dealDetailsReducer_objectSpread({}, state), {}, {
        relatedDeals: payload
      });

    case dealDetailsActionTypes/* SET_WHITELISTED_ROUTERS */.Gg:
      return dealDetailsReducer_objectSpread(dealDetailsReducer_objectSpread({}, state), {}, {
        whiteListedRouters: payload
      });

    default:
      return state;
  }
});
;// CONCATENATED MODULE: ./Redux/reducers/dealBuilderReducer.js


function dealBuilderReducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function dealBuilderReducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? dealBuilderReducer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : dealBuilderReducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var dealBuilderReducer_initialState = {
  contractMode: "new-contract",
  maxRecurring: 99999999999
};
/* harmony default export */ var dealBuilderReducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : dealBuilderReducer_initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case actionTypes/* SET_CONTRACT_MODE */.vy:
      return dealBuilderReducer_objectSpread(dealBuilderReducer_objectSpread({}, state), {}, {
        contractMode: payload
      });

    case actionTypes/* SET_MAX_RECURRING */.nU:
      return dealBuilderReducer_objectSpread(dealBuilderReducer_objectSpread({}, state), {}, {
        maxRecurring: payload
      });

    default:
      return state;
  }
});
;// CONCATENATED MODULE: ./Redux/reducers/commonReducer.js


function commonReducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function commonReducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? commonReducer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : commonReducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var commonReducer_initialState = {
  features: {},
  isLoading: false
};
/* harmony default export */ var commonReducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : commonReducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action && action.type) {
    case actionTypes/* SET_FEATURES */.iQ:
      return commonReducer_objectSpread(commonReducer_objectSpread({}, state), {}, {
        features: action.payload
      });

    case actionTypes/* SET_IS_LOADING */.GA:
      return commonReducer_objectSpread(commonReducer_objectSpread({}, state), {}, {
        isLoading: action.payload
      });

    default:
      return state;
  }
});
;// CONCATENATED MODULE: ./Redux/reducers/pageBuilderReducer.js


function pageBuilderReducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function pageBuilderReducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? pageBuilderReducer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : pageBuilderReducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var pageBuilderReducer_initialState = {
  products: {},
  categoryCmsContent: null,
  currencySymbol: ''
};
/* harmony default export */ var pageBuilderReducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : pageBuilderReducer_initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case actionTypes/* GET_CATEGORY_CMS_CONTENT */.Vs:
      return pageBuilderReducer_objectSpread(pageBuilderReducer_objectSpread({}, state), {}, {
        categoryCmsContent: pageBuilderReducer_objectSpread(pageBuilderReducer_objectSpread({}, state.categoryCmsContent), {}, (0,defineProperty/* default */.Z)({}, payload.categoryId, pageBuilderReducer_objectSpread({}, payload)))
      });

    case actionTypes/* GET_PRODUCTS_BY_SKUS */.l6:
      return pageBuilderReducer_objectSpread(pageBuilderReducer_objectSpread({}, state), {}, {
        products: pageBuilderReducer_objectSpread(pageBuilderReducer_objectSpread({}, state.products), {}, (0,defineProperty/* default */.Z)({}, payload.id, payload))
      });

    case actionTypes/* GET_DEALS_PRODUCTS_BY_SKUS */.Ev:
      return pageBuilderReducer_objectSpread(pageBuilderReducer_objectSpread({}, state), {}, {
        products: pageBuilderReducer_objectSpread(pageBuilderReducer_objectSpread({}, state.products), {}, (0,defineProperty/* default */.Z)({}, payload.id, payload))
      });

    case actionTypes/* GET_CURRENCY_SYMBOL */.sM:
      return pageBuilderReducer_objectSpread(pageBuilderReducer_objectSpread({}, state), {}, {
        currencySymbol: payload.currencySymbol
      });

    default:
      return state;
  }
});
;// CONCATENATED MODULE: ./Redux/reducers/rootReducers.js






















 // COMBINED REDUCERS

var reducers = {
  productCompare: reducers_productCompareReducer,
  productSearchList: productReducer.productSearchList,
  productDetails: productDetailReducer,
  cartDetails: reducers_cartReducer,
  geoLocation: reducers_geoLocationReducer,
  home: homeReducers,
  navigation: reducers_navigationReducer,
  navDetails: reducers_navReducer,
  displayHideFooter: footerReducer,
  termsAndConditions: termsAndConditionsReducer,
  SliceBreadcrumb: breadcrumbReducer,
  alertSelect: AlertReducer,
  checkoutDetails: reducers_checkoutReducer,
  upgrade: reducers_upgradeReducer,
  creditCheckDetails: reducers_creditCheckReducer,
  userProfileSync: userProfileReducer,
  checkoutPageError: checkoutErrorReducer,
  getHelp: reducers_getHelpReducer,
  dealDetails: dealDetailsReducer,
  common: commonReducer,
  pageBuilder: pageBuilderReducer,
  dealBuilder: dealBuilderReducer //hide from sessionstorage

};
/* harmony default export */ var rootReducers = (combineReducers(reducers));
;// CONCATENATED MODULE: ./Redux/store/index.js






/* harmony default export */ var store = (function (initialState) {
  var _EnvConfig$redux;

  function saveToSessionStorage(state) {
    try {
      //code need to be updated
      if (true) {
        // code need to be updated
        (0,helperServices/* updateSessionStorage */.F$)('state', state);
      }
    } catch (e) {
      console.log(e);
    }
  }

  function loadFromSessionStorage() {
    try {
      if (true) {
        var serializedState = (0,helperServices/* getSessionStorage */.wJ)('state');
        if (serializedState === null) return undefined;
        return serializedState;
      }
    } catch (e) {
      console.log(e);
      return undefined;
    }
  }

  var persistedState =  true ? loadFromSessionStorage() : 0;
  var isProdEnv = true;
  var middleware = [redux_thunk_es];

  if (!isProdEnv && config.EnvConfig !== null && config.EnvConfig !== void 0 && (_EnvConfig$redux = config.EnvConfig.redux) !== null && _EnvConfig$redux !== void 0 && _EnvConfig$redux.enableLogger) {
    middleware.push((redux_logger_default()));
  }

  var store = createStore(rootReducers, persistedState, applyMiddleware.apply(void 0, middleware)); // IF REDUCERS WERE CHANGED, RELOAD WITH INITIAL STATE

  if (false) {}

  store.subscribe(function () {
    saveToSessionStorage(store.getState());
  });
  return {
    store: store
  };
});
;// CONCATENATED MODULE: ./lib/with-redux-store.js









function with_redux_store_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function with_redux_store_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? with_redux_store_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : with_redux_store_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }





var __NEXT_REDUX_STORE__ = '__NEXT_REDUX_STORE__';
function getOrCreateStore(initialState) {
  // Always make a new store if server, otherwise state is shared between requests
  if (false) {} // Create store if unavailable on the client and set it on the window object


  if (!window[__NEXT_REDUX_STORE__]) {
    window[__NEXT_REDUX_STORE__] = store(initialState);
  }

  return window[__NEXT_REDUX_STORE__];
}
/* harmony default export */ var with_redux_store = (function (App) {
  return /*#__PURE__*/function (_React$Component) {
    (0,inherits/* default */.Z)(AppWithRedux, _React$Component);

    var _super = _createSuper(AppWithRedux);

    function AppWithRedux() {
      (0,classCallCheck/* default */.Z)(this, AppWithRedux);

      return _super.apply(this, arguments);
    }

    (0,createClass/* default */.Z)(AppWithRedux, [{
      key: "render",
      value: function render() {
        var initialReduxState = this.props.initialReduxState;

        var _getOrCreateStore = getOrCreateStore(initialReduxState),
            store = _getOrCreateStore.store;

        return /*#__PURE__*/(0,jsx_runtime.jsx)(es/* Provider */.zt, {
          store: store,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(App, with_redux_store_objectSpread(with_redux_store_objectSpread({}, this.props), {}, {
            store: store
          }))
        });
      }
    }], [{
      key: "getInitialProps",
      value: function () {
        var _getInitialProps = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(appContext) {
          var _getOrCreateStore2, store;

          return regenerator_default().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  // Get or Create the store with `undefined` as initialState
                  // This allows you to set a custom default initialState
                  _getOrCreateStore2 = getOrCreateStore(), store = _getOrCreateStore2.store; // Provide the store to getInitialProps of pages

                  appContext.ctx.store = store;
                  _context.t0 = with_redux_store_objectSpread;
                  _context.t1 = with_redux_store_objectSpread;
                  _context.t2 = {};

                  if (!App.getInitialProps) {
                    _context.next = 11;
                    break;
                  }

                  _context.next = 8;
                  return App.getInitialProps(appContext);

                case 8:
                  _context.t3 = _context.sent;
                  _context.next = 12;
                  break;

                case 11:
                  _context.t3 = {};

                case 12:
                  _context.t4 = _context.t3;
                  _context.t5 = (0, _context.t1)(_context.t2, _context.t4);
                  _context.t6 = {};
                  _context.t7 = {
                    initialReduxState: store.getState()
                  };
                  return _context.abrupt("return", (0, _context.t0)(_context.t5, _context.t6, _context.t7));

                case 17:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function getInitialProps(_x) {
          return _getInitialProps.apply(this, arguments);
        }

        return getInitialProps;
      }()
    }]);

    return AppWithRedux;
  }(react.Component);
});
// EXTERNAL MODULE: ./styles/main.scss
var main = __webpack_require__(27280);
;// CONCATENATED MODULE: ./Redux/actions/breadcrumbAction.js



var handleSlice = function handleSlice(value) {
  return /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(dispatch) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch({
                type: actionTypes/* BREADCRUMB_SELECT */.T1,
                payload: value
              });

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
// EXTERNAL MODULE: ./Redux/actions/cartAction.js
var cartAction = __webpack_require__(35311);
// EXTERNAL MODULE: ./utils/microServices.js
var microServices = __webpack_require__(49366);
// EXTERNAL MODULE: ./utils/featuresService.js
var featuresService = __webpack_require__(90760);
// EXTERNAL MODULE: ./utils/logger.js
var logger = __webpack_require__(21534);
// EXTERNAL MODULE: ./config/queries.js
var queries = __webpack_require__(91250);
;// CONCATENATED MODULE: ./pages/_app.js










function _app_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _app_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _app_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : _app_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function _app_createSuper(Derived) { var hasNativeReflectConstruct = _app_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _app_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }







































var isServer = function isServer() {
  return false;
};

var k8sConfig =  false ? 0 : "";

var MyApp = /*#__PURE__*/function (_App) {
  (0,inherits/* default */.Z)(MyApp, _App);

  var _super = _app_createSuper(MyApp);

  function MyApp() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, MyApp);

    _this = _super.call(this);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "handleMiniAppHomeClick", function (url) {
      // when isMiniApp = true, we don't ever want to navigate to the home page
      // when navigating to the home page, we will route to the products page by default
      if (url === "/") {
        _this.props.router.push("/shopping/products");

        throw "Route change to \"".concat(url, "\" was aborted (this error can be safely ignored). See https://github.com/zeit/next.js/issues/2476.");
      }
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "createMiniAppBackButton", function () {
      var imagePrefix = config.EnvConfig.imagePrefix;
      return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonWithIcon/* default */.Z, {
          className: "mini_app_back_button",
          labelText: "Back",
          img_url_inactive: "".concat(imagePrefix, "/assets/images/caret-back.svg"),
          img_url_active: "".concat(imagePrefix, "/assets/images/caret-back.svg"),
          img_url_disable: "".concat(imagePrefix, "/assets/images/disable-caret-back.svg"),
          clickHandler: _this.handleBack
        })
      });
    });

    _this.pageStoreHistory = {
      history: [{
        pathname: "/",
        asPath: "/"
      }],
      prevPageName: "/"
    };
    _this.state = {
      isBannerVisible: false,
      domLoaded: false,
      miniAppBackComponent: null
    };
    _this.showTopBanner = _this.showTopBanner.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.handleBack = _this.handleBack.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.closeTopBannerModal = _this.closeTopBannerModal.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.closeBannerAndModal = _this.closeBannerAndModal.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.redirectToDeals = _this.redirectToDeals.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.clearAndOpenBannerModal = _this.clearAndOpenBannerModal.bind((0,assertThisInitialized/* default */.Z)(_this));
    return _this;
  }

  (0,createClass/* default */.Z)(MyApp, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.setProfileLoading(true);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.isMiniApp) {
        this.props.router.events.off("routeChangeStart", this.handleMiniAppHomeClick);
      }
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var userLoggedIn, reLogin, JWTtoken, authtoken, isMiniAppCookie, cartId, _profileInfoRequest$r, _profileInfoRequest$r2, _profileInfo$result, _profileInfo$result2, _profileInfo$result3, _profileInfo$result4, _profileInfo$result4$, params, profileInfoRequest, profileInfo, _profileInfo$result5, _profileInfo$result5$, _profileInfo$result5$2, _profileInfo$result6, _profileInfo$result6$, oAuthToken, selectedUpgradeMsisdn, selectedUpgradeUnmaskedMsisdn, _profileInfoRequest$e, _profileInfoRequest$e2, SyncBackInfo;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                userLoggedIn = this.props.userLoggedIn;
                reLogin = this.props.reLogin;
                this.pageNavigationHistory();
                JWTtoken = (0,helperServices/* getCookieValue */.Do)("vod-web-auth-token");
                authtoken = (0,helperServices/* getCookieValue */.Do)("auth_token");
                isMiniAppCookie = (0,helperServices/* getCookieValue */.Do)("miniApp") === "true";

                if (userLoggedIn && !authtoken) {
                  this.props.store.dispatch((0,upgradeAction/* clearUpgradeJourney */.rX)(true));
                  this.props.setProfileData(null);
                }

                cartId = (0,helperServices/* getCookieValue */.Do)("cart_id");

                if (!(cartId === undefined)) {
                  _context.next = 12;
                  break;
                }

                _context.next = 11;
                return this.createEmptyCart();

              case 11:
                cartId = _context.sent;

              case 12:
                if (!(JWTtoken && (!userLoggedIn || reLogin || isMiniAppCookie))) {
                  _context.next = 23;
                  break;
                }

                (0,helperServices/* showSpinner */.yh)();

                if (cartId) {
                  params = {
                    guestCartId: cartId
                  };
                }

                _context.next = 17;
                return microServices/* default.post */.Z.post("api", "profileSync", {}, params);

              case 17:
                profileInfoRequest = _context.sent;
                profileInfo = (_profileInfoRequest$r = profileInfoRequest.response) === null || _profileInfoRequest$r === void 0 ? void 0 : (_profileInfoRequest$r2 = _profileInfoRequest$r.data) === null || _profileInfoRequest$r2 === void 0 ? void 0 : _profileInfoRequest$r2.result;

                if (!profileInfoRequest.fail && profileInfo && profileInfo !== null && profileInfo !== void 0 && profileInfo.result && profileInfo !== null && profileInfo !== void 0 && (_profileInfo$result = profileInfo.result) !== null && _profileInfo$result !== void 0 && _profileInfo$result.magentoProfileResponse && profileInfo !== null && profileInfo !== void 0 && (_profileInfo$result2 = profileInfo.result) !== null && _profileInfo$result2 !== void 0 && _profileInfo$result2.magentoProfileResponse[0] && profileInfo !== null && profileInfo !== void 0 && (_profileInfo$result3 = profileInfo.result) !== null && _profileInfo$result3 !== void 0 && _profileInfo$result3.profileSubscriptionResponse && profileInfo !== null && profileInfo !== void 0 && (_profileInfo$result4 = profileInfo.result) !== null && _profileInfo$result4 !== void 0 && (_profileInfo$result4$ = _profileInfo$result4.profileSubscriptionResponse) !== null && _profileInfo$result4$ !== void 0 && _profileInfo$result4$.subscriptions) {
                  oAuthToken = profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$result5 = profileInfo.result) === null || _profileInfo$result5 === void 0 ? void 0 : (_profileInfo$result5$ = _profileInfo$result5.magentoProfileResponse[0]) === null || _profileInfo$result5$ === void 0 ? void 0 : (_profileInfo$result5$2 = _profileInfo$result5$.OAuthTokenDetails[0]) === null || _profileInfo$result5$2 === void 0 ? void 0 : _profileInfo$result5$2.OAuthToken;
                  cartId = profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$result6 = profileInfo.result) === null || _profileInfo$result6 === void 0 ? void 0 : (_profileInfo$result6$ = _profileInfo$result6.magentoProfileResponse[0]) === null || _profileInfo$result6$ === void 0 ? void 0 : _profileInfo$result6$.mergedCartID;
                  (0,helperServices/* setCookieConsentWrapper */.ol)("auth_token", [(config_default()).cookie_category.strictly_necessary], "document.cookie='auth_token=".concat(oAuthToken, ";path=/'"));
                  (0,helperServices/* setCookieConsentWrapper */.ol)("cart_id", [(config_default()).cookie_category.strictly_necessary], "document.cookie='cart_id=".concat(cartId, ";path=/'"));
                  DependencyHelper.Cookie.remove("profileSyncFail");
                  this.props.setProfileData(profileInfo);
                  this.props.setReLogin(false);
                  selectedUpgradeMsisdn = this.props.upgrade.selectedUpgradeMsisdn;
                  selectedUpgradeUnmaskedMsisdn = this.props.upgrade.unMaskedMsisdn; // let isUpgradeMsisdnLinked = true;
                  // if (selectedUpgradeMsisdn || selectedUpgradeUnmaskedMsisdn) {
                  //   isUpgradeMsisdnLinked = profileInfo.result.profileSubscriptionResponse.subscriptions.subscriptions.some(
                  //       (subscription) => subscription.subscriptionId === selectedUpgradeMsisdn || subscription.subscriptionId == selectedUpgradeUnmaskedMsisdn
                  //   );
                  // }
                  // if (!isUpgradeMsisdnLinked){
                  //   const shoppingUrlPrefix = config.envConfigs[config.env].shoppingUrlPrefix;
                  //   this.props.store.dispatch(clearUpgradeJourney());
                  //   this.props.router.push(`${shoppingUrlPrefix}/upgrade`);
                  //   return;
                  // }

                  /* reset upgrade journey after success login */

                  if ((this.props.upgrade.upgradeCheckDone || this.props.upgrade.allUpgradesData.length) && (!selectedUpgradeMsisdn || !selectedUpgradeUnmaskedMsisdn)) {
                    this.props.store.dispatch((0,upgradeAction/* clearUpgradeJourney */.rX)());
                  }

                  (0,helperServices/* cartUpdateEvent */.Px)();
                } else {
                  SyncBackInfo = JSON.stringify(profileInfoRequest);
                  logger/* Logger.info */.Y.info("Profile Sync failed", this.pageStoreHistory.prevPageName, {
                    ServiceResponseCode: (_profileInfoRequest$e = profileInfoRequest.error) === null || _profileInfoRequest$e === void 0 ? void 0 : _profileInfoRequest$e.status,
                    response: SyncBackInfo
                  }, {
                    result_code: (_profileInfoRequest$e2 = profileInfoRequest.error) === null || _profileInfoRequest$e2 === void 0 ? void 0 : _profileInfoRequest$e2.status
                  });
                  (0,helperServices/* setCookieConsentWrapper */.ol)("profileSyncFail", [(config_default()).cookie_category.strictly_necessary], "document.cookie='profileSyncFail=true;path=/'");
                  DependencyHelper.Cookie.remove("vod-web-auth-token", {
                    path: "/",
                    domain: ".vodacom.co.za"
                  });
                  DependencyHelper.Cookie.remove("auth_token");
                }

                (0,helperServices/* hideSpinner */.v3)();
                _context.next = 24;
                break;

              case 23:
                if (!authtoken) {
                  DependencyHelper.Cookie.remove("profileSyncFail");
                  this.props.setProfileData(null);
                  this.props.setReLogin(false);
                }

              case 24:
                this.props.showGuestCart(cartId);
                this.props.setProfileLoading(false);

                if (this.props.isMiniApp) {
                  _context.next = 28;
                  break;
                }

                return _context.abrupt("return");

              case 28:
                this.props.router.events.on("routeChangeStart", this.handleMiniAppHomeClick);

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "handleBack",
    value: function handleBack() {
      var pageHistory = (0,helperServices/* getSessionStorage */.wJ)(labels/* default.Session_Keys.lbl_page_visit_history */.Z.Session_Keys.lbl_page_visit_history);
      (0,helperServices/* showSpinner */.yh)();
      window.history.go(-1);
      pageHistory.pop();
      (0,helperServices/* updateSessionStorage */.F$)(labels/* default.Session_Keys.lbl_page_visit_history */.Z.Session_Keys.lbl_page_visit_history, pageHistory);
      (0,helperServices/* hideSpinner */.v3)();
    }
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        var _this$props$router, _this$props$router$pa;

        var splitRoute, pageName, cartId, _this$props$router2, _this$props$router2$q, currDate, PageVisitHistory, current_page_history, _this$props$router3, _this$props$router3$q;

        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (Object.keys(this.props.features || {}).length > 0) {
                  featuresService/* Features.init */.A.init(this.props.features);
                }

                splitRoute = ((_this$props$router = this.props.router) === null || _this$props$router === void 0 ? void 0 : (_this$props$router$pa = _this$props$router.pathname) === null || _this$props$router$pa === void 0 ? void 0 : _this$props$router$pa.replace(/ *\[[^)]*\] */g, "").split("/")) || [];
                pageName = "unknown";

                if (splitRoute.length >= 2) {
                  pageName = splitRoute[splitRoute.length - 1] || splitRoute[splitRoute.length - 2];
                }

                logger/* Logger.setContext */.Y.setContext("Page Logs", {
                  page: pageName
                });
                cartId = (0,helperServices/* getCookieValue */.Do)("cart_id");

                if (cartId === undefined) {
                  this.createEmptyCart();
                }

                this.pageNavigationHistory();

                if (this.props.salesMiniAppEnabled) {
                  if ((_this$props$router2 = this.props.router) !== null && _this$props$router2 !== void 0 && (_this$props$router2$q = _this$props$router2.query) !== null && _this$props$router2$q !== void 0 && _this$props$router2$q.miniApp || (0,helperServices/* getCookieValue */.Do)("miniApp") === "true") {
                    this.props.setMiniApp(true);
                    currDate = new Date();
                    currDate.setMonth(currDate.getMonth() + 1);
                    (0,helperServices/* setCookieConsentWrapper */.ol)("miniApp", true, "document.cookie='miniApp=true;expires=".concat(currDate, ";domain=").concat(config.EnvConfig.cookieDomain, ";path=/'"));
                    logger/* Logger.setTags */.Y.setTags({
                      mini_app: true
                    });
                    !this.state.miniAppBackComponent && this.setState({
                      miniAppBackComponent: this.createMiniAppBackButton()
                    });
                  } else {
                    this.props.setMiniApp(false);
                  }
                }

                PageVisitHistory = this.props.router.asPath;
                current_page_history = (0,helperServices/* getSessionStorage */.wJ)(labels/* default.Session_Keys.lbl_page_visit_history */.Z.Session_Keys.lbl_page_visit_history) || [];

                if (PageVisitHistory !== current_page_history[current_page_history.length - 1]) {
                  current_page_history.push(PageVisitHistory);
                  (0,helperServices/* updateSessionStorage */.F$)(labels/* default.Session_Keys.lbl_page_visit_history */.Z.Session_Keys.lbl_page_visit_history, current_page_history);
                }

                if (current_page_history.length > 1) {
                  this.props.setBackEnabled(!((_this$props$router3 = this.props.router) !== null && _this$props$router3 !== void 0 && (_this$props$router3$q = _this$props$router3.query) !== null && _this$props$router3$q !== void 0 && _this$props$router3$q.fromMiniAppPayment));
                } else {
                  this.props.setBackEnabled(false);
                }

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidUpdate() {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "createEmptyCart",
    value: function () {
      var _createEmptyCart = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
        var _persistCartResponse$, _persistCartResponse$2, _persistCartResponse$3;

        var authtoken, persistCartResponse, persistTime, emptyCartForGuest, cartId;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.emptyCartRequested) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                this.emptyCartRequested = true;
                authtoken = (0,helperServices/* getCookieValue */.Do)("auth_token");
                _context3.next = 6;
                return ajaxServices/* default.fetchGraphQLPOSTRequest */.Z.fetchGraphQLPOSTRequest(queries/* persistCart */.g6);

              case 6:
                persistCartResponse = _context3.sent;
                persistTime = persistCartResponse !== null && persistCartResponse !== void 0 && (_persistCartResponse$ = persistCartResponse.persist_cart) !== null && _persistCartResponse$ !== void 0 && _persistCartResponse$.persistent_enable && persistCartResponse !== null && persistCartResponse !== void 0 && (_persistCartResponse$2 = persistCartResponse.persist_cart) !== null && _persistCartResponse$2 !== void 0 && _persistCartResponse$2.persistent_lifetime ? persistCartResponse === null || persistCartResponse === void 0 ? void 0 : (_persistCartResponse$3 = persistCartResponse.persist_cart) === null || _persistCartResponse$3 === void 0 ? void 0 : _persistCartResponse$3.persistent_lifetime : null;

                if (persistTime) {
                  (0,helperServices/* setCookieConsentWrapper */.ol)("persist_time", [(config_default()).cookie_category.strictly_necessary], "document.cookie='persist_time=".concat(persistTime, ";path=/'"));
                }

                _context3.next = 11;
                return ajaxServices/* default.fetchGraphQLPOSTRequest */.Z.fetchGraphQLPOSTRequest(queries/* guestCreateEmptyCart */.qZ);

              case 11:
                emptyCartForGuest = _context3.sent;
                cartId = emptyCartForGuest === null || emptyCartForGuest === void 0 ? void 0 : emptyCartForGuest.createEmptyCart;

                if (!authtoken) {
                  (0,helperServices/* updateCartExpiry */.YF)(cartId);
                } else {
                  (0,helperServices/* setCookieConsentWrapper */.ol)("cart_id", [(config_default()).cookie_category.strictly_necessary], "document.cookie ='cart_id=".concat(cartId, ";path=/'"));
                }

                (0,helperServices/* cartUpdateEvent */.Px)();
                return _context3.abrupt("return", cartId);

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function createEmptyCart() {
        return _createEmptyCart.apply(this, arguments);
      }

      return createEmptyCart;
    }()
  }, {
    key: "pageNavigationHistory",
    value: function pageNavigationHistory() {
      var _this2 = this;

      this.pageStoreHistory = (0,helperServices/* getSessionStorage */.wJ)(labels/* default.Session_Keys.lbl_breadCrumb */.Z.Session_Keys.lbl_breadCrumb) ? (0,helperServices/* getSessionStorage */.wJ)(labels/* default.Session_Keys.lbl_breadCrumb */.Z.Session_Keys.lbl_breadCrumb) : this.pageStoreHistory;
      var asPath = this.props.router.asPath;
      var pathName = this.props.router.pathname;
      var index;

      if (this.pageStoreHistory && this.pageStoreHistory.history && this.pageStoreHistory.history.length && pathName !== this.pageStoreHistory.prevPageName) {
        this.pageStoreHistory.history.forEach(function (page, i) {
          var _this2$props$router$q, _this2$props$router$q2, _this2$props$router$q3;

          if (page.pathname == _this2.props.router.pathname || page.pathname == "/shopping" + ((_this2$props$router$q = _this2.props.router.query.api) === null || _this2$props$router$q === void 0 ? void 0 : _this2$props$router$q[0]) || page.asPath === _this2.props.router.asPath || page.pathname.split("/shopping")[1] == _this2.props.router.pathname.split("/shopping")[1] || page.asPath.split("/shopping")[1] == _this2.props.router.asPath.split("/shopping")[1] || page.pathname == "/shopping" + ((_this2$props$router$q2 = _this2.props.router.query.api) === null || _this2$props$router$q2 === void 0 ? void 0 : _this2$props$router$q2[0]) || page.asPath.split("shopping/")[1] == "/shopping" + ((_this2$props$router$q3 = _this2.props.router.query.api) === null || _this2$props$router$q3 === void 0 ? void 0 : _this2$props$router$q3[0])) {
            index = i;
          }
        });

        if (index !== -1 && this.pageStoreHistory.history.length > 0) {
          if (this.props.breadcrumbDetails === true) {
            this.pageStoreHistory.history.splice(index, this.pageStoreHistory.history.length - index);
            this.props.handleSlice(false);
          } else {
            index !== undefined && this.pageStoreHistory.history.splice(index, 1);
          }
        }

        this.pageStoreHistory = {
          history: [].concat((0,toConsumableArray/* default */.Z)(this.pageStoreHistory.history), [{
            asPath: asPath,
            pathname: pathName === "/[...api]" ? asPath : pathName
          }]),
          prevPageName: pathName === "/[...api]" ? asPath : pathName
        };
        (0,helperServices/* updateSessionStorage */.F$)(labels/* default.Session_Keys.lbl_breadCrumb */.Z.Session_Keys.lbl_breadCrumb, this.pageStoreHistory);
      } else if (!this.pageStoreHistory) {
        // Set Initial Page
        (0,helperServices/* updateSessionStorage */.F$)(labels/* default.Session_Keys.lbl_breadCrumb */.Z.Session_Keys.lbl_breadCrumb, {
          history: [{
            pathname: "/",
            asPath: "/"
          }],
          prevPageName: "/"
        });
      }
    }
  }, {
    key: "showTopBanner",
    value: function showTopBanner() {
      this.props.store.dispatch((0,upgradeAction/* displayHideUpgradeTopbannerModal */.Ri)(true));
      (0,analyticsUtag/* link */.p4)({
        link_type: "o",
        link_name: "".concat((0,analyticsUtag/* getUtagData */.GS)(["page_name"]).page_name, ": ").concat(labels/* default.lbl_top_banner.lbl_btn.lbl_see_detail */.Z.lbl_top_banner.lbl_btn.lbl_see_detail)
      });
    }
  }, {
    key: "removeUpgradeDealFromCart",
    value: function removeUpgradeDealFromCart() {
      var _this$props$upgrade;

      var _this$props$upgrade$d = (_this$props$upgrade = this.props.upgrade) === null || _this$props$upgrade === void 0 ? void 0 : _this$props$upgrade.devicePrice,
          upgradeDealSKU = _this$props$upgrade$d.sku;

      var reduxState = this.props.store.getState();
      var cartItems = reduxState === null || reduxState === void 0 ? void 0 : reduxState.cartDetails.cartProductItems;
      var upgradeCartItem = Array.isArray(cartItems) ? cartItems.find(function (ci) {
        return (ci === null || ci === void 0 ? void 0 : ci.product.sku) === upgradeDealSKU;
      }) : null;
      var cartId = (0,helperServices/* getCookieValue */.Do)("cart_id");

      if (!upgradeCartItem || !upgradeCartItem.id || !cartId) {
        return;
      }

      this.props.store.dispatch((0,cartAction/* deleteItemsFromCart */.dY)(cartId, upgradeCartItem.id));
    }
  }, {
    key: "closeTopBannerModal",
    value: function closeTopBannerModal() {
      this.props.store.dispatch((0,upgradeAction/* displayHideUpgradeTopbannerModal */.Ri)(false));
      (0,analyticsUtag/* link */.p4)({
        page_tool_event: "use",
        page_tool_name: "".concat((0,analyticsUtag/* getUtagData */.GS)(["page_name"]).page_name, ": dismiss")
      });
    }
  }, {
    key: "closeBannerAndModal",
    value: function closeBannerAndModal() {
      var _this$props, _this$props$router4;

      this.props.store.dispatch((0,upgradeAction/* displayHideUpgradeTopbannerModal */.Ri)(false));
      this.props.store.dispatch((0,upgradeAction/* displayHideUpgradeTopbanner */.Od)(false));
      this.props.store.dispatch((0,upgradeAction/* clearUpgradeJourney */.rX)());
      this.removeUpgradeDealFromCart();
      (0,upgradeService/* resetFiltersOnStopUpgrade */.Jo)((_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$router4 = _this$props.router) === null || _this$props$router4 === void 0 ? void 0 : _this$props$router4.route);
      (0,analyticsUtag/* link */.p4)({
        page_tool_event: "use",
        page_tool_name: "".concat((0,analyticsUtag/* getUtagData */.GS)(["page_name"]).page_name, ": ").concat(labels/* default.lbl_top_banner.lbl_btn.lbl_stop_upgrade */.Z.lbl_top_banner.lbl_btn.lbl_stop_upgrade)
      });
      (0,helperServices/* hideSpinner */.v3)();
    }
  }, {
    key: "clearAndOpenBannerModal",
    value: function clearAndOpenBannerModal() {
      this.closeBannerAndModal();
      this.props.store.dispatch((0,upgradeAction/* displayHideUpgradeModal */.ex)(true));
    }
  }, {
    key: "redirectToDeals",
    value: function redirectToDeals() {
      this.props.store.dispatch((0,upgradeAction/* displayHideUpgradeTopbannerModal */.Ri)(false));
      (0,analyticsUtag/* link */.p4)({
        page_tool_event: "use",
        page_tool_name: "".concat((0,analyticsUtag/* getUtagData */.GS)(["page_name"]).page_name, ": ").concat(labels/* default.lbl_top_banner.lbl_btn.lbl_recommended_deals */.Z.lbl_top_banner.lbl_btn.lbl_recommended_deals)
      });
      (0,helperServices/* showSpinner */.yh)();
      this.props.router.push("/shopping/upgrade").then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          Component = _this$props2.Component,
          pageProps = _this$props2.pageProps,
          hideNavItems = _this$props2.hideNavItems,
          upgrade = _this$props2.upgrade,
          upgradeChecksEnabled = _this$props2.upgradeChecksEnabled,
          isMobileFilter = _this$props2.isMobileFilter,
          leadInterceptEnabled = _this$props2.leadInterceptEnabled,
          hideFooter = _this$props2.hideFooter,
          isMiniApp = _this$props2.isMiniApp,
          isBackEnabled = _this$props2.isBackEnabled,
          salesMiniAppMenuEnabled = _this$props2.salesMiniAppMenuEnabled;
      var env = (config_default()).env;
      var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
      var respSticky = this.props.router.route.includes("product-details") || this.props.router.route.includes("deal-details-page");
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
          children: [(pageProps === null || pageProps === void 0 ? void 0 : pageProps.previewMode) && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
            name: "googlebot",
            content: "noindex"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
            name: "viewport",
            content: "width=device-width, initial-scale=1.0"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
            rel: "preload",
            href: "https://vjs.zencdn.net/7.8.2/video-js.css",
            as: "style",
            onLoad: "this.onload=null;this.rel='stylesheet'"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("noscript", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
              rel: "stylesheet",
              href: "https://vjs.zencdn.net/7.8.2/video-js.css"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
            rel: "preload",
            href: "https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.0.0/animate.min.css",
            as: "style",
            onLoad: "this.onload=null;this.rel='stylesheet'"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("noscript", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
              rel: "stylesheet",
              href: "https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.0.0/animate.min.css"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
            rel: "icon",
            href: "".concat(imagePrefix, "/assets/images/favicon.ico")
          }), isMiniApp && /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
            children: "Shop Online | Vodacom"
          })]
        }), hideNavItems && /*#__PURE__*/(0,jsx_runtime.jsx)(InternalSearch_InterNalSearch, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(loader, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "".concat(this.props.router.route.includes("checkout") || isMobileFilter ? "d-none" : ""),
          children: !isMiniApp ? /*#__PURE__*/(0,jsx_runtime.jsx)(Headerfragment, {}) : salesMiniAppMenuEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(MiniAppHeader, {
            router: this.props.router
          })
        }), !this.props.router.route.includes("checkout") ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [upgradeChecksEnabled && upgrade.topBannerModal && /*#__PURE__*/(0,jsx_runtime.jsx)(upgradeErrorModal_upgradeErrorModal, {
            show: "true",
            title: labels/* default.lbl_top_banner.lbl_process_upgrade_title */.Z.lbl_top_banner.lbl_process_upgrade_title,
            text: labels/* default.lbl_top_banner.lbl_Process_upgrade */.Z.lbl_top_banner.lbl_Process_upgrade,
            cellphone: upgrade.msisdn,
            outlineWhiteBtnLabel: labels/* default.lbl_top_banner.lbl_btn.lbl_stop_upgrade */.Z.lbl_top_banner.lbl_btn.lbl_stop_upgrade,
            solidBlackBtnLabel: labels/* default.lbl_top_banner.lbl_btn.lbl_recommended_deals */.Z.lbl_top_banner.lbl_btn.lbl_recommended_deals,
            solidBlackBtnLabelSecond: labels/* default.lbl_top_banner.lbl_btn.lbl_start_upgrade */.Z.lbl_top_banner.lbl_btn.lbl_start_upgrade,
            handleCancel: this.closeTopBannerModal,
            handleRestart: this.clearAndOpenBannerModal,
            outlineWhiteBtnAction: this.closeBannerAndModal,
            solidBlackBtnAction: this.redirectToDeals
          }), !this.props.router.route.includes("forms") && isBackEnabled && isMiniApp && !isMobileFilter && this.state.miniAppBackComponent, /*#__PURE__*/(0,jsx_runtime.jsxs)(MainContainer/* default */.Z, {
            className: isMiniApp && respSticky ? "large_bottom_space" : "medium_bottom_space",
            children: [upgradeChecksEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(upgradeBanner_UpgradeBanner, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(analyticsUtag/* AnalyticsWrapper */.KS, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Component, _app_objectSpread({}, pageProps)), upgradeChecksEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(upgradeContainer_UpgradeContainer, {})]
          }), !isMiniApp && !isMobileFilter && /*#__PURE__*/(0,jsx_runtime.jsx)(Footer, {})]
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(analyticsUtag/* AnalyticsWrapper */.KS, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Component, _app_objectSpread({}, pageProps))]
        }), !this.props.router.route.includes("forms") && leadInterceptEnabled && !hideFooter ? /*#__PURE__*/(0,jsx_runtime.jsx)(getHelp, {
          stacked: respSticky,
          leadBucket: this.props.getHelpLeadBucket
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})]
      });
    }
  }]);

  return MyApp;
}(app["default"]);

MyApp.getInitialProps = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(_ref) {
    var Component, ctx, features, upgradeChecksEnabled, leadInterceptEnabled, salesMiniAppEnabled, shakaEnabled, salesMiniAppMenuEnabled, _features, _features2, _features3, _features4, _features5;

    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            Component = _ref.Component, ctx = _ref.ctx;
            features = {};
            _context4.prev = 2;
            _context4.next = 5;
            return ajaxServices/* default.httpGet */.Z.httpGet("featureBaseUrl", "", "api", "features");

          case 5:
            features = _context4.sent;
            _context4.next = 11;
            break;

          case 8:
            _context4.prev = 8;
            _context4.t0 = _context4["catch"](2);
            console.log("app : features: error", _context4.t0);

          case 11:
            if (!isServer()) {
              _context4.next = 34;
              break;
            }

            upgradeChecksEnabled = k8sConfig.get("features.upgradeChecks");
            leadInterceptEnabled = k8sConfig.get("features.leadIntercept");
            salesMiniAppEnabled = k8sConfig.get("features.salesMiniApp");
            shakaEnabled = k8sConfig.get("features.shaka");
            salesMiniAppMenuEnabled = k8sConfig.get("features.salesMiniAppMenu");
            _context4.t1 = features;
            _context4.t2 = upgradeChecksEnabled === "true";
            _context4.t3 = leadInterceptEnabled === "true";
            _context4.t4 = salesMiniAppEnabled === "true";
            _context4.t5 = shakaEnabled === "true";
            _context4.t6 = salesMiniAppMenuEnabled === "true";

            if (!Component.getInitialProps) {
              _context4.next = 29;
              break;
            }

            _context4.next = 26;
            return Component.getInitialProps(ctx);

          case 26:
            _context4.t7 = _context4.sent;
            _context4.next = 30;
            break;

          case 29:
            _context4.t7 = {};

          case 30:
            _context4.t8 = _context4.t7;
            return _context4.abrupt("return", {
              features: _context4.t1,
              upgradeChecksEnabled: _context4.t2,
              leadInterceptEnabled: _context4.t3,
              salesMiniAppEnabled: _context4.t4,
              shakaEnabled: _context4.t5,
              salesMiniAppMenuEnabled: _context4.t6,
              pageProps: _context4.t8
            });

          case 34:
            _context4.t9 = features;
            _context4.t10 = (_features = features) === null || _features === void 0 ? void 0 : _features.upgradeChecksEnabled;
            _context4.t11 = (_features2 = features) === null || _features2 === void 0 ? void 0 : _features2.leadInterceptEnabled;
            _context4.t12 = (_features3 = features) === null || _features3 === void 0 ? void 0 : _features3.salesMiniAppEnabled;
            _context4.t13 = (_features4 = features) === null || _features4 === void 0 ? void 0 : _features4.shakaEnabled;
            _context4.t14 = (_features5 = features) === null || _features5 === void 0 ? void 0 : _features5.salesMiniAppMenuEnabled;

            if (!Component.getInitialProps) {
              _context4.next = 46;
              break;
            }

            _context4.next = 43;
            return Component.getInitialProps(ctx);

          case 43:
            _context4.t15 = _context4.sent;
            _context4.next = 47;
            break;

          case 46:
            _context4.t15 = {};

          case 47:
            _context4.t16 = _context4.t15;
            return _context4.abrupt("return", {
              features: _context4.t9,
              upgradeChecksEnabled: _context4.t10,
              leadInterceptEnabled: _context4.t11,
              salesMiniAppEnabled: _context4.t12,
              shakaEnabled: _context4.t13,
              salesMiniAppMenuEnabled: _context4.t14,
              pageProps: _context4.t16
            });

          case 49:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[2, 8]]);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();

var _app_mapStateToProps = function mapStateToProps(state) {
  return {
    hideFooter: state.displayHideFooter.hideFooter,
    hideNavItems: state.navDetails.hideNavItems,
    breadcrumbDetails: state.SliceBreadcrumb.slice,
    userLoggedIn: state.navDetails.isUserLoggedIn,
    reLogin: state.navDetails.isReLogin,
    isMiniApp: state.navDetails.isMiniApp,
    isBackEnabled: state.navDetails.isBackEnabled,
    upgrade: state.upgrade,
    isMobileFilter: state.navDetails.isMobileFilter,
    getHelpLeadBucket: state.getHelp.getHelpLeadBucket
  };
};

/* harmony default export */ var _app = (with_redux_store((0,es/* connect */.$j)(_app_mapStateToProps, {
  showGuestCart: cartAction/* showGuestCart */.cD,
  setProfileData: navAction/* setProfileData */._J,
  setProfileLoading: navAction/* setProfileLoading */.Kg,
  setReLogin: navAction/* setReLogin */.Lf,
  setMiniApp: navAction/* setMiniApp */.no,
  setBackEnabled: navAction/* setBackEnabled */.HS,
  handleSlice: handleSlice,
  clearUpgradeJourney: upgradeAction/* clearUpgradeJourney */.rX,
  displayHideUpgradeTopbanner: upgradeAction/* displayHideUpgradeTopbanner */.Od,
  displayHideUpgradeTopbannerModal: upgradeAction/* displayHideUpgradeTopbannerModal */.Ri
})(MyApp)));

/***/ }),

/***/ 69152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$y": function() { return /* binding */ getProfileData; },
/* harmony export */   "GS": function() { return /* binding */ getUtagData; },
/* harmony export */   "KS": function() { return /* binding */ AnalyticsWrapper; },
/* harmony export */   "ei": function() { return /* binding */ view; },
/* harmony export */   "fv": function() { return /* binding */ setAutoTagging; },
/* harmony export */   "j0": function() { return /* binding */ getPageName; },
/* harmony export */   "p4": function() { return /* binding */ link; },
/* harmony export */   "t0": function() { return /* binding */ setPageName; },
/* harmony export */   "vU": function() { return /* binding */ error; }
/* harmony export */ });
/* unused harmony exports utagDev, utagUat, utagQa, utagProd, utagSyncDev, utagSyncUat, utagSyncQa, utagSyncProd, loadUtag, utagQue, setPageMetaData, setCustomEventArray, setCookieQue */
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28658);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64036);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var utagDev = "https://tags.tiqcdn.com/utag/vodafone/za-microservice/dev/utag.js";
var utagUat = "https://tags.tiqcdn.com/utag/vodafone/za-microservice/dev/utag.js";
var utagQa = "https://tags.tiqcdn.com/utag/vodafone/za-microservice/qa/utag.js";
var utagProd = "https://tags.tiqcdn.com/utag/vodafone/za-microservice/prod/utag.js";
var utagSyncDev = "https://tags.tiqcdn.com/utag/vodafone/za-microservice/dev/utag.sync.js";
var utagSyncUat = "https://tags.tiqcdn.com/utag/vodafone/za-microservice/dev/utag.sync.js";
var utagSyncQa = "https://tags.tiqcdn.com/utag/vodafone/za-microservice/qa/utag.sync.js";
var utagSyncProd = "https://tags.tiqcdn.com/utag/vodafone/za-microservice/prod/utag.sync.js";

function lower(obj) {
  for (var prop in obj) {
    if (prop === 'link_obj') {
      obj.link_obj = undefined;
      continue;
    }

    if (typeof obj[prop] === 'string') {
      obj[prop] = obj[prop].toLowerCase();
    }

    if (typeof obj[prop] === 'object') {
      lower(obj[prop]);
    }
  }

  return obj;
}

var loadUtag = function loadUtag(env) {
  var url = "";

  switch (env) {
    case "prod":
    case "stg":
      url = utagProd;
      break;

    case "qa":
      url = utagQa;
      break;

    default:
      url = utagDev;
  }

  (function (a, b, c, d) {
    a = url; // URL for utag.js

    b = document;
    c = "script";
    d = b.createElement(c);
    d.src = a;
    d.type = "text/java" + c;
    d.async = true;
    a = b.getElementsByTagName(c)[0];
    a.parentNode.insertBefore(d, a);
  })();
};
var utagQue = function utagQue() {
  var queue = [];
  var initialized = false;
  var frequency = 100;
  var timeout = 200 * frequency; // 2 seconds`

  function process() {
    if (!initialized) {
      return;
    }

    var action = null;

    while (action = queue.shift()) {
      action();
    }
  }

  function view(data) {
    queue.push(function () {
      window.utag.view(data);
    });
    process();
  }

  function link(data) {
    queue.push(function () {
      window.utag.link(data);
    });
    process();
  }

  window.MyTIQ = {
    view: view,
    link: link
  };

  (function run() {
    window.setTimeout(function () {
      if ("utag" in window) {
        initialized = true;
        timeout = 0;
        process();
      }

      timeout -= frequency;

      if (timeout > 0) {
        run();
      }
    }, frequency);
  })();
};
var setPageMetaData = function setPageMetaData() {
  //  TO DO: Ask Eugene for these values
  window.pageMetaData = {
    categoryLevel: 0,
    currentDesktop: "kubernetes",
    pageName: "my application",
    pageURL: "my application",
    portalPath: "vodacom",
    weblogicPageName: "myvodacom:my application",
    autoTagging: false
  };
  window.tealiumAuthData = {}; // default empty data object

  window.utag_data = {};
};
var setAutoTagging = function setAutoTagging(setValue) {
  if (window.pageMetaData) {
    window.pageMetaData.autoTagging = setValue;
  } else {
    setPageMetaData();
    window.pageMetaData.autoTagging = setValue;
  }
};
var setCustomEventArray = function setCustomEventArray() {
  window.CustomEventArray = function (callback) {
    window.CustomEventArray.EVENT_TYPE = {
      PUSH: "push",
      POP: "pop"
    };

    var cb = callback || function () {};

    var _stack = [];
    var cb_queue = [cb];

    var processCallbacks = function processCallbacks(evt, obj) {
      for (var i = 0, len = cb_queue.length; i < len; i++) {
        cb_queue[i](evt, obj);
      }
    };

    this.push = function (obj) {
      _stack.push(obj);

      processCallbacks(window.CustomEventArray.EVENT_TYPE.PUSH, obj);
    };

    this.pop = function () {
      var o = _stack.pop();

      processCallbacks(window.CustomEventArray.EVENT_TYPE.POP, o);
      return o;
    };

    this.stack = function () {
      return _stack;
    };

    this.setCallback = function (callback) {
      cb_queue.push(callback);
    };
  };

  window.VodacomJSErrorEvents = new window.CustomEventArray();

  window.onerror = function (msg, url, line, col, error) {
    var d = {};
    d.msg = msg;
    d.url = url;
    d.line = line;
    d.col = !col ? "" : col;
    d.err = !error ? "" : error;
    window.VodacomJSErrorEvents.push(d);
  };
};
var view = function view(data) {
  if ((0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_3__/* .getCookieValue */ .Do)("miniApp") === 'true') {
    data.header_type = "mini_app";
  }

  var lowerData = lower(data);

  try {
    if (data && (data.page_errors || data.page_errors_code)) {
      _utils_logger__WEBPACK_IMPORTED_MODULE_4__/* .Logger.error */ .Y.error(new Error(data.page_errors || "An unknown utag error occurred"), null, {
        AnalyticsData: lowerData
      }, {
        utag_code: data.page_errors_code || "unknown"
      });
    }

    window.MyTIQ.view(lowerData); //Added for unit testing purpose need to remove at the time of prod
    // console.log("view executed with", lowerData);
  } catch (error) {
    console.log("window.utag.view error");
    _utils_logger__WEBPACK_IMPORTED_MODULE_4__/* .Logger.error */ .Y.error(error, null, {
      AnalyticsData: _objectSpread({}, lowerData)
    }, {
      utag_code: data.page_errors_code || "unknown"
    });
  }
};
var link = function link(data) {
  var lowerData = lower(data);

  try {
    if (data && (data.page_errors || data.page_errors_code)) {
      _utils_logger__WEBPACK_IMPORTED_MODULE_4__/* .Logger.error */ .Y.error(new Error(data.page_errors || "An unknown utag error occurred"), null, {
        AnalyticsData: lowerData
      }, {
        utag_code: data.page_errors_code || "unknown"
      });
    }

    window.MyTIQ.link(lowerData); //Added for unit testing purpose need to remove at the time of prod
    // console.log("utag link executed with", lowerData);
  } catch (error) {
    console.warn("window.utag.link error");
    _utils_logger__WEBPACK_IMPORTED_MODULE_4__/* .Logger.error */ .Y.error(error, null, {
      AnalyticsData: _objectSpread({}, lowerData)
    }, {
      utag_code: data.page_errors_code || "unknown"
    });
  }
};
var getUtagData = function getUtagData() {
  var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (typeof utag_data !== "undefined") {
    if (attributes.length) {
      var retrievedData = {};
      attributes.forEach(function (key) {
        retrievedData[key] = utag_data[key];
      });
      return retrievedData;
    }

    var tempObject = _objectSpread({}, utag_data);

    delete tempObject.page_event;
    return tempObject;
  }

  return {};
};
var error = function error(msg) {
  var analyticsData = {
    page_form_event: "error",
    page_errors: msg
  };

  if (utag_data) {
    analyticsData.page_name = utag_data.page_name;
  }

  link(analyticsData);
};
var getProfileData = function getProfileData(loggedIn, profileData) {
  try {
    var userData = {};

    if (loggedIn) {
      userData.visitor_login_status = "logged in";

      if (profileData) {
        if (profileData.customerId) {
          userData.visitor_id_hash = profileData.customerId;
        }
      }

      if (profileData) {
        if (profileData.telephone) {
          userData.visitor_msisdn_hash = (0,_components_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_2__.sha256)(profileData.telephone);
          userData.visitor_customer_id = (0,_components_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_2__.sha256)(profileData.telephone);
        }
      }

      userData.visitor_subscription_type = "";
      return userData;
    }

    return {
      visitor_login_status: "logged out",
      visitor_msisdn_hash: "",
      visitor_customer_id: "",
      visitor_id_hash: "",
      visitor_subscription_type: ""
    };
  } catch (e) {
    console.log(e);
  }
};
var setPageName = function setPageName(pageName) {
  if (utag_data) {
    utag_data.page_name = pageName;
  }
};
var getPageName = function getPageName() {
  if (utag_data) {
    return utag_data.page_name;
  }

  return "";
};
var setCookieQue = function setCookieQue() {
  var queue = [];
  var initialized = false;
  var frequency = 100;
  var timeout = 400 * frequency; // 2 seconds`

  function process() {
    if (!initialized) {
      return;
    }

    var action = null;

    while (action = queue.shift()) {
      action();
    }
  }

  function allowAll() {
    if (!queue.length) {
      queue.push(function () {
        window.OneTrust.AllowAll();
      });
    }

    process();
  }

  window.MyQue = {
    allowAll: allowAll
  };

  (function run() {
    window.setTimeout(function () {
      if ("OneTrust" in window) {
        initialized = true;
        timeout = 0;
        process();
      }

      timeout -= frequency;

      if (timeout > 0) {
        run();
      }
    }, frequency);
  })();
};
var AnalyticsWrapper = function AnalyticsWrapper() {
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    utagQue();
    setPageMetaData();
    setCustomEventArray();
    setCookieQue();
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {});
};

/***/ }),

/***/ 70098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$R": function() { return /* binding */ checkUserNextDueDateforUpgrade; },
/* harmony export */   "I0": function() { return /* binding */ handoverUpgradeeSession; },
/* harmony export */   "IP": function() { return /* binding */ checkChildUpgradable; },
/* harmony export */   "Ip": function() { return /* binding */ checkIfFromDetailPage; },
/* harmony export */   "Jo": function() { return /* binding */ resetFiltersOnStopUpgrade; },
/* harmony export */   "Ls": function() { return /* binding */ newMaskMsisdn; },
/* harmony export */   "Ly": function() { return /* binding */ maskMsisdn; },
/* harmony export */   "M$": function() { return /* binding */ checkIfHiddenDropdown; },
/* harmony export */   "U4": function() { return /* binding */ checkIfFromDealDetailPage; },
/* harmony export */   "Yo": function() { return /* binding */ checkifUpgradableAndC3D; },
/* harmony export */   "Zk": function() { return /* binding */ errorCodes; },
/* harmony export */   "wc": function() { return /* binding */ legacySessionData; },
/* harmony export */   "wv": function() { return /* binding */ upgradeStages; },
/* harmony export */   "x2": function() { return /* binding */ fetchAffordCode; }
/* harmony export */ });
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99599);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64036);
/* harmony import */ var _components_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28658);




var env = (_config_index__WEBPACK_IMPORTED_MODULE_0___default().env);
var urlPrefix = (_config_index__WEBPACK_IMPORTED_MODULE_0___default().envConfigs)[env].shoppingUrlPrefix;
var upgradeStages = Object.freeze({
  NUMBER_ENRTY: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].upgrade.stages.lbl_number_entry */ .Z.upgrade.stages.lbl_number_entry,
  OTP_ENRTY: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].upgrade.stages.lbl_otp_entery */ .Z.upgrade.stages.lbl_otp_entery,
  NUMBER_SELECT: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].upgrade.stages.lbl_number_select */ .Z.upgrade.stages.lbl_number_select,
  UPGRADE_RESULT: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].upgrade.stages.lbl_upgrade_result */ .Z.upgrade.stages.lbl_upgrade_result,
  TECHNICAL_ERROR: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].upgrade.stages.lbl_technical_error */ .Z.upgrade.stages.lbl_technical_error,
  ELIGIBLE_NUMBER_SELECT: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].upgrade.stages.lbl_eligible_number_select */ .Z.upgrade.stages.lbl_eligible_number_select
});
var errorCodes = {
  user_not_found: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].upgrade.errorCodes.code_user_not_found */ .Z.upgrade.errorCodes.code_user_not_found,
  invalid_otp_error: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].upgrade.errorCodes.code_invalid_otp_error */ .Z.upgrade.errorCodes.code_invalid_otp_error,
  otp_service_down: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].upgrade.errorCodes.code_otp_service_down */ .Z.upgrade.errorCodes.code_otp_service_down,
  service_down: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].upgrade.errorCodes.code_service_down */ .Z.upgrade.errorCodes.code_service_down,
  logged_user_service_down: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].upgrade.errorCodes.code_logged_user_service_down */ .Z.upgrade.errorCodes.code_logged_user_service_down,
  user_acc_error: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].upgrade.errorCodes.code_user_acc_error */ .Z.upgrade.errorCodes.code_user_acc_error,
  code_otp_no_alternative: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].upgrade.errorCodes.code_otp_no_alternative */ .Z.upgrade.errorCodes.code_otp_no_alternative
};
var checkifUpgradableAndC3D = function checkifUpgradableAndC3D(resultCode) {
  if (resultCode === _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].upgrade.errorCodes.code_mah_user_upgradable */ .Z.upgrade.errorCodes.code_mah_user_upgradable || resultCode === _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].upgrade.errorCodes.code_child_user_upgradable */ .Z.upgrade.errorCodes.code_child_user_upgradable) {
    return true;
  }

  return false;
};
var checkChildUpgradable = function checkChildUpgradable(resultCode) {
  if (resultCode === _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].upgrade.errorCodes.code_child_user_upgradable */ .Z.upgrade.errorCodes.code_child_user_upgradable) {
    return true;
  }

  return false;
};
var checkIfHiddenDropdown = function checkIfHiddenDropdown(resultCode) {
  switch (resultCode) {
    case "upgradeeligibility_bus_mah":
    case "upgradeeligibility_bus_child":
    case "upgradeeligibility_bus_na":
    case "upgradeeligibility_legacycustomer":
    case "upgradeeligibility_bus_na_001":
    case "upgradeeligibility_c3d_na_004":
    case "upgradeeligibility_c3d_mah_004":
    case "upgradeeligibility_c3d_child_004":
      return true;

    default:
      return false;
  }
};
var checkUserNextDueDateforUpgrade = function checkUserNextDueDateforUpgrade(resultCode) {
  if (resultCode && (resultCode.includes(_config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].upgrade.errorCodes.code_user_duefor_upgrade */ .Z.upgrade.errorCodes.code_user_duefor_upgrade) || resultCode === _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].upgrade.errorCodes.code_cbu_staff_not_eligible */ .Z.upgrade.errorCodes.code_cbu_staff_not_eligible)) {
    return true;
  }

  return false;
};
var maskMsisdn = function maskMsisdn(msisdn) {
  var _tempMsisdn;

  var tempMsisdn = msisdn;

  if (RegExp(/^27[0-9]*$/).test(msisdn)) {
    tempMsisdn = msisdn === null || msisdn === void 0 ? void 0 : msisdn.replace(msisdn.substring(0, 2), "0");
  }

  var maskedMsisdn = (_tempMsisdn = tempMsisdn) === null || _tempMsisdn === void 0 ? void 0 : _tempMsisdn.replace(tempMsisdn.substring(3, 7), "****");
  return maskedMsisdn;
};
var fetchAffordCode = function fetchAffordCode(path) {
  if (path.includes("/shopping/product-details")) {
    return _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].upgrade.errorCodes.code_product_not_affordable */ .Z.upgrade.errorCodes.code_product_not_affordable;
  } else if (path.includes("/shopping/deal-details-page")) {
    return _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].upgrade.errorCodes.code_deal_not_affordable */ .Z.upgrade.errorCodes.code_deal_not_affordable;
  }

  return _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].upgrade.errorCodes.code_deal_not_affordable */ .Z.upgrade.errorCodes.code_deal_not_affordable;
};
var checkIfFromDetailPage = function checkIfFromDetailPage(path) {
  if (path.includes("/shopping/product-details") || path.includes("/shopping/deal-details-page")) {
    return true;
  }

  return false;
};
var checkIfFromDealDetailPage = function checkIfFromDealDetailPage(path) {
  if (path.includes("/shopping/deal-details-page")) {
    return true;
  }

  return false;
};
var resetFiltersOnStopUpgrade = function resetFiltersOnStopUpgrade(path) {
  var resetFilterData = function resetFilterData(pathValue) {
    _components_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_3__.Router.push(pathValue, pathValue, {
      shallow: true
    }).then(function () {
      if (true) {
        window.location.reload();
      }
    });
  };

  var newPathRef;

  switch (path) {
    case "".concat(urlPrefix, "/deals"):
      {
        newPathRef = "".concat(urlPrefix, "/deals");
        resetFilterData(newPathRef);
        return;
      }

    case "".concat(urlPrefix, "/products"):
      {
        newPathRef = "".concat(urlPrefix, "/products");
        resetFilterData(newPathRef);
        return;
      }

    case "".concat(urlPrefix, "/deal-selection/[id]"):
      {
        var asPathRouter = _components_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_3__.Router === null || _components_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_3__.Router === void 0 ? void 0 : _components_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_3__.Router.asPath;
        var parseObjectData = JSON.parse('{"' + decodeURI(asPathRouter).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
        var urlData = "".concat(Object.keys(parseObjectData)[0], "=").concat(Object.values(parseObjectData)[0]).concat(parseObjectData["buyOption"] ? "buyOption=" + parseObjectData["buyOption"] : "");
        newPathRef = urlData;
        resetFilterData(newPathRef);
        return;
      }

    default:
      {
        return;
      }
  }
};
var legacySessionData = ["legacyAllowed", "childAllowed", "isOtherNumber", "collectAtStore", "upgradeMsisdn", "isC3dUser", "mah", "upgradeType", "journey"];
var handoverUpgradeeSession = function handoverUpgradeeSession(canReciveOTP, isChildAllowed, upgradeResponse) {
  var legacyAllowed = (_config_index__WEBPACK_IMPORTED_MODULE_0___default().legacyAllowed);
  var collectAtStore = (_config_index__WEBPACK_IMPORTED_MODULE_0___default().collectAtStore);
  var tempMsisdn = upgradeResponse === null || upgradeResponse === void 0 ? void 0 : upgradeResponse.msisdn;

  if (RegExp(/^27[0-9]*$/).test(upgradeResponse === null || upgradeResponse === void 0 ? void 0 : upgradeResponse.msisdn)) {
    tempMsisdn = upgradeResponse === null || upgradeResponse === void 0 ? void 0 : upgradeResponse.msisdn.replace(upgradeResponse.msisdn.substring(0, 2), "0");
  }

  var legacyData = {
    legacyAllowed: legacyAllowed,
    collectAtStore: collectAtStore,
    isOtherNumber: !canReciveOTP,
    childAllowed: isChildAllowed,
    upgradeType: upgradeResponse.upgradeType,
    mah: upgradeResponse.mah,
    upgradeMsisdn: "".concat(tempMsisdn),
    isC3dUser: upgradeResponse.c3dCustomer,
    journey: upgradeResponse.c3dCustomer ? "C3D" : "Legacy"
  };
  Object.keys(legacyData).forEach(function (key) {
    (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .updateSessionStorage */ .F$)(key, legacyData[key], !legacyData[key] === "upgradeMsisdn");
  });
};
var newMaskMsisdn = function newMaskMsisdn(msisdn) {
  var _tempMsisdn2;

  var tempMsisdn = msisdn;

  if (RegExp(/^27[0-9]*$/).test(msisdn)) {
    tempMsisdn = msisdn === null || msisdn === void 0 ? void 0 : msisdn.replace(msisdn.substring(0, 2), "0");
  }

  var maskedMsisdn = (_tempMsisdn2 = tempMsisdn) === null || _tempMsisdn2 === void 0 ? void 0 : _tempMsisdn2.replace(tempMsisdn.substring(3, 6), "***");
  return maskedMsisdn;
};

/***/ }),

/***/ 18517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ajaxServices; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./utils/helperServices.js + 3 modules
var helperServices = __webpack_require__(64036);
// EXTERNAL MODULE: ./config/queries.js
var queries = __webpack_require__(91250);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(10748);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(81531);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(90607);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/isNativeFunction.js
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/construct.js


function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) (0,setPrototypeOf/* default */.Z)(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/wrapNativeSuper.js




function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, (0,getPrototypeOf/* default */.Z)(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return (0,setPrototypeOf/* default */.Z)(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}
;// CONCATENATED MODULE: ./node_modules/http-status-codes/build/es/status-codes.js
// Generated file. Do not edit
var StatusCodes;
(function (StatusCodes) {
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.3
     *
     * The request has been received but not yet acted upon. It is non-committal, meaning that there is no way in HTTP to later send an asynchronous response indicating the outcome of processing the request. It is intended for cases where another process or server handles the request, or for batch processing.
     */
    StatusCodes[StatusCodes["ACCEPTED"] = 202] = "ACCEPTED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.3
     *
     * This error response means that the server, while working as a gateway to get a response needed to handle the request, got an invalid response.
     */
    StatusCodes[StatusCodes["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.1
     *
     * This response means that server could not understand the request due to invalid syntax.
     */
    StatusCodes[StatusCodes["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.8
     *
     * This response is sent when a request conflicts with the current state of the server.
     */
    StatusCodes[StatusCodes["CONFLICT"] = 409] = "CONFLICT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.2.1
     *
     * This interim response indicates that everything so far is OK and that the client should continue with the request or ignore it if it is already finished.
     */
    StatusCodes[StatusCodes["CONTINUE"] = 100] = "CONTINUE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.2
     *
     * The request has succeeded and a new resource has been created as a result of it. This is typically the response sent after a PUT request.
     */
    StatusCodes[StatusCodes["CREATED"] = 201] = "CREATED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.14
     *
     * This response code means the expectation indicated by the Expect request header field can't be met by the server.
     */
    StatusCodes[StatusCodes["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.5
     *
     * The request failed due to failure of a previous request.
     */
    StatusCodes[StatusCodes["FAILED_DEPENDENCY"] = 424] = "FAILED_DEPENDENCY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.3
     *
     * The client does not have access rights to the content, i.e. they are unauthorized, so server is rejecting to give proper response. Unlike 401, the client's identity is known to the server.
     */
    StatusCodes[StatusCodes["FORBIDDEN"] = 403] = "FORBIDDEN";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.5
     *
     * This error response is given when the server is acting as a gateway and cannot get a response in time.
     */
    StatusCodes[StatusCodes["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.9
     *
     * This response would be sent when the requested content has been permenantly deleted from server, with no forwarding address. Clients are expected to remove their caches and links to the resource. The HTTP specification intends this status code to be used for "limited-time, promotional services". APIs should not feel compelled to indicate resources that have been deleted with this status code.
     */
    StatusCodes[StatusCodes["GONE"] = 410] = "GONE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.6
     *
     * The HTTP version used in the request is not supported by the server.
     */
    StatusCodes[StatusCodes["HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2324#section-2.3.2
     *
     * Any attempt to brew coffee with a teapot should result in the error code "418 I'm a teapot". The resulting entity body MAY be short and stout.
     */
    StatusCodes[StatusCodes["IM_A_TEAPOT"] = 418] = "IM_A_TEAPOT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.6
     *
     * The 507 (Insufficient Storage) status code means the method could not be performed on the resource because the server is unable to store the representation needed to successfully complete the request. This condition is considered to be temporary. If the request which received this status code was the result of a user action, the request MUST NOT be repeated until it is requested by a separate user action.
     */
    StatusCodes[StatusCodes["INSUFFICIENT_SPACE_ON_RESOURCE"] = 419] = "INSUFFICIENT_SPACE_ON_RESOURCE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.6
     *
     * The server has an internal configuration error: the chosen variant resource is configured to engage in transparent content negotiation itself, and is therefore not a proper end point in the negotiation process.
     */
    StatusCodes[StatusCodes["INSUFFICIENT_STORAGE"] = 507] = "INSUFFICIENT_STORAGE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.1
     *
     * The server encountered an unexpected condition that prevented it from fulfilling the request.
     */
    StatusCodes[StatusCodes["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.10
     *
     * The server rejected the request because the Content-Length header field is not defined and the server requires it.
     */
    StatusCodes[StatusCodes["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.4
     *
     * The resource that is being accessed is locked.
     */
    StatusCodes[StatusCodes["LOCKED"] = 423] = "LOCKED";
    /**
     * @deprecated
     * Official Documentation @ https://tools.ietf.org/rfcdiff?difftype=--hwdiff&url2=draft-ietf-webdav-protocol-06.txt
     *
     * A deprecated response used by the Spring Framework when a method has failed.
     */
    StatusCodes[StatusCodes["METHOD_FAILURE"] = 420] = "METHOD_FAILURE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.5
     *
     * The request method is known by the server but has been disabled and cannot be used. For example, an API may forbid DELETE-ing a resource. The two mandatory methods, GET and HEAD, must never be disabled and should not return this error code.
     */
    StatusCodes[StatusCodes["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.2
     *
     * This response code means that URI of requested resource has been changed. Probably, new URI would be given in the response.
     */
    StatusCodes[StatusCodes["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.3
     *
     * This response code means that URI of requested resource has been changed temporarily. New changes in the URI might be made in the future. Therefore, this same URI should be used by the client in future requests.
     */
    StatusCodes[StatusCodes["MOVED_TEMPORARILY"] = 302] = "MOVED_TEMPORARILY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.2
     *
     * A Multi-Status response conveys information about multiple resources in situations where multiple status codes might be appropriate.
     */
    StatusCodes[StatusCodes["MULTI_STATUS"] = 207] = "MULTI_STATUS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.1
     *
     * The request has more than one possible responses. User-agent or user should choose one of them. There is no standardized way to choose one of the responses.
     */
    StatusCodes[StatusCodes["MULTIPLE_CHOICES"] = 300] = "MULTIPLE_CHOICES";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-6
     *
     * The 511 status code indicates that the client needs to authenticate to gain network access.
     */
    StatusCodes[StatusCodes["NETWORK_AUTHENTICATION_REQUIRED"] = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.5
     *
     * There is no content to send for this request, but the headers may be useful. The user-agent may update its cached headers for this resource with the new ones.
     */
    StatusCodes[StatusCodes["NO_CONTENT"] = 204] = "NO_CONTENT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.4
     *
     * This response code means returned meta-information set is not exact set as available from the origin server, but collected from a local or a third party copy. Except this condition, 200 OK response should be preferred instead of this response.
     */
    StatusCodes[StatusCodes["NON_AUTHORITATIVE_INFORMATION"] = 203] = "NON_AUTHORITATIVE_INFORMATION";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.6
     *
     * This response is sent when the web server, after performing server-driven content negotiation, doesn't find any content following the criteria given by the user agent.
     */
    StatusCodes[StatusCodes["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.4
     *
     * The server can not find requested resource. In the browser, this means the URL is not recognized. In an API, this can also mean that the endpoint is valid but the resource itself does not exist. Servers may also send this response instead of 403 to hide the existence of a resource from an unauthorized client. This response code is probably the most famous one due to its frequent occurence on the web.
     */
    StatusCodes[StatusCodes["NOT_FOUND"] = 404] = "NOT_FOUND";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.2
     *
     * The request method is not supported by the server and cannot be handled. The only methods that servers are required to support (and therefore that must not return this code) are GET and HEAD.
     */
    StatusCodes[StatusCodes["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7232#section-4.1
     *
     * This is used for caching purposes. It is telling to client that response has not been modified. So, client can continue to use same cached version of response.
     */
    StatusCodes[StatusCodes["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.1
     *
     * The request has succeeded. The meaning of a success varies depending on the HTTP method:
     * GET: The resource has been fetched and is transmitted in the message body.
     * HEAD: The entity headers are in the message body.
     * POST: The resource describing the result of the action is transmitted in the message body.
     * TRACE: The message body contains the request message as received by the server
     */
    StatusCodes[StatusCodes["OK"] = 200] = "OK";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7233#section-4.1
     *
     * This response code is used because of range header sent by the client to separate download into multiple streams.
     */
    StatusCodes[StatusCodes["PARTIAL_CONTENT"] = 206] = "PARTIAL_CONTENT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.2
     *
     * This response code is reserved for future use. Initial aim for creating this code was using it for digital payment systems however this is not used currently.
     */
    StatusCodes[StatusCodes["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7538#section-3
     *
     * This means that the resource is now permanently located at another URI, specified by the Location: HTTP Response header. This has the same semantics as the 301 Moved Permanently HTTP response code, with the exception that the user agent must not change the HTTP method used: if a POST was used in the first request, a POST must be used in the second request.
     */
    StatusCodes[StatusCodes["PERMANENT_REDIRECT"] = 308] = "PERMANENT_REDIRECT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7232#section-4.2
     *
     * The client has indicated preconditions in its headers which the server does not meet.
     */
    StatusCodes[StatusCodes["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-3
     *
     * The origin server requires the request to be conditional. Intended to prevent the 'lost update' problem, where a client GETs a resource's state, modifies it, and PUTs it back to the server, when meanwhile a third party has modified the state on the server, leading to a conflict.
     */
    StatusCodes[StatusCodes["PRECONDITION_REQUIRED"] = 428] = "PRECONDITION_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.1
     *
     * This code indicates that the server has received and is processing the request, but no response is available yet.
     */
    StatusCodes[StatusCodes["PROCESSING"] = 102] = "PROCESSING";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7235#section-3.2
     *
     * This is similar to 401 but authentication is needed to be done by a proxy.
     */
    StatusCodes[StatusCodes["PROXY_AUTHENTICATION_REQUIRED"] = 407] = "PROXY_AUTHENTICATION_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-5
     *
     * The server is unwilling to process the request because its header fields are too large. The request MAY be resubmitted after reducing the size of the request header fields.
     */
    StatusCodes[StatusCodes["REQUEST_HEADER_FIELDS_TOO_LARGE"] = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.7
     *
     * This response is sent on an idle connection by some servers, even without any previous request by the client. It means that the server would like to shut down this unused connection. This response is used much more since some browsers, like Chrome, Firefox 27+, or IE9, use HTTP pre-connection mechanisms to speed up surfing. Also note that some servers merely shut down the connection without sending this message.
     */
    StatusCodes[StatusCodes["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.11
     *
     * Request entity is larger than limits defined by server; the server might close the connection or return an Retry-After header field.
     */
    StatusCodes[StatusCodes["REQUEST_TOO_LONG"] = 413] = "REQUEST_TOO_LONG";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.12
     *
     * The URI requested by the client is longer than the server is willing to interpret.
     */
    StatusCodes[StatusCodes["REQUEST_URI_TOO_LONG"] = 414] = "REQUEST_URI_TOO_LONG";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7233#section-4.4
     *
     * The range specified by the Range header field in the request can't be fulfilled; it's possible that the range is outside the size of the target URI's data.
     */
    StatusCodes[StatusCodes["REQUESTED_RANGE_NOT_SATISFIABLE"] = 416] = "REQUESTED_RANGE_NOT_SATISFIABLE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.6
     *
     * This response code is sent after accomplishing request to tell user agent reset document view which sent this request.
     */
    StatusCodes[StatusCodes["RESET_CONTENT"] = 205] = "RESET_CONTENT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.4
     *
     * Server sent this response to directing client to get requested resource to another URI with an GET request.
     */
    StatusCodes[StatusCodes["SEE_OTHER"] = 303] = "SEE_OTHER";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.4
     *
     * The server is not ready to handle the request. Common causes are a server that is down for maintenance or that is overloaded. Note that together with this response, a user-friendly page explaining the problem should be sent. This responses should be used for temporary conditions and the Retry-After: HTTP header should, if possible, contain the estimated time before the recovery of the service. The webmaster must also take care about the caching-related headers that are sent along with this response, as these temporary condition responses should usually not be cached.
     */
    StatusCodes[StatusCodes["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.2.2
     *
     * This code is sent in response to an Upgrade request header by the client, and indicates the protocol the server is switching too.
     */
    StatusCodes[StatusCodes["SWITCHING_PROTOCOLS"] = 101] = "SWITCHING_PROTOCOLS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.7
     *
     * Server sent this response to directing client to get requested resource to another URI with same method that used prior request. This has the same semantic than the 302 Found HTTP response code, with the exception that the user agent must not change the HTTP method used: if a POST was used in the first request, a POST must be used in the second request.
     */
    StatusCodes[StatusCodes["TEMPORARY_REDIRECT"] = 307] = "TEMPORARY_REDIRECT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-4
     *
     * The user has sent too many requests in a given amount of time ("rate limiting").
     */
    StatusCodes[StatusCodes["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7235#section-3.1
     *
     * Although the HTTP standard specifies "unauthorized", semantically this response means "unauthenticated". That is, the client must authenticate itself to get the requested response.
     */
    StatusCodes[StatusCodes["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7725
     *
     * The user-agent requested a resource that cannot legally be provided, such as a web page censored by a government.
     */
    StatusCodes[StatusCodes["UNAVAILABLE_FOR_LEGAL_REASONS"] = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.3
     *
     * The request was well-formed but was unable to be followed due to semantic errors.
     */
    StatusCodes[StatusCodes["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.13
     *
     * The media format of the requested data is not supported by the server, so the server is rejecting the request.
     */
    StatusCodes[StatusCodes["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
    /**
     * @deprecated
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.6
     *
     * Was defined in a previous version of the HTTP specification to indicate that a requested response must be accessed by a proxy. It has been deprecated due to security concerns regarding in-band configuration of a proxy.
     */
    StatusCodes[StatusCodes["USE_PROXY"] = 305] = "USE_PROXY";
    /**
     * Official Documentation @ https://datatracker.ietf.org/doc/html/rfc7540#section-9.1.2
     *
     * Defined in the specification of HTTP/2 to indicate that a server is not able to produce a response for the combination of scheme and authority that are included in the request URI.
     */
    StatusCodes[StatusCodes["MISDIRECTED_REQUEST"] = 421] = "MISDIRECTED_REQUEST";
})(StatusCodes || (StatusCodes = {}));

// EXTERNAL MODULE: ./config/constants.js
var constants = __webpack_require__(58223);
;// CONCATENATED MODULE: ./utils/magentoService.js








function _createSuper(Derived) { var hasNativeReflectConstruct = magentoService_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function magentoService_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }



var CustomError = /*#__PURE__*/function (_Error) {
  (0,inherits/* default */.Z)(CustomError, _Error);

  var _super = _createSuper(CustomError);

  function CustomError(message, status, data, cause) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, CustomError);

    _this = _super.call(this, message);
    _this.name = _this.constructor.name;
    _this.status = status;
    _this.data = data;
    _this.cause = cause;

    if (Error.captureStackTrace !== undefined) {
      Error.captureStackTrace((0,assertThisInitialized/* default */.Z)(_this), _this.constructor);
    }

    return _this;
  }

  return (0,createClass/* default */.Z)(CustomError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var handleMagentoResponse = function handleMagentoResponse(res) {
  var ok_value = true;
  var status_value = StatusCodes.OK;
  var msg = 'success';

  if (!res || !res.data || !res.data && !res.errors) {
    var err = new CustomError('InvalidResponse', StatusCodes.FAILED_DEPENDENCY, res);
    return {
      ok: false,
      error: err,
      message: err,
      data: res.data,
      response_time: res.response_time
    };
  }

  if (res !== null && res !== void 0 && res.errors) {
    var _res$errors, _res$errors$;

    var err_msg = res === null || res === void 0 ? void 0 : (_res$errors = res.errors) === null || _res$errors === void 0 ? void 0 : (_res$errors$ = _res$errors[0]) === null || _res$errors$ === void 0 ? void 0 : _res$errors$.message;

    if (err_msg.includes("cannot perform operations on cart") || err_msg.includes("Could not find a cart") || err_msg.includes("Cannot query field")) {
      status_value = StatusCodes.UNPROCESSABLE_ENTITY;
    } else if (err_msg.includes("Some of the products are out of stock") || err_msg.includes("There are no source items with the in stock status") && res.data) {
      // make it success response
      return {
        ok: ok_value,
        status: StatusCodes.OK,
        data: res.data
      };
    } else if (err_msg.includes("Product that you are trying to add is not available")) {
      status_value = constants/* BACK_ORDER_DEAL_AVAILABILITY_STATUS */.ur;
    } else {
      status_value = StatusCodes.INTERNAL_SERVER_ERROR;
    }

    ok_value = false;
    msg = new CustomError('MagentoError', status_value, res);
    return {
      ok: ok_value,
      status: status_value,
      data: res.data,
      message: msg,
      errors: res === null || res === void 0 ? void 0 : res.errors
    };
  }

  return {
    ok: ok_value,
    status: status_value,
    data: res.data
  };
};
// EXTERNAL MODULE: ./utils/logger.js
var logger = __webpack_require__(21534);
// EXTERNAL MODULE: ./components/atoms/DependencyHelper.js + 81 modules
var DependencyHelper = __webpack_require__(28658);
;// CONCATENATED MODULE: ./utils/ajaxServices.js



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var HttpsProxyAgent =  false ? 0 : "";

var config = __webpack_require__(26125);

var env = config.env;





var httpGet = function httpGet(baseUrl, params) {
  var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "stub";
  var requestId = arguments.length > 3 ? arguments[3] : undefined;
  var reqParams = arguments.length > 4 ? arguments[4] : undefined;
  var responseType = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "json";

  if (mode === "api") {
    var server = config.envConfigs[env].server;
    var serverDomain = config.envConfigs[env].serverDomain;
    var url = env == 'dev' || baseUrl == 'featureBaseUrl' ? "".concat(server).concat(config[baseUrl]).concat(config[mode][requestId]) : "".concat(serverDomain).concat(config[mode][requestId]);

    if (reqParams && url.indexOf("{reqParams}") < 0) {
      url = "".concat(url, "/{reqParams}");
      url = url.replace("{reqParams}", reqParams.join("/"));
    }

    if (params && url.indexOf("{param}") < 0) {
      url = "".concat(url, "?{param}");
      url = url.replace("{param}", params);
    }

    var headers = {
      "Content-Type": "application/json"
    };
    var opts;

    if (url.toLowerCase().startsWith("https:") && false) { var agent; } else {
      opts = {
        method: "GET",
        headers: headers
      };
    }

    return fetch(url, opts).then( /*#__PURE__*/function () {
      var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(res) {
        var ret;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(responseType == "text")) {
                  _context.next = 6;
                  break;
                }

                _context.next = 3;
                return res.text();

              case 3:
                _context.t0 = _context.sent;
                _context.next = 9;
                break;

              case 6:
                _context.next = 8;
                return res.json();

              case 8:
                _context.t0 = _context.sent;

              case 9:
                ret = _context.t0;

                if (!(res !== null && res !== void 0 && res.ok)) {
                  logger/* Logger.error */.Y.error(ret.error || ret.message || "Failed to fetch ".concat(url), "httpGet", {
                    request: {
                      baseUrl: baseUrl,
                      params: JSON.stringify(params || {}),
                      mode: mode,
                      requestId: requestId,
                      reqParams: JSON.stringify(reqParams || {}),
                      responseType: responseType
                    },
                    requestUrl: url,
                    response: responseType !== "text" && JSON.stringify(ret) || "HTML Response - unable to display",
                    responseStatus: "".concat(res.status, " - ").concat(res.statusText),
                    options: opts
                  });
                }

                return _context.abrupt("return", ret);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  }
};

var httpPost = function httpPost(baseUrl, data) {
  var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "stub";
  var requestId = arguments.length > 3 ? arguments[3] : undefined;
  var authNeed = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  if (mode === "api") {
    var authToken = (0,helperServices/* getCookieValue */.Do)("auth_token");
    var server = config.envConfigs[env].server;
    var serverDomain = config.envConfigs[env].serverDomain;
    var url = env == 'dev' ? "".concat(server).concat(config[baseUrl]).concat(config[mode][requestId]) : "".concat(serverDomain).concat(config[mode][requestId]);
    var headers = {
      "Content-Type": "application/json",
      Accept: "application/json"
    };

    if (authToken && authNeed) {
      headers.Authorization = "Bearer ".concat(authToken);
    }

    var opts;

    if (url.toLowerCase().startsWith("https:") && false) { var agent; } else {
      opts = {
        method: "POST",
        headers: headers,
        body: data
      };
    }

    return fetch(url, opts).then(function (res) {
      if (!(res !== null && res !== void 0 && res.ok)) {
        logger/* Logger.error */.Y.error("Failed to fetch ".concat(url), "httpPost", {
          request: {
            baseUrl: baseUrl,
            data: JSON.stringify(data || {}),
            mode: mode,
            requestId: requestId,
            authNeed: authNeed
          },
          requestUrl: url,
          responseStatus: "".concat(res.status, " - ").concat(res.statusText),
          options: opts
        });
      }

      return res.json();
    }).then(function (rsp) {
      if (false) {}

      return rsp;
    });
  }
};

var httpPostGrpahQL = function httpPostGrpahQL(baseUrl, data) {
  var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "stub";
  var requestId = arguments.length > 3 ? arguments[3] : undefined;
  var authNeed = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  if (mode === "api") {
    var authToken = (0,helperServices/* getCookieValue */.Do)("auth_token");
    var server = config.envConfigs[env].server;
    var url = env == 'dev' ? "".concat(server).concat(config[baseUrl]).concat(config[mode][requestId]) : "".concat(config.envConfigs[config.env].dxl.url).concat(config[mode][requestId]);
    console.log("httpPostGrpahQL URL: ", url);
    var headers = {
      "Content-Type": "application/json",
      Accept: "application/json"
    };

    if (authToken && authNeed) {
      headers.Authorization = "Bearer ".concat(authToken);
    }

    var opts;

    if (url.toLowerCase().startsWith("https:") && false) { var agent; } else {
      opts = {
        method: "POST",
        headers: headers,
        body: data
      };
    }

    return fetch(url, opts).then(function (res) {
      if (!(res !== null && res !== void 0 && res.ok)) {
        logger/* Logger.error */.Y.error("Failed to fetch ".concat(url), "httpPostGrpahQL", {
          request: {
            baseUrl: baseUrl,
            data: JSON.stringify(data || {}),
            mode: mode,
            requestId: requestId,
            authNeed: authNeed
          },
          requestUrl: url,
          responseStatus: "".concat(res.status, " - ").concat(res.statusText),
          options: opts
        });
      }

      return res.json();
    }).then(function (rsp) {
      if (false) {}

      return rsp;
    });
  }
};

var fetchGraphQLGetRequest = function fetchGraphQLGetRequest(query, variables, signal) {
  var server = config.envConfigs[env].server;
  var url = env == 'dev' ? "".concat(server).concat(config.graphqlUrl) : "".concat(config.envConfigs[config.env].graphql.url);
  var authToken = (0,helperServices/* getCookieValue */.Do)("auth_token");
  var headers = {};

  if (authToken) {
    headers = {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "store": "cbu",
      "Authorization": "Bearer ".concat(authToken)
    };
  } else {
    headers = {
      "Content-Type": "application/json",
      "store": "cbu",
      "Accept": "application/json"
    };
  }

  var opts = {};

  if (url.toLowerCase().startsWith("https:") && false) { var agent; } else {
    opts = {
      method: "GET",
      headers: headers
    };
  }

  if (signal) {
    opts.signal = signal;
  }

  var getUrl = url + '?query=' + query;

  if (variables) {
    getUrl = getUrl + '&variables=' + JSON.stringify(variables);
  }

  var finalURL = getUrl.trim();
  var response;
  return fetch(encodeURI(finalURL), opts).then(function (resData) {
    return resData.json();
  }).then(function (res) {
    var responseStatus = handleMagentoResponse(res);

    if (!(responseStatus !== null && responseStatus !== void 0 && responseStatus.ok)) {
      logger/* Logger.error */.Y.error(responseStatus.error || responseStatus.message || "Failed to fetch ".concat(url), "fetchGraphQLGetRequest", {
        requestUrl: finalURL,
        response: JSON.stringify(responseStatus),
        options: opts
      });
    }

    response = responseStatus;
    return responseStatus;
  }).then(function (rsp) {
    if (false) {}

    if (!rsp.data) {
      return _objectSpread(_objectSpread({}, rsp), {}, {
        status: response.status
      });
    } else {
      return _objectSpread(_objectSpread({}, rsp.data), {}, {
        status: response.status
      });
    }
  })["catch"](function (e) {
    logger/* Logger.error */.Y.error(e);
    logger/* Logger.error */.Y.error(e, "fetchGraphQLGetRequest", {
      requestUrl: finalURL,
      options: opts
    });

    if (e.name === 'AbortError') {
      console.log('Promise Aborted');
    }
  });
};

var httpPdfGet = function httpPdfGet(baseUrl, requestUrl) {
  var url = noCorsUrl(baseUrl, requestUrl);
  var headers = {
    "Content-Type": "application/pdf"
  };
  var opts;

  if (url.toLowerCase().startsWith("https:") && false) { var agent; } else {
    opts = {
      method: "GET",
      headers: headers
    };
  }

  return fetch(url, opts).then(function (res) {
    if (!(res !== null && res !== void 0 && res.ok)) {
      logger/* Logger.error */.Y.error(new Error("Failed to fetch ".concat(url)));
    }

    return res.blob();
  }).then(function (rsp) {
    return rsp;
  });
};

var noCorsUrl = function noCorsUrl(baseUrl, requestUrl) {
  var server = config.envConfigs[env].server;
  var newRequestUrl = "";

  if (baseUrl !== "drupalBaseUrl") {
    newRequestUrl = requestUrl.replace(config.envConfigs[env].graphql.url, "/");
  } else {
    newRequestUrl = requestUrl.replace(config.envConfigs[env].drupalApi.url, "/");
  }

  return "".concat(server).concat(config[baseUrl]).concat(newRequestUrl);
};

var httpAuthGet = function httpAuthGet(baseUrl, params) {
  var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "stub";
  var requestId = arguments.length > 3 ? arguments[3] : undefined;
  var reqParams = arguments.length > 4 ? arguments[4] : undefined;

  if (mode == "stub") {// const resquestedService = require(`../data/${requestId}`);
    //  return resquestedService.default.data;
  } else if (mode == "api") {
    var envConfig = config.envConfigs[env];
    var server = envConfig.server;
    var serverDomain = config.envConfigs[env].serverDomain;
    var url = env == 'dev' ? "".concat(server).concat(config[baseUrl]).concat(config[mode][requestId]) : "".concat(serverDomain).concat(config[mode][requestId]);
    var auth = "Basic ".concat(envConfig["drupalApi"]["auth"]);

    if (reqParams && url.indexOf("{reqParams}") < 0) {
      url = "".concat(url, "/{reqParams}");
      url = url.replace("{reqParams}", reqParams.join("/"));
    }

    if (params && url.indexOf("{param}") < 0) {
      url = "".concat(url, "?{param}");
      url = url.replace("{param}", params);
    }

    var headers = {
      "Content-Type": "application/json",
      Authorization: auth
    };
    var opts;

    if (url.toLowerCase().startsWith("https:") && false) { var agent; } else {
      opts = {
        method: "GET",
        headers: headers
      };
    }

    return fetch(url, opts).then(function (res) {
      if (!(res !== null && res !== void 0 && res.ok)) {
        logger/* Logger.error */.Y.error(new Error("Failed to fetch ".concat(url)));
      }

      return res.json();
    }).then(function (rsp) {
      if (false) {}

      return rsp;
    });
  }
};

var httpAuthPost = function httpAuthPost(baseUrl, data) {
  var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "stub";
  var requestId = arguments.length > 3 ? arguments[3] : undefined;

  if (mode == "stub") {// const resquestedService = require(`../data/${requestId}`);
    // return resquestedService;
  } else if (mode == "api") {
    var envConfig = config.envConfigs[env];
    var server = envConfig.server;
    var serverDomain = config.envConfigs[env].serverDomain;
    var url = env == 'dev' ? "".concat(server).concat(config[baseUrl]).concat(config[mode][requestId]) : "".concat(serverDomain).concat(config[mode][requestId]);
    var auth = "Basic ".concat(envConfig["drupalApi"]["auth"]);
    var headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: auth // "X-CSRF-TOKEN": csrfToken,

    };
    var opts;

    if (url.toLowerCase().startsWith("https:") && false) { var agent; } else {
      opts = {
        method: "POST",
        headers: headers,
        body: data
      };
    }

    return fetch(url, opts).then(function (res) {
      if (!(res !== null && res !== void 0 && res.ok)) {
        logger/* Logger.error */.Y.error(new Error("Failed to fetch ".concat(url)));
      }

      return res.json();
    }).then(function (rsp) {
      if (false) {}

      return rsp;
    });
  }
};

var fetchGraphQLPOSTRequest = function fetchGraphQLPOSTRequest(query, variables) {
  var stubUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var nodeGet = arguments.length > 3 ? arguments[3] : undefined;
  var signal = arguments.length > 4 ? arguments[4] : undefined;
  var requestOptions = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var body = JSON.stringify({
    query: query,
    variables: variables
  });
  var url;
  url = "".concat(config.envConfigs[config.env].graphql.url);
  var operation = nodeGet ? "graphql" : (0,queries/* getGraphQlOperationFromRequestQuery */.Xn)(query);
  var authToken = (0,helperServices/* getCookieValue */.Do)('auth_token');
  var headers = {};

  if (authToken) {
    headers = {
      'Content-Type': 'application/json',
      "Accept": 'application/json',
      'store': 'cbu',
      'Authorization': "Bearer ".concat(authToken)
    };
  } else {
    headers = {
      'Content-Type': 'application/json',
      "Accept": 'application/json',
      'store': 'cbu'
    };
  }

  if (stubUrl !== '') {
    var resquestedService = __webpack_require__(88000)("./".concat(stubUrl));

    return resquestedService.data;
  } else {
    var opts;

    if (url.toLowerCase().startsWith('https:') && false) { var agent; } else {
      opts = {
        method: 'POST',
        headers: headers,
        body: body
      };
    }

    if (signal) {
      opts.signal = signal;
    }

    if (variables && variables.contract_skus) {
      url = "".concat(url, "?contract_skus=").concat((0,DependencyHelper.sha256)(variables.contract_skus));
    }

    var response;

    if (requestOptions && typeof requestOptions === 'object') {
      if (requestOptions.headers && typeof requestOptions.headers === 'object') {
        opts.headers = _objectSpread(_objectSpread({}, opts.headers), requestOptions.headers);
      }
    }

    return fetch(url, opts).then(function (resData) {
      return resData.json();
    }).then(function (res) {
      var responseStatus = handleMagentoResponse(res);

      if (!(responseStatus !== null && responseStatus !== void 0 && responseStatus.ok)) {
        logger/* Logger.error */.Y.error(responseStatus.error || responseStatus.message || "Failed to fetch ".concat(url), "fetchGraphQLPOSTRequest", {
          request: {
            body: JSON.stringify(body || {})
          },
          requestUrl: url,
          response: JSON.stringify(responseStatus),
          options: opts
        });
      }

      response = responseStatus;
      return responseStatus;
    }).then(function (rsp) {
      if (false) {}

      if (rsp !== null && rsp !== void 0 && rsp.data || rsp !== null && rsp !== void 0 && rsp.errors) {
        var _response;

        return _objectSpread(_objectSpread({}, rsp === null || rsp === void 0 ? void 0 : rsp.data), {}, {
          status: (_response = response) === null || _response === void 0 ? void 0 : _response.status,
          errors: (rsp === null || rsp === void 0 ? void 0 : rsp.errors) || null
        });
      } else {
        var _response2;

        return _objectSpread(_objectSpread({}, rsp), {}, {
          status: (_response2 = response) === null || _response2 === void 0 ? void 0 : _response2.status
        });
      }
    })["catch"](function (error) {
      logger/* Logger.error */.Y.error(error, "fetchGraphQLPOSTRequest", {
        request: {
          body: JSON.stringify(body || {})
        },
        requestUrl: url,
        options: opts
      });

      if (false) {}
    });
  }
};

/* harmony default export */ var ajaxServices = ({
  httpGet: httpGet,
  httpPost: httpPost,
  httpPostGrpahQL: httpPostGrpahQL,
  fetchGraphQLPOSTRequest: fetchGraphQLPOSTRequest,
  fetchGraphQLGetRequest: fetchGraphQLGetRequest,
  httpPdfGet: httpPdfGet,
  noCorsUrl: noCorsUrl,
  httpAuthGet: httpAuthGet,
  httpAuthPost: httpAuthPost
});

/***/ }),

/***/ 72490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A_": function() { return /* binding */ createCartItems; },
/* harmony export */   "DT": function() { return /* binding */ createColorSelections; },
/* harmony export */   "HR": function() { return /* binding */ extractDeviceColorOptions; },
/* harmony export */   "T9": function() { return /* binding */ extractProductList; },
/* harmony export */   "U6": function() { return /* binding */ isValidDeviceColor; },
/* harmony export */   "k1": function() { return /* binding */ createColorSelectionConfigs; },
/* harmony export */   "np": function() { return /* binding */ isDoubleDealDevice; },
/* harmony export */   "vi": function() { return /* binding */ selectInitialColor; },
/* harmony export */   "y9": function() { return /* binding */ extractInclusionColorOptions; }
/* harmony export */ });
/* unused harmony export isValidRouterResponse */
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27812);
/* harmony import */ var _config_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58223);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99599);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var createColorSelectionConfigs = function createColorSelectionConfigs() {
  var bundleOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var productSelections = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var products = [];
  var colorSelectionCount = 0;
  bundleOptions.forEach(function (option) {
    var _option$product, _configOpts$find;

    var productId = option === null || option === void 0 ? void 0 : option.product.id;
    var productCount = productSelections.reduce(function (total, ps) {
      return total + ((ps === null || ps === void 0 ? void 0 : ps.productId) === productId);
    }, 0);
    var configOpts = option === null || option === void 0 ? void 0 : (_option$product = option.product) === null || _option$product === void 0 ? void 0 : _option$product.configurable_options;
    var attrId = Array.isArray(configOpts) ? (_configOpts$find = configOpts.find(function (option) {
      return option.label === _config_constants__WEBPACK_IMPORTED_MODULE_1__/* .COLOR_LABEL */ .d4;
    })) === null || _configOpts$find === void 0 ? void 0 : _configOpts$find.attribute_id : '';

    if (productCount === 0) {
      return;
    } else if (productCount === 1) {
      var _prodSelection$produc;

      colorSelectionCount++;
      var prodSelection = productSelections.find(function (ps) {
        return (ps === null || ps === void 0 ? void 0 : ps.productId) === productId;
      });
      products.push({
        id: option.id,
        value_string: prodSelection === null || prodSelection === void 0 ? void 0 : (_prodSelection$produc = prodSelection.product) === null || _prodSelection$produc === void 0 ? void 0 : _prodSelection$produc.id,
        attribute_id: attrId || "",
        attribute_value: prodSelection.value_index
      });
    } else {
      var doubleDevices = productSelections.filter(function (ps) {
        return (ps === null || ps === void 0 ? void 0 : ps.productId) === productId;
      }).map(function (prodSelection) {
        var _prodSelection$produc2;

        colorSelectionCount++;
        return {
          id: option.id,
          value_string: prodSelection === null || prodSelection === void 0 ? void 0 : (_prodSelection$produc2 = prodSelection.product) === null || _prodSelection$produc2 === void 0 ? void 0 : _prodSelection$produc2.id,
          attribute_id: attrId || "",
          attribute_value: prodSelection.value_index
        };
      });
      products.push.apply(products, (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(doubleDevices));
    }
  });
  return {
    products: products,
    count: colorSelectionCount
  };
};
/**
 * Method to create cart items array.
 * @param {Object} params - an object with dealDetails, buyOptionTypeId, vasList
 * @param {Object} params.dealDetails - a deal details object.
 * @param {string} params.buyOptionTypeId - a string Id for the selected application type.
 * @param {Array<Object>} params.vasList - an array of VAS added.
 * @returns {Array<Object>} cart array with list of user selections.
 */

var createCartItems = function createCartItems(_ref) {
  var _dealDetails$options, _dealDetails$options$;

  var dealDetails = _ref.dealDetails,
      buyOptionTypeId = _ref.buyOptionTypeId,
      vasList = _ref.vasList,
      cartBundleOptions = _ref.cartBundleOptions;

  if (!dealDetails || !(dealDetails !== null && dealDetails !== void 0 && dealDetails.sku) || !Array.isArray(dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.items) || !Array.isArray(cartBundleOptions)) {
    return [];
  } // Add primary deal options


  var dealSKU = dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.sku;
  var buyOptionId = dealDetails === null || dealDetails === void 0 ? void 0 : (_dealDetails$options = dealDetails.options) === null || _dealDetails$options === void 0 ? void 0 : (_dealDetails$options$ = _dealDetails$options[0]) === null || _dealDetails$options$ === void 0 ? void 0 : _dealDetails$options$.option_id;
  var customizableOptions = buyOptionId && buyOptionTypeId ? [{
    id: buyOptionId,
    value_string: buyOptionTypeId === null || buyOptionTypeId === void 0 ? void 0 : buyOptionTypeId.toString()
  }] : [];
  var cartArr = [{
    bundle_options: cartBundleOptions,
    data: {
      sku: "".concat(dealSKU).toString(),
      quantity: _config_labels__WEBPACK_IMPORTED_MODULE_2__/* ["default"].lbl_cart_min_product_add_qty */ .Z.lbl_cart_min_product_add_qty
    },
    customizable_options: customizableOptions
  }]; // Add VAS list to cart list.

  if (Array.isArray(vasList) && vasList.length) {
    var vasArray = vasList.map(function (item) {
      return {
        data: {
          sku: item.id,
          quantity: 1
        },
        parent_product_sku: "".concat(dealSKU).toString(),
        monthly_recurring: +item.price,
        customizable_options: customizableOptions,
        bundle_options: []
      };
    });
    cartArr.push.apply(cartArr, (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(vasArray));
  }

  return cartArr;
};
/**
 * Method to create a list of selected product colors
 *
 * @returns {Array<ColorSelections>} a list of selected primary, secondary and inclusion color
 * selections
 */

var createColorSelections = function createColorSelections(_ref2) {
  var selectedPrimaryDeviceColor = _ref2.selectedPrimaryDeviceColor,
      selectedSecondaryDeviceColor = _ref2.selectedSecondaryDeviceColor,
      dealInclusionColors = _ref2.dealInclusionColors;
  var productSelections = [];

  if (selectedPrimaryDeviceColor && selectedPrimaryDeviceColor !== null && selectedPrimaryDeviceColor !== void 0 && selectedPrimaryDeviceColor.productId) {
    productSelections.push(selectedPrimaryDeviceColor);
  }

  if (selectedSecondaryDeviceColor && selectedSecondaryDeviceColor !== null && selectedSecondaryDeviceColor !== void 0 && selectedSecondaryDeviceColor.productId) {
    productSelections.push(selectedSecondaryDeviceColor);
  }

  if (Object.values(dealInclusionColors).length > 0) {
    var selectedIncColors = Object.values(dealInclusionColors).map(function (sic) {
      return sic.selectedColor;
    });
    productSelections.push.apply(productSelections, (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(selectedIncColors));
  }

  return productSelections;
};
/**
 * @typedef {Object} ColorOption
 * @property {number} id - unique id
 * @property {string} label - name of color
 * @property {ColorNotification} notification - optional notification object with "text", "description", "type"
 * @property {Object} product - product device object.
 * @property {string} value - hex value color. e.g. "#ffffff".
 * @property {number} value_index - unique id
 */

/**
 * getFormattedColorOptions - creates an array of colors with product associated with the color
 * @param {Array} configurable_options - list of configurable options (must have "Colour" as one of the options)
 * @param {Array} variants - list of product variants. Each variant is associated with a specific color.
 * @template {Object<string, ColorOption>} T
 * @returns {Array<T>} - array of colors
 */

var getFormattedColorOptions = function getFormattedColorOptions(configurable_options) {
  var variants = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var productId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  if (!Array.isArray(configurable_options)) return [];
  var colors = configurable_options.find(function (option) {
    return option.label === _config_constants__WEBPACK_IMPORTED_MODULE_1__/* .COLOR_LABEL */ .d4;
  });
  var colorOptions = Array.isArray(colors.values) ? colors.values.map(function (val) {
    var _val$swatch_data;

    return {
      id: val.value_index,
      label: val.label,
      product: null,
      productId: productId,
      value: (_val$swatch_data = val.swatch_data) === null || _val$swatch_data === void 0 ? void 0 : _val$swatch_data.value,
      value_index: val.value_index,
      mode: _config_constants__WEBPACK_IMPORTED_MODULE_1__/* .StockMode.IN_STOCK */ .uQ.IN_STOCK
    };
  }) : [];

  if (colorOptions.length > 0 && Array.isArray(variants)) {
    colorOptions.forEach(function (cOption) {
      var _product$product, _product$product2, _product$product3, _product$product4, _product$product5;

      var product = variants.find(function (variant) {
        return variant.attributes.some(function (attr) {
          return attr.value_index === cOption.value_index;
        });
      });
      cOption.product = (product === null || product === void 0 ? void 0 : product.product) || null;
      cOption.isAvailable = typeof (product === null || product === void 0 ? void 0 : (_product$product = product.product) === null || _product$product === void 0 ? void 0 : _product$product.stock_status) === "string" && (product === null || product === void 0 ? void 0 : (_product$product2 = product.product) === null || _product$product2 === void 0 ? void 0 : _product$product2.stock_status) !== _config_constants__WEBPACK_IMPORTED_MODULE_1__/* .StockStatus.OUT_OF_STOCK */ .BQ.OUT_OF_STOCK;

      if (!(product !== null && product !== void 0 && product.product) || (product === null || product === void 0 ? void 0 : (_product$product3 = product.product) === null || _product$product3 === void 0 ? void 0 : _product$product3.stock_status) === _config_constants__WEBPACK_IMPORTED_MODULE_1__/* .StockStatus.OUT_OF_STOCK */ .BQ.OUT_OF_STOCK) {
        cOption.notification = _config_constants__WEBPACK_IMPORTED_MODULE_1__/* .StockNotifications.OutOfStock */ .GS.OutOfStock;
        cOption.mode = _config_constants__WEBPACK_IMPORTED_MODULE_1__/* .StockMode.OUT_OF_STOCK */ .uQ.OUT_OF_STOCK;
      } else if ((product === null || product === void 0 ? void 0 : (_product$product4 = product.product) === null || _product$product4 === void 0 ? void 0 : _product$product4.stock_status) === _config_constants__WEBPACK_IMPORTED_MODULE_1__/* .StockStatus.IN_STOCK */ .BQ.IN_STOCK && (product === null || product === void 0 ? void 0 : (_product$product5 = product.product) === null || _product$product5 === void 0 ? void 0 : _product$product5.quantity) <= 0) {
        cOption.notification = _config_constants__WEBPACK_IMPORTED_MODULE_1__/* .StockNotifications.BackOrder */ .GS.BackOrder;
        cOption.mode = _config_constants__WEBPACK_IMPORTED_MODULE_1__/* .StockMode.BACK_ORDER */ .uQ.BACK_ORDER;
      } else {
        cOption.notification = null;
      }
    });
  }

  return colorOptions;
};
/**
 * Method to extract list of color options from device details object.
 * @param {Object} deviceDetails
 * @returns {Array<ColorOption>} list of device color options
 */


var extractDeviceColorOptions = function extractDeviceColorOptions(deviceDetails) {
  if (typeof deviceDetails !== "object" || !Array.isArray(deviceDetails === null || deviceDetails === void 0 ? void 0 : deviceDetails.configurable_options)) return [];
  return getFormattedColorOptions(deviceDetails === null || deviceDetails === void 0 ? void 0 : deviceDetails.configurable_options, deviceDetails === null || deviceDetails === void 0 ? void 0 : deviceDetails.variants, deviceDetails.id);
};
/**
 * Extract and formats color options from each deal inclusion.
 * @param {Array<Object>} inclusions - list of deal inclusions.
 * @returns {Object} map of sku and inclusion color details
 */

var extractInclusionColorOptions = function extractInclusionColorOptions(inclusions) {
  var dealInclusionColors = {};
  if (!Array.isArray(inclusions)) return dealInclusionColors;
  inclusions.forEach(function (item, index) {
    if (!Array.isArray(item === null || item === void 0 ? void 0 : item.configurable_options) || !(item !== null && item !== void 0 && item.configurable_options.length)) return;
    var colorOptions = getFormattedColorOptions(item === null || item === void 0 ? void 0 : item.configurable_options, item.variants, item.id);
    if (!colorOptions.length) return;
    dealInclusionColors[item.sku + index] = {
      options: colorOptions,
      selectedColor: selectInitialColor(colorOptions),
      groupId: item.sku
    };
  });
  return dealInclusionColors;
};
/**
 * Method to extract and structure all products under a deal into a single list of products
 * @param {Object} activeContract - active deal contract
 * @returns {Array} list of all products included in contract deal
 */

var extractProductList = function extractProductList() {
  var _activeContract$items;

  var activeContract = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!Array.isArray(activeContract === null || activeContract === void 0 ? void 0 : activeContract.items) || !(activeContract !== null && activeContract !== void 0 && (_activeContract$items = activeContract.items) !== null && _activeContract$items !== void 0 && _activeContract$items.length)) return [];
  var allProductOptions = activeContract === null || activeContract === void 0 ? void 0 : activeContract.items.map(function (item) {
    return item.options.reduce(function (productAcc, prod) {
      if ((prod === null || prod === void 0 ? void 0 : prod.is_hidden_product) === "1") {
        return productAcc;
      }

      var isSecondary = item.title === _config_constants__WEBPACK_IMPORTED_MODULE_1__/* .SmartphonesLabel */ .el && !prod.is_default;

      var product = _objectSpread(_objectSpread({}, prod.product), {}, {
        type: item.title,
        isPrimary: prod.is_default,
        isSecondary: isSecondary,
        optionQuantity: prod.quantity,
        optionId: prod.id,
        dealSku: item.sku
      });

      return [].concat((0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(productAcc), [product]);
    }, []);
  });
  return Array.isArray(allProductOptions) ? allProductOptions.flat() : [];
};
var isDoubleDealDevice = function isDoubleDealDevice() {
  var allProductsUnderContract = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var doubleDeals = allProductsUnderContract.filter(function (item) {
    return _config_constants__WEBPACK_IMPORTED_MODULE_1__/* .DoubleDealItems.includes */ .YD.includes(item.type);
  });
  return doubleDeals.length > 1 || doubleDeals.some(function (dd) {
    return dd.optionQuantity > 1;
  });
};
/**
 *
 * @param {ColorOption} deviceColor - color object
 * @returns {boolean} boolean value indicating whether deviceColor param is valid or not.
 */

var isValidDeviceColor = function isValidDeviceColor(deviceColor) {
  return !!(!!deviceColor && typeof deviceColor === "object" && deviceColor.id && deviceColor.label);
};
var isValidRouterResponse = function isValidRouterResponse(routerRes) {
  var _routerRes$products, _routerRes$products2;

  return !!(routerRes && Array.isArray(routerRes === null || routerRes === void 0 ? void 0 : (_routerRes$products = routerRes.products) === null || _routerRes$products === void 0 ? void 0 : _routerRes$products.items) && (routerRes === null || routerRes === void 0 ? void 0 : (_routerRes$products2 = routerRes.products) === null || _routerRes$products2 === void 0 ? void 0 : _routerRes$products2.items.length) > 0);
};
/**
 * Method to select an initial color from a list of colors.
 * Returns the first IN_STOCK color. If no color is IN_STOCK, returns back order color
 * @param {Array<ColorOption>} colors - list of colors to select from
 * @returns {ColorOption} device color object.
 */

var selectInitialColor = function selectInitialColor() {
  var colors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (!Array.isArray(colors) || colors.length === 0) return null;
  if (colors.length === 1) return colors[0];
  var selectedColor = colors.find(function (prodColor) {
    var _prodColor$product;

    return prodColor.isAvailable && ((_prodColor$product = prodColor.product) === null || _prodColor$product === void 0 ? void 0 : _prodColor$product.quantity) > 0;
  });
  if (selectedColor) return selectedColor;
  return colors.find(function (prodColor) {
    return prodColor.isAvailable;
  });
};

/***/ }),

/***/ 90760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ Features; }
/* harmony export */ });
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92777);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82262);


var Features = /*#__PURE__*/function () {
  function Features() {
    (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Features);
  }

  (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Features, null, [{
    key: "init",
    value: function init(features) {
      sessionStorage.setItem("features", JSON.stringify(features));
    }
  }, {
    key: "get",
    value: function get(key) {
      if (typeof sessionStorage === "undefined") {
        return false;
      }

      var features = sessionStorage.getItem("features");

      if (!key || !features) {
        return false;
      }

      var jsonFeatures = JSON.parse(features);
      return jsonFeatures[key] || false;
    }
  }]);

  return Features;
}();

/***/ }),

/***/ 64036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sG": function() { return /* binding */ addAutoSlash; },
  "I": function() { return /* binding */ addAutoSlashToPeriod; },
  "Rt": function() { return /* binding */ addOrdinalSuffix; },
  "xJ": function() { return /* binding */ africaCountryCode; },
  "yT": function() { return /* binding */ appendCountryCode; },
  "QP": function() { return /* binding */ calculateShipping; },
  "fm": function() { return /* binding */ capitalizeFirstLetter; },
  "Px": function() { return /* binding */ cartUpdateEvent; },
  "RZ": function() { return /* binding */ cellPhoneRegEx; },
  "D0": function() { return /* binding */ charRegExp; },
  "lW": function() { return /* binding */ charRegExpForName; },
  "z0": function() { return /* binding */ checkIsFinalPriceReq; },
  "yB": function() { return /* binding */ checkIsLowStock; },
  "zy": function() { return /* binding */ checkIsOutOfStock; },
  "e_": function() { return /* binding */ checkPreOrder; },
  "LY": function() { return /* binding */ checkStockQuantity; },
  "jC": function() { return /* binding */ checkYearAndMonthFormat; },
  "Zj": function() { return /* binding */ clearUserToken; },
  "Qj": function() { return /* binding */ componentCheckSize; },
  "Y4": function() { return /* binding */ componentResize; },
  "Lv": function() { return /* binding */ configurableOptions; },
  "uB": function() { return /* binding */ convertInToObject; },
  "GI": function() { return /* binding */ convertToCorrectDateFormat; },
  "KU": function() { return /* binding */ createMarkup; },
  "DF": function() { return /* binding */ currencyRegex; },
  "f9": function() { return /* binding */ dateRegex; },
  "Ds": function() { return /* binding */ debounce; },
  "pC": function() { return /* binding */ deleteSessionStorage; },
  "sz": function() { return /* binding */ dynamicBreadCrumb; },
  "TH": function() { return /* binding */ emailRegEx; },
  "x9": function() { return /* binding */ formatBreadCrumb; },
  "td": function() { return /* binding */ formatBytes; },
  "G0": function() { return /* binding */ formatNumbersWithComma; },
  "Pj": function() { return /* binding */ generateFormURL; },
  "oU": function() { return /* binding */ generateOrderCSSVariant; },
  "XI": function() { return /* binding */ generateOrderIconVariant; },
  "Ay": function() { return /* binding */ getAge; },
  "Dd": function() { return /* binding */ getAmountOffValue; },
  "bW": function() { return /* binding */ getAuthToken; },
  "n_": function() { return /* binding */ getBadgeName; },
  "h_": function() { return /* binding */ getCartGrandTotal; },
  "Bn": function() { return /* binding */ getClearCartQuery; },
  "Do": function() { return /* binding */ getCookieValue; },
  "GW": function() { return /* binding */ getCurrentPageNumber; },
  "XH": function() { return /* binding */ getCurrentSortVal; },
  "xA": function() { return /* binding */ getCustomDate; },
  "t5": function() { return /* binding */ getCustomerActiveCartService; },
  "dJ": function() { return /* binding */ getCustomerPositionAsync; },
  "cv": function() { return /* binding */ getCustomizableOptions; },
  "MV": function() { return /* binding */ getDateOfBirth; },
  "uJ": function() { return /* binding */ getDealExpiryTime; },
  "d$": function() { return /* binding */ getDealPrice; },
  "JR": function() { return /* binding */ getDealsGridUrl; },
  "x7": function() { return /* binding */ getDisplayedRange; },
  "pF": function() { return /* binding */ getDisplayedRangeOnDealSelection; },
  "eZ": function() { return /* binding */ getFinalPrice; },
  "_Y": function() { return /* binding */ getHighlights; },
  "id": function() { return /* binding */ getLabel; },
  "R3": function() { return /* binding */ getNestedObjectValue; },
  "bm": function() { return /* binding */ getOrderBlurb; },
  "Yn": function() { return /* binding */ getOrderCreated; },
  "yy": function() { return /* binding */ getOrderDetailUrl; },
  "WF": function() { return /* binding */ getOrderInfinityStatus; },
  "Nx": function() { return /* binding */ getOrderMessage; },
  "JA": function() { return /* binding */ getOrderProductImageUrl; },
  "AT": function() { return /* binding */ getOrderTypeAndLabel; },
  "FQ": function() { return /* binding */ getPercentOffValue; },
  "uf": function() { return /* binding */ getPreValidationErrorType; },
  "KL": function() { return /* binding */ getProductDetails; },
  "G": function() { return /* binding */ getProductImageUrl; },
  "X$": function() { return /* binding */ getProductsCookie; },
  "Wp": function() { return /* binding */ getPromotionLabel; },
  "HM": function() { return /* binding */ getPromotionVariant; },
  "xZ": function() { return /* binding */ getRegularPrice; },
  "aG": function() { return /* binding */ getRequestBody; },
  "c": function() { return /* binding */ getSelectedVariant; },
  "wJ": function() { return /* binding */ getSessionStorage; },
  "Fh": function() { return /* binding */ getSpecs; },
  "MI": function() { return /* binding */ getTagName; },
  "SQ": function() { return /* binding */ getTrackingUrl; },
  "DE": function() { return /* binding */ getUpdatedContactPerson; },
  "we": function() { return /* binding */ getUpdatedSurname; },
  "gk": function() { return /* binding */ getValueLabel; },
  "Kz": function() { return /* binding */ getVasData; },
  "DG": function() { return /* binding */ getVasDealPrice; },
  "H5": function() { return /* binding */ getdealDatenVariant; },
  "tt": function() { return /* binding */ goToUrl; },
  "rO": function() { return /* binding */ handleCartActionFailure; },
  "dr": function() { return /* binding */ handlePageSection; },
  "v3": function() { return /* binding */ hideSpinner; },
  "Sj": function() { return /* binding */ imagePrefix; },
  "Sb": function() { return /* binding */ infinityArrayToObject; },
  "az": function() { return /* binding */ internalUrl; },
  "wh": function() { return /* binding */ isArrayNotEmpty; },
  "AA": function() { return /* binding */ isDealOrder; },
  "$K": function() { return /* binding */ isDefined; },
  "iw": function() { return /* binding */ isDiscountTimerApplicable; },
  "xf": function() { return /* binding */ isExternalUrl; },
  "J": function() { return /* binding */ isGuestCheckout; },
  "NO": function() { return /* binding */ isMultiOrder; },
  "y7": function() { return /* binding */ isOnceOffOrder; },
  "$w": function() { return /* binding */ isValueSelected; },
  "Zf": function() { return /* binding */ manipulateFilter; },
  "$T": function() { return /* binding */ mapCartProductItems; },
  "Rn": function() { return /* binding */ matchWordInString; },
  "yJ": function() { return /* binding */ nameRegex; },
  "rP": function() { return /* binding */ numRegEx; },
  "i8": function() { return /* binding */ numberFormat; },
  "oN": function() { return /* binding */ numberToLocaleString; },
  "YM": function() { return /* binding */ options; },
  "Rx": function() { return /* binding */ orderPageButtons; },
  "jW": function() { return /* binding */ preValidationEligible; },
  "qH": function() { return /* binding */ preValidationUpgradeEligible; },
  "p4": function() { return /* binding */ removeCountryCode; },
  "qp": function() { return /* binding */ replaceDropdownKeys; },
  "gB": function() { return /* binding */ replaceValue; },
  "rI": function() { return /* binding */ requestType; },
  "ol": function() { return /* binding */ setCookieConsentWrapper; },
  "OL": function() { return /* binding */ setGuestCheckout; },
  "lX": function() { return /* binding */ setRoutes; },
  "yh": function() { return /* binding */ showSpinner; },
  "zp": function() { return /* binding */ splitCartItems; },
  "VU": function() { return /* binding */ streetNameRegEx; },
  "Qs": function() { return /* binding */ titleCase; },
  "FZ": function() { return /* binding */ titleCaseFirstLetterOfString; },
  "ke": function() { return /* binding */ toDesignation; },
  "rN": function() { return /* binding */ updateBreadCrumbPageTitle; },
  "YF": function() { return /* binding */ updateCartExpiry; },
  "DQ": function() { return /* binding */ updatePathInBreadCrumb; },
  "F$": function() { return /* binding */ updateSessionStorage; },
  "wn": function() { return /* binding */ urlPrefix; },
  "Xo": function() { return /* binding */ valOrNull; },
  "Nr": function() { return /* binding */ validateOrderItems; }
});

// UNUSED EXPORTS: capitalizeString, charSpaceRegExp, checkDealOutOfStock, checkDomain, checkValue, checkVarientInStock, countryCode, durationRegex, dynamicPageSection, equalsIgnoreCase, formatBreadCrumbAsList, getAllInStockMemoryAttributes, getColorHexVal, getOrderCancelled, getPlanNameLabel, getPreferenceRoutingUrl, getProfileData, getTotalDuration, getUrlPath, isMonthlyOrder, isUpgradeOrder, isValidJSON, logOutUser, myFunction, regName, removeCartId, removeCookieConsentWrapper, replaceUnderScore, roundUptwoDecimal, useCookieConsentWrapper

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-countdown/dist/index.es.js
var index_es = __webpack_require__(98130);
// EXTERNAL MODULE: ./utils/dealDetails.js
var dealDetails = __webpack_require__(72490);
;// CONCATENATED MODULE: ./config/badges.js
var badges = {
  "brand new": "brand-new",
  "pre Order": "pre-order",
  "low stock": "low-stock",
  "out of stock": "no-stock",
  "top pick": "top-pick",
  "currently viewing": "currently-viewing",
  "one-time offer": "one-time-offer",
  "today only": "today-only",
  "for today only": "for-today-only",
  "double device deal": "device-deal",
  "limited offer": "limited_offer",
  "exclusive to online": "exclusive-to-online",
  "red hot dealz": "read-hot-dealz",
  "red hot deal": "red-hot-deal",
  "buy one get one free": "buy-one-get-one-free"
};
/* harmony default export */ var config_badges = (badges);
// EXTERNAL MODULE: ./config/labels.js
var config_labels = __webpack_require__(99599);
// EXTERNAL MODULE: ./config/types.js
var types = __webpack_require__(69842);
;// CONCATENATED MODULE: ./config/infinityStatuses.js
var infinityStatuses = {
  "PENDING CONFIRMATION": {
    status: "Pending confirmation",
    description: "",
    nextStep: ["N/A"],
    icon: "",
    cssClass: "Standard"
  },
  "ORDER ERROR": {
    status: "Order placement failed",
    description: "We encountered an error while placing your order",
    nextStep: ["TBC"],
    icon: "",
    cssClass: "Standard"
  },
  "PAYMENT PENDING": {
    status: "Awaiting payment",
    description: "Your order has been placed. Once we’ve received a notification of payment, we’ll continue processing your order.",
    nextStep: ["Please make payment in order to finalise this order"],
    icon: "",
    cssClass: "Standard",
    buttons: [{
      label: "Make payment now",
      type: "payment"
    }]
  },
  "PAYMENT FAILED": {
    status: "Payment failed",
    description: "We couldn’t process this transaction with the card details you provided",
    nextStep: ["Please try making payment again in order to finalise this order"],
    icon: "icon-cross.svg",
    cssClass: "Empty",
    buttons: [{
      label: "Retry payment",
      type: "payment"
    }]
  },
  "PAID": {
    status: "Paid",
    description: "We’ve successfully processed this transaction",
    nextStep: ["Your order will be prepared and dispatched to the courier for delivery", "Your order should be delivered in the next 1 - 3 business days"],
    icon: "",
    cssClass: "Standard"
  },
  "PROCESSING": {
    status: "Processing order",
    description: "We’ve started processing your order",
    nextStep: ["Once your payment has been settled, we’ll start preparing your order for dispatch", "Your order should be delivered in the next 1 - 3 business days"],
    icon: "",
    cssClass: "Standard"
  },
  "PROCESSED": {
    status: "Preparing order",
    description: "Your payment has been settled, and we are now getting your order ready for handover to the courier",
    nextStep: ["Your order will be delivered in the next 1 - 3 business days"],
    icon: "",
    cssClass: "Standard"
  },
  "PAYMENT UNSUCCESSFUL": {
    status: "Payment unsuccessful",
    description: "Your payment could not be settled successfully",
    nextStep: ["TBC"],
    icon: "warning.svg",
    cssClass: "Empty"
  },
  "ORDER FAILED (MANUAL)": {
    status: "Order failed",
    description: "TBC",
    nextStep: ["TBC"],
    icon: "icon-cross.svg",
    cssClass: "Empty"
  },
  "BACK-ORDER": {
    status: "On backorder",
    description: "The device you’ve chosen is currently out of stock. It has been placed on backorder.",
    nextStep: ["As soon as we get stock of your selected device, we’ll prepare your order and dispatch it to the courier for delivery", "If you would like to discuss alternative options, please contact Customer Care at 082XXXX"],
    icon: "",
    cssClass: "Standard"
  },
  "DISPATCHED": {
    status: "Ready for handover to courier",
    description: "Your order has been prepared and is just about to be dispatched to the courier",
    nextStep: ["Once your order has been dispatched, the courier will contact you to arrange a delivery date and time", "Your order will be delivered in the next 1 - 3 business days"],
    icon: "",
    cssClass: "Standard"
  },
  "CONSIGNED": {
    status: "Handed over to courier",
    description: "Your order has been handed over to the courier for delivery",
    nextStep: ["The courier will contact you to arrange a delivery date and time", "Your order will be delivered in the next 1 - 3 business days"],
    icon: "",
    cssClass: "Standard"
  },
  "DELIVERY ATTEMPT FAILED": {
    status: "Delivery attempt failed",
    description: "The courier was unable to deliver your order",
    nextStep: ["Please contact RAM at 082XXXX in order to reschedule your delivery"],
    icon: "",
    cssClass: "Standard"
  },
  "RETURNED": {
    status: "Returned",
    description: "Your order was successfully returned to us",
    nextStep: "Check out our latest products and deals. We’re sure you’ll find something that makes your heart skip a beat!",
    icon: "icon-sucess.svg",
    cssClass: "Empty"
  },
  "HIJACKED": {
    status: "Hijacked",
    description: "Unfortunately, the courier was hijacked while on their way to you. Please accept our sincerest apologies for the delay.",
    nextStep: ["The courier will contact you to reschedule your delivery for a later date"],
    icon: "",
    cssClass: "Standard"
  },
  "STOLEN": {
    status: "Stolen",
    description: "Unfortunately, your parcel was stolen from the courier while on their way to you. Please accept our sincerest apologies for the delay.",
    nextStep: ["The courier will contact you to reschedule your delivery for a later date"],
    icon: "",
    cssClass: "Standard"
  },
  "DELIVERED": {
    status: "Delivered",
    description: "Your order was delivered successfully. Enjoy!",
    nextStep: [],
    icon: "icon-sucess.svg",
    cssClass: "Empty"
  },

  /* VETTING STATUSES */
  "APPROVAL STATUS": {
    status: "Approved & submitted",
    description: "Your credit check was approved and your order successfully submitted.",
    nextStep: ["Your order will be prepared and handed over to the courier for delivery. Delivery normally takes 3 - 5 business days.", "If you’ve chosen to collect from a store, the store will let you know as soon as your order is ready for collection."],
    icon: "",
    cssClass: "Standard"
  },
  "PENDED/REFERRED": {
    status: "Pending document submission",
    description: "In order to finalise your contract application, we need you to send us a few documents.",
    nextStep: ["Please send <a href='#details'><b>these documents</b></a> to <b><u>cadonline@vodacom.co.za</u> in PDF format</b>. Remember to quote your reference number in the subject line of your email to us.", "As soon as we receive your documents we will continue processing your application."],
    icon: "",
    cssClass: "Standard",
    showDocs: true
  },
  "APPROVED WITH CONDITION": {
    status: "Conditionally approved",
    description: "Your credit check was approved for a different set of deals than the one you applied for",
    nextStep: ["Please <u>select a deal from a set of deals that you qualify for</u>", "Once you’ve selected and added your new deal to cart, you can continue to check out. This time we won’t have to perform a credit check again."],
    icon: "",
    cssClass: "Standard",
    showCreditCheck: true,
    hideDeals: true
  },
  "DECLINE": {
    status: "Declined",
    description: "Unfortunately, your application was declined based on the credit check we performed.",
    nextStep: ["You’ll be able to apply for a contract again 30 days after your previous application was declined."],
    icon: "",
    cssClass: "Standard"
  }
};
// EXTERNAL MODULE: ./config/constants.js
var constants = __webpack_require__(58223);
;// CONCATENATED MODULE: ./config/routes.js


var RouteLinks = [{
  url: "/",
  title: config_labels/* default.BreadCrumbLabels.lbl_home */.Z.BreadCrumbLabels.lbl_home
}, {
  url: "/shopping/products",
  title: config_labels/* default.BreadCrumbLabels.lbl_browse_products */.Z.BreadCrumbLabels.lbl_browse_products
}, {
  url: "/shopping/product-compare",
  title: config_labels/* default.BreadCrumbLabels.lbl_compare_products */.Z.BreadCrumbLabels.lbl_compare_products
}, {
  url: "/shopping/product-details/[id]",
  title: config_labels/* default.BreadCrumbLabels.lbl_product_details */.Z.BreadCrumbLabels.lbl_product_details
}, {
  url: "/shopping/cart",
  title: config_labels/* default.BreadCrumbLabels.lbl_cart */.Z.BreadCrumbLabels.lbl_cart
}, {
  url: types/* default.DEAL_GRID_PAGE */.Z.DEAL_GRID_PAGE,
  title: config_labels/* default.BreadCrumbLabels.lbl_browse_all_deals */.Z.BreadCrumbLabels.lbl_browse_all_deals
}, {
  url: "/shopping/view-order-details",
  title: config_labels/* default.BreadCrumbLabels.lbl_order_details */.Z.BreadCrumbLabels.lbl_order_details
}, {
  url: "/shopping/view-order-history",
  title: config_labels/* default.BreadCrumbLabels.lbl_order_history */.Z.BreadCrumbLabels.lbl_order_history
}, {
  url: "/shopping/deal-details-page/[id]",
  title: config_labels/* default.BreadCrumbLabels.lbl_deal_details */.Z.BreadCrumbLabels.lbl_deal_details
}, {
  url: "/shopping/deal-selection",
  title: config_labels/* default.lbl_select_deal */.Z.lbl_select_deal
}];
/* harmony default export */ var config_routes = (RouteLinks);
// EXTERNAL MODULE: ./components/atoms/DependencyHelper.js + 81 modules
var DependencyHelper = __webpack_require__(28658);
// EXTERNAL MODULE: ./utils/ajaxServices.js + 6 modules
var ajaxServices = __webpack_require__(18517);
// EXTERNAL MODULE: ./config/queries.js
var queries = __webpack_require__(91250);
// EXTERNAL MODULE: ./utils/logger.js
var logger = __webpack_require__(21534);
;// CONCATENATED MODULE: ./utils/helperServices.js





var _this = undefined;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















var config = __webpack_require__(26125);

var env = config.env;
var server = config.envConfigs[env].server;
var configUrl = "".concat(server);
var imagePrefix = config.envConfigs[env].imagePrefix;
var urlPrefix = config.envConfigs[env].shoppingUrlPrefix;
var countryCode = "27";
var cartUpdateEvent = function cartUpdateEvent() {
  if (typeof refreshMenuState === "function") {
    // eslint-disable-next-line no-undef
    refreshMenuState();
  }
}; // TODO: Redundant. Please replace all uses with redux SET_IS_LOADING

var showSpinner = function showSpinner() {
  document.body.classList.add("no-scroll");
  var element = document.getElementById("loaderMain");

  if (element) {
    element.classList.add("showspin");
  }
}; // TODO: Redundant. Please replace all uses with redux SET_IS_LOADING

var hideSpinner = function hideSpinner() {
  document.body.classList.remove("no-scroll");
  var element = document.getElementById("loaderMain");

  if (element) {
    element.classList.remove("showspin");
  }
};
var valOrNull = function valOrNull(val) {
  return val || null;
};
var isDefined = function isDefined(variable) {
  return typeof variable !== "undefined";
};
var getSessionStorage = function getSessionStorage(key) {
  return isDefined(sessionStorage) && sessionStorage.getItem(key) ? JSON.parse(sessionStorage.getItem(key)) : null;
};
var updateSessionStorage = function updateSessionStorage(key, value) {
  var notStringify = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return isDefined(sessionStorage) && sessionStorage.setItem(key, notStringify ? JSON.stringify(value) : value);
};
var deleteSessionStorage = function deleteSessionStorage(key) {
  return isDefined(sessionStorage) && sessionStorage.removeItem(key);
};
var getCookieValue = function getCookieValue(value) {
  var cartCookie;
  cartCookie = DependencyHelper.Cookie.get("".concat(value));

  if (cartCookie) {
    return cartCookie;
  }
};
var getProfileData = function getProfileData() {
  var profileData = getSessionStorage("profile_data");

  if (profileData) {
    var _profileData, _profileData$result, _profileData$result$p;

    profileData = JSON.parse(profileData);
    profileData = (_profileData = profileData) === null || _profileData === void 0 ? void 0 : (_profileData$result = _profileData.result) === null || _profileData$result === void 0 ? void 0 : (_profileData$result$p = _profileData$result.profileSubscriptionResponse) === null || _profileData$result$p === void 0 ? void 0 : _profileData$result$p.profile;

    if (profileData.profileId) {
      return profileData;
    } else {
      return null;
    }
  } else {
    return null;
  }
};
var handleCartActionFailure = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(errorCode) {
    var cartAction,
        loggedInAction,
        JWTtoken,
        authtoken,
        _errorCode$errors,
        _errorCode$errors$,
        _errorCode$errors2,
        _errorCode$errors2$,
        cartId,
        emptyCartForGuest,
        newCartId,
        _args = arguments;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cartAction = _args.length > 1 && _args[1] !== undefined ? _args[1] : function () {};
            loggedInAction = _args.length > 2 && _args[2] !== undefined ? _args[2] : function () {};
            JWTtoken = getCookieValue("vod-web-auth-token");
            authtoken = getCookieValue("auth_token");

            if (!JWTtoken) {
              _context.next = 21;
              break;
            }

            if (!(errorCode !== null && errorCode !== void 0 && (_errorCode$errors = errorCode.errors) !== null && _errorCode$errors !== void 0 && (_errorCode$errors$ = _errorCode$errors[0]) !== null && _errorCode$errors$ !== void 0 && _errorCode$errors$.message.includes(config_labels/* default.lbl_current_user_cannot_perform_operation_on_cart */.Z.lbl_current_user_cannot_perform_operation_on_cart))) {
              _context.next = 9;
              break;
            }

            loggedInAction();
            _context.next = 19;
            break;

          case 9:
            if (!(errorCode !== null && errorCode !== void 0 && (_errorCode$errors2 = errorCode.errors) !== null && _errorCode$errors2 !== void 0 && (_errorCode$errors2$ = _errorCode$errors2[0]) !== null && _errorCode$errors2$ !== void 0 && _errorCode$errors2$.message.includes(config_labels/* default.lbl_could_not_find_cart_id */.Z.lbl_could_not_find_cart_id))) {
              _context.next = 19;
              break;
            }

            DependencyHelper.Cookie.remove("cart_id");

            if (!authtoken) {
              _context.next = 18;
              break;
            }

            _context.next = 14;
            return getCustomerActiveCartService();

          case 14:
            cartId = _context.sent;

            if (cartId && !cartId.fail && cartId.length) {
              setCookieConsentWrapper("cart_id", [config.cookie_category.strictly_necessary], "document.cookie='cart_id=".concat(cartId, ";path=/'"));
              cartAction();
            } else {
              loggedInAction();
            }

            _context.next = 19;
            break;

          case 18:
            loggedInAction();

          case 19:
            _context.next = 28;
            break;

          case 21:
            //guestUser
            DependencyHelper.Cookie.remove("cart_id");
            DependencyHelper.Cookie.remove("auth_token");
            _context.next = 25;
            return ajaxServices/* default.fetchGraphQLPOSTRequest */.Z.fetchGraphQLPOSTRequest(queries/* guestCreateEmptyCart */.qZ);

          case 25:
            emptyCartForGuest = _context.sent;
            newCartId = emptyCartForGuest === null || emptyCartForGuest === void 0 ? void 0 : emptyCartForGuest.createEmptyCart;

            if (newCartId) {
              updateCartExpiry(newCartId);
              cartAction();
            }

          case 28:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function handleCartActionFailure(_x) {
    return _ref.apply(this, arguments);
  };
}();
var getCustomerActiveCartService = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
    var result, activeCartId;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return ajaxServices/* default.fetchGraphQLPOSTRequest */.Z.fetchGraphQLPOSTRequest(queries/* getCustomerActiveCart */.T$);

          case 3:
            result = _context2.sent;

            if (result && result.customerCart && result.customerCart.id) {
              activeCartId = result.customerCart.id;
            } else {
              activeCartId = "";
            }

            return _context2.abrupt("return", activeCartId);

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", {
              fail: true,
              error: _context2.t0
            });

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 8]]);
  }));

  return function getCustomerActiveCartService() {
    return _ref2.apply(this, arguments);
  };
}();
var getAuthToken = function getAuthToken(dataResult) {
  var _dataResult$payload, _dataResult$payload$r, _dataResult$payload$r2, _dataResult$payload$r3;

  var oAuthToken = dataResult === null || dataResult === void 0 ? void 0 : (_dataResult$payload = dataResult.payload) === null || _dataResult$payload === void 0 ? void 0 : (_dataResult$payload$r = _dataResult$payload.result) === null || _dataResult$payload$r === void 0 ? void 0 : (_dataResult$payload$r2 = _dataResult$payload$r.magentoProfileResponse[0]) === null || _dataResult$payload$r2 === void 0 ? void 0 : (_dataResult$payload$r3 = _dataResult$payload$r2.OAuthTokenDetails[0]) === null || _dataResult$payload$r3 === void 0 ? void 0 : _dataResult$payload$r3.OAuthToken;
  setCookieConsentWrapper("auth_token", [config.cookie_category.strictly_necessary], "document.cookie='auth_token=".concat(oAuthToken, ";path=/'"));
  return oAuthToken;
};
var logOutUser = function logOutUser() {
  Cookie.remove("vod-web-auth-token", {
    path: "/",
    domain: ".vodacom.co.za"
  });
  Cookie.remove("cart_id");
  Cookie.remove("auth_token");
  Cookie.remove("guest_checkout");
};
var removeCartId = function removeCartId() {
  Cookie.remove("cart_id");
};
var clearUserToken = function clearUserToken() {
  DependencyHelper.Cookie.remove("vod-web-auth-token", {
    path: "/",
    domain: ".vodacom.co.za"
  });
  DependencyHelper.Cookie.remove("auth_token");
  DependencyHelper.Cookie.remove("cart_id");
};
var isGuestCheckout = function isGuestCheckout() {
  var guestCookie = getCookieValue("guest_checkout");
  return guestCookie ? true : false;
};
var setGuestCheckout = function setGuestCheckout() {
  var guestCookie = getCookieValue("guest_checkout");

  if (guestCookie === undefined) {
    setCookieConsentWrapper("guest_checkout", [config.cookie_category.strictly_necessary], "document.cookie='guest_checkout=".concat(true, ";path=/'"));
  }
};
var updateCartExpiry = function updateCartExpiry(cartIdentifier) {
  var persistTime = getCookieValue("persist_time");
  var authtoken = getCookieValue("auth_token");
  var cartId = cartIdentifier ? cartIdentifier : getCookieValue("cart_id");
  var expiryTime = parseInt(persistTime) / 3600 / 24;

  if (!authtoken && cartId) {
    setCookieConsentWrapper("cart_id", [config.cookie_category.strictly_necessary], "document.cookie='cart_id=".concat(cartId, "; expires=").concat(expiryTime, ";path=/'"));
  }
};
var componentResize = function componentResize() {
  var _useState = (0,react.useState)(false),
      isMobile = _useState[0],
      setIsMobile = _useState[1];

  var checkSize = false;
  (0,react.useEffect)(function () {
    if (true) {
      if (!checkSize) {
        updateWidthAndHeight();
        checkSize = true;
      }

      window.addEventListener("resize", updateWidthAndHeight);
      return function () {
        return window.removeEventListener("resize", updateWidthAndHeight);
      };
    }
  }, []);

  var updateWidthAndHeight = function updateWidthAndHeight() {
    if (window.outerWidth <= constants/* MOBILE_WIDTH */.P_) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  return isMobile;
};
var getNestedObjectValue = function getNestedObjectValue(nestedObj, pathArr) {
  return pathArr.reduce(function (obj, key) {
    return obj && obj[key] !== "undefined" ? obj[key] : null;
  }, nestedObj);
};
var createMarkup = function createMarkup(htmlString) {
  return {
    __html: htmlString
  };
};
var roundUptwoDecimal = function roundUptwoDecimal(val) {
  return val.toFixed(2);
};
var equalsIgnoreCase = function equalsIgnoreCase(string, compareString) {
  return string.toUpperCase() === compareString.toUpperCase();
};
var capitalizeString = function capitalizeString(text) {
  return text.toLowerCase().split(" ").map(function (string) {
    return string.charAt(0).toUpperCase() + string.substring(1);
  }).join(" ");
};
var getBadgeName = function getBadgeName(value) {
  var _value;

  value = (_value = value) === null || _value === void 0 ? void 0 : _value.toString().toLowerCase();

  var _badges = Object.keys(config_badges);

  if (_badges.indexOf("".concat(value)) >= 0) return config_badges["".concat(value)];else return "".concat(value);
};
var getTagName = function getTagName(value) {
  var _value2, _value2$match;

  value = (_value2 = value) === null || _value2 === void 0 ? void 0 : (_value2$match = _value2.match(/[^ ,]+/g)) === null || _value2$match === void 0 ? void 0 : _value2$match.join("-");
  return value;
};
var numberFormat = function numberFormat(value) {
  return new Intl.NumberFormat("en-IN").format(value);
};
var numberToLocaleString = function numberToLocaleString(value) {
  return parseInt(value).toLocaleString();
};
var checkIsLowStock = function checkIsLowStock(item) {
  if ((item === null || item === void 0 ? void 0 : item.quantity) === null) {
    return false;
  }

  return (item === null || item === void 0 ? void 0 : item.quantity) < (item === null || item === void 0 ? void 0 : item.low_stock_threshold);
};
var checkDealOutOfStock = function checkDealOutOfStock(item) {
  if ((item === null || item === void 0 ? void 0 : item.__typename) === config_labels/* default.lbl_product_type_bundle */.Z.lbl_product_type_bundle) {
    if ((item === null || item === void 0 ? void 0 : item.stock_status) === config_labels/* default.lbl_out_of_stock */.Z.lbl_out_of_stock) {
      return true;
    }

    for (var i = 0; i < (item === null || item === void 0 ? void 0 : (_item$items = item.items) === null || _item$items === void 0 ? void 0 : _item$items.length); i++) {
      var _item$items;

      var itemOption = item.items[i];

      for (var j = 0; j < (itemOption === null || itemOption === void 0 ? void 0 : (_itemOption$options = itemOption.options) === null || _itemOption$options === void 0 ? void 0 : _itemOption$options.length); j++) {
        var _itemOption$options, _option$product, _option$product2, _option$product3;

        var option = itemOption === null || itemOption === void 0 ? void 0 : itemOption.options[j];

        if ((option === null || option === void 0 ? void 0 : (_option$product = option.product) === null || _option$product === void 0 ? void 0 : _option$product.quantity) !== null && (option === null || option === void 0 ? void 0 : (_option$product2 = option.product) === null || _option$product2 === void 0 ? void 0 : _option$product2.quantity) <= 0 && (option === null || option === void 0 ? void 0 : (_option$product3 = option.product) === null || _option$product3 === void 0 ? void 0 : _option$product3.stock_status) === config_labels/* default.lbl_out_of_stock */.Z.lbl_out_of_stock) {
          return true;
        }
      }
    }

    return false;
  }

  return false;
};
var checkStockQuantity = function checkStockQuantity(item) {
  switch (item === null || item === void 0 ? void 0 : item.__typename) {
    case config_labels/* default.lbl_product_type_bundle */.Z.lbl_product_type_bundle:
      {
        for (var i = 0; i < (item === null || item === void 0 ? void 0 : (_item$items2 = item.items) === null || _item$items2 === void 0 ? void 0 : _item$items2.length); i++) {
          var _item$items2;

          var itemOption = item.items[i];

          for (var j = 0; j < (itemOption === null || itemOption === void 0 ? void 0 : (_itemOption$options2 = itemOption.options) === null || _itemOption$options2 === void 0 ? void 0 : _itemOption$options2.length); j++) {
            var _itemOption$options2;

            if (itemOption !== null && itemOption !== void 0 && itemOption.options[j].is_default) {
              var _itemOption$options$j;

              var option = itemOption === null || itemOption === void 0 ? void 0 : (_itemOption$options$j = itemOption.options[j].product) === null || _itemOption$options$j === void 0 ? void 0 : _itemOption$options$j.variants;

              for (var k = 0; k < option.length; k++) {
                var _option$product4, _option$product5;

                if ((option === null || option === void 0 ? void 0 : (_option$product4 = option.product) === null || _option$product4 === void 0 ? void 0 : _option$product4.quantity) !== null && (option === null || option === void 0 ? void 0 : (_option$product5 = option.product) === null || _option$product5 === void 0 ? void 0 : _option$product5.quantity) <= 0) {
                  return true;
                }
              }
            } else {
              var _option$product6, _option$product7;

              var _option = itemOption === null || itemOption === void 0 ? void 0 : itemOption.options[j];

              if ((_option === null || _option === void 0 ? void 0 : (_option$product6 = _option.product) === null || _option$product6 === void 0 ? void 0 : _option$product6.quantity) !== null && (_option === null || _option === void 0 ? void 0 : (_option$product7 = _option.product) === null || _option$product7 === void 0 ? void 0 : _option$product7.quantity) <= 0) {
                return true;
              }
            }
          }
        }

        return false;
      }

    case config_labels/* default.lbl_product_typeName_simple */.Z.lbl_product_typeName_simple:
      {
        return (item === null || item === void 0 ? void 0 : item.quantity) !== null && (item === null || item === void 0 ? void 0 : item.quantity) <= 0;
      }

    case config_labels/* default.lbl_product_typeName_configurable */.Z.lbl_product_typeName_configurable:
      {
        var flag = item.variants && item.variants.length > 0 && item.variants.every(function (variant) {
          var _variant$product, _variant$product2, _variant$product3;

          return (variant === null || variant === void 0 ? void 0 : (_variant$product = variant.product) === null || _variant$product === void 0 ? void 0 : _variant$product.stock_status) === config_labels/* default.lbl_out_of_stock */.Z.lbl_out_of_stock || (variant === null || variant === void 0 ? void 0 : (_variant$product2 = variant.product) === null || _variant$product2 === void 0 ? void 0 : _variant$product2.quantity) !== null && (variant === null || variant === void 0 ? void 0 : (_variant$product3 = variant.product) === null || _variant$product3 === void 0 ? void 0 : _variant$product3.quantity) <= 0;
        });
        return flag;
      }

    default:
      return false;
  }
};
var checkIsOutOfStock = function checkIsOutOfStock(cartItem) {
  var item = (cartItem === null || cartItem === void 0 ? void 0 : cartItem.product) || cartItem;
  var selectedVariant = cartItem === null || cartItem === void 0 ? void 0 : cartItem.configurable_options;

  if ((item === null || item === void 0 ? void 0 : item.__typename) === config_labels/* default.lbl_product_type_bundle */.Z.lbl_product_type_bundle && (item === null || item === void 0 ? void 0 : item.stock_status) === config_labels/* default.lbl_out_of_stock */.Z.lbl_out_of_stock) {
    return true;
  } else if ((item === null || item === void 0 ? void 0 : item.__typename) === config_labels/* default.lbl_product_typeName_simple */.Z.lbl_product_typeName_simple) {
    return item && item.stock_status && item.stock_status === config_labels/* default.lbl_out_of_stock */.Z.lbl_out_of_stock || (item === null || item === void 0 ? void 0 : item.quantity) === 0;
  } else if ((item === null || item === void 0 ? void 0 : item.__typename) === config_labels/* default.lbl_product_typeName_configurable */.Z.lbl_product_typeName_configurable) {
    var flag = checkEachVariantStock(selectedVariant, item);
    return flag;
  } else {
    return false;
  }
};

var checkEachVariantStock = function checkEachVariantStock(configurableOptions, item) {
  try {
    var selectedConfigurableOptions = configurableOptions.map(function (selectedItem) {
      return selectedItem.value_id;
    });

    var _getSelectedVariant = item.variants.map(function (variantItem) {
      var selectedVariant = variantItem.attributes.filter(function (vItem) {
        return selectedConfigurableOptions.some(function (sItem) {
          return sItem === vItem.value_index;
        });
      });

      if (selectedVariant.length === selectedConfigurableOptions.length) {
        return variantItem;
      }
    });

    _getSelectedVariant = _getSelectedVariant.filter(function (item) {
      return item !== undefined;
    });

    if (_getSelectedVariant.length) {
      return _getSelectedVariant.every(function (variant) {
        if (variant) {
          var _variant$product4, _variant$product5;

          return (variant === null || variant === void 0 ? void 0 : (_variant$product4 = variant.product) === null || _variant$product4 === void 0 ? void 0 : _variant$product4.stock_status) === config_labels/* default.lbl_out_of_stock */.Z.lbl_out_of_stock || (variant === null || variant === void 0 ? void 0 : (_variant$product5 = variant.product) === null || _variant$product5 === void 0 ? void 0 : _variant$product5.quantity) <= 0;
        }
      });
    }
  } catch (error) {
    return false;
  }

  return false;
};

var getColorSelectionIds = function getColorSelectionIds(bundleCustomisableOption) {
  if (!Array.isArray(bundleCustomisableOption)) {
    return [];
  }

  var colorSelections = bundleCustomisableOption.reduce(function (acc, option) {
    var selectedAttr = isValidJSON(option.selected_attribute) ? JSON.parse(option.selected_attribute) : null;
    var attrIds = (selectedAttr === null || selectedAttr === void 0 ? void 0 : selectedAttr.value.indexOf(',')) > 0 ? selectedAttr === null || selectedAttr === void 0 ? void 0 : selectedAttr.value.split(",") : [selectedAttr === null || selectedAttr === void 0 ? void 0 : selectedAttr.value];
    var optionsFormatted = attrIds.map(function (attrId) {
      return {
        attributeId: selectedAttr === null || selectedAttr === void 0 ? void 0 : selectedAttr.name,
        productOptionId: option === null || option === void 0 ? void 0 : option.attribute_option_id,
        colorId: attrId
      };
    });
    return [].concat((0,toConsumableArray/* default */.Z)(acc), (0,toConsumableArray/* default */.Z)(optionsFormatted));
  }, []);
  return colorSelections;
};

var extractColorSelections = function extractColorSelections(dealDetailsItem) {
  if (!(dealDetailsItem !== null && dealDetailsItem !== void 0 && dealDetailsItem.bundle_customisable_option)) {
    return {};
  }

  var products = (0,dealDetails/* extractProductList */.T9)(dealDetailsItem === null || dealDetailsItem === void 0 ? void 0 : dealDetailsItem.product);
  var isDoubleDeal = (0,dealDetails/* isDoubleDealDevice */.np)(products);
  var colorSelections = getColorSelectionIds(dealDetailsItem === null || dealDetailsItem === void 0 ? void 0 : dealDetailsItem.bundle_customisable_option);
  var primaryDevice = products.find(function (product) {
    return product.isPrimary;
  });
  var primaryColorSelectionIndex = colorSelections.findIndex(function (cs) {
    return cs.productOptionId === (primaryDevice === null || primaryDevice === void 0 ? void 0 : primaryDevice.optionId);
  });
  var primaryColorSelection = colorSelections.splice(primaryColorSelectionIndex, 1)[0];
  var colorOptions = (0,dealDetails/* extractDeviceColorOptions */.HR)(primaryDevice);
  var colorSelection = Array.isArray(colorOptions) ? colorOptions.find(function (clo) {
    return clo.id === Number(primaryColorSelection === null || primaryColorSelection === void 0 ? void 0 : primaryColorSelection.colorId);
  }) : null;
  var secondaryDevice = null;
  var colorSelectionSecondary = null;

  if (isDoubleDeal) {
    secondaryDevice = products.find(function (product) {
      return product.isSecondary || product.optionQuantity > 1;
    });
    var secondaryColorSelection = colorSelections.find(function (cs) {
      var _secondaryDevice;

      return cs.productOptionId === ((_secondaryDevice = secondaryDevice) === null || _secondaryDevice === void 0 ? void 0 : _secondaryDevice.optionId);
    });
    var secondaryColorOptions = (0,dealDetails/* extractDeviceColorOptions */.HR)(secondaryDevice);
    colorSelectionSecondary = Array.isArray(secondaryColorOptions) ? secondaryColorOptions.find(function (clo) {
      return clo.id === Number(secondaryColorSelection === null || secondaryColorSelection === void 0 ? void 0 : secondaryColorSelection.colorId);
    }) : null;
  }

  return {
    colorSelection_primary: colorSelection,
    colorSelection_secondary: colorSelectionSecondary,
    isDoubleDeal: isDoubleDeal
  };
};

var checkVarientInStock = function checkVarientInStock(item, selectedVarient) {
  if ((item === null || item === void 0 ? void 0 : item.__typename) === config_labels/* default.lbl_product_type_bundle */.Z.lbl_product_type_bundle) {
    for (var i = 0; i < (item === null || item === void 0 ? void 0 : (_item$items3 = item.items) === null || _item$items3 === void 0 ? void 0 : _item$items3.length); i++) {
      var _item$items3;

      var itemOption = item.items[i];

      for (var j = 0; j < (itemOption === null || itemOption === void 0 ? void 0 : (_itemOption$options3 = itemOption.options) === null || _itemOption$options3 === void 0 ? void 0 : _itemOption$options3.length); j++) {
        var _itemOption$options3;

        if (itemOption !== null && itemOption !== void 0 && itemOption.options[j].is_default) {
          var _itemOption$options$j2, _itemOption$options$j3;

          var option = itemOption !== null && itemOption !== void 0 && (_itemOption$options$j2 = itemOption.options[j].product) !== null && _itemOption$options$j2 !== void 0 && _itemOption$options$j2.variants ? itemOption === null || itemOption === void 0 ? void 0 : (_itemOption$options$j3 = itemOption.options[j].product) === null || _itemOption$options$j3 === void 0 ? void 0 : _itemOption$options$j3.variants : [];

          for (var k = 0; k < (option === null || option === void 0 ? void 0 : option.length); k++) {
            var _option$k, _option$k$attributes$, _option$k2, _option$k2$product, _option$k3, _option$k3$product;

            if (((_option$k = option[k]) === null || _option$k === void 0 ? void 0 : (_option$k$attributes$ = _option$k.attributes[0]) === null || _option$k$attributes$ === void 0 ? void 0 : _option$k$attributes$.value_index) === parseInt(selectedVarient) && ((_option$k2 = option[k]) === null || _option$k2 === void 0 ? void 0 : (_option$k2$product = _option$k2.product) === null || _option$k2$product === void 0 ? void 0 : _option$k2$product.quantity) !== null && ((_option$k3 = option[k]) === null || _option$k3 === void 0 ? void 0 : (_option$k3$product = _option$k3.product) === null || _option$k3$product === void 0 ? void 0 : _option$k3$product.quantity) <= 0) {
              return true;
            }
          }
        }
      }
    }
  }
};
var mapCartProductItems = function mapCartProductItems(cartProductItems) {
  return (cartProductItems || []).filter(function (item) {
    return item && item !== null;
  }).map(function (item) {
    var _item$product, _item$bundle_customis, _item$bundle_customis2, _item$product2, _item$product3, _item$product4;

    var isDealProduct = !!(item !== null && item !== void 0 && (_item$product = item.product) !== null && _item$product !== void 0 && _item$product.is_deal_product);
    var isOutOfStock = isDealProduct ? checkDealOutOfStock(item === null || item === void 0 ? void 0 : item.product) : checkIsOutOfStock(item);
    var selected_attribute = isValidJSON(item === null || item === void 0 ? void 0 : (_item$bundle_customis = item.bundle_customisable_option) === null || _item$bundle_customis === void 0 ? void 0 : _item$bundle_customis.selected_attribute) ? JSON.parse(item === null || item === void 0 ? void 0 : (_item$bundle_customis2 = item.bundle_customisable_option) === null || _item$bundle_customis2 === void 0 ? void 0 : _item$bundle_customis2.selected_attribute) : "";
    var hasBackOrderLabel = checkVarientInStock(item === null || item === void 0 ? void 0 : item.product, selected_attribute.value);

    var _extractColorSelectio = extractColorSelections(item),
        _extractColorSelectio2 = _extractColorSelectio.colorSelection_primary,
        colorSelection_primary = _extractColorSelectio2 === void 0 ? null : _extractColorSelectio2,
        _extractColorSelectio3 = _extractColorSelectio.colorSelection_secondary,
        colorSelection_secondary = _extractColorSelectio3 === void 0 ? null : _extractColorSelectio3,
        _extractColorSelectio4 = _extractColorSelectio.isDoubleDeal,
        isDoubleDeal = _extractColorSelectio4 === void 0 ? false : _extractColorSelectio4;

    var hasPreOrderLabel = (item === null || item === void 0 ? void 0 : (_item$product2 = item.product) === null || _item$product2 === void 0 ? void 0 : _item$product2.promotion_tag_label) === types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER;
    return _objectSpread(_objectSpread({}, item), {}, {
      isDealProduct: isDealProduct,
      isOutOfStock: isOutOfStock,
      isLowStock: checkIsLowStock(item),
      hasBackOrderLabel: isDealProduct && !isOutOfStock && hasBackOrderLabel,
      hasPreOrderLabel: hasPreOrderLabel,
      badgesLabel: item === null || item === void 0 ? void 0 : (_item$product3 = item.product) === null || _item$product3 === void 0 ? void 0 : _item$product3.promotion_tag_label,
      colorSelection: colorSelection_primary,
      colorSelectionSecondary: colorSelection_secondary,
      isDoubleDeal: isDoubleDeal,
      __typename: item === null || item === void 0 ? void 0 : (_item$product4 = item.product) === null || _item$product4 === void 0 ? void 0 : _item$product4.__typename
    });
  });
};

var isOnceOffProductOrder = function isOnceOffProductOrder(item) {
  var _item$product5, _item$product6;

  return ((item === null || item === void 0 ? void 0 : (_item$product5 = item.product) === null || _item$product5 === void 0 ? void 0 : _item$product5.is_deal_product) === 0 || !(item !== null && item !== void 0 && (_item$product6 = item.product) !== null && _item$product6 !== void 0 && _item$product6.is_deal_product)) && (!(item !== null && item !== void 0 && item.parent_product_sku) || (item === null || item === void 0 ? void 0 : item.parent_product_sku) === "" || (item === null || item === void 0 ? void 0 : item.parent_product_sku) === null);
};

var validateOrderItems = function validateOrderItems(items) {
  var orders = items || [];
  var resp = {
    isMulti: false,
    onceOff: orders.some(function (i) {
      return !(i !== null && i !== void 0 && i.isDealProduct) && isOnceOffProductOrder(i);
    }),
    onceOffMissed: orders.some(function (i) {
      return !(i !== null && i !== void 0 && i.isDealProduct) && (i === null || i === void 0 ? void 0 : i.isOutOfStock);
    }),
    contract: orders.some(function (i) {
      return i === null || i === void 0 ? void 0 : i.isDealProduct;
    }),
    contractMissed: orders.some(function (i) {
      return (i === null || i === void 0 ? void 0 : i.isDealProduct) && (i === null || i === void 0 ? void 0 : i.isOutOfStock);
    }),
    hasPreOrder: orders.some(function (i) {
      return i === null || i === void 0 ? void 0 : i.hasPreOrderLabel;
    }),
    hasBackOrder: orders.some(function (i) {
      return i === null || i === void 0 ? void 0 : i.hasBackOrderLabel;
    })
  };

  if (resp.contract && resp.onceOff) {
    resp.isMulti = true;
  }

  return resp;
};
var splitCartItems = function splitCartItems(cartItems) {
  return {
    dealCartProducts: cartItems.filter(function (item) {
      var _item$product7;

      return (item === null || item === void 0 ? void 0 : (_item$product7 = item.product) === null || _item$product7 === void 0 ? void 0 : _item$product7.is_deal_product) === 1;
    }),
    onceOffCartProducts: cartItems.filter(isOnceOffProductOrder)
  };
};
var checkIsFinalPriceReq = function checkIsFinalPriceReq(item) {
  return item && item.price_range && item.price_range.minimum_price && item.price_range.minimum_price.discount && item.price_range.minimum_price.discount.amount_off && item.price_range.minimum_price.discount.amount_off !== "0" ? true : false;
};
var getRegularPrice = function getRegularPrice(item) {
  return item && item.price_range && item.price_range.minimum_price && item.price_range.minimum_price.regular_price && item.price_range.minimum_price.regular_price.value ? item.price_range.minimum_price.regular_price.value : "0";
};
var getFinalPrice = function getFinalPrice(item) {
  return item && item.price_range && item.price_range.minimum_price && item.price_range.minimum_price.final_price && item.price_range.minimum_price.final_price.value ? item.price_range.minimum_price.final_price.value : "0";
};
var getPercentOffValue = function getPercentOffValue(item) {
  return item && item.price_range && item.price_range.minimum_price && item.price_range.minimum_price.discount && item.price_range.minimum_price.discount.percent_off ? item.price_range.minimum_price.discount.percent_off : "0";
};
var getAmountOffValue = function getAmountOffValue(item) {
  return item && item.price_range && item.price_range.minimum_price && item.price_range.minimum_price.discount && item.price_range.minimum_price.discount.amount_off ? item.price_range.minimum_price.discount.amount_off : "0";
};
var checkDomain = function checkDomain(url) {
  if (url.indexOf("//") === 0) {
    var _location;

    url = ((_location = location) === null || _location === void 0 ? void 0 : _location.protocol) + url;
  }

  return url.toLowerCase().replace(/([a-z])?:\/\//, "$1").split("/")[0];
};
var isExternalUrl = function isExternalUrl(url) {
  var _location2;

  return url.indexOf(":") > -1 && url.indexOf("//") > -1 && checkDomain((_location2 = location) === null || _location2 === void 0 ? void 0 : _location2.href) !== checkDomain(url);
};
var goToUrl = function goToUrl(url, router) {
  var newTab = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

  if (newTab && newTab === "1") {
    if (true) {
      window.open(url, "_blank");
    }
  } else if (isExternalUrl(url)) {
    window.open(url, "_blank");
  } else {
    var _location3;

    showSpinner();

    if (checkDomain((_location3 = location) === null || _location3 === void 0 ? void 0 : _location3.href) == checkDomain(url)) {
      var _window$location;

      var newURL = url.split((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.host)[1];
      router.push(newURL).then(function () {
        window.scrollTo(0, 0);
        hideSpinner();
      });
    } else {
      router.push(url).then(function () {
        window.scrollTo(0, 0);
        hideSpinner();
      });
    }
  }
};
var getUrlPath = function getUrlPath(url) {
  return isExternalUrl(url) ? url : new URL(url).pathname;
};
var internalUrl = function internalUrl(url) {
  if (url && url.includes("internal:")) {
    if (url.includes("internal:/shopping")) {
      return {
        url: url.split("internal:")[1],
        internal: true
      };
    } else {
      try {
        var host = configUrl.split("/shopping")[0];
        var newUrl = "".concat(host).concat(url.split("internal:")[1]);
        return {
          url: newUrl,
          internal: false
        };
      } catch (e) {
        logger/* Logger.error */.Y.error(e);
        console.log("error", e);
      }
    }
  }

  return {
    url: url,
    internal: false
  };
};
var isDiscountTimerApplicable = function isDiscountTimerApplicable(promotion) {
  if (promotion && promotion.start_date && promotion.start_date !== "") return (new Date(promotion.start_date.replace(" ", "T")) <= new Date() || new Date(promotion.start_date.replace(/-/g, "/")) <= new Date()) && (new Date(promotion.end_date.replace(" ", "T")) >= new Date() || new Date(promotion.end_date.replace(/-/g, "/")) >= new Date());
  return false;
};
var replaceValue = function replaceValue(str, search, replace) {
  str = str.replace(search, replace);
  return str;
};
var setRoutes = function setRoutes(value) {
  return isDefined(sessionStorage) && updateSessionStorage("routes", value);
};
var dynamicBreadCrumb = function dynamicBreadCrumb() {
  var _useState2 = (0,react.useState)(null),
      pageHistory = _useState2[0],
      setPageHistory = _useState2[1];

  (0,react.useEffect)(function () {
    setPageHistory(getSessionStorage(config_labels/* default.Session_Keys.lbl_breadCrumb */.Z.Session_Keys.lbl_breadCrumb));
  }, [pageHistory === null || pageHistory === void 0 ? void 0 : pageHistory.prevPageName]);
  return formatBreadCrumbAsList(pageHistory === null || pageHistory === void 0 ? void 0 : pageHistory.history, pageHistory === null || pageHistory === void 0 ? void 0 : pageHistory.routes);
};
var formatBreadCrumbAsList = function formatBreadCrumbAsList(crumb) {
  var list = {};
  var breadCrumbArr = [];
  crumb && crumb.forEach(function (page) {
    var _page$pathname;

    var pagePathName = (page === null || page === void 0 ? void 0 : page.pathname) === "/" ? page.pathname : "/shopping" + (page === null || page === void 0 ? void 0 : (_page$pathname = page.pathname) === null || _page$pathname === void 0 ? void 0 : _page$pathname.split("/shopping")[1]);
    var pageLink = page.pathname.includes("shopping/products") ? getSessionStorage(config_labels/* default.Session_Keys.lbl_list_page_router_with_filters */.Z.Session_Keys.lbl_list_page_router_with_filters) : page.asPath;
    var matchedRoute = config_routes.filter(function (route) {
      return pagePathName == route.url;
    });

    if (matchedRoute.length) {
      list[page.replaceTitle ? page.replaceTitle : matchedRoute[0].title] = {
        url: pageLink
      };
    } else {
      var routes = getSessionStorage("routes");

      if (routes !== null && routes !== void 0 && routes.length) {
        var _matchedRoute = routes.filter(function (route) {
          return pagePathName == route.url;
        });

        if (_matchedRoute.length) {
          list[page.replaceTitle ? page.replaceTitle : _matchedRoute[0].title] = {
            url: pageLink
          };
        }
      }
    }

    breadCrumbArr.push(list);
  });
  return list;
};
var formatBreadCrumb = function formatBreadCrumb(crumb) {
  var list = {};
  var breadCrumbArr = [];
  crumb && crumb.forEach(function (page) {
    list[page.label] = {
      url: page.link
    };
    breadCrumbArr.push(list);
  });
  return list;
};
var formatNumbersWithComma = function formatNumbersWithComma(number) {
  return Number(parseFloat(number).toFixed(2)).toLocaleString("en-US", {
    minimumFractionDigits: 2
  });
};
var componentCheckSize = function componentCheckSize() {
  var _useState3 = (0,react.useState)(),
      windowWidth = _useState3[0],
      setWindowWidth = _useState3[1];

  var checkSize = false;
  (0,react.useEffect)(function () {
    if (true) {
      if (!checkSize) {
        updateWidthAndHeight();
        checkSize = true;
      }

      window.addEventListener("resize", updateWidthAndHeight);
      return function () {
        return window.removeEventListener("resize", updateWidthAndHeight);
      };
    }
  }, []);

  var updateWidthAndHeight = function updateWidthAndHeight() {
    setWindowWidth(window.innerWidth);
  };

  return windowWidth;
};
var formatBytes = function formatBytes(a) {
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  if (0 === a) return "0 Bytes";
  var c = 0 > b ? 0 : b,
      d = Math.floor(Math.log(a) / Math.log(1000));
  return parseFloat((a / Math.pow(1000, d)).toFixed(c)) + ["MB", "GB", "TB", "PB", "EB", "ZB", "YB"][d];
};
var getHighlights = function getHighlights(item) {
  var highlights = [{
    id: "1",
    value: "",
    displayUnit: "data",
    unit: "promo_data"
  }, {
    id: "2",
    value: "",
    displayUnit: "voice minutes",
    unit: "minutes_label"
  }, {
    id: "3",
    value: "",
    displayUnit: "airtime",
    unit: "airtime"
  }, {
    id: "4",
    value: "",
    displayUnit: "sms",
    unit: "sms"
  }];
  highlights.forEach(function (highlight) {
    highlight.value = item[highlight.unit];
  });
  var newHighlight = highlights.filter(function (item) {
    if (item.value > 0 || item.value == "Unlimited") {
      return item;
    }
  });
  var dataIndex = newHighlight.findIndex(function (highLight) {
    return highLight.unit === "promo_data";
  });

  if (dataIndex >= 0) {
    newHighlight[dataIndex].value = formatBytes(newHighlight[dataIndex].value);
  }

  var airtimeIndex = newHighlight.findIndex(function (highLight) {
    return highLight.unit === "airtime";
  });

  if (airtimeIndex >= 0) {
    newHighlight[airtimeIndex].value = "R".concat(newHighlight[airtimeIndex].value);
  }

  return newHighlight;
};
var getSpecs = function getSpecs(deviceData) {
  var specTypes = [{
    id: "1",
    value: "",
    displayLabel: "Storage Size",
    label: "internal_storage_label"
  }, {
    id: "2",
    value: "",
    displayLabel: "Colour",
    label: "color_label"
  }, {
    id: "3",
    value: "",
    displayLabel: "Screen Size Pixels",
    label: "screen_size_pixels_label"
  }, {
    id: "4",
    value: "",
    displayLabel: "Battery Capacity",
    label: "battery_capacity_label"
  }, {
    id: "5",
    value: "",
    displayLabel: "Size",
    label: "size_label"
  }];
  specTypes.forEach(function (highlight) {
    highlight.value = deviceData[highlight.label];
  });
  var newHighlight = specTypes.filter(function (item) {
    if (item.value) {
      return item;
    }
  });
  return newHighlight;
};
var requestType = function requestType(api) {
  if (api.method === "GET") {
    return api.apiEndpoint;
  } else {
    return api.requestBody;
  }
};
var getRequestBody = function getRequestBody(api) {
  var requestBody = "";

  if (api.method) {
    requestBody = requestType(api);
  } else {
    requestBody = requestType(api.single);
  }

  return requestBody;
};
var convertToCorrectDateFormat = function convertToCorrectDateFormat(dateTime) {
  if (dateTime) {
    return dateTime.replace(/-/g, "/");
  } else return "";
};
var getdealDatenVariant = function getdealDatenVariant(props) {
  var dealLocked = props.is_deal_locked;
  var dateTime = "";
  var dealVariant = "";
  var isCrntTimeGrtr = 0;
  var deal_go_live_date = convertToCorrectDateFormat(props.deal_go_live_date);
  var deal_end_date = convertToCorrectDateFormat(props.deal_end_date);

  if (deal_go_live_date && new Date() > new Date(deal_go_live_date)) {
    isCrntTimeGrtr = 1;
  }

  if (dealLocked == 1 && deal_go_live_date && isCrntTimeGrtr == 0) {
    dealVariant = "locked";
    dateTime = deal_go_live_date;
  } else if (dealLocked == 0 && deal_go_live_date && deal_end_date == "" && isCrntTimeGrtr == 0) {
    dealVariant = "hidden";
    dateTime = deal_go_live_date;
  } else if (dealLocked === 0 && deal_go_live_date && isCrntTimeGrtr === 0) {
    dealVariant = "comingSoon";
    dateTime = deal_go_live_date;
  } else if (dealLocked == 0 && deal_end_date != "" && isCrntTimeGrtr == 1) {
    if (new Date() > new Date(deal_end_date)) {
      dealVariant = "Expired";
      dateTime = deal_end_date;
    } else {
      dealVariant = "specialDeals";
      dateTime = deal_end_date;
    }
  }

  return [dateTime, dealVariant];
};
var getDealExpiryTime = function getDealExpiryTime(dealEndTime) {
  var deal_expiry = (0,index_es/* calcTimeDelta */.Y6)(dealEndTime);
  return "".concat(deal_expiry === null || deal_expiry === void 0 ? void 0 : deal_expiry.days, "d ").concat(deal_expiry === null || deal_expiry === void 0 ? void 0 : deal_expiry.hours, "h ").concat(deal_expiry === null || deal_expiry === void 0 ? void 0 : deal_expiry.minutes, "m ").concat(deal_expiry === null || deal_expiry === void 0 ? void 0 : deal_expiry.seconds, "s");
};
var getPromotionLabel = function getPromotionLabel(item) {
  if (item !== null && item !== void 0 && item.badges_label) {
    return item.badges_label;
  } else if (item !== null && item !== void 0 && item.promotion_tag_label) {
    return item.promotion_tag_label;
  } else {
    return "";
  }
};
var getPromotionVariant = function getPromotionVariant(item) {
  if (item !== null && item !== void 0 && item.badges_label) {
    return getTagName(item.badges_label);
  } else if (item !== null && item !== void 0 && item.promotion_tag_label && item.promotion_tag_label.length > 1) {
    return getTagName(item.promotion_tag_label);
  } else {
    return "";
  }
};
var getPlanNameLabel = function getPlanNameLabel(item) {
  if (item.items && item.items.length >= 1) {
    var _plan$, _plan$$options;

    var items = item.items;
    var plan = items.filter(function (item) {
      return item.title === "Promo";
    });

    if (plan.length && (_plan$ = plan[0]) !== null && _plan$ !== void 0 && (_plan$$options = _plan$.options) !== null && _plan$$options !== void 0 && _plan$$options.length) {
      var _plan$0$options$0$pro;

      return "on ".concat((_plan$0$options$0$pro = plan[0].options[0].product) === null || _plan$0$options$0$pro === void 0 ? void 0 : _plan$0$options$0$pro.name, " with:");
    } else if (item !== null && item !== void 0 && item.plan_name_label) {
      return "on ".concat(item.plan_name_label, " with:");
    } else {
      return "";
    }
  } else if (item !== null && item !== void 0 && item.plan_name_label) {
    return "on ".concat(item.plan_name_label, " with:");
  } else {
    return "";
  }
};
var getColorHexVal = function getColorHexVal(colorLabel, configOptions) {
  var hexval;
  configOptions === null || configOptions === void 0 ? void 0 : configOptions.filter(function (options) {
    if ((options.label == "Color" || options.attribute_code == "color") && options.values.length) {
      var _matchedColor$swatch_;

      var matchedColor = options.values.find(function (value) {
        var _value$label;

        return (value === null || value === void 0 ? void 0 : (_value$label = value.label) === null || _value$label === void 0 ? void 0 : _value$label.toLowerCase()) == (colorLabel === null || colorLabel === void 0 ? void 0 : colorLabel.toLowerCase());
      });

      if (matchedColor && matchedColor !== null && matchedColor !== void 0 && (_matchedColor$swatch_ = matchedColor.swatch_data) !== null && _matchedColor$swatch_ !== void 0 && _matchedColor$swatch_.value) {
        var _matchedColor$swatch_2;

        hexval = matchedColor === null || matchedColor === void 0 ? void 0 : (_matchedColor$swatch_2 = matchedColor.swatch_data) === null || _matchedColor$swatch_2 === void 0 ? void 0 : _matchedColor$swatch_2.value;
      }
    }
  });
  return hexval;
};
var getCustomDate = function getCustomDate(completeDate) {
  var date = new Date(completeDate.replace(/-/g, "/"));
  var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return date.getDate() + " " + monthNames[date.getMonth()] + " " + date.getFullYear();
};
var getAllInStockMemoryAttributes = function getAllInStockMemoryAttributes(variant, memory) {
  var selectedMemoryVariants = [];

  if (variant !== null && variant !== void 0 && variant.length && memory.length) {
    memory.forEach(function (memory) {
      variant.forEach(function (variant) {
        var _variant$attributes;

        if (variant && variant !== null && variant !== void 0 && (_variant$attributes = variant.attributes) !== null && _variant$attributes !== void 0 && _variant$attributes.length) {
          var _variant$attributes2, _variant$attributes3, _variant$product6;

          var memoryAttr = variant === null || variant === void 0 ? void 0 : (_variant$attributes2 = variant.attributes) === null || _variant$attributes2 === void 0 ? void 0 : _variant$attributes2.filter(function (val) {
            return (val.code == labels.lbl_internal_storage || val.code == labels.lbl_Internal_Storage) && memory.label == val.label;
          });
          var isColorAttrPresent = variant === null || variant === void 0 ? void 0 : (_variant$attributes3 = variant.attributes) === null || _variant$attributes3 === void 0 ? void 0 : _variant$attributes3.filter(function (variant) {
            return variant.code == "color" && variant.label && variant.label !== "";
          });

          if (memoryAttr.length && (variant === null || variant === void 0 ? void 0 : (_variant$product6 = variant.product) === null || _variant$product6 === void 0 ? void 0 : _variant$product6.stock_status) === labels.lbl_in_stock && (selectedMemoryVariants.length && selectedMemoryVariants.filter(function (eachMemory) {
            return (eachMemory === null || eachMemory === void 0 ? void 0 : eachMemory.label) === memory.label;
          }).length === 0 || selectedMemoryVariants.length === 0) && isColorAttrPresent.length) {
            selectedMemoryVariants.push(memory);
          }
        }
      });
    });
  }

  return selectedMemoryVariants;
};
var setCookieConsentWrapper = function setCookieConsentWrapper(id) {
  var _document, _document$body;

  var _categories = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var code = arguments.length > 2 ? arguments[2] : undefined;
  var el = document.getElementById(id);

  if (el) {
    el.parentNode.removeChild(el);
  } // const listCategories = _categories.join("-")


  var script = document.createElement("script");
  script.id = id;
  script.type = "text/javascript"; // script.className = `optanon-category-${listCategories}`;

  script.text = code;
  (_document = document) === null || _document === void 0 ? void 0 : (_document$body = _document.body) === null || _document$body === void 0 ? void 0 : _document$body.appendChild(script);
};
var removeCookieConsentWrapper = function removeCookieConsentWrapper(scriptToremove) {
  var allsuspects = document.getElementsByTagName("script");

  for (var i = allsuspects.length; i >= 0; i--) {
    if (allsuspects[i] && allsuspects[i].getAttribute("src") !== null && allsuspects[i].getAttribute("text").indexOf("".concat(scriptToremove)) !== -1) {
      allsuspects[i].parentNode.removeChild(allsuspects[i]);
    }
  }
};
var useCookieConsentWrapper = function useCookieConsentWrapper() {
  var categories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var code = arguments.length > 1 ? arguments[1] : undefined;
  var listCategories = categories.join("-");
  useEffect(function () {
    var _document2, _document2$body;

    var script = document.createElement("script");
    script.type = "text/plain";
    script.className = "optanon-category-".concat(listCategories);
    script.text = code;
    (_document2 = document) === null || _document2 === void 0 ? void 0 : (_document2$body = _document2.body) === null || _document2$body === void 0 ? void 0 : _document2$body.appendChild(script);
    return function () {
      var _document3, _document3$body;

      (_document3 = document) === null || _document3 === void 0 ? void 0 : (_document3$body = _document3.body) === null || _document3$body === void 0 ? void 0 : _document3$body.removeChild(script);
    };
  }, []);
};
var getTrackingUrl = function getTrackingUrl(trackingId, orderId) {
  var orderParam = orderId ? "/".concat(orderId) : "";
  return "".concat(urlPrefix, "/").concat(types/* default.TRACK_MY_ORDER_PAGE */.Z.TRACK_MY_ORDER_PAGE, "/").concat(trackingId).concat(orderParam);
};
var getOrderDetailUrl = function getOrderDetailUrl(orderId) {
  return "".concat(urlPrefix, "/").concat(types/* default.ORDER_DETAILS_PAGE */.Z.ORDER_DETAILS_PAGE, "/").concat(orderId);
};
var getDealsGridUrl = function getDealsGridUrl() {
  return "".concat(urlPrefix, "/").concat(types/* default.DEAL_GRID_PAGE */.Z.DEAL_GRID_PAGE);
};
var getOrderTypeAndLabel = function getOrderTypeAndLabel(statusCode) {
  var orderStatusLabel = "";

  switch ((statusCode || "").toString().toUpperCase()) {
    case "CREATE_MAGENTO_SUCCESS":
    case "EPPIX_CREATE_TEMP_FAIL":
    case "CREATE_EPPIX_SUCCESS":
    case "CREATE_SUBMITTED_FAIL":
    case "CREATE_SUBMIT_SUCCESS":
    case "ZERO_VALUE_ORDER":
    case "PAYMENT_INIT_SUCCESS":
    case "PAYMENT_COMPLETE_SUCCESS":
    case "CQFD_SUBMIT_TEMP_FAIL":
    case "CQFD_SUBMIT_SUCCESS":
    case "CREATE_L500_FAILED":
    case "CREATE_L500_SUCCESS":
    case "UPDATE_L500_FAILED":
    case "UPDATE_L500_SUCCESS":
    case "UPDATE_EPPIX_FAILED":
    case "UPDATE_EPPIX_SUCCESS":
    case "PROCESSING":
    case "PENDING":
      orderStatusLabel = config_labels/* default.order_status_labels.lbl_processing */.Z.order_status_labels.lbl_processing;
      break;

    case "CREATE_EPPIX_FAILED":
    case "EPPIX_CREATE_FAIL":
    case "FORM_ENCRYPTION_FAILED":
    case "PAYMENT_INIT_FAILED":
    case "CQFD_SUBMIT_FAIL":
    case "MULTI_PAYMENT_SETTLE_FAILED":
    case "PAYMENT_SETTLED_FAILED":
      orderStatusLabel = config_labels/* default.order_status_labels.lbl_order_error */.Z.order_status_labels.lbl_order_error;
      break;

    case "PAYMENT_COMPLETE_FAILED":
      orderStatusLabel = config_labels/* default.order_status_labels.lbl_payment_failed */.Z.order_status_labels.lbl_payment_failed;
      break;

    case "ORDER_COMPLETE_SUCCESS":
      orderStatusLabel = config_labels/* default.order_status_labels.lbl_processed */.Z.order_status_labels.lbl_processed;
      break;

    case "PAYMENT_SETTLED_SUCCESS":
      orderStatusLabel = config_labels/* default.order_status_labels.lbl_paid */.Z.order_status_labels.lbl_paid;
      break;

    case "CANCELED":
    case "PENDING ORDER COUNTDOWN ELAPSED":
      orderStatusLabel = config_labels/* default.order_status_labels.lbl_cancelled */.Z.order_status_labels.lbl_cancelled;
      break;
  }

  return {
    productOrderState: statusCode,
    orderStatusLabel: orderStatusLabel
  };
};
var orderPageButtons = function orderPageButtons(statusCode) {
  var _getOrderTypeAndLabel = getOrderTypeAndLabel(statusCode),
      orderStatusLabel = _getOrderTypeAndLabel.orderStatusLabel;

  var displayTrackOrderBtn = false;
  var displayRetryOrderBtn = false;

  if ([config_labels/* default.order_status_labels.lbl_paid */.Z.order_status_labels.lbl_paid, config_labels/* default.order_status_labels.lbl_processing */.Z.order_status_labels.lbl_processing, config_labels/* default.order_status_labels.lbl_processed */.Z.order_status_labels.lbl_processed].indexOf(orderStatusLabel) !== -1) {
    displayTrackOrderBtn = true;
  }

  switch (statusCode) {
    case "CREATE_EPPIX_FAILED":
    case "FORM_ENCRYPTION_FAILED":
    case "PAYMENT_INIT_FAILED":
    case "PAYMENT_COMPLETE_FAILED":
      displayRetryOrderBtn = true;
      break;
  }

  return {
    displayTrackOrderBtn: displayTrackOrderBtn,
    displayRetryOrderBtn: displayRetryOrderBtn
  };
};
var getOrderBlurb = function getOrderBlurb(statusCode) {
  switch (statusCode) {
    case "CREATE_EPPIX_FAILED":
    case "FORM_ENCRYPTION_FAILED":
    case "PAYMENT_INIT_FAILED":
      return config_labels/* default.order_blurb_labels.lbl_will_be_cancelled */.Z.order_blurb_labels.lbl_will_be_cancelled;

    case "PAYMENT_COMPLETE_FAILED":
      return config_labels/* default.order_blurb_labels.lbl_retry_order */.Z.order_blurb_labels.lbl_retry_order;

    case "CQFD_SUBMIT_FAIL":
      return config_labels/* default.order_blurb_labels.lbl_consultant_touch */.Z.order_blurb_labels.lbl_consultant_touch;

    case "MULTI_PAYMENT_SETTLE_FAILED":
    case "PAYMENT_SETTLED_FAILED":
      return config_labels/* default.order_blurb_labels.lbl_settlement_failed */.Z.order_blurb_labels.lbl_settlement_failed;

    case "PAYMENT_SETTLED_SUCCESS":
      return config_labels/* default.order_blurb_labels.lbl_payment_received */.Z.order_blurb_labels.lbl_payment_received;
  }

  return "";
};
var getOrderMessage = function getOrderMessage(statusCode) {
  switch (statusCode) {
    case "CREATE_EPPIX_FAILED":
    case "FORM_ENCRYPTION_FAILED":
    case "PAYMENT_INIT_FAILED":
    case "PAYMENT_COMPLETE_FAILED":
      return config_labels/* default.order_messages_labels.lbl_will_be_cancelled */.Z.order_messages_labels.lbl_will_be_cancelled;

    case "CQFD_SUBMIT_FAIL":
      return config_labels/* default.order_messages_labels.lbl_consultant_touch */.Z.order_messages_labels.lbl_consultant_touch;

    case "MULTI_PAYMENT_SETTLE_FAILED":
    case "PAYMENT_SETTLED_FAILED":
      return config_labels/* default.order_messages_labels.lbl_settlement_failed */.Z.order_messages_labels.lbl_settlement_failed;

    case "Pending order countdown elapsed":
      return config_labels/* default.order_messages_labels.lbl_is_cancelled */.Z.order_messages_labels.lbl_is_cancelled;
  }

  return "";
};
var getOrderCreated = function getOrderCreated(statusCode) {
  var status = false;

  switch (statusCode) {
    case "CREATE_MAGENTO_SUCCESS":
    case "CREATE_EPPIX_SUCCESS":
    case "CREATE_EPPIX_FAILED":
    case "FORM_ENCRYPTION_FAILED":
      status = true;
      break;
  }

  return status;
};
var getOrderCancelled = function getOrderCancelled(statusCode) {
  return getOrderTypeAndLabel(statusCode).orderStatusLabel === labels.order_status_labels.lbl_cancelled;
};
var generateOrderCSSVariant = function generateOrderCSSVariant(statusCode) {
  var _getOrderTypeAndLabel2 = getOrderTypeAndLabel(statusCode),
      orderStatusLabel = _getOrderTypeAndLabel2.orderStatusLabel;

  if ([config_labels/* default.order_status_labels.lbl_paid */.Z.order_status_labels.lbl_paid, config_labels/* default.order_status_labels.lbl_processing */.Z.order_status_labels.lbl_processing].indexOf(orderStatusLabel) !== -1) {
    return "order-status--processing";
  } else if ([config_labels/* default.order_status_labels.lbl_processed */.Z.order_status_labels.lbl_processed].indexOf(orderStatusLabel) !== -1) {
    return "order-status--processed";
  } else if ([config_labels/* default.order_status_labels.lbl_order_error */.Z.order_status_labels.lbl_order_error, config_labels/* default.order_status_labels.lbl_payment_failed */.Z.order_status_labels.lbl_payment_failed].indexOf(orderStatusLabel) !== -1) {
    return "order-status--error";
  } else if (orderStatusLabel === config_labels/* default.order_status_labels.lbl_cancelled */.Z.order_status_labels.lbl_cancelled) {
    return "order-status--cancelled";
  }

  return "order-status";
};
var generateOrderIconVariant = function generateOrderIconVariant(statusCode) {
  var _getOrderTypeAndLabel3 = getOrderTypeAndLabel(statusCode),
      orderStatusLabel = _getOrderTypeAndLabel3.orderStatusLabel;

  if ([config_labels/* default.order_status_labels.lbl_processing */.Z.order_status_labels.lbl_processing, config_labels/* default.order_status_labels.lbl_paid */.Z.order_status_labels.lbl_paid].indexOf(orderStatusLabel) !== -1) {
    return "sync.svg";
  } else if ([config_labels/* default.order_status_labels.lbl_order_error */.Z.order_status_labels.lbl_order_error, config_labels/* default.order_status_labels.lbl_payment_failed */.Z.order_status_labels.lbl_payment_failed].indexOf(orderStatusLabel) !== -1) {
    return "warning.svg";
  } else if (orderStatusLabel === config_labels/* default.order_status_labels.lbl_cancelled */.Z.order_status_labels.lbl_cancelled) {
    return "icon-cross.svg";
  } else if (orderStatusLabel === config_labels/* default.order_status_labels.lbl_processed */.Z.order_status_labels.lbl_processed) {
    return "success-circle.svg";
  }

  return "success-circle-blue.svg";
};
var getOrderInfinityStatus = function getOrderInfinityStatus(statusCode) {
  var infinityStatus = statusCode.toString().toUpperCase();
  var status;
  status = infinityStatuses[infinityStatus] ? infinityStatuses[infinityStatus] : status;
  return status;
};
var infinityArrayToObject = function infinityArrayToObject(arr) {
  var newObject = {};
  (arr || []).forEach(function (item) {
    newObject[item.schemeName] = item.value;
  });
  return newObject;
};

var checkOrderType = function checkOrderType(orderTypes, orderType) {
  return (orderTypes || []).map(function (s) {
    return s.toUpperCase();
  }).indexOf(orderType) !== -1;
};

var isOnceOffOrder = function isOnceOffOrder(orderTypes) {
  return checkOrderType(orderTypes, config_labels/* default.lbl_once_off_purchase */.Z.lbl_once_off_purchase);
};
var isMonthlyOrder = function isMonthlyOrder(orderTypes) {
  return checkOrderType(orderTypes, config_labels/* default.lbl_monthly_purchase */.Z.lbl_monthly_purchase);
};
var isUpgradeOrder = function isUpgradeOrder(orderTypes) {
  return checkOrderType(orderTypes, config_labels/* default.lbl_upgrade_purchase */.Z.lbl_upgrade_purchase);
};
var isDealOrder = function isDealOrder(orderTypes) {
  return isMonthlyOrder(orderTypes) || isUpgradeOrder(orderTypes);
};
var isMultiOrder = function isMultiOrder(orderTypes) {
  return isDealOrder(orderTypes) && isOnceOffOrder(orderTypes);
};
var getProductDetails = function getProductDetails(_ref3) {
  var ordered_product_details = _ref3.ordered_product_details;

  var _ref4 = ordered_product_details || [],
      _ref5 = (0,slicedToArray/* default */.Z)(_ref4, 1),
      orderItemData = _ref5[0];

  var _ref6 = orderItemData || {},
      product_details = _ref6.product_details;

  return product_details && typeof product_details === "string" ? JSON.parse(product_details) : product_details;
};
var getDealPrice = function getDealPrice(dealProductDetails) {
  return "R".concat(formatNumbersWithComma((dealProductDetails === null || dealProductDetails === void 0 ? void 0 : dealProductDetails.monthly_price) || (dealProductDetails === null || dealProductDetails === void 0 ? void 0 : dealProductDetails.monthly_recurring)), " \xD7 ").concat((dealProductDetails === null || dealProductDetails === void 0 ? void 0 : dealProductDetails.payment_terms_label) || (dealProductDetails === null || dealProductDetails === void 0 ? void 0 : dealProductDetails.payment_terms) || "");
};
var getVasData = function getVasData(_ref7) {
  var items = _ref7.items;
  var dealVasProduct = [];
  items.forEach(function (item) {
    if ((item === null || item === void 0 ? void 0 : item.parent_product_sku) !== null) {
      dealVasProduct.push(item);
    }
  });
  return dealVasProduct;
};
var getVasDealPrice = function getVasDealPrice(vasData, dealProductDetails) {
  var dealVasPrice = 0;
  vasData.forEach(function (item) {
    if ((item === null || item === void 0 ? void 0 : item.parent_product_sku) !== null) {
      dealVasPrice = parseFloat(dealVasPrice) + parseFloat(item === null || item === void 0 ? void 0 : item.monthly_recurring);
    }
  });
  dealVasPrice = parseFloat(dealVasPrice) + parseFloat((dealProductDetails === null || dealProductDetails === void 0 ? void 0 : dealProductDetails.monthly_price) || (dealProductDetails === null || dealProductDetails === void 0 ? void 0 : dealProductDetails.monthly_recurring));
  return "R".concat(formatNumbersWithComma(dealVasPrice), " \xD7 ").concat((dealProductDetails === null || dealProductDetails === void 0 ? void 0 : dealProductDetails.payment_terms_label) || (dealProductDetails === null || dealProductDetails === void 0 ? void 0 : dealProductDetails.payment_terms) || "");
};
var getDisplayedRange = function getDisplayedRange(itemsLoaded, totalItemsCount, text) {
  var resultText = text || "results";
  return itemsLoaded > 0 ? "1 - ".concat(itemsLoaded, " of ").concat(totalItemsCount, " ").concat(resultText) : "0 - 0 of 0 ".concat(resultText);
};
var getDisplayedRangeOnDealSelection = function getDisplayedRangeOnDealSelection(itemsLoaded, itemOnCurrentPage, totalItems, text) {
  return totalItems > 0 ? "".concat(itemsLoaded, " - ").concat(itemOnCurrentPage, " of ").concat(totalItems, " ").concat(text) : "0 - 0 of 0 ".concat(text);
};
var calculateShipping = function calculateShipping(cartDetails) {
  if (cartDetails && cartDetails.shippingFeeCalculate) {
    if (cartDetails.shippingFeeCalculate.shipping_fee == 0 && cartDetails.shippingFeeCalculate.carrier_code == "freeshipping") {
      return cartDetails.shippingFeeCalculate.shipping_label ? cartDetails.shippingFeeCalculate.shipping_label : config_labels/* default.lbl_free */.Z.lbl_free;
    } else {
      return "R".concat(formatNumbersWithComma(Math.round(cartDetails.shippingFeeCalculate.shipping_fee * 100) / 100));
    }
  } else {
    return null;
  }
};
var updateBreadCrumbPageTitle = function updateBreadCrumbPageTitle(page, titleToUpdate) {
  var _breadCrumbList$histo;

  var breadCrumbList = getSessionStorage(config_labels/* default.Session_Keys.lbl_breadCrumb */.Z.Session_Keys.lbl_breadCrumb);
  breadCrumbList === null || breadCrumbList === void 0 ? void 0 : (_breadCrumbList$histo = breadCrumbList.history) === null || _breadCrumbList$histo === void 0 ? void 0 : _breadCrumbList$histo.forEach(function (bcrumb) {
    if (bcrumb.pathname === page) {
      bcrumb["replaceTitle"] = titleToUpdate;
    }
  });
  updateSessionStorage(config_labels/* default.Session_Keys.lbl_breadCrumb */.Z.Session_Keys.lbl_breadCrumb, breadCrumbList);
};
var getCurrentPageNumber = function getCurrentPageNumber(query) {
  var filterCriteria = [];
  var params = query !== {} ? query.toString().split("?") : [];
  var filters = params && params.length > 1 ? params[1].split("&") : [];
  var pageNumber = 1;

  var _iterator = _createForOfIteratorHelper(filters),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      filterCriteria = item.split("=");

      if (filterCriteria[0] === "currentPage") {
        pageNumber = filterCriteria[1];
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return parseInt(pageNumber);
};
var getCurrentSortVal = function getCurrentSortVal(query, appendMonthly) {
  var filterCriteria = [];
  var params = query !== {} ? query.toString().split("?") : [];
  var filters = params && params.length > 1 ? params[1].split("&") : [];
  var sortFilter = config_labels/* default.sortKeys.lbl_recommended */.Z.sortKeys.lbl_recommended;

  var _iterator2 = _createForOfIteratorHelper(filters),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var item = _step2.value;
      filterCriteria = item.split("=");

      if (filterCriteria[0] === "sortBy") {
        sortFilter = filterCriteria[1];
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  if (query.toString().indexOf("monthlyPrice") !== -1) {
    switch (decodeURI(sortFilter)) {
      case config_labels/* default.sortKeys.lbl_low_to_high */.Z.sortKeys.lbl_low_to_high:
        return appendMonthly ? config_labels/* default.priceFilter.monthly_lbl_low_to_high */.Z.priceFilter.monthly_lbl_low_to_high : config_labels/* default.sortKeys.lbl_low_to_high */.Z.sortKeys.lbl_low_to_high;

      case config_labels/* default.sortKeys.lbl_high_to_low */.Z.sortKeys.lbl_high_to_low:
        return appendMonthly ? config_labels/* default.priceFilter.monthly_lbl_high_to_low */.Z.priceFilter.monthly_lbl_high_to_low : config_labels/* default.sortKeys.lbl_high_to_low */.Z.sortKeys.lbl_high_to_low;

      default:
        return decodeURI(sortFilter);
    }
  }

  return decodeURI(sortFilter);
};
var updatePathInBreadCrumb = function updatePathInBreadCrumb(route) {
  var _breadCrumbList$histo2;

  var breadCrumbList = getSessionStorage(config_labels/* default.Session_Keys.lbl_breadCrumb */.Z.Session_Keys.lbl_breadCrumb);
  breadCrumbList === null || breadCrumbList === void 0 ? void 0 : (_breadCrumbList$histo2 = breadCrumbList.history) === null || _breadCrumbList$histo2 === void 0 ? void 0 : _breadCrumbList$histo2.forEach(function (bcrumb) {
    if (bcrumb.asPath === route.asPath || bcrumb.pathname === route.pathname) {
      bcrumb["asPath"] = route.asPath;
    }
  });
  updateSessionStorage(config_labels/* default.Session_Keys.lbl_breadCrumb */.Z.Session_Keys.lbl_breadCrumb, breadCrumbList);
};
var getUpdatedSurname = function getUpdatedSurname(surname) {
  var surName = (surname === null || surname === void 0 ? void 0 : surname.toLowerCase()) === "no last name" ? "" : surname;
  return surName;
};
var getUpdatedContactPerson = function getUpdatedContactPerson(contactdetail) {
  return contactdetail === null || contactdetail === void 0 ? void 0 : contactdetail.replace(/no last name/gi, "");
};
var isArrayNotEmpty = function isArrayNotEmpty(array) {
  return array && Array.isArray(array) && array.length > 0;
};
var getProductsCookie = function getProductsCookie(cookieSkuArr, products) {
  var data = [];

  if (isArrayNotEmpty(cookieSkuArr) && isArrayNotEmpty(products)) {
    cookieSkuArr && cookieSkuArr.forEach(function (skudata) {
      products && products.forEach(function (productIterator) {
        if (productIterator.sku === skudata.sku) {
          var obj = {
            sku: productIterator.sku,
            name: productIterator.name,
            price_range: productIterator.price_range,
            image: productIterator.image,
            badges_label: productIterator.badges_label,
            display_low_stock_badge: productIterator.display_low_stock_badge,
            quantity: productIterator.quantity,
            low_stock_threshold: productIterator.low_stock_threshold,
            stock_status: productIterator.stock_status,
            __typename: productIterator.__typename,
            options: productIterator.options,
            promotion_tag_swatch: productIterator.promotion_tag_swatch,
            badges_swatch: productIterator.badges_swatch
          };

          if (productIterator.__typename === config_labels/* default.lbl_product_type_bundle */.Z.lbl_product_type_bundle) {
            obj.bundleOption = productIterator.items;
          }

          if (productIterator.__typename === config_labels/* default.lbl_product_typeName_configurable */.Z.lbl_product_typeName_configurable && productIterator.variants && productIterator.variants.length > 0) {
            obj.variantConfig = skudata && skudata.variantConfig;
            var variants = productIterator.variants.map(function (variant) {
              var _ref8 = variant || {},
                  _ref8$product = _ref8.product,
                  name = _ref8$product.name,
                  quantity = _ref8$product.quantity,
                  sku = _ref8$product.sku,
                  stock_status = _ref8$product.stock_status,
                  price_range = _ref8$product.price_range,
                  attributes = _ref8.attributes;

              var variantObj = {
                attributes: attributes,
                product: {
                  name: name,
                  quantity: quantity,
                  sku: sku,
                  stock_status: stock_status,
                  price_range: price_range
                }
              };
              return variantObj;
            });
            obj.variants = variants;
          }

          data.push(obj);
        }
      });
    });
    return data;
  } else {
    return null;
  }
};
var options = function options(arr, attr) {
  if (isArrayNotEmpty(arr) && attr) {
    // let values = arr.find((val) => val.attribute_code === attr).values;
    // return values;
    return arr.find(function (val) {
      return val.attribute_code === attr;
    }).values;
  }
};
var configurableOptions = function configurableOptions(arr) {
  if (isArrayNotEmpty(arr)) {
    return arr.map(function (val) {
      return val.attribute_code;
    });
  }
};
var myFunction = function myFunction(code, label, robj) {
  robj[code] = label;
  return robj;
};
var replaceUnderScore = function replaceUnderScore(text) {
  return text.toString().replace(/_/g, " ").toLowerCase().split(" ").map(function (string) {
    return string.charAt(0).toUpperCase() + string.substring(1);
  }).join(" ");
};
var getSelectedVariant = function getSelectedVariant(variants, selectedOption) {
  var selected;

  if (isArrayNotEmpty(variants) && selectedOption) {
    variants.find(function (variant) {
      var selectedVariantValues = [];
      Object.entries(selectedOption).forEach(function (entry) {
        var matched = variant.attributes.filter(function (attr) {
          return attr.code == entry[0] && attr.label == entry[1];
        });

        if (matched.length) {
          var _matched$;

          selectedVariantValues.push((_matched$ = matched[0]) === null || _matched$ === void 0 ? void 0 : _matched$.label);
        } else {
          selectedVariantValues.push(null);
        }
      });

      if (selectedVariantValues.length === Object.values(selectedOption).length && JSON.stringify(selectedVariantValues) === JSON.stringify(Object.values(selectedOption))) {
        selected = variant;
      }
    });
    return selected;
  } else {
    return null;
  }
};
var getLabel = function getLabel(conFigOptionsArr, key) {
  var headingObj;

  if (isArrayNotEmpty(conFigOptionsArr) && isArrayNotEmpty(key)) {
    var _headingObj;

    headingObj = conFigOptionsArr.find(function (config) {
      return config.attribute_code === key[0];
    });
    return headingObj && ((_headingObj = headingObj) === null || _headingObj === void 0 ? void 0 : _headingObj.label);
  }
};
var handlePageSection = function handlePageSection(index, breadcrumbItems) {
  var _breadcrumbItems;

  if ((breadcrumbItems === null || breadcrumbItems === void 0 ? void 0 : breadcrumbItems.length) >= index && (_breadcrumbItems = breadcrumbItems[(breadcrumbItems === null || breadcrumbItems === void 0 ? void 0 : breadcrumbItems.length) - index]) !== null && _breadcrumbItems !== void 0 && _breadcrumbItems.label) {
    var _breadcrumbItems2;

    return (_breadcrumbItems2 = breadcrumbItems[(breadcrumbItems === null || breadcrumbItems === void 0 ? void 0 : breadcrumbItems.length) - index]) === null || _breadcrumbItems2 === void 0 ? void 0 : _breadcrumbItems2.label;
  }

  return "";
};
var dynamicPageSection = function dynamicPageSection(index, dynamicRoute) {
  var dynamicBreadCrumbs = Object.keys(dynamicRoute) ? Object.keys(dynamicRoute) : [];

  if (dynamicBreadCrumbs.length > 0 && dynamicBreadCrumbs.length >= index) {
    return dynamicBreadCrumbs[dynamicBreadCrumbs.length - index];
  }

  return "";
};
var africaCountryCode = function africaCountryCode(num) {
  if (num && num.slice(0, 2) == countryCode) {
    return true;
  } else {
    return false;
  }
};
var appendCountryCode = function appendCountryCode(num) {
  if (!africaCountryCode(num)) {
    return countryCode + num.slice(1);
  } else {
    return num;
  }
};
var removeCountryCode = function removeCountryCode(num) {
  return "0" + num.slice(2);
};
var convertInToObject = function convertInToObject(arr) {
  var data = [];

  if (arr) {
    var len = arr.length;

    for (var i = 0; i < len; i++) {
      data.push({
        name: arr[i],
        id: arr[i]
      });
    }
  }

  return data;
};
var replaceDropdownKeys = function replaceDropdownKeys(arr, f_key, l_key, type) {
  var len = arr.length;

  for (var i = 0; i < len; i++) {
    if (type == "country") {
      arr[i].id = arr[i][f_key] + "-" + arr[i][l_key];
      arr[i].name = capitalizeFirstLetter(arr[i][f_key]);
    } else if (type === "accountType") {
      arr[i].id = [i + 1] + "-" + arr[i][l_key];
    } else if (!("id" in arr[i])) {
      arr[i].id = arr[i][l_key];
      delete arr[i][l_key];
    }

    if (type === "occupations") {
      arr[i].name = capitalizeFirstLetter(arr[i][f_key]);
    } else if (!("name" in arr[i]) && !("label" in arr[i])) {
      arr[i].name = arr[i][f_key];
      delete arr[i][f_key];
    }
  }

  return arr;
};
function getAge(dob) {
  var dOB = dob.split(" / ").join("");
  var year = Number(dOB.substr(4, 4));
  var month = Number(dOB.substr(2, 2)) - 1;
  var day = Number(dOB.substr(0, 2));
  var today = new Date();
  var age = today.getFullYear() - year;

  if (today.getMonth() < month || today.getMonth() == month && today.getDate() < day) {
    age--;
  }

  return age;
}
var addAutoSlash = function addAutoSlash(value) {
  if (/\D\/$/.test(value)) value = value.substr(0, value.length - 3);
  var values = value.split("/").map(function (v) {
    return v.replace(/\D/g, "");
  });

  if (values[0]) {
    values[0] = checkValue(values[0], 31, values[1] ? true : false);
  }

  if (values[1]) {
    values[1] = checkValue(values[1], 12, values[2] ? true : false);
  }

  var output = values.map(function (v, i) {
    //return v.length == 2 && i < 2 ? v + " / " : v;
    if (v.length == 2 && i < 2) {
      return v + " / ";
    } else if (v.length == 1 && i < 2 && values[i + 1]) {
      return v + " / ";
    } else {
      return v;
    }
  });
  return output.join("").substr(0, 14);
};
function checkValue(str, max, addZero) {
  if (str.charAt(0) !== "0" || str == "00" || addZero) {
    var num = parseInt(str);

    if (addZero && str.length == 1 && num !== 0) {
      str = num.toString();
    } else if (isNaN(num) || num <= 0 || num > max) {
      num = 1;
      str = num > parseInt(max.toString().charAt(0)) && num.toString().length == 1 ? "0" + num : num.toString();
    }
  }

  return str;
}
var addOrdinalSuffix = function addOrdinalSuffix(num) {
  var _int = parseInt(num),
      digits = [_int % 10, _int % 100],
      ordinals = ["st", "nd", "rd", "th"],
      oPattern = [1, 2, 3, 4],
      tPattern = [11, 12, 13, 14, 15, 16, 17, 18, 19];

  return oPattern.includes(digits[0]) && !tPattern.includes(digits[1]) ? _int + ordinals[digits[0] - 1] : _int + ordinals[3];
};
var getValueLabel = function getValueLabel(val, arr) {
  var valueLabel = arr.find(function (item) {
    return item.id == val;
  });
  return valueLabel !== null && valueLabel !== void 0 && valueLabel.name ? valueLabel.name : valueLabel !== null && valueLabel !== void 0 && valueLabel.label ? valueLabel.label : "";
};
var getTotalDuration = function getTotalDuration(str) {
  var period = "-";

  if (str && str !== "") {
    var year = str.toString().slice(0, 2);
    var month = str.toString().slice(5, 7);
    period = Number(year) + " years, " + Number(month) + " months";
  }

  return period;
};
var capitalizeFirstLetter = function capitalizeFirstLetter(str) {
  // converting first letter to uppercase
  var lstr = str.toLowerCase(),
      capitalized = lstr.toLowerCase().charAt(0).toUpperCase() + lstr.slice(1);
  return capitalized;
};
var numRegEx = RegExp(/^[0-9]*$/);
var regName = RegExp(/^[a-zA-Z]+ [a-zA-Z]+$/);
var charRegExpForName = RegExp(/^[a-zA-Z ]+$/);
var charRegExp = RegExp(/^[a-zA-Z]+$/);
var dateRegex = RegExp(/^([0][1-9]|[12][0-9]|3[01])[\s][\/][\s]([0][1-9]|1[012])[\s][\/][\s](19|20)\d{2}$/);
var durationRegex = RegExp(/^([0][1-9]|[1-9][0-9])[\s][\/][\s]([0][1-9]|1[011])$/);
var currencyRegex = RegExp(/^[1-9]\d*$/);
var nameRegex = RegExp(/^[a-zA-Z\s]*$/);
var charSpaceRegExp = RegExp(/^[a-z][a-z\s]*$/);
var streetNameRegEx = RegExp(/^[a-zA-Z0-9_ ]*$/);
var cellPhoneRegEx = RegExp(/^0|27[0-9]*$/);
var emailRegEx = RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
var matchWordInString = function matchWordInString(str, word) {
  if (str && str !== "" && word && word !== "") {
    var pattern = RegExp("\\b(" + word + ")\\b", "g");
    var match = pattern.test(str);
    return match;
  } else {
    return false;
  }
};
var preValidationEligible = function preValidationEligible(statusCode) {
  var status = false;

  switch (statusCode) {
    case "PREVALIDATION_ELIGIBLE":
    case "PREVALIDATION_EXPIRED":
    case "PREVALIDATION_ERRORED":
    case "PREVALIDATION_CANCELED":
    case "PREVALIDATION_APPROVED":
    case "PREVALIDATION_APPROVED_WITH_CONDITIONS":
      status = true;
      break;
  }

  return status;
};
var preValidationUpgradeEligible = function preValidationUpgradeEligible(statusCode) {
  var status = false;

  switch (statusCode) {
    case "PREVALIDATION_ELIGIBLE":
      status = true;
      break;
  }

  return status;
};
var getPreValidationErrorType = function getPreValidationErrorType(statusCode) {
  var type = null;

  switch (statusCode) {
    case "PREVALIDATION_UNAUTHORIZED":
      type = "technical error";
      break;

    case "PREVALIDATION_NOT_ELIGIBLE":
      type = "not eligibile";
      break;

    case "PREVALIDATION_NOT_ELIGIBLE_DECLINED_LAST_30_DAY":
    case "PREVALIDATION_NOT_ELIGIBLE_PENDING_LAST_30_DAY":
      type = "30 days";
      break;

    case "PREVALIDATION_NOT_ELIGIBLE_DECLINED_LAST_60_DAY":
    case "PREVALIDATION_NOT_ELIGIBLE_PENDING_LAST_60_DAY":
      type = "60 days";
      break;

    case "LETSGETSTARTED_LEGACY":
    case "PREVALIDATION_NOT_ELIGIBLE_NOT_ONLINE":
      type = "legacy";
      break;

    case "PREVALIDATION_ORDER_EXISTS":
      type = "siebel";
      break;

    case "PREVALIDATION_NOT_ELIGIBLE_PENDED":
      type = "pended";
      break;

    case "PREVALIDATION_NOT_ELIGIBLE_REFERRED":
      type = "referred";
      break;

    case "PREVALIDATION_NOT_ELIGIBLE_DECLINED":
      type = "declined";
      break;

    case "PREVALIDATION_NOT_ELIGIBLE_NOT_AFFORDABLE":
      type = "approved with conditions";
      break;

    case "PREVALIDATION_PREVIOUS_ACTIVE_CREDIT_VET":
      type = "active credit vet";
      break;

    case "PREVALIDATION_NOT_ELIGIBLE_ACCOUNT_IN_ARREARS":
      type = "account in arrears";
      break;

    default:
      type = typeof statusCode === "string" ? statusCode.trim().toLowerCase().replace("prevalidation_", "").replace(/_/g, " ") : null;
      break;
  }

  return type;
};
var titleCase = function titleCase(str) {
  return str.replace(/(^|\s)\S/g, function (t) {
    return t.toUpperCase();
  });
};
var titleCaseFirstLetterOfString = function titleCaseFirstLetterOfString(str) {
  var splitStr = str.toLowerCase().split(" ");

  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }

  return splitStr.join(" ");
};
var toDesignation = function toDesignation(str) {
  return (str || "").toString().replace(/^\s|\s$/, "").replace(/\s+/g, "-").toLowerCase();
};
var debounce = function debounce(func) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  var timer;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timer);
    timer = setTimeout(function () {
      func.apply(_this, args);
    }, timeout);
  };
};
var isValueSelected = function isValueSelected(dataArr, selected, key, field) {
  var isPresent = -1;

  if (dataArr && dataArr[key] && dataArr[key].length > 0) {
    isPresent = dataArr[key].findIndex(function (item) {
      return item[field || "value"] === selected[field || "value"];
    });
  }

  return isPresent !== -1;
};
var manipulateFilter = function manipulateFilter(flag, data, selected, key, field) {
  var dataArr = data && data[key] ? (0,toConsumableArray/* default */.Z)(data[key]) : [];

  if (flag) {
    dataArr.filter(function (item) {
      return item[field || "label"] === selected[field || "label"];
    }).length === 0 ? dataArr.push(selected) : dataArr;
  } else {
    dataArr.filter(function (item, index) {
      if (item[field || "label"] === selected[field || "label"]) {
        dataArr.splice(index, 1);
      }
    });
  }

  return dataArr;
};
var getCartGrandTotal = function getCartGrandTotal(cartDetails) {
  if (cartDetails) {
    var _cartDetails$shipping, _cartDetails$shipping2, _cartDetails$shipping3, _cartDetails$shipping4, _cartDetails$prices3, _cartDetails$prices3$, _cartDetails$shipping8, _cartDetails$shipping9, _cartDetails$prices5, _cartDetails$prices5$, _cartDetails$prices6, _cartDetails$prices6$;

    if (cartDetails !== null && cartDetails !== void 0 && (_cartDetails$shipping = cartDetails.shipping_address) !== null && _cartDetails$shipping !== void 0 && (_cartDetails$shipping2 = _cartDetails$shipping[0]) !== null && _cartDetails$shipping2 !== void 0 && _cartDetails$shipping2.selected_shipping_method) {
      var _cartDetails$prices, _cartDetails$prices$g;

      return "R".concat(formatNumbersWithComma(parseFloat(cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$prices = cartDetails.prices) === null || _cartDetails$prices === void 0 ? void 0 : (_cartDetails$prices$g = _cartDetails$prices.grand_total) === null || _cartDetails$prices$g === void 0 ? void 0 : _cartDetails$prices$g.value)));
    } else {
      if (cartDetails !== null && cartDetails !== void 0 && cartDetails.selected_shipping_method) {
        var _cartDetails$prices2, _cartDetails$prices2$;

        return "R".concat(formatNumbersWithComma(parseFloat(cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$prices2 = cartDetails.prices) === null || _cartDetails$prices2 === void 0 ? void 0 : (_cartDetails$prices2$ = _cartDetails$prices2.grand_total) === null || _cartDetails$prices2$ === void 0 ? void 0 : _cartDetails$prices2$.value)));
      }
    }

    if (!(cartDetails !== null && cartDetails !== void 0 && (_cartDetails$shipping3 = cartDetails.shipping_address) !== null && _cartDetails$shipping3 !== void 0 && (_cartDetails$shipping4 = _cartDetails$shipping3[0]) !== null && _cartDetails$shipping4 !== void 0 && _cartDetails$shipping4.selected_shipping_method) && (cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$prices3 = cartDetails.prices) === null || _cartDetails$prices3 === void 0 ? void 0 : (_cartDetails$prices3$ = _cartDetails$prices3.grand_total) === null || _cartDetails$prices3$ === void 0 ? void 0 : _cartDetails$prices3$.value) == 0) {
      var _cartDetails$shipping5, _cartDetails$shipping6, _cartDetails$prices4, _cartDetails$prices4$;

      if ((cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$shipping5 = cartDetails.shippingFeeCalculate) === null || _cartDetails$shipping5 === void 0 ? void 0 : _cartDetails$shipping5.shipping_fee) != 0 && (cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$shipping6 = cartDetails.shippingFeeCalculate) === null || _cartDetails$shipping6 === void 0 ? void 0 : _cartDetails$shipping6.shipping_fee) != null) {
        var _cartDetails$shipping7;

        return "R".concat(formatNumbersWithComma(parseFloat(cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$shipping7 = cartDetails.shippingFeeCalculate) === null || _cartDetails$shipping7 === void 0 ? void 0 : _cartDetails$shipping7.shipping_fee)));
      }

      return "R".concat(formatNumbersWithComma(parseFloat(cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$prices4 = cartDetails.prices) === null || _cartDetails$prices4 === void 0 ? void 0 : (_cartDetails$prices4$ = _cartDetails$prices4.grand_total) === null || _cartDetails$prices4$ === void 0 ? void 0 : _cartDetails$prices4$.value)));
    }

    if (cartDetails !== null && cartDetails !== void 0 && (_cartDetails$shipping8 = cartDetails.shippingFeeCalculate) !== null && _cartDetails$shipping8 !== void 0 && _cartDetails$shipping8.shipping_fee && (cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$shipping9 = cartDetails.shippingFeeCalculate) === null || _cartDetails$shipping9 === void 0 ? void 0 : _cartDetails$shipping9.shipping_fee) != null && cartDetails !== null && cartDetails !== void 0 && (_cartDetails$prices5 = cartDetails.prices) !== null && _cartDetails$prices5 !== void 0 && (_cartDetails$prices5$ = _cartDetails$prices5.grand_total) !== null && _cartDetails$prices5$ !== void 0 && _cartDetails$prices5$.value && (cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$prices6 = cartDetails.prices) === null || _cartDetails$prices6 === void 0 ? void 0 : (_cartDetails$prices6$ = _cartDetails$prices6.grand_total) === null || _cartDetails$prices6$ === void 0 ? void 0 : _cartDetails$prices6$.value) != null) {
      var _cartDetails$shipping10, _cartDetails$prices7, _cartDetails$prices7$;

      return "R".concat(formatNumbersWithComma(parseFloat(cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$shipping10 = cartDetails.shippingFeeCalculate) === null || _cartDetails$shipping10 === void 0 ? void 0 : _cartDetails$shipping10.shipping_fee) + parseFloat((_cartDetails$prices7 = cartDetails.prices) === null || _cartDetails$prices7 === void 0 ? void 0 : (_cartDetails$prices7$ = _cartDetails$prices7.grand_total) === null || _cartDetails$prices7$ === void 0 ? void 0 : _cartDetails$prices7$.value)));
    }

    return null;
  }

  return null;
};
var addAutoSlashToPeriod = function addAutoSlashToPeriod(value, blur, str) {
  var output = value;

  if (!RegExp(/^[0-9/]+$/).test(value)) {
    output = value.replace(/\D/g, "");
  }

  if (blur && value) {
    if (value) {
      output = Number(value.replace(/\D/g, "")) + " " + str;
    } else {
      output = value;
    }
  } else {
    if (value) {
      output = Number(value.replace(/\D/g, ""));
    } else {
      output = value;
    }
  }

  return output;
};
var checkYearAndMonthFormat = function checkYearAndMonthFormat(years, months, isRequired) {
  var year = parseInt(years.toString().slice(0, 2)),
      month = parseInt(months.toString().slice(0, 2)),
      error = "";

  if (!isRequired) {
    if (isNaN(month) != "" || isNaN(year) != "" || month > 11) {
      error = true;
    } else {
      error = false;
    }
  } else {
    if (isNaN(month) != "" || isNaN(year) != "" || year <= 0 && month <= 0 || month > 11) {
      error = true;
    } else {
      error = false;
    }
  }

  return error;
};
var getCustomizableOptions = function getCustomizableOptions(optionId, valueString) {
  if (optionId && valueString) {
    return [{
      id: optionId,
      value_string: valueString.toString()
    }];
  } else {
    return [];
  }
};
var generateFormURL = function generateFormURL(url, leadType, btnType, preferenceId) {
  var newUrl = url;

  if (preferenceId) {
    newUrl = getPreferenceRoutingUrl(preferenceId);
  }

  if (newUrl.includes("forms/ecommerce")) {
    if (btnType && btnType == "lead") {
      return preferenceId == ("all-above" || 0) ? "".concat(newUrl, "?bucket=").concat(leadType, "&cartType=multicart&preferenceId=").concat(preferenceId) : "".concat(newUrl, "?bucket=").concat(leadType);
    } else {
      return newUrl;
    }
  } else {
    return newUrl;
  }
};
var getProductImageUrl = function getProductImageUrl(item, image_type, no_image) {
  var _item$image_type, _item$image_type2, _item$image_type3, _item$image_type4;

  return item !== null && item !== void 0 && (_item$image_type = item[image_type]) !== null && _item$image_type !== void 0 && _item$image_type.url && (item === null || item === void 0 ? void 0 : (_item$image_type2 = item[image_type]) === null || _item$image_type2 === void 0 ? void 0 : _item$image_type2.url) !== null && !(item !== null && item !== void 0 && item[image_type].url.includes(no_image)) ? item === null || item === void 0 ? void 0 : (_item$image_type3 = item[image_type]) === null || _item$image_type3 === void 0 ? void 0 : _item$image_type3.url : item !== null && item !== void 0 && item.primary_product_image && (item === null || item === void 0 ? void 0 : item.primary_product_image) !== null ? item === null || item === void 0 ? void 0 : item.primary_product_image : item === null || item === void 0 ? void 0 : (_item$image_type4 = item[image_type]) === null || _item$image_type4 === void 0 ? void 0 : _item$image_type4.url;
};
var getOrderProductImageUrl = function getOrderProductImageUrl(item, image_type, no_image) {
  var _item$primary_product;

  return item !== null && item !== void 0 && item[image_type] && item !== null && item !== void 0 && item[image_type].length && !(item !== null && item !== void 0 && item[image_type][0].includes(no_image)) ? item === null || item === void 0 ? void 0 : item[image_type] : item !== null && item !== void 0 && item.primary_product_image && item !== null && item !== void 0 && (_item$primary_product = item.primary_product_image) !== null && _item$primary_product !== void 0 && _item$primary_product.length ? item === null || item === void 0 ? void 0 : item.primary_product_image : item === null || item === void 0 ? void 0 : item[image_type];
};
var getPreferenceRoutingUrl = function getPreferenceRoutingUrl(id) {
  var url = "/forms/ecommerce";

  switch (id) {
    case "call-me-back":
      url = "/forms/ecommerce";
      break;

    case "once-off":
      url = "/checkout";
      break;

    case "all-above":
      url = "/forms/ecommerce";
      break;

    case "select-another-deal-need-once-off":
    case "select-another-deal-dont-need-once-off":
      url = "/deals";
      break;

    case "check-once-off-only":
      url = "/checkout";
      break;
  }

  return url;
};
var getClearCartQuery = function getClearCartQuery(cartItemsIds) {
  var query = "";
  var cartId = getCookieValue("cart_id");

  var _iterator3 = _createForOfIteratorHelper(cartItemsIds),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var id = _step3.value;
      query += "\n  removeItem".concat(id, ": removeItemFromCart(\n     input: {\n       cart_id: \"").concat(cartId, "\",\n       cart_item_id: ").concat(id, "\n     }\n   )\n    {\n   cart {\n     items {\n       id\n     }\n   }\n  }");
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  query = "mutation {" + query + "}";
  return query;
};
var getCustomerPositionAsync = function getCustomerPositionAsync() {
  return new Promise(function (resolve, reject) {
    var resultData = {
      error: "",
      result: {
        latitude: "",
        longitude: ""
      }
    };

    function success(position) {
      resultData.result.latitude = position.coords.latitude;
      resultData.result.longitude = position.coords.longitude;
      resolve(resultData);
    }

    function error() {
      resultData.error = "Unable to retrieve your location";
      reject(resultData);
    }

    if (!navigator.geolocation) {
      resultData.error = "Geolocation is not supported by your browser";
    } else {
      navigator.geolocation.getCurrentPosition(success, error);
    }
  });
};
/**
 *This function is used to get the age of the customer
 */

var getDateOfBirth = function getDateOfBirth(dob) {
  var formattedDate;
  var today = new Date();
  formattedDate = dob.split("/");
  formattedDate = formattedDate[1] + "/" + formattedDate[0] + "/" + formattedDate[2];
  var birthDate = new Date(formattedDate);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();

  if (m < 0 || m === 0 && today.getDate() < birthDate.getDate()) {
    age--;
  }

  return age;
};
var checkPreOrder = function checkPreOrder(resultData) {
  var preOrderFound = resultData.filter(function (item) {
    var _item$product8, _item$product9;

    return (item === null || item === void 0 ? void 0 : (_item$product8 = item.product) === null || _item$product8 === void 0 ? void 0 : _item$product8.badges_label) && (item === null || item === void 0 ? void 0 : (_item$product9 = item.product) === null || _item$product9 === void 0 ? void 0 : _item$product9.badges_label.toLowerCase().indexOf(types/* default.TYPE_PREORDER.toLowerCase */.Z.TYPE_PREORDER.toLowerCase())) > -1;
  });

  if (preOrderFound && preOrderFound.length > 0) {
    return true;
  }

  return false;
};
var isValidJSON = function isValidJSON(jsonStr) {
  try {
    JSON.parse(jsonStr);
  } catch (e) {
    return false;
  }

  return true;
};

/***/ }),

/***/ 21534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Logger; }
/* harmony export */ });
/* unused harmony export Levels */
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16835);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92777);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82262);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59499);




var Levels = {
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  DEBUG: 'debug'
};
var Logger = /*#__PURE__*/function () {
  function Logger() {
    (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Logger);
  }

  (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Logger, null, [{
    key: "setContext",
    value: function setContext(identifier, context) {
      if (typeof identifier !== "string" || typeof context !== "object") {
        return;
      }

      Logger.page = context.page || "unknown";
    }
  }, {
    key: "setTags",
    value: function setTags(tags) {
      if (typeof tags !== "object") {
        return;
      }

      for (var _i = 0, _Object$entries = Object.entries(tags); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            val = _Object$entries$_i[1];

        if (!key || !val) {
          continue;
        }
      }
    }
  }, {
    key: "breadcrumb",
    value: function breadcrumb(message, category, type, data) {
      var level = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Levels.INFO;

      if (!message) {
        return;
      }
    }
  }, {
    key: "info",
    value: function info(message, component) {
      var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var tags = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      if (!message) {
        return;
      }
    }
  }, {
    key: "error",
    value: function error(_error, component) {
      var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var tags = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      try {
        var isErrorInstance = _error instanceof Error;

        if (!isErrorInstance && typeof _error === "object") {
          _error = Error(JSON.stringify(_error));
        }

        if (!isErrorInstance && typeof _error === "string") {
          _error = Error(_error);
        }

        if (!(_error instanceof Error)) {
          // unsupported error type
          return;
        }
      } catch (e) {
        Logger.error(Error("Unable to log sentry exception"));
      }
    }
  }]);

  return Logger;
}();

(0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Logger, "page", "unknown");

/***/ }),

/***/ 49366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helperServices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64036);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21534);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var config = __webpack_require__(26125);

var JWTtoken = (0,_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .getCookieValue */ .Do)("vod-web-auth-token");

var get = function get(mode, requestId, params) {
  var authNeeded = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var reqParams = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var queryParams = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var xAuthNeeded = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var resAuth = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : "";
  var contentType = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : "json";
  var url = "".concat(config.envConfigs[config.env].dxl.url).concat(config[mode][requestId]);

  if (reqParams && url.indexOf("{reqParams}") !== -1) {
    url = url.replace("{reqParams}", reqParams.join("/"));
  }

  if (queryParams) {
    url = "".concat(url).concat(queryParams);
  }

  var headers = _objectSpread({
    "Content-Type": contentType == "json" ? "application/json" : "application/x-www-form-urlencoded"
  }, params === null || params === void 0 ? void 0 : params.headers);

  if (authNeeded && JWTtoken) {
    headers.Authorization = "Bearer ".concat(JWTtoken);
  }

  if (xAuthNeeded && JWTtoken) {
    headers["x-auth-jwt"] = "Bearer ".concat(JWTtoken);
  }

  if (resAuth && resAuth !== "") {
    headers.Authorization = "Bearer ".concat(resAuth);
  }

  var opts;

  if (params) {
    if (params.headers) delete params.headers;
    opts = {
      method: "GET",
      headers: headers,
      params: params
    };
  } else {
    opts = {
      method: "GET",
      headers: headers
    };
  }

  var dataResults = {
    fail: false,
    response: {},
    error: {}
  };
  return axios__WEBPACK_IMPORTED_MODULE_1___default().get(url, opts).then(function (resp) {
    dataResults.response = resp;
    return dataResults;
  })["catch"](function (error) {
    _utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .Logger.error */ .Y.error(error, requestId, {
      request: {
        mode: mode,
        requestId: requestId,
        params: JSON.stringify(params || {}),
        authNeeded: authNeeded,
        reqParams: JSON.stringify(reqParams || {}),
        queryParams: queryParams || "",
        xAuthNeeded: xAuthNeeded,
        resAuth: resAuth,
        contentType: contentType
      },
      requestUrl: url,
      requestMethod: "GET",
      options: opts
    });
    dataResults.fail = true;
    dataResults.error = error === null || error === void 0 ? void 0 : error.response;
    return dataResults;
  });
};

var post = function post(mode, requestId) {
  var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var authNeeded = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var reqParams = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var queryParams = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  var contentType = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : "json";
  var url = "".concat(config.envConfigs[config.env].dxl.url).concat(config[mode][requestId]);

  if (reqParams && url.indexOf("{reqParams}") !== -1) {
    url = url.replace("{reqParams}", reqParams.join("/"));
  }

  if (queryParams) {
    url = "".concat(url).concat(queryParams);
  }

  var headers = _objectSpread({
    "Content-Type": contentType == "json" ? "application/json" : "application/x-www-form-urlencoded"
  }, params === null || params === void 0 ? void 0 : params.headers);

  if (authNeeded && JWTtoken) {
    headers.Authorization = "Bearer ".concat(JWTtoken);
  }

  if (requestId === "creditVettingOutcome" && JWTtoken) {
    headers["x-auth-jwt"] = "Bearer ".concat(JWTtoken);
    headers["x-origin-id"] = 1;
  }

  var opts;

  if (params) {
    if (params.headers) delete params.headers;
    opts = {
      headers: headers,
      params: params
    };
  } else {
    opts = {
      headers: headers
    };
  }

  var dataResults = {
    fail: false,
    response: {},
    error: {}
  };
  return axios__WEBPACK_IMPORTED_MODULE_1___default().post(url, body, opts).then(function (resp) {
    dataResults.response = resp;
    return dataResults;
  })["catch"](function (error) {
    _utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .Logger.error */ .Y.error(error, requestId, {
      request: {
        mode: mode,
        requestId: requestId,
        body: JSON.stringify(body || {}),
        params: JSON.stringify(params || {}),
        authNeeded: authNeeded,
        reqParams: JSON.stringify(reqParams || {}),
        queryParams: queryParams || "",
        contentType: contentType
      },
      requestUrl: url,
      requestMethod: "POST",
      options: opts
    });
    dataResults.fail = true;
    dataResults.error = error === null || error === void 0 ? void 0 : error.response;
    return dataResults;
  });
};

var put = function put(mode, requestId) {
  var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var authNeeded = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var reqParams = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var queryParams = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  var contentType = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : "json";
  var url = "".concat(config.envConfigs[config.env].dxl.url).concat(config[mode][requestId]); // let url = `https://apiqa.vodacom.co.za/dxl/${config[mode][requestId]}`;

  if (reqParams && url.indexOf("{reqParams}") !== -1) {
    url = url.replace("{reqParams}", reqParams.join("/"));
  }

  if (queryParams) {
    url = "".concat(url).concat(queryParams);
  }

  var headers = _objectSpread({
    "Content-Type": contentType == "json" ? "application/json" : "application/x-www-form-urlencoded"
  }, params === null || params === void 0 ? void 0 : params.headers);

  if (authNeeded && JWTtoken) {
    headers.Authorization = "Bearer ".concat(JWTtoken);
  }

  var opts;

  if (params) {
    if (params.headers) delete params.headers;
    opts = {
      headers: headers,
      params: params
    };
  } else {
    opts = {
      headers: headers
    };
  }

  var dataResults = {
    fail: false,
    response: {},
    error: {}
  };
  return axios__WEBPACK_IMPORTED_MODULE_1___default().put(url, body, opts).then(function (resp) {
    dataResults.response = resp;
    return dataResults;
  })["catch"](function (error) {
    _utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .Logger.error */ .Y.error(error, requestId, {
      request: {
        mode: mode,
        requestId: requestId,
        body: JSON.stringify(body || {}),
        params: JSON.stringify(params || {}),
        authNeeded: authNeeded,
        reqParams: JSON.stringify(reqParams || {}),
        queryParams: queryParams || "",
        contentType: contentType
      },
      requestUrl: url,
      requestMethod: "PUT",
      options: opts
    });
    dataResults.fail = true;
    dataResults.error = error === null || error === void 0 ? void 0 : error.response;
    return dataResults;
  });
};

var del = function del(mode, requestId, params) {
  var authNeeded = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var reqParams = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var queryParams = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var xAuthNeeded = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var resAuth = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : "";
  var contentType = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : "json";
  var url = "".concat(config.envConfigs[config.env].dxl.url).concat(config[mode][requestId]);

  if (reqParams && url.indexOf("{reqParams}") !== -1) {
    url = url.replace("{reqParams}", reqParams.join("/"));
  }

  if (queryParams) {
    url = "".concat(url).concat(queryParams);
  }

  var headers = _objectSpread({
    "Content-Type": contentType == "json" ? "application/json" : "application/x-www-form-urlencoded"
  }, params === null || params === void 0 ? void 0 : params.headers);

  if (authNeeded && JWTtoken) {
    headers.Authorization = "Bearer ".concat(JWTtoken);
  }

  if (xAuthNeeded && JWTtoken) {
    headers["x-auth-jwt"] = "Bearer ".concat(JWTtoken);
  }

  if (resAuth && resAuth !== "") {
    headers.Authorization = "Bearer ".concat(resAuth);
  }

  var opts;

  if (params) {
    if (params.headers) delete params.headers;
    opts = {
      method: "DELETE",
      headers: headers,
      params: params
    };
  } else {
    opts = {
      method: "DELETE",
      headers: headers
    };
  }

  var dataResults = {
    fail: false,
    response: {},
    error: {}
  };
  return axios__WEBPACK_IMPORTED_MODULE_1___default()["delete"](url, opts).then(function (resp) {
    dataResults.response = resp;
    return dataResults;
  })["catch"](function (error) {
    _utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .Logger.error */ .Y.error(error, requestId, {
      request: {
        mode: mode,
        requestId: requestId,
        params: JSON.stringify(params || {}),
        authNeeded: authNeeded,
        reqParams: JSON.stringify(reqParams || {}),
        queryParams: queryParams || "",
        xAuthNeeded: xAuthNeeded,
        resAuth: resAuth,
        contentType: contentType
      },
      requestUrl: url,
      requestMethod: "DELETE",
      options: opts
    });
    dataResults.fail = true;
    dataResults.error = error === null || error === void 0 ? void 0 : error.response;
    return dataResults;
  });
};

/* harmony default export */ __webpack_exports__["Z"] = ({
  get: get,
  post: post,
  put: put,
  del: del
});

/***/ }),

/***/ 91118:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(32055);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 27280:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 21938:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"CTAButton_button__X2xdw","button__primary":"CTAButton_button__primary__nzws_","link":"CTAButton_link__FApaP","button__solid-grey":"CTAButton_button__solid-grey__hWcWY","button__solid-white":"CTAButton_button__solid-white__Dcp92","button__solid-blackish":"CTAButton_button__solid-blackish__biCV3","button__solid-black":"CTAButton_button__solid-black__RuPPW","button__solid-red":"CTAButton_button__solid-red__cepWU","button__solid-green":"CTAButton_button__solid-green__jXSb2","button__solid-light-gray":"CTAButton_button__solid-light-gray__3yqqa","button__outline-white":"CTAButton_button__outline-white__PWAah","button__outline-black":"CTAButton_button__outline-black__0_MkU","button__outline-grey":"CTAButton_button__outline-grey__3R8lp","button__flat-black":"CTAButton_button__flat-black__1ZO97","button__flat-white":"CTAButton_button__flat-white__Ma8or","button__flat-red":"CTAButton_button__flat-red__HGTiO","button__flat-teal51":"CTAButton_button__flat-teal51__HJo54","button__link-teal":"CTAButton_button__link-teal__SpQsy","button__link-teal51":"CTAButton_button__link-teal51__Yf4v1","button__link-white":"CTAButton_button__link-white__tzA__","button__link-black":"CTAButton_button__link-black__kB0iJ","button__custom":"CTAButton_button__custom__VAXNF","right-arrow":"CTAButton_right-arrow__I7_VP","order-details-back-btn":"CTAButton_order-details-back-btn__sWR30"};

/***/ }),

/***/ 48258:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button-container":"ButtonWithIcon_button-container__k5Jni","button-label":"ButtonWithIcon_button-label__r89LA","disable-button-label":"ButtonWithIcon_disable-button-label__ILbJq","disable-img":"ButtonWithIcon_disable-img__4ww9u"};

/***/ }),

/***/ 97565:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkbox-label":"Checkbox_checkbox-label__OANb8","checkbox-span":"Checkbox_checkbox-span__lEt85","span-text":"Checkbox_span-text__U2nCq","checkbox-label--bold":"Checkbox_checkbox-label--bold__thSg3","form-checkbox-label":"Checkbox_form-checkbox-label__SiJYb","checkbox-label--large":"Checkbox_checkbox-label--large__Prssj","checkbox-container":"Checkbox_checkbox-container__3tkVt","checkbox-hide":"Checkbox_checkbox-hide__iH2Gp","addToCompareLabelStyling":"Checkbox_addToCompareLabelStyling__uvx7m","brandLabelStyling":"Checkbox_brandLabelStyling__31zSY","promotionLabelStyling":"Checkbox_promotionLabelStyling__S1M3o","checkbox-span-text":"Checkbox_checkbox-span-text__D4F8s","more-filters":"Checkbox_more-filters__KiSJa","checkbox-group":"Checkbox_checkbox-group__LttME"};

/***/ }),

/***/ 69346:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"confirm-modal":"ConfirmModal_confirm-modal__qqbhx","modal-header":"ConfirmModal_modal-header__UTx4k","close-button":"ConfirmModal_close-button__j0eeb","modal-body":"ConfirmModal_modal-body__JBPdA","trash-icon":"ConfirmModal_trash-icon__QW0Ev","title":"ConfirmModal_title__qmQ1l","sub-content":"ConfirmModal_sub-content__WeI7E","content":"ConfirmModal_content__MB1i5","modal-footer":"ConfirmModal_modal-footer__zz0kd","cancel":"ConfirmModal_cancel__1cWN6","disabled":"ConfirmModal_disabled__v1rf7","sure":"ConfirmModal_sure__8a_bB"};

/***/ }),

/***/ 61493:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btn":"getHelp_btn__lQlrL","txt":"getHelp_txt__qQ44M","btn-view":"getHelp_btn-view__LlbSS","fadeInRightMobile":"getHelp_fadeInRightMobile__8QtAA","fadeInRight":"getHelp_fadeInRight__Qphbq","product-details":"getHelp_product-details__nhU9i","stick_to_bottom":"getHelp_stick_to_bottom__pbv_R"};

/***/ }),

/***/ 91490:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__8pLHO","show-spinner":"loader_show-spinner__A4Atg"};

/***/ }),

/***/ 59544:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"snackBar":"SnackBar_snackBar__Yxe0G","snackBar__msgContainer":"SnackBar_snackBar__msgContainer__92P1V","snackBar__titleContainer":"SnackBar_snackBar__titleContainer__GJEai","snackBar__titleContainer__closeImage":"SnackBar_snackBar__titleContainer__closeImage__lNZhe","snackBar__label":"SnackBar_snackBar__label___Yl8p","snackBar__title":"SnackBar_snackBar__title__l1TUj","snackBar__description":"SnackBar_snackBar__description__8tg9u","snackBar__button":"SnackBar_snackBar__button__rnoVG","snackBar__closeImage":"SnackBar_snackBar__closeImage__LiWYj","hide":"SnackBar_hide__rTjy1"};

/***/ }),

/***/ 90326:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"snackBar":"SnackBarWithDismiss_snackBar__C2x4k","snackBar__msgContainer":"SnackBarWithDismiss_snackBar__msgContainer__NnLVS","snackBar__titleContainer":"SnackBarWithDismiss_snackBar__titleContainer__IRvbm","snackBar__titleContainer__closeImage":"SnackBarWithDismiss_snackBar__titleContainer__closeImage__QDeJe","snackBar__label":"SnackBarWithDismiss_snackBar__label__vLATy","snackBar__title":"SnackBarWithDismiss_snackBar__title__iSW7L","snackBar__description":"SnackBarWithDismiss_snackBar__description__AqcZ_","snackBar__button":"SnackBarWithDismiss_snackBar__button__M8gw1","snackBar__closeImage":"SnackBarWithDismiss_snackBar__closeImage__jFuMi","hide":"SnackBarWithDismiss_hide__u5Xdk","snackBar__dismissContainer":"SnackBarWithDismiss_snackBar__dismissContainer__fKRHJ","dismissLink":"SnackBarWithDismiss_dismissLink__gf3a1"};

/***/ }),

/***/ 58151:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tooltipContainer":"Tooltip_tooltipContainer___I1ki","textStyle":"Tooltip_textStyle__2B_gT","toolTipIcon":"Tooltip_toolTipIcon__NP3TD"};

/***/ }),

/***/ 76618:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"native-select":"UpgradeDropdown_native-select__tmmv_","image-style":"UpgradeDropdown_image-style__whdk_","reset-variant":"UpgradeDropdown_reset-variant___ejrv","select":"UpgradeDropdown_select__Gkl1n","select__colour":"UpgradeDropdown_select__colour__P6sxV","select__text":"UpgradeDropdown_select__text__HCwHl","select__options":"UpgradeDropdown_select__options__Ox4s2","select__option":"UpgradeDropdown_select__option__JdaWU","select__option-disable":"UpgradeDropdown_select__option-disable__oR8ga","select__option--active":"UpgradeDropdown_select__option--active__Qyotf","select__option-disable--active":"UpgradeDropdown_select__option-disable--active___tNQv","select__option--active-flag":"UpgradeDropdown_select__option--active-flag__TYyq0","select__option-disable--active-flag":"UpgradeDropdown_select__option-disable--active-flag__crs2m","new-label":"UpgradeDropdown_new-label__a5ZYW","new-select":"UpgradeDropdown_new-select__6_a0a","deal-specification-modal":"UpgradeDropdown_deal-specification-modal__HgR6_"};

/***/ }),

/***/ 98918:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"search-box":"SearchBoxContainer_search-box__8O6Vg","img":"SearchBoxContainer_img__RVPLh","focus":"SearchBoxContainer_focus__1SZTX","search-input":"SearchBoxContainer_search-input__U2XwA","hintBlock-box":"SearchBoxContainer_hintBlock-box__677Rq"};

/***/ }),

/***/ 69418:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"error-card-block":"ErrorTooltip_error-card-block__JdN9W","textContainer":"ErrorTooltip_textContainer__VFtkp","error-card-block__message":"ErrorTooltip_error-card-block__message__0S7vC","error-card-block__icon":"ErrorTooltip_error-card-block__icon__R_AAF","dismiss_button":"ErrorTooltip_dismiss_button__n_l22","upgrade":"ErrorTooltip_upgrade__p9AFq","not_allow_place_order":"ErrorTooltip_not_allow_place_order__v4ZXz","error-card-message":"ErrorTooltip_error-card-message__pSBgg","orders_service":"ErrorTooltip_orders_service__7O7fN"};

/***/ }),

/***/ 73722:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"OtpInput_container__z7wXf"};

/***/ }),

/***/ 27199:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"search-container":"SearchNav_search-container__rCqSW","search-items":"SearchNav_search-items__P8lAq","search-box":"SearchNav_search-box__BR2Y5","img":"SearchNav_img__Y1j_H","search-input":"SearchNav_search-input__Nyi7b","cancel-btn":"SearchNav_cancel-btn__Bbo_V","horizantal-line":"SearchNav_horizantal-line___p_9o"};

/***/ }),

/***/ 43483:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"UpgradeBanner_banner__TU0bD","wrapper":"UpgradeBanner_wrapper__1Avl6","img":"UpgradeBanner_img__NRxqv","text":"UpgradeBanner_text__lFkCx","button":"UpgradeBanner_button__kKAfm"};

/***/ }),

/***/ 91635:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"upgrade-error-modal":"upgradeErrorModal_upgrade-error-modal__9TUrZ","modal-header":"upgradeErrorModal_modal-header__bYU6g","close-button":"upgradeErrorModal_close-button__QheHN","modal-body":"upgradeErrorModal_modal-body__hW6Ow","icon":"upgradeErrorModal_icon__OD4yc","icon-cross":"upgradeErrorModal_icon-cross__Tfqj7","title":"upgradeErrorModal_title__8K66Z","nextDate":"upgradeErrorModal_nextDate__NED1W","subText":"upgradeErrorModal_subText__mVwDZ","sub-content":"upgradeErrorModal_sub-content__gvwGV","content":"upgradeErrorModal_content__uAdcN","modal-footer":"upgradeErrorModal_modal-footer__5Oz_f","cancelUpgradeBttn":"upgradeErrorModal_cancelUpgradeBttn__VdbRr","cancel":"upgradeErrorModal_cancel__4j_Ui","disabled":"upgradeErrorModal_disabled__XOEJN","outlineWhite":"upgradeErrorModal_outlineWhite__dvMSJ","solidBlack":"upgradeErrorModal_solidBlack__mNb8p","secondary":"upgradeErrorModal_secondary__2hc2_","primary":"upgradeErrorModal_primary__swYme"};

/***/ }),

/***/ 57023:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"upgrade-modal":"UpgradeModal_upgrade-modal__IGuFT","upgrade-btn-continue":"UpgradeModal_upgrade-btn-continue__TyFO9","modal-body":"UpgradeModal_modal-body__s_mfR","upgrade-modal-continue":"UpgradeModal_upgrade-modal-continue__FcIb_","upgrade-modal-submit-otp":"UpgradeModal_upgrade-modal-submit-otp__X1Qmj","upgrademodal-header":"UpgradeModal_upgrademodal-header__TvL_j","close-button":"UpgradeModal_close-button__qgw0p","upgrade-continue":"UpgradeModal_upgrade-continue__Amb6A","select-number-form":"UpgradeModal_select-number-form__1fQ4W","num-3":"UpgradeModal_num-3__YHGCE","num-4":"UpgradeModal_num-4__ITW4o","singleNumber":"UpgradeModal_singleNumber__IqIoL","selctedNumber":"UpgradeModal_selctedNumber__0xGd2","re-send-otp-btn":"UpgradeModal_re-send-otp-btn__VTRf4","upgrade-btn-submit-otp":"UpgradeModal_upgrade-btn-submit-otp__5kplH","upgradeComponent":"UpgradeModal_upgradeComponent__VwRuy","icon":"UpgradeModal_icon__PbzT_","title":"UpgradeModal_title__UIzyv","description":"UpgradeModal_description__SPplW","infoText":"UpgradeModal_infoText__OwZEP","inputTitle":"UpgradeModal_inputTitle__FYmzT","input-box":"UpgradeModal_input-box__mYbuW","invalid":"UpgradeModal_invalid__pN2hL","checkboxContainer":"UpgradeModal_checkboxContainer__Xd_FJ","checkboxText":"UpgradeModal_checkboxText__N1FEN","otpInput":"UpgradeModal_otpInput__SN72P","buttonContainer":"UpgradeModal_buttonContainer__T3YB_","invalid-feedback":"UpgradeModal_invalid-feedback__lq00t","addnlInfo":"UpgradeModal_addnlInfo__HrrQg","big-margin-bottom":"UpgradeModal_big-margin-bottom__yX1DY","medium-margin-bottom":"UpgradeModal_medium-margin-bottom__3Q_jU","buttonContainerOTP":"UpgradeModal_buttonContainerOTP__Hofhd","otpContainer":"UpgradeModal_otpContainer__DXLB_","wrap-numbers":"UpgradeModal_wrap-numbers__0mWxJ","inputContainer":"UpgradeModal_inputContainer__17Bvx","mobileNumbers":"UpgradeModal_mobileNumbers__nr_F6"};

/***/ }),

/***/ 96602:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"internal-search-container":"InterNalSearch_internal-search-container__3AnS1","searched-items":"InterNalSearch_searched-items__bczW0","searched-heading":"InterNalSearch_searched-heading__LvmBG","product-labels":"InterNalSearch_product-labels__cNrD3"};

/***/ }),

/***/ 61373:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"toolTip":"UpgradeContainer_toolTip__P_rqE","tooltipCheckbox":"UpgradeContainer_tooltipCheckbox__hFHOE","snackBarStyle":"UpgradeContainer_snackBarStyle___8AIM"};

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(16505)


/***/ }),

/***/ 25675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(29938)


/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(77913)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(61587)


/***/ }),

/***/ 34155:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 4391:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = all;

var _createChainableTypeChecker = __webpack_require__(82613);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function all() {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  function allPropTypes() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var error = null;

    validators.forEach(function (validator) {
      if (error != null) {
        return;
      }

      var result = validator.apply(undefined, args);
      if (result != null) {
        error = result;
      }
    });

    return error;
  }

  return (0, _createChainableTypeChecker2.default)(allPropTypes);
}
module.exports = exports['default'];

/***/ }),

/***/ 55638:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isRequiredForA11y;
function isRequiredForA11y(validator) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}
module.exports = exports['default'];

/***/ }),

/***/ 82613:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 35005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63366);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var _SafeAnchor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48358);


var _excluded = ["bsPrefix", "variant", "size", "active", "className", "block", "type", "as"];




var defaultProps = {
  variant: 'primary',
  active: false,
  disabled: false
};
var Button = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      variant = _ref.variant,
      size = _ref.size,
      active = _ref.active,
      className = _ref.className,
      block = _ref.block,
      type = _ref.type,
      as = _ref.as,
      props = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  var prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'btn');
  var classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, prefix, active && 'active', variant && prefix + "-" + variant, block && prefix + "-block", size && prefix + "-" + size);

  if (props.href) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_SafeAnchor__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props, {
      as: as,
      ref: ref,
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(classes, props.disabled && 'disabled')
    }));
  }

  if (ref) {
    props.ref = ref;
  }

  if (type) {
    props.type = type;
  } else if (!as) {
    props.type = 'button';
  }

  var Component = as || 'button';
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props, {
    className: classes
  }));
});
Button.displayName = 'Button';
Button.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Button);

/***/ }),

/***/ 31555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63366);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);


var _excluded = ["bsPrefix", "className", "as"];



var DEVICE_SIZES = ['xl', 'lg', 'md', 'sm', 'xs'];
var Col = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      props = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  var prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'col');
  var spans = [];
  var classes = [];
  DEVICE_SIZES.forEach(function (brkPoint) {
    var propValue = props[brkPoint];
    delete props[brkPoint];
    var span;
    var offset;
    var order;

    if (typeof propValue === 'object' && propValue != null) {
      var _propValue$span = propValue.span;
      span = _propValue$span === void 0 ? true : _propValue$span;
      offset = propValue.offset;
      order = propValue.order;
    } else {
      span = propValue;
    }

    var infix = brkPoint !== 'xs' ? "-" + brkPoint : '';
    if (span) spans.push(span === true ? "" + prefix + infix : "" + prefix + infix + "-" + span);
    if (order != null) classes.push("order" + infix + "-" + order);
    if (offset != null) classes.push("offset" + infix + "-" + offset);
  });

  if (!spans.length) {
    spans.push(prefix); // plain 'col'
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props, {
    ref: ref,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default().apply(void 0, [className].concat(spans, classes))
  }));
});
Col.displayName = 'Col';
/* harmony default export */ __webpack_exports__["Z"] = (Col);

/***/ }),

/***/ 9966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63366);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dom_helpers_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91505);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26273);
/* harmony import */ var _transitionEndListener__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93825);
/* harmony import */ var _createChainedFunction__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16833);
/* harmony import */ var _triggerBrowserReflow__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34509);


var _excluded = ["onEnter", "onEntering", "onEntered", "onExit", "onExiting", "className", "children", "dimension", "getDimensionValue"];

var _collapseStyles;








var MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
};

function getDefaultDimensionValue(dimension, elem) {
  var offset = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
  var value = elem[offset];
  var margins = MARGINS[dimension];
  return value + // @ts-ignore
  parseInt((0,dom_helpers_css__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(elem, margins[0]), 10) + // @ts-ignore
  parseInt((0,dom_helpers_css__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(elem, margins[1]), 10);
}

var collapseStyles = (_collapseStyles = {}, _collapseStyles[react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_3__/* .EXITED */ .Wj] = 'collapse', _collapseStyles[react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_3__/* .EXITING */ .Ix] = 'collapsing', _collapseStyles[react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_3__/* .ENTERING */ .d0] = 'collapsing', _collapseStyles[react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_3__/* .ENTERED */ .cn] = 'collapse show', _collapseStyles);
var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  getDimensionValue: getDefaultDimensionValue
};
var Collapse = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function (_ref, ref) {
  var onEnter = _ref.onEnter,
      onEntering = _ref.onEntering,
      onEntered = _ref.onEntered,
      onExit = _ref.onExit,
      onExiting = _ref.onExiting,
      className = _ref.className,
      children = _ref.children,
      _ref$dimension = _ref.dimension,
      dimension = _ref$dimension === void 0 ? 'height' : _ref$dimension,
      _ref$getDimensionValu = _ref.getDimensionValue,
      getDimensionValue = _ref$getDimensionValu === void 0 ? getDefaultDimensionValue : _ref$getDimensionValu,
      props = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  /* Compute dimension */
  var computedDimension = typeof dimension === 'function' ? dimension() : dimension;
  /* -- Expanding -- */

  var handleEnter = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return (0,_createChainedFunction__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function (elem) {
      elem.style[computedDimension] = '0';
    }, onEnter);
  }, [computedDimension, onEnter]);
  var handleEntering = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return (0,_createChainedFunction__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function (elem) {
      var scroll = "scroll" + computedDimension[0].toUpperCase() + computedDimension.slice(1);
      elem.style[computedDimension] = elem[scroll] + "px";
    }, onEntering);
  }, [computedDimension, onEntering]);
  var handleEntered = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return (0,_createChainedFunction__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function (elem) {
      elem.style[computedDimension] = null;
    }, onEntered);
  }, [computedDimension, onEntered]);
  /* -- Collapsing -- */

  var handleExit = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return (0,_createChainedFunction__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function (elem) {
      elem.style[computedDimension] = getDimensionValue(computedDimension, elem) + "px";
      (0,_triggerBrowserReflow__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(elem);
    }, onExit);
  }, [onExit, getDimensionValue, computedDimension]);
  var handleExiting = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return (0,_createChainedFunction__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function (elem) {
      elem.style[computedDimension] = null;
    }, onExiting);
  }, [computedDimension, onExiting]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP // @ts-ignore
  , (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    ref: ref,
    addEndListener: _transitionEndListener__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z
  }, props, {
    "aria-expanded": props.role ? props.in : null,
    onEnter: handleEnter,
    onEntering: handleEntering,
    onEntered: handleEntered,
    onExit: handleExit,
    onExiting: handleExiting
  }), function (state, innerProps) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(children, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, innerProps, {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, children.props.className, collapseStyles[state], computedDimension === 'width' && 'width')
    }));
  });
}); // @ts-ignore

// @ts-ignore
Collapse.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Collapse);

/***/ }),

/***/ 10682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63366);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);


var _excluded = ["bsPrefix", "fluid", "as", "className"];



var defaultProps = {
  fluid: false
};
var Container = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      fluid = _ref.fluid,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      className = _ref.className,
      props = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  var prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'container');
  var suffix = typeof fluid === 'string' ? "-" + fluid : '-fluid';
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    ref: ref
  }, props, {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, fluid ? "" + prefix + suffix : prefix)
  }));
});
Container.displayName = 'Container';
Container.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Container);

/***/ }),

/***/ 41068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63366);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26273);
/* harmony import */ var _transitionEndListener__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93825);
/* harmony import */ var _triggerBrowserReflow__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34509);


var _excluded = ["className", "children"];

var _fadeStyles;






var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false
};
var fadeStyles = (_fadeStyles = {}, _fadeStyles[react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_2__/* .ENTERING */ .d0] = 'show', _fadeStyles[react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_2__/* .ENTERED */ .cn] = 'show', _fadeStyles);
var Fade = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      props = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  var handleEnter = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (node) {
    (0,_triggerBrowserReflow__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(node);
    if (props.onEnter) props.onEnter(node);
  }, [props]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    ref: ref,
    addEndListener: _transitionEndListener__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z
  }, props, {
    onEnter: handleEnter
  }), function (status, innerProps) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(children, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, innerProps, {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()('fade', className, children.props.className, fadeStyles[status])
    }));
  });
});
Fade.defaultProps = defaultProps;
Fade.displayName = 'Fade';
/* harmony default export */ __webpack_exports__["Z"] = (Fade);

/***/ }),

/***/ 95944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_OverlayTrigger; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/contains.js
var contains = __webpack_require__(90424);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useMounted.js
var useMounted = __webpack_require__(6454);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useWillUnmount.js + 1 modules
var useWillUnmount = __webpack_require__(76852);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useTimeout.js



/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */

var MAX_DELAY_MS = Math.pow(2, 31) - 1;

function setChainedTimeout(handleRef, fn, timeoutAtMs) {
  var delayMs = timeoutAtMs - Date.now();
  handleRef.current = delayMs <= MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(function () {
    return setChainedTimeout(handleRef, fn, timeoutAtMs);
  }, MAX_DELAY_MS);
}
/**
 * Returns a controller object for setting a timeout that is properly cleaned up
 * once the component unmounts. New timeouts cancel and replace existing ones.
 *
 *
 *
 * ```tsx
 * const { set, clear } = useTimeout();
 * const [hello, showHello] = useState(false);
 * //Display hello after 5 seconds
 * set(() => showHello(true), 5000);
 * return (
 *   <div className="App">
 *     {hello ? <h3>Hello</h3> : null}
 *   </div>
 * );
 * ```
 */


function useTimeout() {
  var isMounted = (0,useMounted/* default */.Z)(); // types are confused between node and web here IDK

  var handleRef = (0,react.useRef)();
  (0,useWillUnmount/* default */.Z)(function () {
    return clearTimeout(handleRef.current);
  });
  return (0,react.useMemo)(function () {
    var clear = function clear() {
      return clearTimeout(handleRef.current);
    };

    function set(fn, delayMs) {
      if (delayMs === void 0) {
        delayMs = 0;
      }

      if (!isMounted()) return;
      clear();

      if (delayMs <= MAX_DELAY_MS) {
        // For simplicity, if the timeout is short, just set a normal timeout.
        handleRef.current = setTimeout(fn, delayMs);
      } else {
        setChainedTimeout(handleRef, fn, Date.now() + delayMs);
      }
    }

    return {
      set: set,
      clear: clear
    };
  }, []);
}
// EXTERNAL MODULE: ./node_modules/react-overlays/esm/safeFindDOMNode.js
var safeFindDOMNode = __webpack_require__(46390);
// EXTERNAL MODULE: ./node_modules/warning/warning.js
var warning = __webpack_require__(42473);
// EXTERNAL MODULE: ./node_modules/uncontrollable/lib/esm/index.js + 4 modules
var esm = __webpack_require__(47150);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useCallbackRef.js
var useCallbackRef = __webpack_require__(32092);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useMergedRefs.js
var useMergedRefs = __webpack_require__(35654);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/enums.js
var enums = __webpack_require__(87701);
// EXTERNAL MODULE: ./node_modules/react-overlays/esm/usePopper.js + 53 modules
var usePopper = __webpack_require__(8534);
// EXTERNAL MODULE: ./node_modules/react-overlays/esm/useRootClose.js + 1 modules
var useRootClose = __webpack_require__(86453);
// EXTERNAL MODULE: ./node_modules/react-overlays/esm/useWaitForDOMRef.js
var useWaitForDOMRef = __webpack_require__(23446);
// EXTERNAL MODULE: ./node_modules/react-overlays/esm/mergeOptionsWithPopperConfig.js
var mergeOptionsWithPopperConfig = __webpack_require__(82343);
;// CONCATENATED MODULE: ./node_modules/react-overlays/esm/Overlay.js













/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */
var Overlay = /*#__PURE__*/react.forwardRef(function (props, outerRef) {
  var flip = props.flip,
      offset = props.offset,
      placement = props.placement,
      _props$containerPaddi = props.containerPadding,
      containerPadding = _props$containerPaddi === void 0 ? 5 : _props$containerPaddi,
      _props$popperConfig = props.popperConfig,
      popperConfig = _props$popperConfig === void 0 ? {} : _props$popperConfig,
      Transition = props.transition;

  var _useCallbackRef = (0,useCallbackRef/* default */.Z)(),
      rootElement = _useCallbackRef[0],
      attachRef = _useCallbackRef[1];

  var _useCallbackRef2 = (0,useCallbackRef/* default */.Z)(),
      arrowElement = _useCallbackRef2[0],
      attachArrowRef = _useCallbackRef2[1];

  var mergedRef = (0,useMergedRefs/* default */.Z)(attachRef, outerRef);
  var container = (0,useWaitForDOMRef/* default */.Z)(props.container);
  var target = (0,useWaitForDOMRef/* default */.Z)(props.target);

  var _useState = (0,react.useState)(!props.show),
      exited = _useState[0],
      setExited = _useState[1];

  var _usePopper = (0,usePopper/* default */.Z)(target, rootElement, (0,mergeOptionsWithPopperConfig/* default */.ZP)({
    placement: placement,
    enableEvents: !!props.show,
    containerPadding: containerPadding || 5,
    flip: flip,
    offset: offset,
    arrowElement: arrowElement,
    popperConfig: popperConfig
  })),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes,
      popper = (0,objectWithoutPropertiesLoose/* default */.Z)(_usePopper, ["styles", "attributes"]);

  if (props.show) {
    if (exited) setExited(false);
  } else if (!props.transition && !exited) {
    setExited(true);
  }

  var handleHidden = function handleHidden() {
    setExited(true);

    if (props.onExited) {
      props.onExited.apply(props, arguments);
    }
  }; // Don't un-render the overlay while it's transitioning out.


  var mountOverlay = props.show || Transition && !exited;
  (0,useRootClose/* default */.Z)(rootElement, props.onHide, {
    disabled: !props.rootClose || props.rootCloseDisabled,
    clickTrigger: props.rootCloseEvent
  });

  if (!mountOverlay) {
    // Don't bother showing anything if we don't have to.
    return null;
  }

  var child = props.children((0,esm_extends/* default */.Z)({}, popper, {
    show: !!props.show,
    props: (0,esm_extends/* default */.Z)({}, attributes.popper, {
      style: styles.popper,
      ref: mergedRef
    }),
    arrowProps: (0,esm_extends/* default */.Z)({}, attributes.arrow, {
      style: styles.arrow,
      ref: attachArrowRef
    })
  }));

  if (Transition) {
    var onExit = props.onExit,
        onExiting = props.onExiting,
        onEnter = props.onEnter,
        onEntering = props.onEntering,
        onEntered = props.onEntered;
    child = /*#__PURE__*/react.createElement(Transition, {
      "in": props.show,
      appear: true,
      onExit: onExit,
      onExiting: onExiting,
      onExited: handleHidden,
      onEnter: onEnter,
      onEntering: onEntering,
      onEntered: onEntered
    }, child);
  }

  return container ? /*#__PURE__*/react_dom.createPortal(child, container) : null;
});
Overlay.displayName = 'Overlay';
Overlay.propTypes = {
  /**
   * Set the visibility of the Overlay
   */
  show: (prop_types_default()).bool,

  /** Specify where the overlay element is positioned in relation to the target element */
  placement: prop_types_default().oneOf(enums/* placements */.Ct),

  /**
   * A DOM Element, Ref to an element, or function that returns either. The `target` element is where
   * the overlay is positioned relative to.
   */
  target: (prop_types_default()).any,

  /**
   * A DOM Element, Ref to an element, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: (prop_types_default()).any,

  /**
   * Enables the Popper.js `flip` modifier, allowing the Overlay to
   * automatically adjust it's placement in case of overlap with the viewport or toggle.
   * Refer to the [flip docs](https://popper.js.org/popper-documentation.html#modifiers..flip.enabled) for more info
   */
  flip: (prop_types_default()).bool,

  /**
   * A render prop that returns an element to overlay and position. See
   * the [react-popper documentation](https://github.com/FezVrasta/react-popper#children) for more info.
   *
   * @type {Function ({
   *   show: boolean,
   *   placement: Placement,
   *   update: () => void,
   *   forceUpdate: () => void,
   *   props: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     aria-labelledby: ?string
   *     [string]: string | number,
   *   },
   *   arrowProps: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     [string]: string | number,
   *   },
   * }) => React.Element}
   */
  children: (prop_types_default()).func.isRequired,

  /**
   * Control how much space there is between the edge of the boundary element and overlay.
   * A convenience shortcut to setting `popperConfig.modfiers.preventOverflow.padding`
   */
  containerPadding: (prop_types_default()).number,

  /**
   * A set of popper options and props passed directly to react-popper's Popper component.
   */
  popperConfig: (prop_types_default()).object,

  /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */
  rootClose: (prop_types_default()).bool,

  /**
   * Specify event for toggling overlay
   */
  rootCloseEvent: prop_types_default().oneOf(['click', 'mousedown']),

  /**
   * Specify disabled for disable RootCloseWrapper
   */
  rootCloseDisabled: (prop_types_default()).bool,

  /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */
  onHide: function onHide(props) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (props.rootClose) {
      var _PropTypes$func;

      return (_PropTypes$func = (prop_types_default()).func).isRequired.apply(_PropTypes$func, [props].concat(args));
    }

    return prop_types_default().func.apply((prop_types_default()), [props].concat(args));
  },

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component
   * used to animate the overlay as it changes visibility.
   */
  // @ts-ignore
  transition: (prop_types_default()).elementType,

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: (prop_types_default()).func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: (prop_types_default()).func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: (prop_types_default()).func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: (prop_types_default()).func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: (prop_types_default()).func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: (prop_types_default()).func
};
/* harmony default export */ var esm_Overlay = (Overlay);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/usePopperMarginModifiers.js
var usePopperMarginModifiers = __webpack_require__(73509);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Fade.js
var Fade = __webpack_require__(41068);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Overlay.js


var _excluded = ["children", "transition", "popperConfig"],
    _excluded2 = ["props", "arrowProps", "show", "update", "forceUpdate", "placement", "state"];






var defaultProps = {
  transition: Fade/* default */.Z,
  rootClose: false,
  show: false,
  placement: 'top'
};

function wrapRefs(props, arrowProps) {
  var ref = props.ref;
  var aRef = arrowProps.ref;

  props.ref = ref.__wrapped || (ref.__wrapped = function (r) {
    return ref((0,safeFindDOMNode/* default */.Z)(r));
  });

  arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = function (r) {
    return aRef((0,safeFindDOMNode/* default */.Z)(r));
  });
}

function Overlay_Overlay(_ref) {
  var overlay = _ref.children,
      transition = _ref.transition,
      _ref$popperConfig = _ref.popperConfig,
      popperConfig = _ref$popperConfig === void 0 ? {} : _ref$popperConfig,
      outerProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, _excluded);

  var popperRef = (0,react.useRef)({});

  var _usePopperMarginModif = (0,usePopperMarginModifiers/* default */.Z)(),
      ref = _usePopperMarginModif[0],
      marginModifiers = _usePopperMarginModif[1];

  var actualTransition = transition === true ? Fade/* default */.Z : transition || null;
  return /*#__PURE__*/react.createElement(esm_Overlay, (0,esm_extends/* default */.Z)({}, outerProps, {
    ref: ref,
    popperConfig: (0,esm_extends/* default */.Z)({}, popperConfig, {
      modifiers: marginModifiers.concat(popperConfig.modifiers || [])
    }),
    transition: actualTransition
  }), function (_ref2) {
    var _state$modifiersData$;

    var overlayProps = _ref2.props,
        arrowProps = _ref2.arrowProps,
        show = _ref2.show,
        update = _ref2.update,
        _ = _ref2.forceUpdate,
        placement = _ref2.placement,
        state = _ref2.state,
        props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, _excluded2);

    wrapRefs(overlayProps, arrowProps);
    var popper = Object.assign(popperRef.current, {
      state: state,
      scheduleUpdate: update,
      placement: placement,
      outOfBoundaries: (state == null ? void 0 : (_state$modifiersData$ = state.modifiersData.hide) == null ? void 0 : _state$modifiersData$.isReferenceHidden) || false
    });
    if (typeof overlay === 'function') return overlay((0,esm_extends/* default */.Z)({}, props, overlayProps, {
      placement: placement,
      show: show
    }, !transition && show && {
      className: 'show'
    }, {
      popper: popper,
      arrowProps: arrowProps
    }));
    return /*#__PURE__*/react.cloneElement(overlay, (0,esm_extends/* default */.Z)({}, props, overlayProps, {
      placement: placement,
      arrowProps: arrowProps,
      popper: popper,
      className: classnames_default()(overlay.props.className, !transition && show && 'show'),
      style: (0,esm_extends/* default */.Z)({}, overlay.props.style, overlayProps.style)
    }));
  });
}

Overlay_Overlay.defaultProps = defaultProps;
/* harmony default export */ var react_bootstrap_esm_Overlay = (Overlay_Overlay);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/OverlayTrigger.js



var OverlayTrigger_excluded = ["trigger", "overlay", "children", "popperConfig", "show", "defaultShow", "onToggle", "delay", "placement", "flip"];








var RefHolder = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(RefHolder, _React$Component);

  function RefHolder() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = RefHolder.prototype;

  _proto.render = function render() {
    return this.props.children;
  };

  return RefHolder;
}(react.Component);

function normalizeDelay(delay) {
  return delay && typeof delay === 'object' ? delay : {
    show: delay,
    hide: delay
  };
} // Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.


function handleMouseOverOut( // eslint-disable-next-line @typescript-eslint/no-shadow
handler, args, relatedNative) {
  var e = args[0];
  var target = e.currentTarget;
  var related = e.relatedTarget || e.nativeEvent[relatedNative];

  if ((!related || related !== target) && !(0,contains/* default */.Z)(target, related)) {
    handler.apply(void 0, args);
  }
}

var OverlayTrigger_defaultProps = {
  defaultShow: false,
  trigger: ['hover', 'focus']
};

function OverlayTrigger(_ref) {
  var trigger = _ref.trigger,
      overlay = _ref.overlay,
      children = _ref.children,
      _ref$popperConfig = _ref.popperConfig,
      popperConfig = _ref$popperConfig === void 0 ? {} : _ref$popperConfig,
      propsShow = _ref.show,
      _ref$defaultShow = _ref.defaultShow,
      defaultShow = _ref$defaultShow === void 0 ? false : _ref$defaultShow,
      onToggle = _ref.onToggle,
      propsDelay = _ref.delay,
      placement = _ref.placement,
      _ref$flip = _ref.flip,
      flip = _ref$flip === void 0 ? placement && placement.indexOf('auto') !== -1 : _ref$flip,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, OverlayTrigger_excluded);

  var triggerNodeRef = (0,react.useRef)(null);
  var timeout = useTimeout();
  var hoverStateRef = (0,react.useRef)('');

  var _useUncontrolledProp = (0,esm/* useUncontrolledProp */.$c)(propsShow, defaultShow, onToggle),
      show = _useUncontrolledProp[0],
      setShow = _useUncontrolledProp[1];

  var delay = normalizeDelay(propsDelay);

  var _ref2 = typeof children !== 'function' ? react.Children.only(children).props : {},
      onFocus = _ref2.onFocus,
      onBlur = _ref2.onBlur,
      onClick = _ref2.onClick;

  var getTarget = (0,react.useCallback)(function () {
    return (0,safeFindDOMNode/* default */.Z)(triggerNodeRef.current);
  }, []);
  var handleShow = (0,react.useCallback)(function () {
    timeout.clear();
    hoverStateRef.current = 'show';

    if (!delay.show) {
      setShow(true);
      return;
    }

    timeout.set(function () {
      if (hoverStateRef.current === 'show') setShow(true);
    }, delay.show);
  }, [delay.show, setShow, timeout]);
  var handleHide = (0,react.useCallback)(function () {
    timeout.clear();
    hoverStateRef.current = 'hide';

    if (!delay.hide) {
      setShow(false);
      return;
    }

    timeout.set(function () {
      if (hoverStateRef.current === 'hide') setShow(false);
    }, delay.hide);
  }, [delay.hide, setShow, timeout]);
  var handleFocus = (0,react.useCallback)(function () {
    handleShow();

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    onFocus == null ? void 0 : onFocus.apply(void 0, args);
  }, [handleShow, onFocus]);
  var handleBlur = (0,react.useCallback)(function () {
    handleHide();

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    onBlur == null ? void 0 : onBlur.apply(void 0, args);
  }, [handleHide, onBlur]);
  var handleClick = (0,react.useCallback)(function () {
    setShow(!show);
    if (onClick) onClick.apply(void 0, arguments);
  }, [onClick, setShow, show]);
  var handleMouseOver = (0,react.useCallback)(function () {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    handleMouseOverOut(handleShow, args, 'fromElement');
  }, [handleShow]);
  var handleMouseOut = (0,react.useCallback)(function () {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    handleMouseOverOut(handleHide, args, 'toElement');
  }, [handleHide]);
  var triggers = trigger == null ? [] : [].concat(trigger);
  var triggerProps = {};

  if (triggers.indexOf('click') !== -1) {
    triggerProps.onClick = handleClick;
  }

  if (triggers.indexOf('focus') !== -1) {
    triggerProps.onFocus = handleFocus;
    triggerProps.onBlur = handleBlur;
  }

  if (triggers.indexOf('hover') !== -1) {
     false ? 0 : void 0;
    triggerProps.onMouseOver = handleMouseOver;
    triggerProps.onMouseOut = handleMouseOut;
  }

  return /*#__PURE__*/react.createElement(react.Fragment, null, typeof children === 'function' ? children((0,esm_extends/* default */.Z)({}, triggerProps, {
    ref: triggerNodeRef
  })) : /*#__PURE__*/react.createElement(RefHolder, {
    ref: triggerNodeRef
  }, /*#__PURE__*/(0,react.cloneElement)(children, triggerProps)), /*#__PURE__*/react.createElement(react_bootstrap_esm_Overlay, (0,esm_extends/* default */.Z)({}, props, {
    show: show,
    onHide: handleHide,
    flip: flip,
    placement: placement,
    popperConfig: popperConfig,
    target: getTarget
  }), overlay));
}

OverlayTrigger.defaultProps = OverlayTrigger_defaultProps;
/* harmony default export */ var esm_OverlayTrigger = (OverlayTrigger);

/***/ }),

/***/ 21608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63366);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);


var _excluded = ["bsPrefix", "className", "noGutters", "as"];



var DEVICE_SIZES = ['xl', 'lg', 'md', 'sm', 'xs'];
var defaultProps = {
  noGutters: false
};
var Row = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      noGutters = _ref.noGutters,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      props = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  var decoratedBsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'row');
  var sizePrefix = decoratedBsPrefix + "-cols";
  var classes = [];
  DEVICE_SIZES.forEach(function (brkPoint) {
    var propValue = props[brkPoint];
    delete props[brkPoint];
    var cols;

    if (propValue != null && typeof propValue === 'object') {
      cols = propValue.cols;
    } else {
      cols = propValue;
    }

    var infix = brkPoint !== 'xs' ? "-" + brkPoint : '';
    if (cols != null) classes.push("" + sizePrefix + infix + "-" + cols);
  });
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    ref: ref
  }, props, {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default().apply(void 0, [className, decoratedBsPrefix, noGutters && 'no-gutters'].concat(classes))
  }));
});
Row.displayName = 'Row';
Row.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Row);

/***/ }),

/***/ 48358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63366);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _createChainedFunction__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16833);


var _excluded = ["as", "disabled", "onKeyDown"];



function isTrivialHref(href) {
  return !href || href.trim() === '#';
}
/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, DropdownItems, etc.
 */


var SafeAnchor = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'a' : _ref$as,
      disabled = _ref.disabled,
      onKeyDown = _ref.onKeyDown,
      props = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, _excluded);

  var handleClick = function handleClick(event) {
    var href = props.href,
        onClick = props.onClick;

    if (disabled || isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === ' ') {
      event.preventDefault();
      handleClick(event);
    }
  };

  if (isTrivialHref(props.href)) {
    props.role = props.role || 'button'; // we want to make sure there is a href attribute on the node
    // otherwise, the cursor incorrectly styled (except with role='button')

    props.href = props.href || '#';
  }

  if (disabled) {
    props.tabIndex = -1;
    props['aria-disabled'] = true;
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    ref: ref
  }, props, {
    onClick: handleClick,
    onKeyDown: (0,_createChainedFunction__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(handleKeyDown, onKeyDown)
  }));
});
SafeAnchor.displayName = 'SafeAnchor';
/* harmony default export */ __webpack_exports__["Z"] = (SafeAnchor);

/***/ }),

/***/ 76792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "vE": function() { return /* binding */ useBootstrapPrefix; }
/* harmony export */ });
/* unused harmony exports createBootstrapComponent, ThemeConsumer */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var ThemeContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
var Consumer = ThemeContext.Consumer,
    Provider = ThemeContext.Provider;

function ThemeProvider(_ref) {
  var prefixes = _ref.prefixes,
      children = _ref.children;
  var copiedPrefixes = useMemo(function () {
    return _extends({}, prefixes);
  }, [prefixes]);
  return /*#__PURE__*/React.createElement(Provider, {
    value: copiedPrefixes
  }, children);
}

function useBootstrapPrefix(prefix, defaultPrefix) {
  var prefixes = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ThemeContext);
  return prefix || prefixes[defaultPrefix] || defaultPrefix;
}

function createBootstrapComponent(Component, opts) {
  if (typeof opts === 'string') opts = {
    prefix: opts
  };
  var isClassy = Component.prototype && Component.prototype.isReactComponent; // If it's a functional component make sure we don't break it with a ref

  var _opts = opts,
      prefix = _opts.prefix,
      _opts$forwardRefAs = _opts.forwardRefAs,
      forwardRefAs = _opts$forwardRefAs === void 0 ? isClassy ? 'ref' : 'innerRef' : _opts$forwardRefAs;
  var Wrapped = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
    var props = _extends({}, _ref2);

    props[forwardRefAs] = ref;
    var bsPrefix = useBootstrapPrefix(props.bsPrefix, prefix);
    return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      bsPrefix: bsPrefix
    }));
  });
  Wrapped.displayName = "Bootstrap(" + (Component.displayName || Component.name) + ")";
  return Wrapped;
}


/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (ThemeProvider)));

/***/ }),

/***/ 43489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63366);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types_extra_lib_isRequiredForA11y__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55638);
/* harmony import */ var prop_types_extra_lib_isRequiredForA11y__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types_extra_lib_isRequiredForA11y__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76792);


var _excluded = ["bsPrefix", "placement", "className", "style", "children", "arrowProps", "popper", "show"];




var defaultProps = {
  placement: 'right'
};
var Tooltip = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      placement = _ref.placement,
      className = _ref.className,
      style = _ref.style,
      children = _ref.children,
      arrowProps = _ref.arrowProps,
      _ = _ref.popper,
      _2 = _ref.show,
      props = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_4__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'tooltip');

  var _ref2 = (placement == null ? void 0 : placement.split('-')) || [],
      primaryPlacement = _ref2[0];

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    ref: ref,
    style: style,
    role: "tooltip",
    "x-placement": primaryPlacement,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, bsPrefix, "bs-tooltip-" + primaryPlacement)
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    className: "arrow"
  }, arrowProps)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: bsPrefix + "-inner"
  }, children));
});
Tooltip.defaultProps = defaultProps;
Tooltip.displayName = 'Tooltip';
/* harmony default export */ __webpack_exports__["Z"] = (Tooltip);

/***/ }),

/***/ 16833:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (f) {
    return f != null;
  }).reduce(function (acc, f) {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) return f;
    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      // @ts-ignore
      acc.apply(this, args); // @ts-ignore

      f.apply(this, args);
    };
  }, null);
}

/* harmony default export */ __webpack_exports__["Z"] = (createChainedFunction);

/***/ }),

/***/ 93825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ transitionEndListener; }
/* harmony export */ });
/* harmony import */ var dom_helpers_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91505);
/* harmony import */ var dom_helpers_transitionEnd__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94305);



function parseDuration(node, property) {
  var str = (0,dom_helpers_css__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(node, property) || '';
  var mult = str.indexOf('ms') === -1 ? 1000 : 1;
  return parseFloat(str) * mult;
}

function transitionEndListener(element, handler) {
  var duration = parseDuration(element, 'transitionDuration');
  var delay = parseDuration(element, 'transitionDelay');
  var remove = (0,dom_helpers_transitionEnd__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(element, function (e) {
    if (e.target === element) {
      remove();
      handler(e);
    }
  }, duration + delay);
}

/***/ }),

/***/ 34509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ triggerBrowserReflow; }
/* harmony export */ });
// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function triggerBrowserReflow(node) {
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  node.offsetHeight;
}

/***/ }),

/***/ 73509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePopperMarginModifiers; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var dom_helpers_hasClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11132);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76792);




function getMargins(element) {
  var styles = window.getComputedStyle(element);
  var top = parseFloat(styles.marginTop) || 0;
  var right = parseFloat(styles.marginRight) || 0;
  var bottom = parseFloat(styles.marginBottom) || 0;
  var left = parseFloat(styles.marginLeft) || 0;
  return {
    top: top,
    right: right,
    bottom: bottom,
    left: left
  };
}

function usePopperMarginModifiers() {
  var overlayRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var margins = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var arrowMargins = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var popoverClass = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_1__/* .useBootstrapPrefix */ .vE)(undefined, 'popover');
  var dropdownMenuClass = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_1__/* .useBootstrapPrefix */ .vE)(undefined, 'dropdown-menu');
  var callback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (overlay) {
    if (!overlay || !((0,dom_helpers_hasClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(overlay, popoverClass) || (0,dom_helpers_hasClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(overlay, dropdownMenuClass))) return;
    margins.current = getMargins(overlay);
    overlay.style.margin = '0';
    overlayRef.current = overlay;
  }, [popoverClass, dropdownMenuClass]);
  var offset = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return {
      name: 'offset',
      options: {
        offset: function offset(_ref) {
          var placement = _ref.placement;
          if (!margins.current) return [0, 0];
          var _margins$current = margins.current,
              top = _margins$current.top,
              left = _margins$current.left,
              bottom = _margins$current.bottom,
              right = _margins$current.right;

          switch (placement.split('-')[0]) {
            case 'top':
              return [0, bottom];

            case 'left':
              return [0, right];

            case 'bottom':
              return [0, top];

            case 'right':
              return [0, left];

            default:
              return [0, 0];
          }
        }
      }
    };
  }, [margins]);
  var arrow = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return {
      name: 'arrow',
      options: {
        padding: function padding() {
          // The options here are used for Popper 2.8.4 and up.
          // For earlier version, padding is handled in popoverArrowMargins below.
          if (!arrowMargins.current) {
            return 0;
          }

          var _arrowMargins$current = arrowMargins.current,
              top = _arrowMargins$current.top,
              right = _arrowMargins$current.right;
          var padding = top || right;
          return {
            top: padding,
            left: padding,
            right: padding,
            bottom: padding
          };
        }
      }
    };
  }, [arrowMargins]); // Converts popover arrow margin to arrow modifier padding

  var popoverArrowMargins = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return {
      name: 'popoverArrowMargins',
      enabled: true,
      phase: 'main',
      fn: function fn() {
        return undefined;
      },
      requiresIfExists: ['arrow'],
      effect: function effect(_ref2) {
        var state = _ref2.state;

        if (!overlayRef.current || !state.elements.arrow || !(0,dom_helpers_hasClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(overlayRef.current, popoverClass)) {
          return undefined;
        }

        if (state.modifiersData['arrow#persistent']) {
          // @popperjs/core <= 2.8.3 uses arrow#persistent to pass padding to arrow modifier.
          var _getMargins = getMargins(state.elements.arrow),
              top = _getMargins.top,
              right = _getMargins.right;

          var padding = top || right;
          state.modifiersData['arrow#persistent'].padding = {
            top: padding,
            left: padding,
            right: padding,
            bottom: padding
          };
        } else {
          // @popperjs/core >= 2.8.4 gets the padding from the arrow modifier options,
          // so we'll get the margins here, and let the arrow modifier above pass
          // it to popper.
          arrowMargins.current = getMargins(state.elements.arrow);
        }

        state.elements.arrow.style.margin = '0';
        return function () {
          if (state.elements.arrow) state.elements.arrow.style.margin = '';
        };
      }
    };
  }, [popoverClass]);
  return [callback, [offset, arrow, popoverArrowMargins]];
}

/***/ }),

/***/ 98130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bu": function() { return /* binding */ zeroPad; },
/* harmony export */   "Y6": function() { return /* binding */ calcTimeDelta; }
/* harmony export */ });
/* unused harmony export formatTimeDelta */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);



function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function zeroPad(value) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var strValue = String(value);
  if (length === 0) return strValue;
  var match = strValue.match(/(.*?)([0-9]+)(.*)/);
  var prefix = match ? match[1] : '';
  var suffix = match ? match[3] : '';
  var strNo = match ? match[2] : strValue;
  var paddedNo = strNo.length >= length ? strNo : (_toConsumableArray(Array(length)).map(function () {
    return '0';
  }).join('') + strNo).slice(length * -1);
  return "".concat(prefix).concat(paddedNo).concat(suffix);
}
var timeDeltaFormatOptionsDefaults = {
  daysInHours: false,
  zeroPadTime: 2
};
function calcTimeDelta(date) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$now = options.now,
      now = _options$now === void 0 ? Date.now : _options$now,
      _options$precision = options.precision,
      precision = _options$precision === void 0 ? 0 : _options$precision,
      controlled = options.controlled,
      _options$offsetTime = options.offsetTime,
      offsetTime = _options$offsetTime === void 0 ? 0 : _options$offsetTime,
      overtime = options.overtime;
  var startTimestamp;

  if (typeof date === 'string') {
    startTimestamp = new Date(date).getTime();
  } else if (date instanceof Date) {
    startTimestamp = date.getTime();
  } else {
    startTimestamp = date;
  }

  if (!controlled) {
    startTimestamp += offsetTime;
  }

  var timeLeft = controlled ? startTimestamp : startTimestamp - now();
  var clampedPrecision = Math.min(20, Math.max(0, precision));
  var total = Math.round(parseFloat(((overtime ? timeLeft : Math.max(0, timeLeft)) / 1000).toFixed(clampedPrecision)) * 1000);
  var seconds = Math.abs(total) / 1000;
  return {
    total: total,
    days: Math.floor(seconds / (3600 * 24)),
    hours: Math.floor(seconds / 3600 % 24),
    minutes: Math.floor(seconds / 60 % 60),
    seconds: Math.floor(seconds % 60),
    milliseconds: Number((seconds % 1 * 1000).toFixed()),
    completed: total <= 0
  };
}
function formatTimeDelta(timeDelta, options) {
  var days = timeDelta.days,
      hours = timeDelta.hours,
      minutes = timeDelta.minutes,
      seconds = timeDelta.seconds;

  var _Object$assign = Object.assign(Object.assign({}, timeDeltaFormatOptionsDefaults), options),
      daysInHours = _Object$assign.daysInHours,
      zeroPadTime = _Object$assign.zeroPadTime,
      _Object$assign$zeroPa = _Object$assign.zeroPadDays,
      zeroPadDays = _Object$assign$zeroPa === void 0 ? zeroPadTime : _Object$assign$zeroPa;

  var zeroPadTimeLength = Math.min(2, zeroPadTime);
  var formattedHours = daysInHours ? zeroPad(hours + days * 24, zeroPadTime) : zeroPad(hours, zeroPadTimeLength);
  return {
    days: daysInHours ? '' : zeroPad(days, zeroPadDays),
    hours: formattedHours,
    minutes: zeroPad(minutes, zeroPadTimeLength),
    seconds: zeroPad(seconds, zeroPadTimeLength)
  };
}

var Countdown = function (_React$Component) {
  _inherits(Countdown, _React$Component);

  var _super = _createSuper(Countdown);

  function Countdown() {
    var _this;

    _classCallCheck(this, Countdown);

    _this = _super.apply(this, arguments);
    _this.state = {
      count: _this.props.count || 3
    };

    _this.startCountdown = function () {
      _this.interval = window.setInterval(function () {
        var count = _this.state.count - 1;

        if (count === 0) {
          _this.stopCountdown();

          _this.props.onComplete && _this.props.onComplete();
        } else {
          _this.setState(function (prevState) {
            return {
              count: prevState.count - 1
            };
          });
        }
      }, 1000);
    };

    _this.stopCountdown = function () {
      clearInterval(_this.interval);
    };

    _this.addTime = function (seconds) {
      _this.stopCountdown();

      _this.setState(function (prevState) {
        return {
          count: prevState.count + seconds
        };
      }, _this.startCountdown);
    };

    return _this;
  }

  _createClass(Countdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startCountdown();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children ? (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(this.props.children, {
        count: this.state.count
      }) : null;
    }
  }]);

  return Countdown;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
Countdown.propTypes = {
  count: prop_types__WEBPACK_IMPORTED_MODULE_1__.number,
  children: prop_types__WEBPACK_IMPORTED_MODULE_1__.element,
  onComplete: prop_types__WEBPACK_IMPORTED_MODULE_1__.func
};

var Countdown$1 = function (_React$Component) {
  _inherits(Countdown$1, _React$Component);

  var _super = _createSuper(Countdown$1);

  function Countdown$1(props) {
    var _this;

    _classCallCheck(this, Countdown$1);

    _this = _super.call(this, props);
    _this.mounted = false;
    _this.initialTimestamp = _this.calcOffsetStartTimestamp();
    _this.offsetStartTimestamp = _this.props.autoStart ? 0 : _this.initialTimestamp;
    _this.offsetTime = 0;
    _this.legacyMode = false;
    _this.legacyCountdownRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.createRef)();

    _this.tick = function () {
      var timeDelta = _this.calcTimeDelta();

      var callback = timeDelta.completed && !_this.props.overtime ? undefined : _this.props.onTick;

      _this.setTimeDeltaState(timeDelta, undefined, callback);
    };

    _this.start = function () {
      if (_this.isStarted()) return;
      var prevOffsetStartTimestamp = _this.offsetStartTimestamp;
      _this.offsetStartTimestamp = 0;
      _this.offsetTime += prevOffsetStartTimestamp ? _this.calcOffsetStartTimestamp() - prevOffsetStartTimestamp : 0;

      var timeDelta = _this.calcTimeDelta();

      _this.setTimeDeltaState(timeDelta, "STARTED", _this.props.onStart);

      if (!_this.props.controlled && (!timeDelta.completed || _this.props.overtime)) {
        _this.clearTimer();

        _this.interval = window.setInterval(_this.tick, _this.props.intervalDelay);
      }
    };

    _this.pause = function () {
      if (_this.isPaused()) return;

      _this.clearTimer();

      _this.offsetStartTimestamp = _this.calcOffsetStartTimestamp();

      _this.setTimeDeltaState(_this.state.timeDelta, "PAUSED", _this.props.onPause);
    };

    _this.stop = function () {
      if (_this.isStopped()) return;

      _this.clearTimer();

      _this.offsetStartTimestamp = _this.calcOffsetStartTimestamp();
      _this.offsetTime = _this.offsetStartTimestamp - _this.initialTimestamp;

      _this.setTimeDeltaState(_this.calcTimeDelta(), "STOPPED", _this.props.onStop);
    };

    _this.isStarted = function () {
      return _this.isStatus("STARTED");
    };

    _this.isPaused = function () {
      return _this.isStatus("PAUSED");
    };

    _this.isStopped = function () {
      return _this.isStatus("STOPPED");
    };

    _this.isCompleted = function () {
      return _this.isStatus("COMPLETED");
    };

    if (props.date) {
      var timeDelta = _this.calcTimeDelta();

      _this.state = {
        timeDelta: timeDelta,
        status: timeDelta.completed ? "COMPLETED" : "STOPPED"
      };
    } else {
      _this.legacyMode = true;
    }

    return _this;
  }

  _createClass(Countdown$1, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.legacyMode) {
        return;
      }

      this.mounted = true;
      if (this.props.onMount) this.props.onMount(this.calcTimeDelta());
      if (this.props.autoStart) this.start();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.legacyMode) {
        return;
      }

      if (this.props.date !== prevProps.date) {
        this.initialTimestamp = this.calcOffsetStartTimestamp();
        this.offsetStartTimestamp = this.initialTimestamp;
        this.offsetTime = 0;
        this.setTimeDeltaState(this.calcTimeDelta());
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.legacyMode) {
        return;
      }

      this.mounted = false;
      this.clearTimer();
    }
  }, {
    key: "calcTimeDelta",
    value: function calcTimeDelta$1() {
      var _this$props = this.props,
          date = _this$props.date,
          now = _this$props.now,
          precision = _this$props.precision,
          controlled = _this$props.controlled,
          overtime = _this$props.overtime;
      return calcTimeDelta(date, {
        now: now,
        precision: precision,
        controlled: controlled,
        offsetTime: this.offsetTime,
        overtime: overtime
      });
    }
  }, {
    key: "calcOffsetStartTimestamp",
    value: function calcOffsetStartTimestamp() {
      return Date.now();
    }
  }, {
    key: "addTime",
    value: function addTime(seconds) {
      this.legacyCountdownRef.current.addTime(seconds);
    }
  }, {
    key: "clearTimer",
    value: function clearTimer() {
      window.clearInterval(this.interval);
    }
  }, {
    key: "isStatus",
    value: function isStatus(status) {
      return this.state.status === status;
    }
  }, {
    key: "setTimeDeltaState",
    value: function setTimeDeltaState(timeDelta, status, callback) {
      var _this2 = this;

      if (!this.mounted) return;
      var completing = timeDelta.completed && !this.state.timeDelta.completed;
      var completedOnStart = timeDelta.completed && status === "STARTED";

      if (completing && !this.props.overtime) {
        this.clearTimer();
      }

      var onDone = function onDone() {
        if (callback) callback(_this2.state.timeDelta);

        if (_this2.props.onComplete && (completing || completedOnStart)) {
          _this2.props.onComplete(timeDelta, completedOnStart);
        }
      };

      return this.setState(function (prevState) {
        var newStatus = status || prevState.status;

        if (timeDelta.completed && !_this2.props.overtime) {
          newStatus = "COMPLETED";
        } else if (!status && newStatus === "COMPLETED") {
          newStatus = "STOPPED";
        }

        return {
          timeDelta: timeDelta,
          status: newStatus
        };
      }, onDone);
    }
  }, {
    key: "getApi",
    value: function getApi() {
      return this.api = this.api || {
        start: this.start,
        pause: this.pause,
        stop: this.stop,
        isStarted: this.isStarted,
        isPaused: this.isPaused,
        isStopped: this.isStopped,
        isCompleted: this.isCompleted
      };
    }
  }, {
    key: "getRenderProps",
    value: function getRenderProps() {
      var _this$props2 = this.props,
          daysInHours = _this$props2.daysInHours,
          zeroPadTime = _this$props2.zeroPadTime,
          zeroPadDays = _this$props2.zeroPadDays;
      var timeDelta = this.state.timeDelta;
      return Object.assign(Object.assign({}, timeDelta), {
        api: this.getApi(),
        props: this.props,
        formatted: formatTimeDelta(timeDelta, {
          daysInHours: daysInHours,
          zeroPadTime: zeroPadTime,
          zeroPadDays: zeroPadDays
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.legacyMode) {
        var _this$props3 = this.props,
            count = _this$props3.count,
            _children = _this$props3.children,
            onComplete = _this$props3.onComplete;
        return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Countdown, {
          ref: this.legacyCountdownRef,
          count: count,
          onComplete: onComplete
        }, _children);
      }

      var _this$props4 = this.props,
          className = _this$props4.className,
          overtime = _this$props4.overtime,
          children = _this$props4.children,
          renderer = _this$props4.renderer;
      var renderProps = this.getRenderProps();

      if (renderer) {
        return renderer(renderProps);
      }

      if (children && this.state.timeDelta.completed && !overtime) {
        return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(children, {
          countdown: renderProps
        });
      }

      var _renderProps$formatte = renderProps.formatted,
          days = _renderProps$formatte.days,
          hours = _renderProps$formatte.hours,
          minutes = _renderProps$formatte.minutes,
          seconds = _renderProps$formatte.seconds;
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("span", {
        className: className
      }, renderProps.total < 0 ? '-' : '', days, days ? ':' : '', hours, ":", minutes, ":", seconds);
    }
  }]);

  return Countdown$1;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
Countdown$1.defaultProps = Object.assign(Object.assign({}, timeDeltaFormatOptionsDefaults), {
  controlled: false,
  intervalDelay: 1000,
  precision: 0,
  autoStart: true
});
Countdown$1.propTypes = {
  date: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOfType)([(0,prop_types__WEBPACK_IMPORTED_MODULE_1__.instanceOf)(Date), prop_types__WEBPACK_IMPORTED_MODULE_1__.string, prop_types__WEBPACK_IMPORTED_MODULE_1__.number]),
  daysInHours: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool,
  zeroPadTime: prop_types__WEBPACK_IMPORTED_MODULE_1__.number,
  zeroPadDays: prop_types__WEBPACK_IMPORTED_MODULE_1__.number,
  controlled: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool,
  intervalDelay: prop_types__WEBPACK_IMPORTED_MODULE_1__.number,
  precision: prop_types__WEBPACK_IMPORTED_MODULE_1__.number,
  autoStart: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool,
  overtime: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool,
  className: prop_types__WEBPACK_IMPORTED_MODULE_1__.string,
  children: prop_types__WEBPACK_IMPORTED_MODULE_1__.element,
  renderer: prop_types__WEBPACK_IMPORTED_MODULE_1__.func,
  now: prop_types__WEBPACK_IMPORTED_MODULE_1__.func,
  onMount: prop_types__WEBPACK_IMPORTED_MODULE_1__.func,
  onStart: prop_types__WEBPACK_IMPORTED_MODULE_1__.func,
  onPause: prop_types__WEBPACK_IMPORTED_MODULE_1__.func,
  onStop: prop_types__WEBPACK_IMPORTED_MODULE_1__.func,
  onTick: prop_types__WEBPACK_IMPORTED_MODULE_1__.func,
  onComplete: prop_types__WEBPACK_IMPORTED_MODULE_1__.func
};

/* harmony default export */ __webpack_exports__["ZP"] = (Countdown$1);



/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}__webpack_unused_export__=h;__webpack_unused_export__=g;__webpack_unused_export__=b;__webpack_unused_export__=l;__webpack_unused_export__=d;__webpack_unused_export__=q;__webpack_unused_export__=p;__webpack_unused_export__=c;__webpack_unused_export__=f;__webpack_unused_export__=e;__webpack_unused_export__=m;
__webpack_unused_export__=n;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return v(a)===h};__webpack_unused_export__=function(a){return v(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return v(a)===l};__webpack_unused_export__=function(a){return v(a)===d};__webpack_unused_export__=function(a){return v(a)===q};__webpack_unused_export__=function(a){return v(a)===p};
__webpack_unused_export__=function(a){return v(a)===c};__webpack_unused_export__=function(a){return v(a)===f};__webpack_unused_export__=function(a){return v(a)===e};__webpack_unused_export__=function(a){return v(a)===m};__webpack_unused_export__=function(a){return v(a)===n};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};exports.typeOf=v;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(69921);
} else {}


/***/ }),

/***/ 82343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ mergeOptionsWithPopperConfig; }
/* harmony export */ });
/* unused harmony exports toModifierMap, toModifierArray */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87462);

function toModifierMap(modifiers) {
  var result = {};

  if (!Array.isArray(modifiers)) {
    return modifiers || result;
  } // eslint-disable-next-line no-unused-expressions


  modifiers == null ? void 0 : modifiers.forEach(function (m) {
    result[m.name] = m;
  });
  return result;
}
function toModifierArray(map) {
  if (map === void 0) {
    map = {};
  }

  if (Array.isArray(map)) return map;
  return Object.keys(map).map(function (k) {
    map[k].name = k;
    return map[k];
  });
}
function mergeOptionsWithPopperConfig(_ref) {
  var _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;

  var enabled = _ref.enabled,
      enableEvents = _ref.enableEvents,
      placement = _ref.placement,
      flip = _ref.flip,
      offset = _ref.offset,
      fixed = _ref.fixed,
      containerPadding = _ref.containerPadding,
      arrowElement = _ref.arrowElement,
      _ref$popperConfig = _ref.popperConfig,
      popperConfig = _ref$popperConfig === void 0 ? {} : _ref$popperConfig;
  var modifiers = toModifierMap(popperConfig.modifiers);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, popperConfig, {
    placement: placement,
    enabled: enabled,
    strategy: fixed ? 'fixed' : popperConfig.strategy,
    modifiers: toModifierArray((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, modifiers, {
      eventListeners: {
        enabled: enableEvents
      },
      preventOverflow: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, modifiers.preventOverflow, {
        options: containerPadding ? (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
          padding: containerPadding
        }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
      }),
      offset: {
        options: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
          offset: offset
        }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
      },
      arrow: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, modifiers.arrow, {
        enabled: !!arrowElement,
        options: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
          element: arrowElement
        })
      }),
      flip: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        enabled: !!flip
      }, modifiers.flip)
    }))
  });
}

/***/ }),

/***/ 46390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ safeFindDOMNode; }
/* harmony export */ });
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73935);

function safeFindDOMNode(componentOrElement) {
  if (componentOrElement && 'setState' in componentOrElement) {
    return react_dom__WEBPACK_IMPORTED_MODULE_0__.findDOMNode(componentOrElement);
  }

  return componentOrElement != null ? componentOrElement : null;
}

/***/ }),

/***/ 8534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_usePopper; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useMounted.js
var useMounted = __webpack_require__(6454);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useSafeState.js



function useSafeState(state) {
  var isMounted = (0,useMounted/* default */.Z)();
  return [state[0], (0,react.useCallback)(function (nextState) {
    if (!isMounted()) return;
    return state[1](nextState);
  }, [isMounted, state[1]])];
}

/* harmony default export */ var esm_useSafeState = (useSafeState);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getBasePlacement.js

function getBasePlacement(placement) {
  return placement.split('-')[0];
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindow.js
function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js


function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}


;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/math.js
var math_max = Math.max;
var math_min = Math.min;
var round = Math.round;
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/userAgent.js
function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js




function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/contains.js

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isTableElement.js

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js



function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js








function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/within.js

function within(min, value, max) {
  return math_max(min, math_min(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/expandToHashMap.js
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/enums.js
var enums = __webpack_require__(87701);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/arrow.js









 // eslint-disable-next-line import/no-unused-modules

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, enums/* basePlacements */.mv));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [enums/* left */.t$, enums/* right */.F2].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? enums/* top */.we : enums/* left */.t$;
  var maxProp = axis === 'y' ? enums/* bottom */.I : enums/* right */.F2;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (false) {}

  if (!contains(state.elements.popper, arrowElement)) {
    if (false) {}

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_arrow = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getVariation.js
function getVariation(placement) {
  return placement.split('-')[1];
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/computeStyles.js







 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = enums/* left */.t$;
  var sideY = enums/* top */.we;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === enums/* top */.we || (placement === enums/* left */.t$ || placement === enums/* right */.F2) && variation === enums/* end */.ut) {
      sideY = enums/* bottom */.I;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === enums/* left */.t$ || (placement === enums/* top */.we || placement === enums/* bottom */.I) && variation === enums/* end */.ut) {
      sideX = enums/* right */.F2;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  if (false) { var transitionProperty; }

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_computeStyles = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/eventListeners.js
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};

function eventListeners_effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var eventListeners = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: eventListeners_effect,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
var getOppositeVariationPlacement_hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return getOppositeVariationPlacement_hash[matched];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js




function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = math_max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = math_max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === 'rtl') {
    x += math_max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js




/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js















function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === enums/* viewport */.Pj ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = math_max(rect.top, accRect.top);
    accRect.right = math_min(rect.right, accRect.right);
    accRect.bottom = math_min(rect.bottom, accRect.bottom);
    accRect.left = math_max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeOffsets.js




function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case enums/* top */.we:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case enums/* bottom */.I:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case enums/* right */.F2:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case enums/* left */.t$:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case enums/* start */.BL:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case enums/* end */.ut:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/detectOverflow.js








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? enums/* clippingParents */.zV : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? enums/* viewport */.Pj : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? enums/* popper */.k5 : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, enums/* basePlacements */.mv));
  var altContext = elementContext === enums/* popper */.k5 ? enums/* reference */.YP : enums/* popper */.k5;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === enums/* popper */.k5 ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === enums/* popper */.k5 && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [enums/* right */.F2, enums/* bottom */.I].indexOf(key) >= 0 ? 1 : -1;
      var axis = [enums/* top */.we, enums/* bottom */.I].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js




function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? enums/* placements */.Ct : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements = variation ? flipVariations ? enums/* variationPlacements */.bw : enums/* variationPlacements.filter */.bw.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : enums/* basePlacements */.mv;
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;

    if (false) {}
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/flip.js






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === enums/* auto */.d7) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === enums/* auto */.d7 ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === enums/* start */.BL;
    var isVertical = [enums/* top */.we, enums/* bottom */.I].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? enums/* right */.F2 : enums/* left */.t$ : isStartVariation ? enums/* bottom */.I : enums/* top */.we;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_flip = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/hide.js



function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [enums/* top */.we, enums/* right */.F2, enums/* bottom */.I, enums/* left */.t$].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_hide = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/offset.js

 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [enums/* left */.t$, enums/* top */.we].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [enums/* left */.t$, enums/* right */.F2].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = enums/* placements.reduce */.Ct.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_offset = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js


function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_popperOffsets = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getAltAxis.js
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js












function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? enums/* top */.we : enums/* left */.t$;
    var altSide = mainAxis === 'y' ? enums/* bottom */.I : enums/* right */.F2;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === enums/* start */.BL ? referenceRect[len] : popperRect[len];
    var maxLen = variation === enums/* start */.BL ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? math_min(min, tetherMin) : min, offset, tether ? math_max(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? enums/* top */.we : enums/* left */.t$;

    var _altSide = mainAxis === 'x' ? enums/* bottom */.I : enums/* right */.F2;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [enums/* top */.we, enums/* left */.t$].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_preventOverflow = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js




function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js









function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/orderModifiers.js
 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return enums/* modifierPhases.reduce */.xs.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/debounce.js
function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergeByName.js
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/createPopper.js














var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (false) { var _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft, flipModifier, modifiers; }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (false) {}

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (false) {}

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      if (false) {}

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper = /*#__PURE__*/(/* unused pure expression or super */ null && (popperGenerator())); // eslint-disable-next-line import/no-unused-modules


;// CONCATENATED MODULE: ./node_modules/react-overlays/esm/popper.js









 // For the common JS build we will turn this file into a bundle with no imports.
// This is b/c the Popper lib is all esm files, and would break in a common js only environment

var popper_createPopper = popperGenerator({
  defaultModifiers: [modifiers_hide, modifiers_popperOffsets, modifiers_computeStyles, eventListeners, modifiers_offset, modifiers_flip, modifiers_preventOverflow, modifiers_arrow]
});

;// CONCATENATED MODULE: ./node_modules/react-overlays/esm/usePopper.js






var initialPopperStyles = function initialPopperStyles(position) {
  return {
    position: position,
    top: '0',
    left: '0',
    opacity: '0',
    pointerEvents: 'none'
  };
};

var disabledApplyStylesModifier = {
  name: 'applyStyles',
  enabled: false
}; // In order to satisfy the current usage of options, including undefined

var ariaDescribedByModifier = {
  name: 'ariaDescribedBy',
  enabled: true,
  phase: 'afterWrite',
  effect: function effect(_ref) {
    var state = _ref.state;
    return function () {
      var _state$elements = state.elements,
          reference = _state$elements.reference,
          popper = _state$elements.popper;

      if ('removeAttribute' in reference) {
        var ids = (reference.getAttribute('aria-describedby') || '').split(',').filter(function (id) {
          return id.trim() !== popper.id;
        });
        if (!ids.length) reference.removeAttribute('aria-describedby');else reference.setAttribute('aria-describedby', ids.join(','));
      }
    };
  },
  fn: function fn(_ref2) {
    var _popper$getAttribute;

    var state = _ref2.state;
    var _state$elements2 = state.elements,
        popper = _state$elements2.popper,
        reference = _state$elements2.reference;
    var role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();

    if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
      var ids = reference.getAttribute('aria-describedby');

      if (ids && ids.split(',').indexOf(popper.id) !== -1) {
        return;
      }

      reference.setAttribute('aria-describedby', ids ? ids + "," + popper.id : popper.id);
    }
  }
};
var EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {boolean=}    options.eventsEnabled have Popper listen on window resize events to reposition the element
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */

function usePopper(referenceElement, popperElement, _temp) {
  var _ref3 = _temp === void 0 ? {} : _temp,
      _ref3$enabled = _ref3.enabled,
      enabled = _ref3$enabled === void 0 ? true : _ref3$enabled,
      _ref3$placement = _ref3.placement,
      placement = _ref3$placement === void 0 ? 'bottom' : _ref3$placement,
      _ref3$strategy = _ref3.strategy,
      strategy = _ref3$strategy === void 0 ? 'absolute' : _ref3$strategy,
      _ref3$modifiers = _ref3.modifiers,
      modifiers = _ref3$modifiers === void 0 ? EMPTY_MODIFIERS : _ref3$modifiers,
      config = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref3, ["enabled", "placement", "strategy", "modifiers"]);

  var popperInstanceRef = (0,react.useRef)();
  var update = (0,react.useCallback)(function () {
    var _popperInstanceRef$cu;

    (_popperInstanceRef$cu = popperInstanceRef.current) == null ? void 0 : _popperInstanceRef$cu.update();
  }, []);
  var forceUpdate = (0,react.useCallback)(function () {
    var _popperInstanceRef$cu2;

    (_popperInstanceRef$cu2 = popperInstanceRef.current) == null ? void 0 : _popperInstanceRef$cu2.forceUpdate();
  }, []);

  var _useSafeState = esm_useSafeState((0,react.useState)({
    placement: placement,
    update: update,
    forceUpdate: forceUpdate,
    attributes: {},
    styles: {
      popper: initialPopperStyles(strategy),
      arrow: {}
    }
  })),
      popperState = _useSafeState[0],
      setState = _useSafeState[1];

  var updateModifier = (0,react.useMemo)(function () {
    return {
      name: 'updateStateModifier',
      enabled: true,
      phase: 'write',
      requires: ['computeStyles'],
      fn: function fn(_ref4) {
        var state = _ref4.state;
        var styles = {};
        var attributes = {};
        Object.keys(state.elements).forEach(function (element) {
          styles[element] = state.styles[element];
          attributes[element] = state.attributes[element];
        });
        setState({
          state: state,
          styles: styles,
          attributes: attributes,
          update: update,
          forceUpdate: forceUpdate,
          placement: state.placement
        });
      }
    };
  }, [update, forceUpdate, setState]);
  (0,react.useEffect)(function () {
    if (!popperInstanceRef.current || !enabled) return;
    popperInstanceRef.current.setOptions({
      placement: placement,
      strategy: strategy,
      modifiers: [].concat(modifiers, [updateModifier, disabledApplyStylesModifier])
    }); // intentionally NOT re-running on new modifiers
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [strategy, placement, updateModifier, enabled]);
  (0,react.useEffect)(function () {
    if (!enabled || referenceElement == null || popperElement == null) {
      return undefined;
    }

    popperInstanceRef.current = popper_createPopper(referenceElement, popperElement, (0,esm_extends/* default */.Z)({}, config, {
      placement: placement,
      strategy: strategy,
      modifiers: [].concat(modifiers, [ariaDescribedByModifier, updateModifier])
    }));
    return function () {
      if (popperInstanceRef.current != null) {
        popperInstanceRef.current.destroy();
        popperInstanceRef.current = undefined;
        setState(function (s) {
          return (0,esm_extends/* default */.Z)({}, s, {
            attributes: {},
            styles: {
              popper: initialPopperStyles(strategy)
            }
          });
        });
      }
    }; // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, referenceElement, popperElement]);
  return popperState;
}

/* harmony default export */ var esm_usePopper = (usePopper);

/***/ }),

/***/ 86453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_useRootClose; }
});

// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/contains.js
var contains = __webpack_require__(90424);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/listen.js
var listen = __webpack_require__(72950);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useEventCallback.js + 1 modules
var useEventCallback = __webpack_require__(51176);
// EXTERNAL MODULE: ./node_modules/warning/warning.js
var warning = __webpack_require__(42473);
var warning_default = /*#__PURE__*/__webpack_require__.n(warning);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/ownerDocument.js
var ownerDocument = __webpack_require__(67216);
// EXTERNAL MODULE: ./node_modules/react-overlays/esm/safeFindDOMNode.js
var safeFindDOMNode = __webpack_require__(46390);
;// CONCATENATED MODULE: ./node_modules/react-overlays/esm/ownerDocument.js


/* harmony default export */ var esm_ownerDocument = (function (componentOrElement) {
  return (0,ownerDocument/* default */.Z)((0,safeFindDOMNode/* default */.Z)(componentOrElement));
});
;// CONCATENATED MODULE: ./node_modules/react-overlays/esm/useRootClose.js






var escapeKeyCode = 27;

var noop = function noop() {};

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var getRefTarget = function getRefTarget(ref) {
  return ref && ('current' in ref ? ref.current : ref);
};

/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */
function useRootClose(ref, onRootClose, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      disabled = _ref.disabled,
      _ref$clickTrigger = _ref.clickTrigger,
      clickTrigger = _ref$clickTrigger === void 0 ? 'click' : _ref$clickTrigger;

  var preventMouseRootCloseRef = (0,react.useRef)(false);
  var onClose = onRootClose || noop;
  var handleMouseCapture = (0,react.useCallback)(function (e) {
    var _e$composedPath$;

    var currentTarget = getRefTarget(ref);
    warning_default()(!!currentTarget, 'RootClose captured a close event but does not have a ref to compare it to. ' + 'useRootClose(), should be passed a ref that resolves to a DOM node');
    preventMouseRootCloseRef.current = !currentTarget || isModifiedEvent(e) || !isLeftClickEvent(e) || !!(0,contains/* default */.Z)(currentTarget, (_e$composedPath$ = e.composedPath == null ? void 0 : e.composedPath()[0]) != null ? _e$composedPath$ : e.target);
  }, [ref]);
  var handleMouse = (0,useEventCallback/* default */.Z)(function (e) {
    if (!preventMouseRootCloseRef.current) {
      onClose(e);
    }
  });
  var handleKeyUp = (0,useEventCallback/* default */.Z)(function (e) {
    if (e.keyCode === escapeKeyCode) {
      onClose(e);
    }
  });
  (0,react.useEffect)(function () {
    if (disabled || ref == null) return undefined; // Store the current event to avoid triggering handlers immediately
    // https://github.com/facebook/react/issues/20074

    var currentEvent = window.event;
    var doc = esm_ownerDocument(getRefTarget(ref)); // Use capture for this listener so it fires before React's listener, to
    // avoid false positives in the contains() check below if the target DOM
    // element is removed in the React mouse callback.

    var removeMouseCaptureListener = (0,listen/* default */.Z)(doc, clickTrigger, handleMouseCapture, true);
    var removeMouseListener = (0,listen/* default */.Z)(doc, clickTrigger, function (e) {
      // skip if this event is the same as the one running when we added the handlers
      if (e === currentEvent) {
        currentEvent = undefined;
        return;
      }

      handleMouse(e);
    });
    var removeKeyupListener = (0,listen/* default */.Z)(doc, 'keyup', function (e) {
      // skip if this event is the same as the one running when we added the handlers
      if (e === currentEvent) {
        currentEvent = undefined;
        return;
      }

      handleKeyUp(e);
    });
    var mobileSafariHackListeners = [];

    if ('ontouchstart' in doc.documentElement) {
      mobileSafariHackListeners = [].slice.call(doc.body.children).map(function (el) {
        return (0,listen/* default */.Z)(el, 'mousemove', noop);
      });
    }

    return function () {
      removeMouseCaptureListener();
      removeMouseListener();
      removeKeyupListener();
      mobileSafariHackListeners.forEach(function (remove) {
        return remove();
      });
    };
  }, [ref, disabled, clickTrigger, handleMouseCapture, handleMouse, handleKeyUp]);
}

/* harmony default export */ var esm_useRootClose = (useRootClose);

/***/ }),

/***/ 23446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWaitForDOMRef; }
/* harmony export */ });
/* unused harmony export resolveContainerRef */
/* harmony import */ var dom_helpers_ownerDocument__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67216);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var resolveContainerRef = function resolveContainerRef(ref) {
  var _ref;

  if (typeof document === 'undefined') return null;
  if (ref == null) return (0,dom_helpers_ownerDocument__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().body;
  if (typeof ref === 'function') ref = ref();
  if (ref && 'current' in ref) ref = ref.current;
  if ((_ref = ref) != null && _ref.nodeType) return ref || null;
  return null;
};
function useWaitForDOMRef(ref, onResolved) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function () {
    return resolveContainerRef(ref);
  }),
      resolvedRef = _useState[0],
      setRef = _useState[1];

  if (!resolvedRef) {
    var earlyRef = resolveContainerRef(ref);
    if (earlyRef) setRef(earlyRef);
  }

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (onResolved && resolvedRef) {
      onResolved(resolvedRef);
    }
  }, [onResolved, resolvedRef]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var nextRef = resolveContainerRef(ref);

    if (nextRef !== resolvedRef) {
      setRef(nextRef);
    }
  }, [ref, resolvedRef]);
  return resolvedRef;
}

/***/ }),

/***/ 68820:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(45697), __webpack_require__(67294), __webpack_require__(73935));
	else {}
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __nested_webpack_require_850__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_850__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__nested_webpack_require_850__.m = modules;

/******/ 	// expose the module cache
/******/ 	__nested_webpack_require_850__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__nested_webpack_require_850__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __nested_webpack_require_850__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	eval("'use strict';\n\nObject.defineProperty(exports, \"__esModule\", {\n\tvalue: true\n});\n\nvar _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };\n\nvar _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if (\"value\" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();\n\nvar _react = __webpack_require__(4);\n\nvar _react2 = _interopRequireDefault(_react);\n\nvar _reactDom = __webpack_require__(5);\n\nvar _propTypes = __webpack_require__(3);\n\nvar _propTypes2 = _interopRequireDefault(_propTypes);\n\n__webpack_require__(2);\n\nfunction _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }\n\nfunction _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError(\"Cannot call a class as a function\"); } }\n\nfunction _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\"); } return call && (typeof call === \"object\" || typeof call === \"function\") ? call : self; }\n\nfunction _inherits(subClass, superClass) { if (typeof superClass !== \"function\" && superClass !== null) { throw new TypeError(\"Super expression must either be null or a function, not \" + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }\n\nvar owlCarouselOptions = {\n\tcore: ['items', 'loop', 'center', 'rewind', 'mouseDrag', 'touchDrag', 'pullDrag', 'freeDrag', 'margin', 'stagePadding', 'merge', 'mergeFit', 'autoWidth', 'startPosition', 'rtl', 'smartSpeed', 'fluidSpeed', 'dragEndSpeed', 'responsive', 'responsiveRefreshRate', 'responsiveBaseElement', 'fallbackEasing', 'info', 'nestedItemSelector', 'itemElement', 'stageElement', 'refreshClass', 'loadedClass', 'loadingClass', 'rtlClass', 'responsiveClass', 'dragClass', 'itemClass', 'stageClass', 'stageOuterClass', 'grabClass'],\n\tautorefresh: ['autoRefresh', 'autoRefreshInterval'],\n\tlazy: ['lazyLoad'],\n\tautoHeight: ['autoHeight', 'autoHeightClass'],\n\tvideo: ['video', 'videoHeight', 'videoWidth'],\n\tanimate: ['animateOut', 'animateIn'],\n\tautoplay: ['autoplay', 'autoplayTimeout', 'autoplayHoverPause', 'autoplaySpeed'],\n\tnavigation: ['nav', 'navText', 'navSpeed', 'navElement', 'navContainer', 'navContainerClass', 'navClass', 'slideBy', 'dotClass', 'dotsClass', 'dots', 'dotsEach', 'dotsData', 'dotsSpeed', 'dotsContainer'],\n\thash: ['URLhashListener']\n};\n\nvar owlCarouselEvents = {\n\tcore: ['onInitialize', 'onInitialized', 'onResize', 'onResized', 'onRefresh', 'onRefreshed', 'onDrag', 'onDragged', 'onTranslate', 'onTranslated', 'onChange', 'onChanged'],\n\tlazy: ['onLoadLazy', 'onLoadedLazy'],\n\tvideo: ['onStopVideo', 'onPlayVideo']\n};\n\nvar OwlCarousel = function (_React$Component) {\n\t_inherits(OwlCarousel, _React$Component);\n\n\tfunction OwlCarousel(props, context) {\n\t\t_classCallCheck(this, OwlCarousel);\n\n\t\tvar _this = _possibleConstructorReturn(this, (OwlCarousel.__proto__ || Object.getPrototypeOf(OwlCarousel)).call(this, props, context));\n\n\t\t_this.onTranslate = function (next) {\n\t\t\treturn function (event) {\n\t\t\t\t_this.currentPosition = event.item.index;\n\t\t\t\tif (next) next(event);\n\t\t\t};\n\t\t};\n\n\t\t_this.next = function () {\n\t\t\treturn _this.$car.next();\n\t\t};\n\t\t_this.prev = function () {\n\t\t\treturn _this.$car.prev();\n\t\t};\n\t\t_this.goTo = function (x) {\n\t\t\treturn _this.$car.to(x);\n\t\t};\n\n\t\t_this.currentPosition = 0;\n\t\t_this.onTranslate = _this.onTranslate.bind(_this);\n\t\treturn _this;\n\t}\n\n\t_createClass(OwlCarousel, [{\n\t\tkey: 'componentDidMount',\n\t\tvalue: function componentDidMount() {\n\t\t\t__webpack_require__(1);\n\t\t\tvar options = this.getOptions();\n\t\t\tthis.init(options);\n\t\t}\n\t}, {\n\t\tkey: 'componentWillReceiveProps',\n\t\tvalue: function componentWillReceiveProps(nextProps) {\n\t\t\tthis.destroy();\n\t\t}\n\t}, {\n\t\tkey: 'componentDidUpdate',\n\t\tvalue: function componentDidUpdate(prevProps, prevState) {\n\t\t\tvar options = this.getOptions();\n\t\t\toptions.startPosition = this.currentPosition;\n\t\t\tthis.init(options);\n\t\t}\n\t}, {\n\t\tkey: 'componentWillUnmount',\n\t\tvalue: function componentWillUnmount() {\n\t\t\tthis.destroy();\n\t\t}\n\t}, {\n\t\tkey: 'init',\n\t\tvalue: function init(options) {\n\t\t\tvar next = options.onTranslate;\n\t\t\toptions.onTranslate = this.onTranslate(next);\n\t\t\tthis.$node.owlCarousel(options);\n\t\t\tthis.$car = this.$node.data('owl.carousel');\n\t\t}\n\t}, {\n\t\tkey: 'destroy',\n\t\tvalue: function destroy() {\n\t\t\tthis.$car.destroy();\n\t\t}\n\t}, {\n\t\tkey: 'getOptions',\n\t\tvalue: function getOptions() {\n\t\t\tvar _this2 = this;\n\n\t\t\tvar options = {};\n\n\t\t\tvar carOptions = Object.values(owlCarouselOptions).reduce(function (a, v) {\n\t\t\t\treturn a.concat(v);\n\t\t\t}, []);\n\n\t\t\tcarOptions.forEach(function (val) {\n\t\t\t\tif (val in _this2.props.options) options[val] = _this2.props.options[val];\n\t\t\t});\n\n\t\t\tvar carEvents = Object.values(owlCarouselEvents).reduce(function (a, v) {\n\t\t\t\treturn a.concat(v);\n\t\t\t}, []);\n\n\t\t\tcarEvents.forEach(function (val) {\n\t\t\t\tif (val in _this2.props.events) options[val] = _this2.props.events[val];\n\t\t\t});\n\n\t\t\treturn options;\n\t\t}\n\t}, {\n\t\tkey: 'render',\n\t\tvalue: function render() {\n\t\t\tvar _this3 = this;\n\n\t\t\tvar _props = this.props,\n\t\t\t    options = _props.options,\n\t\t\t    events = _props.events,\n\t\t\t    children = _props.children,\n\t\t\t    props = _objectWithoutProperties(_props, ['options', 'events', 'children']);\n\n\t\t\treturn _react2.default.createElement(\n\t\t\t\t'div',\n\t\t\t\t_extends({ ref: function ref(item) {\n\t\t\t\t\t\treturn _this3.$node = $((0, _reactDom.findDOMNode)(item));\n\t\t\t\t\t}, className: 'owl-carousel owl-theme' }, props),\n\t\t\t\tchildren\n\t\t\t);\n\t\t}\n\t}]);\n\n\treturn OwlCarousel;\n}(_react2.default.Component);\n\nOwlCarousel.propTypes = {\n\tchildren: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element.isRequired)]).isRequired,\n\n\tstyle: _propTypes2.default.object,\n\tid: _propTypes2.default.string,\n\n\toptions: _propTypes2.default.shape({\n\t\t// core\n\t\titems: _propTypes2.default.number,\n\t\tloop: _propTypes2.default.bool,\n\t\tcenter: _propTypes2.default.bool,\n\t\trewind: _propTypes2.default.bool,\n\n\t\tmouseDrag: _propTypes2.default.bool,\n\t\ttouchDrag: _propTypes2.default.bool,\n\t\tpullDrag: _propTypes2.default.bool,\n\t\tfreeDrag: _propTypes2.default.bool,\n\n\t\tmargin: _propTypes2.default.number,\n\t\tstagePadding: _propTypes2.default.number,\n\n\t\tmerge: _propTypes2.default.bool,\n\t\tmergeFit: _propTypes2.default.bool,\n\t\tautoWidth: _propTypes2.default.bool,\n\n\t\tstartPosition: _propTypes2.default.number,\n\t\trtl: _propTypes2.default.bool,\n\n\t\tsmartSpeed: _propTypes2.default.number,\n\t\tfluidSpeed: _propTypes2.default.bool,\n\t\tdragEndSpeed: _propTypes2.default.bool,\n\n\t\tresponsive: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),\n\t\tresponsiveRefreshRate: _propTypes2.default.number,\n\t\tresponsiveBaseElement: _propTypes2.default.object,\n\n\t\tfallbackEasing: _propTypes2.default.string,\n\n\t\tinfo: _propTypes2.default.bool,\n\n\t\tnestedItemSelector: _propTypes2.default.bool,\n\t\titemElement: _propTypes2.default.string,\n\t\tstageElement: _propTypes2.default.string,\n\n\t\trefreshClass: _propTypes2.default.string,\n\t\tloadedClass: _propTypes2.default.string,\n\t\tloadingClass: _propTypes2.default.string,\n\t\trtlClass: _propTypes2.default.string,\n\t\tresponsiveClass: _propTypes2.default.string,\n\t\tdragClass: _propTypes2.default.string,\n\t\titemClass: _propTypes2.default.string,\n\t\tstageClass: _propTypes2.default.string,\n\t\tstageOuterClass: _propTypes2.default.string,\n\t\tgrabClass: _propTypes2.default.string,\n\n\t\t// autoRefresh\n\t\tautoRefresh: _propTypes2.default.bool,\n\t\tautoRefreshInterval: _propTypes2.default.number,\n\n\t\t// lazy\n\t\tlazyLoad: _propTypes2.default.bool,\n\n\t\t// autoHeight\n\t\tautoHeight: _propTypes2.default.bool,\n\t\tautoHeightClass: _propTypes2.default.string,\n\n\t\t// video\n\t\tvideo: _propTypes2.default.bool,\n\t\tvideoHeight: _propTypes2.default.bool,\n\t\tvideoWidth: _propTypes2.default.bool,\n\n\t\t// animate\n\t\tanimateOut: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),\n\t\tanimateIn: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),\n\n\t\t// autoplay\n\t\tautoplay: _propTypes2.default.bool,\n\t\tautoplayTimeout: _propTypes2.default.number,\n\t\tautoplayHoverPause: _propTypes2.default.bool,\n\t\tautoplaySpeed: _propTypes2.default.bool,\n\n\t\t// navigation\n\t\tnav: _propTypes2.default.bool,\n\t\tnavText: _propTypes2.default.array,\n\t\tnavSpeed: _propTypes2.default.bool,\n\t\tnavElement: _propTypes2.default.string,\n\t\tnavContainer: _propTypes2.default.bool,\n\t\tnavContainerClass: _propTypes2.default.string,\n\t\tnavClass: _propTypes2.default.array,\n\t\tslideBy: _propTypes2.default.number,\n\t\tdotClass: _propTypes2.default.string,\n\t\tdotsClass: _propTypes2.default.string,\n\t\tdots: _propTypes2.default.bool,\n\t\tdotsEach: _propTypes2.default.bool,\n\t\tdotsData: _propTypes2.default.bool,\n\t\tdotsSpeed: _propTypes2.default.bool,\n\t\tdotsContainer: _propTypes2.default.bool,\n\n\t\t// hash\n\t\tURLhashListener: _propTypes2.default.bool\n\t}),\n\n\tevents: _propTypes2.default.shape({\n\t\t// core\n\t\tonInitialize: _propTypes2.default.func,\n\t\tonInitialized: _propTypes2.default.func,\n\t\tonResize: _propTypes2.default.func,\n\t\tonResized: _propTypes2.default.func,\n\t\tonRefresh: _propTypes2.default.func,\n\t\tonRefreshed: _propTypes2.default.func,\n\t\tonDrag: _propTypes2.default.func,\n\t\tonDragged: _propTypes2.default.func,\n\t\tonTranslate: _propTypes2.default.func,\n\t\tonTranslated: _propTypes2.default.func,\n\t\tonChange: _propTypes2.default.func,\n\t\tonChanged: _propTypes2.default.func,\n\n\t\t// lazy\n\t\tonLoadLazy: _propTypes2.default.func,\n\t\tonLoadedLazy: _propTypes2.default.func,\n\n\t\t// video\n\t\tonStopVideo: _propTypes2.default.func,\n\t\tonPlayVideo: _propTypes2.default.func\n\t})\n};\n\nOwlCarousel.defaultProps = {\n\toptions: {},\n\tevents: {}\n};\n\nexports.default = OwlCarousel;\nmodule.exports = exports['default'];\n\n/*****************\n ** WEBPACK FOOTER\n ** ./components/OwlCarousel.jsx\n ** module id = 0\n ** module chunks = 0\n **/\n//# sourceURL=webpack:///./components/OwlCarousel.jsx?");

/***/ },
/* 1 */
/***/ function(module, exports) {

	eval("'use strict';\n\nvar _typeof = typeof Symbol === \"function\" && typeof Symbol.iterator === \"symbol\" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === \"function\" && obj.constructor === Symbol && obj !== Symbol.prototype ? \"symbol\" : typeof obj; };\n\n/**\n * Owl Carousel v2.2.1\n * Copyright 2013-2017 David Deutsch\n * Licensed under  ()\n */\n/**\n * Owl carousel\n * @version 2.1.6\n * @author Bartosz Wojciechowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n * @todo Lazy Load Icon\n * @todo prevent animationend bubling\n * @todo itemsScaleUp\n * @todo Test Zepto\n * @todo stagePadding calculate wrong active classes\n */\n;(function ($, window, document, undefined) {\n\n\t/**\n  * Creates a carousel.\n  * @class The Owl Carousel.\n  * @public\n  * @param {HTMLElement|jQuery} element - The element to create the carousel for.\n  * @param {Object} [options] - The options\n  */\n\tfunction Owl(element, options) {\n\n\t\t/**\n   * Current settings for the carousel.\n   * @public\n   */\n\t\tthis.settings = null;\n\n\t\t/**\n   * Current options set by the caller including defaults.\n   * @public\n   */\n\t\tthis.options = $.extend({}, Owl.Defaults, options);\n\n\t\t/**\n   * Plugin element.\n   * @public\n   */\n\t\tthis.$element = $(element);\n\n\t\t/**\n   * Proxied event handlers.\n   * @protected\n   */\n\t\tthis._handlers = {};\n\n\t\t/**\n   * References to the running plugins of this carousel.\n   * @protected\n   */\n\t\tthis._plugins = {};\n\n\t\t/**\n   * Currently suppressed events to prevent them from beeing retriggered.\n   * @protected\n   */\n\t\tthis._supress = {};\n\n\t\t/**\n   * Absolute current position.\n   * @protected\n   */\n\t\tthis._current = null;\n\n\t\t/**\n   * Animation speed in milliseconds.\n   * @protected\n   */\n\t\tthis._speed = null;\n\n\t\t/**\n   * Coordinates of all items in pixel.\n   * @todo The name of this member is missleading.\n   * @protected\n   */\n\t\tthis._coordinates = [];\n\n\t\t/**\n   * Current breakpoint.\n   * @todo Real media queries would be nice.\n   * @protected\n   */\n\t\tthis._breakpoint = null;\n\n\t\t/**\n   * Current width of the plugin element.\n   */\n\t\tthis._width = null;\n\n\t\t/**\n   * All real items.\n   * @protected\n   */\n\t\tthis._items = [];\n\n\t\t/**\n   * All cloned items.\n   * @protected\n   */\n\t\tthis._clones = [];\n\n\t\t/**\n   * Merge values of all items.\n   * @todo Maybe this could be part of a plugin.\n   * @protected\n   */\n\t\tthis._mergers = [];\n\n\t\t/**\n   * Widths of all items.\n   */\n\t\tthis._widths = [];\n\n\t\t/**\n   * Invalidated parts within the update process.\n   * @protected\n   */\n\t\tthis._invalidated = {};\n\n\t\t/**\n   * Ordered list of workers for the update process.\n   * @protected\n   */\n\t\tthis._pipe = [];\n\n\t\t/**\n   * Current state information for the drag operation.\n   * @todo #261\n   * @protected\n   */\n\t\tthis._drag = {\n\t\t\ttime: null,\n\t\t\ttarget: null,\n\t\t\tpointer: null,\n\t\t\tstage: {\n\t\t\t\tstart: null,\n\t\t\t\tcurrent: null\n\t\t\t},\n\t\t\tdirection: null\n\t\t};\n\n\t\t/**\n   * Current state information and their tags.\n   * @type {Object}\n   * @protected\n   */\n\t\tthis._states = {\n\t\t\tcurrent: {},\n\t\t\ttags: {\n\t\t\t\t'initializing': ['busy'],\n\t\t\t\t'animating': ['busy'],\n\t\t\t\t'dragging': ['interacting']\n\t\t\t}\n\t\t};\n\n\t\t$.each(['onResize', 'onThrottledResize'], $.proxy(function (i, handler) {\n\t\t\tthis._handlers[handler] = $.proxy(this[handler], this);\n\t\t}, this));\n\n\t\t$.each(Owl.Plugins, $.proxy(function (key, plugin) {\n\t\t\tthis._plugins[key.charAt(0).toLowerCase() + key.slice(1)] = new plugin(this);\n\t\t}, this));\n\n\t\t$.each(Owl.Workers, $.proxy(function (priority, worker) {\n\t\t\tthis._pipe.push({\n\t\t\t\t'filter': worker.filter,\n\t\t\t\t'run': $.proxy(worker.run, this)\n\t\t\t});\n\t\t}, this));\n\n\t\tthis.setup();\n\t\tthis.initialize();\n\t}\n\n\t/**\n  * Default options for the carousel.\n  * @public\n  */\n\tOwl.Defaults = {\n\t\titems: 3,\n\t\tloop: false,\n\t\tcenter: false,\n\t\trewind: false,\n\n\t\tmouseDrag: true,\n\t\ttouchDrag: true,\n\t\tpullDrag: true,\n\t\tfreeDrag: false,\n\n\t\tmargin: 0,\n\t\tstagePadding: 0,\n\n\t\tmerge: false,\n\t\tmergeFit: true,\n\t\tautoWidth: false,\n\n\t\tstartPosition: 0,\n\t\trtl: false,\n\n\t\tsmartSpeed: 250,\n\t\tfluidSpeed: false,\n\t\tdragEndSpeed: false,\n\n\t\tresponsive: {},\n\t\tresponsiveRefreshRate: 200,\n\t\tresponsiveBaseElement: window,\n\n\t\tfallbackEasing: 'swing',\n\n\t\tinfo: false,\n\n\t\tnestedItemSelector: false,\n\t\titemElement: 'div',\n\t\tstageElement: 'div',\n\n\t\trefreshClass: 'owl-refresh',\n\t\tloadedClass: 'owl-loaded',\n\t\tloadingClass: 'owl-loading',\n\t\trtlClass: 'owl-rtl',\n\t\tresponsiveClass: 'owl-responsive',\n\t\tdragClass: 'owl-drag',\n\t\titemClass: 'owl-item',\n\t\tstageClass: 'owl-stage',\n\t\tstageOuterClass: 'owl-stage-outer',\n\t\tgrabClass: 'owl-grab'\n\t};\n\n\t/**\n  * Enumeration for width.\n  * @public\n  * @readonly\n  * @enum {String}\n  */\n\tOwl.Width = {\n\t\tDefault: 'default',\n\t\tInner: 'inner',\n\t\tOuter: 'outer'\n\t};\n\n\t/**\n  * Enumeration for types.\n  * @public\n  * @readonly\n  * @enum {String}\n  */\n\tOwl.Type = {\n\t\tEvent: 'event',\n\t\tState: 'state'\n\t};\n\n\t/**\n  * Contains all registered plugins.\n  * @public\n  */\n\tOwl.Plugins = {};\n\n\t/**\n  * List of workers involved in the update process.\n  */\n\tOwl.Workers = [{\n\t\tfilter: ['width', 'settings'],\n\t\trun: function run() {\n\t\t\tthis._width = this.$element.width();\n\t\t}\n\t}, {\n\t\tfilter: ['width', 'items', 'settings'],\n\t\trun: function run(cache) {\n\t\t\tcache.current = this._items && this._items[this.relative(this._current)];\n\t\t}\n\t}, {\n\t\tfilter: ['items', 'settings'],\n\t\trun: function run() {\n\t\t\tthis.$stage.children('.cloned').remove();\n\t\t}\n\t}, {\n\t\tfilter: ['width', 'items', 'settings'],\n\t\trun: function run(cache) {\n\t\t\tvar margin = this.settings.margin || '',\n\t\t\t    grid = !this.settings.autoWidth,\n\t\t\t    rtl = this.settings.rtl,\n\t\t\t    css = {\n\t\t\t\t'width': 'auto',\n\t\t\t\t'margin-left': rtl ? margin : '',\n\t\t\t\t'margin-right': rtl ? '' : margin\n\t\t\t};\n\n\t\t\t!grid && this.$stage.children().css(css);\n\n\t\t\tcache.css = css;\n\t\t}\n\t}, {\n\t\tfilter: ['width', 'items', 'settings'],\n\t\trun: function run(cache) {\n\t\t\tvar width = (this.width() / this.settings.items).toFixed(3) - this.settings.margin,\n\t\t\t    merge = null,\n\t\t\t    iterator = this._items.length,\n\t\t\t    grid = !this.settings.autoWidth,\n\t\t\t    widths = [];\n\n\t\t\tcache.items = {\n\t\t\t\tmerge: false,\n\t\t\t\twidth: width\n\t\t\t};\n\n\t\t\twhile (iterator--) {\n\t\t\t\tmerge = this._mergers[iterator];\n\t\t\t\tmerge = this.settings.mergeFit && Math.min(merge, this.settings.items) || merge;\n\n\t\t\t\tcache.items.merge = merge > 1 || cache.items.merge;\n\n\t\t\t\twidths[iterator] = !grid ? this._items[iterator].width() : width * merge;\n\t\t\t}\n\n\t\t\tthis._widths = widths;\n\t\t}\n\t}, {\n\t\tfilter: ['items', 'settings'],\n\t\trun: function run() {\n\t\t\tvar clones = [],\n\t\t\t    items = this._items,\n\t\t\t    settings = this.settings,\n\n\t\t\t// TODO: Should be computed from number of min width items in stage\n\t\t\tview = Math.max(settings.items * 2, 4),\n\t\t\t    size = Math.ceil(items.length / 2) * 2,\n\t\t\t    repeat = settings.loop && items.length ? settings.rewind ? view : Math.max(view, size) : 0,\n\t\t\t    append = '',\n\t\t\t    prepend = '';\n\n\t\t\trepeat /= 2;\n\n\t\t\twhile (repeat--) {\n\t\t\t\t// Switch to only using appended clones\n\t\t\t\tclones.push(this.normalize(clones.length / 2, true));\n\t\t\t\tappend = append + items[clones[clones.length - 1]][0].outerHTML;\n\t\t\t\tclones.push(this.normalize(items.length - 1 - (clones.length - 1) / 2, true));\n\t\t\t\tprepend = items[clones[clones.length - 1]][0].outerHTML + prepend;\n\t\t\t}\n\n\t\t\tthis._clones = clones;\n\n\t\t\t$(append).addClass('cloned').appendTo(this.$stage);\n\t\t\t$(prepend).addClass('cloned').prependTo(this.$stage);\n\t\t}\n\t}, {\n\t\tfilter: ['width', 'items', 'settings'],\n\t\trun: function run() {\n\t\t\tvar rtl = this.settings.rtl ? 1 : -1,\n\t\t\t    size = this._clones.length + this._items.length,\n\t\t\t    iterator = -1,\n\t\t\t    previous = 0,\n\t\t\t    current = 0,\n\t\t\t    coordinates = [];\n\n\t\t\twhile (++iterator < size) {\n\t\t\t\tprevious = coordinates[iterator - 1] || 0;\n\t\t\t\tcurrent = this._widths[this.relative(iterator)] + this.settings.margin;\n\t\t\t\tcoordinates.push(previous + current * rtl);\n\t\t\t}\n\n\t\t\tthis._coordinates = coordinates;\n\t\t}\n\t}, {\n\t\tfilter: ['width', 'items', 'settings'],\n\t\trun: function run() {\n\t\t\tvar padding = this.settings.stagePadding,\n\t\t\t    coordinates = this._coordinates,\n\t\t\t    css = {\n\t\t\t\t'width': Math.ceil(Math.abs(coordinates[coordinates.length - 1])) + padding * 2,\n\t\t\t\t'padding-left': padding || '',\n\t\t\t\t'padding-right': padding || ''\n\t\t\t};\n\n\t\t\tthis.$stage.css(css);\n\t\t}\n\t}, {\n\t\tfilter: ['width', 'items', 'settings'],\n\t\trun: function run(cache) {\n\t\t\tvar iterator = this._coordinates.length,\n\t\t\t    grid = !this.settings.autoWidth,\n\t\t\t    items = this.$stage.children();\n\n\t\t\tif (grid && cache.items.merge) {\n\t\t\t\twhile (iterator--) {\n\t\t\t\t\tcache.css.width = this._widths[this.relative(iterator)];\n\t\t\t\t\titems.eq(iterator).css(cache.css);\n\t\t\t\t}\n\t\t\t} else if (grid) {\n\t\t\t\tcache.css.width = cache.items.width;\n\t\t\t\titems.css(cache.css);\n\t\t\t}\n\t\t}\n\t}, {\n\t\tfilter: ['items'],\n\t\trun: function run() {\n\t\t\tthis._coordinates.length < 1 && this.$stage.removeAttr('style');\n\t\t}\n\t}, {\n\t\tfilter: ['width', 'items', 'settings'],\n\t\trun: function run(cache) {\n\t\t\tcache.current = cache.current ? this.$stage.children().index(cache.current) : 0;\n\t\t\tcache.current = Math.max(this.minimum(), Math.min(this.maximum(), cache.current));\n\t\t\tthis.reset(cache.current);\n\t\t}\n\t}, {\n\t\tfilter: ['position'],\n\t\trun: function run() {\n\t\t\tthis.animate(this.coordinates(this._current));\n\t\t}\n\t}, {\n\t\tfilter: ['width', 'position', 'items', 'settings'],\n\t\trun: function run() {\n\t\t\tvar rtl = this.settings.rtl ? 1 : -1,\n\t\t\t    padding = this.settings.stagePadding * 2,\n\t\t\t    begin = this.coordinates(this.current()) + padding,\n\t\t\t    end = begin + this.width() * rtl,\n\t\t\t    inner,\n\t\t\t    outer,\n\t\t\t    matches = [],\n\t\t\t    i,\n\t\t\t    n;\n\n\t\t\tfor (i = 0, n = this._coordinates.length; i < n; i++) {\n\t\t\t\tinner = this._coordinates[i - 1] || 0;\n\t\t\t\touter = Math.abs(this._coordinates[i]) + padding * rtl;\n\n\t\t\t\tif (this.op(inner, '<=', begin) && this.op(inner, '>', end) || this.op(outer, '<', begin) && this.op(outer, '>', end)) {\n\t\t\t\t\tmatches.push(i);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tthis.$stage.children('.active').removeClass('active');\n\t\t\tthis.$stage.children(':eq(' + matches.join('), :eq(') + ')').addClass('active');\n\n\t\t\tif (this.settings.center) {\n\t\t\t\tthis.$stage.children('.center').removeClass('center');\n\t\t\t\tthis.$stage.children().eq(this.current()).addClass('center');\n\t\t\t}\n\t\t}\n\t}];\n\n\t/**\n  * Initializes the carousel.\n  * @protected\n  */\n\tOwl.prototype.initialize = function () {\n\t\tthis.enter('initializing');\n\t\tthis.trigger('initialize');\n\n\t\tthis.$element.toggleClass(this.settings.rtlClass, this.settings.rtl);\n\n\t\tif (this.settings.autoWidth && !this.is('pre-loading')) {\n\t\t\tvar imgs, nestedSelector, width;\n\t\t\timgs = this.$element.find('img');\n\t\t\tnestedSelector = this.settings.nestedItemSelector ? '.' + this.settings.nestedItemSelector : undefined;\n\t\t\twidth = this.$element.children(nestedSelector).width();\n\n\t\t\tif (imgs.length && width <= 0) {\n\t\t\t\tthis.preloadAutoWidthImages(imgs);\n\t\t\t}\n\t\t}\n\n\t\tthis.$element.addClass(this.options.loadingClass);\n\n\t\t// HACK: DISABLE SCROLLBAR\n\t\tvar overflowVal = $('body').css('overflow');\n\t\t$('body').css({ 'overflow': 'hidden' });\n\n\t\t// create stage\n\t\tthis.$stage = $('<' + this.settings.stageElement + ' class=\"' + this.settings.stageClass + '\"/>').wrap('<div class=\"' + this.settings.stageOuterClass + '\"/>');\n\n\t\t// append stage\n\t\tthis.$element.append(this.$stage.parent());\n\n\t\t// append content\n\t\tthis.replace(this.$element.children().not(this.$stage.parent()));\n\n\t\t// check visibility\n\t\tif (this.$element.is(':visible')) {\n\t\t\t// update view\n\t\t\tthis.refresh();\n\t\t} else {\n\t\t\t// invalidate width\n\t\t\tthis.invalidate('width');\n\t\t}\n\n\t\t// HACK: RESTORE SCROLLBAR\n\t\t$('body').css({ 'overflow': overflowVal });\n\n\t\tthis.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass);\n\n\t\t// register event handlers\n\t\tthis.registerEventHandlers();\n\n\t\tthis.leave('initializing');\n\t\tthis.trigger('initialized');\n\t};\n\n\t/**\n  * Setups the current settings.\n  * @todo Remove responsive classes. Why should adaptive designs be brought into IE8?\n  * @todo Support for media queries by using `matchMedia` would be nice.\n  * @public\n  */\n\tOwl.prototype.setup = function () {\n\t\tvar viewport = this.viewport(),\n\t\t    overwrites = this.options.responsive,\n\t\t    match = -1,\n\t\t    settings = null;\n\n\t\tif (!overwrites) {\n\t\t\tsettings = $.extend({}, this.options);\n\t\t} else {\n\t\t\t$.each(overwrites, function (breakpoint) {\n\t\t\t\tif (breakpoint <= viewport && breakpoint > match) {\n\t\t\t\t\tmatch = Number(breakpoint);\n\t\t\t\t}\n\t\t\t});\n\n\t\t\tsettings = $.extend({}, this.options, overwrites[match]);\n\t\t\tif (typeof settings.stagePadding === 'function') {\n\t\t\t\tsettings.stagePadding = settings.stagePadding();\n\t\t\t}\n\t\t\tdelete settings.responsive;\n\n\t\t\t// responsive class\n\t\t\tif (settings.responsiveClass) {\n\t\t\t\tthis.$element.attr('class', this.$element.attr('class').replace(new RegExp('(' + this.options.responsiveClass + '-)\\\\S+\\\\s', 'g'), '$1' + match));\n\t\t\t}\n\t\t}\n\n\t\tthis.trigger('change', { property: { name: 'settings', value: settings } });\n\t\tthis._breakpoint = match;\n\t\tthis.settings = settings;\n\t\tthis.invalidate('settings');\n\t\tthis.trigger('changed', { property: { name: 'settings', value: this.settings } });\n\t};\n\n\t/**\n  * Updates option logic if necessery.\n  * @protected\n  */\n\tOwl.prototype.optionsLogic = function () {\n\t\tif (this.settings.autoWidth) {\n\t\t\tthis.settings.stagePadding = false;\n\t\t\tthis.settings.merge = false;\n\t\t}\n\t};\n\n\t/**\n  * Prepares an item before add.\n  * @todo Rename event parameter `content` to `item`.\n  * @protected\n  * @returns {jQuery|HTMLElement} - The item container.\n  */\n\tOwl.prototype.prepare = function (item) {\n\t\tvar event = this.trigger('prepare', { content: item });\n\n\t\tif (!event.data) {\n\t\t\tevent.data = $('<' + this.settings.itemElement + '/>').addClass(this.options.itemClass).append(item);\n\t\t}\n\n\t\tthis.trigger('prepared', { content: event.data });\n\n\t\treturn event.data;\n\t};\n\n\t/**\n  * Updates the view.\n  * @public\n  */\n\tOwl.prototype.update = function () {\n\t\tvar i = 0,\n\t\t    n = this._pipe.length,\n\t\t    filter = $.proxy(function (p) {\n\t\t\treturn this[p];\n\t\t}, this._invalidated),\n\t\t    cache = {};\n\n\t\twhile (i < n) {\n\t\t\tif (this._invalidated.all || $.grep(this._pipe[i].filter, filter).length > 0) {\n\t\t\t\tthis._pipe[i].run(cache);\n\t\t\t}\n\t\t\ti++;\n\t\t}\n\n\t\tthis._invalidated = {};\n\n\t\t!this.is('valid') && this.enter('valid');\n\t};\n\n\t/**\n  * Gets the width of the view.\n  * @public\n  * @param {Owl.Width} [dimension=Owl.Width.Default] - The dimension to return.\n  * @returns {Number} - The width of the view in pixel.\n  */\n\tOwl.prototype.width = function (dimension) {\n\t\tdimension = dimension || Owl.Width.Default;\n\t\tswitch (dimension) {\n\t\t\tcase Owl.Width.Inner:\n\t\t\tcase Owl.Width.Outer:\n\t\t\t\treturn this._width;\n\t\t\tdefault:\n\t\t\t\treturn this._width - this.settings.stagePadding * 2 + this.settings.margin;\n\t\t}\n\t};\n\n\t/**\n  * Refreshes the carousel primarily for adaptive purposes.\n  * @public\n  */\n\tOwl.prototype.refresh = function () {\n\t\tthis.enter('refreshing');\n\t\tthis.trigger('refresh');\n\n\t\tthis.setup();\n\n\t\tthis.optionsLogic();\n\n\t\tthis.$element.addClass(this.options.refreshClass);\n\n\t\tthis.update();\n\n\t\tthis.$element.removeClass(this.options.refreshClass);\n\n\t\tthis.leave('refreshing');\n\t\tthis.trigger('refreshed');\n\t};\n\n\t/**\n  * Checks window `resize` event.\n  * @protected\n  */\n\tOwl.prototype.onThrottledResize = function () {\n\t\twindow.clearTimeout(this.resizeTimer);\n\t\tthis.resizeTimer = window.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate);\n\t};\n\n\t/**\n  * Checks window `resize` event.\n  * @protected\n  */\n\tOwl.prototype.onResize = function () {\n\t\tif (!this._items.length) {\n\t\t\treturn false;\n\t\t}\n\n\t\tif (this._width === this.$element.width()) {\n\t\t\treturn false;\n\t\t}\n\n\t\tif (!this.$element.is(':visible')) {\n\t\t\treturn false;\n\t\t}\n\n\t\tthis.enter('resizing');\n\n\t\tif (this.trigger('resize').isDefaultPrevented()) {\n\t\t\tthis.leave('resizing');\n\t\t\treturn false;\n\t\t}\n\n\t\tthis.invalidate('width');\n\n\t\tthis.refresh();\n\n\t\tthis.leave('resizing');\n\t\tthis.trigger('resized');\n\t};\n\n\t/**\n  * Registers event handlers.\n  * @todo Check `msPointerEnabled`\n  * @todo #261\n  * @protected\n  */\n\tOwl.prototype.registerEventHandlers = function () {\n\t\tif ($.support.transition) {\n\t\t\tthis.$stage.on($.support.transition.end + '.owl.core', $.proxy(this.onTransitionEnd, this));\n\t\t}\n\n\t\tif (this.settings.responsive !== false) {\n\t\t\tthis.on(window, 'resize', this._handlers.onThrottledResize);\n\t\t}\n\n\t\tif (this.settings.mouseDrag) {\n\t\t\tthis.$element.addClass(this.options.dragClass);\n\t\t\tthis.$stage.on('mousedown.owl.core', $.proxy(this.onDragStart, this));\n\t\t\tthis.$stage.on('dragstart.owl.core selectstart.owl.core', function () {\n\t\t\t\treturn false;\n\t\t\t});\n\t\t}\n\n\t\tif (this.settings.touchDrag) {\n\t\t\tthis.$stage.on('touchstart.owl.core', $.proxy(this.onDragStart, this));\n\t\t\tthis.$stage.on('touchcancel.owl.core', $.proxy(this.onDragEnd, this));\n\t\t}\n\t};\n\n\t/**\n  * Handles `touchstart` and `mousedown` events.\n  * @todo Horizontal swipe threshold as option\n  * @todo #261\n  * @protected\n  * @param {Event} event - The event arguments.\n  */\n\tOwl.prototype.onDragStart = function (event) {\n\t\tvar stage = null;\n\n\t\tif (event.which === 3) {\n\t\t\treturn;\n\t\t}\n\n\t\tif ($.support.transform) {\n\t\t\tstage = this.$stage.css('transform').replace(/.*\\(|\\)| /g, '').split(',');\n\t\t\tstage = {\n\t\t\t\tx: stage[stage.length === 16 ? 12 : 4],\n\t\t\t\ty: stage[stage.length === 16 ? 13 : 5]\n\t\t\t};\n\t\t} else {\n\t\t\tstage = this.$stage.position();\n\t\t\tstage = {\n\t\t\t\tx: this.settings.rtl ? stage.left + this.$stage.width() - this.width() + this.settings.margin : stage.left,\n\t\t\t\ty: stage.top\n\t\t\t};\n\t\t}\n\n\t\tif (this.is('animating')) {\n\t\t\t$.support.transform ? this.animate(stage.x) : this.$stage.stop();\n\t\t\tthis.invalidate('position');\n\t\t}\n\n\t\tthis.$element.toggleClass(this.options.grabClass, event.type === 'mousedown');\n\n\t\tthis.speed(0);\n\n\t\tthis._drag.time = new Date().getTime();\n\t\tthis._drag.target = $(event.target);\n\t\tthis._drag.stage.start = stage;\n\t\tthis._drag.stage.current = stage;\n\t\tthis._drag.pointer = this.pointer(event);\n\n\t\t$(document).on('mouseup.owl.core touchend.owl.core', $.proxy(this.onDragEnd, this));\n\n\t\t$(document).one('mousemove.owl.core touchmove.owl.core', $.proxy(function (event) {\n\t\t\tvar delta = this.difference(this._drag.pointer, this.pointer(event));\n\n\t\t\t$(document).on('mousemove.owl.core touchmove.owl.core', $.proxy(this.onDragMove, this));\n\n\t\t\tif (Math.abs(delta.x) < Math.abs(delta.y) && this.is('valid')) {\n\t\t\t\treturn;\n\t\t\t}\n\n\t\t\tevent.preventDefault();\n\n\t\t\tthis.enter('dragging');\n\t\t\tthis.trigger('drag');\n\t\t}, this));\n\t};\n\n\t/**\n  * Handles the `touchmove` and `mousemove` events.\n  * @todo #261\n  * @protected\n  * @param {Event} event - The event arguments.\n  */\n\tOwl.prototype.onDragMove = function (event) {\n\t\tvar minimum = null,\n\t\t    maximum = null,\n\t\t    pull = null,\n\t\t    delta = this.difference(this._drag.pointer, this.pointer(event)),\n\t\t    stage = this.difference(this._drag.stage.start, delta);\n\n\t\tif (!this.is('dragging')) {\n\t\t\treturn;\n\t\t}\n\n\t\tevent.preventDefault();\n\n\t\tif (this.settings.loop) {\n\t\t\tminimum = this.coordinates(this.minimum());\n\t\t\tmaximum = this.coordinates(this.maximum() + 1) - minimum;\n\t\t\tstage.x = ((stage.x - minimum) % maximum + maximum) % maximum + minimum;\n\t\t} else {\n\t\t\tminimum = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum());\n\t\t\tmaximum = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum());\n\t\t\tpull = this.settings.pullDrag ? -1 * delta.x / 5 : 0;\n\t\t\tstage.x = Math.max(Math.min(stage.x, minimum + pull), maximum + pull);\n\t\t}\n\n\t\tthis._drag.stage.current = stage;\n\n\t\tthis.animate(stage.x);\n\t};\n\n\t/**\n  * Handles the `touchend` and `mouseup` events.\n  * @todo #261\n  * @todo Threshold for click event\n  * @protected\n  * @param {Event} event - The event arguments.\n  */\n\tOwl.prototype.onDragEnd = function (event) {\n\t\tvar delta = this.difference(this._drag.pointer, this.pointer(event)),\n\t\t    stage = this._drag.stage.current,\n\t\t    direction = delta.x > 0 ^ this.settings.rtl ? 'left' : 'right';\n\n\t\t$(document).off('.owl.core');\n\n\t\tthis.$element.removeClass(this.options.grabClass);\n\n\t\tif (delta.x !== 0 && this.is('dragging') || !this.is('valid')) {\n\t\t\tthis.speed(this.settings.dragEndSpeed || this.settings.smartSpeed);\n\t\t\tthis.current(this.closest(stage.x, delta.x !== 0 ? direction : this._drag.direction));\n\t\t\tthis.invalidate('position');\n\t\t\tthis.update();\n\n\t\t\tthis._drag.direction = direction;\n\n\t\t\tif (Math.abs(delta.x) > 3 || new Date().getTime() - this._drag.time > 300) {\n\t\t\t\tthis._drag.target.one('click.owl.core', function () {\n\t\t\t\t\treturn false;\n\t\t\t\t});\n\t\t\t}\n\t\t}\n\n\t\tif (!this.is('dragging')) {\n\t\t\treturn;\n\t\t}\n\n\t\tthis.leave('dragging');\n\t\tthis.trigger('dragged');\n\t};\n\n\t/**\n  * Gets absolute position of the closest item for a coordinate.\n  * @todo Setting `freeDrag` makes `closest` not reusable. See #165.\n  * @protected\n  * @param {Number} coordinate - The coordinate in pixel.\n  * @param {String} direction - The direction to check for the closest item. Ether `left` or `right`.\n  * @return {Number} - The absolute position of the closest item.\n  */\n\tOwl.prototype.closest = function (coordinate, direction) {\n\t\tvar position = -1,\n\t\t    pull = 30,\n\t\t    width = this.width(),\n\t\t    coordinates = this.coordinates();\n\n\t\tif (!this.settings.freeDrag) {\n\t\t\t// check closest item\n\t\t\t$.each(coordinates, $.proxy(function (index, value) {\n\t\t\t\t// on a left pull, check on current index\n\t\t\t\tif (direction === 'left' && coordinate > value - pull && coordinate < value + pull) {\n\t\t\t\t\tposition = index;\n\t\t\t\t\t// on a right pull, check on previous index\n\t\t\t\t\t// to do so, subtract width from value and set position = index + 1\n\t\t\t\t} else if (direction === 'right' && coordinate > value - width - pull && coordinate < value - width + pull) {\n\t\t\t\t\tposition = index + 1;\n\t\t\t\t} else if (this.op(coordinate, '<', value) && this.op(coordinate, '>', coordinates[index + 1] || value - width)) {\n\t\t\t\t\tposition = direction === 'left' ? index + 1 : index;\n\t\t\t\t}\n\t\t\t\treturn position === -1;\n\t\t\t}, this));\n\t\t}\n\n\t\tif (!this.settings.loop) {\n\t\t\t// non loop boundries\n\t\t\tif (this.op(coordinate, '>', coordinates[this.minimum()])) {\n\t\t\t\tposition = coordinate = this.minimum();\n\t\t\t} else if (this.op(coordinate, '<', coordinates[this.maximum()])) {\n\t\t\t\tposition = coordinate = this.maximum();\n\t\t\t}\n\t\t}\n\n\t\treturn position;\n\t};\n\n\t/**\n  * Animates the stage.\n  * @todo #270\n  * @public\n  * @param {Number} coordinate - The coordinate in pixels.\n  */\n\tOwl.prototype.animate = function (coordinate) {\n\t\tvar animate = this.speed() > 0;\n\n\t\tthis.is('animating') && this.onTransitionEnd();\n\n\t\tif (animate) {\n\t\t\tthis.enter('animating');\n\t\t\tthis.trigger('translate');\n\t\t}\n\n\t\tif ($.support.transform3d && $.support.transition) {\n\t\t\tthis.$stage.css({\n\t\t\t\ttransform: 'translate3d(' + coordinate + 'px,0px,0px)',\n\t\t\t\ttransition: this.speed() / 1000 + 's'\n\t\t\t});\n\t\t} else if (animate) {\n\t\t\tthis.$stage.animate({\n\t\t\t\tleft: coordinate + 'px'\n\t\t\t}, this.speed(), this.settings.fallbackEasing, $.proxy(this.onTransitionEnd, this));\n\t\t} else {\n\t\t\tthis.$stage.css({\n\t\t\t\tleft: coordinate + 'px'\n\t\t\t});\n\t\t}\n\t};\n\n\t/**\n  * Checks whether the carousel is in a specific state or not.\n  * @param {String} state - The state to check.\n  * @returns {Boolean} - The flag which indicates if the carousel is busy.\n  */\n\tOwl.prototype.is = function (state) {\n\t\treturn this._states.current[state] && this._states.current[state] > 0;\n\t};\n\n\t/**\n  * Sets the absolute position of the current item.\n  * @public\n  * @param {Number} [position] - The new absolute position or nothing to leave it unchanged.\n  * @returns {Number} - The absolute position of the current item.\n  */\n\tOwl.prototype.current = function (position) {\n\t\tif (position === undefined) {\n\t\t\treturn this._current;\n\t\t}\n\n\t\tif (this._items.length === 0) {\n\t\t\treturn undefined;\n\t\t}\n\n\t\tposition = this.normalize(position);\n\n\t\tif (this._current !== position) {\n\t\t\tvar event = this.trigger('change', { property: { name: 'position', value: position } });\n\n\t\t\tif (event.data !== undefined) {\n\t\t\t\tposition = this.normalize(event.data);\n\t\t\t}\n\n\t\t\tthis._current = position;\n\n\t\t\tthis.invalidate('position');\n\n\t\t\tthis.trigger('changed', { property: { name: 'position', value: this._current } });\n\t\t}\n\n\t\treturn this._current;\n\t};\n\n\t/**\n  * Invalidates the given part of the update routine.\n  * @param {String} [part] - The part to invalidate.\n  * @returns {Array.<String>} - The invalidated parts.\n  */\n\tOwl.prototype.invalidate = function (part) {\n\t\tif ($.type(part) === 'string') {\n\t\t\tthis._invalidated[part] = true;\n\t\t\tthis.is('valid') && this.leave('valid');\n\t\t}\n\t\treturn $.map(this._invalidated, function (v, i) {\n\t\t\treturn i;\n\t\t});\n\t};\n\n\t/**\n  * Resets the absolute position of the current item.\n  * @public\n  * @param {Number} position - The absolute position of the new item.\n  */\n\tOwl.prototype.reset = function (position) {\n\t\tposition = this.normalize(position);\n\n\t\tif (position === undefined) {\n\t\t\treturn;\n\t\t}\n\n\t\tthis._speed = 0;\n\t\tthis._current = position;\n\n\t\tthis.suppress(['translate', 'translated']);\n\n\t\tthis.animate(this.coordinates(position));\n\n\t\tthis.release(['translate', 'translated']);\n\t};\n\n\t/**\n  * Normalizes an absolute or a relative position of an item.\n  * @public\n  * @param {Number} position - The absolute or relative position to normalize.\n  * @param {Boolean} [relative=false] - Whether the given position is relative or not.\n  * @returns {Number} - The normalized position.\n  */\n\tOwl.prototype.normalize = function (position, relative) {\n\t\tvar n = this._items.length,\n\t\t    m = relative ? 0 : this._clones.length;\n\n\t\tif (!this.isNumeric(position) || n < 1) {\n\t\t\tposition = undefined;\n\t\t} else if (position < 0 || position >= n + m) {\n\t\t\tposition = ((position - m / 2) % n + n) % n + m / 2;\n\t\t}\n\n\t\treturn position;\n\t};\n\n\t/**\n  * Converts an absolute position of an item into a relative one.\n  * @public\n  * @param {Number} position - The absolute position to convert.\n  * @returns {Number} - The converted position.\n  */\n\tOwl.prototype.relative = function (position) {\n\t\tposition -= this._clones.length / 2;\n\t\treturn this.normalize(position, true);\n\t};\n\n\t/**\n  * Gets the maximum position for the current item.\n  * @public\n  * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.\n  * @returns {Number}\n  */\n\tOwl.prototype.maximum = function (relative) {\n\t\tvar settings = this.settings,\n\t\t    maximum = this._coordinates.length,\n\t\t    iterator,\n\t\t    reciprocalItemsWidth,\n\t\t    elementWidth;\n\n\t\tif (settings.loop) {\n\t\t\tmaximum = this._clones.length / 2 + this._items.length - 1;\n\t\t} else if (settings.autoWidth || settings.merge) {\n\t\t\titerator = this._items.length;\n\t\t\treciprocalItemsWidth = this._items[--iterator].width();\n\t\t\telementWidth = this.$element.width();\n\t\t\twhile (iterator--) {\n\t\t\t\treciprocalItemsWidth += this._items[iterator].width() + this.settings.margin;\n\t\t\t\tif (reciprocalItemsWidth > elementWidth) {\n\t\t\t\t\tbreak;\n\t\t\t\t}\n\t\t\t}\n\t\t\tmaximum = iterator + 1;\n\t\t} else if (settings.center) {\n\t\t\tmaximum = this._items.length - 1;\n\t\t} else {\n\t\t\tmaximum = this._items.length - settings.items;\n\t\t}\n\n\t\tif (relative) {\n\t\t\tmaximum -= this._clones.length / 2;\n\t\t}\n\n\t\treturn Math.max(maximum, 0);\n\t};\n\n\t/**\n  * Gets the minimum position for the current item.\n  * @public\n  * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.\n  * @returns {Number}\n  */\n\tOwl.prototype.minimum = function (relative) {\n\t\treturn relative ? 0 : this._clones.length / 2;\n\t};\n\n\t/**\n  * Gets an item at the specified relative position.\n  * @public\n  * @param {Number} [position] - The relative position of the item.\n  * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.\n  */\n\tOwl.prototype.items = function (position) {\n\t\tif (position === undefined) {\n\t\t\treturn this._items.slice();\n\t\t}\n\n\t\tposition = this.normalize(position, true);\n\t\treturn this._items[position];\n\t};\n\n\t/**\n  * Gets an item at the specified relative position.\n  * @public\n  * @param {Number} [position] - The relative position of the item.\n  * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.\n  */\n\tOwl.prototype.mergers = function (position) {\n\t\tif (position === undefined) {\n\t\t\treturn this._mergers.slice();\n\t\t}\n\n\t\tposition = this.normalize(position, true);\n\t\treturn this._mergers[position];\n\t};\n\n\t/**\n  * Gets the absolute positions of clones for an item.\n  * @public\n  * @param {Number} [position] - The relative position of the item.\n  * @returns {Array.<Number>} - The absolute positions of clones for the item or all if no position was given.\n  */\n\tOwl.prototype.clones = function (position) {\n\t\tvar odd = this._clones.length / 2,\n\t\t    even = odd + this._items.length,\n\t\t    map = function map(index) {\n\t\t\treturn index % 2 === 0 ? even + index / 2 : odd - (index + 1) / 2;\n\t\t};\n\n\t\tif (position === undefined) {\n\t\t\treturn $.map(this._clones, function (v, i) {\n\t\t\t\treturn map(i);\n\t\t\t});\n\t\t}\n\n\t\treturn $.map(this._clones, function (v, i) {\n\t\t\treturn v === position ? map(i) : null;\n\t\t});\n\t};\n\n\t/**\n  * Sets the current animation speed.\n  * @public\n  * @param {Number} [speed] - The animation speed in milliseconds or nothing to leave it unchanged.\n  * @returns {Number} - The current animation speed in milliseconds.\n  */\n\tOwl.prototype.speed = function (speed) {\n\t\tif (speed !== undefined) {\n\t\t\tthis._speed = speed;\n\t\t}\n\n\t\treturn this._speed;\n\t};\n\n\t/**\n  * Gets the coordinate of an item.\n  * @todo The name of this method is missleanding.\n  * @public\n  * @param {Number} position - The absolute position of the item within `minimum()` and `maximum()`.\n  * @returns {Number|Array.<Number>} - The coordinate of the item in pixel or all coordinates.\n  */\n\tOwl.prototype.coordinates = function (position) {\n\t\tvar multiplier = 1,\n\t\t    newPosition = position - 1,\n\t\t    coordinate;\n\n\t\tif (position === undefined) {\n\t\t\treturn $.map(this._coordinates, $.proxy(function (coordinate, index) {\n\t\t\t\treturn this.coordinates(index);\n\t\t\t}, this));\n\t\t}\n\n\t\tif (this.settings.center) {\n\t\t\tif (this.settings.rtl) {\n\t\t\t\tmultiplier = -1;\n\t\t\t\tnewPosition = position + 1;\n\t\t\t}\n\n\t\t\tcoordinate = this._coordinates[position];\n\t\t\tcoordinate += (this.width() - coordinate + (this._coordinates[newPosition] || 0)) / 2 * multiplier;\n\t\t} else {\n\t\t\tcoordinate = this._coordinates[newPosition] || 0;\n\t\t}\n\n\t\tcoordinate = Math.ceil(coordinate);\n\n\t\treturn coordinate;\n\t};\n\n\t/**\n  * Calculates the speed for a translation.\n  * @protected\n  * @param {Number} from - The absolute position of the start item.\n  * @param {Number} to - The absolute position of the target item.\n  * @param {Number} [factor=undefined] - The time factor in milliseconds.\n  * @returns {Number} - The time in milliseconds for the translation.\n  */\n\tOwl.prototype.duration = function (from, to, factor) {\n\t\tif (factor === 0) {\n\t\t\treturn 0;\n\t\t}\n\n\t\treturn Math.min(Math.max(Math.abs(to - from), 1), 6) * Math.abs(factor || this.settings.smartSpeed);\n\t};\n\n\t/**\n  * Slides to the specified item.\n  * @public\n  * @param {Number} position - The position of the item.\n  * @param {Number} [speed] - The time in milliseconds for the transition.\n  */\n\tOwl.prototype.to = function (position, speed) {\n\t\tvar current = this.current(),\n\t\t    revert = null,\n\t\t    distance = position - this.relative(current),\n\t\t    direction = (distance > 0) - (distance < 0),\n\t\t    items = this._items.length,\n\t\t    minimum = this.minimum(),\n\t\t    maximum = this.maximum();\n\n\t\tif (this.settings.loop) {\n\t\t\tif (!this.settings.rewind && Math.abs(distance) > items / 2) {\n\t\t\t\tdistance += direction * -1 * items;\n\t\t\t}\n\n\t\t\tposition = current + distance;\n\t\t\trevert = ((position - minimum) % items + items) % items + minimum;\n\n\t\t\tif (revert !== position && revert - distance <= maximum && revert - distance > 0) {\n\t\t\t\tcurrent = revert - distance;\n\t\t\t\tposition = revert;\n\t\t\t\tthis.reset(current);\n\t\t\t}\n\t\t} else if (this.settings.rewind) {\n\t\t\tmaximum += 1;\n\t\t\tposition = (position % maximum + maximum) % maximum;\n\t\t} else {\n\t\t\tposition = Math.max(minimum, Math.min(maximum, position));\n\t\t}\n\n\t\tthis.speed(this.duration(current, position, speed));\n\t\tthis.current(position);\n\n\t\tif (this.$element.is(':visible')) {\n\t\t\tthis.update();\n\t\t}\n\t};\n\n\t/**\n  * Slides to the next item.\n  * @public\n  * @param {Number} [speed] - The time in milliseconds for the transition.\n  */\n\tOwl.prototype.next = function (speed) {\n\t\tspeed = speed || false;\n\t\tthis.to(this.relative(this.current()) + 1, speed);\n\t};\n\n\t/**\n  * Slides to the previous item.\n  * @public\n  * @param {Number} [speed] - The time in milliseconds for the transition.\n  */\n\tOwl.prototype.prev = function (speed) {\n\t\tspeed = speed || false;\n\t\tthis.to(this.relative(this.current()) - 1, speed);\n\t};\n\n\t/**\n  * Handles the end of an animation.\n  * @protected\n  * @param {Event} event - The event arguments.\n  */\n\tOwl.prototype.onTransitionEnd = function (event) {\n\n\t\t// if css2 animation then event object is undefined\n\t\tif (event !== undefined) {\n\t\t\tevent.stopPropagation();\n\n\t\t\t// Catch only owl-stage transitionEnd event\n\t\t\tif ((event.target || event.srcElement || event.originalTarget) !== this.$stage.get(0)) {\n\t\t\t\treturn false;\n\t\t\t}\n\t\t}\n\n\t\tthis.leave('animating');\n\t\tthis.trigger('translated');\n\t};\n\n\t/**\n  * Gets viewport width.\n  * @protected\n  * @return {Number} - The width in pixel.\n  */\n\tOwl.prototype.viewport = function () {\n\t\tvar width;\n\t\tif (this.options.responsiveBaseElement !== window) {\n\t\t\twidth = $(this.options.responsiveBaseElement).width();\n\t\t} else if (window.innerWidth) {\n\t\t\twidth = window.innerWidth;\n\t\t} else if (document.documentElement && document.documentElement.clientWidth) {\n\t\t\twidth = document.documentElement.clientWidth;\n\t\t} else {\n\t\t\tconsole.warn('Can not detect viewport width.');\n\t\t}\n\t\treturn width;\n\t};\n\n\t/**\n  * Replaces the current content.\n  * @public\n  * @param {HTMLElement|jQuery|String} content - The new content.\n  */\n\tOwl.prototype.replace = function (content) {\n\t\tthis.$stage.empty();\n\t\tthis._items = [];\n\n\t\tif (content) {\n\t\t\tcontent = content instanceof jQuery ? content : $(content);\n\t\t}\n\n\t\tif (this.settings.nestedItemSelector) {\n\t\t\tcontent = content.find('.' + this.settings.nestedItemSelector);\n\t\t}\n\n\t\tcontent.filter(function () {\n\t\t\treturn this.nodeType === 1;\n\t\t}).each($.proxy(function (index, item) {\n\t\t\titem = this.prepare(item);\n\t\t\tthis.$stage.append(item);\n\t\t\tthis._items.push(item);\n\t\t\tthis._mergers.push(item.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);\n\t\t}, this));\n\n\t\tthis.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0);\n\n\t\tthis.invalidate('items');\n\t};\n\n\t/**\n  * Adds an item.\n  * @todo Use `item` instead of `content` for the event arguments.\n  * @public\n  * @param {HTMLElement|jQuery|String} content - The item content to add.\n  * @param {Number} [position] - The relative position at which to insert the item otherwise the item will be added to the end.\n  */\n\tOwl.prototype.add = function (content, position) {\n\t\tvar current = this.relative(this._current);\n\n\t\tposition = position === undefined ? this._items.length : this.normalize(position, true);\n\t\tcontent = content instanceof jQuery ? content : $(content);\n\n\t\tthis.trigger('add', { content: content, position: position });\n\n\t\tcontent = this.prepare(content);\n\n\t\tif (this._items.length === 0 || position === this._items.length) {\n\t\t\tthis._items.length === 0 && this.$stage.append(content);\n\t\t\tthis._items.length !== 0 && this._items[position - 1].after(content);\n\t\t\tthis._items.push(content);\n\t\t\tthis._mergers.push(content.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);\n\t\t} else {\n\t\t\tthis._items[position].before(content);\n\t\t\tthis._items.splice(position, 0, content);\n\t\t\tthis._mergers.splice(position, 0, content.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);\n\t\t}\n\n\t\tthis._items[current] && this.reset(this._items[current].index());\n\n\t\tthis.invalidate('items');\n\n\t\tthis.trigger('added', { content: content, position: position });\n\t};\n\n\t/**\n  * Removes an item by its position.\n  * @todo Use `item` instead of `content` for the event arguments.\n  * @public\n  * @param {Number} position - The relative position of the item to remove.\n  */\n\tOwl.prototype.remove = function (position) {\n\t\tposition = this.normalize(position, true);\n\n\t\tif (position === undefined) {\n\t\t\treturn;\n\t\t}\n\n\t\tthis.trigger('remove', { content: this._items[position], position: position });\n\n\t\tthis._items[position].remove();\n\t\tthis._items.splice(position, 1);\n\t\tthis._mergers.splice(position, 1);\n\n\t\tthis.invalidate('items');\n\n\t\tthis.trigger('removed', { content: null, position: position });\n\t};\n\n\t/**\n  * Preloads images with auto width.\n  * @todo Replace by a more generic approach\n  * @protected\n  */\n\tOwl.prototype.preloadAutoWidthImages = function (images) {\n\t\timages.each($.proxy(function (i, element) {\n\t\t\tthis.enter('pre-loading');\n\t\t\telement = $(element);\n\t\t\t$(new Image()).one('load', $.proxy(function (e) {\n\t\t\t\telement.attr('src', e.target.src);\n\t\t\t\telement.css('opacity', 1);\n\t\t\t\tthis.leave('pre-loading');\n\t\t\t\t!this.is('pre-loading') && !this.is('initializing') && this.refresh();\n\t\t\t}, this)).attr('src', element.attr('src') || element.attr('data-src') || element.attr('data-src-retina'));\n\t\t}, this));\n\t};\n\n\t/**\n  * Destroys the carousel.\n  * @public\n  */\n\tOwl.prototype.destroy = function () {\n\n\t\tthis.$element.off('.owl.core');\n\t\tthis.$stage.off('.owl.core');\n\t\t$(document).off('.owl.core');\n\n\t\tif (this.settings.responsive !== false) {\n\t\t\twindow.clearTimeout(this.resizeTimer);\n\t\t\tthis.off(window, 'resize', this._handlers.onThrottledResize);\n\t\t}\n\n\t\tfor (var i in this._plugins) {\n\t\t\tthis._plugins[i].destroy();\n\t\t}\n\n\t\tthis.$stage.children('.cloned').remove();\n\n\t\tthis.$stage.unwrap();\n\t\tthis.$stage.children().contents().unwrap();\n\t\tthis.$stage.children().unwrap();\n\n\t\tthis.$element.removeClass(this.options.refreshClass).removeClass(this.options.loadingClass).removeClass(this.options.loadedClass).removeClass(this.options.rtlClass).removeClass(this.options.dragClass).removeClass(this.options.grabClass).attr('class', this.$element.attr('class').replace(new RegExp(this.options.responsiveClass + '-\\\\S+\\\\s', 'g'), '')).removeData('owl.carousel');\n\t};\n\n\t/**\n  * Operators to calculate right-to-left and left-to-right.\n  * @protected\n  * @param {Number} [a] - The left side operand.\n  * @param {String} [o] - The operator.\n  * @param {Number} [b] - The right side operand.\n  */\n\tOwl.prototype.op = function (a, o, b) {\n\t\tvar rtl = this.settings.rtl;\n\t\tswitch (o) {\n\t\t\tcase '<':\n\t\t\t\treturn rtl ? a > b : a < b;\n\t\t\tcase '>':\n\t\t\t\treturn rtl ? a < b : a > b;\n\t\t\tcase '>=':\n\t\t\t\treturn rtl ? a <= b : a >= b;\n\t\t\tcase '<=':\n\t\t\t\treturn rtl ? a >= b : a <= b;\n\t\t\tdefault:\n\t\t\t\tbreak;\n\t\t}\n\t};\n\n\t/**\n  * Attaches to an internal event.\n  * @protected\n  * @param {HTMLElement} element - The event source.\n  * @param {String} event - The event name.\n  * @param {Function} listener - The event handler to attach.\n  * @param {Boolean} capture - Wether the event should be handled at the capturing phase or not.\n  */\n\tOwl.prototype.on = function (element, event, listener, capture) {\n\t\tif (element.addEventListener) {\n\t\t\telement.addEventListener(event, listener, capture);\n\t\t} else if (element.attachEvent) {\n\t\t\telement.attachEvent('on' + event, listener);\n\t\t}\n\t};\n\n\t/**\n  * Detaches from an internal event.\n  * @protected\n  * @param {HTMLElement} element - The event source.\n  * @param {String} event - The event name.\n  * @param {Function} listener - The attached event handler to detach.\n  * @param {Boolean} capture - Wether the attached event handler was registered as a capturing listener or not.\n  */\n\tOwl.prototype.off = function (element, event, listener, capture) {\n\t\tif (element.removeEventListener) {\n\t\t\telement.removeEventListener(event, listener, capture);\n\t\t} else if (element.detachEvent) {\n\t\t\telement.detachEvent('on' + event, listener);\n\t\t}\n\t};\n\n\t/**\n  * Triggers a public event.\n  * @todo Remove `status`, `relatedTarget` should be used instead.\n  * @protected\n  * @param {String} name - The event name.\n  * @param {*} [data=null] - The event data.\n  * @param {String} [namespace=carousel] - The event namespace.\n  * @param {String} [state] - The state which is associated with the event.\n  * @param {Boolean} [enter=false] - Indicates if the call enters the specified state or not.\n  * @returns {Event} - The event arguments.\n  */\n\tOwl.prototype.trigger = function (name, data, namespace, state, enter) {\n\t\tvar status = {\n\t\t\titem: { count: this._items.length, index: this.current() }\n\t\t},\n\t\t    handler = $.camelCase($.grep(['on', name, namespace], function (v) {\n\t\t\treturn v;\n\t\t}).join('-').toLowerCase()),\n\t\t    event = $.Event([name, 'owl', namespace || 'carousel'].join('.').toLowerCase(), $.extend({ relatedTarget: this }, status, data));\n\n\t\tif (!this._supress[name]) {\n\t\t\t$.each(this._plugins, function (name, plugin) {\n\t\t\t\tif (plugin.onTrigger) {\n\t\t\t\t\tplugin.onTrigger(event);\n\t\t\t\t}\n\t\t\t});\n\n\t\t\tthis.register({ type: Owl.Type.Event, name: name });\n\t\t\tthis.$element.trigger(event);\n\n\t\t\tif (this.settings && typeof this.settings[handler] === 'function') {\n\t\t\t\tthis.settings[handler].call(this, event);\n\t\t\t}\n\t\t}\n\n\t\treturn event;\n\t};\n\n\t/**\n  * Enters a state.\n  * @param name - The state name.\n  */\n\tOwl.prototype.enter = function (name) {\n\t\t$.each([name].concat(this._states.tags[name] || []), $.proxy(function (i, name) {\n\t\t\tif (this._states.current[name] === undefined) {\n\t\t\t\tthis._states.current[name] = 0;\n\t\t\t}\n\n\t\t\tthis._states.current[name]++;\n\t\t}, this));\n\t};\n\n\t/**\n  * Leaves a state.\n  * @param name - The state name.\n  */\n\tOwl.prototype.leave = function (name) {\n\t\t$.each([name].concat(this._states.tags[name] || []), $.proxy(function (i, name) {\n\t\t\tthis._states.current[name]--;\n\t\t}, this));\n\t};\n\n\t/**\n  * Registers an event or state.\n  * @public\n  * @param {Object} object - The event or state to register.\n  */\n\tOwl.prototype.register = function (object) {\n\t\tif (object.type === Owl.Type.Event) {\n\t\t\tif (!$.event.special[object.name]) {\n\t\t\t\t$.event.special[object.name] = {};\n\t\t\t}\n\n\t\t\tif (!$.event.special[object.name].owl) {\n\t\t\t\tvar _default = $.event.special[object.name]._default;\n\t\t\t\t$.event.special[object.name]._default = function (e) {\n\t\t\t\t\tif (_default && _default.apply && (!e.namespace || e.namespace.indexOf('owl') === -1)) {\n\t\t\t\t\t\treturn _default.apply(this, arguments);\n\t\t\t\t\t}\n\t\t\t\t\treturn e.namespace && e.namespace.indexOf('owl') > -1;\n\t\t\t\t};\n\t\t\t\t$.event.special[object.name].owl = true;\n\t\t\t}\n\t\t} else if (object.type === Owl.Type.State) {\n\t\t\tif (!this._states.tags[object.name]) {\n\t\t\t\tthis._states.tags[object.name] = object.tags;\n\t\t\t} else {\n\t\t\t\tthis._states.tags[object.name] = this._states.tags[object.name].concat(object.tags);\n\t\t\t}\n\n\t\t\tthis._states.tags[object.name] = $.grep(this._states.tags[object.name], $.proxy(function (tag, i) {\n\t\t\t\treturn $.inArray(tag, this._states.tags[object.name]) === i;\n\t\t\t}, this));\n\t\t}\n\t};\n\n\t/**\n  * Suppresses events.\n  * @protected\n  * @param {Array.<String>} events - The events to suppress.\n  */\n\tOwl.prototype.suppress = function (events) {\n\t\t$.each(events, $.proxy(function (index, event) {\n\t\t\tthis._supress[event] = true;\n\t\t}, this));\n\t};\n\n\t/**\n  * Releases suppressed events.\n  * @protected\n  * @param {Array.<String>} events - The events to release.\n  */\n\tOwl.prototype.release = function (events) {\n\t\t$.each(events, $.proxy(function (index, event) {\n\t\t\tdelete this._supress[event];\n\t\t}, this));\n\t};\n\n\t/**\n  * Gets unified pointer coordinates from event.\n  * @todo #261\n  * @protected\n  * @param {Event} - The `mousedown` or `touchstart` event.\n  * @returns {Object} - Contains `x` and `y` coordinates of current pointer position.\n  */\n\tOwl.prototype.pointer = function (event) {\n\t\tvar result = { x: null, y: null };\n\n\t\tevent = event.originalEvent || event || window.event;\n\n\t\tevent = event.touches && event.touches.length ? event.touches[0] : event.changedTouches && event.changedTouches.length ? event.changedTouches[0] : event;\n\n\t\tif (event.pageX) {\n\t\t\tresult.x = event.pageX;\n\t\t\tresult.y = event.pageY;\n\t\t} else {\n\t\t\tresult.x = event.clientX;\n\t\t\tresult.y = event.clientY;\n\t\t}\n\n\t\treturn result;\n\t};\n\n\t/**\n  * Determines if the input is a Number or something that can be coerced to a Number\n  * @protected\n  * @param {Number|String|Object|Array|Boolean|RegExp|Function|Symbol} - The input to be tested\n  * @returns {Boolean} - An indication if the input is a Number or can be coerced to a Number\n  */\n\tOwl.prototype.isNumeric = function (number) {\n\t\treturn !isNaN(parseFloat(number));\n\t};\n\n\t/**\n  * Gets the difference of two vectors.\n  * @todo #261\n  * @protected\n  * @param {Object} - The first vector.\n  * @param {Object} - The second vector.\n  * @returns {Object} - The difference.\n  */\n\tOwl.prototype.difference = function (first, second) {\n\t\treturn {\n\t\t\tx: first.x - second.x,\n\t\t\ty: first.y - second.y\n\t\t};\n\t};\n\n\t/**\n  * The jQuery Plugin for the Owl Carousel\n  * @todo Navigation plugin `next` and `prev`\n  * @public\n  */\n\t$.fn.owlCarousel = function (option) {\n\t\tvar args = Array.prototype.slice.call(arguments, 1);\n\n\t\treturn this.each(function () {\n\t\t\tvar $this = $(this),\n\t\t\t    data = $this.data('owl.carousel');\n\n\t\t\tif (!data) {\n\t\t\t\tdata = new Owl(this, (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option);\n\t\t\t\t$this.data('owl.carousel', data);\n\n\t\t\t\t$.each(['next', 'prev', 'to', 'destroy', 'refresh', 'replace', 'add', 'remove'], function (i, event) {\n\t\t\t\t\tdata.register({ type: Owl.Type.Event, name: event });\n\t\t\t\t\tdata.$element.on(event + '.owl.carousel.core', $.proxy(function (e) {\n\t\t\t\t\t\tif (e.namespace && e.relatedTarget !== this) {\n\t\t\t\t\t\t\tthis.suppress([event]);\n\t\t\t\t\t\t\tdata[event].apply(this, [].slice.call(arguments, 1));\n\t\t\t\t\t\t\tthis.release([event]);\n\t\t\t\t\t\t}\n\t\t\t\t\t}, data));\n\t\t\t\t});\n\t\t\t}\n\n\t\t\tif (typeof option == 'string' && option.charAt(0) !== '_') {\n\t\t\t\tdata[option].apply(data, args);\n\t\t\t}\n\t\t});\n\t};\n\n\t/**\n  * The constructor for the jQuery Plugin\n  * @public\n  */\n\t$.fn.owlCarousel.Constructor = Owl;\n})(window.Zepto || window.jQuery, window, document);\n\n/**\n * AutoRefresh Plugin\n * @version 2.1.0\n * @author Artus Kolanowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n */\n;(function ($, window, document, undefined) {\n\n\t/**\n  * Creates the auto refresh plugin.\n  * @class The Auto Refresh Plugin\n  * @param {Owl} carousel - The Owl Carousel\n  */\n\tvar AutoRefresh = function AutoRefresh(carousel) {\n\t\t/**\n   * Reference to the core.\n   * @protected\n   * @type {Owl}\n   */\n\t\tthis._core = carousel;\n\n\t\t/**\n   * Refresh interval.\n   * @protected\n   * @type {number}\n   */\n\t\tthis._interval = null;\n\n\t\t/**\n   * Whether the element is currently visible or not.\n   * @protected\n   * @type {Boolean}\n   */\n\t\tthis._visible = null;\n\n\t\t/**\n   * All event handlers.\n   * @protected\n   * @type {Object}\n   */\n\t\tthis._handlers = {\n\t\t\t'initialized.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && this._core.settings.autoRefresh) {\n\t\t\t\t\tthis.watch();\n\t\t\t\t}\n\t\t\t}, this)\n\t\t};\n\n\t\t// set default options\n\t\tthis._core.options = $.extend({}, AutoRefresh.Defaults, this._core.options);\n\n\t\t// register event handlers\n\t\tthis._core.$element.on(this._handlers);\n\t};\n\n\t/**\n  * Default options.\n  * @public\n  */\n\tAutoRefresh.Defaults = {\n\t\tautoRefresh: true,\n\t\tautoRefreshInterval: 500\n\t};\n\n\t/**\n  * Watches the element.\n  */\n\tAutoRefresh.prototype.watch = function () {\n\t\tif (this._interval) {\n\t\t\treturn;\n\t\t}\n\n\t\tthis._visible = this._core.$element.is(':visible');\n\t\tthis._interval = window.setInterval($.proxy(this.refresh, this), this._core.settings.autoRefreshInterval);\n\t};\n\n\t/**\n  * Refreshes the element.\n  */\n\tAutoRefresh.prototype.refresh = function () {\n\t\tif (this._core.$element.is(':visible') === this._visible) {\n\t\t\treturn;\n\t\t}\n\n\t\tthis._visible = !this._visible;\n\n\t\tthis._core.$element.toggleClass('owl-hidden', !this._visible);\n\n\t\tthis._visible && this._core.invalidate('width') && this._core.refresh();\n\t};\n\n\t/**\n  * Destroys the plugin.\n  */\n\tAutoRefresh.prototype.destroy = function () {\n\t\tvar handler, property;\n\n\t\twindow.clearInterval(this._interval);\n\n\t\tfor (handler in this._handlers) {\n\t\t\tthis._core.$element.off(handler, this._handlers[handler]);\n\t\t}\n\t\tfor (property in Object.getOwnPropertyNames(this)) {\n\t\t\ttypeof this[property] != 'function' && (this[property] = null);\n\t\t}\n\t};\n\n\t$.fn.owlCarousel.Constructor.Plugins.AutoRefresh = AutoRefresh;\n})(window.Zepto || window.jQuery, window, document);\n\n/**\n * Lazy Plugin\n * @version 2.1.0\n * @author Bartosz Wojciechowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n */\n;(function ($, window, document, undefined) {\n\n\t/**\n  * Creates the lazy plugin.\n  * @class The Lazy Plugin\n  * @param {Owl} carousel - The Owl Carousel\n  */\n\tvar Lazy = function Lazy(carousel) {\n\n\t\t/**\n   * Reference to the core.\n   * @protected\n   * @type {Owl}\n   */\n\t\tthis._core = carousel;\n\n\t\t/**\n   * Already loaded items.\n   * @protected\n   * @type {Array.<jQuery>}\n   */\n\t\tthis._loaded = [];\n\n\t\t/**\n   * Event handlers.\n   * @protected\n   * @type {Object}\n   */\n\t\tthis._handlers = {\n\t\t\t'initialized.owl.carousel change.owl.carousel resized.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (!e.namespace) {\n\t\t\t\t\treturn;\n\t\t\t\t}\n\n\t\t\t\tif (!this._core.settings || !this._core.settings.lazyLoad) {\n\t\t\t\t\treturn;\n\t\t\t\t}\n\n\t\t\t\tif (e.property && e.property.name == 'position' || e.type == 'initialized') {\n\t\t\t\t\tvar settings = this._core.settings,\n\t\t\t\t\t    n = settings.center && Math.ceil(settings.items / 2) || settings.items,\n\t\t\t\t\t    i = settings.center && n * -1 || 0,\n\t\t\t\t\t    position = (e.property && e.property.value !== undefined ? e.property.value : this._core.current()) + i,\n\t\t\t\t\t    clones = this._core.clones().length,\n\t\t\t\t\t    load = $.proxy(function (i, v) {\n\t\t\t\t\t\tthis.load(v);\n\t\t\t\t\t}, this);\n\n\t\t\t\t\twhile (i++ < n) {\n\t\t\t\t\t\tthis.load(clones / 2 + this._core.relative(position));\n\t\t\t\t\t\tclones && $.each(this._core.clones(this._core.relative(position)), load);\n\t\t\t\t\t\tposition++;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}, this)\n\t\t};\n\n\t\t// set the default options\n\t\tthis._core.options = $.extend({}, Lazy.Defaults, this._core.options);\n\n\t\t// register event handler\n\t\tthis._core.$element.on(this._handlers);\n\t};\n\n\t/**\n  * Default options.\n  * @public\n  */\n\tLazy.Defaults = {\n\t\tlazyLoad: false\n\t};\n\n\t/**\n  * Loads all resources of an item at the specified position.\n  * @param {Number} position - The absolute position of the item.\n  * @protected\n  */\n\tLazy.prototype.load = function (position) {\n\t\tvar $item = this._core.$stage.children().eq(position),\n\t\t    $elements = $item && $item.find('.owl-lazy');\n\n\t\tif (!$elements || $.inArray($item.get(0), this._loaded) > -1) {\n\t\t\treturn;\n\t\t}\n\n\t\t$elements.each($.proxy(function (index, element) {\n\t\t\tvar $element = $(element),\n\t\t\t    image,\n\t\t\t    url = window.devicePixelRatio > 1 && $element.attr('data-src-retina') || $element.attr('data-src');\n\n\t\t\tthis._core.trigger('load', { element: $element, url: url }, 'lazy');\n\n\t\t\tif ($element.is('img')) {\n\t\t\t\t$element.one('load.owl.lazy', $.proxy(function () {\n\t\t\t\t\t$element.css('opacity', 1);\n\t\t\t\t\tthis._core.trigger('loaded', { element: $element, url: url }, 'lazy');\n\t\t\t\t}, this)).attr('src', url);\n\t\t\t} else {\n\t\t\t\timage = new Image();\n\t\t\t\timage.onload = $.proxy(function () {\n\t\t\t\t\t$element.css({\n\t\t\t\t\t\t'background-image': 'url(\"' + url + '\")',\n\t\t\t\t\t\t'opacity': '1'\n\t\t\t\t\t});\n\t\t\t\t\tthis._core.trigger('loaded', { element: $element, url: url }, 'lazy');\n\t\t\t\t}, this);\n\t\t\t\timage.src = url;\n\t\t\t}\n\t\t}, this));\n\n\t\tthis._loaded.push($item.get(0));\n\t};\n\n\t/**\n  * Destroys the plugin.\n  * @public\n  */\n\tLazy.prototype.destroy = function () {\n\t\tvar handler, property;\n\n\t\tfor (handler in this.handlers) {\n\t\t\tthis._core.$element.off(handler, this.handlers[handler]);\n\t\t}\n\t\tfor (property in Object.getOwnPropertyNames(this)) {\n\t\t\ttypeof this[property] != 'function' && (this[property] = null);\n\t\t}\n\t};\n\n\t$.fn.owlCarousel.Constructor.Plugins.Lazy = Lazy;\n})(window.Zepto || window.jQuery, window, document);\n\n/**\n * AutoHeight Plugin\n * @version 2.1.0\n * @author Bartosz Wojciechowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n */\n;(function ($, window, document, undefined) {\n\n\t/**\n  * Creates the auto height plugin.\n  * @class The Auto Height Plugin\n  * @param {Owl} carousel - The Owl Carousel\n  */\n\tvar AutoHeight = function AutoHeight(carousel) {\n\t\t/**\n   * Reference to the core.\n   * @protected\n   * @type {Owl}\n   */\n\t\tthis._core = carousel;\n\n\t\t/**\n   * All event handlers.\n   * @protected\n   * @type {Object}\n   */\n\t\tthis._handlers = {\n\t\t\t'initialized.owl.carousel refreshed.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && this._core.settings.autoHeight) {\n\t\t\t\t\tthis.update();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'changed.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && this._core.settings.autoHeight && e.property.name == 'position') {\n\t\t\t\t\tthis.update();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'loaded.owl.lazy': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && this._core.settings.autoHeight && e.element.closest('.' + this._core.settings.itemClass).index() === this._core.current()) {\n\t\t\t\t\tthis.update();\n\t\t\t\t}\n\t\t\t}, this)\n\t\t};\n\n\t\t// set default options\n\t\tthis._core.options = $.extend({}, AutoHeight.Defaults, this._core.options);\n\n\t\t// register event handlers\n\t\tthis._core.$element.on(this._handlers);\n\t};\n\n\t/**\n  * Default options.\n  * @public\n  */\n\tAutoHeight.Defaults = {\n\t\tautoHeight: false,\n\t\tautoHeightClass: 'owl-height'\n\t};\n\n\t/**\n  * Updates the view.\n  */\n\tAutoHeight.prototype.update = function () {\n\t\tvar start = this._core._current,\n\t\t    end = start + this._core.settings.items,\n\t\t    visible = this._core.$stage.children().toArray().slice(start, end),\n\t\t    heights = [],\n\t\t    maxheight = 0;\n\n\t\t$.each(visible, function (index, item) {\n\t\t\theights.push($(item).height());\n\t\t});\n\n\t\tmaxheight = Math.max.apply(null, heights);\n\n\t\tthis._core.$stage.parent().height(maxheight).addClass(this._core.settings.autoHeightClass);\n\t};\n\n\tAutoHeight.prototype.destroy = function () {\n\t\tvar handler, property;\n\n\t\tfor (handler in this._handlers) {\n\t\t\tthis._core.$element.off(handler, this._handlers[handler]);\n\t\t}\n\t\tfor (property in Object.getOwnPropertyNames(this)) {\n\t\t\ttypeof this[property] != 'function' && (this[property] = null);\n\t\t}\n\t};\n\n\t$.fn.owlCarousel.Constructor.Plugins.AutoHeight = AutoHeight;\n})(window.Zepto || window.jQuery, window, document);\n\n/**\n * Video Plugin\n * @version 2.1.0\n * @author Bartosz Wojciechowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n */\n;(function ($, window, document, undefined) {\n\n\t/**\n  * Creates the video plugin.\n  * @class The Video Plugin\n  * @param {Owl} carousel - The Owl Carousel\n  */\n\tvar Video = function Video(carousel) {\n\t\t/**\n   * Reference to the core.\n   * @protected\n   * @type {Owl}\n   */\n\t\tthis._core = carousel;\n\n\t\t/**\n   * Cache all video URLs.\n   * @protected\n   * @type {Object}\n   */\n\t\tthis._videos = {};\n\n\t\t/**\n   * Current playing item.\n   * @protected\n   * @type {jQuery}\n   */\n\t\tthis._playing = null;\n\n\t\t/**\n   * All event handlers.\n   * @todo The cloned content removale is too late\n   * @protected\n   * @type {Object}\n   */\n\t\tthis._handlers = {\n\t\t\t'initialized.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace) {\n\t\t\t\t\tthis._core.register({ type: 'state', name: 'playing', tags: ['interacting'] });\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'resize.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && this._core.settings.video && this.isInFullScreen()) {\n\t\t\t\t\te.preventDefault();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'refreshed.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && this._core.is('resizing')) {\n\t\t\t\t\tthis._core.$stage.find('.cloned .owl-video-frame').remove();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'changed.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && e.property.name === 'position' && this._playing) {\n\t\t\t\t\tthis.stop();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'prepared.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (!e.namespace) {\n\t\t\t\t\treturn;\n\t\t\t\t}\n\n\t\t\t\tvar $element = $(e.content).find('.owl-video');\n\n\t\t\t\tif ($element.length) {\n\t\t\t\t\t$element.css('display', 'none');\n\t\t\t\t\tthis.fetch($element, $(e.content));\n\t\t\t\t}\n\t\t\t}, this)\n\t\t};\n\n\t\t// set default options\n\t\tthis._core.options = $.extend({}, Video.Defaults, this._core.options);\n\n\t\t// register event handlers\n\t\tthis._core.$element.on(this._handlers);\n\n\t\tthis._core.$element.on('click.owl.video', '.owl-video-play-icon', $.proxy(function (e) {\n\t\t\tthis.play(e);\n\t\t}, this));\n\t};\n\n\t/**\n  * Default options.\n  * @public\n  */\n\tVideo.Defaults = {\n\t\tvideo: false,\n\t\tvideoHeight: false,\n\t\tvideoWidth: false\n\t};\n\n\t/**\n  * Gets the video ID and the type (YouTube/Vimeo/vzaar only).\n  * @protected\n  * @param {jQuery} target - The target containing the video data.\n  * @param {jQuery} item - The item containing the video.\n  */\n\tVideo.prototype.fetch = function (target, item) {\n\t\tvar type = function () {\n\t\t\tif (target.attr('data-vimeo-id')) {\n\t\t\t\treturn 'vimeo';\n\t\t\t} else if (target.attr('data-vzaar-id')) {\n\t\t\t\treturn 'vzaar';\n\t\t\t} else {\n\t\t\t\treturn 'youtube';\n\t\t\t}\n\t\t}(),\n\t\t    id = target.attr('data-vimeo-id') || target.attr('data-youtube-id') || target.attr('data-vzaar-id'),\n\t\t    width = target.attr('data-width') || this._core.settings.videoWidth,\n\t\t    height = target.attr('data-height') || this._core.settings.videoHeight,\n\t\t    url = target.attr('href');\n\n\t\tif (url) {\n\n\t\t\t/*\n   \t\tParses the id's out of the following urls (and probably more):\n   \t\thttps://www.youtube.com/watch?v=:id\n   \t\thttps://youtu.be/:id\n   \t\thttps://vimeo.com/:id\n   \t\thttps://vimeo.com/channels/:channel/:id\n   \t\thttps://vimeo.com/groups/:group/videos/:id\n   \t\thttps://app.vzaar.com/videos/:id\n   \t\t\tVisual example: https://regexper.com/#(http%3A%7Chttps%3A%7C)%5C%2F%5C%2F(player.%7Cwww.%7Capp.)%3F(vimeo%5C.com%7Cyoutu(be%5C.com%7C%5C.be%7Cbe%5C.googleapis%5C.com)%7Cvzaar%5C.com)%5C%2F(video%5C%2F%7Cvideos%5C%2F%7Cembed%5C%2F%7Cchannels%5C%2F.%2B%5C%2F%7Cgroups%5C%2F.%2B%5C%2F%7Cwatch%5C%3Fv%3D%7Cv%5C%2F)%3F(%5BA-Za-z0-9._%25-%5D*)(%5C%26%5CS%2B)%3F\n   */\n\n\t\t\tid = url.match(/(http:|https:|)\\/\\/(player.|www.|app.)?(vimeo\\.com|youtu(be\\.com|\\.be|be\\.googleapis\\.com)|vzaar\\.com)\\/(video\\/|videos\\/|embed\\/|channels\\/.+\\/|groups\\/.+\\/|watch\\?v=|v\\/)?([A-Za-z0-9._%-]*)(\\&\\S+)?/);\n\n\t\t\tif (id[3].indexOf('youtu') > -1) {\n\t\t\t\ttype = 'youtube';\n\t\t\t} else if (id[3].indexOf('vimeo') > -1) {\n\t\t\t\ttype = 'vimeo';\n\t\t\t} else if (id[3].indexOf('vzaar') > -1) {\n\t\t\t\ttype = 'vzaar';\n\t\t\t} else {\n\t\t\t\tthrow new Error('Video URL not supported.');\n\t\t\t}\n\t\t\tid = id[6];\n\t\t} else {\n\t\t\tthrow new Error('Missing video URL.');\n\t\t}\n\n\t\tthis._videos[url] = {\n\t\t\ttype: type,\n\t\t\tid: id,\n\t\t\twidth: width,\n\t\t\theight: height\n\t\t};\n\n\t\titem.attr('data-video', url);\n\n\t\tthis.thumbnail(target, this._videos[url]);\n\t};\n\n\t/**\n  * Creates video thumbnail.\n  * @protected\n  * @param {jQuery} target - The target containing the video data.\n  * @param {Object} info - The video info object.\n  * @see `fetch`\n  */\n\tVideo.prototype.thumbnail = function (target, video) {\n\t\tvar tnLink,\n\t\t    icon,\n\t\t    path,\n\t\t    dimensions = video.width && video.height ? 'style=\"width:' + video.width + 'px;height:' + video.height + 'px;\"' : '',\n\t\t    customTn = target.find('img'),\n\t\t    srcType = 'src',\n\t\t    lazyClass = '',\n\t\t    settings = this._core.settings,\n\t\t    create = function create(path) {\n\t\t\ticon = '<div class=\"owl-video-play-icon\"></div>';\n\n\t\t\tif (settings.lazyLoad) {\n\t\t\t\ttnLink = '<div class=\"owl-video-tn ' + lazyClass + '\" ' + srcType + '=\"' + path + '\"></div>';\n\t\t\t} else {\n\t\t\t\ttnLink = '<div class=\"owl-video-tn\" style=\"opacity:1;background-image:url(' + path + ')\"></div>';\n\t\t\t}\n\t\t\ttarget.after(tnLink);\n\t\t\ttarget.after(icon);\n\t\t};\n\n\t\t// wrap video content into owl-video-wrapper div\n\t\ttarget.wrap('<div class=\"owl-video-wrapper\"' + dimensions + '></div>');\n\n\t\tif (this._core.settings.lazyLoad) {\n\t\t\tsrcType = 'data-src';\n\t\t\tlazyClass = 'owl-lazy';\n\t\t}\n\n\t\t// custom thumbnail\n\t\tif (customTn.length) {\n\t\t\tcreate(customTn.attr(srcType));\n\t\t\tcustomTn.remove();\n\t\t\treturn false;\n\t\t}\n\n\t\tif (video.type === 'youtube') {\n\t\t\tpath = \"//img.youtube.com/vi/\" + video.id + \"/hqdefault.jpg\";\n\t\t\tcreate(path);\n\t\t} else if (video.type === 'vimeo') {\n\t\t\t$.ajax({\n\t\t\t\ttype: 'GET',\n\t\t\t\turl: '//vimeo.com/api/v2/video/' + video.id + '.json',\n\t\t\t\tjsonp: 'callback',\n\t\t\t\tdataType: 'jsonp',\n\t\t\t\tsuccess: function success(data) {\n\t\t\t\t\tpath = data[0].thumbnail_large;\n\t\t\t\t\tcreate(path);\n\t\t\t\t}\n\t\t\t});\n\t\t} else if (video.type === 'vzaar') {\n\t\t\t$.ajax({\n\t\t\t\ttype: 'GET',\n\t\t\t\turl: '//vzaar.com/api/videos/' + video.id + '.json',\n\t\t\t\tjsonp: 'callback',\n\t\t\t\tdataType: 'jsonp',\n\t\t\t\tsuccess: function success(data) {\n\t\t\t\t\tpath = data.framegrab_url;\n\t\t\t\t\tcreate(path);\n\t\t\t\t}\n\t\t\t});\n\t\t}\n\t};\n\n\t/**\n  * Stops the current video.\n  * @public\n  */\n\tVideo.prototype.stop = function () {\n\t\tthis._core.trigger('stop', null, 'video');\n\t\tthis._playing.find('.owl-video-frame').remove();\n\t\tthis._playing.removeClass('owl-video-playing');\n\t\tthis._playing = null;\n\t\tthis._core.leave('playing');\n\t\tthis._core.trigger('stopped', null, 'video');\n\t};\n\n\t/**\n  * Starts the current video.\n  * @public\n  * @param {Event} event - The event arguments.\n  */\n\tVideo.prototype.play = function (event) {\n\t\tvar target = $(event.target),\n\t\t    item = target.closest('.' + this._core.settings.itemClass),\n\t\t    video = this._videos[item.attr('data-video')],\n\t\t    width = video.width || '100%',\n\t\t    height = video.height || this._core.$stage.height(),\n\t\t    html;\n\n\t\tif (this._playing) {\n\t\t\treturn;\n\t\t}\n\n\t\tthis._core.enter('playing');\n\t\tthis._core.trigger('play', null, 'video');\n\n\t\titem = this._core.items(this._core.relative(item.index()));\n\n\t\tthis._core.reset(item.index());\n\n\t\tif (video.type === 'youtube') {\n\t\t\thtml = '<iframe width=\"' + width + '\" height=\"' + height + '\" src=\"//www.youtube.com/embed/' + video.id + '?autoplay=1&rel=0&v=' + video.id + '\" frameborder=\"0\" allowfullscreen></iframe>';\n\t\t} else if (video.type === 'vimeo') {\n\t\t\thtml = '<iframe src=\"//player.vimeo.com/video/' + video.id + '?autoplay=1\" width=\"' + width + '\" height=\"' + height + '\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';\n\t\t} else if (video.type === 'vzaar') {\n\t\t\thtml = '<iframe frameborder=\"0\"' + 'height=\"' + height + '\"' + 'width=\"' + width + '\" allowfullscreen mozallowfullscreen webkitAllowFullScreen ' + 'src=\"//view.vzaar.com/' + video.id + '/player?autoplay=true\"></iframe>';\n\t\t}\n\n\t\t$('<div class=\"owl-video-frame\">' + html + '</div>').insertAfter(item.find('.owl-video'));\n\n\t\tthis._playing = item.addClass('owl-video-playing');\n\t};\n\n\t/**\n  * Checks whether an video is currently in full screen mode or not.\n  * @todo Bad style because looks like a readonly method but changes members.\n  * @protected\n  * @returns {Boolean}\n  */\n\tVideo.prototype.isInFullScreen = function () {\n\t\tvar element = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;\n\n\t\treturn element && $(element).parent().hasClass('owl-video-frame');\n\t};\n\n\t/**\n  * Destroys the plugin.\n  */\n\tVideo.prototype.destroy = function () {\n\t\tvar handler, property;\n\n\t\tthis._core.$element.off('click.owl.video');\n\n\t\tfor (handler in this._handlers) {\n\t\t\tthis._core.$element.off(handler, this._handlers[handler]);\n\t\t}\n\t\tfor (property in Object.getOwnPropertyNames(this)) {\n\t\t\ttypeof this[property] != 'function' && (this[property] = null);\n\t\t}\n\t};\n\n\t$.fn.owlCarousel.Constructor.Plugins.Video = Video;\n})(window.Zepto || window.jQuery, window, document);\n\n/**\n * Animate Plugin\n * @version 2.1.0\n * @author Bartosz Wojciechowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n */\n;(function ($, window, document, undefined) {\n\n\t/**\n  * Creates the animate plugin.\n  * @class The Navigation Plugin\n  * @param {Owl} scope - The Owl Carousel\n  */\n\tvar Animate = function Animate(scope) {\n\t\tthis.core = scope;\n\t\tthis.core.options = $.extend({}, Animate.Defaults, this.core.options);\n\t\tthis.swapping = true;\n\t\tthis.previous = undefined;\n\t\tthis.next = undefined;\n\n\t\tthis.handlers = {\n\t\t\t'change.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && e.property.name == 'position') {\n\t\t\t\t\tthis.previous = this.core.current();\n\t\t\t\t\tthis.next = e.property.value;\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'drag.owl.carousel dragged.owl.carousel translated.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace) {\n\t\t\t\t\tthis.swapping = e.type == 'translated';\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'translate.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn)) {\n\t\t\t\t\tthis.swap();\n\t\t\t\t}\n\t\t\t}, this)\n\t\t};\n\n\t\tthis.core.$element.on(this.handlers);\n\t};\n\n\t/**\n  * Default options.\n  * @public\n  */\n\tAnimate.Defaults = {\n\t\tanimateOut: false,\n\t\tanimateIn: false\n\t};\n\n\t/**\n  * Toggles the animation classes whenever an translations starts.\n  * @protected\n  * @returns {Boolean|undefined}\n  */\n\tAnimate.prototype.swap = function () {\n\n\t\tif (this.core.settings.items !== 1) {\n\t\t\treturn;\n\t\t}\n\n\t\tif (!$.support.animation || !$.support.transition) {\n\t\t\treturn;\n\t\t}\n\n\t\tthis.core.speed(0);\n\n\t\tvar left,\n\t\t    clear = $.proxy(this.clear, this),\n\t\t    previous = this.core.$stage.children().eq(this.previous),\n\t\t    next = this.core.$stage.children().eq(this.next),\n\t\t    incoming = this.core.settings.animateIn,\n\t\t    outgoing = this.core.settings.animateOut;\n\n\t\tif (this.core.current() === this.previous) {\n\t\t\treturn;\n\t\t}\n\n\t\tif (outgoing) {\n\t\t\tleft = this.core.coordinates(this.previous) - this.core.coordinates(this.next);\n\t\t\tprevious.one($.support.animation.end, clear).css({ 'left': left + 'px' }).addClass('animated owl-animated-out').addClass(outgoing);\n\t\t}\n\n\t\tif (incoming) {\n\t\t\tnext.one($.support.animation.end, clear).addClass('animated owl-animated-in').addClass(incoming);\n\t\t}\n\t};\n\n\tAnimate.prototype.clear = function (e) {\n\t\t$(e.target).css({ 'left': '' }).removeClass('animated owl-animated-out owl-animated-in').removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut);\n\t\tthis.core.onTransitionEnd();\n\t};\n\n\t/**\n  * Destroys the plugin.\n  * @public\n  */\n\tAnimate.prototype.destroy = function () {\n\t\tvar handler, property;\n\n\t\tfor (handler in this.handlers) {\n\t\t\tthis.core.$element.off(handler, this.handlers[handler]);\n\t\t}\n\t\tfor (property in Object.getOwnPropertyNames(this)) {\n\t\t\ttypeof this[property] != 'function' && (this[property] = null);\n\t\t}\n\t};\n\n\t$.fn.owlCarousel.Constructor.Plugins.Animate = Animate;\n})(window.Zepto || window.jQuery, window, document);\n\n/**\n * Autoplay Plugin\n * @version 2.1.0\n * @author Bartosz Wojciechowski\n * @author Artus Kolanowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n */\n;(function ($, window, document, undefined) {\n\n\t/**\n  * Creates the autoplay plugin.\n  * @class The Autoplay Plugin\n  * @param {Owl} scope - The Owl Carousel\n  */\n\tvar Autoplay = function Autoplay(carousel) {\n\t\t/**\n   * Reference to the core.\n   * @protected\n   * @type {Owl}\n   */\n\t\tthis._core = carousel;\n\n\t\t/**\n   * The autoplay timeout.\n   * @type {Timeout}\n   */\n\t\tthis._timeout = null;\n\n\t\t/**\n   * Indicates whenever the autoplay is paused.\n   * @type {Boolean}\n   */\n\t\tthis._paused = false;\n\n\t\t/**\n   * All event handlers.\n   * @protected\n   * @type {Object}\n   */\n\t\tthis._handlers = {\n\t\t\t'changed.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && e.property.name === 'settings') {\n\t\t\t\t\tif (this._core.settings.autoplay) {\n\t\t\t\t\t\tthis.play();\n\t\t\t\t\t} else {\n\t\t\t\t\t\tthis.stop();\n\t\t\t\t\t}\n\t\t\t\t} else if (e.namespace && e.property.name === 'position') {\n\t\t\t\t\t//console.log('play?', e);\n\t\t\t\t\tif (this._core.settings.autoplay) {\n\t\t\t\t\t\tthis._setAutoPlayInterval();\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'initialized.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && this._core.settings.autoplay) {\n\t\t\t\t\tthis.play();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'play.owl.autoplay': $.proxy(function (e, t, s) {\n\t\t\t\tif (e.namespace) {\n\t\t\t\t\tthis.play(t, s);\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'stop.owl.autoplay': $.proxy(function (e) {\n\t\t\t\tif (e.namespace) {\n\t\t\t\t\tthis.stop();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'mouseover.owl.autoplay': $.proxy(function () {\n\t\t\t\tif (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {\n\t\t\t\t\tthis.pause();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'mouseleave.owl.autoplay': $.proxy(function () {\n\t\t\t\tif (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {\n\t\t\t\t\tthis.play();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'touchstart.owl.core': $.proxy(function () {\n\t\t\t\tif (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {\n\t\t\t\t\tthis.pause();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'touchend.owl.core': $.proxy(function () {\n\t\t\t\tif (this._core.settings.autoplayHoverPause) {\n\t\t\t\t\tthis.play();\n\t\t\t\t}\n\t\t\t}, this)\n\t\t};\n\n\t\t// register event handlers\n\t\tthis._core.$element.on(this._handlers);\n\n\t\t// set default options\n\t\tthis._core.options = $.extend({}, Autoplay.Defaults, this._core.options);\n\t};\n\n\t/**\n  * Default options.\n  * @public\n  */\n\tAutoplay.Defaults = {\n\t\tautoplay: false,\n\t\tautoplayTimeout: 5000,\n\t\tautoplayHoverPause: false,\n\t\tautoplaySpeed: false\n\t};\n\n\t/**\n  * Starts the autoplay.\n  * @public\n  * @param {Number} [timeout] - The interval before the next animation starts.\n  * @param {Number} [speed] - The animation speed for the animations.\n  */\n\tAutoplay.prototype.play = function (timeout, speed) {\n\t\tthis._paused = false;\n\n\t\tif (this._core.is('rotating')) {\n\t\t\treturn;\n\t\t}\n\n\t\tthis._core.enter('rotating');\n\n\t\tthis._setAutoPlayInterval();\n\t};\n\n\t/**\n  * Gets a new timeout\n  * @private\n  * @param {Number} [timeout] - The interval before the next animation starts.\n  * @param {Number} [speed] - The animation speed for the animations.\n  * @return {Timeout}\n  */\n\tAutoplay.prototype._getNextTimeout = function (timeout, speed) {\n\t\tif (this._timeout) {\n\t\t\twindow.clearTimeout(this._timeout);\n\t\t}\n\t\treturn window.setTimeout($.proxy(function () {\n\t\t\tif (this._paused || this._core.is('busy') || this._core.is('interacting') || document.hidden) {\n\t\t\t\treturn;\n\t\t\t}\n\t\t\tthis._core.next(speed || this._core.settings.autoplaySpeed);\n\t\t}, this), timeout || this._core.settings.autoplayTimeout);\n\t};\n\n\t/**\n  * Sets autoplay in motion.\n  * @private\n  */\n\tAutoplay.prototype._setAutoPlayInterval = function () {\n\t\tthis._timeout = this._getNextTimeout();\n\t};\n\n\t/**\n  * Stops the autoplay.\n  * @public\n  */\n\tAutoplay.prototype.stop = function () {\n\t\tif (!this._core.is('rotating')) {\n\t\t\treturn;\n\t\t}\n\n\t\twindow.clearTimeout(this._timeout);\n\t\tthis._core.leave('rotating');\n\t};\n\n\t/**\n  * Stops the autoplay.\n  * @public\n  */\n\tAutoplay.prototype.pause = function () {\n\t\tif (!this._core.is('rotating')) {\n\t\t\treturn;\n\t\t}\n\n\t\tthis._paused = true;\n\t};\n\n\t/**\n  * Destroys the plugin.\n  */\n\tAutoplay.prototype.destroy = function () {\n\t\tvar handler, property;\n\n\t\tthis.stop();\n\n\t\tfor (handler in this._handlers) {\n\t\t\tthis._core.$element.off(handler, this._handlers[handler]);\n\t\t}\n\t\tfor (property in Object.getOwnPropertyNames(this)) {\n\t\t\ttypeof this[property] != 'function' && (this[property] = null);\n\t\t}\n\t};\n\n\t$.fn.owlCarousel.Constructor.Plugins.autoplay = Autoplay;\n})(window.Zepto || window.jQuery, window, document);\n\n/**\n * Navigation Plugin\n * @version 2.1.0\n * @author Artus Kolanowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n */\n;(function ($, window, document, undefined) {\n\t'use strict';\n\n\t/**\n  * Creates the navigation plugin.\n  * @class The Navigation Plugin\n  * @param {Owl} carousel - The Owl Carousel.\n  */\n\n\tvar Navigation = function Navigation(carousel) {\n\t\t/**\n   * Reference to the core.\n   * @protected\n   * @type {Owl}\n   */\n\t\tthis._core = carousel;\n\n\t\t/**\n   * Indicates whether the plugin is initialized or not.\n   * @protected\n   * @type {Boolean}\n   */\n\t\tthis._initialized = false;\n\n\t\t/**\n   * The current paging indexes.\n   * @protected\n   * @type {Array}\n   */\n\t\tthis._pages = [];\n\n\t\t/**\n   * All DOM elements of the user interface.\n   * @protected\n   * @type {Object}\n   */\n\t\tthis._controls = {};\n\n\t\t/**\n   * Markup for an indicator.\n   * @protected\n   * @type {Array.<String>}\n   */\n\t\tthis._templates = [];\n\n\t\t/**\n   * The carousel element.\n   * @type {jQuery}\n   */\n\t\tthis.$element = this._core.$element;\n\n\t\t/**\n   * Overridden methods of the carousel.\n   * @protected\n   * @type {Object}\n   */\n\t\tthis._overrides = {\n\t\t\tnext: this._core.next,\n\t\t\tprev: this._core.prev,\n\t\t\tto: this._core.to\n\t\t};\n\n\t\t/**\n   * All event handlers.\n   * @protected\n   * @type {Object}\n   */\n\t\tthis._handlers = {\n\t\t\t'prepared.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && this._core.settings.dotsData) {\n\t\t\t\t\tthis._templates.push('<div class=\"' + this._core.settings.dotClass + '\">' + $(e.content).find('[data-dot]').addBack('[data-dot]').attr('data-dot') + '</div>');\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'added.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && this._core.settings.dotsData) {\n\t\t\t\t\tthis._templates.splice(e.position, 0, this._templates.pop());\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'remove.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && this._core.settings.dotsData) {\n\t\t\t\t\tthis._templates.splice(e.position, 1);\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'changed.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && e.property.name == 'position') {\n\t\t\t\t\tthis.draw();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'initialized.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && !this._initialized) {\n\t\t\t\t\tthis._core.trigger('initialize', null, 'navigation');\n\t\t\t\t\tthis.initialize();\n\t\t\t\t\tthis.update();\n\t\t\t\t\tthis.draw();\n\t\t\t\t\tthis._initialized = true;\n\t\t\t\t\tthis._core.trigger('initialized', null, 'navigation');\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'refreshed.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && this._initialized) {\n\t\t\t\t\tthis._core.trigger('refresh', null, 'navigation');\n\t\t\t\t\tthis.update();\n\t\t\t\t\tthis.draw();\n\t\t\t\t\tthis._core.trigger('refreshed', null, 'navigation');\n\t\t\t\t}\n\t\t\t}, this)\n\t\t};\n\n\t\t// set default options\n\t\tthis._core.options = $.extend({}, Navigation.Defaults, this._core.options);\n\n\t\t// register event handlers\n\t\tthis.$element.on(this._handlers);\n\t};\n\n\t/**\n  * Default options.\n  * @public\n  * @todo Rename `slideBy` to `navBy`\n  */\n\tNavigation.Defaults = {\n\t\tnav: false,\n\t\tnavText: ['prev', 'next'],\n\t\tnavSpeed: false,\n\t\tnavElement: 'div',\n\t\tnavContainer: false,\n\t\tnavContainerClass: 'owl-nav',\n\t\tnavClass: ['owl-prev', 'owl-next'],\n\t\tslideBy: 1,\n\t\tdotClass: 'owl-dot',\n\t\tdotsClass: 'owl-dots',\n\t\tdots: true,\n\t\tdotsEach: false,\n\t\tdotsData: false,\n\t\tdotsSpeed: false,\n\t\tdotsContainer: false\n\t};\n\n\t/**\n  * Initializes the layout of the plugin and extends the carousel.\n  * @protected\n  */\n\tNavigation.prototype.initialize = function () {\n\t\tvar override,\n\t\t    settings = this._core.settings;\n\n\t\t// create DOM structure for relative navigation\n\t\tthis._controls.$relative = (settings.navContainer ? $(settings.navContainer) : $('<div>').addClass(settings.navContainerClass).appendTo(this.$element)).addClass('disabled');\n\n\t\tthis._controls.$previous = $('<' + settings.navElement + '>').addClass(settings.navClass[0]).html(settings.navText[0]).prependTo(this._controls.$relative).on('click', $.proxy(function (e) {\n\t\t\tthis.prev(settings.navSpeed);\n\t\t}, this));\n\t\tthis._controls.$next = $('<' + settings.navElement + '>').addClass(settings.navClass[1]).html(settings.navText[1]).appendTo(this._controls.$relative).on('click', $.proxy(function (e) {\n\t\t\tthis.next(settings.navSpeed);\n\t\t}, this));\n\n\t\t// create DOM structure for absolute navigation\n\t\tif (!settings.dotsData) {\n\t\t\tthis._templates = [$('<div>').addClass(settings.dotClass).append($('<span>')).prop('outerHTML')];\n\t\t}\n\n\t\tthis._controls.$absolute = (settings.dotsContainer ? $(settings.dotsContainer) : $('<div>').addClass(settings.dotsClass).appendTo(this.$element)).addClass('disabled');\n\n\t\tthis._controls.$absolute.on('click', 'div', $.proxy(function (e) {\n\t\t\tvar index = $(e.target).parent().is(this._controls.$absolute) ? $(e.target).index() : $(e.target).parent().index();\n\n\t\t\te.preventDefault();\n\n\t\t\tthis.to(index, settings.dotsSpeed);\n\t\t}, this));\n\n\t\t// override public methods of the carousel\n\t\tfor (override in this._overrides) {\n\t\t\tthis._core[override] = $.proxy(this[override], this);\n\t\t}\n\t};\n\n\t/**\n  * Destroys the plugin.\n  * @protected\n  */\n\tNavigation.prototype.destroy = function () {\n\t\tvar handler, control, property, override;\n\n\t\tfor (handler in this._handlers) {\n\t\t\tthis.$element.off(handler, this._handlers[handler]);\n\t\t}\n\t\tfor (control in this._controls) {\n\t\t\tthis._controls[control].remove();\n\t\t}\n\t\tfor (override in this.overides) {\n\t\t\tthis._core[override] = this._overrides[override];\n\t\t}\n\t\tfor (property in Object.getOwnPropertyNames(this)) {\n\t\t\ttypeof this[property] != 'function' && (this[property] = null);\n\t\t}\n\t};\n\n\t/**\n  * Updates the internal state.\n  * @protected\n  */\n\tNavigation.prototype.update = function () {\n\t\tvar i,\n\t\t    j,\n\t\t    k,\n\t\t    lower = this._core.clones().length / 2,\n\t\t    upper = lower + this._core.items().length,\n\t\t    maximum = this._core.maximum(true),\n\t\t    settings = this._core.settings,\n\t\t    size = settings.center || settings.autoWidth || settings.dotsData ? 1 : settings.dotsEach || settings.items;\n\n\t\tif (settings.slideBy !== 'page') {\n\t\t\tsettings.slideBy = Math.min(settings.slideBy, settings.items);\n\t\t}\n\n\t\tif (settings.dots || settings.slideBy == 'page') {\n\t\t\tthis._pages = [];\n\n\t\t\tfor (i = lower, j = 0, k = 0; i < upper; i++) {\n\t\t\t\tif (j >= size || j === 0) {\n\t\t\t\t\tthis._pages.push({\n\t\t\t\t\t\tstart: Math.min(maximum, i - lower),\n\t\t\t\t\t\tend: i - lower + size - 1\n\t\t\t\t\t});\n\t\t\t\t\tif (Math.min(maximum, i - lower) === maximum) {\n\t\t\t\t\t\tbreak;\n\t\t\t\t\t}\n\t\t\t\t\tj = 0, ++k;\n\t\t\t\t}\n\t\t\t\tj += this._core.mergers(this._core.relative(i));\n\t\t\t}\n\t\t}\n\t};\n\n\t/**\n  * Draws the user interface.\n  * @todo The option `dotsData` wont work.\n  * @protected\n  */\n\tNavigation.prototype.draw = function () {\n\t\tvar difference,\n\t\t    settings = this._core.settings,\n\t\t    disabled = this._core.items().length <= settings.items,\n\t\t    index = this._core.relative(this._core.current()),\n\t\t    loop = settings.loop || settings.rewind;\n\n\t\tthis._controls.$relative.toggleClass('disabled', !settings.nav || disabled);\n\n\t\tif (settings.nav) {\n\t\t\tthis._controls.$previous.toggleClass('disabled', !loop && index <= this._core.minimum(true));\n\t\t\tthis._controls.$next.toggleClass('disabled', !loop && index >= this._core.maximum(true));\n\t\t}\n\n\t\tthis._controls.$absolute.toggleClass('disabled', !settings.dots || disabled);\n\n\t\tif (settings.dots) {\n\t\t\tdifference = this._pages.length - this._controls.$absolute.children().length;\n\n\t\t\tif (settings.dotsData && difference !== 0) {\n\t\t\t\tthis._controls.$absolute.html(this._templates.join(''));\n\t\t\t} else if (difference > 0) {\n\t\t\t\tthis._controls.$absolute.append(new Array(difference + 1).join(this._templates[0]));\n\t\t\t} else if (difference < 0) {\n\t\t\t\tthis._controls.$absolute.children().slice(difference).remove();\n\t\t\t}\n\n\t\t\tthis._controls.$absolute.find('.active').removeClass('active');\n\t\t\tthis._controls.$absolute.children().eq($.inArray(this.current(), this._pages)).addClass('active');\n\t\t}\n\t};\n\n\t/**\n  * Extends event data.\n  * @protected\n  * @param {Event} event - The event object which gets thrown.\n  */\n\tNavigation.prototype.onTrigger = function (event) {\n\t\tvar settings = this._core.settings;\n\n\t\tevent.page = {\n\t\t\tindex: $.inArray(this.current(), this._pages),\n\t\t\tcount: this._pages.length,\n\t\t\tsize: settings && (settings.center || settings.autoWidth || settings.dotsData ? 1 : settings.dotsEach || settings.items)\n\t\t};\n\t};\n\n\t/**\n  * Gets the current page position of the carousel.\n  * @protected\n  * @returns {Number}\n  */\n\tNavigation.prototype.current = function () {\n\t\tvar current = this._core.relative(this._core.current());\n\t\treturn $.grep(this._pages, $.proxy(function (page, index) {\n\t\t\treturn page.start <= current && page.end >= current;\n\t\t}, this)).pop();\n\t};\n\n\t/**\n  * Gets the current succesor/predecessor position.\n  * @protected\n  * @returns {Number}\n  */\n\tNavigation.prototype.getPosition = function (successor) {\n\t\tvar position,\n\t\t    length,\n\t\t    settings = this._core.settings;\n\n\t\tif (settings.slideBy == 'page') {\n\t\t\tposition = $.inArray(this.current(), this._pages);\n\t\t\tlength = this._pages.length;\n\t\t\tsuccessor ? ++position : --position;\n\t\t\tposition = this._pages[(position % length + length) % length].start;\n\t\t} else {\n\t\t\tposition = this._core.relative(this._core.current());\n\t\t\tlength = this._core.items().length;\n\t\t\tsuccessor ? position += settings.slideBy : position -= settings.slideBy;\n\t\t}\n\n\t\treturn position;\n\t};\n\n\t/**\n  * Slides to the next item or page.\n  * @public\n  * @param {Number} [speed=false] - The time in milliseconds for the transition.\n  */\n\tNavigation.prototype.next = function (speed) {\n\t\t$.proxy(this._overrides.to, this._core)(this.getPosition(true), speed);\n\t};\n\n\t/**\n  * Slides to the previous item or page.\n  * @public\n  * @param {Number} [speed=false] - The time in milliseconds for the transition.\n  */\n\tNavigation.prototype.prev = function (speed) {\n\t\t$.proxy(this._overrides.to, this._core)(this.getPosition(false), speed);\n\t};\n\n\t/**\n  * Slides to the specified item or page.\n  * @public\n  * @param {Number} position - The position of the item or page.\n  * @param {Number} [speed] - The time in milliseconds for the transition.\n  * @param {Boolean} [standard=false] - Whether to use the standard behaviour or not.\n  */\n\tNavigation.prototype.to = function (position, speed, standard) {\n\t\tvar length;\n\n\t\tif (!standard && this._pages.length) {\n\t\t\tlength = this._pages.length;\n\t\t\t$.proxy(this._overrides.to, this._core)(this._pages[(position % length + length) % length].start, speed);\n\t\t} else {\n\t\t\t$.proxy(this._overrides.to, this._core)(position, speed);\n\t\t}\n\t};\n\n\t$.fn.owlCarousel.Constructor.Plugins.Navigation = Navigation;\n})(window.Zepto || window.jQuery, window, document);\n\n/**\n * Hash Plugin\n * @version 2.1.0\n * @author Artus Kolanowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n */\n;(function ($, window, document, undefined) {\n\t'use strict';\n\n\t/**\n  * Creates the hash plugin.\n  * @class The Hash Plugin\n  * @param {Owl} carousel - The Owl Carousel\n  */\n\n\tvar Hash = function Hash(carousel) {\n\t\t/**\n   * Reference to the core.\n   * @protected\n   * @type {Owl}\n   */\n\t\tthis._core = carousel;\n\n\t\t/**\n   * Hash index for the items.\n   * @protected\n   * @type {Object}\n   */\n\t\tthis._hashes = {};\n\n\t\t/**\n   * The carousel element.\n   * @type {jQuery}\n   */\n\t\tthis.$element = this._core.$element;\n\n\t\t/**\n   * All event handlers.\n   * @protected\n   * @type {Object}\n   */\n\t\tthis._handlers = {\n\t\t\t'initialized.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && this._core.settings.startPosition === 'URLHash') {\n\t\t\t\t\t$(window).trigger('hashchange.owl.navigation');\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'prepared.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace) {\n\t\t\t\t\tvar hash = $(e.content).find('[data-hash]').addBack('[data-hash]').attr('data-hash');\n\n\t\t\t\t\tif (!hash) {\n\t\t\t\t\t\treturn;\n\t\t\t\t\t}\n\n\t\t\t\t\tthis._hashes[hash] = e.content;\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'changed.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && e.property.name === 'position') {\n\t\t\t\t\tvar current = this._core.items(this._core.relative(this._core.current())),\n\t\t\t\t\t    hash = $.map(this._hashes, function (item, hash) {\n\t\t\t\t\t\treturn item === current ? hash : null;\n\t\t\t\t\t}).join();\n\n\t\t\t\t\tif (!hash || window.location.hash.slice(1) === hash) {\n\t\t\t\t\t\treturn;\n\t\t\t\t\t}\n\n\t\t\t\t\twindow.location.hash = hash;\n\t\t\t\t}\n\t\t\t}, this)\n\t\t};\n\n\t\t// set default options\n\t\tthis._core.options = $.extend({}, Hash.Defaults, this._core.options);\n\n\t\t// register the event handlers\n\t\tthis.$element.on(this._handlers);\n\n\t\t// register event listener for hash navigation\n\t\t$(window).on('hashchange.owl.navigation', $.proxy(function (e) {\n\t\t\tvar hash = window.location.hash.substring(1),\n\t\t\t    items = this._core.$stage.children(),\n\t\t\t    position = this._hashes[hash] && items.index(this._hashes[hash]);\n\n\t\t\tif (position === undefined || position === this._core.current()) {\n\t\t\t\treturn;\n\t\t\t}\n\n\t\t\tthis._core.to(this._core.relative(position), false, true);\n\t\t}, this));\n\t};\n\n\t/**\n  * Default options.\n  * @public\n  */\n\tHash.Defaults = {\n\t\tURLhashListener: false\n\t};\n\n\t/**\n  * Destroys the plugin.\n  * @public\n  */\n\tHash.prototype.destroy = function () {\n\t\tvar handler, property;\n\n\t\t$(window).off('hashchange.owl.navigation');\n\n\t\tfor (handler in this._handlers) {\n\t\t\tthis._core.$element.off(handler, this._handlers[handler]);\n\t\t}\n\t\tfor (property in Object.getOwnPropertyNames(this)) {\n\t\t\ttypeof this[property] != 'function' && (this[property] = null);\n\t\t}\n\t};\n\n\t$.fn.owlCarousel.Constructor.Plugins.Hash = Hash;\n})(window.Zepto || window.jQuery, window, document);\n\n/**\n * Support Plugin\n *\n * @version 2.1.0\n * @author Vivid Planet Software GmbH\n * @author Artus Kolanowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n */\n;(function ($, window, document, undefined) {\n\n\tvar style = $('<support>').get(0).style,\n\t    prefixes = 'Webkit Moz O ms'.split(' '),\n\t    events = {\n\t\ttransition: {\n\t\t\tend: {\n\t\t\t\tWebkitTransition: 'webkitTransitionEnd',\n\t\t\t\tMozTransition: 'transitionend',\n\t\t\t\tOTransition: 'oTransitionEnd',\n\t\t\t\ttransition: 'transitionend'\n\t\t\t}\n\t\t},\n\t\tanimation: {\n\t\t\tend: {\n\t\t\t\tWebkitAnimation: 'webkitAnimationEnd',\n\t\t\t\tMozAnimation: 'animationend',\n\t\t\t\tOAnimation: 'oAnimationEnd',\n\t\t\t\tanimation: 'animationend'\n\t\t\t}\n\t\t}\n\t},\n\t    tests = {\n\t\tcsstransforms: function csstransforms() {\n\t\t\treturn !!test('transform');\n\t\t},\n\t\tcsstransforms3d: function csstransforms3d() {\n\t\t\treturn !!test('perspective');\n\t\t},\n\t\tcsstransitions: function csstransitions() {\n\t\t\treturn !!test('transition');\n\t\t},\n\t\tcssanimations: function cssanimations() {\n\t\t\treturn !!test('animation');\n\t\t}\n\t};\n\n\tfunction test(property, prefixed) {\n\t\tvar result = false,\n\t\t    upper = property.charAt(0).toUpperCase() + property.slice(1);\n\n\t\t$.each((property + ' ' + prefixes.join(upper + ' ') + upper).split(' '), function (i, property) {\n\t\t\tif (style[property] !== undefined) {\n\t\t\t\tresult = prefixed ? property : true;\n\t\t\t\treturn false;\n\t\t\t}\n\t\t});\n\n\t\treturn result;\n\t}\n\n\tfunction prefixed(property) {\n\t\treturn test(property, true);\n\t}\n\n\tif (tests.csstransitions()) {\n\t\t/* jshint -W053 */\n\t\t$.support.transition = new String(prefixed('transition'));\n\t\t$.support.transition.end = events.transition.end[$.support.transition];\n\t}\n\n\tif (tests.cssanimations()) {\n\t\t/* jshint -W053 */\n\t\t$.support.animation = new String(prefixed('animation'));\n\t\t$.support.animation.end = events.animation.end[$.support.animation];\n\t}\n\n\tif (tests.csstransforms()) {\n\t\t/* jshint -W053 */\n\t\t$.support.transform = new String(prefixed('transform'));\n\t\t$.support.transform3d = tests.csstransforms3d();\n\t}\n})(window.Zepto || window.jQuery, window, document);\n\n/*****************\n ** WEBPACK FOOTER\n ** ./src/owl.carousel.js\n ** module id = 1\n ** module chunks = 0\n **/\n//# sourceURL=webpack:///./src/owl.carousel.js?");

/***/ },
/* 2 */
/***/ function(module, exports) {

	eval("// removed by extract-text-webpack-plugin\n\n/*****************\n ** WEBPACK FOOTER\n ** ./src/owl.carousel.css\n ** module id = 2\n ** module chunks = 0\n **/\n//# sourceURL=webpack:///./src/owl.carousel.css?");

/***/ },
/* 3 */
/***/ function(module, exports) {

	eval("module.exports = __WEBPACK_EXTERNAL_MODULE_3__;\n\n/*****************\n ** WEBPACK FOOTER\n ** external {\"root\":\"PropTypes\",\"commonjs2\":\"prop-types\",\"commonjs\":\"prop-types\",\"amd\":\"prop-types\"}\n ** module id = 3\n ** module chunks = 0\n **/\n//# sourceURL=webpack:///external_%7B%22root%22:%22PropTypes%22,%22commonjs2%22:%22prop-types%22,%22commonjs%22:%22prop-types%22,%22amd%22:%22prop-types%22%7D?");

/***/ },
/* 4 */
/***/ function(module, exports) {

	eval("module.exports = __WEBPACK_EXTERNAL_MODULE_4__;\n\n/*****************\n ** WEBPACK FOOTER\n ** external {\"root\":\"React\",\"commonjs2\":\"react\",\"commonjs\":\"react\",\"amd\":\"react\"}\n ** module id = 4\n ** module chunks = 0\n **/\n//# sourceURL=webpack:///external_%7B%22root%22:%22React%22,%22commonjs2%22:%22react%22,%22commonjs%22:%22react%22,%22amd%22:%22react%22%7D?");

/***/ },
/* 5 */
/***/ function(module, exports) {

	eval("module.exports = __WEBPACK_EXTERNAL_MODULE_5__;\n\n/*****************\n ** WEBPACK FOOTER\n ** external {\"root\":\"ReactDOM\",\"commonjs2\":\"react-dom\",\"commonjs\":\"react-dom\",\"amd\":\"react-dom\"}\n ** module id = 5\n ** module chunks = 0\n **/\n//# sourceURL=webpack:///external_%7B%22root%22:%22ReactDOM%22,%22commonjs2%22:%22react-dom%22,%22commonjs%22:%22react-dom%22,%22amd%22:%22react-dom%22%7D?");

/***/ }
/******/ ])
});
;

/***/ }),

/***/ 14416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zt": function() { return /* reexport */ components_Provider; },
  "$j": function() { return /* reexport */ connect; },
  "I0": function() { return /* reexport */ useDispatch; },
  "v9": function() { return /* reexport */ useSelector; }
});

// UNUSED EXPORTS: ReactReduxContext, batch, connectAdvanced, createDispatchHook, createSelectorHook, createStoreHook, shallowEqual, useStore

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Context.js

var ReactReduxContext = /*#__PURE__*/react.createContext(null);

if (false) {}

/* harmony default export */ var Context = ((/* unused pure expression or super */ null && (ReactReduxContext)));
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/batch.js
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/Subscription.js
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

function createListenerCollection() {
  var batch = getBatch();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var nullListeners = {
  notify: function notify() {},
  get: function get() {
    return [];
  }
};
function createSubscription(store, parentSub) {
  var unsubscribe;
  var listeners = nullListeners;

  function addNestedSub(listener) {
    trySubscribe();
    return listeners.subscribe(listener);
  }

  function notifyNestedSubs() {
    listeners.notify();
  }

  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }

  function isSubscribed() {
    return Boolean(unsubscribe);
  }

  function trySubscribe() {
    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }

  function tryUnsubscribe() {
    if (unsubscribe) {
      unsubscribe();
      unsubscribe = undefined;
      listeners.clear();
      listeners = nullListeners;
    }
  }

  var subscription = {
    addNestedSub: addNestedSub,
    notifyNestedSubs: notifyNestedSubs,
    handleChangeWrapper: handleChangeWrapper,
    isSubscribed: isSubscribed,
    trySubscribe: trySubscribe,
    tryUnsubscribe: tryUnsubscribe,
    getListeners: function getListeners() {
      return listeners;
    }
  };
  return subscription;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/useIsomorphicLayoutEffect.js
 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? react.useLayoutEffect : react.useEffect;
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Provider.js






function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = (0,react.useMemo)(function () {
    var subscription = createSubscription(store);
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = (0,react.useMemo)(function () {
    return store.getState();
  }, [store]);
  useIsomorphicLayoutEffect(function () {
    var subscription = contextValue.subscription;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || ReactReduxContext;
  return /*#__PURE__*/react.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

if (false) {}

/* harmony default export */ var components_Provider = (Provider);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ./node_modules/react-redux/node_modules/react-is/index.js
var react_is = __webpack_require__(72973);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/connectAdvanced.js


var _excluded = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"],
    _excluded2 = ["reactReduxForwardedRef"];





 // Define some constant arrays just to avoid re-creating these

var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  useIsomorphicLayoutEffect(function () {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

  var didUnsubscribe = false;
  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  var checkForUpdates = function checkForUpdates() {
    if (didUnsubscribe) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    }

    var latestStoreState = store.getState();
    var newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

      forceComponentUpdateDispatch({
        type: 'STORE_UPDATED',
        payload: {
          error: error
        }
      });
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  var unsubscribeWrapper = function unsubscribeWrapper() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? ReactReduxContext : _ref2$context,
      connectOptions = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, _excluded);

  if (false) { var customStoreWarningMessage; }

  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (false) {}

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = (0,esm_extends/* default */.Z)({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? react.useMemo : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = (0,react.useMemo)(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var reactReduxForwardedRef = props.reactReduxForwardedRef,
            wrapperProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded2);

        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          reactReduxForwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = (0,react.useMemo)(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && (0,react_is.isContextConsumer)( /*#__PURE__*/react.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = (0,react.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (false) {} // Based on the previous check, one of these must be true


      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = (0,react.useMemo)(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = (0,react.useMemo)(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var subscription = createSubscription(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.
        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = (0,react.useMemo)(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return (0,esm_extends/* default */.Z)({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = (0,react.useReducer)(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = (0,react.useRef)();
      var lastWrapperProps = (0,react.useRef)(wrapperProps);
      var childPropsFromStoreUpdate = (0,react.useRef)();
      var renderIsScheduled = (0,react.useRef)(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = (0,react.useMemo)(function () {
        return /*#__PURE__*/react.createElement(WrappedComponent, (0,esm_extends/* default */.Z)({}, actualChildProps, {
          ref: reactReduxForwardedRef
        }));
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = (0,react.useMemo)(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/react.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? react.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = ConnectFunction.displayName = displayName;

    if (forwardRef) {
      var forwarded = react.forwardRef(function forwardConnectRef(props, ref) {
        return /*#__PURE__*/react.createElement(Connect, (0,esm_extends/* default */.Z)({}, props, {
          reactReduxForwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoist_non_react_statics_cjs_default()(forwarded, WrappedComponent);
    }

    return hoist_non_react_statics_cjs_default()(Connect, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/shallowEqual.js
function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/bindActionCreators.js
function bindActionCreators(actionCreators, dispatch) {
  var boundActionCreators = {};

  var _loop = function _loop(key) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = function () {
        return dispatch(actionCreator.apply(void 0, arguments));
      };
    }
  };

  for (var key in actionCreators) {
    _loop(key);
  }

  return boundActionCreators;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/wrapMapToProps.js

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) {}
      return props;
    };

    return proxy;
  };
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapDispatchToProps.js


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return bindActionCreators(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ var mapDispatchToProps = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapStateToProps.js

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ var mapStateToProps = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mergeProps.js


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return (0,esm_extends/* default */.Z)({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) {}
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ var mergeProps = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/selectorFactory.js

var selectorFactory_excluded = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];

function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, selectorFactory_excluded);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {}

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/connect.js


var connect_excluded = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];






/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? mapStateToProps : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? mapDispatchToProps : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? mergeProps : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? finalPropsSelectorFactory : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual : _ref3$areMergedPropsE,
        extraOptions = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref3, connect_excluded);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, (0,esm_extends/* default */.Z)({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ var connect = (/*#__PURE__*/createConnect());
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useReduxContext.js


/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

function useReduxContext_useReduxContext() {
  var contextValue = (0,react.useContext)(ReactReduxContext);

  if (false) {}

  return contextValue;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useStore.js



/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useReduxContext = context === ReactReduxContext ? useReduxContext_useReduxContext : function () {
    return (0,react.useContext)(context);
  };
  return function useStore() {
    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store;

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

var useStore_useStore = /*#__PURE__*/createStoreHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useDispatch.js


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useStore = context === ReactReduxContext ? useStore_useStore : createStoreHook(context);
  return function useDispatch() {
    var store = useStore();
    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

var useDispatch = /*#__PURE__*/createDispatchHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useSelector.js






var refEquality = function refEquality(a, b) {
  return a === b;
};

function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
  var _useReducer = (0,react.useReducer)(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = (0,react.useMemo)(function () {
    return createSubscription(store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = (0,react.useRef)();
  var latestSelector = (0,react.useRef)();
  var latestStoreState = (0,react.useRef)();
  var latestSelectedState = (0,react.useRef)();
  var storeState = store.getState();
  var selectedState;

  try {
    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
      var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references

      if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) {
        selectedState = newSelectedState;
      } else {
        selectedState = latestSelectedState.current;
      }
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    if (latestSubscriptionCallbackError.current) {
      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
    }

    throw err;
  }

  useIsomorphicLayoutEffect(function () {
    latestSelector.current = selector;
    latestStoreState.current = storeState;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  useIsomorphicLayoutEffect(function () {
    function checkForUpdates() {
      try {
        var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed

        if (newStoreState === latestStoreState.current) {
          return;
        }

        var _newSelectedState = latestSelector.current(newStoreState);

        if (equalityFn(_newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = _newSelectedState;
        latestStoreState.current = newStoreState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender();
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useReduxContext = context === ReactReduxContext ? useReduxContext_useReduxContext : function () {
    return (0,react.useContext)(context);
  };
  return function useSelector(selector, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }

    if (false) {}

    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store,
        contextSub = _useReduxContext.subscription;

    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
    (0,react.useDebugValue)(selectedState);
    return selectedState;
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

var useSelector = /*#__PURE__*/createSelectorHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/exports.js









// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/reactBatchedUpdates.js
/* eslint-disable import/no-unresolved */

;// CONCATENATED MODULE: ./node_modules/react-redux/es/index.js


 // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)

setBatch(react_dom.unstable_batchedUpdates);


/***/ }),

/***/ 88359:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;__webpack_unused_export__=h;__webpack_unused_export__=z;__webpack_unused_export__=A;__webpack_unused_export__=B;__webpack_unused_export__=C;__webpack_unused_export__=D;__webpack_unused_export__=E;__webpack_unused_export__=F;__webpack_unused_export__=G;__webpack_unused_export__=H;
__webpack_unused_export__=I;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};exports.isContextConsumer=function(a){return y(a)===h};__webpack_unused_export__=function(a){return y(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return y(a)===k};__webpack_unused_export__=function(a){return y(a)===d};__webpack_unused_export__=function(a){return y(a)===p};__webpack_unused_export__=function(a){return y(a)===n};
__webpack_unused_export__=function(a){return y(a)===c};__webpack_unused_export__=function(a){return y(a)===f};__webpack_unused_export__=function(a){return y(a)===e};__webpack_unused_export__=function(a){return y(a)===l};__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
__webpack_unused_export__=y;


/***/ }),

/***/ 72973:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(88359);
} else {}


/***/ }),

/***/ 37856:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(67294), __webpack_require__(45697)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(void 0, function (exports, _react, _propTypes) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var PRECISION = 0.0001;

  var isEqual = function isEqual(n1, n2) {
    return Math.abs(n1 - n2) < PRECISION;
  };

  var TextTruncate = function (_Component) {
    _inherits(TextTruncate, _Component);

    function TextTruncate() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, TextTruncate);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TextTruncate)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "onResize", function () {
        if (_this.rafId) {
          window.cancelAnimationFrame(_this.rafId);
        }

        _this.rafId = window.requestAnimationFrame(_this.update.bind(_assertThisInitialized(_this)));
      });

      _defineProperty(_assertThisInitialized(_this), "onToggled", function (truncated) {
        typeof _this.props.onToggled === 'function' && setTimeout(function () {
          return _this.props.onToggled(truncated);
        }, 0);
      });

      _defineProperty(_assertThisInitialized(_this), "onTruncated", function () {
        typeof _this.props.onTruncated === 'function' && setTimeout(function () {
          return _this.props.onTruncated();
        }, 0);
      });

      _defineProperty(_assertThisInitialized(_this), "onCalculated", function () {
        typeof _this.props.onCalculated === 'function' && setTimeout(function () {
          return _this.props.onCalculated();
        }, 0);
      });

      _defineProperty(_assertThisInitialized(_this), "update", function () {
        var style = window.getComputedStyle(_this.scope);
        var font = [style['font-weight'], style['font-style'], style['font-size'], style['font-family'], style['letter-spacing']].join(' ');
        _this.canvas.font = font;

        _this.forceUpdate();
      });

      return _this;
    }

    _createClass(TextTruncate, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var canvas = document.createElement('canvas');
        var docFragment = document.createDocumentFragment();
        var style = window.getComputedStyle(this.scope);
        var font = [style['font-weight'], style['font-style'], style['font-size'], style['font-family']].join(' ');
        docFragment.appendChild(canvas);
        this.canvas = canvas.getContext('2d');
        this.canvas.font = font;
        this.forceUpdate();
        window.addEventListener('resize', this.onResize);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);

        if (this.rafId) {
          window.cancelAnimationFrame(this.rafId);
        }
      }
    }, {
      key: "measureWidth",
      value: function measureWidth(text) {
        return this.canvas.measureText(text).width;
      }
    }, {
      key: "getRenderText",
      value: function getRenderText() {
        var _this$props = this.props,
            containerClassName = _this$props.containerClassName,
            element = _this$props.element,
            line = _this$props.line,
            onCalculated = _this$props.onCalculated,
            onTruncated = _this$props.onTruncated,
            onToggled = _this$props.onToggled,
            text = _this$props.text,
            textElement = _this$props.textElement,
            textTruncateChild = _this$props.textTruncateChild,
            truncateText = _this$props.truncateText,
            maxCalculateTimes = _this$props.maxCalculateTimes,
            props = _objectWithoutProperties(_this$props, ["containerClassName", "element", "line", "onCalculated", "onTruncated", "onToggled", "text", "textElement", "textTruncateChild", "truncateText", "maxCalculateTimes"]);

        var scopeWidth = this.scope.getBoundingClientRect().width; // return if display:none

        if (scopeWidth === 0) {
          return null;
        }

        var fullTextWidth = this.measureWidth(text); // return if all of text can be displayed

        if (scopeWidth > fullTextWidth || isEqual(scopeWidth, fullTextWidth)) {
          this.onToggled(false);
          return (0, _react.createElement)(textElement, props, text);
        }

        var childText = '';

        if (textTruncateChild && typeof textTruncateChild.type === 'string') {
          var type = textTruncateChild.type;

          if (type.indexOf('span') >= 0 || type.indexOf('a') >= 0) {
            childText = textTruncateChild.props.children;
          }
        }

        var currentPos = 1;
        var maxTextLength = text.length;
        var truncatedText = '';
        var splitPos = 0;
        var startPos = 0;
        var displayLine = line;
        var width = 0;
        var lastIsEng = false;
        var isPrevLineWithoutSpace = false;
        var lastPos = 0;
        var lastSpaceIndex = -1;
        var ext = '';
        var loopCnt = 0;

        while (displayLine-- > 0) {
          ext = displayLine ? '' : truncateText + (childText ? ' ' + childText : '');

          while (currentPos <= maxTextLength) {
            truncatedText = text.substr(startPos, currentPos);
            width = this.measureWidth(truncatedText + ext);

            if (width < scopeWidth) {
              splitPos = text.indexOf(' ', currentPos + 1);

              if (splitPos === -1) {
                currentPos += 1;
                lastIsEng = false;
              } else {
                lastIsEng = true;
                currentPos = splitPos;
              }
            } else {
              do {
                if (loopCnt++ >= maxCalculateTimes) {
                  break;
                }

                truncatedText = text.substr(startPos, currentPos);

                if (!displayLine) {
                  currentPos--;
                }

                if (truncatedText[truncatedText.length - 1] === ' ') {
                  truncatedText = text.substr(startPos, currentPos - 1);
                }

                if (lastIsEng) {
                  lastSpaceIndex = truncatedText.lastIndexOf(' ');

                  if (lastSpaceIndex > -1) {
                    currentPos = lastSpaceIndex;

                    if (displayLine) {
                      currentPos++;
                    }

                    truncatedText = text.substr(startPos, currentPos);
                  } else {
                    currentPos--;
                    truncatedText = text.substr(startPos, currentPos);
                  }
                } else {
                  currentPos--;
                  truncatedText = text.substr(startPos, currentPos);
                }

                width = this.measureWidth(truncatedText + ext);
              } while ((width > scopeWidth || isEqual(width, scopeWidth)) && truncatedText.length > 0);

              startPos += currentPos;
              break;
            }
          }

          if (currentPos >= maxTextLength) {
            startPos = maxTextLength;
            break;
          }

          if (lastIsEng && !isPrevLineWithoutSpace && text.substr(lastPos, currentPos).indexOf(' ') === -1) {
            isPrevLineWithoutSpace = text.substr(lastPos, currentPos).indexOf(' ') === -1;
            displayLine--;
          }

          lastPos = currentPos + 1;
        }

        if (startPos === maxTextLength) {
          this.onToggled(false);
          return (0, _react.createElement)(textElement, props, text);
        }

        this.onTruncated();
        this.onToggled(true);
        return _react2["default"].createElement("span", props, (0, _react.createElement)(textElement, props, text.substr(0, startPos) + truncateText + ' '), textTruncateChild);
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props2 = this.props,
            element = _this$props2.element,
            text = _this$props2.text,
            _this$props2$style = _this$props2.style,
            style = _this$props2$style === void 0 ? {} : _this$props2$style,
            containerClassName = _this$props2.containerClassName,
            line = _this$props2.line,
            onCalculated = _this$props2.onCalculated,
            onTruncated = _this$props2.onTruncated,
            onToggled = _this$props2.onToggled,
            textElement = _this$props2.textElement,
            textTruncateChild = _this$props2.textTruncateChild,
            truncateText = _this$props2.truncateText,
            maxCalculateTimes = _this$props2.maxCalculateTimes,
            props = _objectWithoutProperties(_this$props2, ["element", "text", "style", "containerClassName", "line", "onCalculated", "onTruncated", "onToggled", "textElement", "textTruncateChild", "truncateText", "maxCalculateTimes"]);

        var fontWeight = style.fontWeight,
            fontStyle = style.fontStyle,
            fontSize = style.fontSize,
            fontFamily = style.fontFamily;
        var renderText = this.scope && line ? this.getRenderText() : (0, _react.createElement)(textElement, props, text);
        var rootProps = {
          ref: function ref(el) {
            _this2.scope = el;
          },
          className: containerClassName,
          style: {
            overflow: 'hidden',
            fontWeight: fontWeight,
            fontStyle: fontStyle,
            fontSize: fontSize,
            fontFamily: fontFamily
          }
        };
        this.scope && this.onCalculated();
        return (0, _react.createElement)(element, rootProps, renderText);
      }
    }]);

    return TextTruncate;
  }(_react.Component);

  _defineProperty(TextTruncate, "propTypes", {
    containerClassName: _propTypes2["default"].string,
    element: _propTypes2["default"].string,
    line: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].bool]),
    onCalculated: _propTypes2["default"].func,
    onTruncated: _propTypes2["default"].func,
    onToggled: _propTypes2["default"].func,
    text: _propTypes2["default"].string,
    textElement: _propTypes2["default"].elementType,
    textTruncateChild: _propTypes2["default"].node,
    truncateText: _propTypes2["default"].string,
    maxCalculateTimes: _propTypes2["default"].number
  });

  _defineProperty(TextTruncate, "defaultProps", {
    element: 'div',
    line: 1,
    text: '',
    textElement: 'span',
    truncateText: '…',
    maxCalculateTimes: 10
  });

  exports.default = TextTruncate;
  ;
  module.exports = exports.default;
});


/***/ }),

/***/ 26273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cn": function() { return /* binding */ ENTERED; },
  "d0": function() { return /* binding */ ENTERING; },
  "Wj": function() { return /* binding */ EXITED; },
  "Ix": function() { return /* binding */ EXITING; },
  "ZP": function() { return /* binding */ esm_Transition; }
});

// UNUSED EXPORTS: UNMOUNTED

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/config.js
/* harmony default export */ var config = ({
  disabled: false
});
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/TransitionGroupContext.js

/* harmony default export */ var TransitionGroupContext = (react.createContext(null));
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/utils/reflow.js
var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/Transition.js









var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [react_dom.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : react_dom.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      react.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : react.cloneElement(react.Children.only(children), childProps))
    );
  };

  return Transition;
}(react.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes =  false ? 0 : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ var esm_Transition = (Transition);

/***/ }),

/***/ 94500:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

!function(e,t){ true?t(exports):0}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof __webpack_require__.g?"undefined":N(__webpack_require__.g))&&__webpack_require__.g?__webpack_require__.g:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});


/***/ }),

/***/ 96774:
/***/ (function(module) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ 19521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ styled_components_browser_esm; }
});

// UNUSED EXPORTS: ServerStyleSheet, StyleSheetConsumer, StyleSheetContext, StyleSheetManager, ThemeConsumer, ThemeContext, ThemeProvider, __PRIVATE__, createGlobalStyle, css, isStyledComponent, keyframes, useTheme, version, withTheme

// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(59864);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/shallowequal/index.js
var shallowequal = __webpack_require__(96774);
var shallowequal_default = /*#__PURE__*/__webpack_require__.n(shallowequal);
;// CONCATENATED MODULE: ./node_modules/@emotion/stylis/dist/stylis.browser.esm.js
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ var stylis_browser_esm = (stylis_min);

;// CONCATENATED MODULE: ./node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var unitless_browser_esm = (unitlessKeys);

;// CONCATENATED MODULE: ./node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var emotion_memoize_esm = (memoize);

;// CONCATENATED MODULE: ./node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */emotion_memoize_esm(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ var emotion_is_prop_valid_esm = (isPropValid);

// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
/* provided dependency */ var process = __webpack_require__(34155);
function v(){return(v=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}var g=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},S=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!(0,react_is.typeOf)(t)},w=Object.freeze([]),E=Object.freeze({});function b(e){return"function"==typeof e}function _(e){return false||e.displayName||e.name||"Component"}function N(e){return e&&"string"==typeof e.styledComponentId}var A="undefined"!=typeof process&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",C="5.3.6",I="undefined"!=typeof window&&"HTMLElement"in window,P=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!=="production"),O={},R= false?0:{};function D(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t)})),e}function j(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw true?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):0}var T=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&j(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++)},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n)}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),x=new Map,k=new Map,V=1,B=function(e){if(x.has(e))return x.get(e);for(;k.has(V);)V++;var t=V++;return false&&0,x.set(e,t),k.set(t,e),t},z=function(e){return k.get(e)},M=function(e,t){t>=V&&(V=t+1),x.set(e,t),k.set(t,e)},G="style["+A+'][data-styled-version="5.3.6"]',L=new RegExp("^"+A+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),F=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r)},Y=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(L);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(M(u,c),F(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0}else r.push(i)}}},q=function(){return true?__webpack_require__.nc:0},H=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(A))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(A,"active"),r.setAttribute("data-styled-version","5.3.6");var i=q();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},$=function(){function e(e){var t=this.element=H(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}j(17)}(t),this.length=0}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return!1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),W=function(){function e(e){var t=this.element=H(e);this.nodes=t.childNodes,this.length=0}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return!1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),U=function(){function e(e){this.rules=[],this.length=0}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),J=I,X={isServer:!I,useCSSOMInjection:!P},Z=function(){function e(e,t,n){void 0===e&&(e=E),void 0===t&&(t={}),this.options=v({},X,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&I&&J&&(J=!1,function(e){for(var t=document.querySelectorAll(G),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(A)&&(Y(e,o),o.parentNode&&o.parentNode.removeChild(o))}}(this))}e.registerId=function(e){return B(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(v({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new U(o):r?new $(o):new W(o),new T(e)));var e,t,n,r,o},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(B(e),this.names.has(e))this.names.get(e).add(t);else{var n=new Set;n.add(t),this.names.set(e,n)}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(B(e),n)},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear()},t.clearRules=function(e){this.getTag().clearGroup(B(e)),this.clearNames(e)},t.clearTag=function(){this.tag=void 0},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=z(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=A+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",")})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n'}}}return r}(this)},e}(),K=/(a)(d)/gi,Q=function(e){return String.fromCharCode(e+(e>25?39:97))};function ee(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=Q(t%52)+n;return(Q(t%52)+n).replace(K,"$1-$2")}var te=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},ne=function(e){return te(5381,e)};function re(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(b(n)&&!N(n))return!1}return!0}var oe=ne("5.3.6"),se=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic= true&&(void 0===n||n.isStatic)&&re(e),this.componentId=t,this.baseHash=te(oe,t),this.baseStyle=n,Z.registerId(t)}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else{var s=Ne(this.rules,e,t,n).join(""),i=ee(te(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a)}o.push(i),this.staticRulesId=i}else{for(var c=this.rules.length,u=te(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h, false&&(0);else if(h){var p=Ne(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=te(u,f+d),l+=f}}if(l){var m=ee(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y)}o.push(m)}}return o.join(" ")},e}(),ie=/^\s*\/\/.*$/gm,ae=[":","[",".","#"];function ce(e){var t,n,r,o,s=void 0===e?E:e,i=s.options,a=void 0===i?E:i,c=s.plugins,u=void 0===c?w:c,l=new stylis_browser_esm(a),d=[],h=function(e){function t(t){if(t)try{e(t+"}")}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t)}}}((function(e){d.push(e)})),f=function(e,r,s){return 0===r&&-1!==ae.indexOf(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){void 0===a&&(a="&");var c=e.replace(ie,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f))},h,function(e){if(-2===e){var t=d;return d=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||j(15),te(e,t.name)}),5381).toString():"",m}var ue=react.createContext(),le=ue.Consumer,de=react.createContext(),he=(de.Consumer,new Z),pe=ce();function fe(){return (0,react.useContext)(ue)||he}function me(){return (0,react.useContext)(de)||pe}function ye(e){var t=(0,react.useState)(e.stylisPlugins),n=t[0],s=t[1],c=fe(),u=(0,react.useMemo)((function(){var t=c;return e.sheet?t=e.sheet:e.target&&(t=t.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(t=t.reconstructWithOptions({useCSSOMInjection:!1})),t}),[e.disableCSSOMInjection,e.sheet,e.target]),l=(0,react.useMemo)((function(){return ce({options:{prefix:!e.disableVendorPrefixes},plugins:n})}),[e.disableVendorPrefixes,n]);return (0,react.useEffect)((function(){shallowequal_default()(n,e.stylisPlugins)||s(e.stylisPlugins)}),[e.stylisPlugins]),react.createElement(ue.Provider,{value:u},react.createElement(de.Provider,{value:l}, false?0:e.children))}var ve=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=pe);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"))},this.toString=function(){return j(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t}return e.prototype.getName=function(e){return void 0===e&&(e=pe),this.name+e.hash},e}(),ge=/([A-Z])/,Se=/([A-Z])/g,we=/^ms-/,Ee=function(e){return"-"+e.toLowerCase()};function be(e){return ge.test(e)?e.replace(Se,Ee).replace(we,"-ms-"):e}var _e=function(e){return null==e||!1===e||""===e};function Ne(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=Ne(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(_e(e))return"";if(N(e))return"."+e.styledComponentId;if(b(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return false&&0,Ne(u,n,r,o)}var l;return e instanceof ve?r?(e.inject(r,o),e.getName(o)):e:S(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!_e(t[i])&&(Array.isArray(t[i])&&t[i].isCss||b(t[i])?s.push(be(i)+":",t[i],";"):S(t[i])?s.push.apply(s,e(t[i],i)):s.push(be(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in unitless_browser_esm?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var Ae=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function Ce(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return b(e)||S(e)?Ae(Ne(g(w,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:Ae(Ne(g(e,n)))}var Ie=/invalid hook call/i,Pe=new Set,Oe=function(e,t){if(false){ var o, n, r; }},Re=function(e,t,n){return void 0===n&&(n=E),e.theme!==n.theme&&e.theme||t||n.theme},De=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,je=/(^-|-$)/g;function Te(e){return e.replace(De,"-").replace(je,"")}var xe=function(e){return ee(ne(e)>>>0)};function ke(e){return"string"==typeof e&&( true||0)}var Ve=function(e){return"function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Be=function(e){return"__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function ze(e,t,n){var r=e[n];Ve(t)&&Ve(r)?Me(r,t):e[n]=t}function Me(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(Ve(i))for(var a in i)Be(a)&&ze(e,i[a],a)}return e}var Ge=react.createContext(),Le=Ge.Consumer;function Fe(e){var t=s(Ge),n=i((function(){return function(e,t){if(!e)return j(14);if(b(e)){var n=e(t);return true?n:0}return Array.isArray(e)||"object"!=typeof e?j(8):t?v({},t,{},e):e}(e.theme,t)}),[e.theme,t]);return e.children?r.createElement(Ge.Provider,{value:n},e.children):null}var Ye={};function qe(e,t,n){var o=N(e),i=!ke(e),a=t.attrs,c=void 0===a?w:a,d=t.componentId,h=void 0===d?function(e,t){var n="string"!=typeof e?"sc":Te(e);Ye[n]=(Ye[n]||0)+1;var r=n+"-"+xe("5.3.6"+n+Ye[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):d,p=t.displayName,f=void 0===p?function(e){return ke(e)?"styled."+e:"Styled("+_(e)+")"}(e):p,g=t.displayName&&t.componentId?Te(t.displayName)+"-"+t.componentId:t.componentId||h,S=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,A=t.shouldForwardProp;o&&e.shouldForwardProp&&(A=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var C,I=new se(n,g,o?e.componentStyle:void 0),P=I.isStatic&&0===c.length,O=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,d=e.shouldForwardProp,h=e.styledComponentId,p=e.target; false&&0;var f=function(e,t,n){void 0===e&&(e=E);var r=v({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in b(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t]})),[r,o]}(Re(t,(0,react.useContext)(Ge),a)||E,t,o),y=f[0],g=f[1],S=function(e,t,n,r){var o=fe(),s=me(),i=t?e.generateAndInjectStyles(E,o,s):e.generateAndInjectStyles(n,o,s);return false&&0, false&&0,i}(i,r,y, false?0:void 0),w=n,_=g.$as||t.$as||g.as||t.as||p,N=ke(_),A=g!==t?v({},t,{},g):t,C={};for(var I in A)"$"!==I[0]&&"as"!==I&&("forwardedAs"===I?C.as=A[I]:(d?d(I,emotion_is_prop_valid_esm,_):!N||emotion_is_prop_valid_esm(I))&&(C[I]=A[I]));return t.style&&g.style!==t.style&&(C.style=v({},t.style,{},g.style)),C.className=Array.prototype.concat(c,h,S!==h?S:null,t.className,g.className).filter(Boolean).join(" "),C.ref=w,(0,react.createElement)(_,C)}(C,e,t,P)};return O.displayName=f,(C=react.forwardRef(O)).attrs=S,C.componentStyle=I,C.displayName=f,C.shouldForwardProp=A,C.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):w,C.styledComponentId=g,C.target=o?e.target:e,C.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return{};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(ke(e)?e:Te(_(e)));return qe(e,v({},o,{attrs:S,componentId:s}),n)},Object.defineProperty(C,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?Me({},e.defaultProps,t):t}}), false&&(0),C.toString=function(){return"."+C.styledComponentId},i&&hoist_non_react_statics_cjs_default()(C,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),C}var He=function(e){return function e(t,r,o){if(void 0===o&&(o=E),!(0,react_is.isValidElementType)(r))return j(1,String(r));var s=function(){return t(r,o,Ce.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,v({},o,{},n))},s.attrs=function(n){return e(t,r,v({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(qe,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){He[e]=He(e)}));var $e=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=re(e),Z.registerId(this.componentId+1)}var t=e.prototype;return t.createStyles=function(e,t,n,r){var o=r(Ne(this.rules,t,n,r).join(""),""),s=this.componentId+e;n.insertRules(s,s,o)},t.removeStyles=function(e,t){t.clearRules(this.componentId+e)},t.renderStyles=function(e,t,n,r){e>2&&Z.registerId(this.componentId+e),this.removeStyles(e,n),this.createStyles(e,t,n,r)},e}();function We(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];var i=Ce.apply(void 0,[e].concat(n)),a="sc-global-"+xe(JSON.stringify(i)),u=new $e(i,a);function l(e){var t=fe(),n=me(),o=s(Ge),l=c(t.allocateGSInstance(a)).current;return false&&0, false&&0,t.server&&h(l,e,t,o,n),d((function(){if(!t.server)return h(l,e,t,o,n),function(){return u.removeStyles(l,t)}}),[l,e,t,o,n]),null}function h(e,t,n,r,o){if(u.isStatic)u.renderStyles(e,O,n,o);else{var s=v({},t,{theme:Re(t,r,l.defaultProps)});u.renderStyles(e,s,n,o)}}return false&&0,r.memo(l)}function Ue(e){ false&&0;for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=Ce.apply(void 0,[e].concat(n)).join(""),s=xe(o);return new ve(s,o)}var Je=function(){function e(){var e=this;this._emitSheetCSS=function(){var t=e.instance.toString();if(!t)return"";var n=q();return"<style "+[n&&'nonce="'+n+'"',A+'="true"','data-styled-version="5.3.6"'].filter(Boolean).join(" ")+">"+t+"</style>"},this.getStyleTags=function(){return e.sealed?j(2):e._emitSheetCSS()},this.getStyleElement=function(){var t;if(e.sealed)return j(2);var n=((t={})[A]="",t["data-styled-version"]="5.3.6",t.dangerouslySetInnerHTML={__html:e.instance.toString()},t),o=q();return o&&(n.nonce=o),[react.createElement("style",v({},n,{key:"sc-0-0"}))]},this.seal=function(){e.sealed=!0},this.instance=new Z({isServer:!0}),this.sealed=!1}var t=e.prototype;return t.collectStyles=function(e){return this.sealed?j(2):react.createElement(ye,{sheet:this.instance},e)},t.interleaveWithNodeStream=function(e){return j(3)},e}(),Xe=function(e){var t=r.forwardRef((function(t,n){var o=s(Ge),i=e.defaultProps,a=Re(t,o,i);return false&&0,r.createElement(e,v({},t,{theme:a,ref:n}))}));return y(t,e),t.displayName="WithTheme("+_(e)+")",t},Ze=function(){return s(Ge)},Ke={StyleSheet:Z,masterSheet:he}; false&&0, false&&(0);/* harmony default export */ var styled_components_browser_esm = (He);
//# sourceMappingURL=styled-components.browser.esm.js.map


/***/ }),

/***/ 47150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ch": function() { return /* reexport */ useUncontrolled; },
  "$c": function() { return /* reexport */ useUncontrolledProp; }
});

// UNUSED EXPORTS: uncontrollable

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/invariant/browser.js
var browser = __webpack_require__(41143);
;// CONCATENATED MODULE: ./node_modules/uncontrollable/lib/esm/utils.js


var noop = function noop() {};

function readOnlyPropType(handler, name) {
  return function (props, propName) {
    if (props[propName] !== undefined) {
      if (!props[handler]) {
        return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + defaultKey(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
      }
    }
  };
}

function uncontrolledPropTypes(controlledValues, displayName) {
  var propTypes = {};
  Object.keys(controlledValues).forEach(function (prop) {
    // add default propTypes for folks that use runtime checks
    propTypes[defaultKey(prop)] = noop;

    if (false) { var handler; }
  });
  return propTypes;
}
function isProp(props, prop) {
  return props[prop] !== undefined;
}
function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

function canAcceptRef(component) {
  return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}
;// CONCATENATED MODULE: ./node_modules/uncontrollable/lib/esm/hook.js



function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }




function useUncontrolledProp(propValue, defaultValue, handler) {
  var wasPropRef = (0,react.useRef)(propValue !== undefined);

  var _useState = (0,react.useState)(defaultValue),
      stateValue = _useState[0],
      setState = _useState[1];

  var isProp = propValue !== undefined;
  var wasProp = wasPropRef.current;
  wasPropRef.current = isProp;
  /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */

  if (!isProp && wasProp && stateValue !== defaultValue) {
    setState(defaultValue);
  }

  return [isProp ? propValue : stateValue, (0,react.useCallback)(function (value) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (handler) handler.apply(void 0, [value].concat(args));
    setState(value);
  }, [handler])];
}


function useUncontrolled(props, config) {
  return Object.keys(config).reduce(function (result, fieldName) {
    var _extends2;

    var _ref = result,
        defaultValue = _ref[defaultKey(fieldName)],
        propsValue = _ref[fieldName],
        rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, [defaultKey(fieldName), fieldName].map(_toPropertyKey));

    var handlerName = config[fieldName];

    var _useUncontrolledProp = useUncontrolledProp(propsValue, defaultValue, props[handlerName]),
        value = _useUncontrolledProp[0],
        handler = _useUncontrolledProp[1];

    return (0,esm_extends/* default */.Z)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
  }, props);
}
;// CONCATENATED MODULE: ./node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function react_lifecycles_compat_es_polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}



;// CONCATENATED MODULE: ./node_modules/uncontrollable/lib/esm/uncontrollable.js



var _jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";




function uncontrollable(Component, controlledValues, methods) {
  if (methods === void 0) {
    methods = [];
  }

  var displayName = Component.displayName || Component.name || 'Component';
  var canAcceptRef = Utils.canAcceptRef(Component);
  var controlledProps = Object.keys(controlledValues);
  var PROPS_TO_OMIT = controlledProps.map(Utils.defaultKey);
  !(canAcceptRef || !methods.length) ?  false ? 0 : invariant(false) : void 0;

  var UncontrolledComponent =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(UncontrolledComponent, _React$Component);

    function UncontrolledComponent() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      _this.handlers = Object.create(null);
      controlledProps.forEach(function (propName) {
        var handlerName = controlledValues[propName];

        var handleChange = function handleChange(value) {
          if (_this.props[handlerName]) {
            var _this$props;

            _this._notifying = true;

            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            (_this$props = _this.props)[handlerName].apply(_this$props, [value].concat(args));

            _this._notifying = false;
          }

          if (!_this.unmounted) _this.setState(function (_ref) {
            var _extends2;

            var values = _ref.values;
            return {
              values: _extends(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
            };
          });
        };

        _this.handlers[handlerName] = handleChange;
      });
      if (methods.length) _this.attachRef = function (ref) {
        _this.inner = ref;
      };
      var values = Object.create(null);
      controlledProps.forEach(function (key) {
        values[key] = _this.props[Utils.defaultKey(key)];
      });
      _this.state = {
        values: values,
        prevProps: {}
      };
      return _this;
    }

    var _proto = UncontrolledComponent.prototype;

    _proto.shouldComponentUpdate = function shouldComponentUpdate() {
      //let setState trigger the update
      return !this._notifying;
    };

    UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
      var values = _ref2.values,
          prevProps = _ref2.prevProps;
      var nextState = {
        values: _extends(Object.create(null), values),
        prevProps: {}
      };
      controlledProps.forEach(function (key) {
        /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */
        nextState.prevProps[key] = props[key];

        if (!Utils.isProp(props, key) && Utils.isProp(prevProps, key)) {
          nextState.values[key] = props[Utils.defaultKey(key)];
        }
      });
      return nextState;
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.unmounted = true;
    };

    _proto.render = function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          innerRef = _this$props2.innerRef,
          props = _objectWithoutPropertiesLoose(_this$props2, ["innerRef"]);

      PROPS_TO_OMIT.forEach(function (prop) {
        delete props[prop];
      });
      var newProps = {};
      controlledProps.forEach(function (propName) {
        var propValue = _this2.props[propName];
        newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
      });
      return React.createElement(Component, _extends({}, props, newProps, this.handlers, {
        ref: innerRef || this.attachRef
      }));
    };

    return UncontrolledComponent;
  }(React.Component);

  polyfill(UncontrolledComponent);
  UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
  UncontrolledComponent.propTypes = _extends({
    innerRef: function innerRef() {}
  }, Utils.uncontrolledPropTypes(controlledValues, displayName));
  methods.forEach(function (method) {
    UncontrolledComponent.prototype[method] = function $proxiedMethod() {
      var _this$inner;

      return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
    };
  });
  var WrappedComponent = UncontrolledComponent;

  if (React.forwardRef) {
    WrappedComponent = React.forwardRef(function (props, ref) {
      return React.createElement(UncontrolledComponent, _extends({}, props, {
        innerRef: ref,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 128
        },
        __self: this
      }));
    });
    WrappedComponent.propTypes = UncontrolledComponent.propTypes;
  }

  WrappedComponent.ControlledComponent = Component;
  /**
   * useful when wrapping a Component and you want to control
   * everything
   */

  WrappedComponent.deferControlTo = function (newComponent, additions, nextMethods) {
    if (additions === void 0) {
      additions = {};
    }

    return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
  };

  return WrappedComponent;
}
;// CONCATENATED MODULE: ./node_modules/uncontrollable/lib/esm/index.js



/***/ }),

/***/ 42473:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 94578:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inheritsLoose; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89611);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 63366:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),

/***/ 89611:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 52587:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 10748:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ 50029:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ }),

/***/ 92777:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 82262:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),

/***/ 59499:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ 37247:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ 81531:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90607);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 4730:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 63553:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var next_dist_compiled_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14027);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10748);


function _possibleConstructorReturn(self, call) {
  if (call && (next_dist_compiled_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(self);
}

/***/ }),

/***/ 90607:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 16835:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ }),

/***/ 27812:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(52587);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ }),

/***/ 2937:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52587);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ }),

/***/ 20814:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"products":{"items":[{"id":816,"attribute_set_id":10,"name":"Apple iPhone 11 Pro","badges_label":"Brand New","manufacturer_label":"Apple","specification_data":"{\\"General\\":{\\"Payment Terms\\":false},\\"Information Tab and Badges\\":{\\"Promotion Tag\\":\\"For Today Only\\"},\\"Accessories\\":{\\"Accessories 01\\":\\"Lightning Earpods\\",\\"Accessories 02\\":\\"18W USB-Type-C Power Delivery Wall Charger\\"},\\"Key Features\\":{\\"Key Features_01\\":\\"More durable, water resistant body.\\",\\"Key Features_02\\":\\"Triple-lens cameras w\\\\/ new ultra wide-angle lens\\"},\\"Network &amp; Connectivity\\":{\\"4G Network\\":\\"No\\",\\"Bluetooth\\":\\"No\\"},\\"Camera\\":{\\"Primary Camera\\":\\"32MP\\",\\"Secondary Camera\\":\\"32MP\\",\\"Front Camera\\":\\"32MP\\",\\"Camera Flash\\":\\"Yes\\"},\\"Battery\\":{\\"Battery Capacity\\":\\"3600mAh\\"},\\"Brand\\":{\\"Manufacturer\\":\\"Apple\\"}}","delivery_message":"This will be delivery within 3-5 days","video_preview_url":"http://34.250.49.67/sites/default/files/2020-06/group-67.png","video_title":"Apple Iphone 11 Pro","video_url":"http://34.250.49.67/sites/default/files/2020-07/AdobeStock_295620918_Video_HD_Preview.mp4","short_description":{"html":"<p>Built for rapid and cost-effective innovation, the platform combines rich, out-of-the-box functionality, <a class=\\"inner-link\\" href=\\"https://magento.com/solutions/mid-and-enterprise\\">enterprise</a> performance and scale, and powerful business tools to keep you ahead of increasingly complex commerce operations and growing customer demands.</p>"},"description":{"html":"<div data-content-type=\\"row\\" data-appearance=\\"contained\\" data-element=\\"main\\"><div data-enable-parallax=\\"0\\" data-parallax-speed=\\"0.5\\" data-background-images=\\"{}\\" data-element=\\"inner\\" style=\\"justify-content: flex-start; display: flex; flex-direction: column; background-position: left top; background-size: cover; background-repeat: no-repeat; background-attachment: scroll; border-style: none; border-width: 1px; border-radius: 0px; margin: 0px 0px 10px; padding: 10px;\\"><div data-content-type=\\"text\\" data-appearance=\\"default\\" data-element=\\"main\\" style=\\"border-style: none; border-width: 1px; border-radius: 0px; margin: 0px; padding: 0px;\\"><p>A transformative triple‑camera system that adds tons of capability without complexity. An unprecedented leap in battery life. And a mind‑blowing chip that doubles down on machine learning and pushes the boundaries of what a smartphone can do. Welcome to the first iPhone powerful enough to be called Pro.</p></div></div></div>"},"promotions":{"start_date":"","end_date":""},"stock_status":"IN_STOCK","stock_item":{"min_qty":4,"min_sale_qty":1,"max_sale_qty":5},"deal_data":[{"product_id":844,"min_price":"1973.000000"},{"product_id":845,"min_price":"1000.000000"},{"product_id":846,"min_price":"1973.000000"}],"quantity":0,"low_stock_threshold":5,"display_low_stock_badge":0,"promotion_tag_label":"For Today Only","payment_terms_label":null,"sku":"Apple iPhone 11 Pro","delivery_and_return":"<h3 id=\\"How_do_I_get_ADSL__3\\" class=\\"click\\">14-day Return policy</h3>\\r\\n<div class=\\"adslSlide\\">\\r\\n<p>We give you peace of mind when it comes to faulty handsets and cancellation</p>\\r\\n<p>Faulty Handset:</p>\\r\\n<p>Should you find that your new device is technically faulty within 14 days of delivery, kindly contact us on 082 1945 to arrange for a replacement.</p>\\r\\n<p>Cancellation:</p>\\r\\n<p>Should you not be completely satisfied with your purchase within 14 days of delivery","front_camera":"32MP","secondary_camera":"32MP","network_4g":0,"battery_capacity":"5475","__typename":"ConfigurableProduct","price_range":{"minimum_price":{"regular_price":{"value":19960,"currency":"ZAR"}},"maximum_price":{"regular_price":{"value":23960,"currency":"ZAR"}}},"image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/6/1/61jgflbydjl._sx679_.jpg","label":"Apple iPhone 11 Pro"},"small_image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/6/1/61jgflbydjl._sx679_.jpg","label":"Apple iPhone 11 Pro"},"media_gallery":[{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/i/m/images_2.jpeg","label":"Apple iPhone 11 Pro"},{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/6/1/61jgflbydjl._sx679_.jpg","label":"Apple iPhone 11 Pro"},{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/6/1/61ers6ozvul._sx679__2.jpg","label":"Apple iPhone 11 Pro"}],"categories":[{"id":49,"name":"Phones & SIM","level":2},{"id":50,"name":"Smartphones","level":3},{"id":51,"name":"Feature phones","level":3},{"id":52,"name":"Accessories","level":2},{"id":53,"name":"Wearable Tech","level":2},{"id":54,"name":"Fitness trackers","level":3}],"options":[{"title":"I would like to ","required":false,"sort_order":1,"option_id":2,"__typename":"CustomizableDropDownOption","value":[{"price_type":"FIXED","option_type_id":2,"title":"Buy this product once off","price":0,"sku":"once-off"},{"price_type":"FIXED","option_type_id":3,"title":"Get this product on a new contract","price":0,"sku":"contract"},{"price_type":"FIXED","option_type_id":4,"title":"Upgrade","price":0,"sku":"upgrade"}]}],"configurable_options":[{"id":26,"attribute_id":"93","label":"Color","position":1,"use_default":false,"attribute_code":"color","values":[{"value_index":5485,"label":"Midnight Green"},{"value_index":5486,"label":"Space Grey"}],"product_id":901},{"id":27,"attribute_id":"227","label":"Internal Storage","position":0,"use_default":false,"attribute_code":"internal_storage","values":[{"value_index":5482,"label":"512GB"},{"value_index":5483,"label":"256GB"}],"product_id":901}],"variants":[{"product":{"id":844,"name":"Apple iPhone 11 Pro-256GB-Midnight Green","quantity":996,"stock_status":"IN_STOCK","stock_item":{"min_qty":1,"min_sale_qty":1,"max_sale_qty":32},"description":{"html":"<div data-content-type=\\"row\\" data-appearance=\\"contained\\" data-element=\\"main\\"><div data-enable-parallax=\\"0\\" data-parallax-speed=\\"0.5\\" data-background-images=\\"{}\\" data-element=\\"inner\\" style=\\"justify-content: flex-start; display: flex; flex-direction: column; background-position: left top; background-size: cover; background-repeat: no-repeat; background-attachment: scroll; border-style: none; border-width: 1px; border-radius: 0px; margin: 0px 0px 10px; padding: 10px;\\"></div></div>"},"promotions":{"start_date":"","end_date":""},"specification_data":"{\\"General\\":{\\"Payment Terms\\":false},\\"Information Tab and Badges\\":{\\"Promotion Tag\\":\\"Exclusive to Online\\"},\\"Accessories\\":{\\"Accessories 01\\":null,\\"Accessories 02\\":null},\\"Key Features\\":{\\"Key Features_01\\":null,\\"Key Features_02\\":null},\\"Network &amp; Connectivity\\":{\\"4G Network\\":\\"No\\",\\"Bluetooth\\":\\"No\\"},\\"Camera\\":{\\"Primary Camera\\":\\"32MP\\",\\"Secondary Camera\\":\\"32MP\\",\\"Front Camera\\":\\"32MP\\",\\"Camera Flash\\":\\"Yes\\"},\\"Battery\\":{\\"Battery Capacity\\":\\"3600mAh\\"},\\"Brand\\":{\\"Manufacturer\\":\\"Apple\\"}}","sku":"Apple iPhone 11 Pro-256GB-Midnight Green","delivery_and_return":null,"delivery_message":null,"front_camera":"32MP","secondary_camera":"32MP","network_4g":0,"battery_capacity":"5475","low_stock_threshold":5,"display_low_stock_badge":0,"__typename":"SimpleProduct","image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/6/1/61ers6ozvul._sx679__1.jpg","label":"Apple iPhone 11 Pro-256GB-Midnight Green"},"small_image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/6/1/61ers6ozvul._sx679__1.jpg","label":"Apple iPhone 11 Pro-256GB-Midnight Green"},"thumbnail":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/6/1/61ers6ozvul._sx679__1.jpg","label":"Apple iPhone 11 Pro-256GB-Midnight Green"},"media_gallery":[{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/6/1/61ers6ozvul._sx679__1.jpg","label":"Apple iPhone 11 Pro-256GB-Midnight Green"}],"attribute_set_id":10,"weight":1,"price_range":{"minimum_price":{"regular_price":{"value":21960,"currency":"ZAR"},"final_price":{"value":21960,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":21960,"currency":"ZAR"},"final_price":{"value":21960,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"price_tiers":[]},"attributes":[{"label":"Midnight Green","code":"color","value_index":5485},{"label":"256GB","code":"internal_storage","value_index":5483}]},{"product":{"id":845,"name":"Apple iPhone 11 Pro-256GB-Space Grey","quantity":1000,"stock_status":"IN_STOCK","stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":5},"description":{"html":"<div data-content-type=\\"row\\" data-appearance=\\"contained\\" data-element=\\"main\\"><div data-enable-parallax=\\"0\\" data-parallax-speed=\\"0.5\\" data-background-images=\\"{}\\" data-element=\\"inner\\" style=\\"justify-content: flex-start; display: flex; flex-direction: column; background-position: left top; background-size: cover; background-repeat: no-repeat; background-attachment: scroll; border-style: none; border-width: 1px; border-radius: 0px; margin: 0px 0px 10px; padding: 10px;\\"><div data-content-type=\\"text\\" data-appearance=\\"default\\" data-element=\\"main\\" style=\\"border-style: none; border-width: 1px; border-radius: 0px; margin: 0px; padding: 0px;\\"><p>Test Data2</p></div><div data-content-type=\\"video\\" data-appearance=\\"default\\" data-element=\\"main\\" style=\\"margin: 0px;\\"><div class=\\"pagebuilder-video-inner\\" data-element=\\"inner\\"><div class=\\"pagebuilder-video-wrapper\\" data-element=\\"wrapper\\" style=\\"border-style: none; border-width: 1px; border-radius: 0px; padding: 0px;\\"><div class=\\"pagebuilder-video-container\\"><iframe frameborder=\\"0\\" allowfullscreen=\\"\\" src=\\"https://www.youtube.com/embed/4gDndwMg_zk\\" data-element=\\"video\\"></iframe></div></div></div></div></div></div>"},"promotions":{"start_date":"","end_date":""},"specification_data":"{\\"General\\":{\\"Payment Terms\\":false},\\"Information Tab and Badges\\":{\\"Promotion Tag\\":\\"Exclusive to Online\\"},\\"Accessories\\":{\\"Accessories 01\\":null,\\"Accessories 02\\":null},\\"Key Features\\":{\\"Key Features_01\\":null,\\"Key Features_02\\":null},\\"Network &amp; Connectivity\\":{\\"4G Network\\":\\"No\\",\\"Bluetooth\\":\\"No\\"},\\"Camera\\":{\\"Primary Camera\\":\\"32MP\\",\\"Secondary Camera\\":\\"32MP\\",\\"Front Camera\\":\\"32MP\\",\\"Camera Flash\\":\\"Yes\\"},\\"Battery\\":{\\"Battery Capacity\\":\\"3600mAh\\"},\\"Brand\\":{\\"Manufacturer\\":\\"Apple\\"}}","sku":"Apple iPhone 11 Pro-256GB-Space Grey","delivery_and_return":null,"delivery_message":null,"front_camera":"32MP","secondary_camera":"32MP","network_4g":0,"battery_capacity":"5475","low_stock_threshold":5,"display_low_stock_badge":0,"__typename":"SimpleProduct","image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/6/1/61tuqdl2yll._sx679__1.jpg","label":"Apple iPhone 11 Pro-256GB-Space Grey"},"small_image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/6/1/61tuqdl2yll._sx679__1.jpg","label":"Apple iPhone 11 Pro-256GB-Space Grey"},"thumbnail":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/6/1/61tuqdl2yll._sx679__1.jpg","label":"Apple iPhone 11 Pro-256GB-Space Grey"},"media_gallery":[{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/6/1/61tuqdl2yll._sx679__1.jpg","label":"Apple iPhone 11 Pro-256GB-Space Grey"}],"attribute_set_id":10,"weight":1,"price_range":{"minimum_price":{"regular_price":{"value":22960,"currency":"ZAR"},"final_price":{"value":22960,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":22960,"currency":"ZAR"},"final_price":{"value":22960,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"price_tiers":[]},"attributes":[{"label":"Space Grey","code":"color","value_index":5486},{"label":"256GB","code":"internal_storage","value_index":5483}]},{"product":{"id":846,"name":"Apple iPhone 11 Pro-512GB-Midnight Green","quantity":884,"stock_status":"IN_STOCK","stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":5},"description":{"html":""},"promotions":{"start_date":"","end_date":""},"specification_data":"{\\"General\\":{\\"Payment Terms\\":false},\\"Information Tab and Badges\\":{\\"Promotion Tag\\":\\"Exclusive to Online\\"},\\"Accessories\\":{\\"Accessories 01\\":\\"Lightning Earpods\\",\\"Accessories 02\\":\\"18W USB-Type-C Power Delivery Wall Charger\\"},\\"Key Features\\":{\\"Key Features_01\\":\\"More durable, water resistant body.\\",\\"Key Features_02\\":\\"Triple-lens cameras w\\\\/ new ultra wide-angle lens\\"},\\"Network &amp; Connectivity\\":{\\"4G Network\\":\\"No\\",\\"Bluetooth\\":\\"No\\"},\\"Camera\\":{\\"Primary Camera\\":\\"32MP\\",\\"Secondary Camera\\":\\"32MP\\",\\"Front Camera\\":\\"32MP\\",\\"Camera Flash\\":\\"Yes\\"},\\"Battery\\":{\\"Battery Capacity\\":\\"3600mAh\\"},\\"Brand\\":{\\"Manufacturer\\":\\"Apple\\"}}","sku":"Apple iPhone 11 Pro-512GB-Midnight Green","delivery_and_return":"<h3 id=\\"How_do_I_get_ADSL__3\\" class=\\"click\\">14-day Return policy</h3>\\r\\n<div class=\\"adslSlide\\">\\r\\n<p>We give you peace of mind when it comes to faulty handsets and cancellation</p>\\r\\n<p>Faulty Handset:</p>\\r\\n<p>Should you find that your new device is technically faulty within 14 days of delivery, kindly contact us on 082 1945 to arrange for a replacement.</p>\\r\\n<p>Cancellation:</p>\\r\\n<p>Should you not be completely satisfied with your purchase within 14 days of delivery","delivery_message":"This will be delivery within 3-5 days","front_camera":"32MP","secondary_camera":"32MP","network_4g":0,"battery_capacity":"5475","low_stock_threshold":5,"display_low_stock_badge":0,"__typename":"SimpleProduct","image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/6/1/61ers6ozvul._sx679_.jpg","label":"Apple iPhone 11 Pro-512GB-Midnight Green"},"small_image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/6/1/61ers6ozvul._sx679_.jpg","label":"Apple iPhone 11 Pro-512GB-Midnight Green"},"thumbnail":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/6/1/61ers6ozvul._sx679_.jpg","label":"Apple iPhone 11 Pro-512GB-Midnight Green"},"media_gallery":[{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/6/1/61ers6ozvul._sx679_.jpg","label":"Apple iPhone 11 Pro-512GB-Midnight Green"}],"attribute_set_id":10,"weight":1,"price_range":{"minimum_price":{"regular_price":{"value":19960,"currency":"ZAR"},"final_price":{"value":19960,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":19960,"currency":"ZAR"},"final_price":{"value":19960,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"price_tiers":[]},"attributes":[{"label":"Midnight Green","code":"color","value_index":5485},{"label":"512GB","code":"internal_storage","value_index":5482}]},{"product":{"id":847,"name":"Apple iPhone 11 Pro-512GB-Space Grey","quantity":998,"stock_status":"IN_STOCK","stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":5},"description":{"html":""},"promotions":{"start_date":"","end_date":""},"specification_data":"{\\"General\\":{\\"Payment Terms\\":false,\\"Manufacturer\\":\\"Apple\\"},\\"Information Tab and Badges\\":{\\"Promotion Tag\\":\\"Exclusive to Online\\"},\\"Accessories\\":{\\"Accessories 01\\":null,\\"Accessories 02\\":null},\\"Key Features\\":{\\"Key Features_01\\":null,\\"Key Features_02\\":null},\\"Network &amp; Connectivity\\":{\\"4G Network\\":\\"No\\",\\"Bluetooth\\":\\"No\\",\\"LTE\\":\\"No\\"},\\"Camera\\":{\\"Primary Camera\\":\\"32MP\\",\\"Secondary Camera\\":\\"32MP\\",\\"Front Camera\\":\\"32MP\\"},\\"Battery\\":{\\"Battery Capacity\\":\\"3600mAh\\"}}","sku":"Apple iPhone 11 Pro-512GB-Space Grey","delivery_and_return":null,"delivery_message":null,"front_camera":"32MP","secondary_camera":"32MP","network_4g":0,"battery_capacity":"5475","low_stock_threshold":5,"display_low_stock_badge":0,"__typename":"SimpleProduct","image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/6/1/61tuqdl2yll._sx679_.jpg","label":"Apple iPhone 11 Pro-512GB-Space Grey"},"small_image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/6/1/61tuqdl2yll._sx679_.jpg","label":"Apple iPhone 11 Pro-512GB-Space Grey"},"thumbnail":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/6/1/61tuqdl2yll._sx679_.jpg","label":"Apple iPhone 11 Pro-512GB-Space Grey"},"media_gallery":[{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/6/1/61tuqdl2yll._sx679_.jpg","label":"Apple iPhone 11 Pro-512GB-Space Grey"}],"attribute_set_id":11,"weight":1,"price_range":{"minimum_price":{"regular_price":{"value":23960,"currency":"ZAR"},"final_price":{"value":23960,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":23960,"currency":"ZAR"},"final_price":{"value":23960,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"price_tiers":[]},"attributes":[{"label":"Space Grey","code":"color","value_index":5486},{"label":"512GB","code":"internal_storage","value_index":5482}]}],"related_products":[{"name":"Apple iPhone 11 Pro Max","sku":"104046524-1","badges":5493,"badges_label":"For Today Only","quantity":null,"low_stock_threshold":5,"display_low_stock_badge":0,"price_range":{"minimum_price":{"regular_price":{"value":24859,"currency":"ZAR"},"final_price":{"value":22999,"currency":"ZAR"},"discount":{"amount_off":1860,"percent_off":7.48}},"maximum_price":{"regular_price":{"value":24859,"currency":"ZAR"},"final_price":{"value":22999,"currency":"ZAR"},"discount":{"amount_off":1860,"percent_off":7.48}}},"image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple-iphone-5s-a1530-original-imaerjwghhx5xdgm.jpeg","label":"Apple iPhone 11 Pro Max"}}],"upsell_products":[{"name":"Apple iPhone 11 Pro Max","sku":"104046524-1","badges":5493,"badges_label":"For Today Only","quantity":null,"low_stock_threshold":5,"display_low_stock_badge":0,"price_range":{"minimum_price":{"regular_price":{"value":24859,"currency":"ZAR"},"final_price":{"value":22999,"currency":"ZAR"},"discount":{"amount_off":1860,"percent_off":7.48}},"maximum_price":{"regular_price":{"value":24859,"currency":"ZAR"},"final_price":{"value":22999,"currency":"ZAR"},"discount":{"amount_off":1860,"percent_off":7.48}}},"image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple-iphone-5s-a1530-original-imaerjwghhx5xdgm.jpeg","label":"Apple iPhone 11 Pro Max"}}],"crosssell_products":[{"name":"Apple iPhone 11 Pro Max","sku":"104046524-1","badges":5493,"badges_label":"For Today Only","quantity":null,"low_stock_threshold":5,"display_low_stock_badge":0,"price_range":{"minimum_price":{"regular_price":{"value":24859,"currency":"ZAR"},"final_price":{"value":22999,"currency":"ZAR"},"discount":{"amount_off":1860,"percent_off":7.48}},"maximum_price":{"regular_price":{"value":24859,"currency":"ZAR"},"final_price":{"value":22999,"currency":"ZAR"},"discount":{"amount_off":1860,"percent_off":7.48}}},"image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple-iphone-5s-a1530-original-imaerjwghhx5xdgm.jpeg","label":"Apple iPhone 11 Pro Max"}}]}]}}}');

/***/ }),

/***/ 30431:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"status":"success","id":"fd5a4171-efa6-478f-a837-f1ae2478cad7","analyticTitle":"Shake every day ","pageTitle":"Shake every day","breadcrumb":{"Home":{"url":"/"},"Terms and conditions (T&C)":{"url":"/terms-and-conditions"},"Shake every day":{"url":"/shake-every-day"}},"summaryLabel":"Short version","summaryText":"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut porttitor leo a diam. Blandit massa enim nec dui nunc mattis enim ut tellus.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut porttitor leo a diam. Blandit massa enim nec dui nunc mattis enim ut tellus.Lorem ipsum dolor sit amet, consectetur.</p><p>&nbsp;</p>","updatedDate":"Last updated: 14 July 2020","siteType":"CBU","template":{"name":"Terms&ConditionDetailpage","metadata":{"Content":["Content Display"]}},"iconLinks":[{"label":"Print "},{"label":"Download PDF"}],"documentLink":"http://3.250.153.131/sites/default/files/2020-07/Presentation1_0.pdf","tableOfContent":{"label":"Table of contents","content":[{"id":"1029a137-c185-44dc-98c5-c2622ef3b316","title":"Ordered list"},{"id":"729a69e8-6ee5-479b-a2c5-2e8e28369483","title":"Ordered list with unordered list"},{"id":"b3005f94-5091-49d8-ba9c-fed48eaf7c8a","title":"Description with ordered list change"},{"id":"7d5ef0e9-1384-4aac-bce5-8a29dfd5731b","title":"Description with sub-heading change"}]},"contentDetails":{"content":[{"id":"1029a137-c185-44dc-98c5-c2622ef3b316","title":"Ordered list","description":"<ol>\\t<li>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</li>\\t<li>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.&nbsp;</li>\\t<li>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut porttitor leo a diam. Blandit massa enim nec dui nunc mattis enim ut tellus.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut porttitor leo a diam. Blandit massa enim nec dui nunc mattis enim ut tellus.Lorem ipsum dolor sit amet, consectetur.</li></ol>","tableInformation":{"0":["Minute Allocation/Bundle Description","Price","In-Bundle Rate Per Minute","Network","Unitisation"],"1":["50min","R59","R1.18","Any Network Any Time","Per Second"],"2":["50min","R109","R1.09","Any Network Any Time","Per Second"],"3":["50min","R59","R1.18","Any Network Any Time","Per Second"],"4":["50min","R109","R1.09","Any Network Any Time","Per Second"],"caption":"Lorem ipsum dolor sit amet"}},{"id":"729a69e8-6ee5-479b-a2c5-2e8e28369483","title":"Ordered list with unordered list","description":"<ol>\\t<li>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.&nbsp;</li>\\t<li>Lorem ipsum dolor sit amet:&nbsp;\\t<ol>\\t\\t<li>Consectetur adipiscing elit</li>\\t\\t<li>Consectetur adipiscing elit</li>\\t\\t<li>Consectetur adipiscing elit</li>\\t</ol>\\t</li></ol><p>&nbsp;</p><p><strong>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed</strong></p><p><strong><img alt=\\"icon\\" data-entity-type=\\"file\\" data-entity-uuid=\\"8ce14c5b-cce0-47dd-9848-6e4b585430f1\\" height=\\"361\\" src=\\"http://3.250.153.131/sites/default/files/inline-images/icon-2.png\\" width=\\"538\\" /></strong></p>","tableInformation":null},{"id":"b3005f94-5091-49d8-ba9c-fed48eaf7c8a","title":"Description with ordered list change","description":"<ol>\\t<li>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.&nbsp;</li>\\t<li>Lorem ipsum dolor sit amet:&nbsp;\\t<ol>\\t\\t<li>Consectetur adipiscing elit</li>\\t\\t<li>Consectetur adipiscing elit</li>\\t\\t<li>Consectetur adipiscing elit</li>\\t</ol>\\t</li></ol>","tableInformation":null},{"id":"7d5ef0e9-1384-4aac-bce5-8a29dfd5731b","title":"Description with sub-heading change","description":"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.&nbsp;</p><p>Ut porttitor leo a diam. Blandit massa enim nec dui nunc mattis enim ut tellus.</p><ul>\\t<li>Sub-heading<br />\\tLorem ipsum dolor sit amet, consectetur adipiscing elit.&nbsp;<br />\\tSed do eiusmod tempor incididunt ut labore et dolore magna aliqua.&nbsp;<br />\\tUt porttitor leo a diam. Blandit massa enim nec dui nunc mattis enim ut tellus.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut porttitor leo a diam.&nbsp;</li></ul>","tableInformation":null}]}}');

/***/ }),

/***/ 91209:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"cart":{"email":"27630187850@mailinator.com","allow_place_order":1,"notification_data":{"is_pending_orders":1,"cancel_order_duration":24},"shippingMessageText":{"delivery_message":"Deliveries are made on weekdays between 08:00 and 17:00","free_shipping_message":"Your Order is over R600","free_shipping_method_message":"your delivery is FREE","standard_shipping_message":"Your Order is","standard_shipping_method_message":"Delivery is Standard Delivery"},"shipping_fee_calculate":{"method_code":"freeshipping","carrier_code":"freeshipping","shipping_label":"Free","shipping_fee":"0"},"cart_order_limits":{"cart_qty_limit":"20","order_value_limit":"200000"},"items":[{"id":"1046161","prices":{"row_total_original":{"value":0},"row_total_including_tax":{"value":0},"total_item_discount":{"value":0},"price":{"value":0},"discounts":null},"product":{"items":[{"option_id":123038,"title":"Smartphones","options":[{"id":224552,"is_hidden_product":"0","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","product":{"id":30182,"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","sku":"104048115"}}]},{"option_id":123041,"title":"Tablet","options":[{"id":224555,"is_hidden_product":"0","label":"SAMSUNG GALAXY TAB A 2019 10.1","product":{"id":21416,"name":"SAMSUNG GALAXY TAB A 2019 10.1","sku":"108017080"}}]},{"option_id":123044,"title":"Promo","options":[{"id":224558,"is_hidden_product":"0","label":"RED SELECT TOP UP+","product":{"id":17102,"name":"RED SELECT TOP UP+","sku":"VID10002061"}}]},{"option_id":123035,"title":"General","options":[{"id":224540,"is_hidden_product":"1","label":"Next Day Delivery","product":{"id":11528,"name":"Next Day Delivery","sku":"102027255"}},{"id":224543,"is_hidden_product":"1","label":"Promotional My Gig 2 - 24 Month Hybrid","product":{"id":18704,"name":"Promotional My Gig 2 - 24 Month Hybrid","sku":"VID10001942"}},{"id":224546,"is_hidden_product":"1","label":"RED SELECT TOP UP+ Line Rental","product":{"id":25049,"name":"RED SELECT TOP UP+ Line Rental","sku":"VID10002083"}},{"id":224549,"is_hidden_product":"1","label":"Handset Installment 15","product":{"id":22238,"name":"Handset Installment 15","sku":"VID10002750"}}]}],"options":[{"option_id":132144}],"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1499 PM (R350 Finance + R1149 Sub on Red Select Top Up + (36 Months) (PROMOGIG2)","id":48209,"sku":"V15DE11247","categories":[{"id":209,"name":"Deals"},{"id":212,"name":"Phones & SIM"},{"id":221,"name":"Smartphones"}],"promotion_tag_label":"For today only","low_stock_threshold":5,"quantity":0,"stock_status":"IN_STOCK","is_deal_product":1,"badges":16619,"promo_data":4000,"minutes":900,"minutes_label":"900","airtime":0,"old_monthly_recurring":"4000","sms":"Unlimited","plan_name":16721,"plan_name_label":"Red","plan_type":16706,"componentid":"102027255,104048115,108017080,VID10001942,VID10002061,VID10002083,VID10002750","contract_sku":["V15DE11247","DV8NR13073"],"plan_type_label":"Data & voice minutes","nightowl_units":"12","nightowl_uom":"GB","contract_type":16715,"contract_type_label":"Standard contract","payment_terms":"16703","payment_terms_label":"36","badges_label":"Black Friday","promotion_tag":16670,"accessories":null,"accessories_label":null,"monthly_recurring":1499,"primary_product_sku":"104048115","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg","primary_product_name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","stock_item":null,"__typename":"BundleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1499 PM (R350 Finance + R1149 Sub on Red Select Top Up + (36 Months) (PROMOGIG2)"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1499 PM (R350 Finance + R1149 Sub on Red Select Top Up + (36 Months) (PROMOGIG2)"},"crosssell_products":[]},"bundle_custom_options":[{"values":[{"value":"332492"}]}],"customizable_options":[{"label":"I would like to","values":[{"value":"332492","label":"Get this deal on a new contract"}]}],"quantity":1},{"id":"1061437","simple_custom_options":[{"values":[{"value":"13339"}]}],"prices":{"row_total_original":{"value":0},"row_total_including_tax":{"value":0},"total_item_discount":{"value":0},"price":{"value":0},"discounts":null},"product":{"options":[{"option_id":4496},{"option_id":18720}],"name":"Personal Alarm","id":28154,"sku":"102063462","categories":[{"id":62,"name":"Smart Home"},{"id":65,"name":"Smart Devices"}],"promotion_tag_label":null,"low_stock_threshold":5,"quantity":0,"stock_status":"IN_STOCK","is_deal_product":0,"badges":16601,"promo_data":null,"minutes":null,"minutes_label":null,"airtime":null,"old_monthly_recurring":null,"sms":null,"plan_name":null,"plan_name_label":null,"plan_type":null,"componentid":null,"contract_sku":["102063462"],"plan_type_label":null,"nightowl_units":null,"nightowl_uom":null,"contract_type":null,"contract_type_label":null,"payment_terms":null,"payment_terms_label":null,"badges_label":"Pre Order","promotion_tag":null,"accessories":null,"accessories_label":null,"monthly_recurring":null,"primary_product_sku":null,"primary_product_image":null,"primary_product_name":null,"stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":10000},"__typename":"SimpleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/i/m/image_12.png?quality=80&fit=bounds&height=&width=","label":"Personal Alarm"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/i/m/image_12.png?quality=80&fit=bounds&height=&width=","label":"Personal Alarm"},"crosssell_products":[]},"quantity":1}],"available_payment_methods":[{"code":"checkmo","title":"VFS"}],"selected_payment_method":{"code":"","title":""},"applied_coupons":null,"prices":{"discounts":null,"grand_total":{"value":10099.5,"currency":"ZAR"},"subtotal_including_tax":{"value":10099.5,"currency":"ZAR"},"subtotal_excluding_tax":{"value":8782.17,"currency":"ZAR"},"subtotal_with_discount_excluding_tax":{"value":8782.17,"currency":"ZAR"},"applied_taxes":[{"amount":{"value":1317.33,"currency":"ZAR"},"label":"VAT (incl.):"}]},"total_quantity":3}}}');

/***/ }),

/***/ 81839:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"cart":{"email":"27823178744@mailinator.com","allow_place_order":1,"notification_data":{"is_pending_orders":1,"cancel_order_duration":24},"shippingMessageText":{"delivery_message":"Deliveries are made on weekdays between 08:00 and 17:00","free_shipping_message":"Your Order is over R600","free_shipping_method_message":"your delivery is FREE","standard_shipping_message":"Your Order is","standard_shipping_method_message":"Delivery is Standard Delivery"},"shipping_fee_calculate":{"method_code":"freeshipping","carrier_code":"freeshipping","shipping_label":"Free","shipping_fee":"0"},"cart_order_limits":{"cart_qty_limit":"20","order_value_limit":"200000"},"items":[{"id":"1046161","prices":{"row_total_original":{"value":0},"row_total_including_tax":{"value":0},"total_item_discount":{"value":0},"price":{"value":0},"discounts":null},"product":{"items":[{"option_id":123038,"title":"Smartphones","options":[{"id":224552,"is_hidden_product":"0","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","product":{"id":30182,"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","sku":"104048115","quantity":0}}]},{"option_id":123041,"title":"Tablet","options":[{"id":224555,"is_hidden_product":"0","label":"SAMSUNG GALAXY TAB A 2019 10.1","product":{"id":21416,"name":"SAMSUNG GALAXY TAB A 2019 10.1","sku":"108017080"}}]}],"options":[{"option_id":132144}],"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1499 PM (R350 Finance + R1149 Sub on Red Select Top Up + (36 Months) (PROMOGIG2)","id":48209,"sku":"V15DE11247","categories":[{"id":209,"name":"Deals"},{"id":212,"name":"Phones & SIM"},{"id":221,"name":"Smartphones"}],"promotion_tag_label":"For today only","low_stock_threshold":5,"quantity":0,"stock_status":"IN_STOCK","is_deal_product":1,"badges":16619,"promo_data":4000,"minutes":900,"minutes_label":"900","airtime":0,"old_monthly_recurring":"4000","sms":"Unlimited","plan_name":16721,"plan_name_label":"Red","plan_type":16706,"componentid":"102027255,104048115,108017080,VID10001942,VID10002061,VID10002083,VID10002750","contract_sku":["V15DE11247","DV8NR13073"],"plan_type_label":"Data & voice minutes","nightowl_units":"12","nightowl_uom":"GB","contract_type":16715,"contract_type_label":"Standard contract","payment_terms":"16703","payment_terms_label":"36","badges_label":"Black Friday","promotion_tag":16670,"accessories":null,"accessories_label":null,"monthly_recurring":1499,"primary_product_sku":"104048115","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg","primary_product_name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","stock_item":null,"__typename":"BundleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1499 PM (R350 Finance + R1149 Sub on Red Select Top Up + (36 Months) (PROMOGIG2)"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1499 PM (R350 Finance + R1149 Sub on Red Select Top Up + (36 Months) (PROMOGIG2)"},"crosssell_products":[]},"bundle_custom_options":[{"values":[{"value":"332492"}]}],"customizable_options":[{"label":"I would like to","values":[{"value":"332492","label":"Get this deal on a new contract"}]}],"quantity":1}],"available_payment_methods":[{"code":"checkmo","title":"VFS"}],"selected_payment_method":{"code":"","title":""},"applied_coupons":null,"prices":{"discounts":null,"grand_total":{"value":12399,"currency":"ZAR"},"subtotal_including_tax":{"value":12399,"currency":"ZAR"},"subtotal_excluding_tax":{"value":10781.74,"currency":"ZAR"},"subtotal_with_discount_excluding_tax":{"value":10781.74,"currency":"ZAR"},"applied_taxes":[{"amount":{"value":1617.26,"currency":"ZAR"},"label":"VAT (incl.):"}]},"total_quantity":2}}}');

/***/ }),

/***/ 21225:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"cart":{"email":"27823178744@mailinator.com","allow_place_order":1,"notification_data":{"is_pending_orders":1,"cancel_order_duration":24},"shippingMessageText":{"delivery_message":"Deliveries are made on weekdays between 08:00 and 17:00","free_shipping_message":"Your Order is over R600","free_shipping_method_message":"your delivery is FREE","standard_shipping_message":"Your Order is","standard_shipping_method_message":"Delivery is Standard Delivery"},"shipping_fee_calculate":{"method_code":"freeshipping","carrier_code":"freeshipping","shipping_label":"Free","shipping_fee":"0"},"cart_order_limits":{"cart_qty_limit":"20","order_value_limit":"200000"},"items":[{"id":"1046161","prices":{"row_total_original":{"value":0},"row_total_including_tax":{"value":0},"total_item_discount":{"value":0},"price":{"value":0},"discounts":null},"product":{"items":[{"option_id":123038,"title":"Smartphones","options":[{"id":224552,"is_hidden_product":"0","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","product":{"id":30182,"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","sku":"104048115","quantity":0}}]},{"option_id":123041,"title":"Tablet","options":[{"id":224555,"is_hidden_product":"0","label":"SAMSUNG GALAXY TAB A 2019 10.1","product":{"id":21416,"name":"SAMSUNG GALAXY TAB A 2019 10.1","sku":"108017080"}}]}],"options":[{"option_id":132144}],"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1499 PM (R350 Finance + R1149 Sub on Red Select Top Up + (36 Months) (PROMOGIG2)","id":48209,"sku":"V15DE11247","categories":[{"id":209,"name":"Deals"},{"id":212,"name":"Phones & SIM"},{"id":221,"name":"Smartphones"}],"promotion_tag_label":"For today only","low_stock_threshold":5,"quantity":0,"stock_status":"IN_STOCK","is_deal_product":1,"badges":16619,"promo_data":4000,"minutes":900,"minutes_label":"900","airtime":0,"old_monthly_recurring":"4000","sms":"Unlimited","plan_name":16721,"plan_name_label":"Red","plan_type":16706,"componentid":"102027255,104048115,108017080,VID10001942,VID10002061,VID10002083,VID10002750","contract_sku":["V15DE11247","DV8NR13073"],"plan_type_label":"Data & voice minutes","nightowl_units":"12","nightowl_uom":"GB","contract_type":16715,"contract_type_label":"Standard contract","payment_terms":"16703","payment_terms_label":"36","badges_label":"BackOrder","promotion_tag":16670,"accessories":null,"accessories_label":null,"monthly_recurring":1499,"primary_product_sku":"104048115","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg","primary_product_name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","stock_item":null,"__typename":"BundleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1499 PM (R350 Finance + R1149 Sub on Red Select Top Up + (36 Months) (PROMOGIG2)"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1499 PM (R350 Finance + R1149 Sub on Red Select Top Up + (36 Months) (PROMOGIG2)"},"crosssell_products":[]},"bundle_custom_options":[{"values":[{"value":"332492"}]}],"customizable_options":[{"label":"I would like to","values":[{"value":"332492","label":"Get this deal on a new contract"}]}],"quantity":1}],"available_payment_methods":[{"code":"checkmo","title":"VFS"}],"selected_payment_method":{"code":"","title":""},"applied_coupons":null,"prices":{"discounts":null,"grand_total":{"value":12399,"currency":"ZAR"},"subtotal_including_tax":{"value":12399,"currency":"ZAR"},"subtotal_excluding_tax":{"value":10781.74,"currency":"ZAR"},"subtotal_with_discount_excluding_tax":{"value":10781.74,"currency":"ZAR"},"applied_taxes":[{"amount":{"value":1617.26,"currency":"ZAR"},"label":"VAT (incl.):"}]},"total_quantity":2}}}');

/***/ }),

/***/ 78394:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"cart":{"email":"27823178744@mailinator.com","allow_place_order":1,"notification_data":{"is_pending_orders":1,"cancel_order_duration":24},"shippingMessageText":{"delivery_message":"Deliveries are made on weekdays between 08:00 and 17:00","free_shipping_message":"Your Order is over R600","free_shipping_method_message":"your delivery is FREE","standard_shipping_message":"Your Order is","standard_shipping_method_message":"Delivery is Standard Delivery"},"shipping_fee_calculate":{"method_code":"freeshipping","carrier_code":"freeshipping","shipping_label":"Free","shipping_fee":"0"},"cart_order_limits":{"cart_qty_limit":"20","order_value_limit":"200000"},"items":[{"id":"1046161","prices":{"row_total_original":{"value":0},"row_total_including_tax":{"value":0},"total_item_discount":{"value":0},"price":{"value":0},"discounts":null},"product":{"items":[{"option_id":123038,"title":"Smartphones","options":[{"id":224552,"is_hidden_product":"0","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","product":{"id":30182,"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","sku":"104048115"}}]},{"option_id":123041,"title":"Tablet","options":[{"id":224555,"is_hidden_product":"0","label":"SAMSUNG GALAXY TAB A 2019 10.1","product":{"id":21416,"name":"SAMSUNG GALAXY TAB A 2019 10.1","sku":"108017080"}}]},{"option_id":123044,"title":"Promo","options":[{"id":224558,"is_hidden_product":"0","label":"RED SELECT TOP UP+","product":{"id":17102,"name":"RED SELECT TOP UP+","sku":"VID10002061"}}]},{"option_id":123035,"title":"General","options":[{"id":224540,"is_hidden_product":"1","label":"Next Day Delivery","product":{"id":11528,"name":"Next Day Delivery","sku":"102027255"}},{"id":224543,"is_hidden_product":"1","label":"Promotional My Gig 2 - 24 Month Hybrid","product":{"id":18704,"name":"Promotional My Gig 2 - 24 Month Hybrid","sku":"VID10001942"}},{"id":224546,"is_hidden_product":"1","label":"RED SELECT TOP UP+ Line Rental","product":{"id":25049,"name":"RED SELECT TOP UP+ Line Rental","sku":"VID10002083"}},{"id":224549,"is_hidden_product":"1","label":"Handset Installment 15","product":{"id":22238,"name":"Handset Installment 15","sku":"VID10002750"}}]}],"options":[{"option_id":132144}],"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1499 PM (R350 Finance + R1149 Sub on Red Select Top Up + (36 Months) (PROMOGIG2)","id":48209,"sku":"V15DE11247","categories":[{"id":209,"name":"Deals"},{"id":212,"name":"Phones & SIM"},{"id":221,"name":"Smartphones"}],"promotion_tag_label":"For today only","low_stock_threshold":5,"quantity":0,"stock_status":"IN_STOCK","is_deal_product":1,"badges":16619,"promo_data":4000,"minutes":900,"minutes_label":"900","airtime":0,"old_monthly_recurring":"4000","sms":"Unlimited","plan_name":16721,"plan_name_label":"Red","plan_type":16706,"componentid":"102027255,104048115,108017080,VID10001942,VID10002061,VID10002083,VID10002750","contract_sku":["V15DE11247","DV8NR13073"],"plan_type_label":"Data & voice minutes","nightowl_units":"12","nightowl_uom":"GB","contract_type":16715,"contract_type_label":"Standard contract","payment_terms":"16703","payment_terms_label":"36","badges_label":"Black Friday","promotion_tag":16670,"accessories":null,"accessories_label":null,"monthly_recurring":1499,"primary_product_sku":"104048115","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg","primary_product_name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","stock_item":null,"__typename":"BundleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1499 PM (R350 Finance + R1149 Sub on Red Select Top Up + (36 Months) (PROMOGIG2)"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1499 PM (R350 Finance + R1149 Sub on Red Select Top Up + (36 Months) (PROMOGIG2)"},"crosssell_products":[]},"bundle_custom_options":[{"values":[{"value":"332492"}]}],"customizable_options":[{"label":"I would like to","values":[{"value":"332492","label":"Get this deal on a new contract"}]}],"quantity":1},{"id":"1056733","simple_custom_options":[{"values":[{"value":"1887"}]}],"prices":{"row_total_original":{"value":12399},"row_total_including_tax":{"value":12399},"total_item_discount":{"value":0},"price":{"value":10781.74},"discounts":null},"product":{"options":[{"option_id":678}],"name":"HP I5","id":28484,"sku":"108015831","categories":[{"id":77,"name":"Tablets & Laptops"},{"id":83,"name":"Work Laptops"}],"promotion_tag_label":null,"low_stock_threshold":5,"quantity":0,"stock_status":"IN_STOCK","is_deal_product":0,"badges":null,"promo_data":null,"minutes":null,"minutes_label":null,"airtime":null,"old_monthly_recurring":null,"sms":null,"plan_name":null,"plan_name_label":null,"plan_type":null,"componentid":null,"contract_sku":["108015831"],"plan_type_label":null,"nightowl_units":null,"nightowl_uom":null,"contract_type":null,"contract_type_label":null,"payment_terms":null,"payment_terms_label":null,"badges_label":null,"promotion_tag":null,"accessories":null,"accessories_label":null,"monthly_recurring":null,"primary_product_sku":null,"primary_product_image":null,"primary_product_name":null,"stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":10000},"__typename":"SimpleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/4/6/465953.jpg?quality=80&fit=bounds&height=&width=","label":"HP I5"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/4/6/465953.jpg?quality=80&fit=bounds&height=&width=","label":"HP I5"},"crosssell_products":[]},"quantity":1}],"available_payment_methods":[{"code":"checkmo","title":"VFS"}],"selected_payment_method":{"code":"","title":""},"applied_coupons":null,"prices":{"discounts":null,"grand_total":{"value":12399,"currency":"ZAR"},"subtotal_including_tax":{"value":12399,"currency":"ZAR"},"subtotal_excluding_tax":{"value":10781.74,"currency":"ZAR"},"subtotal_with_discount_excluding_tax":{"value":10781.74,"currency":"ZAR"},"applied_taxes":[{"amount":{"value":1617.26,"currency":"ZAR"},"label":"VAT (incl.):"}]},"total_quantity":2}}}');

/***/ }),

/***/ 96057:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"cart":{"email":"27823178744@mailinator.com","allow_place_order":1,"notification_data":{"is_pending_orders":1,"cancel_order_duration":24},"shippingMessageText":{"delivery_message":"Deliveries are made on weekdays between 08:00 and 17:00","free_shipping_message":"Your Order is over R600","free_shipping_method_message":"your delivery is FREE","standard_shipping_message":"Your Order is","standard_shipping_method_message":"Delivery is Standard Delivery"},"shipping_fee_calculate":{"method_code":"freeshipping","carrier_code":"freeshipping","shipping_label":"Free","shipping_fee":"0"},"cart_order_limits":{"cart_qty_limit":"20","order_value_limit":"200000"},"items":[{"id":"1025881","prices":{"row_total_original":{"value":0},"row_total_including_tax":{"value":0},"total_item_discount":{"value":0},"price":{"value":0},"discounts":null},"product":{"items":[{"option_id":1106244,"title":"General","options":[{"id":2081340,"is_hidden_product":"1","label":"Bonus Video Ticket 1GB 3 Months","product":{"id":27026,"name":"Bonus Video Ticket 1GB 3 Months","sku":"VID10003749","quantity":0}},{"id":2081343,"is_hidden_product":"1","label":"MyRed 2GB 150min Line Rental","product":{"id":11798,"name":"MyRed 2GB 150min Line Rental","sku":"VID10003600","quantity":0}},{"id":2081346,"is_hidden_product":"1","label":"Reduced Subscription Discount Proration - New","product":{"id":14207,"name":"Reduced Subscription Discount Proration - New","sku":"VID10003207","quantity":0}},{"id":2081349,"is_hidden_product":"0","label":"Promotional 20GB - 30 days","product":{"id":21473,"name":"Promotional 20GB - 30 days","sku":"VID10002758","quantity":0}},{"id":2081352,"is_hidden_product":"1","label":"Next Day Delivery","product":{"id":11528,"name":"Next Day Delivery","sku":"102027255","quantity":0}}]},{"option_id":1106247,"title":"Promo","options":[{"id":2081355,"is_hidden_product":"1","label":"MyRed 2GB 150min","product":{"id":13502,"name":"MyRed 2GB 150min","sku":"VID10003573","quantity":0}}]},{"option_id":1106250,"title":"Smartphones","options":[{"id":2081358,"is_hidden_product":"0","label":"Vivo Y11 Blue","product":{"id":30434,"name":"Vivo Y11 Blue","sku":"104047377","quantity":0}}]}],"options":[{"option_id":144550}],"name":"VIVO Y11 BLUE + 20GB DATA X 1 - (C) + VIDEO TICKET - 3 MONTHS - 1GB @ R389 Reduced Sub PM on Red 2GB 200min","id":264567,"sku":"DV1GD13880","categories":[{"id":209,"name":"Deals"},{"id":212,"name":"Phones & SIM"},{"id":221,"name":"Smartphones"}],"promotion_tag_label":"Red hot deal","low_stock_threshold":5,"quantity":0,"stock_status":"IN_STOCK","is_deal_product":1,"badges":16625,"promo_data":200,"minutes":419,"minutes_label":"419","airtime":0,"old_monthly_recurring":null,"sms":"2000","plan_name":16721,"plan_name_label":"Red","plan_type":16709,"componentid":"VID10002758,VID10003207,VID10003573,VID10003600,VID10003749,102027255,104047377","contract_sku":["DV1GD13880"],"plan_type_label":"Airtime","nightowl_units":"2GB","contract_type":16715,"contract_type_label":"Standard contract","payment_terms":"16697","payment_terms_label":"24","badges_label":"Device","promotion_tag":19247,"accessories":null,"accessories_label":null,"monthly_recurring":389,"primary_product_sku":"104047377","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/v/i/vivo-y11-104047377-front-huge_b6lzdjo7rqdlektt.png","primary_product_name":"Vivo Y11 Blue","stock_item":null,"__typename":"BundleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png","label":"VIVO Y11 BLUE + 20GB DATA X 1 - (C) + VIDEO TICKET - 3 MONTHS - 1GB @ R389 Reduced Sub PM on Red 2GB 200min"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png","label":"VIVO Y11 BLUE + 20GB DATA X 1 - (C) + VIDEO TICKET - 3 MONTHS - 1GB @ R389 Reduced Sub PM on Red 2GB 200min"},"crosssell_products":[]},"bundle_custom_options":[{"values":[{"value":"427199"}]}],"customizable_options":[{"label":"I would like to:","values":[{"value":"427199","label":"Get this deal on a new contract"}]}],"quantity":1},{"id":"1029163","prices":{"row_total_original":{"value":6899},"row_total_including_tax":{"value":5},"total_item_discount":{"value":0},"price":{"value":4.35},"discounts":null},"product":{"options":[{"option_id":18216}],"name":"HP 15 CeleronNotebooks","id":148983,"sku":"HP_15_Celeron_Notebooks","categories":[{"id":77,"name":"Tablets & Laptops"},{"id":80,"name":"Basic Laptops"}],"promotion_tag_label":null,"low_stock_threshold":5,"quantity":0,"stock_status":"IN_STOCK","is_deal_product":0,"badges":null,"promo_data":null,"minutes":null,"minutes_label":null,"airtime":null,"old_monthly_recurring":null,"sms":null,"plan_name":null,"plan_name_label":null,"plan_type":null,"componentid":null,"contract_sku":["HP_15_Celeron_Notebooks"],"plan_type_label":null,"nightowl_units":null,"contract_type":null,"contract_type_label":null,"payment_terms":null,"payment_terms_label":null,"badges_label":null,"promotion_tag":null,"accessories":null,"accessories_label":null,"monthly_recurring":null,"primary_product_sku":null,"primary_product_image":null,"primary_product_name":null,"stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":10000},"__typename":"ConfigurableProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/h/p/hp-2_fufbswu3xy1hrpjt.jpg?quality=80&fit=bounds&height=&width=","label":"HP 15 CeleronNotebooks"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/h/p/hp-2_fufbswu3xy1hrpjt.jpg?quality=80&fit=bounds&height=&width=","label":"HP 15 CeleronNotebooks"},"configurable_options":[{"id":1121,"attribute_id":"667","label":"Storage size","position":0,"use_default":false,"attribute_code":"internal_storage","values":[{"value_index":18095,"label":"500GB","swatch_data":null}],"product_id":149139},{"id":468,"attribute_id":"673","label":"Screen Size Pixels","position":0,"use_default":false,"attribute_code":"screen_size_pixels","values":[{"value_index":18056,"label":"15.6\'\'","swatch_data":null}],"product_id":149139}],"variants":[{"product":{"id":29606,"name":"HP 15 CELERON WITH WIN 10","sku":"102054091","promotion_tag_label":null,"stock_status":"OUT_OF_STOCK","stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":10000},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/4/6/465941.jpg?quality=80&fit=bounds&height=&width=","label":"HP 15 CELERON WITH WIN 10"},"price_range":{"minimum_price":{"regular_price":{"value":6899,"currency":"ZAR"},"final_price":{"value":5,"currency":"ZAR"},"discount":{"amount_off":6894,"percent_off":99.93}},"maximum_price":{"regular_price":{"value":6899,"currency":"ZAR"},"final_price":{"value":5,"currency":"ZAR"},"discount":{"amount_off":6894,"percent_off":99.93}}},"quantity":0,"badges_label":null,"low_stock_threshold":5,"attribute_set_id":19},"attributes":[{"label":"500GB","code":"internal_storage","value_index":18095},{"label":"15.6\'\'","code":"screen_size_pixels","value_index":18056}]}],"crosssell_products":[]},"configurable_options":[{"id":667,"option_label":"Storage size","value_id":18095,"value_label":"500GB"},{"id":673,"option_label":"Screen Size Pixels","value_id":18056,"value_label":"15.6\'\'"}],"config_custom_options":[{"values":[{"value":"56856"}]}],"quantity":1}],"available_payment_methods":[{"code":"checkmo","title":"VFS"}],"selected_payment_method":{"code":"","title":""},"applied_coupons":null,"prices":{"discounts":null,"grand_total":{"value":5,"currency":"ZAR"},"subtotal_including_tax":{"value":5,"currency":"ZAR"},"subtotal_excluding_tax":{"value":4.35,"currency":"ZAR"},"subtotal_with_discount_excluding_tax":{"value":4.35,"currency":"ZAR"},"applied_taxes":[{"amount":{"value":0.65,"currency":"ZAR"},"label":"VAT (incl.):"}]},"total_quantity":3}}}');

/***/ }),

/***/ 24804:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"cart":{"email":"27823178744@mailinator.com","allow_place_order":1,"notification_data":{"is_pending_orders":1,"cancel_order_duration":24},"shippingMessageText":{"delivery_message":"Deliveries are made on weekdays between 08:00 and 17:00","free_shipping_message":"Your Order is over R600","free_shipping_method_message":"your delivery is FREE","standard_shipping_message":"Your Order is","standard_shipping_method_message":"Delivery is Standard Delivery"},"shipping_fee_calculate":{"method_code":"freeshipping","carrier_code":"freeshipping","shipping_label":"Free","shipping_fee":"0"},"cart_order_limits":{"cart_qty_limit":"20","order_value_limit":"200000"},"items":[{"id":"1025881","prices":{"row_total_original":{"value":0},"row_total_including_tax":{"value":0},"total_item_discount":{"value":0},"price":{"value":0},"discounts":null},"product":{"items":[{"option_id":1106244,"title":"General","options":[{"id":2081340,"is_hidden_product":"1","label":"Bonus Video Ticket 1GB 3 Months","product":{"id":27026,"name":"Bonus Video Ticket 1GB 3 Months","sku":"VID10003749","quantity":0}},{"id":2081343,"is_hidden_product":"1","label":"MyRed 2GB 150min Line Rental","product":{"id":11798,"name":"MyRed 2GB 150min Line Rental","sku":"VID10003600","quantity":0}},{"id":2081346,"is_hidden_product":"1","label":"Reduced Subscription Discount Proration - New","product":{"id":14207,"name":"Reduced Subscription Discount Proration - New","sku":"VID10003207","quantity":0}},{"id":2081349,"is_hidden_product":"0","label":"Promotional 20GB - 30 days","product":{"id":21473,"name":"Promotional 20GB - 30 days","sku":"VID10002758","quantity":0}},{"id":2081352,"is_hidden_product":"1","label":"Next Day Delivery","product":{"id":11528,"name":"Next Day Delivery","sku":"102027255","quantity":0}}]},{"option_id":1106247,"title":"Promo","options":[{"id":2081355,"is_hidden_product":"1","label":"MyRed 2GB 150min","product":{"id":13502,"name":"MyRed 2GB 150min","sku":"VID10003573","quantity":0}}]},{"option_id":1106250,"title":"Smartphones","options":[{"id":2081358,"is_hidden_product":"0","label":"Vivo Y11 Blue","product":{"id":30434,"name":"Vivo Y11 Blue","sku":"104047377","quantity":0}}]}],"options":[{"option_id":144550}],"name":"VIVO Y11 BLUE + 20GB DATA X 1 - (C) + VIDEO TICKET - 3 MONTHS - 1GB @ R389 Reduced Sub PM on Red 2GB 200min","id":264567,"sku":"DV1GD13880","categories":[{"id":209,"name":"Deals"},{"id":212,"name":"Phones & SIM"},{"id":221,"name":"Smartphones"}],"promotion_tag_label":"Red hot deal","low_stock_threshold":5,"quantity":0,"stock_status":"IN_STOCK","is_deal_product":1,"badges":16625,"promo_data":200,"minutes":419,"minutes_label":"419","airtime":0,"old_monthly_recurring":null,"sms":"2000","plan_name":16721,"plan_name_label":"Red","plan_type":16709,"componentid":"VID10002758,VID10003207,VID10003573,VID10003600,VID10003749,102027255,104047377","contract_sku":["DV1GD13880"],"plan_type_label":"Airtime","nightowl_units":"2GB","contract_type":16715,"contract_type_label":"Standard contract","payment_terms":"16697","payment_terms_label":"24","badges_label":"Device","promotion_tag":19247,"accessories":null,"accessories_label":null,"monthly_recurring":389,"primary_product_sku":"104047377","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/v/i/vivo-y11-104047377-front-huge_b6lzdjo7rqdlektt.png","primary_product_name":"Vivo Y11 Blue","stock_item":null,"__typename":"BundleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png","label":"VIVO Y11 BLUE + 20GB DATA X 1 - (C) + VIDEO TICKET - 3 MONTHS - 1GB @ R389 Reduced Sub PM on Red 2GB 200min"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png","label":"VIVO Y11 BLUE + 20GB DATA X 1 - (C) + VIDEO TICKET - 3 MONTHS - 1GB @ R389 Reduced Sub PM on Red 2GB 200min"},"crosssell_products":[]},"bundle_custom_options":[{"values":[{"value":"427199"}]}],"customizable_options":[{"label":"I would like to:","values":[{"value":"427199","label":"Get this deal on a new contract"}]}],"quantity":1},{"id":"1029163","prices":{"row_total_original":{"value":6899},"row_total_including_tax":{"value":5},"total_item_discount":{"value":0},"price":{"value":4.35},"discounts":null},"product":{"options":[{"option_id":18216}],"name":"HP 15 CeleronNotebooks","id":148983,"sku":"HP_15_Celeron_Notebooks","categories":[{"id":77,"name":"Tablets & Laptops"},{"id":80,"name":"Basic Laptops"}],"promotion_tag_label":null,"low_stock_threshold":5,"quantity":0,"stock_status":"IN_STOCK","is_deal_product":0,"badges":null,"promo_data":null,"minutes":null,"minutes_label":null,"airtime":null,"old_monthly_recurring":null,"sms":null,"plan_name":null,"plan_name_label":null,"plan_type":null,"componentid":null,"contract_sku":["HP_15_Celeron_Notebooks"],"plan_type_label":null,"nightowl_units":null,"contract_type":null,"contract_type_label":null,"payment_terms":null,"payment_terms_label":null,"badges_label":null,"promotion_tag":null,"accessories":null,"accessories_label":null,"monthly_recurring":null,"primary_product_sku":null,"primary_product_image":null,"primary_product_name":null,"stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":10000},"__typename":"ConfigurableProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/h/p/hp-2_fufbswu3xy1hrpjt.jpg?quality=80&fit=bounds&height=&width=","label":"HP 15 CeleronNotebooks"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/h/p/hp-2_fufbswu3xy1hrpjt.jpg?quality=80&fit=bounds&height=&width=","label":"HP 15 CeleronNotebooks"},"configurable_options":[{"id":1121,"attribute_id":"667","label":"Storage size","position":0,"use_default":false,"attribute_code":"internal_storage","values":[{"value_index":18095,"label":"500GB","swatch_data":null}],"product_id":149139},{"id":468,"attribute_id":"673","label":"Screen Size Pixels","position":0,"use_default":false,"attribute_code":"screen_size_pixels","values":[{"value_index":18056,"label":"15.6\'\'","swatch_data":null}],"product_id":149139}],"variants":[{"product":{"id":29606,"name":"HP 15 CELERON WITH WIN 10","sku":"102054091","promotion_tag_label":null,"stock_status":"OUT_OF_STOCK","stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":10000},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/4/6/465941.jpg?quality=80&fit=bounds&height=&width=","label":"HP 15 CELERON WITH WIN 10"},"price_range":{"minimum_price":{"regular_price":{"value":6899,"currency":"ZAR"},"final_price":{"value":5,"currency":"ZAR"},"discount":{"amount_off":6894,"percent_off":99.93}},"maximum_price":{"regular_price":{"value":6899,"currency":"ZAR"},"final_price":{"value":5,"currency":"ZAR"},"discount":{"amount_off":6894,"percent_off":99.93}}},"quantity":0,"badges_label":null,"low_stock_threshold":5,"attribute_set_id":19},"attributes":[{"label":"500GB","code":"internal_storage","value_index":18095},{"label":"15.6\'\'","code":"screen_size_pixels","value_index":18056}]}],"crosssell_products":[]},"configurable_options":[{"id":667,"option_label":"Storage size","value_id":18095,"value_label":"500GB"},{"id":673,"option_label":"Screen Size Pixels","value_id":18056,"value_label":"15.6\'\'"}],"config_custom_options":[{"values":[{"value":"56856"}]}],"quantity":1}],"available_payment_methods":[{"code":"checkmo","title":"VFS"}],"selected_payment_method":{"code":"","title":""},"applied_coupons":null,"prices":{"discounts":null,"grand_total":{"value":5,"currency":"ZAR"},"subtotal_including_tax":{"value":5,"currency":"ZAR"},"subtotal_excluding_tax":{"value":4.35,"currency":"ZAR"},"subtotal_with_discount_excluding_tax":{"value":4.35,"currency":"ZAR"},"applied_taxes":[{"amount":{"value":0.65,"currency":"ZAR"},"label":"VAT (incl.):"}]},"total_quantity":3}}}');

/***/ }),

/***/ 78149:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"cart":{"email":"27823178744@mailinator.com","allow_place_order":1,"notification_data":{"is_pending_orders":1,"cancel_order_duration":24},"shippingMessageText":{"delivery_message":"Deliveries are made on weekdays between 08:00 and 17:00","free_shipping_message":"Your Order is over R600","free_shipping_method_message":"your delivery is FREE","standard_shipping_message":"Your Order is","standard_shipping_method_message":"Delivery is Standard Delivery"},"shipping_fee_calculate":{"method_code":"freeshipping","carrier_code":"freeshipping","shipping_label":"Free","shipping_fee":"0"},"cart_order_limits":{"cart_qty_limit":"20","order_value_limit":"200000"},"items":[{"id":"1046161","prices":{"row_total_original":{"value":0},"row_total_including_tax":{"value":0},"total_item_discount":{"value":0},"price":{"value":0},"discounts":null},"product":{"items":[{"option_id":123038,"title":"Smartphones","options":[{"id":224552,"is_hidden_product":"0","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","product":{"id":30182,"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","sku":"104048115"}}]},{"option_id":123041,"title":"Tablet","options":[{"id":224555,"is_hidden_product":"0","label":"SAMSUNG GALAXY TAB A 2019 10.1","product":{"id":21416,"name":"SAMSUNG GALAXY TAB A 2019 10.1","sku":"108017080"}}]},{"option_id":123044,"title":"Promo","options":[{"id":224558,"is_hidden_product":"0","label":"RED SELECT TOP UP+","product":{"id":17102,"name":"RED SELECT TOP UP+","sku":"VID10002061"}}]},{"option_id":123035,"title":"General","options":[{"id":224540,"is_hidden_product":"1","label":"Next Day Delivery","product":{"id":11528,"name":"Next Day Delivery","sku":"102027255"}},{"id":224543,"is_hidden_product":"1","label":"Promotional My Gig 2 - 24 Month Hybrid","product":{"id":18704,"name":"Promotional My Gig 2 - 24 Month Hybrid","sku":"VID10001942"}},{"id":224546,"is_hidden_product":"1","label":"RED SELECT TOP UP+ Line Rental","product":{"id":25049,"name":"RED SELECT TOP UP+ Line Rental","sku":"VID10002083"}},{"id":224549,"is_hidden_product":"1","label":"Handset Installment 15","product":{"id":22238,"name":"Handset Installment 15","sku":"VID10002750"}}]}],"options":[{"option_id":132144}],"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1499 PM (R350 Finance + R1149 Sub on Red Select Top Up + (36 Months) (PROMOGIG2)","id":48209,"sku":"V15DE11247","categories":[{"id":209,"name":"Deals"},{"id":212,"name":"Phones & SIM"},{"id":221,"name":"Smartphones"}],"promotion_tag_label":"For today only","low_stock_threshold":5,"quantity":0,"stock_status":"IN_STOCK","is_deal_product":1,"badges":16619,"promo_data":4000,"minutes":900,"minutes_label":"900","airtime":0,"old_monthly_recurring":"4000","sms":"Unlimited","plan_name":16721,"plan_name_label":"Red","plan_type":16706,"componentid":"102027255,104048115,108017080,VID10001942,VID10002061,VID10002083,VID10002750","contract_sku":["V15DE11247","DV8NR13073"],"plan_type_label":"Data & voice minutes","nightowl_units":"12","nightowl_uom":"GB","contract_type":16715,"contract_type_label":"Standard contract","payment_terms":"16703","payment_terms_label":"36","badges_label":"Pre Order","promotion_tag":16670,"accessories":null,"accessories_label":null,"monthly_recurring":1499,"primary_product_sku":"104048115","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg","primary_product_name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","stock_item":null,"__typename":"BundleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1499 PM (R350 Finance + R1149 Sub on Red Select Top Up + (36 Months) (PROMOGIG2)"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1499 PM (R350 Finance + R1149 Sub on Red Select Top Up + (36 Months) (PROMOGIG2)"},"crosssell_products":[]},"bundle_custom_options":[{"values":[{"value":"332492"}]}],"customizable_options":[{"label":"I would like to","values":[{"value":"332492","label":"Get this deal on a new contract"}]}],"quantity":1},{"id":"1056733","simple_custom_options":[{"values":[{"value":"1887"}]}],"prices":{"row_total_original":{"value":12399},"row_total_including_tax":{"value":12399},"total_item_discount":{"value":0},"price":{"value":10781.74},"discounts":null},"product":{"options":[{"option_id":678}],"name":"HP I5","id":28484,"sku":"108015831","categories":[{"id":77,"name":"Tablets & Laptops"},{"id":83,"name":"Work Laptops"}],"promotion_tag_label":null,"low_stock_threshold":5,"quantity":100,"stock_status":"IN_STOCK","is_deal_product":0,"badges":null,"promo_data":null,"minutes":null,"minutes_label":null,"airtime":null,"old_monthly_recurring":null,"sms":null,"plan_name":null,"plan_name_label":null,"plan_type":null,"componentid":null,"contract_sku":["108015831"],"plan_type_label":null,"nightowl_units":null,"nightowl_uom":null,"contract_type":null,"contract_type_label":null,"payment_terms":null,"payment_terms_label":null,"badges_label":null,"promotion_tag":null,"accessories":null,"accessories_label":null,"monthly_recurring":null,"primary_product_sku":null,"primary_product_image":null,"primary_product_name":null,"stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":10000},"__typename":"SimpleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/4/6/465953.jpg?quality=80&fit=bounds&height=&width=","label":"HP I5"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/4/6/465953.jpg?quality=80&fit=bounds&height=&width=","label":"HP I5"},"crosssell_products":[]},"quantity":1}],"available_payment_methods":[{"code":"checkmo","title":"VFS"}],"selected_payment_method":{"code":"","title":""},"applied_coupons":null,"prices":{"discounts":null,"grand_total":{"value":12399,"currency":"ZAR"},"subtotal_including_tax":{"value":12399,"currency":"ZAR"},"subtotal_excluding_tax":{"value":10781.74,"currency":"ZAR"},"subtotal_with_discount_excluding_tax":{"value":10781.74,"currency":"ZAR"},"applied_taxes":[{"amount":{"value":1617.26,"currency":"ZAR"},"label":"VAT (incl.):"}]},"total_quantity":2}}}');

/***/ }),

/***/ 58844:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"cart":{"email":"27823178744@mailinator.com","allow_place_order":1,"notification_data":{"is_pending_orders":1,"cancel_order_duration":24},"shippingMessageText":{"delivery_message":"Deliveries are made on weekdays between 08:00 and 17:00","free_shipping_message":"Your Order is over R600","free_shipping_method_message":"your delivery is FREE","standard_shipping_message":"Your Order is","standard_shipping_method_message":"Delivery is Standard Delivery"},"shipping_fee_calculate":{"method_code":"freeshipping","carrier_code":"freeshipping","shipping_label":"Free","shipping_fee":"0"},"cart_order_limits":{"cart_qty_limit":"20","order_value_limit":"200000"},"items":[{"id":"1025881","prices":{"row_total_original":{"value":0},"row_total_including_tax":{"value":0},"total_item_discount":{"value":0},"price":{"value":0},"discounts":null},"product":{"items":[{"option_id":1106244,"title":"General","options":[{"id":2081340,"is_hidden_product":"1","label":"Bonus Video Ticket 1GB 3 Months","product":{"id":27026,"name":"Bonus Video Ticket 1GB 3 Months","sku":"VID10003749"}},{"id":2081343,"is_hidden_product":"1","label":"MyRed 2GB 150min Line Rental","product":{"id":11798,"name":"MyRed 2GB 150min Line Rental","sku":"VID10003600"}},{"id":2081346,"is_hidden_product":"1","label":"Reduced Subscription Discount Proration - New","product":{"id":14207,"name":"Reduced Subscription Discount Proration - New","sku":"VID10003207"}},{"id":2081349,"is_hidden_product":"0","label":"Promotional 20GB - 30 days","product":{"id":21473,"name":"Promotional 20GB - 30 days","sku":"VID10002758"}},{"id":2081352,"is_hidden_product":"1","label":"Next Day Delivery","product":{"id":11528,"name":"Next Day Delivery","sku":"102027255"}}]},{"option_id":1106247,"title":"Promo","options":[{"id":2081355,"is_hidden_product":"1","label":"MyRed 2GB 150min","product":{"id":13502,"name":"MyRed 2GB 150min","sku":"VID10003573"}}]},{"option_id":1106250,"title":"Smartphones","options":[{"id":2081358,"is_hidden_product":"0","label":"Vivo Y11 Blue","product":{"id":30434,"name":"Vivo Y11 Blue","sku":"104047377"}}]}],"options":[{"option_id":144550}],"name":"VIVO Y11 BLUE + 20GB DATA X 1 - (C) + VIDEO TICKET - 3 MONTHS - 1GB @ R389 Reduced Sub PM on Red 2GB 200min","id":264567,"sku":"DV1GD13880","categories":[{"id":209,"name":"Deals"},{"id":212,"name":"Phones & SIM"},{"id":221,"name":"Smartphones"}],"promotion_tag_label":"Red hot deal","low_stock_threshold":5,"quantity":0,"stock_status":"IN_STOCK","is_deal_product":1,"badges":16625,"promo_data":200,"minutes":419,"minutes_label":"419","airtime":0,"old_monthly_recurring":null,"sms":"2000","plan_name":16721,"plan_name_label":"Red","plan_type":16709,"componentid":"VID10002758,VID10003207,VID10003573,VID10003600,VID10003749,102027255,104047377","contract_sku":["DV1GD13880"],"plan_type_label":"Airtime","nightowl_units":"2GB","contract_type":16715,"contract_type_label":"Standard contract","payment_terms":"16697","payment_terms_label":"24","badges_label":"Device","promotion_tag":19247,"accessories":null,"accessories_label":null,"monthly_recurring":389,"primary_product_sku":"104047377","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/v/i/vivo-y11-104047377-front-huge_b6lzdjo7rqdlektt.png","primary_product_name":"Vivo Y11 Blue","stock_item":null,"__typename":"BundleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png","label":"VIVO Y11 BLUE + 20GB DATA X 1 - (C) + VIDEO TICKET - 3 MONTHS - 1GB @ R389 Reduced Sub PM on Red 2GB 200min"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png","label":"VIVO Y11 BLUE + 20GB DATA X 1 - (C) + VIDEO TICKET - 3 MONTHS - 1GB @ R389 Reduced Sub PM on Red 2GB 200min"},"crosssell_products":[]},"bundle_custom_options":[{"values":[{"value":"427199"}]}],"customizable_options":[{"label":"I would like to:","values":[{"value":"427199","label":"Get this deal on a new contract"}]}],"quantity":1},{"id":"1029163","prices":{"row_total_original":{"value":6899},"row_total_including_tax":{"value":5},"total_item_discount":{"value":0},"price":{"value":4.35},"discounts":null},"product":{"options":[{"option_id":18216}],"name":"HP 15 CeleronNotebooks","id":148983,"sku":"HP_15_Celeron_Notebooks","categories":[{"id":77,"name":"Tablets & Laptops"},{"id":80,"name":"Basic Laptops"}],"promotion_tag_label":null,"low_stock_threshold":5,"quantity":0,"stock_status":"IN_STOCK","is_deal_product":0,"badges":null,"promo_data":null,"minutes":null,"minutes_label":null,"airtime":null,"old_monthly_recurring":null,"sms":null,"plan_name":null,"plan_name_label":null,"plan_type":null,"componentid":null,"contract_sku":["HP_15_Celeron_Notebooks"],"plan_type_label":null,"nightowl_units":null,"contract_type":null,"contract_type_label":null,"payment_terms":null,"payment_terms_label":null,"badges_label":null,"promotion_tag":null,"accessories":null,"accessories_label":null,"monthly_recurring":null,"primary_product_sku":null,"primary_product_image":null,"primary_product_name":null,"stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":10000},"__typename":"ConfigurableProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/h/p/hp-2_fufbswu3xy1hrpjt.jpg?quality=80&fit=bounds&height=&width=","label":"HP 15 CeleronNotebooks"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/h/p/hp-2_fufbswu3xy1hrpjt.jpg?quality=80&fit=bounds&height=&width=","label":"HP 15 CeleronNotebooks"},"configurable_options":[{"id":1121,"attribute_id":"667","label":"Storage size","position":0,"use_default":false,"attribute_code":"internal_storage","values":[{"value_index":18095,"label":"500GB","swatch_data":null}],"product_id":149139},{"id":468,"attribute_id":"673","label":"Screen Size Pixels","position":0,"use_default":false,"attribute_code":"screen_size_pixels","values":[{"value_index":18056,"label":"15.6\'\'","swatch_data":null}],"product_id":149139}],"variants":[{"product":{"id":29606,"name":"HP 15 CELERON WITH WIN 10","sku":"102054091","promotion_tag_label":null,"stock_status":"IN_STOCK","stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":10000},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/4/6/465941.jpg?quality=80&fit=bounds&height=&width=","label":"HP 15 CELERON WITH WIN 10"},"price_range":{"minimum_price":{"regular_price":{"value":6899,"currency":"ZAR"},"final_price":{"value":5,"currency":"ZAR"},"discount":{"amount_off":6894,"percent_off":99.93}},"maximum_price":{"regular_price":{"value":6899,"currency":"ZAR"},"final_price":{"value":5,"currency":"ZAR"},"discount":{"amount_off":6894,"percent_off":99.93}}},"quantity":8909,"badges_label":null,"low_stock_threshold":5,"attribute_set_id":19},"attributes":[{"label":"500GB","code":"internal_storage","value_index":18095},{"label":"15.6\'\'","code":"screen_size_pixels","value_index":18056}]}],"crosssell_products":[]},"configurable_options":[{"id":667,"option_label":"Storage size","value_id":18095,"value_label":"500GB"},{"id":673,"option_label":"Screen Size Pixels","value_id":18056,"value_label":"15.6\'\'"}],"config_custom_options":[{"values":[{"value":"56856"}]}],"quantity":1},{"id":"1029268","prices":{"row_total_original":{"value":0},"row_total_including_tax":{"value":0},"total_item_discount":{"value":0},"price":{"value":0},"discounts":null},"product":{"items":[{"option_id":122888,"title":"General","options":[{"id":224249,"is_hidden_product":"1","label":"Handset Installment 15","product":{"id":22238,"name":"Handset Installment 15","sku":"VID10002750"}},{"id":224252,"is_hidden_product":"1","label":"Bonus 20GB Once Off 7 Days- Hyb","product":{"id":25550,"name":"Bonus 20GB Once Off 7 Days- Hyb","sku":"VID10003069"}},{"id":224255,"is_hidden_product":"0","label":"Bonus Video Ticket 5GB 3 Months","product":{"id":16820,"name":"Bonus Video Ticket 5GB 3 Months","sku":"VID10003761"}},{"id":224258,"is_hidden_product":"1","label":"MyRed 2GB 250min TopUp Line Rental","product":{"id":16856,"name":"MyRed 2GB 250min TopUp Line Rental","sku":"VID10003897"}}]},{"option_id":122891,"title":"Promo","options":[{"id":224261,"is_hidden_product":"0","label":"MyRed 2GB 250min TopUp","product":{"id":24464,"name":"MyRed 2GB 250min TopUp","sku":"VID10003863"}}]},{"option_id":122885,"title":"Smartphones","options":[{"id":224246,"is_hidden_product":"0","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","product":{"id":30182,"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","sku":"104048115"}}]}],"options":[{"option_id":288}],"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 20GB DATA X 7 DAYS - (H) + VIDEO TICKET - 3 MONTHS - 5GB @ R1519 PM (R960 Finance + R559 Sub on MyRed 2GB 250min TopUp","id":48161,"sku":"DV8DA2447","categories":[{"id":209,"name":"Deals"},{"id":212,"name":"Phones & SIM"},{"id":221,"name":"Smartphones"},{"id":308,"name":"Phones"},{"id":311,"name":"Smartphones"}],"promotion_tag_label":null,"low_stock_threshold":5,"quantity":0,"stock_status":"IN_STOCK","is_deal_product":1,"badges":16619,"promo_data":2000,"minutes":250,"minutes_label":"250","airtime":0,"old_monthly_recurring":null,"sms":"150","plan_name":16721,"plan_name_label":"Red","plan_type":16712,"componentid":"104048115,VID10002750,VID10003069,VID10003761,VID10003863,VID10003897","contract_sku":["DV8DA2447"],"plan_type_label":"Data only","nightowl_units":"2","contract_type":16718,"contract_type_label":"Top Up contract","payment_terms":"16697","payment_terms_label":"24","badges_label":"Black Friday","promotion_tag":null,"accessories":null,"accessories_label":null,"monthly_recurring":1519,"primary_product_sku":"104048115","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg","primary_product_name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","stock_item":null,"__typename":"BundleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 20GB DATA X 7 DAYS - (H) + VIDEO TICKET - 3 MONTHS - 5GB @ R1519 PM (R960 Finance + R559 Sub on MyRed 2GB 250min TopUp"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 20GB DATA X 7 DAYS - (H) + VIDEO TICKET - 3 MONTHS - 5GB @ R1519 PM (R960 Finance + R559 Sub on MyRed 2GB 250min TopUp"},"crosssell_products":[]},"bundle_custom_options":[{"values":[{"value":"747"}]}],"customizable_options":[{"label":"I would like to","values":[{"value":"747","label":"Get this deal on a new contract"}]}],"quantity":1}],"available_payment_methods":[{"code":"checkmo","title":"VFS"}],"selected_payment_method":{"code":"","title":""},"applied_coupons":null,"prices":{"discounts":null,"grand_total":{"value":5,"currency":"ZAR"},"subtotal_including_tax":{"value":5,"currency":"ZAR"},"subtotal_excluding_tax":{"value":4.35,"currency":"ZAR"},"subtotal_with_discount_excluding_tax":{"value":4.35,"currency":"ZAR"},"applied_taxes":[{"amount":{"value":0.65,"currency":"ZAR"},"label":"VAT (incl.):"}]},"total_quantity":3}}}');

/***/ }),

/***/ 59637:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"cart":{"email":null,"allow_place_order":1,"notification_data":{"is_pending_orders":0,"cancel_order_duration":0},"shippingMessageText":{"delivery_message":"We will deliver within 5 - 6 days","free_shipping_message":"Your Order is over R600","free_shipping_method_message":"Delivery is Free","standard_shipping_message":"Your Order is","standard_shipping_method_message":"Delivery is Standard Delivery"},"shipping_fee_calculate":{"method_code":"freeshipping","carrier_code":"freeshipping","shipping_label":"Free","shipping_fee":"0"},"cart_order_limits":{"cart_qty_limit":"20","order_value_limit":"200000"},"items":[{"id":"6070062","prices":{"row_total_original":{"value":5999},"row_total_including_tax":{"value":5999},"total_item_discount":{"value":0},"price":{"value":5216.52},"discounts":null},"product":{"options":[{"option_id":904050}],"name":"Samsung Galaxy A32 5G 128GB","id":571650,"sku":"samsung_galaxy_a32_5g","categories":[{"id":83,"name":"Phones & SIM"},{"id":143,"name":"Smartphones"}],"promotion_tag_label":"Online Exclusive","low_stock_threshold":1,"quantity":0,"stock_status":"IN_STOCK","is_deal_product":0,"badges":16562,"promo_data":null,"minutes":null,"minutes_label":null,"airtime":null,"old_monthly_recurring":null,"sms":null,"plan_name":null,"plan_name_label":null,"plan_type":null,"componentid":null,"contract_sku":["samsung_galaxy_a32_5g"],"plan_type_label":null,"nightowl_units":null,"nightowl_uom":null,"contract_type":null,"contract_type_label":null,"payment_terms":null,"payment_terms_label":null,"badges_label":"Online Exclusive","promotion_tag":16604,"accessories":null,"accessories_label":null,"monthly_recurring":null,"primary_product_sku":null,"primary_product_image":null,"primary_product_name":null,"stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":10000},"__typename":"ConfigurableProduct","image":{"url":"https://shop.vodacom.co.za/media/catalog/product/cache/38f1dc2852feafa5f3723df282debf5d/s/a/samsung_galaxy_a32_5g_-_main.jpg","label":"Samsung Galaxy A32 5G 128GB"},"small_image":{"url":"https://shop.vodacom.co.za/media/catalog/product/cache/38f1dc2852feafa5f3723df282debf5d/s/a/samsung_galaxy_a32_5g_-_main.jpg","label":"Samsung Galaxy A32 5G 128GB"},"configurable_options":[{"id":2507,"attribute_id":"278","label":"Colour","position":0,"use_default":false,"attribute_code":"color","values":[{"value_index":16319,"label":"Black","swatch_data":{"value":"#000000"}},{"value_index":16322,"label":"Blue","swatch_data":{"value":"#1260a0"}}],"product_id":920073},{"id":2510,"attribute_id":"707","label":"Storage size","position":0,"use_default":false,"attribute_code":"internal_storage","values":[{"value_index":20790,"label":"4GB RAM, 128GB ROM","swatch_data":null}],"product_id":920073}],"variants":[{"product":{"id":519627,"name":"Samsung Galaxy A32 5G 128GB Black","sku":"104053894","promotion_tag_label":null,"stock_status":"IN_STOCK","stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":10000},"small_image":{"url":"https://shop.vodacom.co.za/media/catalog/product/cache/38f1dc2852feafa5f3723df282debf5d/s/a/samsung_galaxy_a32_lte_-_main_2_2.jpg","label":"Samsung Galaxy A32 5G 128GB Black"},"price_range":{"minimum_price":{"regular_price":{"value":5999,"currency":"ZAR"},"final_price":{"value":5999,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":5999,"currency":"ZAR"},"final_price":{"value":5999,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"quantity":2010,"badges_label":null,"low_stock_threshold":1,"attribute_set_id":20},"attributes":[{"label":"Black","code":"color","value_index":16319},{"label":"4GB RAM, 128GB ROM","code":"internal_storage","value_index":20790}]},{"product":{"id":519624,"name":"Samsung Galaxy A32 5G 128GB Blue","sku":"104053893","promotion_tag_label":null,"stock_status":"IN_STOCK","stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":10000},"small_image":{"url":"https://shop.vodacom.co.za/media/catalog/product/cache/38f1dc2852feafa5f3723df282debf5d/s/a/samsung_galaxy_a32_lte_-_main_2_1.jpg","label":"Samsung Galaxy A32 5G 128GB Blue"},"price_range":{"minimum_price":{"regular_price":{"value":5999,"currency":"ZAR"},"final_price":{"value":5999,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":5999,"currency":"ZAR"},"final_price":{"value":5999,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"quantity":-89,"badges_label":null,"low_stock_threshold":1,"attribute_set_id":20},"attributes":[{"label":"Blue","code":"color","value_index":16322},{"label":"4GB RAM, 128GB ROM","code":"internal_storage","value_index":20790}]}],"crosssell_products":[]},"configurable_options":[{"id":278,"option_label":"Colour","value_id":16319,"value_label":"Black"},{"id":707,"option_label":"Storage size","value_id":20790,"value_label":"4GB RAM, 128GB ROM"}],"config_custom_options":[{"values":[{"value":"2990823"}]}],"quantity":1}],"available_payment_methods":[{"code":"checkmo","title":"Check / Money order"}],"selected_payment_method":{"code":"","title":""},"applied_coupons":null,"prices":{"discounts":null,"grand_total":{"value":5999,"currency":"ZAR"},"subtotal_including_tax":{"value":5999,"currency":"ZAR"},"subtotal_excluding_tax":{"value":5216.52,"currency":"ZAR"},"subtotal_with_discount_excluding_tax":{"value":5216.52,"currency":"ZAR"},"applied_taxes":[{"amount":{"value":782.48,"currency":"ZAR"},"label":"VAT (incl.):"}]},"total_quantity":1}}}');

/***/ }),

/***/ 5402:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"cart":{"email":"27823178744@mailinator.com","allow_place_order":1,"notification_data":{"is_pending_orders":1,"cancel_order_duration":24},"shippingMessageText":{"delivery_message":"Deliveries are made on weekdays between 08:00 and 17:00","free_shipping_message":"Your Order is over R600","free_shipping_method_message":"your delivery is FREE","standard_shipping_message":"Your Order is","standard_shipping_method_message":"Delivery is Standard Delivery"},"shipping_fee_calculate":{"method_code":"freeshipping","carrier_code":"freeshipping","shipping_label":"Free","shipping_fee":"0"},"cart_order_limits":{"cart_qty_limit":"20","order_value_limit":"200000"},"items":[{"id":"1046161","prices":{"row_total_original":{"value":0},"row_total_including_tax":{"value":0},"total_item_discount":{"value":0},"price":{"value":0},"discounts":null},"product":{"items":[{"option_id":123038,"title":"Smartphones","options":[{"id":224552,"is_hidden_product":"0","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","product":{"id":30182,"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","sku":"104048115"}}]},{"option_id":123041,"title":"Tablet","options":[{"id":224555,"is_hidden_product":"0","label":"SAMSUNG GALAXY TAB A 2019 10.1","product":{"id":21416,"name":"SAMSUNG GALAXY TAB A 2019 10.1","sku":"108017080"}}]},{"option_id":123044,"title":"Promo","options":[{"id":224558,"is_hidden_product":"0","label":"RED SELECT TOP UP+","product":{"id":17102,"name":"RED SELECT TOP UP+","sku":"VID10002061"}}]},{"option_id":123035,"title":"General","options":[{"id":224540,"is_hidden_product":"1","label":"Next Day Delivery","product":{"id":11528,"name":"Next Day Delivery","sku":"102027255"}},{"id":224543,"is_hidden_product":"1","label":"Promotional My Gig 2 - 24 Month Hybrid","product":{"id":18704,"name":"Promotional My Gig 2 - 24 Month Hybrid","sku":"VID10001942"}},{"id":224546,"is_hidden_product":"1","label":"RED SELECT TOP UP+ Line Rental","product":{"id":25049,"name":"RED SELECT TOP UP+ Line Rental","sku":"VID10002083"}},{"id":224549,"is_hidden_product":"1","label":"Handset Installment 15","product":{"id":22238,"name":"Handset Installment 15","sku":"VID10002750"}}]}],"options":[{"option_id":132144}],"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1499 PM (R350 Finance + R1149 Sub on Red Select Top Up + (36 Months) (PROMOGIG2)","id":48209,"sku":"V15DE11247","categories":[{"id":209,"name":"Deals"},{"id":212,"name":"Phones & SIM"},{"id":221,"name":"Smartphones"}],"promotion_tag_label":"For today only","low_stock_threshold":5,"quantity":0,"stock_status":"IN_STOCK","is_deal_product":1,"badges":16619,"promo_data":4000,"minutes":900,"minutes_label":"900","airtime":0,"old_monthly_recurring":"4000","sms":"Unlimited","plan_name":16721,"plan_name_label":"Red","plan_type":16706,"componentid":"102027255,104048115,108017080,VID10001942,VID10002061,VID10002083,VID10002750","contract_sku":["V15DE11247","DV8NR13073"],"plan_type_label":"Data & voice minutes","nightowl_units":"12","nightowl_uom":"GB","contract_type":16715,"contract_type_label":"Standard contract","payment_terms":"16703","payment_terms_label":"36","badges_label":"Black Friday","promotion_tag":16670,"accessories":null,"accessories_label":null,"monthly_recurring":1499,"primary_product_sku":"104048115","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg","primary_product_name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","stock_item":null,"__typename":"BundleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1499 PM (R350 Finance + R1149 Sub on Red Select Top Up + (36 Months) (PROMOGIG2)"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1499 PM (R350 Finance + R1149 Sub on Red Select Top Up + (36 Months) (PROMOGIG2)"},"crosssell_products":[]},"bundle_custom_options":[{"values":[{"value":"332492"}]}],"customizable_options":[{"label":"I would like to","values":[{"value":"332492","label":"Get this deal on a new contract"}]}],"quantity":1},{"id":"1056733","simple_custom_options":[{"values":[{"value":"1887"}]}],"prices":{"row_total_original":{"value":12399},"row_total_including_tax":{"value":12399},"total_item_discount":{"value":0},"price":{"value":10781.74},"discounts":null},"product":{"options":[{"option_id":678}],"name":"HP I5","id":28484,"sku":"108015831","categories":[{"id":77,"name":"Tablets & Laptops"},{"id":83,"name":"Work Laptops"}],"promotion_tag_label":null,"low_stock_threshold":5,"quantity":100,"stock_status":"IN_STOCK","is_deal_product":0,"badges":null,"promo_data":null,"minutes":null,"minutes_label":null,"airtime":null,"old_monthly_recurring":null,"sms":null,"plan_name":null,"plan_name_label":null,"plan_type":null,"componentid":null,"contract_sku":["108015831"],"plan_type_label":null,"nightowl_units":null,"nightowl_uom":null,"contract_type":null,"contract_type_label":null,"payment_terms":null,"payment_terms_label":null,"badges_label":null,"promotion_tag":null,"accessories":null,"accessories_label":null,"monthly_recurring":null,"primary_product_sku":null,"primary_product_image":null,"primary_product_name":null,"stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":10000},"__typename":"SimpleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/4/6/465953.jpg?quality=80&fit=bounds&height=&width=","label":"HP I5"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/4/6/465953.jpg?quality=80&fit=bounds&height=&width=","label":"HP I5"},"crosssell_products":[]},"quantity":1}],"available_payment_methods":[{"code":"checkmo","title":"VFS"}],"selected_payment_method":{"code":"","title":""},"applied_coupons":null,"prices":{"discounts":null,"grand_total":{"value":12399,"currency":"ZAR"},"subtotal_including_tax":{"value":12399,"currency":"ZAR"},"subtotal_excluding_tax":{"value":10781.74,"currency":"ZAR"},"subtotal_with_discount_excluding_tax":{"value":10781.74,"currency":"ZAR"},"applied_taxes":[{"amount":{"value":1617.26,"currency":"ZAR"},"label":"VAT (incl.):"}]},"total_quantity":2}}}');

/***/ }),

/***/ 42816:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"errors":[{"message":"There are no source items with the in stock status","extensions":{"category":"graphql-input"},"locations":[{"line":1,"column":426}],"path":["cart","items",0]},{"message":"Some of the products are out of stock.","extensions":{"category":"graphql-input"},"locations":[{"line":1,"column":426}],"path":["cart","items",1]}],"data":{"cart":{"email":null,"allow_place_order":1,"notification_data":{"is_pending_orders":0,"cancel_order_duration":0},"shippingMessageText":{"delivery_message":"Deliveries are made on weekdays between 08:00 and 17:00","free_shipping_message":"Your Order is over R600","free_shipping_method_message":"your delivery is FREE","standard_shipping_message":"Your Order is","standard_shipping_method_message":"Delivery is Standard Delivery"},"shipping_fee_calculate":{"method_code":"freeshipping","carrier_code":"freeshipping","shipping_label":"Free","shipping_fee":"0"},"cart_order_limits":{"cart_qty_limit":"20","order_value_limit":"200000"},"items":[null,null,{"id":"1311427","monthly_recurring":null,"parent_product_sku":"","prices":{"row_total_original":{"value":14799},"row_total_including_tax":{"value":14799},"total_item_discount":{"value":0},"price":{"value":12868.7},"discounts":null},"product":{"options":[{"option_id":8377}],"name":"vivo X50","id":139543,"sku":"vivo_x50","categories":[{"id":26,"name":"Phones & SIM","level":2,"category_url":null,"image":null,"description":null},{"id":29,"name":"Smartphones","level":3,"category_url":null,"image":null,"description":null}],"promotion_tag_label":null,"low_stock_threshold":5,"quantity":0,"stock_status":"IN_STOCK","is_deal_product":0,"description":{"html":"vivo X50"},"badges":null,"promo_data":null,"minutes":null,"minutes_label":null,"airtime":null,"old_monthly_recurring":null,"sms":null,"plan_name":null,"plan_name_label":null,"plan_type":null,"componentid":null,"contract_sku":["vivo_x50"],"plan_type_label":null,"nightowl_units":null,"nightowl_uom":null,"contract_type":null,"contract_type_label":null,"payment_terms":null,"payment_terms_label":null,"badges_label":null,"promotion_tag":null,"promotion_link":null,"accessories":null,"accessories_label":null,"monthly_recurring":null,"primary_product_sku":null,"primary_product_image":null,"primary_product_name":null,"stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":10000},"__typename":"ConfigurableProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/v/i/vivo-x50-104049899-front-huge_m8pfwahq3qgd6qji_b6aijk7fyub8tdzu.png?quality=80&fit=bounds&height=&width=","label":"vivo X50"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png","label":"vivo X50"},"configurable_options":[{"id":741,"attribute_id":"277","label":"Colour","position":0,"use_default":false,"attribute_code":"color","values":[{"value_index":17125,"label":"Light Blue","swatch_data":{"value":"#0c4d4e"}},{"value_index":16321,"label":"Black","swatch_data":{"value":"#000000"}}],"product_id":139588},{"id":995,"attribute_id":"667","label":"Storage size","position":0,"use_default":false,"attribute_code":"internal_storage","values":[{"value_index":19082,"label":"1GB RAM; 8GB ROM","swatch_data":null},{"value_index":16411,"label":"128GB","swatch_data":null}],"product_id":139588}],"variants":[{"product":{"id":30938,"name":"VIVO X50 5G FROST BLUE","sku":"104049894","promotion_tag_label":null,"stock_status":"OUT_OF_STOCK","stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":10000},"attribute_set_id":16,"weight":174.5,"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/v/i/vivo-x50-104049894-front-huge_ujxg56wiq3ql9kwy.png?quality=80&fit=bounds&height=&width=","label":"VIVO X50 5G FROST BLUE"},"price_range":{"minimum_price":{"regular_price":{"value":14799,"currency":"ZAR"},"final_price":{"value":14799,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":14799,"currency":"ZAR"},"final_price":{"value":14799,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"quantity":0,"badges_label":null,"low_stock_threshold":5},"attributes":[{"label":"Light Blue","code":"color","value_index":17125},{"label":"1GB RAM; 8GB ROM","code":"internal_storage","value_index":19082}]},{"product":{"id":31043,"name":"VIVO X50 5G GLAZE BLACK","sku":"104049899","promotion_tag_label":null,"stock_status":"IN_STOCK","stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":10000},"attribute_set_id":16,"weight":174.5,"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/v/i/vivo-x50-104049899-front-huge_orsblqqcwux5abvz.png?quality=80&fit=bounds&height=&width=","label":"VIVO X50 5G GLAZE BLACK"},"price_range":{"minimum_price":{"regular_price":{"value":100,"currency":"ZAR"},"final_price":{"value":100,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":100,"currency":"ZAR"},"final_price":{"value":100,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"quantity":91,"badges_label":null,"low_stock_threshold":5},"attributes":[{"label":"Black","code":"color","value_index":16321},{"label":"128GB","code":"internal_storage","value_index":16411}]}],"crosssell_products":[]},"configurable_options":[{"id":277,"option_label":"Colour","value_id":17125,"value_label":"Light Blue"},{"id":667,"option_label":"Storage size","value_id":19082,"value_label":"1GB RAM; 8GB ROM"}],"config_custom_options":[{"values":[{"value":"24856"}]}],"quantity":1}],"available_payment_methods":[{"code":"checkmo","title":"VFS"}],"selected_payment_method":{"code":"","title":""},"applied_coupons":null,"prices":{"discounts":null,"grand_total":{"value":14799,"currency":"ZAR"},"subtotal_including_tax":{"value":14799,"currency":"ZAR"},"subtotal_excluding_tax":{"value":12868.7,"currency":"ZAR"},"subtotal_with_discount_excluding_tax":{"value":12868.7,"currency":"ZAR"},"applied_taxes":[{"amount":{"value":1930.3,"currency":"ZAR"},"label":"VAT (incl.):"}]},"total_quantity":1}}}');

/***/ }),

/***/ 8143:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"errors":[{"message":"Some of the products are out of stock.","extensions":{"category":"graphql-input"},"locations":[{"line":1,"column":426}],"path":["cart","items",0]}],"data":{"cart":{"email":null,"allow_place_order":1,"notification_data":{"is_pending_orders":0,"cancel_order_duration":0},"shippingMessageText":{"delivery_message":"Deliveries are made on weekdays between 08:00 and 17:00","free_shipping_message":"Your Order is over R600","free_shipping_method_message":"your delivery is FREE","standard_shipping_message":"Your Order is","standard_shipping_method_message":"Delivery is Standard Delivery"},"shipping_fee_calculate":{"method_code":"bestway","carrier_code":"tablerate","shipping_label":"Table Rate","shipping_fee":"5"},"cart_order_limits":{"cart_qty_limit":"20","order_value_limit":"200000"},"items":[null,{"id":"1338577","monthly_recurring":null,"parent_product_sku":"","simple_custom_options":[{"values":[{"value":"329171"}]}],"prices":{"row_total_original":{"value":3},"row_total_including_tax":{"value":3},"total_item_discount":{"value":0},"price":{"value":2.61},"discounts":null},"product":{"options":[{"option_id":131309}],"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","id":30182,"sku":"104048115","categories":[{"id":26,"name":"Phones & SIM","level":2,"category_url":null,"image":null,"description":null},{"id":29,"name":"Smartphones","level":3,"category_url":null,"image":null,"description":null},{"id":181,"name":"Phones","level":2,"category_url":null,"image":null,"description":null},{"id":184,"name":"Smartphones","level":3,"category_url":null,"image":null,"description":null}],"promotion_tag_label":"Pre Order","low_stock_threshold":5,"quantity":0,"stock_status":"OUT_OF_STOCK","is_deal_product":0,"description":{"html":"Samsung Galaxy S20 Ultra 128GB Cosmic Gray"},"badges":16601,"promo_data":null,"minutes":null,"minutes_label":null,"airtime":null,"old_monthly_recurring":null,"sms":null,"plan_name":null,"plan_name_label":null,"plan_type":null,"componentid":null,"contract_sku":["104048115"],"plan_type_label":null,"nightowl_units":null,"nightowl_uom":null,"contract_type":null,"contract_type_label":null,"payment_terms":null,"payment_terms_label":null,"badges_label":"Pre Order","promotion_tag":19261,"promotion_link":"https://www.samsung.com","accessories":null,"accessories_label":null,"monthly_recurring":null,"primary_product_sku":null,"primary_product_image":null,"primary_product_name":null,"stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":10000},"__typename":"SimpleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg?quality=80&fit=bounds&height=&width=","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg?quality=80&fit=bounds&height=&width=","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY"},"crosssell_products":[{"name":"Samsung Galaxy A11 32GB","sku":"samsung_galaxy_a11_32gb","badges":16619,"badges_label":"Black Friday","quantity":0,"stock_status":"IN_STOCK","__typename":"ConfigurableProduct","low_stock_threshold":5,"display_low_stock_badge":0,"price_range":{"minimum_price":{"regular_price":{"value":2300,"currency":"ZAR"},"final_price":{"value":4,"currency":"ZAR"},"discount":{"amount_off":2296,"percent_off":99.83}},"maximum_price":{"regular_price":{"value":2300,"currency":"ZAR"},"final_price":{"value":2300,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/s/a/samsung-galaxy-a11-32gb-104049391-front-huge_hym36bsfzelow0ch.png?quality=80&fit=bounds&height=&width=","label":"Samsung Galaxy A11 32GB"},"variants":[{"product":{"id":28715,"name":"SAMSUNG GALAXY A11 32GB BLUE","sku":"104049392","stock_status":"OUT_OF_STOCK","quantity":0,"__typename":"SimpleProduct","price_range":{"minimum_price":{"regular_price":{"value":4,"currency":"ZAR"},"final_price":{"value":4,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":4,"currency":"ZAR"},"final_price":{"value":4,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}}},{"product":{"id":28712,"name":"SAMSUNG GALAXY A11 32GB BLACK","sku":"104049391","stock_status":"IN_STOCK","quantity":35,"__typename":"SimpleProduct","price_range":{"minimum_price":{"regular_price":{"value":2300,"currency":"ZAR"},"final_price":{"value":2300,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":2300,"currency":"ZAR"},"final_price":{"value":2300,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}}}]}]},"quantity":1}],"available_payment_methods":[{"code":"checkmo","title":"VFS"}],"selected_payment_method":{"code":"","title":""},"applied_coupons":null,"prices":{"discounts":null,"grand_total":{"value":3,"currency":"ZAR"},"subtotal_including_tax":{"value":3,"currency":"ZAR"},"subtotal_excluding_tax":{"value":2.61,"currency":"ZAR"},"subtotal_with_discount_excluding_tax":{"value":2.61,"currency":"ZAR"},"applied_taxes":[{"amount":{"value":0.39,"currency":"ZAR"},"label":"VAT (incl.):"}]},"total_quantity":1}}}');

/***/ }),

/***/ 58968:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"cart":{"email":"27823178744@mailinator.com","allow_place_order":1,"notification_data":{"is_pending_orders":1,"cancel_order_duration":24},"shippingMessageText":{"delivery_message":"Deliveries are made on weekdays between 08:00 and 17:00","free_shipping_message":"Your Order is over R600","free_shipping_method_message":"your delivery is FREE","standard_shipping_message":"Your Order is","standard_shipping_method_message":"Delivery is Standard Delivery"},"shipping_fee_calculate":{"method_code":"freeshipping","carrier_code":"freeshipping","shipping_label":"Free","shipping_fee":"0"},"cart_order_limits":{"cart_qty_limit":"20","order_value_limit":"200000"},"items":[{"id":"1046161","prices":{"row_total_original":{"value":0},"row_total_including_tax":{"value":0},"total_item_discount":{"value":0},"price":{"value":0},"discounts":null},"product":{"items":[{"option_id":123038,"title":"Smartphones","options":[{"id":224552,"is_hidden_product":"0","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","product":{"id":30182,"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","sku":"104048115"}}]},{"option_id":123041,"title":"Tablet","options":[{"id":224555,"is_hidden_product":"0","label":"SAMSUNG GALAXY TAB A 2019 10.1","product":{"id":21416,"name":"SAMSUNG GALAXY TAB A 2019 10.1","sku":"108017080"}}]},{"option_id":123044,"title":"Promo","options":[{"id":224558,"is_hidden_product":"0","label":"RED SELECT TOP UP+","product":{"id":17102,"name":"RED SELECT TOP UP+","sku":"VID10002061"}}]},{"option_id":123035,"title":"General","options":[{"id":224540,"is_hidden_product":"1","label":"Next Day Delivery","product":{"id":11528,"name":"Next Day Delivery","sku":"102027255"}},{"id":224543,"is_hidden_product":"1","label":"Promotional My Gig 2 - 24 Month Hybrid","product":{"id":18704,"name":"Promotional My Gig 2 - 24 Month Hybrid","sku":"VID10001942"}},{"id":224546,"is_hidden_product":"1","label":"RED SELECT TOP UP+ Line Rental","product":{"id":25049,"name":"RED SELECT TOP UP+ Line Rental","sku":"VID10002083"}},{"id":224549,"is_hidden_product":"1","label":"Handset Installment 15","product":{"id":22238,"name":"Handset Installment 15","sku":"VID10002750"}}]}],"options":[{"option_id":132144}],"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1499 PM (R350 Finance + R1149 Sub on Red Select Top Up + (36 Months) (PROMOGIG2)","id":48209,"sku":"V15DE11247","categories":[{"id":209,"name":"Deals"},{"id":212,"name":"Phones & SIM"},{"id":221,"name":"Smartphones"}],"promotion_tag_label":"For today only","low_stock_threshold":5,"quantity":0,"stock_status":"IN_STOCK","is_deal_product":1,"badges":16619,"promo_data":4000,"minutes":900,"minutes_label":"900","airtime":0,"old_monthly_recurring":"4000","sms":"Unlimited","plan_name":16721,"plan_name_label":"Red","plan_type":16706,"componentid":"102027255,104048115,108017080,VID10001942,VID10002061,VID10002083,VID10002750","contract_sku":["V15DE11247","DV8NR13073"],"plan_type_label":"Data & voice minutes","nightowl_units":"12","nightowl_uom":"GB","contract_type":16715,"contract_type_label":"Standard contract","payment_terms":"16703","payment_terms_label":"36","badges_label":"Black Friday","promotion_tag":16670,"accessories":null,"accessories_label":null,"monthly_recurring":1499,"primary_product_sku":"104048115","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg","primary_product_name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","stock_item":null,"__typename":"BundleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1499 PM (R350 Finance + R1149 Sub on Red Select Top Up + (36 Months) (PROMOGIG2)"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1499 PM (R350 Finance + R1149 Sub on Red Select Top Up + (36 Months) (PROMOGIG2)"},"crosssell_products":[]},"bundle_custom_options":[{"values":[{"value":"332492"}]}],"customizable_options":[{"label":"I would like to","values":[{"value":"332492","label":"Get this deal on a new contract"}]}],"quantity":1},{"id":"1061437","simple_custom_options":[{"values":[{"value":"13339"}]}],"prices":{"row_total_original":{"value":0},"row_total_including_tax":{"value":0},"total_item_discount":{"value":0},"price":{"value":0},"discounts":null},"product":{"options":[{"option_id":4496},{"option_id":18720}],"name":"Personal Alarm","id":28154,"sku":"102063462","categories":[{"id":62,"name":"Smart Home"},{"id":65,"name":"Smart Devices"}],"promotion_tag_label":null,"low_stock_threshold":5,"quantity":0,"stock_status":"OUT_OF_STOCK","is_deal_product":0,"badges":16601,"promo_data":null,"minutes":null,"minutes_label":null,"airtime":null,"old_monthly_recurring":null,"sms":null,"plan_name":null,"plan_name_label":null,"plan_type":null,"componentid":null,"contract_sku":["102063462"],"plan_type_label":null,"nightowl_units":null,"nightowl_uom":null,"contract_type":null,"contract_type_label":null,"payment_terms":null,"payment_terms_label":null,"badges_label":"Pre Order","promotion_tag":null,"accessories":null,"accessories_label":null,"monthly_recurring":null,"primary_product_sku":null,"primary_product_image":null,"primary_product_name":null,"stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":10000},"__typename":"SimpleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/i/m/image_12.png?quality=80&fit=bounds&height=&width=","label":"Personal Alarm"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/i/m/image_12.png?quality=80&fit=bounds&height=&width=","label":"Personal Alarm"},"crosssell_products":[]},"quantity":1}],"available_payment_methods":[{"code":"checkmo","title":"VFS"}],"selected_payment_method":{"code":"","title":""},"applied_coupons":null,"prices":{"discounts":null,"grand_total":{"value":12399,"currency":"ZAR"},"subtotal_including_tax":{"value":12399,"currency":"ZAR"},"subtotal_excluding_tax":{"value":10781.74,"currency":"ZAR"},"subtotal_with_discount_excluding_tax":{"value":10781.74,"currency":"ZAR"},"applied_taxes":[{"amount":{"value":1617.26,"currency":"ZAR"},"label":"VAT (incl.):"}]},"total_quantity":3}}}');

/***/ }),

/***/ 68181:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"cart":{"email":null,"allow_place_order":1,"shippingMessageText":{"delivery_message":"Deliveries are made on weekdays between 08:00 and 17:00","free_shipping_message":"Your Order is over R600","free_shipping_method_message":"your delivery is FREE","standard_shipping_message":"Your Order is","standard_shipping_method_message":"Delivery is Standard Delivery"},"cart_order_limits":{"cart_qty_limit":"20","order_value_limit":"200000"},"shipping_fee_calculate":{"method_code":"freeshipping","carrier_code":"freeshipping","shipping_label":"Free","shipping_fee":"0"},"billing_address":null,"shipping_addresses":[],"items":[{"id":"1199827","monthly_recurring":null,"parent_product_sku":"","prices":{"row_total":{"value":12868.7},"row_total_original":{"value":14799},"row_total_including_tax":{"value":14799},"total_item_discount":{"value":0},"price":{"value":12868.7},"discounts":[{"label":"Discount","amount":{"value":2.5}}]},"configurable_options":[{"id":277,"option_label":"Colour","value_id":17125,"value_label":"Light Blue"},{"id":667,"option_label":"Storage size","value_id":19082,"value_label":"1GB RAM; 8GB ROM"}],"product":{"name":"vivo X50","sku":"vivo_x50","promotion_link":null,"stock_status":"IN_STOCK","is_deal_product":0,"description":{"html":"vivo X50"},"badges":null,"promo_data":null,"minutes":null,"minutes_label":null,"airtime":null,"sms":null,"plan_name":null,"plan_name_label":null,"plan_type":null,"componentid":null,"contract_sku":["vivo_x50"],"plan_type_label":null,"contract_type":null,"contract_type_label":null,"payment_terms":null,"payment_terms_label":null,"badges_label":null,"promotion_tag":null,"promotion_tag_label":null,"accessories":null,"accessories_label":null,"monthly_recurring":null,"primary_product_sku":null,"categories":[{"id":26,"name":"Phones & SIM","level":2,"category_url":null,"image":"https://shopqa.vodacom.co.za/media/catalog/category/Phone_SIM.png","description":null},{"id":29,"name":"Smartphones","level":3,"category_url":null,"image":null,"description":null}],"primary_product_image":null,"primary_product_name":null,"stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":10000},"price_range":{"minimum_price":{"regular_price":{"value":100,"currency":"ZAR"}},"maximum_price":{"regular_price":{"value":14799,"currency":"ZAR"}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/v/i/vivo-x50-104049899-front-huge_m8pfwahq3qgd6qji_b6aijk7fyub8tdzu.png?quality=80&fit=bounds&height=&width=","label":"vivo X50"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png","label":"vivo X50"},"configurable_options":[{"id":741,"label":"Colour","position":0,"use_default":false,"attribute_code":"color","attribute_id":"277","values":[{"value_index":17125,"label":"Light Blue","swatch_data":{"value":"#0c4d4e"}},{"value_index":16321,"label":"Black","swatch_data":{"value":"#000000"}}],"product_id":139588},{"id":995,"label":"Storage size","position":0,"use_default":false,"attribute_code":"internal_storage","attribute_id":"667","values":[{"value_index":19082,"label":"1GB RAM; 8GB ROM","swatch_data":null},{"value_index":16411,"label":"128GB","swatch_data":null}],"product_id":139588}],"variants":[{"product":{"id":30938,"name":"VIVO X50 5G FROST BLUE","sku":"104049894","stock_status":"IN_STOCK","stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":10000},"attribute_set_id":16,"weight":174.5,"price_range":{"minimum_price":{"regular_price":{"value":14799,"currency":"ZAR"}}}},"attributes":[{"label":"Light Blue","code":"color","value_index":17125},{"label":"1GB RAM; 8GB ROM","code":"internal_storage","value_index":19082}]},{"product":{"id":31043,"name":"VIVO X50 5G GLAZE BLACK","sku":"104049899","stock_status":"IN_STOCK","stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":10000},"attribute_set_id":16,"weight":174.5,"price_range":{"minimum_price":{"regular_price":{"value":100,"currency":"ZAR"}}}},"attributes":[{"label":"Black","code":"color","value_index":16321},{"label":"128GB","code":"internal_storage","value_index":16411}]}],"crosssell_products":[]},"quantity":1},{"id":"1199881","monthly_recurring":1829,"parent_product_sku":"","prices":{"row_total":{"value":0},"row_total_original":{"value":0},"row_total_including_tax":{"value":0},"total_item_discount":{"value":0},"price":{"value":0},"discounts":null},"customizable_options":[{"label":"I would like to:","values":[{"value":"11352"}]}],"__typename":"BundleCartItem","bundle_options":[{"id":123114,"label":"Promo","type":"multi","values":[{"id":224682,"label":"RED VIP 25GB Top Up Unlimited","price":0,"quantity":1}]},{"id":123111,"label":"General","type":"multi","values":[{"id":224679,"label":"Vodacom SIM card","price":0,"quantity":1},{"id":1067949,"label":"Promotional 20GB - 30 days","price":0,"quantity":1}]}],"product":{"name":" MyRed 25GB VIP Unlimited TopUp sim only","sku":"DV20K28606-1_sim","promotion_link":"https://www.samsung.com","stock_status":"IN_STOCK","is_deal_product":1,"description":{"html":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 20GB DATA X 1 - (H) + VIDEO TICKET - 3 MONTHS - 10GB @ R2619 PM (R790 Finance + R1829 Sub on MyRed 25GB VIP Unlimited TopUp"},"badges":null,"promo_data":25000,"minutes":99999,"minutes_label":"Unlimited","airtime":0,"sms":"Unlimited","plan_name":null,"plan_name_label":null,"plan_type":null,"componentid":"104048115,VID10002750,VID10002759,VID10003765,VID10003875,VID10003909","contract_sku":["DV20K28606-1_sim","DV20K28607_sim"],"plan_type_label":null,"contract_type":null,"contract_type_label":null,"payment_terms":"16703","payment_terms_label":"36","badges_label":null,"promotion_tag":16679,"promotion_tag_label":"Sim only deals","accessories":null,"accessories_label":null,"monthly_recurring":1829,"primary_product_sku":"VID10003875","categories":[{"id":209,"name":"Deals","level":2,"category_url":null,"image":"https://shopqa.vodacom.co.za/media/catalog/category/Phone_SIM_white_2_3.png","description":null},{"id":212,"name":"Phones & SIM","level":3,"category_url":null,"image":"https://shopqa.vodacom.co.za/media/catalog/category/Phone_SIM_1.png","description":null},{"id":224,"name":"SIM","level":4,"category_url":null,"image":null,"description":null}],"primary_product_image":null,"primary_product_name":"RED VIP 25GB Top Up Unlimited","stock_item":null,"price_range":{"minimum_price":{"regular_price":{"value":0,"currency":"ZAR"}},"maximum_price":{"regular_price":{"value":0,"currency":"ZAR"}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png","label":" MyRed 25GB VIP Unlimited TopUp sim only"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png","label":" MyRed 25GB VIP Unlimited TopUp sim only"},"dynamic_sku":true,"dynamic_price":false,"__typename":"BundleProduct","items":[{"option_id":123114,"title":"Promo","required":true,"type":"multi","position":1,"sku":"DV20K28606-1_sim","options":[{"id":224682,"quantity":1,"position":0,"is_default":true,"price":0.0001,"label":"RED VIP 25GB Top Up Unlimited","product":{"id":26042,"name":"RED VIP 25GB Top Up Unlimited","sku":"VID10003875","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png","label":"RED VIP 25GB Top Up Unlimited"},"__typename":"SimpleProduct"}}]},{"option_id":123111,"title":"General","required":true,"type":"multi","position":2,"sku":"DV20K28606-1_sim","options":[{"id":224679,"quantity":1,"position":0,"is_default":true,"price":0.0001,"label":"Vodacom SIM card","product":{"id":19580,"name":"Vodacom SIM card","sku":"103004940","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/d/o/download_2_.jpg?quality=80&fit=bounds&height=&width=","label":"Vodacom SIM card"},"__typename":"SimpleProduct"}},{"id":1067949,"quantity":1,"position":1,"is_default":true,"price":0.0001,"label":"Promotional 20GB - 30 days","product":{"id":21473,"name":"Promotional 20GB - 30 days","sku":"VID10002758","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/w/i/wifi.jpg?quality=80&fit=bounds&height=&width=","label":"Promotional 20GB - 30 days"},"__typename":"SimpleProduct"}}]}],"crosssell_products":[]},"quantity":1}],"available_payment_methods":[{"code":"checkmo","title":"VFS"}],"selected_payment_method":{"code":"","title":""},"applied_coupons":null,"prices":{"discounts":[{"amount":{"value":2.5},"label":"Discount"}],"grand_total":{"value":14796.5,"currency":"ZAR"},"subtotal_including_tax":{"value":14799,"currency":"ZAR"},"subtotal_excluding_tax":{"value":12868.7,"currency":"ZAR"},"subtotal_with_discount_excluding_tax":{"value":12866.2,"currency":"ZAR"},"applied_taxes":[{"amount":{"value":1929.98,"currency":"ZAR"},"label":"VAT (incl.):"}]}}}}');

/***/ }),

/***/ 36189:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"cart":{"email":"27630187850@mailinator.com","allow_place_order":1,"notification_data":{"is_pending_orders":1,"cancel_order_duration":24},"shippingMessageText":{"delivery_message":"Deliveries are made on weekdays between 08:00 and 17:00","free_shipping_message":"Your Order is over R600","free_shipping_method_message":"your delivery is FREE","standard_shipping_message":"Your Order is","standard_shipping_method_message":"Delivery is Standard Delivery"},"shipping_fee_calculate":{"method_code":"freeshipping","carrier_code":"freeshipping","shipping_label":"Free","shipping_fee":"0"},"cart_order_limits":{"cart_qty_limit":"20","order_value_limit":"200000"},"items":[{"id":"1065064","prices":{"row_total_original":{"value":0},"row_total_including_tax":{"value":0},"total_item_discount":{"value":0},"price":{"value":0},"discounts":null},"product":{"items":[{"option_id":123080,"title":"Smartphones","options":[{"id":224630,"is_hidden_product":"0","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","product":{"id":30182,"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","sku":"104048115"}}]},{"option_id":123083,"title":"Tablet","options":[{"id":224633,"is_hidden_product":"0","label":"SAMSUNG GALAXY TAB A 2019 10.1","product":{"id":21416,"name":"SAMSUNG GALAXY TAB A 2019 10.1","sku":"108017080"}}]},{"option_id":123086,"title":"Promo","options":[{"id":224636,"is_hidden_product":"0","label":"RED CLASSIC +","product":{"id":17105,"name":"RED CLASSIC +","sku":"VID10002062"}}]},{"option_id":123077,"title":"General","options":[{"id":224618,"is_hidden_product":"1","label":"Next Day Delivery","product":{"id":11528,"name":"Next Day Delivery","sku":"102027255"}},{"id":224621,"is_hidden_product":"1","label":"Promotional My Gig 5 - 24 Month Post","product":{"id":18698,"name":"Promotional My Gig 5 - 24 Month Post","sku":"VID10001940"}},{"id":224624,"is_hidden_product":"1","label":"RED CLASSIC + Line Rental","product":{"id":25052,"name":"RED CLASSIC + Line Rental","sku":"VID10002084"}},{"id":224627,"is_hidden_product":"1","label":"Handset Installment 15","product":{"id":22238,"name":"Handset Installment 15","sku":"VID10002750"}}]}],"options":[{"option_id":182}],"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 5GB DATA X 24 - (C) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1649 PM (R290 Finance + R1359 Sub on Red Classic + (36 Months) (PROMOGIG2)","id":48221,"sku":"DV9NN15879","categories":[{"id":209,"name":"Deals"},{"id":212,"name":"Phones & SIM"},{"id":221,"name":"Smartphones"},{"id":227,"name":"Tablets & Laptops"},{"id":239,"name":"Premium Laptops"}],"promotion_tag_label":null,"low_stock_threshold":5,"quantity":0,"stock_status":"IN_STOCK","is_deal_product":1,"badges":16619,"promo_data":4000,"minutes":1200,"minutes_label":"1200","airtime":0,"old_monthly_recurring":null,"sms":"Unlimited","plan_name":16766,"plan_name_label":"Top Up","plan_type":16706,"componentid":"102027255,104048115,108017080,VID10001940,VID10002062,VID10002084,VID10002750","contract_sku":["DV9NN15879","DV8DA7211"],"plan_type_label":"Data & voice minutes","nightowl_units":"20","nightowl_uom":"GB","contract_type":16718,"contract_type_label":"Top Up contract","payment_terms":"16703","payment_terms_label":"36","badges_label":"Black Friday","promotion_tag":null,"accessories":null,"accessories_label":null,"monthly_recurring":1649,"primary_product_sku":"108017080","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/4/6/464598.jpg","primary_product_name":"SAMSUNG GALAXY TAB A 2019 10.1","stock_item":null,"__typename":"BundleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 5GB DATA X 24 - (C) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1649 PM (R290 Finance + R1359 Sub on Red Classic + (36 Months) (PROMOGIG2)"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 5GB DATA X 24 - (C) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1649 PM (R290 Finance + R1359 Sub on Red Classic + (36 Months) (PROMOGIG2)"},"crosssell_products":[]},"bundle_custom_options":[{"values":[{"value":"494"}]}],"customizable_options":[{"label":"I would like to","values":[{"value":"494","label":"Upgrade"}]}],"quantity":1},{"id":"1065193","prices":{"row_total_original":{"value":0},"row_total_including_tax":{"value":0},"total_item_discount":{"value":0},"price":{"value":0},"discounts":null},"product":{"items":[{"option_id":123038,"title":"Smartphones","options":[{"id":224552,"is_hidden_product":"0","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","product":{"id":30182,"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","sku":"104048115"}}]},{"option_id":123041,"title":"Tablet","options":[{"id":224555,"is_hidden_product":"0","label":"SAMSUNG GALAXY TAB A 2019 10.1","product":{"id":21416,"name":"SAMSUNG GALAXY TAB A 2019 10.1","sku":"108017080"}}]},{"option_id":123044,"title":"Promo","options":[{"id":224558,"is_hidden_product":"0","label":"RED SELECT TOP UP+","product":{"id":17102,"name":"RED SELECT TOP UP+","sku":"VID10002061"}}]},{"option_id":123035,"title":"General","options":[{"id":224540,"is_hidden_product":"1","label":"Next Day Delivery","product":{"id":11528,"name":"Next Day Delivery","sku":"102027255"}},{"id":224543,"is_hidden_product":"1","label":"Promotional My Gig 2 - 24 Month Hybrid","product":{"id":18704,"name":"Promotional My Gig 2 - 24 Month Hybrid","sku":"VID10001942"}},{"id":224546,"is_hidden_product":"1","label":"RED SELECT TOP UP+ Line Rental","product":{"id":25049,"name":"RED SELECT TOP UP+ Line Rental","sku":"VID10002083"}},{"id":224549,"is_hidden_product":"1","label":"Handset Installment 15","product":{"id":22238,"name":"Handset Installment 15","sku":"VID10002750"}}]}],"options":[{"option_id":132144}],"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1499 PM (R350 Finance + R1149 Sub on Red Select Top Up + (36 Months) (PROMOGIG2)","id":48209,"sku":"V15DE11247","categories":[{"id":209,"name":"Deals"},{"id":212,"name":"Phones & SIM"},{"id":221,"name":"Smartphones"}],"promotion_tag_label":"For today only","low_stock_threshold":5,"quantity":0,"stock_status":"IN_STOCK","is_deal_product":1,"badges":16619,"promo_data":4000,"minutes":900,"minutes_label":"900","airtime":0,"old_monthly_recurring":"4000","sms":"Unlimited","plan_name":16721,"plan_name_label":"Red","plan_type":16706,"componentid":"102027255,104048115,108017080,VID10001942,VID10002061,VID10002083,VID10002750","contract_sku":["V15DE11247","DV8NR13073"],"plan_type_label":"Data & voice minutes","nightowl_units":"12","nightowl_uom":"GB","contract_type":16715,"contract_type_label":"Standard contract","payment_terms":"16703","payment_terms_label":"36","badges_label":"Black Friday","promotion_tag":16670,"accessories":null,"accessories_label":null,"monthly_recurring":1499,"primary_product_sku":"104048115","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg","primary_product_name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","stock_item":null,"__typename":"BundleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1499 PM (R350 Finance + R1149 Sub on Red Select Top Up + (36 Months) (PROMOGIG2)"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1499 PM (R350 Finance + R1149 Sub on Red Select Top Up + (36 Months) (PROMOGIG2)"},"crosssell_products":[]},"bundle_custom_options":[{"values":[{"value":"332493"}]}],"customizable_options":[{"label":"I would like to","values":[{"value":"332493","label":"Upgrade"}]}],"quantity":1}],"available_payment_methods":[{"code":"checkmo","title":"VFS"},{"code":"free","title":"No Payment Information Required"}],"selected_payment_method":{"code":"","title":""},"applied_coupons":null,"prices":{"discounts":null,"grand_total":{"value":0,"currency":"ZAR"},"subtotal_including_tax":{"value":0,"currency":"ZAR"},"subtotal_excluding_tax":{"value":0,"currency":"ZAR"},"subtotal_with_discount_excluding_tax":{"value":0,"currency":"ZAR"},"applied_taxes":[]},"total_quantity":1}}}');

/***/ }),

/***/ 44376:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"cart":{"email":"27630187850@mailinator.com","allow_place_order":1,"notification_data":{"is_pending_orders":1,"cancel_order_duration":24},"shippingMessageText":{"delivery_message":"Deliveries are made on weekdays between 08:00 and 17:00","free_shipping_message":"Your Order is over R600","free_shipping_method_message":"your delivery is FREE","standard_shipping_message":"Your Order is","standard_shipping_method_message":"Delivery is Standard Delivery"},"shipping_fee_calculate":{"method_code":"freeshipping","carrier_code":"freeshipping","shipping_label":"Free","shipping_fee":"0"},"cart_order_limits":{"cart_qty_limit":"20","order_value_limit":"200000"},"items":[{"id":"1075795","prices":{"row_total_original":{"value":0},"row_total_including_tax":{"value":0},"total_item_discount":{"value":0},"price":{"value":0},"discounts":null},"product":{"items":[{"option_id":122888,"title":"General","options":[{"id":224249,"is_hidden_product":"1","label":"Handset Installment 15","product":{"id":22238,"name":"Handset Installment 15","sku":"VID10002750"}},{"id":224252,"is_hidden_product":"1","label":"Bonus 20GB Once Off 7 Days- Hyb","product":{"id":25550,"name":"Bonus 20GB Once Off 7 Days- Hyb","sku":"VID10003069"}},{"id":224255,"is_hidden_product":"0","label":"Bonus Video Ticket 5GB 3 Months","product":{"id":16820,"name":"Bonus Video Ticket 5GB 3 Months","sku":"VID10003761"}},{"id":224258,"is_hidden_product":"1","label":"MyRed 2GB 250min TopUp Line Rental","product":{"id":16856,"name":"MyRed 2GB 250min TopUp Line Rental","sku":"VID10003897"}}]},{"option_id":122891,"title":"Promo","options":[{"id":224261,"is_hidden_product":"0","label":"MyRed 2GB 250min TopUp","product":{"id":24464,"name":"MyRed 2GB 250min TopUp","sku":"VID10003863"}}]},{"option_id":122885,"title":"Smartphones","options":[{"id":224246,"is_hidden_product":"0","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","product":{"id":30182,"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","sku":"104048115"}}]}],"options":[{"option_id":288}],"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 20GB DATA X 7 DAYS - (H) + VIDEO TICKET - 3 MONTHS - 5GB @ R1519 PM (R960 Finance + R559 Sub on MyRed 2GB 250min TopUp","id":48161,"sku":"DV8DA2447","categories":[{"id":209,"name":"Deals"},{"id":212,"name":"Phones & SIM"},{"id":221,"name":"Smartphones"},{"id":308,"name":"Phones"},{"id":311,"name":"Smartphones"}],"promotion_tag_label":null,"low_stock_threshold":5,"quantity":0,"stock_status":"IN_STOCK","is_deal_product":1,"badges":16619,"promo_data":2000,"minutes":250,"minutes_label":"250","airtime":0,"old_monthly_recurring":null,"sms":"150","plan_name":16721,"plan_name_label":"Red","plan_type":16712,"componentid":"104048115,VID10002750,VID10003069,VID10003761,VID10003863,VID10003897","contract_sku":["DV8DA2447"],"plan_type_label":"Data only","nightowl_units":"2","nightowl_uom":"GB","contract_type":16718,"contract_type_label":"Top Up contract","payment_terms":"16697","payment_terms_label":"24","badges_label":"Black Friday","promotion_tag":null,"accessories":null,"accessories_label":null,"monthly_recurring":1519,"primary_product_sku":"104048115","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg","primary_product_name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","stock_item":null,"__typename":"BundleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 20GB DATA X 7 DAYS - (H) + VIDEO TICKET - 3 MONTHS - 5GB @ R1519 PM (R960 Finance + R559 Sub on MyRed 2GB 250min TopUp"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png","label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 20GB DATA X 7 DAYS - (H) + VIDEO TICKET - 3 MONTHS - 5GB @ R1519 PM (R960 Finance + R559 Sub on MyRed 2GB 250min TopUp"},"crosssell_products":[]},"bundle_custom_options":[{"values":[{"value":"747"}]}],"customizable_options":[{"label":"I would like to","values":[{"value":"747","label":"Get this deal on a new contract"}]}],"quantity":1},{"id":"1023023","monthly_recurring":10,"parent_product_sku":"DV8DA2447","prices":{"row_total":{"value":0},"row_total_original":{"value":0},"row_total_including_tax":{"value":0},"total_item_discount":{"value":0},"price":{"value":0},"discounts":null},"product":{"name":"Vodacom Insurance Comp.Quick SIM","sku":"VID00000584","stock_status":"IN_STOCK","is_deal_product":null,"badges":null,"promo_data":null,"minutes":null,"minutes_label":null,"airtime":null,"sms":null,"plan_name":null,"plan_name_label":null,"plan_type":null,"componentid":null,"contract_sku":["VID00000584"],"plan_type_label":null,"contract_type":null,"contract_type_label":null,"payment_terms":null,"payment_terms_label":"24","badges_label":null,"promotion_tag":null,"promotion_tag_label":null,"accessories":null,"accessories_label":null,"monthly_recurring":null,"primary_product_sku":null,"primary_product_image":null,"primary_product_name":null,"stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":10000},"categories":[{"name":"VAS","image":"https://shopqa.vodacom.co.za/media/catalog/category/Tablets_laptop_1.png"}],"price_range":{"minimum_price":{"regular_price":{"value":0,"currency":"ZAR"}},"maximum_price":{"regular_price":{"value":0,"currency":"ZAR"}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png","label":"Vodacom Insurance Comp.Quick SIM"},"crosssell_products":[]},"quantity":1},{"id":"1023025","monthly_recurring":10,"parent_product_sku":"DV8DA2447","prices":{"row_total":{"value":0},"row_total_original":{"value":0},"row_total_including_tax":{"value":0},"total_item_discount":{"value":0},"price":{"value":0},"discounts":null},"product":{"name":"Insurance N1200","sku":"VID00000988","stock_status":"IN_STOCK","is_deal_product":null,"badges":null,"promo_data":null,"minutes":null,"minutes_label":null,"airtime":null,"sms":null,"plan_name":null,"plan_name_label":null,"plan_type":null,"componentid":null,"contract_sku":["VID00000988"],"plan_type_label":null,"contract_type":null,"contract_type_label":null,"payment_terms":null,"payment_terms_label":"24","badges_label":null,"promotion_tag":null,"promotion_tag_label":null,"accessories":null,"accessories_label":null,"monthly_recurring":null,"primary_product_sku":null,"primary_product_image":null,"primary_product_name":null,"stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":10000},"categories":[{"name":"VAS","image":"https://shopqa.vodacom.co.za/media/catalog/category/Tablets_laptop_1.png"}],"price_range":{"minimum_price":{"regular_price":{"value":0,"currency":"ZAR"}},"maximum_price":{"regular_price":{"value":0,"currency":"ZAR"}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png","label":"Insurance N1200"},"crosssell_products":[]},"quantity":1},{"id":"1199827","monthly_recurring":null,"parent_product_sku":"","prices":{"row_total":{"value":12868.7},"row_total_original":{"value":14799},"row_total_including_tax":{"value":14799},"total_item_discount":{"value":0},"price":{"value":12868.7},"discounts":[{"label":"Discount","amount":{"value":2.5}}]},"configurable_options":[{"id":277,"option_label":"Colour","value_id":17125,"value_label":"Light Blue"},{"id":667,"option_label":"Storage size","value_id":19082,"value_label":"1GB RAM; 8GB ROM"}],"product":{"name":"vivo X50","sku":"vivo_x50","promotion_link":null,"stock_status":"IN_STOCK","is_deal_product":0,"description":{"html":"vivo X50"},"badges":null,"promo_data":null,"minutes":null,"minutes_label":null,"airtime":null,"sms":null,"plan_name":null,"plan_name_label":null,"plan_type":null,"componentid":null,"contract_sku":["vivo_x50"],"plan_type_label":null,"contract_type":null,"contract_type_label":null,"payment_terms":null,"payment_terms_label":null,"badges_label":null,"promotion_tag":null,"promotion_tag_label":null,"accessories":null,"accessories_label":null,"monthly_recurring":null,"primary_product_sku":null,"categories":[{"id":26,"name":"Phones & SIM","level":2,"category_url":null,"image":"https://shopqa.vodacom.co.za/media/catalog/category/Phone_SIM.png","description":null},{"id":29,"name":"Smartphones","level":3,"category_url":null,"image":null,"description":null}],"primary_product_image":null,"primary_product_name":null,"stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":10000},"price_range":{"minimum_price":{"regular_price":{"value":100,"currency":"ZAR"}},"maximum_price":{"regular_price":{"value":14799,"currency":"ZAR"}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/v/i/vivo-x50-104049899-front-huge_m8pfwahq3qgd6qji_b6aijk7fyub8tdzu.png?quality=80&fit=bounds&height=&width=","label":"vivo X50"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png","label":"vivo X50"},"configurable_options":[{"id":741,"label":"Colour","position":0,"use_default":false,"attribute_code":"color","attribute_id":"277","values":[{"value_index":17125,"label":"Light Blue","swatch_data":{"value":"#0c4d4e"}},{"value_index":16321,"label":"Black","swatch_data":{"value":"#000000"}}],"product_id":139588},{"id":995,"label":"Storage size","position":0,"use_default":false,"attribute_code":"internal_storage","attribute_id":"667","values":[{"value_index":19082,"label":"1GB RAM; 8GB ROM","swatch_data":null},{"value_index":16411,"label":"128GB","swatch_data":null}],"product_id":139588}],"variants":[{"product":{"id":30938,"name":"VIVO X50 5G FROST BLUE","sku":"104049894","stock_status":"IN_STOCK","stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":10000},"attribute_set_id":16,"weight":174.5,"price_range":{"minimum_price":{"regular_price":{"value":14799,"currency":"ZAR"}}}},"attributes":[{"label":"Light Blue","code":"color","value_index":17125},{"label":"1GB RAM; 8GB ROM","code":"internal_storage","value_index":19082}]},{"product":{"id":31043,"name":"VIVO X50 5G GLAZE BLACK","sku":"104049899","stock_status":"IN_STOCK","stock_item":{"min_qty":0,"min_sale_qty":1,"max_sale_qty":10000},"attribute_set_id":16,"weight":174.5,"price_range":{"minimum_price":{"regular_price":{"value":100,"currency":"ZAR"}}}},"attributes":[{"label":"Black","code":"color","value_index":16321},{"label":"128GB","code":"internal_storage","value_index":16411}]}],"crosssell_products":[]},"quantity":1}],"available_payment_methods":[{"code":"checkmo","title":"VFS"},{"code":"free","title":"No Payment Information Required"}],"selected_payment_method":{"code":"","title":""},"applied_coupons":null,"prices":{"discounts":null,"grand_total":{"value":0,"currency":"ZAR"},"subtotal_including_tax":{"value":0,"currency":"ZAR"},"subtotal_excluding_tax":{"value":0,"currency":"ZAR"},"subtotal_with_discount_excluding_tax":{"value":0,"currency":"ZAR"},"applied_taxes":[]},"total_quantity":1}}}');

/***/ }),

/***/ 11008:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"contract_type_desc":[{"contract_type_option_label":"Standard contract","contract_type_desc":"Let me continue using data/minutes and add the cost to my bill"},{"contract_type_option_label":"Top Up contract","contract_type_desc":"Keep me from using more data/minutes, but give me the option to buy a data/voice bundle"},{"contract_type_option_label":"Top-up ContractRed","contract_type_desc":"Keep me from using more data/minutes, but give me the option to buy a data/voice bundle"},{"contract_type_option_label":"Top-up Contracts","contract_type_desc":"Keep me from using more data/minutes, but give me the option to buy a data/voice bundle"},{"contract_type_option_label":"Red contracts","contract_type_desc":"Let me continue using data/minutes and add the cost to my bill"}],"products":{"total_count":5819,"page_info":{"page_size":12,"current_page":1,"total_pages":485},"items":[{"name":" MyRed 25GB VIP Unlimited TopUp sim only","sku":"DV20K28606-1_sim","promo_data":25000,"minutes":99999,"categories":[{"id":209,"name":"Deals","level":2},{"id":212,"name":"Phones & SIM","level":3},{"id":224,"name":"SIM","level":4}],"promotion_tag_swatch":null,"minutes_label":"Unlimited","airtime":0,"sms":"Unlimited","primary_product_image":null,"primary_product_sku":"VID10003875","contract_sku":["DV20K28606-1_sim"],"payment_terms":"16703","payment_terms_label":"36","package_description":null,"promotion_tag":16679,"promotion_tag_label":"Sim only deals","monthly_recurring":1829,"old_tariff":1929,"old_installment":0,"old_monthly_recurring":"1929","save_monthly_recurring":"100","stock_status":"IN_STOCK","deal_go_live_date":"","deal_end_date":"","deal_label":null,"is_deal_locked":0,"__typename":"BundleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}},{"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 20GB DATA X 7 DAYS - (H) + VIDEO TICKET - 3 MONTHS - 5GB @ R1419 PM (R990 Finance + R429 Sub on MyRed 2GB 150min TopUp","sku":"DV20K28620","promo_data":2000,"minutes":150,"categories":[{"id":209,"name":"Deals","level":2},{"id":212,"name":"Phones & SIM","level":3},{"id":221,"name":"Smartphones","level":4},{"id":308,"name":"Phones","level":3},{"id":311,"name":"Smartphones","level":4}],"promotion_tag_swatch":null,"minutes_label":"150","airtime":0,"sms":"150","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg","primary_product_sku":"104048115","contract_sku":["DV20K28620"],"payment_terms":"16697","payment_terms_label":"24","package_description":null,"promotion_tag":null,"promotion_tag_label":null,"monthly_recurring":1419,"old_tariff":null,"old_installment":null,"old_monthly_recurring":"1929","save_monthly_recurring":"100","stock_status":"IN_STOCK","deal_go_live_date":"2020-12-31 14:59:00","deal_end_date":"","deal_label":"Unlocks In:","is_deal_locked":1,"__typename":"BundleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/i/p/iphone_11_2.jpg?quality=80&fit=bounds&height=&width="},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/i/p/iphone_11_1.jpg?quality=80&fit=bounds&height=&width="}},{"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1499 PM (R350 Finance + R1149 Sub on Red Select Top Up + (36 Months) (PROMOGIG2)","sku":"V15DE11247","promo_data":4000,"minutes":900,"categories":[{"id":209,"name":"Deals","level":2},{"id":212,"name":"Phones & SIM","level":3},{"id":221,"name":"Smartphones","level":4}],"promotion_tag_swatch":null,"minutes_label":"900","airtime":0,"sms":"Unlimited","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg","primary_product_sku":"104048115","contract_sku":["V15DE11247","DV8NR13073"],"payment_terms":"16703","payment_terms_label":"36","package_description":null,"promotion_tag":16670,"promotion_tag_label":"For today only","monthly_recurring":1499,"old_tariff":2000,"old_installment":2000,"old_monthly_recurring":"4000","save_monthly_recurring":"2501","stock_status":"IN_STOCK","deal_go_live_date":"2020-12-31 14:59:00","deal_end_date":"","deal_label":null,"is_deal_locked":0,"__typename":"BundleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}},{"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 20GB DATA X 7 DAYS - (H) + VIDEO TICKET - 3 MONTHS - 5GB @ R1569 PM (R940 Finance + R629 Sub on MyRed 5GB 150min TopUp","sku":"DV15DC1000-1","promo_data":5000,"minutes":150,"categories":[{"id":209,"name":"Deals","level":2},{"id":212,"name":"Phones & SIM","level":3},{"id":221,"name":"Smartphones","level":4},{"id":308,"name":"Phones","level":3},{"id":311,"name":"Smartphones","level":4}],"promotion_tag_swatch":null,"minutes_label":"150","airtime":0,"sms":"150","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg","primary_product_sku":"104048115","contract_sku":["DV15DC1000-1"],"payment_terms":"16697","payment_terms_label":"24","package_description":null,"promotion_tag":16670,"promotion_tag_label":"For today only","monthly_recurring":1569.01,"old_tariff":null,"old_installment":null,"old_monthly_recurring":"4000","save_monthly_recurring":"2501","stock_status":"IN_STOCK","deal_go_live_date":"2020-12-31 14:59:00","deal_end_date":"","deal_label":null,"is_deal_locked":0,"__typename":"BundleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}},{"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 20GB DATA X 7 DAYS - (H) + VIDEO TICKET - 3 MONTHS - 5GB @ R1869 PM (R840 Finance + R1029 Sub on MyRed 3GB Unlimited TopUp","sku":"DV0KD01366","promo_data":3000,"minutes":99999,"categories":[{"id":209,"name":"Deals","level":2},{"id":212,"name":"Phones & SIM","level":3},{"id":308,"name":"Phones","level":3},{"id":311,"name":"Smartphones","level":4}],"promotion_tag_swatch":null,"minutes_label":"Unlimited","airtime":0,"sms":"150","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg","primary_product_sku":"104048115","contract_sku":["DV0KD01366"],"payment_terms":"16697","payment_terms_label":"24","package_description":null,"promotion_tag":19247,"promotion_tag_label":"Red hot deal","monthly_recurring":1868.99,"old_tariff":null,"old_installment":null,"old_monthly_recurring":"4000","save_monthly_recurring":"2501","stock_status":"IN_STOCK","deal_go_live_date":"2020-12-31 14:59:00","deal_end_date":"2021-07-20 13:38:00","deal_label":"Promotion","is_deal_locked":0,"__typename":"BundleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}},{"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 20GB DATA X 7 DAYS - (H) + VIDEO TICKET - 3 MONTHS - 5GB @ R1519 PM (R960 Finance + R559 Sub on MyRed 2GB 250min TopUp","sku":"DV8DA2447","promo_data":2000,"minutes":250,"categories":[{"id":209,"name":"Deals","level":2},{"id":212,"name":"Phones & SIM","level":3},{"id":221,"name":"Smartphones","level":4},{"id":308,"name":"Phones","level":3},{"id":311,"name":"Smartphones","level":4}],"promotion_tag_swatch":null,"minutes_label":"250","airtime":0,"sms":"150","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg","primary_product_sku":"104048115","contract_sku":["DV8DA2447"],"payment_terms":"16697","payment_terms_label":"24","package_description":null,"promotion_tag":null,"promotion_tag_label":null,"monthly_recurring":1519,"old_tariff":null,"old_installment":null,"old_monthly_recurring":"4000","save_monthly_recurring":"2501","stock_status":"IN_STOCK","deal_go_live_date":"2020-12-31 14:59:00","deal_end_date":"2021-07-20 13:38:00","deal_label":null,"is_deal_locked":0,"__typename":"BundleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}},{"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 5GB DATA X 24 - (C) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1649 PM (R290 Finance + R1359 Sub on Red Classic + (36 Months) (PROMOGIG2)","sku":"DV9NN15879","promo_data":4000,"minutes":1200,"categories":[{"id":209,"name":"Deals","level":2},{"id":212,"name":"Phones & SIM","level":3},{"id":221,"name":"Smartphones","level":4}],"promotion_tag_swatch":null,"minutes_label":"1200","airtime":0,"sms":"Unlimited","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/4/6/464598.jpg","primary_product_sku":"108017080","contract_sku":["DV9NN15879","DV8DA7211"],"payment_terms":"16703","payment_terms_label":"36","package_description":null,"promotion_tag":null,"promotion_tag_label":null,"monthly_recurring":1649,"old_tariff":null,"old_installment":null,"old_monthly_recurring":"4000","save_monthly_recurring":"2501","stock_status":"IN_STOCK","deal_go_live_date":"2020-12-31 14:59:00","deal_end_date":"2021-07-20 13:38:00","deal_label":null,"is_deal_locked":0,"__typename":"BundleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}},{"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 20GB DATA X 7 DAYS - (H) + VIDEO TICKET - 3 MONTHS - 5GB @ R1819 PM (R860 Finance + R959 Sub on MyRed 5GB 500min TopUp","sku":"DV8NR12130","promo_data":5000,"minutes":500,"categories":[{"id":209,"name":"Deals","level":2},{"id":212,"name":"Phones & SIM","level":3},{"id":221,"name":"Smartphones","level":4},{"id":308,"name":"Phones","level":3},{"id":311,"name":"Smartphones","level":4}],"promotion_tag_swatch":null,"minutes_label":"500","airtime":0,"sms":"150","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg","primary_product_sku":"104048115","contract_sku":["DV8NR12130"],"payment_terms":"16697","payment_terms_label":"24","package_description":null,"promotion_tag":16682,"promotion_tag_label":"Big data deals","monthly_recurring":1819,"old_tariff":null,"old_installment":null,"old_monthly_recurring":"4000","save_monthly_recurring":"2501","stock_status":"IN_STOCK","deal_go_live_date":"2020-12-31 14:59:00","deal_end_date":"2021-07-20 13:38:00","deal_label":null,"is_deal_locked":0,"__typename":"BundleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}},{"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 20GB DATA X 7 DAYS - (H) + VIDEO TICKET - 3 MONTHS - 5GB @ R1669 PM (R910 Finance + R759 Sub on MyRed 2GB 500min TopUp","sku":"DV8NR13076","promo_data":2000,"minutes":500,"categories":[{"id":209,"name":"Deals","level":2},{"id":212,"name":"Phones & SIM","level":3},{"id":221,"name":"Smartphones","level":4},{"id":308,"name":"Phones","level":3},{"id":311,"name":"Smartphones","level":4}],"promotion_tag_swatch":null,"minutes_label":"500","airtime":0,"sms":"150","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg","primary_product_sku":"104048115","contract_sku":["DV8NR13076"],"payment_terms":"16697","payment_terms_label":"24","package_description":null,"promotion_tag":null,"promotion_tag_label":null,"monthly_recurring":1669,"old_tariff":null,"old_installment":null,"old_monthly_recurring":"4000","save_monthly_recurring":"2501","stock_status":"IN_STOCK","deal_go_live_date":"2020-12-31 14:59:00","deal_end_date":"2021-06-29 09:41:00","deal_label":"Go live","is_deal_locked":0,"__typename":"BundleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}},{"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1869 PM (R720 Finance + R1149 Sub on Red Select Top Up + (PROMOGIG2)","sku":"DV8NR13073","promo_data":2000,"minutes":800,"categories":[{"id":209,"name":"Deals","level":2},{"id":212,"name":"Phones & SIM","level":3},{"id":221,"name":"Smartphones","level":4}],"promotion_tag_swatch":null,"minutes_label":"800","airtime":0,"sms":"Unlimited","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/4/6/464598.jpg","primary_product_sku":"108017080","contract_sku":["V15DE11247","DV8NR13073"],"payment_terms":"16697","payment_terms_label":"24","package_description":null,"promotion_tag":null,"promotion_tag_label":null,"monthly_recurring":1869,"old_tariff":null,"old_installment":null,"old_monthly_recurring":"4000","save_monthly_recurring":"2501","stock_status":"IN_STOCK","deal_go_live_date":"2020-12-31 14:59:00","deal_end_date":"2021-06-29 09:41:00","deal_label":null,"is_deal_locked":0,"__typename":"BundleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}},{"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 5GB DATA X 24 - (C) @ R1969 PM (R610 Finance + R1359 Sub on Red Classic +","sku":"DV8NR2938","promo_data":4000,"minutes":1200,"categories":[{"id":209,"name":"Deals","level":2},{"id":212,"name":"Phones & SIM","level":3},{"id":221,"name":"Smartphones","level":4},{"id":308,"name":"Phones","level":3},{"id":311,"name":"Smartphones","level":4}],"promotion_tag_swatch":null,"minutes_label":"1200","airtime":0,"sms":"Unlimited","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg","primary_product_sku":"104048115","contract_sku":["DV8NR2938"],"payment_terms":"16697","payment_terms_label":"24","package_description":null,"promotion_tag":null,"promotion_tag_label":null,"monthly_recurring":1969,"old_tariff":1000,"old_installment":300,"old_monthly_recurring":"1300","save_monthly_recurring":"-669","stock_status":"IN_STOCK","deal_go_live_date":"2020-12-31 14:59:00","deal_end_date":"2021-06-29 09:41:00","deal_label":null,"is_deal_locked":0,"__typename":"BundleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}},{"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 20GB DATA X 7 DAYS - (H) + VIDEO TICKET - 3 MONTHS - 5GB @ R1719 PM (R890 Finance + R829 Sub on MyRed 3GB 500min TopUp","sku":"DV8DA6103","promo_data":3000,"minutes":500,"categories":[{"id":209,"name":"Deals","level":2},{"id":212,"name":"Phones & SIM","level":3},{"id":221,"name":"Smartphones","level":4},{"id":308,"name":"Phones","level":3},{"id":311,"name":"Smartphones","level":4}],"promotion_tag_swatch":null,"minutes_label":"500","airtime":0,"sms":"150","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg","primary_product_sku":"104048115","contract_sku":["DV8DA6103"],"payment_terms":"16697","payment_terms_label":"24","package_description":null,"promotion_tag":null,"promotion_tag_label":null,"monthly_recurring":1719,"old_tariff":null,"old_installment":null,"old_monthly_recurring":"1300","save_monthly_recurring":"-669","stock_status":"IN_STOCK","deal_go_live_date":"2020-12-31 14:59:00","deal_end_date":"2021-06-29 09:41:00","deal_label":null,"is_deal_locked":0,"__typename":"BundleProduct","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}}],"aggregations":[{"label":"Price","attribute_code":"price","options":[{"label":"0-100","value":"0_100"},{"label":"500-600","value":"500_600"},{"label":"1600-1700","value":"1600_1700"},{"label":"1800-1900","value":"1800_1900"},{"label":"1900-2000","value":"1900_2000"},{"label":"3100-3200","value":"3100_3200"},{"label":"3900-4000","value":"3900_4000"},{"label":"7700-7800","value":"7700_7800"},{"label":"14400-14500","value":"14400_14500"},{"label":"17900-18000","value":"17900_18000"}]},{"label":"Category","attribute_code":"category_id","options":[{"label":"Deals","value":"209"},{"label":"Phones & SIM","value":"212"},{"label":"Smartphones","value":"221"},{"label":"Smartphones","value":"311"},{"label":"Phones","value":"308"},{"label":"SIM","value":"224"}]},{"label":"Accessories","attribute_code":"accessories","options":[{"label":"Samsung Gear Fit2 Pro","value":"16748"}]},{"label":"airtime_bucket","attribute_code":"airtime_bucket","options":[{"label":"0_100","value":"0_100"},{"label":"100_200","value":"100_200"},{"label":"200_300","value":"200_300"},{"label":"300_400","value":"300_400"},{"label":"500_600","value":"500_600"},{"label":"800_900","value":"800_900"},{"label":"1200_1300","value":"1200_1300"},{"label":"3000_3100","value":"3000_3100"}]},{"label":"bundle_product_price_bucket","attribute_code":"bundle_product_price_bucket","options":[{"label":"0_100","value":"0_100"},{"label":"100_200","value":"100_200"},{"label":"300_400","value":"300_400"},{"label":"400_500","value":"400_500"},{"label":"500_600","value":"500_600"},{"label":"600_700","value":"600_700"},{"label":"700_800","value":"700_800"},{"label":"800_900","value":"800_900"},{"label":"900_1000","value":"900_1000"},{"label":"1000_1100","value":"1000_1100"}]},{"label":"Contract Type","attribute_code":"contract_type","options":[{"label":"Standard contract","value":"16715"},{"label":"Top Up contract","value":"16718"},{"label":"Red contract","value":"16864"}]},{"label":"deal_installment_bucket","attribute_code":"deal_installment_bucket","options":[{"label":"0_100","value":"0_100"},{"label":"100_200","value":"100_200"},{"label":"400_500","value":"400_500"},{"label":"600_700","value":"600_700"}]},{"label":"Deal Product","attribute_code":"deal_product","options":[{"label":"Yes","value":"16873"},{"label":"No","value":"16876"}]},{"label":"installment_bucket","attribute_code":"installment_bucket","options":[{"label":"0_100","value":"0_100"},{"label":"100_200","value":"100_200"},{"label":"200_300","value":"200_300"},{"label":"300_400","value":"300_400"},{"label":"400_500","value":"400_500"},{"label":"500_600","value":"500_600"},{"label":"600_700","value":"600_700"},{"label":"700_800","value":"700_800"},{"label":"800_900","value":"800_900"},{"label":"900_1000","value":"900_1000"}]},{"label":"Is Deal Product","attribute_code":"is_deal_product","options":[{"label":"1","value":"1"}]},{"label":"Hide Product From Search And Listing Page","attribute_code":"is_hidden_product","options":[{"label":"0","value":"0"}]},{"label":"Brands","attribute_code":"manufacturer","options":[{"label":"Apple","value":"16520"},{"label":"Samsung","value":"16517"},{"label":"TCL","value":"16478"},{"label":"Vivo","value":"16589"},{"label":"Hisense","value":"16565"}]},{"label":"minutes_bucket","attribute_code":"minutes_bucket","options":[{"label":"0_100","value":"0_100"},{"label":"100_200","value":"100_200"},{"label":"200_300","value":"200_300"},{"label":"300_400","value":"300_400"},{"label":"400_500","value":"400_500"},{"label":"500_600","value":"500_600"},{"label":"600_700","value":"600_700"},{"label":"800_900","value":"800_900"},{"label":"900_1000","value":"900_1000"},{"label":"1000_1100","value":"1000_1100"}]},{"label":"monthly_recurring_bucket","attribute_code":"monthly_recurring_bucket","options":[{"label":"100_200","value":"100_200"},{"label":"200_300","value":"200_300"},{"label":"300_400","value":"300_400"},{"label":"400_500","value":"400_500"},{"label":"500_600","value":"500_600"},{"label":"600_700","value":"600_700"},{"label":"700_800","value":"700_800"},{"label":"800_900","value":"800_900"},{"label":"900_1000","value":"900_1000"},{"label":"1000_1100","value":"1000_1100"}]},{"label":"Payment Terms","attribute_code":"payment_terms","options":[{"label":"24","value":"16697"},{"label":"36","value":"16703"},{"label":"30","value":"19230"}]},{"label":"Package Type or Plan Name","attribute_code":"plan_name","options":[{"label":"Red","value":"16721"},{"label":"Smart","value":"16730"},{"label":"Top Up","value":"16766"},{"label":"uChoose","value":"16727"},{"label":"Data","value":"16724"}]},{"label":"Plan Type","attribute_code":"plan_type","options":[{"label":"Data & voice minutes","value":"16706"},{"label":"Airtime","value":"16709"},{"label":"Data only","value":"16712"}]},{"label":"Promotion Tag","attribute_code":"promotion_tag","options":[{"label":"Pre Order","value":"19261"},{"label":"Red hot deal","value":"19247"},{"label":"For today only","value":"16670"},{"label":"Sim only deals","value":"16679"},{"label":"Big data deals","value":"16682"},{"label":"Black friday","value":"19244"},{"label":"2 is better than 1","value":"16673"},{"label":"2 For 1","value":"16688"},{"label":"Brand new","value":"19259"}]},{"label":"promo_data_bucket","attribute_code":"promo_data_bucket","options":[{"label":"0_100","value":"0_100"},{"label":"200_300","value":"200_300"},{"label":"300_400","value":"300_400"},{"label":"500_600","value":"500_600"},{"label":"600_700","value":"600_700"},{"label":"800_900","value":"800_900"},{"label":"900_1000","value":"900_1000"},{"label":"1000_1100","value":"1000_1100"},{"label":"1200_1300","value":"1200_1300"},{"label":"2000_2100","value":"2000_2100"}]}],"price_range":[{"attribute_code":"airtime","min_value":"0.000000","max_value":"0.000000"},{"attribute_code":"minutes","min_value":"0.000000","max_value":"99999.000000"},{"attribute_code":"monthly_recurring","min_value":"145.000000","max_value":"3238.000000"},{"attribute_code":"price","min_value":"0.000000","max_value":"0.000000"},{"attribute_code":"promo_data","min_value":"0.000000","max_value":"100000.000000"}]}}}');

/***/ }),

/***/ 66473:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"products":{"total_count":35,"page_info":{"page_size":10,"current_page":1,"total_pages":4},"items":[{"name":"Vibe 4G","sku":"104045329","badges":5469,"badges_label":"Brand new","manufacturer":5475,"manufacturer_label":"Vibe","promotion_tag_label":"Exclusive to Online","payment_terms_label":null,"stock_status":"IN_STOCK","quantity":250,"low_stock_threshold":1,"display_low_stock_badge":0,"categories":[{"id":22,"name":"Phones","url_key":"phones","image":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/phone_sim.png"},{"id":23,"name":"Feature phones","url_key":"feature-phones","image":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Tablet_PNG_Image_38437.png"}],"__typename":"SimpleProduct","description":{"html":"Vodacom Vibe 4G Network Locked"},"meta_title":null,"meta_description":null,"price_range":{"minimum_price":{"regular_price":{"value":496,"currency":"ZAR"},"final_price":{"value":496,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":496,"currency":"ZAR"},"final_price":{"value":496,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"price_tiers":[],"image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/V/i/Vibe_4G_-_Main_1.jpg","label":"Vibe 4G"},"small_image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/V/i/Vibe_4G_-_Main_2.jpg","label":"Vibe 4G"},"media_gallery":[{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/V/i/Vibe_4G_-_Main_1.jpg","label":"Vibe 4G"},{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/V/i/Vibe_4G_-_Main_2.jpg","label":"Vibe 4G"},{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/V/i/Vibe_4G_-_Main_3.jpg","label":"Vibe 4G"}]},{"name":"Vibe 3G 2.8 Network Lock","sku":"104045994","badges":null,"badges_label":null,"manufacturer":null,"manufacturer_label":null,"promotion_tag_label":null,"payment_terms_label":null,"stock_status":"IN_STOCK","quantity":250,"low_stock_threshold":1,"display_low_stock_badge":null,"categories":[],"__typename":"SimpleProduct","description":{"html":"Vibe 3G 2.8 Network Lock Black"},"meta_title":null,"meta_description":null,"price_range":{"minimum_price":{"regular_price":{"value":329,"currency":"ZAR"},"final_price":{"value":329,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":329,"currency":"ZAR"},"final_price":{"value":329,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"price_tiers":[],"image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/V/i/Vibe_3G_28_Network_Lock_-_Bottom_1.jpg","label":"Vibe 3G 2.8 Network Lock"},"small_image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/V/i/Vibe_3G_28_Network_Lock_-_Bottom_2.jpg","label":"Vibe 3G 2.8 Network Lock"},"media_gallery":[{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/V/i/Vibe_3G_28_Network_Lock_-_Bottom_1.jpg","label":"Vibe 3G 2.8 Network Lock"},{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/V/i/Vibe_3G_28_Network_Lock_-_Bottom_2.jpg","label":"Vibe 3G 2.8 Network Lock"},{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/V/i/Vibe_3G_28_Network_Lock_-_Bottom_3.jpg","label":"Vibe 3G 2.8 Network Lock"}]},{"name":"Samsung Galaxy Tab S 10.5 4G","sku":"1270464748","badges":null,"badges_label":null,"manufacturer":5463,"manufacturer_label":"Samsung","promotion_tag_label":null,"payment_terms_label":null,"stock_status":"IN_STOCK","quantity":100,"low_stock_threshold":1,"display_low_stock_badge":null,"categories":[{"id":31,"name":"Tablets & Laptops","url_key":"tablets-laptops","image":null},{"id":53,"name":"Tablets","url_key":"tablets","image":null}],"__typename":"SimpleProduct","description":{"html":""},"meta_title":"Samsung Galaxy Tab S 10.5 4G","meta_description":"Samsung Galaxy Tab S 10.5 4G ","price_range":{"minimum_price":{"regular_price":{"value":10000,"currency":"ZAR"},"final_price":{"value":10000,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":10000,"currency":"ZAR"},"final_price":{"value":10000,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"price_tiers":[],"image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/d/o/download_1.jpg","label":"Samsung Galaxy Tab S 10.5 4G"},"small_image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/d/o/download_1.jpg","label":"Samsung Galaxy Tab S 10.5 4G"},"media_gallery":[{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/d/o/download_1.jpg","label":"Samsung Galaxy Tab S 10.5 4G"}]},{"name":"Samsung Galaxy Tab S","sku":"1280464748","badges":5469,"badges_label":"Brand new","manufacturer":5463,"manufacturer_label":"Samsung","promotion_tag_label":"Exclusive to Online","payment_terms_label":null,"stock_status":"IN_STOCK","quantity":100,"low_stock_threshold":1,"display_low_stock_badge":0,"categories":[{"id":31,"name":"Tablets & Laptops","url_key":"tablets-laptops","image":null},{"id":53,"name":"Tablets","url_key":"tablets","image":null}],"__typename":"SimpleProduct","description":{"html":""},"meta_title":"Samsung Galaxy Tab S","meta_description":"Samsung Galaxy Tab S ","price_range":{"minimum_price":{"regular_price":{"value":10500,"currency":"ZAR"},"final_price":{"value":10,"currency":"ZAR"},"discount":{"amount_off":10490,"percent_off":99.9}},"maximum_price":{"regular_price":{"value":10500,"currency":"ZAR"},"final_price":{"value":10,"currency":"ZAR"},"discount":{"amount_off":10490,"percent_off":99.9}}},"price_tiers":[{"discount":{"amount_off":500,"percent_off":4.76},"final_price":{"value":10000,"currency":"ZAR"},"quantity":1}],"image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/s/a/samsung-galaxy-tab-s.jpg","label":"Samsung Galaxy Tab S"},"small_image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/s/a/samsung-galaxy-tab-s.jpg","label":"Samsung Galaxy Tab S"},"media_gallery":[{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/s/a/samsung-galaxy-tab-s.jpg","label":"Samsung Galaxy Tab S"},{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/i/m/images.jpeg","label":"Samsung Galaxy Tab S"},{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/7/1/717aeqcigsl._sl1500_.jpg","label":"Samsung Galaxy Tab S"}]},{"name":"Samsung Galaxy S20+  ","sku":"1240464748","badges":5469,"badges_label":"Brand new","manufacturer":5463,"manufacturer_label":"Samsung","promotion_tag_label":"Exclusive to Online","payment_terms_label":null,"stock_status":"IN_STOCK","quantity":100,"low_stock_threshold":1,"display_low_stock_badge":0,"categories":[],"__typename":"SimpleProduct","description":{"html":""},"meta_title":"Samsung Galaxy S20+  ","meta_description":"Samsung Galaxy S20+   ","price_range":{"minimum_price":{"regular_price":{"value":3500,"currency":"ZAR"},"final_price":{"value":3150,"currency":"ZAR"},"discount":{"amount_off":350,"percent_off":10}},"maximum_price":{"regular_price":{"value":3500,"currency":"ZAR"},"final_price":{"value":3150,"currency":"ZAR"},"discount":{"amount_off":350,"percent_off":10}}},"price_tiers":[],"image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/u/n/untitled3_2.png","label":"Samsung Galaxy S20+  "},"small_image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/u/n/untitled3_2.png","label":"Samsung Galaxy S20+  "},"media_gallery":[{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/u/n/untitled3_2.png","label":"Samsung Galaxy S20+  "}]},{"name":"Samsung Galaxy S20 128GB","sku":"1230464748","badges":5469,"badges_label":"Brand new","manufacturer":5463,"manufacturer_label":"Samsung","promotion_tag_label":"Exclusive to Online","payment_terms_label":null,"stock_status":"IN_STOCK","quantity":100,"low_stock_threshold":1,"display_low_stock_badge":0,"categories":[{"id":22,"name":"Phones","url_key":"phones","image":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/phone_sim.png"},{"id":26,"name":"Vouchers","url_key":"vouchers","image":null},{"id":27,"name":"Printers & Scanners","url_key":"printers-scanners","image":null}],"__typename":"SimpleProduct","description":{"html":""},"meta_title":"Samsung Galaxy S20 128GB","meta_description":"Samsung Galaxy S20 128GB ","price_range":{"minimum_price":{"regular_price":{"value":25499,"currency":"ZAR"},"final_price":{"value":22949.1,"currency":"ZAR"},"discount":{"amount_off":2549.9,"percent_off":10}},"maximum_price":{"regular_price":{"value":25499,"currency":"ZAR"},"final_price":{"value":22949.1,"currency":"ZAR"},"discount":{"amount_off":2549.9,"percent_off":10}}},"price_tiers":[],"image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/u/n/untitled.png","label":"Samsung Galaxy S20 128GB"},"small_image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/u/n/untitled.png","label":"Samsung Galaxy S20 128GB"},"media_gallery":[{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/u/n/untitled.png","label":"Samsung Galaxy S20 128GB"},{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/u/n/untitled2.png","label":"Samsung Galaxy S20 128GB"}]},{"name":"Samsung Galaxy M31","sku":"SK1020345","badges":5469,"badges_label":"Brand new","manufacturer":5463,"manufacturer_label":"Samsung","promotion_tag_label":"Exclusive to Online","payment_terms_label":null,"stock_status":"IN_STOCK","quantity":130,"low_stock_threshold":1,"display_low_stock_badge":0,"categories":[{"id":22,"name":"Phones","url_key":"phones","image":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/phone_sim.png"},{"id":24,"name":"Smartphones","url_key":"smartphones","image":null}],"__typename":"SimpleProduct","description":{"html":"<div data-content-type=\\"row\\" data-appearance=\\"contained\\" data-element=\\"main\\"><div data-enable-parallax=\\"0\\" data-parallax-speed=\\"0.5\\" data-background-images=\\"{}\\" data-element=\\"inner\\" style=\\"justify-content: flex-start; display: flex; flex-direction: column; background-position: left top; background-size: cover; background-repeat: no-repeat; background-attachment: scroll; border-style: none; border-width: 1px; border-radius: 0px; margin: 0px 0px 10px; padding: 10px;\\"><div data-content-type=\\"text\\" data-appearance=\\"default\\" data-element=\\"main\\" style=\\"border-style: none; border-width: 1px; border-radius: 0px; margin: 0px; padding: 0px;\\"><p>TEST Description is given here</p></div></div></div>"},"meta_title":"Samsung Galaxy M31","meta_description":"Samsung Galaxy M31 ","price_range":{"minimum_price":{"regular_price":{"value":1200,"currency":"ZAR"},"final_price":{"value":1200,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":1200,"currency":"ZAR"},"final_price":{"value":1200,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"price_tiers":[],"image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/s/a/samsung-galaxy-m31.jpeg","label":"Samsung Galaxy M31"},"small_image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/s/a/samsung-galaxy-m31.jpeg","label":"Samsung Galaxy M31"},"media_gallery":[{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/s/a/samsung-galaxy-m31.jpeg","label":"Samsung Galaxy M31"}]},{"name":"Nokia 105, 4th Edition","sku":"104046260","badges":null,"badges_label":null,"manufacturer":null,"manufacturer_label":null,"promotion_tag_label":null,"payment_terms_label":null,"stock_status":"IN_STOCK","quantity":250,"low_stock_threshold":1,"display_low_stock_badge":0,"categories":[],"__typename":"SimpleProduct","description":{"html":"<div data-content-type=\\"row\\" data-appearance=\\"contained\\" data-element=\\"main\\"><div data-enable-parallax=\\"0\\" data-parallax-speed=\\"0.5\\" data-background-images=\\"{}\\" data-element=\\"inner\\" style=\\"justify-content: flex-start; display: flex; flex-direction: column; background-position: left top; background-size: cover; background-repeat: no-repeat; background-attachment: scroll; border-style: none; border-width: 1px; border-radius: 0px; margin: 0px 0px 10px; padding: 10px;\\"><div data-content-type=\\"html\\" data-appearance=\\"default\\" data-element=\\"main\\" style=\\"border-style: none; border-width: 1px; border-radius: 0px; margin: 0px; padding: 0px;\\">Nokia 105 2019 Black Nokia 105 2019 Black</div></div></div>"},"meta_title":null,"meta_description":null,"price_range":{"minimum_price":{"regular_price":{"value":199,"currency":"ZAR"},"final_price":{"value":199,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":199,"currency":"ZAR"},"final_price":{"value":199,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"price_tiers":[],"image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/N/o/Nokia_105_4th_Edition_-_Front_1.jpg","label":"Nokia 105, 4th Edition"},"small_image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/N/o/Nokia_105_4th_Edition_-_Front_2.jpg","label":"Nokia 105, 4th Edition"},"media_gallery":[{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/N/o/Nokia_105_4th_Edition_-_Front_1.jpg","label":"Nokia 105, 4th Edition"},{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/N/o/Nokia_105_4th_Edition_-_Front_2.jpg","label":"Nokia 105, 4th Edition"},{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/N/o/Nokia_105_4th_Edition_-_Front_3.jpg","label":"Nokia 105, 4th Edition"}]},{"name":"Mobicel K6","sku":"104044521","badges":5469,"badges_label":"Brand new","manufacturer":5476,"manufacturer_label":"Mobicel","promotion_tag_label":"Exclusive to Online","payment_terms_label":null,"stock_status":"IN_STOCK","quantity":250,"low_stock_threshold":1,"display_low_stock_badge":0,"categories":[{"id":22,"name":"Phones","url_key":"phones","image":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/phone_sim.png"},{"id":24,"name":"Smartphones","url_key":"smartphones","image":null}],"__typename":"SimpleProduct","description":{"html":"Mobicel K6"},"meta_title":null,"meta_description":null,"price_range":{"minimum_price":{"regular_price":{"value":121,"currency":"ZAR"},"final_price":{"value":121,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":121,"currency":"ZAR"},"final_price":{"value":121,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"price_tiers":[],"image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/M/o/Mobicel_K6_-_Side_1.jpg","label":"Mobicel K6"},"small_image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/M/o/Mobicel_K6_-_Side_2.jpg","label":"Mobicel K6"},"media_gallery":[{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/M/o/Mobicel_K6_-_Side_1.jpg","label":"Mobicel K6"},{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/M/o/Mobicel_K6_-_Side_2.jpg","label":"Mobicel K6"},{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/M/o/Mobicel_K6_-_Side_3.jpg","label":"Mobicel K6"}]},{"name":"Micromax Canvas P701","sku":"1250464748","badges":null,"badges_label":null,"manufacturer":5463,"manufacturer_label":"Samsung","promotion_tag_label":null,"payment_terms_label":null,"stock_status":"IN_STOCK","quantity":100,"low_stock_threshold":1,"display_low_stock_badge":null,"categories":[{"id":31,"name":"Tablets & Laptops","url_key":"tablets-laptops","image":null},{"id":53,"name":"Tablets","url_key":"tablets","image":null}],"__typename":"SimpleProduct","description":{"html":""},"meta_title":"Micromax Canvas P701","meta_description":"Micromax Canvas P701 ","price_range":{"minimum_price":{"regular_price":{"value":10000,"currency":"ZAR"},"final_price":{"value":10000,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":10000,"currency":"ZAR"},"final_price":{"value":10000,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"price_tiers":[],"image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/1/0/10690-87-1.jpg","label":"Micromax Canvas P701"},"small_image":{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/1/0/10690-87-1.jpg","label":"Micromax Canvas P701"},"media_gallery":[{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/1/0/10690-87-1.jpg","label":"Micromax Canvas P701"},{"url":"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/1/0/10690-87-2.jpg","label":"Micromax Canvas P701"}]}],"aggregations":[{"count":3,"label":"Price","attribute_code":"price","options":[{"count":11,"label":"*-10000","value":"*_10000"},{"count":7,"label":"10000-20000","value":"10000_20000"},{"count":17,"label":"20000-*","value":"20000_*"}]},{"count":7,"label":"Category","attribute_code":"category_id","options":[{"count":15,"label":"Phones","value":"22"},{"count":12,"label":"Feature phones","value":"23"},{"count":4,"label":"Tablets & Laptops","value":"31"},{"count":4,"label":"Tablets","value":"53"},{"count":3,"label":"Smartphones","value":"24"},{"count":1,"label":"Vouchers","value":"26"},{"count":1,"label":"Printers & Scanners","value":"27"}]},{"count":6,"label":"Color","attribute_code":"color","options":[{"count":8,"label":"Space Grey","value":"5454"},{"count":8,"label":"Silver","value":"5456"},{"count":5,"label":"Midnight Green","value":"5455"},{"count":2,"label":"Black","value":"5477"},{"count":1,"label":"White","value":"5478"},{"count":1,"label":"Space Silver","value":"5479"}]},{"count":4,"label":"Brand","attribute_code":"manufacturer","options":[{"count":7,"label":"Samsung","value":"5463"},{"count":3,"label":"Apple","value":"5462"},{"count":1,"label":"Vibe","value":"5475"},{"count":1,"label":"Mobicel","value":"5476"}]},{"count":2,"label":"Promotion Tag","attribute_code":"promotion_tag","options":[{"count":21,"label":"Exclusive to Online","value":"5471"},{"count":3,"label":"For Today Only","value":"5472"}]}],"sort_fields":{"default":"position","options":[{"label":"Position","value":"position"},{"label":"Product Name","value":"name"},{"label":"Price","value":"price"}]}}}}');

/***/ }),

/***/ 21781:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"salesOrder":{"increment_id":"7000048091","customer_name":"LegacyStaff","grand_total":"4497","order_type":["New Contract",", Once-Off purchase"],"is_guest_customer":false,"created_at":"2021-09-16 11:07:52","shipping_method":"freeshipping_freeshipping","customer_email":"27823178744@mailinator.com","tracking_number":"7000048091","courier_partner":"RAM","delivery_address":" Tester Street, qwert, Western Cape, 7550","contact_person":"LegacyStaff  | 27630190704","payment_status":null,"order_status":"CQFD_SUBMIT_SUCCESS","invoice_url":"https://shopqa.vodacom.co.za/sales/order/printInvoice/invoice_id/","delivery_time_message":"5 - 6 business days","estimated_delivery_date":"","waybill_number":"6576876y87yyi","discount_amount":"","cancel_order_duration_in_minutes":0,"ordered_product_details":[{"product_details":"[{\\"old_monthly_price\\":null,\\"monthly_price\\":\\"1869.000000\\",\\"promo_data\\":\\"2000.000000\\",\\"minutes\\":\\"800.000000\\",\\"sms\\":\\"Unlimited\\",\\"nightowl_units\\":null,\\"nightowl_uom\\":null,\\"payment_terms\\":\\"16697\\",\\"payment_terms_label\\":\\"24\\",\\"plan_name\\":null,\\"plan_name_label\\":false,\\"primary_product\\":{\\"name\\":\\"SAMSUNG GALAXY TAB A 2019 10.1\\",\\"primary_product_image\\":\\"\\\\/s\\\\/a\\\\/samsung-galaxy-tab-a-10-1--108017080-front-huge_jlzpcdig1jvg4gnl.png\\",\\"attribute_values\\":{\\"internal_storage\\":\\"18482\\",\\"internal_storage_label\\":\\"128 GB\\"}},\\"product_name\\":{\\"name\\":[\\"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY\\"]},\\"promo_product\\":{\\"name\\":[\\"RED SELECT TOP UP+\\"]}}]"}],"journey_type":"UPGRADE","vetting_result":null,"items":[{"image":"https://shopqa.vodacom.co.za/media/catalog/product","title":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1869 PM (R720 Finance + R1149 Sub on Red Select Top Up + (PROMOGIG2)","price":0,"qty":"1","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/s/a/samsung-galaxy-tab-a-10-1--108017080-front-huge_jlzpcdig1jvg4gnl.png","regular_price":0,"is_deal_product":"1","configurable_options":[],"bundle_options":[{"id":123047,"label":"General","values":[{"label":"Promotional My Gig 2 - 24 Month Hybrid","price":0,"quantity":1},{"label":"RED SELECT TOP UP+ Line Rental","price":0,"quantity":1},{"label":"Handset Installment 15","price":0,"quantity":1},{"label":"Next Day Delivery","price":0,"quantity":1}]},{"id":123050,"label":"Smartphones","values":[{"label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","price":0,"quantity":1}]},{"id":123053,"label":"Tablet","values":[{"label":"SAMSUNG GALAXY TAB A 2019 10.1","price":0,"quantity":1}]},{"id":123056,"label":"Promo","values":[{"label":"RED SELECT TOP UP+","price":0,"quantity":1}]}]},{"image":"https://shopqa.vodacom.co.za/media/catalog/product/s/a/samsung-galaxy-tab-a-10-1--108017080-front-huge_jlzpcdig1jvg4gnl.png","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/s/a/samsung-galaxy-tab-a-10-1--108017080-front-huge_jlzpcdig1jvg4gnl.png","title":"SAMSUNG GALAXY S21","price":4497,"qty":"1","regular_price":0,"is_deal_product":"0","configurable_options":[]}]}}}');

/***/ }),

/***/ 50393:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"salesOrder":{"increment_id":"7000048091","customer_name":"LegacyStaff","grand_total":"4497","order_type":["New Contract"],"is_guest_customer":false,"created_at":"2021-09-16 11:07:52","shipping_method":"freeshipping_freeshipping","customer_email":"27823178744@mailinator.com","tracking_number":"7000048091","courier_partner":"RAM","delivery_address":" Tester Street, qwert, Western Cape, 7550","contact_person":"LegacyStaff  | 27630190704","payment_status":null,"order_status":"CQFD_SUBMIT_SUCCESS","invoice_url":"https://shopqa.vodacom.co.za/sales/order/printInvoice/invoice_id/","delivery_time_message":"5 - 6 business days","estimated_delivery_date":"","waybill_number":"6576876y87yyi","discount_amount":"","cancel_order_duration_in_minutes":0,"ordered_product_details":[{"product_details":"[{\\"old_monthly_price\\":null,\\"monthly_price\\":\\"1869.000000\\",\\"promo_data\\":\\"2000.000000\\",\\"minutes\\":\\"800.000000\\",\\"sms\\":\\"Unlimited\\",\\"nightowl_units\\":null,\\"nightowl_uom\\":null,\\"payment_terms\\":\\"16697\\",\\"payment_terms_label\\":\\"24\\",\\"plan_name\\":null,\\"plan_name_label\\":false,\\"primary_product\\":{\\"name\\":\\"SAMSUNG GALAXY TAB A 2019 10.1\\",\\"primary_product_image\\":\\"\\\\/s\\\\/a\\\\/samsung-galaxy-tab-a-10-1--108017080-front-huge_jlzpcdig1jvg4gnl.png\\",\\"attribute_values\\":{\\"internal_storage\\":\\"18482\\",\\"internal_storage_label\\":\\"128 GB\\"}},\\"product_name\\":{\\"name\\":[\\"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY\\"]},\\"promo_product\\":{\\"name\\":[\\"RED SELECT TOP UP+\\"]}}]"}],"journey_type":"ADDLINE","vetting_result":null,"items":[{"image":"https://shopqa.vodacom.co.za/media/catalog/product","title":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1869 PM (R720 Finance + R1149 Sub on Red Select Top Up + (PROMOGIG2)","price":0,"qty":"1","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/s/a/samsung-galaxy-tab-a-10-1--108017080-front-huge_jlzpcdig1jvg4gnl.png","regular_price":0,"is_deal_product":"1","configurable_options":[],"bundle_options":[{"id":123047,"label":"General","values":[{"label":"Promotional My Gig 2 - 24 Month Hybrid","price":0,"quantity":1},{"label":"RED SELECT TOP UP+ Line Rental","price":0,"quantity":1},{"label":"Handset Installment 15","price":0,"quantity":1},{"label":"Next Day Delivery","price":0,"quantity":1}]},{"id":123050,"label":"Smartphones","values":[{"label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","price":0,"quantity":1}]},{"id":123053,"label":"Tablet","values":[{"label":"SAMSUNG GALAXY TAB A 2019 10.1","price":0,"quantity":1}]},{"id":123056,"label":"Promo","values":[{"label":"RED SELECT TOP UP+","price":0,"quantity":1}]}]},{"image":"https://shopqa.vodacom.co.za/media/catalog/product/s/a/samsung-galaxy-tab-a-10-1--108017080-front-huge_jlzpcdig1jvg4gnl.png","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/s/a/samsung-galaxy-tab-a-10-1--108017080-front-huge_jlzpcdig1jvg4gnl.png","title":"SAMSUNG GALAXY S21","price":4497,"qty":"1","regular_price":0,"is_deal_product":"0","configurable_options":[]}]}}}');

/***/ }),

/***/ 92701:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"salesOrder":{"increment_id":"2450000990","customer_name":"Arvind","grand_total":"4497.0000","is_guest_customer":false,"created_at":"2021-07-25 19:21:39","shipping_method":"vodacomcustomshipping_vodacomcustomshipping","customer_email":"arvind.h.singh@accenture.com","tracking_number":"2450000990","courier_partner":"RAM","delivery_address":"123 Joseph Street, Menlo Park, Pretoria, 1809","contact_person":"John Smith | 0821234567","payment_status":null,"order_status":"Pending order countdown elapsed","order_type":["Once-off purchase"],"waybill_number":"E1240349","cancel_order_duration_in_minutes":0,"items":[{"image":null,"primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/s/a/samsung-galaxy-note-20-ultra-5g-256gb-104050483-front-huge_cvlly2cwgz4nl3zd.png?width=75&height=75&quality=80&fit=bounds","title":"SAMSUNG GALAXY S21","price":4497,"qty":"1","regular_price":0,"is_deal_product":"0","configurable_options":[]}],"invoice_url":"https://shopqa.vodacom.co.za/sales/order/printInvoice/invoice_id/","delivery_time_message":"","estimated_delivery_date":"","discount_amount":"","ordered_product_details":[{"product_details":[{"old_monthly_price":null,"monthly_price":"769.000000","promo_data":"300.000000","minutes":"50.000000","sms":"50","nightowl_units":null,"payment_terms":"20091","payment_terms_label":"24","plan_name":"20108","plan_name_label":"Smart","primary_product":{"name":"Samsung Galaxy S21 5","attribute_values":{"color":"16385","color_label":"Pink","internal_storage":"17688","internal_storage_label":"8GB RAM / 256GB ROM"}},"product_name":{"name":["Promotional 20GB - Once Off - Topup","Handset Installment 15","Samsung Gal Watch Ac"]},"promo_product":{"name":["SMART TOP UP XS+"]}}]}]}}}');

/***/ }),

/***/ 62825:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"salesOrder":{"increment_id":"2450000990","customer_name":"Arvind","grand_total":"4497.0000","is_guest_customer":false,"created_at":"2021-07-25 19:21:39","shipping_method":"vodacomcustomshipping_vodacomcustomshipping","customer_email":"arvind.h.singh@accenture.com","tracking_number":"2450000990","courier_partner":"RAM","delivery_address":"123 Joseph Street, Menlo Park, Pretoria, 1809","contact_person":"John Smith | 0821234567","payment_status":null,"order_status":"CREATE_EPPIX_FAILED","order_type":["Once-off purchase"],"waybill_number":"E1240349","cancel_order_duration_in_minutes":0,"items":[{"image":null,"primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/s/a/samsung-galaxy-note-20-ultra-5g-256gb-104050483-front-huge_cvlly2cwgz4nl3zd.png?width=75&height=75&quality=80&fit=bounds","title":"SAMSUNG GALAXY S21","price":4497,"qty":"1","regular_price":0,"is_deal_product":"0","configurable_options":[]}],"invoice_url":"https://shopqa.vodacom.co.za/sales/order/printInvoice/invoice_id/","delivery_time_message":"We will deliver within 5 - 6 days","estimated_delivery_date":"","discount_amount":"","ordered_product_details":[{"product_details":[{"old_monthly_price":null,"monthly_price":"769.000000","promo_data":"300.000000","minutes":"50.000000","sms":"50","nightowl_units":null,"payment_terms":"20091","payment_terms_label":"24","plan_name":"20108","plan_name_label":"Smart","primary_product":{"name":"Samsung Galaxy S21 5","attribute_values":{"color":"16385","color_label":"Pink","internal_storage":"17688","internal_storage_label":"8GB RAM / 256GB ROM"}},"product_name":{"name":["Promotional 20GB - Once Off - Topup","Handset Installment 15","Samsung Gal Watch Ac"]},"promo_product":{"name":["SMART TOP UP XS+"]}}]}]}}}');

/***/ }),

/***/ 65907:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"salesOrder":{"increment_id":"2450000990","customer_name":"Arvind","grand_total":"4497.0000","is_guest_customer":false,"created_at":"2021-07-25 19:21:39","shipping_method":"vodacomcustomshipping_vodacomcustomshipping","customer_email":"arvind.h.singh@accenture.com","tracking_number":"2450000990","courier_partner":"RAM","delivery_address":"123 Joseph Street, Menlo Park, Pretoria, 1809","contact_person":"John Smith | 0821234567","payment_status":null,"order_status":"CQFD_SUBMIT_FAIL","order_type":["New contract"],"waybill_number":"E1240349","cancel_order_duration_in_minutes":0,"items":[{"image":null,"primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/s/a/samsung-galaxy-note-20-ultra-5g-256gb-104050483-front-huge_cvlly2cwgz4nl3zd.png?width=75&height=75&quality=80&fit=bounds","title":"SAMSUNG GALAXY S21","price":4497,"qty":"1","regular_price":0,"is_deal_product":"0","configurable_options":[]}],"invoice_url":"https://shopqa.vodacom.co.za/sales/order/printInvoice/invoice_id/","delivery_time_message":"We will deliver within 5 - 6 days","estimated_delivery_date":"","discount_amount":"","ordered_product_details":[{"product_details":[{"old_monthly_price":null,"monthly_price":"769.000000","promo_data":"300.000000","minutes":"50.000000","sms":"50","nightowl_units":null,"payment_terms":"20091","payment_terms_label":"24","plan_name":"20108","plan_name_label":"Smart","primary_product":{"name":"Samsung Galaxy S21 5","attribute_values":{"color":"16385","color_label":"Pink","internal_storage":"17688","internal_storage_label":"8GB RAM / 256GB ROM"}},"product_name":{"name":["Promotional 20GB - Once Off - Topup","Handset Installment 15","Samsung Gal Watch Ac"]},"promo_product":{"name":["SMART TOP UP XS+"]}}]}]}}}');

/***/ }),

/***/ 11237:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"salesOrder":{"increment_id":"4000000080","customer_name":"Arvind","grand_total":"24498.0000","is_guest_customer":false,"created_at":"2021-07-15 17:21:39","shipping_method":"vodacomcustomshipping_vodacomcustomshipping","customer_email":"arvind.h.singh@accenture.com","tracking_number":"4000000080","courier_partner":"RAM","delivery_address":"123 320 N Crescent Dr Beverly Hills, Free State, Free State,90210","contact_person":"Test singh | 0123213123","payment_status":null,"order_status":"PAYMENT_COMPLETE_FAILED","order_type":["New contract"],"waybill_number":"KT675556F","cancel_order_duration_in_minutes":100,"items":[{"image":null,"primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/s/a/samsung-galaxy-note-20-ultra-5g-256gb-104050483-front-huge_cvlly2cwgz4nl3zd.png?width=75&height=75&quality=80&fit=bounds","title":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","price":24498,"qty":"1","regular_price":0,"is_deal_product":"0","configurable_options":[]}],"invoice_url":"https://shopqa.vodacom.co.za/sales/order/printInvoice/invoice_id/","delivery_time_message":"","estimated_delivery_date":"","discount_amount":"","ordered_product_details":[{"product_details":[{"old_monthly_price":null,"monthly_price":"769.000000","promo_data":"300.000000","minutes":"50.000000","sms":"50","nightowl_units":null,"payment_terms":"20091","payment_terms_label":"24","plan_name":"20108","plan_name_label":"Smart","primary_product":{"name":"Samsung Galaxy S21 5","attribute_values":{"color":"16385","color_label":"Pink","internal_storage":"17688","internal_storage_label":"8GB RAM / 256GB ROM"}},"product_name":{"name":["Promotional 20GB - Once Off - Topup","Handset Installment 15","Samsung Gal Watch Ac"]},"promo_product":{"name":["SMART TOP UP XS+"]}}]}]}}}');

/***/ }),

/***/ 47811:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"salesOrder":{"increment_id":"7000034581","customer_name":"Lily","grand_total":"0.0000","order_type":["Upgrade"],"is_guest_customer":false,"created_at":"2021-08-17 10:26:51","shipping_method":"freeshipping_freeshipping","customer_email":"27630189447@mailinator.com","tracking_number":"7000034581","courier_partner":"RAM","delivery_address":" Johann Place, Pretoria, Gauteng,0081","contact_person":"Lily  | 27630180873","payment_status":null,"order_status":"CQFD_SUBMIT_FAIL","invoice_url":"https://shopqa.vodacom.co.za/sales/order/printInvoice/invoice_id/","delivery_time_message":"5 - 6 business days","estimated_delivery_date":"","waybill_number":null,"discount_amount":"","cancel_order_duration_in_minutes":0,"ordered_product_details":[{"product_details":"[{\\"old_monthly_price\\":\\"2000.000000\\",\\"monthly_price\\":\\"1499.000000\\",\\"promo_data\\":\\"4000.000000\\",\\"minutes\\":\\"900.000000\\",\\"sms\\":\\"99999\\",\\"nightowl_units\\":\\"12\\",\\"payment_terms\\":\\"16703\\",\\"payment_terms_label\\":\\"36\\",\\"plan_name\\":\\"16721\\",\\"plan_name_label\\":\\"Red\\",\\"primary_product\\":{\\"name\\":\\"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY\\",\\"primary_product_image\\":\\"\\\\/h\\\\/e\\\\/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg\\",\\"attribute_values\\":{\\"color\\":\\"16763\\",\\"color_label\\":\\"Cosmic Gray\\",\\"internal_storage\\":\\"18482\\",\\"internal_storage_label\\":\\"128 GB\\"}},\\"product_name\\":{\\"name\\":[\\"SAMSUNG GALAXY TAB A 2019 10.1\\",\\"Handset Installment 15\\"]},\\"promo_product\\":{\\"name\\":[\\"RED SELECT TOP UP+\\"]}}]"}],"journey_type":"ADDLINE","vetting_result":"APPROVED","items":[{"image":"https://shopqa.vodacom.co.za/media/catalog/product","title":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY + 2GB DATA X 24 - (H) + SAMSUNG GALAXY TAB A 2019 10.1 @ R1499 PM (R350 Finance + R1149 Sub on Red Select Top Up + (36 Months) (PROMOGIG2)","price":0,"qty":"1","primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg","regular_price":0,"is_deal_product":"1","configurable_options":[],"bundle_options":[{"id":123035,"label":"General","values":[{"label":"Promotional My Gig 2 - 24 Month Hybrid","price":0,"quantity":1},{"label":"RED SELECT TOP UP+ Line Rental","price":0,"quantity":1},{"label":"Handset Installment 15","price":0,"quantity":1},{"label":"Next Day Delivery","price":0,"quantity":1}]},{"id":123038,"label":"Smartphones","values":[{"label":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","price":0,"quantity":1}]},{"id":123041,"label":"Tablet","values":[{"label":"SAMSUNG GALAXY TAB A 2019 10.1","price":0,"quantity":1}]},{"id":123044,"label":"Promo","values":[{"label":"RED SELECT TOP UP+","price":0,"quantity":1}]}]}]}}}');

/***/ }),

/***/ 74667:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"salesOrder":{"increment_id":"2450000990","customer_name":"Arvind","grand_total":"4497.0000","is_guest_customer":false,"created_at":"2021-07-25 19:21:39","shipping_method":"vodacomcustomshipping_vodacomcustomshipping","customer_email":"arvind.h.singh@accenture.com","tracking_number":"2450000990","courier_partner":"RAM","delivery_address":"123 Joseph Street, Menlo Park, Pretoria, 1809","contact_person":"John Smith | 0821234567","payment_status":null,"order_status":"PAYMENT_SETTLED_SUCCESS","order_type":["New contract","Once-off purchase"],"waybill_number":"E1240349","cancel_order_duration_in_minutes":0,"items":[{"image":null,"primary_product_image":"https://shopqa.vodacom.co.za/media/catalog/product/s/a/samsung-galaxy-note-20-ultra-5g-256gb-104050483-front-huge_cvlly2cwgz4nl3zd.png?width=75&height=75&quality=80&fit=bounds","title":"SAMSUNG GALAXY S21","price":4497,"qty":"1","regular_price":0,"is_deal_product":"0","configurable_options":[]}],"invoice_url":"https://shopqa.vodacom.co.za/sales/order/printInvoice/invoice_id/","delivery_time_message":"We will deliver within 5 - 6 days","estimated_delivery_date":"","discount_amount":"","ordered_product_details":[{"product_details":[{"old_monthly_price":null,"monthly_price":"769.000000","promo_data":"300.000000","minutes":"50.000000","sms":"50","nightowl_units":null,"payment_terms":"20091","payment_terms_label":"24","plan_name":"20108","plan_name_label":"Smart","primary_product":{"name":"Samsung Galaxy S21 5","attribute_values":{"color":"16385","color_label":"Pink","internal_storage":"17688","internal_storage_label":"8GB RAM / 256GB ROM"}},"product_name":{"name":["Promotional 20GB - Once Off - Topup","Handset Installment 15","Samsung Gal Watch Ac"]},"promo_product":{"name":["SMART TOP UP XS+"]}}]}]}}}');

/***/ }),

/***/ 28029:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"salesOrder":{"increment_id":"7000026315","customer_name":"Lily","grand_total":"10.0000","order_type":["Once-off purchase"],"is_guest_customer":false,"created_at":"2021-06-14 11:04:15","shipping_method":"tablerate_bestway","customer_email":"27630189447@mailinator.com","tracking_number":"7000026315","courier_partner":"RAM","delivery_address":" sss, sss, Eastern Cape,0001","contact_person":"Lily  | 27630189447","payment_status":null,"order_status":"CREATE_SUBMITTED_FAIL","invoice_url":"https://shopqa.vodacom.co.za/sales/order/printInvoice/invoice_id/","delivery_time_message":"We will deliver within 5 - 6 days","estimated_delivery_date":"","waybill_number":"E6220100","discount_amount":"","cancel_order_duration_in_minutes":0,"ordered_product_details":[{"product_details":null}],"journey_type":null,"vetting_result":null,"items":[{"image":"https://shopqa.vodacom.co.za/media/catalog/product/h/p/hp-2_fufbswu3xy1hrpjt.jpg","title":"HP 15 CeleronNotebooks","price":5,"qty":"1","regular_price":6899,"is_deal_product":"0","configurable_options":[{"id":667,"option_label":"Storage size","value_id":18095,"option_value":"500GB","attribute_code":"internal_storage"},{"id":673,"option_label":"Screen Size Pixels","value_id":18056,"option_value":"15.6\'\'","attribute_code":"screen_size_pixels"}],"bundle_options":[]}]}}}');

/***/ }),

/***/ 18498:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"customerPlacedOrder":{"total_count":10,"page_info":{"page_size":6,"current_page":1,"total_pages":2},"allOrderRecords":[{"order_id":29652,"increment_id":"7000029371","customer_name":"LegacyStaff Andreas","grand_total":"R205.00","created_at":"2021-07-13 12:21:04","shipping_method":"tablerate_bestway","status":"CREATE_SUBMITTED_FAIL","estimated_delivery_date":"","order_type":["Once-off purchase"],"image":["https://shopqa.vodacom.co.za/media/catalog/product/s/a/samsung-galaxy-note-20-ultra-5g-256gb-104050483-front-huge_cvlly2cwgz4nl3zd.png?width=75&height=75&quality=80&fit=bounds"],"view_order_history":"https://shopqa.vodacom.co.za/sales/order/view/order_id/29650","waybill_number":"E6222031","cancel_order_duration_in_minutes":0},{"order_id":29651,"increment_id":"7000029377","customer_name":"LegacyStaff Andreas","grand_total":"R205.00","created_at":"2021-07-13 12:21:04","shipping_method":"tablerate_bestway","status":"CREATE_EPPIX_SUCCESS","estimated_delivery_date":"","monthly_recurring":"R1,037.99","order_type":["New contract","Once-off purchase"],"image":["https://shopqa.vodacom.co.za/media/catalog/product/s/a/samsung-galaxy-note-20-ultra-5g-256gb-104050483-front-huge_cvlly2cwgz4nl3zd.png?width=75&height=75&quality=80&fit=bounds"],"view_order_history":"https://shopqa.vodacom.co.za/sales/order/view/order_id/29650","waybill_number":"E6222031","cancel_order_duration_in_minutes":0},{"order_id":29650,"increment_id":"7000029377","customer_name":"LegacyStaff Andreas","grand_total":"R205.00","created_at":"2021-07-13 12:21:04","shipping_method":"tablerate_bestway","status":"PAYMENT_COMPLETE_FAILED","estimated_delivery_date":"This order will be cancelled in 23h 24m. Please retry payment to avoid cancellation.","order_type":["Once-off purchase"],"image":["https://shopqa.vodacom.co.za/media/catalog/product/s/a/samsung-galaxy-note-20-ultra-5g-256gb-104050483-front-huge_cvlly2cwgz4nl3zd.png?width=75&height=75&quality=80&fit=bounds"],"view_order_history":"https://shopqa.vodacom.co.za/sales/order/view/order_id/29650","waybill_number":"E6222031","cancel_order_duration_in_minutes":0},{"order_id":27167,"increment_id":"7000026894","customer_name":"LegacyStaff No last name","grand_total":"R14,198.40","created_at":"2021-06-16 09:49:08","shipping_method":"freeshipping_freeshipping","status":"Pending order countdown elapsed","estimated_delivery_date":"","order_type":["Once-off purchase"],"image":["https://shopqa.vodacom.co.za/media/catalog/product/s/a/samsung-galaxy-note-20-ultra-5g-256gb-104050483-front-huge_cvlly2cwgz4nl3zd.png?width=75&height=75&quality=80&fit=bounds","https://shopqa.vodacom.co.za/media/catalog/product/s/a/samsung-galaxy-note-20-5g-256gb-104050480-front-huge_nvzokpxyjirtuc6k.png?width=75&height=75&quality=80&fit=bounds"],"view_order_history":"https://shopqa.vodacom.co.za/sales/order/view/order_id/27167","waybill_number":"E6220312","cancel_order_duration_in_minutes":0},{"order_id":27167,"increment_id":"7000026894","customer_name":"LegacyStaff No last name","grand_total":"","monthly_recurring":"R1,037.99","created_at":"2021-06-16 09:49:08","shipping_method":"freeshipping_freeshipping","status":"CREATE_EPPIX_FAILED","estimated_delivery_date":"A consultant will get in touch with you","order_type":["New contract"],"image":["https://shopqa.vodacom.co.za/media/catalog/product/s/a/samsung-galaxy-note-20-5g-256gb-104050480-front-huge_nvzokpxyjirtuc6k.png?width=75&height=75&quality=80&fit=bounds"],"view_order_history":"https://shopqa.vodacom.co.za/sales/order/view/order_id/27167","waybill_number":"E6220312","cancel_order_duration_in_minutes":0},{"order_id":26168,"increment_id":"7000026890","customer_name":"LegacyStaff No last name","grand_total":"R14,198.40","monthly_recurring":"R1,037.99","created_at":"2021-06-16 09:49:08","shipping_method":"freeshipping_freeshipping","status":"CQFD_SUBMIT_FAIL","estimated_delivery_date":"Payment settlement failed","order_type":["New contract","Once-off purchase"],"image":["https://shopqa.vodacom.co.za/media/catalog/product/s/a/samsung-galaxy-note-20-ultra-5g-256gb-104050483-front-huge_cvlly2cwgz4nl3zd.png?width=75&height=75&quality=80&fit=bounds","https://shopqa.vodacom.co.za/media/catalog/product/s/a/samsung-galaxy-note-20-5g-256gb-104050480-front-huge_nvzokpxyjirtuc6k.png?width=75&height=75&quality=80&fit=bounds"],"view_order_history":"https://shopqa.vodacom.co.za/sales/order/view/order_id/27167","waybill_number":"E6220312","cancel_order_duration_in_minutes":0}]}}}');

/***/ }),

/***/ 95675:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"customerPlacedOrder":{"total_count":10,"page_info":{"page_size":6,"current_page":2,"total_pages":2},"allOrderRecords":[{"order_id":29652,"increment_id":"7000029377","customer_name":"LegacyStaff Andreas","grand_total":"R205.00","created_at":"2021-07-13 12:21:04","shipping_method":"tablerate_bestway","status":"MULTI_PAYMENT_SETTLE_FAILED","estimated_delivery_date":"Payment settlement failed","order_type":["Once-off purchase"],"image":["https://shopqa.vodacom.co.za/media/catalog/product/s/a/samsung-galaxy-note-20-ultra-5g-256gb-104050483-front-huge_cvlly2cwgz4nl3zd.png?width=75&height=75&quality=80&fit=bounds"],"view_order_history":"https://shopqa.vodacom.co.za/sales/order/view/order_id/29650","waybill_number":"E6222031","cancel_order_duration_in_minutes":0},{"order_id":29654,"increment_id":"7000029377","customer_name":"LegacyStaff Andreas","grand_total":"R205.00","created_at":"2021-07-13 12:21:04","shipping_method":"tablerate_bestway","status":"PAYMENT_SETTLED_SUCCESS","estimated_delivery_date":"","order_type":["Once-off purchase"],"image":["https://shopqa.vodacom.co.za/media/catalog/product/s/a/samsung-galaxy-note-20-ultra-5g-256gb-104050483-front-huge_cvlly2cwgz4nl3zd.png?width=75&height=75&quality=80&fit=bounds"],"view_order_history":"https://shopqa.vodacom.co.za/sales/order/view/order_id/29650","waybill_number":"E6222031","cancel_order_duration_in_minutes":0},{"order_id":29655,"increment_id":"7000029377","customer_name":"LegacyStaff Andreas","grand_total":"","monthly_recurring":"R1,037.99","created_at":"2021-07-13 12:21:04","shipping_method":"tablerate_bestway","status":"ORDER_COMPLETE_SUCCESS","estimated_delivery_date":"","order_type":["New contract"],"image":["https://shopqa.vodacom.co.za/media/catalog/product/s/a/samsung-galaxy-note-20-ultra-5g-256gb-104050483-front-huge_cvlly2cwgz4nl3zd.png?width=75&height=75&quality=80&fit=bounds"],"view_order_history":"https://shopqa.vodacom.co.za/sales/order/view/order_id/29650","waybill_number":"E6222031","cancel_order_duration_in_minutes":0},{"order_id":29656,"increment_id":"7000029377","customer_name":"LegacyStaff Andreas","grand_total":"R205.00","monthly_recurring":"R1,037.99","created_at":"2021-07-13 12:21:04","shipping_method":"tablerate_bestway","status":"ORDER_COMPLETE_SUCCESS","estimated_delivery_date":"","order_type":["New contract","Once-off purchase"],"image":["https://shopqa.vodacom.co.za/media/catalog/product/s/a/samsung-galaxy-note-20-ultra-5g-256gb-104050483-front-huge_cvlly2cwgz4nl3zd.png?width=75&height=75&quality=80&fit=bounds"],"view_order_history":"https://shopqa.vodacom.co.za/sales/order/view/order_id/29650","waybill_number":"E6222031","cancel_order_duration_in_minutes":0}]}}}');

/***/ }),

/***/ 13637:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"customerPlacedOrder":{"total_count":24,"page_info":{"page_size":6,"current_page":1,"total_pages":4},"allOrderRecords":[{"order_id":34905,"increment_id":"7000034614","customer_name":"Lily No last name","grand_total":"R0.00","monthly_recurring":"1499.000000","payment_terms":24,"created_at":"2021-08-17 14:35:55","shipping_method":"freeshipping_freeshipping","status":"ORDER_COMPLETE_SUCCESS","estimated_delivery_date":"","order_type":["Get this deal on a new contract"],"image":["https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png?quality=80&fit=bounds&height=75&width=75"],"primary_product_image":["https://shopqa.vodacom.co.za/media/catalog/product//h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg"],"view_order_history":"https://shopqa.vodacom.co.za/sales/order/view/order_id/34905","waybill_number":null,"cancel_order_duration_in_minutes":264},{"order_id":34872,"increment_id":"7000034581","customer_name":"Lily No last name","grand_total":"R0.00","monthly_recurring":"1499.000000","payment_terms":24,"created_at":"2021-08-17 10:26:51","shipping_method":"freeshipping_freeshipping","status":"CQFD_SUBMIT_FAIL","estimated_delivery_date":"","order_type":["Upgrade"],"image":["https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png?quality=80&fit=bounds&height=75&width=75"],"primary_product_image":["https://shopqa.vodacom.co.za/media/catalog/product//h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg"],"view_order_history":"https://shopqa.vodacom.co.za/sales/order/view/order_id/34872","waybill_number":null,"cancel_order_duration_in_minutes":15},{"order_id":33537,"increment_id":"7000033246","customer_name":"Lily No last name","grand_total":"R0.00","monthly_recurring":"1500.000000","payment_terms":36,"created_at":"2021-08-16 08:21:18","shipping_method":"freeshipping_freeshipping","status":"CQFD_SUBMIT_FAIL","estimated_delivery_date":"","order_type":["Upgrade"],"image":["https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png?quality=80&fit=bounds&height=75&width=75"],"primary_product_image":["https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"],"view_order_history":"https://shopqa.vodacom.co.za/sales/order/view/order_id/33537","waybill_number":null,"cancel_order_duration_in_minutes":0},{"order_id":33189,"increment_id":"7000032898","customer_name":"Lily No last name","grand_total":"R0.00","monthly_recurring":"1500.000000","created_at":"2021-08-12 14:13:38","shipping_method":"freeshipping_freeshipping","status":"CQFD_SUBMIT_FAIL_LEAD_FAIL","estimated_delivery_date":"","order_type":["Upgrade"],"image":["https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png?quality=80&fit=bounds&height=75&width=75"],"primary_product_image":["https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"],"view_order_history":"https://shopqa.vodacom.co.za/sales/order/view/order_id/33189","waybill_number":null,"cancel_order_duration_in_minutes":0},{"order_id":33180,"increment_id":"7000032889","customer_name":"Lily sunr","grand_total":"R0.00","monthly_recurring":"1500.000000","created_at":"2021-08-12 11:15:34","shipping_method":"freeshipping_freeshipping","status":"CQFD_SUBMIT_FAIL_LEAD_FAIL","estimated_delivery_date":"","order_type":["Upgrade"],"image":["https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png?quality=80&fit=bounds&height=75&width=75"],"primary_product_image":["https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"],"view_order_history":"https://shopqa.vodacom.co.za/sales/order/view/order_id/33180","waybill_number":null,"cancel_order_duration_in_minutes":0},{"order_id":33177,"increment_id":"7000032886","customer_name":"Lily No last name","grand_total":"R0.00","monthly_recurring":"1500.000000","created_at":"2021-08-12 10:55:09","shipping_method":"freeshipping_freeshipping","status":"CQFD_SUBMIT_FAIL_LEAD_FAIL","estimated_delivery_date":"","order_type":["Upgrade"],"image":["https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png?quality=80&fit=bounds&height=75&width=75"],"primary_product_image":["https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"],"view_order_history":"https://shopqa.vodacom.co.za/sales/order/view/order_id/33177","waybill_number":null,"cancel_order_duration_in_minutes":0}]}}}');

/***/ }),

/***/ 95093:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"customerPlacedOrder":{"total_count":38,"page_info":{"page_size":6,"current_page":1,"total_pages":7},"allOrderRecords":[{"order_id":46365,"increment_id":"7000045897","customer_name":"Lily Test","grand_total":"R0.00","monthly_recurring":"1499.000000","payment_terms":"16703","created_at":"2021-08-20 14:09:04","shipping_method":"freeshipping_freeshipping","status":"CQFD_SUBMIT_FAIL","estimated_delivery_date":"","order_type":["Upgrade"],"image":["https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png?quality=80&fit=bounds&height=75&width=75"],"primary_product_image":["https://shopqa.vodacom.co.za/media/catalog/product//h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg"],"view_order_history":"https://shopqa.vodacom.co.za/sales/order/view/order_id/46365","cancel_order_duration_in_minutes":0,"waybill_number":null},{"order_id":46347,"increment_id":"7000045879","customer_name":"Lily No last name","grand_total":"R0.00","monthly_recurring":"1499.000000","payment_terms":"16703","created_at":"2021-08-20 13:30:01","shipping_method":"freeshipping_freeshipping","status":"CQFD_SUBMIT_FAIL","estimated_delivery_date":"","order_type":["Upgrade"],"image":["https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png?quality=80&fit=bounds&height=75&width=75"],"primary_product_image":["https://shopqa.vodacom.co.za/media/catalog/product//h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg"],"view_order_history":"https://shopqa.vodacom.co.za/sales/order/view/order_id/46347","cancel_order_duration_in_minutes":0,"waybill_number":null},{"order_id":46335,"increment_id":"7000045867","customer_name":"Lily No last name","grand_total":"R0.00","monthly_recurring":"1499.000000","payment_terms":"16703","created_at":"2021-08-20 12:23:48","shipping_method":"freeshipping_freeshipping","status":"CQFD_SUBMIT_FAIL","estimated_delivery_date":"","order_type":["New Contract"],"image":["https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png?quality=80&fit=bounds&height=75&width=75"],"primary_product_image":["https://shopqa.vodacom.co.za/media/catalog/product//h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg"],"view_order_history":"https://shopqa.vodacom.co.za/sales/order/view/order_id/46335","cancel_order_duration_in_minutes":0,"waybill_number":null},{"order_id":46332,"increment_id":"7000045864","customer_name":"Lily No last name","grand_total":"R0.00","monthly_recurring":"1499.000000","payment_terms":"16703","created_at":"2021-08-20 12:01:11","shipping_method":"freeshipping_freeshipping","status":"CQFD_SUBMIT_FAIL","estimated_delivery_date":"","order_type":["Upgrade"],"image":["https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png?quality=80&fit=bounds&height=75&width=75"],"primary_product_image":["https://shopqa.vodacom.co.za/media/catalog/product//h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg"],"view_order_history":"https://shopqa.vodacom.co.za/sales/order/view/order_id/46332","cancel_order_duration_in_minutes":0,"waybill_number":null},{"order_id":46302,"increment_id":"7000045834","customer_name":"Lily No last name","grand_total":"R0.00","monthly_recurring":"1499.000000","payment_terms":"16703","created_at":"2021-08-20 11:18:51","shipping_method":"freeshipping_freeshipping","status":"CQFD_SUBMIT_FAIL","estimated_delivery_date":"","order_type":["Upgrade"],"image":["https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png?quality=80&fit=bounds&height=75&width=75"],"primary_product_image":["https://shopqa.vodacom.co.za/media/catalog/product//h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg"],"view_order_history":"https://shopqa.vodacom.co.za/sales/order/view/order_id/46302","cancel_order_duration_in_minutes":0,"waybill_number":null},{"order_id":46254,"increment_id":"7000045786","customer_name":"Lily No last name","grand_total":"R0.00","monthly_recurring":"","payment_terms":"","created_at":"2021-08-20 07:01:45","shipping_method":"freeshipping_freeshipping","status":"CREATE_EPPIX_FAILED","estimated_delivery_date":"","order_type":["Once-off purchase"],"image":["https://shopqa.vodacom.co.za/media/catalog/product/h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg?width=75&height=75&quality=80&fit=bounds"],"primary_product_image":[],"view_order_history":"https://shopqa.vodacom.co.za/sales/order/view/order_id/46254","cancel_order_duration_in_minutes":0,"waybill_number":null}]}}}');

/***/ }),

/***/ 3628:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"products":{"total_count":86,"page_info":{"page_size":20,"current_page":1,"total_pages":5},"items":[{"name":"2 x Apple Iphone 11 PRO","quantity":0,"bundle_product_price":null,"promotion_tag_swatch":null,"badges_swatch":null,"sku":"apple_bogo-1","badges":16613,"badges_label":"2 For 1","stock_status":"IN_STOCK","low_stock_threshold":5,"display_low_stock_badge":0,"deal_go_live_date":"","deal_end_date":"","deal_label":null,"is_deal_locked":0,"categories":[{"id":26,"name":"Phones & SIM","url_key":"phones-sim","image":"https://shopqa.vodacom.co.za/media/catalog/category/Phone_SIM.png"},{"id":29,"name":"Smartphones","url_key":"smartphones","image":null}],"__typename":"BundleProduct","price_range":{"minimum_price":{"regular_price":{"value":17999,"currency":"ZAR"},"final_price":{"value":17999,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":17999,"currency":"ZAR"},"final_price":{"value":17999,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/i/m/images_1.jpg?quality=80&fit=bounds&height=&width="},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/i/m/images_1.jpg?quality=80&fit=bounds&height=&width="}},{"name":"iPad Pro 12.9 inch WiFi & Cellular (128GB)","quantity":0,"bundle_product_price":null,"promotion_tag_swatch":null,"badges_swatch":null,"sku":"ipad_pro_12.9_inch_wifi_&_cellular_(128gb)","badges":null,"badges_label":null,"stock_status":"OUT_OF_STOCK","low_stock_threshold":5,"display_low_stock_badge":0,"deal_go_live_date":"","deal_end_date":"","deal_label":null,"is_deal_locked":0,"categories":[{"id":77,"name":"Tablets & Laptops","url_key":"tablets-laptops","image":"https://shopqa.vodacom.co.za/media/catalog/category/Tablets_laptop_1.png"},{"id":92,"name":"Tablets","url_key":"tablets","image":null}],"variants":[{"product":{"id":28550,"name":"12.9-INCH IPAD PRO WI-FI + CELLULAR 128GB 4TH EDITION SPACE GREY","quantity":0,"sku":"108018221","stock_status":"OUT_OF_STOCK","price_range":{"minimum_price":{"regular_price":{"value":23899,"currency":"ZAR"},"final_price":{"value":23899,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":23899,"currency":"ZAR"},"final_price":{"value":23899,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"128GB","code":"internal_storage","value_index":16411}]}],"__typename":"ConfigurableProduct","price_range":{"minimum_price":{"regular_price":{"value":0,"currency":"ZAR"},"final_price":{"value":23899,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":23899,"currency":"ZAR"},"final_price":{"value":23899,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}},{"name":"APPLE IPHONE 5S","quantity":0,"bundle_product_price":null,"promotion_tag_swatch":null,"badges_swatch":null,"sku":"202012043","badges":null,"badges_label":null,"stock_status":"IN_STOCK","low_stock_threshold":5,"display_low_stock_badge":0,"deal_go_live_date":"","deal_end_date":"","deal_label":null,"is_deal_locked":0,"categories":[{"id":26,"name":"Phones & SIM","url_key":"phones-sim","image":"https://shopqa.vodacom.co.za/media/catalog/category/Phone_SIM.png"},{"id":29,"name":"Smartphones","url_key":"smartphones","image":null}],"variants":[{"product":{"id":253871,"name":"APPLE IPHONE 5S 32GB CPO SPACE GREY","quantity":40,"sku":"202012031","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":5,"currency":"ZAR"},"final_price":{"value":5,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":5,"currency":"ZAR"},"final_price":{"value":5,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Black","code":"color","value_index":16321},{"label":"128GB","code":"internal_storage","value_index":16411}]},{"product":{"id":253874,"name":"APPLE IPHONE 5S 32GB CPO SILVER","quantity":0,"sku":"202012032","stock_status":"OUT_OF_STOCK","price_range":{"minimum_price":{"regular_price":{"value":1500,"currency":"ZAR"},"final_price":{"value":1500,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":1500,"currency":"ZAR"},"final_price":{"value":1500,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Gray","code":"color","value_index":16840},{"label":"512GB","code":"internal_storage","value_index":16649}]},{"product":{"id":253883,"name":"APPLE IPHONE 5S 32GB CPO SPACE GREY","quantity":100,"sku":"202012035","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":7,"currency":"ZAR"},"final_price":{"value":7,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":7,"currency":"ZAR"},"final_price":{"value":7,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Black ","code":"color","value_index":16816},{"label":"64GB","code":"internal_storage","value_index":16417}]}],"__typename":"ConfigurableProduct","price_range":{"minimum_price":{"regular_price":{"value":5,"currency":"ZAR"},"final_price":{"value":5,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":1500,"currency":"ZAR"},"final_price":{"value":1500,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png"},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}},{"name":"Lenovo L340 i7 Gaming Notebook Black","quantity":0,"bundle_product_price":null,"promotion_tag_swatch":null,"badges_swatch":null,"sku":"Lenovo_L340_i7_Gaming_Notebook_Black","badges":null,"badges_label":null,"stock_status":"IN_STOCK","low_stock_threshold":5,"display_low_stock_badge":0,"deal_go_live_date":"","deal_end_date":"","deal_label":null,"is_deal_locked":0,"categories":[{"id":77,"name":"Tablets & Laptops","url_key":"tablets-laptops","image":"https://shopqa.vodacom.co.za/media/catalog/category/Tablets_laptop_1.png"},{"id":89,"name":"Gaming Laptops","url_key":"gaming-laptops","image":null}],"variants":[{"product":{"id":31247,"name":"LENOVO L340 I7 GAMING NOTEBOOK BLACK","quantity":996,"sku":"108019123","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":26099,"currency":"ZAR"},"final_price":{"value":26099,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":26099,"currency":"ZAR"},"final_price":{"value":26099,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"1920 x 1080","code":"screen_size_pixels","value_index":17086},{"label":"1TB","code":"internal_storage","value_index":16655}]}],"__typename":"ConfigurableProduct","price_range":{"minimum_price":{"regular_price":{"value":26099,"currency":"ZAR"},"final_price":{"value":26099,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":26099,"currency":"ZAR"},"final_price":{"value":26099,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/4/6/465733_1_1_uv1vwjweqtasc2p8.jpg?quality=80&fit=bounds&height=&width="},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}},{"name":"Lenovo Ideapad Celeron ","quantity":0,"bundle_product_price":null,"promotion_tag_swatch":null,"badges_swatch":null,"sku":"Lenovo_Ideapad_Celeron","badges":null,"badges_label":null,"stock_status":"OUT_OF_STOCK","low_stock_threshold":5,"display_low_stock_badge":0,"deal_go_live_date":"","deal_end_date":"","deal_label":null,"is_deal_locked":0,"categories":[{"id":77,"name":"Tablets & Laptops","url_key":"tablets-laptops","image":"https://shopqa.vodacom.co.za/media/catalog/category/Tablets_laptop_1.png"},{"id":92,"name":"Tablets","url_key":"tablets","image":null}],"variants":[{"product":{"id":30908,"name":"LENOVO IDEAPAD CELERON","quantity":967,"sku":"102065664","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":6699,"currency":"ZAR"},"final_price":{"value":6699,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":6699,"currency":"ZAR"},"final_price":{"value":6699,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"200 nits 16:9 aspect ratio","code":"screen_size_pixels","value_index":18098},{"label":"500GB","code":"internal_storage","value_index":18095}]}],"__typename":"ConfigurableProduct","price_range":{"minimum_price":{"regular_price":{"value":6699,"currency":"ZAR"},"final_price":{"value":6699,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":6699,"currency":"ZAR"},"final_price":{"value":6699,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/l/e/lenovo.jpg?quality=80&fit=bounds&height=&width="},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/l/e/lenovo.jpg?quality=80&fit=bounds&height=&width="}},{"name":"HP 15 CeleronNotebooks","quantity":0,"bundle_product_price":null,"promotion_tag_swatch":null,"badges_swatch":null,"sku":"HP_15_Celeron_Notebooks","badges":null,"badges_label":null,"stock_status":"IN_STOCK","low_stock_threshold":5,"display_low_stock_badge":0,"deal_go_live_date":"","deal_end_date":"","deal_label":null,"is_deal_locked":0,"categories":[{"id":77,"name":"Tablets & Laptops","url_key":"tablets-laptops","image":"https://shopqa.vodacom.co.za/media/catalog/category/Tablets_laptop_1.png"},{"id":80,"name":"Basic Laptops","url_key":"basic-laptops","image":null}],"variants":[{"product":{"id":29606,"name":"HP 15 CELERON WITH WIN 10","quantity":9058,"sku":"102054091","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":6899,"currency":"ZAR"},"final_price":{"value":5,"currency":"ZAR"},"discount":{"amount_off":6894,"percent_off":99.93}},"maximum_price":{"regular_price":{"value":6899,"currency":"ZAR"},"final_price":{"value":5,"currency":"ZAR"},"discount":{"amount_off":6894,"percent_off":99.93}}}},"attributes":[{"label":"15.6\'\'","code":"screen_size_pixels","value_index":18056},{"label":"500GB","code":"internal_storage","value_index":18095}]}],"__typename":"ConfigurableProduct","price_range":{"minimum_price":{"regular_price":{"value":6899,"currency":"ZAR"},"final_price":{"value":5,"currency":"ZAR"},"discount":{"amount_off":6894,"percent_off":99.93}},"maximum_price":{"regular_price":{"value":6899,"currency":"ZAR"},"final_price":{"value":5,"currency":"ZAR"},"discount":{"amount_off":6894,"percent_off":99.93}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/h/p/hp-2_fufbswu3xy1hrpjt.jpg?quality=80&fit=bounds&height=&width="},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/h/p/hp-2_fufbswu3xy1hrpjt.jpg?quality=80&fit=bounds&height=&width="}},{"name":"HUAWEI P40 Pro+","quantity":0,"bundle_product_price":null,"promotion_tag_swatch":null,"badges_swatch":null,"sku":"huawei_p40_pro+","badges":null,"badges_label":null,"stock_status":"OUT_OF_STOCK","low_stock_threshold":5,"display_low_stock_badge":0,"deal_go_live_date":"","deal_end_date":"","deal_label":null,"is_deal_locked":0,"categories":[{"id":26,"name":"Phones & SIM","url_key":"phones-sim","image":"https://shopqa.vodacom.co.za/media/catalog/category/Phone_SIM.png"},{"id":29,"name":"Smartphones","url_key":"smartphones","image":null},{"id":38,"name":"Wearable Tech","url_key":"wearable-tech","image":"https://shopqa.vodacom.co.za/media/catalog/category/Wearable_tech.png"},{"id":95,"name":"Smart watches","url_key":"smart-watches","image":null}],"variants":[{"product":{"id":30965,"name":"HUAWEI P40 PRO+ 5G (AG)","quantity":999,"sku":"104050268","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":23999,"currency":"ZAR"},"final_price":{"value":23999,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":23999,"currency":"ZAR"},"final_price":{"value":23999,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Black Ceramic","code":"color","value_index":17734},{"label":"8GB RAM + 512GB ROM","code":"internal_storage","value_index":18788}]}],"__typename":"ConfigurableProduct","price_range":{"minimum_price":{"regular_price":{"value":23999,"currency":"ZAR"},"final_price":{"value":23999,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":23999,"currency":"ZAR"},"final_price":{"value":23999,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/h/u/huawei-p40-pro--104050268-front-huge_u9ggvi5lwjw8tv2u.png?quality=80&fit=bounds&height=&width="},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}},{"name":"Huawei Watch Fit","quantity":0,"bundle_product_price":null,"promotion_tag_swatch":null,"badges_swatch":null,"sku":"Huawei_Watch_Fit","badges":null,"badges_label":null,"stock_status":"IN_STOCK","low_stock_threshold":5,"display_low_stock_badge":0,"deal_go_live_date":"","deal_end_date":"","deal_label":null,"is_deal_locked":0,"categories":[{"id":38,"name":"Wearable Tech","url_key":"wearable-tech","image":"https://shopqa.vodacom.co.za/media/catalog/category/Wearable_tech.png"},{"id":95,"name":"Smart watches","url_key":"smart-watches","image":null}],"variants":[{"product":{"id":254071,"name":"Huawei Black fit","quantity":10000,"sku":"102078040-1","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":100,"currency":"ZAR"},"final_price":{"value":100,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":100,"currency":"ZAR"},"final_price":{"value":100,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Black ","code":"color","value_index":16816}]}],"__typename":"ConfigurableProduct","price_range":{"minimum_price":{"regular_price":{"value":100,"currency":"ZAR"},"final_price":{"value":100,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":100,"currency":"ZAR"},"final_price":{"value":100,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/4/6/467335_1.jpg?quality=80&fit=bounds&height=&width="},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}},{"name":"Samsung Galaxy A3 Core","quantity":0,"bundle_product_price":null,"promotion_tag_swatch":null,"badges_swatch":null,"sku":"Samsung_Galaxy_A3_Core","badges":null,"badges_label":null,"stock_status":"OUT_OF_STOCK","low_stock_threshold":5,"display_low_stock_badge":0,"deal_go_live_date":"","deal_end_date":"","deal_label":null,"is_deal_locked":0,"categories":[{"id":26,"name":"Phones & SIM","url_key":"phones-sim","image":"https://shopqa.vodacom.co.za/media/catalog/category/Phone_SIM.png"},{"id":29,"name":"Smartphones","url_key":"smartphones","image":null}],"variants":[{"product":{"id":30959,"name":"SAMSUNG GALAXY A3 CORE BLACK 16GB","quantity":0,"sku":"104049957","stock_status":"OUT_OF_STOCK","price_range":{"minimum_price":{"regular_price":{"value":1699,"currency":"ZAR"},"final_price":{"value":1699,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":1699,"currency":"ZAR"},"final_price":{"value":1699,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Black","code":"color","value_index":16321},{"label":"1GB RAM, 16GB ROM","code":"internal_storage","value_index":18920}]},{"product":{"id":31238,"name":"SAMSUNG GALAXY A3 CORE BLUE 16GB","quantity":999,"sku":"104049958","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":1699,"currency":"ZAR"},"final_price":{"value":1699,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":1699,"currency":"ZAR"},"final_price":{"value":1699,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Blue","code":"color","value_index":16345},{"label":"1GB RAM, 16GB ROM","code":"internal_storage","value_index":18920}]}],"__typename":"ConfigurableProduct","price_range":{"minimum_price":{"regular_price":{"value":1699,"currency":"ZAR"},"final_price":{"value":1699,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":1699,"currency":"ZAR"},"final_price":{"value":1699,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/4/6/466488_1.jpg?quality=80&fit=bounds&height=&width="},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}},{"name":"Samsung Galaxy A2 Core","quantity":0,"bundle_product_price":null,"promotion_tag_swatch":null,"badges_swatch":null,"sku":"Samsung_Galaxy_A2_Core","badges":null,"badges_label":null,"stock_status":"OUT_OF_STOCK","low_stock_threshold":5,"display_low_stock_badge":0,"deal_go_live_date":"","deal_end_date":"","deal_label":null,"is_deal_locked":0,"categories":[{"id":26,"name":"Phones & SIM","url_key":"phones-sim","image":"https://shopqa.vodacom.co.za/media/catalog/category/Phone_SIM.png"},{"id":29,"name":"Smartphones","url_key":"smartphones","image":null}],"variants":[{"product":{"id":30530,"name":"SAMSUNG GALAXY A2 CORE BLACK","quantity":999,"sku":"104044150","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":1349,"currency":"ZAR"},"final_price":{"value":1349,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":1349,"currency":"ZAR"},"final_price":{"value":1349,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Dark Grey","code":"color","value_index":17179},{"label":"1GB RAM/8GB ROM","code":"internal_storage","value_index":18581}]},{"product":{"id":30527,"name":"SAMSUNG GALAXY A2 CORE BLUE","quantity":999,"sku":"104044149","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":1349,"currency":"ZAR"},"final_price":{"value":1349,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":1349,"currency":"ZAR"},"final_price":{"value":1349,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Blue","code":"color","value_index":16345},{"label":"1GB RAM/8GB ROM","code":"internal_storage","value_index":18581}]}],"__typename":"ConfigurableProduct","price_range":{"minimum_price":{"regular_price":{"value":1349,"currency":"ZAR"},"final_price":{"value":1349,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":1349,"currency":"ZAR"},"final_price":{"value":1349,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/4/6/461021_1.jpg?quality=80&fit=bounds&height=&width="},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}},{"name":"Samsung Galaxy A10","quantity":0,"bundle_product_price":null,"promotion_tag_swatch":null,"badges_swatch":null,"sku":"Samsung_Galaxy_A10","badges":null,"badges_label":null,"stock_status":"OUT_OF_STOCK","low_stock_threshold":5,"display_low_stock_badge":0,"deal_go_live_date":"","deal_end_date":"","deal_label":null,"is_deal_locked":0,"categories":[{"id":26,"name":"Phones & SIM","url_key":"phones-sim","image":"https://shopqa.vodacom.co.za/media/catalog/category/Phone_SIM.png"},{"id":29,"name":"Smartphones","url_key":"smartphones","image":null}],"variants":[{"product":{"id":30035,"name":"SAMSUNG GALAXY A10 BLACK","quantity":999,"sku":"104044531","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":2699,"currency":"ZAR"},"final_price":{"value":2699,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":2699,"currency":"ZAR"},"final_price":{"value":2699,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Black","code":"color","value_index":16321},{"label":"2GB RAM /32GB ROM","code":"internal_storage","value_index":18533}]},{"product":{"id":30038,"name":"SAMSUNG GALAXY A10 BLUE","quantity":999,"sku":"104044532","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":2699,"currency":"ZAR"},"final_price":{"value":2699,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":2699,"currency":"ZAR"},"final_price":{"value":2699,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Blue","code":"color","value_index":16345},{"label":"2GB RAM /32GB ROM","code":"internal_storage","value_index":18533}]}],"__typename":"ConfigurableProduct","price_range":{"minimum_price":{"regular_price":{"value":2699,"currency":"ZAR"},"final_price":{"value":2699,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":2699,"currency":"ZAR"},"final_price":{"value":2699,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/4/6/461342_1.jpg?quality=80&fit=bounds&height=&width="},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}},{"name":"Huawei Y7 2019","quantity":0,"bundle_product_price":null,"promotion_tag_swatch":null,"badges_swatch":null,"sku":"Huawei_Y7_2019","badges":null,"badges_label":null,"stock_status":"OUT_OF_STOCK","low_stock_threshold":5,"display_low_stock_badge":null,"deal_go_live_date":"","deal_end_date":"","deal_label":null,"is_deal_locked":0,"categories":[{"id":26,"name":"Phones & SIM","url_key":"phones-sim","image":"https://shopqa.vodacom.co.za/media/catalog/category/Phone_SIM.png"},{"id":29,"name":"Smartphones","url_key":"smartphones","image":null}],"variants":[{"product":{"id":28334,"name":"HUAWEI Y7 2019 AURORA BLUE","quantity":999,"sku":"104043581","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":2999,"currency":"ZAR"},"final_price":{"value":2999,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":2999,"currency":"ZAR"},"final_price":{"value":2999,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Aurora Blue","code":"color","value_index":17239},{"label":"ROM: 32GB, RAM: 3GB","code":"internal_storage","value_index":18971}]},{"product":{"id":28337,"name":"HUAWEI Y7 2019 MIDNIGHT BLACK","quantity":999,"sku":"104043583","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":2799,"currency":"ZAR"},"final_price":{"value":2799,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":2799,"currency":"ZAR"},"final_price":{"value":2799,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Midnight Black","code":"color","value_index":16945},{"label":"ROM: 32GB, RAM: 3GB","code":"internal_storage","value_index":18971}]}],"__typename":"ConfigurableProduct","price_range":{"minimum_price":{"regular_price":{"value":2799,"currency":"ZAR"},"final_price":{"value":2799,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":2999,"currency":"ZAR"},"final_price":{"value":2999,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/4/6/460392_1.jpg?quality=80&fit=bounds&height=&width="},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}},{"name":"Huawei Y6 2019","quantity":0,"bundle_product_price":null,"promotion_tag_swatch":null,"badges_swatch":null,"sku":"Huawei_Y6_2019","badges":null,"badges_label":null,"stock_status":"OUT_OF_STOCK","low_stock_threshold":5,"display_low_stock_badge":null,"deal_go_live_date":"","deal_end_date":"","deal_label":null,"is_deal_locked":0,"categories":[{"id":26,"name":"Phones & SIM","url_key":"phones-sim","image":"https://shopqa.vodacom.co.za/media/catalog/category/Phone_SIM.png"},{"id":29,"name":"Smartphones","url_key":"smartphones","image":null}],"variants":[{"product":{"id":28343,"name":"HUAWEI Y6 2019 AMBER BROWN","quantity":999,"sku":"104043587","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":2399,"currency":"ZAR"},"final_price":{"value":2399,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":2399,"currency":"ZAR"},"final_price":{"value":2399,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Amber Brown","code":"color","value_index":16933},{"label":"32GB ROM 2GB RAM","code":"internal_storage","value_index":18347}]},{"product":{"id":28346,"name":"HUAWEI Y6 2019 MIDNIGHT BLACK","quantity":999,"sku":"104043588","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":2399,"currency":"ZAR"},"final_price":{"value":2399,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":2399,"currency":"ZAR"},"final_price":{"value":2399,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Midnight Black","code":"color","value_index":16945},{"label":"32GB ROM 2GB RAM","code":"internal_storage","value_index":18347}]}],"__typename":"ConfigurableProduct","price_range":{"minimum_price":{"regular_price":{"value":2399,"currency":"ZAR"},"final_price":{"value":2399,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":2399,"currency":"ZAR"},"final_price":{"value":2399,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/4/6/460634_1.jpg?quality=80&fit=bounds&height=&width="},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}},{"name":"Hisense E40","quantity":0,"bundle_product_price":null,"promotion_tag_swatch":null,"badges_swatch":null,"sku":"Hisense_E40\\"","badges":null,"badges_label":null,"stock_status":"IN_STOCK","low_stock_threshold":5,"display_low_stock_badge":0,"deal_go_live_date":"","deal_end_date":"","deal_label":null,"is_deal_locked":0,"categories":[{"id":26,"name":"Phones & SIM","url_key":"phones-sim","image":"https://shopqa.vodacom.co.za/media/catalog/category/Phone_SIM.png"},{"id":29,"name":"Smartphones","url_key":"smartphones","image":null}],"variants":[{"product":{"id":30374,"name":"HISENSE E40 AQUA BLUE","quantity":999,"sku":"104048862","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":2499,"currency":"ZAR"},"final_price":{"value":2499,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":2499,"currency":"ZAR"},"final_price":{"value":2499,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Aqua","code":"color","value_index":17944},{"label":"1GB RAM; 8GB ROM","code":"internal_storage","value_index":19082}]},{"product":{"id":30371,"name":"HISENSE E40 CHARCOAL","quantity":0,"sku":"104048861","stock_status":"OUT_OF_STOCK","price_range":{"minimum_price":{"regular_price":{"value":2499,"currency":"ZAR"},"final_price":{"value":2499,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":2499,"currency":"ZAR"},"final_price":{"value":2499,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"CHARCOAL","code":"color","value_index":16802},{"label":"2GB RAM + 32GB RAM","code":"internal_storage","value_index":18545}]}],"__typename":"ConfigurableProduct","price_range":{"minimum_price":{"regular_price":{"value":2499,"currency":"ZAR"},"final_price":{"value":2499,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":2499,"currency":"ZAR"},"final_price":{"value":2499,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/4/6/464666_1.jpg?quality=80&fit=bounds&height=&width="},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}},{"name":"vivo X50","quantity":0,"bundle_product_price":null,"promotion_tag_swatch":null,"badges_swatch":null,"sku":"vivo_x50","badges":null,"badges_label":null,"stock_status":"IN_STOCK","low_stock_threshold":5,"display_low_stock_badge":0,"deal_go_live_date":"2021-02-05 09:09:00","deal_end_date":"2021-02-06 08:54:00","deal_label":"Ends In:","is_deal_locked":0,"categories":[{"id":26,"name":"Phones & SIM","url_key":"phones-sim","image":"https://shopqa.vodacom.co.za/media/catalog/category/Phone_SIM.png"},{"id":29,"name":"Smartphones","url_key":"smartphones","image":null}],"variants":[{"product":{"id":30938,"name":"VIVO X50 5G FROST BLUE","quantity":0,"sku":"104049894","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":14799,"currency":"ZAR"},"final_price":{"value":14799,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":14799,"currency":"ZAR"},"final_price":{"value":14799,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Light Blue","code":"color","value_index":17125},{"label":"1GB RAM; 8GB ROM","code":"internal_storage","value_index":19082}]},{"product":{"id":31043,"name":"VIVO X50 5G GLAZE BLACK","quantity":996,"sku":"104049899","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":14799,"currency":"ZAR"},"final_price":{"value":14799,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":14799,"currency":"ZAR"},"final_price":{"value":14799,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Black","code":"color","value_index":16321},{"label":"128GB","code":"internal_storage","value_index":16411}]}],"__typename":"ConfigurableProduct","price_range":{"minimum_price":{"regular_price":{"value":14799,"currency":"ZAR"},"final_price":{"value":14799,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":14799,"currency":"ZAR"},"final_price":{"value":14799,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/v/i/vivo-x50-104049899-front-huge_m8pfwahq3qgd6qji_b6aijk7fyub8tdzu.png?quality=80&fit=bounds&height=&width="},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}},{"name":"Samsung Galaxy Z Fold2 5G","quantity":0,"bundle_product_price":null,"promotion_tag_swatch":null,"badges_swatch":null,"sku":"samsung_galaxy_zfold2_5g","badges":null,"badges_label":null,"stock_status":"OUT_OF_STOCK","low_stock_threshold":5,"display_low_stock_badge":0,"deal_go_live_date":"","deal_end_date":"","deal_label":null,"is_deal_locked":0,"categories":[{"id":26,"name":"Phones & SIM","url_key":"phones-sim","image":"https://shopqa.vodacom.co.za/media/catalog/category/Phone_SIM.png"},{"id":29,"name":"Smartphones","url_key":"smartphones","image":null}],"variants":[{"product":{"id":31037,"name":"Samsung Galaxy z Fold2 5G 256GB Mystic Black","quantity":999,"sku":"104050693","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":44999,"currency":"ZAR"},"final_price":{"value":44999,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":44999,"currency":"ZAR"},"final_price":{"value":44999,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Mystic Black","code":"color","value_index":17209},{"label":"12GB RAM, 256GB ROM","code":"internal_storage","value_index":18605}]},{"product":{"id":31055,"name":"Samsung Galaxy z Fold2 5G 256GB Mystic Bronze","quantity":999,"sku":"104050694","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":44999,"currency":"ZAR"},"final_price":{"value":44999,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":44999,"currency":"ZAR"},"final_price":{"value":44999,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Mystic Bronze","code":"color","value_index":17380},{"label":"12GB RAM, 256GB ROM","code":"internal_storage","value_index":18605}]}],"__typename":"ConfigurableProduct","price_range":{"minimum_price":{"regular_price":{"value":44999,"currency":"ZAR"},"final_price":{"value":44999,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":44999,"currency":"ZAR"},"final_price":{"value":44999,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/4/6/467413_1.jpg?quality=80&fit=bounds&height=&width="},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}},{"name":"Samsung Galaxy Z Flip 256GB","quantity":0,"bundle_product_price":null,"promotion_tag_swatch":null,"badges_swatch":null,"sku":"samsung_galaxy_z_flip_256gb","badges":null,"badges_label":null,"stock_status":"OUT_OF_STOCK","low_stock_threshold":5,"display_low_stock_badge":0,"deal_go_live_date":"","deal_end_date":"","deal_label":null,"is_deal_locked":0,"categories":[{"id":26,"name":"Phones & SIM","url_key":"phones-sim","image":"https://shopqa.vodacom.co.za/media/catalog/category/Phone_SIM.png"},{"id":29,"name":"Smartphones","url_key":"smartphones","image":null}],"variants":[{"product":{"id":30179,"name":"SAMSUNG GALAXY Z FLIP 256GB BLACK MIRROR","quantity":999,"sku":"104048114","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":31499,"currency":"ZAR"},"final_price":{"value":31499,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":31499,"currency":"ZAR"},"final_price":{"value":31499,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Mirror Black","code":"color","value_index":17203},{"label":"8 + 256GB","code":"internal_storage","value_index":18593}]},{"product":{"id":30176,"name":"SAMSUNG GALAXY Z FLIP 256GB PURPLE MIRROR","quantity":999,"sku":"104048113","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":31499,"currency":"ZAR"},"final_price":{"value":31499,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":31499,"currency":"ZAR"},"final_price":{"value":31499,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Mirror Purple","code":"color","value_index":17905},{"label":"8 + 256GB","code":"internal_storage","value_index":18593}]}],"__typename":"ConfigurableProduct","price_range":{"minimum_price":{"regular_price":{"value":31499,"currency":"ZAR"},"final_price":{"value":31499,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":31499,"currency":"ZAR"},"final_price":{"value":31499,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/4/6/464519_1.jpg?quality=80&fit=bounds&height=&width="},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}},{"name":"Samsung Galaxy J4 Core (SM-J415)","quantity":0,"bundle_product_price":null,"promotion_tag_swatch":null,"badges_swatch":null,"sku":"samsung_galaxy_j4_core_(sm-j415)","badges":null,"badges_label":null,"stock_status":"OUT_OF_STOCK","low_stock_threshold":5,"display_low_stock_badge":0,"deal_go_live_date":"","deal_end_date":"","deal_label":null,"is_deal_locked":0,"categories":[{"id":26,"name":"Phones & SIM","url_key":"phones-sim","image":"https://shopqa.vodacom.co.za/media/catalog/category/Phone_SIM.png"},{"id":29,"name":"Smartphones","url_key":"smartphones","image":null}],"variants":[{"product":{"id":29279,"name":"SAMSUNG GALAXY J4 CORE BLACK","quantity":999,"sku":"104043290","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":2299,"currency":"ZAR"},"final_price":{"value":2299,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":2299,"currency":"ZAR"},"final_price":{"value":2299,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Black","code":"color","value_index":16321},{"label":"1GB RAM / 16GB ROM","code":"internal_storage","value_index":18548}]},{"product":{"id":29282,"name":"SAMSUNG GALAXY J4 CORE GOLD","quantity":999,"sku":"104043291","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":2299,"currency":"ZAR"},"final_price":{"value":2299,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":2299,"currency":"ZAR"},"final_price":{"value":2299,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Gold","code":"color","value_index":16646},{"label":"1GB RAM / 16GB ROM","code":"internal_storage","value_index":18548}]}],"__typename":"ConfigurableProduct","price_range":{"minimum_price":{"regular_price":{"value":2299,"currency":"ZAR"},"final_price":{"value":2299,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":2299,"currency":"ZAR"},"final_price":{"value":2299,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/s/a/samsung-galaxy-j4-core--sm-j415--104043291-front-huge_vjfnldxfn5jpbor4.png?quality=80&fit=bounds&height=&width="},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}},{"name":"Samsung Galaxy A71 128GB","quantity":0,"bundle_product_price":null,"promotion_tag_swatch":null,"badges_swatch":null,"sku":"samsung_galaxy_a71_128gb","badges":null,"badges_label":null,"stock_status":"OUT_OF_STOCK","low_stock_threshold":5,"display_low_stock_badge":0,"deal_go_live_date":"","deal_end_date":"","deal_label":null,"is_deal_locked":0,"categories":[{"id":26,"name":"Phones & SIM","url_key":"phones-sim","image":"https://shopqa.vodacom.co.za/media/catalog/category/Phone_SIM.png"},{"id":29,"name":"Smartphones","url_key":"smartphones","image":null}],"variants":[{"product":{"id":30539,"name":"SAMSUNG GALAXY A71 PRISM CRUSH BLACK","quantity":0,"sku":"104047466","stock_status":"OUT_OF_STOCK","price_range":{"minimum_price":{"regular_price":{"value":9399,"currency":"ZAR"},"final_price":{"value":9399,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":9399,"currency":"ZAR"},"final_price":{"value":9399,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Prism Crush Black","code":"color","value_index":17665},{"label":"6GB RAM + 128GB ROM","code":"internal_storage","value_index":18692}]},{"product":{"id":30197,"name":"SAMSUNG GALAXY A71 PRISM CRUSH BLUE","quantity":0,"sku":"104047467","stock_status":"OUT_OF_STOCK","price_range":{"minimum_price":{"regular_price":{"value":9399,"currency":"ZAR"},"final_price":{"value":9399,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":9399,"currency":"ZAR"},"final_price":{"value":9399,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Prism Crush Blue","code":"color","value_index":17803},{"label":"6GB RAM + 128GB ROM","code":"internal_storage","value_index":18692}]},{"product":{"id":30200,"name":"SAMSUNG GALAXY A71 PRISM CRUSH SILVER","quantity":0,"sku":"104047468","stock_status":"OUT_OF_STOCK","price_range":{"minimum_price":{"regular_price":{"value":9399,"currency":"ZAR"},"final_price":{"value":9399,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":9399,"currency":"ZAR"},"final_price":{"value":9399,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Prism Crush Silver","code":"color","value_index":17752},{"label":"6GB RAM + 128GB ROM","code":"internal_storage","value_index":18692}]}],"__typename":"ConfigurableProduct","price_range":{"minimum_price":{"regular_price":{"value":0,"currency":"ZAR"},"final_price":{"value":9399,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":9399,"currency":"ZAR"},"final_price":{"value":9399,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/s/a/samsung-galaxy-a71-128gb-104047466-front-huge_z1k6lqhzju7yicxk_nniedcxuv1ujmxok.png?quality=80&fit=bounds&height=&width="},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}},{"name":"Samsung Galaxy A31 128GB","quantity":0,"bundle_product_price":null,"promotion_tag_swatch":null,"badges_swatch":null,"sku":"samsung_galaxy_a31_128gb","badges":null,"badges_label":null,"stock_status":"OUT_OF_STOCK","low_stock_threshold":5,"display_low_stock_badge":0,"deal_go_live_date":"","deal_end_date":"","deal_label":null,"is_deal_locked":0,"categories":[{"id":26,"name":"Phones & SIM","url_key":"phones-sim","image":"https://shopqa.vodacom.co.za/media/catalog/category/Phone_SIM.png"},{"id":29,"name":"Smartphones","url_key":"smartphones","image":null}],"variants":[{"product":{"id":30377,"name":"SAMSUNG GALAXY A31 128GB BLACK","quantity":999,"sku":"104048863","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":5799,"currency":"ZAR"},"final_price":{"value":5799,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":5799,"currency":"ZAR"},"final_price":{"value":5799,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Black","code":"color","value_index":16321},{"label":"4GB RAM & 128GB ROM","code":"internal_storage","value_index":18689}]},{"product":{"id":30713,"name":"SAMSUNG GALAXY A31 128GB BLUE","quantity":999,"sku":"104048865","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":5799,"currency":"ZAR"},"final_price":{"value":5799,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":5799,"currency":"ZAR"},"final_price":{"value":5799,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Blue","code":"color","value_index":16345},{"label":"4GB RAM & 128GB ROM","code":"internal_storage","value_index":18689}]}],"__typename":"ConfigurableProduct","price_range":{"minimum_price":{"regular_price":{"value":5799,"currency":"ZAR"},"final_price":{"value":5799,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":5799,"currency":"ZAR"},"final_price":{"value":5799,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/s/a/samsung-galaxy-a31-128gb-104048863-front-huge_ai2h1wp5zoptzad0.png?quality=80&fit=bounds&height=&width="},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}}],"aggregations":[{"count":10,"label":"Price","attribute_code":"price","options":[{"count":8,"label":"0-100","value":"0_100"},{"count":1,"label":"100-200","value":"100_200"},{"count":2,"label":"200-300","value":"200_300"},{"count":2,"label":"500-600","value":"500_600"},{"count":1,"label":"600-700","value":"600_700"},{"count":1,"label":"1200-1300","value":"1200_1300"},{"count":2,"label":"1300-1400","value":"1300_1400"},{"count":2,"label":"1500-1600","value":"1500_1600"},{"count":1,"label":"1600-1700","value":"1600_1700"},{"count":66,"label":"1800-1900","value":"1800_1900"}]},{"count":23,"label":"Category","attribute_code":"category_id","options":[{"count":51,"label":"Phones & SIM","value":"26"},{"count":46,"label":"Smartphones","value":"29"},{"count":10,"label":"Smart Home","value":"62"},{"count":10,"label":"Smart Devices","value":"65"},{"count":9,"label":"Tablets & Laptops","value":"77"},{"count":6,"label":"Wearable Tech","value":"38"},{"count":6,"label":"Smart watches","value":"95"},{"count":5,"label":"Gaming","value":"119"},{"count":5,"label":"Gaming Consoles","value":"122"},{"count":5,"label":"Phones","value":"181"},{"count":4,"label":"Smartphones","value":"184"},{"count":3,"label":"Basic Laptops","value":"80"},{"count":3,"label":"Work Laptops","value":"83"},{"count":3,"label":"Portable Audio","value":"98"},{"count":3,"label":"Headphones & Earphones","value":"101"},{"count":3,"label":"Feature Phones","value":"317"},{"count":2,"label":"Tablets","value":"92"},{"count":2,"label":"Connectivity","value":"107"},{"count":1,"label":"Accessories","value":"35"},{"count":1,"label":"Accessories","value":"44"},{"count":1,"label":"Gaming Laptops","value":"89"},{"count":1,"label":"Routers","value":"110"},{"count":1,"label":"Feature phones","value":"205"}]},{"count":5,"label":"bundle_product_price_bucket","attribute_code":"bundle_product_price_bucket","options":[{"count":4,"label":"100_200","value":"100_200"},{"count":1,"label":"600_700","value":"600_700"},{"count":5,"label":"800_900","value":"800_900"},{"count":1,"label":"900_1000","value":"900_1000"},{"count":1,"label":"2300_2400","value":"2300_2400"}]},{"count":1,"label":"Contract Type","attribute_code":"contract_type","options":[{"count":1,"label":"Red contract","value":"16864"}]},{"count":4,"label":"deal_installment_bucket","attribute_code":"deal_installment_bucket","options":[{"count":4,"label":"0_100","value":"0_100"},{"count":3,"label":"600_700","value":"600_700"},{"count":1,"label":"700_800","value":"700_800"},{"count":1,"label":"900_1000","value":"900_1000"}]},{"count":2,"label":"Deal Product","attribute_code":"deal_product","options":[{"count":85,"label":"No","value":"16876"},{"count":1,"label":"Yes","value":"16873"}]},{"count":1,"label":"Is Deal Product","attribute_code":"is_deal_product","options":[{"count":86,"label":"0","value":"0"}]},{"count":1,"label":"Hide Product From Search And Listing Page","attribute_code":"is_hidden_product","options":[{"count":86,"label":"0","value":"0"}]},{"count":17,"label":"Brands","attribute_code":"manufacturer","options":[{"count":19,"label":"Samsung","value":"16517"},{"count":12,"label":"Huawei","value":"16556"},{"count":6,"label":"Hisense","value":"16565"},{"count":5,"label":"Apple","value":"16520"},{"count":3,"label":"TCL","value":"16478"},{"count":3,"label":"Digital planet","value":"16514"},{"count":3,"label":"LG mobile","value":"16580"},{"count":2,"label":"Lenovo","value":"16532"},{"count":2,"label":"HP","value":"16553"},{"count":2,"label":"Vivo","value":"16589"},{"count":2,"label":"Caterpillar","value":"16592"},{"count":1,"label":"Nokia","value":"16499"},{"count":1,"label":"Acer","value":"16541"},{"count":1,"label":"Celcom","value":"16559"},{"count":1,"label":"Alcatel","value":"16595"},{"count":1,"label":"Land rover","value":"16799"},{"count":1,"label":"Oppo","value":"16805"}]},{"count":1,"label":"Plan Type","attribute_code":"plan_type","options":[{"count":1,"label":"Data & voice minutes","value":"16706"}]},{"count":6,"label":"Promotion Tag","attribute_code":"promotion_tag","options":[{"count":4,"label":"Summer 2020","value":"16754"},{"count":3,"label":"Exclusive to online","value":"16667"},{"count":3,"label":"For today only","value":"16670"},{"count":2,"label":"2 For 1","value":"16688"},{"count":1,"label":"Black friday","value":"19244"},{"count":1,"label":"Red hot deal","value":"19247"}]}]}}}');

/***/ }),

/***/ 92365:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"trackingTrackingInformation":[{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"APPROVED WITH CONDITION"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-29 18:47:09"}]},{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"CONSIGNED"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-28 09:40:27"}]},{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"Paid"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-28 09:30:27"}]},{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"Pending confirmation"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-28 09:20:27"}]}],"drupalDeliveryStatus":[{"analyticTitle":"Delivered","resultTitle":"Delivered","category":"","resultCode":"Delivered","resultText":"Your order was delivered successfully. Enjoy!","resultHTML":false,"icon":"","primaryEnabled":"No","primaryCTAText":"","primaryCTAURL":"","primaryCTAType":"","secondaryEnabled":"No","secondaryCTAText":"","secondaryCTAURL":"","secondaryCTAType":"","leadType":""}]}');

/***/ }),

/***/ 41763:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"trackingTrackingInformation":[{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"AS2125102"},{"schemeName":"shippingOrderStatus","value":"APPROVED WITH CONDITION"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-29 18:47:09"}]},{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"CONSIGNED"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-28 09:40:27"}]},{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"Paid"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-28 09:30:27"}]},{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"Pending confirmation"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-28 09:20:27"}]}],"drupalDeliveryStatus":[{"analyticTitle":"Delivered","resultTitle":"Delivered","category":"","resultCode":"Delivered","resultText":"Your order was delivered successfully. Enjoy!","resultHTML":false,"icon":"","primaryEnabled":"No","primaryCTAText":"","primaryCTAURL":"","primaryCTAType":"","secondaryEnabled":"No","secondaryCTAText":"","secondaryCTAURL":"","secondaryCTAType":"","leadType":""}]}');

/***/ }),

/***/ 64214:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"trackingTrackingInformation":[{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"PENDED/REFERRED"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-29 18:47:09"}]},{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"CONSIGNED"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-28 09:40:27"}]},{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"Paid"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-28 09:30:27"}]},{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"Pending confirmation"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-28 09:20:27"}]}],"drupalDeliveryStatus":[{"analyticTitle":"Delivered","resultTitle":"Delivered","category":"","resultCode":"Delivered","resultText":"Your order was delivered successfully. Enjoy!","resultHTML":false,"icon":"","primaryEnabled":"No","primaryCTAText":"","primaryCTAURL":"","primaryCTAType":"","secondaryEnabled":"No","secondaryCTAText":"","secondaryCTAURL":"","secondaryCTAType":"","leadType":""}]}');

/***/ }),

/***/ 1584:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"trackingTrackingInformation":[{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"PENDED/REFERRED"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-29 18:47:09"}]},{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"CONSIGNED"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-28 09:40:27"}]},{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"Paid"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-28 09:30:27"}]},{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"Pending confirmation"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-28 09:20:27"}]}],"drupalDeliveryStatus":[{"analyticTitle":"Delivered","resultTitle":"Delivered","category":"","resultCode":"Delivered","resultText":"Your order was delivered successfully. Enjoy!","resultHTML":false,"icon":"","primaryEnabled":"No","primaryCTAText":"","primaryCTAURL":"","primaryCTAType":"","secondaryEnabled":"No","secondaryCTAText":"","secondaryCTAURL":"","secondaryCTAType":"","leadType":""}]}');

/***/ }),

/***/ 28131:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"trackingTrackingInformation":[{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"DELIVERED"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-29 18:47:09"}]},{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"CONSIGNED"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-28 09:40:27"}]},{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"Paid"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-28 09:30:27"}]},{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"Pending confirmation"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-28 09:20:27"}]}],"drupalDeliveryStatus":[{"analyticTitle":"Delivered","resultTitle":"Delivered","category":"","resultCode":"Delivered","resultText":"Your order was delivered successfully. Enjoy!","resultHTML":false,"icon":"","primaryEnabled":"No","primaryCTAText":"","primaryCTAURL":"","primaryCTAType":"","secondaryEnabled":"No","secondaryCTAText":"","secondaryCTAURL":"","secondaryCTAType":"","leadType":""}]}');

/***/ }),

/***/ 77567:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"trackingTrackingInformation":[{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"PAYMENT UNSUCCESSFUL"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-29 18:47:09"}]},{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"CONSIGNED"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-28 09:40:27"}]},{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"Paid"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-28 09:30:27"}]},{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"Pending confirmation"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-28 09:20:27"}]}],"drupalDeliveryStatus":[{"analyticTitle":"Delivered","resultTitle":"Delivered","category":"","resultCode":"Delivered","resultText":"Your order was delivered successfully. Enjoy!","resultHTML":false,"icon":"","primaryEnabled":"No","primaryCTAText":"","primaryCTAURL":"","primaryCTAType":"","secondaryEnabled":"No","secondaryCTAText":"","secondaryCTAURL":"","secondaryCTAType":"","leadType":""}]}');

/***/ }),

/***/ 41572:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"trackingTrackingInformation":[{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"PAYMENT FAILED"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-29 18:47:09"}]},{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"CONSIGNED"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-28 09:40:27"}]},{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"Paid"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-28 09:30:27"}]},{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"Pending confirmation"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-28 09:20:27"}]}],"drupalDeliveryStatus":[{"analyticTitle":"Delivered","resultTitle":"Delivered","category":"","resultCode":"Delivered","resultText":"Your order was delivered successfully. Enjoy!","resultHTML":false,"icon":"","primaryEnabled":"No","primaryCTAText":"","primaryCTAURL":"","primaryCTAType":"","secondaryEnabled":"No","secondaryCTAText":"","secondaryCTAURL":"","secondaryCTAType":"","leadType":""}]}');

/***/ }),

/***/ 75768:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"trackingTrackingInformation":[{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"Payment pending"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-29 18:47:09"}]},{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"CONSIGNED"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-28 09:40:27"}]},{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"Paid"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-28 09:30:27"}]},{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"Pending confirmation"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-28 09:20:27"}]}],"drupalDeliveryStatus":[{"analyticTitle":"Payment pending","resultTitle":"Awaiting payment","category":"","resultCode":"Payment pending","resultText":"Your order has been placed. Once we’ve received a notification of payment, we’ll continue processing your order.","resultHTML":"<p>Please make payment in order to finalise this order.</p>\\r\\n","icon":"","primaryEnabled":"Yes","primaryCTAText":"Make payment now","primaryCTAURL":"","primaryCTAType":"","secondaryEnabled":"No","secondaryCTAText":"","secondaryCTAURL":"","secondaryCTAType":"","leadType":""}]}');

/***/ }),

/***/ 54647:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"trackingTrackingInformation":[{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"Processing"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-29 18:47:09"}]},{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"CONSIGNED"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-28 09:40:27"}]},{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"Paid"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-28 09:30:27"}]},{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839978622"},{"schemeName":"shippingOrderNo","value":"K2125102"},{"schemeName":"shippingOrderStatus","value":"Pending confirmation"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-28 09:20:27"}]}],"drupalDeliveryStatus":[{"analyticTitle":"Delivered","resultTitle":"Delivered","category":"","resultCode":"Delivered","resultText":"Your order was delivered successfully. Enjoy!","resultHTML":false,"icon":"","primaryEnabled":"No","primaryCTAText":"","primaryCTAURL":"","primaryCTAType":"","secondaryEnabled":"No","secondaryCTAText":"","secondaryCTAURL":"","secondaryCTAType":"","leadType":""}]}');

/***/ }),

/***/ 64140:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"trackingTrackingInformation":{"id":[{"schemeName":"shippingOrderMSISDN","value":"27839111111"},{"schemeName":"shippingOrderNo","value":"K2125569888"},{"schemeName":"shippingOrderStatus","value":"STOLEN"},{"schemeName":"shippingOrderStatusdt","value":"2020-07-29 18:47:09"}]},"drupalDeliveryStatus":[{"analyticTitle":"Delivered","resultTitle":"Delivered","category":"","resultCode":"Delivered","resultText":"Your order was delivered successfully. Enjoy!","resultHTML":false,"icon":"","primaryEnabled":"No","primaryCTAText":"","primaryCTAURL":"","primaryCTAType":"","secondaryEnabled":"No","secondaryCTAText":"","secondaryCTAURL":"","secondaryCTAType":"","leadType":""}]}');

/***/ }),

/***/ 72930:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"id":"1a9c7b3f-e2bb-4a3b-9438-2dfcb49fda7b","analyticTitle":"Order tracking - Vetting status - Landing Page","template":{"name":"Demo-Template"},"sections":[{"type":"paragraph_list","id":"3de15aa2-271a-4b35-ba92-c59bb5c51c7c","analyticTitle":"Order tracking - Vetting status","siteType":"CBU","description":"<p>Please send these documents to <strong><u>cadonline@vodacom.co.za</u></strong> <strong>in PDF format</strong>. Remember to <strong>quote the reference number above in the subject line</strong> of your email to us.</p>","headingTitle":"Documents we require:","items":[{"id":"5c19d862-eaae-462e-9953-c1b460d5ce41","icon":"https://wwwqa.vodacom.co.za/sites/vodacomcoza/files/2021-07/profile_0_0.svg","title":"A copy of your ID"}]}]}');

/***/ }),

/***/ 56743:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"customer":{"orders":{"items":[{"id":"MTAx","order_date":"2020-10-12 06:28:50","total":{"grand_total":{"value":3879,"currency":"ZAR"}},"status":"Closed"},{"id":"MTA0","order_date":"2020-10-12 14:31:27","total":{"grand_total":{"value":976.35,"currency":"ZAR"}},"status":"Pending"},{"id":"MTEw","order_date":"2020-10-12 14:51:45","total":{"grand_total":{"value":976.35,"currency":"ZAR"}},"status":"Pending"},{"id":"MTE2","order_date":"2020-10-13 08:54:40","total":{"grand_total":{"value":976.35,"currency":"ZAR"}},"status":"Pending"},{"id":"MTE5","order_date":"2020-10-13 09:01:24","total":{"grand_total":{"value":976.35,"currency":"ZAR"}},"status":"Payment Unsuccessful"},{"id":"MTIy","order_date":"2020-10-13 09:03:59","total":{"grand_total":{"value":976.35,"currency":"ZAR"}},"status":"Pending"},{"id":"MTI1","order_date":"2020-10-13 09:08:07","total":{"grand_total":{"value":976.35,"currency":"ZAR"}},"status":"Pending"},{"id":"MTI4","order_date":"2020-10-13 09:12:17","total":{"grand_total":{"value":976.35,"currency":"ZAR"}},"status":"Pending"},{"id":"MTMx","order_date":"2020-10-13 09:16:03","total":{"grand_total":{"value":976.35,"currency":"ZAR"}},"status":"Pending"},{"id":"MTM0","order_date":"2020-10-13 09:23:05","total":{"grand_total":{"value":5288.85,"currency":"ZAR"}},"status":"Pending"},{"id":"MTUy","order_date":"2020-10-13 18:52:30","total":{"grand_total":{"value":9537.85,"currency":"ZAR"}},"status":"Pending"},{"id":"MTU1","order_date":"2020-10-13 19:05:58","total":{"grand_total":{"value":1029,"currency":"ZAR"}},"status":"Pending"},{"id":"MTY3","order_date":"2020-10-14 05:44:01","total":{"grand_total":{"value":9537.85,"currency":"ZAR"}},"status":"Pending"},{"id":"MTcw","order_date":"2020-10-14 05:46:54","total":{"grand_total":{"value":1029,"currency":"ZAR"}},"status":"Pending"},{"id":"MTcz","order_date":"2020-10-14 06:06:44","total":{"grand_total":{"value":9107.85,"currency":"ZAR"}},"status":"Pending"},{"id":"MTc2","order_date":"2020-10-14 06:10:16","total":{"grand_total":{"value":1029,"currency":"ZAR"}},"status":"Processed"},{"id":"MTgy","order_date":"2020-10-14 08:21:47","total":{"grand_total":{"value":1029,"currency":"ZAR"}},"status":"Pending"},{"id":"MTg1","order_date":"2020-10-14 08:25:49","total":{"grand_total":{"value":1029,"currency":"ZAR"}},"status":"Pending"},{"id":"MTg4","order_date":"2020-10-14 08:43:17","total":{"grand_total":{"value":1029,"currency":"ZAR"}},"status":"Cancelled"},{"id":"MTkx","order_date":"2020-10-14 09:07:39","total":{"grand_total":{"value":9107.85,"currency":"ZAR"}},"status":"Pending"}]}}},"response_time":2177}');

/***/ }),

/***/ 79687:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"ok":true,"result":[{"id":"5d0f27cf-f807-452c-b7c2-44c13230c4df","href":"https://qa.vodacompaymentgateway.co.za/api/PayBroker/URL/2xXELREmsECPNwDRCftT5A?cardToken=VU0xTUsvcmlyM2ZaMkN0RlY1dHg5L0RlcjY5WlFyajRObFlzV1ZLVi8waEZONDVheVNSUmp0L1lrdldoWkNDNURZTUZyNzE1MlVBMXVTUGhyOWR1OERtMGV6Q1VHWHBmY29DTHdDQzhXSjBSM2dTY3pmWmtKVU9jUlYyRTZCdDNKcE5xNzBWbktaN3R6Wjh5OXRsM2lqTkFSaGVqakYwZjRNZnFaS1BSbzBFMHhHZEVjNnBUVjlNbWQraS9YeWdQNGh1bWpYQThqRjJDVzh3UHppTTNEUT09","name":"visa","description":"Bank Card","preferred":false,"@type":"bankCard","status":"Active","details":{"type":"Visa","number":"4038 22** **** 0012"}},{"id":"54239543-4953-47bf-b097-28b5bca19bd2","href":"https://qa.vodacompaymentgateway.co.za/api/PayBroker/URL/2xXELREmsECPNwDRCftT5A?cardToken=dVlXVnN6S1IvaW5Ha2RIVWQzT2tvSTBBV0NiY2pNOTM3clBhMTlsK0tUczQzRUM2dk4vK3E4ejBXY2ZiNU1vdlVZUTB3WG93VSs3WFRpSzBLbmZxT3Q5MEE0MjV5RXRJMWJNV0cySHlRRUh2Y3U4czFDMXZKWnRiTVB3M0QzSTIrN1lhSTJteXV1VHlSYXV6bFFSOW9YNEFJRTFISEFqQVZKSzZwaTByS25KOHBaTmh5eXFxNTVIVWxDd3l2cFFJb3p5c0V4cm1zd056THQ3Ui84bGpGQT09","name":"visanew","description":"Bank Card","preferred":false,"@type":"bankCard","status":"Active","details":{"type":"Visa","number":"4038 22** **** 7026"}}],"paymentTypes":[{"id":1,"name":"VisaMasterCard","description":"Visa/Mastercard","paymentUrl":"https://qa.vodacompaymentgateway.co.za/api/PayBroker/URL/2xXELREmsECPNwDRCftT5A?paymentType=1"},{"id":4,"name":"MasterPass","description":"MasterPass","paymentUrl":"https://qa.vodacompaymentgateway.co.za/api/PayBroker/URL/2xXELREmsECPNwDRCftT5A?paymentType=4"},{"id":5,"name":"VodaPay","description":"VodaPay","paymentUrl":"https://qa.vodacompaymentgateway.co.za/api/PayBroker/URL/2xXELREmsECPNwDRCftT5A?paymentType=5"}],"newCardUrl":"/PaymentPage/Card/AddNewCard","paymentUrl":"https://qa.vodacompaymentgateway.co.za/api/PayBroker/URL/2xXELREmsECPNwDRCftT5A","removeCardUrl":null}');

/***/ }),

/***/ 97710:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"markup":{"#type":"webform_markup","#markup":"<a href=\\"/cart\\">Back to cart</a>","#webform":"pre_launch_form","#webform_id":"pre_launch_form--markup","#webform_key":"markup","#webform_parent_key":"","#webform_parent_flexbox":false,"#webform_depth":0,"#webform_children":[],"#webform_multiple":false,"#webform_composite":false,"#webform_parents":["markup"],"#title":null,"#admin_title":null,"#webform_plugin_id":"webform_markup"},"pre_order_form":{"#type":"label","#title":"Pre-order form","#description":"To pre-order your device","#webform":"pre_launch_form","#webform_id":"pre_launch_form--pre_order_form","#webform_key":"pre_order_form","#webform_parent_key":"","#webform_parent_flexbox":false,"#webform_depth":0,"#webform_children":[],"#webform_multiple":false,"#webform_composite":false,"#webform_parents":["pre_order_form"],"#admin_title":"Pre-order form","#webform_plugin_id":"label"},"personal_details":{"#type":"fieldset","#title":"Personal details","#description":"How we will contact you","#description_display":"before","name":{"#type":"textfield","#title":"Name","#title_display":"before","#placeholder":"Add name","#required":true,"#required_error":"Please enter your name.","#webform":"pre_launch_form","#webform_id":"pre_launch_form--name","#webform_key":"name","#webform_parent_key":"personal_details","#webform_parent_flexbox":false,"#webform_depth":1,"#webform_children":[],"#webform_multiple":false,"#webform_composite":false,"#webform_parents":["personal_details","name"],"#admin_title":"Name","#webform_plugin_id":"textfield"},"surname":{"#type":"textfield","#title":"Surname","#title_display":"before","#placeholder":"Add last name","#required":true,"#required_error":"Please enter your surname.","#webform":"pre_launch_form","#webform_id":"pre_launch_form--surname","#webform_key":"surname","#webform_parent_key":"personal_details","#webform_parent_flexbox":false,"#webform_depth":1,"#webform_children":[],"#webform_multiple":false,"#webform_composite":false,"#webform_parents":["personal_details","surname"],"#admin_title":"Surname","#webform_plugin_id":"textfield"},"contact_number":{"#type":"tel","#title":"Contact number","#placeholder":"Add contact number","#required":true,"#required_error":"Please enter your contact number.","#webform":"pre_launch_form","#webform_id":"pre_launch_form--contact_number","#webform_key":"contact_number","#webform_parent_key":"personal_details","#webform_parent_flexbox":false,"#webform_depth":1,"#webform_children":[],"#webform_multiple":false,"#webform_composite":false,"#webform_parents":["personal_details","contact_number"],"#admin_title":"Contact number","#webform_plugin_id":"tel"},"email_address":{"#type":"email","#title":"Email Address","#description_display":"tooltip","#placeholder":"Add email address","#required":true,"#required_error":"Please enter your email address.","#unique":true,"#unique_user":true,"#unique_error":"Email address already exists.","#webform":"pre_launch_form","#webform_id":"pre_launch_form--email_address","#webform_key":"email_address","#webform_parent_key":"personal_details","#webform_parent_flexbox":false,"#webform_depth":1,"#webform_children":[],"#webform_multiple":false,"#webform_composite":false,"#webform_parents":["personal_details","email_address"],"#admin_title":"Email Address","#webform_plugin_id":"email"},"#webform":"pre_launch_form","#webform_id":"pre_launch_form--personal_details","#webform_key":"personal_details","#webform_parent_key":"","#webform_parent_flexbox":false,"#webform_depth":0,"#webform_children":[],"#webform_multiple":false,"#webform_composite":false,"#webform_parents":["personal_details"],"#admin_title":"Personal details","#webform_plugin_id":"fieldset"},"device_details":{"#type":"fieldset","#title":"Device details","#description":"Please choose the device variants you prefer","#description_display":"before","device_colour":{"#type":"radios","#title":"Device colour","#options":{"Space grey":"Space grey","Midnight green":"Midnight green"},"#default_value":"Midnight green","#webform":"pre_launch_form","#webform_id":"pre_launch_form--device_colour","#webform_key":"device_colour","#webform_parent_key":"device_details","#webform_parent_flexbox":false,"#webform_depth":1,"#webform_children":[],"#webform_multiple":false,"#webform_composite":false,"#webform_parents":["device_details","device_colour"],"#admin_title":"Device colour","#webform_plugin_id":"radios"},"storage_size":{"#type":"radios","#title":"Storage size","#options":{"128GB":"128GB","256GB":"256GB"},"#default_value":"256GB","#webform":"pre_launch_form","#webform_id":"pre_launch_form--storage_size","#webform_key":"storage_size","#webform_parent_key":"device_details","#webform_parent_flexbox":false,"#webform_depth":1,"#webform_children":[],"#webform_multiple":false,"#webform_composite":false,"#webform_parents":["device_details","storage_size"],"#admin_title":"Storage size","#webform_plugin_id":"radios"},"#webform":"pre_launch_form","#webform_id":"pre_launch_form--device_details","#webform_key":"device_details","#webform_parent_key":"","#webform_parent_flexbox":false,"#webform_depth":0,"#webform_children":[],"#webform_multiple":false,"#webform_composite":false,"#webform_parents":["device_details"],"#admin_title":"Device details","#webform_plugin_id":"fieldset"},"tnc":{"#type":"checkbox","#title":"TnC","#description":"I give consent to <a href=\\"/terms-and-conditions\\" target=\\"_blank\\">Vodacom(PTY)Ltd</a> to perform a credit check on this application.","#title_display":"none","#required":true,"#required_error":"Please accept terms and conditions.","#webform":"pre_launch_form","#webform_id":"pre_launch_form--tnc","#webform_key":"tnc","#webform_parent_key":"","#webform_parent_flexbox":false,"#webform_depth":0,"#webform_children":[],"#webform_multiple":false,"#webform_composite":false,"#webform_parents":["tnc"],"#admin_title":"TnC","#webform_plugin_id":"checkbox"},"actions":{"#type":"webform_actions","#title":"Submit button(s)","#submit__label":"Submit","#webform":"pre_launch_form","#webform_id":"pre_launch_form--actions","#webform_key":"actions","#webform_parent_key":"","#webform_parent_flexbox":false,"#webform_depth":0,"#webform_children":[],"#webform_multiple":false,"#webform_composite":false,"#webform_parents":["actions"],"#admin_title":"Submit button(s)","#webform_plugin_id":"webform_actions"}}');

/***/ }),

/***/ 88306:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"data":{"products":{"total_count":2,"page_info":{"page_size":20,"current_page":1,"total_pages":1},"items":[{"name":"vivo X50","quantity":0,"bundle_product_price":null,"promotion_tag_swatch":null,"badges_swatch":null,"sku":"vivo_x50","badges":null,"badges_label":null,"stock_status":"IN_STOCK","low_stock_threshold":5,"display_low_stock_badge":0,"deal_go_live_date":"2021-02-05 09:09:00","deal_end_date":"2021-02-06 08:54:00","deal_label":"Ends In:","is_deal_locked":0,"categories":[{"id":26,"name":"Phones & SIM","url_key":"phones-sim","image":"https://shopqa.vodacom.co.za/media/catalog/category/Phone_SIM.png"},{"id":29,"name":"Smartphones","url_key":"smartphones","image":null}],"variants":[{"product":{"id":30938,"name":"VIVO X50 5G FROST BLUE","quantity":0,"sku":"104049894","stock_status":"OUT_OF_STOCK","price_range":{"minimum_price":{"regular_price":{"value":14799,"currency":"ZAR"},"final_price":{"value":14799,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":14799,"currency":"ZAR"},"final_price":{"value":14799,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Light Blue","code":"color","value_index":17125},{"label":"1GB RAM; 8GB ROM","code":"internal_storage","value_index":19082}]},{"product":{"id":31043,"name":"VIVO X50 5G GLAZE BLACK","quantity":91,"sku":"104049899","stock_status":"IN_STOCK","price_range":{"minimum_price":{"regular_price":{"value":100,"currency":"ZAR"},"final_price":{"value":100,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":100,"currency":"ZAR"},"final_price":{"value":100,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}}},"attributes":[{"label":"Black","code":"color","value_index":16321},{"label":"128GB","code":"internal_storage","value_index":16411}]}],"__typename":"ConfigurableProduct","options":[{"title":"I would like to:","required":false,"sort_order":0,"option_id":8377,"__typename":"CustomizableDropDownOption","value":[{"price_type":"FIXED","option_type_id":24856,"title":"Buy this product once off","price":0,"sku":"once-off"},{"price_type":"FIXED","option_type_id":24859,"title":"Get this product on a new contract","price":0,"sku":"contract"},{"price_type":"FIXED","option_type_id":24862,"title":"Upgrade","price":0,"sku":"upgrade"}]}],"price_range":{"minimum_price":{"regular_price":{"value":100,"currency":"ZAR"},"final_price":{"value":100,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":14799,"currency":"ZAR"},"final_price":{"value":14799,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/v/i/vivo-x50-104049899-front-huge_m8pfwahq3qgd6qji_b6aijk7fyub8tdzu.png?quality=80&fit=bounds&height=&width="},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image_1.png"}},{"name":"SAMSUNG GALAXY S20 ULTRA 128GB COSMIC GRAY","quantity":0,"bundle_product_price":849,"promotion_tag_swatch":null,"badges_swatch":"#007c92","sku":"104048115","badges":16601,"badges_label":"Pre Order","stock_status":"OUT_OF_STOCK","low_stock_threshold":5,"display_low_stock_badge":0,"deal_go_live_date":"","deal_end_date":"2021-10-15 13:50:00","deal_label":"Available:","is_deal_locked":0,"categories":[{"id":26,"name":"Phones & SIM","url_key":"phones-sim","image":"https://shopqa.vodacom.co.za/media/catalog/category/Phone_SIM.png"},{"id":29,"name":"Smartphones","url_key":"smartphones","image":null},{"id":181,"name":"Phones","url_key":"phones","image":null},{"id":184,"name":"Smartphones","url_key":"smartphones","image":null}],"__typename":"SimpleProduct","options":[{"title":"I would like to:","required":false,"sort_order":1,"option_id":131309,"__typename":"CustomizableDropDownOption","value":[{"price_type":"FIXED","option_type_id":329171,"title":"Buy this product once off","price":0,"sku":"once-off"},{"price_type":"FIXED","option_type_id":329174,"title":"Get this product on a new contract","price":0,"sku":"contract"},{"price_type":"FIXED","option_type_id":329177,"title":"Upgrade","price":0,"sku":"upgrade"}]}],"price_range":{"minimum_price":{"regular_price":{"value":3,"currency":"ZAR"},"final_price":{"value":3,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}},"maximum_price":{"regular_price":{"value":3,"currency":"ZAR"},"final_price":{"value":3,"currency":"ZAR"},"discount":{"amount_off":0,"percent_off":0}}},"image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg?quality=80&fit=bounds&height=&width="},"small_image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/h/e/hetv-free-samsungs20ultra12gb-128gb-491935960-i-1-1200wx1200h.jpg?quality=80&fit=bounds&height=&width="}}],"aggregations":[{"count":2,"label":"Price","attribute_code":"price","options":[{"count":1,"label":"0-100","value":"0_100"},{"count":1,"label":"100-200","value":"100_200"}]},{"count":4,"label":"Category","attribute_code":"category_id","options":[{"count":2,"label":"Phones & SIM","value":"26"},{"count":2,"label":"Smartphones","value":"29"},{"count":1,"label":"Phones","value":"181"},{"count":1,"label":"Smartphones","value":"184"}]},{"count":1,"label":"bundle_product_price_bucket","attribute_code":"bundle_product_price_bucket","options":[{"count":1,"label":"800_900","value":"800_900"}]},{"count":1,"label":"deal_installment_bucket","attribute_code":"deal_installment_bucket","options":[{"count":1,"label":"600_700","value":"600_700"}]},{"count":1,"label":"Deal Product","attribute_code":"deal_product","options":[{"count":2,"label":"No","value":"16876"}]},{"count":1,"label":"Is Deal Product","attribute_code":"is_deal_product","options":[{"count":2,"label":"0","value":"0"}]},{"count":1,"label":"Hide Product From Search And Listing Page","attribute_code":"is_hidden_product","options":[{"count":2,"label":"0","value":"0"}]},{"count":2,"label":"Brands","attribute_code":"manufacturer","options":[{"count":1,"label":"Samsung","value":"16517"},{"count":1,"label":"Vivo","value":"16589"}]},{"count":1,"label":"Promotion Tag","attribute_code":"promotion_tag","options":[{"count":1,"label":"Pre Order","value":"19261"}]}],"sort_fields":{"default":"position","options":[{"label":"Position","value":"position"},{"label":"Product Name","value":"name"},{"label":"SKU","value":"sku"},{"label":"Price","value":"price"},{"label":"Deal Product Price","value":"bundle_product_price"},{"label":"Product Position","value":"product_ranking"},{"label":"Installment","value":"installment"},{"label":"Monthly Recurring","value":"monthly_recurring"},{"label":"Most Popular Sort","value":"mostpopular"},{"label":"newest","value":"newest"},{"label":"Deal Installment","value":"deal_installment"}]}}}}');

/***/ }),

/***/ 91764:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"result":{"messages":[],"result":{"storeList":[{"storeID":1199,"shopCode":"352794061115343","name":"VODACOM SHOP BOULDERS MIDRAND","addressLineOne":"Old Pretoria Road","addressLineTwo":"Shop 26, Boulders Shopping Centre","city":"Midrand","district":"Johannesburg","state":"Southern Gauteng","country":"ZA","postalCode":"1685","mainPhone":"+27114658104","email":"OmniBBDDevTeam@vodacom.co.za","alternativePhone":null,"mobilePhone":null,"fax":null,"paymentTypes":[{"paymentTypeDescription":null,"paymentTypeId":0}],"additionalPhone":null,"tradingHours":[{"dayOfWeek":0,"startTime":0,"endTime":0}],"bir":false,"storeCategory":{"categoryID":4,"description":"Emerging Market"},"open":true,"coordinate":{"latitude":-25.99977,"longitude":28.12571},"distance":3.448784277021117,"type":{"typeId":4,"description":"Vodacom Shop"},"stockReservationEnable":true,"upgradeToCollectEnable":true,"stockCode":null,"quantity":0,"inStock":false,"lastUpdate":null},{"storeID":1327,"shopCode":"23209","name":"VODACOM SHOP REPAIRS FOURWAYS","addressLineOne":"Corner William Nicol and Witkoppen Street","addressLineTwo":"Shop M7C, Fourways Mall","city":"Fourways","district":"Johannesburg","state":"Southern Gauteng","country":"ZA","postalCode":"2191","mainPhone":"27114656716","email":"OmniBBDDevTeam@vodacom.co.za","alternativePhone":null,"mobilePhone":null,"fax":null,"paymentTypes":[{"paymentTypeDescription":null,"paymentTypeId":0}],"additionalPhone":null,"tradingHours":[{"dayOfWeek":0,"startTime":0,"endTime":0}],"bir":false,"storeCategory":{"categoryID":3,"description":"Super Premium"},"open":true,"coordinate":{"latitude":-26.022339,"longitude":28.008699},"distance":13.37037840001163,"type":{"typeId":4,"description":"Vodacom Shop"},"stockReservationEnable":false,"upgradeToCollectEnable":false,"stockCode":"0000000103004940","quantity":625,"inStock":true,"lastUpdate":"2020-08-09T01:18:29.0"},{"storeID":1345,"shopCode":"27881","name":"VODACOM SHOP RIVONIA ","addressLineOne":"Corner Rivonia Boulevard and Mutual Road","addressLineTwo":"Shop 70, Rivonia Village Shopping Centre","city":"Rivonia","district":"Johannesburg","state":"Southern Gauteng","country":"ZA","postalCode":"2499","mainPhone":"27118074391","email":"OmniBBDDevTeam@vodacom.co.za","alternativePhone":null,"mobilePhone":null,"fax":null,"paymentTypes":[{"paymentTypeDescription":null,"paymentTypeId":0}],"additionalPhone":null,"tradingHours":[{"dayOfWeek":0,"startTime":0,"endTime":0}],"bir":false,"storeCategory":{"categoryID":1,"description":"Standard"},"open":true,"coordinate":{"latitude":-26.060142,"longitude":28.060374},"distance":12.222816237212735,"type":{"typeId":4,"description":"Vodacom Shop"},"stockReservationEnable":true,"upgradeToCollectEnable":true,"stockCode":null,"quantity":0,"inStock":false,"lastUpdate":null},{"storeID":1510,"shopCode":"POSTEST1997","name":"TEST VODACOM SHOP VODACOM WORLD","addressLineOne":"082 Vodacom Boulevard","addressLineTwo":"Shop 7, Vodacom World ","city":"Midrand","district":"Johannesburg","state":"Southern Gauteng","country":"ZA","postalCode":"1682","mainPhone":"27116536750","email":"hitesh.buwade@vcontractor.co.za","alternativePhone":null,"mobilePhone":null,"fax":null,"paymentTypes":[{"paymentTypeDescription":null,"paymentTypeId":0}],"additionalPhone":null,"tradingHours":[{"dayOfWeek":0,"startTime":0,"endTime":0}],"bir":true,"storeCategory":{"categoryID":3,"description":"Super Premium"},"open":true,"coordinate":{"latitude":-25.970113,"longitude":28.128212},"distance":0.142907789240403,"type":{"typeId":4,"description":"Vodacom Shop"},"stockReservationEnable":true,"upgradeToCollectEnable":true,"stockCode":null,"quantity":0,"inStock":false,"lastUpdate":null},{"storeID":1384,"shopCode":"27277","name":"VODACOM SHOP WOODMEAD RETAIL PARK","addressLineOne":"1 Waterval Street","addressLineTwo":"Shop 3A and 4, Woodmead Retail Park","city":"Woodmead Ext 40","district":"Johannesburg","state":"Southern Gauteng","country":"ZA","postalCode":"2191","mainPhone":"27116569598","email":"OmniBBDDevTeam@vodacom.co.za","alternativePhone":null,"mobilePhone":null,"fax":null,"paymentTypes":[{"paymentTypeDescription":null,"paymentTypeId":0}],"additionalPhone":null,"tradingHours":[{"dayOfWeek":0,"startTime":0,"endTime":0}],"bir":false,"storeCategory":{"categoryID":1,"description":"Standard"},"open":true,"coordinate":{"latitude":-26.047415,"longitude":28.080078},"distance":9.986754721365912,"type":{"typeId":4,"description":"Vodacom Shop"},"stockReservationEnable":true,"upgradeToCollectEnable":true,"stockCode":null,"quantity":0,"inStock":false,"lastUpdate":null},{"storeID":1373,"shopCode":"VWOR1","name":"VODACOM SHOP VODACOM WORLD","addressLineOne":"082 Vodacom Boulevard","addressLineTwo":"Shop 7, Vodacom World ","city":"Midrand","district":"Johannesburg","state":"Southern Gauteng","country":"ZA","postalCode":"1682","mainPhone":"27116536750","email":"OmniBBDDevTeam@vodacom.co.za","alternativePhone":null,"mobilePhone":null,"fax":null,"paymentTypes":[{"paymentTypeDescription":null,"paymentTypeId":0}],"additionalPhone":null,"tradingHours":[{"dayOfWeek":0,"startTime":0,"endTime":0}],"bir":true,"storeCategory":{"categoryID":3,"description":"Super Premium"},"open":true,"coordinate":{"latitude":-25.970113,"longitude":28.128212},"distance":0.142907789240403,"type":{"typeId":4,"description":"Vodacom Shop"},"stockReservationEnable":false,"upgradeToCollectEnable":false,"stockCode":"0000000103004940","quantity":98,"inStock":true,"lastUpdate":"2020-09-14T13:03:55.0"},{"storeID":1366,"shopCode":"36401","name":"VODACOM SHOP THEMBISA BIRCH ACRES ","addressLineOne":"Corner Isimuku Street and Andrew Mapheto Drive","addressLineTwo":"Shop 51C, Birch Acres Mall","city":"Birch Acres","district":"Johannesburg","state":"Southern Gauteng","country":"ZA","postalCode":"1618","mainPhone":"27721440826","email":"OmniBBDDevTeam@vodacom.co.za","alternativePhone":null,"mobilePhone":null,"fax":null,"paymentTypes":[{"paymentTypeDescription":null,"paymentTypeId":0}],"additionalPhone":null,"tradingHours":[{"dayOfWeek":0,"startTime":0,"endTime":0}],"bir":false,"storeCategory":{"categoryID":4,"description":"Emerging Market"},"open":true,"coordinate":{"latitude":-26.034944,"longitude":28.19142},"distance":9.670766171614137,"type":{"typeId":4,"description":"Vodacom Shop"},"stockReservationEnable":true,"upgradeToCollectEnable":true,"stockCode":null,"quantity":0,"inStock":false,"lastUpdate":null},{"storeID":1206,"shopCode":"13212","name":"VODACOM SHOP CENTURION MALL","addressLineOne":"Heuwel Avenue, Entrance 5","addressLineTwo":"Shop 268B, Centurion Shopping Centre","city":"Centurion","district":"Pretoria","state":"Northern Gauteng","country":"ZA","postalCode":"1049","mainPhone":"+27183923495","email":"OmniBBDDevTeam@vodacom.co.za","alternativePhone":null,"mobilePhone":null,"fax":null,"paymentTypes":[{"paymentTypeDescription":null,"paymentTypeId":0}],"additionalPhone":null,"tradingHours":[{"dayOfWeek":0,"startTime":0,"endTime":0}],"bir":false,"storeCategory":{"categoryID":2,"description":"Premium"},"open":true,"coordinate":{"latitude":-25.856605,"longitude":28.184833},"distance":13.69392629113139,"type":{"typeId":4,"description":"Vodacom Shop"},"stockReservationEnable":true,"upgradeToCollectEnable":true,"stockCode":null,"quantity":0,"inStock":false,"lastUpdate":null},{"storeID":1365,"shopCode":"37723","name":"VODACOM SHOP THE REDS","addressLineOne":"Corner Hendrik Verwoerd and Rooihuiskraal Drives","addressLineTwo":"Shop 15 and 16, Mall @ Reds","city":"Rooihuiskraal","district":"Pretoria","state":"Northern Gauteng","country":"ZA","postalCode":"0157","mainPhone":"27126569567","email":"OmniBBDDevTeam@vodacom.co.za","alternativePhone":null,"mobilePhone":null,"fax":null,"paymentTypes":[{"paymentTypeDescription":null,"paymentTypeId":0}],"additionalPhone":null,"tradingHours":[{"dayOfWeek":0,"startTime":0,"endTime":0}],"bir":true,"storeCategory":{"categoryID":2,"description":"Premium"},"open":true,"coordinate":{"latitude":-25.895967,"longitude":28.156153},"distance":8.563258521616842,"type":{"typeId":4,"description":"Vodacom Shop"},"stockReservationEnable":false,"upgradeToCollectEnable":false,"stockCode":"0000000103004940","quantity":297,"inStock":true,"lastUpdate":"2020-08-17T01:23:37.0"},{"storeID":1228,"shopCode":"VDSFR","name":"VODACOM SHOP FOURWAYS","addressLineOne":"Corner William Nicol and Witkoppen Street","addressLineTwo":"Shop G100A, Fourways Mall","city":"Fourways","district":"Johannesburg","state":"Southern Gauteng","country":"ZA","postalCode":"2191","mainPhone":"27114658104","email":"OmniBBDDevTeam@vodacom.co.za","alternativePhone":null,"mobilePhone":null,"fax":null,"paymentTypes":[{"paymentTypeDescription":null,"paymentTypeId":0}],"additionalPhone":null,"tradingHours":[{"dayOfWeek":0,"startTime":0,"endTime":0}],"bir":true,"storeCategory":{"categoryID":3,"description":"Super Premium"},"open":true,"coordinate":{"latitude":-26.022339,"longitude":28.008699},"distance":13.37037840001163,"type":{"typeId":4,"description":"Vodacom Shop"},"stockReservationEnable":false,"upgradeToCollectEnable":false,"stockCode":"0000000103004940","quantity":2640,"inStock":true,"lastUpdate":"2020-08-17T01:42:04.0"}]},"successful":false,"code":0}}');

/***/ }),

/***/ 14604:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"vas":[{"vidCode":"VID10001842","eppixCode":"IL07","name":"Comp Laptop & Tab Ins (R10001-15000)","desc":"Comp Laptop & Tab Ins (R10001-15000)","categoryName":"\\"Smart L\\"","category":"Comp Laptop & Tablet Insurance","bundleSize":"","price":"129.57","vasDetails":{"name":"Comp Laptop & Tab Ins (R10001-15000)","sku":"VID10001842","is_pre_selected":true,"description":{"html":"Comp Laptop & Tab Ins (R10001-15000)"},"stock_status":"IN_STOCK","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png","label":"Comp Laptop & Tab Ins (R10001-15000)"},"categories":[],"options":[{"title":"I would like to:","required":false,"sort_order":1,"option_id":1614,"value":[{"price_type":"FIXED","option_type_id":4692,"title":"Buy this product once off","price":0,"sku":"once-off"},{"price_type":"FIXED","option_type_id":4693,"title":"Get this product on a new contract","price":0,"sku":"contract"},{"price_type":"FIXED","option_type_id":4694,"title":"Upgrade","price":0,"sku":"upgrade"}]},{"title":"Buy Option Types","required":false,"sort_order":2,"option_id":24097,"value":[{"price_type":"FIXED","option_type_id":73595,"title":"Buy this product once off","price":0,"sku":"once-off"},{"price_type":"FIXED","option_type_id":73596,"title":"Get this product on a new contract","price":0,"sku":"contract"},{"price_type":"FIXED","option_type_id":73597,"title":"Upgrade","price":0,"sku":"upgrade"}]}]}},{"vidCode":"VID10001849","eppixCode":"ID03","name":"Accidental Damage Ins (R10001-R20000)","desc":"Accidental Damage Ins (R10001-R20000)","categoryName":"\\"Smart L\\"","category":"Accidental Damage Insurance","bundleSize":"","price":"66.09","vasDetails":{"name":"Accidental Damage Ins (R10001-R20000)","sku":"VID10001849","is_pre_selected":false,"description":{"html":"Accidental Damage Ins (R10001-R20000)"},"stock_status":"IN_STOCK","image":{"url":"https://shopqa.vodacom.co.za/media/catalog/product/placeholder/default/No_image.png","label":"Accidental Damage Ins (R10001-R20000)"},"categories":[],"options":[{"title":"I would like to:","required":false,"sort_order":1,"option_id":1621,"value":[{"price_type":"FIXED","option_type_id":4713,"title":"Buy this product once off","price":0,"sku":"once-off"},{"price_type":"FIXED","option_type_id":4714,"title":"Get this product on a new contract","price":0,"sku":"contract"},{"price_type":"FIXED","option_type_id":4715,"title":"Upgrade","price":0,"sku":"upgrade"}]},{"title":"Buy Option Types","required":false,"sort_order":2,"option_id":24104,"value":[{"price_type":"FIXED","option_type_id":73616,"title":"Buy this product once off","price":0,"sku":"once-off"},{"price_type":"FIXED","option_type_id":73617,"title":"Get this product on a new contract","price":0,"sku":"contract"},{"price_type":"FIXED","option_type_id":73618,"title":"Upgrade","price":0,"sku":"upgrade"}]}]}}]}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(91118), __webpack_exec__(61587); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);